
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
"use strict";
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $4d82739dd229d539$var$Mg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Ng = null, $4d82739dd229d539$var$Og = null, $4d82739dd229d539$var$Pg = null;
function $4d82739dd229d539$var$Qg() {
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Ng = null;
}
function $4d82739dd229d539$var$Rg(a) {
    var b = $4d82739dd229d539$var$Mg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Mg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$Tg(a, b) {
    $4d82739dd229d539$var$Ng = a;
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$Ug = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$Vg(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Og) {
            if (null === $4d82739dd229d539$var$Ng) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Og = a;
            $4d82739dd229d539$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Og.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$Wg = null;
function $4d82739dd229d539$var$Xg(a) {
    null === $4d82739dd229d539$var$Wg ? $4d82739dd229d539$var$Wg = [
        a
    ] : $4d82739dd229d539$var$Wg.push(a);
}
function $4d82739dd229d539$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$Zg(a, d);
}
function $4d82739dd229d539$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$$g = !1;
function $4d82739dd229d539$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$Zg(a, c);
}
function $4d82739dd229d539$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$jh = (new $7fPBF.Component).refs;
function $4d82739dd229d539$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$L(), d = $4d82739dd229d539$var$lh(a), e = $4d82739dd229d539$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$dh(a, e, d);
        null !== b && ($4d82739dd229d539$var$mh(b, a, d, c), $4d82739dd229d539$var$eh(b, a, d));
    }
};
function $4d82739dd229d539$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$ph(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$Vg(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$nh.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4d82739dd229d539$var$jh;
    $4d82739dd229d539$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$Vg(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$nh.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $4d82739dd229d539$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$sh(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$sh(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$zh(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Ah(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Bh = $4d82739dd229d539$var$vh(!0), $4d82739dd229d539$var$Ch = $4d82739dd229d539$var$vh(!1), $4d82739dd229d539$var$Dh = {}, $4d82739dd229d539$var$Eh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh);
function $4d82739dd229d539$var$Hh(a) {
    if (a === $4d82739dd229d539$var$Dh) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$Ih(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Gh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, $4d82739dd229d539$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, b);
}
function $4d82739dd229d539$var$Jh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Gh);
}
function $4d82739dd229d539$var$Kh(a) {
    $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
    var b = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, c));
}
function $4d82739dd229d539$var$Lh(a) {
    $4d82739dd229d539$var$Fh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$Eh), $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh));
}
var $4d82739dd229d539$var$M = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nh = [];
function $4d82739dd229d539$var$Oh() {
    for(var a = 0; a < $4d82739dd229d539$var$Nh.length; a++)$4d82739dd229d539$var$Nh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Nh.length = 0;
}
var $4d82739dd229d539$var$Ph = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Qh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Rh = 0, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$P = null, $4d82739dd229d539$var$Sh = !1, $4d82739dd229d539$var$Th = !1, $4d82739dd229d539$var$Uh = 0, $4d82739dd229d539$var$Vh = 0;
function $4d82739dd229d539$var$Q() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Xh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Rh = f;
    $4d82739dd229d539$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Ph.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Yh : $4d82739dd229d539$var$Zh;
    a = c(d, e);
    if ($4d82739dd229d539$var$Th) {
        f = 0;
        do {
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$$h;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Th);
    }
    $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
    b = null !== $4d82739dd229d539$var$O && null !== $4d82739dd229d539$var$O.next;
    $4d82739dd229d539$var$Rh = 0;
    $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
    $4d82739dd229d539$var$Sh = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$bi() {
    var a = 0 !== $4d82739dd229d539$var$Uh;
    $4d82739dd229d539$var$Uh = 0;
    return a;
}
function $4d82739dd229d539$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$di() {
    if (null === $4d82739dd229d539$var$O) {
        var a = $4d82739dd229d539$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$O.next;
    var b = null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState : $4d82739dd229d539$var$P.next;
    if (null !== b) $4d82739dd229d539$var$P = b, $4d82739dd229d539$var$O = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$O = a;
        a = {
            memoizedState: $4d82739dd229d539$var$O.memoizedState,
            baseState: $4d82739dd229d539$var$O.baseState,
            baseQueue: $4d82739dd229d539$var$O.baseQueue,
            queue: $4d82739dd229d539$var$O.queue,
            next: null
        };
        null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    }
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$N.lanes |= m;
                $4d82739dd229d539$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$N.lanes |= f, $4d82739dd229d539$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$gi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$hi() {}
function $4d82739dd229d539$var$ii(a, b) {
    var c = $4d82739dd229d539$var$N, d = $4d82739dd229d539$var$di(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$Ug = !0);
    d = d.queue;
    $4d82739dd229d539$var$ji($4d82739dd229d539$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$P && $4d82739dd229d539$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
}
function $4d82739dd229d539$var$ki(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
    });
}
function $4d82739dd229d539$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$pi(a) {
    var b = $4d82739dd229d539$var$Zg(a, 1);
    null !== b && $4d82739dd229d539$var$mh(b, a, 1, -1);
}
function $4d82739dd229d539$var$qi(a) {
    var b = $4d82739dd229d539$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ri.bind(null, $4d82739dd229d539$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$si() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$ti(a, b, c, d) {
    var e = $4d82739dd229d539$var$ci();
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$ui(a, b, c, d) {
    var e = $4d82739dd229d539$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$O) {
        var g = $4d82739dd229d539$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Wh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$li(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, f, d);
}
function $4d82739dd229d539$var$vi(a, b) {
    return $4d82739dd229d539$var$ti(8390656, 8, a, b);
}
function $4d82739dd229d539$var$ji(a, b) {
    return $4d82739dd229d539$var$ui(2048, 8, a, b);
}
function $4d82739dd229d539$var$wi(a, b) {
    return $4d82739dd229d539$var$ui(4, 2, a, b);
}
function $4d82739dd229d539$var$xi(a, b) {
    return $4d82739dd229d539$var$ui(4, 4, a, b);
}
function $4d82739dd229d539$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$ui(4, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$Ai() {}
function $4d82739dd229d539$var$Bi(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Ci(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Di(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Rh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$Ug = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$N.lanes |= c, $4d82739dd229d539$var$hh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$Ei(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Qh.transition;
    $4d82739dd229d539$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Qh.transition = d;
    }
}
function $4d82739dd229d539$var$Fi() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, c);
    else if (c = $4d82739dd229d539$var$Yg(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$L();
        $4d82739dd229d539$var$mh(c, a, d, e);
        $4d82739dd229d539$var$Ji(c, b, d);
    }
}
function $4d82739dd229d539$var$ri(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$Yg(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$L(), $4d82739dd229d539$var$mh(c, a, d, e), $4d82739dd229d539$var$Ji(c, b, d));
    }
}
function $4d82739dd229d539$var$Hi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$N || null !== b && b === $4d82739dd229d539$var$N;
}
function $4d82739dd229d539$var$Ii(a, b) {
    $4d82739dd229d539$var$Th = $4d82739dd229d539$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$ai = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Q,
    useContext: $4d82739dd229d539$var$Q,
    useEffect: $4d82739dd229d539$var$Q,
    useImperativeHandle: $4d82739dd229d539$var$Q,
    useInsertionEffect: $4d82739dd229d539$var$Q,
    useLayoutEffect: $4d82739dd229d539$var$Q,
    useMemo: $4d82739dd229d539$var$Q,
    useReducer: $4d82739dd229d539$var$Q,
    useRef: $4d82739dd229d539$var$Q,
    useState: $4d82739dd229d539$var$Q,
    useDebugValue: $4d82739dd229d539$var$Q,
    useDeferredValue: $4d82739dd229d539$var$Q,
    useTransition: $4d82739dd229d539$var$Q,
    useMutableSource: $4d82739dd229d539$var$Q,
    useSyncExternalStore: $4d82739dd229d539$var$Q,
    useId: $4d82739dd229d539$var$Q,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Yh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ti(4194308, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$Gi.bind(null, $4d82739dd229d539$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$qi,
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$qi(!1), b = a[0];
        a = $4d82739dd229d539$var$Ei.bind(null, a[1]);
        $4d82739dd229d539$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$N, e = $4d82739dd229d539$var$ci();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$vi($4d82739dd229d539$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$ci(), b = $4d82739dd229d539$var$R.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Zh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$fi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$$h = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$gi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return null === $4d82739dd229d539$var$O ? b.memoizedState = a : $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Oi(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Pi || ($4d82739dd229d539$var$Pi = !0, $4d82739dd229d539$var$Qi = d);
        $4d82739dd229d539$var$Mi(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Ri(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Mi(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Si ? $4d82739dd229d539$var$Si = new Set([
            this
        ]) : $4d82739dd229d539$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$ch(-1, 1), b.tag = 2, $4d82739dd229d539$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Xi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$Ug = !1;
function $4d82739dd229d539$var$Yi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Ch(b, null, c, d) : $4d82739dd229d539$var$Bh(b, a.child, c, d);
}
function $4d82739dd229d539$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$Tg(b, e);
    d = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$cj(a, b, f, d, e);
        a = $4d82739dd229d539$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$Ug = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$$i(a, b, e);
        }
    }
    return $4d82739dd229d539$var$dj(a, b, c, d, e);
}
function $4d82739dd229d539$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj);
            $4d82739dd229d539$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= d;
    $4d82739dd229d539$var$Yi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$dj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$Tg(b, e);
    c = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$Tg(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$jj(a, b), $4d82739dd229d539$var$ph(b, c, d), $4d82739dd229d539$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$Vg(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$qh(b, g, d, l);
        $4d82739dd229d539$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof m && ($4d82739dd229d539$var$kh(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Vg(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$qh(b, g, d, k);
        $4d82739dd229d539$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof y && ($4d82739dd229d539$var$kh(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$kj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$kj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$$i(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Bh(b, a.child, null, f), b.child = $4d82739dd229d539$var$Bh(b, null, h, f)) : $4d82739dd229d539$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$Ih(a, b.containerInfo);
}
function $4d82739dd229d539$var$mj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Yi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$pj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$qj(g, d, 0, null), a = $4d82739dd229d539$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$oj(c), b.memoizedState = $4d82739dd229d539$var$nj, a) : $4d82739dd229d539$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$wh(h, f) : (f = $4d82739dd229d539$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$rj(a, b) {
    b = $4d82739dd229d539$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$tj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Bh(b, a.child, null, c);
    a = $4d82739dd229d539$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$oj(g);
        b.memoizedState = $4d82739dd229d539$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Li(f, d, void 0);
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$Ug || h) {
        d = $4d82739dd229d539$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$Zg(a, e), $4d82739dd229d539$var$mh(d, a, e, -1));
        }
        $4d82739dd229d539$var$uj();
        d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$Sg(a.return, b, c);
}
function $4d82739dd229d539$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Yi(a, b, d.children, c);
    d = $4d82739dd229d539$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$wj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$lj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Kh(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$pj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
                a = $4d82739dd229d539$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$ej(a, b, c);
    }
    return $4d82739dd229d539$var$$i(a, b, c);
}
var $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj, $4d82739dd229d539$var$Dj;
$4d82739dd229d539$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Bj = function() {};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Ej(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$Jh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Bj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Lh(b);
            var e = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
                $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$M.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$Bj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Ej(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Hj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$M.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$gj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Jj(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Lh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$M), null;
        case 4:
            return $4d82739dd229d539$var$Jh(), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Kj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Oj = !1;
function $4d82739dd229d539$var$Pj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Oj;
    $4d82739dd229d539$var$Oj = !1;
    return n;
}
function $4d82739dd229d539$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Xj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Xj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Yj = !1;
function $4d82739dd229d539$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$ak(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$ak(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Mj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Yj = !0;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Nj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Zj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Zj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Zj(a, b, c);
    }
}
function $4d82739dd229d539$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Lj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Yj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$ak(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$ek(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Qj(3, a, a.return), $4d82739dd229d539$var$Rj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Qj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            break;
        case 13:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$gk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$fk(a);
    }
}
function $4d82739dd229d539$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$jk(a, b, c);
}
function $4d82739dd229d539$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Kj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Kj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$kk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$kk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$jk(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Kj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$lk(a, b, c);
    }
}
function $4d82739dd229d539$var$lk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Sj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$hk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$mk = Math.ceil, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$pk = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$gj = 0, $4d82739dd229d539$var$fj = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$qk = null, $4d82739dd229d539$var$hh = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = 0, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$gk = 0, $4d82739dd229d539$var$Hj = Infinity, $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Pi = !1, $4d82739dd229d539$var$Qi = null, $4d82739dd229d539$var$Si = null, $4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = null, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, $4d82739dd229d539$var$Bk = -1, $4d82739dd229d539$var$Ck = 0;
function $4d82739dd229d539$var$L() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Bk ? $4d82739dd229d539$var$Bk : $4d82739dd229d539$var$Bk = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Ck && ($4d82739dd229d539$var$Ck = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Ck;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$mh(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$zk) throw $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$R) a === $4d82739dd229d539$var$R && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$rk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Ek(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Ek(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Fk.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Fk.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Gk(c, $4d82739dd229d539$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Hk(a, b) {
    $4d82739dd229d539$var$Bk = -1;
    $4d82739dd229d539$var$Ck = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Ik() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Jk(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Kk();
        if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Lk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Mk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Nk(a, h);
        }
        $4d82739dd229d539$var$Qg();
        $4d82739dd229d539$var$nk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Ok(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Pk(e) && (b = $4d82739dd229d539$var$Jk(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Ok(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$gk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Hk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Ok(a, b) {
    var c = $4d82739dd229d539$var$tk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Lk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Jk(a, b);
    2 !== a && (b = $4d82739dd229d539$var$uk, $4d82739dd229d539$var$uk = c, null !== b && $4d82739dd229d539$var$Gj(b));
    return a;
}
function $4d82739dd229d539$var$Gj(a) {
    null === $4d82739dd229d539$var$uk ? $4d82739dd229d539$var$uk = a : $4d82739dd229d539$var$uk.push.apply($4d82739dd229d539$var$uk, a);
}
function $4d82739dd229d539$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Dk(a, b) {
    b &= ~$4d82739dd229d539$var$sk;
    b &= ~$4d82739dd229d539$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Fk(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Ok(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, b), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Rk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Sk(a) {
    null !== $4d82739dd229d539$var$xk && 0 === $4d82739dd229d539$var$xk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$pk.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$pk.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Ij() {
    $4d82739dd229d539$var$gj = $4d82739dd229d539$var$fj.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$fj);
}
function $4d82739dd229d539$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$Jh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Oh();
                break;
            case 5:
                $4d82739dd229d539$var$Lh(d);
                break;
            case 4:
                $4d82739dd229d539$var$Jh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 10:
                $4d82739dd229d539$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Ij();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$R = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$wh(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$gj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$qk = null;
    $4d82739dd229d539$var$sk = $4d82739dd229d539$var$rk = $4d82739dd229d539$var$hh = 0;
    $4d82739dd229d539$var$uk = $4d82739dd229d539$var$tk = null;
    if (null !== $4d82739dd229d539$var$Wg) {
        for(b = 0; b < $4d82739dd229d539$var$Wg.length; b++)if (c = $4d82739dd229d539$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$Wg = null;
    }
    return a;
}
function $4d82739dd229d539$var$Nk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$Qg();
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
            if ($4d82739dd229d539$var$Sh) {
                for(var d = $4d82739dd229d539$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Sh = !1;
            }
            $4d82739dd229d539$var$Rh = 0;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            $4d82739dd229d539$var$ok.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$qk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Ti(f, l, b);
                            $4d82739dd229d539$var$uj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Wi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ki(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = [
                    f
                ] : $4d82739dd229d539$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Oi(f, k, b);
                            $4d82739dd229d539$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Ri(f, h, b);
                                $4d82739dd229d539$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Tk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Kk() {
    var a = $4d82739dd229d539$var$nk.current;
    $4d82739dd229d539$var$nk.current = $4d82739dd229d539$var$ai;
    return null === a ? $4d82739dd229d539$var$ai : a;
}
function $4d82739dd229d539$var$uj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$R || 0 === ($4d82739dd229d539$var$hh & 268435455) && 0 === ($4d82739dd229d539$var$rk & 268435455) || $4d82739dd229d539$var$Dk($4d82739dd229d539$var$R, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Jk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Kk();
    if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Lk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Uk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Nk(a, e);
    }
    $4d82739dd229d539$var$Qg();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$nk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$R = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Uk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Mk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Vk(a) {
    var b = $4d82739dd229d539$var$Wk(a.alternate, a, $4d82739dd229d539$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Tk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$ok.current = null;
}
function $4d82739dd229d539$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Fj(c, b, $4d82739dd229d539$var$gj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Qk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$pk.transition;
    try {
        $4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Xk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$pk.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Xk(a, b, c, d) {
    do $4d82739dd229d539$var$Ik();
    while (null !== $4d82739dd229d539$var$xk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$R && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$wk || ($4d82739dd229d539$var$wk = !0, $4d82739dd229d539$var$Gk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$pk.transition;
        $4d82739dd229d539$var$pk.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$ok.current = null;
        $4d82739dd229d539$var$Pj(a, c);
        $4d82739dd229d539$var$ek(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$ik(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$pk.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$wk && ($4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = a, $4d82739dd229d539$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Si = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Pi) throw $4d82739dd229d539$var$Pi = !1, a = $4d82739dd229d539$var$Qi, $4d82739dd229d539$var$Qi = null, a;
    0 !== ($4d82739dd229d539$var$yk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$zk++ : ($4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = a) : $4d82739dd229d539$var$zk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Ik() {
    if (null !== $4d82739dd229d539$var$xk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$yk), b = $4d82739dd229d539$var$pk.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$pk.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$xk) var d = !1;
            else {
                a = $4d82739dd229d539$var$xk;
                $4d82739dd229d539$var$xk = null;
                $4d82739dd229d539$var$yk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Tj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Rj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$pk.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Yk(a, b, c) {
    b = $4d82739dd229d539$var$Ki(c, b);
    b = $4d82739dd229d539$var$Oi(a, b, 1);
    a = $4d82739dd229d539$var$dh(a, b, 1);
    b = $4d82739dd229d539$var$L();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Ek(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(d))) {
                a = $4d82739dd229d539$var$Ki(c, a);
                a = $4d82739dd229d539$var$Ri(b, a, 1);
                b = $4d82739dd229d539$var$dh(b, a, 1);
                a = $4d82739dd229d539$var$L();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$R === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$gk ? $4d82739dd229d539$var$Lk(a, 0) : $4d82739dd229d539$var$sk |= c);
    $4d82739dd229d539$var$Ek(a, b);
}
function $4d82739dd229d539$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$L();
    a = $4d82739dd229d539$var$Zg(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Ek(a, c));
}
function $4d82739dd229d539$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Zk(a, c);
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Zk(a, c);
}
var $4d82739dd229d539$var$Wk;
$4d82739dd229d539$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$zj(a, b, c);
            $4d82739dd229d539$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$jj(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$Tg(b, c);
            e = $4d82739dd229d539$var$Xh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$ah(b), e.updater = $4d82739dd229d539$var$nh, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$rh(b, d, a, c), b = $4d82739dd229d539$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$$k(d);
                a = $4d82739dd229d539$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$aj(null, b, d, $4d82739dd229d539$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$lj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$bh(a, b);
                $4d82739dd229d539$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$$i(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Kh(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$hj(a, b), $4d82739dd229d539$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$pj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Bh(b, null, d, c) : $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$Zi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$Tg(b, c), e = $4d82739dd229d539$var$Vg(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Lg(d, b.pendingProps), e = $4d82739dd229d539$var$Lg(d.type, e), $4d82739dd229d539$var$aj(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$jj(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$Tg(b, c), $4d82739dd229d539$var$ph(b, d, e), $4d82739dd229d539$var$rh(b, d, e, c), $4d82739dd229d539$var$kj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$yj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$ej(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Gk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$al(a, b, c, d);
}
function $4d82739dd229d539$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$$k(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Ah(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Ah(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$qj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$xh(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$zh(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$ah(f);
    return a;
}
function $4d82739dd229d539$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$el(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$el(null);
    c = a.current;
    d = $4d82739dd229d539$var$L();
    e = $4d82739dd229d539$var$lh(c);
    f = $4d82739dd229d539$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$dh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Ek(a, d);
    return a;
}
function $4d82739dd229d539$var$gl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$L(), g = $4d82739dd229d539$var$lh(e);
    c = $4d82739dd229d539$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$dh(e, b, g);
    null !== a && ($4d82739dd229d539$var$mh(a, e, g, f), $4d82739dd229d539$var$eh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$jl(a, b) {
    $4d82739dd229d539$var$il(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$il(a, b);
}
function $4d82739dd229d539$var$kl() {
    return null;
}
var $4d82739dd229d539$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.render = $4d82739dd229d539$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$gl(a, b, null, null);
};
$4d82739dd229d539$var$nl.prototype.unmount = $4d82739dd229d539$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Sk(function() {
            $4d82739dd229d539$var$gl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$nl(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$ql() {}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$hl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$fl(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$ql);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$hl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$cl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$ql);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$gl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$hl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$gl(b, g, a, e);
    } else g = $4d82739dd229d539$var$rl(c, b, a, e, d);
    return $4d82739dd229d539$var$hl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Ek(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Sk(function() {
                var b = $4d82739dd229d539$var$Zg(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$L();
                    $4d82739dd229d539$var$mh(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$jl(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$jl(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$lh(a), c = $4d82739dd229d539$var$Zg(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(c, a, b, d);
        }
        $4d82739dd229d539$var$jl(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Sk;
var $4d82739dd229d539$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Rk
    ]
}, $4d82739dd229d539$var$ul = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$vl = {
    bundleType: $4d82739dd229d539$var$ul.bundleType,
    version: $4d82739dd229d539$var$ul.version,
    rendererPackageName: $4d82739dd229d539$var$ul.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$ul.findFiberByHostInstance || $4d82739dd229d539$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$wl.isDisabled && $4d82739dd229d539$var$wl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$wl.inject($4d82739dd229d539$var$vl), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$wl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$tl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$dl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Sk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$nl(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$pl(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$pl(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$sl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("33s19", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
"use strict";
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("bIIiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88862ae379718d07$export$2e2bcd8739ae039; });

var $gfMQZ = parcelRequire("gfMQZ");
var $88862ae379718d07$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $88862ae379718d07$var$index = (0, $gfMQZ.default)(function(prop) {
    return $88862ae379718d07$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $88862ae379718d07$export$2e2bcd8739ae039 = $88862ae379718d07$var$index;

});
parcelRegister("gfMQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd53f15c06ad9cc8$export$2e2bcd8739ae039; });
function $bd53f15c06ad9cc8$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $bd53f15c06ad9cc8$export$2e2bcd8739ae039 = $bd53f15c06ad9cc8$var$memoize;

});


var $824c049f32d4395d$exports = {};
"use strict";

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));



var $7fPBF = parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
"use strict";
var $b4ba1c853f6e1116$exports = {};
"use strict";
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;




var $eaf6e2f2fe42ede8$exports = {};
$eaf6e2f2fe42ede8$exports = new URL("logotype.9f6bf0ae.png", import.meta.url).toString();



var $80b309bb900a72a7$exports = {};
$80b309bb900a72a7$exports = new URL("barcode.64125419.svg", import.meta.url).toString();


var $6d0d5034b72fb48a$exports = {};
$6d0d5034b72fb48a$exports = new URL("arrow-back.077b9a67.svg", import.meta.url).toString();


var $d8166cd39748a67e$exports = {};
$d8166cd39748a67e$exports = new URL("credit-card.eb429200.svg", import.meta.url).toString();



var $7fPBF = parcelRequire("7fPBF");
var $849102574a83a574$var$s = function() {
    return $849102574a83a574$var$s = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $849102574a83a574$var$s.apply(this, arguments);
};
function $849102574a83a574$var$u(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                u(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                u(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, s);
        }
        u((n = n.apply(t, e || [])).next());
    });
}
function $849102574a83a574$var$c(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function s(s) {
        return function(u) {
            return function(s) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; i && (i = 0, s[0] && (a = 0)), a;)try {
                    if (r = 1, n && (o = 2 & s[0] ? n.return : s[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, s[1])).done) return o;
                    switch(n = 0, o && (s = [
                        2 & s[0],
                        o.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            o = s;
                            break;
                        case 4:
                            return a.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                                a.label = s[1];
                                break;
                            }
                            if (6 === s[0] && a.label < o[1]) {
                                a.label = o[1], o = s;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(s);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    s = e.call(t, a);
                } catch (t) {
                    s = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                u
            ]);
        };
    }
}
"function" == typeof SuppressedError && SuppressedError;
var $849102574a83a574$var$f = {
    facingMode: "environment",
    width: {
        min: 640,
        ideal: 720,
        max: 1920
    },
    height: {
        min: 640,
        ideal: 720,
        max: 1080
    }
}, $849102574a83a574$export$6aa26f5ebe6471fc = "undefined" != typeof navigator && navigator.mediaDevices ? function(t) {
    var n = (0, $7fPBF.useState)([]), o = n[0], i = n[1];
    return (0, $7fPBF.useEffect)(function() {
        var e, r = {
            audio: !1,
            video: null != t ? t : $849102574a83a574$var$f
        }, n = function() {
            navigator.mediaDevices.getUserMedia(r).then(function(t) {
                var r = [];
                e = t, t.getVideoTracks().forEach(function(t) {
                    r.push(t.getSettings());
                }), i(r);
            }).catch(function(t) {
                return console.log(t);
            });
        };
        return function(t) {
            for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
            t && t.addEventListener && t.addEventListener.apply(t, e);
        }(navigator.mediaDevices, "devicechange", n), n(), function() {
            !function(t) {
                for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
                t && t.removeEventListener && t.removeEventListener.apply(t, e);
            }(navigator.mediaDevices, "devicechange", n), void 0 !== e && e.getVideoTracks().forEach(function(t) {
                t.stop();
            });
        };
    }, []), o;
} : function() {
    return [];
}, $849102574a83a574$var$l = function(e) {
    var o, i, a = e.result, s = e.video, u = e.constraints, c = e.deviceId, f = e.scanDelay, l = (0, $7fPBF.useRef)(null), d = $849102574a83a574$export$6aa26f5ebe6471fc(u);
    return (0, $7fPBF.useEffect)(function() {
        if (void 0 !== a && null !== l.current && null !== s && 11 === a.getBarcodeFormat()) {
            var t = d[0];
            if (void 0 !== c && d.length > 1) {
                var e = d.find(function(t) {
                    return t.deviceId === c;
                });
                void 0 !== e && (t = e);
            }
            if (void 0 !== t && void 0 !== t.width) {
                var r = t.width / s.clientWidth, n = l.current, o = n.getContext("2d");
                if (null !== o) {
                    var i = setTimeout(function() {
                        o.clearRect(0, 0, n.width, n.height);
                    }, f);
                    o.strokeStyle = "rgba(0, 255, 0, 0.5)", o.lineWidth = 4;
                    var u = a.getResultPoints()[0];
                    o.beginPath(), o.arc(u.getX() / r, u.getY() / r, u.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath();
                    var h = a.getResultPoints()[1];
                    o.beginPath(), o.arc(h.getX() / r, h.getY() / r, h.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath();
                    var p = a.getResultPoints()[2];
                    if (o.beginPath(), o.arc(p.getX() / r, p.getY() / r, p.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath(), a.getResultPoints().length >= 4) {
                        var g = a.getResultPoints()[3];
                        o.beginPath(), o.arc(g.getX() / r, g.getY() / r, g.estimatedModuleSize, 0, 2 * Math.PI), o.stroke(), o.closePath();
                    }
                    return function() {
                        return clearTimeout(i);
                    };
                }
            }
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("canvas", {
        ref: l,
        width: null !== (o = null == s ? void 0 : s.clientWidth) && void 0 !== o ? o : 0,
        height: null !== (i = null == s ? void 0 : s.clientHeight) && void 0 !== i ? i : 0,
        style: {
            position: "absolute",
            top: 0,
            zIndex: 2
        }
    });
}, $849102574a83a574$var$d = {
    count: {
        bottom: 0,
        right: 5,
        fontSize: 30,
        color: "#fff",
        position: "absolute",
        zIndex: 1
    }
}, $849102574a83a574$var$p = function(e) {
    var r = e.scanCount;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: $849102574a83a574$var$d.count
    }, r);
}, $849102574a83a574$var$g = function(n) {
    var i = n.scanCount, a = n.hideCount, s = n.tracker, u = n.border, c = void 0 === u ? 80 : u, f = n.result, h = n.video, d = n.constraints, g = n.deviceId, y = n.scanDelay, w = (0, $7fPBF.useState)("rgba(255, 0, 0, 0.5)"), v = w[0], _ = w[1];
    return (0, $7fPBF.useEffect)(function() {
        if (11 != (null == f ? void 0 : f.getBarcodeFormat()) || !s) {
            _("rgba(0, 255, 0, 0.5)");
            var t = setTimeout(function() {
                _("rgba(255, 0, 0, 0.5)");
            }, y);
            return function() {
                clearTimeout(t);
            };
        }
        _("rgba(255, 0, 0, 0.5)");
    }, [
        i
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, !a && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($849102574a83a574$var$p, {
        scanCount: i
    }), s && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($849102574a83a574$var$l, {
        video: h,
        result: f,
        constraints: d,
        deviceId: g,
        scanDelay: y
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 100 100",
        style: {
            top: 0,
            left: 0,
            zIndex: 1,
            boxSizing: "border-box",
            border: "".concat(c, "px solid rgba(0, 0, 0, 0.1)"),
            position: "absolute",
            width: "100%",
            height: "100%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M23,0 L0,0 L0,23",
        stroke: v,
        strokeWidth: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M0,77 L0,100 L23,100",
        stroke: v,
        strokeWidth: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M77,100 L100,100 L100,77",
        stroke: v,
        strokeWidth: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M100,23 L100,0 77,0",
        stroke: v,
        strokeWidth: "5"
    })));
};
var $849102574a83a574$var$y, $849102574a83a574$var$w, $849102574a83a574$var$v, $849102574a83a574$var$_ = ($849102574a83a574$var$y = function(t, e) {
    return $849102574a83a574$var$y = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $849102574a83a574$var$y(t, e);
}, function(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $849102574a83a574$var$y(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}), $849102574a83a574$var$A = function(t) {
    function e(e, r) {
        var n, o, i, a = this.constructor, s = t.call(this, e, r) || this;
        return Object.defineProperty(s, "name", {
            value: a.name,
            enumerable: !1,
            configurable: !0
        }), n = s, o = a.prototype, (i = Object.setPrototypeOf) ? i(n, o) : n.__proto__ = o, function(t, e) {
            void 0 === e && (e = t.constructor);
            var r = Error.captureStackTrace;
            r && r(t, e);
        }(s), s;
    }
    return $849102574a83a574$var$_(e, t), e;
}(Error), $849102574a83a574$var$C = ($849102574a83a574$var$w = function(t, e) {
    return $849102574a83a574$var$w = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
    }, $849102574a83a574$var$w(t, e);
}, function(t, e) {
    function r() {
        this.constructor = t;
    }
    $849102574a83a574$var$w(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}), $849102574a83a574$var$m = function(t) {
    function e(e) {
        void 0 === e && (e = void 0);
        var r = t.call(this, e) || this;
        return r.message = e, r;
    }
    return $849102574a83a574$var$C(e, t), e.prototype.getKind = function() {
        return this.constructor.kind;
    }, e.kind = "Exception", e;
}($849102574a83a574$var$A), $849102574a83a574$var$E = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$I = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$E(e, t), e.kind = "ArgumentException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$S = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$T = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$S(e, t), e.kind = "IllegalArgumentException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$O = function() {
    function t(t) {
        if (this.binarizer = t, null === t) throw new $849102574a83a574$var$T("Binarizer must be non-null.");
    }
    return t.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    }, t.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    }, t.prototype.getBlackRow = function(t, e) {
        return this.binarizer.getBlackRow(t, e);
    }, t.prototype.getBlackMatrix = function() {
        return null !== this.matrix && void 0 !== this.matrix || (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, t.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    }, t.prototype.crop = function(e, r, n, o) {
        var i = this.binarizer.getLuminanceSource().crop(e, r, n, o);
        return new t(this.binarizer.createBinarizer(i));
    }, t.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    }, t.prototype.rotateCounterClockwise = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.rotateCounterClockwise45 = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (t) {
            return "";
        }
    }, t;
}(), $849102574a83a574$var$b = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$R = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$b(e, t), e.getChecksumInstance = function() {
        return new e;
    }, e.kind = "ChecksumException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$N = function() {
    function t(t) {
        this.source = t;
    }
    return t.prototype.getLuminanceSource = function() {
        return this.source;
    }, t.prototype.getWidth = function() {
        return this.source.getWidth();
    }, t.prototype.getHeight = function() {
        return this.source.getHeight();
    }, t;
}(), $849102574a83a574$var$D = function() {
    function t() {}
    return t.arraycopy = function(t, e, r, n, o) {
        for(; o--;)r[n++] = t[e++];
    }, t.currentTimeMillis = function() {
        return Date.now();
    }, t;
}(), $849102574a83a574$var$M = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$P = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$M(e, t), e.kind = "IndexOutOfBoundsException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$B = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$L = function(t) {
    function e(e, r) {
        void 0 === e && (e = void 0), void 0 === r && (r = void 0);
        var n = t.call(this, r) || this;
        return n.index = e, n.message = r, n;
    }
    return $849102574a83a574$var$B(e, t), e.kind = "ArrayIndexOutOfBoundsException", e;
}($849102574a83a574$var$P), $849102574a83a574$var$F = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$k = function() {
    function t() {}
    return t.fill = function(t, e) {
        for(var r = 0, n = t.length; r < n; r++)t[r] = e;
    }, t.fillWithin = function(e, r, n, o) {
        t.rangeCheck(e.length, r, n);
        for(var i = r; i < n; i++)e[i] = o;
    }, t.rangeCheck = function(t, e, r) {
        if (e > r) throw new $849102574a83a574$var$T("fromIndex(" + e + ") > toIndex(" + r + ")");
        if (e < 0) throw new $849102574a83a574$var$L(e);
        if (r > t) throw new $849102574a83a574$var$L(r);
    }, t.asList = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        return t;
    }, t.create = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Array.from({
                length: e
            }).fill(r);
        });
    }, t.createInt32Array = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Int32Array.from({
                length: e
            }).fill(r);
        });
    }, t.equals = function(t, e) {
        if (!t) return !1;
        if (!e) return !1;
        if (!t.length) return !1;
        if (!e.length) return !1;
        if (t.length !== e.length) return !1;
        for(var r = 0, n = t.length; r < n; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, t.hashCode = function(t) {
        var e, r;
        if (null === t) return 0;
        var n = 1;
        try {
            for(var o = $849102574a83a574$var$F(t), i = o.next(); !i.done; i = o.next())n = 31 * n + i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.fillUint8Array = function(t, e) {
        for(var r = 0; r !== t.length; r++)t[r] = e;
    }, t.copyOf = function(t, e) {
        return t.slice(0, e);
    }, t.copyOfUint8Array = function(t, e) {
        if (t.length <= e) {
            var r = new Uint8Array(e);
            return r.set(t), r;
        }
        return t.slice(0, e);
    }, t.copyOfRange = function(t, e, r) {
        var n = r - e, o = new Int32Array(n);
        return $849102574a83a574$var$D.arraycopy(t, e, o, 0, n), o;
    }, t.binarySearch = function(e, r, n) {
        void 0 === n && (n = t.numberComparator);
        for(var o = 0, i = e.length - 1; o <= i;){
            var a = i + o >> 1, s = n(r, e[a]);
            if (s > 0) o = a + 1;
            else {
                if (!(s < 0)) return a;
                i = a - 1;
            }
        }
        return -o - 1;
    }, t.numberComparator = function(t, e) {
        return t - e;
    }, t;
}(), $849102574a83a574$var$x = function() {
    function t() {}
    return t.numberOfTrailingZeros = function(t) {
        var e;
        if (0 === t) return 32;
        var r = 31;
        return 0 !== (e = t << 16) && (r -= 16, t = e), 0 !== (e = t << 8) && (r -= 8, t = e), 0 !== (e = t << 4) && (r -= 4, t = e), 0 !== (e = t << 2) && (r -= 2, t = e), r - (t << 1 >>> 31);
    }, t.numberOfLeadingZeros = function(t) {
        if (0 === t) return 32;
        var e = 1;
        return t >>> 16 == 0 && (e += 16, t <<= 16), t >>> 24 == 0 && (e += 8, t <<= 8), t >>> 28 == 0 && (e += 4, t <<= 4), t >>> 30 == 0 && (e += 2, t <<= 2), e -= t >>> 31;
    }, t.toHexString = function(t) {
        return t.toString(16);
    }, t.toBinaryString = function(t) {
        return String(parseInt(String(t), 2));
    }, t.bitCount = function(t) {
        return t = (t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135, t += t >>> 8, 63 & (t += t >>> 16);
    }, t.truncDivision = function(t, e) {
        return Math.trunc(t / e);
    }, t.parseInt = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t.MIN_VALUE_32_BITS = -2147483648, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $849102574a83a574$var$V = function() {
    function t(e, r) {
        void 0 === e ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, this.bits = null == r ? t.makeArray(e) : r);
    }
    return t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    }, t.prototype.ensureCapacity = function(e) {
        if (e > 32 * this.bits.length) {
            var r = t.makeArray(e);
            $849102574a83a574$var$D.arraycopy(this.bits, 0, r, 0, this.bits.length), this.bits = r;
        }
    }, t.prototype.get = function(t) {
        return 0 != (this.bits[Math.floor(t / 32)] & 1 << (31 & t));
    }, t.prototype.set = function(t) {
        this.bits[Math.floor(t / 32)] |= 1 << (31 & t);
    }, t.prototype.flip = function(t) {
        this.bits[Math.floor(t / 32)] ^= 1 << (31 & t);
    }, t.prototype.getNextSet = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = r[n];
        }
        var a = 32 * n + $849102574a83a574$var$x.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.getNextUnset = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = ~r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = ~r[n];
        }
        var a = 32 * n + $849102574a83a574$var$x.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.setBulk = function(t, e) {
        this.bits[Math.floor(t / 32)] = e;
    }, t.prototype.setRange = function(t, e) {
        if (e < t || t < 0 || e > this.size) throw new $849102574a83a574$var$T;
        if (e !== t) {
            e--;
            for(var r = Math.floor(t / 32), n = Math.floor(e / 32), o = this.bits, i = r; i <= n; i++){
                var a = (2 << (i < n ? 31 : 31 & e)) - (1 << (i > r ? 0 : 31 & t));
                o[i] |= a;
            }
        }
    }, t.prototype.clear = function() {
        for(var t = this.bits.length, e = this.bits, r = 0; r < t; r++)e[r] = 0;
    }, t.prototype.isRange = function(t, e, r) {
        if (e < t || t < 0 || e > this.size) throw new $849102574a83a574$var$T;
        if (e === t) return !0;
        e--;
        for(var n = Math.floor(t / 32), o = Math.floor(e / 32), i = this.bits, a = n; a <= o; a++){
            var s = (2 << (a < o ? 31 : 31 & e)) - (1 << (a > n ? 0 : 31 & t)) & 4294967295;
            if ((i[a] & s) !== (r ? s : 0)) return !1;
        }
        return !0;
    }, t.prototype.appendBit = function(t) {
        this.ensureCapacity(this.size + 1), t && (this.bits[Math.floor(this.size / 32)] |= 1 << (31 & this.size)), this.size++;
    }, t.prototype.appendBits = function(t, e) {
        if (e < 0 || e > 32) throw new $849102574a83a574$var$T("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + e);
        for(var r = e; r > 0; r--)this.appendBit(1 == (t >> r - 1 & 1));
    }, t.prototype.appendBitArray = function(t) {
        var e = t.size;
        this.ensureCapacity(this.size + e);
        for(var r = 0; r < e; r++)this.appendBit(t.get(r));
    }, t.prototype.xor = function(t) {
        if (this.size !== t.size) throw new $849102574a83a574$var$T("Sizes don't match");
        for(var e = this.bits, r = 0, n = e.length; r < n; r++)e[r] ^= t.bits[r];
    }, t.prototype.toBytes = function(t, e, r, n) {
        for(var o = 0; o < n; o++){
            for(var i = 0, a = 0; a < 8; a++)this.get(t) && (i |= 1 << 7 - a), t++;
            e[r + o] = i;
        }
    }, t.prototype.getBitArray = function() {
        return this.bits;
    }, t.prototype.reverse = function() {
        for(var t = new Int32Array(this.bits.length), e = Math.floor((this.size - 1) / 32), r = e + 1, n = this.bits, o = 0; o < r; o++){
            var i = n[o];
            i = (i = (i = (i = (i = i >> 1 & 1431655765 | (1431655765 & i) << 1) >> 2 & 858993459 | (858993459 & i) << 2) >> 4 & 252645135 | (252645135 & i) << 4) >> 8 & 16711935 | (16711935 & i) << 8) >> 16 & 65535 | (65535 & i) << 16, t[e - o] = i;
        }
        if (this.size !== 32 * r) {
            var a = 32 * r - this.size, s = t[0] >>> a;
            for(o = 1; o < r; o++){
                var u = t[o];
                s |= u << 32 - a, t[o - 1] = s, s = u >>> a;
            }
            t[r - 1] = s;
        }
        this.bits = t;
    }, t.makeArray = function(t) {
        return new Int32Array(Math.floor((t + 31) / 32));
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.size === r.size && $849102574a83a574$var$k.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        return 31 * this.size + $849102574a83a574$var$k.hashCode(this.bits);
    }, t.prototype.toString = function() {
        for(var t = "", e = 0, r = this.size; e < r; e++)0 == (7 & e) && (t += " "), t += this.get(e) ? "X" : ".";
        return t;
    }, t.prototype.clone = function() {
        return new t(this.size, this.bits.slice());
    }, t.prototype.toArray = function() {
        for(var t = [], e = 0, r = this.size; e < r; e++)t.push(this.get(e));
        return t;
    }, t;
}();
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.PURE_BARCODE = 1] = "PURE_BARCODE", t[t.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", t[t.TRY_HARDER = 3] = "TRY_HARDER", t[t.CHARACTER_SET = 4] = "CHARACTER_SET", t[t.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", t[t.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", t[t.ASSUME_GS1 = 7] = "ASSUME_GS1", t[t.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", t[t.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", t[t.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
}($849102574a83a574$var$v || ($849102574a83a574$var$v = {}));
var $849102574a83a574$var$H, $849102574a83a574$var$U = $849102574a83a574$var$v, $849102574a83a574$var$X = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$G = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$X(e, t), e.getFormatInstance = function() {
        return new e;
    }, e.kind = "FormatException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$W = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    t[t.Cp437 = 0] = "Cp437", t[t.ISO8859_1 = 1] = "ISO8859_1", t[t.ISO8859_2 = 2] = "ISO8859_2", t[t.ISO8859_3 = 3] = "ISO8859_3", t[t.ISO8859_4 = 4] = "ISO8859_4", t[t.ISO8859_5 = 5] = "ISO8859_5", t[t.ISO8859_6 = 6] = "ISO8859_6", t[t.ISO8859_7 = 7] = "ISO8859_7", t[t.ISO8859_8 = 8] = "ISO8859_8", t[t.ISO8859_9 = 9] = "ISO8859_9", t[t.ISO8859_10 = 10] = "ISO8859_10", t[t.ISO8859_11 = 11] = "ISO8859_11", t[t.ISO8859_13 = 12] = "ISO8859_13", t[t.ISO8859_14 = 13] = "ISO8859_14", t[t.ISO8859_15 = 14] = "ISO8859_15", t[t.ISO8859_16 = 15] = "ISO8859_16", t[t.SJIS = 16] = "SJIS", t[t.Cp1250 = 17] = "Cp1250", t[t.Cp1251 = 18] = "Cp1251", t[t.Cp1252 = 19] = "Cp1252", t[t.Cp1256 = 20] = "Cp1256", t[t.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", t[t.UTF8 = 22] = "UTF8", t[t.ASCII = 23] = "ASCII", t[t.Big5 = 24] = "Big5", t[t.GB18030 = 25] = "GB18030", t[t.EUC_KR = 26] = "EUC_KR";
}($849102574a83a574$var$H || ($849102574a83a574$var$H = {}));
var $849102574a83a574$var$z, $849102574a83a574$var$j = function() {
    function t(e, r, n) {
        for(var o, i, a = [], s = 3; s < arguments.length; s++)a[s - 3] = arguments[s];
        this.valueIdentifier = e, this.name = n, this.values = "number" == typeof r ? Int32Array.from([
            r
        ]) : r, this.otherEncodingNames = a, t.VALUE_IDENTIFIER_TO_ECI.set(e, this), t.NAME_TO_ECI.set(n, this);
        for(var u = this.values, c = 0, f = u.length; c !== f; c++){
            var h = u[c];
            t.VALUES_TO_ECI.set(h, this);
        }
        try {
            for(var l = $849102574a83a574$var$W(a), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                t.NAME_TO_ECI.set(p, this);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
    }
    return t.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    }, t.prototype.getName = function() {
        return this.name;
    }, t.prototype.getValue = function() {
        return this.values[0];
    }, t.getCharacterSetECIByValue = function(e) {
        if (e < 0 || e >= 900) throw new $849102574a83a574$var$G("incorect value");
        var r = t.VALUES_TO_ECI.get(e);
        if (void 0 === r) throw new $849102574a83a574$var$G("incorect value");
        return r;
    }, t.getCharacterSetECIByName = function(e) {
        var r = t.NAME_TO_ECI.get(e);
        if (void 0 === r) throw new $849102574a83a574$var$G("incorect value");
        return r;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.getName() === r.getName();
    }, t.VALUE_IDENTIFIER_TO_ECI = new Map, t.VALUES_TO_ECI = new Map, t.NAME_TO_ECI = new Map, t.Cp437 = new t($849102574a83a574$var$H.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437"), t.ISO8859_1 = new t($849102574a83a574$var$H.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1"), t.ISO8859_2 = new t($849102574a83a574$var$H.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), t.ISO8859_3 = new t($849102574a83a574$var$H.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), t.ISO8859_4 = new t($849102574a83a574$var$H.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), t.ISO8859_5 = new t($849102574a83a574$var$H.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), t.ISO8859_6 = new t($849102574a83a574$var$H.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), t.ISO8859_7 = new t($849102574a83a574$var$H.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), t.ISO8859_8 = new t($849102574a83a574$var$H.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), t.ISO8859_9 = new t($849102574a83a574$var$H.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), t.ISO8859_10 = new t($849102574a83a574$var$H.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), t.ISO8859_11 = new t($849102574a83a574$var$H.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), t.ISO8859_13 = new t($849102574a83a574$var$H.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), t.ISO8859_14 = new t($849102574a83a574$var$H.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), t.ISO8859_15 = new t($849102574a83a574$var$H.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), t.ISO8859_16 = new t($849102574a83a574$var$H.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), t.SJIS = new t($849102574a83a574$var$H.SJIS, 20, "SJIS", "Shift_JIS"), t.Cp1250 = new t($849102574a83a574$var$H.Cp1250, 21, "Cp1250", "windows-1250"), t.Cp1251 = new t($849102574a83a574$var$H.Cp1251, 22, "Cp1251", "windows-1251"), t.Cp1252 = new t($849102574a83a574$var$H.Cp1252, 23, "Cp1252", "windows-1252"), t.Cp1256 = new t($849102574a83a574$var$H.Cp1256, 24, "Cp1256", "windows-1256"), t.UnicodeBigUnmarked = new t($849102574a83a574$var$H.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), t.UTF8 = new t($849102574a83a574$var$H.UTF8, 26, "UTF8", "UTF-8"), t.ASCII = new t($849102574a83a574$var$H.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII"), t.Big5 = new t($849102574a83a574$var$H.Big5, 28, "Big5"), t.GB18030 = new t($849102574a83a574$var$H.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), t.EUC_KR = new t($849102574a83a574$var$H.EUC_KR, 30, "EUC_KR", "EUC-KR"), t;
}(), $849102574a83a574$var$Y = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Z = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Y(e, t), e.kind = "UnsupportedOperationException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$K = function() {
    function t() {}
    return t.decode = function(t, e) {
        var r = this.encodingName(e);
        return this.customDecoder ? this.customDecoder(t, r) : "undefined" == typeof TextDecoder || this.shouldDecodeOnFallback(r) ? this.decodeFallback(t, r) : new TextDecoder(r).decode(t);
    }, t.shouldDecodeOnFallback = function(e) {
        return !t.isBrowser() && "ISO-8859-1" === e;
    }, t.encode = function(t, e) {
        var r = this.encodingName(e);
        return this.customEncoder ? this.customEncoder(t, r) : "undefined" == typeof TextEncoder ? this.encodeFallback(t) : (new TextEncoder).encode(t);
    }, t.isBrowser = function() {
        return "undefined" != typeof window && "[object Window]" === ({}).toString.call(window);
    }, t.encodingName = function(t) {
        return "string" == typeof t ? t : t.getName();
    }, t.encodingCharacterSet = function(t) {
        return t instanceof $849102574a83a574$var$j ? t : $849102574a83a574$var$j.getCharacterSetECIByName(t);
    }, t.decodeFallback = function(e, r) {
        var n = this.encodingCharacterSet(r);
        if (t.isDecodeFallbackSupported(n)) {
            for(var o = "", i = 0, a = e.length; i < a; i++){
                var s = e[i].toString(16);
                s.length < 2 && (s = "0" + s), o += "%" + s;
            }
            return decodeURIComponent(o);
        }
        if (n.equals($849102574a83a574$var$j.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
        throw new $849102574a83a574$var$Z("Encoding " + this.encodingName(r) + " not supported by fallback.");
    }, t.isDecodeFallbackSupported = function(t) {
        return t.equals($849102574a83a574$var$j.UTF8) || t.equals($849102574a83a574$var$j.ISO8859_1) || t.equals($849102574a83a574$var$j.ASCII);
    }, t.encodeFallback = function(t) {
        for(var e = btoa(unescape(encodeURIComponent(t))).split(""), r = [], n = 0; n < e.length; n++)r.push(e[n].charCodeAt(0));
        return new Uint8Array(r);
    }, t;
}(), $849102574a83a574$var$q = function() {
    function t() {}
    return t.castAsNonUtf8Char = function(t, e) {
        void 0 === e && (e = null);
        var r = e ? e.getName() : this.ISO88591;
        return $849102574a83a574$var$K.decode(new Uint8Array([
            t
        ]), r);
    }, t.guessEncoding = function(e, r) {
        if (null != r && void 0 !== r.get($849102574a83a574$var$U.CHARACTER_SET)) return r.get($849102574a83a574$var$U.CHARACTER_SET).toString();
        for(var n = e.length, o = !0, i = !0, a = !0, s = 0, u = 0, c = 0, f = 0, h = 0, l = 0, d = 0, p = 0, g = 0, y = 0, w = 0, v = e.length > 3 && 239 === e[0] && 187 === e[1] && 191 === e[2], _ = 0; _ < n && (o || i || a); _++){
            var A = 255 & e[_];
            a && (s > 0 ? 0 == (128 & A) ? a = !1 : s-- : 0 != (128 & A) && (0 == (64 & A) ? a = !1 : (s++, 0 == (32 & A) ? u++ : (s++, 0 == (16 & A) ? c++ : (s++, 0 == (8 & A) ? f++ : a = !1))))), o && (A > 127 && A < 160 ? o = !1 : A > 159 && (A < 192 || 215 === A || 247 === A) && w++), i && (h > 0 ? A < 64 || 127 === A || A > 252 ? i = !1 : h-- : 128 === A || 160 === A || A > 239 ? i = !1 : A > 160 && A < 224 ? (l++, p = 0, ++d > g && (g = d)) : A > 127 ? (h++, d = 0, ++p > y && (y = p)) : (d = 0, p = 0));
        }
        return a && s > 0 && (a = !1), i && h > 0 && (i = !1), a && (v || u + c + f > 0) ? t.UTF8 : i && (t.ASSUME_SHIFT_JIS || g >= 3 || y >= 3) ? t.SHIFT_JIS : o && i ? 2 === g && 2 === l || 10 * w >= n ? t.SHIFT_JIS : t.ISO88591 : o ? t.ISO88591 : i ? t.SHIFT_JIS : a ? t.UTF8 : t.PLATFORM_DEFAULT_ENCODING;
    }, t.format = function(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        var n = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, r, o, i, a, s) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++n]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var u, c = a ? parseInt(a.substr(1)) : void 0;
                switch(s){
                    case "s":
                        u = e[n];
                        break;
                    case "c":
                        u = e[n][0];
                        break;
                    case "f":
                        u = parseFloat(e[n]).toFixed(t);
                        break;
                    case "p":
                        u = parseFloat(e[n]).toPrecision(t);
                        break;
                    case "e":
                        u = parseFloat(e[n]).toExponential(t);
                        break;
                    case "x":
                        u = parseInt(e[n]).toString(c || 16);
                        break;
                    case "d":
                        u = parseFloat(parseInt(e[n], c || 10).toPrecision(t)).toFixed(0);
                }
                u = "object" == typeof u ? JSON.stringify(u) : (+u).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; u.length < f;)u = void 0 !== r ? u + h : h + u;
                return u;
            }
        });
    }, t.getBytes = function(t, e) {
        return $849102574a83a574$var$K.encode(t, e);
    }, t.getCharCode = function(t, e) {
        return void 0 === e && (e = 0), t.charCodeAt(e);
    }, t.getCharAt = function(t) {
        return String.fromCharCode(t);
    }, t.SHIFT_JIS = $849102574a83a574$var$j.SJIS.getName(), t.GB2312 = "GB2312", t.ISO88591 = $849102574a83a574$var$j.ISO8859_1.getName(), t.EUC_JP = "EUC_JP", t.UTF8 = $849102574a83a574$var$j.UTF8.getName(), t.PLATFORM_DEFAULT_ENCODING = t.UTF8, t.ASSUME_SHIFT_JIS = !1, t;
}(), $849102574a83a574$var$Q = function() {
    function t(t) {
        void 0 === t && (t = ""), this.value = t;
    }
    return t.prototype.enableDecoding = function(t) {
        return this.encoding = t, this;
    }, t.prototype.append = function(t) {
        return "string" == typeof t ? this.value += t.toString() : this.encoding ? this.value += $849102574a83a574$var$q.castAsNonUtf8Char(t, this.encoding) : this.value += String.fromCharCode(t), this;
    }, t.prototype.appendChars = function(t, e, r) {
        for(var n = e; e < e + r; n++)this.append(t[n]);
        return this;
    }, t.prototype.length = function() {
        return this.value.length;
    }, t.prototype.charAt = function(t) {
        return this.value.charAt(t);
    }, t.prototype.deleteCharAt = function(t) {
        this.value = this.value.substr(0, t) + this.value.substring(t + 1);
    }, t.prototype.setCharAt = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + 1);
    }, t.prototype.substring = function(t, e) {
        return this.value.substring(t, e);
    }, t.prototype.setLengthToZero = function() {
        this.value = "";
    }, t.prototype.toString = function() {
        return this.value;
    }, t.prototype.insert = function(t, e) {
        this.value = this.value.substring(0, t) + e + this.value.substring(t);
    }, t;
}(), $849102574a83a574$var$J = function() {
    function t(t, e, r, n) {
        if (this.width = t, this.height = e, this.rowSize = r, this.bits = n, null == e && (e = t), this.height = e, t < 1 || e < 1) throw new $849102574a83a574$var$T("Both dimensions must be greater than 0");
        null == r && (r = Math.floor((t + 31) / 32)), this.rowSize = r, null == n && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return t.parseFromBooleanArray = function(e) {
        for(var r = e.length, n = e[0].length, o = new t(n, r), i = 0; i < r; i++)for(var a = e[i], s = 0; s < n; s++)a[s] && o.set(s, i);
        return o;
    }, t.parseFromString = function(e, r, n) {
        if (null === e) throw new $849102574a83a574$var$T("stringRepresentation cannot be null");
        for(var o = new Array(e.length), i = 0, a = 0, s = -1, u = 0, c = 0; c < e.length;)if ("\n" === e.charAt(c) || "\r" === e.charAt(c)) {
            if (i > a) {
                if (-1 === s) s = i - a;
                else if (i - a !== s) throw new $849102574a83a574$var$T("row lengths do not match");
                a = i, u++;
            }
            c++;
        } else if (e.substring(c, c + r.length) === r) c += r.length, o[i] = !0, i++;
        else {
            if (e.substring(c, c + n.length) !== n) throw new $849102574a83a574$var$T("illegal character encountered: " + e.substring(c));
            c += n.length, o[i] = !1, i++;
        }
        if (i > a) {
            if (-1 === s) s = i - a;
            else if (i - a !== s) throw new $849102574a83a574$var$T("row lengths do not match");
            u++;
        }
        for(var f = new t(s, u), h = 0; h < i; h++)o[h] && f.set(Math.floor(h % s), Math.floor(h / s));
        return f;
    }, t.prototype.get = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        return 0 != (this.bits[r] >>> (31 & t) & 1);
    }, t.prototype.set = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] |= 1 << (31 & t) & 4294967295;
    }, t.prototype.unset = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] &= ~(1 << (31 & t) & 4294967295);
    }, t.prototype.flip = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] ^= 1 << (31 & t) & 4294967295;
    }, t.prototype.xor = function(t) {
        if (this.width !== t.getWidth() || this.height !== t.getHeight() || this.rowSize !== t.getRowSize()) throw new $849102574a83a574$var$T("input matrix dimensions do not match");
        for(var e = new $849102574a83a574$var$V(Math.floor(this.width / 32) + 1), r = this.rowSize, n = this.bits, o = 0, i = this.height; o < i; o++)for(var a = o * r, s = t.getRow(o, e).getBitArray(), u = 0; u < r; u++)n[a + u] ^= s[u];
    }, t.prototype.clear = function() {
        for(var t = this.bits, e = t.length, r = 0; r < e; r++)t[r] = 0;
    }, t.prototype.setRegion = function(t, e, r, n) {
        if (e < 0 || t < 0) throw new $849102574a83a574$var$T("Left and top must be nonnegative");
        if (n < 1 || r < 1) throw new $849102574a83a574$var$T("Height and width must be at least 1");
        var o = t + r, i = e + n;
        if (i > this.height || o > this.width) throw new $849102574a83a574$var$T("The region must fit inside the matrix");
        for(var a = this.rowSize, s = this.bits, u = e; u < i; u++)for(var c = u * a, f = t; f < o; f++)s[c + Math.floor(f / 32)] |= 1 << (31 & f) & 4294967295;
    }, t.prototype.getRow = function(t, e) {
        null == e || e.getSize() < this.width ? e = new $849102574a83a574$var$V(this.width) : e.clear();
        for(var r = this.rowSize, n = this.bits, o = t * r, i = 0; i < r; i++)e.setBulk(32 * i, n[o + i]);
        return e;
    }, t.prototype.setRow = function(t, e) {
        $849102574a83a574$var$D.arraycopy(e.getBitArray(), 0, this.bits, t * this.rowSize, this.rowSize);
    }, t.prototype.rotate180 = function() {
        for(var t = this.getWidth(), e = this.getHeight(), r = new $849102574a83a574$var$V(t), n = new $849102574a83a574$var$V(t), o = 0, i = Math.floor((e + 1) / 2); o < i; o++)r = this.getRow(o, r), n = this.getRow(e - 1 - o, n), r.reverse(), n.reverse(), this.setRow(o, n), this.setRow(e - 1 - o, r);
    }, t.prototype.getEnclosingRectangle = function() {
        for(var t = this.width, e = this.height, r = this.rowSize, n = this.bits, o = t, i = e, a = -1, s = -1, u = 0; u < e; u++)for(var c = 0; c < r; c++){
            var f = n[u * r + c];
            if (0 !== f) {
                if (u < i && (i = u), u > s && (s = u), 32 * c < o) {
                    for(var h = 0; 0 == (f << 31 - h & 4294967295);)h++;
                    32 * c + h < o && (o = 32 * c + h);
                }
                if (32 * c + 31 > a) {
                    for(h = 31; f >>> h == 0;)h--;
                    32 * c + h > a && (a = 32 * c + h);
                }
            }
        }
        return a < o || s < i ? null : Int32Array.from([
            o,
            i,
            a - o + 1,
            s - i + 1
        ]);
    }, t.prototype.getTopLeftOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = 0; r < e.length && 0 === e[r];)r++;
        if (r === e.length) return null;
        for(var n = r / t, o = r % t * 32, i = e[r], a = 0; 0 == (i << 31 - a & 4294967295);)a++;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getBottomRightOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = e.length - 1; r >= 0 && 0 === e[r];)r--;
        if (r < 0) return null;
        for(var n = Math.floor(r / t), o = 32 * Math.floor(r % t), i = e[r], a = 31; i >>> a == 0;)a--;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getRowSize = function() {
        return this.rowSize;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.width === r.width && this.height === r.height && this.rowSize === r.rowSize && $849102574a83a574$var$k.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        var t = this.width;
        return t = 31 * (t = 31 * (t = 31 * (t = 31 * t + this.width) + this.height) + this.rowSize) + $849102574a83a574$var$k.hashCode(this.bits);
    }, t.prototype.toString = function(t, e, r) {
        return void 0 === t && (t = "X "), void 0 === e && (e = "  "), void 0 === r && (r = "\n"), this.buildToString(t, e, r);
    }, t.prototype.buildToString = function(t, e, r) {
        for(var n = new $849102574a83a574$var$Q, o = 0, i = this.height; o < i; o++){
            for(var a = 0, s = this.width; a < s; a++)n.append(this.get(a, o) ? t : e);
            n.append(r);
        }
        return n.toString();
    }, t.prototype.clone = function() {
        return new t(this.width, this.height, this.rowSize, this.bits.slice());
    }, t;
}(), $849102574a83a574$var$$ = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$tt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$$(e, t), e.getNotFoundInstance = function() {
        return new e;
    }, e.kind = "NotFoundException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$et = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$rt = function(t) {
    function e(r) {
        var n = t.call(this, r) || this;
        return n.luminances = e.EMPTY, n.buckets = new Int32Array(e.LUMINANCE_BUCKETS), n;
    }
    return $849102574a83a574$var$et(e, t), e.prototype.getBlackRow = function(t, r) {
        var n = this.getLuminanceSource(), o = n.getWidth();
        null == r || r.getSize() < o ? r = new $849102574a83a574$var$V(o) : r.clear(), this.initArrays(o);
        for(var i = n.getRow(t, this.luminances), a = this.buckets, s = 0; s < o; s++)a[(255 & i[s]) >> e.LUMINANCE_SHIFT]++;
        var u = e.estimateBlackPoint(a);
        if (o < 3) for(s = 0; s < o; s++)(255 & i[s]) < u && r.set(s);
        else {
            var c = 255 & i[0], f = 255 & i[1];
            for(s = 1; s < o - 1; s++){
                var h = 255 & i[s + 1];
                (4 * f - c - h) / 2 < u && r.set(s), c = f, f = h;
            }
        }
        return r;
    }, e.prototype.getBlackMatrix = function() {
        var t = this.getLuminanceSource(), r = t.getWidth(), n = t.getHeight(), o = new $849102574a83a574$var$J(r, n);
        this.initArrays(r);
        for(var i = this.buckets, a = 1; a < 5; a++)for(var s = Math.floor(n * a / 5), u = t.getRow(s, this.luminances), c = Math.floor(4 * r / 5), f = Math.floor(r / 5); f < c; f++)i[(255 & u[f]) >> e.LUMINANCE_SHIFT]++;
        var h = e.estimateBlackPoint(i), l = t.getMatrix();
        for(a = 0; a < n; a++){
            var d = a * r;
            for(f = 0; f < r; f++)(255 & l[d + f]) < h && o.set(f, a);
        }
        return o;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.prototype.initArrays = function(t) {
        this.luminances.length < t && (this.luminances = new Uint8ClampedArray(t));
        for(var r = this.buckets, n = 0; n < e.LUMINANCE_BUCKETS; n++)r[n] = 0;
    }, e.estimateBlackPoint = function(t) {
        for(var r = t.length, n = 0, o = 0, i = 0, a = 0; a < r; a++)t[a] > i && (o = a, i = t[a]), t[a] > n && (n = t[a]);
        var s = 0, u = 0;
        for(a = 0; a < r; a++){
            var c = a - o;
            (d = t[a] * c * c) > u && (s = a, u = d);
        }
        if (o > s) {
            var f = o;
            o = s, s = f;
        }
        if (s - o <= r / 16) throw new $849102574a83a574$var$tt;
        var h = s - 1, l = -1;
        for(a = s - 1; a > o; a--){
            var d, p = a - o;
            (d = p * p * (s - a) * (n - t[a])) > l && (h = a, l = d);
        }
        return h << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([
        0
    ]), e;
}($849102574a83a574$var$N), $849102574a83a574$var$nt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ot = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.matrix = null, r;
    }
    return $849102574a83a574$var$nt(e, t), e.prototype.getBlackMatrix = function() {
        if (null !== this.matrix) return this.matrix;
        var r = this.getLuminanceSource(), n = r.getWidth(), o = r.getHeight();
        if (n >= e.MINIMUM_DIMENSION && o >= e.MINIMUM_DIMENSION) {
            var i = r.getMatrix(), a = n >> e.BLOCK_SIZE_POWER;
            0 != (n & e.BLOCK_SIZE_MASK) && a++;
            var s = o >> e.BLOCK_SIZE_POWER;
            0 != (o & e.BLOCK_SIZE_MASK) && s++;
            var u = e.calculateBlackPoints(i, a, s, n, o), c = new $849102574a83a574$var$J(n, o);
            e.calculateThresholdForBlock(i, a, s, n, o, u, c), this.matrix = c;
        } else this.matrix = t.prototype.getBlackMatrix.call(this);
        return this.matrix;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.calculateThresholdForBlock = function(t, r, n, o, i, a, s) {
        for(var u = i - e.BLOCK_SIZE, c = o - e.BLOCK_SIZE, f = 0; f < n; f++){
            var h = f << e.BLOCK_SIZE_POWER;
            h > u && (h = u);
            for(var l = e.cap(f, 2, n - 3), d = 0; d < r; d++){
                var p = d << e.BLOCK_SIZE_POWER;
                p > c && (p = c);
                for(var g = e.cap(d, 2, r - 3), y = 0, w = -2; w <= 2; w++){
                    var v = a[l + w];
                    y += v[g - 2] + v[g - 1] + v[g] + v[g + 1] + v[g + 2];
                }
                var _ = y / 25;
                e.thresholdBlock(t, p, h, _, o, s);
            }
        }
    }, e.cap = function(t, e, r) {
        return t < e ? e : t > r ? r : t;
    }, e.thresholdBlock = function(t, r, n, o, i, a) {
        for(var s = 0, u = n * i + r; s < e.BLOCK_SIZE; s++, u += i)for(var c = 0; c < e.BLOCK_SIZE; c++)(255 & t[u + c]) <= o && a.set(r + c, n + s);
    }, e.calculateBlackPoints = function(t, r, n, o, i) {
        for(var a = i - e.BLOCK_SIZE, s = o - e.BLOCK_SIZE, u = new Array(n), c = 0; c < n; c++){
            u[c] = new Int32Array(r);
            var f = c << e.BLOCK_SIZE_POWER;
            f > a && (f = a);
            for(var h = 0; h < r; h++){
                var l = h << e.BLOCK_SIZE_POWER;
                l > s && (l = s);
                for(var d = 0, p = 255, g = 0, y = 0, w = f * o + l; y < e.BLOCK_SIZE; y++, w += o){
                    for(var v = 0; v < e.BLOCK_SIZE; v++){
                        var _ = 255 & t[w + v];
                        d += _, _ < p && (p = _), _ > g && (g = _);
                    }
                    if (g - p > e.MIN_DYNAMIC_RANGE) for(y++, w += o; y < e.BLOCK_SIZE; y++, w += o)for(v = 0; v < e.BLOCK_SIZE; v++)d += 255 & t[w + v];
                }
                var A = d >> 2 * e.BLOCK_SIZE_POWER;
                if (g - p <= e.MIN_DYNAMIC_RANGE && (A = p / 2, c > 0 && h > 0)) {
                    var C = (u[c - 1][h] + 2 * u[c][h - 1] + u[c - 1][h - 1]) / 4;
                    p < C && (A = C);
                }
                u[c][h] = A;
            }
        }
        return u;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = 5 * e.BLOCK_SIZE, e.MIN_DYNAMIC_RANGE = 24, e;
}($849102574a83a574$var$rt), $849102574a83a574$var$it = function() {
    function t(t, e) {
        this.width = t, this.height = e;
    }
    return t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.isCropSupported = function() {
        return !1;
    }, t.prototype.crop = function(t, e, r, n) {
        throw new $849102574a83a574$var$Z("This luminance source does not support cropping.");
    }, t.prototype.isRotateSupported = function() {
        return !1;
    }, t.prototype.rotateCounterClockwise = function() {
        throw new $849102574a83a574$var$Z("This luminance source does not support rotation by 90 degrees.");
    }, t.prototype.rotateCounterClockwise45 = function() {
        throw new $849102574a83a574$var$Z("This luminance source does not support rotation by 45 degrees.");
    }, t.prototype.toString = function() {
        for(var t = new Uint8ClampedArray(this.width), e = new $849102574a83a574$var$Q, r = 0; r < this.height; r++){
            for(var n = this.getRow(r, t), o = 0; o < this.width; o++){
                var i = 255 & n[o], a = void 0;
                a = i < 64 ? "#" : i < 128 ? "+" : i < 192 ? "." : " ", e.append(a);
            }
            e.append("\n");
        }
        return e.toString();
    }, t;
}(), $849102574a83a574$var$at = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$st = function(t) {
    function e(e) {
        var r = t.call(this, e.getWidth(), e.getHeight()) || this;
        return r.delegate = e, r;
    }
    return $849102574a83a574$var$at(e, t), e.prototype.getRow = function(t, e) {
        for(var r = this.delegate.getRow(t, e), n = this.getWidth(), o = 0; o < n; o++)r[o] = 255 - (255 & r[o]);
        return r;
    }, e.prototype.getMatrix = function() {
        for(var t = this.delegate.getMatrix(), e = this.getWidth() * this.getHeight(), r = new Uint8ClampedArray(e), n = 0; n < e; n++)r[n] = 255 - (255 & t[n]);
        return r;
    }, e.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.delegate.crop(t, r, n, o));
    }, e.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
        return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
        return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
        return new e(this.delegate.rotateCounterClockwise45());
    }, e;
}($849102574a83a574$var$it), $849102574a83a574$var$ut = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ct = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $849102574a83a574$var$ut(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d").getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(r.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, r, n) {
        var o = new Uint8ClampedArray(r * n);
        if (e.FRAME_INDEX = !e.FRAME_INDEX, e.FRAME_INDEX) for(var i = 0, a = 0, s = t.length; i < s; i += 4, a++){
            var u = void 0;
            if (0 === t[i + 3]) u = 255;
            else u = 306 * t[i] + 601 * t[i + 1] + 117 * t[i + 2] + 512 >> 10;
            o[a] = u;
        }
        else {
            i = 0, a = 0;
            for(var c = t.length; i < c; i += 4, a++){
                u = void 0;
                if (0 === t[i + 3]) u = 255;
                else u = 306 * t[i] + 601 * t[i + 1] + 117 * t[i + 2] + 512 >> 10;
                o[a] = 255 - u;
            }
        }
        return o;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $849102574a83a574$var$T("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement(), n = r.getContext("2d"), o = t * e.DEGREE_TO_RADIANS, i = this.canvas.width, a = this.canvas.height, s = Math.ceil(Math.abs(Math.cos(o)) * i + Math.abs(Math.sin(o)) * a), u = Math.ceil(Math.abs(Math.sin(o)) * i + Math.abs(Math.cos(o)) * a);
        return r.width = s, r.height = u, n.translate(s / 2, u / 2), n.rotate(o), n.drawImage(this.canvas, i / -2, a / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.prototype.invert = function() {
        return new $849102574a83a574$var$st(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e.FRAME_INDEX = !0, e;
}($849102574a83a574$var$it), $849102574a83a574$var$ft = function() {
    function t(t, e, r) {
        this.deviceId = t, this.label = e, this.kind = "videoinput", this.groupId = r || void 0;
    }
    return t.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    }, t;
}(), $849102574a83a574$var$ht = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                u(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                u(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, s);
        }
        u((n = n.apply(t, e || [])).next());
    });
}, $849102574a83a574$var$lt = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function s(i) {
        return function(s) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                s
            ]);
        };
    }
}, $849102574a83a574$var$dt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$pt = function() {
    function t(t, e, r) {
        void 0 === e && (e = 500), this.reader = t, this.timeBetweenScansMillis = e, this._hints = r, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(t.prototype, "hasNavigator", {
        get: function() {
            return "undefined" != typeof navigator;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isMediaDevicesSuported", {
        get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "canEnumerateDevices", {
        get: function() {
            return !(!this.isMediaDevicesSuported || !navigator.mediaDevices.enumerateDevices);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timeBetweenDecodingAttempts", {
        get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        set: function(t) {
            this._timeBetweenDecodingAttempts = t < 0 ? 0 : t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hints", {
        get: function() {
            return this._hints;
        },
        set: function(t) {
            this._hints = t || null;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listVideoInputDevices = function() {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, s, u, c, f, h;
            return $849102574a83a574$var$lt(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $849102574a83a574$var$dt(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, s = o.label || "Video device " + (e.length + 1), u = o.groupId, c = {
                                deviceId: a,
                                label: s,
                                kind: i,
                                groupId: u
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.getVideoInputDevices = function() {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return [
                            2,
                            t.sent().map(function(t) {
                                return new $849102574a83a574$var$ft(t.deviceId, t.label);
                            })
                        ];
                }
            });
        });
    }, t.prototype.findDeviceById = function(t) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var e;
            return $849102574a83a574$var$lt(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return (e = r.sent()) ? [
                            2,
                            e.find(function(e) {
                                return e.deviceId === t;
                            })
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDevice = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.decodeOnceFromVideoDevice(t, e)
                        ];
                    case 1:
                        return [
                            2,
                            r.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnce(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDeviceContinuously = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.decodeFromVideoDevice(t, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var n;
            return $849102574a83a574$var$lt(this, function(o) {
                switch(o.label){
                    case 0:
                        return n = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(n, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var n;
            return $849102574a83a574$var$lt(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeFromStream(n, e, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(t, e, r) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var n;
            return $849102574a83a574$var$lt(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeContinuously(n, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = !0;
    }, t.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = !0;
    }, t.prototype.attachStreamToVideo = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            var r;
            return $849102574a83a574$var$lt(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this.prepareVideoElement(e), this.addVideoSource(r, t), this.videoElement = r, this.stream = t, [
                            4,
                            this.playVideoOnLoadAsync(r)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.playVideoOnLoadAsync = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            return e.playVideoOnLoad(t, function() {
                return r();
            });
        });
    }, t.prototype.playVideoOnLoad = function(t, e) {
        var r = this;
        this.videoEndedListener = function() {
            return r.stopStreams();
        }, this.videoCanPlayListener = function() {
            return r.tryPlayVideo(t);
        }, t.addEventListener("ended", this.videoEndedListener), t.addEventListener("canplay", this.videoCanPlayListener), t.addEventListener("playing", e), this.tryPlayVideo(t);
    }, t.prototype.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && !t.ended && t.readyState > 2;
    }, t.prototype.tryPlayVideo = function(t) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(e) {
                switch(e.label){
                    case 0:
                        if (this.isVideoPlaying(t)) return console.warn("Trying to play video that is already playing."), [
                            2
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            t.play()
                        ];
                    case 2:
                        return e.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        return e.sent(), console.warn("It was not possible to play the video."), [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $849102574a83a574$var$I("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $849102574a83a574$var$I("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.prototype.decodeFromImage = function(t, e) {
        if (!t && !e) throw new $849102574a83a574$var$I("either imageElement with a src set or an url must be provided");
        return e && !t ? this.decodeFromImageUrl(e) : this.decodeFromImageElement(t);
    }, t.prototype.decodeFromVideo = function(t, e) {
        if (!t && !e) throw new $849102574a83a574$var$I("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrl(e) : this.decodeFromVideoElement(t);
    }, t.prototype.decodeFromVideoContinuously = function(t, e, r) {
        if (void 0 === t && void 0 === e) throw new $849102574a83a574$var$I("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrlContinuously(e, r) : this.decodeFromVideoElementContinuously(t, r);
    }, t.prototype.decodeFromImageElement = function(t) {
        if (!t) throw new $849102574a83a574$var$I("An image element must be provided.");
        this.reset();
        var e = this.prepareImageElement(t);
        return this.imageElement = e, this.isImageLoaded(e) ? this.decodeOnce(e, !1, !0) : this._decodeOnLoadImage(e);
    }, t.prototype.decodeFromVideoElement = function(t) {
        var e = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideo(e);
    }, t.prototype.decodeFromVideoElementContinuously = function(t, e) {
        var r = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideoContinuously(r, e);
    }, t.prototype._decodeFromVideoElementSetup = function(t) {
        if (!t) throw new $849102574a83a574$var$I("A video element must be provided.");
        this.reset();
        var e = this.prepareVideoElement(t);
        return this.videoElement = e, e;
    }, t.prototype.decodeFromImageUrl = function(t) {
        if (!t) throw new $849102574a83a574$var$I("An URL must be provided.");
        this.reset();
        var e = this.prepareImageElement();
        this.imageElement = e;
        var r = this._decodeOnLoadImage(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrl = function(t) {
        if (!t) throw new $849102574a83a574$var$I("An URL must be provided.");
        this.reset();
        var e = this.prepareVideoElement(), r = this.decodeFromVideoElement(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrlContinuously = function(t, e) {
        if (!t) throw new $849102574a83a574$var$I("An URL must be provided.");
        this.reset();
        var r = this.prepareVideoElement(), n = this.decodeFromVideoElementContinuously(r, e);
        return r.src = t, n;
    }, t.prototype._decodeOnLoadImage = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            e.imageLoadedListener = function() {
                return e.decodeOnce(t, !1, !0).then(r, n);
            }, t.addEventListener("load", e.imageLoadedListener);
        });
    }, t.prototype._decodeOnLoadVideo = function(t) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.decodeOnce(t)
                        ];
                    case 2:
                        return [
                            2,
                            e.sent()
                        ];
                }
            });
        });
    }, t.prototype._decodeOnLoadVideoContinuously = function(t, e) {
        return $849102574a83a574$var$ht(this, void 0, void 0, function() {
            return $849102574a83a574$var$lt(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return r.sent(), this.decodeContinuously(t, e), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.prototype.prepareImageElement = function(t) {
        var e;
        return void 0 === t && ((e = document.createElement("img")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "img")), t instanceof HTMLImageElement && (e = t), e;
    }, t.prototype.prepareVideoElement = function(t) {
        var e;
        return t || "undefined" == typeof document || ((e = document.createElement("video")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "video")), t instanceof HTMLVideoElement && (e = t), e.setAttribute("autoplay", "true"), e.setAttribute("muted", "true"), e.setAttribute("playsinline", "true"), e;
    }, t.prototype.decodeOnce = function(t, e, r) {
        var n = this;
        void 0 === e && (e = !0), void 0 === r && (r = !0), this._stopAsyncDecode = !1;
        var o = function(i, a) {
            if (n._stopAsyncDecode) return a(new $849102574a83a574$var$tt("Video stream has ended before any code could be detected.")), void (n._stopAsyncDecode = void 0);
            try {
                i(n.decode(t));
            } catch (t) {
                if (e && t instanceof $849102574a83a574$var$tt || (t instanceof $849102574a83a574$var$R || t instanceof $849102574a83a574$var$G) && r) return setTimeout(o, n._timeBetweenDecodingAttempts, i, a);
                a(t);
            }
        };
        return new Promise(function(t, e) {
            return o(t, e);
        });
    }, t.prototype.decodeContinuously = function(t, e) {
        var r = this;
        this._stopContinuousDecode = !1;
        var n = function() {
            if (r._stopContinuousDecode) r._stopContinuousDecode = void 0;
            else try {
                var o = r.decode(t);
                e(o, null), setTimeout(n, r.timeBetweenScansMillis);
            } catch (t) {
                e(null, t), (t instanceof $849102574a83a574$var$R || t instanceof $849102574a83a574$var$G || t instanceof $849102574a83a574$var$tt) && setTimeout(n, r._timeBetweenDecodingAttempts);
            }
        };
        n();
    }, t.prototype.decode = function(t) {
        var e = this.createBinaryBitmap(t);
        return this.decodeBitmap(e);
    }, t.prototype.createBinaryBitmap = function(t) {
        this.getCaptureCanvasContext(t), t instanceof HTMLVideoElement ? this.drawFrameOnCanvas(t) : this.drawImageOnCanvas(t);
        var e = this.getCaptureCanvas(t), r = new $849102574a83a574$var$ct(e), n = new $849102574a83a574$var$ot(r);
        return new $849102574a83a574$var$O(n);
    }, t.prototype.getCaptureCanvasContext = function(t) {
        if (!this.captureCanvasContext) {
            var e = this.getCaptureCanvas(t), r = void 0;
            try {
                r = e.getContext("2d", {
                    willReadFrequently: !0
                });
            } catch (t) {
                r = e.getContext("2d");
            }
            this.captureCanvasContext = r;
        }
        return this.captureCanvasContext;
    }, t.prototype.getCaptureCanvas = function(t) {
        if (!this.captureCanvas) {
            var e = this.createCaptureCanvas(t);
            this.captureCanvas = e;
        }
        return this.captureCanvas;
    }, t.prototype.drawFrameOnCanvas = function(t, e, r) {
        void 0 === e && (e = {
            sx: 0,
            sy: 0,
            sWidth: t.videoWidth,
            sHeight: t.videoHeight,
            dx: 0,
            dy: 0,
            dWidth: t.videoWidth,
            dHeight: t.videoHeight
        }), void 0 === r && (r = this.captureCanvasContext), r.drawImage(t, e.sx, e.sy, e.sWidth, e.sHeight, e.dx, e.dy, e.dWidth, e.dHeight);
    }, t.prototype.drawImageOnCanvas = function(t, e, r) {
        void 0 === e && (e = {
            sx: 0,
            sy: 0,
            sWidth: t.naturalWidth,
            sHeight: t.naturalHeight,
            dx: 0,
            dy: 0,
            dWidth: t.naturalWidth,
            dHeight: t.naturalHeight
        }), void 0 === r && (r = this.captureCanvasContext), r.drawImage(t, e.sx, e.sy, e.sWidth, e.sHeight, e.dx, e.dy, e.dWidth, e.dHeight);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this._hints);
    }, t.prototype.createCaptureCanvas = function(t) {
        if ("undefined" == typeof document) return this._destroyCaptureCanvas(), null;
        var e, r, n = document.createElement("canvas");
        return void 0 !== t && (t instanceof HTMLVideoElement ? (e = t.videoWidth, r = t.videoHeight) : t instanceof HTMLImageElement && (e = t.naturalWidth || t.width, r = t.naturalHeight || t.height)), n.style.width = e + "px", n.style.height = r + "px", n.width = e, n.height = r, n;
    }, t.prototype.stopStreams = function() {
        this.stream && (this.stream.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), this.stream = void 0), !1 === this._stopAsyncDecode && this.stopAsyncDecode(), !1 === this._stopContinuousDecode && this.stopContinuousDecode();
    }, t.prototype.reset = function() {
        this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, t.prototype._destroyVideoElement = function() {
        this.videoElement && (void 0 !== this.videoEndedListener && this.videoElement.removeEventListener("ended", this.videoEndedListener), void 0 !== this.videoPlayingEventListener && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), void 0 !== this.videoCanPlayListener && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, t.prototype._destroyImageElement = function() {
        this.imageElement && (void 0 !== this.imageLoadedListener && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, t.prototype._destroyCaptureCanvas = function() {
        this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, t.prototype.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.prototype.cleanVideoSource = function(t) {
        try {
            t.srcObject = null;
        } catch (e) {
            t.src = "";
        }
        this.videoElement.removeAttribute("src");
    }, t;
}(), $849102574a83a574$var$gt = function() {
    function t(t, e, r, n, o, i) {
        void 0 === r && (r = null == e ? 0 : 8 * e.length), void 0 === i && (i = $849102574a83a574$var$D.currentTimeMillis()), this.text = t, this.rawBytes = e, this.numBits = r, this.resultPoints = n, this.format = o, this.timestamp = i, this.text = t, this.rawBytes = e, this.numBits = null == r ? null == e ? 0 : 8 * e.length : r, this.resultPoints = n, this.format = o, this.resultMetadata = null, this.timestamp = null == i ? $849102574a83a574$var$D.currentTimeMillis() : i;
    }
    return t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.getBarcodeFormat = function() {
        return this.format;
    }, t.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    }, t.prototype.putMetadata = function(t, e) {
        null === this.resultMetadata && (this.resultMetadata = new Map), this.resultMetadata.set(t, e);
    }, t.prototype.putAllMetadata = function(t) {
        null !== t && (null === this.resultMetadata ? this.resultMetadata = t : this.resultMetadata = new Map(t));
    }, t.prototype.addResultPoints = function(t) {
        var e = this.resultPoints;
        if (null === e) this.resultPoints = t;
        else if (null !== t && t.length > 0) {
            var r = new Array(e.length + t.length);
            $849102574a83a574$var$D.arraycopy(e, 0, r, 0, e.length), $849102574a83a574$var$D.arraycopy(t, 0, r, e.length, t.length), this.resultPoints = r;
        }
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.toString = function() {
        return this.text;
    }, t;
}();
!function(t) {
    t[t.AZTEC = 0] = "AZTEC", t[t.CODABAR = 1] = "CODABAR", t[t.CODE_39 = 2] = "CODE_39", t[t.CODE_93 = 3] = "CODE_93", t[t.CODE_128 = 4] = "CODE_128", t[t.DATA_MATRIX = 5] = "DATA_MATRIX", t[t.EAN_8 = 6] = "EAN_8", t[t.EAN_13 = 7] = "EAN_13", t[t.ITF = 8] = "ITF", t[t.MAXICODE = 9] = "MAXICODE", t[t.PDF_417 = 10] = "PDF_417", t[t.QR_CODE = 11] = "QR_CODE", t[t.RSS_14 = 12] = "RSS_14", t[t.RSS_EXPANDED = 13] = "RSS_EXPANDED", t[t.UPC_A = 14] = "UPC_A", t[t.UPC_E = 15] = "UPC_E", t[t.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
}($849102574a83a574$var$z || ($849102574a83a574$var$z = {}));
var $849102574a83a574$var$yt, $849102574a83a574$var$wt = $849102574a83a574$var$z;
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.ORIENTATION = 1] = "ORIENTATION", t[t.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", t[t.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", t[t.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", t[t.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", t[t.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", t[t.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", t[t.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", t[t.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", t[t.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
}($849102574a83a574$var$yt || ($849102574a83a574$var$yt = {}));
var $849102574a83a574$var$vt, $849102574a83a574$var$_t = $849102574a83a574$var$yt, $849102574a83a574$var$At = function() {
    function t(t, e, r, n, o, i) {
        void 0 === o && (o = -1), void 0 === i && (i = -1), this.rawBytes = t, this.text = e, this.byteSegments = r, this.ecLevel = n, this.structuredAppendSequenceNumber = o, this.structuredAppendParity = i, this.numBits = null == t ? 0 : 8 * t.length;
    }
    return t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.setNumBits = function(t) {
        this.numBits = t;
    }, t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getByteSegments = function() {
        return this.byteSegments;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    }, t.prototype.setErrorsCorrected = function(t) {
        this.errorsCorrected = t;
    }, t.prototype.getErasures = function() {
        return this.erasures;
    }, t.prototype.setErasures = function(t) {
        this.erasures = t;
    }, t.prototype.getOther = function() {
        return this.other;
    }, t.prototype.setOther = function(t) {
        this.other = t;
    }, t.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, t.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    }, t.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    }, t;
}(), $849102574a83a574$var$Ct = function() {
    function t() {}
    return t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $849102574a83a574$var$T;
        return this.logTable[t];
    }, t.addOrSubtract = function(t, e) {
        return t ^ e;
    }, t;
}(), $849102574a83a574$var$mt = function() {
    function t(t, e) {
        if (0 === e.length) throw new $849102574a83a574$var$T;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = Int32Array.from([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $849102574a83a574$var$D.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        if (0 === t) return this.getCoefficient(0);
        var e, r = this.coefficients;
        if (1 === t) {
            e = 0;
            for(var n = 0, o = r.length; n !== o; n++){
                var i = r[n];
                e = $849102574a83a574$var$Ct.addOrSubtract(e, i);
            }
            return e;
        }
        e = r[0];
        var a = r.length, s = this.field;
        for(n = 1; n < a; n++)e = $849102574a83a574$var$Ct.addOrSubtract(s.multiply(t, e), r[n]);
        return e;
    }, t.prototype.addOrSubtract = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $849102574a83a574$var$D.arraycopy(n, 0, i, 0, a);
        for(var s = a; s < n.length; s++)i[s] = $849102574a83a574$var$Ct.addOrSubtract(r[s - a], n[s]);
        return new t(this.field, i);
    }, t.prototype.multiply = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || e.isZero()) return this.field.getZero();
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), s = this.field, u = 0; u < n; u++)for(var c = r[u], f = 0; f < i; f++)a[u + f] = $849102574a83a574$var$Ct.addOrSubtract(a[u + f], s.multiply(c, o[f]));
        return new t(s, a);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return this.field.getZero();
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = this.field, o = new Int32Array(r), i = this.coefficients, a = 0; a < r; a++)o[a] = n.multiply(i[a], e);
        return new t(n, o);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $849102574a83a574$var$T;
        if (0 === r) return this.field.getZero();
        for(var n = this.coefficients, o = n.length, i = new Int32Array(o + e), a = this.field, s = 0; s < o; s++)i[s] = a.multiply(n[s], r);
        return new t(a, i);
    }, t.prototype.divide = function(t) {
        if (!this.field.equals(t.field)) throw new $849102574a83a574$var$T("GenericGFPolys do not have same GenericGF field");
        if (t.isZero()) throw new $849102574a83a574$var$T("Divide by 0");
        for(var e = this.field, r = e.getZero(), n = this, o = t.getCoefficient(t.getDegree()), i = e.inverse(o); n.getDegree() >= t.getDegree() && !n.isZero();){
            var a = n.getDegree() - t.getDegree(), s = e.multiply(n.getCoefficient(n.getDegree()), i), u = t.multiplyByMonomial(a, s), c = e.buildMonomial(a, s);
            r = r.addOrSubtract(c), n = n.addOrSubtract(u);
        }
        return [
            r,
            n
        ];
    }, t.prototype.toString = function() {
        for(var t = "", e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            if (0 !== r) {
                if (r < 0 ? (t += " - ", r = -r) : t.length > 0 && (t += " + "), 0 === e || 1 !== r) {
                    var n = this.field.log(r);
                    0 === n ? t += "1" : 1 === n ? t += "a" : (t += "a^", t += n);
                }
                0 !== e && (1 === e ? t += "x" : (t += "x^", t += e));
            }
        }
        return t;
    }, t;
}(), $849102574a83a574$var$Et = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$It = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Et(e, t), e.kind = "ArithmeticException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$St = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Tt = function(t) {
    function e(e, r, n) {
        var o = t.call(this) || this;
        o.primitive = e, o.size = r, o.generatorBase = n;
        for(var i = new Int32Array(r), a = 1, s = 0; s < r; s++)i[s] = a, (a *= 2) >= r && (a ^= e, a &= r - 1);
        o.expTable = i;
        var u = new Int32Array(r);
        for(s = 0; s < r - 1; s++)u[i[s]] = s;
        return o.logTable = u, o.zero = new $849102574a83a574$var$mt(o, Int32Array.from([
            0
        ])), o.one = new $849102574a83a574$var$mt(o, Int32Array.from([
            1
        ])), o;
    }
    return $849102574a83a574$var$St(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $849102574a83a574$var$T;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $849102574a83a574$var$mt(this, r);
    }, e.prototype.inverse = function(t) {
        if (0 === t) throw new $849102574a83a574$var$It;
        return this.expTable[this.size - this.logTable[t] - 1];
    }, e.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
        return this.size;
    }, e.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    }, e.prototype.toString = function() {
        return "GF(0x" + $849102574a83a574$var$x.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(t) {
        return t === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
}($849102574a83a574$var$Ct), $849102574a83a574$var$Ot = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$bt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Ot(e, t), e.kind = "ReedSolomonException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$Rt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Nt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Rt(e, t), e.kind = "IllegalStateException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$Dt = function() {
    function t(t) {
        this.field = t;
    }
    return t.prototype.decode = function(t, e) {
        for(var r = this.field, n = new $849102574a83a574$var$mt(r, t), o = new Int32Array(e), i = !0, a = 0; a < e; a++){
            var s = n.evaluateAt(r.exp(a + r.getGeneratorBase()));
            o[o.length - 1 - a] = s, 0 !== s && (i = !1);
        }
        if (!i) {
            var u = new $849102574a83a574$var$mt(r, o), c = this.runEuclideanAlgorithm(r.buildMonomial(e, 1), u, e), f = c[0], h = c[1], l = this.findErrorLocations(f), d = this.findErrorMagnitudes(h, l);
            for(a = 0; a < l.length; a++){
                var p = t.length - 1 - r.log(l[a]);
                if (p < 0) throw new $849102574a83a574$var$bt("Bad error location");
                t[p] = $849102574a83a574$var$Tt.addOrSubtract(t[p], d[a]);
            }
        }
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = this.field, i = t, a = e, s = o.getZero(), u = o.getOne(); a.getDegree() >= (r / 2 | 0);){
            var c = i, f = s;
            if (s = u, (i = a).isZero()) throw new $849102574a83a574$var$bt("r_{i-1} was zero");
            a = c;
            for(var h = o.getZero(), l = i.getCoefficient(i.getDegree()), d = o.inverse(l); a.getDegree() >= i.getDegree() && !a.isZero();){
                var p = a.getDegree() - i.getDegree(), g = o.multiply(a.getCoefficient(a.getDegree()), d);
                h = h.addOrSubtract(o.buildMonomial(p, g)), a = a.addOrSubtract(i.multiplyByMonomial(p, g));
            }
            if (u = h.multiply(s).addOrSubtract(f), a.getDegree() >= i.getDegree()) throw new $849102574a83a574$var$Nt("Division algorithm failed to reduce polynomial?");
        }
        var y = u.getCoefficient(0);
        if (0 === y) throw new $849102574a83a574$var$bt("sigmaTilde(0) was zero");
        var w = o.inverse(y);
        return [
            u.multiplyScalar(w),
            a.multiplyScalar(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        var e = t.getDegree();
        if (1 === e) return Int32Array.from([
            t.getCoefficient(1)
        ]);
        for(var r = new Int32Array(e), n = 0, o = this.field, i = 1; i < o.getSize() && n < e; i++)0 === t.evaluateAt(i) && (r[n] = o.inverse(i), n++);
        if (n !== e) throw new $849102574a83a574$var$bt("Error locator degree does not match number of roots");
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e) {
        for(var r = e.length, n = new Int32Array(r), o = this.field, i = 0; i < r; i++){
            for(var a = o.inverse(e[i]), s = 1, u = 0; u < r; u++)if (i !== u) {
                var c = o.multiply(e[u], a), f = 0 == (1 & c) ? 1 | c : -2 & c;
                s = o.multiply(s, f);
            }
            n[i] = o.multiply(t.evaluateAt(a), o.inverse(s)), 0 !== o.getGeneratorBase() && (n[i] = o.multiply(n[i], a));
        }
        return n;
    }, t;
}();
!function(t) {
    t[t.UPPER = 0] = "UPPER", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.DIGIT = 3] = "DIGIT", t[t.PUNCT = 4] = "PUNCT", t[t.BINARY = 5] = "BINARY";
}($849102574a83a574$var$vt || ($849102574a83a574$var$vt = {}));
var $849102574a83a574$var$Mt = function() {
    function t() {}
    return t.prototype.decode = function(e) {
        this.ddata = e;
        var r = e.getBits(), n = this.extractBits(r), o = this.correctBits(n), i = t.convertBoolArrayToByteArray(o), a = t.getEncodedData(o), s = new $849102574a83a574$var$At(i, a, null, null);
        return s.setNumBits(o.length), s;
    }, t.highLevelDecode = function(t) {
        return this.getEncodedData(t);
    }, t.getEncodedData = function(e) {
        for(var r = e.length, n = $849102574a83a574$var$vt.UPPER, o = $849102574a83a574$var$vt.UPPER, i = "", a = 0; a < r;)if (o === $849102574a83a574$var$vt.BINARY) {
            if (r - a < 5) break;
            var s = t.readCode(e, a, 5);
            if (a += 5, 0 === s) {
                if (r - a < 11) break;
                s = t.readCode(e, a, 11) + 31, a += 11;
            }
            for(var u = 0; u < s; u++){
                if (r - a < 8) {
                    a = r;
                    break;
                }
                var c = t.readCode(e, a, 8);
                i += $849102574a83a574$var$q.castAsNonUtf8Char(c), a += 8;
            }
            o = n;
        } else {
            var f = o === $849102574a83a574$var$vt.DIGIT ? 4 : 5;
            if (r - a < f) break;
            c = t.readCode(e, a, f);
            a += f;
            var h = t.getCharacter(o, c);
            h.startsWith("CTRL_") ? (n = o, o = t.getTable(h.charAt(5)), "L" === h.charAt(6) && (n = o)) : (i += h, o = n);
        }
        return i;
    }, t.getTable = function(t) {
        switch(t){
            case "L":
                return $849102574a83a574$var$vt.LOWER;
            case "P":
                return $849102574a83a574$var$vt.PUNCT;
            case "M":
                return $849102574a83a574$var$vt.MIXED;
            case "D":
                return $849102574a83a574$var$vt.DIGIT;
            case "B":
                return $849102574a83a574$var$vt.BINARY;
            default:
                return $849102574a83a574$var$vt.UPPER;
        }
    }, t.getCharacter = function(e, r) {
        switch(e){
            case $849102574a83a574$var$vt.UPPER:
                return t.UPPER_TABLE[r];
            case $849102574a83a574$var$vt.LOWER:
                return t.LOWER_TABLE[r];
            case $849102574a83a574$var$vt.MIXED:
                return t.MIXED_TABLE[r];
            case $849102574a83a574$var$vt.PUNCT:
                return t.PUNCT_TABLE[r];
            case $849102574a83a574$var$vt.DIGIT:
                return t.DIGIT_TABLE[r];
            default:
                throw new $849102574a83a574$var$Nt("Bad table");
        }
    }, t.prototype.correctBits = function(e) {
        var r, n;
        this.ddata.getNbLayers() <= 2 ? (n = 6, r = $849102574a83a574$var$Tt.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (n = 8, r = $849102574a83a574$var$Tt.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (n = 10, r = $849102574a83a574$var$Tt.AZTEC_DATA_10) : (n = 12, r = $849102574a83a574$var$Tt.AZTEC_DATA_12);
        var o = this.ddata.getNbDatablocks(), i = e.length / n;
        if (i < o) throw new $849102574a83a574$var$G;
        for(var a = e.length % n, s = new Int32Array(i), u = 0; u < i; u++, a += n)s[u] = t.readCode(e, a, n);
        try {
            new $849102574a83a574$var$Dt(r).decode(s, i - o);
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
        var c = (1 << n) - 1, f = 0;
        for(u = 0; u < o; u++){
            if (0 === (d = s[u]) || d === c) throw new $849102574a83a574$var$G;
            1 !== d && d !== c - 1 || f++;
        }
        var h = new Array(o * n - f), l = 0;
        for(u = 0; u < o; u++){
            var d;
            if (1 === (d = s[u]) || d === c - 1) h.fill(d > 1, l, l + n - 1), l += n - 1;
            else for(var p = n - 1; p >= 0; --p)h[l++] = 0 != (d & 1 << p);
        }
        return h;
    }, t.prototype.extractBits = function(t) {
        var e = this.ddata.isCompact(), r = this.ddata.getNbLayers(), n = (e ? 11 : 14) + 4 * r, o = new Int32Array(n), i = new Array(this.totalBitsInLayer(r, e));
        if (e) for(var a = 0; a < o.length; a++)o[a] = a;
        else {
            var s = n + 1 + 2 * $849102574a83a574$var$x.truncDivision($849102574a83a574$var$x.truncDivision(n, 2) - 1, 15), u = n / 2, c = $849102574a83a574$var$x.truncDivision(s, 2);
            for(a = 0; a < u; a++){
                var f = a + $849102574a83a574$var$x.truncDivision(a, 15);
                o[u - a - 1] = c - f - 1, o[u + a] = c + f + 1;
            }
        }
        a = 0;
        for(var h = 0; a < r; a++){
            for(var l = 4 * (r - a) + (e ? 9 : 12), d = 2 * a, p = n - 1 - d, g = 0; g < l; g++)for(var y = 2 * g, w = 0; w < 2; w++)i[h + y + w] = t.get(o[d + w], o[d + g]), i[h + 2 * l + y + w] = t.get(o[d + g], o[p - w]), i[h + 4 * l + y + w] = t.get(o[p - w], o[p - g]), i[h + 6 * l + y + w] = t.get(o[p - g], o[d + w]);
            h += 8 * l;
        }
        return i;
    }, t.readCode = function(t, e, r) {
        for(var n = 0, o = e; o < e + r; o++)n <<= 1, t[o] && (n |= 1);
        return n;
    }, t.readByte = function(e, r) {
        var n = e.length - r;
        return n >= 8 ? t.readCode(e, r, 8) : t.readCode(e, r, n) << 8 - n;
    }, t.convertBoolArrayToByteArray = function(e) {
        for(var r = new Uint8Array((e.length + 7) / 8), n = 0; n < r.length; n++)r[n] = t.readByte(e, 8 * n);
        return r;
    }, t.prototype.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.MIXED_TABLE = [
        "CTRL_PS",
        " ",
        "\\1",
        "\\2",
        "\\3",
        "\\4",
        "\\5",
        "\\6",
        "\\7",
        "\b",
        "	",
        "\n",
        "\\13",
        "\f",
        "\r",
        "\\33",
        "\\34",
        "\\35",
        "\\36",
        "\\37",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\\177",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ], t.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ], t.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ], t;
}(), $849102574a83a574$var$Pt = function() {
    function t() {}
    return t.round = function(t) {
        return isNaN(t) ? 0 : t <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : t >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t + (t < 0 ? -0.5 : .5) | 0;
    }, t.distance = function(t, e, r, n) {
        var o = t - r, i = e - n;
        return Math.sqrt(o * o + i * i);
    }, t.sum = function(t) {
        for(var e = 0, r = 0, n = t.length; r !== n; r++)e += t[r];
        return e;
    }, t;
}(), $849102574a83a574$var$Bt = function() {
    function t() {}
    return t.floatToIntBits = function(t) {
        return t;
    }, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $849102574a83a574$var$Lt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t.prototype.equals = function(e) {
        if (e instanceof t) {
            var r = e;
            return this.x === r.x && this.y === r.y;
        }
        return !1;
    }, t.prototype.hashCode = function() {
        return 31 * $849102574a83a574$var$Bt.floatToIntBits(this.x) + $849102574a83a574$var$Bt.floatToIntBits(this.y);
    }, t.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    }, t.orderBestPatterns = function(t) {
        var e, r, n, o = this.distance(t[0], t[1]), i = this.distance(t[1], t[2]), a = this.distance(t[0], t[2]);
        if (i >= o && i >= a ? (r = t[0], e = t[1], n = t[2]) : a >= i && a >= o ? (r = t[1], e = t[0], n = t[2]) : (r = t[2], e = t[0], n = t[1]), this.crossProductZ(e, r, n) < 0) {
            var s = e;
            e = n, n = s;
        }
        t[0] = e, t[1] = r, t[2] = n;
    }, t.distance = function(t, e) {
        return $849102574a83a574$var$Pt.distance(t.x, t.y, e.x, e.y);
    }, t.crossProductZ = function(t, e, r) {
        var n = e.x, o = e.y;
        return (r.x - n) * (t.y - o) - (r.y - o) * (t.x - n);
    }, t;
}(), $849102574a83a574$var$Ft = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $849102574a83a574$var$kt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$xt = function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r) || this;
        return a.compact = n, a.nbDatablocks = o, a.nbLayers = i, a;
    }
    return $849102574a83a574$var$kt(e, t), e.prototype.getNbLayers = function() {
        return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
        return this.compact;
    }, e;
}($849102574a83a574$var$Ft), $849102574a83a574$var$Vt = function() {
    function t(e, r, n, o) {
        this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), null == r && (r = t.INIT_SIZE), null == n && (n = e.getWidth() / 2 | 0), null == o && (o = e.getHeight() / 2 | 0);
        var i = r / 2 | 0;
        if (this.leftInit = n - i, this.rightInit = n + i, this.upInit = o - i, this.downInit = o + i, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new $849102574a83a574$var$tt;
    }
    return t.prototype.detect = function() {
        for(var t = this.leftInit, e = this.rightInit, r = this.upInit, n = this.downInit, o = !1, i = !0, a = !1, s = !1, u = !1, c = !1, f = !1, h = this.width, l = this.height; i;){
            i = !1;
            for(var d = !0; (d || !s) && e < h;)(d = this.containsBlackPoint(r, n, e, !1)) ? (e++, i = !0, s = !0) : s || e++;
            if (e >= h) {
                o = !0;
                break;
            }
            for(var p = !0; (p || !u) && n < l;)(p = this.containsBlackPoint(t, e, n, !0)) ? (n++, i = !0, u = !0) : u || n++;
            if (n >= l) {
                o = !0;
                break;
            }
            for(var g = !0; (g || !c) && t >= 0;)(g = this.containsBlackPoint(r, n, t, !1)) ? (t--, i = !0, c = !0) : c || t--;
            if (t < 0) {
                o = !0;
                break;
            }
            for(var y = !0; (y || !f) && r >= 0;)(y = this.containsBlackPoint(t, e, r, !0)) ? (r--, i = !0, f = !0) : f || r--;
            if (r < 0) {
                o = !0;
                break;
            }
            i && (a = !0);
        }
        if (!o && a) {
            for(var w = e - t, v = null, _ = 1; null === v && _ < w; _++)v = this.getBlackPointOnSegment(t, n - _, t + _, n);
            if (null == v) throw new $849102574a83a574$var$tt;
            var A = null;
            for(_ = 1; null === A && _ < w; _++)A = this.getBlackPointOnSegment(t, r + _, t + _, r);
            if (null == A) throw new $849102574a83a574$var$tt;
            var C = null;
            for(_ = 1; null === C && _ < w; _++)C = this.getBlackPointOnSegment(e, r + _, e - _, r);
            if (null == C) throw new $849102574a83a574$var$tt;
            var m = null;
            for(_ = 1; null === m && _ < w; _++)m = this.getBlackPointOnSegment(e, n - _, e - _, n);
            if (null == m) throw new $849102574a83a574$var$tt;
            return this.centerEdges(m, v, C, A);
        }
        throw new $849102574a83a574$var$tt;
    }, t.prototype.getBlackPointOnSegment = function(t, e, r, n) {
        for(var o = $849102574a83a574$var$Pt.round($849102574a83a574$var$Pt.distance(t, e, r, n)), i = (r - t) / o, a = (n - e) / o, s = this.image, u = 0; u < o; u++){
            var c = $849102574a83a574$var$Pt.round(t + u * i), f = $849102574a83a574$var$Pt.round(e + u * a);
            if (s.get(c, f)) return new $849102574a83a574$var$Lt(c, f);
        }
        return null;
    }, t.prototype.centerEdges = function(e, r, n, o) {
        var i = e.getX(), a = e.getY(), s = r.getX(), u = r.getY(), c = n.getX(), f = n.getY(), h = o.getX(), l = o.getY(), d = t.CORR;
        return i < this.width / 2 ? [
            new $849102574a83a574$var$Lt(h - d, l + d),
            new $849102574a83a574$var$Lt(s + d, u + d),
            new $849102574a83a574$var$Lt(c - d, f - d),
            new $849102574a83a574$var$Lt(i + d, a - d)
        ] : [
            new $849102574a83a574$var$Lt(h + d, l + d),
            new $849102574a83a574$var$Lt(s + d, u - d),
            new $849102574a83a574$var$Lt(c - d, f + d),
            new $849102574a83a574$var$Lt(i - d, a - d)
        ];
    }, t.prototype.containsBlackPoint = function(t, e, r, n) {
        var o = this.image;
        if (n) {
            for(var i = t; i <= e; i++)if (o.get(i, r)) return !0;
        } else for(var a = t; a <= e; a++)if (o.get(r, a)) return !0;
        return !1;
    }, t.INIT_SIZE = 10, t.CORR = 1, t;
}(), $849102574a83a574$var$Ht = function() {
    function t() {}
    return t.checkAndNudgePoints = function(t, e) {
        for(var r = t.getWidth(), n = t.getHeight(), o = !0, i = 0; i < e.length && o; i += 2){
            var a = Math.floor(e[i]), s = Math.floor(e[i + 1]);
            if (a < -1 || a > r || s < -1 || s > n) throw new $849102574a83a574$var$tt;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === s ? (e[i + 1] = 0, o = !0) : s === n && (e[i + 1] = n - 1, o = !0);
        }
        o = !0;
        for(i = e.length - 2; i >= 0 && o; i -= 2){
            a = Math.floor(e[i]), s = Math.floor(e[i + 1]);
            if (a < -1 || a > r || s < -1 || s > n) throw new $849102574a83a574$var$tt;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === s ? (e[i + 1] = 0, o = !0) : s === n && (e[i + 1] = n - 1, o = !0);
        }
    }, t;
}(), $849102574a83a574$var$Ut = function() {
    function t(t, e, r, n, o, i, a, s, u) {
        this.a11 = t, this.a21 = e, this.a31 = r, this.a12 = n, this.a22 = o, this.a32 = i, this.a13 = a, this.a23 = s, this.a33 = u;
    }
    return t.quadrilateralToQuadrilateral = function(e, r, n, o, i, a, s, u, c, f, h, l, d, p, g, y) {
        var w = t.quadrilateralToSquare(e, r, n, o, i, a, s, u);
        return t.squareToQuadrilateral(c, f, h, l, d, p, g, y).times(w);
    }, t.prototype.transformPoints = function(t) {
        for(var e = t.length, r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, s = this.a23, u = this.a31, c = this.a32, f = this.a33, h = 0; h < e; h += 2){
            var l = t[h], d = t[h + 1], p = o * l + s * d + f;
            t[h] = (r * l + i * d + u) / p, t[h + 1] = (n * l + a * d + c) / p;
        }
    }, t.prototype.transformPointsWithValues = function(t, e) {
        for(var r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, s = this.a23, u = this.a31, c = this.a32, f = this.a33, h = t.length, l = 0; l < h; l++){
            var d = t[l], p = e[l], g = o * d + s * p + f;
            t[l] = (r * d + i * p + u) / g, e[l] = (n * d + a * p + c) / g;
        }
    }, t.squareToQuadrilateral = function(e, r, n, o, i, a, s, u) {
        var c = e - n + i - s, f = r - o + a - u;
        if (0 === c && 0 === f) return new t(n - e, i - n, e, o - r, a - o, r, 0, 0, 1);
        var h = n - i, l = s - i, d = o - a, p = u - a, g = h * p - l * d, y = (c * p - l * f) / g, w = (h * f - c * d) / g;
        return new t(n - e + y * n, s - e + w * s, e, o - r + y * o, u - r + w * u, r, y, w, 1);
    }, t.quadrilateralToSquare = function(e, r, n, o, i, a, s, u) {
        return t.squareToQuadrilateral(e, r, n, o, i, a, s, u).buildAdjoint();
    }, t.prototype.buildAdjoint = function() {
        return new t(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, t.prototype.times = function(e) {
        return new t(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, t;
}(), $849102574a83a574$var$Xt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Gt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Xt(e, t), e.prototype.sampleGrid = function(t, e, r, n, o, i, a, s, u, c, f, h, l, d, p, g, y, w, v) {
        var _ = $849102574a83a574$var$Ut.quadrilateralToQuadrilateral(n, o, i, a, s, u, c, f, h, l, d, p, g, y, w, v);
        return this.sampleGridWithTransform(t, e, r, _);
    }, e.prototype.sampleGridWithTransform = function(t, e, r, n) {
        if (e <= 0 || r <= 0) throw new $849102574a83a574$var$tt;
        for(var o = new $849102574a83a574$var$J(e, r), i = new Float32Array(2 * e), a = 0; a < r; a++){
            for(var s = i.length, u = a + .5, c = 0; c < s; c += 2)i[c] = c / 2 + .5, i[c + 1] = u;
            n.transformPoints(i), $849102574a83a574$var$Ht.checkAndNudgePoints(t, i);
            try {
                for(c = 0; c < s; c += 2)t.get(Math.floor(i[c]), Math.floor(i[c + 1])) && o.set(c / 2, a);
            } catch (t) {
                throw new $849102574a83a574$var$tt;
            }
        }
        return o;
    }, e;
}($849102574a83a574$var$Ht), $849102574a83a574$var$Wt = function() {
    function t() {}
    return t.setGridSampler = function(e) {
        t.gridSampler = e;
    }, t.getInstance = function() {
        return t.gridSampler;
    }, t.gridSampler = new $849102574a83a574$var$Gt, t;
}(), $849102574a83a574$var$zt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.toResultPoint = function() {
        return new $849102574a83a574$var$Lt(this.getX(), this.getY());
    }, t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t;
}(), $849102574a83a574$var$jt = function() {
    function t(t) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            3808,
            476,
            2107,
            1799
        ]), this.image = t;
    }
    return t.prototype.detect = function() {
        return this.detectMirror(!1);
    }, t.prototype.detectMirror = function(t) {
        var e = this.getMatrixCenter(), r = this.getBullsEyeCorners(e);
        if (t) {
            var n = r[0];
            r[0] = r[2], r[2] = n;
        }
        this.extractParameters(r);
        var o = this.sampleGrid(this.image, r[this.shift % 4], r[(this.shift + 1) % 4], r[(this.shift + 2) % 4], r[(this.shift + 3) % 4]), i = this.getMatrixCornerPoints(r);
        return new $849102574a83a574$var$xt(o, i, this.compact, this.nbDataBlocks, this.nbLayers);
    }, t.prototype.extractParameters = function(t) {
        if (!(this.isValidPoint(t[0]) && this.isValidPoint(t[1]) && this.isValidPoint(t[2]) && this.isValidPoint(t[3]))) throw new $849102574a83a574$var$tt;
        var e = 2 * this.nbCenterLayers, r = new Int32Array([
            this.sampleLine(t[0], t[1], e),
            this.sampleLine(t[1], t[2], e),
            this.sampleLine(t[2], t[3], e),
            this.sampleLine(t[3], t[0], e)
        ]);
        this.shift = this.getRotation(r, e);
        for(var n = 0, o = 0; o < 4; o++){
            var i = r[(this.shift + o) % 4];
            this.compact ? (n <<= 7, n += i >> 1 & 127) : (n <<= 10, n += (i >> 2 & 992) + (i >> 1 & 31));
        }
        var a = this.getCorrectedParameterData(n, this.compact);
        this.compact ? (this.nbLayers = 1 + (a >> 6), this.nbDataBlocks = 1 + (63 & a)) : (this.nbLayers = 1 + (a >> 11), this.nbDataBlocks = 1 + (2047 & a));
    }, t.prototype.getRotation = function(t, e) {
        var r = 0;
        t.forEach(function(t, n, o) {
            r = (r << 3) + ((t >> e - 2 << 1) + (1 & t));
        }), r = ((1 & r) << 11) + (r >> 1);
        for(var n = 0; n < 4; n++)if ($849102574a83a574$var$x.bitCount(r ^ this.EXPECTED_CORNER_BITS[n]) <= 2) return n;
        throw new $849102574a83a574$var$tt;
    }, t.prototype.getCorrectedParameterData = function(t, e) {
        var r, n;
        e ? (r = 7, n = 2) : (r = 10, n = 4);
        for(var o = r - n, i = new Int32Array(r), a = r - 1; a >= 0; --a)i[a] = 15 & t, t >>= 4;
        try {
            new $849102574a83a574$var$Dt($849102574a83a574$var$Tt.AZTEC_PARAM).decode(i, o);
        } catch (t) {
            throw new $849102574a83a574$var$tt;
        }
        var s = 0;
        for(a = 0; a < n; a++)s = (s << 4) + i[a];
        return s;
    }, t.prototype.getBullsEyeCorners = function(t) {
        var e = t, r = t, n = t, o = t, i = !0;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var a = this.getFirstDifferent(e, i, 1, -1), s = this.getFirstDifferent(r, i, 1, 1), u = this.getFirstDifferent(n, i, -1, 1), c = this.getFirstDifferent(o, i, -1, -1);
            if (this.nbCenterLayers > 2) {
                var f = this.distancePoint(c, a) * this.nbCenterLayers / (this.distancePoint(o, e) * (this.nbCenterLayers + 2));
                if (f < .75 || f > 1.25 || !this.isWhiteOrBlackRectangle(a, s, u, c)) break;
            }
            e = a, r = s, n = u, o = c, i = !i;
        }
        if (5 !== this.nbCenterLayers && 7 !== this.nbCenterLayers) throw new $849102574a83a574$var$tt;
        this.compact = 5 === this.nbCenterLayers;
        var h = new $849102574a83a574$var$Lt(e.getX() + .5, e.getY() - .5), l = new $849102574a83a574$var$Lt(r.getX() + .5, r.getY() + .5), d = new $849102574a83a574$var$Lt(n.getX() - .5, n.getY() + .5), p = new $849102574a83a574$var$Lt(o.getX() - .5, o.getY() - .5);
        return this.expandSquare([
            h,
            l,
            d,
            p
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, t.prototype.getMatrixCenter = function() {
        var t, e, r, n;
        try {
            t = (u = new $849102574a83a574$var$Vt(this.image).detect())[0], e = u[1], r = u[2], n = u[3];
        } catch (a) {
            var o = this.image.getWidth() / 2, i = this.image.getHeight() / 2;
            t = this.getFirstDifferent(new $849102574a83a574$var$zt(o + 7, i - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $849102574a83a574$var$zt(o + 7, i + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $849102574a83a574$var$zt(o - 7, i + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $849102574a83a574$var$zt(o - 7, i - 7), !1, -1, -1).toResultPoint();
        }
        var a = $849102574a83a574$var$Pt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), s = $849102574a83a574$var$Pt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4);
        try {
            var u;
            t = (u = new $849102574a83a574$var$Vt(this.image, 15, a, s).detect())[0], e = u[1], r = u[2], n = u[3];
        } catch (o) {
            t = this.getFirstDifferent(new $849102574a83a574$var$zt(a + 7, s - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $849102574a83a574$var$zt(a + 7, s + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $849102574a83a574$var$zt(a - 7, s + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $849102574a83a574$var$zt(a - 7, s - 7), !1, -1, -1).toResultPoint();
        }
        return a = $849102574a83a574$var$Pt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), s = $849102574a83a574$var$Pt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4), new $849102574a83a574$var$zt(a, s);
    }, t.prototype.getMatrixCornerPoints = function(t) {
        return this.expandSquare(t, 2 * this.nbCenterLayers, this.getDimension());
    }, t.prototype.sampleGrid = function(t, e, r, n, o) {
        var i = $849102574a83a574$var$Wt.getInstance(), a = this.getDimension(), s = a / 2 - this.nbCenterLayers, u = a / 2 + this.nbCenterLayers;
        return i.sampleGrid(t, a, a, s, s, u, s, u, u, s, u, e.getX(), e.getY(), r.getX(), r.getY(), n.getX(), n.getY(), o.getX(), o.getY());
    }, t.prototype.sampleLine = function(t, e, r) {
        for(var n = 0, o = this.distanceResultPoint(t, e), i = o / r, a = t.getX(), s = t.getY(), u = i * (e.getX() - t.getX()) / o, c = i * (e.getY() - t.getY()) / o, f = 0; f < r; f++)this.image.get($849102574a83a574$var$Pt.round(a + f * u), $849102574a83a574$var$Pt.round(s + f * c)) && (n |= 1 << r - f - 1);
        return n;
    }, t.prototype.isWhiteOrBlackRectangle = function(t, e, r, n) {
        t = new $849102574a83a574$var$zt(t.getX() - 3, t.getY() + 3), e = new $849102574a83a574$var$zt(e.getX() - 3, e.getY() - 3), r = new $849102574a83a574$var$zt(r.getX() + 3, r.getY() - 3), n = new $849102574a83a574$var$zt(n.getX() + 3, n.getY() + 3);
        var o = this.getColor(n, t);
        if (0 === o) return !1;
        var i = this.getColor(t, e);
        return i === o && (i = this.getColor(e, r)) === o && (i = this.getColor(r, n)) === o;
    }, t.prototype.getColor = function(t, e) {
        for(var r = this.distancePoint(t, e), n = (e.getX() - t.getX()) / r, o = (e.getY() - t.getY()) / r, i = 0, a = t.getX(), s = t.getY(), u = this.image.get(t.getX(), t.getY()), c = Math.ceil(r), f = 0; f < c; f++)a += n, s += o, this.image.get($849102574a83a574$var$Pt.round(a), $849102574a83a574$var$Pt.round(s)) !== u && i++;
        var h = i / r;
        return h > .1 && h < .9 ? 0 : h <= .1 === u ? 1 : -1;
    }, t.prototype.getFirstDifferent = function(t, e, r, n) {
        for(var o = t.getX() + r, i = t.getY() + n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r, i += n;
        for(o -= r, i -= n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r;
        for(o -= r; this.isValid(o, i) && this.image.get(o, i) === e;)i += n;
        return new $849102574a83a574$var$zt(o, i -= n);
    }, t.prototype.expandSquare = function(t, e, r) {
        var n = r / (2 * e), o = t[0].getX() - t[2].getX(), i = t[0].getY() - t[2].getY(), a = (t[0].getX() + t[2].getX()) / 2, s = (t[0].getY() + t[2].getY()) / 2, u = new $849102574a83a574$var$Lt(a + n * o, s + n * i), c = new $849102574a83a574$var$Lt(a - n * o, s - n * i);
        return o = t[1].getX() - t[3].getX(), i = t[1].getY() - t[3].getY(), a = (t[1].getX() + t[3].getX()) / 2, s = (t[1].getY() + t[3].getY()) / 2, [
            u,
            new $849102574a83a574$var$Lt(a + n * o, s + n * i),
            c,
            new $849102574a83a574$var$Lt(a - n * o, s - n * i)
        ];
    }, t.prototype.isValid = function(t, e) {
        return t >= 0 && t < this.image.getWidth() && e > 0 && e < this.image.getHeight();
    }, t.prototype.isValidPoint = function(t) {
        var e = $849102574a83a574$var$Pt.round(t.getX()), r = $849102574a83a574$var$Pt.round(t.getY());
        return this.isValid(e, r);
    }, t.prototype.distancePoint = function(t, e) {
        return $849102574a83a574$var$Pt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.distanceResultPoint = function(t, e) {
        return $849102574a83a574$var$Pt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.getDimension = function() {
        return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * ($849102574a83a574$var$x.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, t;
}(), $849102574a83a574$var$Yt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        void 0 === e && (e = null);
        var r = null, n = new $849102574a83a574$var$jt(t.getBlackMatrix()), o = null, i = null;
        try {
            o = (a = n.detectMirror(!1)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $849102574a83a574$var$Mt).decode(a);
        } catch (t) {
            r = t;
        }
        if (null == i) try {
            var a;
            o = (a = n.detectMirror(!0)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $849102574a83a574$var$Mt).decode(a);
        } catch (t) {
            if (null != r) throw r;
            throw t;
        }
        var s = new $849102574a83a574$var$gt(i.getText(), i.getRawBytes(), i.getNumBits(), o, $849102574a83a574$var$wt.AZTEC, $849102574a83a574$var$D.currentTimeMillis()), u = i.getByteSegments();
        null != u && s.putMetadata($849102574a83a574$var$_t.BYTE_SEGMENTS, u);
        var c = i.getECLevel();
        return null != c && s.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, c), s;
    }, t.prototype.reportFoundResultPoints = function(t, e) {
        if (null != t) {
            var r = t.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
            null != r && e.forEach(function(t, e, n) {
                r.foundPossibleResultPoint(t);
            });
        }
    }, t.prototype.reset = function() {}, t;
}(), $849102574a83a574$var$Zt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$Yt, e) || this;
    }
    $849102574a83a574$var$Zt(e, t);
}($849102574a83a574$var$pt);
var $849102574a83a574$var$Kt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        try {
            return this.doDecode(t, e);
        } catch (c) {
            if (e && !0 === e.get($849102574a83a574$var$U.TRY_HARDER) && t.isRotateSupported()) {
                var r = t.rotateCounterClockwise(), n = this.doDecode(r, e), o = n.getResultMetadata(), i = 270;
                null !== o && !0 === o.get($849102574a83a574$var$_t.ORIENTATION) && (i += o.get($849102574a83a574$var$_t.ORIENTATION) % 360), n.putMetadata($849102574a83a574$var$_t.ORIENTATION, i);
                var a = n.getResultPoints();
                if (null !== a) for(var s = r.getHeight(), u = 0; u < a.length; u++)a[u] = new $849102574a83a574$var$Lt(s - a[u].getY() - 1, a[u].getX());
                return n;
            }
            throw new $849102574a83a574$var$tt;
        }
    }, t.prototype.reset = function() {}, t.prototype.doDecode = function(t, e) {
        var r, n = t.getWidth(), o = t.getHeight(), i = new $849102574a83a574$var$V(n), a = e && !0 === e.get($849102574a83a574$var$U.TRY_HARDER), s = Math.max(1, o >> (a ? 8 : 5));
        r = a ? o : 15;
        for(var u = Math.trunc(o / 2), c = 0; c < r; c++){
            var f = Math.trunc((c + 1) / 2), h = u + s * (0 == (1 & c) ? f : -f);
            if (h < 0 || h >= o) break;
            try {
                i = t.getBlackRow(h, i);
            } catch (t) {
                continue;
            }
            for(var l = function(t) {
                if (1 === t && (i.reverse(), e && !0 === e.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK))) {
                    var r = new Map;
                    e.forEach(function(t, e) {
                        return r.set(e, t);
                    }), r.delete($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK), e = r;
                }
                try {
                    var o = d.decodeRow(h, i, e);
                    if (1 === t) {
                        o.putMetadata($849102574a83a574$var$_t.ORIENTATION, 180);
                        var a = o.getResultPoints();
                        null !== a && (a[0] = new $849102574a83a574$var$Lt(n - a[0].getX() - 1, a[0].getY()), a[1] = new $849102574a83a574$var$Lt(n - a[1].getX() - 1, a[1].getY()));
                    }
                    return {
                        value: o
                    };
                } catch (t) {}
            }, d = this, p = 0; p < 2; p++){
                var g = l(p);
                if ("object" == typeof g) return g.value;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, t.recordPattern = function(t, e, r) {
        for(var n = r.length, o = 0; o < n; o++)r[o] = 0;
        var i = t.getSize();
        if (e >= i) throw new $849102574a83a574$var$tt;
        for(var a = !t.get(e), s = 0, u = e; u < i;){
            if (t.get(u) !== a) r[s]++;
            else {
                if (++s === n) break;
                r[s] = 1, a = !a;
            }
            u++;
        }
        if (s !== n && (s !== n - 1 || u !== i)) throw new $849102574a83a574$var$tt;
    }, t.recordPatternInReverse = function(e, r, n) {
        for(var o = n.length, i = e.get(r); r > 0 && o >= 0;)e.get(--r) !== i && (o--, i = !i);
        if (o >= 0) throw new $849102574a83a574$var$tt;
        t.recordPattern(e, r + 1, n);
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return Number.POSITIVE_INFINITY;
        var s = o / i;
        r *= s;
        for(var u = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * s, l = f > h ? f - h : h - f;
            if (l > r) return Number.POSITIVE_INFINITY;
            u += l;
        }
        return u / o;
    }, t;
}(), $849102574a83a574$var$qt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Qt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$qt(e, t), e.findStartPattern = function(t) {
        for(var r = t.getSize(), n = t.getNextSet(0), o = 0, i = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), a = n, s = !1, u = n; u < r; u++)if (t.get(u) !== s) i[o]++;
        else {
            if (5 === o) {
                for(var c = e.MAX_AVG_VARIANCE, f = -1, h = e.CODE_START_A; h <= e.CODE_START_C; h++){
                    var l = $849102574a83a574$var$Kt.patternMatchVariance(i, e.CODE_PATTERNS[h], e.MAX_INDIVIDUAL_VARIANCE);
                    l < c && (c = l, f = h);
                }
                if (f >= 0 && t.isRange(Math.max(0, a - (u - a) / 2), a, !1)) return Int32Array.from([
                    a,
                    u,
                    f
                ]);
                a += i[0] + i[1], (i = i.slice(2, i.length - 1))[o - 1] = 0, i[o] = 0, o--;
            } else o++;
            i[o] = 1, s = !s;
        }
        throw new $849102574a83a574$var$tt;
    }, e.decodeCode = function(t, r, n) {
        $849102574a83a574$var$Kt.recordPattern(t, n, r);
        for(var o = e.MAX_AVG_VARIANCE, i = -1, a = 0; a < e.CODE_PATTERNS.length; a++){
            var s = e.CODE_PATTERNS[a], u = this.patternMatchVariance(r, s, e.MAX_INDIVIDUAL_VARIANCE);
            u < o && (o = u, i = a);
        }
        if (i >= 0) return i;
        throw new $849102574a83a574$var$tt;
    }, e.prototype.decodeRow = function(t, r, n) {
        var o, i = n && !0 === n.get($849102574a83a574$var$U.ASSUME_GS1), a = e.findStartPattern(r), s = a[2], u = 0, c = new Uint8Array(20);
        switch(c[u++] = s, s){
            case e.CODE_START_A:
                o = e.CODE_CODE_A;
                break;
            case e.CODE_START_B:
                o = e.CODE_CODE_B;
                break;
            case e.CODE_START_C:
                o = e.CODE_CODE_C;
                break;
            default:
                throw new $849102574a83a574$var$G;
        }
        for(var f = !1, h = !1, l = "", d = a[0], p = a[1], g = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), y = 0, w = 0, v = s, _ = 0, A = !0, C = !1, m = !1; !f;){
            var E = h;
            switch(h = !1, y = w, w = e.decodeCode(r, g, p), c[u++] = w, w !== e.CODE_STOP && (A = !0), w !== e.CODE_STOP && (v += ++_ * w), d = p, p += g.reduce(function(t, e) {
                return t + e;
            }, 0), w){
                case e.CODE_START_A:
                case e.CODE_START_B:
                case e.CODE_START_C:
                    throw new $849102574a83a574$var$G;
            }
            switch(o){
                case e.CODE_CODE_A:
                    if (w < 64) l += m === C ? String.fromCharCode(" ".charCodeAt(0) + w) : String.fromCharCode(" ".charCodeAt(0) + w + 128), m = !1;
                    else if (w < 96) l += m === C ? String.fromCharCode(w - 64) : String.fromCharCode(w + 64), m = !1;
                    else switch(w !== e.CODE_STOP && (A = !1), w){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_A:
                            !C && m ? (C = !0, m = !1) : C && m ? (C = !1, m = !1) : m = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_B:
                    if (w < 96) l += m === C ? String.fromCharCode(" ".charCodeAt(0) + w) : String.fromCharCode(" ".charCodeAt(0) + w + 128), m = !1;
                    else switch(w !== e.CODE_STOP && (A = !1), w){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_B:
                            !C && m ? (C = !0, m = !1) : C && m ? (C = !1, m = !1) : m = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_C:
                    if (w < 100) w < 10 && (l += "0"), l += w;
                    else switch(w !== e.CODE_STOP && (A = !1), w){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
            }
            E && (o = o === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
        }
        var I = p - d;
        if (p = r.getNextUnset(p), !r.isRange(p, Math.min(r.getSize(), p + (p - d) / 2), !1)) throw new $849102574a83a574$var$tt;
        if ((v -= _ * y) % 103 !== y) throw new $849102574a83a574$var$R;
        var S = l.length;
        if (0 === S) throw new $849102574a83a574$var$tt;
        S > 0 && A && (l = o === e.CODE_CODE_C ? l.substring(0, S - 2) : l.substring(0, S - 1));
        for(var T = (a[1] + a[0]) / 2, O = d + I / 2, b = c.length, N = new Uint8Array(b), D = 0; D < b; D++)N[D] = c[D];
        var M = [
            new $849102574a83a574$var$Lt(T, t),
            new $849102574a83a574$var$Lt(O, t)
        ];
        return new $849102574a83a574$var$gt(l, N, 0, M, $849102574a83a574$var$wt.CODE_128, (new Date).getTime());
    }, e.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ], e.MAX_AVG_VARIANCE = .25, e.MAX_INDIVIDUAL_VARIANCE = .7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Jt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$$t = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$te = function(t) {
    function e(e, r) {
        void 0 === e && (e = !1), void 0 === r && (r = !1);
        var n = t.call(this) || this;
        return n.usingCheckDigit = e, n.extendedMode = r, n.decodeRowResult = "", n.counters = new Int32Array(9), n;
    }
    return $849102574a83a574$var$Jt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, s, u = this.counters;
        u.fill(0), this.decodeRowResult = "";
        var c, f, h = e.findAsteriskPattern(r, u), l = r.getNextSet(h[1]), d = r.getSize();
        do {
            e.recordPattern(r, l, u);
            var p = e.toNarrowWidePattern(u);
            if (p < 0) throw new $849102574a83a574$var$tt;
            c = e.patternToChar(p), this.decodeRowResult += c, f = l;
            try {
                for(var g = (o = void 0, $849102574a83a574$var$$t(u)), y = g.next(); !y.done; y = g.next())l += y.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    y && !y.done && (i = g.return) && i.call(g);
                } finally{
                    if (o) throw o.error;
                }
            }
            l = r.getNextSet(l);
        }while ("*" !== c);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var w, v = 0;
        try {
            for(var _ = $849102574a83a574$var$$t(u), A = _.next(); !A.done; A = _.next())v += A.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (s = _.return) && s.call(_);
            } finally{
                if (a) throw a.error;
            }
        }
        if (l !== d && 2 * (l - f - v) < v) throw new $849102574a83a574$var$tt;
        if (this.usingCheckDigit) {
            for(var C = this.decodeRowResult.length - 1, m = 0, E = 0; E < C; E++)m += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(E));
            if (this.decodeRowResult.charAt(C) !== e.ALPHABET_STRING.charAt(m % 43)) throw new $849102574a83a574$var$R;
            this.decodeRowResult = this.decodeRowResult.substring(0, C);
        }
        if (0 === this.decodeRowResult.length) throw new $849102574a83a574$var$tt;
        w = this.extendedMode ? e.decodeExtended(this.decodeRowResult) : this.decodeRowResult;
        var I = (h[1] + h[0]) / 2, S = f + v / 2;
        return new $849102574a83a574$var$gt(w, null, 0, [
            new $849102574a83a574$var$Lt(I, t),
            new $849102574a83a574$var$Lt(S, t)
        ], $849102574a83a574$var$wt.CODE_39, (new Date).getTime());
    }, e.findAsteriskPattern = function(t, r) {
        for(var n = t.getSize(), o = t.getNextSet(0), i = 0, a = o, s = !1, u = r.length, c = o; c < n; c++)if (t.get(c) !== s) r[i]++;
        else {
            if (i === u - 1) {
                if (this.toNarrowWidePattern(r) === e.ASTERISK_ENCODING && t.isRange(Math.max(0, a - Math.floor((c - a) / 2)), a, !1)) return [
                    a,
                    c
                ];
                a += r[0] + r[1], r.copyWithin(0, 2, 2 + i - 1), r[i - 1] = 0, r[i] = 0, i--;
            } else i++;
            r[i] = 1, s = !s;
        }
        throw new $849102574a83a574$var$tt;
    }, e.toNarrowWidePattern = function(t) {
        var e, r, n, o = t.length, i = 0;
        do {
            var a = 2147483647;
            try {
                for(var s = (e = void 0, $849102574a83a574$var$$t(t)), u = s.next(); !u.done; u = s.next())(l = u.value) < a && l > i && (a = l);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    u && !u.done && (r = s.return) && r.call(s);
                } finally{
                    if (e) throw e.error;
                }
            }
            i = a, n = 0;
            for(var c = 0, f = 0, h = 0; h < o; h++)(l = t[h]) > i && (f |= 1 << o - 1 - h, n++, c += l);
            if (3 === n) {
                for(h = 0; h < o && n > 0; h++){
                    var l;
                    if ((l = t[h]) > i && (n--, 2 * l >= c)) return -1;
                }
                return f;
            }
        }while (n > 3);
        return -1;
    }, e.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        if (t === e.ASTERISK_ENCODING) return "*";
        throw new $849102574a83a574$var$tt;
    }, e.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if ("+" === o || "$" === o || "%" === o || "/" === o) {
                var i = t.charAt(n + 1), a = "\x00";
                switch(o){
                    case "+":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "$":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "%":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\x00";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if ("X" !== i && "Y" !== i && "Z" !== i) throw new $849102574a83a574$var$G;
                            a = "\x7f";
                        }
                        break;
                    case "/":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $849102574a83a574$var$G;
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
        52,
        289,
        97,
        352,
        49,
        304,
        112,
        37,
        292,
        100,
        265,
        73,
        328,
        25,
        280,
        88,
        13,
        268,
        76,
        28,
        259,
        67,
        322,
        19,
        274,
        82,
        7,
        262,
        70,
        22,
        385,
        193,
        448,
        145,
        400,
        208,
        133,
        388,
        196,
        168,
        162,
        138,
        42
    ], e.ASTERISK_ENCODING = 148, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$ee = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$re = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ne = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeRowResult = "", e.counters = new Int32Array(6), e;
    }
    return $849102574a83a574$var$ee(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, s, u, c, f = this.findAsteriskPattern(r), h = r.getNextSet(f[1]), l = r.getSize(), d = this.counters;
        d.fill(0), this.decodeRowResult = "";
        do {
            e.recordPattern(r, h, d);
            var p = this.toPattern(d);
            if (p < 0) throw new $849102574a83a574$var$tt;
            u = this.patternToChar(p), this.decodeRowResult += u, c = h;
            try {
                for(var g = (o = void 0, $849102574a83a574$var$re(d)), y = g.next(); !y.done; y = g.next())h += y.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    y && !y.done && (i = g.return) && i.call(g);
                } finally{
                    if (o) throw o.error;
                }
            }
            h = r.getNextSet(h);
        }while ("*" !== u);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var w = 0;
        try {
            for(var v = $849102574a83a574$var$re(d), _ = v.next(); !_.done; _ = v.next())w += _.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                _ && !_.done && (s = v.return) && s.call(v);
            } finally{
                if (a) throw a.error;
            }
        }
        if (h === l || !r.get(h)) throw new $849102574a83a574$var$tt;
        if (this.decodeRowResult.length < 2) throw new $849102574a83a574$var$tt;
        this.checkChecksums(this.decodeRowResult), this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 2);
        var A = this.decodeExtended(this.decodeRowResult), C = (f[1] + f[0]) / 2, m = c + w / 2;
        return new $849102574a83a574$var$gt(A, null, 0, [
            new $849102574a83a574$var$Lt(C, t),
            new $849102574a83a574$var$Lt(m, t)
        ], $849102574a83a574$var$wt.CODE_93, (new Date).getTime());
    }, e.prototype.findAsteriskPattern = function(t) {
        var r = t.getSize(), n = t.getNextSet(0);
        this.counters.fill(0);
        for(var o = this.counters, i = n, a = !1, s = o.length, u = 0, c = n; c < r; c++)if (t.get(c) !== a) o[u]++;
        else {
            if (u === s - 1) {
                if (this.toPattern(o) === e.ASTERISK_ENCODING) return new Int32Array([
                    i,
                    c
                ]);
                i += o[0] + o[1], o.copyWithin(0, 2, 2 + u - 1), o[u - 1] = 0, o[u] = 0, u--;
            } else u++;
            o[u] = 1, a = !a;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.toPattern = function(t) {
        var e, r, n = 0;
        try {
            for(var o = $849102574a83a574$var$re(t), i = o.next(); !i.done; i = o.next())n += i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var a = 0, s = t.length, u = 0; u < s; u++){
            var c = Math.round(9 * t[u] / n);
            if (c < 1 || c > 4) return -1;
            if (0 == (1 & u)) for(var f = 0; f < c; f++)a = a << 1 | 1;
            else a <<= c;
        }
        return a;
    }, e.prototype.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        throw new $849102574a83a574$var$tt;
    }, e.prototype.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if (o >= "a" && o <= "d") {
                if (n >= e - 1) throw new $849102574a83a574$var$G;
                var i = t.charAt(n + 1), a = "\x00";
                switch(o){
                    case "d":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "a":
                        if (!(i >= "A" && i <= "Z")) throw new $849102574a83a574$var$G;
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "b":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\x00";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if (!(i >= "X" && i <= "Z")) throw new $849102574a83a574$var$G;
                            a = String.fromCharCode(127);
                        }
                        break;
                    case "c":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $849102574a83a574$var$G;
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.prototype.checkChecksums = function(t) {
        var e = t.length;
        this.checkOneChecksum(t, e - 2, 20), this.checkOneChecksum(t, e - 1, 15);
    }, e.prototype.checkOneChecksum = function(t, r, n) {
        for(var o = 1, i = 0, a = r - 1; a >= 0; a--)i += o * e.ALPHABET_STRING.indexOf(t.charAt(a)), ++o > n && (o = 1);
        if (t.charAt(r) !== e.ALPHABET_STRING[i % 47]) throw new $849102574a83a574$var$R;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*", e.CHARACTER_ENCODINGS = [
        276,
        328,
        324,
        322,
        296,
        292,
        290,
        336,
        274,
        266,
        424,
        420,
        418,
        404,
        402,
        394,
        360,
        356,
        354,
        308,
        282,
        344,
        332,
        326,
        300,
        278,
        436,
        434,
        428,
        422,
        406,
        410,
        364,
        358,
        310,
        314,
        302,
        468,
        466,
        458,
        366,
        374,
        430,
        294,
        474,
        470,
        306,
        350
    ], e.ASTERISK_ENCODING = e.CHARACTER_ENCODINGS[47], e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$oe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ie = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ae = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.narrowLineWidth = -1, e;
    }
    return $849102574a83a574$var$oe(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a = this.decodeStart(r), s = this.decodeEnd(r), u = new $849102574a83a574$var$Q;
        e.decodeMiddle(r, a[1], s[0], u);
        var c = u.toString(), f = null;
        null != n && (f = n.get($849102574a83a574$var$U.ALLOWED_LENGTHS)), null == f && (f = e.DEFAULT_ALLOWED_LENGTHS);
        var h = c.length, l = !1, d = 0;
        try {
            for(var p = $849102574a83a574$var$ie(f), g = p.next(); !g.done; g = p.next()){
                var y = g.value;
                if (h === y) {
                    l = !0;
                    break;
                }
                y > d && (d = y);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        if (!l && h > d && (l = !0), !l) throw new $849102574a83a574$var$G;
        var w = [
            new $849102574a83a574$var$Lt(a[1], t),
            new $849102574a83a574$var$Lt(s[0], t)
        ];
        return new $849102574a83a574$var$gt(c, null, 0, w, $849102574a83a574$var$wt.ITF, (new Date).getTime());
    }, e.decodeMiddle = function(t, r, n, o) {
        var i = new Int32Array(10), a = new Int32Array(5), s = new Int32Array(5);
        for(i.fill(0), a.fill(0), s.fill(0); r < n;){
            $849102574a83a574$var$Kt.recordPattern(t, r, i);
            for(var u = 0; u < 5; u++){
                var c = 2 * u;
                a[u] = i[c], s[u] = i[c + 1];
            }
            var f = e.decodeDigit(a);
            o.append(f.toString()), f = this.decodeDigit(s), o.append(f.toString()), i.forEach(function(t) {
                r += t;
            });
        }
    }, e.prototype.decodeStart = function(t) {
        var r = e.skipWhiteSpace(t), n = e.findGuardPattern(t, r, e.START_PATTERN);
        return this.narrowLineWidth = (n[1] - n[0]) / 4, this.validateQuietZone(t, n[0]), n;
    }, e.prototype.validateQuietZone = function(t, e) {
        var r = 10 * this.narrowLineWidth;
        r = r < e ? r : e;
        for(var n = e - 1; r > 0 && n >= 0 && !t.get(n); n--)r--;
        if (0 !== r) throw new $849102574a83a574$var$tt;
    }, e.skipWhiteSpace = function(t) {
        var e = t.getSize(), r = t.getNextSet(0);
        if (r === e) throw new $849102574a83a574$var$tt;
        return r;
    }, e.prototype.decodeEnd = function(t) {
        t.reverse();
        try {
            var r = e.skipWhiteSpace(t), n = void 0;
            try {
                n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[0]);
            } catch (o) {
                o instanceof $849102574a83a574$var$tt && (n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[1]));
            }
            this.validateQuietZone(t, n[0]);
            var o = n[0];
            return n[0] = t.getSize() - n[1], n[1] = t.getSize() - o, n;
        } finally{
            t.reverse();
        }
    }, e.findGuardPattern = function(t, r, n) {
        var o = n.length, i = new Int32Array(o), a = t.getSize(), s = !1, u = 0, c = r;
        i.fill(0);
        for(var f = r; f < a; f++)if (t.get(f) !== s) i[u]++;
        else {
            if (u === o - 1) {
                if ($849102574a83a574$var$Kt.patternMatchVariance(i, n, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return [
                    c,
                    f
                ];
                c += i[0] + i[1], $849102574a83a574$var$D.arraycopy(i, 2, i, 0, u - 1), i[u - 1] = 0, i[u] = 0, u--;
            } else u++;
            i[u] = 1, s = !s;
        }
        throw new $849102574a83a574$var$tt;
    }, e.decodeDigit = function(t) {
        for(var r = e.MAX_AVG_VARIANCE, n = -1, o = e.PATTERNS.length, i = 0; i < o; i++){
            var a = e.PATTERNS[i], s = $849102574a83a574$var$Kt.patternMatchVariance(t, a, e.MAX_INDIVIDUAL_VARIANCE);
            s < r ? (r = s, n = i) : s === r && (n = -1);
        }
        if (n >= 0) return n % 10;
        throw new $849102574a83a574$var$tt;
    }, e.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ])
    ], e.MAX_AVG_VARIANCE = .38, e.MAX_INDIVIDUAL_VARIANCE = .5, e.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ], e.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]), e.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ])
    ], e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$se = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ue = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.decodeRowStringBuffer = "", e;
    }
    return $849102574a83a574$var$se(e, t), e.findStartGuardPattern = function(t) {
        for(var r, n = !1, o = 0, i = Int32Array.from([
            0,
            0,
            0
        ]); !n;){
            i = Int32Array.from([
                0,
                0,
                0
            ]);
            var a = (r = e.findGuardPattern(t, o, !1, this.START_END_PATTERN, i))[0], s = a - ((o = r[1]) - a);
            s >= 0 && (n = t.isRange(s, a, !1));
        }
        return r;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(t, e, r, n) {
        return this.findGuardPattern(t, e, r, n, new Int32Array(n.length));
    }, e.findGuardPattern = function(t, r, n, o, i) {
        for(var a = t.getSize(), s = 0, u = r = n ? t.getNextUnset(r) : t.getNextSet(r), c = o.length, f = n, h = r; h < a; h++)if (t.get(h) !== f) i[s]++;
        else {
            if (s === c - 1) {
                if ($849102574a83a574$var$Kt.patternMatchVariance(i, o, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return Int32Array.from([
                    u,
                    h
                ]);
                u += i[0] + i[1];
                for(var l = i.slice(2, i.length), d = 0; d < s - 1; d++)i[d] = l[d];
                i[s - 1] = 0, i[s] = 0, s--;
            } else s++;
            i[s] = 1, f = !f;
        }
        throw new $849102574a83a574$var$tt;
    }, e.decodeDigit = function(t, r, n, o) {
        this.recordPattern(t, n, r);
        for(var i = this.MAX_AVG_VARIANCE, a = -1, s = o.length, u = 0; u < s; u++){
            var c = o[u], f = $849102574a83a574$var$Kt.patternMatchVariance(r, c, e.MAX_INDIVIDUAL_VARIANCE);
            f < i && (i = f, a = u);
        }
        if (a >= 0) return a;
        throw new $849102574a83a574$var$tt;
    }, e.MAX_AVG_VARIANCE = .48, e.MAX_INDIVIDUAL_VARIANCE = .7, e.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]), e.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]), e.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ], e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$ce = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$fe = function() {
    function t() {
        this.CHECK_DIGIT_ENCODINGS = [
            24,
            20,
            18,
            17,
            12,
            6,
            3,
            10,
            9,
            5
        ], this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), s = t.parseExtensionString(a), u = [
            new $849102574a83a574$var$Lt((n[0] + n[1]) / 2, e),
            new $849102574a83a574$var$Lt(i, e)
        ], c = new $849102574a83a574$var$gt(a, null, 0, u, $849102574a83a574$var$wt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != s && c.putAllMetadata(s), c;
    }, t.prototype.decodeMiddle = function(e, r, n) {
        var o, i, a = this.decodeMiddleCounters;
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var s = e.getSize(), u = r[1], c = 0, f = 0; f < 5 && u < s; f++){
            var h = $849102574a83a574$var$ue.decodeDigit(e, a, u, $849102574a83a574$var$ue.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $849102574a83a574$var$ce(a)), d = l.next(); !d.done; d = l.next())u += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 4 - f), 4 !== f && (u = e.getNextSet(u), u = e.getNextUnset(u));
        }
        if (5 !== n.length) throw new $849102574a83a574$var$tt;
        var p = this.determineCheckDigit(c);
        if (t.extensionChecksum(n.toString()) !== p) throw new $849102574a83a574$var$tt;
        return u;
    }, t.extensionChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 2; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        r *= 3;
        for(n = e - 1; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        return (r *= 3) % 10;
    }, t.prototype.determineCheckDigit = function(t) {
        for(var e = 0; e < 10; e++)if (t === this.CHECK_DIGIT_ENCODINGS[e]) return e;
        throw new $849102574a83a574$var$tt;
    }, t.parseExtensionString = function(e) {
        if (5 !== e.length) return null;
        var r = t.parseExtension5String(e);
        return null == r ? null : new Map([
            [
                $849102574a83a574$var$_t.SUGGESTED_PRICE,
                r
            ]
        ]);
    }, t.parseExtension5String = function(t) {
        var e;
        switch(t.charAt(0)){
            case "0":
                e = "\xa3";
                break;
            case "5":
                e = "$";
                break;
            case "9":
                switch(t){
                    case "90000":
                        return null;
                    case "99991":
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                e = "";
                break;
            default:
                e = "";
        }
        var r = parseInt(t.substring(1)), n = r % 100;
        return e + (r / 100).toString() + "." + (n < 10 ? "0" + n : n.toString());
    }, t;
}(), $849102574a83a574$var$he = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$le = function() {
    function t() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), s = t.parseExtensionString(a), u = [
            new $849102574a83a574$var$Lt((n[0] + n[1]) / 2, e),
            new $849102574a83a574$var$Lt(i, e)
        ], c = new $849102574a83a574$var$gt(a, null, 0, u, $849102574a83a574$var$wt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != s && c.putAllMetadata(s), c;
    }, t.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i = this.decodeMiddleCounters;
        i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
        for(var a = t.getSize(), s = e[1], u = 0, c = 0; c < 2 && s < a; c++){
            var f = $849102574a83a574$var$ue.decodeDigit(t, i, s, $849102574a83a574$var$ue.L_AND_G_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + f % 10);
            try {
                for(var h = (n = void 0, $849102574a83a574$var$he(i)), l = h.next(); !l.done; l = h.next())s += l.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    l && !l.done && (o = h.return) && o.call(h);
                } finally{
                    if (n) throw n.error;
                }
            }
            f >= 10 && (u |= 1 << 1 - c), 1 !== c && (s = t.getNextSet(s), s = t.getNextUnset(s));
        }
        if (2 !== r.length) throw new $849102574a83a574$var$tt;
        if (parseInt(r.toString()) % 4 !== u) throw new $849102574a83a574$var$tt;
        return s;
    }, t.parseExtensionString = function(t) {
        return 2 !== t.length ? null : new Map([
            [
                $849102574a83a574$var$_t.ISSUE_NUMBER,
                parseInt(t)
            ]
        ]);
    }, t;
}(), $849102574a83a574$var$de = function() {
    function t() {}
    return t.decodeRow = function(t, e, r) {
        var n = $849102574a83a574$var$ue.findGuardPattern(e, r, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            return (new $849102574a83a574$var$fe).decodeRow(t, e, n);
        } catch (r) {
            return (new $849102574a83a574$var$le).decodeRow(t, e, n);
        }
    }, t.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]), t;
}(), $849102574a83a574$var$pe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ge = function(t) {
    function e() {
        var r = t.call(this) || this;
        r.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(t) {
            return Int32Array.from(t);
        });
        for(var n = 10; n < 20; n++){
            for(var o = e.L_PATTERNS[n - 10], i = new Int32Array(o.length), a = 0; a < o.length; a++)i[a] = o[o.length - a - 1];
            e.L_AND_G_PATTERNS[n] = i;
        }
        return r;
    }
    return $849102574a83a574$var$pe(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o = e.findStartGuardPattern(r), i = null == n ? null : n.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
        if (null != i) {
            var a = new $849102574a83a574$var$Lt((o[0] + o[1]) / 2, t);
            i.foundPossibleResultPoint(a);
        }
        var s = this.decodeMiddle(r, o, this.decodeRowStringBuffer), u = s.rowOffset, c = s.resultString;
        if (null != i) {
            var f = new $849102574a83a574$var$Lt(u, t);
            i.foundPossibleResultPoint(f);
        }
        var h = e.decodeEnd(r, u);
        if (null != i) {
            var l = new $849102574a83a574$var$Lt((h[0] + h[1]) / 2, t);
            i.foundPossibleResultPoint(l);
        }
        var d = h[1], p = d + (d - h[0]);
        if (p >= r.getSize() || !r.isRange(d, p, !1)) throw new $849102574a83a574$var$tt;
        var g = c.toString();
        if (g.length < 8) throw new $849102574a83a574$var$G;
        if (!e.checkChecksum(g)) throw new $849102574a83a574$var$R;
        var y = (o[1] + o[0]) / 2, w = (h[1] + h[0]) / 2, v = this.getBarcodeFormat(), _ = [
            new $849102574a83a574$var$Lt(y, t),
            new $849102574a83a574$var$Lt(w, t)
        ], A = new $849102574a83a574$var$gt(g, null, 0, _, v, (new Date).getTime()), C = 0;
        try {
            var m = $849102574a83a574$var$de.decodeRow(t, r, h[1]);
            A.putMetadata($849102574a83a574$var$_t.UPC_EAN_EXTENSION, m.getText()), A.putAllMetadata(m.getResultMetadata()), A.addResultPoints(m.getResultPoints()), C = m.getText().length;
        } catch (t) {}
        var E = null == n ? null : n.get($849102574a83a574$var$U.ALLOWED_EAN_EXTENSIONS);
        if (null != E) {
            var I = !1;
            for(var S in E)if (C.toString() === S) {
                I = !0;
                break;
            }
            if (!I) throw new $849102574a83a574$var$tt;
        }
        return v === $849102574a83a574$var$wt.EAN_13 || $849102574a83a574$var$wt.UPC_A, A;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $849102574a83a574$var$G;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
}($849102574a83a574$var$ue), $849102574a83a574$var$ye = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$we = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ve = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $849102574a83a574$var$ye(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a, s, u = this.decodeMiddleCounters;
        u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
        for(var c = t.getSize(), f = r[1], h = 0, l = 0; l < 6 && f < c; l++){
            var d = $849102574a83a574$var$ge.decodeDigit(t, u, f, $849102574a83a574$var$ge.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d % 10);
            try {
                for(var p = (o = void 0, $849102574a83a574$var$we(u)), g = p.next(); !g.done; g = p.next())f += g.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (i = p.return) && i.call(p);
                } finally{
                    if (o) throw o.error;
                }
            }
            d >= 10 && (h |= 1 << 5 - l);
        }
        n = e.determineFirstDigit(n, h), f = $849102574a83a574$var$ge.findGuardPattern(t, f, !0, $849102574a83a574$var$ge.MIDDLE_PATTERN, new Int32Array($849102574a83a574$var$ge.MIDDLE_PATTERN.length).fill(0))[1];
        for(l = 0; l < 6 && f < c; l++){
            d = $849102574a83a574$var$ge.decodeDigit(t, u, f, $849102574a83a574$var$ge.L_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d);
            try {
                for(var y = (a = void 0, $849102574a83a574$var$we(u)), w = y.next(); !w.done; w = y.next())f += w.value;
            } catch (t) {
                a = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (s = y.return) && s.call(y);
                } finally{
                    if (a) throw a.error;
                }
            }
        }
        return {
            rowOffset: f,
            resultString: n
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.EAN_13;
    }, e.determineFirstDigit = function(t, e) {
        for(var r = 0; r < 10; r++)if (e === this.FIRST_DIGIT_ENCODINGS[r]) return t = String.fromCharCode("0".charCodeAt(0) + r) + t;
        throw new $849102574a83a574$var$tt;
    }, e.FIRST_DIGIT_ENCODINGS = [
        0,
        11,
        13,
        14,
        19,
        25,
        28,
        21,
        22,
        26
    ], e;
}($849102574a83a574$var$ge), $849102574a83a574$var$_e = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ae = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Ce = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $849102574a83a574$var$_e(e, t), e.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i, a, s = this.decodeMiddleCounters;
        s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
        for(var u = t.getSize(), c = e[1], f = 0; f < 4 && c < u; f++){
            var h = $849102574a83a574$var$ge.decodeDigit(t, s, c, $849102574a83a574$var$ge.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var l = (n = void 0, $849102574a83a574$var$Ae(s)), d = l.next(); !d.done; d = l.next())c += d.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (o = l.return) && o.call(l);
                } finally{
                    if (n) throw n.error;
                }
            }
        }
        c = $849102574a83a574$var$ge.findGuardPattern(t, c, !0, $849102574a83a574$var$ge.MIDDLE_PATTERN, new Int32Array($849102574a83a574$var$ge.MIDDLE_PATTERN.length).fill(0))[1];
        for(f = 0; f < 4 && c < u; f++){
            h = $849102574a83a574$var$ge.decodeDigit(t, s, c, $849102574a83a574$var$ge.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var p = (i = void 0, $849102574a83a574$var$Ae(s)), g = p.next(); !g.done; g = p.next())c += g.value;
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (a = p.return) && a.call(p);
                } finally{
                    if (i) throw i.error;
                }
            }
        }
        return {
            rowOffset: c,
            resultString: r
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.EAN_8;
    }, e;
}($849102574a83a574$var$ge), $849102574a83a574$var$me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ee = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.ean13Reader = new $849102574a83a574$var$ve, e;
    }
    return $849102574a83a574$var$me(e, t), e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.UPC_A;
    }, e.prototype.decode = function(t, e) {
        return this.maybeReturnResult(this.ean13Reader.decode(t));
    }, e.prototype.decodeRow = function(t, e, r) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(t, e, r));
    }, e.prototype.decodeMiddle = function(t, e, r) {
        return this.ean13Reader.decodeMiddle(t, e, r);
    }, e.prototype.maybeReturnResult = function(t) {
        var e = t.getText();
        if ("0" === e.charAt(0)) {
            var r = new $849102574a83a574$var$gt(e.substring(1), null, null, t.getResultPoints(), $849102574a83a574$var$wt.UPC_A);
            return null != t.getResultMetadata() && r.putAllMetadata(t.getResultMetadata()), r;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.reset = function() {
        this.ean13Reader.reset();
    }, e;
}($849102574a83a574$var$ge), $849102574a83a574$var$Ie = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Se = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Te = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = new Int32Array(4), e;
    }
    return $849102574a83a574$var$Ie(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a = this.decodeMiddleCounters.map(function(t) {
            return t;
        });
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var s = t.getSize(), u = r[1], c = 0, f = 0; f < 6 && u < s; f++){
            var h = e.decodeDigit(t, a, u, e.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $849102574a83a574$var$Se(a)), d = l.next(); !d.done; d = l.next())u += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 5 - f);
        }
        return e.determineNumSysAndCheckDigit(new $849102574a83a574$var$Q(n), c), u;
    }, e.prototype.decodeEnd = function(t, r) {
        return e.findGuardPatternWithoutCounters(t, r, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(t) {
        return $849102574a83a574$var$ge.checkChecksum(e.convertUPCEtoUPCA(t));
    }, e.determineNumSysAndCheckDigit = function(t, e) {
        for(var r = 0; r <= 1; r++)for(var n = 0; n < 10; n++)if (e === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[r][n]) return t.insert(0, "0" + r), void t.append("0" + n);
        throw $849102574a83a574$var$tt.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
        return $849102574a83a574$var$wt.UPC_E;
    }, e.convertUPCEtoUPCA = function(t) {
        var e = t.slice(1, 7).split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $849102574a83a574$var$Q;
        r.append(t.charAt(0));
        var n = e[5];
        switch(n){
            case 0:
            case 1:
            case 2:
                r.appendChars(e, 0, 2), r.append(n), r.append("0000"), r.appendChars(e, 2, 3);
                break;
            case 3:
                r.appendChars(e, 0, 3), r.append("00000"), r.appendChars(e, 3, 2);
                break;
            case 4:
                r.appendChars(e, 0, 4), r.append("00000"), r.append(e[4]);
                break;
            default:
                r.appendChars(e, 0, 5), r.append("0000"), r.append(n);
        }
        return t.length >= 8 && r.append(t.charAt(7)), r.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            56,
            52,
            50,
            49,
            44,
            38,
            35,
            42,
            41,
            37
        ]),
        Int32Array.from([
            7,
            11,
            13,
            14,
            19,
            25,
            28,
            21,
            22,
            1
        ])
    ], e;
}($849102574a83a574$var$ge), $849102574a83a574$var$Oe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$be = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Re = function(t) {
    function e(e) {
        var r = t.call(this) || this, n = null == e ? null : e.get($849102574a83a574$var$U.POSSIBLE_FORMATS), o = [];
        return null != n && (n.indexOf($849102574a83a574$var$wt.EAN_13) > -1 && o.push(new $849102574a83a574$var$ve), n.indexOf($849102574a83a574$var$wt.UPC_A) > -1 && o.push(new $849102574a83a574$var$Ee), n.indexOf($849102574a83a574$var$wt.EAN_8) > -1 && o.push(new $849102574a83a574$var$Ce), n.indexOf($849102574a83a574$var$wt.UPC_E) > -1 && o.push(new $849102574a83a574$var$Te)), 0 === o.length && (o.push(new $849102574a83a574$var$ve), o.push(new $849102574a83a574$var$Ee), o.push(new $849102574a83a574$var$Ce), o.push(new $849102574a83a574$var$Te)), r.readers = o, r;
    }
    return $849102574a83a574$var$Oe(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n, o;
        try {
            for(var i = $849102574a83a574$var$be(this.readers), a = i.next(); !a.done; a = i.next()){
                var s = a.value;
                try {
                    var u = s.decodeRow(t, e, r), c = u.getBarcodeFormat() === $849102574a83a574$var$wt.EAN_13 && "0" === u.getText().charAt(0), f = null == r ? null : r.get($849102574a83a574$var$U.POSSIBLE_FORMATS), h = null == f || f.includes($849102574a83a574$var$wt.UPC_A);
                    if (c && h) {
                        var l = u.getRawBytes(), d = new $849102574a83a574$var$gt(u.getText().substring(1), l, l ? l.length : null, u.getResultPoints(), $849102574a83a574$var$wt.UPC_A);
                        return d.putAllMetadata(u.getResultMetadata()), d;
                    }
                    return u;
                } catch (t) {}
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.reset = function() {
        var t, e;
        try {
            for(var r = $849102574a83a574$var$be(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Ne = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$De = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.CODA_BAR_CHAR_SET = {
            nnnnnww: "0",
            nnnnwwn: "1",
            nnnwnnw: "2",
            wwnnnnn: "3",
            nnwnnwn: "4",
            wnnnnwn: "5",
            nwnnnnw: "6",
            nwnnwnn: "7",
            nwwnnnn: "8",
            wnnwnnn: "9",
            nnnwwnn: "-",
            nnwwnnn: "$",
            wnnnwnw: ":",
            wnwnnnw: "/",
            wnwnwnn: ".",
            nnwwwww: "+",
            nnwwnwn: "A",
            nwnwnnw: "B",
            nnnwnww: "C",
            nnnwwwn: "D"
        }, e;
    }
    return $849102574a83a574$var$Ne(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n = this.getValidRowData(e);
        if (!n) throw new $849102574a83a574$var$tt;
        var o = this.codaBarDecodeRow(n.row);
        if (!o) throw new $849102574a83a574$var$tt;
        return new $849102574a83a574$var$gt(o, null, 0, [
            new $849102574a83a574$var$Lt(n.left, t),
            new $849102574a83a574$var$Lt(n.right, t)
        ], $849102574a83a574$var$wt.CODABAR, (new Date).getTime());
    }, e.prototype.getValidRowData = function(t) {
        var e = t.toArray(), r = e.indexOf(!0);
        if (-1 === r) return null;
        var n = e.lastIndexOf(!0);
        if (n <= r) return null;
        for(var o = [], i = (e = e.slice(r, n + 1))[0], a = 1, s = 1; s < e.length; s++)e[s] === i ? a++ : (i = e[s], o.push(a), a = 1);
        return o.push(a), o.length < 23 && (o.length + 1) % 8 != 0 ? null : {
            row: o,
            left: r,
            right: n
        };
    }, e.prototype.codaBarDecodeRow = function(t) {
        for(var e = [], r = Math.ceil(t.reduce(function(t, e) {
            return (t + e) / 2;
        }, 0)); t.length > 0;){
            var n = t.splice(0, 8).splice(0, 7).map(function(t) {
                return t < r ? "n" : "w";
            }).join("");
            if (void 0 === this.CODA_BAR_CHAR_SET[n]) return null;
            e.push(this.CODA_BAR_CHAR_SET[n]);
        }
        var o = e.join("");
        return this.validCodaBarString(o) ? o : null;
    }, e.prototype.validCodaBarString = function(t) {
        return /^[A-D].{1,}[A-D]$/.test(t);
    }, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Pe = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Be = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeFinderCounters = new Int32Array(4), e.dataCharacterCounters = new Int32Array(8), e.oddRoundingErrors = new Array(4), e.evenRoundingErrors = new Array(4), e.oddCounts = new Array(e.dataCharacterCounters.length / 2), e.evenCounts = new Array(e.dataCharacterCounters.length / 2), e;
    }
    return $849102574a83a574$var$Me(e, t), e.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
        return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
        return this.evenCounts;
    }, e.prototype.parseFinderValue = function(t, r) {
        for(var n = 0; n < r.length; n++)if ($849102574a83a574$var$Kt.patternMatchVariance(t, r[n], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return n;
        throw new $849102574a83a574$var$tt;
    }, e.count = function(t) {
        return $849102574a83a574$var$Pt.sum(new Int32Array(t));
    }, e.increment = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] > n && (n = e[o], r = o);
        t[r]++;
    }, e.decrement = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] < n && (n = e[o], r = o);
        t[r]--;
    }, e.isFinderPattern = function(t) {
        var r, n, o = t[0] + t[1], i = o / (o + t[2] + t[3]);
        if (i >= e.MIN_FINDER_PATTERN_RATIO && i <= e.MAX_FINDER_PATTERN_RATIO) {
            var a = Number.MAX_SAFE_INTEGER, s = Number.MIN_SAFE_INTEGER;
            try {
                for(var u = $849102574a83a574$var$Pe(t), c = u.next(); !c.done; c = u.next()){
                    var f = c.value;
                    f > s && (s = f), f < a && (a = f);
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    c && !c.done && (n = u.return) && n.call(u);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s < 10 * a;
        }
        return !1;
    }, e.MAX_AVG_VARIANCE = .2, e.MAX_INDIVIDUAL_VARIANCE = .45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Le = function() {
    function t(t, e) {
        this.value = t, this.checksumPortion = e;
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    }, t.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value && this.checksumPortion === r.checksumPortion;
    }, t.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    }, t;
}(), $849102574a83a574$var$Fe = function() {
    function t(t, e, r, n, o) {
        this.value = t, this.startEnd = e, this.value = t, this.startEnd = e, this.resultPoints = new Array, this.resultPoints.push(new $849102574a83a574$var$Lt(r, o)), this.resultPoints.push(new $849102574a83a574$var$Lt(n, o));
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getStartEnd = function() {
        return this.startEnd;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.hashCode = function() {
        return this.value;
    }, t;
}(), $849102574a83a574$var$ke = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$xe = function() {
    function t() {}
    return t.getRSSvalue = function(e, r, n) {
        var o, i, a = 0;
        try {
            for(var s = $849102574a83a574$var$ke(e), u = s.next(); !u.done; u = s.next())a += u.value;
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (i = s.return) && i.call(s);
            } finally{
                if (o) throw o.error;
            }
        }
        for(var c = 0, f = 0, h = e.length, l = 0; l < h - 1; l++){
            var d = void 0;
            for(d = 1, f |= 1 << l; d < e[l]; d++, f &= ~(1 << l)){
                var p = t.combins(a - d - 1, h - l - 2);
                if (n && 0 === f && a - d - (h - l - 1) >= h - l - 1 && (p -= t.combins(a - d - (h - l), h - l - 2)), h - l - 1 > 1) {
                    for(var g = 0, y = a - d - (h - l - 2); y > r; y--)g += t.combins(a - d - y - 1, h - l - 3);
                    p -= g * (h - 1 - l);
                } else a - d > r && p--;
                c += p;
            }
            a -= d;
        }
        return c;
    }, t.combins = function(t, e) {
        var r, n;
        t - e > e ? (n = e, r = t - e) : (n = t - e, r = e);
        for(var o = 1, i = 1, a = t; a > r; a--)o *= a, i <= n && (o /= i, i++);
        for(; i <= n;)o /= i, i++;
        return o;
    }, t;
}(), $849102574a83a574$var$Ve = function() {
    function t() {}
    return t.buildBitArray = function(t) {
        var e = 2 * t.length - 1;
        null == t[t.length - 1].getRightChar() && (e -= 1);
        for(var r = new $849102574a83a574$var$V(12 * e), n = 0, o = t[0].getRightChar().getValue(), i = 11; i >= 0; --i)0 != (o & 1 << i) && r.set(n), n++;
        for(i = 1; i < t.length; ++i){
            for(var a = t[i], s = a.getLeftChar().getValue(), u = 11; u >= 0; --u)0 != (s & 1 << u) && r.set(n), n++;
            if (null !== a.getRightChar()) {
                var c = a.getRightChar().getValue();
                for(u = 11; u >= 0; --u)0 != (c & 1 << u) && r.set(n), n++;
            }
        }
        return r;
    }, t;
}(), $849102574a83a574$var$He = function() {
    function t(t, e) {
        e ? this.decodedInformation = null : (this.finished = t, this.decodedInformation = e);
    }
    return t.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    }, t.prototype.isFinished = function() {
        return this.finished;
    }, t;
}(), $849102574a83a574$var$Ue = function() {
    function t(t) {
        this.newPosition = t;
    }
    return t.prototype.getNewPosition = function() {
        return this.newPosition;
    }, t;
}(), $849102574a83a574$var$Xe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ge = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n.value = r, n;
    }
    return $849102574a83a574$var$Xe(e, t), e.prototype.getValue = function() {
        return this.value;
    }, e.prototype.isFNC1 = function() {
        return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
}($849102574a83a574$var$Ue), $849102574a83a574$var$We = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ze = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return n ? (o.remaining = !0, o.remainingValue = o.remainingValue) : (o.remaining = !1, o.remainingValue = 0), o.newString = r, o;
    }
    return $849102574a83a574$var$We(e, t), e.prototype.getNewString = function() {
        return this.newString;
    }, e.prototype.isRemaining = function() {
        return this.remaining;
    }, e.prototype.getRemainingValue = function() {
        return this.remainingValue;
    }, e;
}($849102574a83a574$var$Ue), $849102574a83a574$var$je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ye = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        if (r < 0 || r > 10 || n < 0 || n > 10) throw new $849102574a83a574$var$G;
        return o.firstDigit = r, o.secondDigit = n, o;
    }
    return $849102574a83a574$var$je(e, t), e.prototype.getFirstDigit = function() {
        return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
        return this.secondDigit;
    }, e.prototype.getValue = function() {
        return 10 * this.firstDigit + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
        return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
}($849102574a83a574$var$Ue), $849102574a83a574$var$Ze = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Ke = function() {
    function t() {}
    return t.parseFieldsInGeneralPurpose = function(e) {
        var r, n, o, i, a, s, u, c;
        if (!e) return null;
        if (e.length < 2) throw new $849102574a83a574$var$tt;
        var f = e.substring(0, 2);
        try {
            for(var h = $849102574a83a574$var$Ze(t.TWO_DIGIT_DATA_LENGTH), l = h.next(); !l.done; l = h.next()){
                if ((C = l.value)[0] === f) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(2, C[2], e) : t.processFixedAI(2, C[1], e);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        if (e.length < 3) throw new $849102574a83a574$var$tt;
        var d = e.substring(0, 3);
        try {
            for(var p = $849102574a83a574$var$Ze(t.THREE_DIGIT_DATA_LENGTH), g = p.next(); !g.done; g = p.next()){
                if ((C = g.value)[0] === d) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(3, C[2], e) : t.processFixedAI(3, C[1], e);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        try {
            for(var y = $849102574a83a574$var$Ze(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), w = y.next(); !w.done; w = y.next()){
                if ((C = w.value)[0] === d) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, C[2], e) : t.processFixedAI(4, C[1], e);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (s = y.return) && s.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        if (e.length < 4) throw new $849102574a83a574$var$tt;
        var v = e.substring(0, 4);
        try {
            for(var _ = $849102574a83a574$var$Ze(t.FOUR_DIGIT_DATA_LENGTH), A = _.next(); !A.done; A = _.next()){
                var C;
                if ((C = A.value)[0] === v) return C[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, C[2], e) : t.processFixedAI(4, C[1], e);
            }
        } catch (t) {
            u = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (c = _.return) && c.call(_);
            } finally{
                if (u) throw u.error;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, t.processFixedAI = function(e, r, n) {
        if (n.length < e) throw new $849102574a83a574$var$tt;
        var o = n.substring(0, e);
        if (n.length < e + r) throw new $849102574a83a574$var$tt;
        var i = n.substring(e, e + r), a = n.substring(e + r), s = "(" + o + ")" + i, u = t.parseFieldsInGeneralPurpose(a);
        return null == u ? s : s + u;
    }, t.processVariableAI = function(e, r, n) {
        var o, i = n.substring(0, e);
        o = n.length < e + r ? n.length : e + r;
        var a = n.substring(e, o), s = n.substring(o), u = "(" + i + ")" + a, c = t.parseFieldsInGeneralPurpose(s);
        return null == c ? u : u + c;
    }, t.VARIABLE_LENGTH = [], t.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            t.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "90",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            t.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.THREE_DIGIT_DATA_LENGTH = [
        [
            "240",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            t.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            t.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ], t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.FOUR_DIGIT_DATA_LENGTH = [
        [
            "7001",
            13
        ],
        [
            "7002",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            t.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            t.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            t.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            t.VARIABLE_LENGTH,
            70
        ]
    ], t;
}(), $849102574a83a574$var$qe = function() {
    function t(t) {
        this.buffer = new $849102574a83a574$var$Q, this.information = t;
    }
    return t.prototype.decodeAllCodes = function(t, e) {
        for(var r = e, n = null;;){
            var o = this.decodeGeneralPurposeField(r, n), i = $849102574a83a574$var$Ke.parseFieldsInGeneralPurpose(o.getNewString());
            if (null != i && t.append(i), n = o.isRemaining() ? "" + o.getRemainingValue() : null, r === o.getNewPosition()) break;
            r = o.getNewPosition();
        }
        return t.toString();
    }, t.prototype.isStillNumeric = function(t) {
        if (t + 7 > this.information.getSize()) return t + 4 <= this.information.getSize();
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !0;
        return this.information.get(t + 3);
    }, t.prototype.decodeNumeric = function(t) {
        if (t + 7 > this.information.getSize()) {
            var e = this.extractNumericValueFromBitArray(t, 4);
            return new $849102574a83a574$var$Ye(this.information.getSize(), 0 === e ? $849102574a83a574$var$Ye.FNC1 : e - 1, $849102574a83a574$var$Ye.FNC1);
        }
        var r = this.extractNumericValueFromBitArray(t, 7);
        return new $849102574a83a574$var$Ye(t + 7, (r - 8) / 11, (r - 8) % 11);
    }, t.prototype.extractNumericValueFromBitArray = function(e, r) {
        return t.extractNumericValueFromBitArray(this.information, e, r);
    }, t.extractNumericValueFromBitArray = function(t, e, r) {
        for(var n = 0, o = 0; o < r; ++o)t.get(e + o) && (n |= 1 << r - o - 1);
        return n;
    }, t.prototype.decodeGeneralPurposeField = function(t, e) {
        this.buffer.setLengthToZero(), null != e && this.buffer.append(e), this.current.setPosition(t);
        var r = this.parseBlocks();
        return null != r && r.isRemaining() ? new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString(), r.getRemainingValue()) : new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
    }, t.prototype.parseBlocks = function() {
        var t, e;
        do {
            var r = this.current.getPosition();
            if (t = this.current.isAlpha() ? (e = this.parseAlphaBlock()).isFinished() : this.current.isIsoIec646() ? (e = this.parseIsoIec646Block()).isFinished() : (e = this.parseNumericBlock()).isFinished(), !(r !== this.current.getPosition()) && !t) break;
        }while (!t);
        return e.getDecodedInformation();
    }, t.prototype.parseNumericBlock = function() {
        for(; this.isStillNumeric(this.current.getPosition());){
            var t = this.decodeNumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFirstDigitFNC1()) {
                var e = void 0;
                return e = t.isSecondDigitFNC1() ? new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString()) : new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString(), t.getSecondDigit()), new $849102574a83a574$var$He(!0, e);
            }
            if (this.buffer.append(t.getFirstDigit()), t.isSecondDigitFNC1()) {
                e = new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
                return new $849102574a83a574$var$He(!0, e);
            }
            this.buffer.append(t.getSecondDigit());
        }
        return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new $849102574a83a574$var$He(!1);
    }, t.prototype.parseIsoIec646Block = function() {
        for(; this.isStillIsoIec646(this.current.getPosition());){
            var t = this.decodeIsoIec646(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
                return new $849102574a83a574$var$He(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new $849102574a83a574$var$He(!1);
    }, t.prototype.parseAlphaBlock = function() {
        for(; this.isStillAlpha(this.current.getPosition());){
            var t = this.decodeAlphanumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $849102574a83a574$var$ze(this.current.getPosition(), this.buffer.toString());
                return new $849102574a83a574$var$He(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new $849102574a83a574$var$He(!1);
    }, t.prototype.isStillIsoIec646 = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 7 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 7);
        if (r >= 64 && r < 116) return !0;
        if (t + 8 > this.information.getSize()) return !1;
        var n = this.extractNumericValueFromBitArray(t, 8);
        return n >= 232 && n < 253;
    }, t.prototype.decodeIsoIec646 = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $849102574a83a574$var$Ge(t + 5, $849102574a83a574$var$Ge.FNC1);
        if (e >= 5 && e < 15) return new $849102574a83a574$var$Ge(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 7);
        if (n >= 64 && n < 90) return new $849102574a83a574$var$Ge(t + 7, "" + (n + 1));
        if (n >= 90 && n < 116) return new $849102574a83a574$var$Ge(t + 7, "" + (n + 7));
        switch(this.extractNumericValueFromBitArray(t, 8)){
            case 232:
                r = "!";
                break;
            case 233:
                r = '"';
                break;
            case 234:
                r = "%";
                break;
            case 235:
                r = "&";
                break;
            case 236:
                r = "'";
                break;
            case 237:
                r = "(";
                break;
            case 238:
                r = ")";
                break;
            case 239:
                r = "*";
                break;
            case 240:
                r = "+";
                break;
            case 241:
                r = ",";
                break;
            case 242:
                r = "-";
                break;
            case 243:
                r = ".";
                break;
            case 244:
                r = "/";
                break;
            case 245:
                r = ":";
                break;
            case 246:
                r = ";";
                break;
            case 247:
                r = "<";
                break;
            case 248:
                r = "=";
                break;
            case 249:
                r = ">";
                break;
            case 250:
                r = "?";
                break;
            case 251:
                r = "_";
                break;
            case 252:
                r = " ";
                break;
            default:
                throw new $849102574a83a574$var$G;
        }
        return new $849102574a83a574$var$Ge(t + 8, r);
    }, t.prototype.isStillAlpha = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 6 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 6);
        return r >= 16 && r < 63;
    }, t.prototype.decodeAlphanumeric = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $849102574a83a574$var$Ge(t + 5, $849102574a83a574$var$Ge.FNC1);
        if (e >= 5 && e < 15) return new $849102574a83a574$var$Ge(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 6);
        if (n >= 32 && n < 58) return new $849102574a83a574$var$Ge(t + 6, "" + (n + 33));
        switch(n){
            case 58:
                r = "*";
                break;
            case 59:
                r = ",";
                break;
            case 60:
                r = "-";
                break;
            case 61:
                r = ".";
                break;
            case 62:
                r = "/";
                break;
            default:
                throw new $849102574a83a574$var$Nt("Decoding invalid alphanumeric value: " + n);
        }
        return new $849102574a83a574$var$Ge(t + 6, r);
    }, t.prototype.isAlphaTo646ToAlphaLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 5 && e + t < this.information.getSize(); ++e)if (2 === e) {
            if (!this.information.get(t + 2)) return !1;
        } else if (this.information.get(t + e)) return !1;
        return !0;
    }, t.prototype.isAlphaOr646ToNumericLatch = function(t) {
        if (t + 3 > this.information.getSize()) return !1;
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !1;
        return !0;
    }, t.prototype.isNumericToAlphaNumericLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 4 && e + t < this.information.getSize(); ++e)if (this.information.get(t + e)) return !1;
        return !0;
    }, t;
}(), $849102574a83a574$var$Qe = function() {
    function t(t) {
        this.information = t, this.generalDecoder = new $849102574a83a574$var$qe(t);
    }
    return t.prototype.getInformation = function() {
        return this.information;
    }, t.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    }, t;
}(), $849102574a83a574$var$Je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$$e = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$Je(e, t), e.prototype.encodeCompressedGtin = function(t, e) {
        t.append("(01)");
        var r = t.length();
        t.append("9"), this.encodeCompressedGtinWithoutAI(t, e, r);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(t, r, n) {
        for(var o = 0; o < 4; ++o){
            var i = this.getGeneralDecoder().extractNumericValueFromBitArray(r + 10 * o, 10);
            i / 100 == 0 && t.append("0"), i / 10 == 0 && t.append("0"), t.append(i);
        }
        e.appendCheckDigit(t, n);
    }, e.appendCheckDigit = function(t, e) {
        for(var r = 0, n = 0; n < 13; n++){
            var o = t.charAt(n + e).charCodeAt(0) - "0".charCodeAt(0);
            r += 0 == (1 & n) ? 3 * o : o;
        }
        10 === (r = 10 - r % 10) && (r = 0), t.append(r);
    }, e.GTIN_SIZE = 40, e;
}($849102574a83a574$var$Qe), $849102574a83a574$var$tr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$er = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$tr(e, t), e.prototype.parseInformation = function() {
        var t = new $849102574a83a574$var$Q;
        t.append("(01)");
        var r = t.length(), n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
        return t.append(n), this.encodeCompressedGtinWithoutAI(t, e.HEADER_SIZE + 4, r), this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 4, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$rr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$nr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$rr(e, t), e.prototype.parseInformation = function() {
        var t = new $849102574a83a574$var$Q;
        return this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 5, e;
}($849102574a83a574$var$Qe), $849102574a83a574$var$or = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ir = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$or(e, t), e.prototype.encodeCompressedWeight = function(t, e, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e, r);
        this.addWeightCode(t, n);
        for(var o = this.checkWeight(n), i = 1e5, a = 0; a < 5; ++a)o / i == 0 && t.append("0"), i /= 10;
        t.append(o);
    }, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$sr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$ar(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== e.HEADER_SIZE + $849102574a83a574$var$ir.GTIN_SIZE + e.WEIGHT_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + $849102574a83a574$var$ir.GTIN_SIZE, e.WEIGHT_SIZE), t.toString();
    }, e.HEADER_SIZE = 5, e.WEIGHT_SIZE = 15, e;
}($849102574a83a574$var$ir), $849102574a83a574$var$ur = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$cr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$ur(e, t), e.prototype.addWeightCode = function(t, e) {
        t.append("(3103)");
    }, e.prototype.checkWeight = function(t) {
        return t;
    }, e;
}($849102574a83a574$var$sr), $849102574a83a574$var$fr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$hr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$fr(e, t), e.prototype.addWeightCode = function(t, e) {
        e < 1e4 ? t.append("(3202)") : t.append("(3203)");
    }, e.prototype.checkWeight = function(t) {
        return t < 1e4 ? t : t - 1e4;
    }, e;
}($849102574a83a574$var$sr), $849102574a83a574$var$lr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$dr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$lr(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(392"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
        return t.append(n.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$pr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$gr = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $849102574a83a574$var$pr(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(393"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
        n / 100 == 0 && t.append("0"), n / 10 == 0 && t.append("0"), t.append(n);
        var o = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $849102574a83a574$var$$e.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
        return t.append(o.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
}($849102574a83a574$var$$e), $849102574a83a574$var$yr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$wr = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.dateCode = n, o.firstAIdigits = r, o;
    }
    return $849102574a83a574$var$yr(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE) throw new $849102574a83a574$var$tt;
        var t = new $849102574a83a574$var$Q;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(t, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), t.toString();
    }, e.prototype.encodeCompressedDate = function(t, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(r, e.DATE_SIZE);
        if (38400 !== n) {
            t.append("("), t.append(this.dateCode), t.append(")");
            var o = n % 32, i = (n /= 32) % 12 + 1, a = n /= 12;
            a / 10 == 0 && t.append("0"), t.append(a), i / 10 == 0 && t.append("0"), t.append(i), o / 10 == 0 && t.append("0"), t.append(o);
        }
    }, e.prototype.addWeightCode = function(t, e) {
        t.append("("), t.append(this.firstAIdigits), t.append(e / 1e5), t.append(")");
    }, e.prototype.checkWeight = function(t) {
        return t % 1e5;
    }, e.HEADER_SIZE = 8, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
}($849102574a83a574$var$ir);
var $849102574a83a574$var$vr = function() {
    function t(t, e, r, n) {
        this.leftchar = t, this.rightchar = e, this.finderpattern = r, this.maybeLast = n;
    }
    return t.prototype.mayBeLast = function() {
        return this.maybeLast;
    }, t.prototype.getLeftChar = function() {
        return this.leftchar;
    }, t.prototype.getRightChar = function() {
        return this.rightchar;
    }, t.prototype.getFinderPattern = function() {
        return this.finderpattern;
    }, t.prototype.mustBeLast = function() {
        return null == this.rightchar;
    }, t.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (null == this.finderpattern ? "null" : this.finderpattern.getValue()) + " ]";
    }, t.equals = function(e, r) {
        return e instanceof t && t.equalsOrNull(e.leftchar, r.leftchar) && t.equalsOrNull(e.rightchar, r.rightchar) && t.equalsOrNull(e.finderpattern, r.finderpattern);
    }, t.equalsOrNull = function(e, r) {
        return null === e ? null === r : t.equals(e, r);
    }, t.prototype.hashCode = function() {
        return this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
    }, t;
}(), $849102574a83a574$var$_r = function() {
    function t(t, e, r) {
        this.pairs = t, this.rowNumber = e, this.wasReversed = r;
    }
    return t.prototype.getPairs = function() {
        return this.pairs;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.isReversed = function() {
        return this.wasReversed;
    }, t.prototype.isEquivalent = function(t) {
        return this.checkEqualitity(this, t);
    }, t.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    }, t.prototype.equals = function(e, r) {
        return e instanceof t && this.checkEqualitity(e, r) && e.wasReversed === r.wasReversed;
    }, t.prototype.checkEqualitity = function(t, e) {
        var r;
        if (t && e) return t.forEach(function(t, n) {
            e.forEach(function(e) {
                t.getLeftChar().getValue() === e.getLeftChar().getValue() && t.getRightChar().getValue() === e.getRightChar().getValue() && t.getFinderPatter().getValue() === e.getFinderPatter().getValue() && (r = !0);
            });
        }), r;
    }, t;
}(), $849102574a83a574$var$Ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Cr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$mr = function(t) {
    function e() {
        var r = null !== t && t.apply(this, arguments) || this;
        return r.pairs = new Array(e.MAX_PAIRS), r.rows = new Array, r.startEnd = [
            2
        ], r;
    }
    return $849102574a83a574$var$Ar(e, t), e.prototype.decodeRow = function(t, r, n) {
        this.pairs.length = 0, this.startFromEven = !1;
        try {
            return e.constructResult(this.decodeRow2pairs(t, r));
        } catch (t) {}
        return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(t, r));
    }, e.prototype.reset = function() {
        this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(t, e) {
        for(var r, n = !1; !n;)try {
            this.pairs.push(this.retrieveNextPair(e, this.pairs, t));
        } catch (t) {
            if (t instanceof $849102574a83a574$var$tt) {
                if (!this.pairs.length) throw new $849102574a83a574$var$tt;
                n = !0;
            }
        }
        if (this.checkChecksum()) return this.pairs;
        if (r = !!this.rows.length, this.storeRow(t, !1), r) {
            var o = this.checkRowsBoolean(!1);
            if (null != o) return o;
            if (null != (o = this.checkRowsBoolean(!0))) return o;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.checkRowsBoolean = function(t) {
        if (this.rows.length > 25) return this.rows.length = 0, null;
        this.pairs.length = 0, t && (this.rows = this.rows.reverse());
        var e = null;
        try {
            e = this.checkRows(new Array, 0);
        } catch (t) {
            console.log(t);
        }
        return t && (this.rows = this.rows.reverse()), e;
    }, e.prototype.checkRows = function(t, r) {
        for(var n, o, i = r; i < this.rows.length; i++){
            var a = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var s = (n = void 0, $849102574a83a574$var$Cr(t)), u = s.next(); !u.done; u = s.next()){
                    var c = u.value;
                    this.pairs.push(c.getPairs());
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    u && !u.done && (o = s.return) && o.call(s);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (this.pairs.push(a.getPairs()), e.isValidSequence(this.pairs)) {
                if (this.checkChecksum()) return this.pairs;
                var f = new Array(t);
                f.push(a);
                try {
                    return this.checkRows(f, i + 1);
                } catch (t) {
                    console.log(t);
                }
            }
        }
        throw new $849102574a83a574$var$tt;
    }, e.isValidSequence = function(t) {
        var r, n;
        try {
            for(var o = $849102574a83a574$var$Cr(e.FINDER_PATTERN_SEQUENCES), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (!(t.length > a.length)) {
                    for(var s = !0, u = 0; u < t.length; u++)if (t[u].getFinderPattern().getValue() !== a[u]) {
                        s = !1;
                        break;
                    }
                    if (s) return !0;
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = o.return) && n.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.storeRow = function(t, r) {
        for(var n = 0, o = !1, i = !1; n < this.rows.length;){
            var a = this.rows[n];
            if (a.getRowNumber() > t) {
                i = a.isEquivalent(this.pairs);
                break;
            }
            o = a.isEquivalent(this.pairs), n++;
        }
        i || o || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(n, new $849102574a83a574$var$_r(this.pairs, t, r)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(t, e) {
        var r, n, o, i, a, s;
        try {
            for(var u = $849102574a83a574$var$Cr(e), c = u.next(); !c.done; c = u.next()){
                var f = c.value;
                if (f.getPairs().length !== t.length) try {
                    for(var h = (o = void 0, $849102574a83a574$var$Cr(f.getPairs())), l = h.next(); !l.done; l = h.next()){
                        var d = l.value, p = !1;
                        try {
                            for(var g = (a = void 0, $849102574a83a574$var$Cr(t)), y = g.next(); !y.done; y = g.next()){
                                var w = y.value;
                                if ($849102574a83a574$var$vr.equals(d, w)) {
                                    p = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                y && !y.done && (s = g.return) && s.call(g);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        p;
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (i = h.return) && i.call(h);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
    }, e.isPartialRow = function(t, e) {
        var r, n, o, i, a, s;
        try {
            for(var u = $849102574a83a574$var$Cr(e), c = u.next(); !c.done; c = u.next()){
                var f = c.value, h = !0;
                try {
                    for(var l = (o = void 0, $849102574a83a574$var$Cr(t)), d = l.next(); !d.done; d = l.next()){
                        var p = d.value, g = !1;
                        try {
                            for(var y = (a = void 0, $849102574a83a574$var$Cr(f.getPairs())), w = y.next(); !w.done; w = y.next()){
                                var v = w.value;
                                if (p.equals(v)) {
                                    g = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                w && !w.done && (s = y.return) && s.call(y);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        if (!g) {
                            h = !1;
                            break;
                        }
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (i = l.return) && i.call(l);
                    } finally{
                        if (o) throw o.error;
                    }
                }
                if (h) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.getRows = function() {
        return this.rows;
    }, e.constructResult = function(t) {
        var e = (function(t) {
            try {
                if (t.get(1)) return new $849102574a83a574$var$er(t);
                if (!t.get(2)) return new $849102574a83a574$var$nr(t);
                switch($849102574a83a574$var$qe.extractNumericValueFromBitArray(t, 1, 4)){
                    case 4:
                        return new $849102574a83a574$var$cr(t);
                    case 5:
                        return new $849102574a83a574$var$hr(t);
                }
                switch($849102574a83a574$var$qe.extractNumericValueFromBitArray(t, 1, 5)){
                    case 12:
                        return new $849102574a83a574$var$dr(t);
                    case 13:
                        return new $849102574a83a574$var$gr(t);
                }
                switch($849102574a83a574$var$qe.extractNumericValueFromBitArray(t, 1, 7)){
                    case 56:
                        return new $849102574a83a574$var$wr(t, "310", "11");
                    case 57:
                        return new $849102574a83a574$var$wr(t, "320", "11");
                    case 58:
                        return new $849102574a83a574$var$wr(t, "310", "13");
                    case 59:
                        return new $849102574a83a574$var$wr(t, "320", "13");
                    case 60:
                        return new $849102574a83a574$var$wr(t, "310", "15");
                    case 61:
                        return new $849102574a83a574$var$wr(t, "320", "15");
                    case 62:
                        return new $849102574a83a574$var$wr(t, "310", "17");
                    case 63:
                        return new $849102574a83a574$var$wr(t, "320", "17");
                }
            } catch (e) {
                throw console.log(e), new $849102574a83a574$var$Nt("unknown decoder: " + t);
            }
        })($849102574a83a574$var$Ve.buildBitArray(t)).parseInformation(), r = t[0].getFinderPattern().getResultPoints(), n = t[t.length - 1].getFinderPattern().getResultPoints(), o = [
            r[0],
            r[1],
            n[0],
            n[1]
        ];
        return new $849102574a83a574$var$gt(e, null, null, o, $849102574a83a574$var$wt.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
        var t = this.pairs.get(0), e = t.getLeftChar(), r = t.getRightChar();
        if (null === r) return !1;
        for(var n = r.getChecksumPortion(), o = 2, i = 1; i < this.pairs.size(); ++i){
            var a = this.pairs.get(i);
            n += a.getLeftChar().getChecksumPortion(), o++;
            var s = a.getRightChar();
            null != s && (n += s.getChecksumPortion(), o++);
        }
        return 211 * (o - 4) + (n %= 211) === e.getValue();
    }, e.getNextSecondBar = function(t, e) {
        var r;
        return t.get(e) ? (r = t.getNextUnset(e), r = t.getNextSet(r)) : (r = t.getNextSet(e), r = t.getNextUnset(r)), r;
    }, e.prototype.retrieveNextPair = function(t, r, n) {
        var o, i = r.length % 2 == 0;
        this.startFromEven && (i = !i);
        var a = !0, s = -1;
        do this.findNextPair(t, r, s), null === (o = this.parseFoundFinderPattern(t, n, i)) ? s = e.getNextSecondBar(t, this.startEnd[0]) : a = !1;
        while (a);
        var u, c = this.decodeDataCharacter(t, o, i, !0);
        if (!this.isEmptyPair(r) && r[r.length - 1].mustBeLast()) throw new $849102574a83a574$var$tt;
        try {
            u = this.decodeDataCharacter(t, o, i, !1);
        } catch (t) {
            u = null, console.log(t);
        }
        return new $849102574a83a574$var$vr(c, u, o, !0);
    }, e.prototype.isEmptyPair = function(t) {
        return 0 === t.length;
    }, e.prototype.findNextPair = function(t, r, n) {
        var o = this.getDecodeFinderCounters();
        o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0;
        var i, a = t.getSize();
        if (n >= 0) i = n;
        else if (this.isEmptyPair(r)) i = 0;
        else i = r[r.length - 1].getFinderPattern().getStartEnd()[1];
        var s = r.length % 2 != 0;
        this.startFromEven && (s = !s);
        for(var u = !1; i < a && (u = !t.get(i));)i++;
        for(var c = 0, f = i, h = i; h < a; h++)if (t.get(h) !== u) o[c]++;
        else {
            if (3 === c) {
                if (s && e.reverseCounters(o), e.isFinderPattern(o)) return this.startEnd[0] = f, void (this.startEnd[1] = h);
                s && e.reverseCounters(o), f += o[0] + o[1], o[0] = o[2], o[1] = o[3], o[2] = 0, o[3] = 0, c--;
            } else c++;
            o[c] = 1, u = !u;
        }
        throw new $849102574a83a574$var$tt;
    }, e.reverseCounters = function(t) {
        for(var e = t.length, r = 0; r < e / 2; ++r){
            var n = t[r];
            t[r] = t[e - r - 1], t[e - r - 1] = n;
        }
    }, e.prototype.parseFoundFinderPattern = function(t, r, n) {
        var o, i, a;
        if (n) {
            for(var s = this.startEnd[0] - 1; s >= 0 && !t.get(s);)s--;
            s++, o = this.startEnd[0] - s, i = s, a = this.startEnd[1];
        } else i = this.startEnd[0], o = (a = t.getNextUnset(this.startEnd[1] + 1)) - this.startEnd[1];
        var u, c = this.getDecodeFinderCounters();
        $849102574a83a574$var$D.arraycopy(c, 0, c, 1, c.length - 1), c[0] = o;
        try {
            u = this.parseFinderValue(c, e.FINDER_PATTERNS);
        } catch (t) {
            return null;
        }
        return new $849102574a83a574$var$Fe(u, [
            i,
            a
        ], i, a, r);
    }, e.prototype.decodeDataCharacter = function(t, r, n, o) {
        for(var i = this.getDataCharacterCounters(), a = 0; a < i.length; a++)i[a] = 0;
        if (o) e.recordPatternInReverse(t, r.getStartEnd()[0], i);
        else {
            e.recordPattern(t, r.getStartEnd()[1], i);
            for(var s = 0, u = i.length - 1; s < u; s++, u--){
                var c = i[s];
                i[s] = i[u], i[u] = c;
            }
        }
        var f = $849102574a83a574$var$Pt.sum(new Int32Array(i)) / 17, h = (r.getStartEnd()[1] - r.getStartEnd()[0]) / 15;
        if (Math.abs(f - h) / h > .3) throw new $849102574a83a574$var$tt;
        var l = this.getOddCounts(), d = this.getEvenCounts(), p = this.getOddRoundingErrors(), g = this.getEvenRoundingErrors();
        for(s = 0; s < i.length; s++){
            var y = 1 * i[s] / f, w = y + .5;
            if (w < 1) {
                if (y < .3) throw new $849102574a83a574$var$tt;
                w = 1;
            } else if (w > 8) {
                if (y > 8.7) throw new $849102574a83a574$var$tt;
                w = 8;
            }
            var v = s / 2;
            0 == (1 & s) ? (l[v] = w, p[v] = y - w) : (d[v] = w, g[v] = y - w);
        }
        this.adjustOddEvenCounts(17);
        var _ = 4 * r.getValue() + (n ? 0 : 2) + (o ? 0 : 1) - 1, A = 0, C = 0;
        for(s = l.length - 1; s >= 0; s--){
            if (e.isNotA1left(r, n, o)) {
                var m = e.WEIGHTS[_][2 * s];
                C += l[s] * m;
            }
            A += l[s];
        }
        var E = 0;
        for(s = d.length - 1; s >= 0; s--)if (e.isNotA1left(r, n, o)) {
            m = e.WEIGHTS[_][2 * s + 1];
            E += d[s] * m;
        }
        var I = C + E;
        if (0 != (1 & A) || A > 13 || A < 4) throw new $849102574a83a574$var$tt;
        var S = (13 - A) / 2, T = e.SYMBOL_WIDEST[S], O = 9 - T, b = $849102574a83a574$var$xe.getRSSvalue(l, T, !0), R = $849102574a83a574$var$xe.getRSSvalue(d, O, !1), N = e.EVEN_TOTAL_SUBSET[S], D = e.GSUM[S];
        return new $849102574a83a574$var$Le(b * N + R + D, I);
    }, e.isNotA1left = function(t, e, r) {
        return !(0 === t.getValue() && e && r);
    }, e.prototype.adjustOddEvenCounts = function(t) {
        var r = $849102574a83a574$var$Pt.sum(new Int32Array(this.getOddCounts())), n = $849102574a83a574$var$Pt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1;
        r > 13 ? i = !0 : r < 4 && (o = !0);
        var a = !1, s = !1;
        n > 13 ? s = !0 : n < 4 && (a = !0);
        var u = r + n - t, c = 1 == (1 & r), f = 0 == (1 & n);
        if (1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                i = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                s = !0;
            }
        } else if (-1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                o = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                a = !0;
            }
        } else {
            if (0 !== u) throw new $849102574a83a574$var$tt;
            if (c) {
                if (!f) throw new $849102574a83a574$var$tt;
                r < n ? (o = !0, s = !0) : (i = !0, a = !0);
            } else if (f) throw new $849102574a83a574$var$tt;
        }
        if (o) {
            if (i) throw new $849102574a83a574$var$tt;
            e.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (s) throw new $849102574a83a574$var$tt;
            e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        s && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ], e.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ], e.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ], e.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_C,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_C
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ]
    ], e.MAX_PAIRS = 11, e;
}($849102574a83a574$var$Be), $849102574a83a574$var$Er = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ir = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.count = 0, o.finderPattern = n, o;
    }
    return $849102574a83a574$var$Er(e, t), e.prototype.getFinderPattern = function() {
        return this.finderPattern;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.incrementCount = function() {
        this.count++;
    }, e;
}($849102574a83a574$var$Le), $849102574a83a574$var$Sr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Tr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Or = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.possibleLeftPairs = [], e.possibleRightPairs = [], e;
    }
    return $849102574a83a574$var$Sr(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, s, u = this.decodePair(r, !1, t, n);
        e.addOrTally(this.possibleLeftPairs, u), r.reverse();
        var c = this.decodePair(r, !0, t, n);
        e.addOrTally(this.possibleRightPairs, c), r.reverse();
        try {
            for(var f = $849102574a83a574$var$Tr(this.possibleLeftPairs), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (l.getCount() > 1) try {
                    for(var d = (a = void 0, $849102574a83a574$var$Tr(this.possibleRightPairs)), p = d.next(); !p.done; p = d.next()){
                        var g = p.value;
                        if (g.getCount() > 1 && e.checkChecksum(l, g)) return e.constructResult(l, g);
                    }
                } catch (t) {
                    a = {
                        error: t
                    };
                } finally{
                    try {
                        p && !p.done && (s = d.return) && s.call(d);
                    } finally{
                        if (a) throw a.error;
                    }
                }
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
        throw new $849102574a83a574$var$tt;
    }, e.addOrTally = function(t, e) {
        var r, n;
        if (null != e) {
            var o = !1;
            try {
                for(var i = $849102574a83a574$var$Tr(t), a = i.next(); !a.done; a = i.next()){
                    var s = a.value;
                    if (s.getValue() === e.getValue()) {
                        s.incrementCount(), o = !0;
                        break;
                    }
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    a && !a.done && (n = i.return) && n.call(i);
                } finally{
                    if (r) throw r.error;
                }
            }
            o || t.push(e);
        }
    }, e.prototype.reset = function() {
        this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(t, e) {
        for(var r = 4537077 * t.getValue() + e.getValue(), n = new String(r).toString(), o = new $849102574a83a574$var$Q, i = 13 - n.length; i > 0; i--)o.append("0");
        o.append(n);
        var a = 0;
        for(i = 0; i < 13; i++){
            var s = o.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            a += 0 == (1 & i) ? 3 * s : s;
        }
        10 === (a = 10 - a % 10) && (a = 0), o.append(a.toString());
        var u = t.getFinderPattern().getResultPoints(), c = e.getFinderPattern().getResultPoints();
        return new $849102574a83a574$var$gt(o.toString(), null, 0, [
            u[0],
            u[1],
            c[0],
            c[1]
        ], $849102574a83a574$var$wt.RSS_14, (new Date).getTime());
    }, e.checkChecksum = function(t, e) {
        var r = (t.getChecksumPortion() + 16 * e.getChecksumPortion()) % 79, n = 9 * t.getFinderPattern().getValue() + e.getFinderPattern().getValue();
        return n > 72 && n--, n > 8 && n--, r === n;
    }, e.prototype.decodePair = function(t, e, r, n) {
        try {
            var o = this.findFinderPattern(t, e), i = this.parseFoundFinderPattern(t, r, e, o), a = null == n ? null : n.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
            if (null != a) {
                var s = (o[0] + o[1]) / 2;
                e && (s = t.getSize() - 1 - s), a.foundPossibleResultPoint(new $849102574a83a574$var$Lt(s, r));
            }
            var u = this.decodeDataCharacter(t, i, !0), c = this.decodeDataCharacter(t, i, !1);
            return new $849102574a83a574$var$Ir(1597 * u.getValue() + c.getValue(), u.getChecksumPortion() + 4 * c.getChecksumPortion(), i);
        } catch (t) {
            return null;
        }
    }, e.prototype.decodeDataCharacter = function(t, r, n) {
        for(var o = this.getDataCharacterCounters(), i = 0; i < o.length; i++)o[i] = 0;
        if (n) $849102574a83a574$var$Kt.recordPatternInReverse(t, r.getStartEnd()[0], o);
        else {
            $849102574a83a574$var$Kt.recordPattern(t, r.getStartEnd()[1] + 1, o);
            for(var a = 0, s = o.length - 1; a < s; a++, s--){
                var u = o[a];
                o[a] = o[s], o[s] = u;
            }
        }
        var c = n ? 16 : 15, f = $849102574a83a574$var$Pt.sum(new Int32Array(o)) / c, h = this.getOddCounts(), l = this.getEvenCounts(), d = this.getOddRoundingErrors(), p = this.getEvenRoundingErrors();
        for(a = 0; a < o.length; a++){
            var g = o[a] / f, y = Math.floor(g + .5);
            y < 1 ? y = 1 : y > 8 && (y = 8);
            var w = Math.floor(a / 2);
            0 == (1 & a) ? (h[w] = y, d[w] = g - y) : (l[w] = y, p[w] = g - y);
        }
        this.adjustOddEvenCounts(n, c);
        var v = 0, _ = 0;
        for(a = h.length - 1; a >= 0; a--)_ *= 9, _ += h[a], v += h[a];
        var A = 0, C = 0;
        for(a = l.length - 1; a >= 0; a--)A *= 9, A += l[a], C += l[a];
        var m = _ + 3 * A;
        if (n) {
            if (0 != (1 & v) || v > 12 || v < 4) throw new $849102574a83a574$var$tt;
            var E = (12 - v) / 2, I = 9 - (R = e.OUTSIDE_ODD_WIDEST[E]), S = $849102574a83a574$var$xe.getRSSvalue(h, R, !1), T = $849102574a83a574$var$xe.getRSSvalue(l, I, !0), O = e.OUTSIDE_EVEN_TOTAL_SUBSET[E], b = e.OUTSIDE_GSUM[E];
            return new $849102574a83a574$var$Le(S * O + T + b, m);
        }
        if (0 != (1 & C) || C > 10 || C < 4) throw new $849102574a83a574$var$tt;
        E = (10 - C) / 2, I = 9 - (R = e.INSIDE_ODD_WIDEST[E]), S = $849102574a83a574$var$xe.getRSSvalue(h, R, !0), T = $849102574a83a574$var$xe.getRSSvalue(l, I, !1);
        var R, N = e.INSIDE_ODD_TOTAL_SUBSET[E];
        b = e.INSIDE_GSUM[E];
        return new $849102574a83a574$var$Le(T * N + S + b, m);
    }, e.prototype.findFinderPattern = function(t, e) {
        var r = this.getDecodeFinderCounters();
        r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 0;
        for(var n = t.getSize(), o = !1, i = 0; i < n && e !== (o = !t.get(i));)i++;
        for(var a = 0, s = i, u = i; u < n; u++)if (t.get(u) !== o) r[a]++;
        else {
            if (3 === a) {
                if ($849102574a83a574$var$Be.isFinderPattern(r)) return [
                    s,
                    u
                ];
                s += r[0] + r[1], r[0] = r[2], r[1] = r[3], r[2] = 0, r[3] = 0, a--;
            } else a++;
            r[a] = 1, o = !o;
        }
        throw new $849102574a83a574$var$tt;
    }, e.prototype.parseFoundFinderPattern = function(t, r, n, o) {
        for(var i = t.get(o[0]), a = o[0] - 1; a >= 0 && i !== t.get(a);)a--;
        a++;
        var s = o[0] - a, u = this.getDecodeFinderCounters(), c = new Int32Array(u.length);
        $849102574a83a574$var$D.arraycopy(u, 0, c, 1, u.length - 1), c[0] = s;
        var f = this.parseFinderValue(c, e.FINDER_PATTERNS), h = a, l = o[1];
        return n && (h = t.getSize() - 1 - h, l = t.getSize() - 1 - l), new $849102574a83a574$var$Fe(f, [
            a,
            o[1]
        ], h, l, r);
    }, e.prototype.adjustOddEvenCounts = function(t, e) {
        var r = $849102574a83a574$var$Pt.sum(new Int32Array(this.getOddCounts())), n = $849102574a83a574$var$Pt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1, a = !1, s = !1;
        t ? (r > 12 ? i = !0 : r < 4 && (o = !0), n > 12 ? s = !0 : n < 4 && (a = !0)) : (r > 11 ? i = !0 : r < 5 && (o = !0), n > 10 ? s = !0 : n < 4 && (a = !0));
        var u = r + n - e, c = (1 & r) == (t ? 1 : 0), f = 1 == (1 & n);
        if (1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                i = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                s = !0;
            }
        } else if (-1 === u) {
            if (c) {
                if (f) throw new $849102574a83a574$var$tt;
                o = !0;
            } else {
                if (!f) throw new $849102574a83a574$var$tt;
                a = !0;
            }
        } else {
            if (0 !== u) throw new $849102574a83a574$var$tt;
            if (c) {
                if (!f) throw new $849102574a83a574$var$tt;
                r < n ? (o = !0, s = !0) : (i = !0, a = !0);
            } else if (f) throw new $849102574a83a574$var$tt;
        }
        if (o) {
            if (i) throw new $849102574a83a574$var$tt;
            $849102574a83a574$var$Be.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && $849102574a83a574$var$Be.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (s) throw new $849102574a83a574$var$tt;
            $849102574a83a574$var$Be.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        s && $849102574a83a574$var$Be.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ], e.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ], e.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ], e.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ], e.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ], e.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ], e;
}($849102574a83a574$var$Be), $849102574a83a574$var$br = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Rr = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        r.readers = [];
        var n = e ? e.get($849102574a83a574$var$U.POSSIBLE_FORMATS) : null, o = e && void 0 !== e.get($849102574a83a574$var$U.ASSUME_CODE_39_CHECK_DIGIT);
        return n && ((n.includes($849102574a83a574$var$wt.EAN_13) || n.includes($849102574a83a574$var$wt.UPC_A) || n.includes($849102574a83a574$var$wt.EAN_8) || n.includes($849102574a83a574$var$wt.UPC_E)) && r.readers.push(new $849102574a83a574$var$Re(e)), n.includes($849102574a83a574$var$wt.CODE_39) && r.readers.push(new $849102574a83a574$var$te(o)), n.includes($849102574a83a574$var$wt.CODE_93) && r.readers.push(new $849102574a83a574$var$ne), n.includes($849102574a83a574$var$wt.CODE_128) && r.readers.push(new $849102574a83a574$var$Qt), n.includes($849102574a83a574$var$wt.ITF) && r.readers.push(new $849102574a83a574$var$ae), n.includes($849102574a83a574$var$wt.CODABAR) && r.readers.push(new $849102574a83a574$var$De), n.includes($849102574a83a574$var$wt.RSS_14) && r.readers.push(new $849102574a83a574$var$Or), n.includes($849102574a83a574$var$wt.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), r.readers.push(new $849102574a83a574$var$mr))), 0 === r.readers.length && (r.readers.push(new $849102574a83a574$var$Re(e)), r.readers.push(new $849102574a83a574$var$te), r.readers.push(new $849102574a83a574$var$ne), r.readers.push(new $849102574a83a574$var$Re(e)), r.readers.push(new $849102574a83a574$var$Qt), r.readers.push(new $849102574a83a574$var$ae), r.readers.push(new $849102574a83a574$var$Or)), r;
    }
    return $849102574a83a574$var$br(e, t), e.prototype.decodeRow = function(t, e, r) {
        for(var n = 0; n < this.readers.length; n++)try {
            return this.readers[n].decodeRow(t, e, r);
        } catch (t) {}
        throw new $849102574a83a574$var$tt;
    }, e.prototype.reset = function() {
        this.readers.forEach(function(t) {
            return t.reset();
        });
    }, e;
}($849102574a83a574$var$Kt), $849102574a83a574$var$Nr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$Rr(r), e, r) || this;
    }
    $849102574a83a574$var$Nr(e, t);
}($849102574a83a574$var$pt);
var $849102574a83a574$var$Dr, $849102574a83a574$var$Mr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Pr = function() {
    function t(t, e, r) {
        this.ecCodewords = t, this.ecBlocks = [
            e
        ], r && this.ecBlocks.push(r);
    }
    return t.prototype.getECCodewords = function() {
        return this.ecCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $849102574a83a574$var$Br = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $849102574a83a574$var$Lr = function() {
    function t(t, e, r, n, o, i) {
        var a, s;
        this.versionNumber = t, this.symbolSizeRows = e, this.symbolSizeColumns = r, this.dataRegionSizeRows = n, this.dataRegionSizeColumns = o, this.ecBlocks = i;
        var u = 0, c = i.getECCodewords(), f = i.getECBlocks();
        try {
            for(var h = $849102574a83a574$var$Mr(f), l = h.next(); !l.done; l = h.next()){
                var d = l.value;
                u += d.getCount() * (d.getDataCodewords() + c);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (s = h.return) && s.call(h);
            } finally{
                if (a) throw a.error;
            }
        }
        this.totalCodewords = u;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    }, t.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    }, t.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    }, t.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t.getVersionForDimensions = function(e, r) {
        var n, o;
        if (0 != (1 & e) || 0 != (1 & r)) throw new $849102574a83a574$var$G;
        try {
            for(var i = $849102574a83a574$var$Mr(t.VERSIONS), a = i.next(); !a.done; a = i.next()){
                var s = a.value;
                if (s.symbolSizeRows === e && s.symbolSizeColumns === r) return s;
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $849102574a83a574$var$G;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.buildVersions = function() {
        return [
            new t(1, 10, 10, 8, 8, new $849102574a83a574$var$Pr(5, new $849102574a83a574$var$Br(1, 3))),
            new t(2, 12, 12, 10, 10, new $849102574a83a574$var$Pr(7, new $849102574a83a574$var$Br(1, 5))),
            new t(3, 14, 14, 12, 12, new $849102574a83a574$var$Pr(10, new $849102574a83a574$var$Br(1, 8))),
            new t(4, 16, 16, 14, 14, new $849102574a83a574$var$Pr(12, new $849102574a83a574$var$Br(1, 12))),
            new t(5, 18, 18, 16, 16, new $849102574a83a574$var$Pr(14, new $849102574a83a574$var$Br(1, 18))),
            new t(6, 20, 20, 18, 18, new $849102574a83a574$var$Pr(18, new $849102574a83a574$var$Br(1, 22))),
            new t(7, 22, 22, 20, 20, new $849102574a83a574$var$Pr(20, new $849102574a83a574$var$Br(1, 30))),
            new t(8, 24, 24, 22, 22, new $849102574a83a574$var$Pr(24, new $849102574a83a574$var$Br(1, 36))),
            new t(9, 26, 26, 24, 24, new $849102574a83a574$var$Pr(28, new $849102574a83a574$var$Br(1, 44))),
            new t(10, 32, 32, 14, 14, new $849102574a83a574$var$Pr(36, new $849102574a83a574$var$Br(1, 62))),
            new t(11, 36, 36, 16, 16, new $849102574a83a574$var$Pr(42, new $849102574a83a574$var$Br(1, 86))),
            new t(12, 40, 40, 18, 18, new $849102574a83a574$var$Pr(48, new $849102574a83a574$var$Br(1, 114))),
            new t(13, 44, 44, 20, 20, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(1, 144))),
            new t(14, 48, 48, 22, 22, new $849102574a83a574$var$Pr(68, new $849102574a83a574$var$Br(1, 174))),
            new t(15, 52, 52, 24, 24, new $849102574a83a574$var$Pr(42, new $849102574a83a574$var$Br(2, 102))),
            new t(16, 64, 64, 14, 14, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(2, 140))),
            new t(17, 72, 72, 16, 16, new $849102574a83a574$var$Pr(36, new $849102574a83a574$var$Br(4, 92))),
            new t(18, 80, 80, 18, 18, new $849102574a83a574$var$Pr(48, new $849102574a83a574$var$Br(4, 114))),
            new t(19, 88, 88, 20, 20, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(4, 144))),
            new t(20, 96, 96, 22, 22, new $849102574a83a574$var$Pr(68, new $849102574a83a574$var$Br(4, 174))),
            new t(21, 104, 104, 24, 24, new $849102574a83a574$var$Pr(56, new $849102574a83a574$var$Br(6, 136))),
            new t(22, 120, 120, 18, 18, new $849102574a83a574$var$Pr(68, new $849102574a83a574$var$Br(6, 175))),
            new t(23, 132, 132, 20, 20, new $849102574a83a574$var$Pr(62, new $849102574a83a574$var$Br(8, 163))),
            new t(24, 144, 144, 22, 22, new $849102574a83a574$var$Pr(62, new $849102574a83a574$var$Br(8, 156), new $849102574a83a574$var$Br(2, 155))),
            new t(25, 8, 18, 6, 16, new $849102574a83a574$var$Pr(7, new $849102574a83a574$var$Br(1, 5))),
            new t(26, 8, 32, 6, 14, new $849102574a83a574$var$Pr(11, new $849102574a83a574$var$Br(1, 10))),
            new t(27, 12, 26, 10, 24, new $849102574a83a574$var$Pr(14, new $849102574a83a574$var$Br(1, 16))),
            new t(28, 12, 36, 10, 16, new $849102574a83a574$var$Pr(18, new $849102574a83a574$var$Br(1, 22))),
            new t(29, 16, 36, 14, 16, new $849102574a83a574$var$Pr(24, new $849102574a83a574$var$Br(1, 32))),
            new t(30, 16, 48, 14, 22, new $849102574a83a574$var$Pr(28, new $849102574a83a574$var$Br(1, 49)))
        ];
    }, t.VERSIONS = t.buildVersions(), t;
}(), $849102574a83a574$var$Fr = function() {
    function t(e) {
        var r = e.getHeight();
        if (r < 8 || r > 144 || 0 != (1 & r)) throw new $849102574a83a574$var$G;
        this.version = t.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new $849102574a83a574$var$J(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return t.prototype.getVersion = function() {
        return this.version;
    }, t.readVersion = function(t) {
        var e = t.getHeight(), r = t.getWidth();
        return $849102574a83a574$var$Lr.getVersionForDimensions(e, r);
    }, t.prototype.readCodewords = function() {
        var t = new Int8Array(this.version.getTotalCodewords()), e = 0, r = 4, n = 0, o = this.mappingBitMatrix.getHeight(), i = this.mappingBitMatrix.getWidth(), a = !1, s = !1, u = !1, c = !1;
        do if (r !== o || 0 !== n || a) {
            if (r !== o - 2 || 0 !== n || 0 == (3 & i) || s) {
                if (r !== o + 4 || 2 !== n || 0 != (7 & i) || u) {
                    if (r !== o - 2 || 0 !== n || 4 != (7 & i) || c) {
                        do r < o && n >= 0 && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r -= 2, n += 2;
                        while (r >= 0 && n < i);
                        r += 1, n += 3;
                        do r >= 0 && n < i && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r += 2, n -= 2;
                        while (r < o && n >= 0);
                        r += 3, n += 1;
                    } else t[e++] = 255 & this.readCorner4(o, i), r -= 2, n += 2, c = !0;
                } else t[e++] = 255 & this.readCorner3(o, i), r -= 2, n += 2, u = !0;
            } else t[e++] = 255 & this.readCorner2(o, i), r -= 2, n += 2, s = !0;
        } else t[e++] = 255 & this.readCorner1(o, i), r -= 2, n += 2, a = !0;
        while (r < o || n < i);
        if (e !== this.version.getTotalCodewords()) throw new $849102574a83a574$var$G;
        return t;
    }, t.prototype.readModule = function(t, e, r, n) {
        return t < 0 && (t += r, e += 4 - (r + 4 & 7)), e < 0 && (e += n, t += 4 - (n + 4 & 7)), this.readMappingMatrix.set(e, t), this.mappingBitMatrix.get(e, t);
    }, t.prototype.readUtah = function(t, e, r, n) {
        var o = 0;
        return this.readModule(t - 2, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 2, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t, e, r, n) && (o |= 1), o;
    }, t.prototype.readCorner1 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 1, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner2 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 4, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner3 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner4 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.extractDataRegion = function(t) {
        var e = this.version.getSymbolSizeRows(), r = this.version.getSymbolSizeColumns();
        if (t.getHeight() !== e) throw new $849102574a83a574$var$T("Dimension of bitMatrix must match the version size");
        for(var n = this.version.getDataRegionSizeRows(), o = this.version.getDataRegionSizeColumns(), i = e / n | 0, a = r / o | 0, s = new $849102574a83a574$var$J(a * o, i * n), u = 0; u < i; ++u)for(var c = u * n, f = 0; f < a; ++f)for(var h = f * o, l = 0; l < n; ++l)for(var d = u * (n + 2) + 1 + l, p = c + l, g = 0; g < o; ++g){
            var y = f * (o + 2) + 1 + g;
            if (t.get(y, d)) {
                var w = h + g;
                s.set(w, p);
            }
        }
        return s;
    }, t;
}(), $849102574a83a574$var$kr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$xr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r) {
        var n, o, i, a, s = r.getECBlocks(), u = 0, c = s.getECBlocks();
        try {
            for(var f = $849102574a83a574$var$kr(c), h = f.next(); !h.done; h = f.next())u += (y = h.value).getCount();
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (o = f.return) && o.call(f);
            } finally{
                if (n) throw n.error;
            }
        }
        var l = new Array(u), d = 0;
        try {
            for(var p = $849102574a83a574$var$kr(c), g = p.next(); !g.done; g = p.next())for(var y = g.value, w = 0; w < y.getCount(); w++){
                var v = y.getDataCodewords(), _ = s.getECCodewords() + v;
                l[d++] = new t(v, new Uint8Array(_));
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (a = p.return) && a.call(p);
            } finally{
                if (i) throw i.error;
            }
        }
        var A = l[0].codewords.length - s.getECCodewords(), C = A - 1, m = 0;
        for(w = 0; w < C; w++)for(var E = 0; E < d; E++)l[E].codewords[w] = e[m++];
        var I = 24 === r.getVersionNumber(), S = I ? 8 : d;
        for(E = 0; E < S; E++)l[E].codewords[A - 1] = e[m++];
        var O = l[0].codewords.length;
        for(w = A; w < O; w++)for(E = 0; E < d; E++){
            var b = I ? (E + 8) % d : E, R = I && b > 7 ? w - 1 : w;
            l[b].codewords[R] = e[m++];
        }
        if (m !== e.length) throw new $849102574a83a574$var$T;
        return l;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}(), $849102574a83a574$var$Vr = function() {
    function t(t) {
        this.bytes = t, this.byteOffset = 0, this.bitOffset = 0;
    }
    return t.prototype.getBitOffset = function() {
        return this.bitOffset;
    }, t.prototype.getByteOffset = function() {
        return this.byteOffset;
    }, t.prototype.readBits = function(t) {
        if (t < 1 || t > 32 || t > this.available()) throw new $849102574a83a574$var$T("" + t);
        var e = 0, r = this.bitOffset, n = this.byteOffset, o = this.bytes;
        if (r > 0) {
            var i = 8 - r, a = t < i ? t : i, s = 255 >> 8 - a << (u = i - a);
            e = (o[n] & s) >> u, t -= a, 8 === (r += a) && (r = 0, n++);
        }
        if (t > 0) {
            for(; t >= 8;)e = e << 8 | 255 & o[n], n++, t -= 8;
            if (t > 0) {
                var u;
                s = 255 >> (u = 8 - t) << u;
                e = e << t | (o[n] & s) >> u, r += t;
            }
        }
        return this.bitOffset = r, this.byteOffset = n, e;
    }, t.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, t;
}();
!function(t) {
    t[t.PAD_ENCODE = 0] = "PAD_ENCODE", t[t.ASCII_ENCODE = 1] = "ASCII_ENCODE", t[t.C40_ENCODE = 2] = "C40_ENCODE", t[t.TEXT_ENCODE = 3] = "TEXT_ENCODE", t[t.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", t[t.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", t[t.BASE256_ENCODE = 6] = "BASE256_ENCODE";
}($849102574a83a574$var$Dr || ($849102574a83a574$var$Dr = {}));
var $849102574a83a574$var$Hr, $849102574a83a574$var$Ur = function() {
    function t() {}
    return t.decode = function(t) {
        var e = new $849102574a83a574$var$Vr(t), r = new $849102574a83a574$var$Q, n = new $849102574a83a574$var$Q, o = new Array, i = $849102574a83a574$var$Dr.ASCII_ENCODE;
        do if (i === $849102574a83a574$var$Dr.ASCII_ENCODE) i = this.decodeAsciiSegment(e, r, n);
        else {
            switch(i){
                case $849102574a83a574$var$Dr.C40_ENCODE:
                    this.decodeC40Segment(e, r);
                    break;
                case $849102574a83a574$var$Dr.TEXT_ENCODE:
                    this.decodeTextSegment(e, r);
                    break;
                case $849102574a83a574$var$Dr.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(e, r);
                    break;
                case $849102574a83a574$var$Dr.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(e, r);
                    break;
                case $849102574a83a574$var$Dr.BASE256_ENCODE:
                    this.decodeBase256Segment(e, r, o);
                    break;
                default:
                    throw new $849102574a83a574$var$G;
            }
            i = $849102574a83a574$var$Dr.ASCII_ENCODE;
        }
        while (i !== $849102574a83a574$var$Dr.PAD_ENCODE && e.available() > 0);
        return n.length() > 0 && r.append(n.toString()), new $849102574a83a574$var$At(t, r.toString(), 0 === o.length ? null : o, null);
    }, t.decodeAsciiSegment = function(t, e, r) {
        var n = !1;
        do {
            var o = t.readBits(8);
            if (0 === o) throw new $849102574a83a574$var$G;
            if (o <= 128) return n && (o += 128), e.append(String.fromCharCode(o - 1)), $849102574a83a574$var$Dr.ASCII_ENCODE;
            if (129 === o) return $849102574a83a574$var$Dr.PAD_ENCODE;
            if (o <= 229) {
                var i = o - 130;
                i < 10 && e.append("0"), e.append("" + i);
            } else switch(o){
                case 230:
                    return $849102574a83a574$var$Dr.C40_ENCODE;
                case 231:
                    return $849102574a83a574$var$Dr.BASE256_ENCODE;
                case 232:
                    e.append(String.fromCharCode(29));
                    break;
                case 233:
                case 234:
                case 241:
                    break;
                case 235:
                    n = !0;
                    break;
                case 236:
                    e.append("[)>\x1e05\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 237:
                    e.append("[)>\x1e06\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 238:
                    return $849102574a83a574$var$Dr.ANSIX12_ENCODE;
                case 239:
                    return $849102574a83a574$var$Dr.TEXT_ENCODE;
                case 240:
                    return $849102574a83a574$var$Dr.EDIFACT_ENCODE;
                default:
                    if (254 !== o || 0 !== t.available()) throw new $849102574a83a574$var$G;
            }
        }while (t.available() > 0);
        return $849102574a83a574$var$Dr.ASCII_ENCODE;
    }, t.decodeC40Segment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var s = n[a];
                switch(o){
                    case 0:
                        if (s < 3) o = s + 1;
                        else {
                            if (!(s < this.C40_BASIC_SET_CHARS.length)) throw new $849102574a83a574$var$G;
                            var u = this.C40_BASIC_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(s + 128)), r = !1) : e.append(String.fromCharCode(s)), o = 0;
                        break;
                    case 2:
                        if (s < this.C40_SHIFT2_SET_CHARS.length) {
                            u = this.C40_SHIFT2_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        } else switch(s){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $849102574a83a574$var$G;
                        }
                        o = 0;
                        break;
                    case 3:
                        r ? (e.append(String.fromCharCode(s + 224)), r = !1) : e.append(String.fromCharCode(s + 96)), o = 0;
                        break;
                    default:
                        throw new $849102574a83a574$var$G;
                }
            }
        }while (t.available() > 0);
    }, t.decodeTextSegment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var s = n[a];
                switch(o){
                    case 0:
                        if (s < 3) o = s + 1;
                        else {
                            if (!(s < this.TEXT_BASIC_SET_CHARS.length)) throw new $849102574a83a574$var$G;
                            var u = this.TEXT_BASIC_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(s + 128)), r = !1) : e.append(String.fromCharCode(s)), o = 0;
                        break;
                    case 2:
                        if (s < this.TEXT_SHIFT2_SET_CHARS.length) {
                            u = this.TEXT_SHIFT2_SET_CHARS[s];
                            r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u);
                        } else switch(s){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $849102574a83a574$var$G;
                        }
                        o = 0;
                        break;
                    case 3:
                        if (!(s < this.TEXT_SHIFT3_SET_CHARS.length)) throw new $849102574a83a574$var$G;
                        u = this.TEXT_SHIFT3_SET_CHARS[s];
                        r ? (e.append(String.fromCharCode(u.charCodeAt(0) + 128)), r = !1) : e.append(u), o = 0;
                        break;
                    default:
                        throw new $849102574a83a574$var$G;
                }
            }
        }while (t.available() > 0);
    }, t.decodeAnsiX12Segment = function(t, e) {
        var r = [];
        do {
            if (8 === t.available()) return;
            var n = t.readBits(8);
            if (254 === n) return;
            this.parseTwoBytes(n, t.readBits(8), r);
            for(var o = 0; o < 3; o++){
                var i = r[o];
                switch(i){
                    case 0:
                        e.append("\r");
                        break;
                    case 1:
                        e.append("*");
                        break;
                    case 2:
                        e.append(">");
                        break;
                    case 3:
                        e.append(" ");
                        break;
                    default:
                        if (i < 14) e.append(String.fromCharCode(i + 44));
                        else {
                            if (!(i < 40)) throw new $849102574a83a574$var$G;
                            e.append(String.fromCharCode(i + 51));
                        }
                }
            }
        }while (t.available() > 0);
    }, t.parseTwoBytes = function(t, e, r) {
        var n = (t << 8) + e - 1, o = Math.floor(n / 1600);
        r[0] = o, n -= 1600 * o, o = Math.floor(n / 40), r[1] = o, r[2] = n - 40 * o;
    }, t.decodeEdifactSegment = function(t, e) {
        do {
            if (t.available() <= 16) return;
            for(var r = 0; r < 4; r++){
                var n = t.readBits(6);
                if (31 === n) {
                    var o = 8 - t.getBitOffset();
                    return void (8 !== o && t.readBits(o));
                }
                0 == (32 & n) && (n |= 64), e.append(String.fromCharCode(n));
            }
        }while (t.available() > 0);
    }, t.decodeBase256Segment = function(t, e, r) {
        var n, o = 1 + t.getByteOffset(), i = this.unrandomize255State(t.readBits(8), o++);
        if ((n = 0 === i ? t.available() / 8 | 0 : i < 250 ? i : 250 * (i - 249) + this.unrandomize255State(t.readBits(8), o++)) < 0) throw new $849102574a83a574$var$G;
        for(var a = new Uint8Array(n), s = 0; s < n; s++){
            if (t.available() < 8) throw new $849102574a83a574$var$G;
            a[s] = this.unrandomize255State(t.readBits(8), o++);
        }
        r.push(a);
        try {
            e.append($849102574a83a574$var$K.decode(a, $849102574a83a574$var$q.ISO88591));
        } catch (t) {
            throw new $849102574a83a574$var$Nt("Platform does not support required encoding: " + t.message);
        }
    }, t.unrandomize255State = function(t, e) {
        var r = t - (149 * e % 255 + 1);
        return r >= 0 ? r : r + 256;
    }, t.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ], t.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ], t.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], t.TEXT_SHIFT2_SET_CHARS = t.C40_SHIFT2_SET_CHARS, t.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ], t;
}(), $849102574a83a574$var$Xr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Gr = function() {
    function t() {
        this.rsDecoder = new $849102574a83a574$var$Dt($849102574a83a574$var$Tt.DATA_MATRIX_FIELD_256);
    }
    return t.prototype.decode = function(t) {
        var e, r, n = new $849102574a83a574$var$Fr(t), o = n.getVersion(), i = n.readCodewords(), a = $849102574a83a574$var$xr.getDataBlocks(i, o), s = 0;
        try {
            for(var u = $849102574a83a574$var$Xr(a), c = u.next(); !c.done; c = u.next())s += c.value.getNumDataCodewords();
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = u.return) && r.call(u);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var f = new Uint8Array(s), h = a.length, l = 0; l < h; l++){
            var d = a[l], p = d.getCodewords(), g = d.getNumDataCodewords();
            this.correctErrors(p, g);
            for(var y = 0; y < g; y++)f[y * h + l] = p[y];
        }
        return $849102574a83a574$var$Ur.decode(f);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $849102574a83a574$var$R;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $849102574a83a574$var$Wr = function() {
    function t(t) {
        this.image = t, this.rectangleDetector = new $849102574a83a574$var$Vt(this.image);
    }
    return t.prototype.detect = function() {
        var e = this.rectangleDetector.detect(), r = this.detectSolid1(e);
        if ((r = this.detectSolid2(r))[3] = this.correctTopRight(r), !r[3]) throw new $849102574a83a574$var$tt;
        var n = (r = this.shiftToModuleCenter(r))[0], o = r[1], i = r[2], a = r[3], s = this.transitionsBetween(n, a) + 1, u = this.transitionsBetween(i, a) + 1;
        1 == (1 & s) && (s += 1), 1 == (1 & u) && (u += 1), 4 * s < 7 * u && 4 * u < 7 * s && (s = u = Math.max(s, u));
        var c = t.sampleGrid(this.image, n, o, i, a, s, u);
        return new $849102574a83a574$var$Ft(c, [
            n,
            o,
            i,
            a
        ]);
    }, t.shiftPoint = function(t, e, r) {
        var n = (e.getX() - t.getX()) / (r + 1), o = (e.getY() - t.getY()) / (r + 1);
        return new $849102574a83a574$var$Lt(t.getX() + n, t.getY() + o);
    }, t.moveAway = function(t, e, r) {
        var n = t.getX(), o = t.getY();
        return n < e ? n -= 1 : n += 1, o < r ? o -= 1 : o += 1, new $849102574a83a574$var$Lt(n, o);
    }, t.prototype.detectSolid1 = function(t) {
        var e = t[0], r = t[1], n = t[3], o = t[2], i = this.transitionsBetween(e, r), a = this.transitionsBetween(r, n), s = this.transitionsBetween(n, o), u = this.transitionsBetween(o, e), c = i, f = [
            o,
            e,
            r,
            n
        ];
        return c > a && (c = a, f[0] = e, f[1] = r, f[2] = n, f[3] = o), c > s && (c = s, f[0] = r, f[1] = n, f[2] = o, f[3] = e), c > u && (f[0] = n, f[1] = o, f[2] = e, f[3] = r), f;
    }, t.prototype.detectSolid2 = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), s = t.shiftPoint(n, o, 4 * (a + 1)), u = t.shiftPoint(o, n, 4 * (a + 1));
        return this.transitionsBetween(s, r) < this.transitionsBetween(u, i) ? (e[0] = r, e[1] = n, e[2] = o, e[3] = i) : (e[0] = n, e[1] = o, e[2] = i, e[3] = r), e;
    }, t.prototype.correctTopRight = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), s = this.transitionsBetween(n, i), u = t.shiftPoint(r, n, 4 * (s + 1)), c = t.shiftPoint(o, n, 4 * (a + 1));
        a = this.transitionsBetween(u, i), s = this.transitionsBetween(c, i);
        var f = new $849102574a83a574$var$Lt(i.getX() + (o.getX() - n.getX()) / (a + 1), i.getY() + (o.getY() - n.getY()) / (a + 1)), h = new $849102574a83a574$var$Lt(i.getX() + (r.getX() - n.getX()) / (s + 1), i.getY() + (r.getY() - n.getY()) / (s + 1));
        return this.isValid(f) ? this.isValid(h) ? this.transitionsBetween(u, f) + this.transitionsBetween(c, f) > this.transitionsBetween(u, h) + this.transitionsBetween(c, h) ? f : h : f : this.isValid(h) ? h : null;
    }, t.prototype.shiftToModuleCenter = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i) + 1, s = this.transitionsBetween(o, i) + 1, u = t.shiftPoint(r, n, 4 * s), c = t.shiftPoint(o, n, 4 * a);
        1 == (1 & (a = this.transitionsBetween(u, i) + 1)) && (a += 1), 1 == (1 & (s = this.transitionsBetween(c, i) + 1)) && (s += 1);
        var f, h, l = (r.getX() + n.getX() + o.getX() + i.getX()) / 4, d = (r.getY() + n.getY() + o.getY() + i.getY()) / 4;
        return r = t.moveAway(r, l, d), n = t.moveAway(n, l, d), o = t.moveAway(o, l, d), i = t.moveAway(i, l, d), u = t.shiftPoint(r, n, 4 * s), u = t.shiftPoint(u, i, 4 * a), f = t.shiftPoint(n, r, 4 * s), f = t.shiftPoint(f, o, 4 * a), c = t.shiftPoint(o, i, 4 * s), c = t.shiftPoint(c, n, 4 * a), h = t.shiftPoint(i, o, 4 * s), [
            u,
            f,
            c,
            h = t.shiftPoint(h, r, 4 * a)
        ];
    }, t.prototype.isValid = function(t) {
        return t.getX() >= 0 && t.getX() < this.image.getWidth() && t.getY() > 0 && t.getY() < this.image.getHeight();
    }, t.sampleGrid = function(t, e, r, n, o, i, a) {
        return $849102574a83a574$var$Wt.getInstance().sampleGrid(t, i, a, .5, .5, i - .5, .5, i - .5, a - .5, .5, a - .5, e.getX(), e.getY(), o.getX(), o.getY(), n.getX(), n.getY(), r.getX(), r.getY());
    }, t.prototype.transitionsBetween = function(t, e) {
        var r = Math.trunc(t.getX()), n = Math.trunc(t.getY()), o = Math.trunc(e.getX()), i = Math.trunc(e.getY()), a = Math.abs(i - n) > Math.abs(o - r);
        if (a) {
            var s = r;
            r = n, n = s, s = o, o = i, i = s;
        }
        for(var u = Math.abs(o - r), c = Math.abs(i - n), f = -u / 2, h = n < i ? 1 : -1, l = r < o ? 1 : -1, d = 0, p = this.image.get(a ? n : r, a ? r : n), g = r, y = n; g !== o; g += l){
            var w = this.image.get(a ? y : g, a ? g : y);
            if (w !== p && (d++, p = w), (f += c) > 0) {
                if (y === i) break;
                y += h, f -= u;
            }
        }
        return d;
    }, t;
}(), $849102574a83a574$var$zr = function() {
    function t() {
        this.decoder = new $849102574a83a574$var$Gr;
    }
    return t.prototype.decode = function(e, r) {
        var n, o;
        if (void 0 === r && (r = null), null != r && r.has($849102574a83a574$var$U.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decode(i), o = t.NO_POINTS;
        } else {
            var a = new $849102574a83a574$var$Wr(e.getBlackMatrix()).detect();
            n = this.decoder.decode(a.getBits()), o = a.getPoints();
        }
        var s = n.getRawBytes(), u = new $849102574a83a574$var$gt(n.getText(), s, 8 * s.length, o, $849102574a83a574$var$wt.DATA_MATRIX, $849102574a83a574$var$D.currentTimeMillis()), c = n.getByteSegments();
        null != c && u.putMetadata($849102574a83a574$var$_t.BYTE_SEGMENTS, c);
        var f = n.getECLevel();
        return null != f && u.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, f), u;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null == e || null == r) throw new $849102574a83a574$var$tt;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], s = (r[0] - a + 1) / n, u = (i - o + 1) / n;
        if (s <= 0 || u <= 0) throw new $849102574a83a574$var$tt;
        var c = n / 2;
        o += c, a += c;
        for(var f = new $849102574a83a574$var$J(s, u), h = 0; h < u; h++)for(var l = o + h * n, d = 0; d < s; d++)t.get(a + d * n, l) && f.set(d, h);
        return f;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getWidth(), n = t[0], o = t[1]; n < r && e.get(n, o);)n++;
        if (n === r) throw new $849102574a83a574$var$tt;
        var i = n - t[0];
        if (0 === i) throw new $849102574a83a574$var$tt;
        return i;
    }, t.NO_POINTS = [], t;
}(), $849102574a83a574$var$jr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$zr, e) || this;
    }
    $849102574a83a574$var$jr(e, t);
}($849102574a83a574$var$pt), function(t) {
    t[t.L = 0] = "L", t[t.M = 1] = "M", t[t.Q = 2] = "Q", t[t.H = 3] = "H";
}($849102574a83a574$var$Hr || ($849102574a83a574$var$Hr = {}));
var $849102574a83a574$var$Yr, $849102574a83a574$var$Zr = function() {
    function t(e, r, n) {
        this.value = e, this.stringValue = r, this.bits = n, t.FOR_BITS.set(n, this), t.FOR_VALUE.set(e, this);
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.fromString = function(e) {
        switch(e){
            case "L":
                return t.L;
            case "M":
                return t.M;
            case "Q":
                return t.Q;
            case "H":
                return t.H;
            default:
                throw new $849102574a83a574$var$I(e + "not available");
        }
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.forBits = function(e) {
        if (e < 0 || e >= t.FOR_BITS.size) throw new $849102574a83a574$var$T;
        return t.FOR_BITS.get(e);
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.L = new t($849102574a83a574$var$Hr.L, "L", 1), t.M = new t($849102574a83a574$var$Hr.M, "M", 0), t.Q = new t($849102574a83a574$var$Hr.Q, "Q", 3), t.H = new t($849102574a83a574$var$Hr.H, "H", 2), t;
}(), $849102574a83a574$var$Kr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$qr = function() {
    function t(t) {
        this.errorCorrectionLevel = $849102574a83a574$var$Zr.forBits(t >> 3 & 3), this.dataMask = 7 & t;
    }
    return t.numBitsDiffering = function(t, e) {
        return $849102574a83a574$var$x.bitCount(t ^ e);
    }, t.decodeFormatInformation = function(e, r) {
        var n = t.doDecodeFormatInformation(e, r);
        return null !== n ? n : t.doDecodeFormatInformation(e ^ t.FORMAT_INFO_MASK_QR, r ^ t.FORMAT_INFO_MASK_QR);
    }, t.doDecodeFormatInformation = function(e, r) {
        var n, o, i = Number.MAX_SAFE_INTEGER, a = 0;
        try {
            for(var s = $849102574a83a574$var$Kr(t.FORMAT_INFO_DECODE_LOOKUP), u = s.next(); !u.done; u = s.next()){
                var c = u.value, f = c[0];
                if (f === e || f === r) return new t(c[1]);
                var h = t.numBitsDiffering(e, f);
                h < i && (a = c[1], i = h), e !== r && (h = t.numBitsDiffering(r, f)) < i && (a = c[1], i = h);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (o = s.return) && o.call(s);
            } finally{
                if (n) throw n.error;
            }
        }
        return i <= 3 ? new t(a) : null;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getDataMask = function() {
        return this.dataMask;
    }, t.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.errorCorrectionLevel === r.errorCorrectionLevel && this.dataMask === r.dataMask;
    }, t.FORMAT_INFO_MASK_QR = 21522, t.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            21522,
            0
        ]),
        Int32Array.from([
            20773,
            1
        ]),
        Int32Array.from([
            24188,
            2
        ]),
        Int32Array.from([
            23371,
            3
        ]),
        Int32Array.from([
            17913,
            4
        ]),
        Int32Array.from([
            16590,
            5
        ]),
        Int32Array.from([
            20375,
            6
        ]),
        Int32Array.from([
            19104,
            7
        ]),
        Int32Array.from([
            30660,
            8
        ]),
        Int32Array.from([
            29427,
            9
        ]),
        Int32Array.from([
            32170,
            10
        ]),
        Int32Array.from([
            30877,
            11
        ]),
        Int32Array.from([
            26159,
            12
        ]),
        Int32Array.from([
            25368,
            13
        ]),
        Int32Array.from([
            27713,
            14
        ]),
        Int32Array.from([
            26998,
            15
        ]),
        Int32Array.from([
            5769,
            16
        ]),
        Int32Array.from([
            5054,
            17
        ]),
        Int32Array.from([
            7399,
            18
        ]),
        Int32Array.from([
            6608,
            19
        ]),
        Int32Array.from([
            1890,
            20
        ]),
        Int32Array.from([
            597,
            21
        ]),
        Int32Array.from([
            3340,
            22
        ]),
        Int32Array.from([
            2107,
            23
        ]),
        Int32Array.from([
            13663,
            24
        ]),
        Int32Array.from([
            12392,
            25
        ]),
        Int32Array.from([
            16177,
            26
        ]),
        Int32Array.from([
            14854,
            27
        ]),
        Int32Array.from([
            9396,
            28
        ]),
        Int32Array.from([
            8579,
            29
        ]),
        Int32Array.from([
            11994,
            30
        ]),
        Int32Array.from([
            11245,
            31
        ])
    ], t;
}(), $849102574a83a574$var$Qr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Jr = function() {
    function t(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        this.ecCodewordsPerBlock = t, this.ecBlocks = e;
    }
    return t.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    }, t.prototype.getNumBlocks = function() {
        var t, e, r = 0, n = this.ecBlocks;
        try {
            for(var o = $849102574a83a574$var$Qr(n), i = o.next(); !i.done; i = o.next())r += i.value.getCount();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r;
    }, t.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $849102574a83a574$var$$r = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $849102574a83a574$var$tn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$en = function() {
    function t(t, e) {
        for(var r, n, o = [], i = 2; i < arguments.length; i++)o[i - 2] = arguments[i];
        this.versionNumber = t, this.alignmentPatternCenters = e, this.ecBlocks = o;
        var a = 0, s = o[0].getECCodewordsPerBlock(), u = o[0].getECBlocks();
        try {
            for(var c = $849102574a83a574$var$tn(u), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                a += h.getCount() * (h.getDataCodewords() + s);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (n = c.return) && n.call(c);
            } finally{
                if (r) throw r.error;
            }
        }
        this.totalCodewords = a;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    }, t.prototype.getECBlocksForLevel = function(t) {
        return this.ecBlocks[t.getValue()];
    }, t.getProvisionalVersionForDimension = function(t) {
        if (t % 4 != 1) throw new $849102574a83a574$var$G;
        try {
            return this.getVersionForNumber((t - 17) / 4);
        } catch (t) {
            throw new $849102574a83a574$var$G;
        }
    }, t.getVersionForNumber = function(e) {
        if (e < 1 || e > 40) throw new $849102574a83a574$var$T;
        return t.VERSIONS[e - 1];
    }, t.decodeVersionInformation = function(e) {
        for(var r = Number.MAX_SAFE_INTEGER, n = 0, o = 0; o < t.VERSION_DECODE_INFO.length; o++){
            var i = t.VERSION_DECODE_INFO[o];
            if (i === e) return t.getVersionForNumber(o + 7);
            var a = $849102574a83a574$var$qr.numBitsDiffering(e, i);
            a < r && (n = o + 7, r = a);
        }
        return r <= 3 ? t.getVersionForNumber(n) : null;
    }, t.prototype.buildFunctionPattern = function() {
        var t = this.getDimensionForVersion(), e = new $849102574a83a574$var$J(t);
        e.setRegion(0, 0, 9, 9), e.setRegion(t - 8, 0, 8, 9), e.setRegion(0, t - 8, 9, 8);
        for(var r = this.alignmentPatternCenters.length, n = 0; n < r; n++)for(var o = this.alignmentPatternCenters[n] - 2, i = 0; i < r; i++)0 === n && (0 === i || i === r - 1) || n === r - 1 && 0 === i || e.setRegion(this.alignmentPatternCenters[i] - 2, o, 5, 5);
        return e.setRegion(6, 9, 1, t - 17), e.setRegion(9, 6, t - 17, 1), this.versionNumber > 6 && (e.setRegion(t - 11, 0, 3, 6), e.setRegion(0, t - 11, 6, 3)), e;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.VERSION_DECODE_INFO = Int32Array.from([
        31892,
        34236,
        39577,
        42195,
        48118,
        51042,
        55367,
        58893,
        63784,
        68472,
        70749,
        76311,
        79154,
        84390,
        87683,
        92361,
        96236,
        102084,
        102881,
        110507,
        110734,
        117786,
        119615,
        126325,
        127568,
        133589,
        136944,
        141498,
        145311,
        150283,
        152622,
        158308,
        161089,
        167017
    ]), t.VERSIONS = [
        new t(1, new Int32Array(0), new $849102574a83a574$var$Jr(7, new $849102574a83a574$var$$r(1, 19)), new $849102574a83a574$var$Jr(10, new $849102574a83a574$var$$r(1, 16)), new $849102574a83a574$var$Jr(13, new $849102574a83a574$var$$r(1, 13)), new $849102574a83a574$var$Jr(17, new $849102574a83a574$var$$r(1, 9))),
        new t(2, Int32Array.from([
            6,
            18
        ]), new $849102574a83a574$var$Jr(10, new $849102574a83a574$var$$r(1, 34)), new $849102574a83a574$var$Jr(16, new $849102574a83a574$var$$r(1, 28)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(1, 22)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(1, 16))),
        new t(3, Int32Array.from([
            6,
            22
        ]), new $849102574a83a574$var$Jr(15, new $849102574a83a574$var$$r(1, 55)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(1, 44)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 17)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(2, 13))),
        new t(4, Int32Array.from([
            6,
            26
        ]), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(1, 80)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 32)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(2, 24)), new $849102574a83a574$var$Jr(16, new $849102574a83a574$var$$r(4, 9))),
        new t(5, Int32Array.from([
            6,
            30
        ]), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(1, 108)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(2, 43)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 15), new $849102574a83a574$var$$r(2, 16)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(2, 11), new $849102574a83a574$var$$r(2, 12))),
        new t(6, Int32Array.from([
            6,
            34
        ]), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 68)), new $849102574a83a574$var$Jr(16, new $849102574a83a574$var$$r(4, 27)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(4, 19)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 15))),
        new t(7, Int32Array.from([
            6,
            22,
            38
        ]), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(2, 78)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(4, 31)), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 14), new $849102574a83a574$var$$r(4, 15)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 13), new $849102574a83a574$var$$r(1, 14))),
        new t(8, Int32Array.from([
            6,
            24,
            42
        ]), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(2, 97)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(2, 38), new $849102574a83a574$var$$r(2, 39)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(4, 18), new $849102574a83a574$var$$r(2, 19)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 14), new $849102574a83a574$var$$r(2, 15))),
        new t(9, Int32Array.from([
            6,
            26,
            46
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(2, 116)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(3, 36), new $849102574a83a574$var$$r(2, 37)), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(4, 16), new $849102574a83a574$var$$r(4, 17)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(4, 12), new $849102574a83a574$var$$r(4, 13))),
        new t(10, Int32Array.from([
            6,
            28,
            50
        ]), new $849102574a83a574$var$Jr(18, new $849102574a83a574$var$$r(2, 68), new $849102574a83a574$var$$r(2, 69)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 43), new $849102574a83a574$var$$r(1, 44)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(6, 19), new $849102574a83a574$var$$r(2, 20)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(6, 15), new $849102574a83a574$var$$r(2, 16))),
        new t(11, Int32Array.from([
            6,
            30,
            54
        ]), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(4, 81)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(1, 50), new $849102574a83a574$var$$r(4, 51)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 22), new $849102574a83a574$var$$r(4, 23)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(3, 12), new $849102574a83a574$var$$r(8, 13))),
        new t(12, Int32Array.from([
            6,
            32,
            58
        ]), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(2, 92), new $849102574a83a574$var$$r(2, 93)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(6, 36), new $849102574a83a574$var$$r(2, 37)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 20), new $849102574a83a574$var$$r(6, 21)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(7, 14), new $849102574a83a574$var$$r(4, 15))),
        new t(13, Int32Array.from([
            6,
            34,
            62
        ]), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(4, 107)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(8, 37), new $849102574a83a574$var$$r(1, 38)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(8, 20), new $849102574a83a574$var$$r(4, 21)), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(12, 11), new $849102574a83a574$var$$r(4, 12))),
        new t(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(3, 115), new $849102574a83a574$var$$r(1, 116)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(4, 40), new $849102574a83a574$var$$r(5, 41)), new $849102574a83a574$var$Jr(20, new $849102574a83a574$var$$r(11, 16), new $849102574a83a574$var$$r(5, 17)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(11, 12), new $849102574a83a574$var$$r(5, 13))),
        new t(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new $849102574a83a574$var$Jr(22, new $849102574a83a574$var$$r(5, 87), new $849102574a83a574$var$$r(1, 88)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(5, 41), new $849102574a83a574$var$$r(5, 42)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(5, 24), new $849102574a83a574$var$$r(7, 25)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(11, 12), new $849102574a83a574$var$$r(7, 13))),
        new t(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(5, 98), new $849102574a83a574$var$$r(1, 99)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(7, 45), new $849102574a83a574$var$$r(3, 46)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(15, 19), new $849102574a83a574$var$$r(2, 20)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(3, 15), new $849102574a83a574$var$$r(13, 16))),
        new t(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(1, 107), new $849102574a83a574$var$$r(5, 108)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(10, 46), new $849102574a83a574$var$$r(1, 47)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(1, 22), new $849102574a83a574$var$$r(15, 23)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 14), new $849102574a83a574$var$$r(17, 15))),
        new t(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(5, 120), new $849102574a83a574$var$$r(1, 121)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(9, 43), new $849102574a83a574$var$$r(4, 44)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(17, 22), new $849102574a83a574$var$$r(1, 23)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 14), new $849102574a83a574$var$$r(19, 15))),
        new t(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(3, 113), new $849102574a83a574$var$$r(4, 114)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(3, 44), new $849102574a83a574$var$$r(11, 45)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(17, 21), new $849102574a83a574$var$$r(4, 22)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(9, 13), new $849102574a83a574$var$$r(16, 14))),
        new t(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(3, 107), new $849102574a83a574$var$$r(5, 108)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(3, 41), new $849102574a83a574$var$$r(13, 42)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(15, 24), new $849102574a83a574$var$$r(5, 25)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(15, 15), new $849102574a83a574$var$$r(10, 16))),
        new t(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 116), new $849102574a83a574$var$$r(4, 117)), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(17, 42)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(17, 22), new $849102574a83a574$var$$r(6, 23)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 16), new $849102574a83a574$var$$r(6, 17))),
        new t(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 111), new $849102574a83a574$var$$r(7, 112)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(17, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(7, 24), new $849102574a83a574$var$$r(16, 25)), new $849102574a83a574$var$Jr(24, new $849102574a83a574$var$$r(34, 13))),
        new t(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(4, 121), new $849102574a83a574$var$$r(5, 122)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(4, 47), new $849102574a83a574$var$$r(14, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 24), new $849102574a83a574$var$$r(14, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(16, 15), new $849102574a83a574$var$$r(14, 16))),
        new t(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(6, 117), new $849102574a83a574$var$$r(4, 118)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(6, 45), new $849102574a83a574$var$$r(14, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 24), new $849102574a83a574$var$$r(16, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(30, 16), new $849102574a83a574$var$$r(2, 17))),
        new t(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new $849102574a83a574$var$Jr(26, new $849102574a83a574$var$$r(8, 106), new $849102574a83a574$var$$r(4, 107)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(8, 47), new $849102574a83a574$var$$r(13, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(7, 24), new $849102574a83a574$var$$r(22, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(22, 15), new $849102574a83a574$var$$r(13, 16))),
        new t(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(10, 114), new $849102574a83a574$var$$r(2, 115)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(19, 46), new $849102574a83a574$var$$r(4, 47)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(28, 22), new $849102574a83a574$var$$r(6, 23)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(33, 16), new $849102574a83a574$var$$r(4, 17))),
        new t(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(8, 122), new $849102574a83a574$var$$r(4, 123)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(22, 45), new $849102574a83a574$var$$r(3, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(8, 23), new $849102574a83a574$var$$r(26, 24)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(12, 15), new $849102574a83a574$var$$r(28, 16))),
        new t(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(3, 117), new $849102574a83a574$var$$r(10, 118)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(3, 45), new $849102574a83a574$var$$r(23, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(4, 24), new $849102574a83a574$var$$r(31, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 15), new $849102574a83a574$var$$r(31, 16))),
        new t(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(7, 116), new $849102574a83a574$var$$r(7, 117)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(21, 45), new $849102574a83a574$var$$r(7, 46)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(1, 23), new $849102574a83a574$var$$r(37, 24)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 15), new $849102574a83a574$var$$r(26, 16))),
        new t(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(5, 115), new $849102574a83a574$var$$r(10, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(19, 47), new $849102574a83a574$var$$r(10, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(15, 24), new $849102574a83a574$var$$r(25, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(23, 15), new $849102574a83a574$var$$r(25, 16))),
        new t(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(13, 115), new $849102574a83a574$var$$r(3, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(2, 46), new $849102574a83a574$var$$r(29, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(42, 24), new $849102574a83a574$var$$r(1, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(23, 15), new $849102574a83a574$var$$r(28, 16))),
        new t(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(17, 115)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(10, 46), new $849102574a83a574$var$$r(23, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(10, 24), new $849102574a83a574$var$$r(35, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 15), new $849102574a83a574$var$$r(35, 16))),
        new t(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(17, 115), new $849102574a83a574$var$$r(1, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(14, 46), new $849102574a83a574$var$$r(21, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(29, 24), new $849102574a83a574$var$$r(19, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(11, 15), new $849102574a83a574$var$$r(46, 16))),
        new t(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(13, 115), new $849102574a83a574$var$$r(6, 116)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(14, 46), new $849102574a83a574$var$$r(23, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(44, 24), new $849102574a83a574$var$$r(7, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(59, 16), new $849102574a83a574$var$$r(1, 17))),
        new t(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(12, 121), new $849102574a83a574$var$$r(7, 122)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(12, 47), new $849102574a83a574$var$$r(26, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(39, 24), new $849102574a83a574$var$$r(14, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(22, 15), new $849102574a83a574$var$$r(41, 16))),
        new t(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(6, 121), new $849102574a83a574$var$$r(14, 122)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(6, 47), new $849102574a83a574$var$$r(34, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(46, 24), new $849102574a83a574$var$$r(10, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(2, 15), new $849102574a83a574$var$$r(64, 16))),
        new t(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(17, 122), new $849102574a83a574$var$$r(4, 123)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(29, 46), new $849102574a83a574$var$$r(14, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(49, 24), new $849102574a83a574$var$$r(10, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(24, 15), new $849102574a83a574$var$$r(46, 16))),
        new t(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(4, 122), new $849102574a83a574$var$$r(18, 123)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(13, 46), new $849102574a83a574$var$$r(32, 47)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(48, 24), new $849102574a83a574$var$$r(14, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(42, 15), new $849102574a83a574$var$$r(32, 16))),
        new t(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(20, 117), new $849102574a83a574$var$$r(4, 118)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(40, 47), new $849102574a83a574$var$$r(7, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(43, 24), new $849102574a83a574$var$$r(22, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(10, 15), new $849102574a83a574$var$$r(67, 16))),
        new t(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(19, 118), new $849102574a83a574$var$$r(6, 119)), new $849102574a83a574$var$Jr(28, new $849102574a83a574$var$$r(18, 47), new $849102574a83a574$var$$r(31, 48)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(34, 24), new $849102574a83a574$var$$r(34, 25)), new $849102574a83a574$var$Jr(30, new $849102574a83a574$var$$r(20, 15), new $849102574a83a574$var$$r(61, 16)))
    ], t;
}();
!function(t) {
    t[t.DATA_MASK_000 = 0] = "DATA_MASK_000", t[t.DATA_MASK_001 = 1] = "DATA_MASK_001", t[t.DATA_MASK_010 = 2] = "DATA_MASK_010", t[t.DATA_MASK_011 = 3] = "DATA_MASK_011", t[t.DATA_MASK_100 = 4] = "DATA_MASK_100", t[t.DATA_MASK_101 = 5] = "DATA_MASK_101", t[t.DATA_MASK_110 = 6] = "DATA_MASK_110", t[t.DATA_MASK_111 = 7] = "DATA_MASK_111";
}($849102574a83a574$var$Yr || ($849102574a83a574$var$Yr = {}));
var $849102574a83a574$var$rn, $849102574a83a574$var$nn = function() {
    function t(t, e) {
        this.value = t, this.isMasked = e;
    }
    return t.prototype.unmaskBitMatrix = function(t, e) {
        for(var r = 0; r < e; r++)for(var n = 0; n < e; n++)this.isMasked(r, n) && t.flip(n, r);
    }, t.values = new Map([
        [
            $849102574a83a574$var$Yr.DATA_MASK_000,
            new t($849102574a83a574$var$Yr.DATA_MASK_000, function(t, e) {
                return 0 == (t + e & 1);
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_001,
            new t($849102574a83a574$var$Yr.DATA_MASK_001, function(t, e) {
                return 0 == (1 & t);
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_010,
            new t($849102574a83a574$var$Yr.DATA_MASK_010, function(t, e) {
                return e % 3 == 0;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_011,
            new t($849102574a83a574$var$Yr.DATA_MASK_011, function(t, e) {
                return (t + e) % 3 == 0;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_100,
            new t($849102574a83a574$var$Yr.DATA_MASK_100, function(t, e) {
                return 0 == (Math.floor(t / 2) + Math.floor(e / 3) & 1);
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_101,
            new t($849102574a83a574$var$Yr.DATA_MASK_101, function(t, e) {
                return t * e % 6 == 0;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_110,
            new t($849102574a83a574$var$Yr.DATA_MASK_110, function(t, e) {
                return t * e % 6 < 3;
            })
        ],
        [
            $849102574a83a574$var$Yr.DATA_MASK_111,
            new t($849102574a83a574$var$Yr.DATA_MASK_111, function(t, e) {
                return 0 == (t + e + t * e % 3 & 1);
            })
        ]
    ]), t;
}(), $849102574a83a574$var$on = function() {
    function t(t) {
        var e = t.getHeight();
        if (e < 21 || 1 != (3 & e)) throw new $849102574a83a574$var$G;
        this.bitMatrix = t;
    }
    return t.prototype.readFormatInformation = function() {
        if (null !== this.parsedFormatInfo && void 0 !== this.parsedFormatInfo) return this.parsedFormatInfo;
        for(var t = 0, e = 0; e < 6; e++)t = this.copyBit(e, 8, t);
        t = this.copyBit(7, 8, t), t = this.copyBit(8, 8, t), t = this.copyBit(8, 7, t);
        for(var r = 5; r >= 0; r--)t = this.copyBit(8, r, t);
        var n = this.bitMatrix.getHeight(), o = 0, i = n - 7;
        for(r = n - 1; r >= i; r--)o = this.copyBit(8, r, o);
        for(e = n - 8; e < n; e++)o = this.copyBit(e, 8, o);
        if (this.parsedFormatInfo = $849102574a83a574$var$qr.decodeFormatInformation(t, o), null !== this.parsedFormatInfo) return this.parsedFormatInfo;
        throw new $849102574a83a574$var$G;
    }, t.prototype.readVersion = function() {
        if (null !== this.parsedVersion && void 0 !== this.parsedVersion) return this.parsedVersion;
        var t = this.bitMatrix.getHeight(), e = Math.floor((t - 17) / 4);
        if (e <= 6) return $849102574a83a574$var$en.getVersionForNumber(e);
        for(var r = 0, n = t - 11, o = 5; o >= 0; o--)for(var i = t - 9; i >= n; i--)r = this.copyBit(i, o, r);
        var a = $849102574a83a574$var$en.decodeVersionInformation(r);
        if (null !== a && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        r = 0;
        for(i = 5; i >= 0; i--)for(o = t - 9; o >= n; o--)r = this.copyBit(i, o, r);
        if (null !== (a = $849102574a83a574$var$en.decodeVersionInformation(r)) && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        throw new $849102574a83a574$var$G;
    }, t.prototype.copyBit = function(t, e, r) {
        return (this.isMirror ? this.bitMatrix.get(e, t) : this.bitMatrix.get(t, e)) ? r << 1 | 1 : r << 1;
    }, t.prototype.readCodewords = function() {
        var t = this.readFormatInformation(), e = this.readVersion(), r = $849102574a83a574$var$nn.values.get(t.getDataMask()), n = this.bitMatrix.getHeight();
        r.unmaskBitMatrix(this.bitMatrix, n);
        for(var o = e.buildFunctionPattern(), i = !0, a = new Uint8Array(e.getTotalCodewords()), s = 0, u = 0, c = 0, f = n - 1; f > 0; f -= 2){
            6 === f && f--;
            for(var h = 0; h < n; h++)for(var l = i ? n - 1 - h : h, d = 0; d < 2; d++)o.get(f - d, l) || (c++, u <<= 1, this.bitMatrix.get(f - d, l) && (u |= 1), 8 === c && (a[s++] = u, c = 0, u = 0));
            i = !i;
        }
        if (s !== e.getTotalCodewords()) throw new $849102574a83a574$var$G;
        return a;
    }, t.prototype.remask = function() {
        if (null !== this.parsedFormatInfo) {
            var t = $849102574a83a574$var$nn.values[this.parsedFormatInfo.getDataMask()], e = this.bitMatrix.getHeight();
            t.unmaskBitMatrix(this.bitMatrix, e);
        }
    }, t.prototype.setMirror = function(t) {
        this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = t;
    }, t.prototype.mirror = function() {
        for(var t = this.bitMatrix, e = 0, r = t.getWidth(); e < r; e++)for(var n = e + 1, o = t.getHeight(); n < o; n++)t.get(e, n) !== t.get(n, e) && (t.flip(n, e), t.flip(e, n));
    }, t;
}(), $849102574a83a574$var$an = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$sn = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r, n) {
        var o, i, a, s;
        if (e.length !== r.getTotalCodewords()) throw new $849102574a83a574$var$T;
        var u = r.getECBlocksForLevel(n), c = 0, f = u.getECBlocks();
        try {
            for(var h = $849102574a83a574$var$an(f), l = h.next(); !l.done; l = h.next())c += (w = l.value).getCount();
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (i = h.return) && i.call(h);
            } finally{
                if (o) throw o.error;
            }
        }
        var d = new Array(c), p = 0;
        try {
            for(var g = $849102574a83a574$var$an(f), y = g.next(); !y.done; y = g.next())for(var w = y.value, v = 0; v < w.getCount(); v++){
                var _ = w.getDataCodewords(), A = u.getECCodewordsPerBlock() + _;
                d[p++] = new t(_, new Uint8Array(A));
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (s = g.return) && s.call(g);
            } finally{
                if (a) throw a.error;
            }
        }
        for(var C = d[0].codewords.length, m = d.length - 1; m >= 0;){
            if (d[m].codewords.length === C) break;
            m--;
        }
        m++;
        var E = C - u.getECCodewordsPerBlock(), I = 0;
        for(v = 0; v < E; v++)for(var S = 0; S < p; S++)d[S].codewords[v] = e[I++];
        for(S = m; S < p; S++)d[S].codewords[E] = e[I++];
        var O = d[0].codewords.length;
        for(v = E; v < O; v++)for(S = 0; S < p; S++){
            var b = S < m ? v : v + 1;
            d[S].codewords[b] = e[I++];
        }
        return d;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}();
!function(t) {
    t[t.TERMINATOR = 0] = "TERMINATOR", t[t.NUMERIC = 1] = "NUMERIC", t[t.ALPHANUMERIC = 2] = "ALPHANUMERIC", t[t.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", t[t.BYTE = 4] = "BYTE", t[t.ECI = 5] = "ECI", t[t.KANJI = 6] = "KANJI", t[t.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", t[t.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", t[t.HANZI = 9] = "HANZI";
}($849102574a83a574$var$rn || ($849102574a83a574$var$rn = {}));
var $849102574a83a574$var$un, $849102574a83a574$var$cn, $849102574a83a574$var$fn = function() {
    function t(e, r, n, o) {
        this.value = e, this.stringValue = r, this.characterCountBitsForVersions = n, this.bits = o, t.FOR_BITS.set(o, this), t.FOR_VALUE.set(e, this);
    }
    return t.forBits = function(e) {
        var r = t.FOR_BITS.get(e);
        if (void 0 === r) throw new $849102574a83a574$var$T;
        return r;
    }, t.prototype.getCharacterCountBits = function(t) {
        var e, r = t.getVersionNumber();
        return e = r <= 9 ? 0 : r <= 26 ? 1 : 2, this.characterCountBitsForVersions[e];
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.TERMINATOR = new t($849102574a83a574$var$rn.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0), t.NUMERIC = new t($849102574a83a574$var$rn.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 1), t.ALPHANUMERIC = new t($849102574a83a574$var$rn.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 2), t.STRUCTURED_APPEND = new t($849102574a83a574$var$rn.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 3), t.BYTE = new t($849102574a83a574$var$rn.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 4), t.ECI = new t($849102574a83a574$var$rn.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 7), t.KANJI = new t($849102574a83a574$var$rn.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 8), t.FNC1_FIRST_POSITION = new t($849102574a83a574$var$rn.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 5), t.FNC1_SECOND_POSITION = new t($849102574a83a574$var$rn.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 9), t.HANZI = new t($849102574a83a574$var$rn.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 13), t;
}(), $849102574a83a574$var$hn = function() {
    function t() {}
    return t.decode = function(e, r, n, o) {
        var i = new $849102574a83a574$var$Vr(e), a = new $849102574a83a574$var$Q, s = new Array, u = -1, c = -1;
        try {
            var f = null, h = !1, l = void 0;
            do {
                if (i.available() < 4) l = $849102574a83a574$var$fn.TERMINATOR;
                else {
                    var d = i.readBits(4);
                    l = $849102574a83a574$var$fn.forBits(d);
                }
                switch(l){
                    case $849102574a83a574$var$fn.TERMINATOR:
                        break;
                    case $849102574a83a574$var$fn.FNC1_FIRST_POSITION:
                    case $849102574a83a574$var$fn.FNC1_SECOND_POSITION:
                        h = !0;
                        break;
                    case $849102574a83a574$var$fn.STRUCTURED_APPEND:
                        if (i.available() < 16) throw new $849102574a83a574$var$G;
                        u = i.readBits(8), c = i.readBits(8);
                        break;
                    case $849102574a83a574$var$fn.ECI:
                        var p = t.parseECIValue(i);
                        if (null === (f = $849102574a83a574$var$j.getCharacterSetECIByValue(p))) throw new $849102574a83a574$var$G;
                        break;
                    case $849102574a83a574$var$fn.HANZI:
                        var g = i.readBits(4), y = i.readBits(l.getCharacterCountBits(r));
                        g === t.GB2312_SUBSET && t.decodeHanziSegment(i, a, y);
                        break;
                    default:
                        var w = i.readBits(l.getCharacterCountBits(r));
                        switch(l){
                            case $849102574a83a574$var$fn.NUMERIC:
                                t.decodeNumericSegment(i, a, w);
                                break;
                            case $849102574a83a574$var$fn.ALPHANUMERIC:
                                t.decodeAlphanumericSegment(i, a, w, h);
                                break;
                            case $849102574a83a574$var$fn.BYTE:
                                t.decodeByteSegment(i, a, w, f, s, o);
                                break;
                            case $849102574a83a574$var$fn.KANJI:
                                t.decodeKanjiSegment(i, a, w);
                                break;
                            default:
                                throw new $849102574a83a574$var$G;
                        }
                }
            }while (l !== $849102574a83a574$var$fn.TERMINATOR);
        } catch (t) {
            throw new $849102574a83a574$var$G;
        }
        return new $849102574a83a574$var$At(e, a.toString(), 0 === s.length ? null : s, null === n ? null : n.toString(), u, c);
    }, t.decodeHanziSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $849102574a83a574$var$G;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 96 << 8 & 4294967295 | i % 96;
            a += a < 959 ? 41377 : 42657, n[o] = a >> 8 & 255, n[o + 1] = 255 & a, o += 2, r--;
        }
        try {
            e.append($849102574a83a574$var$K.decode(n, $849102574a83a574$var$q.GB2312));
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
    }, t.decodeKanjiSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $849102574a83a574$var$G;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 192 << 8 & 4294967295 | i % 192;
            a += a < 7936 ? 33088 : 49472, n[o] = a >> 8, n[o + 1] = a, o += 2, r--;
        }
        try {
            e.append($849102574a83a574$var$K.decode(n, $849102574a83a574$var$q.SHIFT_JIS));
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
    }, t.decodeByteSegment = function(t, e, r, n, o, i) {
        if (8 * r > t.available()) throw new $849102574a83a574$var$G;
        for(var a, s = new Uint8Array(r), u = 0; u < r; u++)s[u] = t.readBits(8);
        a = null === n ? $849102574a83a574$var$q.guessEncoding(s, i) : n.getName();
        try {
            e.append($849102574a83a574$var$K.decode(s, a));
        } catch (t) {
            throw new $849102574a83a574$var$G(t);
        }
        o.push(s);
    }, t.toAlphaNumericChar = function(e) {
        if (e >= t.ALPHANUMERIC_CHARS.length) throw new $849102574a83a574$var$G;
        return t.ALPHANUMERIC_CHARS[e];
    }, t.decodeAlphanumericSegment = function(e, r, n, o) {
        for(var i = r.length(); n > 1;){
            if (e.available() < 11) throw new $849102574a83a574$var$G;
            var a = e.readBits(11);
            r.append(t.toAlphaNumericChar(Math.floor(a / 45))), r.append(t.toAlphaNumericChar(a % 45)), n -= 2;
        }
        if (1 === n) {
            if (e.available() < 6) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(e.readBits(6)));
        }
        if (o) for(var s = i; s < r.length(); s++)"%" === r.charAt(s) && (s < r.length() - 1 && "%" === r.charAt(s + 1) ? r.deleteCharAt(s + 1) : r.setCharAt(s, String.fromCharCode(29)));
    }, t.decodeNumericSegment = function(e, r, n) {
        for(; n >= 3;){
            if (e.available() < 10) throw new $849102574a83a574$var$G;
            var o = e.readBits(10);
            if (o >= 1e3) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(Math.floor(o / 100))), r.append(t.toAlphaNumericChar(Math.floor(o / 10) % 10)), r.append(t.toAlphaNumericChar(o % 10)), n -= 3;
        }
        if (2 === n) {
            if (e.available() < 7) throw new $849102574a83a574$var$G;
            var i = e.readBits(7);
            if (i >= 100) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(Math.floor(i / 10))), r.append(t.toAlphaNumericChar(i % 10));
        } else if (1 === n) {
            if (e.available() < 4) throw new $849102574a83a574$var$G;
            var a = e.readBits(4);
            if (a >= 10) throw new $849102574a83a574$var$G;
            r.append(t.toAlphaNumericChar(a));
        }
    }, t.parseECIValue = function(t) {
        var e = t.readBits(8);
        if (0 == (128 & e)) return 127 & e;
        if (128 == (192 & e)) return (63 & e) << 8 & 4294967295 | t.readBits(8);
        if (192 == (224 & e)) return (31 & e) << 16 & 4294967295 | t.readBits(16);
        throw new $849102574a83a574$var$G;
    }, t.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", t.GB2312_SUBSET = 1, t;
}(), $849102574a83a574$var$ln = function() {
    function t(t) {
        this.mirrored = t;
    }
    return t.prototype.isMirrored = function() {
        return this.mirrored;
    }, t.prototype.applyMirroredCorrection = function(t) {
        if (this.mirrored && null !== t && !(t.length < 3)) {
            var e = t[0];
            t[0] = t[2], t[2] = e;
        }
    }, t;
}(), $849102574a83a574$var$dn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$pn = function() {
    function t() {
        this.rsDecoder = new $849102574a83a574$var$Dt($849102574a83a574$var$Tt.QR_CODE_FIELD_256);
    }
    return t.prototype.decodeBooleanArray = function(t, e) {
        return this.decodeBitMatrix($849102574a83a574$var$J.parseFromBooleanArray(t), e);
    }, t.prototype.decodeBitMatrix = function(t, e) {
        var r = new $849102574a83a574$var$on(t), n = null;
        try {
            return this.decodeBitMatrixParser(r, e);
        } catch (t) {
            n = t;
        }
        try {
            r.remask(), r.setMirror(!0), r.readVersion(), r.readFormatInformation(), r.mirror();
            var o = this.decodeBitMatrixParser(r, e);
            return o.setOther(new $849102574a83a574$var$ln(!0)), o;
        } catch (t) {
            if (null !== n) throw n;
            throw t;
        }
    }, t.prototype.decodeBitMatrixParser = function(t, e) {
        var r, n, o, i, a = t.readVersion(), s = t.readFormatInformation().getErrorCorrectionLevel(), u = t.readCodewords(), c = $849102574a83a574$var$sn.getDataBlocks(u, a, s), f = 0;
        try {
            for(var h = $849102574a83a574$var$dn(c), l = h.next(); !l.done; l = h.next())f += (w = l.value).getNumDataCodewords();
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        var d = new Uint8Array(f), p = 0;
        try {
            for(var g = $849102574a83a574$var$dn(c), y = g.next(); !y.done; y = g.next()){
                var w, v = (w = y.value).getCodewords(), _ = w.getNumDataCodewords();
                this.correctErrors(v, _);
                for(var A = 0; A < _; A++)d[p++] = v[A];
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (i = g.return) && i.call(g);
            } finally{
                if (o) throw o.error;
            }
        }
        return $849102574a83a574$var$hn.decode(d, a, s, e);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $849102574a83a574$var$R;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $849102574a83a574$var$gn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$yn = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.estimatedModuleSize = n, o;
    }
    return $849102574a83a574$var$gn(e, t), e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        return new e((this.getX() + r) / 2, (this.getY() + t) / 2, (this.estimatedModuleSize + n) / 2);
    }, e;
}($849102574a83a574$var$Lt), $849102574a83a574$var$wn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$vn = function() {
    function t(t, e, r, n, o, i, a) {
        this.image = t, this.startX = e, this.startY = r, this.width = n, this.height = o, this.moduleSize = i, this.resultPointCallback = a, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return t.prototype.find = function() {
        for(var t = this.startX, e = this.height, r = t + this.width, n = this.startY + e / 2, o = new Int32Array(3), i = this.image, a = 0; a < e; a++){
            var s = n + (0 == (1 & a) ? Math.floor((a + 1) / 2) : -Math.floor((a + 1) / 2));
            o[0] = 0, o[1] = 0, o[2] = 0;
            for(var u = t; u < r && !i.get(u, s);)u++;
            for(var c = 0; u < r;){
                if (i.get(u, s)) {
                    if (1 === c) o[1]++;
                    else if (2 === c) {
                        var f;
                        if (this.foundPatternCross(o)) {
                            if (null !== (f = this.handlePossibleCenter(o, s, u))) return f;
                        }
                        o[0] = o[2], o[1] = 1, o[2] = 0, c = 1;
                    } else o[++c]++;
                } else 1 === c && c++, o[c]++;
                u++;
            }
            if (this.foundPatternCross(o)) {
                if (null !== (f = this.handlePossibleCenter(o, s, r))) return f;
            }
        }
        if (0 !== this.possibleCenters.length) return this.possibleCenters[0];
        throw new $849102574a83a574$var$tt;
    }, t.centerFromEnd = function(t, e) {
        return e - t[2] - t[1] / 2;
    }, t.prototype.foundPatternCross = function(t) {
        for(var e = this.moduleSize, r = e / 2, n = 0; n < 3; n++)if (Math.abs(e - t[n]) >= r) return !1;
        return !0;
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        var i = this.image, a = i.getHeight(), s = this.crossCheckStateCount;
        s[0] = 0, s[1] = 0, s[2] = 0;
        for(var u = e; u >= 0 && i.get(r, u) && s[1] <= n;)s[1]++, u--;
        if (u < 0 || s[1] > n) return NaN;
        for(; u >= 0 && !i.get(r, u) && s[0] <= n;)s[0]++, u--;
        if (s[0] > n) return NaN;
        for(u = e + 1; u < a && i.get(r, u) && s[1] <= n;)s[1]++, u++;
        if (u === a || s[1] > n) return NaN;
        for(; u < a && !i.get(r, u) && s[2] <= n;)s[2]++, u++;
        if (s[2] > n) return NaN;
        var c = s[0] + s[1] + s[2];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : this.foundPatternCross(s) ? t.centerFromEnd(s, u) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n) {
        var o, i, a = e[0] + e[1] + e[2], s = t.centerFromEnd(e, n), u = this.crossCheckVertical(r, s, 2 * e[1], a);
        if (!isNaN(u)) {
            var c = (e[0] + e[1] + e[2]) / 3;
            try {
                for(var f = $849102574a83a574$var$wn(this.possibleCenters), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (l.aboutEquals(c, u, s)) return l.combineEstimate(u, s, c);
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
            var d = new $849102574a83a574$var$yn(s, u, c);
            this.possibleCenters.push(d), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(d);
        }
        return null;
    }, t;
}(), $849102574a83a574$var$_n = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$An = function(t) {
    function e(e, r, n, o) {
        var i = t.call(this, e, r) || this;
        return i.estimatedModuleSize = n, i.count = o, void 0 === o && (i.count = 1), i;
    }
    return $849102574a83a574$var$_n(e, t), e.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        var o = this.count + 1;
        return new e((this.count * this.getX() + r) / o, (this.count * this.getY() + t) / o, (this.count * this.estimatedModuleSize + n) / o, o);
    }, e;
}($849102574a83a574$var$Lt), $849102574a83a574$var$Cn = function() {
    function t(t) {
        this.bottomLeft = t[0], this.topLeft = t[1], this.topRight = t[2];
    }
    return t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t;
}(), $849102574a83a574$var$mn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$En = function() {
    function t(t, e) {
        this.image = t, this.resultPointCallback = e, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = e;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    }, t.prototype.find = function(e) {
        var r = null != e && void 0 !== e.get($849102574a83a574$var$U.TRY_HARDER), n = null != e && void 0 !== e.get($849102574a83a574$var$U.PURE_BARCODE), o = this.image, i = o.getHeight(), a = o.getWidth(), s = Math.floor(3 * i / (4 * t.MAX_MODULES));
        (s < t.MIN_SKIP || r) && (s = t.MIN_SKIP);
        for(var u = !1, c = new Int32Array(5), f = s - 1; f < i && !u; f += s){
            c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
            for(var h = 0, l = 0; l < a; l++)if (o.get(l, f)) 1 == (1 & h) && h++, c[h]++;
            else if (0 == (1 & h)) {
                if (4 === h) {
                    if (t.foundPatternCross(c)) {
                        if (!0 !== this.handlePossibleCenter(c, f, l, n)) {
                            c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                            continue;
                        }
                        if (s = 2, !0 === this.hasSkipped) u = this.haveMultiplyConfirmedCenters();
                        else {
                            var d = this.findRowSkip();
                            d > c[2] && (f += d - c[2] - s, l = a - 1);
                        }
                        h = 0, c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
                    } else c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                } else c[++h]++;
            } else c[h]++;
            if (t.foundPatternCross(c)) !0 === this.handlePossibleCenter(c, f, a, n) && (s = c[0], this.hasSkipped && (u = this.haveMultiplyConfirmedCenters()));
        }
        var p = this.selectBestPatterns();
        return $849102574a83a574$var$Lt.orderBestPatterns(p), new $849102574a83a574$var$Cn(p);
    }, t.centerFromEnd = function(t, e) {
        return e - t[4] - t[3] - t[2] / 2;
    }, t.foundPatternCross = function(t) {
        for(var e = 0, r = 0; r < 5; r++){
            var n = t[r];
            if (0 === n) return !1;
            e += n;
        }
        if (e < 7) return !1;
        var o = e / 7, i = o / 2;
        return Math.abs(o - t[0]) < i && Math.abs(o - t[1]) < i && Math.abs(3 * o - t[2]) < 3 * i && Math.abs(o - t[3]) < i && Math.abs(o - t[4]) < i;
    }, t.prototype.getCrossCheckStateCount = function() {
        var t = this.crossCheckStateCount;
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t;
    }, t.prototype.crossCheckDiagonal = function(e, r, n, o) {
        for(var i = this.getCrossCheckStateCount(), a = 0, s = this.image; e >= a && r >= a && s.get(r - a, e - a);)i[2]++, a++;
        if (e < a || r < a) return !1;
        for(; e >= a && r >= a && !s.get(r - a, e - a) && i[1] <= n;)i[1]++, a++;
        if (e < a || r < a || i[1] > n) return !1;
        for(; e >= a && r >= a && s.get(r - a, e - a) && i[0] <= n;)i[0]++, a++;
        if (i[0] > n) return !1;
        var u = s.getHeight(), c = s.getWidth();
        for(a = 1; e + a < u && r + a < c && s.get(r + a, e + a);)i[2]++, a++;
        if (e + a >= u || r + a >= c) return !1;
        for(; e + a < u && r + a < c && !s.get(r + a, e + a) && i[3] < n;)i[3]++, a++;
        if (e + a >= u || r + a >= c || i[3] >= n) return !1;
        for(; e + a < u && r + a < c && s.get(r + a, e + a) && i[4] < n;)i[4]++, a++;
        if (i[4] >= n) return !1;
        var f = i[0] + i[1] + i[2] + i[3] + i[4];
        return Math.abs(f - o) < 2 * o && t.foundPatternCross(i);
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        for(var i = this.image, a = i.getHeight(), s = this.getCrossCheckStateCount(), u = e; u >= 0 && i.get(r, u);)s[2]++, u--;
        if (u < 0) return NaN;
        for(; u >= 0 && !i.get(r, u) && s[1] <= n;)s[1]++, u--;
        if (u < 0 || s[1] > n) return NaN;
        for(; u >= 0 && i.get(r, u) && s[0] <= n;)s[0]++, u--;
        if (s[0] > n) return NaN;
        for(u = e + 1; u < a && i.get(r, u);)s[2]++, u++;
        if (u === a) return NaN;
        for(; u < a && !i.get(r, u) && s[3] < n;)s[3]++, u++;
        if (u === a || s[3] >= n) return NaN;
        for(; u < a && i.get(r, u) && s[4] < n;)s[4]++, u++;
        if (s[4] >= n) return NaN;
        var c = s[0] + s[1] + s[2] + s[3] + s[4];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : t.foundPatternCross(s) ? t.centerFromEnd(s, u) : NaN;
    }, t.prototype.crossCheckHorizontal = function(e, r, n, o) {
        for(var i = this.image, a = i.getWidth(), s = this.getCrossCheckStateCount(), u = e; u >= 0 && i.get(u, r);)s[2]++, u--;
        if (u < 0) return NaN;
        for(; u >= 0 && !i.get(u, r) && s[1] <= n;)s[1]++, u--;
        if (u < 0 || s[1] > n) return NaN;
        for(; u >= 0 && i.get(u, r) && s[0] <= n;)s[0]++, u--;
        if (s[0] > n) return NaN;
        for(u = e + 1; u < a && i.get(u, r);)s[2]++, u++;
        if (u === a) return NaN;
        for(; u < a && !i.get(u, r) && s[3] < n;)s[3]++, u++;
        if (u === a || s[3] >= n) return NaN;
        for(; u < a && i.get(u, r) && s[4] < n;)s[4]++, u++;
        if (s[4] >= n) return NaN;
        var c = s[0] + s[1] + s[2] + s[3] + s[4];
        return 5 * Math.abs(c - o) >= o ? NaN : t.foundPatternCross(s) ? t.centerFromEnd(s, u) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n, o) {
        var i = e[0] + e[1] + e[2] + e[3] + e[4], a = t.centerFromEnd(e, n), s = this.crossCheckVertical(r, Math.floor(a), e[2], i);
        if (!isNaN(s) && (a = this.crossCheckHorizontal(Math.floor(a), Math.floor(s), e[2], i), !isNaN(a) && (!o || this.crossCheckDiagonal(Math.floor(s), Math.floor(a), e[2], i)))) {
            for(var u = i / 7, c = !1, f = this.possibleCenters, h = 0, l = f.length; h < l; h++){
                var d = f[h];
                if (d.aboutEquals(u, s, a)) {
                    f[h] = d.combineEstimate(s, a, u), c = !0;
                    break;
                }
            }
            if (!c) {
                var p = new $849102574a83a574$var$An(a, s, u);
                f.push(p), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(p);
            }
            return !0;
        }
        return !1;
    }, t.prototype.findRowSkip = function() {
        var e, r;
        if (this.possibleCenters.length <= 1) return 0;
        var n = null;
        try {
            for(var o = $849102574a83a574$var$mn(this.possibleCenters), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (a.getCount() >= t.CENTER_QUORUM) {
                    if (null != n) return this.hasSkipped = !0, Math.floor((Math.abs(n.getX() - a.getX()) - Math.abs(n.getY() - a.getY())) / 2);
                    n = a;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return 0;
    }, t.prototype.haveMultiplyConfirmedCenters = function() {
        var e, r, n, o, i = 0, a = 0, s = this.possibleCenters.length;
        try {
            for(var u = $849102574a83a574$var$mn(this.possibleCenters), c = u.next(); !c.done; c = u.next())(p = c.value).getCount() >= t.CENTER_QUORUM && (i++, a += p.getEstimatedModuleSize());
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = u.return) && r.call(u);
            } finally{
                if (e) throw e.error;
            }
        }
        if (i < 3) return !1;
        var f = a / s, h = 0;
        try {
            for(var l = $849102574a83a574$var$mn(this.possibleCenters), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h += Math.abs(p.getEstimatedModuleSize() - f);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (o = l.return) && o.call(l);
            } finally{
                if (n) throw n.error;
            }
        }
        return h <= .05 * a;
    }, t.prototype.selectBestPatterns = function() {
        var t, e, r, n, o = this.possibleCenters.length;
        if (o < 3) throw new $849102574a83a574$var$tt;
        var i, a = this.possibleCenters;
        if (o > 3) {
            var s = 0, u = 0;
            try {
                for(var c = $849102574a83a574$var$mn(this.possibleCenters), f = c.next(); !f.done; f = c.next()){
                    var h = f.value.getEstimatedModuleSize();
                    s += h, u += h * h;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    f && !f.done && (e = c.return) && e.call(c);
                } finally{
                    if (t) throw t.error;
                }
            }
            i = s / o;
            var l = Math.sqrt(u / o - i * i);
            a.sort(function(t, e) {
                var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                return r < n ? -1 : r > n ? 1 : 0;
            });
            for(var d = Math.max(.2 * i, l), p = 0; p < a.length && a.length > 3; p++){
                var g = a[p];
                Math.abs(g.getEstimatedModuleSize() - i) > d && (a.splice(p, 1), p--);
            }
        }
        if (a.length > 3) {
            s = 0;
            try {
                for(var y = $849102574a83a574$var$mn(a), w = y.next(); !w.done; w = y.next())s += w.value.getEstimatedModuleSize();
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (n = y.return) && n.call(y);
                } finally{
                    if (r) throw r.error;
                }
            }
            i = s / a.length, a.sort(function(t, e) {
                if (e.getCount() === t.getCount()) {
                    var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                    return r < n ? 1 : r > n ? -1 : 0;
                }
                return e.getCount() - t.getCount();
            }), a.splice(3);
        }
        return [
            a[0],
            a[1],
            a[2]
        ];
    }, t.CENTER_QUORUM = 2, t.MIN_SKIP = 3, t.MAX_MODULES = 57, t;
}(), $849102574a83a574$var$In = function() {
    function t(t) {
        this.image = t;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    }, t.prototype.detect = function(t) {
        this.resultPointCallback = null == t ? null : t.get($849102574a83a574$var$U.NEED_RESULT_POINT_CALLBACK);
        var e = new $849102574a83a574$var$En(this.image, this.resultPointCallback).find(t);
        return this.processFinderPatternInfo(e);
    }, t.prototype.processFinderPatternInfo = function(e) {
        var r = e.getTopLeft(), n = e.getTopRight(), o = e.getBottomLeft(), i = this.calculateModuleSize(r, n, o);
        if (i < 1) throw new $849102574a83a574$var$tt("No pattern found in proccess finder.");
        var a = t.computeDimension(r, n, o, i), s = $849102574a83a574$var$en.getProvisionalVersionForDimension(a), u = s.getDimensionForVersion() - 7, c = null;
        if (s.getAlignmentPatternCenters().length > 0) for(var f = n.getX() - r.getX() + o.getX(), h = n.getY() - r.getY() + o.getY(), l = 1 - 3 / u, d = Math.floor(r.getX() + l * (f - r.getX())), p = Math.floor(r.getY() + l * (h - r.getY())), g = 4; g <= 16; g <<= 1)try {
            c = this.findAlignmentInRegion(i, d, p, g);
            break;
        } catch (t) {
            if (!(t instanceof $849102574a83a574$var$tt)) throw t;
        }
        var y = t.createTransform(r, n, o, c, a), w = t.sampleGrid(this.image, y, a);
        return new $849102574a83a574$var$Ft(w, null === c ? [
            o,
            r,
            n
        ] : [
            o,
            r,
            n,
            c
        ]);
    }, t.createTransform = function(t, e, r, n, o) {
        var i, a, s, u, c = o - 3.5;
        return null !== n ? (i = n.getX(), a = n.getY(), u = s = c - 3) : (i = e.getX() - t.getX() + r.getX(), a = e.getY() - t.getY() + r.getY(), s = c, u = c), $849102574a83a574$var$Ut.quadrilateralToQuadrilateral(3.5, 3.5, c, 3.5, s, u, 3.5, c, t.getX(), t.getY(), e.getX(), e.getY(), i, a, r.getX(), r.getY());
    }, t.sampleGrid = function(t, e, r) {
        return $849102574a83a574$var$Wt.getInstance().sampleGridWithTransform(t, r, r, e);
    }, t.computeDimension = function(t, e, r, n) {
        var o = $849102574a83a574$var$Pt.round($849102574a83a574$var$Lt.distance(t, e) / n), i = $849102574a83a574$var$Pt.round($849102574a83a574$var$Lt.distance(t, r) / n), a = Math.floor((o + i) / 2) + 7;
        switch(3 & a){
            case 0:
                a++;
                break;
            case 2:
                a--;
                break;
            case 3:
                throw new $849102574a83a574$var$tt("Dimensions could be not found.");
        }
        return a;
    }, t.prototype.calculateModuleSize = function(t, e, r) {
        return (this.calculateModuleSizeOneWay(t, e) + this.calculateModuleSizeOneWay(t, r)) / 2;
    }, t.prototype.calculateModuleSizeOneWay = function(t, e) {
        var r = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.getX()), Math.floor(t.getY()), Math.floor(e.getX()), Math.floor(e.getY())), n = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.getX()), Math.floor(e.getY()), Math.floor(t.getX()), Math.floor(t.getY()));
        return isNaN(r) ? n / 7 : isNaN(n) ? r / 7 : (r + n) / 14;
    }, t.prototype.sizeOfBlackWhiteBlackRunBothWays = function(t, e, r, n) {
        var o = this.sizeOfBlackWhiteBlackRun(t, e, r, n), i = 1, a = t - (r - t);
        a < 0 ? (i = t / (t - a), a = 0) : a >= this.image.getWidth() && (i = (this.image.getWidth() - 1 - t) / (a - t), a = this.image.getWidth() - 1);
        var s = Math.floor(e - (n - e) * i);
        return i = 1, s < 0 ? (i = e / (e - s), s = 0) : s >= this.image.getHeight() && (i = (this.image.getHeight() - 1 - e) / (s - e), s = this.image.getHeight() - 1), a = Math.floor(t + (a - t) * i), (o += this.sizeOfBlackWhiteBlackRun(t, e, a, s)) - 1;
    }, t.prototype.sizeOfBlackWhiteBlackRun = function(t, e, r, n) {
        var o = Math.abs(n - e) > Math.abs(r - t);
        if (o) {
            var i = t;
            t = e, e = i, i = r, r = n, n = i;
        }
        for(var a = Math.abs(r - t), s = Math.abs(n - e), u = -a / 2, c = t < r ? 1 : -1, f = e < n ? 1 : -1, h = 0, l = r + c, d = t, p = e; d !== l; d += c){
            var g = o ? p : d, y = o ? d : p;
            if (1 === h === this.image.get(g, y)) {
                if (2 === h) return $849102574a83a574$var$Pt.distance(d, p, t, e);
                h++;
            }
            if ((u += s) > 0) {
                if (p === n) break;
                p += f, u -= a;
            }
        }
        return 2 === h ? $849102574a83a574$var$Pt.distance(r + c, n, t, e) : NaN;
    }, t.prototype.findAlignmentInRegion = function(t, e, r, n) {
        var o = Math.floor(n * t), i = Math.max(0, e - o), a = Math.min(this.image.getWidth() - 1, e + o);
        if (a - i < 3 * t) throw new $849102574a83a574$var$tt("Alignment top exceeds estimated module size.");
        var s = Math.max(0, r - o), u = Math.min(this.image.getHeight() - 1, r + o);
        if (u - s < 3 * t) throw new $849102574a83a574$var$tt("Alignment bottom exceeds estimated module size.");
        return new $849102574a83a574$var$vn(this.image, i, s, a - i, u - s, t, this.resultPointCallback).find();
    }, t;
}(), $849102574a83a574$var$Sn = function() {
    function t() {
        this.decoder = new $849102574a83a574$var$pn;
    }
    return t.prototype.getDecoder = function() {
        return this.decoder;
    }, t.prototype.decode = function(e, r) {
        var n, o;
        if (null != r && void 0 !== r.get($849102574a83a574$var$U.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decodeBitMatrix(i, r), o = t.NO_POINTS;
        } else {
            var a = new $849102574a83a574$var$In(e.getBlackMatrix()).detect(r);
            n = this.decoder.decodeBitMatrix(a.getBits(), r), o = a.getPoints();
        }
        n.getOther() instanceof $849102574a83a574$var$ln && n.getOther().applyMirroredCorrection(o);
        var s = new $849102574a83a574$var$gt(n.getText(), n.getRawBytes(), void 0, o, $849102574a83a574$var$wt.QR_CODE, void 0), u = n.getByteSegments();
        null !== u && s.putMetadata($849102574a83a574$var$_t.BYTE_SEGMENTS, u);
        var c = n.getECLevel();
        return null !== c && s.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, c), n.hasStructuredAppend() && (s.putMetadata($849102574a83a574$var$_t.STRUCTURED_APPEND_SEQUENCE, n.getStructuredAppendSequenceNumber()), s.putMetadata($849102574a83a574$var$_t.STRUCTURED_APPEND_PARITY, n.getStructuredAppendParity())), s;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null === e || null === r) throw new $849102574a83a574$var$tt;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], s = r[0];
        if (a >= s || o >= i) throw new $849102574a83a574$var$tt;
        if (i - o != s - a && (s = a + (i - o)) >= t.getWidth()) throw new $849102574a83a574$var$tt;
        var u = Math.round((s - a + 1) / n), c = Math.round((i - o + 1) / n);
        if (u <= 0 || c <= 0) throw new $849102574a83a574$var$tt;
        if (c !== u) throw new $849102574a83a574$var$tt;
        var f = Math.floor(n / 2);
        o += f;
        var h = (a += f) + Math.floor((u - 1) * n) - s;
        if (h > 0) {
            if (h > f) throw new $849102574a83a574$var$tt;
            a -= h;
        }
        var l = o + Math.floor((c - 1) * n) - i;
        if (l > 0) {
            if (l > f) throw new $849102574a83a574$var$tt;
            o -= l;
        }
        for(var d = new $849102574a83a574$var$J(u, c), p = 0; p < c; p++)for(var g = o + Math.floor(p * n), y = 0; y < u; y++)t.get(a + Math.floor(y * n), g) && d.set(y, p);
        return d;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getHeight(), n = e.getWidth(), o = t[0], i = t[1], a = !0, s = 0; o < n && i < r;){
            if (a !== e.get(o, i)) {
                if (5 == ++s) break;
                a = !a;
            }
            o++, i++;
        }
        if (o === n || i === r) throw new $849102574a83a574$var$tt;
        return (o - t[0]) / 7;
    }, t.NO_POINTS = new Array, t;
}(), $849102574a83a574$var$Tn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$On = function() {
    function t() {}
    return t.prototype.PDF417Common = function() {}, t.getBitCountSum = function(t) {
        return $849102574a83a574$var$Pt.sum(t);
    }, t.toIntArray = function(e) {
        var r, n;
        if (null == e || !e.length) return t.EMPTY_INT_ARRAY;
        var o = new Int32Array(e.length), i = 0;
        try {
            for(var a = $849102574a83a574$var$Tn(e), s = a.next(); !s.done; s = a.next()){
                var u = s.value;
                o[i++] = u;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (n = a.return) && n.call(a);
            } finally{
                if (r) throw r.error;
            }
        }
        return o;
    }, t.getCodeword = function(e) {
        var r = $849102574a83a574$var$k.binarySearch(t.SYMBOL_TABLE, 262143 & e);
        return r < 0 ? -1 : (t.CODEWORD_TABLE[r] - 1) % t.NUMBER_OF_CODEWORDS;
    }, t.NUMBER_OF_CODEWORDS = 929, t.MAX_CODEWORDS_IN_BARCODE = t.NUMBER_OF_CODEWORDS - 1, t.MIN_ROWS_IN_BARCODE = 3, t.MAX_ROWS_IN_BARCODE = 90, t.MODULES_IN_CODEWORD = 17, t.MODULES_IN_STOP_PATTERN = 18, t.BARS_IN_MODULE = 8, t.EMPTY_INT_ARRAY = new Int32Array([]), t.SYMBOL_TABLE = Int32Array.from([
        66142,
        66170,
        66206,
        66236,
        66290,
        66292,
        66350,
        66382,
        66396,
        66454,
        66470,
        66476,
        66594,
        66600,
        66614,
        66626,
        66628,
        66632,
        66640,
        66654,
        66662,
        66668,
        66682,
        66690,
        66718,
        66720,
        66748,
        66758,
        66776,
        66798,
        66802,
        66804,
        66820,
        66824,
        66832,
        66846,
        66848,
        66876,
        66880,
        66936,
        66950,
        66956,
        66968,
        66992,
        67006,
        67022,
        67036,
        67042,
        67044,
        67048,
        67062,
        67118,
        67150,
        67164,
        67214,
        67228,
        67256,
        67294,
        67322,
        67350,
        67366,
        67372,
        67398,
        67404,
        67416,
        67438,
        67474,
        67476,
        67490,
        67492,
        67496,
        67510,
        67618,
        67624,
        67650,
        67656,
        67664,
        67678,
        67686,
        67692,
        67706,
        67714,
        67716,
        67728,
        67742,
        67744,
        67772,
        67782,
        67788,
        67800,
        67822,
        67826,
        67828,
        67842,
        67848,
        67870,
        67872,
        67900,
        67904,
        67960,
        67974,
        67992,
        68016,
        68030,
        68046,
        68060,
        68066,
        68068,
        68072,
        68086,
        68104,
        68112,
        68126,
        68128,
        68156,
        68160,
        68216,
        68336,
        68358,
        68364,
        68376,
        68400,
        68414,
        68448,
        68476,
        68494,
        68508,
        68536,
        68546,
        68548,
        68552,
        68560,
        68574,
        68582,
        68588,
        68654,
        68686,
        68700,
        68706,
        68708,
        68712,
        68726,
        68750,
        68764,
        68792,
        68802,
        68804,
        68808,
        68816,
        68830,
        68838,
        68844,
        68858,
        68878,
        68892,
        68920,
        68976,
        68990,
        68994,
        68996,
        69e3,
        69008,
        69022,
        69024,
        69052,
        69062,
        69068,
        69080,
        69102,
        69106,
        69108,
        69142,
        69158,
        69164,
        69190,
        69208,
        69230,
        69254,
        69260,
        69272,
        69296,
        69310,
        69326,
        69340,
        69386,
        69394,
        69396,
        69410,
        69416,
        69430,
        69442,
        69444,
        69448,
        69456,
        69470,
        69478,
        69484,
        69554,
        69556,
        69666,
        69672,
        69698,
        69704,
        69712,
        69726,
        69754,
        69762,
        69764,
        69776,
        69790,
        69792,
        69820,
        69830,
        69836,
        69848,
        69870,
        69874,
        69876,
        69890,
        69918,
        69920,
        69948,
        69952,
        70008,
        70022,
        70040,
        70064,
        70078,
        70094,
        70108,
        70114,
        70116,
        70120,
        70134,
        70152,
        70174,
        70176,
        70264,
        70384,
        70412,
        70448,
        70462,
        70496,
        70524,
        70542,
        70556,
        70584,
        70594,
        70600,
        70608,
        70622,
        70630,
        70636,
        70664,
        70672,
        70686,
        70688,
        70716,
        70720,
        70776,
        70896,
        71136,
        71180,
        71192,
        71216,
        71230,
        71264,
        71292,
        71360,
        71416,
        71452,
        71480,
        71536,
        71550,
        71554,
        71556,
        71560,
        71568,
        71582,
        71584,
        71612,
        71622,
        71628,
        71640,
        71662,
        71726,
        71732,
        71758,
        71772,
        71778,
        71780,
        71784,
        71798,
        71822,
        71836,
        71864,
        71874,
        71880,
        71888,
        71902,
        71910,
        71916,
        71930,
        71950,
        71964,
        71992,
        72048,
        72062,
        72066,
        72068,
        72080,
        72094,
        72096,
        72124,
        72134,
        72140,
        72152,
        72174,
        72178,
        72180,
        72206,
        72220,
        72248,
        72304,
        72318,
        72416,
        72444,
        72456,
        72464,
        72478,
        72480,
        72508,
        72512,
        72568,
        72588,
        72600,
        72624,
        72638,
        72654,
        72668,
        72674,
        72676,
        72680,
        72694,
        72726,
        72742,
        72748,
        72774,
        72780,
        72792,
        72814,
        72838,
        72856,
        72880,
        72894,
        72910,
        72924,
        72930,
        72932,
        72936,
        72950,
        72966,
        72972,
        72984,
        73008,
        73022,
        73056,
        73084,
        73102,
        73116,
        73144,
        73156,
        73160,
        73168,
        73182,
        73190,
        73196,
        73210,
        73226,
        73234,
        73236,
        73250,
        73252,
        73256,
        73270,
        73282,
        73284,
        73296,
        73310,
        73318,
        73324,
        73346,
        73348,
        73352,
        73360,
        73374,
        73376,
        73404,
        73414,
        73420,
        73432,
        73454,
        73498,
        73518,
        73522,
        73524,
        73550,
        73564,
        73570,
        73572,
        73576,
        73590,
        73800,
        73822,
        73858,
        73860,
        73872,
        73886,
        73888,
        73916,
        73944,
        73970,
        73972,
        73992,
        74014,
        74016,
        74044,
        74048,
        74104,
        74118,
        74136,
        74160,
        74174,
        74210,
        74212,
        74216,
        74230,
        74244,
        74256,
        74270,
        74272,
        74360,
        74480,
        74502,
        74508,
        74544,
        74558,
        74592,
        74620,
        74638,
        74652,
        74680,
        74690,
        74696,
        74704,
        74726,
        74732,
        74782,
        74784,
        74812,
        74992,
        75232,
        75288,
        75326,
        75360,
        75388,
        75456,
        75512,
        75576,
        75632,
        75646,
        75650,
        75652,
        75664,
        75678,
        75680,
        75708,
        75718,
        75724,
        75736,
        75758,
        75808,
        75836,
        75840,
        75896,
        76016,
        76256,
        76736,
        76824,
        76848,
        76862,
        76896,
        76924,
        76992,
        77048,
        77296,
        77340,
        77368,
        77424,
        77438,
        77536,
        77564,
        77572,
        77576,
        77584,
        77600,
        77628,
        77632,
        77688,
        77702,
        77708,
        77720,
        77744,
        77758,
        77774,
        77788,
        77870,
        77902,
        77916,
        77922,
        77928,
        77966,
        77980,
        78008,
        78018,
        78024,
        78032,
        78046,
        78060,
        78074,
        78094,
        78136,
        78192,
        78206,
        78210,
        78212,
        78224,
        78238,
        78240,
        78268,
        78278,
        78284,
        78296,
        78322,
        78324,
        78350,
        78364,
        78448,
        78462,
        78560,
        78588,
        78600,
        78622,
        78624,
        78652,
        78656,
        78712,
        78726,
        78744,
        78768,
        78782,
        78798,
        78812,
        78818,
        78820,
        78824,
        78838,
        78862,
        78876,
        78904,
        78960,
        78974,
        79072,
        79100,
        79296,
        79352,
        79368,
        79376,
        79390,
        79392,
        79420,
        79424,
        79480,
        79600,
        79628,
        79640,
        79664,
        79678,
        79712,
        79740,
        79772,
        79800,
        79810,
        79812,
        79816,
        79824,
        79838,
        79846,
        79852,
        79894,
        79910,
        79916,
        79942,
        79948,
        79960,
        79982,
        79988,
        80006,
        80024,
        80048,
        80062,
        80078,
        80092,
        80098,
        80100,
        80104,
        80134,
        80140,
        80176,
        80190,
        80224,
        80252,
        80270,
        80284,
        80312,
        80328,
        80336,
        80350,
        80358,
        80364,
        80378,
        80390,
        80396,
        80408,
        80432,
        80446,
        80480,
        80508,
        80576,
        80632,
        80654,
        80668,
        80696,
        80752,
        80766,
        80776,
        80784,
        80798,
        80800,
        80828,
        80844,
        80856,
        80878,
        80882,
        80884,
        80914,
        80916,
        80930,
        80932,
        80936,
        80950,
        80962,
        80968,
        80976,
        80990,
        80998,
        81004,
        81026,
        81028,
        81040,
        81054,
        81056,
        81084,
        81094,
        81100,
        81112,
        81134,
        81154,
        81156,
        81160,
        81168,
        81182,
        81184,
        81212,
        81216,
        81272,
        81286,
        81292,
        81304,
        81328,
        81342,
        81358,
        81372,
        81380,
        81384,
        81398,
        81434,
        81454,
        81458,
        81460,
        81486,
        81500,
        81506,
        81508,
        81512,
        81526,
        81550,
        81564,
        81592,
        81602,
        81604,
        81608,
        81616,
        81630,
        81638,
        81644,
        81702,
        81708,
        81722,
        81734,
        81740,
        81752,
        81774,
        81778,
        81780,
        82050,
        82078,
        82080,
        82108,
        82180,
        82184,
        82192,
        82206,
        82208,
        82236,
        82240,
        82296,
        82316,
        82328,
        82352,
        82366,
        82402,
        82404,
        82408,
        82440,
        82448,
        82462,
        82464,
        82492,
        82496,
        82552,
        82672,
        82694,
        82700,
        82712,
        82736,
        82750,
        82784,
        82812,
        82830,
        82882,
        82884,
        82888,
        82896,
        82918,
        82924,
        82952,
        82960,
        82974,
        82976,
        83004,
        83008,
        83064,
        83184,
        83424,
        83468,
        83480,
        83504,
        83518,
        83552,
        83580,
        83648,
        83704,
        83740,
        83768,
        83824,
        83838,
        83842,
        83844,
        83848,
        83856,
        83872,
        83900,
        83910,
        83916,
        83928,
        83950,
        83984,
        84e3,
        84028,
        84032,
        84088,
        84208,
        84448,
        84928,
        85040,
        85054,
        85088,
        85116,
        85184,
        85240,
        85488,
        85560,
        85616,
        85630,
        85728,
        85756,
        85764,
        85768,
        85776,
        85790,
        85792,
        85820,
        85824,
        85880,
        85894,
        85900,
        85912,
        85936,
        85966,
        85980,
        86048,
        86080,
        86136,
        86256,
        86496,
        86976,
        88160,
        88188,
        88256,
        88312,
        88560,
        89056,
        89200,
        89214,
        89312,
        89340,
        89536,
        89592,
        89608,
        89616,
        89632,
        89664,
        89720,
        89840,
        89868,
        89880,
        89904,
        89952,
        89980,
        89998,
        90012,
        90040,
        90190,
        90204,
        90254,
        90268,
        90296,
        90306,
        90308,
        90312,
        90334,
        90382,
        90396,
        90424,
        90480,
        90494,
        90500,
        90504,
        90512,
        90526,
        90528,
        90556,
        90566,
        90572,
        90584,
        90610,
        90612,
        90638,
        90652,
        90680,
        90736,
        90750,
        90848,
        90876,
        90884,
        90888,
        90896,
        90910,
        90912,
        90940,
        90944,
        91e3,
        91014,
        91020,
        91032,
        91056,
        91070,
        91086,
        91100,
        91106,
        91108,
        91112,
        91126,
        91150,
        91164,
        91192,
        91248,
        91262,
        91360,
        91388,
        91584,
        91640,
        91664,
        91678,
        91680,
        91708,
        91712,
        91768,
        91888,
        91928,
        91952,
        91966,
        92e3,
        92028,
        92046,
        92060,
        92088,
        92098,
        92100,
        92104,
        92112,
        92126,
        92134,
        92140,
        92188,
        92216,
        92272,
        92384,
        92412,
        92608,
        92664,
        93168,
        93200,
        93214,
        93216,
        93244,
        93248,
        93304,
        93424,
        93664,
        93720,
        93744,
        93758,
        93792,
        93820,
        93888,
        93944,
        93980,
        94008,
        94064,
        94078,
        94084,
        94088,
        94096,
        94110,
        94112,
        94140,
        94150,
        94156,
        94168,
        94246,
        94252,
        94278,
        94284,
        94296,
        94318,
        94342,
        94348,
        94360,
        94384,
        94398,
        94414,
        94428,
        94440,
        94470,
        94476,
        94488,
        94512,
        94526,
        94560,
        94588,
        94606,
        94620,
        94648,
        94658,
        94660,
        94664,
        94672,
        94686,
        94694,
        94700,
        94714,
        94726,
        94732,
        94744,
        94768,
        94782,
        94816,
        94844,
        94912,
        94968,
        94990,
        95004,
        95032,
        95088,
        95102,
        95112,
        95120,
        95134,
        95136,
        95164,
        95180,
        95192,
        95214,
        95218,
        95220,
        95244,
        95256,
        95280,
        95294,
        95328,
        95356,
        95424,
        95480,
        95728,
        95758,
        95772,
        95800,
        95856,
        95870,
        95968,
        95996,
        96008,
        96016,
        96030,
        96032,
        96060,
        96064,
        96120,
        96152,
        96176,
        96190,
        96220,
        96226,
        96228,
        96232,
        96290,
        96292,
        96296,
        96310,
        96322,
        96324,
        96328,
        96336,
        96350,
        96358,
        96364,
        96386,
        96388,
        96392,
        96400,
        96414,
        96416,
        96444,
        96454,
        96460,
        96472,
        96494,
        96498,
        96500,
        96514,
        96516,
        96520,
        96528,
        96542,
        96544,
        96572,
        96576,
        96632,
        96646,
        96652,
        96664,
        96688,
        96702,
        96718,
        96732,
        96738,
        96740,
        96744,
        96758,
        96772,
        96776,
        96784,
        96798,
        96800,
        96828,
        96832,
        96888,
        97008,
        97030,
        97036,
        97048,
        97072,
        97086,
        97120,
        97148,
        97166,
        97180,
        97208,
        97220,
        97224,
        97232,
        97246,
        97254,
        97260,
        97326,
        97330,
        97332,
        97358,
        97372,
        97378,
        97380,
        97384,
        97398,
        97422,
        97436,
        97464,
        97474,
        97476,
        97480,
        97488,
        97502,
        97510,
        97516,
        97550,
        97564,
        97592,
        97648,
        97666,
        97668,
        97672,
        97680,
        97694,
        97696,
        97724,
        97734,
        97740,
        97752,
        97774,
        97830,
        97836,
        97850,
        97862,
        97868,
        97880,
        97902,
        97906,
        97908,
        97926,
        97932,
        97944,
        97968,
        97998,
        98012,
        98018,
        98020,
        98024,
        98038,
        98618,
        98674,
        98676,
        98838,
        98854,
        98874,
        98892,
        98904,
        98926,
        98930,
        98932,
        98968,
        99006,
        99042,
        99044,
        99048,
        99062,
        99166,
        99194,
        99246,
        99286,
        99350,
        99366,
        99372,
        99386,
        99398,
        99416,
        99438,
        99442,
        99444,
        99462,
        99504,
        99518,
        99534,
        99548,
        99554,
        99556,
        99560,
        99574,
        99590,
        99596,
        99608,
        99632,
        99646,
        99680,
        99708,
        99726,
        99740,
        99768,
        99778,
        99780,
        99784,
        99792,
        99806,
        99814,
        99820,
        99834,
        99858,
        99860,
        99874,
        99880,
        99894,
        99906,
        99920,
        99934,
        99962,
        99970,
        99972,
        99976,
        99984,
        99998,
        1e5,
        100028,
        100038,
        100044,
        100056,
        100078,
        100082,
        100084,
        100142,
        100174,
        100188,
        100246,
        100262,
        100268,
        100306,
        100308,
        100390,
        100396,
        100410,
        100422,
        100428,
        100440,
        100462,
        100466,
        100468,
        100486,
        100504,
        100528,
        100542,
        100558,
        100572,
        100578,
        100580,
        100584,
        100598,
        100620,
        100656,
        100670,
        100704,
        100732,
        100750,
        100792,
        100802,
        100808,
        100816,
        100830,
        100838,
        100844,
        100858,
        100888,
        100912,
        100926,
        100960,
        100988,
        101056,
        101112,
        101148,
        101176,
        101232,
        101246,
        101250,
        101252,
        101256,
        101264,
        101278,
        101280,
        101308,
        101318,
        101324,
        101336,
        101358,
        101362,
        101364,
        101410,
        101412,
        101416,
        101430,
        101442,
        101448,
        101456,
        101470,
        101478,
        101498,
        101506,
        101508,
        101520,
        101534,
        101536,
        101564,
        101580,
        101618,
        101620,
        101636,
        101640,
        101648,
        101662,
        101664,
        101692,
        101696,
        101752,
        101766,
        101784,
        101838,
        101858,
        101860,
        101864,
        101934,
        101938,
        101940,
        101966,
        101980,
        101986,
        101988,
        101992,
        102030,
        102044,
        102072,
        102082,
        102084,
        102088,
        102096,
        102138,
        102166,
        102182,
        102188,
        102214,
        102220,
        102232,
        102254,
        102282,
        102290,
        102292,
        102306,
        102308,
        102312,
        102326,
        102444,
        102458,
        102470,
        102476,
        102488,
        102514,
        102516,
        102534,
        102552,
        102576,
        102590,
        102606,
        102620,
        102626,
        102632,
        102646,
        102662,
        102668,
        102704,
        102718,
        102752,
        102780,
        102798,
        102812,
        102840,
        102850,
        102856,
        102864,
        102878,
        102886,
        102892,
        102906,
        102936,
        102974,
        103008,
        103036,
        103104,
        103160,
        103224,
        103280,
        103294,
        103298,
        103300,
        103312,
        103326,
        103328,
        103356,
        103366,
        103372,
        103384,
        103406,
        103410,
        103412,
        103472,
        103486,
        103520,
        103548,
        103616,
        103672,
        103920,
        103992,
        104048,
        104062,
        104160,
        104188,
        104194,
        104196,
        104200,
        104208,
        104224,
        104252,
        104256,
        104312,
        104326,
        104332,
        104344,
        104368,
        104382,
        104398,
        104412,
        104418,
        104420,
        104424,
        104482,
        104484,
        104514,
        104520,
        104528,
        104542,
        104550,
        104570,
        104578,
        104580,
        104592,
        104606,
        104608,
        104636,
        104652,
        104690,
        104692,
        104706,
        104712,
        104734,
        104736,
        104764,
        104768,
        104824,
        104838,
        104856,
        104910,
        104930,
        104932,
        104936,
        104968,
        104976,
        104990,
        104992,
        105020,
        105024,
        105080,
        105200,
        105240,
        105278,
        105312,
        105372,
        105410,
        105412,
        105416,
        105424,
        105446,
        105518,
        105524,
        105550,
        105564,
        105570,
        105572,
        105576,
        105614,
        105628,
        105656,
        105666,
        105672,
        105680,
        105702,
        105722,
        105742,
        105756,
        105784,
        105840,
        105854,
        105858,
        105860,
        105864,
        105872,
        105888,
        105932,
        105970,
        105972,
        106006,
        106022,
        106028,
        106054,
        106060,
        106072,
        106100,
        106118,
        106124,
        106136,
        106160,
        106174,
        106190,
        106210,
        106212,
        106216,
        106250,
        106258,
        106260,
        106274,
        106276,
        106280,
        106306,
        106308,
        106312,
        106320,
        106334,
        106348,
        106394,
        106414,
        106418,
        106420,
        106566,
        106572,
        106610,
        106612,
        106630,
        106636,
        106648,
        106672,
        106686,
        106722,
        106724,
        106728,
        106742,
        106758,
        106764,
        106776,
        106800,
        106814,
        106848,
        106876,
        106894,
        106908,
        106936,
        106946,
        106948,
        106952,
        106960,
        106974,
        106982,
        106988,
        107032,
        107056,
        107070,
        107104,
        107132,
        107200,
        107256,
        107292,
        107320,
        107376,
        107390,
        107394,
        107396,
        107400,
        107408,
        107422,
        107424,
        107452,
        107462,
        107468,
        107480,
        107502,
        107506,
        107508,
        107544,
        107568,
        107582,
        107616,
        107644,
        107712,
        107768,
        108016,
        108060,
        108088,
        108144,
        108158,
        108256,
        108284,
        108290,
        108292,
        108296,
        108304,
        108318,
        108320,
        108348,
        108352,
        108408,
        108422,
        108428,
        108440,
        108464,
        108478,
        108494,
        108508,
        108514,
        108516,
        108520,
        108592,
        108640,
        108668,
        108736,
        108792,
        109040,
        109536,
        109680,
        109694,
        109792,
        109820,
        110016,
        110072,
        110084,
        110088,
        110096,
        110112,
        110140,
        110144,
        110200,
        110320,
        110342,
        110348,
        110360,
        110384,
        110398,
        110432,
        110460,
        110478,
        110492,
        110520,
        110532,
        110536,
        110544,
        110558,
        110658,
        110686,
        110714,
        110722,
        110724,
        110728,
        110736,
        110750,
        110752,
        110780,
        110796,
        110834,
        110836,
        110850,
        110852,
        110856,
        110864,
        110878,
        110880,
        110908,
        110912,
        110968,
        110982,
        111e3,
        111054,
        111074,
        111076,
        111080,
        111108,
        111112,
        111120,
        111134,
        111136,
        111164,
        111168,
        111224,
        111344,
        111372,
        111422,
        111456,
        111516,
        111554,
        111556,
        111560,
        111568,
        111590,
        111632,
        111646,
        111648,
        111676,
        111680,
        111736,
        111856,
        112096,
        112152,
        112224,
        112252,
        112320,
        112440,
        112514,
        112516,
        112520,
        112528,
        112542,
        112544,
        112588,
        112686,
        112718,
        112732,
        112782,
        112796,
        112824,
        112834,
        112836,
        112840,
        112848,
        112870,
        112890,
        112910,
        112924,
        112952,
        113008,
        113022,
        113026,
        113028,
        113032,
        113040,
        113054,
        113056,
        113100,
        113138,
        113140,
        113166,
        113180,
        113208,
        113264,
        113278,
        113376,
        113404,
        113416,
        113424,
        113440,
        113468,
        113472,
        113560,
        113614,
        113634,
        113636,
        113640,
        113686,
        113702,
        113708,
        113734,
        113740,
        113752,
        113778,
        113780,
        113798,
        113804,
        113816,
        113840,
        113854,
        113870,
        113890,
        113892,
        113896,
        113926,
        113932,
        113944,
        113968,
        113982,
        114016,
        114044,
        114076,
        114114,
        114116,
        114120,
        114128,
        114150,
        114170,
        114194,
        114196,
        114210,
        114212,
        114216,
        114242,
        114244,
        114248,
        114256,
        114270,
        114278,
        114306,
        114308,
        114312,
        114320,
        114334,
        114336,
        114364,
        114380,
        114420,
        114458,
        114478,
        114482,
        114484,
        114510,
        114524,
        114530,
        114532,
        114536,
        114842,
        114866,
        114868,
        114970,
        114994,
        114996,
        115042,
        115044,
        115048,
        115062,
        115130,
        115226,
        115250,
        115252,
        115278,
        115292,
        115298,
        115300,
        115304,
        115318,
        115342,
        115394,
        115396,
        115400,
        115408,
        115422,
        115430,
        115436,
        115450,
        115478,
        115494,
        115514,
        115526,
        115532,
        115570,
        115572,
        115738,
        115758,
        115762,
        115764,
        115790,
        115804,
        115810,
        115812,
        115816,
        115830,
        115854,
        115868,
        115896,
        115906,
        115912,
        115920,
        115934,
        115942,
        115948,
        115962,
        115996,
        116024,
        116080,
        116094,
        116098,
        116100,
        116104,
        116112,
        116126,
        116128,
        116156,
        116166,
        116172,
        116184,
        116206,
        116210,
        116212,
        116246,
        116262,
        116268,
        116282,
        116294,
        116300,
        116312,
        116334,
        116338,
        116340,
        116358,
        116364,
        116376,
        116400,
        116414,
        116430,
        116444,
        116450,
        116452,
        116456,
        116498,
        116500,
        116514,
        116520,
        116534,
        116546,
        116548,
        116552,
        116560,
        116574,
        116582,
        116588,
        116602,
        116654,
        116694,
        116714,
        116762,
        116782,
        116786,
        116788,
        116814,
        116828,
        116834,
        116836,
        116840,
        116854,
        116878,
        116892,
        116920,
        116930,
        116936,
        116944,
        116958,
        116966,
        116972,
        116986,
        117006,
        117048,
        117104,
        117118,
        117122,
        117124,
        117136,
        117150,
        117152,
        117180,
        117190,
        117196,
        117208,
        117230,
        117234,
        117236,
        117304,
        117360,
        117374,
        117472,
        117500,
        117506,
        117508,
        117512,
        117520,
        117536,
        117564,
        117568,
        117624,
        117638,
        117644,
        117656,
        117680,
        117694,
        117710,
        117724,
        117730,
        117732,
        117736,
        117750,
        117782,
        117798,
        117804,
        117818,
        117830,
        117848,
        117874,
        117876,
        117894,
        117936,
        117950,
        117966,
        117986,
        117988,
        117992,
        118022,
        118028,
        118040,
        118064,
        118078,
        118112,
        118140,
        118172,
        118210,
        118212,
        118216,
        118224,
        118238,
        118246,
        118266,
        118306,
        118312,
        118338,
        118352,
        118366,
        118374,
        118394,
        118402,
        118404,
        118408,
        118416,
        118430,
        118432,
        118460,
        118476,
        118514,
        118516,
        118574,
        118578,
        118580,
        118606,
        118620,
        118626,
        118628,
        118632,
        118678,
        118694,
        118700,
        118730,
        118738,
        118740,
        118830,
        118834,
        118836,
        118862,
        118876,
        118882,
        118884,
        118888,
        118902,
        118926,
        118940,
        118968,
        118978,
        118980,
        118984,
        118992,
        119006,
        119014,
        119020,
        119034,
        119068,
        119096,
        119152,
        119166,
        119170,
        119172,
        119176,
        119184,
        119198,
        119200,
        119228,
        119238,
        119244,
        119256,
        119278,
        119282,
        119284,
        119324,
        119352,
        119408,
        119422,
        119520,
        119548,
        119554,
        119556,
        119560,
        119568,
        119582,
        119584,
        119612,
        119616,
        119672,
        119686,
        119692,
        119704,
        119728,
        119742,
        119758,
        119772,
        119778,
        119780,
        119784,
        119798,
        119920,
        119934,
        120032,
        120060,
        120256,
        120312,
        120324,
        120328,
        120336,
        120352,
        120384,
        120440,
        120560,
        120582,
        120588,
        120600,
        120624,
        120638,
        120672,
        120700,
        120718,
        120732,
        120760,
        120770,
        120772,
        120776,
        120784,
        120798,
        120806,
        120812,
        120870,
        120876,
        120890,
        120902,
        120908,
        120920,
        120946,
        120948,
        120966,
        120972,
        120984,
        121008,
        121022,
        121038,
        121058,
        121060,
        121064,
        121078,
        121100,
        121112,
        121136,
        121150,
        121184,
        121212,
        121244,
        121282,
        121284,
        121288,
        121296,
        121318,
        121338,
        121356,
        121368,
        121392,
        121406,
        121440,
        121468,
        121536,
        121592,
        121656,
        121730,
        121732,
        121736,
        121744,
        121758,
        121760,
        121804,
        121842,
        121844,
        121890,
        121922,
        121924,
        121928,
        121936,
        121950,
        121958,
        121978,
        121986,
        121988,
        121992,
        122e3,
        122014,
        122016,
        122044,
        122060,
        122098,
        122100,
        122116,
        122120,
        122128,
        122142,
        122144,
        122172,
        122176,
        122232,
        122246,
        122264,
        122318,
        122338,
        122340,
        122344,
        122414,
        122418,
        122420,
        122446,
        122460,
        122466,
        122468,
        122472,
        122510,
        122524,
        122552,
        122562,
        122564,
        122568,
        122576,
        122598,
        122618,
        122646,
        122662,
        122668,
        122694,
        122700,
        122712,
        122738,
        122740,
        122762,
        122770,
        122772,
        122786,
        122788,
        122792,
        123018,
        123026,
        123028,
        123042,
        123044,
        123048,
        123062,
        123098,
        123146,
        123154,
        123156,
        123170,
        123172,
        123176,
        123190,
        123202,
        123204,
        123208,
        123216,
        123238,
        123244,
        123258,
        123290,
        123314,
        123316,
        123402,
        123410,
        123412,
        123426,
        123428,
        123432,
        123446,
        123458,
        123464,
        123472,
        123486,
        123494,
        123500,
        123514,
        123522,
        123524,
        123528,
        123536,
        123552,
        123580,
        123590,
        123596,
        123608,
        123630,
        123634,
        123636,
        123674,
        123698,
        123700,
        123740,
        123746,
        123748,
        123752,
        123834,
        123914,
        123922,
        123924,
        123938,
        123944,
        123958,
        123970,
        123976,
        123984,
        123998,
        124006,
        124012,
        124026,
        124034,
        124036,
        124048,
        124062,
        124064,
        124092,
        124102,
        124108,
        124120,
        124142,
        124146,
        124148,
        124162,
        124164,
        124168,
        124176,
        124190,
        124192,
        124220,
        124224,
        124280,
        124294,
        124300,
        124312,
        124336,
        124350,
        124366,
        124380,
        124386,
        124388,
        124392,
        124406,
        124442,
        124462,
        124466,
        124468,
        124494,
        124508,
        124514,
        124520,
        124558,
        124572,
        124600,
        124610,
        124612,
        124616,
        124624,
        124646,
        124666,
        124694,
        124710,
        124716,
        124730,
        124742,
        124748,
        124760,
        124786,
        124788,
        124818,
        124820,
        124834,
        124836,
        124840,
        124854,
        124946,
        124948,
        124962,
        124964,
        124968,
        124982,
        124994,
        124996,
        125e3,
        125008,
        125022,
        125030,
        125036,
        125050,
        125058,
        125060,
        125064,
        125072,
        125086,
        125088,
        125116,
        125126,
        125132,
        125144,
        125166,
        125170,
        125172,
        125186,
        125188,
        125192,
        125200,
        125216,
        125244,
        125248,
        125304,
        125318,
        125324,
        125336,
        125360,
        125374,
        125390,
        125404,
        125410,
        125412,
        125416,
        125430,
        125444,
        125448,
        125456,
        125472,
        125504,
        125560,
        125680,
        125702,
        125708,
        125720,
        125744,
        125758,
        125792,
        125820,
        125838,
        125852,
        125880,
        125890,
        125892,
        125896,
        125904,
        125918,
        125926,
        125932,
        125978,
        125998,
        126002,
        126004,
        126030,
        126044,
        126050,
        126052,
        126056,
        126094,
        126108,
        126136,
        126146,
        126148,
        126152,
        126160,
        126182,
        126202,
        126222,
        126236,
        126264,
        126320,
        126334,
        126338,
        126340,
        126344,
        126352,
        126366,
        126368,
        126412,
        126450,
        126452,
        126486,
        126502,
        126508,
        126522,
        126534,
        126540,
        126552,
        126574,
        126578,
        126580,
        126598,
        126604,
        126616,
        126640,
        126654,
        126670,
        126684,
        126690,
        126692,
        126696,
        126738,
        126754,
        126756,
        126760,
        126774,
        126786,
        126788,
        126792,
        126800,
        126814,
        126822,
        126828,
        126842,
        126894,
        126898,
        126900,
        126934,
        127126,
        127142,
        127148,
        127162,
        127178,
        127186,
        127188,
        127254,
        127270,
        127276,
        127290,
        127302,
        127308,
        127320,
        127342,
        127346,
        127348,
        127370,
        127378,
        127380,
        127394,
        127396,
        127400,
        127450,
        127510,
        127526,
        127532,
        127546,
        127558,
        127576,
        127598,
        127602,
        127604,
        127622,
        127628,
        127640,
        127664,
        127678,
        127694,
        127708,
        127714,
        127716,
        127720,
        127734,
        127754,
        127762,
        127764,
        127778,
        127784,
        127810,
        127812,
        127816,
        127824,
        127838,
        127846,
        127866,
        127898,
        127918,
        127922,
        127924,
        128022,
        128038,
        128044,
        128058,
        128070,
        128076,
        128088,
        128110,
        128114,
        128116,
        128134,
        128140,
        128152,
        128176,
        128190,
        128206,
        128220,
        128226,
        128228,
        128232,
        128246,
        128262,
        128268,
        128280,
        128304,
        128318,
        128352,
        128380,
        128398,
        128412,
        128440,
        128450,
        128452,
        128456,
        128464,
        128478,
        128486,
        128492,
        128506,
        128522,
        128530,
        128532,
        128546,
        128548,
        128552,
        128566,
        128578,
        128580,
        128584,
        128592,
        128606,
        128614,
        128634,
        128642,
        128644,
        128648,
        128656,
        128670,
        128672,
        128700,
        128716,
        128754,
        128756,
        128794,
        128814,
        128818,
        128820,
        128846,
        128860,
        128866,
        128868,
        128872,
        128886,
        128918,
        128934,
        128940,
        128954,
        128978,
        128980,
        129178,
        129198,
        129202,
        129204,
        129238,
        129258,
        129306,
        129326,
        129330,
        129332,
        129358,
        129372,
        129378,
        129380,
        129384,
        129398,
        129430,
        129446,
        129452,
        129466,
        129482,
        129490,
        129492,
        129562,
        129582,
        129586,
        129588,
        129614,
        129628,
        129634,
        129636,
        129640,
        129654,
        129678,
        129692,
        129720,
        129730,
        129732,
        129736,
        129744,
        129758,
        129766,
        129772,
        129814,
        129830,
        129836,
        129850,
        129862,
        129868,
        129880,
        129902,
        129906,
        129908,
        129930,
        129938,
        129940,
        129954,
        129956,
        129960,
        129974,
        130010
    ]), t.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2e3,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1e3,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]), t;
}(), $849102574a83a574$var$bn = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $849102574a83a574$var$Rn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Nn = function() {
    function t() {}
    return t.detectMultiple = function(e, r, n) {
        var o = e.getBlackMatrix(), i = t.detect(n, o);
        return i.length || ((o = o.clone()).rotate180(), i = t.detect(n, o)), new $849102574a83a574$var$bn(o, i);
    }, t.detect = function(e, r) {
        for(var n, o, i = new Array, a = 0, s = 0, u = !1; a < r.getHeight();){
            var c = t.findVertices(r, a, s);
            if (null != c[0] || null != c[3]) {
                if (u = !0, i.push(c), !e) break;
                null != c[2] ? (s = Math.trunc(c[2].getX()), a = Math.trunc(c[2].getY())) : (s = Math.trunc(c[4].getX()), a = Math.trunc(c[4].getY()));
            } else {
                if (!u) break;
                u = !1, s = 0;
                try {
                    for(var f = (n = void 0, $849102574a83a574$var$Rn(i)), h = f.next(); !h.done; h = f.next()){
                        var l = h.value;
                        null != l[1] && (a = Math.trunc(Math.max(a, l[1].getY()))), null != l[3] && (a = Math.max(a, Math.trunc(l[3].getY())));
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                a += t.ROW_STEP;
            }
        }
        return i;
    }, t.findVertices = function(e, r, n) {
        var o = e.getHeight(), i = e.getWidth(), a = new Array(8);
        return t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.START_PATTERN), t.INDEXES_START_PATTERN), null != a[4] && (n = Math.trunc(a[4].getX()), r = Math.trunc(a[4].getY())), t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.STOP_PATTERN), t.INDEXES_STOP_PATTERN), a;
    }, t.copyToResult = function(t, e, r) {
        for(var n = 0; n < r.length; n++)t[r[n]] = e[n];
    }, t.findRowsWithPattern = function(e, r, n, o, i, a) {
        for(var s = new Array(4), u = !1, c = new Int32Array(a.length); o < r; o += t.ROW_STEP)if (null != (d = t.findGuardPattern(e, i, o, n, !1, a, c))) {
            for(; o > 0;){
                if (null == (l = t.findGuardPattern(e, i, --o, n, !1, a, c))) {
                    o++;
                    break;
                }
                d = l;
            }
            s[0] = new $849102574a83a574$var$Lt(d[0], o), s[1] = new $849102574a83a574$var$Lt(d[1], o), u = !0;
            break;
        }
        var f = o + 1;
        if (u) {
            for(var h = 0, l = Int32Array.from([
                Math.trunc(s[0].getX()),
                Math.trunc(s[1].getX())
            ]); f < r; f++){
                var d;
                if (null != (d = t.findGuardPattern(e, l[0], f, n, !1, a, c)) && Math.abs(l[0] - d[0]) < t.MAX_PATTERN_DRIFT && Math.abs(l[1] - d[1]) < t.MAX_PATTERN_DRIFT) l = d, h = 0;
                else {
                    if (h > t.SKIPPED_ROW_COUNT_MAX) break;
                    h++;
                }
            }
            f -= h + 1, s[2] = new $849102574a83a574$var$Lt(l[0], f), s[3] = new $849102574a83a574$var$Lt(l[1], f);
        }
        return f - o < t.BARCODE_MIN_HEIGHT && $849102574a83a574$var$k.fill(s, null), s;
    }, t.findGuardPattern = function(e, r, n, o, i, a, s) {
        $849102574a83a574$var$k.fillWithin(s, 0, s.length, 0);
        for(var u = r, c = 0; e.get(u, n) && u > 0 && c++ < t.MAX_PIXEL_DRIFT;)u--;
        for(var f = u, h = 0, l = a.length, d = i; f < o; f++)if (e.get(f, n) !== d) s[h]++;
        else {
            if (h === l - 1) {
                if (t.patternMatchVariance(s, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE) return new Int32Array([
                    u,
                    f
                ]);
                u += s[0] + s[1], $849102574a83a574$var$D.arraycopy(s, 2, s, 0, h - 1), s[h - 1] = 0, s[h] = 0, h--;
            } else h++;
            s[h] = 1, d = !d;
        }
        return h === l - 1 && t.patternMatchVariance(s, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE ? new Int32Array([
            u,
            f - 1
        ]) : null;
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return 1 / 0;
        var s = o / i;
        r *= s;
        for(var u = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * s, l = f > h ? f - h : h - f;
            if (l > r) return 1 / 0;
            u += l;
        }
        return u / o;
    }, t.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]), t.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]), t.MAX_AVG_VARIANCE = .42, t.MAX_INDIVIDUAL_VARIANCE = .8, t.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]), t.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]), t.MAX_PIXEL_DRIFT = 3, t.MAX_PATTERN_DRIFT = 5, t.SKIPPED_ROW_COUNT_MAX = 25, t.ROW_STEP = 5, t.BARCODE_MIN_HEIGHT = 10, t;
}(), $849102574a83a574$var$Dn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Mn = function() {
    function t(t, e) {
        if (0 === e.length) throw new $849102574a83a574$var$T;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = new Int32Array([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $849102574a83a574$var$D.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        var e, r;
        if (0 === t) return this.getCoefficient(0);
        if (1 === t) {
            var n = 0;
            try {
                for(var o = $849102574a83a574$var$Dn(this.coefficients), i = o.next(); !i.done; i = o.next()){
                    var a = i.value;
                    n = this.field.add(n, a);
                }
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    i && !i.done && (r = o.return) && r.call(o);
                } finally{
                    if (e) throw e.error;
                }
            }
            return n;
        }
        for(var s = this.coefficients[0], u = this.coefficients.length, c = 1; c < u; c++)s = this.field.add(this.field.multiply(t, s), this.coefficients[c]);
        return s;
    }, t.prototype.add = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $849102574a83a574$var$D.arraycopy(n, 0, i, 0, a);
        for(var s = a; s < n.length; s++)i[s] = this.field.add(r[s - a], n[s]);
        return new t(this.field, i);
    }, t.prototype.subtract = function(t) {
        if (!this.field.equals(t.field)) throw new $849102574a83a574$var$T("ModulusPolys do not have same ModulusGF field");
        return t.isZero() ? this : this.add(t.negative());
    }, t.prototype.multiply = function(e) {
        return e instanceof t ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, t.prototype.multiplyOther = function(e) {
        if (!this.field.equals(e.field)) throw new $849102574a83a574$var$T("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || e.isZero()) return new t(this.field, new Int32Array([
            0
        ]));
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), s = 0; s < n; s++)for(var u = r[s], c = 0; c < i; c++)a[s + c] = this.field.add(a[s + c], this.field.multiply(u, o[c]));
        return new t(this.field, a);
    }, t.prototype.negative = function() {
        for(var e = this.coefficients.length, r = new Int32Array(e), n = 0; n < e; n++)r[n] = this.field.subtract(0, this.coefficients[n]);
        return new t(this.field, r);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return new t(this.field, new Int32Array([
            0
        ]));
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = new Int32Array(r), o = 0; o < r; o++)n[o] = this.field.multiply(this.coefficients[o], e);
        return new t(this.field, n);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $849102574a83a574$var$T;
        if (0 === r) return new t(this.field, new Int32Array([
            0
        ]));
        for(var n = this.coefficients.length, o = new Int32Array(n + e), i = 0; i < n; i++)o[i] = this.field.multiply(this.coefficients[i], r);
        return new t(this.field, o);
    }, t.prototype.toString = function() {
        for(var t = new $849102574a83a574$var$Q, e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            0 !== r && (r < 0 ? (t.append(" - "), r = -r) : t.length() > 0 && t.append(" + "), 0 !== e && 1 === r || t.append(r), 0 !== e && (1 === e ? t.append("x") : (t.append("x^"), t.append(e))));
        }
        return t.toString();
    }, t;
}(), $849102574a83a574$var$Pn = function() {
    function t() {}
    return t.prototype.add = function(t, e) {
        return (t + e) % this.modulus;
    }, t.prototype.subtract = function(t, e) {
        return (this.modulus + t - e) % this.modulus;
    }, t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $849102574a83a574$var$T;
        return this.logTable[t];
    }, t.prototype.inverse = function(t) {
        if (0 === t) throw new $849102574a83a574$var$It;
        return this.expTable[this.modulus - this.logTable[t] - 1];
    }, t.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.modulus - 1)];
    }, t.prototype.getSize = function() {
        return this.modulus;
    }, t.prototype.equals = function(t) {
        return t === this;
    }, t;
}(), $849102574a83a574$var$Bn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ln = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        n.modulus = e, n.expTable = new Int32Array(e), n.logTable = new Int32Array(e);
        for(var o = 1, i = 0; i < e; i++)n.expTable[i] = o, o = o * r % e;
        for(i = 0; i < e - 1; i++)n.logTable[n.expTable[i]] = i;
        return n.zero = new $849102574a83a574$var$Mn(n, new Int32Array([
            0
        ])), n.one = new $849102574a83a574$var$Mn(n, new Int32Array([
            1
        ])), n;
    }
    return $849102574a83a574$var$Bn(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $849102574a83a574$var$T;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $849102574a83a574$var$Mn(this, r);
    }, e.PDF417_GF = new e($849102574a83a574$var$On.NUMBER_OF_CODEWORDS, 3), e;
}($849102574a83a574$var$Pn), $849102574a83a574$var$Fn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$kn = function() {
    function t() {
        this.field = $849102574a83a574$var$Ln.PDF417_GF;
    }
    return t.prototype.decode = function(t, e, r) {
        for(var n, o, i = new $849102574a83a574$var$Mn(this.field, t), a = new Int32Array(e), s = !1, u = e; u > 0; u--){
            var c = i.evaluateAt(this.field.exp(u));
            a[e - u] = c, 0 !== c && (s = !0);
        }
        if (!s) return 0;
        var f = this.field.getOne();
        if (null != r) try {
            for(var h = $849102574a83a574$var$Fn(r), l = h.next(); !l.done; l = h.next()){
                var d = l.value, p = this.field.exp(t.length - 1 - d), g = new $849102574a83a574$var$Mn(this.field, new Int32Array([
                    this.field.subtract(0, p),
                    1
                ]));
                f = f.multiply(g);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (o = h.return) && o.call(h);
            } finally{
                if (n) throw n.error;
            }
        }
        var y = new $849102574a83a574$var$Mn(this.field, a), w = this.runEuclideanAlgorithm(this.field.buildMonomial(e, 1), y, e), v = w[0], _ = w[1], A = this.findErrorLocations(v), C = this.findErrorMagnitudes(_, v, A);
        for(u = 0; u < A.length; u++){
            var m = t.length - 1 - this.field.log(A[u]);
            if (m < 0) throw $849102574a83a574$var$R.getChecksumInstance();
            t[m] = this.field.subtract(t[m], C[u]);
        }
        return A.length;
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = t, i = e, a = this.field.getZero(), s = this.field.getOne(); i.getDegree() >= Math.round(r / 2);){
            var u = o, c = a;
            if (a = s, (o = i).isZero()) throw $849102574a83a574$var$R.getChecksumInstance();
            i = u;
            for(var f = this.field.getZero(), h = o.getCoefficient(o.getDegree()), l = this.field.inverse(h); i.getDegree() >= o.getDegree() && !i.isZero();){
                var d = i.getDegree() - o.getDegree(), p = this.field.multiply(i.getCoefficient(i.getDegree()), l);
                f = f.add(this.field.buildMonomial(d, p)), i = i.subtract(o.multiplyByMonomial(d, p));
            }
            s = f.multiply(a).subtract(c).negative();
        }
        var g = s.getCoefficient(0);
        if (0 === g) throw $849102574a83a574$var$R.getChecksumInstance();
        var y = this.field.inverse(g);
        return [
            s.multiply(y),
            i.multiply(y)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        for(var e = t.getDegree(), r = new Int32Array(e), n = 0, o = 1; o < this.field.getSize() && n < e; o++)0 === t.evaluateAt(o) && (r[n] = this.field.inverse(o), n++);
        if (n !== e) throw $849102574a83a574$var$R.getChecksumInstance();
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e, r) {
        for(var n = e.getDegree(), o = new Int32Array(n), i = 1; i <= n; i++)o[n - i] = this.field.multiply(i, e.getCoefficient(i));
        var a = new $849102574a83a574$var$Mn(this.field, o), s = r.length, u = new Int32Array(s);
        for(i = 0; i < s; i++){
            var c = this.field.inverse(r[i]), f = this.field.subtract(0, t.evaluateAt(c)), h = this.field.inverse(a.evaluateAt(c));
            u[i] = this.field.multiply(f, h);
        }
        return u;
    }, t;
}(), $849102574a83a574$var$xn = function() {
    function t(e, r, n, o, i) {
        e instanceof t ? this.constructor_2(e) : this.constructor_1(e, r, n, o, i);
    }
    return t.prototype.constructor_1 = function(t, e, r, n, o) {
        var i = null == e || null == r, a = null == n || null == o;
        if (i && a) throw new $849102574a83a574$var$tt;
        i ? (e = new $849102574a83a574$var$Lt(0, n.getY()), r = new $849102574a83a574$var$Lt(0, o.getY())) : a && (n = new $849102574a83a574$var$Lt(t.getWidth() - 1, e.getY()), o = new $849102574a83a574$var$Lt(t.getWidth() - 1, r.getY())), this.image = t, this.topLeft = e, this.bottomLeft = r, this.topRight = n, this.bottomRight = o, this.minX = Math.trunc(Math.min(e.getX(), r.getX())), this.maxX = Math.trunc(Math.max(n.getX(), o.getX())), this.minY = Math.trunc(Math.min(e.getY(), n.getY())), this.maxY = Math.trunc(Math.max(r.getY(), o.getY()));
    }, t.prototype.constructor_2 = function(t) {
        this.image = t.image, this.topLeft = t.getTopLeft(), this.bottomLeft = t.getBottomLeft(), this.topRight = t.getTopRight(), this.bottomRight = t.getBottomRight(), this.minX = t.getMinX(), this.maxX = t.getMaxX(), this.minY = t.getMinY(), this.maxY = t.getMaxY();
    }, t.merge = function(e, r) {
        return null == e ? r : null == r ? e : new t(e.image, e.topLeft, e.bottomLeft, r.topRight, r.bottomRight);
    }, t.prototype.addMissingRows = function(e, r, n) {
        var o = this.topLeft, i = this.bottomLeft, a = this.topRight, s = this.bottomRight;
        if (e > 0) {
            var u = n ? this.topLeft : this.topRight, c = Math.trunc(u.getY() - e);
            c < 0 && (c = 0);
            var f = new $849102574a83a574$var$Lt(u.getX(), c);
            n ? o = f : a = f;
        }
        if (r > 0) {
            var h = n ? this.bottomLeft : this.bottomRight, l = Math.trunc(h.getY() + r);
            l >= this.image.getHeight() && (l = this.image.getHeight() - 1);
            var d = new $849102574a83a574$var$Lt(h.getX(), l);
            n ? i = d : s = d;
        }
        return new t(this.image, o, i, a, s);
    }, t.prototype.getMinX = function() {
        return this.minX;
    }, t.prototype.getMaxX = function() {
        return this.maxX;
    }, t.prototype.getMinY = function() {
        return this.minY;
    }, t.prototype.getMaxY = function() {
        return this.maxY;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getBottomRight = function() {
        return this.bottomRight;
    }, t;
}(), $849102574a83a574$var$Vn = function() {
    function t(t, e, r, n) {
        this.columnCount = t, this.errorCorrectionLevel = n, this.rowCountUpperPart = e, this.rowCountLowerPart = r, this.rowCount = e + r;
    }
    return t.prototype.getColumnCount = function() {
        return this.columnCount;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getRowCount = function() {
        return this.rowCount;
    }, t.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    }, t.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    }, t;
}(), $849102574a83a574$var$Hn = function() {
    function t() {
        this.buffer = "";
    }
    return t.form = function(t, e) {
        var r = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, n, o, i, a, s) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++r]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var u, c = a ? parseInt(a.substr(1)) : void 0;
                switch(s){
                    case "s":
                        u = e[r];
                        break;
                    case "c":
                        u = e[r][0];
                        break;
                    case "f":
                        u = parseFloat(e[r]).toFixed(t);
                        break;
                    case "p":
                        u = parseFloat(e[r]).toPrecision(t);
                        break;
                    case "e":
                        u = parseFloat(e[r]).toExponential(t);
                        break;
                    case "x":
                        u = parseInt(e[r]).toString(c || 16);
                        break;
                    case "d":
                        u = parseFloat(parseInt(e[r], c || 10).toPrecision(t)).toFixed(0);
                }
                u = "object" == typeof u ? JSON.stringify(u) : (+u).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; u.length < f;)u = void 0 !== n ? u + h : h + u;
                return u;
            }
        });
    }, t.prototype.format = function(e) {
        for(var r = [], n = 1; n < arguments.length; n++)r[n - 1] = arguments[n];
        this.buffer += t.form(e, r);
    }, t.prototype.toString = function() {
        return this.buffer;
    }, t;
}(), $849102574a83a574$var$Un = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Xn = function() {
    function t(t) {
        this.boundingBox = new $849102574a83a574$var$xn(t), this.codewords = new Array(t.getMaxY() - t.getMinY() + 1);
    }
    return t.prototype.getCodewordNearby = function(e) {
        var r = this.getCodeword(e);
        if (null != r) return r;
        for(var n = 1; n < t.MAX_NEARBY_DISTANCE; n++){
            var o = this.imageRowToCodewordIndex(e) - n;
            if (o >= 0 && null != (r = this.codewords[o])) return r;
            if ((o = this.imageRowToCodewordIndex(e) + n) < this.codewords.length && null != (r = this.codewords[o])) return r;
        }
        return null;
    }, t.prototype.imageRowToCodewordIndex = function(t) {
        return t - this.boundingBox.getMinY();
    }, t.prototype.setCodeword = function(t, e) {
        this.codewords[this.imageRowToCodewordIndex(t)] = e;
    }, t.prototype.getCodeword = function(t) {
        return this.codewords[this.imageRowToCodewordIndex(t)];
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.toString = function() {
        var t, e, r = new $849102574a83a574$var$Hn, n = 0;
        try {
            for(var o = $849102574a83a574$var$Un(this.codewords), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                null != a ? r.format("%3d: %3d|%3d%n", n++, a.getRowNumber(), a.getValue()) : r.format("%3d:    |   %n", n++);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r.toString();
    }, t.MAX_NEARBY_DISTANCE = 5, t;
}(), $849102574a83a574$var$Gn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Wn = function(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var n, o, i = r.call(t), a = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(n = i.next()).done;)a.push(n.value);
    } catch (t) {
        o = {
            error: t
        };
    } finally{
        try {
            n && !n.done && (r = i.return) && r.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return a;
}, $849102574a83a574$var$zn = function() {
    function t() {
        this.values = new Map;
    }
    return t.prototype.setValue = function(t) {
        t = Math.trunc(t);
        var e = this.values.get(t);
        null == e && (e = 0), e++, this.values.set(t, e);
    }, t.prototype.getValue = function() {
        var t, e, r = -1, n = new Array, o = function(t, e) {
            var o = function() {
                return t;
            }, i = function() {
                return e;
            };
            i() > r ? (r = i(), (n = []).push(o())) : i() === r && n.push(o());
        };
        try {
            for(var i = $849102574a83a574$var$Gn(this.values.entries()), a = i.next(); !a.done; a = i.next()){
                var s = $849102574a83a574$var$Wn(a.value, 2);
                o(s[0], s[1]);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (e = i.return) && e.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return $849102574a83a574$var$On.toIntArray(n);
    }, t.prototype.getConfidence = function(t) {
        return this.values.get(t);
    }, t;
}(), $849102574a83a574$var$jn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Yn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Zn = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n._isLeft = r, n;
    }
    return $849102574a83a574$var$jn(e, t), e.prototype.setRowNumbers = function() {
        var t, e;
        try {
            for(var r = $849102574a83a574$var$Yn(this.getCodewords()), n = r.next(); !n.done; n = r.next()){
                var o = n.value;
                null != o && o.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(t) {
        var e = this.getCodewords();
        this.setRowNumbers(), this.removeIncorrectCodewords(e, t);
        for(var r = this.getBoundingBox(), n = this._isLeft ? r.getTopLeft() : r.getTopRight(), o = this._isLeft ? r.getBottomLeft() : r.getBottomRight(), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.imageRowToCodewordIndex(Math.trunc(o.getY())), s = -1, u = 1, c = 0, f = i; f < a; f++)if (null != e[f]) {
            var h = e[f], l = h.getRowNumber() - s;
            if (0 === l) c++;
            else if (1 === l) u = Math.max(u, c), c = 1, s = h.getRowNumber();
            else if (l < 0 || h.getRowNumber() >= t.getRowCount() || l > f) e[f] = null;
            else {
                for(var d = void 0, p = (d = u > 2 ? (u - 2) * l : l) >= f, g = 1; g <= d && !p; g++)p = null != e[f - g];
                p ? e[f] = null : (s = h.getRowNumber(), c = 1);
            }
        }
    }, e.prototype.getRowHeights = function() {
        var t, e, r = this.getBarcodeMetadata();
        if (null == r) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(r);
        var n = new Int32Array(r.getRowCount());
        try {
            for(var o = $849102574a83a574$var$Yn(this.getCodewords()), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (null != a) {
                    var s = a.getRowNumber();
                    if (s >= n.length) continue;
                    n[s]++;
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return n;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(t) {
        for(var e = this.getBoundingBox(), r = this._isLeft ? e.getTopLeft() : e.getTopRight(), n = this._isLeft ? e.getBottomLeft() : e.getBottomRight(), o = this.imageRowToCodewordIndex(Math.trunc(r.getY())), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.getCodewords(), s = -1, u = o; u < i; u++)if (null != a[u]) {
            var c = a[u];
            c.setRowNumberAsRowIndicatorColumn();
            var f = c.getRowNumber() - s;
            0 === f || (1 === f ? s = c.getRowNumber() : c.getRowNumber() >= t.getRowCount() ? a[u] = null : s = c.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
        var t, e, r = this.getCodewords(), n = new $849102574a83a574$var$zn, o = new $849102574a83a574$var$zn, i = new $849102574a83a574$var$zn, a = new $849102574a83a574$var$zn;
        try {
            for(var s = $849102574a83a574$var$Yn(r), u = s.next(); !u.done; u = s.next()){
                var c = u.value;
                if (null != c) {
                    c.setRowNumberAsRowIndicatorColumn();
                    var f = c.getValue() % 30, h = c.getRowNumber();
                    switch(this._isLeft || (h += 2), h % 3){
                        case 0:
                            o.setValue(3 * f + 1);
                            break;
                        case 1:
                            a.setValue(f / 3), i.setValue(f % 3);
                            break;
                        case 2:
                            n.setValue(f + 1);
                    }
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                u && !u.done && (e = s.return) && e.call(s);
            } finally{
                if (t) throw t.error;
            }
        }
        if (0 === n.getValue().length || 0 === o.getValue().length || 0 === i.getValue().length || 0 === a.getValue().length || n.getValue()[0] < 1 || o.getValue()[0] + i.getValue()[0] < $849102574a83a574$var$On.MIN_ROWS_IN_BARCODE || o.getValue()[0] + i.getValue()[0] > $849102574a83a574$var$On.MAX_ROWS_IN_BARCODE) return null;
        var l = new $849102574a83a574$var$Vn(n.getValue()[0], o.getValue()[0], i.getValue()[0], a.getValue()[0]);
        return this.removeIncorrectCodewords(r, l), l;
    }, e.prototype.removeIncorrectCodewords = function(t, e) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            if (null != t[r]) {
                var o = n.getValue() % 30, i = n.getRowNumber();
                if (i > e.getRowCount()) t[r] = null;
                else switch(this._isLeft || (i += 2), i % 3){
                    case 0:
                        3 * o + 1 !== e.getRowCountUpperPart() && (t[r] = null);
                        break;
                    case 1:
                        Math.trunc(o / 3) === e.getErrorCorrectionLevel() && o % 3 === e.getRowCountLowerPart() || (t[r] = null);
                        break;
                    case 2:
                        o + 1 !== e.getColumnCount() && (t[r] = null);
                }
            }
        }
    }, e.prototype.isLeft = function() {
        return this._isLeft;
    }, e.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + t.prototype.toString.call(this);
    }, e;
}($849102574a83a574$var$Xn), $849102574a83a574$var$Kn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$qn = function() {
    function t(t, e) {
        this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = t, this.barcodeColumnCount = t.getColumnCount(), this.boundingBox = e, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return t.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var t, e = $849102574a83a574$var$On.MAX_CODEWORDS_IN_BARCODE;
        do t = e, e = this.adjustRowNumbersAndGetCount();
        while (e > 0 && e < t);
        return this.detectionResultColumns;
    }, t.prototype.adjustIndicatorColumnRowNumbers = function(t) {
        null != t && t.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, t.prototype.adjustRowNumbersAndGetCount = function() {
        var t = this.adjustRowNumbersByRow();
        if (0 === t) return 0;
        for(var e = 1; e < this.barcodeColumnCount + 1; e++)for(var r = this.detectionResultColumns[e].getCodewords(), n = 0; n < r.length; n++)null != r[n] && (r[n].hasValidRowNumber() || this.adjustRowNumbers(e, n, r));
        return t;
    }, t.prototype.adjustRowNumbersByRow = function() {
        return this.adjustRowNumbersFromBothRI(), this.adjustRowNumbersFromLRI() + this.adjustRowNumbersFromRRI();
    }, t.prototype.adjustRowNumbersFromBothRI = function() {
        if (null != this.detectionResultColumns[0] && null != this.detectionResultColumns[this.barcodeColumnCount + 1]) {
            for(var t = this.detectionResultColumns[0].getCodewords(), e = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < t.length; r++)if (null != t[r] && null != e[r] && t[r].getRowNumber() === e[r].getRowNumber()) for(var n = 1; n <= this.barcodeColumnCount; n++){
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o && (o.setRowNumber(t[r].getRowNumber()), o.hasValidRowNumber() || (this.detectionResultColumns[n].getCodewords()[r] = null));
            }
        }
    }, t.prototype.adjustRowNumbersFromRRI = function() {
        if (null == this.detectionResultColumns[this.barcodeColumnCount + 1]) return 0;
        for(var e = 0, r = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = this.barcodeColumnCount + 1; a > 0 && i < this.ADJUST_ROW_NUMBER_SKIP; a--){
            var s = this.detectionResultColumns[a].getCodewords()[n];
            null != s && (i = t.adjustRowNumberIfValid(o, i, s), s.hasValidRowNumber() || e++);
        }
        return e;
    }, t.prototype.adjustRowNumbersFromLRI = function() {
        if (null == this.detectionResultColumns[0]) return 0;
        for(var e = 0, r = this.detectionResultColumns[0].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = 1; a < this.barcodeColumnCount + 1 && i < this.ADJUST_ROW_NUMBER_SKIP; a++){
            var s = this.detectionResultColumns[a].getCodewords()[n];
            null != s && (i = t.adjustRowNumberIfValid(o, i, s), s.hasValidRowNumber() || e++);
        }
        return e;
    }, t.adjustRowNumberIfValid = function(t, e, r) {
        return null == r || r.hasValidRowNumber() || (r.isValidRowNumber(t) ? (r.setRowNumber(t), e = 0) : ++e), e;
    }, t.prototype.adjustRowNumbers = function(e, r, n) {
        var o, i;
        if (null != this.detectionResultColumns[e - 1]) {
            var a = n[r], s = this.detectionResultColumns[e - 1].getCodewords(), u = s;
            null != this.detectionResultColumns[e + 1] && (u = this.detectionResultColumns[e + 1].getCodewords());
            var c = new Array(14);
            c[2] = s[r], c[3] = u[r], r > 0 && (c[0] = n[r - 1], c[4] = s[r - 1], c[5] = u[r - 1]), r > 1 && (c[8] = n[r - 2], c[10] = s[r - 2], c[11] = u[r - 2]), r < n.length - 1 && (c[1] = n[r + 1], c[6] = s[r + 1], c[7] = u[r + 1]), r < n.length - 2 && (c[9] = n[r + 2], c[12] = s[r + 2], c[13] = u[r + 2]);
            try {
                for(var f = $849102574a83a574$var$Kn(c), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (t.adjustRowNumber(a, l)) return;
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
        }
    }, t.adjustRowNumber = function(t, e) {
        return null != e && !(!e.hasValidRowNumber() || e.getBucket() !== t.getBucket()) && (t.setRowNumber(e.getRowNumber()), !0);
    }, t.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    }, t.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    }, t.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    }, t.prototype.setBoundingBox = function(t) {
        this.boundingBox = t;
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.setDetectionResultColumn = function(t, e) {
        this.detectionResultColumns[t] = e;
    }, t.prototype.getDetectionResultColumn = function(t) {
        return this.detectionResultColumns[t];
    }, t.prototype.toString = function() {
        var t = this.detectionResultColumns[0];
        null == t && (t = this.detectionResultColumns[this.barcodeColumnCount + 1]);
        for(var e = new $849102574a83a574$var$Hn, r = 0; r < t.getCodewords().length; r++){
            e.format("CW %3d:", r);
            for(var n = 0; n < this.barcodeColumnCount + 2; n++)if (null != this.detectionResultColumns[n]) {
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o ? e.format(" %3d|%3d", o.getRowNumber(), o.getValue()) : e.format("    |   ");
            } else e.format("    |   ");
            e.format("%n");
        }
        return e.toString();
    }, t;
}(), $849102574a83a574$var$Qn = function() {
    function t(e, r, n, o) {
        this.rowNumber = t.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(r), this.bucket = Math.trunc(n), this.value = Math.trunc(o);
    }
    return t.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    }, t.prototype.isValidRowNumber = function(e) {
        return e !== t.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, t.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(3 * Math.trunc(this.value / 30) + Math.trunc(this.bucket / 3));
    }, t.prototype.getWidth = function() {
        return this.endX - this.startX;
    }, t.prototype.getStartX = function() {
        return this.startX;
    }, t.prototype.getEndX = function() {
        return this.endX;
    }, t.prototype.getBucket = function() {
        return this.bucket;
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.setRowNumber = function(t) {
        this.rowNumber = t;
    }, t.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    }, t.BARCODE_ROW_UNKNOWN = -1, t;
}(), $849102574a83a574$var$Jn = function() {
    function t() {}
    return t.initialize = function() {
        for(var e = 0; e < $849102574a83a574$var$On.SYMBOL_TABLE.length; e++)for(var r = $849102574a83a574$var$On.SYMBOL_TABLE[e], n = 1 & r, o = 0; o < $849102574a83a574$var$On.BARS_IN_MODULE; o++){
            for(var i = 0; (1 & r) === n;)i += 1, r >>= 1;
            n = 1 & r, t.RATIOS_TABLE[e] || (t.RATIOS_TABLE[e] = new Array($849102574a83a574$var$On.BARS_IN_MODULE)), t.RATIOS_TABLE[e][$849102574a83a574$var$On.BARS_IN_MODULE - o - 1] = Math.fround(i / $849102574a83a574$var$On.MODULES_IN_CODEWORD);
        }
        this.bSymbolTableReady = !0;
    }, t.getDecodedValue = function(e) {
        var r = t.getDecodedCodewordValue(t.sampleBitCounts(e));
        return -1 !== r ? r : t.getClosestDecodedValue(e);
    }, t.sampleBitCounts = function(t) {
        for(var e = $849102574a83a574$var$Pt.sum(t), r = new Int32Array($849102574a83a574$var$On.BARS_IN_MODULE), n = 0, o = 0, i = 0; i < $849102574a83a574$var$On.MODULES_IN_CODEWORD; i++){
            var a = e / (2 * $849102574a83a574$var$On.MODULES_IN_CODEWORD) + i * e / $849102574a83a574$var$On.MODULES_IN_CODEWORD;
            o + t[n] <= a && (o += t[n], n++), r[n]++;
        }
        return r;
    }, t.getDecodedCodewordValue = function(e) {
        var r = t.getBitValue(e);
        return -1 === $849102574a83a574$var$On.getCodeword(r) ? -1 : r;
    }, t.getBitValue = function(t) {
        for(var e = 0, r = 0; r < t.length; r++)for(var n = 0; n < t[r]; n++)e = e << 1 | (r % 2 == 0 ? 1 : 0);
        return Math.trunc(e);
    }, t.getClosestDecodedValue = function(e) {
        var r = $849102574a83a574$var$Pt.sum(e), n = new Array($849102574a83a574$var$On.BARS_IN_MODULE);
        if (r > 1) for(var o = 0; o < n.length; o++)n[o] = Math.fround(e[o] / r);
        var i = $849102574a83a574$var$Bt.MAX_VALUE, a = -1;
        this.bSymbolTableReady || t.initialize();
        for(var s = 0; s < t.RATIOS_TABLE.length; s++){
            for(var u = 0, c = t.RATIOS_TABLE[s], f = 0; f < $849102574a83a574$var$On.BARS_IN_MODULE; f++){
                var h = Math.fround(c[f] - n[f]);
                if ((u += Math.fround(h * h)) >= i) break;
            }
            u < i && (i = u, a = $849102574a83a574$var$On.SYMBOL_TABLE[s]);
        }
        return a;
    }, t.bSymbolTableReady = !1, t.RATIOS_TABLE = new Array($849102574a83a574$var$On.SYMBOL_TABLE.length).map(function(t) {
        return new Array($849102574a83a574$var$On.BARS_IN_MODULE);
    }), t;
}(), $849102574a83a574$var$$n = function() {
    function t() {
        this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return t.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, t.prototype.setSegmentIndex = function(t) {
        this.segmentIndex = t;
    }, t.prototype.getFileId = function() {
        return this.fileId;
    }, t.prototype.setFileId = function(t) {
        this.fileId = t;
    }, t.prototype.getOptionalData = function() {
        return this.optionalData;
    }, t.prototype.setOptionalData = function(t) {
        this.optionalData = t;
    }, t.prototype.isLastSegment = function() {
        return this.lastSegment;
    }, t.prototype.setLastSegment = function(t) {
        this.lastSegment = t;
    }, t.prototype.getSegmentCount = function() {
        return this.segmentCount;
    }, t.prototype.setSegmentCount = function(t) {
        this.segmentCount = t;
    }, t.prototype.getSender = function() {
        return this.sender || null;
    }, t.prototype.setSender = function(t) {
        this.sender = t;
    }, t.prototype.getAddressee = function() {
        return this.addressee || null;
    }, t.prototype.setAddressee = function(t) {
        this.addressee = t;
    }, t.prototype.getFileName = function() {
        return this.fileName;
    }, t.prototype.setFileName = function(t) {
        this.fileName = t;
    }, t.prototype.getFileSize = function() {
        return this.fileSize;
    }, t.prototype.setFileSize = function(t) {
        this.fileSize = t;
    }, t.prototype.getChecksum = function() {
        return this.checksum;
    }, t.prototype.setChecksum = function(t) {
        this.checksum = t;
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.setTimestamp = function(t) {
        this.timestamp = t;
    }, t;
}(), $849102574a83a574$var$to = function() {
    function t() {}
    return t.parseLong = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t;
}(), $849102574a83a574$var$eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ro = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$eo(e, t), e.kind = "NullPointerException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$no = function() {
    function t() {}
    return t.prototype.writeBytes = function(t) {
        this.writeBytesOffset(t, 0, t.length);
    }, t.prototype.writeBytesOffset = function(t, e, r) {
        if (null == t) throw new $849102574a83a574$var$ro;
        if (e < 0 || e > t.length || r < 0 || e + r > t.length || e + r < 0) throw new $849102574a83a574$var$P;
        if (0 !== r) for(var n = 0; n < r; n++)this.write(t[e + n]);
    }, t.prototype.flush = function() {}, t.prototype.close = function() {}, t;
}(), $849102574a83a574$var$oo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$io = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$oo(e, t), e;
}($849102574a83a574$var$m), $849102574a83a574$var$ao = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$so = function(t) {
    function e(e) {
        void 0 === e && (e = 32);
        var r = t.call(this) || this;
        if (r.count = 0, e < 0) throw new $849102574a83a574$var$T("Negative initial size: " + e);
        return r.buf = new Uint8Array(e), r;
    }
    return $849102574a83a574$var$ao(e, t), e.prototype.ensureCapacity = function(t) {
        t - this.buf.length > 0 && this.grow(t);
    }, e.prototype.grow = function(t) {
        var e = this.buf.length << 1;
        if (e - t < 0 && (e = t), e < 0) {
            if (t < 0) throw new $849102574a83a574$var$io;
            e = $849102574a83a574$var$x.MAX_VALUE;
        }
        this.buf = $849102574a83a574$var$k.copyOfUint8Array(this.buf, e);
    }, e.prototype.write = function(t) {
        this.ensureCapacity(this.count + 1), this.buf[this.count] = t, this.count += 1;
    }, e.prototype.writeBytesOffset = function(t, e, r) {
        if (e < 0 || e > t.length || r < 0 || e + r - t.length > 0) throw new $849102574a83a574$var$P;
        this.ensureCapacity(this.count + r), $849102574a83a574$var$D.arraycopy(t, e, this.buf, this.count, r), this.count += r;
    }, e.prototype.writeTo = function(t) {
        t.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
        this.count = 0;
    }, e.prototype.toByteArray = function() {
        return $849102574a83a574$var$k.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
        return this.count;
    }, e.prototype.toString = function(t) {
        return t ? "string" == typeof t ? this.toString_string(t) : this.toString_number(t) : this.toString_void();
    }, e.prototype.toString_void = function() {
        return new String(this.buf).toString();
    }, e.prototype.toString_string = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.toString_number = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.close = function() {}, e;
}($849102574a83a574$var$no);
function $849102574a83a574$var$uo() {
    if ("undefined" != typeof window) return window.BigInt || null;
    if ("undefined" != typeof $parcel$global) return $parcel$global.BigInt || null;
    if ("undefined" != typeof self) return self.BigInt || null;
    throw new Error("Can't search globals for BigInt!");
}
function $849102574a83a574$var$co(t) {
    if (void 0 === $849102574a83a574$var$cn && ($849102574a83a574$var$cn = $849102574a83a574$var$uo()), null === $849102574a83a574$var$cn) throw new Error("BigInt is not supported!");
    return $849102574a83a574$var$cn(t);
}
!function(t) {
    t[t.ALPHA = 0] = "ALPHA", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.PUNCT = 3] = "PUNCT", t[t.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", t[t.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
}($849102574a83a574$var$un || ($849102574a83a574$var$un = {}));
var $849102574a83a574$var$fo = function() {
    function t() {}
    return t.decode = function(e, r) {
        var n = new $849102574a83a574$var$Q(""), o = $849102574a83a574$var$j.ISO8859_1;
        n.enableDecoding(o);
        for(var i = 1, a = e[i++], s = new $849102574a83a574$var$$n; i < e[0];){
            switch(a){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    i = t.textCompaction(e, i, n);
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                    i = t.byteCompaction(a, e, o, i, n);
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    n.append(e[i++]);
                    break;
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                    i = t.numericCompaction(e, i, n);
                    break;
                case t.ECI_CHARSET:
                    $849102574a83a574$var$j.getCharacterSetECIByValue(e[i++]);
                    break;
                case t.ECI_GENERAL_PURPOSE:
                    i += 2;
                    break;
                case t.ECI_USER_DEFINED:
                    i++;
                    break;
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    i = t.decodeMacroBlock(e, i, s);
                    break;
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    throw new $849102574a83a574$var$G;
                default:
                    i--, i = t.textCompaction(e, i, n);
            }
            if (!(i < e.length)) throw $849102574a83a574$var$G.getFormatInstance();
            a = e[i++];
        }
        if (0 === n.length()) throw $849102574a83a574$var$G.getFormatInstance();
        var u = new $849102574a83a574$var$At(null, n.toString(), null, r);
        return u.setOther(s), u;
    }, t.decodeMacroBlock = function(e, r, n) {
        if (r + t.NUMBER_OF_SEQUENCE_CODEWORDS > e[0]) throw $849102574a83a574$var$G.getFormatInstance();
        for(var o = new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS), i = 0; i < t.NUMBER_OF_SEQUENCE_CODEWORDS; i++, r++)o[i] = e[r];
        n.setSegmentIndex($849102574a83a574$var$x.parseInt(t.decodeBase900toBase10(o, t.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var a = new $849102574a83a574$var$Q;
        r = t.textCompaction(e, r, a), n.setFileId(a.toString());
        var s = -1;
        for(e[r] === t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (s = r + 1); r < e[0];)switch(e[r]){
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                switch(e[++r]){
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var u = new $849102574a83a574$var$Q;
                        r = t.textCompaction(e, r + 1, u), n.setFileName(u.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var c = new $849102574a83a574$var$Q;
                        r = t.textCompaction(e, r + 1, c), n.setSender(c.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var f = new $849102574a83a574$var$Q;
                        r = t.textCompaction(e, r + 1, f), n.setAddressee(f.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var h = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, h), n.setSegmentCount($849102574a83a574$var$x.parseInt(h.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var l = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, l), n.setTimestamp($849102574a83a574$var$to.parseLong(l.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var d = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, d), n.setChecksum($849102574a83a574$var$x.parseInt(d.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var p = new $849102574a83a574$var$Q;
                        r = t.numericCompaction(e, r + 1, p), n.setFileSize($849102574a83a574$var$to.parseLong(p.toString()));
                        break;
                    default:
                        throw $849102574a83a574$var$G.getFormatInstance();
                }
                break;
            case t.MACRO_PDF417_TERMINATOR:
                r++, n.setLastSegment(!0);
                break;
            default:
                throw $849102574a83a574$var$G.getFormatInstance();
        }
        if (-1 !== s) {
            var g = r - s;
            n.isLastSegment() && g--, n.setOptionalData($849102574a83a574$var$k.copyOfRange(e, s, s + g));
        }
        return r;
    }, t.textCompaction = function(e, r, n) {
        for(var o = new Int32Array(2 * (e[0] - r)), i = new Int32Array(2 * (e[0] - r)), a = 0, s = !1; r < e[0] && !s;){
            var u = e[r++];
            if (u < t.TEXT_COMPACTION_MODE_LATCH) o[a] = u / 30, o[a + 1] = u % 30, a += 2;
            else switch(u){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    o[a++] = t.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, s = !0;
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    o[a] = t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, u = e[r++], i[a] = u, a++;
            }
        }
        return t.decodeTextCompaction(o, i, a, n), r;
    }, t.decodeTextCompaction = function(e, r, n, o) {
        for(var i = $849102574a83a574$var$un.ALPHA, a = $849102574a83a574$var$un.ALPHA, s = 0; s < n;){
            var u = e[s], c = "";
            switch(i){
                case $849102574a83a574$var$un.ALPHA:
                    if (u < 26) c = String.fromCharCode(65 + u);
                    else switch(u){
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $849102574a83a574$var$un.LOWER;
                            break;
                        case t.ML:
                            i = $849102574a83a574$var$un.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $849102574a83a574$var$un.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.LOWER:
                    if (u < 26) c = String.fromCharCode(97 + u);
                    else switch(u){
                        case 26:
                            c = " ";
                            break;
                        case t.AS:
                            a = i, i = $849102574a83a574$var$un.ALPHA_SHIFT;
                            break;
                        case t.ML:
                            i = $849102574a83a574$var$un.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $849102574a83a574$var$un.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.MIXED:
                    if (u < t.PL) c = t.MIXED_CHARS[u];
                    else switch(u){
                        case t.PL:
                            i = $849102574a83a574$var$un.PUNCT;
                            break;
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $849102574a83a574$var$un.LOWER;
                            break;
                        case t.AL:
                            i = $849102574a83a574$var$un.ALPHA;
                            break;
                        case t.PS:
                            a = i, i = $849102574a83a574$var$un.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.PUNCT:
                    if (u < t.PAL) c = t.PUNCT_CHARS[u];
                    else switch(u){
                        case t.PAL:
                            i = $849102574a83a574$var$un.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.ALPHA_SHIFT:
                    if (i = a, u < 26) c = String.fromCharCode(65 + u);
                    else switch(u){
                        case 26:
                            c = " ";
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
                    break;
                case $849102574a83a574$var$un.PUNCT_SHIFT:
                    if (i = a, u < t.PAL) c = t.PUNCT_CHARS[u];
                    else switch(u){
                        case t.PAL:
                            i = $849102574a83a574$var$un.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[s]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $849102574a83a574$var$un.ALPHA;
                    }
            }
            "" !== c && o.append(c), s++;
        }
    }, t.byteCompaction = function(e, r, n, o, i) {
        var a = new $849102574a83a574$var$so, s = 0, u = 0, c = !1;
        switch(e){
            case t.BYTE_COMPACTION_MODE_LATCH:
                for(var f = new Int32Array(6), h = r[o++]; o < r[0] && !c;)switch(f[s++] = h, u = 900 * u + h, h = r[o++]){
                    case t.TEXT_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH:
                    case t.NUMERIC_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH_6:
                    case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case t.MACRO_PDF417_TERMINATOR:
                        o--, c = !0;
                        break;
                    default:
                        if (s % 5 == 0 && s > 0) {
                            for(var l = 0; l < 6; ++l)a.write(Number($849102574a83a574$var$co(u) >> $849102574a83a574$var$co(8 * (5 - l))));
                            u = 0, s = 0;
                        }
                }
                o === r[0] && h < t.TEXT_COMPACTION_MODE_LATCH && (f[s++] = h);
                for(var d = 0; d < s; d++)a.write(f[d]);
                break;
            case t.BYTE_COMPACTION_MODE_LATCH_6:
                for(; o < r[0] && !c;){
                    var p = r[o++];
                    if (p < t.TEXT_COMPACTION_MODE_LATCH) s++, u = 900 * u + p;
                    else switch(p){
                        case t.TEXT_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH:
                        case t.NUMERIC_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH_6:
                        case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case t.MACRO_PDF417_TERMINATOR:
                            o--, c = !0;
                    }
                    if (s % 5 == 0 && s > 0) {
                        for(l = 0; l < 6; ++l)a.write(Number($849102574a83a574$var$co(u) >> $849102574a83a574$var$co(8 * (5 - l))));
                        u = 0, s = 0;
                    }
                }
        }
        return i.append($849102574a83a574$var$K.decode(a.toByteArray(), n)), o;
    }, t.numericCompaction = function(e, r, n) {
        for(var o = 0, i = !1, a = new Int32Array(t.MAX_NUMERIC_CODEWORDS); r < e[0] && !i;){
            var s = e[r++];
            if (r === e[0] && (i = !0), s < t.TEXT_COMPACTION_MODE_LATCH) a[o] = s, o++;
            else switch(s){
                case t.TEXT_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, i = !0;
            }
            (o % t.MAX_NUMERIC_CODEWORDS == 0 || s === t.NUMERIC_COMPACTION_MODE_LATCH || i) && o > 0 && (n.append(t.decodeBase900toBase10(a, o)), o = 0);
        }
        return r;
    }, t.decodeBase900toBase10 = function(e, r) {
        for(var n = $849102574a83a574$var$co(0), o = 0; o < r; o++)n += t.EXP900[r - o - 1] * $849102574a83a574$var$co(e[o]);
        var i = n.toString();
        if ("1" !== i.charAt(0)) throw new $849102574a83a574$var$G;
        return i.substring(1);
    }, t.TEXT_COMPACTION_MODE_LATCH = 900, t.BYTE_COMPACTION_MODE_LATCH = 901, t.NUMERIC_COMPACTION_MODE_LATCH = 902, t.BYTE_COMPACTION_MODE_LATCH_6 = 924, t.ECI_USER_DEFINED = 925, t.ECI_GENERAL_PURPOSE = 926, t.ECI_CHARSET = 927, t.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, t.MACRO_PDF417_TERMINATOR = 922, t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, t.MAX_NUMERIC_CODEWORDS = 15, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, t.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, t.PL = 25, t.LL = 27, t.AS = 27, t.ML = 28, t.AL = 28, t.PS = 29, t.PAL = 29, t.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'", t.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", t.EXP900 = $849102574a83a574$var$uo() ? function() {
        var t = [];
        t[0] = $849102574a83a574$var$co(1);
        var e = $849102574a83a574$var$co(900);
        t[1] = e;
        for(var r = 2; r < 16; r++)t[r] = t[r - 1] * e;
        return t;
    }() : [], t.NUMBER_OF_SEQUENCE_CODEWORDS = 2, t;
}(), $849102574a83a574$var$ho = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$lo = function() {
    function t() {}
    return t.decode = function(e, r, n, o, i, a, s) {
        for(var u, c = new $849102574a83a574$var$xn(e, r, n, o, i), f = null, h = null, l = !0;; l = !1){
            if (null != r && (f = t.getRowIndicatorColumn(e, c, r, !0, a, s)), null != o && (h = t.getRowIndicatorColumn(e, c, o, !1, a, s)), null == (u = t.merge(f, h))) throw $849102574a83a574$var$tt.getNotFoundInstance();
            var d = u.getBoundingBox();
            if (!l || null == d || !(d.getMinY() < c.getMinY() || d.getMaxY() > c.getMaxY())) break;
            c = d;
        }
        u.setBoundingBox(c);
        var p = u.getBarcodeColumnCount() + 1;
        u.setDetectionResultColumn(0, f), u.setDetectionResultColumn(p, h);
        for(var g = null != f, y = 1; y <= p; y++){
            var w = g ? y : p - y;
            if (void 0 === u.getDetectionResultColumn(w)) {
                var v = void 0;
                v = 0 === w || w === p ? new $849102574a83a574$var$Zn(c, 0 === w) : new $849102574a83a574$var$Xn(c), u.setDetectionResultColumn(w, v);
                for(var _ = -1, A = _, C = c.getMinY(); C <= c.getMaxY(); C++){
                    if ((_ = t.getStartColumn(u, w, C, g)) < 0 || _ > c.getMaxX()) {
                        if (-1 === A) continue;
                        _ = A;
                    }
                    var m = t.detectCodeword(e, c.getMinX(), c.getMaxX(), g, _, C, a, s);
                    null != m && (v.setCodeword(C, m), A = _, a = Math.min(a, m.getWidth()), s = Math.max(s, m.getWidth()));
                }
            }
        }
        return t.createDecoderResult(u);
    }, t.merge = function(e, r) {
        if (null == e && null == r) return null;
        var n = t.getBarcodeMetadata(e, r);
        if (null == n) return null;
        var o = $849102574a83a574$var$xn.merge(t.adjustBoundingBox(e), t.adjustBoundingBox(r));
        return new $849102574a83a574$var$qn(n, o);
    }, t.adjustBoundingBox = function(e) {
        var r, n;
        if (null == e) return null;
        var o = e.getRowHeights();
        if (null == o) return null;
        var i = t.getMax(o), a = 0;
        try {
            for(var s = $849102574a83a574$var$ho(o), u = s.next(); !u.done; u = s.next()){
                var c = u.value;
                if (a += i - c, c > 0) break;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
        for(var f = e.getCodewords(), h = 0; a > 0 && null == f[h]; h++)a--;
        var l = 0;
        for(h = o.length - 1; h >= 0 && (l += i - o[h], !(o[h] > 0)); h--);
        for(h = f.length - 1; l > 0 && null == f[h]; h--)l--;
        return e.getBoundingBox().addMissingRows(a, l, e.isLeft());
    }, t.getMax = function(t) {
        var e, r, n = -1;
        try {
            for(var o = $849102574a83a574$var$ho(t), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                n = Math.max(n, a);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.getBarcodeMetadata = function(t, e) {
        var r, n;
        return null == t || null == (r = t.getBarcodeMetadata()) ? null == e ? null : e.getBarcodeMetadata() : null == e || null == (n = e.getBarcodeMetadata()) ? r : r.getColumnCount() !== n.getColumnCount() && r.getErrorCorrectionLevel() !== n.getErrorCorrectionLevel() && r.getRowCount() !== n.getRowCount() ? null : r;
    }, t.getRowIndicatorColumn = function(e, r, n, o, i, a) {
        for(var s = new $849102574a83a574$var$Zn(r, o), u = 0; u < 2; u++)for(var c = 0 === u ? 1 : -1, f = Math.trunc(Math.trunc(n.getX())), h = Math.trunc(Math.trunc(n.getY())); h <= r.getMaxY() && h >= r.getMinY(); h += c){
            var l = t.detectCodeword(e, 0, e.getWidth(), o, f, h, i, a);
            null != l && (s.setCodeword(h, l), f = o ? l.getStartX() : l.getEndX());
        }
        return s;
    }, t.adjustCodewordCount = function(e, r) {
        var n = r[0][1], o = n.getValue(), i = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - t.getNumberOfECCodeWords(e.getBarcodeECLevel());
        if (0 === o.length) {
            if (i < 1 || i > $849102574a83a574$var$On.MAX_CODEWORDS_IN_BARCODE) throw $849102574a83a574$var$tt.getNotFoundInstance();
            n.setValue(i);
        } else o[0] !== i && n.setValue(i);
    }, t.createDecoderResult = function(e) {
        var r = t.createBarcodeMatrix(e);
        t.adjustCodewordCount(e, r);
        for(var n = new Array, o = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), i = [], a = new Array, s = 0; s < e.getBarcodeRowCount(); s++)for(var u = 0; u < e.getBarcodeColumnCount(); u++){
            var c = r[s][u + 1].getValue(), f = s * e.getBarcodeColumnCount() + u;
            0 === c.length ? n.push(f) : 1 === c.length ? o[f] = c[0] : (a.push(f), i.push(c));
        }
        for(var h = new Array(i.length), l = 0; l < h.length; l++)h[l] = i[l];
        return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), o, $849102574a83a574$var$On.toIntArray(n), $849102574a83a574$var$On.toIntArray(a), h);
    }, t.createDecoderResultFromAmbiguousValues = function(e, r, n, o, i) {
        for(var a = new Int32Array(o.length), s = 100; s-- > 0;){
            for(var u = 0; u < a.length; u++)r[o[u]] = i[u][a[u]];
            try {
                return t.decodeCodewords(r, e, n);
            } catch (t) {
                if (!(t instanceof $849102574a83a574$var$R)) throw t;
            }
            if (0 === a.length) throw $849102574a83a574$var$R.getChecksumInstance();
            for(u = 0; u < a.length; u++){
                if (a[u] < i[u].length - 1) {
                    a[u]++;
                    break;
                }
                if (a[u] = 0, u === a.length - 1) throw $849102574a83a574$var$R.getChecksumInstance();
            }
        }
        throw $849102574a83a574$var$R.getChecksumInstance();
    }, t.createBarcodeMatrix = function(t) {
        for(var e, r, n, o, i = Array.from({
            length: t.getBarcodeRowCount()
        }, function() {
            return new Array(t.getBarcodeColumnCount() + 2);
        }), a = 0; a < i.length; a++)for(var s = 0; s < i[a].length; s++)i[a][s] = new $849102574a83a574$var$zn;
        var u = 0;
        try {
            for(var c = $849102574a83a574$var$ho(t.getDetectionResultColumns()), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                if (null != h) try {
                    for(var l = (n = void 0, $849102574a83a574$var$ho(h.getCodewords())), d = l.next(); !d.done; d = l.next()){
                        var p = d.value;
                        if (null != p) {
                            var g = p.getRowNumber();
                            if (g >= 0) {
                                if (g >= i.length) continue;
                                i[g][u].setValue(p.getValue());
                            }
                        }
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (o = l.return) && o.call(l);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                u++;
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (r = c.return) && r.call(c);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.isValidBarcodeColumn = function(t, e) {
        return e >= 0 && e <= t.getBarcodeColumnCount() + 1;
    }, t.getStartColumn = function(e, r, n, o) {
        var i, a, s = o ? 1 : -1, u = null;
        if (t.isValidBarcodeColumn(e, r - s) && (u = e.getDetectionResultColumn(r - s).getCodeword(n)), null != u) return o ? u.getEndX() : u.getStartX();
        if (null != (u = e.getDetectionResultColumn(r).getCodewordNearby(n))) return o ? u.getStartX() : u.getEndX();
        if (t.isValidBarcodeColumn(e, r - s) && (u = e.getDetectionResultColumn(r - s).getCodewordNearby(n)), null != u) return o ? u.getEndX() : u.getStartX();
        for(var c = 0; t.isValidBarcodeColumn(e, r - s);){
            r -= s;
            try {
                for(var f = (i = void 0, $849102574a83a574$var$ho(e.getDetectionResultColumn(r).getCodewords())), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (null != l) return (o ? l.getEndX() : l.getStartX()) + s * c * (l.getEndX() - l.getStartX());
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (a = f.return) && a.call(f);
                } finally{
                    if (i) throw i.error;
                }
            }
            c++;
        }
        return o ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, t.detectCodeword = function(e, r, n, o, i, a, s, u) {
        i = t.adjustCodewordStartColumn(e, r, n, o, i, a);
        var c, f = t.getModuleBitCount(e, r, n, o, i, a);
        if (null == f) return null;
        var h = $849102574a83a574$var$Pt.sum(f);
        if (o) c = i + h;
        else {
            for(var l = 0; l < f.length / 2; l++){
                var d = f[l];
                f[l] = f[f.length - 1 - l], f[f.length - 1 - l] = d;
            }
            i = (c = i) - h;
        }
        if (!t.checkCodewordSkew(h, s, u)) return null;
        var p = $849102574a83a574$var$Jn.getDecodedValue(f), g = $849102574a83a574$var$On.getCodeword(p);
        return -1 === g ? null : new $849102574a83a574$var$Qn(i, c, t.getCodewordBucketNumber(p), g);
    }, t.getModuleBitCount = function(t, e, r, n, o, i) {
        for(var a = o, s = new Int32Array(8), u = 0, c = n ? 1 : -1, f = n; (n ? a < r : a >= e) && u < s.length;)t.get(a, i) === f ? (s[u]++, a += c) : (u++, f = !f);
        return u === s.length || a === (n ? r : e) && u === s.length - 1 ? s : null;
    }, t.getNumberOfECCodeWords = function(t) {
        return 2 << t;
    }, t.adjustCodewordStartColumn = function(e, r, n, o, i, a) {
        for(var s = i, u = o ? -1 : 1, c = 0; c < 2; c++){
            for(; (o ? s >= r : s < n) && o === e.get(s, a);){
                if (Math.abs(i - s) > t.CODEWORD_SKEW_SIZE) return i;
                s += u;
            }
            u = -u, o = !o;
        }
        return s;
    }, t.checkCodewordSkew = function(e, r, n) {
        return r - t.CODEWORD_SKEW_SIZE <= e && e <= n + t.CODEWORD_SKEW_SIZE;
    }, t.decodeCodewords = function(e, r, n) {
        if (0 === e.length) throw $849102574a83a574$var$G.getFormatInstance();
        var o = 1 << r + 1, i = t.correctErrors(e, n, o);
        t.verifyCodewordCount(e, o);
        var a = $849102574a83a574$var$fo.decode(e, "" + r);
        return a.setErrorsCorrected(i), a.setErasures(n.length), a;
    }, t.correctErrors = function(e, r, n) {
        if (null != r && r.length > n / 2 + t.MAX_ERRORS || n < 0 || n > t.MAX_EC_CODEWORDS) throw $849102574a83a574$var$R.getChecksumInstance();
        return t.errorCorrection.decode(e, n, r);
    }, t.verifyCodewordCount = function(t, e) {
        if (t.length < 4) throw $849102574a83a574$var$G.getFormatInstance();
        var r = t[0];
        if (r > t.length) throw $849102574a83a574$var$G.getFormatInstance();
        if (0 === r) {
            if (!(e < t.length)) throw $849102574a83a574$var$G.getFormatInstance();
            t[0] = t.length - e;
        }
    }, t.getBitCountForCodeword = function(t) {
        for(var e = new Int32Array(8), r = 0, n = e.length - 1; !((1 & t) !== r && (r = 1 & t, --n < 0));)e[n]++, t >>= 1;
        return e;
    }, t.getCodewordBucketNumber = function(t) {
        return t instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(t) : this.getCodewordBucketNumber_number(t);
    }, t.getCodewordBucketNumber_number = function(e) {
        return t.getCodewordBucketNumber(t.getBitCountForCodeword(e));
    }, t.getCodewordBucketNumber_Int32Array = function(t) {
        return (t[0] - t[2] + t[4] - t[6] + 9) % 9;
    }, t.toString = function(t) {
        for(var e = new $849102574a83a574$var$Hn, r = 0; r < t.length; r++){
            e.format("Row %2d: ", r);
            for(var n = 0; n < t[r].length; n++){
                var o = t[r][n];
                0 === o.getValue().length ? e.format("        ", null) : e.format("%4d(%2d)", o.getValue()[0], o.getConfidence(o.getValue()[0]));
            }
            e.format("%n");
        }
        return e.toString();
    }, t.CODEWORD_SKEW_SIZE = 2, t.MAX_ERRORS = 3, t.MAX_EC_CODEWORDS = 512, t.errorCorrection = new $849102574a83a574$var$kn, t;
}(), $849102574a83a574$var$po = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$go = function() {
    function t() {}
    return t.prototype.decode = function(e, r) {
        void 0 === r && (r = null);
        var n = t.decode(e, r, !1);
        if (null == n || 0 === n.length || null == n[0]) throw $849102574a83a574$var$tt.getNotFoundInstance();
        return n[0];
    }, t.prototype.decodeMultiple = function(e, r) {
        void 0 === r && (r = null);
        try {
            return t.decode(e, r, !0);
        } catch (t) {
            if (t instanceof $849102574a83a574$var$G || t instanceof $849102574a83a574$var$R) throw $849102574a83a574$var$tt.getNotFoundInstance();
            throw t;
        }
    }, t.decode = function(e, r, n) {
        var o, i, a = new Array, s = $849102574a83a574$var$Nn.detectMultiple(e, r, n);
        try {
            for(var u = $849102574a83a574$var$po(s.getPoints()), c = u.next(); !c.done; c = u.next()){
                var f = c.value, h = $849102574a83a574$var$lo.decode(s.getBits(), f[4], f[5], f[6], f[7], t.getMinCodewordWidth(f), t.getMaxCodewordWidth(f)), l = new $849102574a83a574$var$gt(h.getText(), h.getRawBytes(), void 0, f, $849102574a83a574$var$wt.PDF_417);
                l.putMetadata($849102574a83a574$var$_t.ERROR_CORRECTION_LEVEL, h.getECLevel());
                var d = h.getOther();
                null != d && l.putMetadata($849102574a83a574$var$_t.PDF417_EXTRA_METADATA, d), a.push(l);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (i = u.return) && i.call(u);
            } finally{
                if (o) throw o.error;
            }
        }
        return a.map(function(t) {
            return t;
        });
    }, t.getMaxWidth = function(t, e) {
        return null == t || null == e ? 0 : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMinWidth = function(t, e) {
        return null == t || null == e ? $849102574a83a574$var$x.MAX_VALUE : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMaxCodewordWidth = function(e) {
        return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0], e[4]), t.getMaxWidth(e[6], e[2]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN), Math.max(t.getMaxWidth(e[1], e[5]), t.getMaxWidth(e[7], e[3]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN)));
    }, t.getMinCodewordWidth = function(e) {
        return Math.floor(Math.min(Math.min(t.getMinWidth(e[0], e[4]), t.getMinWidth(e[6], e[2]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN), Math.min(t.getMinWidth(e[1], e[5]), t.getMinWidth(e[7], e[3]) * $849102574a83a574$var$On.MODULES_IN_CODEWORD / $849102574a83a574$var$On.MODULES_IN_STOP_PATTERN)));
    }, t.prototype.reset = function() {}, t;
}(), $849102574a83a574$var$yo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$wo = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$yo(e, t), e.kind = "ReaderException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$vo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$_o = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        return this.setHints(e), this.decodeInternal(t);
    }, t.prototype.decodeWithState = function(t) {
        return null !== this.readers && void 0 !== this.readers || this.setHints(null), this.decodeInternal(t);
    }, t.prototype.setHints = function(t) {
        this.hints = t;
        var e = null != t && void 0 !== t.get($849102574a83a574$var$U.TRY_HARDER), r = null == t ? null : t.get($849102574a83a574$var$U.POSSIBLE_FORMATS), n = new Array;
        if (null != r) {
            var o = r.some(function(t) {
                return t === $849102574a83a574$var$wt.UPC_A || t === $849102574a83a574$var$wt.UPC_E || t === $849102574a83a574$var$wt.EAN_13 || t === $849102574a83a574$var$wt.EAN_8 || t === $849102574a83a574$var$wt.CODABAR || t === $849102574a83a574$var$wt.CODE_39 || t === $849102574a83a574$var$wt.CODE_93 || t === $849102574a83a574$var$wt.CODE_128 || t === $849102574a83a574$var$wt.ITF || t === $849102574a83a574$var$wt.RSS_14 || t === $849102574a83a574$var$wt.RSS_EXPANDED;
            });
            o && !e && n.push(new $849102574a83a574$var$Rr(t)), r.includes($849102574a83a574$var$wt.QR_CODE) && n.push(new $849102574a83a574$var$Sn), r.includes($849102574a83a574$var$wt.DATA_MATRIX) && n.push(new $849102574a83a574$var$zr), r.includes($849102574a83a574$var$wt.AZTEC) && n.push(new $849102574a83a574$var$Yt), r.includes($849102574a83a574$var$wt.PDF_417) && n.push(new $849102574a83a574$var$go), o && e && n.push(new $849102574a83a574$var$Rr(t));
        }
        0 === n.length && (e || n.push(new $849102574a83a574$var$Rr(t)), n.push(new $849102574a83a574$var$Sn), n.push(new $849102574a83a574$var$zr), n.push(new $849102574a83a574$var$Yt), n.push(new $849102574a83a574$var$go), e && n.push(new $849102574a83a574$var$Rr(t))), this.readers = n;
    }, t.prototype.reset = function() {
        var t, e;
        if (null !== this.readers) try {
            for(var r = $849102574a83a574$var$vo(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype.decodeInternal = function(t) {
        var e, r;
        if (null === this.readers) throw new $849102574a83a574$var$wo("No readers where selected, nothing can be read.");
        try {
            for(var n = $849102574a83a574$var$vo(this.readers), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                try {
                    return i.decode(t, this.hints);
                } catch (t) {
                    if (t instanceof $849102574a83a574$var$wo) continue;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
        throw new $849102574a83a574$var$tt("No MultiFormat Readers were able to detect the code.");
    }, t;
}(), $849102574a83a574$var$Ao = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Co = function(t) {
    function e(e, r) {
        void 0 === e && (e = null), void 0 === r && (r = 500);
        var n = new $849102574a83a574$var$_o;
        return n.setHints(e), t.call(this, n, r) || this;
    }
    return $849102574a83a574$var$Ao(e, t), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    }, e;
}($849102574a83a574$var$pt), $849102574a83a574$var$mo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$go, e) || this;
    }
    $849102574a83a574$var$mo(e, t);
}($849102574a83a574$var$pt);
var $849102574a83a574$var$Eo, $849102574a83a574$var$Io = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $849102574a83a574$var$Sn, e) || this;
    }
    $849102574a83a574$var$Io(e, t);
}($849102574a83a574$var$pt), function(t) {
    t[t.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", t[t.CHARACTER_SET = 1] = "CHARACTER_SET", t[t.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", t[t.DATA_MATRIX_COMPACT = 3] = "DATA_MATRIX_COMPACT", t[t.MIN_SIZE = 4] = "MIN_SIZE", t[t.MAX_SIZE = 5] = "MAX_SIZE", t[t.MARGIN = 6] = "MARGIN", t[t.PDF417_COMPACT = 7] = "PDF417_COMPACT", t[t.PDF417_COMPACTION = 8] = "PDF417_COMPACTION", t[t.PDF417_DIMENSIONS = 9] = "PDF417_DIMENSIONS", t[t.AZTEC_LAYERS = 10] = "AZTEC_LAYERS", t[t.QR_VERSION = 11] = "QR_VERSION", t[t.GS1_FORMAT = 12] = "GS1_FORMAT", t[t.FORCE_C40 = 13] = "FORCE_C40";
}($849102574a83a574$var$Eo || ($849102574a83a574$var$Eo = {}));
var $849102574a83a574$var$So = $849102574a83a574$var$Eo, $849102574a83a574$var$To = function() {
    function t(t) {
        this.field = t, this.cachedGenerators = [], this.cachedGenerators.push(new $849102574a83a574$var$mt(t, Int32Array.from([
            1
        ])));
    }
    return t.prototype.buildGenerator = function(t) {
        var e = this.cachedGenerators;
        if (t >= e.length) for(var r = e[e.length - 1], n = this.field, o = e.length; o <= t; o++){
            var i = r.multiply(new $849102574a83a574$var$mt(n, Int32Array.from([
                1,
                n.exp(o - 1 + n.getGeneratorBase())
            ])));
            e.push(i), r = i;
        }
        return e[t];
    }, t.prototype.encode = function(t, e) {
        if (0 === e) throw new $849102574a83a574$var$T("No error correction bytes");
        var r = t.length - e;
        if (r <= 0) throw new $849102574a83a574$var$T("No data bytes provided");
        var n = this.buildGenerator(e), o = new Int32Array(r);
        $849102574a83a574$var$D.arraycopy(t, 0, o, 0, r);
        for(var i = new $849102574a83a574$var$mt(this.field, o), a = (i = i.multiplyByMonomial(e, 1)).divide(n)[1].getCoefficients(), s = e - a.length, u = 0; u < s; u++)t[r + u] = 0;
        $849102574a83a574$var$D.arraycopy(a, 0, t, r + s, a.length);
    }, t;
}(), $849102574a83a574$var$Oo = function() {
    function t() {}
    return t.applyMaskPenaltyRule1 = function(e) {
        return t.applyMaskPenaltyRule1Internal(e, !0) + t.applyMaskPenaltyRule1Internal(e, !1);
    }, t.applyMaskPenaltyRule2 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i - 1; a++)for(var s = n[a], u = 0; u < o - 1; u++){
            var c = s[u];
            c === s[u + 1] && c === n[a + 1][u] && c === n[a + 1][u + 1] && r++;
        }
        return t.N2 * r;
    }, t.applyMaskPenaltyRule3 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var s = 0; s < o; s++){
            var u = n[a];
            s + 6 < o && 1 === u[s] && 0 === u[s + 1] && 1 === u[s + 2] && 1 === u[s + 3] && 1 === u[s + 4] && 0 === u[s + 5] && 1 === u[s + 6] && (t.isWhiteHorizontal(u, s - 4, s) || t.isWhiteHorizontal(u, s + 7, s + 11)) && r++, a + 6 < i && 1 === n[a][s] && 0 === n[a + 1][s] && 1 === n[a + 2][s] && 1 === n[a + 3][s] && 1 === n[a + 4][s] && 0 === n[a + 5][s] && 1 === n[a + 6][s] && (t.isWhiteVertical(n, s, a - 4, a) || t.isWhiteVertical(n, s, a + 7, a + 11)) && r++;
        }
        return r * t.N3;
    }, t.isWhiteHorizontal = function(t, e, r) {
        e = Math.max(e, 0), r = Math.min(r, t.length);
        for(var n = e; n < r; n++)if (1 === t[n]) return !1;
        return !0;
    }, t.isWhiteVertical = function(t, e, r, n) {
        r = Math.max(r, 0), n = Math.min(n, t.length);
        for(var o = r; o < n; o++)if (1 === t[o][e]) return !1;
        return !0;
    }, t.applyMaskPenaltyRule4 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var s = n[a], u = 0; u < o; u++)1 === s[u] && r++;
        var c = e.getHeight() * e.getWidth();
        return Math.floor(10 * Math.abs(2 * r - c) / c) * t.N4;
    }, t.getDataMaskBit = function(t, e, r) {
        var n, o;
        switch(t){
            case 0:
                n = r + e & 1;
                break;
            case 1:
                n = 1 & r;
                break;
            case 2:
                n = e % 3;
                break;
            case 3:
                n = (r + e) % 3;
                break;
            case 4:
                n = Math.floor(r / 2) + Math.floor(e / 3) & 1;
                break;
            case 5:
                n = (1 & (o = r * e)) + o % 3;
                break;
            case 6:
                n = (1 & (o = r * e)) + o % 3 & 1;
                break;
            case 7:
                n = (o = r * e) % 3 + (r + e & 1) & 1;
                break;
            default:
                throw new $849102574a83a574$var$T("Invalid mask pattern: " + t);
        }
        return 0 === n;
    }, t.applyMaskPenaltyRule1Internal = function(e, r) {
        for(var n = 0, o = r ? e.getHeight() : e.getWidth(), i = r ? e.getWidth() : e.getHeight(), a = e.getArray(), s = 0; s < o; s++){
            for(var u = 0, c = -1, f = 0; f < i; f++){
                var h = r ? a[s][f] : a[f][s];
                h === c ? u++ : (u >= 5 && (n += t.N1 + (u - 5)), u = 1, c = h);
            }
            u >= 5 && (n += t.N1 + (u - 5));
        }
        return n;
    }, t.N1 = 3, t.N2 = 3, t.N3 = 40, t.N4 = 10, t;
}(), $849102574a83a574$var$bo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Ro = function() {
    function t(t, e) {
        this.width = t, this.height = e;
        for(var r = new Array(e), n = 0; n !== e; n++)r[n] = new Uint8Array(t);
        this.bytes = r;
    }
    return t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.get = function(t, e) {
        return this.bytes[e][t];
    }, t.prototype.getArray = function() {
        return this.bytes;
    }, t.prototype.setNumber = function(t, e, r) {
        this.bytes[e][t] = r;
    }, t.prototype.setBoolean = function(t, e, r) {
        this.bytes[e][t] = r ? 1 : 0;
    }, t.prototype.clear = function(t) {
        var e, r;
        try {
            for(var n = $849102574a83a574$var$bo(this.bytes), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                $849102574a83a574$var$k.fill(i, t);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        if (this.width !== r.width) return !1;
        if (this.height !== r.height) return !1;
        for(var n = 0, o = this.height; n < o; ++n)for(var i = this.bytes[n], a = r.bytes[n], s = 0, u = this.width; s < u; ++s)if (i[s] !== a[s]) return !1;
        return !0;
    }, t.prototype.toString = function() {
        for(var t = new $849102574a83a574$var$Q, e = 0, r = this.height; e < r; ++e){
            for(var n = this.bytes[e], o = 0, i = this.width; o < i; ++o)switch(n[o]){
                case 0:
                    t.append(" 0");
                    break;
                case 1:
                    t.append(" 1");
                    break;
                default:
                    t.append("  ");
            }
            t.append("\n");
        }
        return t.toString();
    }, t;
}(), $849102574a83a574$var$No = function() {
    function t() {
        this.maskPattern = -1;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getVersion = function() {
        return this.version;
    }, t.prototype.getMaskPattern = function() {
        return this.maskPattern;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.toString = function() {
        var t = new $849102574a83a574$var$Q;
        return t.append("<<\n"), t.append(" mode: "), t.append(this.mode ? this.mode.toString() : "null"), t.append("\n ecLevel: "), t.append(this.ecLevel ? this.ecLevel.toString() : "null"), t.append("\n version: "), t.append(this.version ? this.version.toString() : "null"), t.append("\n maskPattern: "), t.append(this.maskPattern.toString()), this.matrix ? (t.append("\n matrix:\n"), t.append(this.matrix.toString())) : t.append("\n matrix: null\n"), t.append(">>\n"), t.toString();
    }, t.prototype.setMode = function(t) {
        this.mode = t;
    }, t.prototype.setECLevel = function(t) {
        this.ecLevel = t;
    }, t.prototype.setVersion = function(t) {
        this.version = t;
    }, t.prototype.setMaskPattern = function(t) {
        this.maskPattern = t;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t.isValidMaskPattern = function(e) {
        return e >= 0 && e < t.NUM_MASK_PATTERNS;
    }, t.NUM_MASK_PATTERNS = 8, t;
}(), $849102574a83a574$var$Do = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Mo = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Do(e, t), e.kind = "WriterException", e;
}($849102574a83a574$var$m), $849102574a83a574$var$Po = function() {
    function t() {}
    return t.clearMatrix = function(t) {
        t.clear(255);
    }, t.buildMatrix = function(e, r, n, o, i) {
        t.clearMatrix(i), t.embedBasicPatterns(n, i), t.embedTypeInfo(r, o, i), t.maybeEmbedVersionInfo(n, i), t.embedDataBits(e, o, i);
    }, t.embedBasicPatterns = function(e, r) {
        t.embedPositionDetectionPatternsAndSeparators(r), t.embedDarkDotAtLeftBottomCorner(r), t.maybeEmbedPositionAdjustmentPatterns(e, r), t.embedTimingPatterns(r);
    }, t.embedTypeInfo = function(e, r, n) {
        var o = new $849102574a83a574$var$V;
        t.makeTypeInfoBits(e, r, o);
        for(var i = 0, a = o.getSize(); i < a; ++i){
            var s = o.get(o.getSize() - 1 - i), u = t.TYPE_INFO_COORDINATES[i], c = u[0], f = u[1];
            if (n.setBoolean(c, f, s), i < 8) {
                var h = n.getWidth() - i - 1, l = 8;
                n.setBoolean(h, l, s);
            } else {
                h = 8, l = n.getHeight() - 7 + (i - 8);
                n.setBoolean(h, l, s);
            }
        }
    }, t.maybeEmbedVersionInfo = function(e, r) {
        if (!(e.getVersionNumber() < 7)) {
            var n = new $849102574a83a574$var$V;
            t.makeVersionInfoBits(e, n);
            for(var o = 17, i = 0; i < 6; ++i)for(var a = 0; a < 3; ++a){
                var s = n.get(o);
                o--, r.setBoolean(i, r.getHeight() - 11 + a, s), r.setBoolean(r.getHeight() - 11 + a, i, s);
            }
        }
    }, t.embedDataBits = function(e, r, n) {
        for(var o = 0, i = -1, a = n.getWidth() - 1, s = n.getHeight() - 1; a > 0;){
            for(6 === a && (a -= 1); s >= 0 && s < n.getHeight();){
                for(var u = 0; u < 2; ++u){
                    var c = a - u;
                    if (t.isEmpty(n.get(c, s))) {
                        var f = void 0;
                        o < e.getSize() ? (f = e.get(o), ++o) : f = !1, 255 !== r && $849102574a83a574$var$Oo.getDataMaskBit(r, c, s) && (f = !f), n.setBoolean(c, s, f);
                    }
                }
                s += i;
            }
            s += i = -i, a -= 2;
        }
        if (o !== e.getSize()) throw new $849102574a83a574$var$Mo("Not all bits consumed: " + o + "/" + e.getSize());
    }, t.findMSBSet = function(t) {
        return 32 - $849102574a83a574$var$x.numberOfLeadingZeros(t);
    }, t.calculateBCHCode = function(e, r) {
        if (0 === r) throw new $849102574a83a574$var$T("0 polynomial");
        var n = t.findMSBSet(r);
        for(e <<= n - 1; t.findMSBSet(e) >= n;)e ^= r << t.findMSBSet(e) - n;
        return e;
    }, t.makeTypeInfoBits = function(e, r, n) {
        if (!$849102574a83a574$var$No.isValidMaskPattern(r)) throw new $849102574a83a574$var$Mo("Invalid mask pattern");
        var o = e.getBits() << 3 | r;
        n.appendBits(o, 5);
        var i = t.calculateBCHCode(o, t.TYPE_INFO_POLY);
        n.appendBits(i, 10);
        var a = new $849102574a83a574$var$V;
        if (a.appendBits(t.TYPE_INFO_MASK_PATTERN, 15), n.xor(a), 15 !== n.getSize()) throw new $849102574a83a574$var$Mo("should not happen but we got: " + n.getSize());
    }, t.makeVersionInfoBits = function(e, r) {
        r.appendBits(e.getVersionNumber(), 6);
        var n = t.calculateBCHCode(e.getVersionNumber(), t.VERSION_INFO_POLY);
        if (r.appendBits(n, 12), 18 !== r.getSize()) throw new $849102574a83a574$var$Mo("should not happen but we got: " + r.getSize());
    }, t.isEmpty = function(t) {
        return 255 === t;
    }, t.embedTimingPatterns = function(e) {
        for(var r = 8; r < e.getWidth() - 8; ++r){
            var n = (r + 1) % 2;
            t.isEmpty(e.get(r, 6)) && e.setNumber(r, 6, n), t.isEmpty(e.get(6, r)) && e.setNumber(6, r, n);
        }
    }, t.embedDarkDotAtLeftBottomCorner = function(t) {
        if (0 === t.get(8, t.getHeight() - 8)) throw new $849102574a83a574$var$Mo;
        t.setNumber(8, t.getHeight() - 8, 1);
    }, t.embedHorizontalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 8; ++o){
            if (!t.isEmpty(n.get(e + o, r))) throw new $849102574a83a574$var$Mo;
            n.setNumber(e + o, r, 0);
        }
    }, t.embedVerticalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o){
            if (!t.isEmpty(n.get(e, r + o))) throw new $849102574a83a574$var$Mo;
            n.setNumber(e, r + o, 0);
        }
    }, t.embedPositionAdjustmentPattern = function(e, r, n) {
        for(var o = 0; o < 5; ++o)for(var i = t.POSITION_ADJUSTMENT_PATTERN[o], a = 0; a < 5; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o)for(var i = t.POSITION_DETECTION_PATTERN[o], a = 0; a < 7; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPatternsAndSeparators = function(e) {
        var r = t.POSITION_DETECTION_PATTERN[0].length;
        t.embedPositionDetectionPattern(0, 0, e), t.embedPositionDetectionPattern(e.getWidth() - r, 0, e), t.embedPositionDetectionPattern(0, e.getWidth() - r, e);
        t.embedHorizontalSeparationPattern(0, 7, e), t.embedHorizontalSeparationPattern(e.getWidth() - 8, 7, e), t.embedHorizontalSeparationPattern(0, e.getWidth() - 8, e);
        t.embedVerticalSeparationPattern(7, 0, e), t.embedVerticalSeparationPattern(e.getHeight() - 7 - 1, 0, e), t.embedVerticalSeparationPattern(7, e.getHeight() - 7, e);
    }, t.maybeEmbedPositionAdjustmentPatterns = function(e, r) {
        if (!(e.getVersionNumber() < 2)) for(var n = e.getVersionNumber() - 1, o = t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n], i = 0, a = o.length; i !== a; i++){
            var s = o[i];
            if (s >= 0) for(var u = 0; u !== a; u++){
                var c = o[u];
                c >= 0 && t.isEmpty(r.get(c, s)) && t.embedPositionAdjustmentPattern(c - 2, s - 2, r);
            }
        }
    }, t.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]), t.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]), t.VERSION_INFO_POLY = 7973, t.TYPE_INFO_POLY = 1335, t.TYPE_INFO_MASK_PATTERN = 21522, t;
}(), $849102574a83a574$var$Bo = function() {
    function t(t, e) {
        this.dataBytes = t, this.errorCorrectionBytes = e;
    }
    return t.prototype.getDataBytes = function() {
        return this.dataBytes;
    }, t.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    }, t;
}(), $849102574a83a574$var$Lo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.calculateMaskPenalty = function(t) {
        return $849102574a83a574$var$Oo.applyMaskPenaltyRule1(t) + $849102574a83a574$var$Oo.applyMaskPenaltyRule2(t) + $849102574a83a574$var$Oo.applyMaskPenaltyRule3(t) + $849102574a83a574$var$Oo.applyMaskPenaltyRule4(t);
    }, t.encode = function(e, r, n) {
        void 0 === n && (n = null);
        var o = t.DEFAULT_BYTE_MODE_ENCODING, i = null !== n && void 0 !== n.get($849102574a83a574$var$So.CHARACTER_SET);
        i && (o = n.get($849102574a83a574$var$So.CHARACTER_SET).toString());
        var a = this.chooseMode(e, o), s = new $849102574a83a574$var$V;
        if (a === $849102574a83a574$var$fn.BYTE && (i || t.DEFAULT_BYTE_MODE_ENCODING !== o)) {
            var u = $849102574a83a574$var$j.getCharacterSetECIByName(o);
            void 0 !== u && this.appendECI(u, s);
        }
        this.appendModeInfo(a, s);
        var c, f = new $849102574a83a574$var$V;
        if (this.appendBytes(e, a, f, o), null !== n && void 0 !== n.get($849102574a83a574$var$So.QR_VERSION)) {
            var h = Number.parseInt(n.get($849102574a83a574$var$So.QR_VERSION).toString(), 10);
            c = $849102574a83a574$var$en.getVersionForNumber(h);
            var l = this.calculateBitsNeeded(a, s, f, c);
            if (!this.willFit(l, c, r)) throw new $849102574a83a574$var$Mo("Data too big for requested version");
        } else c = this.recommendVersion(r, a, s, f);
        var d = new $849102574a83a574$var$V;
        d.appendBitArray(s);
        var p = a === $849102574a83a574$var$fn.BYTE ? f.getSizeInBytes() : e.length;
        this.appendLengthInfo(p, c, a, d), d.appendBitArray(f);
        var g = c.getECBlocksForLevel(r), y = c.getTotalCodewords() - g.getTotalECCodewords();
        this.terminateBits(y, d);
        var w = this.interleaveWithECBytes(d, c.getTotalCodewords(), y, g.getNumBlocks()), v = new $849102574a83a574$var$No;
        v.setECLevel(r), v.setMode(a), v.setVersion(c);
        var _ = c.getDimensionForVersion(), A = new $849102574a83a574$var$Ro(_, _), C = this.chooseMaskPattern(w, r, c, A);
        return v.setMaskPattern(C), $849102574a83a574$var$Po.buildMatrix(w, r, c, C, A), v.setMatrix(A), v;
    }, t.recommendVersion = function(t, e, r, n) {
        var o = this.calculateBitsNeeded(e, r, n, $849102574a83a574$var$en.getVersionForNumber(1)), i = this.chooseVersion(o, t), a = this.calculateBitsNeeded(e, r, n, i);
        return this.chooseVersion(a, t);
    }, t.calculateBitsNeeded = function(t, e, r, n) {
        return e.getSize() + t.getCharacterCountBits(n) + r.getSize();
    }, t.getAlphanumericCode = function(e) {
        return e < t.ALPHANUMERIC_TABLE.length ? t.ALPHANUMERIC_TABLE[e] : -1;
    }, t.chooseMode = function(e, r) {
        if (void 0 === r && (r = null), $849102574a83a574$var$j.SJIS.getName() === r && this.isOnlyDoubleByteKanji(e)) return $849102574a83a574$var$fn.KANJI;
        for(var n = !1, o = !1, i = 0, a = e.length; i < a; ++i){
            var s = e.charAt(i);
            if (t.isDigit(s)) n = !0;
            else {
                if (-1 === this.getAlphanumericCode(s.charCodeAt(0))) return $849102574a83a574$var$fn.BYTE;
                o = !0;
            }
        }
        return o ? $849102574a83a574$var$fn.ALPHANUMERIC : n ? $849102574a83a574$var$fn.NUMERIC : $849102574a83a574$var$fn.BYTE;
    }, t.isOnlyDoubleByteKanji = function(t) {
        var e;
        try {
            e = $849102574a83a574$var$K.encode(t, $849102574a83a574$var$j.SJIS);
        } catch (t) {
            return !1;
        }
        var r = e.length;
        if (r % 2 != 0) return !1;
        for(var n = 0; n < r; n += 2){
            var o = 255 & e[n];
            if ((o < 129 || o > 159) && (o < 224 || o > 235)) return !1;
        }
        return !0;
    }, t.chooseMaskPattern = function(t, e, r, n) {
        for(var o = Number.MAX_SAFE_INTEGER, i = -1, a = 0; a < $849102574a83a574$var$No.NUM_MASK_PATTERNS; a++){
            $849102574a83a574$var$Po.buildMatrix(t, e, r, a, n);
            var s = this.calculateMaskPenalty(n);
            s < o && (o = s, i = a);
        }
        return i;
    }, t.chooseVersion = function(e, r) {
        for(var n = 1; n <= 40; n++){
            var o = $849102574a83a574$var$en.getVersionForNumber(n);
            if (t.willFit(e, o, r)) return o;
        }
        throw new $849102574a83a574$var$Mo("Data too big");
    }, t.willFit = function(t, e, r) {
        return e.getTotalCodewords() - e.getECBlocksForLevel(r).getTotalECCodewords() >= (t + 7) / 8;
    }, t.terminateBits = function(t, e) {
        var r = 8 * t;
        if (e.getSize() > r) throw new $849102574a83a574$var$Mo("data bits cannot fit in the QR Code" + e.getSize() + " > " + r);
        for(var n = 0; n < 4 && e.getSize() < r; ++n)e.appendBit(!1);
        var o = 7 & e.getSize();
        if (o > 0) for(n = o; n < 8; n++)e.appendBit(!1);
        var i = t - e.getSizeInBytes();
        for(n = 0; n < i; ++n)e.appendBits(0 == (1 & n) ? 236 : 17, 8);
        if (e.getSize() !== r) throw new $849102574a83a574$var$Mo("Bits size does not equal capacity");
    }, t.getNumDataBytesAndNumECBytesForBlockID = function(t, e, r, n, o, i) {
        if (n >= r) throw new $849102574a83a574$var$Mo("Block ID too large");
        var a = t % r, s = r - a, u = Math.floor(t / r), c = u + 1, f = Math.floor(e / r), h = f + 1, l = u - f, d = c - h;
        if (l !== d) throw new $849102574a83a574$var$Mo("EC bytes mismatch");
        if (r !== s + a) throw new $849102574a83a574$var$Mo("RS blocks mismatch");
        if (t !== (f + l) * s + (h + d) * a) throw new $849102574a83a574$var$Mo("Total bytes mismatch");
        n < s ? (o[0] = f, i[0] = l) : (o[0] = h, i[0] = d);
    }, t.interleaveWithECBytes = function(e, r, n, o) {
        var i, a, s, u;
        if (e.getSizeInBytes() !== n) throw new $849102574a83a574$var$Mo("Number of bits and data bytes does not match");
        for(var c = 0, f = 0, h = 0, l = new Array, d = 0; d < o; ++d){
            var p = new Int32Array(1), g = new Int32Array(1);
            t.getNumDataBytesAndNumECBytesForBlockID(r, n, o, d, p, g);
            var y = p[0], w = new Uint8Array(y);
            e.toBytes(8 * c, w, 0, y);
            var v = t.generateECBytes(w, g[0]);
            l.push(new $849102574a83a574$var$Bo(w, v)), f = Math.max(f, y), h = Math.max(h, v.length), c += p[0];
        }
        if (n !== c) throw new $849102574a83a574$var$Mo("Data bytes does not match offset");
        var _ = new $849102574a83a574$var$V;
        for(d = 0; d < f; ++d)try {
            for(var A = (i = void 0, $849102574a83a574$var$Lo(l)), C = A.next(); !C.done; C = A.next())d < (w = C.value.getDataBytes()).length && _.appendBits(w[d], 8);
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                C && !C.done && (a = A.return) && a.call(A);
            } finally{
                if (i) throw i.error;
            }
        }
        for(d = 0; d < h; ++d)try {
            for(var m = (s = void 0, $849102574a83a574$var$Lo(l)), E = m.next(); !E.done; E = m.next())d < (v = E.value.getErrorCorrectionBytes()).length && _.appendBits(v[d], 8);
        } catch (t) {
            s = {
                error: t
            };
        } finally{
            try {
                E && !E.done && (u = m.return) && u.call(m);
            } finally{
                if (s) throw s.error;
            }
        }
        if (r !== _.getSizeInBytes()) throw new $849102574a83a574$var$Mo("Interleaving error: " + r + " and " + _.getSizeInBytes() + " differ.");
        return _;
    }, t.generateECBytes = function(t, e) {
        for(var r = t.length, n = new Int32Array(r + e), o = 0; o < r; o++)n[o] = 255 & t[o];
        new $849102574a83a574$var$To($849102574a83a574$var$Tt.QR_CODE_FIELD_256).encode(n, e);
        var i = new Uint8Array(e);
        for(o = 0; o < e; o++)i[o] = n[r + o];
        return i;
    }, t.appendModeInfo = function(t, e) {
        e.appendBits(t.getBits(), 4);
    }, t.appendLengthInfo = function(t, e, r, n) {
        var o = r.getCharacterCountBits(e);
        if (t >= 1 << o) throw new $849102574a83a574$var$Mo(t + " is bigger than " + ((1 << o) - 1));
        n.appendBits(t, o);
    }, t.appendBytes = function(e, r, n, o) {
        switch(r){
            case $849102574a83a574$var$fn.NUMERIC:
                t.appendNumericBytes(e, n);
                break;
            case $849102574a83a574$var$fn.ALPHANUMERIC:
                t.appendAlphanumericBytes(e, n);
                break;
            case $849102574a83a574$var$fn.BYTE:
                t.append8BitBytes(e, n, o);
                break;
            case $849102574a83a574$var$fn.KANJI:
                t.appendKanjiBytes(e, n);
                break;
            default:
                throw new $849102574a83a574$var$Mo("Invalid mode: " + r);
        }
    }, t.getDigit = function(t) {
        return t.charCodeAt(0) - 48;
    }, t.isDigit = function(e) {
        var r = t.getDigit(e);
        return r >= 0 && r <= 9;
    }, t.appendNumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getDigit(e.charAt(o));
            if (o + 2 < n) {
                var a = t.getDigit(e.charAt(o + 1)), s = t.getDigit(e.charAt(o + 2));
                r.appendBits(100 * i + 10 * a + s, 10), o += 3;
            } else if (o + 1 < n) {
                a = t.getDigit(e.charAt(o + 1));
                r.appendBits(10 * i + a, 7), o += 2;
            } else r.appendBits(i, 4), o++;
        }
    }, t.appendAlphanumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getAlphanumericCode(e.charCodeAt(o));
            if (-1 === i) throw new $849102574a83a574$var$Mo;
            if (o + 1 < n) {
                var a = t.getAlphanumericCode(e.charCodeAt(o + 1));
                if (-1 === a) throw new $849102574a83a574$var$Mo;
                r.appendBits(45 * i + a, 11), o += 2;
            } else r.appendBits(i, 6), o++;
        }
    }, t.append8BitBytes = function(t, e, r) {
        var n;
        try {
            n = $849102574a83a574$var$K.encode(t, r);
        } catch (t) {
            throw new $849102574a83a574$var$Mo(t);
        }
        for(var o = 0, i = n.length; o !== i; o++){
            var a = n[o];
            e.appendBits(a, 8);
        }
    }, t.appendKanjiBytes = function(t, e) {
        var r;
        try {
            r = $849102574a83a574$var$K.encode(t, $849102574a83a574$var$j.SJIS);
        } catch (t) {
            throw new $849102574a83a574$var$Mo(t);
        }
        for(var n = r.length, o = 0; o < n; o += 2){
            var i = (255 & r[o]) << 8 & 4294967295 | 255 & r[o + 1], a = -1;
            if (i >= 33088 && i <= 40956 ? a = i - 33088 : i >= 57408 && i <= 60351 && (a = i - 49472), -1 === a) throw new $849102574a83a574$var$Mo("Invalid byte sequence");
            var s = 192 * (a >> 8) + (255 & a);
            e.appendBits(s, 13);
        }
    }, t.appendECI = function(t, e) {
        e.appendBits($849102574a83a574$var$fn.ECI.getBits(), 4), e.appendBits(t.getValue(), 8);
    }, t.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]), t.DEFAULT_BYTE_MODE_ENCODING = $849102574a83a574$var$j.UTF8.getName();
}();
var $849102574a83a574$var$Fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, s, u) {
        var c = t.call(this, a, s) || this;
        if (c.yuvData = e, c.dataWidth = r, c.dataHeight = n, c.left = o, c.top = i, o + a > r || i + s > n) throw new $849102574a83a574$var$T("Crop rectangle does not fit within image data.");
        return u && c.reverseHorizontal(a, s), c;
    }
    $849102574a83a574$var$Fo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $849102574a83a574$var$T("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $849102574a83a574$var$D.arraycopy(this.yuvData, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.yuvData;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $849102574a83a574$var$D.arraycopy(this.yuvData, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $849102574a83a574$var$D.arraycopy(this.yuvData, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + t, this.top + r, n, o, !1);
    }, e.prototype.renderThumbnail = function() {
        for(var t = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, r = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, n = new Int32Array(t * r), o = this.yuvData, i = this.top * this.dataWidth + this.left, a = 0; a < r; a++){
            for(var s = a * t, u = 0; u < t; u++){
                var c = 255 & o[i + u * e.THUMBNAIL_SCALE_FACTOR];
                n[s + u] = 4278190080 | 65793 * c;
            }
            i += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
        }
        return n;
    }, e.prototype.getThumbnailWidth = function() {
        return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.getThumbnailHeight = function() {
        return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.reverseHorizontal = function(t, e) {
        for(var r = this.yuvData, n = 0, o = this.top * this.dataWidth + this.left; n < e; n++, o += this.dataWidth)for(var i = o + t / 2, a = o, s = o + t - 1; a < i; a++, s--){
            var u = r[a];
            r[a] = r[s], r[s] = u;
        }
    }, e.prototype.invert = function() {
        return new $849102574a83a574$var$st(this);
    }, e.THUMBNAIL_SCALE_FACTOR = 2;
}($849102574a83a574$var$it);
var $849102574a83a574$var$ko = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, s) {
        var u = t.call(this, r, n) || this;
        if (u.dataWidth = o, u.dataHeight = i, u.left = a, u.top = s, 4 === e.BYTES_PER_ELEMENT) {
            for(var c = r * n, f = new Uint8ClampedArray(c), h = 0; h < c; h++){
                var l = e[h], d = l >> 16 & 255, p = l >> 7 & 510, g = 255 & l;
                f[h] = (d + p + g) / 4 & 255;
            }
            u.luminances = f;
        } else u.luminances = e;
        if (void 0 === o && (u.dataWidth = r), void 0 === i && (u.dataHeight = n), void 0 === a && (u.left = 0), void 0 === s && (u.top = 0), u.left + r > u.dataWidth || u.top + n > u.dataHeight) throw new $849102574a83a574$var$T("Crop rectangle does not fit within image data.");
        return u;
    }
    $849102574a83a574$var$ko(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $849102574a83a574$var$T("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $849102574a83a574$var$D.arraycopy(this.luminances, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.luminances;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $849102574a83a574$var$D.arraycopy(this.luminances, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $849102574a83a574$var$D.arraycopy(this.luminances, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.luminances, n, o, this.dataWidth, this.dataHeight, this.left + t, this.top + r);
    }, e.prototype.invert = function() {
        return new $849102574a83a574$var$st(this);
    };
}($849102574a83a574$var$it);
var $849102574a83a574$var$xo, $849102574a83a574$var$Vo, $849102574a83a574$var$Ho = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Uo = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$Ho(e, t), e.forName = function(t) {
        return this.getCharacterSetECIByName(t);
    }, e;
}($849102574a83a574$var$j), $849102574a83a574$var$Xo = function() {
    function t() {}
    return t.ISO_8859_1 = $849102574a83a574$var$j.ISO8859_1, t;
}();
($849102574a83a574$var$xo = function(t, e) {
    for(var r = 1, n = 0; n < 255; n++)e[n] = r, t[r] = n, (r *= 2) >= 256 && (r ^= 301);
    return {
        LOG: t,
        ALOG: e
    };
}([], [])).LOG, $849102574a83a574$var$xo.ALOG, function(t) {
    t[t.FORCE_NONE = 0] = "FORCE_NONE", t[t.FORCE_SQUARE = 1] = "FORCE_SQUARE", t[t.FORCE_RECTANGLE = 2] = "FORCE_RECTANGLE";
}($849102574a83a574$var$Vo || ($849102574a83a574$var$Vo = {}));
var $849102574a83a574$var$Go, $849102574a83a574$var$Wo = "[)>\x1e05\x1d", $849102574a83a574$var$zo = "[)>\x1e06\x1d", $849102574a83a574$var$jo = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 0;
    }, t.prototype.encode = function(t) {
        if ($849102574a83a574$var$si.determineConsecutiveDigitCount(t.getMessage(), t.pos) >= 2) t.writeCodeword(this.encodeASCIIDigits(t.getMessage().charCodeAt(t.pos), t.getMessage().charCodeAt(t.pos + 1))), t.pos += 2;
        else {
            var e = t.getCurrentChar(), r = $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode());
            if (r !== this.getEncodingMode()) switch(r){
                case 5:
                    return t.writeCodeword(231), void t.signalEncoderChange(5);
                case 1:
                    return t.writeCodeword(230), void t.signalEncoderChange(1);
                case 3:
                    t.writeCodeword(238), t.signalEncoderChange(3);
                    break;
                case 2:
                    t.writeCodeword(239), t.signalEncoderChange(2);
                    break;
                case 4:
                    t.writeCodeword(240), t.signalEncoderChange(4);
                    break;
                default:
                    throw new Error("Illegal mode: " + r);
            }
            else $849102574a83a574$var$si.isExtendedASCII(e) ? (t.writeCodeword(235), t.writeCodeword(e - 128 + 1), t.pos++) : (t.writeCodeword(e + 1), t.pos++);
        }
    }, t.prototype.encodeASCIIDigits = function(t, e) {
        if ($849102574a83a574$var$si.isDigit(t) && $849102574a83a574$var$si.isDigit(e)) return 10 * (t - 48) + (e - 48) + 130;
        throw new Error("not digits: " + t + e);
    }, t;
}(), $849102574a83a574$var$Yo = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 5;
    }, t.prototype.encode = function(t) {
        var e = new $849102574a83a574$var$Q;
        for(e.append(0); t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            if (e.append(r), t.pos++, $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                t.signalEncoderChange(0);
                break;
            }
        }
        var n = e.length() - 1, o = t.getCodewordCount() + n + 1;
        t.updateSymbolInfo(o);
        var i = t.getSymbolInfo().getDataCapacity() - o > 0;
        if (t.hasMoreCharacters() || i) {
            if (n <= 249) e.setCharAt(0, $849102574a83a574$var$q.getCharAt(n));
            else {
                if (!(n <= 1555)) throw new Error("Message length not in valid ranges: " + n);
                e.setCharAt(0, $849102574a83a574$var$q.getCharAt(Math.floor(n / 250) + 249)), e.insert(1, $849102574a83a574$var$q.getCharAt(n % 250));
            }
        }
        var a = 0;
        for(r = e.length(); a < r; a++)t.writeCodeword(this.randomize255State(e.charAt(a).charCodeAt(0), t.getCodewordCount() + 1));
    }, t.prototype.randomize255State = function(t, e) {
        var r = t + (149 * e % 255 + 1);
        return r <= 255 ? r : r - 256;
    }, t;
}(), $849102574a83a574$var$Zo = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 1;
    }, t.prototype.encodeMaximal = function(t) {
        for(var e = new $849102574a83a574$var$Q, r = 0, n = t.pos, o = 0; t.hasMoreCharacters();){
            var i = t.getCurrentChar();
            t.pos++, r = this.encodeChar(i, e), e.length() % 3 == 0 && (n = t.pos, o = e.length());
        }
        if (o !== e.length()) {
            var a = Math.floor(e.length() / 3 * 2), s = Math.floor(t.getCodewordCount() + a + 1);
            t.updateSymbolInfo(s);
            var u = t.getSymbolInfo().getDataCapacity() - s, c = Math.floor(e.length() % 3);
            (2 === c && 2 !== u || 1 === c && (r > 3 || 1 !== u)) && (t.pos = n);
        }
        e.length() > 0 && t.writeCodeword(230), this.handleEOD(t, e);
    }, t.prototype.encode = function(t) {
        for(var e = new $849102574a83a574$var$Q; t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            t.pos++;
            var n = this.encodeChar(r, e), o = 2 * Math.floor(e.length() / 3), i = t.getCodewordCount() + o;
            t.updateSymbolInfo(i);
            var a = t.getSymbolInfo().getDataCapacity() - i;
            if (!t.hasMoreCharacters()) {
                var s = new $849102574a83a574$var$Q;
                for(e.length() % 3 == 2 && 2 !== a && (n = this.backtrackOneCharacter(t, e, s, n)); e.length() % 3 == 1 && (n > 3 || 1 !== a);)n = this.backtrackOneCharacter(t, e, s, n);
                break;
            }
            if (e.length() % 3 == 0) {
                if ($849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                    t.signalEncoderChange(0);
                    break;
                }
            }
        }
        this.handleEOD(t, e);
    }, t.prototype.backtrackOneCharacter = function(t, e, r, n) {
        var o = e.length(), i = e.toString().substring(0, o - n);
        e.setLengthToZero(), e.append(i), t.pos--;
        var a = t.getCurrentChar();
        return n = this.encodeChar(a, r), t.resetSymbolInfo(), n;
    }, t.prototype.writeNextTriplet = function(t, e) {
        t.writeCodewords(this.encodeToCodewords(e.toString()));
        var r = e.toString().substring(3);
        e.setLengthToZero(), e.append(r);
    }, t.prototype.handleEOD = function(t, e) {
        var r = Math.floor(e.length() / 3 * 2), n = e.length() % 3, o = t.getCodewordCount() + r;
        t.updateSymbolInfo(o);
        var i = t.getSymbolInfo().getDataCapacity() - o;
        if (2 === n) {
            for(e.append("\x00"); e.length() >= 3;)this.writeNextTriplet(t, e);
            t.hasMoreCharacters() && t.writeCodeword(254);
        } else if (1 === i && 1 === n) {
            for(; e.length() >= 3;)this.writeNextTriplet(t, e);
            t.hasMoreCharacters() && t.writeCodeword(254), t.pos--;
        } else {
            if (0 !== n) throw new Error("Unexpected case. Please report!");
            for(; e.length() >= 3;)this.writeNextTriplet(t, e);
            (i > 0 || t.hasMoreCharacters()) && t.writeCodeword(254);
        }
        t.signalEncoderChange(0);
    }, t.prototype.encodeChar = function(t, e) {
        if (t === " ".charCodeAt(0)) return e.append(3), 1;
        if (t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0)) return e.append(t - 48 + 4), 1;
        if (t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0)) return e.append(t - 65 + 14), 1;
        if (t < " ".charCodeAt(0)) return e.append(0), e.append(t), 2;
        if (t <= "/".charCodeAt(0)) return e.append(1), e.append(t - 33), 2;
        if (t <= "@".charCodeAt(0)) return e.append(1), e.append(t - 58 + 15), 2;
        if (t <= "_".charCodeAt(0)) return e.append(1), e.append(t - 91 + 22), 2;
        if (t <= 127) return e.append(2), e.append(t - 96), 2;
        e.append("1\x1e");
        var r = 2;
        return r += this.encodeChar(t - 128, e);
    }, t.prototype.encodeToCodewords = function(t) {
        var e = 1600 * t.charCodeAt(0) + 40 * t.charCodeAt(1) + t.charCodeAt(2) + 1, r = e / 256, n = e % 256, o = new $849102574a83a574$var$Q;
        return o.append(r), o.append(n), o.toString();
    }, t;
}(), $849102574a83a574$var$Ko = function() {
    function t() {}
    return t.prototype.getEncodingMode = function() {
        return 4;
    }, t.prototype.encode = function(t) {
        for(var e = new $849102574a83a574$var$Q; t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            if (this.encodeChar(r, e), t.pos++, e.length() >= 4) {
                t.writeCodewords(this.encodeToCodewords(e.toString()));
                var n = e.toString().substring(4);
                if (e.setLengthToZero(), e.append(n), $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                    t.signalEncoderChange(0);
                    break;
                }
            }
        }
        e.append($849102574a83a574$var$q.getCharAt(31)), this.handleEOD(t, e);
    }, t.prototype.handleEOD = function(t, e) {
        try {
            var r = e.length();
            if (0 === r) return;
            if (1 === r) {
                t.updateSymbolInfo();
                var n = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount(), o = t.getRemainingCharacters();
                if (o > n && (t.updateSymbolInfo(t.getCodewordCount() + 1), n = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount()), o <= n && n <= 2) return;
            }
            if (r > 4) throw new Error("Count must not exceed 4");
            var i = r - 1, a = this.encodeToCodewords(e.toString()), s = !t.hasMoreCharacters() && i <= 2;
            if (i <= 2) t.updateSymbolInfo(t.getCodewordCount() + i), (n = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount()) >= 3 && (s = !1, t.updateSymbolInfo(t.getCodewordCount() + a.length));
            s ? (t.resetSymbolInfo(), t.pos -= i) : t.writeCodewords(a);
        } finally{
            t.signalEncoderChange(0);
        }
    }, t.prototype.encodeChar = function(t, e) {
        t >= " ".charCodeAt(0) && t <= "?".charCodeAt(0) ? e.append(t) : t >= "@".charCodeAt(0) && t <= "^".charCodeAt(0) ? e.append($849102574a83a574$var$q.getCharAt(t - 64)) : $849102574a83a574$var$si.illegalCharacter($849102574a83a574$var$q.getCharAt(t));
    }, t.prototype.encodeToCodewords = function(t) {
        var e = t.length;
        if (0 === e) throw new Error("StringBuilder must not be empty");
        var r = (t.charAt(0).charCodeAt(0) << 18) + ((e >= 2 ? t.charAt(1).charCodeAt(0) : 0) << 12) + ((e >= 3 ? t.charAt(2).charCodeAt(0) : 0) << 6) + (e >= 4 ? t.charAt(3).charCodeAt(0) : 0), n = r >> 16 & 255, o = r >> 8 & 255, i = 255 & r, a = new $849102574a83a574$var$Q;
        return a.append(n), e >= 2 && a.append(o), e >= 3 && a.append(i), a.toString();
    }, t;
}(), $849102574a83a574$var$qo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Qo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Jo = function() {
    function t(t, e, r, n, o, i, a, s) {
        void 0 === a && (a = 0), void 0 === s && (s = 0), this.rectangular = t, this.dataCapacity = e, this.errorCodewords = r, this.matrixWidth = n, this.matrixHeight = o, this.dataRegions = i, this.rsBlockData = a, this.rsBlockError = s;
    }
    return t.lookup = function(t, e, r, n, o) {
        var i, a;
        void 0 === e && (e = 0), void 0 === r && (r = null), void 0 === n && (n = null), void 0 === o && (o = !0);
        try {
            for(var s = $849102574a83a574$var$Qo($849102574a83a574$var$ti), u = s.next(); !u.done; u = s.next()){
                var c = u.value;
                if ((1 !== e || !c.rectangular) && (2 !== e || c.rectangular) && (null == r || !(c.getSymbolWidth() < r.getWidth() || c.getSymbolHeight() < r.getHeight())) && (null == n || !(c.getSymbolWidth() > n.getWidth() || c.getSymbolHeight() > n.getHeight())) && t <= c.dataCapacity) return c;
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (a = s.return) && a.call(s);
            } finally{
                if (i) throw i.error;
            }
        }
        if (o) throw new Error("Can't find a symbol arrangement that matches the message. Data codewords: " + t);
        return null;
    }, t.prototype.getHorizontalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
                return 1;
            case 2:
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    }, t.prototype.getVerticalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
            case 2:
                return 1;
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    }, t.prototype.getSymbolDataWidth = function() {
        return this.getHorizontalDataRegions() * this.matrixWidth;
    }, t.prototype.getSymbolDataHeight = function() {
        return this.getVerticalDataRegions() * this.matrixHeight;
    }, t.prototype.getSymbolWidth = function() {
        return this.getSymbolDataWidth() + 2 * this.getHorizontalDataRegions();
    }, t.prototype.getSymbolHeight = function() {
        return this.getSymbolDataHeight() + 2 * this.getVerticalDataRegions();
    }, t.prototype.getCodewordCount = function() {
        return this.dataCapacity + this.errorCodewords;
    }, t.prototype.getInterleavedBlockCount = function() {
        return this.rsBlockData ? this.dataCapacity / this.rsBlockData : 1;
    }, t.prototype.getDataCapacity = function() {
        return this.dataCapacity;
    }, t.prototype.getErrorCodewords = function() {
        return this.errorCodewords;
    }, t.prototype.getDataLengthForInterleavedBlock = function(t) {
        return this.rsBlockData;
    }, t.prototype.getErrorLengthForInterleavedBlock = function(t) {
        return this.rsBlockError;
    }, t;
}(), $849102574a83a574$var$$o = function(t) {
    function e() {
        return t.call(this, !1, 1558, 620, 22, 22, 36, -1, 62) || this;
    }
    return $849102574a83a574$var$qo(e, t), e.prototype.getInterleavedBlockCount = function() {
        return 10;
    }, e.prototype.getDataLengthForInterleavedBlock = function(t) {
        return t <= 8 ? 156 : 155;
    }, e;
}($849102574a83a574$var$Jo), $849102574a83a574$var$ti = [
    new $849102574a83a574$var$Jo(!1, 3, 5, 8, 8, 1),
    new $849102574a83a574$var$Jo(!1, 5, 7, 10, 10, 1),
    new $849102574a83a574$var$Jo(!0, 5, 7, 16, 6, 1),
    new $849102574a83a574$var$Jo(!1, 8, 10, 12, 12, 1),
    new $849102574a83a574$var$Jo(!0, 10, 11, 14, 6, 2),
    new $849102574a83a574$var$Jo(!1, 12, 12, 14, 14, 1),
    new $849102574a83a574$var$Jo(!0, 16, 14, 24, 10, 1),
    new $849102574a83a574$var$Jo(!1, 18, 14, 16, 16, 1),
    new $849102574a83a574$var$Jo(!1, 22, 18, 18, 18, 1),
    new $849102574a83a574$var$Jo(!0, 22, 18, 16, 10, 2),
    new $849102574a83a574$var$Jo(!1, 30, 20, 20, 20, 1),
    new $849102574a83a574$var$Jo(!0, 32, 24, 16, 14, 2),
    new $849102574a83a574$var$Jo(!1, 36, 24, 22, 22, 1),
    new $849102574a83a574$var$Jo(!1, 44, 28, 24, 24, 1),
    new $849102574a83a574$var$Jo(!0, 49, 28, 22, 14, 2),
    new $849102574a83a574$var$Jo(!1, 62, 36, 14, 14, 4),
    new $849102574a83a574$var$Jo(!1, 86, 42, 16, 16, 4),
    new $849102574a83a574$var$Jo(!1, 114, 48, 18, 18, 4),
    new $849102574a83a574$var$Jo(!1, 144, 56, 20, 20, 4),
    new $849102574a83a574$var$Jo(!1, 174, 68, 22, 22, 4),
    new $849102574a83a574$var$Jo(!1, 204, 84, 24, 24, 4, 102, 42),
    new $849102574a83a574$var$Jo(!1, 280, 112, 14, 14, 16, 140, 56),
    new $849102574a83a574$var$Jo(!1, 368, 144, 16, 16, 16, 92, 36),
    new $849102574a83a574$var$Jo(!1, 456, 192, 18, 18, 16, 114, 48),
    new $849102574a83a574$var$Jo(!1, 576, 224, 20, 20, 16, 144, 56),
    new $849102574a83a574$var$Jo(!1, 696, 272, 22, 22, 16, 174, 68),
    new $849102574a83a574$var$Jo(!1, 816, 336, 24, 24, 16, 136, 56),
    new $849102574a83a574$var$Jo(!1, 1050, 408, 18, 18, 36, 175, 68),
    new $849102574a83a574$var$Jo(!1, 1304, 496, 20, 20, 36, 163, 62),
    new $849102574a83a574$var$$o
], $849102574a83a574$var$ei = function() {
    function t(t) {
        this.msg = t, this.pos = 0, this.skipAtEnd = 0;
        for(var e = t.split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $849102574a83a574$var$Q, n = 0, o = e.length; n < o; n++){
            var i = String.fromCharCode(255 & e[n]);
            if ("?" === i && "?" !== t.charAt(n)) throw new Error("Message contains characters outside ISO-8859-1 encoding.");
            r.append(i);
        }
        this.msg = r.toString(), this.shape = 0, this.codewords = new $849102574a83a574$var$Q, this.newEncoding = -1;
    }
    return t.prototype.setSymbolShape = function(t) {
        this.shape = t;
    }, t.prototype.setSizeConstraints = function(t, e) {
        this.minSize = t, this.maxSize = e;
    }, t.prototype.getMessage = function() {
        return this.msg;
    }, t.prototype.setSkipAtEnd = function(t) {
        this.skipAtEnd = t;
    }, t.prototype.getCurrentChar = function() {
        return this.msg.charCodeAt(this.pos);
    }, t.prototype.getCurrent = function() {
        return this.msg.charCodeAt(this.pos);
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.writeCodewords = function(t) {
        this.codewords.append(t);
    }, t.prototype.writeCodeword = function(t) {
        this.codewords.append(t);
    }, t.prototype.getCodewordCount = function() {
        return this.codewords.length();
    }, t.prototype.getNewEncoding = function() {
        return this.newEncoding;
    }, t.prototype.signalEncoderChange = function(t) {
        this.newEncoding = t;
    }, t.prototype.resetEncoderSignal = function() {
        this.newEncoding = -1;
    }, t.prototype.hasMoreCharacters = function() {
        return this.pos < this.getTotalMessageCharCount();
    }, t.prototype.getTotalMessageCharCount = function() {
        return this.msg.length - this.skipAtEnd;
    }, t.prototype.getRemainingCharacters = function() {
        return this.getTotalMessageCharCount() - this.pos;
    }, t.prototype.getSymbolInfo = function() {
        return this.symbolInfo;
    }, t.prototype.updateSymbolInfo = function(t) {
        void 0 === t && (t = this.getCodewordCount()), (null == this.symbolInfo || t > this.symbolInfo.getDataCapacity()) && (this.symbolInfo = $849102574a83a574$var$Jo.lookup(t, this.shape, this.minSize, this.maxSize, !0));
    }, t.prototype.resetSymbolInfo = function() {
        this.symbolInfo = null;
    }, t;
}(), $849102574a83a574$var$ri = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ni = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$ri(e, t), e.prototype.getEncodingMode = function() {
        return 3;
    }, e.prototype.encode = function(t) {
        for(var e = new $849102574a83a574$var$Q; t.hasMoreCharacters();){
            var r = t.getCurrentChar();
            if (t.pos++, this.encodeChar(r, e), e.length() % 3 == 0) {
                if (this.writeNextTriplet(t, e), $849102574a83a574$var$si.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode()) !== this.getEncodingMode()) {
                    t.signalEncoderChange(0);
                    break;
                }
            }
        }
        this.handleEOD(t, e);
    }, e.prototype.encodeChar = function(t, e) {
        switch(t){
            case 13:
                e.append(0);
                break;
            case "*".charCodeAt(0):
                e.append(1);
                break;
            case ">".charCodeAt(0):
                e.append(2);
                break;
            case " ".charCodeAt(0):
                e.append(3);
                break;
            default:
                t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) ? e.append(t - 48 + 4) : t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0) ? e.append(t - 65 + 14) : $849102574a83a574$var$si.illegalCharacter($849102574a83a574$var$q.getCharAt(t));
        }
        return 1;
    }, e.prototype.handleEOD = function(t, e) {
        t.updateSymbolInfo();
        var r = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount(), n = e.length();
        t.pos -= n, (t.getRemainingCharacters() > 1 || r > 1 || t.getRemainingCharacters() !== r) && t.writeCodeword(254), t.getNewEncoding() < 0 && t.signalEncoderChange(0);
    }, e;
}($849102574a83a574$var$Zo), $849102574a83a574$var$oi = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$ii = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $849102574a83a574$var$oi(e, t), e.prototype.getEncodingMode = function() {
        return 2;
    }, e.prototype.encodeChar = function(t, e) {
        if (t === " ".charCodeAt(0)) return e.append(3), 1;
        if (t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0)) return e.append(t - 48 + 4), 1;
        if (t >= "a".charCodeAt(0) && t <= "z".charCodeAt(0)) return e.append(t - 97 + 14), 1;
        if (t < " ".charCodeAt(0)) return e.append(0), e.append(t), 2;
        if (t <= "/".charCodeAt(0)) return e.append(1), e.append(t - 33), 2;
        if (t <= "@".charCodeAt(0)) return e.append(1), e.append(t - 58 + 15), 2;
        if (t >= "[".charCodeAt(0) && t <= "_".charCodeAt(0)) return e.append(1), e.append(t - 91 + 22), 2;
        if (t === "`".charCodeAt(0)) return e.append(2), e.append(0), 2;
        if (t <= "Z".charCodeAt(0)) return e.append(2), e.append(t - 65 + 1), 2;
        if (t <= 127) return e.append(2), e.append(t - 123 + 27), 2;
        e.append("1\x1e");
        var r = 2;
        return r += this.encodeChar(t - 128, e);
    }, e;
}($849102574a83a574$var$Zo), $849102574a83a574$var$ai = function() {
    function t() {}
    return t.randomize253State = function(t) {
        var e = 129 + (149 * t % 253 + 1);
        return e <= 254 ? e : e - 254;
    }, t.encodeHighLevel = function(t, e, r, n, o) {
        void 0 === e && (e = 0), void 0 === r && (r = null), void 0 === n && (n = null), void 0 === o && (o = !1);
        var i = new $849102574a83a574$var$Zo, a = [
            new $849102574a83a574$var$jo,
            i,
            new $849102574a83a574$var$ii,
            new $849102574a83a574$var$ni,
            new $849102574a83a574$var$Ko,
            new $849102574a83a574$var$Yo
        ], s = new $849102574a83a574$var$ei(t);
        s.setSymbolShape(e), s.setSizeConstraints(r, n), t.startsWith($849102574a83a574$var$Wo) && t.endsWith("\x1e\x04") ? (s.writeCodeword(236), s.setSkipAtEnd(2), s.pos += 7) : t.startsWith($849102574a83a574$var$zo) && t.endsWith("\x1e\x04") && (s.writeCodeword(237), s.setSkipAtEnd(2), s.pos += 7);
        var u = 0;
        for(o && (i.encodeMaximal(s), u = s.getNewEncoding(), s.resetEncoderSignal()); s.hasMoreCharacters();)a[u].encode(s), s.getNewEncoding() >= 0 && (u = s.getNewEncoding(), s.resetEncoderSignal());
        var c = s.getCodewordCount();
        s.updateSymbolInfo();
        var f = s.getSymbolInfo().getDataCapacity();
        c < f && 0 !== u && 5 !== u && 4 !== u && s.writeCodeword("\xfe");
        var h = s.getCodewords();
        for(h.length() < f && h.append(129); h.length() < f;)h.append(this.randomize253State(h.length() + 1));
        return s.getCodewords().toString();
    }, t.lookAheadTest = function(t, e, r) {
        var n = this.lookAheadTestIntern(t, e, r);
        if (3 === r && 3 === n) {
            for(var o = Math.min(e + 3, t.length), i = e; i < o; i++)if (!this.isNativeX12(t.charCodeAt(i))) return 0;
        } else if (4 === r && 4 === n) {
            for(o = Math.min(e + 4, t.length), i = e; i < o; i++)if (!this.isNativeEDIFACT(t.charCodeAt(i))) return 0;
        }
        return n;
    }, t.lookAheadTestIntern = function(t, e, r) {
        if (e >= t.length) return r;
        var n;
        0 === r ? n = [
            0,
            1,
            1,
            1,
            1,
            1.25
        ] : (n = [
            1,
            2,
            2,
            2,
            2,
            2.25
        ])[r] = 0;
        for(var o = 0, i = new Uint8Array(6), a = [];;){
            if (e + o === t.length) {
                $849102574a83a574$var$k.fill(i, 0), $849102574a83a574$var$k.fill(a, 0);
                var s = this.findMinimums(n, a, $849102574a83a574$var$x.MAX_VALUE, i), u = this.getMinimumCount(i);
                if (a[0] === s) return 0;
                if (1 === u) {
                    if (i[5] > 0) return 5;
                    if (i[4] > 0) return 4;
                    if (i[2] > 0) return 2;
                    if (i[3] > 0) return 3;
                }
                return 1;
            }
            var c = t.charCodeAt(e + o);
            if (o++, this.isDigit(c) ? n[0] += .5 : this.isExtendedASCII(c) ? (n[0] = Math.ceil(n[0]), n[0] += 2) : (n[0] = Math.ceil(n[0]), n[0]++), this.isNativeC40(c) ? n[1] += 2 / 3 : this.isExtendedASCII(c) ? n[1] += 8 / 3 : n[1] += 4 / 3, this.isNativeText(c) ? n[2] += 2 / 3 : this.isExtendedASCII(c) ? n[2] += 8 / 3 : n[2] += 4 / 3, this.isNativeX12(c) ? n[3] += 2 / 3 : this.isExtendedASCII(c) ? n[3] += 13 / 3 : n[3] += 10 / 3, this.isNativeEDIFACT(c) ? n[4] += 3 / 4 : this.isExtendedASCII(c) ? n[4] += 4.25 : n[4] += 3.25, this.isSpecialB256(c) ? n[5] += 4 : n[5]++, o >= 4) {
                if ($849102574a83a574$var$k.fill(i, 0), $849102574a83a574$var$k.fill(a, 0), this.findMinimums(n, a, $849102574a83a574$var$x.MAX_VALUE, i), a[0] < this.min(a[5], a[1], a[2], a[3], a[4])) return 0;
                if (a[5] < a[0] || a[5] + 1 < this.min(a[1], a[2], a[3], a[4])) return 5;
                if (a[4] + 1 < this.min(a[5], a[1], a[2], a[3], a[0])) return 4;
                if (a[2] + 1 < this.min(a[5], a[1], a[4], a[3], a[0])) return 2;
                if (a[3] + 1 < this.min(a[5], a[1], a[4], a[2], a[0])) return 3;
                if (a[1] + 1 < this.min(a[0], a[5], a[4], a[2])) {
                    if (a[1] < a[3]) return 1;
                    if (a[1] === a[3]) {
                        for(var f = e + o + 1; f < t.length;){
                            var h = t.charCodeAt(f);
                            if (this.isX12TermSep(h)) return 3;
                            if (!this.isNativeX12(h)) break;
                            f++;
                        }
                        return 1;
                    }
                }
            }
        }
    }, t.min = function(t, e, r, n, o) {
        var i = Math.min(t, Math.min(e, Math.min(r, n)));
        return void 0 === o ? i : Math.min(i, o);
    }, t.findMinimums = function(t, e, r, n) {
        for(var o = 0; o < 6; o++){
            var i = e[o] = Math.ceil(t[o]);
            r > i && (r = i, $849102574a83a574$var$k.fill(n, 0)), r === i && (n[o] = n[o] + 1);
        }
        return r;
    }, t.getMinimumCount = function(t) {
        for(var e = 0, r = 0; r < 6; r++)e += t[r];
        return e || 0;
    }, t.isDigit = function(t) {
        return t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0);
    }, t.isExtendedASCII = function(t) {
        return t >= 128 && t <= 255;
    }, t.isNativeC40 = function(t) {
        return t === " ".charCodeAt(0) || t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) || t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0);
    }, t.isNativeText = function(t) {
        return t === " ".charCodeAt(0) || t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) || t >= "a".charCodeAt(0) && t <= "z".charCodeAt(0);
    }, t.isNativeX12 = function(t) {
        return this.isX12TermSep(t) || t === " ".charCodeAt(0) || t >= "0".charCodeAt(0) && t <= "9".charCodeAt(0) || t >= "A".charCodeAt(0) && t <= "Z".charCodeAt(0);
    }, t.isX12TermSep = function(t) {
        return 13 === t || t === "*".charCodeAt(0) || t === ">".charCodeAt(0);
    }, t.isNativeEDIFACT = function(t) {
        return t >= " ".charCodeAt(0) && t <= "^".charCodeAt(0);
    }, t.isSpecialB256 = function(t) {
        return !1;
    }, t.determineConsecutiveDigitCount = function(t, e) {
        void 0 === e && (e = 0);
        for(var r = t.length, n = e; n < r && this.isDigit(t.charCodeAt(n));)n++;
        return n - e;
    }, t.illegalCharacter = function(t) {
        var e = $849102574a83a574$var$x.toHexString(t.charCodeAt(0));
        throw e = "0000".substring(0, 4 - e.length) + e, new Error("Illegal character: " + t + " (0x" + e + ")");
    }, t;
}(), $849102574a83a574$var$si = $849102574a83a574$var$ai, $849102574a83a574$var$ui = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$ci = function() {
    function t(t) {
        this.charset = t, this.name = t.name;
    }
    return t.prototype.canEncode = function(t) {
        try {
            return null != $849102574a83a574$var$K.encode(t, this.charset);
        } catch (t) {
            return !1;
        }
    }, t;
}(), $849102574a83a574$var$fi = function() {
    function t(t, e, r) {
        var n, o, i, a, s, u;
        this.ENCODERS = [
            "IBM437",
            "ISO-8859-2",
            "ISO-8859-3",
            "ISO-8859-4",
            "ISO-8859-5",
            "ISO-8859-6",
            "ISO-8859-7",
            "ISO-8859-8",
            "ISO-8859-9",
            "ISO-8859-10",
            "ISO-8859-11",
            "ISO-8859-13",
            "ISO-8859-14",
            "ISO-8859-15",
            "ISO-8859-16",
            "windows-1250",
            "windows-1251",
            "windows-1252",
            "windows-1256",
            "Shift_JIS"
        ].map(function(t) {
            return new $849102574a83a574$var$ci($849102574a83a574$var$Uo.forName(t));
        }), this.encoders = [];
        var c = [];
        c.push(new $849102574a83a574$var$ci($849102574a83a574$var$Xo.ISO_8859_1));
        for(var f = null != e && e.name.startsWith("UTF"), h = 0; h < t.length; h++){
            var l = !1;
            try {
                for(var d = (n = void 0, $849102574a83a574$var$ui(c)), p = d.next(); !p.done; p = d.next()){
                    var g = p.value, y = t.charAt(h);
                    if (y.charCodeAt(0) === r || g.canEncode(y)) {
                        l = !0;
                        break;
                    }
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    p && !p.done && (o = d.return) && o.call(d);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (!l) try {
                for(var w = (i = void 0, $849102574a83a574$var$ui(this.ENCODERS)), v = w.next(); !v.done; v = w.next())if ((g = v.value).canEncode(t.charAt(h))) {
                    c.push(g), l = !0;
                    break;
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    v && !v.done && (a = w.return) && a.call(w);
                } finally{
                    if (i) throw i.error;
                }
            }
            l || (f = !0);
        }
        if (1 !== c.length || f) {
            this.encoders = [];
            var _ = 0;
            try {
                for(var A = $849102574a83a574$var$ui(c), C = A.next(); !C.done; C = A.next()){
                    g = C.value;
                    this.encoders[_++] = g;
                }
            } catch (t) {
                s = {
                    error: t
                };
            } finally{
                try {
                    C && !C.done && (u = A.return) && u.call(A);
                } finally{
                    if (s) throw s.error;
                }
            }
        } else this.encoders = [
            c[0]
        ];
        var m = -1;
        if (null != e) {
            for(h = 0; h < this.encoders.length; h++)if (null != this.encoders[h] && e.name === this.encoders[h].name) {
                m = h;
                break;
            }
        }
        this.priorityEncoderIndex = m;
    }
    return t.prototype.length = function() {
        return this.encoders.length;
    }, t.prototype.getCharsetName = function(t) {
        if (!(t < this.length())) throw new Error("index must be less than length");
        return this.encoders[t].name;
    }, t.prototype.getCharset = function(t) {
        if (!(t < this.length())) throw new Error("index must be less than length");
        return this.encoders[t].charset;
    }, t.prototype.getECIValue = function(t) {
        return this.encoders[t].charset.getValueIdentifier();
    }, t.prototype.getPriorityEncoderIndex = function() {
        return this.priorityEncoderIndex;
    }, t.prototype.canEncode = function(t, e) {
        if (!(e < this.length())) throw new Error("index must be less than length");
        return !0;
    }, t.prototype.encode = function(t, e) {
        if (!(e < this.length())) throw new Error("index must be less than length");
        return $849102574a83a574$var$K.encode($849102574a83a574$var$q.getCharAt(t), this.encoders[e].name);
    }, t;
}(), $849102574a83a574$var$hi = function() {
    function t(t, e, r) {
        this.fnc1 = r;
        var n = new $849102574a83a574$var$fi(t, e, r);
        if (1 === n.length()) for(var o = 0; o < this.bytes.length; o++){
            var i = t.charAt(o).charCodeAt(0);
            this.bytes[o] = i === r ? 1e3 : i;
        }
        else this.bytes = this.encodeMinimally(t, n, r);
    }
    return t.prototype.getFNC1Character = function() {
        return this.fnc1;
    }, t.prototype.length = function() {
        return this.bytes.length;
    }, t.prototype.haveNCharacters = function(t, e) {
        if (t + e - 1 >= this.bytes.length) return !1;
        for(var r = 0; r < e; r++)if (this.isECI(t + r)) return !1;
        return !0;
    }, t.prototype.charAt = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        if (this.isECI(t)) throw new Error("value at " + t + " is not a character but an ECI");
        return this.isFNC1(t) ? this.fnc1 : this.bytes[t];
    }, t.prototype.subSequence = function(t, e) {
        if (t < 0 || t > e || e > this.length()) throw new Error("" + t);
        for(var r = new $849102574a83a574$var$Q, n = t; n < e; n++){
            if (this.isECI(n)) throw new Error("value at " + n + " is not a character but an ECI");
            r.append(this.charAt(n));
        }
        return r.toString();
    }, t.prototype.isECI = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        return this.bytes[t] > 255 && this.bytes[t] <= 999;
    }, t.prototype.isFNC1 = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        return 1e3 === this.bytes[t];
    }, t.prototype.getECIValue = function(t) {
        if (t < 0 || t >= this.length()) throw new Error("" + t);
        if (!this.isECI(t)) throw new Error("value at " + t + " is not an ECI but a character");
        return this.bytes[t] - 256;
    }, t.prototype.addEdge = function(t, e, r) {
        (null == t[e][r.encoderIndex] || t[e][r.encoderIndex].cachedTotalSize > r.cachedTotalSize) && (t[e][r.encoderIndex] = r);
    }, t.prototype.addEdges = function(t, e, r, n, o, i) {
        var a = t.charAt(n).charCodeAt(0), s = 0, u = e.length();
        e.getPriorityEncoderIndex() >= 0 && (a === i || e.canEncode(a, e.getPriorityEncoderIndex())) && (u = (s = e.getPriorityEncoderIndex()) + 1);
        for(var c = s; c < u; c++)(a === i || e.canEncode(a, c)) && this.addEdge(r, n + 1, new $849102574a83a574$var$li(a, e, c, o, i));
    }, t.prototype.encodeMinimally = function(t, e, r) {
        var n = t.length, o = new $849102574a83a574$var$li[n + 1][e.length()];
        this.addEdges(t, e, o, 0, null, r);
        for(var i = 1; i <= n; i++){
            for(var a = 0; a < e.length(); a++)null != o[i][a] && i < n && this.addEdges(t, e, o, i, o[i][a], r);
            for(a = 0; a < e.length(); a++)o[i - 1][a] = null;
        }
        var s = -1, u = $849102574a83a574$var$x.MAX_VALUE;
        for(a = 0; a < e.length(); a++)if (null != o[n][a]) {
            var c = o[n][a];
            c.cachedTotalSize < u && (u = c.cachedTotalSize, s = a);
        }
        if (s < 0) throw new Error('Failed to encode "' + t + '"');
        for(var f = [], h = o[n][s]; null != h;){
            if (h.isFNC1()) f.unshift(1e3);
            else {
                var l = e.encode(h.c, h.encoderIndex);
                for(i = l.length - 1; i >= 0; i--)f.unshift(255 & l[i]);
            }
            (null === h.previous ? 0 : h.previous.encoderIndex) !== h.encoderIndex && f.unshift(256 + e.getECIValue(h.encoderIndex)), h = h.previous;
        }
        var d = [];
        for(i = 0; i < d.length; i++)d[i] = f[i];
        return d;
    }, t;
}(), $849102574a83a574$var$li = function() {
    function t(t, e, r, n, o) {
        this.c = t, this.encoderSet = e, this.encoderIndex = r, this.previous = n, this.fnc1 = o, this.c = t === o ? 1e3 : t;
        var i = this.isFNC1() ? 1 : e.encode(t, r).length;
        (null === n ? 0 : n.encoderIndex) !== r && (i += 3), null != n && (i += n.cachedTotalSize), this.cachedTotalSize = i;
    }
    return t.prototype.isFNC1 = function() {
        return 1e3 === this.c;
    }, t;
}(), $849102574a83a574$var$di = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    t[t.ASCII = 0] = "ASCII", t[t.C40 = 1] = "C40", t[t.TEXT = 2] = "TEXT", t[t.X12 = 3] = "X12", t[t.EDF = 4] = "EDF", t[t.B256 = 5] = "B256";
}($849102574a83a574$var$Go || ($849102574a83a574$var$Go = {})), function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r, n) || this;
        return a.shape = o, a.macroId = i, a;
    }
    $849102574a83a574$var$di(e, t), e.prototype.getMacroId = function() {
        return this.macroId;
    }, e.prototype.getShapeHint = function() {
        return this.shape;
    };
}($849102574a83a574$var$hi);
var $849102574a83a574$var$pi = function() {
    function t() {}
    return t.prototype.isCompact = function() {
        return this.compact;
    }, t.prototype.setCompact = function(t) {
        this.compact = t;
    }, t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.setSize = function(t) {
        this.size = t;
    }, t.prototype.getLayers = function() {
        return this.layers;
    }, t.prototype.setLayers = function(t) {
        this.layers = t;
    }, t.prototype.getCodeWords = function() {
        return this.codeWords;
    }, t.prototype.setCodeWords = function(t) {
        this.codeWords = t;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t;
}(), $849102574a83a574$var$gi = function() {
    function t() {}
    return t.singletonList = function(t) {
        return [
            t
        ];
    }, t.min = function(t, e) {
        return t.sort(e)[0];
    }, t;
}(), $849102574a83a574$var$yi = function() {
    function t(t) {
        this.previous = t;
    }
    return t.prototype.getPrevious = function() {
        return this.previous;
    }, t;
}(), $849102574a83a574$var$wi = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$vi = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.value = r, o.bitCount = n, o;
    }
    return $849102574a83a574$var$wi(e, t), e.prototype.appendTo = function(t, e) {
        t.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.addBinaryShift = function(t, r) {
        return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, t, r);
    }, e.prototype.toString = function() {
        var t = this.value & (1 << this.bitCount) - 1;
        return t |= 1 << this.bitCount, "<" + $849102574a83a574$var$x.toBinaryString(t | 1 << this.bitCount).substring(1) + ">";
    }, e;
}($849102574a83a574$var$yi), $849102574a83a574$var$_i = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $849102574a83a574$var$Ai = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, 0, 0) || this;
        return o.binaryShiftStart = r, o.binaryShiftByteCount = n, o;
    }
    return $849102574a83a574$var$_i(e, t), e.prototype.appendTo = function(t, e) {
        for(var r = 0; r < this.binaryShiftByteCount; r++)(0 === r || 31 === r && this.binaryShiftByteCount <= 62) && (t.appendBits(31, 5), this.binaryShiftByteCount > 62 ? t.appendBits(this.binaryShiftByteCount - 31, 16) : 0 === r ? t.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : t.appendBits(this.binaryShiftByteCount - 31, 5)), t.appendBits(e[this.binaryShiftStart + r], 8);
    }, e.prototype.addBinaryShift = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    }, e;
}($849102574a83a574$var$vi);
function $849102574a83a574$var$Ci(t, e, r) {
    return new $849102574a83a574$var$vi(t, e, r);
}
var $849102574a83a574$var$mi = [
    "UPPER",
    "LOWER",
    "DIGIT",
    "MIXED",
    "PUNCT"
], $849102574a83a574$var$Ei = new $849102574a83a574$var$vi(null, 0, 0), $849102574a83a574$var$Ii = [
    Int32Array.from([
        0,
        327708,
        327710,
        327709,
        656318
    ]),
    Int32Array.from([
        590318,
        0,
        327710,
        327709,
        656318
    ]),
    Int32Array.from([
        262158,
        590300,
        0,
        590301,
        932798
    ]),
    Int32Array.from([
        327709,
        327708,
        656318,
        0,
        327710
    ]),
    Int32Array.from([
        327711,
        656380,
        656382,
        656381,
        0
    ])
], $849102574a83a574$var$Si = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $849102574a83a574$var$Ti = function(t) {
    var e, r;
    try {
        for(var n = $849102574a83a574$var$Si(t), o = n.next(); !o.done; o = n.next()){
            var i = o.value;
            $849102574a83a574$var$k.fill(i, -1);
        }
    } catch (t) {
        e = {
            error: t
        };
    } finally{
        try {
            o && !o.done && (r = n.return) && r.call(n);
        } finally{
            if (e) throw e.error;
        }
    }
    return t[0][4] = 0, t[1][4] = 0, t[1][0] = 28, t[3][4] = 0, t[2][4] = 0, t[2][0] = 15, t;
}($849102574a83a574$var$k.createInt32Array(6, 6)), $849102574a83a574$var$Oi = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$bi = function() {
    function t(t, e, r, n) {
        this.token = t, this.mode = e, this.binaryShiftByteCount = r, this.bitCount = n;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getToken = function() {
        return this.token;
    }, t.prototype.getBinaryShiftByteCount = function() {
        return this.binaryShiftByteCount;
    }, t.prototype.getBitCount = function() {
        return this.bitCount;
    }, t.prototype.latchAndAppend = function(e, r) {
        var n = this.bitCount, o = this.token;
        if (e !== this.mode) {
            var i = $849102574a83a574$var$Ii[this.mode][e];
            o = $849102574a83a574$var$Ci(o, 65535 & i, i >> 16), n += i >> 16;
        }
        var a = 2 === e ? 4 : 5;
        return new t(o = $849102574a83a574$var$Ci(o, r, a), e, 0, n + a);
    }, t.prototype.shiftAndAppend = function(e, r) {
        var n = this.token, o = 2 === this.mode ? 4 : 5;
        return n = $849102574a83a574$var$Ci(n, $849102574a83a574$var$Ti[this.mode][e], o), new t(n = $849102574a83a574$var$Ci(n, r, 5), this.mode, 0, this.bitCount + o + 5);
    }, t.prototype.addBinaryShiftChar = function(e) {
        var r = this.token, n = this.mode, o = this.bitCount;
        if (4 === this.mode || 2 === this.mode) {
            var i = $849102574a83a574$var$Ii[n][0];
            r = $849102574a83a574$var$Ci(r, 65535 & i, i >> 16), o += i >> 16, n = 0;
        }
        var a = 0 === this.binaryShiftByteCount || 31 === this.binaryShiftByteCount ? 18 : 62 === this.binaryShiftByteCount ? 9 : 8, s = new t(r, n, this.binaryShiftByteCount + 1, o + a);
        return 2078 === s.binaryShiftByteCount && (s = s.endBinaryShift(e + 1)), s;
    }, t.prototype.endBinaryShift = function(e) {
        if (0 === this.binaryShiftByteCount) return this;
        var r = this.token;
        return new t(r = function(t, e, r) {
            return new $849102574a83a574$var$Ai(t, e, r);
        }(r, e - this.binaryShiftByteCount, this.binaryShiftByteCount), this.mode, 0, this.bitCount);
    }, t.prototype.isBetterThanOrEqualTo = function(e) {
        var r = this.bitCount + ($849102574a83a574$var$Ii[this.mode][e.mode] >> 16);
        return this.binaryShiftByteCount < e.binaryShiftByteCount ? r += t.calculateBinaryShiftCost(e) - t.calculateBinaryShiftCost(this) : this.binaryShiftByteCount > e.binaryShiftByteCount && e.binaryShiftByteCount > 0 && (r += 10), r <= e.bitCount;
    }, t.prototype.toBitArray = function(t) {
        for(var e, r, n = [], o = this.endBinaryShift(t.length).token; null !== o; o = o.getPrevious())n.unshift(o);
        var i = new $849102574a83a574$var$V;
        try {
            for(var a = $849102574a83a574$var$Oi(n), s = a.next(); !s.done; s = a.next())s.value.appendTo(i, t);
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (r = a.return) && r.call(a);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.prototype.toString = function() {
        return $849102574a83a574$var$q.format("%s bits=%d bytes=%d", $849102574a83a574$var$mi[this.mode], this.bitCount, this.binaryShiftByteCount);
    }, t.calculateBinaryShiftCost = function(t) {
        return t.binaryShiftByteCount > 62 ? 21 : t.binaryShiftByteCount > 31 ? 20 : t.binaryShiftByteCount > 0 ? 10 : 0;
    }, t.INITIAL_STATE = new t($849102574a83a574$var$Ei, 0, 0, 0), t;
}();
var $849102574a83a574$var$Ri = function(t) {
    var e = $849102574a83a574$var$q.getCharCode(" "), r = $849102574a83a574$var$q.getCharCode("."), n = $849102574a83a574$var$q.getCharCode(",");
    t[0][e] = 1;
    for(var o = $849102574a83a574$var$q.getCharCode("Z"), i = $849102574a83a574$var$q.getCharCode("A"), a = i; a <= o; a++)t[0][a] = a - i + 2;
    t[1][e] = 1;
    var s = $849102574a83a574$var$q.getCharCode("z"), u = $849102574a83a574$var$q.getCharCode("a");
    for(a = u; a <= s; a++)t[1][a] = a - u + 2;
    t[2][e] = 1;
    var c = $849102574a83a574$var$q.getCharCode("9"), f = $849102574a83a574$var$q.getCharCode("0");
    for(a = f; a <= c; a++)t[2][a] = a - f + 2;
    t[2][n] = 12, t[2][r] = 13;
    for(var h = [
        "\x00",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f"
    ], l = 0; l < h.length; l++)t[3][$849102574a83a574$var$q.getCharCode(h[l])] = l;
    var d = [
        "\x00",
        "\r",
        "\x00",
        "\x00",
        "\x00",
        "\x00",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(l = 0; l < d.length; l++)$849102574a83a574$var$q.getCharCode(d[l]) > 0 && (t[4][$849102574a83a574$var$q.getCharCode(d[l])] = l);
    return t;
}($849102574a83a574$var$k.createInt32Array(5, 256)), $849102574a83a574$var$Ni = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $849102574a83a574$var$Di = function() {
    function t(t) {
        this.text = t;
    }
    return t.prototype.encode = function() {
        for(var e = $849102574a83a574$var$q.getCharCode(" "), r = $849102574a83a574$var$q.getCharCode("\n"), n = $849102574a83a574$var$gi.singletonList($849102574a83a574$var$bi.INITIAL_STATE), o = 0; o < this.text.length; o++){
            var i = void 0, a = o + 1 < this.text.length ? this.text[o + 1] : 0;
            switch(this.text[o]){
                case $849102574a83a574$var$q.getCharCode("\r"):
                    i = a === r ? 2 : 0;
                    break;
                case $849102574a83a574$var$q.getCharCode("."):
                    i = a === e ? 3 : 0;
                    break;
                case $849102574a83a574$var$q.getCharCode(","):
                    i = a === e ? 4 : 0;
                    break;
                case $849102574a83a574$var$q.getCharCode(":"):
                    i = a === e ? 5 : 0;
                    break;
                default:
                    i = 0;
            }
            i > 0 ? (n = t.updateStateListForPair(n, o, i), o++) : n = this.updateStateListForChar(n, o);
        }
        return $849102574a83a574$var$gi.min(n, function(t, e) {
            return t.getBitCount() - e.getBitCount();
        }).toBitArray(this.text);
    }, t.prototype.updateStateListForChar = function(e, r) {
        var n, o, i = [];
        try {
            for(var a = $849102574a83a574$var$Ni(e), s = a.next(); !s.done; s = a.next()){
                var u = s.value;
                this.updateStateForChar(u, r, i);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = a.return) && o.call(a);
            } finally{
                if (n) throw n.error;
            }
        }
        return t.simplifyStates(i);
    }, t.prototype.updateStateForChar = function(t, e, r) {
        for(var n = 255 & this.text[e], o = $849102574a83a574$var$Ri[t.getMode()][n] > 0, i = null, a = 0; a <= 4; a++){
            var s = $849102574a83a574$var$Ri[a][n];
            if (s > 0) {
                if (null == i && (i = t.endBinaryShift(e)), !o || a === t.getMode() || 2 === a) {
                    var u = i.latchAndAppend(a, s);
                    r.push(u);
                }
                if (!o && $849102574a83a574$var$Ti[t.getMode()][a] >= 0) {
                    var c = i.shiftAndAppend(a, s);
                    r.push(c);
                }
            }
        }
        if (t.getBinaryShiftByteCount() > 0 || 0 === $849102574a83a574$var$Ri[t.getMode()][n]) {
            var f = t.addBinaryShiftChar(e);
            r.push(f);
        }
    }, t.updateStateListForPair = function(t, e, r) {
        var n, o, i = [];
        try {
            for(var a = $849102574a83a574$var$Ni(t), s = a.next(); !s.done; s = a.next()){
                var u = s.value;
                this.updateStateForPair(u, e, r, i);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = a.return) && o.call(a);
            } finally{
                if (n) throw n.error;
            }
        }
        return this.simplifyStates(i);
    }, t.updateStateForPair = function(t, e, r, n) {
        var o = t.endBinaryShift(e);
        if (n.push(o.latchAndAppend(4, r)), 4 !== t.getMode() && n.push(o.shiftAndAppend(4, r)), 3 === r || 4 === r) {
            var i = o.latchAndAppend(2, 16 - r).latchAndAppend(2, 1);
            n.push(i);
        }
        if (t.getBinaryShiftByteCount() > 0) {
            var a = t.addBinaryShiftChar(e).addBinaryShiftChar(e + 1);
            n.push(a);
        }
    }, t.simplifyStates = function(t) {
        var e, r, n, o, i = [];
        try {
            for(var a = $849102574a83a574$var$Ni(t), s = a.next(); !s.done; s = a.next()){
                var u = s.value, c = !0, f = function(t) {
                    if (t.isBetterThanOrEqualTo(u)) return c = !1, "break";
                    u.isBetterThanOrEqualTo(t) && (i = i.filter(function(e) {
                        return e !== t;
                    }));
                };
                try {
                    for(var h = (n = void 0, $849102574a83a574$var$Ni(i)), l = h.next(); !l.done; l = h.next()){
                        if ("break" === f(l.value)) break;
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (o = h.return) && o.call(h);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                c && i.push(u);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (r = a.return) && r.call(a);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t;
}(), $849102574a83a574$var$Mi = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.encodeBytes = function(e) {
        return t.encode(e, t.DEFAULT_EC_PERCENT, t.DEFAULT_AZTEC_LAYERS);
    }, t.encode = function(e, r, n) {
        var o, i, a, s, u, c = new $849102574a83a574$var$Di(e).encode(), f = $849102574a83a574$var$x.truncDivision(c.getSize() * r, 100) + 11, h = c.getSize() + f;
        if (n !== t.DEFAULT_AZTEC_LAYERS) {
            if (o = n < 0, (i = Math.abs(n)) > (o ? t.MAX_NB_BITS_COMPACT : t.MAX_NB_BITS)) throw new $849102574a83a574$var$T($849102574a83a574$var$q.format("Illegal value %s for layers", n));
            var l = (a = t.totalBitsInLayer(i, o)) - a % (s = t.WORD_SIZE[i]);
            if ((u = t.stuffBits(c, s)).getSize() + f > l) throw new $849102574a83a574$var$T("Data to large for user specified layer");
            if (o && u.getSize() > 64 * s) throw new $849102574a83a574$var$T("Data to large for user specified layer");
        } else {
            s = 0, u = null;
            for(var d = 0;; d++){
                if (d > t.MAX_NB_BITS) throw new $849102574a83a574$var$T("Data too large for an Aztec code");
                if (i = (o = d <= 3) ? d + 1 : d, !(h > (a = t.totalBitsInLayer(i, o)))) {
                    null != u && s === t.WORD_SIZE[i] || (s = t.WORD_SIZE[i], u = t.stuffBits(c, s));
                    l = a - a % s;
                    if (!(o && u.getSize() > 64 * s) && u.getSize() + f <= l) break;
                }
            }
        }
        var p, g = t.generateCheckWords(u, a, s), y = u.getSize() / s, w = t.generateModeMessage(o, i, y), v = (o ? 11 : 14) + 4 * i, _ = new Int32Array(v);
        if (o) {
            p = v;
            for(d = 0; d < _.length; d++)_[d] = d;
        } else {
            p = v + 1 + 2 * $849102574a83a574$var$x.truncDivision($849102574a83a574$var$x.truncDivision(v, 2) - 1, 15);
            var A = $849102574a83a574$var$x.truncDivision(v, 2), C = $849102574a83a574$var$x.truncDivision(p, 2);
            for(d = 0; d < A; d++){
                var m = d + $849102574a83a574$var$x.truncDivision(d, 15);
                _[A - d - 1] = C - m - 1, _[A + d] = C + m + 1;
            }
        }
        for(var E = new $849102574a83a574$var$J(p), I = (d = 0, 0); d < i; d++){
            for(var S = 4 * (i - d) + (o ? 9 : 12), O = 0; O < S; O++)for(var b = 2 * O, R = 0; R < 2; R++)g.get(I + b + R) && E.set(_[2 * d + R], _[2 * d + O]), g.get(I + 2 * S + b + R) && E.set(_[2 * d + O], _[v - 1 - 2 * d - R]), g.get(I + 4 * S + b + R) && E.set(_[v - 1 - 2 * d - R], _[v - 1 - 2 * d - O]), g.get(I + 6 * S + b + R) && E.set(_[v - 1 - 2 * d - O], _[2 * d + R]);
            I += 8 * S;
        }
        if (t.drawModeMessage(E, o, p, w), o) t.drawBullsEye(E, $849102574a83a574$var$x.truncDivision(p, 2), 5);
        else {
            t.drawBullsEye(E, $849102574a83a574$var$x.truncDivision(p, 2), 7);
            for(d = 0, O = 0; d < $849102574a83a574$var$x.truncDivision(v, 2) - 1; d += 15, O += 16)for(R = 1 & $849102574a83a574$var$x.truncDivision(p, 2); R < p; R += 2)E.set($849102574a83a574$var$x.truncDivision(p, 2) - O, R), E.set($849102574a83a574$var$x.truncDivision(p, 2) + O, R), E.set(R, $849102574a83a574$var$x.truncDivision(p, 2) - O), E.set(R, $849102574a83a574$var$x.truncDivision(p, 2) + O);
        }
        var N = new $849102574a83a574$var$pi;
        return N.setCompact(o), N.setSize(p), N.setLayers(i), N.setCodeWords(y), N.setMatrix(E), N;
    }, t.drawBullsEye = function(t, e, r) {
        for(var n = 0; n < r; n += 2)for(var o = e - n; o <= e + n; o++)t.set(o, e - n), t.set(o, e + n), t.set(e - n, o), t.set(e + n, o);
        t.set(e - r, e - r), t.set(e - r + 1, e - r), t.set(e - r, e - r + 1), t.set(e + r, e - r), t.set(e + r, e - r + 1), t.set(e + r, e + r - 1);
    }, t.generateModeMessage = function(e, r, n) {
        var o = new $849102574a83a574$var$V;
        return e ? (o.appendBits(r - 1, 2), o.appendBits(n - 1, 6), o = t.generateCheckWords(o, 28, 4)) : (o.appendBits(r - 1, 5), o.appendBits(n - 1, 11), o = t.generateCheckWords(o, 40, 4)), o;
    }, t.drawModeMessage = function(t, e, r, n) {
        var o = $849102574a83a574$var$x.truncDivision(r, 2);
        if (e) for(var i = 0; i < 7; i++){
            var a = o - 3 + i;
            n.get(i) && t.set(a, o - 5), n.get(i + 7) && t.set(o + 5, a), n.get(20 - i) && t.set(a, o + 5), n.get(27 - i) && t.set(o - 5, a);
        }
        else for(i = 0; i < 10; i++){
            a = o - 5 + i + $849102574a83a574$var$x.truncDivision(i, 5);
            n.get(i) && t.set(a, o - 7), n.get(i + 10) && t.set(o + 7, a), n.get(29 - i) && t.set(a, o + 7), n.get(39 - i) && t.set(o - 7, a);
        }
    }, t.generateCheckWords = function(e, r, n) {
        var o, i, a = e.getSize() / n, s = new $849102574a83a574$var$To(t.getGF(n)), u = $849102574a83a574$var$x.truncDivision(r, n), c = t.bitsToWords(e, n, u);
        s.encode(c, u - a);
        var f = r % n, h = new $849102574a83a574$var$V;
        h.appendBits(0, f);
        try {
            for(var l = $849102574a83a574$var$Mi(Array.from(c)), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h.appendBits(p, n);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
        return h;
    }, t.bitsToWords = function(t, e, r) {
        var n, o, i = new Int32Array(r);
        for(n = 0, o = t.getSize() / e; n < o; n++){
            for(var a = 0, s = 0; s < e; s++)a |= t.get(n * e + s) ? 1 << e - s - 1 : 0;
            i[n] = a;
        }
        return i;
    }, t.getGF = function(t) {
        switch(t){
            case 4:
                return $849102574a83a574$var$Tt.AZTEC_PARAM;
            case 6:
                return $849102574a83a574$var$Tt.AZTEC_DATA_6;
            case 8:
                return $849102574a83a574$var$Tt.AZTEC_DATA_8;
            case 10:
                return $849102574a83a574$var$Tt.AZTEC_DATA_10;
            case 12:
                return $849102574a83a574$var$Tt.AZTEC_DATA_12;
            default:
                throw new $849102574a83a574$var$T("Unsupported word size " + t);
        }
    }, t.stuffBits = function(t, e) {
        for(var r = new $849102574a83a574$var$V, n = t.getSize(), o = (1 << e) - 2, i = 0; i < n; i += e){
            for(var a = 0, s = 0; s < e; s++)(i + s >= n || t.get(i + s)) && (a |= 1 << e - 1 - s);
            (a & o) === o ? (r.appendBits(a & o, e), i--) : 0 == (a & o) ? (r.appendBits(1 | a, e), i--) : r.appendBits(a, e);
        }
        return r;
    }, t.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.DEFAULT_EC_PERCENT = 33, t.DEFAULT_AZTEC_LAYERS = 0, t.MAX_NB_BITS = 32, t.MAX_NB_BITS_COMPACT = 4, t.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
}();
var $849102574a83a574$var$Pi = function(t) {
    return t instanceof Date;
}, $849102574a83a574$var$Bi = function(t) {
    return null == t;
}, $849102574a83a574$var$Li = function(t) {
    return "object" == typeof t;
}, $849102574a83a574$var$Fi = function(t) {
    return !$849102574a83a574$var$Bi(t) && !Array.isArray(t) && $849102574a83a574$var$Li(t) && !$849102574a83a574$var$Pi(t);
}, $849102574a83a574$var$ki = function(t) {
    return $849102574a83a574$var$Bi(t) || !$849102574a83a574$var$Li(t);
};
function $849102574a83a574$var$xi(t, e) {
    if ($849102574a83a574$var$ki(t) || $849102574a83a574$var$ki(e)) return t === e;
    if ($849102574a83a574$var$Pi(t) && $849102574a83a574$var$Pi(e)) return t.getTime() === e.getTime();
    var r = Object.keys(t), n = Object.keys(e);
    if (r.length !== n.length) return !1;
    for(var o = 0, i = r; o < i.length; o++){
        var a = i[o], s = t[a];
        if (!n.includes(a)) return !1;
        if ("ref" !== a) {
            var u = e[a];
            if ($849102574a83a574$var$Pi(s) && $849102574a83a574$var$Pi(u) || $849102574a83a574$var$Fi(s) && $849102574a83a574$var$Fi(u) || Array.isArray(s) && Array.isArray(u) ? !$849102574a83a574$var$xi(s, u) : s !== u) return !1;
        }
    }
    return !0;
}
var $849102574a83a574$var$Vi = function(t) {
    var o = t.onResult, s = t.onError, f = t.scanDelay, h = t.hints, l = t.deviceId, d = t.stopDecoding, p = (0, $7fPBF.useRef)(!1), g = (0, $7fPBF.useRef)(o), y = (0, $7fPBF.useRef)(s), w = (0, $7fPBF.useRef)(null), v = (0, $7fPBF.useState)(t.constraints), _ = v[0], A = v[1], C = (0, $7fPBF.useMemo)(function() {
        return new $849102574a83a574$var$Co(h, f);
    }, []), m = (0, $7fPBF.useCallback)(function(t, e) {
        t && g.current(t), !e || e instanceof $849102574a83a574$var$tt || y.current(e);
    }, []), E = (0, $7fPBF.useCallback)(function() {
        C.reset();
    }, [
        C
    ]), I = (0, $7fPBF.useCallback)(function() {
        C.stopAsyncDecode();
    }, [
        C
    ]), S = (0, $7fPBF.useCallback)(function() {
        return $849102574a83a574$var$u(void 0, void 0, void 0, function() {
            var t, e;
            return $849102574a83a574$var$c(this, function(r) {
                switch(r.label){
                    case 0:
                        if (!w.current) return [
                            2
                        ];
                        r.label = 1;
                    case 1:
                        return r.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]), l ? [
                            4,
                            C.decodeFromVideoDevice(l, w.current, m)
                        ] : [
                            3,
                            3
                        ];
                    case 2:
                        return r.sent(), [
                            3,
                            5
                        ];
                    case 3:
                        return t = {
                            audio: !1,
                            video: _
                        }, [
                            4,
                            C.decodeFromConstraints(t, w.current, m)
                        ];
                    case 4:
                        r.sent(), r.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        return e = r.sent(), y.current(e), [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        C,
        l,
        _,
        m
    ]);
    return (0, $7fPBF.useEffect)(function() {
        if (p.current = !0, !d) return $849102574a83a574$var$u(void 0, void 0, void 0, function() {
            return $849102574a83a574$var$c(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            S()
                        ];
                    case 1:
                        return t.sent(), p.current || E(), [
                            2
                        ];
                }
            });
        }), function() {
            p.current = !1, E();
        };
        I();
    }, [
        S,
        E,
        d
    ]), (0, $7fPBF.useEffect)(function() {
        $849102574a83a574$var$xi(t.constraints, _) || A(t.constraints);
    }, [
        t.constraints
    ]), (0, $7fPBF.useEffect)(function() {
        g.current = o;
    }, [
        o
    ]), (0, $7fPBF.useEffect)(function() {
        y.current = s;
    }, [
        s
    ]), {
        ref: w,
        start: S,
        stop: d
    };
}, $849102574a83a574$var$Hi = {
    width: "100%",
    paddingTop: "100%",
    overflow: "hidden",
    position: "relative"
}, $849102574a83a574$var$Ui = {
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "block",
    overflow: "hidden",
    position: "absolute"
}, $849102574a83a574$export$646b390d8bcaeffa = function(r) {
    var n = r.containerStyle, o = r.videoStyle, i = r.constraints, a = void 0 === i ? $849102574a83a574$var$f : i, u = r.onResult, c = r.onDecode, h = r.viewFinder, l = r.hideCount, d = void 0 === l || l, p = r.tracker, y = void 0 !== p && p, w = r.viewFinderBorder, v = r.deviceId, _ = r.scanDelay, A = void 0 === _ ? 100 : _, C = function(t, e) {
        var r = {};
        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for(n = Object.getOwnPropertySymbols(t); o < n.length; o++)e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
        }
        return r;
    }(r, [
        "containerStyle",
        "videoStyle",
        "constraints",
        "onResult",
        "onDecode",
        "viewFinder",
        "hideCount",
        "tracker",
        "viewFinderBorder",
        "deviceId",
        "scanDelay"
    ]), m = (0, $7fPBF.useState)(0), E = m[0], I = m[1], S = (0, $7fPBF.useState)(), T = S[0], O = S[1], b = $849102574a83a574$var$Vi($849102574a83a574$var$s({
        onResult: function(t) {
            O(t), u && u(t), c && c(t.getText()), I(function(t) {
                return t + 1;
            });
        },
        constraints: a,
        deviceId: v,
        scanDelay: A
    }, C)).ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: $849102574a83a574$var$s($849102574a83a574$var$s({}, $849102574a83a574$var$Hi), n)
    }, h ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(h, null) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($849102574a83a574$var$g, {
        video: b.current,
        result: T,
        scanCount: E,
        hideCount: d,
        tracker: y,
        border: w,
        constraints: a,
        deviceId: v,
        scanDelay: A
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("video", {
        ref: b,
        muted: !0,
        playsInline: !0,
        style: $849102574a83a574$var$s($849102574a83a574$var$s({}, $849102574a83a574$var$Ui), o)
    }));
};


// browser
function $43127d27241ac2f4$var$fixProto(target, prototype) {
    var setPrototypeOf = Object.setPrototypeOf;
    setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function $43127d27241ac2f4$var$fixStack(target, fn) {
    if (fn === void 0) fn = target.constructor;
    var captureStackTrace = Error.captureStackTrace;
    captureStackTrace && captureStackTrace(target, fn);
}
var $43127d27241ac2f4$var$__extends = function() {
    var _extendStatics = function extendStatics(d, b) {
        _extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return _extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        _extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $43127d27241ac2f4$export$f7a70f5f17339408 = function(_super) {
    $43127d27241ac2f4$var$__extends(CustomError, _super);
    function CustomError(message, options) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, options) || this;
        Object.defineProperty(_this, "name", {
            value: _newTarget.name,
            enumerable: false,
            configurable: true
        });
        $43127d27241ac2f4$var$fixProto(_this, _newTarget.prototype);
        $43127d27241ac2f4$var$fixStack(_this);
        return _this;
    }
    return CustomError;
}(Error);
var $43127d27241ac2f4$var$__spreadArray = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $43127d27241ac2f4$export$aa5f2b9aeca47350(fn, parent) {
    if (parent === void 0) parent = Error;
    function CustomError() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!(this instanceof CustomError)) return new (CustomError.bind.apply(CustomError, $43127d27241ac2f4$var$__spreadArray([
            void 0
        ], args, false)))();
        parent.apply(this, args);
        Object.defineProperty(this, "name", {
            value: fn.name || parent.name,
            enumerable: false,
            configurable: true
        });
        fn.apply(this, args);
        $43127d27241ac2f4$var$fixStack(this, CustomError);
    }
    return Object.defineProperties(CustomError, {
        prototype: {
            value: Object.create(parent.prototype, {
                constructor: {
                    value: CustomError,
                    writable: true,
                    configurable: true
                }
            })
        }
    });
}


var $7715bd82b11d6dee$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $7715bd82b11d6dee$var$Exception = /** @class */ function(_super) {
    $7715bd82b11d6dee$var$__extends(Exception, _super);
    /**
     * Allows Exception to be constructed directly
     * with some message and prototype definition.
     */ function Exception(message) {
        if (message === void 0) message = undefined;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        return _this;
    }
    Exception.prototype.getKind = function() {
        var ex = this.constructor;
        return ex.kind;
    };
    /**
     * It's typed as string so it can be extended and overriden.
     */ Exception.kind = "Exception";
    return Exception;
}((0, $43127d27241ac2f4$export$f7a70f5f17339408));
var $7715bd82b11d6dee$export$2e2bcd8739ae039 = $7715bd82b11d6dee$var$Exception;


var $e8bfbc55b79267d4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $e8bfbc55b79267d4$var$ArgumentException = /** @class */ function(_super) {
    $e8bfbc55b79267d4$var$__extends(ArgumentException, _super);
    function ArgumentException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArgumentException.kind = "ArgumentException";
    return ArgumentException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $e8bfbc55b79267d4$export$2e2bcd8739ae039 = $e8bfbc55b79267d4$var$ArgumentException;


/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $f35d37e876714c26$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $f35d37e876714c26$var$IllegalArgumentException = /** @class */ function(_super) {
    $f35d37e876714c26$var$__extends(IllegalArgumentException, _super);
    function IllegalArgumentException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IllegalArgumentException.kind = "IllegalArgumentException";
    return IllegalArgumentException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $f35d37e876714c26$export$2e2bcd8739ae039 = $f35d37e876714c26$var$IllegalArgumentException;


var $ea8d2e97db9675c3$var$BinaryBitmap = /** @class */ function() {
    function BinaryBitmap(binarizer) {
        this.binarizer = binarizer;
        if (binarizer === null) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Binarizer must be non-null.");
    }
    /**
     * @return The width of the bitmap.
     */ BinaryBitmap.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    };
    /**
     * @return The height of the bitmap.
     */ BinaryBitmap.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    };
    /**
     * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
     * cached data. Callers should assume this method is expensive and call it as seldom as possible.
     * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
     *
     * @param y The row to fetch, which must be in [0, bitmap height)
     * @param row An optional preallocated array. If null or too small, it will be ignored.
     *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
     * @return The array of bits for this row (true means black).
     * @throws NotFoundException if row can't be binarized
     */ BinaryBitmap.prototype.getBlackRow = function(y /*int*/ , row) {
        return this.binarizer.getBlackRow(y, row);
    };
    /**
     * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
     * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
     * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
     * fetched using getBlackRow(), so don't mix and match between them.
     *
     * @return The 2D array of bits for the image (true means black).
     * @throws NotFoundException if image can't be binarized to make a matrix
     */ BinaryBitmap.prototype.getBlackMatrix = function() {
        // The matrix is created on demand the first time it is requested, then cached. There are two
        // reasons for this:
        // 1. This work will never be done if the caller only installs 1D Reader objects, or if a
        //    1D Reader finds a barcode before the 2D Readers run.
        // 2. This work will only be done once even if the caller installs multiple 2D Readers.
        if (this.matrix === null || this.matrix === undefined) this.matrix = this.binarizer.getBlackMatrix();
        return this.matrix;
    };
    /**
     * @return Whether this bitmap can be cropped.
     */ BinaryBitmap.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    };
    /**
     * Returns a new object with cropped image data. Implementations may keep a reference to the
     * original data rather than a copy. Only callable if isCropSupported() is true.
     *
     * @param left The left coordinate, which must be in [0,getWidth())
     * @param top The top coordinate, which must be in [0,getHeight())
     * @param width The width of the rectangle to crop.
     * @param height The height of the rectangle to crop.
     * @return A cropped version of this object.
     */ BinaryBitmap.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        var newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
    };
    /**
     * @return Whether this bitmap supports counter-clockwise rotation.
     */ BinaryBitmap.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    };
    /**
     * Returns a new object with rotated image data by 90 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ BinaryBitmap.prototype.rotateCounterClockwise = function() {
        var newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
    };
    /**
     * Returns a new object with rotated image data by 45 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ BinaryBitmap.prototype.rotateCounterClockwise45 = function() {
        var newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
    };
    /*@Override*/ BinaryBitmap.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (e /*: NotFoundException*/ ) {
            return "";
        }
    };
    return BinaryBitmap;
}();
var $ea8d2e97db9675c3$export$2e2bcd8739ae039 = $ea8d2e97db9675c3$var$BinaryBitmap;



var $e19cfb3b440de53d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $e19cfb3b440de53d$var$ChecksumException = /** @class */ function(_super) {
    $e19cfb3b440de53d$var$__extends(ChecksumException, _super);
    function ChecksumException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChecksumException.getChecksumInstance = function() {
        return new ChecksumException();
    };
    ChecksumException.kind = "ChecksumException";
    return ChecksumException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $e19cfb3b440de53d$export$2e2bcd8739ae039 = $e19cfb3b440de53d$var$ChecksumException;


/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class hierarchy provides a set of methods to convert luminance data to 1 bit data.
 * It allows the algorithm to vary polymorphically, for example allowing a very expensive
 * thresholding technique for servers and a fast one for mobile. It also permits the implementation
 * to vary, e.g. a JNI version for Android and a Java fallback version for other platforms.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $03611c9bb2a5a87c$var$Binarizer = /** @class */ function() {
    function Binarizer(source) {
        this.source = source;
    }
    Binarizer.prototype.getLuminanceSource = function() {
        return this.source;
    };
    Binarizer.prototype.getWidth = function() {
        return this.source.getWidth();
    };
    Binarizer.prototype.getHeight = function() {
        return this.source.getHeight();
    };
    return Binarizer;
}();
var $03611c9bb2a5a87c$export$2e2bcd8739ae039 = $03611c9bb2a5a87c$var$Binarizer;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.util.Arrays;*/ 
var $77e52d7ed15ef280$var$System = /** @class */ function() {
    function System() {}
    // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
    /**
     * Makes a copy of a array.
     */ System.arraycopy = function(src, srcPos, dest, destPos, length) {
        // TODO: better use split or set?
        while(length--)dest[destPos++] = src[srcPos++];
    };
    /**
     * Returns the current time in milliseconds.
     */ System.currentTimeMillis = function() {
        return Date.now();
    };
    return System;
}();
var $77e52d7ed15ef280$export$2e2bcd8739ae039 = $77e52d7ed15ef280$var$System;




var $d11d81052c0bc9f1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $d11d81052c0bc9f1$var$IndexOutOfBoundsException = /** @class */ function(_super) {
    $d11d81052c0bc9f1$var$__extends(IndexOutOfBoundsException, _super);
    function IndexOutOfBoundsException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexOutOfBoundsException.kind = "IndexOutOfBoundsException";
    return IndexOutOfBoundsException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $d11d81052c0bc9f1$export$2e2bcd8739ae039 = $d11d81052c0bc9f1$var$IndexOutOfBoundsException;


var $0e130d78a29a82e0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $0e130d78a29a82e0$var$ArrayIndexOutOfBoundsException = /** @class */ function(_super) {
    $0e130d78a29a82e0$var$__extends(ArrayIndexOutOfBoundsException, _super);
    function ArrayIndexOutOfBoundsException(index, message) {
        if (index === void 0) index = undefined;
        if (message === void 0) message = undefined;
        var _this = _super.call(this, message) || this;
        _this.index = index;
        _this.message = message;
        return _this;
    }
    ArrayIndexOutOfBoundsException.kind = "ArrayIndexOutOfBoundsException";
    return ArrayIndexOutOfBoundsException;
}((0, $d11d81052c0bc9f1$export$2e2bcd8739ae039));
var $0e130d78a29a82e0$export$2e2bcd8739ae039 = $0e130d78a29a82e0$var$ArrayIndexOutOfBoundsException;


var $eed4834329730fe6$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $eed4834329730fe6$var$Arrays = /** @class */ function() {
    function Arrays() {}
    /**
     * Assigns the specified int value to each element of the specified array
     * of ints.
     *
     * @param a the array to be filled
     * @param val the value to be stored in all elements of the array
     */ Arrays.fill = function(a, val) {
        for(var i = 0, len = a.length; i < len; i++)a[i] = val;
    };
    /**
     * Assigns the specified int value to each element of the specified
     * range of the specified array of ints.  The range to be filled
     * extends from index {@code fromIndex}, inclusive, to index
     * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
     * range to be filled is empty.)
     *
     * @param a the array to be filled
     * @param fromIndex the index of the first element (inclusive) to be
     *        filled with the specified value
     * @param toIndex the index of the last element (exclusive) to be
     *        filled with the specified value
     * @param val the value to be stored in all elements of the array
     * @throws IllegalArgumentException if {@code fromIndex > toIndex}
     * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
     *         {@code toIndex > a.length}
     */ Arrays.fillWithin = function(a, fromIndex, toIndex, val) {
        Arrays.rangeCheck(a.length, fromIndex, toIndex);
        for(var i = fromIndex; i < toIndex; i++)a[i] = val;
    };
    /**
     * Checks that {@code fromIndex} and {@code toIndex} are in
     * the range and throws an exception if they aren't.
     */ Arrays.rangeCheck = function(arrayLength, fromIndex, toIndex) {
        if (fromIndex > toIndex) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("fromIndex(" + fromIndex + ") > toIndex(" + toIndex + ")");
        if (fromIndex < 0) throw new (0, $0e130d78a29a82e0$export$2e2bcd8739ae039)(fromIndex);
        if (toIndex > arrayLength) throw new (0, $0e130d78a29a82e0$export$2e2bcd8739ae039)(toIndex);
    };
    Arrays.asList = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return args;
    };
    Arrays.create = function(rows, cols, value) {
        var arr = Array.from({
            length: rows
        });
        return arr.map(function(x) {
            return Array.from({
                length: cols
            }).fill(value);
        });
    };
    Arrays.createInt32Array = function(rows, cols, value) {
        var arr = Array.from({
            length: rows
        });
        return arr.map(function(x) {
            return Int32Array.from({
                length: cols
            }).fill(value);
        });
    };
    Arrays.equals = function(first, second) {
        if (!first) return false;
        if (!second) return false;
        if (!first.length) return false;
        if (!second.length) return false;
        if (first.length !== second.length) return false;
        for(var i = 0, length_1 = first.length; i < length_1; i++){
            if (first[i] !== second[i]) return false;
        }
        return true;
    };
    Arrays.hashCode = function(a) {
        var e_1, _a;
        if (a === null) return 0;
        var result = 1;
        try {
            for(var a_1 = $eed4834329730fe6$var$__values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()){
                var element = a_1_1.value;
                result = 31 * result + element;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (a_1_1 && !a_1_1.done && (_a = a_1.return)) _a.call(a_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return result;
    };
    Arrays.fillUint8Array = function(a, value) {
        for(var i = 0; i !== a.length; i++)a[i] = value;
    };
    Arrays.copyOf = function(original, newLength) {
        return original.slice(0, newLength);
    };
    Arrays.copyOfUint8Array = function(original, newLength) {
        if (original.length <= newLength) {
            var newArray = new Uint8Array(newLength);
            newArray.set(original);
            return newArray;
        }
        return original.slice(0, newLength);
    };
    Arrays.copyOfRange = function(original, from, to) {
        var newLength = to - from;
        var copy = new Int32Array(newLength);
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(original, from, copy, 0, newLength);
        return copy;
    };
    /*
    * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
    * for the new element.
    * Parameters:
    *     ar - A sorted array
    *     el - An element to search for
    *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
    *        a negative number  if a is less than b;
    *        0 if a is equal to b;
    *        a positive number of a is greater than b.
    * The array may contain duplicate elements. If there are more than one equal elements in the array,
    * the returned value can be the index of any one of the equal elements.
    *
    * http://jsfiddle.net/aryzhov/pkfst550/
    */ Arrays.binarySearch = function(ar, el, comparator) {
        if (undefined === comparator) comparator = Arrays.numberComparator;
        var m = 0;
        var n = ar.length - 1;
        while(m <= n){
            var k = n + m >> 1;
            var cmp = comparator(el, ar[k]);
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return -m - 1;
    };
    Arrays.numberComparator = function(a, b) {
        return a - b;
    };
    return Arrays;
}();
var $eed4834329730fe6$export$2e2bcd8739ae039 = $eed4834329730fe6$var$Arrays;


/**
 * Ponyfill for Java's Integer class.
 */ var $902e90c40380930f$var$Integer = /** @class */ function() {
    function Integer() {}
    Integer.numberOfTrailingZeros = function(i) {
        var y;
        if (i === 0) return 32;
        var n = 31;
        y = i << 16;
        if (y !== 0) {
            n -= 16;
            i = y;
        }
        y = i << 8;
        if (y !== 0) {
            n -= 8;
            i = y;
        }
        y = i << 4;
        if (y !== 0) {
            n -= 4;
            i = y;
        }
        y = i << 2;
        if (y !== 0) {
            n -= 2;
            i = y;
        }
        return n - (i << 1 >>> 31);
    };
    Integer.numberOfLeadingZeros = function(i) {
        // HD, Figure 5-6
        if (i === 0) return 32;
        var n = 1;
        if (i >>> 16 === 0) {
            n += 16;
            i <<= 16;
        }
        if (i >>> 24 === 0) {
            n += 8;
            i <<= 8;
        }
        if (i >>> 28 === 0) {
            n += 4;
            i <<= 4;
        }
        if (i >>> 30 === 0) {
            n += 2;
            i <<= 2;
        }
        n -= i >>> 31;
        return n;
    };
    Integer.toHexString = function(i) {
        return i.toString(16);
    };
    Integer.toBinaryString = function(intNumber) {
        return String(parseInt(String(intNumber), 2));
    };
    // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
    // Returns:
    // the number of one-bits in the two's complement binary representation of the specified int value.
    Integer.bitCount = function(i) {
        // HD, Figure 5-2
        i = i - (i >>> 1 & 0x55555555);
        i = (i & 0x33333333) + (i >>> 2 & 0x33333333);
        i = i + (i >>> 4) & 0x0f0f0f0f;
        i = i + (i >>> 8);
        i = i + (i >>> 16);
        return i & 0x3f;
    };
    Integer.truncDivision = function(dividend, divisor) {
        return Math.trunc(dividend / divisor);
    };
    /**
     * Converts A string to an integer.
     * @param s A string to convert into a number.
     * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
     */ Integer.parseInt = function(num, radix) {
        if (radix === void 0) radix = undefined;
        return parseInt(num, radix);
    };
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    return Integer;
}();
var $902e90c40380930f$export$2e2bcd8739ae039 = $902e90c40380930f$var$Integer;



/**
 * <p>A simple, fast array of bits, represented compactly by an array of ints internally.</p>
 *
 * @author Sean Owen
 */ var $d449ed9f21ed6168$var$BitArray /*implements Cloneable*/  = /** @class */ function() {
    // public constructor() {
    //   this.size = 0
    //   this.bits = new Int32Array(1)
    // }
    // public constructor(size?: number /*int*/) {
    //   if (undefined === size) {
    //     this.size = 0
    //   } else {
    //     this.size = size
    //   }
    //   this.bits = this.makeArray(size)
    // }
    // For testing only
    function BitArray(size /*int*/ , bits) {
        if (undefined === size) {
            this.size = 0;
            this.bits = new Int32Array(1);
        } else {
            this.size = size;
            if (undefined === bits || null === bits) this.bits = BitArray.makeArray(size);
            else this.bits = bits;
        }
    }
    BitArray.prototype.getSize = function() {
        return this.size;
    };
    BitArray.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    };
    BitArray.prototype.ensureCapacity = function(size /*int*/ ) {
        if (size > this.bits.length * 32) {
            var newBits = BitArray.makeArray(size);
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.bits, 0, newBits, 0, this.bits.length);
            this.bits = newBits;
        }
    };
    /**
     * @param i bit to get
     * @return true iff bit i is set
     */ BitArray.prototype.get = function(i /*int*/ ) {
        return (this.bits[Math.floor(i / 32)] & 1 << (i & 0x1F)) !== 0;
    };
    /**
     * Sets bit i.
     *
     * @param i bit to set
     */ BitArray.prototype.set = function(i /*int*/ ) {
        this.bits[Math.floor(i / 32)] |= 1 << (i & 0x1F);
    };
    /**
     * Flips bit i.
     *
     * @param i bit to set
     */ BitArray.prototype.flip = function(i /*int*/ ) {
        this.bits[Math.floor(i / 32)] ^= 1 << (i & 0x1F);
    };
    /**
     * @param from first bit to check
     * @return index of first bit that is set, starting from the given index, or size if none are set
     *  at or beyond this given index
     * @see #getNextUnset(int)
     */ BitArray.prototype.getNextSet = function(from /*int*/ ) {
        var size = this.size;
        if (from >= size) return size;
        var bits = this.bits;
        var bitsOffset = Math.floor(from / 32);
        var currentBits = bits[bitsOffset];
        // mask off lesser bits first
        currentBits &= ~((1 << (from & 0x1F)) - 1);
        var length = bits.length;
        while(currentBits === 0){
            if (++bitsOffset === length) return size;
            currentBits = bits[bitsOffset];
        }
        var result = bitsOffset * 32 + (0, $902e90c40380930f$export$2e2bcd8739ae039).numberOfTrailingZeros(currentBits);
        return result > size ? size : result;
    };
    /**
     * @param from index to start looking for unset bit
     * @return index of next unset bit, or {@code size} if none are unset until the end
     * @see #getNextSet(int)
     */ BitArray.prototype.getNextUnset = function(from /*int*/ ) {
        var size = this.size;
        if (from >= size) return size;
        var bits = this.bits;
        var bitsOffset = Math.floor(from / 32);
        var currentBits = ~bits[bitsOffset];
        // mask off lesser bits first
        currentBits &= ~((1 << (from & 0x1F)) - 1);
        var length = bits.length;
        while(currentBits === 0){
            if (++bitsOffset === length) return size;
            currentBits = ~bits[bitsOffset];
        }
        var result = bitsOffset * 32 + (0, $902e90c40380930f$export$2e2bcd8739ae039).numberOfTrailingZeros(currentBits);
        return result > size ? size : result;
    };
    /**
     * Sets a block of 32 bits, starting at bit i.
     *
     * @param i first bit to set
     * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
     * corresponds to bit i, the next-least-significant to i+1, and so on.
     */ BitArray.prototype.setBulk = function(i /*int*/ , newBits /*int*/ ) {
        this.bits[Math.floor(i / 32)] = newBits;
    };
    /**
     * Sets a range of bits.
     *
     * @param start start of range, inclusive.
     * @param end end of range, exclusive
     */ BitArray.prototype.setRange = function(start /*int*/ , end /*int*/ ) {
        if (end < start || start < 0 || end > this.size) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        if (end === start) return;
        end--; // will be easier to treat this as the last actually set bit -- inclusive
        var firstInt = Math.floor(start / 32);
        var lastInt = Math.floor(end / 32);
        var bits = this.bits;
        for(var i = firstInt; i <= lastInt; i++){
            var firstBit = i > firstInt ? 0 : start & 0x1F;
            var lastBit = i < lastInt ? 31 : end & 0x1F;
            // Ones from firstBit to lastBit, inclusive
            var mask = (2 << lastBit) - (1 << firstBit);
            bits[i] |= mask;
        }
    };
    /**
     * Clears all bits (sets to false).
     */ BitArray.prototype.clear = function() {
        var max = this.bits.length;
        var bits = this.bits;
        for(var i = 0; i < max; i++)bits[i] = 0;
    };
    /**
     * Efficient method to check if a range of bits is set, or not set.
     *
     * @param start start of range, inclusive.
     * @param end end of range, exclusive
     * @param value if true, checks that bits in range are set, otherwise checks that they are not set
     * @return true iff all bits are set or not set in range, according to value argument
     * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
     */ BitArray.prototype.isRange = function(start /*int*/ , end /*int*/ , value) {
        if (end < start || start < 0 || end > this.size) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        if (end === start) return true; // empty range matches
        end--; // will be easier to treat this as the last actually set bit -- inclusive
        var firstInt = Math.floor(start / 32);
        var lastInt = Math.floor(end / 32);
        var bits = this.bits;
        for(var i = firstInt; i <= lastInt; i++){
            var firstBit = i > firstInt ? 0 : start & 0x1F;
            var lastBit = i < lastInt ? 31 : end & 0x1F;
            // Ones from firstBit to lastBit, inclusive
            var mask = (2 << lastBit) - (1 << firstBit) & 0xFFFFFFFF;
            // TYPESCRIPTPORT: & 0xFFFFFFFF added to discard anything after 32 bits, as ES has 53 bits
            // Return false if we're looking for 1s and the masked bits[i] isn't all 1s (is: that,
            // equals the mask, or we're looking for 0s and the masked portion is not all 0s
            if ((bits[i] & mask) !== (value ? mask : 0)) return false;
        }
        return true;
    };
    BitArray.prototype.appendBit = function(bit) {
        this.ensureCapacity(this.size + 1);
        if (bit) this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 0x1F);
        this.size++;
    };
    /**
     * Appends the least-significant bits, from value, in order from most-significant to
     * least-significant. For example, appending 6 bits from 0x000001E will append the bits
     * 0, 1, 1, 1, 1, 0 in that order.
     *
     * @param value {@code int} containing bits to append
     * @param numBits bits from value to append
     */ BitArray.prototype.appendBits = function(value /*int*/ , numBits /*int*/ ) {
        if (numBits < 0 || numBits > 32) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + numBits);
        // const appendBit = this.appendBit;
        for(var numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--)this.appendBit((value >> numBitsLeft - 1 & 0x01) === 1);
    };
    BitArray.prototype.appendBitArray = function(other) {
        var otherSize = other.size;
        this.ensureCapacity(this.size + otherSize);
        // const appendBit = this.appendBit;
        for(var i = 0; i < otherSize; i++)this.appendBit(other.get(i));
    };
    BitArray.prototype.xor = function(other) {
        if (this.size !== other.size) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Sizes don't match");
        var bits = this.bits;
        for(var i = 0, length_1 = bits.length; i < length_1; i++)// The last int could be incomplete (i.e. not have 32 bits in
        // it) but there is no problem since 0 XOR 0 == 0.
        bits[i] ^= other.bits[i];
    };
    /**
     *
     * @param bitOffset first bit to start writing
     * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
     *  of the internal representation, which is exposed by {@link #getBitArray()}
     * @param offset position in array to start writing
     * @param numBytes how many bytes to write
     */ BitArray.prototype.toBytes = function(bitOffset /*int*/ , array, offset /*int*/ , numBytes /*int*/ ) {
        for(var i = 0; i < numBytes; i++){
            var theByte = 0;
            for(var j = 0; j < 8; j++){
                if (this.get(bitOffset)) theByte |= 1 << 7 - j;
                bitOffset++;
            }
            array[offset + i] = /*(byte)*/ theByte;
        }
    };
    /**
     * @return underlying array of ints. The first element holds the first 32 bits, and the least
     *         significant bit is bit 0.
     */ BitArray.prototype.getBitArray = function() {
        return this.bits;
    };
    /**
     * Reverses all bits in the array.
     */ BitArray.prototype.reverse = function() {
        var newBits = new Int32Array(this.bits.length);
        // reverse all int's first
        var len = Math.floor((this.size - 1) / 32);
        var oldBitsLen = len + 1;
        var bits = this.bits;
        for(var i = 0; i < oldBitsLen; i++){
            var x = bits[i];
            x = x >> 1 & 0x55555555 | (x & 0x55555555) << 1;
            x = x >> 2 & 0x33333333 | (x & 0x33333333) << 2;
            x = x >> 4 & 0x0f0f0f0f | (x & 0x0f0f0f0f) << 4;
            x = x >> 8 & 0x00ff00ff | (x & 0x00ff00ff) << 8;
            x = x >> 16 & 0x0000ffff | (x & 0x0000ffff) << 16;
            newBits[len - i] = /*(int)*/ x;
        }
        // now correct the int's if the bit size isn't a multiple of 32
        if (this.size !== oldBitsLen * 32) {
            var leftOffset = oldBitsLen * 32 - this.size;
            var currentInt = newBits[0] >>> leftOffset;
            for(var i = 1; i < oldBitsLen; i++){
                var nextInt = newBits[i];
                currentInt |= nextInt << 32 - leftOffset;
                newBits[i - 1] = currentInt;
                currentInt = nextInt >>> leftOffset;
            }
            newBits[oldBitsLen - 1] = currentInt;
        }
        this.bits = newBits;
    };
    BitArray.makeArray = function(size /*int*/ ) {
        return new Int32Array(Math.floor((size + 31) / 32));
    };
    /*@Override*/ BitArray.prototype.equals = function(o) {
        if (!(o instanceof BitArray)) return false;
        var other = o;
        return this.size === other.size && (0, $eed4834329730fe6$export$2e2bcd8739ae039).equals(this.bits, other.bits);
    };
    /*@Override*/ BitArray.prototype.hashCode = function() {
        return 31 * this.size + (0, $eed4834329730fe6$export$2e2bcd8739ae039).hashCode(this.bits);
    };
    /*@Override*/ BitArray.prototype.toString = function() {
        var result = "";
        for(var i = 0, size = this.size; i < size; i++){
            if ((i & 0x07) === 0) result += " ";
            result += this.get(i) ? "X" : ".";
        }
        return result;
    };
    /*@Override*/ BitArray.prototype.clone = function() {
        return new BitArray(this.size, this.bits.slice());
    };
    /**
     * converts to boolean array.
     */ BitArray.prototype.toArray = function() {
        var result = [];
        for(var i = 0, size = this.size; i < size; i++)result.push(this.get(i));
        return result;
    };
    return BitArray;
}();
var $d449ed9f21ed6168$export$2e2bcd8739ae039 = $d449ed9f21ed6168$var$BitArray;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.util.Arrays;*/ 


/*
 * Copyright (C) 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.nio.charset.Charset;*/ /*import java.util.Map;*/ /*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * Encapsulates a type of hint that a caller may pass to a barcode reader to help it
 * more quickly or accurately decode it. It is up to implementations to decide what,
 * if anything, to do with the information that is supplied.
 *
 * @author Sean Owen
 * @author dswitkin@google.com (Daniel Switkin)
 * @see Reader#decode(BinaryBitmap,java.util.Map)
 */ var $7d7d8fb74b352319$var$DecodeHintType;
(function(DecodeHintType) {
    /**
     * Unspecified, application-specific hint. Maps to an unspecified {@link Object}.
     */ DecodeHintType[DecodeHintType["OTHER"] = 0] = "OTHER"; /*(Object.class)*/ 
    /**
     * Image is a pure monochrome image of a barcode. Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["PURE_BARCODE"] = 1] = "PURE_BARCODE"; /*(Void.class)*/ 
    /**
     * Image is known to be of one of a few possible formats.
     * Maps to a {@link List} of {@link BarcodeFormat}s.
     */ DecodeHintType[DecodeHintType["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS"; /*(List.class)*/ 
    /**
     * Spend more time to try to find a barcode; optimize for accuracy, not speed.
     * Doesn't matter what it maps to; use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["TRY_HARDER"] = 3] = "TRY_HARDER"; /*(Void.class)*/ 
    /**
     * Specifies what character encoding to use when decoding, where applicable (type String)
     */ DecodeHintType[DecodeHintType["CHARACTER_SET"] = 4] = "CHARACTER_SET"; /*(String.class)*/ 
    /**
     * Allowed lengths of encoded data -- reject anything else. Maps to an {@code Int32Array}.
     */ DecodeHintType[DecodeHintType["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS"; /*(Int32Array.class)*/ 
    /**
     * Assume Code 39 codes employ a check digit. Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT"; /*(Void.class)*/ 
    /**
     * Assume the barcode is being processed as a GS1 barcode, and modify behavior as needed.
     * For example this affects FNC1 handling for Code 128 (aka GS1-128). Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["ASSUME_GS1"] = 7] = "ASSUME_GS1"; /*(Void.class)*/ 
    /**
     * If true, return the start and end digits in a Codabar barcode instead of stripping them. They
     * are alpha, whereas the rest are numeric. By default, they are stripped, but this causes them
     * to not be. Doesn't matter what it maps to; use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END"; /*(Void.class)*/ 
    /**
     * The caller needs to be notified via callback when a possible {@link ResultPoint}
     * is found. Maps to a {@link ResultPointCallback}.
     */ DecodeHintType[DecodeHintType["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK"; /*(ResultPointCallback.class)*/ 
    /**
     * Allowed extension lengths for EAN or UPC barcodes. Other formats will ignore this.
     * Maps to an {@code Int32Array} of the allowed extension lengths, for example [2], [5], or [2, 5].
     * If it is optional to have an extension, do not set this hint. If this is set,
     * and a UPC or EAN barcode is found but an extension is not, then no result will be returned
     * at all.
     */ DecodeHintType[DecodeHintType["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS"; /*(Int32Array.class)*/ 
// End of enumeration values.
/**
     * Data type the hint is expecting.
     * Among the possible values the {@link Void} stands out as being used for
     * hints that do not expect a value to be supplied (flag hints). Such hints
     * will possibly have their value ignored, or replaced by a
     * {@link Boolean#TRUE}. Hint suppliers should probably use
     * {@link Boolean#TRUE} as directed by the actual hint documentation.
     */ // private valueType: Class<?>
// DecodeHintType(valueType: Class<?>) {
//   this.valueType = valueType
// }
// public getValueType(): Class<?> {
//   return valueType
// }
})($7d7d8fb74b352319$var$DecodeHintType || ($7d7d8fb74b352319$var$DecodeHintType = {}));
var $7d7d8fb74b352319$export$2e2bcd8739ae039 = $7d7d8fb74b352319$var$DecodeHintType;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $13fe167df36b6e3a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $13fe167df36b6e3a$var$FormatException = /** @class */ function(_super) {
    $13fe167df36b6e3a$var$__extends(FormatException, _super);
    function FormatException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormatException.getFormatInstance = function() {
        return new FormatException();
    };
    FormatException.kind = "FormatException";
    return FormatException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $13fe167df36b6e3a$export$2e2bcd8739ae039 = $13fe167df36b6e3a$var$FormatException;


var $cb860ff3f180bf6b$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $cb860ff3f180bf6b$export$f767678c309eaa03;
(function(CharacterSetValueIdentifiers) {
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp437"] = 0] = "Cp437";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_1"] = 1] = "ISO8859_1";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_2"] = 2] = "ISO8859_2";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_3"] = 3] = "ISO8859_3";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_4"] = 4] = "ISO8859_4";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_5"] = 5] = "ISO8859_5";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_6"] = 6] = "ISO8859_6";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_7"] = 7] = "ISO8859_7";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_8"] = 8] = "ISO8859_8";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_9"] = 9] = "ISO8859_9";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_10"] = 10] = "ISO8859_10";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_11"] = 11] = "ISO8859_11";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_13"] = 12] = "ISO8859_13";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_14"] = 13] = "ISO8859_14";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_15"] = 14] = "ISO8859_15";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_16"] = 15] = "ISO8859_16";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["SJIS"] = 16] = "SJIS";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1250"] = 17] = "Cp1250";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1251"] = 18] = "Cp1251";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1252"] = 19] = "Cp1252";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1256"] = 20] = "Cp1256";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UTF8"] = 22] = "UTF8";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ASCII"] = 23] = "ASCII";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Big5"] = 24] = "Big5";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["GB18030"] = 25] = "GB18030";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["EUC_KR"] = 26] = "EUC_KR";
})($cb860ff3f180bf6b$export$f767678c309eaa03 || ($cb860ff3f180bf6b$export$f767678c309eaa03 = {}));
/**
 * Encapsulates a Character Set ECI, according to "Extended Channel Interpretations" 5.3.1.1
 * of ISO 18004.
 *
 * @author Sean Owen
 */ var $cb860ff3f180bf6b$var$CharacterSetECI = /** @class */ function() {
    function CharacterSetECI(valueIdentifier, valuesParam, name) {
        var e_1, _a;
        var otherEncodingNames = [];
        for(var _i = 3; _i < arguments.length; _i++)otherEncodingNames[_i - 3] = arguments[_i];
        this.valueIdentifier = valueIdentifier;
        this.name = name;
        if (typeof valuesParam === "number") this.values = Int32Array.from([
            valuesParam
        ]);
        else this.values = valuesParam;
        this.otherEncodingNames = otherEncodingNames;
        CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
        CharacterSetECI.NAME_TO_ECI.set(name, this);
        var values = this.values;
        for(var i = 0, length_1 = values.length; i !== length_1; i++){
            var v = values[i];
            CharacterSetECI.VALUES_TO_ECI.set(v, this);
        }
        try {
            for(var otherEncodingNames_1 = $cb860ff3f180bf6b$var$__values(otherEncodingNames), otherEncodingNames_1_1 = otherEncodingNames_1.next(); !otherEncodingNames_1_1.done; otherEncodingNames_1_1 = otherEncodingNames_1.next()){
                var otherName = otherEncodingNames_1_1.value;
                CharacterSetECI.NAME_TO_ECI.set(otherName, this);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (otherEncodingNames_1_1 && !otherEncodingNames_1_1.done && (_a = otherEncodingNames_1.return)) _a.call(otherEncodingNames_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    // CharacterSetECI(value: number /*int*/) {
    //   this(new Int32Array {value})
    // }
    // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
    //   this.values = new Int32Array {value}
    //   this.otherEncodingNames = otherEncodingNames
    // }
    // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
    //   this.values = values
    //   this.otherEncodingNames = otherEncodingNames
    // }
    CharacterSetECI.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    };
    CharacterSetECI.prototype.getName = function() {
        return this.name;
    };
    CharacterSetECI.prototype.getValue = function() {
        return this.values[0];
    };
    /**
     * @param value character set ECI value
     * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
     *   unsupported
     * @throws FormatException if ECI value is invalid
     */ CharacterSetECI.getCharacterSetECIByValue = function(value /*int*/ ) {
        if (value < 0 || value >= 900) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)("incorect value");
        var characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
        if (undefined === characterSet) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)("incorect value");
        return characterSet;
    };
    /**
     * @param name character set ECI encoding name
     * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
     *   but unsupported
     */ CharacterSetECI.getCharacterSetECIByName = function(name) {
        var characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
        if (undefined === characterSet) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)("incorect value");
        return characterSet;
    };
    CharacterSetECI.prototype.equals = function(o) {
        if (!(o instanceof CharacterSetECI)) return false;
        var other = o;
        return this.getName() === other.getName();
    };
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = new Map();
    CharacterSetECI.VALUES_TO_ECI = new Map();
    CharacterSetECI.NAME_TO_ECI = new Map();
    // Enum name is a Java encoding valid for java.lang and java.io
    // TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
    // (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
    // later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
    CharacterSetECI.Cp437 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437");
    CharacterSetECI.ISO8859_1 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1");
    CharacterSetECI.ISO8859_2 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2");
    CharacterSetECI.ISO8859_3 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3");
    CharacterSetECI.ISO8859_4 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4");
    CharacterSetECI.ISO8859_5 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5");
    CharacterSetECI.ISO8859_6 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6");
    CharacterSetECI.ISO8859_7 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7");
    CharacterSetECI.ISO8859_8 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8");
    CharacterSetECI.ISO8859_9 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9");
    CharacterSetECI.ISO8859_10 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10");
    CharacterSetECI.ISO8859_11 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11");
    CharacterSetECI.ISO8859_13 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13");
    CharacterSetECI.ISO8859_14 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14");
    CharacterSetECI.ISO8859_15 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15");
    CharacterSetECI.ISO8859_16 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16");
    CharacterSetECI.SJIS = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.SJIS, 20, "SJIS", "Shift_JIS");
    CharacterSetECI.Cp1250 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.Cp1250, 21, "Cp1250", "windows-1250");
    CharacterSetECI.Cp1251 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.Cp1251, 22, "Cp1251", "windows-1251");
    CharacterSetECI.Cp1252 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.Cp1252, 23, "Cp1252", "windows-1252");
    CharacterSetECI.Cp1256 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.Cp1256, 24, "Cp1256", "windows-1256");
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig");
    CharacterSetECI.UTF8 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.UTF8, 26, "UTF8", "UTF-8");
    CharacterSetECI.ASCII = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII");
    CharacterSetECI.Big5 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.Big5, 28, "Big5");
    CharacterSetECI.GB18030 = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK");
    CharacterSetECI.EUC_KR = new CharacterSetECI($cb860ff3f180bf6b$export$f767678c309eaa03.EUC_KR, 30, "EUC_KR", "EUC-KR");
    return CharacterSetECI;
}();
var $cb860ff3f180bf6b$export$2e2bcd8739ae039 = $cb860ff3f180bf6b$var$CharacterSetECI;



var $9900d18ea51157af$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $9900d18ea51157af$var$UnsupportedOperationException = /** @class */ function(_super) {
    $9900d18ea51157af$var$__extends(UnsupportedOperationException, _super);
    function UnsupportedOperationException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedOperationException.kind = "UnsupportedOperationException";
    return UnsupportedOperationException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $9900d18ea51157af$export$2e2bcd8739ae039 = $9900d18ea51157af$var$UnsupportedOperationException;



/**
 * Responsible for en/decoding strings.
 */ var $3a88fa58822b35a1$var$StringEncoding = /** @class */ function() {
    function StringEncoding() {}
    /**
     * Decodes some Uint8Array to a string format.
     */ StringEncoding.decode = function(bytes, encoding) {
        var encodingName = this.encodingName(encoding);
        if (this.customDecoder) return this.customDecoder(bytes, encodingName);
        // Increases browser support.
        if (typeof TextDecoder === "undefined" || this.shouldDecodeOnFallback(encodingName)) return this.decodeFallback(bytes, encodingName);
        return new TextDecoder(encodingName).decode(bytes);
    };
    /**
     * Checks if the decoding method should use the fallback for decoding
     * once Node TextDecoder doesn't support all encoding formats.
     *
     * @param encodingName
     */ StringEncoding.shouldDecodeOnFallback = function(encodingName) {
        return !StringEncoding.isBrowser() && encodingName === "ISO-8859-1";
    };
    /**
     * Encodes some string into a Uint8Array.
     */ StringEncoding.encode = function(s, encoding) {
        var encodingName = this.encodingName(encoding);
        if (this.customEncoder) return this.customEncoder(s, encodingName);
        // Increases browser support.
        if (typeof TextEncoder === "undefined") return this.encodeFallback(s);
        // TextEncoder only encodes to UTF8 by default as specified by encoding.spec.whatwg.org
        return new TextEncoder().encode(s);
    };
    StringEncoding.isBrowser = function() {
        return typeof window !== "undefined" && ({}).toString.call(window) === "[object Window]";
    };
    /**
     * Returns the string value from some encoding character set.
     */ StringEncoding.encodingName = function(encoding) {
        return typeof encoding === "string" ? encoding : encoding.getName();
    };
    /**
     * Returns character set from some encoding character set.
     */ StringEncoding.encodingCharacterSet = function(encoding) {
        if (encoding instanceof (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039)) return encoding;
        return (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).getCharacterSetECIByName(encoding);
    };
    /**
     * Runs a fallback for the native decoding funcion.
     */ StringEncoding.decodeFallback = function(bytes, encoding) {
        var characterSet = this.encodingCharacterSet(encoding);
        if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
            var s = "";
            for(var i = 0, length_1 = bytes.length; i < length_1; i++){
                var h = bytes[i].toString(16);
                if (h.length < 2) h = "0" + h;
                s += "%" + h;
            }
            return decodeURIComponent(s);
        }
        if (characterSet.equals((0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
        throw new (0, $9900d18ea51157af$export$2e2bcd8739ae039)("Encoding " + this.encodingName(encoding) + " not supported by fallback.");
    };
    StringEncoding.isDecodeFallbackSupported = function(characterSet) {
        return characterSet.equals((0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).UTF8) || characterSet.equals((0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).ISO8859_1) || characterSet.equals((0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).ASCII);
    };
    /**
     * Runs a fallback for the native encoding funcion.
     *
     * @see https://stackoverflow.com/a/17192845/4367683
     */ StringEncoding.encodeFallback = function(s) {
        var encodedURIstring = btoa(unescape(encodeURIComponent(s)));
        var charList = encodedURIstring.split("");
        var uintArray = [];
        for(var i = 0; i < charList.length; i++)uintArray.push(charList[i].charCodeAt(0));
        return new Uint8Array(uintArray);
    };
    return StringEncoding;
}();
var $3a88fa58822b35a1$export$2e2bcd8739ae039 = $3a88fa58822b35a1$var$StringEncoding;


/**
 * Common string-related functions.
 *
 * @author Sean Owen
 * @author Alex Dupre
 */ var $d9f8f9e5b61dd63f$var$StringUtils = /** @class */ function() {
    function StringUtils() {}
    // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
    // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
    StringUtils.castAsNonUtf8Char = function(code, encoding) {
        if (encoding === void 0) encoding = null;
        // ISO 8859-1 is the Java default as UTF-8 is JavaScripts
        // you can see this method as a Java version of String.fromCharCode
        var e = encoding ? encoding.getName() : this.ISO88591;
        // use passed format (fromCharCode will return UTF8 encoding)
        return (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).decode(new Uint8Array([
            code
        ]), e);
    };
    /**
     * @param bytes bytes encoding a string, whose encoding should be guessed
     * @param hints decode hints if applicable
     * @return name of guessed encoding; at the moment will only guess one of:
     *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
     *  default encoding if none of these can possibly be correct
     */ StringUtils.guessEncoding = function(bytes, hints) {
        if (hints !== null && hints !== undefined && undefined !== hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).CHARACTER_SET)) return hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).CHARACTER_SET).toString();
        // For now, merely tries to distinguish ISO-8859-1, UTF-8 and Shift_JIS,
        // which should be by far the most common encodings.
        var length = bytes.length;
        var canBeISO88591 = true;
        var canBeShiftJIS = true;
        var canBeUTF8 = true;
        var utf8BytesLeft = 0;
        // int utf8LowChars = 0
        var utf2BytesChars = 0;
        var utf3BytesChars = 0;
        var utf4BytesChars = 0;
        var sjisBytesLeft = 0;
        // int sjisLowChars = 0
        var sjisKatakanaChars = 0;
        // int sjisDoubleBytesChars = 0
        var sjisCurKatakanaWordLength = 0;
        var sjisCurDoubleBytesWordLength = 0;
        var sjisMaxKatakanaWordLength = 0;
        var sjisMaxDoubleBytesWordLength = 0;
        // int isoLowChars = 0
        // int isoHighChars = 0
        var isoHighOther = 0;
        var utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */ 0xEF && bytes[1] === /*(byte) */ 0xBB && bytes[2] === /*(byte) */ 0xBF;
        for(var i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++){
            var value = bytes[i] & 0xFF;
            // UTF-8 stuff
            if (canBeUTF8) {
                if (utf8BytesLeft > 0) {
                    if ((value & 0x80) === 0) canBeUTF8 = false;
                    else utf8BytesLeft--;
                } else if ((value & 0x80) !== 0) {
                    if ((value & 0x40) === 0) canBeUTF8 = false;
                    else {
                        utf8BytesLeft++;
                        if ((value & 0x20) === 0) utf2BytesChars++;
                        else {
                            utf8BytesLeft++;
                            if ((value & 0x10) === 0) utf3BytesChars++;
                            else {
                                utf8BytesLeft++;
                                if ((value & 0x08) === 0) utf4BytesChars++;
                                else canBeUTF8 = false;
                            }
                        }
                    }
                } // else {
            // utf8LowChars++
            // }
            }
            // ISO-8859-1 stuff
            if (canBeISO88591) {
                if (value > 0x7F && value < 0xA0) canBeISO88591 = false;
                else if (value > 0x9F) {
                    if (value < 0xC0 || value === 0xD7 || value === 0xF7) isoHighOther++;
                     // else {
                } // else {
            // isoLowChars++
            // }
            }
            // Shift_JIS stuff
            if (canBeShiftJIS) {
                if (sjisBytesLeft > 0) {
                    if (value < 0x40 || value === 0x7F || value > 0xFC) canBeShiftJIS = false;
                    else sjisBytesLeft--;
                } else if (value === 0x80 || value === 0xA0 || value > 0xEF) canBeShiftJIS = false;
                else if (value > 0xA0 && value < 0xE0) {
                    sjisKatakanaChars++;
                    sjisCurDoubleBytesWordLength = 0;
                    sjisCurKatakanaWordLength++;
                    if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
                } else if (value > 0x7F) {
                    sjisBytesLeft++;
                    // sjisDoubleBytesChars++
                    sjisCurKatakanaWordLength = 0;
                    sjisCurDoubleBytesWordLength++;
                    if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
                } else {
                    // sjisLowChars++
                    sjisCurKatakanaWordLength = 0;
                    sjisCurDoubleBytesWordLength = 0;
                }
            }
        }
        if (canBeUTF8 && utf8BytesLeft > 0) canBeUTF8 = false;
        if (canBeShiftJIS && sjisBytesLeft > 0) canBeShiftJIS = false;
        // Easy -- if there is BOM or at least 1 valid not-single byte character (and no evidence it can't be UTF-8), done
        if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) return StringUtils.UTF8;
        // Easy -- if assuming Shift_JIS or at least 3 valid consecutive not-ascii characters (and no evidence it can't be), done
        if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) return StringUtils.SHIFT_JIS;
        // Distinguishing Shift_JIS and ISO-8859-1 can be a little tough for short words. The crude heuristic is:
        // - If we saw
        //   - only two consecutive katakana chars in the whole text, or
        //   - at least 10% of bytes that could be "upper" not-alphanumeric Latin1,
        // - then we conclude Shift_JIS, else ISO-8859-1
        if (canBeISO88591 && canBeShiftJIS) return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
        // Otherwise, try in order ISO-8859-1, Shift JIS, UTF-8 and fall back to default platform encoding
        if (canBeISO88591) return StringUtils.ISO88591;
        if (canBeShiftJIS) return StringUtils.SHIFT_JIS;
        if (canBeUTF8) return StringUtils.UTF8;
        // Otherwise, we take a wild guess with platform encoding
        return StringUtils.PLATFORM_DEFAULT_ENCODING;
    };
    /**
     *
     * @see https://stackoverflow.com/a/13439711/4367683
     *
     * @param append The new string to append.
     * @param args Argumets values to be formated.
     */ StringUtils.format = function(append) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var i = -1;
        function callback(exp, p0, p1, p2, p3, p4) {
            if (exp === "%%") return "%";
            if (args[++i] === undefined) return undefined;
            exp = p2 ? parseInt(p2.substr(1)) : undefined;
            var base = p3 ? parseInt(p3.substr(1)) : undefined;
            var val;
            switch(p4){
                case "s":
                    val = args[i];
                    break;
                case "c":
                    val = args[i][0];
                    break;
                case "f":
                    val = parseFloat(args[i]).toFixed(exp);
                    break;
                case "p":
                    val = parseFloat(args[i]).toPrecision(exp);
                    break;
                case "e":
                    val = parseFloat(args[i]).toExponential(exp);
                    break;
                case "x":
                    val = parseInt(args[i]).toString(base ? base : 16);
                    break;
                case "d":
                    val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                    break;
            }
            val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
            var size = parseInt(p1); /* padding size */ 
            var ch = p1 && p1[0] + "" === "0" ? "0" : " "; /* isnull? */ 
            while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
            return val;
        }
        var regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return append.replace(regex, callback);
    };
    /**
     *
     */ StringUtils.getBytes = function(str, encoding) {
        return (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).encode(str, encoding);
    };
    /**
     * Returns the charcode at the specified index or at index zero.
     */ StringUtils.getCharCode = function(str, index) {
        if (index === void 0) index = 0;
        return str.charCodeAt(index);
    };
    /**
     * Returns char for given charcode
     */ StringUtils.getCharAt = function(charCode) {
        return String.fromCharCode(charCode);
    };
    StringUtils.SHIFT_JIS = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).SJIS.getName(); // "SJIS"
    StringUtils.GB2312 = "GB2312";
    StringUtils.ISO88591 = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).ISO8859_1.getName(); // "ISO8859_1"
    StringUtils.EUC_JP = "EUC_JP";
    StringUtils.UTF8 = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).UTF8.getName(); // "UTF8"
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8; // "UTF8"//Charset.defaultCharset().name()
    StringUtils.ASSUME_SHIFT_JIS = false;
    return StringUtils;
}();
var $d9f8f9e5b61dd63f$export$2e2bcd8739ae039 = $d9f8f9e5b61dd63f$var$StringUtils;


var $f9764fdce9a0dbd7$var$StringBuilder = /** @class */ function() {
    function StringBuilder(value) {
        if (value === void 0) value = "";
        this.value = value;
    }
    StringBuilder.prototype.enableDecoding = function(encoding) {
        this.encoding = encoding;
        return this;
    };
    StringBuilder.prototype.append = function(s) {
        if (typeof s === "string") this.value += s.toString();
        else if (this.encoding) // use passed format (fromCharCode will return UTF8 encoding)
        this.value += (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).castAsNonUtf8Char(s, this.encoding);
        else // correctly converts from UTF-8, but not other encodings
        this.value += String.fromCharCode(s);
        return this;
    };
    StringBuilder.prototype.appendChars = function(str, offset, len) {
        for(var i = offset; offset < offset + len; i++)this.append(str[i]);
        return this;
    };
    StringBuilder.prototype.length = function() {
        return this.value.length;
    };
    StringBuilder.prototype.charAt = function(n) {
        return this.value.charAt(n);
    };
    StringBuilder.prototype.deleteCharAt = function(n) {
        this.value = this.value.substr(0, n) + this.value.substring(n + 1);
    };
    StringBuilder.prototype.setCharAt = function(n, c) {
        this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
    };
    StringBuilder.prototype.substring = function(start, end) {
        return this.value.substring(start, end);
    };
    /**
     * @note helper method for RSS Expanded
     */ StringBuilder.prototype.setLengthToZero = function() {
        this.value = "";
    };
    StringBuilder.prototype.toString = function() {
        return this.value;
    };
    StringBuilder.prototype.insert = function(n, c) {
        this.value = this.value.substring(0, n) + c + this.value.substring(n);
    };
    return StringBuilder;
}();
var $f9764fdce9a0dbd7$export$2e2bcd8739ae039 = $f9764fdce9a0dbd7$var$StringBuilder;



/**
 * <p>Represents a 2D matrix of bits. In function arguments below, and throughout the common
 * module, x is the column position, and y is the row position. The ordering is always x, y.
 * The origin is at the top-left.</p>
 *
 * <p>Internally the bits are represented in a 1-D array of 32-bit ints. However, each row begins
 * with a new int. This is done intentionally so that we can copy out a row into a BitArray very
 * efficiently.</p>
 *
 * <p>The ordering of bits is row-major. Within each int, the least significant bits are used first,
 * meaning they represent lower x values. This is compatible with BitArray's implementation.</p>
 *
 * @author Sean Owen
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ff4f860b0cfaffff$var$BitMatrix /*implements Cloneable*/  = /** @class */ function() {
    /**
     * Creates an empty square {@link BitMatrix}.
     *
     * @param dimension height and width
     */ // public constructor(dimension: number /*int*/) {
    //   this(dimension, dimension)
    // }
    /**
     * Creates an empty {@link BitMatrix}.
     *
     * @param width bit matrix width
     * @param height bit matrix height
     */ // public constructor(width: number /*int*/, height: number /*int*/) {
    //   if (width < 1 || height < 1) {
    //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
    //   }
    //   this.width = width
    //   this.height = height
    //   this.rowSize = (width + 31) / 32
    //   bits = new int[rowSize * height];
    // }
    function BitMatrix(width /*int*/ , height /*int*/ , rowSize /*int*/ , bits) {
        this.width = width;
        this.height = height;
        this.rowSize = rowSize;
        this.bits = bits;
        if (undefined === height || null === height) height = width;
        this.height = height;
        if (width < 1 || height < 1) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Both dimensions must be greater than 0");
        if (undefined === rowSize || null === rowSize) rowSize = Math.floor((width + 31) / 32);
        this.rowSize = rowSize;
        if (undefined === bits || null === bits) this.bits = new Int32Array(this.rowSize * this.height);
    }
    /**
     * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
     *
     * @function parse
     * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
     * @return {@link BitMatrix} representation of image
     */ BitMatrix.parseFromBooleanArray = function(image) {
        var height = image.length;
        var width = image[0].length;
        var bits = new BitMatrix(width, height);
        for(var i = 0; i < height; i++){
            var imageI = image[i];
            for(var j = 0; j < width; j++)if (imageI[j]) bits.set(j, i);
        }
        return bits;
    };
    /**
     *
     * @function parse
     * @param stringRepresentation
     * @param setString
     * @param unsetString
     */ BitMatrix.parseFromString = function(stringRepresentation, setString, unsetString) {
        if (stringRepresentation === null) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("stringRepresentation cannot be null");
        var bits = new Array(stringRepresentation.length);
        var bitsPos = 0;
        var rowStartPos = 0;
        var rowLength = -1;
        var nRows = 0;
        var pos = 0;
        while(pos < stringRepresentation.length){
            if (stringRepresentation.charAt(pos) === "\n" || stringRepresentation.charAt(pos) === "\r") {
                if (bitsPos > rowStartPos) {
                    if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                    else if (bitsPos - rowStartPos !== rowLength) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("row lengths do not match");
                    rowStartPos = bitsPos;
                    nRows++;
                }
                pos++;
            } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
                pos += setString.length;
                bits[bitsPos] = true;
                bitsPos++;
            } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
                pos += unsetString.length;
                bits[bitsPos] = false;
                bitsPos++;
            } else throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("illegal character encountered: " + stringRepresentation.substring(pos));
        }
        // no EOL at end?
        if (bitsPos > rowStartPos) {
            if (rowLength === -1) rowLength = bitsPos - rowStartPos;
            else if (bitsPos - rowStartPos !== rowLength) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("row lengths do not match");
            nRows++;
        }
        var matrix = new BitMatrix(rowLength, nRows);
        for(var i = 0; i < bitsPos; i++)if (bits[i]) matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
        return matrix;
    };
    /**
     * <p>Gets the requested bit, where true means black.</p>
     *
     * @param x The horizontal component (i.e. which column)
     * @param y The vertical component (i.e. which row)
     * @return value of given bit in matrix
     */ BitMatrix.prototype.get = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        return (this.bits[offset] >>> (x & 0x1f) & 1) !== 0;
    };
    /**
     * <p>Sets the given bit to true.</p>
     *
     * @param x The horizontal component (i.e. which column)
     * @param y The vertical component (i.e. which row)
     */ BitMatrix.prototype.set = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        this.bits[offset] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
    };
    BitMatrix.prototype.unset = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        this.bits[offset] &= ~(1 << (x & 0x1f) & 0xFFFFFFFF);
    };
    /**
     * <p>Flips the given bit.</p>
     *
     * @param x The horizontal component (i.e. which column)
     * @param y The vertical component (i.e. which row)
     */ BitMatrix.prototype.flip = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        this.bits[offset] ^= 1 << (x & 0x1f) & 0xFFFFFFFF;
    };
    /**
     * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
     * mask bit is set.
     *
     * @param mask XOR mask
     */ BitMatrix.prototype.xor = function(mask) {
        if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("input matrix dimensions do not match");
        var rowArray = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(Math.floor(this.width / 32) + 1);
        var rowSize = this.rowSize;
        var bits = this.bits;
        for(var y = 0, height = this.height; y < height; y++){
            var offset = y * rowSize;
            var row = mask.getRow(y, rowArray).getBitArray();
            for(var x = 0; x < rowSize; x++)bits[offset + x] ^= row[x];
        }
    };
    /**
     * Clears all bits (sets to false).
     */ BitMatrix.prototype.clear = function() {
        var bits = this.bits;
        var max = bits.length;
        for(var i = 0; i < max; i++)bits[i] = 0;
    };
    /**
     * <p>Sets a square region of the bit matrix to true.</p>
     *
     * @param left The horizontal position to begin at (inclusive)
     * @param top The vertical position to begin at (inclusive)
     * @param width The width of the region
     * @param height The height of the region
     */ BitMatrix.prototype.setRegion = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        if (top < 0 || left < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Left and top must be nonnegative");
        if (height < 1 || width < 1) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Height and width must be at least 1");
        var right = left + width;
        var bottom = top + height;
        if (bottom > this.height || right > this.width) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("The region must fit inside the matrix");
        var rowSize = this.rowSize;
        var bits = this.bits;
        for(var y = top; y < bottom; y++){
            var offset = y * rowSize;
            for(var x = left; x < right; x++)bits[offset + Math.floor(x / 32)] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
    };
    /**
     * A fast method to retrieve one row of data from the matrix as a BitArray.
     *
     * @param y The row to retrieve
     * @param row An optional caller-allocated BitArray, will be allocated if null or too small
     * @return The resulting BitArray - this reference should always be used even when passing
     *         your own row
     */ BitMatrix.prototype.getRow = function(y /*int*/ , row) {
        if (row === null || row === undefined || row.getSize() < this.width) row = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(this.width);
        else row.clear();
        var rowSize = this.rowSize;
        var bits = this.bits;
        var offset = y * rowSize;
        for(var x = 0; x < rowSize; x++)row.setBulk(x * 32, bits[offset + x]);
        return row;
    };
    /**
     * @param y row to set
     * @param row {@link BitArray} to copy from
     */ BitMatrix.prototype.setRow = function(y /*int*/ , row) {
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
    };
    /**
     * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
     */ BitMatrix.prototype.rotate180 = function() {
        var width = this.getWidth();
        var height = this.getHeight();
        var topRow = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(width);
        var bottomRow = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(width);
        for(var i = 0, length_1 = Math.floor((height + 1) / 2); i < length_1; i++){
            topRow = this.getRow(i, topRow);
            bottomRow = this.getRow(height - 1 - i, bottomRow);
            topRow.reverse();
            bottomRow.reverse();
            this.setRow(i, bottomRow);
            this.setRow(height - 1 - i, topRow);
        }
    };
    /**
     * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
     *
     * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
     */ BitMatrix.prototype.getEnclosingRectangle = function() {
        var width = this.width;
        var height = this.height;
        var rowSize = this.rowSize;
        var bits = this.bits;
        var left = width;
        var top = height;
        var right = -1;
        var bottom = -1;
        for(var y = 0; y < height; y++)for(var x32 = 0; x32 < rowSize; x32++){
            var theBits = bits[y * rowSize + x32];
            if (theBits !== 0) {
                if (y < top) top = y;
                if (y > bottom) bottom = y;
                if (x32 * 32 < left) {
                    var bit = 0;
                    while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
                    if (x32 * 32 + bit < left) left = x32 * 32 + bit;
                }
                if (x32 * 32 + 31 > right) {
                    var bit = 31;
                    while(theBits >>> bit === 0)bit--;
                    if (x32 * 32 + bit > right) right = x32 * 32 + bit;
                }
            }
        }
        if (right < left || bottom < top) return null;
        return Int32Array.from([
            left,
            top,
            right - left + 1,
            bottom - top + 1
        ]);
    };
    /**
     * This is useful in detecting a corner of a 'pure' barcode.
     *
     * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
     */ BitMatrix.prototype.getTopLeftOnBit = function() {
        var rowSize = this.rowSize;
        var bits = this.bits;
        var bitsOffset = 0;
        while(bitsOffset < bits.length && bits[bitsOffset] === 0)bitsOffset++;
        if (bitsOffset === bits.length) return null;
        var y = bitsOffset / rowSize;
        var x = bitsOffset % rowSize * 32;
        var theBits = bits[bitsOffset];
        var bit = 0;
        while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
        x += bit;
        return Int32Array.from([
            x,
            y
        ]);
    };
    BitMatrix.prototype.getBottomRightOnBit = function() {
        var rowSize = this.rowSize;
        var bits = this.bits;
        var bitsOffset = bits.length - 1;
        while(bitsOffset >= 0 && bits[bitsOffset] === 0)bitsOffset--;
        if (bitsOffset < 0) return null;
        var y = Math.floor(bitsOffset / rowSize);
        var x = Math.floor(bitsOffset % rowSize) * 32;
        var theBits = bits[bitsOffset];
        var bit = 31;
        while(theBits >>> bit === 0)bit--;
        x += bit;
        return Int32Array.from([
            x,
            y
        ]);
    };
    /**
     * @return The width of the matrix
     */ BitMatrix.prototype.getWidth = function() {
        return this.width;
    };
    /**
     * @return The height of the matrix
     */ BitMatrix.prototype.getHeight = function() {
        return this.height;
    };
    /**
     * @return The row size of the matrix
     */ BitMatrix.prototype.getRowSize = function() {
        return this.rowSize;
    };
    /*@Override*/ BitMatrix.prototype.equals = function(o) {
        if (!(o instanceof BitMatrix)) return false;
        var other = o;
        return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && (0, $eed4834329730fe6$export$2e2bcd8739ae039).equals(this.bits, other.bits);
    };
    /*@Override*/ BitMatrix.prototype.hashCode = function() {
        var hash = this.width;
        hash = 31 * hash + this.width;
        hash = 31 * hash + this.height;
        hash = 31 * hash + this.rowSize;
        hash = 31 * hash + (0, $eed4834329730fe6$export$2e2bcd8739ae039).hashCode(this.bits);
        return hash;
    };
    /**
     * @return string representation using "X" for set and " " for unset bits
     */ /*@Override*/ // public toString(): string {
    //   return toString(": "X, "  ")
    // }
    /**
     * @param setString representation of a set bit
     * @param unsetString representation of an unset bit
     * @return string representation of entire matrix utilizing given strings
     */ // public toString(setString: string = "X ", unsetString: string = "  "): string {
    //   return this.buildToString(setString, unsetString, "\n")
    // }
    /**
     * @param setString representation of a set bit
     * @param unsetString representation of an unset bit
     * @param lineSeparator newline character in string representation
     * @return string representation of entire matrix utilizing given strings and line separator
     * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
     */ // @Deprecated
    BitMatrix.prototype.toString = function(setString, unsetString, lineSeparator) {
        if (setString === void 0) setString = "X ";
        if (unsetString === void 0) unsetString = "  ";
        if (lineSeparator === void 0) lineSeparator = "\n";
        return this.buildToString(setString, unsetString, lineSeparator);
    };
    BitMatrix.prototype.buildToString = function(setString, unsetString, lineSeparator) {
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        // result.append(lineSeparator);
        for(var y = 0, height = this.height; y < height; y++){
            for(var x = 0, width = this.width; x < width; x++)result.append(this.get(x, y) ? setString : unsetString);
            result.append(lineSeparator);
        }
        return result.toString();
    };
    /*@Override*/ BitMatrix.prototype.clone = function() {
        return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
    };
    return BitMatrix;
}();
var $ff4f860b0cfaffff$export$2e2bcd8739ae039 = $ff4f860b0cfaffff$var$BitMatrix;



var $283aa2ad27179317$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $283aa2ad27179317$var$NotFoundException = /** @class */ function(_super) {
    $283aa2ad27179317$var$__extends(NotFoundException, _super);
    function NotFoundException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotFoundException.getNotFoundInstance = function() {
        return new NotFoundException();
    };
    NotFoundException.kind = "NotFoundException";
    return NotFoundException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $283aa2ad27179317$export$2e2bcd8739ae039 = $283aa2ad27179317$var$NotFoundException;


var $07f9f3c2b09c319c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This Binarizer implementation uses the old ZXing global histogram approach. It is suitable
 * for low-end mobile devices which don't have enough CPU or memory to use a local thresholding
 * algorithm. However, because it picks a global black point, it cannot handle difficult shadows
 * and gradients.
 *
 * Faster mobile devices and all desktop applications should probably use HybridBinarizer instead.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 */ var $07f9f3c2b09c319c$var$GlobalHistogramBinarizer = /** @class */ function(_super) {
    $07f9f3c2b09c319c$var$__extends(GlobalHistogramBinarizer, _super);
    function GlobalHistogramBinarizer(source) {
        var _this = _super.call(this, source) || this;
        _this.luminances = GlobalHistogramBinarizer.EMPTY;
        _this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
        return _this;
    }
    // Applies simple sharpening to the row data to improve performance of the 1D Readers.
    /*@Override*/ GlobalHistogramBinarizer.prototype.getBlackRow = function(y /*int*/ , row) {
        var source = this.getLuminanceSource();
        var width = source.getWidth();
        if (row === undefined || row === null || row.getSize() < width) row = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(width);
        else row.clear();
        this.initArrays(width);
        var localLuminances = source.getRow(y, this.luminances);
        var localBuckets = this.buckets;
        for(var x = 0; x < width; x++)localBuckets[(localLuminances[x] & 0xff) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
        var blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
        if (width < 3) {
            // Special case for very small images
            for(var x = 0; x < width; x++)if ((localLuminances[x] & 0xff) < blackPoint) row.set(x);
        } else {
            var left = localLuminances[0] & 0xff;
            var center = localLuminances[1] & 0xff;
            for(var x = 1; x < width - 1; x++){
                var right = localLuminances[x + 1] & 0xff;
                // A simple -1 4 -1 box filter with a weight of 2.
                if ((center * 4 - left - right) / 2 < blackPoint) row.set(x);
                left = center;
                center = right;
            }
        }
        return row;
    };
    // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
    /*@Override*/ GlobalHistogramBinarizer.prototype.getBlackMatrix = function() {
        var source = this.getLuminanceSource();
        var width = source.getWidth();
        var height = source.getHeight();
        var matrix = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(width, height);
        // Quickly calculates the histogram by sampling four rows from the image. This proved to be
        // more robust on the blackbox tests than sampling a diagonal as we used to do.
        this.initArrays(width);
        var localBuckets = this.buckets;
        for(var y = 1; y < 5; y++){
            var row = Math.floor(height * y / 5);
            var localLuminances_1 = source.getRow(row, this.luminances);
            var right = Math.floor(width * 4 / 5);
            for(var x = Math.floor(width / 5); x < right; x++){
                var pixel = localLuminances_1[x] & 0xff;
                localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
            }
        }
        var blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
        // We delay reading the entire image luminance until the black point estimation succeeds.
        // Although we end up reading four rows twice, it is consistent with our motto of
        // "fail quickly" which is necessary for continuous scanning.
        var localLuminances = source.getMatrix();
        for(var y = 0; y < height; y++){
            var offset = y * width;
            for(var x = 0; x < width; x++){
                var pixel = localLuminances[offset + x] & 0xff;
                if (pixel < blackPoint) matrix.set(x, y);
            }
        }
        return matrix;
    };
    /*@Override*/ GlobalHistogramBinarizer.prototype.createBinarizer = function(source) {
        return new GlobalHistogramBinarizer(source);
    };
    GlobalHistogramBinarizer.prototype.initArrays = function(luminanceSize /*int*/ ) {
        if (this.luminances.length < luminanceSize) this.luminances = new Uint8ClampedArray(luminanceSize);
        var buckets = this.buckets;
        for(var x = 0; x < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++)buckets[x] = 0;
    };
    GlobalHistogramBinarizer.estimateBlackPoint = function(buckets) {
        // Find the tallest peak in the histogram.
        var numBuckets = buckets.length;
        var maxBucketCount = 0;
        var firstPeak = 0;
        var firstPeakSize = 0;
        for(var x = 0; x < numBuckets; x++){
            if (buckets[x] > firstPeakSize) {
                firstPeak = x;
                firstPeakSize = buckets[x];
            }
            if (buckets[x] > maxBucketCount) maxBucketCount = buckets[x];
        }
        // Find the second-tallest peak which is somewhat far from the tallest peak.
        var secondPeak = 0;
        var secondPeakScore = 0;
        for(var x = 0; x < numBuckets; x++){
            var distanceToBiggest = x - firstPeak;
            // Encourage more distant second peaks by multiplying by square of distance.
            var score = buckets[x] * distanceToBiggest * distanceToBiggest;
            if (score > secondPeakScore) {
                secondPeak = x;
                secondPeakScore = score;
            }
        }
        // Make sure firstPeak corresponds to the black peak.
        if (firstPeak > secondPeak) {
            var temp = firstPeak;
            firstPeak = secondPeak;
            secondPeak = temp;
        }
        // If there is too little contrast in the image to pick a meaningful black point, throw rather
        // than waste time trying to decode the image, and risk false positives.
        if (secondPeak - firstPeak <= numBuckets / 16) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        // Find a valley between them that is low and closer to the white peak.
        var bestValley = secondPeak - 1;
        var bestValleyScore = -1;
        for(var x = secondPeak - 1; x > firstPeak; x--){
            var fromFirst = x - firstPeak;
            var score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
            if (score > bestValleyScore) {
                bestValley = x;
                bestValleyScore = score;
            }
        }
        return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
    };
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([
        0
    ]);
    return GlobalHistogramBinarizer;
}((0, $03611c9bb2a5a87c$export$2e2bcd8739ae039));
var $07f9f3c2b09c319c$export$2e2bcd8739ae039 = $07f9f3c2b09c319c$var$GlobalHistogramBinarizer;



var $7286045d1fa79212$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class implements a local thresholding algorithm, which while slower than the
 * GlobalHistogramBinarizer, is fairly efficient for what it does. It is designed for
 * high frequency images of barcodes with black data on white backgrounds. For this application,
 * it does a much better job than a global blackpoint with severe shadows and gradients.
 * However it tends to produce artifacts on lower frequency images and is therefore not
 * a good general purpose binarizer for uses outside ZXing.
 *
 * This class extends GlobalHistogramBinarizer, using the older histogram approach for 1D readers,
 * and the newer local approach for 2D readers. 1D decoding using a per-row histogram is already
 * inherently local, and only fails for horizontal gradients. We can revisit that problem later,
 * but for now it was not a win to use local blocks for 1D.
 *
 * This Binarizer is the default for the unit tests and the recommended class for library users.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $7286045d1fa79212$var$HybridBinarizer = /** @class */ function(_super) {
    $7286045d1fa79212$var$__extends(HybridBinarizer, _super);
    function HybridBinarizer(source) {
        var _this = _super.call(this, source) || this;
        _this.matrix = null;
        return _this;
    }
    /**
     * Calculates the final BitMatrix once for all requests. This could be called once from the
     * constructor instead, but there are some advantages to doing it lazily, such as making
     * profiling easier, and not doing heavy lifting when callers don't expect it.
     */ /*@Override*/ HybridBinarizer.prototype.getBlackMatrix = function() {
        if (this.matrix !== null) return this.matrix;
        var source = this.getLuminanceSource();
        var width = source.getWidth();
        var height = source.getHeight();
        if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
            var luminances = source.getMatrix();
            var subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
            if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subWidth++;
            var subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
            if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subHeight++;
            var blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
            var newMatrix = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(width, height);
            HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
            this.matrix = newMatrix;
        } else // If the image is too small, fall back to the global histogram approach.
        this.matrix = _super.prototype.getBlackMatrix.call(this);
        return this.matrix;
    };
    /*@Override*/ HybridBinarizer.prototype.createBinarizer = function(source) {
        return new HybridBinarizer(source);
    };
    /**
     * For each block in the image, calculate the average black point using a 5x5 grid
     * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
     * on the last pixels in the row/column which are also used in the previous block).
     */ HybridBinarizer.calculateThresholdForBlock = function(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ , blackPoints, matrix) {
        var maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
        var maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
        for(var y = 0; y < subHeight; y++){
            var yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
            if (yoffset > maxYOffset) yoffset = maxYOffset;
            var top_1 = HybridBinarizer.cap(y, 2, subHeight - 3);
            for(var x = 0; x < subWidth; x++){
                var xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                if (xoffset > maxXOffset) xoffset = maxXOffset;
                var left = HybridBinarizer.cap(x, 2, subWidth - 3);
                var sum = 0;
                for(var z = -2; z <= 2; z++){
                    var blackRow = blackPoints[top_1 + z];
                    sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
                }
                var average = sum / 25;
                HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
            }
        }
    };
    HybridBinarizer.cap = function(value /*int*/ , min /*int*/ , max /*int*/ ) {
        return value < min ? min : value > max ? max : value;
    };
    /**
     * Applies a single threshold to a block of pixels.
     */ HybridBinarizer.thresholdBlock = function(luminances, xoffset /*int*/ , yoffset /*int*/ , threshold /*int*/ , stride /*int*/ , matrix) {
        for(var y = 0, offset = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset += stride){
            for(var x = 0; x < HybridBinarizer.BLOCK_SIZE; x++)// Comparison needs to be <= so that black == 0 pixels are black even if the threshold is 0.
            if ((luminances[offset + x] & 0xFF) <= threshold) matrix.set(xoffset + x, yoffset + y);
        }
    };
    /**
     * Calculates a single black point for each block of pixels and saves it away.
     * See the following thread for a discussion of this algorithm:
     *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
     */ HybridBinarizer.calculateBlackPoints = function(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ ) {
        var maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
        var maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
        // tslint:disable-next-line:whitespace
        var blackPoints = new Array(subHeight); // subWidth
        for(var y = 0; y < subHeight; y++){
            blackPoints[y] = new Int32Array(subWidth);
            var yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
            if (yoffset > maxYOffset) yoffset = maxYOffset;
            for(var x = 0; x < subWidth; x++){
                var xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                if (xoffset > maxXOffset) xoffset = maxXOffset;
                var sum = 0;
                var min = 0xFF;
                var max = 0;
                for(var yy = 0, offset = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width){
                    for(var xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++){
                        var pixel = luminances[offset + xx] & 0xFF;
                        sum += pixel;
                        // still looking for good contrast
                        if (pixel < min) min = pixel;
                        if (pixel > max) max = pixel;
                    }
                    // short-circuit min/max tests once dynamic range is met
                    if (max - min > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                        // finish the rest of the rows quickly
                        for(yy++, offset += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width)for(var xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++)sum += luminances[offset + xx] & 0xFF;
                    }
                }
                // The default estimate is the average of the values in the block.
                var average = sum >> HybridBinarizer.BLOCK_SIZE_POWER * 2;
                if (max - min <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
                    // If variation within the block is low, assume this is a block with only light or only
                    // dark pixels. In that case we do not want to use the average, as it would divide this
                    // low contrast area into black and white pixels, essentially creating data out of noise.
                    //
                    // The default assumption is that the block is light/background. Since no estimate for
                    // the level of dark pixels exists locally, use half the min for the block.
                    average = min / 2;
                    if (y > 0 && x > 0) {
                        // Correct the "white background" assumption for blocks that have neighbors by comparing
                        // the pixels in this block to the previously calculated black points. This is based on
                        // the fact that dark barcode symbology is always surrounded by some amount of light
                        // background for which reasonable black point estimates were made. The bp estimated at
                        // the boundaries is used for the interior.
                        // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                        var averageNeighborBlackPoint = (blackPoints[y - 1][x] + 2 * blackPoints[y][x - 1] + blackPoints[y - 1][x - 1]) / 4;
                        if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                    }
                }
                blackPoints[y][x] = average;
            }
        }
        return blackPoints;
    };
    // This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
    // So this is the smallest dimension in each axis we can accept.
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER; // ...0100...00
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1; // ...0011...11
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;
    return HybridBinarizer;
}((0, $07f9f3c2b09c319c$export$2e2bcd8739ae039));
var $7286045d1fa79212$export$2e2bcd8739ae039 = $7286045d1fa79212$var$HybridBinarizer;




/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*namespace com.google.zxing {*/ /**
 * The purpose of this class hierarchy is to abstract different bitmap implementations across
 * platforms into a standard interface for requesting greyscale luminance values. The interface
 * only provides immutable methods; therefore crop and rotation create copies. This is to ensure
 * that one Reader does not modify the original luminance source and leave it in an unknown state
 * for other Readers in the chain.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ac3b31e65220c3d3$var$LuminanceSource = /** @class */ function() {
    function LuminanceSource(width /*int*/ , height /*int*/ ) {
        this.width = width;
        this.height = height;
    }
    /**
     * @return The width of the bitmap.
     */ LuminanceSource.prototype.getWidth = function() {
        return this.width;
    };
    /**
     * @return The height of the bitmap.
     */ LuminanceSource.prototype.getHeight = function() {
        return this.height;
    };
    /**
     * @return Whether this subclass supports cropping.
     */ LuminanceSource.prototype.isCropSupported = function() {
        return false;
    };
    /**
     * Returns a new object with cropped image data. Implementations may keep a reference to the
     * original data rather than a copy. Only callable if isCropSupported() is true.
     *
     * @param left The left coordinate, which must be in [0,getWidth())
     * @param top The top coordinate, which must be in [0,getHeight())
     * @param width The width of the rectangle to crop.
     * @param height The height of the rectangle to crop.
     * @return A cropped version of this object.
     */ LuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        throw new (0, $9900d18ea51157af$export$2e2bcd8739ae039)("This luminance source does not support cropping.");
    };
    /**
     * @return Whether this subclass supports counter-clockwise rotation.
     */ LuminanceSource.prototype.isRotateSupported = function() {
        return false;
    };
    /**
     * Returns a new object with rotated image data by 90 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ LuminanceSource.prototype.rotateCounterClockwise = function() {
        throw new (0, $9900d18ea51157af$export$2e2bcd8739ae039)("This luminance source does not support rotation by 90 degrees.");
    };
    /**
     * Returns a new object with rotated image data by 45 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ LuminanceSource.prototype.rotateCounterClockwise45 = function() {
        throw new (0, $9900d18ea51157af$export$2e2bcd8739ae039)("This luminance source does not support rotation by 45 degrees.");
    };
    /*@Override*/ LuminanceSource.prototype.toString = function() {
        var row = new Uint8ClampedArray(this.width);
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        for(var y = 0; y < this.height; y++){
            var sourceRow = this.getRow(y, row);
            for(var x = 0; x < this.width; x++){
                var luminance = sourceRow[x] & 0xFF;
                var c = void 0;
                if (luminance < 0x40) c = "#";
                else if (luminance < 0x80) c = "+";
                else if (luminance < 0xC0) c = ".";
                else c = " ";
                result.append(c);
            }
            result.append("\n");
        }
        return result.toString();
    };
    return LuminanceSource;
}();
var $ac3b31e65220c3d3$export$2e2bcd8739ae039 = $ac3b31e65220c3d3$var$LuminanceSource;


var $a29a81894b6c54d7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/*namespace com.google.zxing {*/ /**
 * A wrapper implementation of {@link LuminanceSource} which inverts the luminances it returns -- black becomes
 * white and vice versa, and each value becomes (255-value).
 *
 * @author Sean Owen
 */ var $a29a81894b6c54d7$var$InvertedLuminanceSource = /** @class */ function(_super) {
    $a29a81894b6c54d7$var$__extends(InvertedLuminanceSource, _super);
    function InvertedLuminanceSource(delegate) {
        var _this = _super.call(this, delegate.getWidth(), delegate.getHeight()) || this;
        _this.delegate = delegate;
        return _this;
    }
    /*@Override*/ InvertedLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        var sourceRow = this.delegate.getRow(y, row);
        var width = this.getWidth();
        for(var i = 0; i < width; i++)sourceRow[i] = /*(byte)*/ 255 - (sourceRow[i] & 0xFF);
        return sourceRow;
    };
    /*@Override*/ InvertedLuminanceSource.prototype.getMatrix = function() {
        var matrix = this.delegate.getMatrix();
        var length = this.getWidth() * this.getHeight();
        var invertedMatrix = new Uint8ClampedArray(length);
        for(var i = 0; i < length; i++)invertedMatrix[i] = /*(byte)*/ 255 - (matrix[i] & 0xFF);
        return invertedMatrix;
    };
    /*@Override*/ InvertedLuminanceSource.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    };
    /*@Override*/ InvertedLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
    };
    /*@Override*/ InvertedLuminanceSource.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    };
    /**
     * @return original delegate {@link LuminanceSource} since invert undoes itself
     */ /*@Override*/ InvertedLuminanceSource.prototype.invert = function() {
        return this.delegate;
    };
    /*@Override*/ InvertedLuminanceSource.prototype.rotateCounterClockwise = function() {
        return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
    };
    /*@Override*/ InvertedLuminanceSource.prototype.rotateCounterClockwise45 = function() {
        return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
    };
    return InvertedLuminanceSource;
}((0, $ac3b31e65220c3d3$export$2e2bcd8739ae039));
var $a29a81894b6c54d7$export$2e2bcd8739ae039 = $a29a81894b6c54d7$var$InvertedLuminanceSource;




var $636e2e55f6ebe220$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 */ var $636e2e55f6ebe220$export$4ae6c62b2342fa1a = /** @class */ function(_super) {
    $636e2e55f6ebe220$var$__extends(HTMLCanvasElementLuminanceSource, _super);
    function HTMLCanvasElementLuminanceSource(canvas) {
        var _this = _super.call(this, canvas.width, canvas.height) || this;
        _this.canvas = canvas;
        _this.tempCanvasElement = null;
        _this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
        return _this;
    }
    HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData = function(canvas) {
        var imageData = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
        return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
    };
    HTMLCanvasElementLuminanceSource.toGrayscaleBuffer = function(imageBuffer, width, height) {
        var grayscaleBuffer = new Uint8ClampedArray(width * height);
        HTMLCanvasElementLuminanceSource.FRAME_INDEX = !HTMLCanvasElementLuminanceSource.FRAME_INDEX;
        if (HTMLCanvasElementLuminanceSource.FRAME_INDEX) for(var i = 0, j = 0, length_1 = imageBuffer.length; i < length_1; i += 4, j++){
            var gray = void 0;
            var alpha = imageBuffer[i + 3];
            // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
            // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
            // barcode image. Force any such pixel to be white:
            if (alpha === 0) gray = 0xFF;
            else {
                var pixelR = imageBuffer[i];
                var pixelG = imageBuffer[i + 1];
                var pixelB = imageBuffer[i + 2];
                // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                // 0x200 >> 10 is 0.5, it implements rounding.
                gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
            }
            grayscaleBuffer[j] = gray;
        }
        else for(var i = 0, j = 0, length_2 = imageBuffer.length; i < length_2; i += 4, j++){
            var gray = void 0;
            var alpha = imageBuffer[i + 3];
            // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
            // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
            // barcode image. Force any such pixel to be white:
            if (alpha === 0) gray = 0xFF;
            else {
                var pixelR = imageBuffer[i];
                var pixelG = imageBuffer[i + 1];
                var pixelB = imageBuffer[i + 2];
                // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                // 0x200 >> 10 is 0.5, it implements rounding.
                gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
            }
            grayscaleBuffer[j] = 0xFF - gray;
        }
        return grayscaleBuffer;
    };
    HTMLCanvasElementLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        if (y < 0 || y >= this.getHeight()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Requested row is outside the image: " + y);
        var width = this.getWidth();
        var start = y * width;
        if (row === null) row = this.buffer.slice(start, start + width);
        else {
            if (row.length < width) row = new Uint8ClampedArray(width);
            // The underlying raster of image consists of bytes with the luminance values
            // TODO: can avoid set/slice?
            row.set(this.buffer.slice(start, start + width));
        }
        return row;
    };
    HTMLCanvasElementLuminanceSource.prototype.getMatrix = function() {
        return this.buffer;
    };
    HTMLCanvasElementLuminanceSource.prototype.isCropSupported = function() {
        return true;
    };
    HTMLCanvasElementLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        _super.prototype.crop.call(this, left, top, width, height);
        return this;
    };
    /**
     * This is always true, since the image is a gray-scale image.
     *
     * @return true
     */ HTMLCanvasElementLuminanceSource.prototype.isRotateSupported = function() {
        return true;
    };
    HTMLCanvasElementLuminanceSource.prototype.rotateCounterClockwise = function() {
        this.rotate(-90);
        return this;
    };
    HTMLCanvasElementLuminanceSource.prototype.rotateCounterClockwise45 = function() {
        this.rotate(-45);
        return this;
    };
    HTMLCanvasElementLuminanceSource.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var tempCanvasElement = this.canvas.ownerDocument.createElement("canvas");
            tempCanvasElement.width = this.canvas.width;
            tempCanvasElement.height = this.canvas.height;
            this.tempCanvasElement = tempCanvasElement;
        }
        return this.tempCanvasElement;
    };
    HTMLCanvasElementLuminanceSource.prototype.rotate = function(angle) {
        var tempCanvasElement = this.getTempCanvasElement();
        var tempContext = tempCanvasElement.getContext("2d");
        var angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
        // Calculate and set new dimensions for temp canvas
        var width = this.canvas.width;
        var height = this.canvas.height;
        var newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
        var newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
        tempCanvasElement.width = newWidth;
        tempCanvasElement.height = newHeight;
        // Draw at center of temp canvas to prevent clipping of image data
        tempContext.translate(newWidth / 2, newHeight / 2);
        tempContext.rotate(angleRadians);
        tempContext.drawImage(this.canvas, width / -2, height / -2);
        this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
        return this;
    };
    HTMLCanvasElementLuminanceSource.prototype.invert = function() {
        return new (0, $a29a81894b6c54d7$export$2e2bcd8739ae039)(this);
    };
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;
    HTMLCanvasElementLuminanceSource.FRAME_INDEX = true;
    return HTMLCanvasElementLuminanceSource;
}((0, $ac3b31e65220c3d3$export$2e2bcd8739ae039));


/**
 * @deprecated Moving to @zxing/browser
 *
 * Video input device metadata containing the id and label of the device if available.
 */ var $46c28a267ccfc3c9$export$78e94e704b2dbda0 = /** @class */ function() {
    /**
     * Creates an instance of VideoInputDevice.
     *
     * @param {string} deviceId the video input device id
     * @param {string} label the label of the device if available
     */ function VideoInputDevice(deviceId, label, groupId) {
        this.deviceId = deviceId;
        this.label = label;
        /** @inheritdoc */ this.kind = "videoinput";
        this.groupId = groupId || undefined;
    }
    /** @inheritdoc */ VideoInputDevice.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    };
    return VideoInputDevice;
}();


var $d9cadefb0b7bb79e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d9cadefb0b7bb79e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d9cadefb0b7bb79e$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @deprecated Moving to @zxing/browser
 *
 * Base class for browser code reader.
 */ var $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607 = /** @class */ function() {
    /**
     * Creates an instance of BrowserCodeReader.
     * @param {Reader} reader The reader instance to decode the barcode
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
     *
     * @memberOf BrowserCodeReader
     */ function BrowserCodeReader(reader, timeBetweenScansMillis, _hints) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        this.reader = reader;
        this.timeBetweenScansMillis = timeBetweenScansMillis;
        this._hints = _hints;
        /**
         * This will break the loop.
         */ this._stopContinuousDecode = false;
        /**
         * This will break the loop.
         */ this._stopAsyncDecode = false;
        /**
         * Delay time between decode attempts made by the scanner.
         */ this._timeBetweenDecodingAttempts = 0;
    }
    Object.defineProperty(BrowserCodeReader.prototype, "hasNavigator", {
        /**
         * If navigator is present.
         */ get: function() {
            return typeof navigator !== "undefined";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "isMediaDevicesSuported", {
        /**
         * If mediaDevices under navigator is supported.
         */ get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "canEnumerateDevices", {
        /**
         * If enumerateDevices under navigator is supported.
         */ get: function() {
            return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "timeBetweenDecodingAttempts", {
        /** Time between two decoding tries in milli seconds. */ get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        /**
         * Change the time span the decoder waits between two decoding tries.
         *
         * @param {number} millis Time between two decoding tries in milli seconds.
         */ set: function(millis) {
            this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "hints", {
        /**
         * Sets the hints.
         */ get: function() {
            return this._hints;
        },
        /**
         * Sets the hints.
         */ set: function(hints) {
            this._hints = hints || null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Lists all the available video input devices.
     */ BrowserCodeReader.prototype.listVideoInputDevices = function() {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var devices, videoDevices, devices_1, devices_1_1, device, kind, deviceId, label, groupId, videoDevice;
            var e_1, _a;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        devices = _b.sent();
                        videoDevices = [];
                        try {
                            for(devices_1 = $d9cadefb0b7bb79e$var$__values(devices), devices_1_1 = devices_1.next(); !devices_1_1.done; devices_1_1 = devices_1.next()){
                                device = devices_1_1.value;
                                kind = device.kind === "video" ? "videoinput" : device.kind;
                                if (kind !== "videoinput") continue;
                                deviceId = device.deviceId || device.id;
                                label = device.label || "Video device " + (videoDevices.length + 1);
                                groupId = device.groupId;
                                videoDevice = {
                                    deviceId: deviceId,
                                    label: label,
                                    kind: kind,
                                    groupId: groupId
                                };
                                videoDevices.push(videoDevice);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (devices_1_1 && !devices_1_1.done && (_a = devices_1.return)) _a.call(devices_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        return [
                            2 /*return*/ ,
                            videoDevices
                        ];
                }
            });
        });
    };
    /**
     * Obtain the list of available devices with type 'videoinput'.
     *
     * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
     *
     * @memberOf BrowserCodeReader
     *
     * @deprecated Use `listVideoInputDevices` instead.
     */ BrowserCodeReader.prototype.getVideoInputDevices = function() {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        return [
                            2 /*return*/ ,
                            devices.map(function(d) {
                                return new (0, $46c28a267ccfc3c9$export$78e94e704b2dbda0)(d.deviceId, d.label);
                            })
                        ];
                }
            });
        });
    };
    /**
     * Let's you find a device using it's Id.
     */ BrowserCodeReader.prototype.findDeviceById = function(deviceId) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        if (!devices) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ ,
                            devices.find(function(x) {
                                return x.deviceId === deviceId;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
     *
     * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns The decoding result.
     *
     * @memberOf BrowserCodeReader
     *
     * @deprecated Use `decodeOnceFromVideoDevice` instead.
     */ BrowserCodeReader.prototype.decodeFromInputVideoDevice = function(deviceId, videoSource) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.decodeOnceFromVideoDevice(deviceId, videoSource)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
     *
     * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeOnceFromVideoDevice = function(deviceId, videoSource) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var videoConstraints, constraints;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.reset();
                        if (!deviceId) videoConstraints = {
                            facingMode: "environment"
                        };
                        else videoConstraints = {
                            deviceId: {
                                exact: deviceId
                            }
                        };
                        constraints = {
                            video: videoConstraints
                        };
                        return [
                            4 /*yield*/ ,
                            this.decodeOnceFromConstraints(constraints, videoSource)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param constraints the media stream constraints to get s valid media stream to decode from
     * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeOnceFromConstraints = function(constraints, videoSource) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        stream = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeOnceFromStream(stream, videoSource)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
     * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeOnceFromStream = function(stream, videoSource) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var video, result;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.reset();
                        return [
                            4 /*yield*/ ,
                            this.attachStreamToVideo(stream, videoSource)
                        ];
                    case 1:
                        video = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeOnce(video)
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
     *
     * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<void>}
     *
     * @memberOf BrowserCodeReader
     *
     * @deprecated Use `decodeFromVideoDevice` instead.
     */ BrowserCodeReader.prototype.decodeFromInputVideoDeviceContinuously = function(deviceId, videoSource, callbackFn) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.decodeFromVideoDevice(deviceId, videoSource, callbackFn)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
     *
     * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<void>}
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromVideoDevice = function(deviceId, videoSource, callbackFn) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var videoConstraints, constraints;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!deviceId) videoConstraints = {
                            facingMode: "environment"
                        };
                        else videoConstraints = {
                            deviceId: {
                                exact: deviceId
                            }
                        };
                        constraints = {
                            video: videoConstraints
                        };
                        return [
                            4 /*yield*/ ,
                            this.decodeFromConstraints(constraints, videoSource, callbackFn)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
     * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromConstraints = function(constraints, videoSource, callbackFn) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        stream = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeFromStream(stream, videoSource, callbackFn)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
     * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromStream = function(stream, videoSource, callbackFn) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var video;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.reset();
                        return [
                            4 /*yield*/ ,
                            this.attachStreamToVideo(stream, videoSource)
                        ];
                    case 1:
                        video = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeContinuously(video, callbackFn)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Breaks the decoding loop.
     */ BrowserCodeReader.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = true;
    };
    /**
     * Breaks the decoding loop.
     */ BrowserCodeReader.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = true;
    };
    /**
     * Sets the new stream and request a new decoding-with-delay.
     *
     * @param stream The stream to be shown in the video element.
     * @param decodeFn A callback for the decode method.
     */ BrowserCodeReader.prototype.attachStreamToVideo = function(stream, videoSource) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var videoElement;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        videoElement = this.prepareVideoElement(videoSource);
                        this.addVideoSource(videoElement, stream);
                        this.videoElement = videoElement;
                        this.stream = stream;
                        return [
                            4 /*yield*/ ,
                            this.playVideoOnLoadAsync(videoElement)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            videoElement
                        ];
                }
            });
        });
    };
    /**
     *
     * @param videoElement
     */ BrowserCodeReader.prototype.playVideoOnLoadAsync = function(videoElement) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            return _this.playVideoOnLoad(videoElement, function() {
                return resolve();
            });
        });
    };
    /**
     * Binds listeners and callbacks to the videoElement.
     *
     * @param element
     * @param callbackFn
     */ BrowserCodeReader.prototype.playVideoOnLoad = function(element, callbackFn) {
        var _this = this;
        this.videoEndedListener = function() {
            return _this.stopStreams();
        };
        this.videoCanPlayListener = function() {
            return _this.tryPlayVideo(element);
        };
        element.addEventListener("ended", this.videoEndedListener);
        element.addEventListener("canplay", this.videoCanPlayListener);
        element.addEventListener("playing", callbackFn);
        // if canplay was already fired, we won't know when to play, so just give it a try
        this.tryPlayVideo(element);
    };
    /**
     * Checks if the given video element is currently playing.
     */ BrowserCodeReader.prototype.isVideoPlaying = function(video) {
        return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
    };
    /**
     * Just tries to play the video and logs any errors.
     * The play call is only made is the video is not already playing.
     */ BrowserCodeReader.prototype.tryPlayVideo = function(videoElement) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $d9cadefb0b7bb79e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.isVideoPlaying(videoElement)) {
                            console.warn("Trying to play video that is already playing.");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            videoElement.play()
                        ];
                    case 2:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a = _b.sent();
                        console.warn("It was not possible to play the video.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Searches and validates a media element.
     */ BrowserCodeReader.prototype.getMediaElement = function(mediaElementId, type) {
        var mediaElement = document.getElementById(mediaElementId);
        if (!mediaElement) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("element with id '" + mediaElementId + "' not found");
        if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("element with id '" + mediaElementId + "' must be an " + type + " element");
        return mediaElement;
    };
    /**
     * Decodes the barcode from an image.
     *
     * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
     * @param {string} [url]
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromImage = function(source, url) {
        if (!source && !url) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("either imageElement with a src set or an url must be provided");
        if (url && !source) return this.decodeFromImageUrl(url);
        return this.decodeFromImageElement(source);
    };
    /**
     * Decodes the barcode from a video.
     *
     * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
     * @param {string} [url]
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromVideo = function(source, url) {
        if (!source && !url) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("Either an element with a src set or an URL must be provided");
        if (url && !source) return this.decodeFromVideoUrl(url);
        return this.decodeFromVideoElement(source);
    };
    /**
     * Decodes continuously the barcode from a video.
     *
     * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
     * @param {string} [url]
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     *
     * @experimental
     */ BrowserCodeReader.prototype.decodeFromVideoContinuously = function(source, url, callbackFn) {
        if (undefined === source && undefined === url) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("Either an element with a src set or an URL must be provided");
        if (url && !source) return this.decodeFromVideoUrlContinuously(url, callbackFn);
        return this.decodeFromVideoElementContinuously(source, callbackFn);
    };
    /**
     * Decodes something from an image HTML element.
     */ BrowserCodeReader.prototype.decodeFromImageElement = function(source) {
        if (!source) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("An image element must be provided.");
        this.reset();
        var element = this.prepareImageElement(source);
        this.imageElement = element;
        var task;
        if (this.isImageLoaded(element)) task = this.decodeOnce(element, false, true);
        else task = this._decodeOnLoadImage(element);
        return task;
    };
    /**
     * Decodes something from an image HTML element.
     */ BrowserCodeReader.prototype.decodeFromVideoElement = function(source) {
        var element = this._decodeFromVideoElementSetup(source);
        return this._decodeOnLoadVideo(element);
    };
    /**
     * Decodes something from an image HTML element.
     */ BrowserCodeReader.prototype.decodeFromVideoElementContinuously = function(source, callbackFn) {
        var element = this._decodeFromVideoElementSetup(source);
        return this._decodeOnLoadVideoContinuously(element, callbackFn);
    };
    /**
     * Sets up the video source so it can be decoded when loaded.
     *
     * @param source The video source element.
     */ BrowserCodeReader.prototype._decodeFromVideoElementSetup = function(source) {
        if (!source) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("A video element must be provided.");
        this.reset();
        var element = this.prepareVideoElement(source);
        // defines the video element before starts decoding
        this.videoElement = element;
        return element;
    };
    /**
     * Decodes an image from a URL.
     */ BrowserCodeReader.prototype.decodeFromImageUrl = function(url) {
        if (!url) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("An URL must be provided.");
        this.reset();
        var element = this.prepareImageElement();
        this.imageElement = element;
        var decodeTask = this._decodeOnLoadImage(element);
        element.src = url;
        return decodeTask;
    };
    /**
     * Decodes an image from a URL.
     */ BrowserCodeReader.prototype.decodeFromVideoUrl = function(url) {
        if (!url) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("An URL must be provided.");
        this.reset();
        // creates a new element
        var element = this.prepareVideoElement();
        var decodeTask = this.decodeFromVideoElement(element);
        element.src = url;
        return decodeTask;
    };
    /**
     * Decodes an image from a URL.
     *
     * @experimental
     */ BrowserCodeReader.prototype.decodeFromVideoUrlContinuously = function(url, callbackFn) {
        if (!url) throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)("An URL must be provided.");
        this.reset();
        // creates a new element
        var element = this.prepareVideoElement();
        var decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
        element.src = url;
        return decodeTask;
    };
    BrowserCodeReader.prototype._decodeOnLoadImage = function(element) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.imageLoadedListener = function() {
                return _this.decodeOnce(element, false, true).then(resolve, reject);
            };
            element.addEventListener("load", _this.imageLoadedListener);
        });
    };
    BrowserCodeReader.prototype._decodeOnLoadVideo = function(videoElement) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // plays the video
                        return [
                            4 /*yield*/ ,
                            this.playVideoOnLoadAsync(videoElement)
                        ];
                    case 1:
                        // plays the video
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeOnce(videoElement)
                        ];
                    case 2:
                        // starts decoding after played the video
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    BrowserCodeReader.prototype._decodeOnLoadVideoContinuously = function(videoElement, callbackFn) {
        return $d9cadefb0b7bb79e$var$__awaiter(this, void 0, void 0, function() {
            return $d9cadefb0b7bb79e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // plays the video
                        return [
                            4 /*yield*/ ,
                            this.playVideoOnLoadAsync(videoElement)
                        ];
                    case 1:
                        // plays the video
                        _a.sent();
                        // starts decoding after played the video
                        this.decodeContinuously(videoElement, callbackFn);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserCodeReader.prototype.isImageLoaded = function(img) {
        // During the onload event, IE correctly identifies any images that
        // weren’t downloaded as not complete. Others should too. Gecko-based
        // browsers act like NS4 in that they report this incorrectly.
        if (!img.complete) return false;
        // However, they do have two very useful properties: naturalWidth and
        // naturalHeight. These give the true size of the image. If it failed
        // to load, either of these should be zero.
        if (img.naturalWidth === 0) return false;
        // No other way of checking: assume it’s ok.
        return true;
    };
    BrowserCodeReader.prototype.prepareImageElement = function(imageSource) {
        var imageElement;
        if (typeof imageSource === "undefined") {
            imageElement = document.createElement("img");
            imageElement.width = 200;
            imageElement.height = 200;
        }
        if (typeof imageSource === "string") imageElement = this.getMediaElement(imageSource, "img");
        if (imageSource instanceof HTMLImageElement) imageElement = imageSource;
        return imageElement;
    };
    /**
     * Sets a HTMLVideoElement for scanning or creates a new one.
     *
     * @param videoSource The HTMLVideoElement to be set.
     */ BrowserCodeReader.prototype.prepareVideoElement = function(videoSource) {
        var videoElement;
        if (!videoSource && typeof document !== "undefined") {
            videoElement = document.createElement("video");
            videoElement.width = 200;
            videoElement.height = 200;
        }
        if (typeof videoSource === "string") videoElement = this.getMediaElement(videoSource, "video");
        if (videoSource instanceof HTMLVideoElement) videoElement = videoSource;
        // Needed for iOS 11
        videoElement.setAttribute("autoplay", "true");
        videoElement.setAttribute("muted", "true");
        videoElement.setAttribute("playsinline", "true");
        return videoElement;
    };
    /**
     * Tries to decode from the video input until it finds some value.
     */ BrowserCodeReader.prototype.decodeOnce = function(element, retryIfNotFound, retryIfChecksumOrFormatError) {
        var _this = this;
        if (retryIfNotFound === void 0) retryIfNotFound = true;
        if (retryIfChecksumOrFormatError === void 0) retryIfChecksumOrFormatError = true;
        this._stopAsyncDecode = false;
        var loop = function(resolve, reject) {
            if (_this._stopAsyncDecode) {
                reject(new (0, $283aa2ad27179317$export$2e2bcd8739ae039)("Video stream has ended before any code could be detected."));
                _this._stopAsyncDecode = undefined;
                return;
            }
            try {
                var result = _this.decode(element);
                resolve(result);
            } catch (e) {
                var ifNotFound = retryIfNotFound && e instanceof (0, $283aa2ad27179317$export$2e2bcd8739ae039);
                var isChecksumOrFormatError = e instanceof (0, $e19cfb3b440de53d$export$2e2bcd8739ae039) || e instanceof (0, $13fe167df36b6e3a$export$2e2bcd8739ae039);
                var ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
                if (ifNotFound || ifChecksumOrFormat) // trying again
                return setTimeout(loop, _this._timeBetweenDecodingAttempts, resolve, reject);
                reject(e);
            }
        };
        return new Promise(function(resolve, reject) {
            return loop(resolve, reject);
        });
    };
    /**
     * Continuously decodes from video input.
     */ BrowserCodeReader.prototype.decodeContinuously = function(element, callbackFn) {
        var _this = this;
        this._stopContinuousDecode = false;
        var loop = function() {
            if (_this._stopContinuousDecode) {
                _this._stopContinuousDecode = undefined;
                return;
            }
            try {
                var result = _this.decode(element);
                callbackFn(result, null);
                setTimeout(loop, _this.timeBetweenScansMillis);
            } catch (e) {
                callbackFn(null, e);
                var isChecksumOrFormatError = e instanceof (0, $e19cfb3b440de53d$export$2e2bcd8739ae039) || e instanceof (0, $13fe167df36b6e3a$export$2e2bcd8739ae039);
                var isNotFound = e instanceof (0, $283aa2ad27179317$export$2e2bcd8739ae039);
                if (isChecksumOrFormatError || isNotFound) // trying again
                setTimeout(loop, _this._timeBetweenDecodingAttempts);
            }
        };
        loop();
    };
    /**
     * Gets the BinaryBitmap for ya! (and decodes it)
     */ BrowserCodeReader.prototype.decode = function(element) {
        // get binary bitmap for decode function
        var binaryBitmap = this.createBinaryBitmap(element);
        return this.decodeBitmap(binaryBitmap);
    };
    /**
     * Creates a binaryBitmap based in some image source.
     *
     * @param mediaElement HTML element containing drawable image source.
     */ BrowserCodeReader.prototype.createBinaryBitmap = function(mediaElement) {
        var ctx = this.getCaptureCanvasContext(mediaElement);
        if (mediaElement instanceof HTMLVideoElement) this.drawFrameOnCanvas(mediaElement);
        else this.drawImageOnCanvas(mediaElement);
        var canvas = this.getCaptureCanvas(mediaElement);
        var luminanceSource = new (0, $636e2e55f6ebe220$export$4ae6c62b2342fa1a)(canvas);
        var hybridBinarizer = new (0, $7286045d1fa79212$export$2e2bcd8739ae039)(luminanceSource);
        return new (0, $ea8d2e97db9675c3$export$2e2bcd8739ae039)(hybridBinarizer);
    };
    /**
     *
     */ BrowserCodeReader.prototype.getCaptureCanvasContext = function(mediaElement) {
        if (!this.captureCanvasContext) {
            var elem = this.getCaptureCanvas(mediaElement);
            var ctx = void 0;
            try {
                ctx = elem.getContext("2d", {
                    willReadFrequently: true
                });
            } catch (e) {
                ctx = elem.getContext("2d");
            }
            this.captureCanvasContext = ctx;
        }
        return this.captureCanvasContext;
    };
    /**
     *
     */ BrowserCodeReader.prototype.getCaptureCanvas = function(mediaElement) {
        if (!this.captureCanvas) {
            var elem = this.createCaptureCanvas(mediaElement);
            this.captureCanvas = elem;
        }
        return this.captureCanvas;
    };
    /**
     * Overwriting this allows you to manipulate the next frame in anyway you want before decode.
     */ BrowserCodeReader.prototype.drawFrameOnCanvas = function(srcElement, dimensions, canvasElementContext) {
        if (dimensions === void 0) dimensions = {
            sx: 0,
            sy: 0,
            sWidth: srcElement.videoWidth,
            sHeight: srcElement.videoHeight,
            dx: 0,
            dy: 0,
            dWidth: srcElement.videoWidth,
            dHeight: srcElement.videoHeight
        };
        if (canvasElementContext === void 0) canvasElementContext = this.captureCanvasContext;
        canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
    };
    /**
     * Ovewriting this allows you to manipulate the snapshot image in anyway you want before decode.
     */ BrowserCodeReader.prototype.drawImageOnCanvas = function(srcElement, dimensions, canvasElementContext) {
        if (dimensions === void 0) dimensions = {
            sx: 0,
            sy: 0,
            sWidth: srcElement.naturalWidth,
            sHeight: srcElement.naturalHeight,
            dx: 0,
            dy: 0,
            dWidth: srcElement.naturalWidth,
            dHeight: srcElement.naturalHeight
        };
        if (canvasElementContext === void 0) canvasElementContext = this.captureCanvasContext;
        canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
    };
    /**
     * Call the encapsulated readers decode
     */ BrowserCodeReader.prototype.decodeBitmap = function(binaryBitmap) {
        return this.reader.decode(binaryBitmap, this._hints);
    };
    /**
     * 🖌 Prepares the canvas for capture and scan frames.
     */ BrowserCodeReader.prototype.createCaptureCanvas = function(mediaElement) {
        if (typeof document === "undefined") {
            this._destroyCaptureCanvas();
            return null;
        }
        var canvasElement = document.createElement("canvas");
        var width;
        var height;
        if (typeof mediaElement !== "undefined") {
            if (mediaElement instanceof HTMLVideoElement) {
                width = mediaElement.videoWidth;
                height = mediaElement.videoHeight;
            } else if (mediaElement instanceof HTMLImageElement) {
                width = mediaElement.naturalWidth || mediaElement.width;
                height = mediaElement.naturalHeight || mediaElement.height;
            }
        }
        canvasElement.style.width = width + "px";
        canvasElement.style.height = height + "px";
        canvasElement.width = width;
        canvasElement.height = height;
        return canvasElement;
    };
    /**
     * Stops the continuous scan and cleans the stream.
     */ BrowserCodeReader.prototype.stopStreams = function() {
        if (this.stream) {
            this.stream.getVideoTracks().forEach(function(t) {
                return t.stop();
            });
            this.stream = undefined;
        }
        if (this._stopAsyncDecode === false) this.stopAsyncDecode();
        if (this._stopContinuousDecode === false) this.stopContinuousDecode();
    };
    /**
     * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.reset = function() {
        // stops the camera, preview and scan 🔴
        this.stopStreams();
        // clean and forget about HTML elements
        this._destroyVideoElement();
        this._destroyImageElement();
        this._destroyCaptureCanvas();
    };
    BrowserCodeReader.prototype._destroyVideoElement = function() {
        if (!this.videoElement) return;
        // first gives freedon to the element 🕊
        if (typeof this.videoEndedListener !== "undefined") this.videoElement.removeEventListener("ended", this.videoEndedListener);
        if (typeof this.videoPlayingEventListener !== "undefined") this.videoElement.removeEventListener("playing", this.videoPlayingEventListener);
        if (typeof this.videoCanPlayListener !== "undefined") this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener);
        // then forgets about that element 😢
        this.cleanVideoSource(this.videoElement);
        this.videoElement = undefined;
    };
    BrowserCodeReader.prototype._destroyImageElement = function() {
        if (!this.imageElement) return;
        // first gives freedon to the element 🕊
        if (undefined !== this.imageLoadedListener) this.imageElement.removeEventListener("load", this.imageLoadedListener);
        // then forget about that element 😢
        this.imageElement.src = undefined;
        this.imageElement.removeAttribute("src");
        this.imageElement = undefined;
    };
    /**
     * Cleans canvas references 🖌
     */ BrowserCodeReader.prototype._destroyCaptureCanvas = function() {
        // then forget about that element 😢
        this.captureCanvasContext = undefined;
        this.captureCanvas = undefined;
    };
    /**
     * Defines what the videoElement src will be.
     *
     * @param videoElement
     * @param stream
     */ BrowserCodeReader.prototype.addVideoSource = function(videoElement, stream) {
        // Older browsers may not have `srcObject`
        try {
            // @note Throws Exception if interrupted by a new loaded request
            videoElement.srcObject = stream;
        } catch (err) {
            // @note Avoid using this in new browsers, as it is going away.
            // @ts-ignore
            videoElement.src = URL.createObjectURL(stream);
        }
    };
    /**
     * Unbinds a HTML video src property.
     *
     * @param videoElement
     */ BrowserCodeReader.prototype.cleanVideoSource = function(videoElement) {
        try {
            videoElement.srcObject = null;
        } catch (err) {
            videoElement.src = "";
        }
        this.videoElement.removeAttribute("src");
    };
    return BrowserCodeReader;
}();


/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * <p>Encapsulates the result of decoding a barcode within an image.</p>
 *
 * @author Sean Owen
 */ var $aa06c8d16b4c59af$var$Result = /** @class */ function() {
    // public constructor(private text: string,
    //               Uint8Array rawBytes,
    //               ResultPoconst resultPoints: Int32Array,
    //               BarcodeFormat format) {
    //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
    // }
    // public constructor(text: string,
    //               Uint8Array rawBytes,
    //               ResultPoconst resultPoints: Int32Array,
    //               BarcodeFormat format,
    //               long timestamp) {
    //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
    //        resultPoints, format, timestamp)
    // }
    function Result(text, rawBytes, numBits, resultPoints, format, timestamp) {
        if (numBits === void 0) numBits = rawBytes == null ? 0 : 8 * rawBytes.length;
        if (timestamp === void 0) timestamp = (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).currentTimeMillis();
        this.text = text;
        this.rawBytes = rawBytes;
        this.numBits = numBits;
        this.resultPoints = resultPoints;
        this.format = format;
        this.timestamp = timestamp;
        this.text = text;
        this.rawBytes = rawBytes;
        if (undefined === numBits || null === numBits) this.numBits = rawBytes === null || rawBytes === undefined ? 0 : 8 * rawBytes.length;
        else this.numBits = numBits;
        this.resultPoints = resultPoints;
        this.format = format;
        this.resultMetadata = null;
        if (undefined === timestamp || null === timestamp) this.timestamp = (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).currentTimeMillis();
        else this.timestamp = timestamp;
    }
    /**
     * @return raw text encoded by the barcode
     */ Result.prototype.getText = function() {
        return this.text;
    };
    /**
     * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
     */ Result.prototype.getRawBytes = function() {
        return this.rawBytes;
    };
    /**
     * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
     * @since 3.3.0
     */ Result.prototype.getNumBits = function() {
        return this.numBits;
    };
    /**
     * @return points related to the barcode in the image. These are typically points
     *         identifying finder patterns or the corners of the barcode. The exact meaning is
     *         specific to the type of barcode that was decoded.
     */ Result.prototype.getResultPoints = function() {
        return this.resultPoints;
    };
    /**
     * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
     */ Result.prototype.getBarcodeFormat = function() {
        return this.format;
    };
    /**
     * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
     *   {@code null}. This contains optional metadata about what was detected about the barcode,
     *   like orientation.
     */ Result.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    };
    Result.prototype.putMetadata = function(type, value) {
        if (this.resultMetadata === null) this.resultMetadata = new Map();
        this.resultMetadata.set(type, value);
    };
    Result.prototype.putAllMetadata = function(metadata) {
        if (metadata !== null) {
            if (this.resultMetadata === null) this.resultMetadata = metadata;
            else this.resultMetadata = new Map(metadata);
        }
    };
    Result.prototype.addResultPoints = function(newPoints) {
        var oldPoints = this.resultPoints;
        if (oldPoints === null) this.resultPoints = newPoints;
        else if (newPoints !== null && newPoints.length > 0) {
            var allPoints = new Array(oldPoints.length + newPoints.length);
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
            this.resultPoints = allPoints;
        }
    };
    Result.prototype.getTimestamp = function() {
        return this.timestamp;
    };
    /*@Override*/ Result.prototype.toString = function() {
        return this.text;
    };
    return Result;
}();
var $aa06c8d16b4c59af$export$2e2bcd8739ae039 = $aa06c8d16b4c59af$var$Result;


/*
 * Direct port to TypeScript of ZXing by Adrian Toșcă
 */ /*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * Enumerates barcode formats known to this package. Please keep alphabetized.
 *
 * @author Sean Owen
 */ var $03ea32520a329dec$var$BarcodeFormat;
(function(BarcodeFormat) {
    /** Aztec 2D barcode format. */ BarcodeFormat[BarcodeFormat["AZTEC"] = 0] = "AZTEC";
    /** CODABAR 1D format. */ BarcodeFormat[BarcodeFormat["CODABAR"] = 1] = "CODABAR";
    /** Code 39 1D format. */ BarcodeFormat[BarcodeFormat["CODE_39"] = 2] = "CODE_39";
    /** Code 93 1D format. */ BarcodeFormat[BarcodeFormat["CODE_93"] = 3] = "CODE_93";
    /** Code 128 1D format. */ BarcodeFormat[BarcodeFormat["CODE_128"] = 4] = "CODE_128";
    /** Data Matrix 2D barcode format. */ BarcodeFormat[BarcodeFormat["DATA_MATRIX"] = 5] = "DATA_MATRIX";
    /** EAN-8 1D format. */ BarcodeFormat[BarcodeFormat["EAN_8"] = 6] = "EAN_8";
    /** EAN-13 1D format. */ BarcodeFormat[BarcodeFormat["EAN_13"] = 7] = "EAN_13";
    /** ITF (Interleaved Two of Five) 1D format. */ BarcodeFormat[BarcodeFormat["ITF"] = 8] = "ITF";
    /** MaxiCode 2D barcode format. */ BarcodeFormat[BarcodeFormat["MAXICODE"] = 9] = "MAXICODE";
    /** PDF417 format. */ BarcodeFormat[BarcodeFormat["PDF_417"] = 10] = "PDF_417";
    /** QR Code 2D barcode format. */ BarcodeFormat[BarcodeFormat["QR_CODE"] = 11] = "QR_CODE";
    /** RSS 14 */ BarcodeFormat[BarcodeFormat["RSS_14"] = 12] = "RSS_14";
    /** RSS EXPANDED */ BarcodeFormat[BarcodeFormat["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    /** UPC-A 1D format. */ BarcodeFormat[BarcodeFormat["UPC_A"] = 14] = "UPC_A";
    /** UPC-E 1D format. */ BarcodeFormat[BarcodeFormat["UPC_E"] = 15] = "UPC_E";
    /** UPC/EAN extension format. Not a stand-alone format. */ BarcodeFormat[BarcodeFormat["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})($03ea32520a329dec$var$BarcodeFormat || ($03ea32520a329dec$var$BarcodeFormat = {}));
var $03ea32520a329dec$export$2e2bcd8739ae039 = $03ea32520a329dec$var$BarcodeFormat;



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * Represents some type of metadata about the result of the decoding that the decoder
 * wishes to communicate back to the caller.
 *
 * @author Sean Owen
 */ var $84e98e00dae0cad6$var$ResultMetadataType;
(function(ResultMetadataType) {
    /**
     * Unspecified, application-specific metadata. Maps to an unspecified {@link Object}.
     */ ResultMetadataType[ResultMetadataType["OTHER"] = 0] = "OTHER";
    /**
     * Denotes the likely approximate orientation of the barcode in the image. This value
     * is given as degrees rotated clockwise from the normal, upright orientation.
     * For example a 1D barcode which was found by reading top-to-bottom would be
     * said to have orientation "90". This key maps to an {@link Integer} whose
     * value is in the range [0,360).
     */ ResultMetadataType[ResultMetadataType["ORIENTATION"] = 1] = "ORIENTATION";
    /**
     * <p>2D barcode formats typically encode text, but allow for a sort of 'byte mode'
     * which is sometimes used to encode binary data. While {@link Result} makes available
     * the complete raw bytes in the barcode for these formats, it does not offer the bytes
     * from the byte segments alone.</p>
     *
     * <p>This maps to a {@link java.util.List} of byte arrays corresponding to the
     * raw bytes in the byte segments in the barcode, in order.</p>
     */ ResultMetadataType[ResultMetadataType["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
    /**
     * Error correction level used, if applicable. The value type depends on the
     * format, but is typically a String.
     */ ResultMetadataType[ResultMetadataType["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
    /**
     * For some periodicals, indicates the issue number as an {@link Integer}.
     */ ResultMetadataType[ResultMetadataType["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
    /**
     * For some products, indicates the suggested retail price in the barcode as a
     * formatted {@link String}.
     */ ResultMetadataType[ResultMetadataType["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
    /**
     * For some products, the possible country of manufacture as a {@link String} denoting the
     * ISO country code. Some map to multiple possible countries, like "US/CA".
     */ ResultMetadataType[ResultMetadataType["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
    /**
     * For some products, the extension text
     */ ResultMetadataType[ResultMetadataType["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
    /**
     * PDF417-specific metadata
     */ ResultMetadataType[ResultMetadataType["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
    /**
     * If the code format supports structured append and the current scanned code is part of one then the
     * sequence number is given with it.
     */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
    /**
     * If the code format supports structured append and the current scanned code is part of one then the
     * parity is given with it.
     */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
})($84e98e00dae0cad6$var$ResultMetadataType || ($84e98e00dae0cad6$var$ResultMetadataType = {}));
var $84e98e00dae0cad6$export$2e2bcd8739ae039 = $84e98e00dae0cad6$var$ResultMetadataType;



/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.util.List;*/ /**
 * <p>Encapsulates the result of decoding a matrix of bits. This typically
 * applies to 2D barcode formats. For now it contains the raw bytes obtained,
 * as well as a String interpretation of those bytes, if applicable.</p>
 *
 * @author Sean Owen
 */ var $aa602f5deffed2f7$var$DecoderResult = /** @class */ function() {
    // public constructor(rawBytes: Uint8Array,
    //                      text: string,
    //                      List<Uint8Array> byteSegments,
    //                      String ecLevel) {
    //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
    // }
    function DecoderResult(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber, structuredAppendParity) {
        if (structuredAppendSequenceNumber === void 0) structuredAppendSequenceNumber = -1;
        if (structuredAppendParity === void 0) structuredAppendParity = -1;
        this.rawBytes = rawBytes;
        this.text = text;
        this.byteSegments = byteSegments;
        this.ecLevel = ecLevel;
        this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
        this.structuredAppendParity = structuredAppendParity;
        this.numBits = rawBytes === undefined || rawBytes === null ? 0 : 8 * rawBytes.length;
    }
    /**
     * @return raw bytes representing the result, or {@code null} if not applicable
     */ DecoderResult.prototype.getRawBytes = function() {
        return this.rawBytes;
    };
    /**
     * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
     * @since 3.3.0
     */ DecoderResult.prototype.getNumBits = function() {
        return this.numBits;
    };
    /**
     * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
     * @since 3.3.0
     */ DecoderResult.prototype.setNumBits = function(numBits /*int*/ ) {
        this.numBits = numBits;
    };
    /**
     * @return text representation of the result
     */ DecoderResult.prototype.getText = function() {
        return this.text;
    };
    /**
     * @return list of byte segments in the result, or {@code null} if not applicable
     */ DecoderResult.prototype.getByteSegments = function() {
        return this.byteSegments;
    };
    /**
     * @return name of error correction level used, or {@code null} if not applicable
     */ DecoderResult.prototype.getECLevel = function() {
        return this.ecLevel;
    };
    /**
     * @return number of errors corrected, or {@code null} if not applicable
     */ DecoderResult.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    };
    DecoderResult.prototype.setErrorsCorrected = function(errorsCorrected /*Integer*/ ) {
        this.errorsCorrected = errorsCorrected;
    };
    /**
     * @return number of erasures corrected, or {@code null} if not applicable
     */ DecoderResult.prototype.getErasures = function() {
        return this.erasures;
    };
    DecoderResult.prototype.setErasures = function(erasures /*Integer*/ ) {
        this.erasures = erasures;
    };
    /**
     * @return arbitrary additional metadata
     */ DecoderResult.prototype.getOther = function() {
        return this.other;
    };
    DecoderResult.prototype.setOther = function(other) {
        this.other = other;
    };
    DecoderResult.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    };
    DecoderResult.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    };
    DecoderResult.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    };
    return DecoderResult;
}();
var $aa602f5deffed2f7$export$2e2bcd8739ae039 = $aa602f5deffed2f7$var$DecoderResult;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.reedsolomon {*/ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * <p>This class contains utility methods for performing mathematical operations over
 * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
 *
 * <p>Throughout this package, elements of the GF are represented as an {@code int}
 * for convenience and speed (but at the cost of memory).
 * </p>
 *
 * @author Sean Owen
 * @author David Olivier
 */ var $b2c4ec5d2e0ede22$var$AbstractGenericGF = /** @class */ function() {
    function AbstractGenericGF() {}
    /**
     * @return 2 to the power of a in GF(size)
     */ AbstractGenericGF.prototype.exp = function(a) {
        return this.expTable[a];
    };
    /**
     * @return base 2 log of a in GF(size)
     */ AbstractGenericGF.prototype.log = function(a /*int*/ ) {
        if (a === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        return this.logTable[a];
    };
    /**
     * Implements both addition and subtraction -- they are the same in GF(size).
     *
     * @return sum/difference of a and b
     */ AbstractGenericGF.addOrSubtract = function(a /*int*/ , b /*int*/ ) {
        return a ^ b;
    };
    return AbstractGenericGF;
}();
var $b2c4ec5d2e0ede22$export$2e2bcd8739ae039 = $b2c4ec5d2e0ede22$var$AbstractGenericGF;




/**
 * <p>Represents a polynomial whose coefficients are elements of a GF.
 * Instances of this class are immutable.</p>
 *
 * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
 * port of his C++ Reed-Solomon implementation.</p>
 *
 * @author Sean Owen
 */ var $a366de35f27fadf9$var$GenericGFPoly = /** @class */ function() {
    /**
     * @param field the {@link GenericGF} instance representing the field to use
     * to perform computations
     * @param coefficients coefficients as ints representing elements of GF(size), arranged
     * from most significant (highest-power term) coefficient to least significant
     * @throws IllegalArgumentException if argument is null or empty,
     * or if leading coefficient is 0 and this is not a
     * constant polynomial (that is, it is not the monomial "0")
     */ function GenericGFPoly(field, coefficients) {
        if (coefficients.length === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        this.field = field;
        var coefficientsLength = coefficients.length;
        if (coefficientsLength > 1 && coefficients[0] === 0) {
            // Leading term must be non-zero for anything except the constant polynomial "0"
            var firstNonZero = 1;
            while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
            if (firstNonZero === coefficientsLength) this.coefficients = Int32Array.from([
                0
            ]);
            else {
                this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
            }
        } else this.coefficients = coefficients;
    }
    GenericGFPoly.prototype.getCoefficients = function() {
        return this.coefficients;
    };
    /**
     * @return degree of this polynomial
     */ GenericGFPoly.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    };
    /**
     * @return true iff this polynomial is the monomial "0"
     */ GenericGFPoly.prototype.isZero = function() {
        return this.coefficients[0] === 0;
    };
    /**
     * @return coefficient of x^degree term in this polynomial
     */ GenericGFPoly.prototype.getCoefficient = function(degree /*int*/ ) {
        return this.coefficients[this.coefficients.length - 1 - degree];
    };
    /**
     * @return evaluation of this polynomial at a given point
     */ GenericGFPoly.prototype.evaluateAt = function(a /*int*/ ) {
        if (a === 0) // Just return the x^0 coefficient
        return this.getCoefficient(0);
        var coefficients = this.coefficients;
        var result;
        if (a === 1) {
            // Just the sum of the coefficients
            result = 0;
            for(var i = 0, length_1 = coefficients.length; i !== length_1; i++){
                var coefficient = coefficients[i];
                result = (0, $b2c4ec5d2e0ede22$export$2e2bcd8739ae039).addOrSubtract(result, coefficient);
            }
            return result;
        }
        result = coefficients[0];
        var size = coefficients.length;
        var field = this.field;
        for(var i = 1; i < size; i++)result = (0, $b2c4ec5d2e0ede22$export$2e2bcd8739ae039).addOrSubtract(field.multiply(a, result), coefficients[i]);
        return result;
    };
    GenericGFPoly.prototype.addOrSubtract = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return other;
        if (other.isZero()) return this;
        var smallerCoefficients = this.coefficients;
        var largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) {
            var temp = smallerCoefficients;
            smallerCoefficients = largerCoefficients;
            largerCoefficients = temp;
        }
        var sumDiff = new Int32Array(largerCoefficients.length);
        var lengthDiff = largerCoefficients.length - smallerCoefficients.length;
        // Copy high-order terms only found in higher-degree polynomial's coefficients
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
        for(var i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = (0, $b2c4ec5d2e0ede22$export$2e2bcd8739ae039).addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
        return new GenericGFPoly(this.field, sumDiff);
    };
    GenericGFPoly.prototype.multiply = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || other.isZero()) return this.field.getZero();
        var aCoefficients = this.coefficients;
        var aLength = aCoefficients.length;
        var bCoefficients = other.coefficients;
        var bLength = bCoefficients.length;
        var product = new Int32Array(aLength + bLength - 1);
        var field = this.field;
        for(var i = 0; i < aLength; i++){
            var aCoeff = aCoefficients[i];
            for(var j = 0; j < bLength; j++)product[i + j] = (0, $b2c4ec5d2e0ede22$export$2e2bcd8739ae039).addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
        }
        return new GenericGFPoly(field, product);
    };
    GenericGFPoly.prototype.multiplyScalar = function(scalar /*int*/ ) {
        if (scalar === 0) return this.field.getZero();
        if (scalar === 1) return this;
        var size = this.coefficients.length;
        var field = this.field;
        var product = new Int32Array(size);
        var coefficients = this.coefficients;
        for(var i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], scalar);
        return new GenericGFPoly(field, product);
    };
    GenericGFPoly.prototype.multiplyByMonomial = function(degree /*int*/ , coefficient /*int*/ ) {
        if (degree < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        if (coefficient === 0) return this.field.getZero();
        var coefficients = this.coefficients;
        var size = coefficients.length;
        var product = new Int32Array(size + degree);
        var field = this.field;
        for(var i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], coefficient);
        return new GenericGFPoly(field, product);
    };
    GenericGFPoly.prototype.divide = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("GenericGFPolys do not have same GenericGF field");
        if (other.isZero()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Divide by 0");
        var field = this.field;
        var quotient = field.getZero();
        var remainder = this;
        var denominatorLeadingTerm = other.getCoefficient(other.getDegree());
        var inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
        while(remainder.getDegree() >= other.getDegree() && !remainder.isZero()){
            var degreeDifference = remainder.getDegree() - other.getDegree();
            var scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            var term = other.multiplyByMonomial(degreeDifference, scale);
            var iterationQuotient = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.addOrSubtract(iterationQuotient);
            remainder = remainder.addOrSubtract(term);
        }
        return [
            quotient,
            remainder
        ];
    };
    /*@Override*/ GenericGFPoly.prototype.toString = function() {
        var result = "";
        for(var degree = this.getDegree(); degree >= 0; degree--){
            var coefficient = this.getCoefficient(degree);
            if (coefficient !== 0) {
                if (coefficient < 0) {
                    result += " - ";
                    coefficient = -coefficient;
                } else if (result.length > 0) result += " + ";
                if (degree === 0 || coefficient !== 1) {
                    var alphaPower = this.field.log(coefficient);
                    if (alphaPower === 0) result += "1";
                    else if (alphaPower === 1) result += "a";
                    else {
                        result += "a^";
                        result += alphaPower;
                    }
                }
                if (degree !== 0) {
                    if (degree === 1) result += "x";
                    else {
                        result += "x^";
                        result += degree;
                    }
                }
            }
        }
        return result;
    };
    return GenericGFPoly;
}();
var $a366de35f27fadf9$export$2e2bcd8739ae039 = $a366de35f27fadf9$var$GenericGFPoly;






var $c8dc29a1cba9dc67$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $c8dc29a1cba9dc67$var$ArithmeticException = /** @class */ function(_super) {
    $c8dc29a1cba9dc67$var$__extends(ArithmeticException, _super);
    function ArithmeticException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArithmeticException.kind = "ArithmeticException";
    return ArithmeticException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $c8dc29a1cba9dc67$export$2e2bcd8739ae039 = $c8dc29a1cba9dc67$var$ArithmeticException;


var $7973dc50831a46a1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>This class contains utility methods for performing mathematical operations over
 * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
 *
 * <p>Throughout this package, elements of the GF are represented as an {@code int}
 * for convenience and speed (but at the cost of memory).
 * </p>
 *
 * @author Sean Owen
 * @author David Olivier
 */ var $7973dc50831a46a1$var$GenericGF = /** @class */ function(_super) {
    $7973dc50831a46a1$var$__extends(GenericGF, _super);
    /**
     * Create a representation of GF(size) using the given primitive polynomial.
     *
     * @param primitive irreducible polynomial whose coefficients are represented by
     *  the bits of an int, where the least-significant bit represents the constant
     *  coefficient
     * @param size the size of the field
     * @param b the factor b in the generator polynomial can be 0- or 1-based
     *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
     *  In most cases it should be 1, but for QR code it is 0.
     */ function GenericGF(primitive /*int*/ , size /*int*/ , generatorBase /*int*/ ) {
        var _this = _super.call(this) || this;
        _this.primitive = primitive;
        _this.size = size;
        _this.generatorBase = generatorBase;
        var expTable = new Int32Array(size);
        var x = 1;
        for(var i = 0; i < size; i++){
            expTable[i] = x;
            x *= 2; // we're assuming the generator alpha is 2
            if (x >= size) {
                x ^= primitive;
                x &= size - 1;
            }
        }
        _this.expTable = expTable;
        var logTable = new Int32Array(size);
        for(var i = 0; i < size - 1; i++)logTable[expTable[i]] = i;
        _this.logTable = logTable;
        // logTable[0] == 0 but this should never be used
        _this.zero = new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(_this, Int32Array.from([
            0
        ]));
        _this.one = new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(_this, Int32Array.from([
            1
        ]));
        return _this;
    }
    GenericGF.prototype.getZero = function() {
        return this.zero;
    };
    GenericGF.prototype.getOne = function() {
        return this.one;
    };
    /**
     * @return the monomial representing coefficient * x^degree
     */ GenericGF.prototype.buildMonomial = function(degree /*int*/ , coefficient /*int*/ ) {
        if (degree < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        if (coefficient === 0) return this.zero;
        var coefficients = new Int32Array(degree + 1);
        coefficients[0] = coefficient;
        return new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(this, coefficients);
    };
    /**
     * @return multiplicative inverse of a
     */ GenericGF.prototype.inverse = function(a /*int*/ ) {
        if (a === 0) throw new (0, $c8dc29a1cba9dc67$export$2e2bcd8739ae039)();
        return this.expTable[this.size - this.logTable[a] - 1];
    };
    /**
     * @return product of a and b in GF(size)
     */ GenericGF.prototype.multiply = function(a /*int*/ , b /*int*/ ) {
        if (a === 0 || b === 0) return 0;
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
    };
    GenericGF.prototype.getSize = function() {
        return this.size;
    };
    GenericGF.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    };
    /*@Override*/ GenericGF.prototype.toString = function() {
        return "GF(0x" + (0, $902e90c40380930f$export$2e2bcd8739ae039).toHexString(this.primitive) + "," + this.size + ")";
    };
    GenericGF.prototype.equals = function(o) {
        return o === this;
    };
    GenericGF.AZTEC_DATA_12 = new GenericGF(0x1069, 4096, 1); // x^12 + x^6 + x^5 + x^3 + 1
    GenericGF.AZTEC_DATA_10 = new GenericGF(0x409, 1024, 1); // x^10 + x^3 + 1
    GenericGF.AZTEC_DATA_6 = new GenericGF(0x43, 64, 1); // x^6 + x + 1
    GenericGF.AZTEC_PARAM = new GenericGF(0x13, 16, 1); // x^4 + x + 1
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(0x012d, 256, 1); // x^8 + x^5 + x^3 + x^2 + 1
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;
    return GenericGF;
}((0, $b2c4ec5d2e0ede22$export$2e2bcd8739ae039));
var $7973dc50831a46a1$export$2e2bcd8739ae039 = $7973dc50831a46a1$var$GenericGF;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.reedsolomon {*/ 


var $3155c93560707883$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $3155c93560707883$var$ReedSolomonException = /** @class */ function(_super) {
    $3155c93560707883$var$__extends(ReedSolomonException, _super);
    function ReedSolomonException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReedSolomonException.kind = "ReedSolomonException";
    return ReedSolomonException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $3155c93560707883$export$2e2bcd8739ae039 = $3155c93560707883$var$ReedSolomonException;



var $66514fa37e3c5a9c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $66514fa37e3c5a9c$var$IllegalStateException = /** @class */ function(_super) {
    $66514fa37e3c5a9c$var$__extends(IllegalStateException, _super);
    function IllegalStateException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IllegalStateException.kind = "IllegalStateException";
    return IllegalStateException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $66514fa37e3c5a9c$export$2e2bcd8739ae039 = $66514fa37e3c5a9c$var$IllegalStateException;


/**
 * <p>Implements Reed-Solomon decoding, as the name implies.</p>
 *
 * <p>The algorithm will not be explained here, but the following references were helpful
 * in creating this implementation:</p>
 *
 * <ul>
 * <li>Bruce Maggs.
 * <a href="http://www.cs.cmu.edu/afs/cs.cmu.edu/project/pscico-guyb/realworld/www/rs_decode.ps">
 * "Decoding Reed-Solomon Codes"</a> (see discussion of Forney's Formula)</li>
 * <li>J.I. Hall. <a href="www.mth.msu.edu/~jhall/classes/codenotes/GRS.pdf">
 * "Chapter 5. Generalized Reed-Solomon Codes"</a>
 * (see discussion of Euclidean algorithm)</li>
 * </ul>
 *
 * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
 * port of his C++ Reed-Solomon implementation.</p>
 *
 * @author Sean Owen
 * @author William Rucklidge
 * @author sanfordsquires
 */ var $a1039736c6639077$var$ReedSolomonDecoder = /** @class */ function() {
    function ReedSolomonDecoder(field) {
        this.field = field;
    }
    /**
     * <p>Decodes given set of received codewords, which include both data and error-correction
     * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
     * in the input.</p>
     *
     * @param received data and error-correction codewords
     * @param twoS number of error-correction codewords available
     * @throws ReedSolomonException if decoding fails for any reason
     */ ReedSolomonDecoder.prototype.decode = function(received, twoS /*int*/ ) {
        var field = this.field;
        var poly = new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(field, received);
        var syndromeCoefficients = new Int32Array(twoS);
        var noError = true;
        for(var i = 0; i < twoS; i++){
            var evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
            syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
            if (evalResult !== 0) noError = false;
        }
        if (noError) return;
        var syndrome = new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(field, syndromeCoefficients);
        var sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
        var sigma = sigmaOmega[0];
        var omega = sigmaOmega[1];
        var errorLocations = this.findErrorLocations(sigma);
        var errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
        for(var i = 0; i < errorLocations.length; i++){
            var position = received.length - 1 - field.log(errorLocations[i]);
            if (position < 0) throw new (0, $3155c93560707883$export$2e2bcd8739ae039)("Bad error location");
            received[position] = (0, $7973dc50831a46a1$export$2e2bcd8739ae039).addOrSubtract(received[position], errorMagnitudes[i]);
        }
    };
    ReedSolomonDecoder.prototype.runEuclideanAlgorithm = function(a, b, R /*int*/ ) {
        // Assume a's degree is >= b's
        if (a.getDegree() < b.getDegree()) {
            var temp = a;
            a = b;
            b = temp;
        }
        var field = this.field;
        var rLast = a;
        var r = b;
        var tLast = field.getZero();
        var t = field.getOne();
        // Run Euclidean algorithm until r's degree is less than R/2
        while(r.getDegree() >= (R / 2 | 0)){
            var rLastLast = rLast;
            var tLastLast = tLast;
            rLast = r;
            tLast = t;
            // Divide rLastLast by rLast, with quotient in q and remainder in r
            if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
            throw new (0, $3155c93560707883$export$2e2bcd8739ae039)("r_{i-1} was zero");
            r = rLastLast;
            var q = field.getZero();
            var denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
            var dltInverse = field.inverse(denominatorLeadingTerm);
            while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                var degreeDiff = r.getDegree() - rLast.getDegree();
                var scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
            }
            t = q.multiply(tLast).addOrSubtract(tLastLast);
            if (r.getDegree() >= rLast.getDegree()) throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)("Division algorithm failed to reduce polynomial?");
        }
        var sigmaTildeAtZero = t.getCoefficient(0);
        if (sigmaTildeAtZero === 0) throw new (0, $3155c93560707883$export$2e2bcd8739ae039)("sigmaTilde(0) was zero");
        var inverse = field.inverse(sigmaTildeAtZero);
        var sigma = t.multiplyScalar(inverse);
        var omega = r.multiplyScalar(inverse);
        return [
            sigma,
            omega
        ];
    };
    ReedSolomonDecoder.prototype.findErrorLocations = function(errorLocator) {
        // This is a direct application of Chien's search
        var numErrors = errorLocator.getDegree();
        if (numErrors === 1) return Int32Array.from([
            errorLocator.getCoefficient(1)
        ]);
        var result = new Int32Array(numErrors);
        var e = 0;
        var field = this.field;
        for(var i = 1; i < field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
            result[e] = field.inverse(i);
            e++;
        }
        if (e !== numErrors) throw new (0, $3155c93560707883$export$2e2bcd8739ae039)("Error locator degree does not match number of roots");
        return result;
    };
    ReedSolomonDecoder.prototype.findErrorMagnitudes = function(errorEvaluator, errorLocations) {
        // This is directly applying Forney's Formula
        var s = errorLocations.length;
        var result = new Int32Array(s);
        var field = this.field;
        for(var i = 0; i < s; i++){
            var xiInverse = field.inverse(errorLocations[i]);
            var denominator = 1;
            for(var j = 0; j < s; j++)if (i !== j) {
                // denominator = field.multiply(denominator,
                //    GenericGF.addOrSubtract(1, field.multiply(errorLocations[j], xiInverse)))
                // Above should work but fails on some Apple and Linux JDKs due to a Hotspot bug.
                // Below is a funny-looking workaround from Steven Parkes
                var term = field.multiply(errorLocations[j], xiInverse);
                var termPlus1 = (term & 0x1) === 0 ? term | 1 : term & -2;
                denominator = field.multiply(denominator, termPlus1);
            }
            result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
            if (field.getGeneratorBase() !== 0) result[i] = field.multiply(result[i], xiInverse);
        }
        return result;
    };
    return ReedSolomonDecoder;
}();
var $a1039736c6639077$export$2e2bcd8739ae039 = $a1039736c6639077$var$ReedSolomonDecoder;






// import java.util.Arrays;
var $47ecffee5020b05a$var$Table;
(function(Table) {
    Table[Table["UPPER"] = 0] = "UPPER";
    Table[Table["LOWER"] = 1] = "LOWER";
    Table[Table["MIXED"] = 2] = "MIXED";
    Table[Table["DIGIT"] = 3] = "DIGIT";
    Table[Table["PUNCT"] = 4] = "PUNCT";
    Table[Table["BINARY"] = 5] = "BINARY";
})($47ecffee5020b05a$var$Table || ($47ecffee5020b05a$var$Table = {}));
/**
 * <p>The main class which implements Aztec Code decoding -- as opposed to locating and extracting
 * the Aztec Code from an image.</p>
 *
 * @author David Olivier
 */ var $47ecffee5020b05a$var$Decoder = /** @class */ function() {
    function Decoder() {}
    Decoder.prototype.decode = function(detectorResult) {
        this.ddata = detectorResult;
        var matrix = detectorResult.getBits();
        var rawbits = this.extractBits(matrix);
        var correctedBits = this.correctBits(rawbits);
        var rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
        var result = Decoder.getEncodedData(correctedBits);
        var decoderResult = new (0, $aa602f5deffed2f7$export$2e2bcd8739ae039)(rawBytes, result, null, null);
        decoderResult.setNumBits(correctedBits.length);
        return decoderResult;
    };
    // This method is used for testing the high-level encoder
    Decoder.highLevelDecode = function(correctedBits) {
        return this.getEncodedData(correctedBits);
    };
    /**
     * Gets the string encoded in the aztec code bits
     *
     * @return the decoded string
     */ Decoder.getEncodedData = function(correctedBits) {
        var endIndex = correctedBits.length;
        var latchTable = $47ecffee5020b05a$var$Table.UPPER; // table most recently latched to
        var shiftTable = $47ecffee5020b05a$var$Table.UPPER; // table to use for the next read
        var result = "";
        var index = 0;
        while(index < endIndex)if (shiftTable === $47ecffee5020b05a$var$Table.BINARY) {
            if (endIndex - index < 5) break;
            var length_1 = Decoder.readCode(correctedBits, index, 5);
            index += 5;
            if (length_1 === 0) {
                if (endIndex - index < 11) break;
                length_1 = Decoder.readCode(correctedBits, index, 11) + 31;
                index += 11;
            }
            for(var charCount = 0; charCount < length_1; charCount++){
                if (endIndex - index < 8) {
                    index = endIndex; // Force outer loop to exit
                    break;
                }
                var code = Decoder.readCode(correctedBits, index, 8);
                result += /*(char)*/ (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).castAsNonUtf8Char(code);
                index += 8;
            }
            // Go back to whatever mode we had been in
            shiftTable = latchTable;
        } else {
            var size = shiftTable === $47ecffee5020b05a$var$Table.DIGIT ? 4 : 5;
            if (endIndex - index < size) break;
            var code = Decoder.readCode(correctedBits, index, size);
            index += size;
            var str = Decoder.getCharacter(shiftTable, code);
            if (str.startsWith("CTRL_")) {
                // Table changes
                // ISO/IEC 24778:2008 prescribes ending a shift sequence in the mode from which it was invoked.
                // That's including when that mode is a shift.
                // Our test case dlusbs.png for issue #642 exercises that.
                latchTable = shiftTable; // Latch the current mode, so as to return to Upper after U/S B/S
                shiftTable = Decoder.getTable(str.charAt(5));
                if (str.charAt(6) === "L") latchTable = shiftTable;
            } else {
                result += str;
                // Go back to whatever mode we had been in
                shiftTable = latchTable;
            }
        }
        return result;
    };
    /**
     * gets the table corresponding to the char passed
     */ Decoder.getTable = function(t) {
        switch(t){
            case "L":
                return $47ecffee5020b05a$var$Table.LOWER;
            case "P":
                return $47ecffee5020b05a$var$Table.PUNCT;
            case "M":
                return $47ecffee5020b05a$var$Table.MIXED;
            case "D":
                return $47ecffee5020b05a$var$Table.DIGIT;
            case "B":
                return $47ecffee5020b05a$var$Table.BINARY;
            case "U":
            default:
                return $47ecffee5020b05a$var$Table.UPPER;
        }
    };
    /**
     * Gets the character (or string) corresponding to the passed code in the given table
     *
     * @param table the table used
     * @param code the code of the character
     */ Decoder.getCharacter = function(table, code) {
        switch(table){
            case $47ecffee5020b05a$var$Table.UPPER:
                return Decoder.UPPER_TABLE[code];
            case $47ecffee5020b05a$var$Table.LOWER:
                return Decoder.LOWER_TABLE[code];
            case $47ecffee5020b05a$var$Table.MIXED:
                return Decoder.MIXED_TABLE[code];
            case $47ecffee5020b05a$var$Table.PUNCT:
                return Decoder.PUNCT_TABLE[code];
            case $47ecffee5020b05a$var$Table.DIGIT:
                return Decoder.DIGIT_TABLE[code];
            default:
                // Should not reach here.
                throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)("Bad table");
        }
    };
    /**
     * <p>Performs RS error correction on an array of bits.</p>
     *
     * @return the corrected array
     * @throws FormatException if the input contains too many errors
     */ Decoder.prototype.correctBits = function(rawbits) {
        var gf;
        var codewordSize;
        if (this.ddata.getNbLayers() <= 2) {
            codewordSize = 6;
            gf = (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_6;
        } else if (this.ddata.getNbLayers() <= 8) {
            codewordSize = 8;
            gf = (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_8;
        } else if (this.ddata.getNbLayers() <= 22) {
            codewordSize = 10;
            gf = (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_10;
        } else {
            codewordSize = 12;
            gf = (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_12;
        }
        var numDataCodewords = this.ddata.getNbDatablocks();
        var numCodewords = rawbits.length / codewordSize;
        if (numCodewords < numDataCodewords) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        var offset = rawbits.length % codewordSize;
        var dataWords = new Int32Array(numCodewords);
        for(var i = 0; i < numCodewords; i++, offset += codewordSize)dataWords[i] = Decoder.readCode(rawbits, offset, codewordSize);
        try {
            var rsDecoder = new (0, $a1039736c6639077$export$2e2bcd8739ae039)(gf);
            rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
        } catch (ex) {
            throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)(ex);
        }
        // Now perform the unstuffing operation.
        // First, count how many bits are going to be thrown out as stuffing
        var mask = (1 << codewordSize) - 1;
        var stuffedBits = 0;
        for(var i = 0; i < numDataCodewords; i++){
            var dataWord = dataWords[i];
            if (dataWord === 0 || dataWord === mask) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            else if (dataWord === 1 || dataWord === mask - 1) stuffedBits++;
        }
        // Now, actually unpack the bits and remove the stuffing
        var correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
        var index = 0;
        for(var i = 0; i < numDataCodewords; i++){
            var dataWord = dataWords[i];
            if (dataWord === 1 || dataWord === mask - 1) {
                // next codewordSize-1 bits are all zeros or all ones
                correctedBits.fill(dataWord > 1, index, index + codewordSize - 1);
                // Arrays.fill(correctedBits, index, index + codewordSize - 1, dataWord > 1);
                index += codewordSize - 1;
            } else for(var bit = codewordSize - 1; bit >= 0; --bit)correctedBits[index++] = (dataWord & 1 << bit) !== 0;
        }
        return correctedBits;
    };
    /**
     * Gets the array of bits from an Aztec Code matrix
     *
     * @return the array of bits
     */ Decoder.prototype.extractBits = function(matrix) {
        var compact = this.ddata.isCompact();
        var layers = this.ddata.getNbLayers();
        var baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
        var alignmentMap = new Int32Array(baseMatrixSize);
        var rawbits = new Array(this.totalBitsInLayer(layers, compact));
        if (compact) for(var i = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
        else {
            var matrixSize = baseMatrixSize + 1 + 2 * (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision((0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(baseMatrixSize, 2) - 1, 15);
            var origCenter = baseMatrixSize / 2;
            var center = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2);
            for(var i = 0; i < origCenter; i++){
                var newOffset = i + (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(i, 15);
                alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                alignmentMap[origCenter + i] = center + newOffset + 1;
            }
        }
        for(var i = 0, rowOffset = 0; i < layers; i++){
            var rowSize = (layers - i) * 4 + (compact ? 9 : 12);
            // The top-left most point of this layer is <low, low> (not including alignment lines)
            var low = i * 2;
            // The bottom-right most point of this layer is <high, high> (not including alignment lines)
            var high = baseMatrixSize - 1 - low;
            // We pull bits from the two 2 x rowSize columns and two rowSize x 2 rows
            for(var j = 0; j < rowSize; j++){
                var columnOffset = j * 2;
                for(var k = 0; k < 2; k++){
                    // left column
                    rawbits[rowOffset + columnOffset + k] = matrix.get(alignmentMap[low + k], alignmentMap[low + j]);
                    // bottom row
                    rawbits[rowOffset + 2 * rowSize + columnOffset + k] = matrix.get(alignmentMap[low + j], alignmentMap[high - k]);
                    // right column
                    rawbits[rowOffset + 4 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - k], alignmentMap[high - j]);
                    // top row
                    rawbits[rowOffset + 6 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - j], alignmentMap[low + k]);
                }
            }
            rowOffset += rowSize * 8;
        }
        return rawbits;
    };
    /**
     * Reads a code of given length and at given index in an array of bits
     */ Decoder.readCode = function(rawbits, startIndex, length) {
        var res = 0;
        for(var i = startIndex; i < startIndex + length; i++){
            res <<= 1;
            if (rawbits[i]) res |= 0x01;
        }
        return res;
    };
    /**
     * Reads a code of length 8 in an array of bits, padding with zeros
     */ Decoder.readByte = function(rawbits, startIndex) {
        var n = rawbits.length - startIndex;
        if (n >= 8) return Decoder.readCode(rawbits, startIndex, 8);
        return Decoder.readCode(rawbits, startIndex, n) << 8 - n;
    };
    /**
     * Packs a bit array into bytes, most significant bit first
     */ Decoder.convertBoolArrayToByteArray = function(boolArr) {
        var byteArr = new Uint8Array((boolArr.length + 7) / 8);
        for(var i = 0; i < byteArr.length; i++)byteArr[i] = Decoder.readByte(boolArr, 8 * i);
        return byteArr;
    };
    Decoder.prototype.totalBitsInLayer = function(layers, compact) {
        return ((compact ? 88 : 112) + 16 * layers) * layers;
    };
    Decoder.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ];
    Decoder.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ];
    Decoder.MIXED_TABLE = [
        // Module parse failed: Octal literal in strict mode (50:29)
        // so number string were scaped
        "CTRL_PS",
        " ",
        "\\1",
        "\\2",
        "\\3",
        "\\4",
        "\\5",
        "\\6",
        "\\7",
        "\b",
        "	",
        "\n",
        "\\13",
        "\f",
        "\r",
        "\\33",
        "\\34",
        "\\35",
        "\\36",
        "\\37",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\\177",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ];
    Decoder.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ];
    Decoder.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ];
    return Decoder;
}();
var $47ecffee5020b05a$export$2e2bcd8739ae039 = $47ecffee5020b05a$var$Decoder;


/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /*
 * Copyright 2012 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.detector {*/ /**
 * General math-related and numeric utility functions.
 */ var $ebab38c0c75ceb72$var$MathUtils = /** @class */ function() {
    function MathUtils() {}
    /**
     * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
     * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
     * differ slightly from {@link Math#round(float)} in that half rounds down for negative
     * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
     *
     * @param d real value to round
     * @return nearest {@code int}
     */ MathUtils.round = function(d /*float*/ ) {
        if (isNaN(d)) return 0;
        if (d <= Number.MIN_SAFE_INTEGER) return Number.MIN_SAFE_INTEGER;
        if (d >= Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
        return /*(int) */ d + (d < 0.0 ? -0.5 : 0.5) | 0;
    };
    // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
    /**
     * @param aX point A x coordinate
     * @param aY point A y coordinate
     * @param bX point B x coordinate
     * @param bY point B y coordinate
     * @return Euclidean distance between points A and B
     */ MathUtils.distance = function(aX /*float|int*/ , aY /*float|int*/ , bX /*float|int*/ , bY /*float|int*/ ) {
        var xDiff = aX - bX;
        var yDiff = aY - bY;
        return /*(float) */ Math.sqrt(xDiff * xDiff + yDiff * yDiff);
    };
    /**
     * @param aX point A x coordinate
     * @param aY point A y coordinate
     * @param bX point B x coordinate
     * @param bY point B y coordinate
     * @return Euclidean distance between points A and B
     */ // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
    //   const xDiff = aX - bX
    //   const yDiff = aY - bY
    //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
    // }
    /**
     * @param array values to sum
     * @return sum of values in array
     */ MathUtils.sum = function(array) {
        var count = 0;
        for(var i = 0, length_1 = array.length; i !== length_1; i++){
            var a = array[i];
            count += a;
        }
        return count;
    };
    return MathUtils;
}();
var $ebab38c0c75ceb72$export$2e2bcd8739ae039 = $ebab38c0c75ceb72$var$MathUtils;


/**
 * Ponyfill for Java's Float class.
 */ var $61429817f07e819d$var$Float = /** @class */ function() {
    function Float() {}
    /**
     * SincTS has no difference between int and float, there's all numbers,
     * this is used only to polyfill Java code.
     */ Float.floatToIntBits = function(f) {
        return f;
    };
    /**
     * The float max value in JS is the number max value.
     */ Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    return Float;
}();
var $61429817f07e819d$export$2e2bcd8739ae039 = $61429817f07e819d$var$Float;


/**
 * <p>Encapsulates a point of interest in an image containing a barcode. Typically, this
 * would be the location of a finder pattern or the corner of the barcode, for example.</p>
 *
 * @author Sean Owen
 */ var $e9ec26965ff3031c$var$ResultPoint = /** @class */ function() {
    function ResultPoint(x, y) {
        this.x = x;
        this.y = y;
    }
    ResultPoint.prototype.getX = function() {
        return this.x;
    };
    ResultPoint.prototype.getY = function() {
        return this.y;
    };
    /*@Override*/ ResultPoint.prototype.equals = function(other) {
        if (other instanceof ResultPoint) {
            var otherPoint = other;
            return this.x === otherPoint.x && this.y === otherPoint.y;
        }
        return false;
    };
    /*@Override*/ ResultPoint.prototype.hashCode = function() {
        return 31 * (0, $61429817f07e819d$export$2e2bcd8739ae039).floatToIntBits(this.x) + (0, $61429817f07e819d$export$2e2bcd8739ae039).floatToIntBits(this.y);
    };
    /*@Override*/ ResultPoint.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    };
    /**
     * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
     * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
     *
     * @param patterns array of three {@code ResultPoint} to order
     */ ResultPoint.orderBestPatterns = function(patterns) {
        // Find distances between pattern centers
        var zeroOneDistance = this.distance(patterns[0], patterns[1]);
        var oneTwoDistance = this.distance(patterns[1], patterns[2]);
        var zeroTwoDistance = this.distance(patterns[0], patterns[2]);
        var pointA;
        var pointB;
        var pointC;
        // Assume one closest to other two is B; A and C will just be guesses at first
        if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
            pointB = patterns[0];
            pointA = patterns[1];
            pointC = patterns[2];
        } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
            pointB = patterns[1];
            pointA = patterns[0];
            pointC = patterns[2];
        } else {
            pointB = patterns[2];
            pointA = patterns[0];
            pointC = patterns[1];
        }
        // Use cross product to figure out whether A and C are correct or flipped.
        // This asks whether BC x BA has a positive z component, which is the arrangement
        // we want for A, B, C. If it's negative, then we've got it flipped around and
        // should swap A and C.
        if (this.crossProductZ(pointA, pointB, pointC) < 0.0) {
            var temp = pointA;
            pointA = pointC;
            pointC = temp;
        }
        patterns[0] = pointA;
        patterns[1] = pointB;
        patterns[2] = pointC;
    };
    /**
     * @param pattern1 first pattern
     * @param pattern2 second pattern
     * @return distance between two points
     */ ResultPoint.distance = function(pattern1, pattern2) {
        return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
    };
    /**
     * Returns the z component of the cross product between vectors BC and BA.
     */ ResultPoint.crossProductZ = function(pointA, pointB, pointC) {
        var bX = pointB.x;
        var bY = pointB.y;
        return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
    };
    return ResultPoint;
}();
var $e9ec26965ff3031c$export$2e2bcd8739ae039 = $e9ec26965ff3031c$var$ResultPoint;


/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates the result of detecting a barcode in an image. This includes the raw
 * matrix of black/white pixels corresponding to the barcode, and possibly points of interest
 * in the image, like the location of finder patterns or corners of the barcode in the image.</p>
 *
 * @author Sean Owen
 */ var $af1075b9a52868b5$var$DetectorResult = /** @class */ function() {
    function DetectorResult(bits, points) {
        this.bits = bits;
        this.points = points;
    }
    DetectorResult.prototype.getBits = function() {
        return this.bits;
    };
    DetectorResult.prototype.getPoints = function() {
        return this.points;
    };
    return DetectorResult;
}();
var $af1075b9a52868b5$export$2e2bcd8739ae039 = $af1075b9a52868b5$var$DetectorResult;


var $9f90ac9a90d7e984$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Extends {@link DetectorResult} with more information specific to the Aztec format,
 * like the number of layers and whether it's compact.</p>
 *
 * @author Sean Owen
 */ var $9f90ac9a90d7e984$var$AztecDetectorResult = /** @class */ function(_super) {
    $9f90ac9a90d7e984$var$__extends(AztecDetectorResult, _super);
    function AztecDetectorResult(bits, points, compact, nbDatablocks, nbLayers) {
        var _this = _super.call(this, bits, points) || this;
        _this.compact = compact;
        _this.nbDatablocks = nbDatablocks;
        _this.nbLayers = nbLayers;
        return _this;
    }
    AztecDetectorResult.prototype.getNbLayers = function() {
        return this.nbLayers;
    };
    AztecDetectorResult.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    };
    AztecDetectorResult.prototype.isCompact = function() {
        return this.compact;
    };
    return AztecDetectorResult;
}((0, $af1075b9a52868b5$export$2e2bcd8739ae039));
var $9f90ac9a90d7e984$export$2e2bcd8739ae039 = $9f90ac9a90d7e984$var$AztecDetectorResult;



/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.detector {*/ 


/**
 * <p>
 * Detects a candidate barcode-like rectangular region within an image. It
 * starts around the center of the image, increases the size of the candidate
 * region until it finds a white rectangular region. By keeping track of the
 * last black points it encountered, it determines the corners of the barcode.
 * </p>
 *
 * @author David Olivier
 */ var $dd96a8353b0eb50e$var$WhiteRectangleDetector = /** @class */ function() {
    // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
    //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
    // }
    /**
     * @param image barcode image to find a rectangle in
     * @param initSize initial size of search area around center
     * @param x x position of search center
     * @param y y position of search center
     * @throws NotFoundException if image is too small to accommodate {@code initSize}
     */ function WhiteRectangleDetector(image, initSize /*int*/ , x /*int*/ , y /*int*/ ) {
        this.image = image;
        this.height = image.getHeight();
        this.width = image.getWidth();
        if (undefined === initSize || null === initSize) initSize = WhiteRectangleDetector.INIT_SIZE;
        if (undefined === x || null === x) x = image.getWidth() / 2 | 0;
        if (undefined === y || null === y) y = image.getHeight() / 2 | 0;
        var halfsize = initSize / 2 | 0;
        this.leftInit = x - halfsize;
        this.rightInit = x + halfsize;
        this.upInit = y - halfsize;
        this.downInit = y + halfsize;
        if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    }
    /**
     * <p>
     * Detects a candidate barcode-like rectangular region within an image. It
     * starts around the center of the image, increases the size of the candidate
     * region until it finds a white rectangular region.
     * </p>
     *
     * @return {@link ResultPoint}[] describing the corners of the rectangular
     *         region. The first and last points are opposed on the diagonal, as
     *         are the second and third. The first point will be the topmost
     *         point and the last, the bottommost. The second point will be
     *         leftmost and the third, the rightmost
     * @throws NotFoundException if no Data Matrix Code can be found
     */ WhiteRectangleDetector.prototype.detect = function() {
        var left = this.leftInit;
        var right = this.rightInit;
        var up = this.upInit;
        var down = this.downInit;
        var sizeExceeded = false;
        var aBlackPointFoundOnBorder = true;
        var atLeastOneBlackPointFoundOnBorder = false;
        var atLeastOneBlackPointFoundOnRight = false;
        var atLeastOneBlackPointFoundOnBottom = false;
        var atLeastOneBlackPointFoundOnLeft = false;
        var atLeastOneBlackPointFoundOnTop = false;
        var width = this.width;
        var height = this.height;
        while(aBlackPointFoundOnBorder){
            aBlackPointFoundOnBorder = false;
            // .....
            // .   |
            // .....
            var rightBorderNotWhite = true;
            while((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width){
                rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
                if (rightBorderNotWhite) {
                    right++;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnRight = true;
                } else if (!atLeastOneBlackPointFoundOnRight) right++;
            }
            if (right >= width) {
                sizeExceeded = true;
                break;
            }
            // .....
            // .   .
            // .___.
            var bottomBorderNotWhite = true;
            while((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height){
                bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
                if (bottomBorderNotWhite) {
                    down++;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnBottom = true;
                } else if (!atLeastOneBlackPointFoundOnBottom) down++;
            }
            if (down >= height) {
                sizeExceeded = true;
                break;
            }
            // .....
            // |   .
            // .....
            var leftBorderNotWhite = true;
            while((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0){
                leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
                if (leftBorderNotWhite) {
                    left--;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnLeft = true;
                } else if (!atLeastOneBlackPointFoundOnLeft) left--;
            }
            if (left < 0) {
                sizeExceeded = true;
                break;
            }
            // .___.
            // .   .
            // .....
            var topBorderNotWhite = true;
            while((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0){
                topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
                if (topBorderNotWhite) {
                    up--;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnTop = true;
                } else if (!atLeastOneBlackPointFoundOnTop) up--;
            }
            if (up < 0) {
                sizeExceeded = true;
                break;
            }
            if (aBlackPointFoundOnBorder) atLeastOneBlackPointFoundOnBorder = true;
        }
        if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
            var maxSize = right - left;
            var z = null;
            for(var i = 1; z === null && i < maxSize; i++)z = this.getBlackPointOnSegment(left, down - i, left + i, down);
            if (z == null) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            var t = null;
            // go down right
            for(var i = 1; t === null && i < maxSize; i++)t = this.getBlackPointOnSegment(left, up + i, left + i, up);
            if (t == null) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            var x = null;
            // go down left
            for(var i = 1; x === null && i < maxSize; i++)x = this.getBlackPointOnSegment(right, up + i, right - i, up);
            if (x == null) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            var y = null;
            // go up left
            for(var i = 1; y === null && i < maxSize; i++)y = this.getBlackPointOnSegment(right, down - i, right - i, down);
            if (y == null) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            return this.centerEdges(y, z, x, t);
        } else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    WhiteRectangleDetector.prototype.getBlackPointOnSegment = function(aX /*float*/ , aY /*float*/ , bX /*float*/ , bY /*float*/ ) {
        var dist = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).distance(aX, aY, bX, bY));
        var xStep = (bX - aX) / dist;
        var yStep = (bY - aY) / dist;
        var image = this.image;
        for(var i = 0; i < dist; i++){
            var x = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(aX + i * xStep);
            var y = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(aY + i * yStep);
            if (image.get(x, y)) return new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(x, y);
        }
        return null;
    };
    /**
     * recenters the points of a constant distance towards the center
     *
     * @param y bottom most point
     * @param z left most point
     * @param x right most point
     * @param t top most point
     * @return {@link ResultPoint}[] describing the corners of the rectangular
     *         region. The first and last points are opposed on the diagonal, as
     *         are the second and third. The first point will be the topmost
     *         point and the last, the bottommost. The second point will be
     *         leftmost and the third, the rightmost
     */ WhiteRectangleDetector.prototype.centerEdges = function(y, z, x, t) {
        //
        //       t            t
        //  z                      x
        //        x    OR    z
        //   y                    y
        //
        var yi = y.getX();
        var yj = y.getY();
        var zi = z.getX();
        var zj = z.getY();
        var xi = x.getX();
        var xj = x.getY();
        var ti = t.getX();
        var tj = t.getY();
        var CORR = WhiteRectangleDetector.CORR;
        if (yi < this.width / 2.0) return [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(ti - CORR, tj + CORR),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(zi + CORR, zj + CORR),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(xi - CORR, xj - CORR),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(yi + CORR, yj - CORR)
        ];
        else return [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(ti + CORR, tj + CORR),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(zi + CORR, zj - CORR),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(xi - CORR, xj + CORR),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(yi - CORR, yj - CORR)
        ];
    };
    /**
     * Determines whether a segment contains a black point
     *
     * @param a          min value of the scanned coordinate
     * @param b          max value of the scanned coordinate
     * @param fixed      value of fixed coordinate
     * @param horizontal set to true if scan must be horizontal, false if vertical
     * @return true if a black point has been found, else false.
     */ WhiteRectangleDetector.prototype.containsBlackPoint = function(a /*int*/ , b /*int*/ , fixed /*int*/ , horizontal) {
        var image = this.image;
        if (horizontal) for(var x = a; x <= b; x++){
            if (image.get(x, fixed)) return true;
        }
        else for(var y = a; y <= b; y++){
            if (image.get(fixed, y)) return true;
        }
        return false;
    };
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;
    return WhiteRectangleDetector;
}();
var $dd96a8353b0eb50e$export$2e2bcd8739ae039 = $dd96a8353b0eb50e$var$WhiteRectangleDetector;





/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * Implementations of this class can, given locations of finder patterns for a QR code in an
 * image, sample the right points in the image to reconstruct the QR code, accounting for
 * perspective distortion. It is abstracted since it is relatively expensive and should be allowed
 * to take advantage of platform-specific optimized implementations, like Sun's Java Advanced
 * Imaging library, but which may not be available in other environments such as J2ME, and vice
 * versa.
 *
 * The implementation used can be controlled by calling {@link #setGridSampler(GridSampler)}
 * with an instance of a class which implements this interface.
 *
 * @author Sean Owen
 */ var $fd0299eee670088b$var$GridSampler = /** @class */ function() {
    function GridSampler() {}
    /**
     * <p>Checks a set of points that have been transformed to sample points on an image against
     * the image's dimensions to see if the point are even within the image.</p>
     *
     * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
     * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
     * patterns in an image where the QR Code runs all the way to the image border.</p>
     *
     * <p>For efficiency, the method will check points from either end of the line until one is found
     * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
     *
     * @param image image into which the points should map
     * @param points actual points in x1,y1,...,xn,yn form
     * @throws NotFoundException if an endpoint is lies outside the image boundaries
     */ GridSampler.checkAndNudgePoints = function(image, points) {
        var width = image.getWidth();
        var height = image.getHeight();
        // Check and nudge points from start until we see some that are OK:
        var nudged = true;
        for(var offset = 0; offset < points.length && nudged; offset += 2){
            var x = Math.floor(points[offset]);
            var y = Math.floor(points[offset + 1]);
            if (x < -1 || x > width || y < -1 || y > height) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            nudged = false;
            if (x === -1) {
                points[offset] = 0.0;
                nudged = true;
            } else if (x === width) {
                points[offset] = width - 1;
                nudged = true;
            }
            if (y === -1) {
                points[offset + 1] = 0.0;
                nudged = true;
            } else if (y === height) {
                points[offset + 1] = height - 1;
                nudged = true;
            }
        }
        // Check and nudge points from end:
        nudged = true;
        for(var offset = points.length - 2; offset >= 0 && nudged; offset -= 2){
            var x = Math.floor(points[offset]);
            var y = Math.floor(points[offset + 1]);
            if (x < -1 || x > width || y < -1 || y > height) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            nudged = false;
            if (x === -1) {
                points[offset] = 0.0;
                nudged = true;
            } else if (x === width) {
                points[offset] = width - 1;
                nudged = true;
            }
            if (y === -1) {
                points[offset + 1] = 0.0;
                nudged = true;
            } else if (y === height) {
                points[offset + 1] = height - 1;
                nudged = true;
            }
        }
    };
    return GridSampler;
}();
var $fd0299eee670088b$export$2e2bcd8739ae039 = $fd0299eee670088b$var$GridSampler;



/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /**
 * <p>This class implements a perspective transform in two dimensions. Given four source and four
 * destination points, it will compute the transformation implied between them. The code is based
 * directly upon section 3.4.2 of George Wolberg's "Digital Image Warping"; see pages 54-56.</p>
 *
 * @author Sean Owen
 */ var $b13b825fa9745d86$var$PerspectiveTransform = /** @class */ function() {
    function PerspectiveTransform(a11 /*float*/ , a21 /*float*/ , a31 /*float*/ , a12 /*float*/ , a22 /*float*/ , a32 /*float*/ , a13 /*float*/ , a23 /*float*/ , a33 /*float*/ ) {
        this.a11 = a11;
        this.a21 = a21;
        this.a31 = a31;
        this.a12 = a12;
        this.a22 = a22;
        this.a32 = a32;
        this.a13 = a13;
        this.a23 = a23;
        this.a33 = a33;
    }
    PerspectiveTransform.quadrilateralToQuadrilateral = function(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ , x0p /*float*/ , y0p /*float*/ , x1p /*float*/ , y1p /*float*/ , x2p /*float*/ , y2p /*float*/ , x3p /*float*/ , y3p /*float*/ ) {
        var qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
        var sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
        return sToQ.times(qToS);
    };
    PerspectiveTransform.prototype.transformPoints = function(points) {
        var max = points.length;
        var a11 = this.a11;
        var a12 = this.a12;
        var a13 = this.a13;
        var a21 = this.a21;
        var a22 = this.a22;
        var a23 = this.a23;
        var a31 = this.a31;
        var a32 = this.a32;
        var a33 = this.a33;
        for(var i = 0; i < max; i += 2){
            var x = points[i];
            var y = points[i + 1];
            var denominator = a13 * x + a23 * y + a33;
            points[i] = (a11 * x + a21 * y + a31) / denominator;
            points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
        }
    };
    PerspectiveTransform.prototype.transformPointsWithValues = function(xValues, yValues) {
        var a11 = this.a11;
        var a12 = this.a12;
        var a13 = this.a13;
        var a21 = this.a21;
        var a22 = this.a22;
        var a23 = this.a23;
        var a31 = this.a31;
        var a32 = this.a32;
        var a33 = this.a33;
        var n = xValues.length;
        for(var i = 0; i < n; i++){
            var x = xValues[i];
            var y = yValues[i];
            var denominator = a13 * x + a23 * y + a33;
            xValues[i] = (a11 * x + a21 * y + a31) / denominator;
            yValues[i] = (a12 * x + a22 * y + a32) / denominator;
        }
    };
    PerspectiveTransform.squareToQuadrilateral = function(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
        var dx3 = x0 - x1 + x2 - x3;
        var dy3 = y0 - y1 + y2 - y3;
        if (dx3 === 0.0 && dy3 === 0.0) // Affine
        return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0.0, 0.0, 1.0);
        else {
            var dx1 = x1 - x2;
            var dx2 = x3 - x2;
            var dy1 = y1 - y2;
            var dy2 = y3 - y2;
            var denominator = dx1 * dy2 - dx2 * dy1;
            var a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
            var a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
            return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1.0);
        }
    };
    PerspectiveTransform.quadrilateralToSquare = function(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
        // Here, the adjoint serves as the inverse:
        return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
    };
    PerspectiveTransform.prototype.buildAdjoint = function() {
        // Adjoint is the transpose of the cofactor matrix:
        return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    };
    PerspectiveTransform.prototype.times = function(other) {
        return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
    };
    return PerspectiveTransform;
}();
var $b13b825fa9745d86$export$2e2bcd8739ae039 = $b13b825fa9745d86$var$PerspectiveTransform;



var $2c2afef65eae91b4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @author Sean Owen
 */ var $2c2afef65eae91b4$var$DefaultGridSampler = /** @class */ function(_super) {
    $2c2afef65eae91b4$var$__extends(DefaultGridSampler, _super);
    function DefaultGridSampler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*@Override*/ DefaultGridSampler.prototype.sampleGrid = function(image, dimensionX /*int*/ , dimensionY /*int*/ , p1ToX /*float*/ , p1ToY /*float*/ , p2ToX /*float*/ , p2ToY /*float*/ , p3ToX /*float*/ , p3ToY /*float*/ , p4ToX /*float*/ , p4ToY /*float*/ , p1FromX /*float*/ , p1FromY /*float*/ , p2FromX /*float*/ , p2FromY /*float*/ , p3FromX /*float*/ , p3FromY /*float*/ , p4FromX /*float*/ , p4FromY /*float*/ ) {
        var transform = (0, $b13b825fa9745d86$export$2e2bcd8739ae039).quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
        return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
    };
    /*@Override*/ DefaultGridSampler.prototype.sampleGridWithTransform = function(image, dimensionX /*int*/ , dimensionY /*int*/ , transform) {
        if (dimensionX <= 0 || dimensionY <= 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var bits = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(dimensionX, dimensionY);
        var points = new Float32Array(2 * dimensionX);
        for(var y = 0; y < dimensionY; y++){
            var max = points.length;
            var iValue = y + 0.5;
            for(var x = 0; x < max; x += 2){
                points[x] = x / 2 + 0.5;
                points[x + 1] = iValue;
            }
            transform.transformPoints(points);
            // Quick check to see if points transformed to something inside the image
            // sufficient to check the endpoints
            (0, $fd0299eee670088b$export$2e2bcd8739ae039).checkAndNudgePoints(image, points);
            try {
                for(var x = 0; x < max; x += 2)if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) // Black(-ish) pixel
                bits.set(x / 2, y);
            } catch (aioobe /*: ArrayIndexOutOfBoundsException*/ ) {
                // This feels wrong, but, sometimes if the finder patterns are misidentified, the resulting
                // transform gets "twisted" such that it maps a straight line of points to a set of points
                // whose endpoints are in bounds, but others are not. There is probably some mathematical
                // way to detect this about the transformation that I don't know yet.
                // This results in an ugly runtime exception despite our clever checks above -- can't have
                // that. We could check each point's coordinates but that feels duplicative. We settle for
                // catching and wrapping ArrayIndexOutOfBoundsException.
                throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            }
        }
        return bits;
    };
    return DefaultGridSampler;
}((0, $fd0299eee670088b$export$2e2bcd8739ae039));
var $2c2afef65eae91b4$export$2e2bcd8739ae039 = $2c2afef65eae91b4$var$DefaultGridSampler;


var $6aeaa999aa5396ea$var$GridSamplerInstance = /** @class */ function() {
    function GridSamplerInstance() {}
    /**
     * Sets the implementation of GridSampler used by the library. One global
     * instance is stored, which may sound problematic. But, the implementation provided
     * ought to be appropriate for the entire platform, and all uses of this library
     * in the whole lifetime of the JVM. For instance, an Android activity can swap in
     * an implementation that takes advantage of native platform libraries.
     *
     * @param newGridSampler The platform-specific object to install.
     */ GridSamplerInstance.setGridSampler = function(newGridSampler) {
        GridSamplerInstance.gridSampler = newGridSampler;
    };
    /**
     * @return the current implementation of GridSampler
     */ GridSamplerInstance.getInstance = function() {
        return GridSamplerInstance.gridSampler;
    };
    GridSamplerInstance.gridSampler = new (0, $2c2afef65eae91b4$export$2e2bcd8739ae039)();
    return GridSamplerInstance;
}();
var $6aeaa999aa5396ea$export$2e2bcd8739ae039 = $6aeaa999aa5396ea$var$GridSamplerInstance;



var $18d59afa05bdf445$export$baf26146a414f24a = /** @class */ function() {
    function Point(x, y) {
        this.x = x;
        this.y = y;
    }
    Point.prototype.toResultPoint = function() {
        return new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(this.getX(), this.getY());
    };
    Point.prototype.getX = function() {
        return this.x;
    };
    Point.prototype.getY = function() {
        return this.y;
    };
    return Point;
}();
/**
 * Encapsulates logic that can detect an Aztec Code in an image, even if the Aztec Code
 * is rotated or skewed, or partially obscured.
 *
 * @author David Olivier
 * @author Frank Yellin
 */ var $18d59afa05bdf445$var$Detector = /** @class */ function() {
    function Detector(image) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            0xee0,
            0x1dc,
            0x83b,
            0x707
        ]);
        this.image = image;
    }
    Detector.prototype.detect = function() {
        return this.detectMirror(false);
    };
    /**
     * Detects an Aztec Code in an image.
     *
     * @param isMirror if true, image is a mirror-image of original
     * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
     * @throws NotFoundException if no Aztec Code can be found
     */ Detector.prototype.detectMirror = function(isMirror) {
        // 1. Get the center of the aztec matrix
        var pCenter = this.getMatrixCenter();
        // 2. Get the center points of the four diagonal points just outside the bull's eye
        //  [topRight, bottomRight, bottomLeft, topLeft]
        var bullsEyeCorners = this.getBullsEyeCorners(pCenter);
        if (isMirror) {
            var temp = bullsEyeCorners[0];
            bullsEyeCorners[0] = bullsEyeCorners[2];
            bullsEyeCorners[2] = temp;
        }
        // 3. Get the size of the matrix and other parameters from the bull's eye
        this.extractParameters(bullsEyeCorners);
        // 4. Sample the grid
        var bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
        // 5. Get the corners of the matrix.
        var corners = this.getMatrixCornerPoints(bullsEyeCorners);
        return new (0, $9f90ac9a90d7e984$export$2e2bcd8739ae039)(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
    };
    /**
     * Extracts the number of data layers and data blocks from the layer around the bull's eye.
     *
     * @param bullsEyeCorners the array of bull's eye corners
     * @throws NotFoundException in case of too many errors or invalid parameters
     */ Detector.prototype.extractParameters = function(bullsEyeCorners) {
        if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) || !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var length = 2 * this.nbCenterLayers;
        // Get the bits around the bull's eye
        var sides = new Int32Array([
            this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
            this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
            this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
            this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length) // Top
        ]);
        // bullsEyeCorners[shift] is the corner of the bulls'eye that has three
        // orientation marks.
        // sides[shift] is the row/column that goes from the corner with three
        // orientation marks to the corner with two.
        this.shift = this.getRotation(sides, length);
        // Flatten the parameter bits into a single 28- or 40-bit long
        var parameterData = 0;
        for(var i = 0; i < 4; i++){
            var side = sides[(this.shift + i) % 4];
            if (this.compact) {
                // Each side of the form ..XXXXXXX. where Xs are parameter data
                parameterData <<= 7;
                parameterData += side >> 1 & 0x7F;
            } else {
                // Each side of the form ..XXXXX.XXXXX. where Xs are parameter data
                parameterData <<= 10;
                parameterData += (side >> 2 & 992) + (side >> 1 & 0x1F);
            }
        }
        // Corrects parameter data using RS.  Returns just the data portion
        // without the error correction.
        var correctedData = this.getCorrectedParameterData(parameterData, this.compact);
        if (this.compact) {
            // 8 bits:  2 bits layers and 6 bits data blocks
            this.nbLayers = (correctedData >> 6) + 1;
            this.nbDataBlocks = (correctedData & 0x3F) + 1;
        } else {
            // 16 bits:  5 bits layers and 11 bits data blocks
            this.nbLayers = (correctedData >> 11) + 1;
            this.nbDataBlocks = (correctedData & 0x7FF) + 1;
        }
    };
    Detector.prototype.getRotation = function(sides, length) {
        // In a normal pattern, we expect to See
        //   **    .*             D       A
        //   *      *
        //
        //   .      *
        //   ..    ..             C       B
        //
        // Grab the 3 bits from each of the sides the form the locator pattern and concatenate
        // into a 12-bit integer.  Start with the bit at A
        var cornerBits = 0;
        sides.forEach(function(side, idx, arr) {
            // XX......X where X's are orientation marks
            var t = (side >> length - 2 << 1) + (side & 1);
            cornerBits = (cornerBits << 3) + t;
        });
        // for (var side in sides) {
        //     // XX......X where X's are orientation marks
        //     var t = ((side >> (length - 2)) << 1) + (side & 1);
        //     cornerBits = (cornerBits << 3) + t;
        // }
        // Mov the bottom bit to the top, so that the three bits of the locator pattern at A are
        // together.  cornerBits is now:
        //  3 orientation bits at A || 3 orientation bits at B || ... || 3 orientation bits at D
        cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
        // The result shift indicates which element of BullsEyeCorners[] goes into the top-left
        // corner. Since the four rotation values have a Hamming distance of 8, we
        // can easily tolerate two errors.
        for(var shift = 0; shift < 4; shift++){
            if ((0, $902e90c40380930f$export$2e2bcd8739ae039).bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift]) <= 2) return shift;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    /**
     * Corrects the parameter bits using Reed-Solomon algorithm.
     *
     * @param parameterData parameter bits
     * @param compact true if this is a compact Aztec code
     * @throws NotFoundException if the array contains too many errors
     */ Detector.prototype.getCorrectedParameterData = function(parameterData, compact) {
        var numCodewords;
        var numDataCodewords;
        if (compact) {
            numCodewords = 7;
            numDataCodewords = 2;
        } else {
            numCodewords = 10;
            numDataCodewords = 4;
        }
        var numECCodewords = numCodewords - numDataCodewords;
        var parameterWords = new Int32Array(numCodewords);
        for(var i = numCodewords - 1; i >= 0; --i){
            parameterWords[i] = parameterData & 0xF;
            parameterData >>= 4;
        }
        try {
            var rsDecoder = new (0, $a1039736c6639077$export$2e2bcd8739ae039)((0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_PARAM);
            rsDecoder.decode(parameterWords, numECCodewords);
        } catch (ignored) {
            throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        }
        // Toss the error correction.  Just return the data as an integer
        var result = 0;
        for(var i = 0; i < numDataCodewords; i++)result = (result << 4) + parameterWords[i];
        return result;
    };
    /**
     * Finds the corners of a bull-eye centered on the passed point.
     * This returns the centers of the diagonal points just outside the bull's eye
     * Returns [topRight, bottomRight, bottomLeft, topLeft]
     *
     * @param pCenter Center point
     * @return The corners of the bull-eye
     * @throws NotFoundException If no valid bull-eye can be found
     */ Detector.prototype.getBullsEyeCorners = function(pCenter) {
        var pina = pCenter;
        var pinb = pCenter;
        var pinc = pCenter;
        var pind = pCenter;
        var color = true;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var pouta = this.getFirstDifferent(pina, color, 1, -1);
            var poutb = this.getFirstDifferent(pinb, color, 1, 1);
            var poutc = this.getFirstDifferent(pinc, color, -1, 1);
            var poutd = this.getFirstDifferent(pind, color, -1, -1);
            // d      a
            //
            // c      b
            if (this.nbCenterLayers > 2) {
                var q = this.distancePoint(poutd, pouta) * this.nbCenterLayers / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
                if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) break;
            }
            pina = pouta;
            pinb = poutb;
            pinc = poutc;
            pind = poutd;
            color = !color;
        }
        if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        this.compact = this.nbCenterLayers === 5;
        // Expand the square by .5 pixel in each direction so that we're on the border
        // between the white square and the black square
        var pinax = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(pina.getX() + 0.5, pina.getY() - 0.5);
        var pinbx = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(pinb.getX() + 0.5, pinb.getY() + 0.5);
        var pincx = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(pinc.getX() - 0.5, pinc.getY() + 0.5);
        var pindx = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(pind.getX() - 0.5, pind.getY() - 0.5);
        // Expand the square so that its corners are the centers of the points
        // just outside the bull's eye.
        return this.expandSquare([
            pinax,
            pinbx,
            pincx,
            pindx
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    };
    /**
     * Finds a candidate center point of an Aztec code from an image
     *
     * @return the center point
     */ Detector.prototype.getMatrixCenter = function() {
        var pointA;
        var pointB;
        var pointC;
        var pointD;
        // Get a white rectangle that can be the border of the matrix in center bull's eye or
        try {
            var cornerPoints = new (0, $dd96a8353b0eb50e$export$2e2bcd8739ae039)(this.image).detect();
            pointA = cornerPoints[0];
            pointB = cornerPoints[1];
            pointC = cornerPoints[2];
            pointD = cornerPoints[3];
        } catch (e) {
            // This exception can be in case the initial rectangle is white
            // In that case, surely in the bull's eye, we try to expand the rectangle.
            var cx_1 = this.image.getWidth() / 2;
            var cy_1 = this.image.getHeight() / 2;
            pointA = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx_1 + 7, cy_1 - 7), false, 1, -1).toResultPoint();
            pointB = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx_1 + 7, cy_1 + 7), false, 1, 1).toResultPoint();
            pointC = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx_1 - 7, cy_1 + 7), false, -1, 1).toResultPoint();
            pointD = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx_1 - 7, cy_1 - 7), false, -1, -1).toResultPoint();
        }
        // Compute the center of the rectangle
        var cx = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
        var cy = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
        // Redetermine the white rectangle starting from previously computed center.
        // This will ensure that we end up with a white rectangle in center bull's eye
        // in order to compute a more accurate center.
        try {
            var cornerPoints = new (0, $dd96a8353b0eb50e$export$2e2bcd8739ae039)(this.image, 15, cx, cy).detect();
            pointA = cornerPoints[0];
            pointB = cornerPoints[1];
            pointC = cornerPoints[2];
            pointD = cornerPoints[3];
        } catch (e) {
            // This exception can be in case the initial rectangle is white
            // In that case we try to expand the rectangle.
            pointA = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx + 7, cy - 7), false, 1, -1).toResultPoint();
            pointB = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx + 7, cy + 7), false, 1, 1).toResultPoint();
            pointC = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx - 7, cy + 7), false, -1, 1).toResultPoint();
            pointD = this.getFirstDifferent(new $18d59afa05bdf445$export$baf26146a414f24a(cx - 7, cy - 7), false, -1, -1).toResultPoint();
        }
        // Recompute the center of the rectangle
        cx = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
        cy = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
        return new $18d59afa05bdf445$export$baf26146a414f24a(cx, cy);
    };
    /**
     * Gets the Aztec code corners from the bull's eye corners and the parameters.
     *
     * @param bullsEyeCorners the array of bull's eye corners
     * @return the array of aztec code corners
     */ Detector.prototype.getMatrixCornerPoints = function(bullsEyeCorners) {
        return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
    };
    /**
     * Creates a BitMatrix by sampling the provided image.
     * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
     * diagonal just outside the bull's eye.
     */ Detector.prototype.sampleGrid = function(image, topLeft, topRight, bottomRight, bottomLeft) {
        var sampler = (0, $6aeaa999aa5396ea$export$2e2bcd8739ae039).getInstance();
        var dimension = this.getDimension();
        var low = dimension / 2 - this.nbCenterLayers;
        var high = dimension / 2 + this.nbCenterLayers;
        return sampler.sampleGrid(image, dimension, dimension, low, low, high, low, high, high, low, high, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
    };
    /**
     * Samples a line.
     *
     * @param p1   start point (inclusive)
     * @param p2   end point (exclusive)
     * @param size number of bits
     * @return the array of bits as an int (first bit is high-order bit of result)
     */ Detector.prototype.sampleLine = function(p1, p2, size) {
        var result = 0;
        var d = this.distanceResultPoint(p1, p2);
        var moduleSize = d / size;
        var px = p1.getX();
        var py = p1.getY();
        var dx = moduleSize * (p2.getX() - p1.getX()) / d;
        var dy = moduleSize * (p2.getY() - p1.getY()) / d;
        for(var i = 0; i < size; i++)if (this.image.get((0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(px + i * dx), (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(py + i * dy))) result |= 1 << size - i - 1;
        return result;
    };
    /**
     * @return true if the border of the rectangle passed in parameter is compound of white points only
     *         or black points only
     */ Detector.prototype.isWhiteOrBlackRectangle = function(p1, p2, p3, p4) {
        var corr = 3;
        p1 = new $18d59afa05bdf445$export$baf26146a414f24a(p1.getX() - corr, p1.getY() + corr);
        p2 = new $18d59afa05bdf445$export$baf26146a414f24a(p2.getX() - corr, p2.getY() - corr);
        p3 = new $18d59afa05bdf445$export$baf26146a414f24a(p3.getX() + corr, p3.getY() - corr);
        p4 = new $18d59afa05bdf445$export$baf26146a414f24a(p4.getX() + corr, p4.getY() + corr);
        var cInit = this.getColor(p4, p1);
        if (cInit === 0) return false;
        var c = this.getColor(p1, p2);
        if (c !== cInit) return false;
        c = this.getColor(p2, p3);
        if (c !== cInit) return false;
        c = this.getColor(p3, p4);
        return c === cInit;
    };
    /**
     * Gets the color of a segment
     *
     * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
     */ Detector.prototype.getColor = function(p1, p2) {
        var d = this.distancePoint(p1, p2);
        var dx = (p2.getX() - p1.getX()) / d;
        var dy = (p2.getY() - p1.getY()) / d;
        var error = 0;
        var px = p1.getX();
        var py = p1.getY();
        var colorModel = this.image.get(p1.getX(), p1.getY());
        var iMax = Math.ceil(d);
        for(var i = 0; i < iMax; i++){
            px += dx;
            py += dy;
            if (this.image.get((0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(px), (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(py)) !== colorModel) error++;
        }
        var errRatio = error / d;
        if (errRatio > 0.1 && errRatio < 0.9) return 0;
        return errRatio <= 0.1 === colorModel ? 1 : -1;
    };
    /**
     * Gets the coordinate of the first point with a different color in the given direction
     */ Detector.prototype.getFirstDifferent = function(init, color, dx, dy) {
        var x = init.getX() + dx;
        var y = init.getY() + dy;
        while(this.isValid(x, y) && this.image.get(x, y) === color){
            x += dx;
            y += dy;
        }
        x -= dx;
        y -= dy;
        while(this.isValid(x, y) && this.image.get(x, y) === color)x += dx;
        x -= dx;
        while(this.isValid(x, y) && this.image.get(x, y) === color)y += dy;
        y -= dy;
        return new $18d59afa05bdf445$export$baf26146a414f24a(x, y);
    };
    /**
     * Expand the square represented by the corner points by pushing out equally in all directions
     *
     * @param cornerPoints the corners of the square, which has the bull's eye at its center
     * @param oldSide the original length of the side of the square in the target bit matrix
     * @param newSide the new length of the size of the square in the target bit matrix
     * @return the corners of the expanded square
     */ Detector.prototype.expandSquare = function(cornerPoints, oldSide, newSide) {
        var ratio = newSide / (2.0 * oldSide);
        var dx = cornerPoints[0].getX() - cornerPoints[2].getX();
        var dy = cornerPoints[0].getY() - cornerPoints[2].getY();
        var centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2.0;
        var centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2.0;
        var result0 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(centerx + ratio * dx, centery + ratio * dy);
        var result2 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(centerx - ratio * dx, centery - ratio * dy);
        dx = cornerPoints[1].getX() - cornerPoints[3].getX();
        dy = cornerPoints[1].getY() - cornerPoints[3].getY();
        centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2.0;
        centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2.0;
        var result1 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(centerx + ratio * dx, centery + ratio * dy);
        var result3 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(centerx - ratio * dx, centery - ratio * dy);
        var results = [
            result0,
            result1,
            result2,
            result3
        ];
        return results;
    };
    Detector.prototype.isValid = function(x, y) {
        return x >= 0 && x < this.image.getWidth() && y > 0 && y < this.image.getHeight();
    };
    Detector.prototype.isValidPoint = function(point) {
        var x = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(point.getX());
        var y = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round(point.getY());
        return this.isValid(x, y);
    };
    Detector.prototype.distancePoint = function(a, b) {
        return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).distance(a.getX(), a.getY(), b.getX(), b.getY());
    };
    Detector.prototype.distanceResultPoint = function(a, b) {
        return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).distance(a.getX(), a.getY(), b.getX(), b.getY());
    };
    Detector.prototype.getDimension = function() {
        if (this.compact) return 4 * this.nbLayers + 11;
        if (this.nbLayers <= 4) return 4 * this.nbLayers + 15;
        return 4 * this.nbLayers + 2 * ((0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    };
    return Detector;
}();
var $18d59afa05bdf445$export$2e2bcd8739ae039 = $18d59afa05bdf445$var$Detector;


// import java.util.List;
// import java.util.Map;
/**
 * This implementation can detect and decode Aztec codes in an image.
 *
 * @author David Olivier
 */ var $b5a91da25a9d81df$var$AztecReader = /** @class */ function() {
    function AztecReader() {}
    /**
     * Locates and decodes a Data Matrix code in an image.
     *
     * @return a String representing the content encoded by the Data Matrix code
     * @throws NotFoundException if a Data Matrix code cannot be found
     * @throws FormatException if a Data Matrix code cannot be decoded
     */ AztecReader.prototype.decode = function(image, hints) {
        if (hints === void 0) hints = null;
        var exception = null;
        var detector = new (0, $18d59afa05bdf445$export$2e2bcd8739ae039)(image.getBlackMatrix());
        var points = null;
        var decoderResult = null;
        try {
            var detectorResult = detector.detectMirror(false);
            points = detectorResult.getPoints();
            this.reportFoundResultPoints(hints, points);
            decoderResult = new (0, $47ecffee5020b05a$export$2e2bcd8739ae039)().decode(detectorResult);
        } catch (e) {
            exception = e;
        }
        if (decoderResult == null) try {
            var detectorResult = detector.detectMirror(true);
            points = detectorResult.getPoints();
            this.reportFoundResultPoints(hints, points);
            decoderResult = new (0, $47ecffee5020b05a$export$2e2bcd8739ae039)().decode(detectorResult);
        } catch (e) {
            if (exception != null) throw exception;
            throw e;
        }
        var result = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).AZTEC, (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).currentTimeMillis());
        var byteSegments = decoderResult.getByteSegments();
        if (byteSegments != null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).BYTE_SEGMENTS, byteSegments);
        var ecLevel = decoderResult.getECLevel();
        if (ecLevel != null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ERROR_CORRECTION_LEVEL, ecLevel);
        return result;
    };
    AztecReader.prototype.reportFoundResultPoints = function(hints, points) {
        if (hints != null) {
            var rpcb_1 = hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).NEED_RESULT_POINT_CALLBACK);
            if (rpcb_1 != null) points.forEach(function(point, idx, arr) {
                rpcb_1.foundPossibleResultPoint(point);
            });
        }
    };
    // @Override
    AztecReader.prototype.reset = function() {
    // do nothing
    };
    return AztecReader;
}();
var $b5a91da25a9d81df$export$2e2bcd8739ae039 = $b5a91da25a9d81df$var$AztecReader;


var $481b6a474e75d0c4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Aztec Code reader to use from browser.
 *
 * @class BrowserAztecCodeReader
 * @extends {BrowserCodeReader}
 */ var $481b6a474e75d0c4$export$f01bcae3c23f676f = /** @class */ function(_super) {
    $481b6a474e75d0c4$var$__extends(BrowserAztecCodeReader, _super);
    /**
     * Creates an instance of BrowserAztecCodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     *
     * @memberOf BrowserAztecCodeReader
     */ function BrowserAztecCodeReader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $b5a91da25a9d81df$export$2e2bcd8739ae039)(), timeBetweenScansMillis) || this;
    }
    return BrowserAztecCodeReader;
}((0, $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607));



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 






/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/**
 * Encapsulates functionality and implementation that is common to all families
 * of one-dimensional barcodes.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 */ var $2907db4645bc034b$var$OneDReader = /** @class */ function() {
    function OneDReader() {}
    /*
    @Override
    public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
      return decode(image, null);
    }
    */ // Note that we don't try rotation without the try harder flag, even if rotation was supported.
    // @Override
    OneDReader.prototype.decode = function(image, hints) {
        try {
            return this.doDecode(image, hints);
        } catch (nfe) {
            var tryHarder = hints && hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).TRY_HARDER) === true;
            if (tryHarder && image.isRotateSupported()) {
                var rotatedImage = image.rotateCounterClockwise();
                var result = this.doDecode(rotatedImage, hints);
                // Record that we found it rotated 90 degrees CCW / 270 degrees CW
                var metadata = result.getResultMetadata();
                var orientation_1 = 270;
                if (metadata !== null && metadata.get((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ORIENTATION) === true) // But if we found it reversed in doDecode(), add in that result here:
                orientation_1 = orientation_1 + metadata.get((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ORIENTATION) % 360;
                result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ORIENTATION, orientation_1);
                // Update result points
                var points = result.getResultPoints();
                if (points !== null) {
                    var height = rotatedImage.getHeight();
                    for(var i = 0; i < points.length; i++)points[i] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(height - points[i].getY() - 1, points[i].getX());
                }
                return result;
            } else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        }
    };
    // @Override
    OneDReader.prototype.reset = function() {
    // do nothing
    };
    /**
     * We're going to examine rows from the middle outward, searching alternately above and below the
     * middle, and farther out each time. rowStep is the number of rows between each successive
     * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
     * middle + rowStep, then middle - (2 * rowStep), etc.
     * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
     * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
     * image if "trying harder".
     *
     * @param image The image to decode
     * @param hints Any hints that were requested
     * @return The contents of the decoded barcode
     * @throws NotFoundException Any spontaneous errors which occur
     */ OneDReader.prototype.doDecode = function(image, hints) {
        var width = image.getWidth();
        var height = image.getHeight();
        var row = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(width);
        var tryHarder = hints && hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).TRY_HARDER) === true;
        var rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
        var maxLines;
        if (tryHarder) maxLines = height; // Look at the whole image, not just the center
        else maxLines = 15; // 15 rows spaced 1/32 apart is roughly the middle half of the image
        var middle = Math.trunc(height / 2);
        for(var x = 0; x < maxLines; x++){
            // Scanning from the middle out. Determine which row we're looking at next:
            var rowStepsAboveOrBelow = Math.trunc((x + 1) / 2);
            var isAbove = (x & 0x01) === 0; // i.e. is x even?
            var rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
            if (rowNumber < 0 || rowNumber >= height) break;
            // Estimate black point for this row and load it:
            try {
                row = image.getBlackRow(rowNumber, row);
            } catch (ignored) {
                continue;
            }
            var _loop_1 = function(attempt) {
                if (attempt === 1) {
                    row.reverse(); // reverse the row and continue
                    // This means we will only ever draw result points *once* in the life of this method
                    // since we want to avoid drawing the wrong points after flipping the row, and,
                    // don't want to clutter with noise from every single row scan -- just the scans
                    // that start on the center line.
                    if (hints && hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).NEED_RESULT_POINT_CALLBACK) === true) {
                        var newHints_1 = new Map();
                        hints.forEach(function(hint, key) {
                            return newHints_1.set(key, hint);
                        });
                        newHints_1.delete((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).NEED_RESULT_POINT_CALLBACK);
                        hints = newHints_1;
                    }
                }
                try {
                    // Look for a barcode
                    var result = this_1.decodeRow(rowNumber, row, hints);
                    // We found our barcode
                    if (attempt === 1) {
                        // But it was upside down, so note that
                        result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ORIENTATION, 180);
                        // And remember to flip the result points horizontally.
                        var points = result.getResultPoints();
                        if (points !== null) {
                            points[0] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(width - points[0].getX() - 1, points[0].getY());
                            points[1] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(width - points[1].getX() - 1, points[1].getY());
                        }
                    }
                    return {
                        value: result
                    };
                } catch (re) {
                // continue -- just couldn't decode this row
                }
            };
            var this_1 = this;
            // While we have the image data in a BitArray, it's fairly cheap to reverse it in place to
            // handle decoding upside down barcodes.
            for(var attempt = 0; attempt < 2; attempt++){
                var state_1 = _loop_1(attempt);
                if (typeof state_1 === "object") return state_1.value;
            }
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    /**
     * Records the size of successive runs of white and black pixels in a row, starting at a given point.
     * The values are recorded in the given array, and the number of runs recorded is equal to the size
     * of the array. If the row starts on a white pixel at the given start point, then the first count
     * recorded is the run of white pixels starting from that point; likewise it is the count of a run
     * of black pixels if the row begin on a black pixels at that point.
     *
     * @param row row to count from
     * @param start offset into row to start at
     * @param counters array into which to record counts
     * @throws NotFoundException if counters cannot be filled entirely from row before running out
     *  of pixels
     */ OneDReader.recordPattern = function(row, start, counters) {
        var numCounters = counters.length;
        for(var index = 0; index < numCounters; index++)counters[index] = 0;
        var end = row.getSize();
        if (start >= end) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var isWhite = !row.get(start);
        var counterPosition = 0;
        var i = start;
        while(i < end){
            if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (++counterPosition === numCounters) break;
                else {
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            i++;
        }
        // If we read fully the last section of pixels and filled up our counters -- or filled
        // the last counter but ran off the side of the image, OK. Otherwise, a problem.
        if (!(counterPosition === numCounters || counterPosition === numCounters - 1 && i === end)) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    OneDReader.recordPatternInReverse = function(row, start, counters) {
        // This could be more efficient I guess
        var numTransitionsLeft = counters.length;
        var last = row.get(start);
        while(start > 0 && numTransitionsLeft >= 0)if (row.get(--start) !== last) {
            numTransitionsLeft--;
            last = !last;
        }
        if (numTransitionsLeft >= 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        OneDReader.recordPattern(row, start + 1, counters);
    };
    /**
     * Determines how closely a set of observed counts of runs of black/white values matches a given
     * target pattern. This is reported as the ratio of the total variance from the expected pattern
     * proportions across all pattern elements, to the length of the pattern.
     *
     * @param counters observed counters
     * @param pattern expected pattern
     * @param maxIndividualVariance The most any counter can differ before we give up
     * @return ratio of total variance between counters and pattern compared to total pattern size
     */ OneDReader.patternMatchVariance = function(counters, pattern, maxIndividualVariance) {
        var numCounters = counters.length;
        var total = 0;
        var patternLength = 0;
        for(var i = 0; i < numCounters; i++){
            total += counters[i];
            patternLength += pattern[i];
        }
        if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this is too small
        // to reliably match, so fail:
        return Number.POSITIVE_INFINITY;
        var unitBarWidth = total / patternLength;
        maxIndividualVariance *= unitBarWidth;
        var totalVariance = 0.0;
        for(var x = 0; x < numCounters; x++){
            var counter = counters[x];
            var scaledPattern = pattern[x] * unitBarWidth;
            var variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
            if (variance > maxIndividualVariance) return Number.POSITIVE_INFINITY;
            totalVariance += variance;
        }
        return totalVariance / total;
    };
    return OneDReader;
}();
var $2907db4645bc034b$export$2e2bcd8739ae039 = $2907db4645bc034b$var$OneDReader;


var $af87434495d688e4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Decodes Code 128 barcodes.</p>
 *
 * @author Sean Owen
 */ var $af87434495d688e4$var$Code128Reader = /** @class */ function(_super) {
    $af87434495d688e4$var$__extends(Code128Reader, _super);
    function Code128Reader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Code128Reader.findStartPattern = function(row) {
        var width = row.getSize();
        var rowOffset = row.getNextSet(0);
        var counterPosition = 0;
        var counters = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        var patternStart = rowOffset;
        var isWhite = false;
        var patternLength = 6;
        for(var i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                var bestVariance = Code128Reader.MAX_AVG_VARIANCE;
                var bestMatch = -1;
                for(var startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++){
                    var variance = (0, $2907db4645bc034b$export$2e2bcd8739ae039).patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                    if (variance < bestVariance) {
                        bestVariance = variance;
                        bestMatch = startCode;
                    }
                }
                // Look for whitespace before start pattern, >= 50% of width of start pattern
                if (bestMatch >= 0 && row.isRange(Math.max(0, patternStart - (i - patternStart) / 2), patternStart, false)) return Int32Array.from([
                    patternStart,
                    i,
                    bestMatch
                ]);
                patternStart += counters[0] + counters[1];
                counters = counters.slice(2, counters.length - 1);
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    Code128Reader.decodeCode = function(row, counters, rowOffset) {
        (0, $2907db4645bc034b$export$2e2bcd8739ae039).recordPattern(row, rowOffset, counters);
        var bestVariance = Code128Reader.MAX_AVG_VARIANCE; // worst variance we'll accept
        var bestMatch = -1;
        for(var d = 0; d < Code128Reader.CODE_PATTERNS.length; d++){
            var pattern = Code128Reader.CODE_PATTERNS[d];
            var variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
            if (variance < bestVariance) {
                bestVariance = variance;
                bestMatch = d;
            }
        }
        // TODO We're overlooking the fact that the STOP pattern has 7 values, not 6.
        if (bestMatch >= 0) return bestMatch;
        else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    Code128Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var convertFNC1 = hints && hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).ASSUME_GS1) === true;
        var startPatternInfo = Code128Reader.findStartPattern(row);
        var startCode = startPatternInfo[2];
        var currentRawCodesIndex = 0;
        var rawCodes = new Uint8Array(20);
        rawCodes[currentRawCodesIndex++] = startCode;
        var codeSet;
        switch(startCode){
            case Code128Reader.CODE_START_A:
                codeSet = Code128Reader.CODE_CODE_A;
                break;
            case Code128Reader.CODE_START_B:
                codeSet = Code128Reader.CODE_CODE_B;
                break;
            case Code128Reader.CODE_START_C:
                codeSet = Code128Reader.CODE_CODE_C;
                break;
            default:
                throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        }
        var done = false;
        var isNextShifted = false;
        var result = "";
        var lastStart = startPatternInfo[0];
        var nextStart = startPatternInfo[1];
        var counters = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        var lastCode = 0;
        var code = 0;
        var checksumTotal = startCode;
        var multiplier = 0;
        var lastCharacterWasPrintable = true;
        var upperMode = false;
        var shiftUpperMode = false;
        while(!done){
            var unshift = isNextShifted;
            isNextShifted = false;
            // Save off last code
            lastCode = code;
            // Decode another code from image
            code = Code128Reader.decodeCode(row, counters, nextStart);
            rawCodes[currentRawCodesIndex++] = code;
            // Remember whether the last code was printable or not (excluding CODE_STOP)
            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = true;
            // Add to checksum computation (if not CODE_STOP of course)
            if (code !== Code128Reader.CODE_STOP) {
                multiplier++;
                checksumTotal += multiplier * code;
            }
            // Advance to where the next code will to start
            lastStart = nextStart;
            nextStart += counters.reduce(function(previous, current) {
                return previous + current;
            }, 0);
            // Take care of illegal start codes
            switch(code){
                case Code128Reader.CODE_START_A:
                case Code128Reader.CODE_START_B:
                case Code128Reader.CODE_START_C:
                    throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            }
            switch(codeSet){
                case Code128Reader.CODE_CODE_A:
                    if (code < 64) {
                        if (shiftUpperMode === upperMode) result += String.fromCharCode(" ".charCodeAt(0) + code);
                        else result += String.fromCharCode(" ".charCodeAt(0) + code + 128);
                        shiftUpperMode = false;
                    } else if (code < 96) {
                        if (shiftUpperMode === upperMode) result += String.fromCharCode(code - 64);
                        else result += String.fromCharCode(code + 64);
                        shiftUpperMode = false;
                    } else {
                        // Don't let CODE_STOP, which always appears, affect whether whether we think the last
                        // code was printable or not.
                        if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                        switch(code){
                            case Code128Reader.CODE_FNC_1:
                                if (convertFNC1) {
                                    if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                    // is FNC1 then this is GS1-128. We add the symbology identifier.
                                    result += "]C1";
                                    else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                    result += String.fromCharCode(29);
                                }
                                break;
                            case Code128Reader.CODE_FNC_2:
                            case Code128Reader.CODE_FNC_3:
                                break;
                            case Code128Reader.CODE_FNC_4_A:
                                if (!upperMode && shiftUpperMode) {
                                    upperMode = true;
                                    shiftUpperMode = false;
                                } else if (upperMode && shiftUpperMode) {
                                    upperMode = false;
                                    shiftUpperMode = false;
                                } else shiftUpperMode = true;
                                break;
                            case Code128Reader.CODE_SHIFT:
                                isNextShifted = true;
                                codeSet = Code128Reader.CODE_CODE_B;
                                break;
                            case Code128Reader.CODE_CODE_B:
                                codeSet = Code128Reader.CODE_CODE_B;
                                break;
                            case Code128Reader.CODE_CODE_C:
                                codeSet = Code128Reader.CODE_CODE_C;
                                break;
                            case Code128Reader.CODE_STOP:
                                done = true;
                                break;
                        }
                    }
                    break;
                case Code128Reader.CODE_CODE_B:
                    if (code < 96) {
                        if (shiftUpperMode === upperMode) result += String.fromCharCode(" ".charCodeAt(0) + code);
                        else result += String.fromCharCode(" ".charCodeAt(0) + code + 128);
                        shiftUpperMode = false;
                    } else {
                        if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                        switch(code){
                            case Code128Reader.CODE_FNC_1:
                                if (convertFNC1) {
                                    if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                    // is FNC1 then this is GS1-128. We add the symbology identifier.
                                    result += "]C1";
                                    else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                    result += String.fromCharCode(29);
                                }
                                break;
                            case Code128Reader.CODE_FNC_2:
                            case Code128Reader.CODE_FNC_3:
                                break;
                            case Code128Reader.CODE_FNC_4_B:
                                if (!upperMode && shiftUpperMode) {
                                    upperMode = true;
                                    shiftUpperMode = false;
                                } else if (upperMode && shiftUpperMode) {
                                    upperMode = false;
                                    shiftUpperMode = false;
                                } else shiftUpperMode = true;
                                break;
                            case Code128Reader.CODE_SHIFT:
                                isNextShifted = true;
                                codeSet = Code128Reader.CODE_CODE_A;
                                break;
                            case Code128Reader.CODE_CODE_A:
                                codeSet = Code128Reader.CODE_CODE_A;
                                break;
                            case Code128Reader.CODE_CODE_C:
                                codeSet = Code128Reader.CODE_CODE_C;
                                break;
                            case Code128Reader.CODE_STOP:
                                done = true;
                                break;
                        }
                    }
                    break;
                case Code128Reader.CODE_CODE_C:
                    if (code < 100) {
                        if (code < 10) result += "0";
                        result += code;
                    } else {
                        if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                        switch(code){
                            case Code128Reader.CODE_FNC_1:
                                if (convertFNC1) {
                                    if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                    // is FNC1 then this is GS1-128. We add the symbology identifier.
                                    result += "]C1";
                                    else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                    result += String.fromCharCode(29);
                                }
                                break;
                            case Code128Reader.CODE_CODE_A:
                                codeSet = Code128Reader.CODE_CODE_A;
                                break;
                            case Code128Reader.CODE_CODE_B:
                                codeSet = Code128Reader.CODE_CODE_B;
                                break;
                            case Code128Reader.CODE_STOP:
                                done = true;
                                break;
                        }
                    }
                    break;
            }
            // Unshift back to another code set if we were shifted
            if (unshift) codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
        }
        var lastPatternSize = nextStart - lastStart;
        // Check for ample whitespace following pattern, but, to do this we first need to remember that
        // we fudged decoding CODE_STOP since it actually has 7 bars, not 6. There is a black bar left
        // to read off. Would be slightly better to properly read. Here we just skip it:
        nextStart = row.getNextUnset(nextStart);
        if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        // Pull out from sum the value of the penultimate check code
        checksumTotal -= multiplier * lastCode;
        // lastCode is the checksum then:
        if (checksumTotal % 103 !== lastCode) throw new (0, $e19cfb3b440de53d$export$2e2bcd8739ae039)();
        // Need to pull out the check digits from string
        var resultLength = result.length;
        if (resultLength === 0) // false positive
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        // Only bother if the result had at least one character, and if the checksum digit happened to
        // be a printable character. If it was just interpreted as a control code, nothing to remove.
        if (resultLength > 0 && lastCharacterWasPrintable) {
            if (codeSet === Code128Reader.CODE_CODE_C) result = result.substring(0, resultLength - 2);
            else result = result.substring(0, resultLength - 1);
        }
        var left = (startPatternInfo[1] + startPatternInfo[0]) / 2.0;
        var right = lastStart + lastPatternSize / 2.0;
        var rawCodesSize = rawCodes.length;
        var rawBytes = new Uint8Array(rawCodesSize);
        for(var i = 0; i < rawCodesSize; i++)rawBytes[i] = rawCodes[i];
        var points = [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(left, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(right, rowNumber)
        ];
        return new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(result, rawBytes, 0, points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_128, new Date().getTime());
    };
    Code128Reader.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;
    return Code128Reader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $af87434495d688e4$export$2e2bcd8739ae039 = $af87434495d688e4$var$Code128Reader;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 






var $80bc94e3cee10a11$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $80bc94e3cee10a11$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Decodes Code 39 barcodes. Supports "Full ASCII Code 39" if USE_CODE_39_EXTENDED_MODE is set.</p>
 *
 * @author Sean Owen
 * @see Code93Reader
 */ var $80bc94e3cee10a11$var$Code39Reader = /** @class */ function(_super) {
    $80bc94e3cee10a11$var$__extends(Code39Reader, _super);
    /**
     * Creates a reader that assumes all encoded data is data, and does not treat the final
     * character as a check digit. It will not decoded "extended Code 39" sequences.
     */ // public Code39Reader() {
    //   this(false);
    // }
    /**
     * Creates a reader that can be configured to check the last character as a check digit.
     * It will not decoded "extended Code 39" sequences.
     *
     * @param usingCheckDigit if true, treat the last data character as a check digit, not
     * data, and verify that the checksum passes.
     */ // public Code39Reader(boolean usingCheckDigit) {
    //   this(usingCheckDigit, false);
    // }
    /**
     * Creates a reader that can be configured to check the last character as a check digit,
     * or optionally attempt to decode "extended Code 39" sequences that are used to encode
     * the full ASCII character set.
     *
     * @param usingCheckDigit if true, treat the last data character as a check digit, not
     * data, and verify that the checksum passes.
     * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
     * text.
     */ function Code39Reader(usingCheckDigit, extendedMode) {
        if (usingCheckDigit === void 0) usingCheckDigit = false;
        if (extendedMode === void 0) extendedMode = false;
        var _this = _super.call(this) || this;
        _this.usingCheckDigit = usingCheckDigit;
        _this.extendedMode = extendedMode;
        _this.decodeRowResult = "";
        _this.counters = new Int32Array(9);
        return _this;
    }
    Code39Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a, e_2, _b;
        var theCounters = this.counters;
        theCounters.fill(0);
        this.decodeRowResult = "";
        var start = Code39Reader.findAsteriskPattern(row, theCounters);
        // Read off white space
        var nextStart = row.getNextSet(start[1]);
        var end = row.getSize();
        var decodedChar;
        var lastStart;
        do {
            Code39Reader.recordPattern(row, nextStart, theCounters);
            var pattern = Code39Reader.toNarrowWidePattern(theCounters);
            if (pattern < 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            decodedChar = Code39Reader.patternToChar(pattern);
            this.decodeRowResult += decodedChar;
            lastStart = nextStart;
            try {
                for(var theCounters_1 = (e_1 = void 0, $80bc94e3cee10a11$var$__values(theCounters)), theCounters_1_1 = theCounters_1.next(); !theCounters_1_1.done; theCounters_1_1 = theCounters_1.next()){
                    var counter = theCounters_1_1.value;
                    nextStart += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (theCounters_1_1 && !theCounters_1_1.done && (_a = theCounters_1.return)) _a.call(theCounters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Read off white space
            nextStart = row.getNextSet(nextStart);
        }while (decodedChar !== "*");
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
        // Look for whitespace after pattern:
        var lastPatternSize = 0;
        try {
            for(var theCounters_2 = $80bc94e3cee10a11$var$__values(theCounters), theCounters_2_1 = theCounters_2.next(); !theCounters_2_1.done; theCounters_2_1 = theCounters_2.next()){
                var counter = theCounters_2_1.value;
                lastPatternSize += counter;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (theCounters_2_1 && !theCounters_2_1.done && (_b = theCounters_2.return)) _b.call(theCounters_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
        // If 50% of last pattern size, following last pattern, is not whitespace, fail
        // (but if it's whitespace to the very end of the image, that's OK)
        if (nextStart !== end && whiteSpaceAfterEnd * 2 < lastPatternSize) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (this.usingCheckDigit) {
            var max = this.decodeRowResult.length - 1;
            var total = 0;
            for(var i = 0; i < max; i++)total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i));
            if (this.decodeRowResult.charAt(max) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) throw new (0, $e19cfb3b440de53d$export$2e2bcd8739ae039)();
            this.decodeRowResult = this.decodeRowResult.substring(0, max);
        }
        if (this.decodeRowResult.length === 0) // false positive
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var resultString;
        if (this.extendedMode) resultString = Code39Reader.decodeExtended(this.decodeRowResult);
        else resultString = this.decodeRowResult;
        var left = (start[1] + start[0]) / 2.0;
        var right = lastStart + lastPatternSize / 2.0;
        return new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultString, null, 0, [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(left, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(right, rowNumber)
        ], (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_39, new Date().getTime());
    };
    Code39Reader.findAsteriskPattern = function(row, counters) {
        var width = row.getSize();
        var rowOffset = row.getNextSet(0);
        var counterPosition = 0;
        var patternStart = rowOffset;
        var isWhite = false;
        var patternLength = counters.length;
        for(var i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                // Look for whitespace before start pattern, >= 50% of width of start pattern
                if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING && row.isRange(Math.max(0, patternStart - Math.floor((i - patternStart) / 2)), patternStart, false)) return [
                    patternStart,
                    i
                ];
                patternStart += counters[0] + counters[1];
                counters.copyWithin(0, 2, 2 + counterPosition - 1);
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
    // per image when using some of our blackbox images.
    Code39Reader.toNarrowWidePattern = function(counters) {
        var e_3, _a;
        var numCounters = counters.length;
        var maxNarrowCounter = 0;
        var wideCounters;
        do {
            var minCounter = 0x7fffffff;
            try {
                for(var counters_1 = (e_3 = void 0, $80bc94e3cee10a11$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    if (counter < minCounter && counter > maxNarrowCounter) minCounter = counter;
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            maxNarrowCounter = minCounter;
            wideCounters = 0;
            var totalWideCountersWidth = 0;
            var pattern = 0;
            for(var i = 0; i < numCounters; i++){
                var counter = counters[i];
                if (counter > maxNarrowCounter) {
                    pattern |= 1 << numCounters - 1 - i;
                    wideCounters++;
                    totalWideCountersWidth += counter;
                }
            }
            if (wideCounters === 3) {
                // Found 3 wide counters, but are they close enough in width?
                // We can perform a cheap, conservative check to see if any individual
                // counter is more than 1.5 times the average:
                for(var i = 0; i < numCounters && wideCounters > 0; i++){
                    var counter = counters[i];
                    if (counter > maxNarrowCounter) {
                        wideCounters--;
                        // totalWideCountersWidth = 3 * average, so this checks if counter >= 3/2 * average
                        if (counter * 2 >= totalWideCountersWidth) return -1;
                    }
                }
                return pattern;
            }
        }while (wideCounters > 3);
        return -1;
    };
    Code39Reader.patternToChar = function(pattern) {
        for(var i = 0; i < Code39Reader.CHARACTER_ENCODINGS.length; i++){
            if (Code39Reader.CHARACTER_ENCODINGS[i] === pattern) return Code39Reader.ALPHABET_STRING.charAt(i);
        }
        if (pattern === Code39Reader.ASTERISK_ENCODING) return "*";
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    Code39Reader.decodeExtended = function(encoded) {
        var length = encoded.length;
        var decoded = "";
        for(var i = 0; i < length; i++){
            var c = encoded.charAt(i);
            if (c === "+" || c === "$" || c === "%" || c === "/") {
                var next = encoded.charAt(i + 1);
                var decodedChar = "\x00";
                switch(c){
                    case "+":
                        // +A to +Z map to a to z
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case "$":
                        // $A to $Z map to control codes SH to SB
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case "%":
                        // %A to %E map to control codes ESC to US
                        if (next >= "A" && next <= "E") decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                        else if (next >= "F" && next <= "J") decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                        else if (next >= "K" && next <= "O") decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                        else if (next >= "P" && next <= "T") decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                        else if (next === "U") decodedChar = "\x00";
                        else if (next === "V") decodedChar = "@";
                        else if (next === "W") decodedChar = "`";
                        else if (next === "X" || next === "Y" || next === "Z") decodedChar = "\x7f";
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case "/":
                        // /A to /O map to ! to , and /Z maps to :
                        if (next >= "A" && next <= "O") decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                        else if (next === "Z") decodedChar = ":";
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                }
                decoded += decodedChar;
                // bump up i again since we read two characters
                i++;
            } else decoded += c;
        }
        return decoded;
    };
    Code39Reader.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%";
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow,
     * with 1s representing "wide" and 0s representing narrow.
     */ Code39Reader.CHARACTER_ENCODINGS = [
        0x034,
        0x121,
        0x061,
        0x160,
        0x031,
        0x130,
        0x070,
        0x025,
        0x124,
        0x064,
        0x109,
        0x049,
        0x148,
        0x019,
        0x118,
        0x058,
        0x00D,
        0x10C,
        0x04C,
        0x01C,
        0x103,
        0x043,
        0x142,
        0x013,
        0x112,
        0x052,
        0x007,
        0x106,
        0x046,
        0x016,
        0x181,
        0x0C1,
        0x1C0,
        0x091,
        0x190,
        0x0D0,
        0x085,
        0x184,
        0x0C4,
        0x0A8,
        0x0A2,
        0x08A,
        0x02A // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 0x094;
    return Code39Reader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $80bc94e3cee10a11$export$2e2bcd8739ae039 = $80bc94e3cee10a11$var$Code39Reader;


/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 






var $055b6bd23ef58e1b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $055b6bd23ef58e1b$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Decodes Code 93 barcodes.</p>
 *
 * @author Sean Owen
 * @see Code39Reader
 */ var $055b6bd23ef58e1b$var$Code93Reader = /** @class */ function(_super) {
    $055b6bd23ef58e1b$var$__extends(Code93Reader, _super);
    //public Code93Reader() {
    //  decodeRowResult = new StringBuilder(20);
    //  counters = new int[6];
    //}
    function Code93Reader() {
        var _this = _super.call(this) || this;
        _this.decodeRowResult = "";
        _this.counters = new Int32Array(6);
        return _this;
    }
    Code93Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a, e_2, _b;
        var start = this.findAsteriskPattern(row);
        // Read off white space
        var nextStart = row.getNextSet(start[1]);
        var end = row.getSize();
        var theCounters = this.counters;
        theCounters.fill(0);
        this.decodeRowResult = "";
        var decodedChar;
        var lastStart;
        do {
            Code93Reader.recordPattern(row, nextStart, theCounters);
            var pattern = this.toPattern(theCounters);
            if (pattern < 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            decodedChar = this.patternToChar(pattern);
            this.decodeRowResult += decodedChar;
            lastStart = nextStart;
            try {
                for(var theCounters_1 = (e_1 = void 0, $055b6bd23ef58e1b$var$__values(theCounters)), theCounters_1_1 = theCounters_1.next(); !theCounters_1_1.done; theCounters_1_1 = theCounters_1.next()){
                    var counter = theCounters_1_1.value;
                    nextStart += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (theCounters_1_1 && !theCounters_1_1.done && (_a = theCounters_1.return)) _a.call(theCounters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Read off white space
            nextStart = row.getNextSet(nextStart);
        }while (decodedChar !== "*");
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
        var lastPatternSize = 0;
        try {
            for(var theCounters_2 = $055b6bd23ef58e1b$var$__values(theCounters), theCounters_2_1 = theCounters_2.next(); !theCounters_2_1.done; theCounters_2_1 = theCounters_2.next()){
                var counter = theCounters_2_1.value;
                lastPatternSize += counter;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (theCounters_2_1 && !theCounters_2_1.done && (_b = theCounters_2.return)) _b.call(theCounters_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // Should be at least one more black module
        if (nextStart === end || !row.get(nextStart)) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (this.decodeRowResult.length < 2) // false positive -- need at least 2 checksum digits
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        this.checkChecksums(this.decodeRowResult);
        // Remove checksum digits
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 2);
        var resultString = this.decodeExtended(this.decodeRowResult);
        var left = (start[1] + start[0]) / 2.0;
        var right = lastStart + lastPatternSize / 2.0;
        return new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultString, null, 0, [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(left, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(right, rowNumber)
        ], (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_93, new Date().getTime());
    };
    Code93Reader.prototype.findAsteriskPattern = function(row) {
        var width = row.getSize();
        var rowOffset = row.getNextSet(0);
        this.counters.fill(0);
        var theCounters = this.counters;
        var patternStart = rowOffset;
        var isWhite = false;
        var patternLength = theCounters.length;
        var counterPosition = 0;
        for(var i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) theCounters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                if (this.toPattern(theCounters) === Code93Reader.ASTERISK_ENCODING) return new Int32Array([
                    patternStart,
                    i
                ]);
                patternStart += theCounters[0] + theCounters[1];
                theCounters.copyWithin(0, 2, 2 + counterPosition - 1);
                theCounters[counterPosition - 1] = 0;
                theCounters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            theCounters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039);
    };
    Code93Reader.prototype.toPattern = function(counters) {
        var e_3, _a;
        var sum = 0;
        try {
            for(var counters_1 = $055b6bd23ef58e1b$var$__values(counters), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                var counter = counters_1_1.value;
                sum += counter;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        var pattern = 0;
        var max = counters.length;
        for(var i = 0; i < max; i++){
            var scaled = Math.round(counters[i] * 9.0 / sum);
            if (scaled < 1 || scaled > 4) return -1;
            if ((i & 0x01) === 0) for(var j = 0; j < scaled; j++)pattern = pattern << 1 | 0x01;
            else pattern <<= scaled;
        }
        return pattern;
    };
    Code93Reader.prototype.patternToChar = function(pattern) {
        for(var i = 0; i < Code93Reader.CHARACTER_ENCODINGS.length; i++){
            if (Code93Reader.CHARACTER_ENCODINGS[i] === pattern) return Code93Reader.ALPHABET_STRING.charAt(i);
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    Code93Reader.prototype.decodeExtended = function(encoded) {
        var length = encoded.length;
        var decoded = "";
        for(var i = 0; i < length; i++){
            var c = encoded.charAt(i);
            if (c >= "a" && c <= "d") {
                if (i >= length - 1) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                var next = encoded.charAt(i + 1);
                var decodedChar = "\x00";
                switch(c){
                    case "d":
                        // +A to +Z map to a to z
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case "a":
                        // $A to $Z map to control codes SH to SB
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case "b":
                        if (next >= "A" && next <= "E") // %A to %E map to control codes ESC to USep
                        decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                        else if (next >= "F" && next <= "J") // %F to %J map to ; < = > ?
                        decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                        else if (next >= "K" && next <= "O") // %K to %O map to [ \ ] ^ _
                        decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                        else if (next >= "P" && next <= "T") // %P to %T map to { | } ~ DEL
                        decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                        else if (next === "U") // %U map to NUL
                        decodedChar = "\x00";
                        else if (next === "V") // %V map to @
                        decodedChar = "@";
                        else if (next === "W") // %W map to `
                        decodedChar = "`";
                        else if (next >= "X" && next <= "Z") // %X to %Z all map to DEL (127)
                        decodedChar = String.fromCharCode(127);
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case "c":
                        // /A to /O map to ! to , and /Z maps to :
                        if (next >= "A" && next <= "O") decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                        else if (next === "Z") decodedChar = ":";
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                }
                decoded += decodedChar;
                // bump up i again since we read two characters
                i++;
            } else decoded += c;
        }
        return decoded;
    };
    Code93Reader.prototype.checkChecksums = function(result) {
        var length = result.length;
        this.checkOneChecksum(result, length - 2, 20);
        this.checkOneChecksum(result, length - 1, 15);
    };
    Code93Reader.prototype.checkOneChecksum = function(result, checkPosition, weightMax) {
        var weight = 1;
        var total = 0;
        for(var i = checkPosition - 1; i >= 0; i--){
            total += weight * Code93Reader.ALPHABET_STRING.indexOf(result.charAt(i));
            if (++weight > weightMax) weight = 1;
        }
        if (result.charAt(checkPosition) !== Code93Reader.ALPHABET_STRING[total % 47]) throw new (0, $e19cfb3b440de53d$export$2e2bcd8739ae039);
    };
    // Note that 'abcd' are dummy characters in place of control characters.
    Code93Reader.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*";
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow.
     */ Code93Reader.CHARACTER_ENCODINGS = [
        0x114,
        0x148,
        0x144,
        0x142,
        0x128,
        0x124,
        0x122,
        0x150,
        0x112,
        0x10A,
        0x1A8,
        0x1A4,
        0x1A2,
        0x194,
        0x192,
        0x18A,
        0x168,
        0x164,
        0x162,
        0x134,
        0x11A,
        0x158,
        0x14C,
        0x146,
        0x12C,
        0x116,
        0x1B4,
        0x1B2,
        0x1AC,
        0x1A6,
        0x196,
        0x19A,
        0x16C,
        0x166,
        0x136,
        0x13A,
        0x12E,
        0x1D4,
        0x1D2,
        0x1CA,
        0x16E,
        0x176,
        0x1AE,
        0x126,
        0x1DA,
        0x1D6,
        0x132,
        0x15E
    ];
    Code93Reader.ASTERISK_ENCODING = Code93Reader.CHARACTER_ENCODINGS[47];
    return Code93Reader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $055b6bd23ef58e1b$export$2e2bcd8739ae039 = $055b6bd23ef58e1b$var$Code93Reader;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 








var $99414f6a07350203$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $99414f6a07350203$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Decodes ITF barcodes.</p>
 *
 * @author Tjieco
 */ var $99414f6a07350203$var$ITFReader = /** @class */ function(_super) {
    $99414f6a07350203$var$__extends(ITFReader, _super);
    function ITFReader() {
        // private static W = 3; // Pixel width of a 3x wide line
        // private static w = 2; // Pixel width of a 2x wide line
        // private static N = 1; // Pixed width of a narrow line
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Stores the actual narrow line width of the image being decoded.
        _this.narrowLineWidth = -1;
        return _this;
    }
    // See ITFWriter.PATTERNS
    /*
  
    /!**
     * Patterns of Wide / Narrow lines to indicate each digit
     *!/
    */ ITFReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a;
        // Find out where the Middle section (payload) starts & ends
        var startRange = this.decodeStart(row);
        var endRange = this.decodeEnd(row);
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        ITFReader.decodeMiddle(row, startRange[1], endRange[0], result);
        var resultString = result.toString();
        var allowedLengths = null;
        if (hints != null) allowedLengths = hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).ALLOWED_LENGTHS);
        if (allowedLengths == null) allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
        // To avoid false positives with 2D barcodes (and other patterns), make
        // an assumption that the decoded string must be a 'standard' length if it's short
        var length = resultString.length;
        var lengthOK = false;
        var maxAllowedLength = 0;
        try {
            for(var allowedLengths_1 = $99414f6a07350203$var$__values(allowedLengths), allowedLengths_1_1 = allowedLengths_1.next(); !allowedLengths_1_1.done; allowedLengths_1_1 = allowedLengths_1.next()){
                var value = allowedLengths_1_1.value;
                if (length === value) {
                    lengthOK = true;
                    break;
                }
                if (value > maxAllowedLength) maxAllowedLength = value;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (allowedLengths_1_1 && !allowedLengths_1_1.done && (_a = allowedLengths_1.return)) _a.call(allowedLengths_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (!lengthOK && length > maxAllowedLength) lengthOK = true;
        if (!lengthOK) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        var points = [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(startRange[1], rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(endRange[0], rowNumber)
        ];
        var resultReturn = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultString, null, 0, points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).ITF, new Date().getTime());
        return resultReturn;
    };
    /*
    /!**
     * @param row          row of black/white values to search
     * @param payloadStart offset of start pattern
     * @param resultString {@link StringBuilder} to append decoded chars to
     * @throws NotFoundException if decoding could not complete successfully
     *!/*/ ITFReader.decodeMiddle = function(row, payloadStart, payloadEnd, resultString) {
        // Digits are interleaved in pairs - 5 black lines for one digit, and the
        // 5
        // interleaved white lines for the second digit.
        // Therefore, need to scan 10 lines and then
        // split these into two arrays
        var counterDigitPair = new Int32Array(10); // 10
        var counterBlack = new Int32Array(5); // 5
        var counterWhite = new Int32Array(5); // 5
        counterDigitPair.fill(0);
        counterBlack.fill(0);
        counterWhite.fill(0);
        while(payloadStart < payloadEnd){
            // Get 10 runs of black/white.
            (0, $2907db4645bc034b$export$2e2bcd8739ae039).recordPattern(row, payloadStart, counterDigitPair);
            // Split them into each array
            for(var k = 0; k < 5; k++){
                var twoK = 2 * k;
                counterBlack[k] = counterDigitPair[twoK];
                counterWhite[k] = counterDigitPair[twoK + 1];
            }
            var bestMatch = ITFReader.decodeDigit(counterBlack);
            resultString.append(bestMatch.toString());
            bestMatch = this.decodeDigit(counterWhite);
            resultString.append(bestMatch.toString());
            counterDigitPair.forEach(function(counterDigit) {
                payloadStart += counterDigit;
            });
        }
    };
    /*/!**
     * Identify where the start of the middle / payload section starts.
     *
     * @param row row of black/white values to search
     * @return Array, containing index of start of 'start block' and end of
     *         'start block'
     *!/*/ ITFReader.prototype.decodeStart = function(row) {
        var endStart = ITFReader.skipWhiteSpace(row);
        var startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
        // Determine the width of a narrow line in pixels. We can do this by
        // getting the width of the start pattern and dividing by 4 because its
        // made up of 4 narrow lines.
        this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
        this.validateQuietZone(row, startPattern[0]);
        return startPattern;
    };
    /*/!**
     * The start & end patterns must be pre/post fixed by a quiet zone. This
     * zone must be at least 10 times the width of a narrow line.  Scan back until
     * we either get to the start of the barcode or match the necessary number of
     * quiet zone pixels.
     *
     * Note: Its assumed the row is reversed when using this method to find
     * quiet zone after the end pattern.
     *
     * ref: http://www.barcode-1.net/i25code.html
     *
     * @param row bit array representing the scanned barcode.
     * @param startPattern index into row of the start or end pattern.
     * @throws NotFoundException if the quiet zone cannot be found
     *!/*/ ITFReader.prototype.validateQuietZone = function(row, startPattern) {
        var quietCount = this.narrowLineWidth * 10; // expect to find this many pixels of quiet zone
        // if there are not so many pixel at all let's try as many as possible
        quietCount = quietCount < startPattern ? quietCount : startPattern;
        for(var i = startPattern - 1; quietCount > 0 && i >= 0; i--){
            if (row.get(i)) break;
            quietCount--;
        }
        if (quietCount !== 0) // Unable to find the necessary number of quiet zone pixels.
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    /*
    /!**
     * Skip all whitespace until we get to the first black line.
     *
     * @param row row of black/white values to search
     * @return index of the first black line.
     * @throws NotFoundException Throws exception if no black lines are found in the row
     *!/*/ ITFReader.skipWhiteSpace = function(row) {
        var width = row.getSize();
        var endStart = row.getNextSet(0);
        if (endStart === width) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        return endStart;
    };
    /*/!**
     * Identify where the end of the middle / payload section ends.
     *
     * @param row row of black/white values to search
     * @return Array, containing index of start of 'end block' and end of 'end
     *         block'
     *!/*/ ITFReader.prototype.decodeEnd = function(row) {
        // For convenience, reverse the row and then
        // search from 'the start' for the end block
        row.reverse();
        try {
            var endStart = ITFReader.skipWhiteSpace(row);
            var endPattern = void 0;
            try {
                endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
            } catch (error) {
                if (error instanceof (0, $283aa2ad27179317$export$2e2bcd8739ae039)) endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
            }
            // The start & end patterns must be pre/post fixed by a quiet zone. This
            // zone must be at least 10 times the width of a narrow line.
            // ref: http://www.barcode-1.net/i25code.html
            this.validateQuietZone(row, endPattern[0]);
            // Now recalculate the indices of where the 'endblock' starts & stops to
            // accommodate
            // the reversed nature of the search
            var temp = endPattern[0];
            endPattern[0] = row.getSize() - endPattern[1];
            endPattern[1] = row.getSize() - temp;
            return endPattern;
        } finally{
            // Put the row back the right way.
            row.reverse();
        }
    };
    /*
    /!**
     * @param row       row of black/white values to search
     * @param rowOffset position to start search
     * @param pattern   pattern of counts of number of black and white pixels that are
     *                  being searched for as a pattern
     * @return start/end horizontal offset of guard pattern, as an array of two
     *         ints
     * @throws NotFoundException if pattern is not found
     *!/*/ ITFReader.findGuardPattern = function(row, rowOffset, pattern) {
        var patternLength = pattern.length;
        var counters = new Int32Array(patternLength);
        var width = row.getSize();
        var isWhite = false;
        var counterPosition = 0;
        var patternStart = rowOffset;
        counters.fill(0);
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                if ((0, $2907db4645bc034b$export$2e2bcd8739ae039).patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) return [
                    patternStart,
                    x
                ];
                patternStart += counters[0] + counters[1];
                (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(counters, 2, counters, 0, counterPosition - 1);
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    /*/!**
     * Attempts to decode a sequence of ITF black/white lines into single
     * digit.
     *
     * @param counters the counts of runs of observed black/white/black/... values
     * @return The decoded digit
     * @throws NotFoundException if digit cannot be decoded
     *!/*/ ITFReader.decodeDigit = function(counters) {
        var bestVariance = ITFReader.MAX_AVG_VARIANCE; // worst variance we'll accept
        var bestMatch = -1;
        var max = ITFReader.PATTERNS.length;
        for(var i = 0; i < max; i++){
            var pattern = ITFReader.PATTERNS[i];
            var variance = (0, $2907db4645bc034b$export$2e2bcd8739ae039).patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
            if (variance < bestVariance) {
                bestVariance = variance;
                bestMatch = i;
            } else if (variance === bestVariance) // if we find a second 'best match' with the same variance, we can not reliably report to have a suitable match
            bestMatch = -1;
        }
        if (bestMatch >= 0) return bestMatch % 10;
        else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    ITFReader.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ]) // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    /* /!** Valid ITF lengths. Anything longer than the largest value is also allowed. *!/*/ ITFReader.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ];
    /*/!**
     * Start/end guard pattern.
     *
     * Note: The end pattern is reversed because the row is reversed before
     * searching for the END_PATTERN
     *!/*/ ITFReader.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]);
    ITFReader.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ]) // 3x
    ];
    return ITFReader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $99414f6a07350203$export$2e2bcd8739ae039 = $99414f6a07350203$var$ITFReader;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/*
 * Copyright (C) 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


var $c2af1f8149d6f2a7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
 * of one-dimensional barcodes.</p>
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author alasdair@google.com (Alasdair Mackintosh)
 */ var $c2af1f8149d6f2a7$var$AbstractUPCEANReader = /** @class */ function(_super) {
    $c2af1f8149d6f2a7$var$__extends(AbstractUPCEANReader, _super);
    function AbstractUPCEANReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.decodeRowStringBuffer = "";
        return _this;
    }
    // private final UPCEANExtensionSupport extensionReader;
    // private final EANManufacturerOrgSupport eanManSupport;
    /*
    protected UPCEANReader() {
        decodeRowStringBuffer = new StringBuilder(20);
        extensionReader = new UPCEANExtensionSupport();
        eanManSupport = new EANManufacturerOrgSupport();
    }
    */ AbstractUPCEANReader.findStartGuardPattern = function(row) {
        var foundStart = false;
        var startRange;
        var nextStart = 0;
        var counters = Int32Array.from([
            0,
            0,
            0
        ]);
        while(!foundStart){
            counters = Int32Array.from([
                0,
                0,
                0
            ]);
            startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
            var start = startRange[0];
            nextStart = startRange[1];
            var quietStart = start - (nextStart - start);
            if (quietStart >= 0) foundStart = row.isRange(quietStart, start, false);
        }
        return startRange;
    };
    AbstractUPCEANReader.checkChecksum = function(s) {
        return AbstractUPCEANReader.checkStandardUPCEANChecksum(s);
    };
    AbstractUPCEANReader.checkStandardUPCEANChecksum = function(s) {
        var length = s.length;
        if (length === 0) return false;
        var check = parseInt(s.charAt(length - 1), 10);
        return AbstractUPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
    };
    AbstractUPCEANReader.getStandardUPCEANChecksum = function(s) {
        var length = s.length;
        var sum = 0;
        for(var i = length - 1; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            sum += digit;
        }
        sum *= 3;
        for(var i = length - 2; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            sum += digit;
        }
        return (1000 - sum) % 10;
    };
    AbstractUPCEANReader.decodeEnd = function(row, endStart) {
        return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
    };
    /**
     * @throws NotFoundException
     */ AbstractUPCEANReader.findGuardPatternWithoutCounters = function(row, rowOffset, whiteFirst, pattern) {
        return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
    };
    /**
     * @param row row of black/white values to search
     * @param rowOffset position to start search
     * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
     * pixel counts, otherwise, it is interpreted as black/white/black/...
     * @param pattern pattern of counts of number of black and white pixels that are being
     * searched for as a pattern
     * @param counters array of counters, as long as pattern, to re-use
     * @return start/end horizontal offset of guard pattern, as an array of two ints
     * @throws NotFoundException if pattern is not found
     */ AbstractUPCEANReader.findGuardPattern = function(row, rowOffset, whiteFirst, pattern, counters) {
        var width = row.getSize();
        rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
        var counterPosition = 0;
        var patternStart = rowOffset;
        var patternLength = pattern.length;
        var isWhite = whiteFirst;
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                if ((0, $2907db4645bc034b$export$2e2bcd8739ae039).patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) return Int32Array.from([
                    patternStart,
                    x
                ]);
                patternStart += counters[0] + counters[1];
                var slice = counters.slice(2, counters.length);
                for(var i = 0; i < counterPosition - 1; i++)counters[i] = slice[i];
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    AbstractUPCEANReader.decodeDigit = function(row, counters, rowOffset, patterns) {
        this.recordPattern(row, rowOffset, counters);
        var bestVariance = this.MAX_AVG_VARIANCE;
        var bestMatch = -1;
        var max = patterns.length;
        for(var i = 0; i < max; i++){
            var pattern = patterns[i];
            var variance = (0, $2907db4645bc034b$export$2e2bcd8739ae039).patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
            if (variance < bestVariance) {
                bestVariance = variance;
                bestMatch = i;
            }
        }
        if (bestMatch >= 0) return bestMatch;
        else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    // These two values are critical for determining how permissive the decoding will be.
    // We've arrived at these values through a lot of trial and error. Setting them any higher
    // lets false positives creep in quickly.
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    /**
     * Start/end guard pattern.
     */ AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]);
    /**
     * Pattern marking the middle of a UPC/EAN pattern, separating the two halves.
     */ AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * end guard pattern.
     */ AbstractUPCEANReader.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * "Odd", or "L" patterns used to encode UPC/EAN digits.
     */ AbstractUPCEANReader.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ];
    return AbstractUPCEANReader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $c2af1f8149d6f2a7$export$2e2bcd8739ae039 = $c2af1f8149d6f2a7$var$AbstractUPCEANReader;


/*
 * Copyright (C) 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 





var $2a011f1d77efef99$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @see UPCEANExtension2Support
 */ var $2a011f1d77efef99$var$UPCEANExtension5Support = /** @class */ function() {
    function UPCEANExtension5Support() {
        this.CHECK_DIGIT_ENCODINGS = [
            0x18,
            0x14,
            0x12,
            0x11,
            0x0C,
            0x06,
            0x03,
            0x0A,
            0x09,
            0x05
        ];
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        this.decodeRowStringBuffer = "";
    }
    UPCEANExtension5Support.prototype.decodeRow = function(rowNumber, row, extensionStartRange) {
        var result = this.decodeRowStringBuffer;
        var end = this.decodeMiddle(row, extensionStartRange, result);
        var resultString = result.toString();
        var extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
        var resultPoints = [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(end, rowNumber)
        ];
        var extensionResult = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultString, null, 0, resultPoints, (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_EAN_EXTENSION, new Date().getTime());
        if (extensionData != null) extensionResult.putAllMetadata(extensionData);
        return extensionResult;
    };
    UPCEANExtension5Support.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var lgPatternFound = 0;
        for(var x = 0; x < 5 && rowOffset < end; x++){
            var bestMatch = (0, $c2af1f8149d6f2a7$export$2e2bcd8739ae039).decodeDigit(row, counters, rowOffset, (0, $c2af1f8149d6f2a7$export$2e2bcd8739ae039).L_AND_G_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $2a011f1d77efef99$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) lgPatternFound |= 1 << 4 - x;
            if (x !== 4) {
                // Read off separator if not last
                rowOffset = row.getNextSet(rowOffset);
                rowOffset = row.getNextUnset(rowOffset);
            }
        }
        if (resultString.length !== 5) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var checkDigit = this.determineCheckDigit(lgPatternFound);
        if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        return rowOffset;
    };
    UPCEANExtension5Support.extensionChecksum = function(s) {
        var length = s.length;
        var sum = 0;
        for(var i = length - 2; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
        sum *= 3;
        for(var i = length - 1; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
        sum *= 3;
        return sum % 10;
    };
    UPCEANExtension5Support.prototype.determineCheckDigit = function(lgPatternFound) {
        for(var d = 0; d < 10; d++){
            if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d]) return d;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    UPCEANExtension5Support.parseExtensionString = function(raw) {
        if (raw.length !== 5) return null;
        var value = UPCEANExtension5Support.parseExtension5String(raw);
        if (value == null) return null;
        return new Map([
            [
                (0, $84e98e00dae0cad6$export$2e2bcd8739ae039).SUGGESTED_PRICE,
                value
            ]
        ]);
    };
    UPCEANExtension5Support.parseExtension5String = function(raw) {
        var currency;
        switch(raw.charAt(0)){
            case "0":
                currency = "\xa3";
                break;
            case "5":
                currency = "$";
                break;
            case "9":
                // Reference: http://www.jollytech.com
                switch(raw){
                    case "90000":
                        // No suggested retail price
                        return null;
                    case "99991":
                        // Complementary
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                // Otherwise... unknown currency?
                currency = "";
                break;
            default:
                currency = "";
                break;
        }
        var rawAmount = parseInt(raw.substring(1));
        var unitsString = (rawAmount / 100).toString();
        var hundredths = rawAmount % 100;
        var hundredthsString = hundredths < 10 ? "0" + hundredths : hundredths.toString(); // fixme
        return currency + unitsString + "." + hundredthsString;
    };
    return UPCEANExtension5Support;
}();
var $2a011f1d77efef99$export$2e2bcd8739ae039 = $2a011f1d77efef99$var$UPCEANExtension5Support;


/*
 * Copyright (C) 2012 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 





var $7fc099df21473c22$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @see UPCEANExtension5Support
 */ var $7fc099df21473c22$var$UPCEANExtension2Support = /** @class */ function() {
    function UPCEANExtension2Support() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        this.decodeRowStringBuffer = "";
    }
    UPCEANExtension2Support.prototype.decodeRow = function(rowNumber, row, extensionStartRange) {
        var result = this.decodeRowStringBuffer;
        var end = this.decodeMiddle(row, extensionStartRange, result);
        var resultString = result.toString();
        var extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
        var resultPoints = [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(end, rowNumber)
        ];
        var extensionResult = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultString, null, 0, resultPoints, (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_EAN_EXTENSION, new Date().getTime());
        if (extensionData != null) extensionResult.putAllMetadata(extensionData);
        return extensionResult;
    };
    UPCEANExtension2Support.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var checkParity = 0;
        for(var x = 0; x < 2 && rowOffset < end; x++){
            var bestMatch = (0, $c2af1f8149d6f2a7$export$2e2bcd8739ae039).decodeDigit(row, counters, rowOffset, (0, $c2af1f8149d6f2a7$export$2e2bcd8739ae039).L_AND_G_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $7fc099df21473c22$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) checkParity |= 1 << 1 - x;
            if (x !== 1) {
                // Read off separator if not last
                rowOffset = row.getNextSet(rowOffset);
                rowOffset = row.getNextUnset(rowOffset);
            }
        }
        if (resultString.length !== 2) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (parseInt(resultString.toString()) % 4 !== checkParity) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        return rowOffset;
    };
    UPCEANExtension2Support.parseExtensionString = function(raw) {
        if (raw.length !== 2) return null;
        return new Map([
            [
                (0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ISSUE_NUMBER,
                parseInt(raw)
            ]
        ]);
    };
    return UPCEANExtension2Support;
}();
var $7fc099df21473c22$export$2e2bcd8739ae039 = $7fc099df21473c22$var$UPCEANExtension2Support;


var $8972e1262340c891$var$UPCEANExtensionSupport = /** @class */ function() {
    function UPCEANExtensionSupport() {}
    UPCEANExtensionSupport.decodeRow = function(rowNumber, row, rowOffset) {
        var extensionStartRange = (0, $c2af1f8149d6f2a7$export$2e2bcd8739ae039).findGuardPattern(row, rowOffset, false, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            // return null;
            var fiveSupport = new (0, $2a011f1d77efef99$export$2e2bcd8739ae039)();
            return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
        } catch (err) {
            // return null;
            var twoSupport = new (0, $7fc099df21473c22$export$2e2bcd8739ae039)();
            return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
        }
    };
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]);
    return UPCEANExtensionSupport;
}();
var $8972e1262340c891$export$2e2bcd8739ae039 = $8972e1262340c891$var$UPCEANExtensionSupport;






var $62510b891dc0e006$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
 * of one-dimensional barcodes.</p>
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author alasdair@google.com (Alasdair Mackintosh)
 */ var $62510b891dc0e006$var$UPCEANReader = /** @class */ function(_super) {
    $62510b891dc0e006$var$__extends(UPCEANReader, _super);
    function UPCEANReader() {
        var _this = _super.call(this) || this;
        _this.decodeRowStringBuffer = "";
        UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map(function(arr) {
            return Int32Array.from(arr);
        });
        for(var i = 10; i < 20; i++){
            var widths = UPCEANReader.L_PATTERNS[i - 10];
            var reversedWidths = new Int32Array(widths.length);
            for(var j = 0; j < widths.length; j++)reversedWidths[j] = widths[widths.length - j - 1];
            UPCEANReader.L_AND_G_PATTERNS[i] = reversedWidths;
        }
        return _this;
    }
    UPCEANReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var startGuardRange = UPCEANReader.findStartGuardPattern(row);
        var resultPointCallback = hints == null ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).NEED_RESULT_POINT_CALLBACK);
        if (resultPointCallback != null) {
            var resultPoint_1 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)((startGuardRange[0] + startGuardRange[1]) / 2.0, rowNumber);
            resultPointCallback.foundPossibleResultPoint(resultPoint_1);
        }
        var budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
        var endStart = budello.rowOffset;
        var result = budello.resultString;
        if (resultPointCallback != null) {
            var resultPoint_2 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(endStart, rowNumber);
            resultPointCallback.foundPossibleResultPoint(resultPoint_2);
        }
        var endRange = UPCEANReader.decodeEnd(row, endStart);
        if (resultPointCallback != null) {
            var resultPoint_3 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)((endRange[0] + endRange[1]) / 2.0, rowNumber);
            resultPointCallback.foundPossibleResultPoint(resultPoint_3);
        }
        // Make sure there is a quiet zone at least as big as the end pattern after the barcode. The
        // spec might want more whitespace, but in practice this is the maximum we can count on.
        var end = endRange[1];
        var quietEnd = end + (end - endRange[0]);
        if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var resultString = result.toString();
        // UPC/EAN should never be less than 8 chars anyway
        if (resultString.length < 8) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        if (!UPCEANReader.checkChecksum(resultString)) throw new (0, $e19cfb3b440de53d$export$2e2bcd8739ae039)();
        var left = (startGuardRange[1] + startGuardRange[0]) / 2.0;
        var right = (endRange[1] + endRange[0]) / 2.0;
        var format = this.getBarcodeFormat();
        var resultPoint = [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(left, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(right, rowNumber)
        ];
        var decodeResult = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultString, null, 0, resultPoint, format, new Date().getTime());
        var extensionLength = 0;
        try {
            var extensionResult = (0, $8972e1262340c891$export$2e2bcd8739ae039).decodeRow(rowNumber, row, endRange[1]);
            decodeResult.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).UPC_EAN_EXTENSION, extensionResult.getText());
            decodeResult.putAllMetadata(extensionResult.getResultMetadata());
            decodeResult.addResultPoints(extensionResult.getResultPoints());
            extensionLength = extensionResult.getText().length;
        } catch (err) {}
        var allowedExtensions = hints == null ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).ALLOWED_EAN_EXTENSIONS);
        if (allowedExtensions != null) {
            var valid = false;
            for(var length_1 in allowedExtensions)if (extensionLength.toString() === length_1) {
                valid = true;
                break;
            }
            if (!valid) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        }
        format === (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13 || (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A;
        return decodeResult;
    };
    UPCEANReader.checkChecksum = function(s) {
        return UPCEANReader.checkStandardUPCEANChecksum(s);
    };
    UPCEANReader.checkStandardUPCEANChecksum = function(s) {
        var length = s.length;
        if (length === 0) return false;
        var check = parseInt(s.charAt(length - 1), 10);
        return UPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
    };
    UPCEANReader.getStandardUPCEANChecksum = function(s) {
        var length = s.length;
        var sum = 0;
        for(var i = length - 1; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            sum += digit;
        }
        sum *= 3;
        for(var i = length - 2; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            sum += digit;
        }
        return (1000 - sum) % 10;
    };
    UPCEANReader.decodeEnd = function(row, endStart) {
        return UPCEANReader.findGuardPattern(row, endStart, false, UPCEANReader.START_END_PATTERN, new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0));
    };
    return UPCEANReader;
}((0, $c2af1f8149d6f2a7$export$2e2bcd8739ae039));
var $62510b891dc0e006$export$2e2bcd8739ae039 = $62510b891dc0e006$var$UPCEANReader;



var $9f5f60023fd1790e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9f5f60023fd1790e$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Implements decoding of the EAN-13 format.</p>
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author alasdair@google.com (Alasdair Mackintosh)
 */ var $9f5f60023fd1790e$var$EAN13Reader = /** @class */ function(_super) {
    $9f5f60023fd1790e$var$__extends(EAN13Reader, _super);
    function EAN13Reader() {
        var _this = _super.call(this) || this;
        _this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        return _this;
    }
    EAN13Reader.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a, e_2, _b;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var lgPatternFound = 0;
        for(var x = 0; x < 6 && rowOffset < end; x++){
            var bestMatch = (0, $62510b891dc0e006$export$2e2bcd8739ae039).decodeDigit(row, counters, rowOffset, (0, $62510b891dc0e006$export$2e2bcd8739ae039).L_AND_G_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $9f5f60023fd1790e$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
        }
        resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
        var middleRange = (0, $62510b891dc0e006$export$2e2bcd8739ae039).findGuardPattern(row, rowOffset, true, (0, $62510b891dc0e006$export$2e2bcd8739ae039).MIDDLE_PATTERN, new Int32Array((0, $62510b891dc0e006$export$2e2bcd8739ae039).MIDDLE_PATTERN.length).fill(0));
        rowOffset = middleRange[1];
        for(var x = 0; x < 6 && rowOffset < end; x++){
            var bestMatch = (0, $62510b891dc0e006$export$2e2bcd8739ae039).decodeDigit(row, counters, rowOffset, (0, $62510b891dc0e006$export$2e2bcd8739ae039).L_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
            try {
                for(var counters_2 = (e_2 = void 0, $9f5f60023fd1790e$var$__values(counters)), counters_2_1 = counters_2.next(); !counters_2_1.done; counters_2_1 = counters_2.next()){
                    var counter = counters_2_1.value;
                    rowOffset += counter;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (counters_2_1 && !counters_2_1.done && (_b = counters_2.return)) _b.call(counters_2);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
        return {
            rowOffset: rowOffset,
            resultString: resultString
        };
    };
    EAN13Reader.prototype.getBarcodeFormat = function() {
        return (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13;
    };
    EAN13Reader.determineFirstDigit = function(resultString, lgPatternFound) {
        for(var d = 0; d < 10; d++)if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d]) {
            resultString = String.fromCharCode("0".charCodeAt(0) + d) + resultString;
            return resultString;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [
        0x00,
        0x0B,
        0x0D,
        0xE,
        0x13,
        0x19,
        0x1C,
        0x15,
        0x16,
        0x1A
    ];
    return EAN13Reader;
}((0, $62510b891dc0e006$export$2e2bcd8739ae039));
var $9f5f60023fd1790e$export$2e2bcd8739ae039 = $9f5f60023fd1790e$var$EAN13Reader;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $35f16979c25eff79$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $35f16979c25eff79$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Implements decoding of the EAN-8 format.</p>
 *
 * @author Sean Owen
 */ var $35f16979c25eff79$var$EAN8Reader = /** @class */ function(_super) {
    $35f16979c25eff79$var$__extends(EAN8Reader, _super);
    function EAN8Reader() {
        var _this = _super.call(this) || this;
        _this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        return _this;
    }
    EAN8Reader.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a, e_2, _b;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        for(var x = 0; x < 4 && rowOffset < end; x++){
            var bestMatch = (0, $62510b891dc0e006$export$2e2bcd8739ae039).decodeDigit(row, counters, rowOffset, (0, $62510b891dc0e006$export$2e2bcd8739ae039).L_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
            try {
                for(var counters_1 = (e_1 = void 0, $35f16979c25eff79$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        var middleRange = (0, $62510b891dc0e006$export$2e2bcd8739ae039).findGuardPattern(row, rowOffset, true, (0, $62510b891dc0e006$export$2e2bcd8739ae039).MIDDLE_PATTERN, new Int32Array((0, $62510b891dc0e006$export$2e2bcd8739ae039).MIDDLE_PATTERN.length).fill(0));
        rowOffset = middleRange[1];
        for(var x = 0; x < 4 && rowOffset < end; x++){
            var bestMatch = (0, $62510b891dc0e006$export$2e2bcd8739ae039).decodeDigit(row, counters, rowOffset, (0, $62510b891dc0e006$export$2e2bcd8739ae039).L_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
            try {
                for(var counters_2 = (e_2 = void 0, $35f16979c25eff79$var$__values(counters)), counters_2_1 = counters_2.next(); !counters_2_1.done; counters_2_1 = counters_2.next()){
                    var counter = counters_2_1.value;
                    rowOffset += counter;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (counters_2_1 && !counters_2_1.done && (_b = counters_2.return)) _b.call(counters_2);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
        return {
            rowOffset: rowOffset,
            resultString: resultString
        };
    };
    EAN8Reader.prototype.getBarcodeFormat = function() {
        return (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_8;
    };
    return EAN8Reader;
}((0, $62510b891dc0e006$export$2e2bcd8739ae039));
var $35f16979c25eff79$export$2e2bcd8739ae039 = $35f16979c25eff79$var$EAN8Reader;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




var $e918fab24213995b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Encapsulates functionality and implementation that is common to all families
 * of one-dimensional barcodes.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author sam2332 (Sam Rudloff)
 *
 * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCAReader.java
 *
 * @experimental
 */ var $e918fab24213995b$var$UPCAReader = /** @class */ function(_super) {
    $e918fab24213995b$var$__extends(UPCAReader, _super);
    function UPCAReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ean13Reader = new (0, $9f5f60023fd1790e$export$2e2bcd8739ae039)();
        return _this;
    }
    // @Override
    UPCAReader.prototype.getBarcodeFormat = function() {
        return (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A;
    };
    // Note that we don't try rotation without the try harder flag, even if rotation was supported.
    // @Override
    UPCAReader.prototype.decode = function(image, hints) {
        return this.maybeReturnResult(this.ean13Reader.decode(image));
    };
    // @Override
    UPCAReader.prototype.decodeRow = function(rowNumber, row, hints) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
    };
    // @Override
    UPCAReader.prototype.decodeMiddle = function(row, startRange, resultString) {
        return this.ean13Reader.decodeMiddle(row, startRange, resultString);
    };
    UPCAReader.prototype.maybeReturnResult = function(result) {
        var text = result.getText();
        if (text.charAt(0) === "0") {
            var upcaResult = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(text.substring(1), null, null, result.getResultPoints(), (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A);
            if (result.getResultMetadata() != null) upcaResult.putAllMetadata(result.getResultMetadata());
            return upcaResult;
        } else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    UPCAReader.prototype.reset = function() {
        this.ean13Reader.reset();
    };
    return UPCAReader;
}((0, $62510b891dc0e006$export$2e2bcd8739ae039));
var $e918fab24213995b$export$2e2bcd8739ae039 = $e918fab24213995b$var$UPCAReader;



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



var $ba521c69cdf8774f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ba521c69cdf8774f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// package com.google.zxing.oned;
// import com.google.zxing.BarcodeFormat;
// import com.google.zxing.FormatException;
// import com.google.zxing.NotFoundException;
// import com.google.zxing.common.BitArray;
/**
 * <p>Implements decoding of the UPC-E format.</p>
 * <p><a href="http://www.barcodeisland.com/upce.phtml">This</a> is a great reference for
 * UPC-E information.</p>
 *
 * @author Sean Owen
 *
 * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCEReader.java
 *
 * @experimental
 */ var $ba521c69cdf8774f$var$UPCEReader = /** @class */ function(_super) {
    $ba521c69cdf8774f$var$__extends(UPCEReader, _super);
    function UPCEReader() {
        var _this = _super.call(this) || this;
        _this.decodeMiddleCounters = new Int32Array(4);
        return _this;
    }
    /**
     * @throws NotFoundException
     */ // @Override
    UPCEReader.prototype.decodeMiddle = function(row, startRange, result) {
        var e_1, _a;
        var counters = this.decodeMiddleCounters.map(function(x) {
            return x;
        });
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var lgPatternFound = 0;
        for(var x = 0; x < 6 && rowOffset < end; x++){
            var bestMatch = UPCEReader.decodeDigit(row, counters, rowOffset, UPCEReader.L_AND_G_PATTERNS);
            result += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $ba521c69cdf8774f$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
        }
        UPCEReader.determineNumSysAndCheckDigit(new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)(result), lgPatternFound);
        return rowOffset;
    };
    /**
     * @throws NotFoundException
     */ // @Override
    UPCEReader.prototype.decodeEnd = function(row, endStart) {
        return UPCEReader.findGuardPatternWithoutCounters(row, endStart, true, UPCEReader.MIDDLE_END_PATTERN);
    };
    /**
     * @throws FormatException
     */ // @Override
    UPCEReader.prototype.checkChecksum = function(s) {
        return (0, $62510b891dc0e006$export$2e2bcd8739ae039).checkChecksum(UPCEReader.convertUPCEtoUPCA(s));
    };
    /**
     * @throws NotFoundException
     */ UPCEReader.determineNumSysAndCheckDigit = function(resultString, lgPatternFound) {
        for(var numSys = 0; numSys <= 1; numSys++){
            for(var d = 0; d < 10; d++)if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d]) {
                resultString.insert(0, /*(char)*/ "0" + numSys);
                resultString.append(/*(char)*/ "0" + d);
                return;
            }
        }
        throw (0, $283aa2ad27179317$export$2e2bcd8739ae039).getNotFoundInstance();
    };
    // @Override
    UPCEReader.prototype.getBarcodeFormat = function() {
        return (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_E;
    };
    /**
     * Expands a UPC-E value back into its full, equivalent UPC-A code value.
     *
     * @param upce UPC-E code as string of digits
     * @return equivalent UPC-A code as string of digits
     */ UPCEReader.convertUPCEtoUPCA = function(upce) {
        // the following line is equivalent to upce.getChars(1, 7, upceChars, 0);
        var upceChars = upce.slice(1, 7).split("").map(function(x) {
            return x.charCodeAt(0);
        });
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        result.append(upce.charAt(0));
        var lastChar = upceChars[5];
        switch(lastChar){
            case 0:
            case 1:
            case 2:
                result.appendChars(upceChars, 0, 2);
                result.append(lastChar);
                result.append("0000");
                result.appendChars(upceChars, 2, 3);
                break;
            case 3:
                result.appendChars(upceChars, 0, 3);
                result.append("00000");
                result.appendChars(upceChars, 3, 2);
                break;
            case 4:
                result.appendChars(upceChars, 0, 4);
                result.append("00000");
                result.append(upceChars[4]);
                break;
            default:
                result.appendChars(upceChars, 0, 5);
                result.append("0000");
                result.append(lastChar);
                break;
        }
        // Only append check digit in conversion if supplied
        if (upce.length >= 8) result.append(upce.charAt(7));
        return result.toString();
    };
    /**
     * The pattern that marks the middle, and end, of a UPC-E pattern.
     * There is no "second half" to a UPC-E barcode.
     */ UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    // For an UPC-E barcode, the final digit is represented by the parities used
    // to encode the middle six digits, according to the table below.
    //
    //                Parity of next 6 digits
    //    Digit   0     1     2     3     4     5
    //       0    Even   Even  Even Odd  Odd   Odd
    //       1    Even   Even  Odd  Even Odd   Odd
    //       2    Even   Even  Odd  Odd  Even  Odd
    //       3    Even   Even  Odd  Odd  Odd   Even
    //       4    Even   Odd   Even Even Odd   Odd
    //       5    Even   Odd   Odd  Even Even  Odd
    //       6    Even   Odd   Odd  Odd  Even  Even
    //       7    Even   Odd   Even Odd  Even  Odd
    //       8    Even   Odd   Even Odd  Odd   Even
    //       9    Even   Odd   Odd  Even Odd   Even
    //
    // The encoding is represented by the following array, which is a bit pattern
    // using Odd = 0 and Even = 1. For example, 5 is represented by:
    //
    //              Odd Even Even Odd Odd Even
    // in binary:
    //                0    1    1   0   0    1   == 0x19
    //
    /**
     * See {@link #L_AND_G_PATTERNS}; these values similarly represent patterns of
     * even-odd parity encodings of digits that imply both the number system (0 or 1)
     * used, and the check digit.
     */ UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            0x38,
            0x34,
            0x32,
            0x31,
            0x2C,
            0x26,
            0x23,
            0x2A,
            0x29,
            0x25
        ]),
        Int32Array.from([
            0x07,
            0x0B,
            0x0D,
            0x0E,
            0x13,
            0x19,
            0x1C,
            0x15,
            0x16,
            0x1
        ])
    ];
    return UPCEReader;
}((0, $62510b891dc0e006$export$2e2bcd8739ae039));
var $ba521c69cdf8774f$export$2e2bcd8739ae039 = $ba521c69cdf8774f$var$UPCEReader;


var $d716d6460a89b943$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d716d6460a89b943$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>A reader that can read all available UPC/EAN formats. If a caller wants to try to
 * read all such formats, it is most efficient to use this implementation rather than invoke
 * individual readers.</p>
 *
 * @author Sean Owen
 */ var $d716d6460a89b943$var$MultiFormatUPCEANReader = /** @class */ function(_super) {
    $d716d6460a89b943$var$__extends(MultiFormatUPCEANReader, _super);
    function MultiFormatUPCEANReader(hints) {
        var _this = _super.call(this) || this;
        var possibleFormats = hints == null ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).POSSIBLE_FORMATS);
        var readers = [];
        if (possibleFormats != null) {
            if (possibleFormats.indexOf((0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13) > -1) readers.push(new (0, $9f5f60023fd1790e$export$2e2bcd8739ae039)());
            if (possibleFormats.indexOf((0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A) > -1) readers.push(new (0, $e918fab24213995b$export$2e2bcd8739ae039)());
            if (possibleFormats.indexOf((0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_8) > -1) readers.push(new (0, $35f16979c25eff79$export$2e2bcd8739ae039)());
            if (possibleFormats.indexOf((0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_E) > -1) readers.push(new (0, $ba521c69cdf8774f$export$2e2bcd8739ae039)());
        }
        if (readers.length === 0) {
            readers.push(new (0, $9f5f60023fd1790e$export$2e2bcd8739ae039)());
            readers.push(new (0, $e918fab24213995b$export$2e2bcd8739ae039)());
            readers.push(new (0, $35f16979c25eff79$export$2e2bcd8739ae039)());
            readers.push(new (0, $ba521c69cdf8774f$export$2e2bcd8739ae039)());
        }
        _this.readers = readers;
        return _this;
    }
    MultiFormatUPCEANReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a;
        try {
            for(var _b = $d716d6460a89b943$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                try {
                    // const result: Result = reader.decodeRow(rowNumber, row, startGuardPattern, hints);
                    var result = reader.decodeRow(rowNumber, row, hints);
                    // Special case: a 12-digit code encoded in UPC-A is identical to a "0"
                    // followed by those 12 digits encoded as EAN-13. Each will recognize such a code,
                    // UPC-A as a 12-digit string and EAN-13 as a 13-digit string starting with "0".
                    // Individually these are correct and their readers will both read such a code
                    // and correctly call it EAN-13, or UPC-A, respectively.
                    //
                    // In this case, if we've been looking for both types, we'd like to call it
                    // a UPC-A code. But for efficiency we only run the EAN-13 decoder to also read
                    // UPC-A. So we special case it here, and convert an EAN-13 result to a UPC-A
                    // result if appropriate.
                    //
                    // But, don't return UPC-A if UPC-A was not a requested format!
                    var ean13MayBeUPCA = result.getBarcodeFormat() === (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13 && result.getText().charAt(0) === "0";
                    // @SuppressWarnings("unchecked")
                    var possibleFormats = hints == null ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).POSSIBLE_FORMATS);
                    var canReturnUPCA = possibleFormats == null || possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A);
                    if (ean13MayBeUPCA && canReturnUPCA) {
                        var rawBytes = result.getRawBytes();
                        // Transfer the metadata across
                        var resultUPCA = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(result.getText().substring(1), rawBytes, rawBytes ? rawBytes.length : null, result.getResultPoints(), (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A);
                        resultUPCA.putAllMetadata(result.getResultMetadata());
                        return resultUPCA;
                    }
                    return result;
                } catch (err) {
                // continue;
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    MultiFormatUPCEANReader.prototype.reset = function() {
        var e_2, _a;
        try {
            for(var _b = $d716d6460a89b943$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                reader.reset();
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    return MultiFormatUPCEANReader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $d716d6460a89b943$export$2e2bcd8739ae039 = $d716d6460a89b943$var$MultiFormatUPCEANReader;



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




var $e1389124812422eb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Decodes CodaBar barcodes. </p>
 *
 * @author Evan @dodobelieve
 * @see CodaBarReader
 */ var $e1389124812422eb$var$CodaBarReader = /** @class */ function(_super) {
    $e1389124812422eb$var$__extends(CodaBarReader, _super);
    function CodaBarReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CODA_BAR_CHAR_SET = {
            nnnnnww: "0",
            nnnnwwn: "1",
            nnnwnnw: "2",
            wwnnnnn: "3",
            nnwnnwn: "4",
            wnnnnwn: "5",
            nwnnnnw: "6",
            nwnnwnn: "7",
            nwwnnnn: "8",
            wnnwnnn: "9",
            nnnwwnn: "-",
            nnwwnnn: "$",
            wnnnwnw: ":",
            wnwnnnw: "/",
            wnwnwnn: ".",
            nnwwwww: "+",
            nnwwnwn: "A",
            nwnwnnw: "B",
            nnnwnww: "C",
            nnnwwwn: "D"
        };
        return _this;
    }
    CodaBarReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var validRowData = this.getValidRowData(row);
        if (!validRowData) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var retStr = this.codaBarDecodeRow(validRowData.row);
        if (!retStr) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        return new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(retStr, null, 0, [
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(validRowData.left, rowNumber),
            new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(validRowData.right, rowNumber)
        ], (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODABAR, new Date().getTime());
    };
    /**
     * converts bit array to valid data array(lengths of black bits and white bits)
     * @param row bit array to convert
     */ CodaBarReader.prototype.getValidRowData = function(row) {
        var booleanArr = row.toArray();
        var startIndex = booleanArr.indexOf(true);
        if (startIndex === -1) return null;
        var lastIndex = booleanArr.lastIndexOf(true);
        if (lastIndex <= startIndex) return null;
        booleanArr = booleanArr.slice(startIndex, lastIndex + 1);
        var result = [];
        var lastBit = booleanArr[0];
        var bitLength = 1;
        for(var i = 1; i < booleanArr.length; i++)if (booleanArr[i] === lastBit) bitLength++;
        else {
            lastBit = booleanArr[i];
            result.push(bitLength);
            bitLength = 1;
        }
        result.push(bitLength);
        // CodaBar code data valid
        if (result.length < 23 && (result.length + 1) % 8 !== 0) return null;
        return {
            row: result,
            left: startIndex,
            right: lastIndex
        };
    };
    /**
     * decode codabar code
     * @param row row to cecode
     */ CodaBarReader.prototype.codaBarDecodeRow = function(row) {
        var code = [];
        var barThreshold = Math.ceil(row.reduce(function(pre, item) {
            return (pre + item) / 2;
        }, 0));
        // Read one encoded character at a time.
        while(row.length > 0){
            var seg = row.splice(0, 8).splice(0, 7);
            var key = seg.map(function(len) {
                return len < barThreshold ? "n" : "w";
            }).join("");
            if (this.CODA_BAR_CHAR_SET[key] === undefined) return null;
            code.push(this.CODA_BAR_CHAR_SET[key]);
        }
        var strCode = code.join("");
        if (this.validCodaBarString(strCode)) return strCode;
        return null;
    };
    /**
     * check if the string is a CodaBar string
     * @param src string to determine
     */ CodaBarReader.prototype.validCodaBarString = function(src) {
        var reg = /^[A-D].{1,}[A-D]$/;
        return reg.test(src);
    };
    return CodaBarReader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $e1389124812422eb$export$2e2bcd8739ae039 = $e1389124812422eb$var$CodaBarReader;










var $79dfad1f91e537a3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $79dfad1f91e537a3$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import Integer from '../../util/Integer';
// import Float from '../../util/Float';
var $79dfad1f91e537a3$var$AbstractRSSReader = /** @class */ function(_super) {
    $79dfad1f91e537a3$var$__extends(AbstractRSSReader, _super);
    function AbstractRSSReader() {
        var _this = _super.call(this) || this;
        _this.decodeFinderCounters = new Int32Array(4);
        _this.dataCharacterCounters = new Int32Array(8);
        _this.oddRoundingErrors = new Array(4);
        _this.evenRoundingErrors = new Array(4);
        _this.oddCounts = new Array(_this.dataCharacterCounters.length / 2);
        _this.evenCounts = new Array(_this.dataCharacterCounters.length / 2);
        return _this;
    }
    AbstractRSSReader.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    };
    AbstractRSSReader.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    };
    AbstractRSSReader.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    };
    AbstractRSSReader.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    };
    AbstractRSSReader.prototype.getOddCounts = function() {
        return this.oddCounts;
    };
    AbstractRSSReader.prototype.getEvenCounts = function() {
        return this.evenCounts;
    };
    AbstractRSSReader.prototype.parseFinderValue = function(counters, finderPatterns) {
        for(var value = 0; value < finderPatterns.length; value++){
            if ((0, $2907db4645bc034b$export$2e2bcd8739ae039).patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) return value;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    /**
     * @param array values to sum
     * @return sum of values
     * @deprecated call {@link MathUtils#sum(int[])}
     */ AbstractRSSReader.count = function(array) {
        return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(array));
    };
    AbstractRSSReader.increment = function(array, errors) {
        var index = 0;
        var biggestError = errors[0];
        for(var i = 1; i < array.length; i++)if (errors[i] > biggestError) {
            biggestError = errors[i];
            index = i;
        }
        array[index]++;
    };
    AbstractRSSReader.decrement = function(array, errors) {
        var index = 0;
        var biggestError = errors[0];
        for(var i = 1; i < array.length; i++)if (errors[i] < biggestError) {
            biggestError = errors[i];
            index = i;
        }
        array[index]--;
    };
    AbstractRSSReader.isFinderPattern = function(counters) {
        var e_1, _a;
        var firstTwoSum = counters[0] + counters[1];
        var sum = firstTwoSum + counters[2] + counters[3];
        var ratio = firstTwoSum / sum;
        if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
            // passes ratio test in spec, but see if the counts are unreasonable
            var minCounter = Number.MAX_SAFE_INTEGER;
            var maxCounter = Number.MIN_SAFE_INTEGER;
            try {
                for(var counters_1 = $79dfad1f91e537a3$var$__values(counters), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    if (counter > maxCounter) maxCounter = counter;
                    if (counter < minCounter) minCounter = counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return maxCounter < 10 * minCounter;
        }
        return false;
    };
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12.0;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14.0;
    return AbstractRSSReader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $79dfad1f91e537a3$export$2e2bcd8739ae039 = $79dfad1f91e537a3$var$AbstractRSSReader;


var $e653915cec153e15$var$DataCharacter = /** @class */ function() {
    function DataCharacter(value, checksumPortion) {
        this.value = value;
        this.checksumPortion = checksumPortion;
    }
    DataCharacter.prototype.getValue = function() {
        return this.value;
    };
    DataCharacter.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    };
    DataCharacter.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    };
    DataCharacter.prototype.equals = function(o) {
        if (!(o instanceof DataCharacter)) return false;
        var that = o;
        return this.value === that.value && this.checksumPortion === that.checksumPortion;
    };
    DataCharacter.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    };
    return DataCharacter;
}();
var $e653915cec153e15$export$2e2bcd8739ae039 = $e653915cec153e15$var$DataCharacter;



var $f7def40e6012f42d$var$FinderPattern = /** @class */ function() {
    function FinderPattern(value, startEnd, start, end, rowNumber) {
        this.value = value;
        this.startEnd = startEnd;
        this.value = value;
        this.startEnd = startEnd;
        this.resultPoints = new Array();
        this.resultPoints.push(new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(start, rowNumber));
        this.resultPoints.push(new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(end, rowNumber));
    }
    FinderPattern.prototype.getValue = function() {
        return this.value;
    };
    FinderPattern.prototype.getStartEnd = function() {
        return this.startEnd;
    };
    FinderPattern.prototype.getResultPoints = function() {
        return this.resultPoints;
    };
    FinderPattern.prototype.equals = function(o) {
        if (!(o instanceof FinderPattern)) return false;
        var that = o;
        return this.value === that.value;
    };
    FinderPattern.prototype.hashCode = function() {
        return this.value;
    };
    return FinderPattern;
}();
var $f7def40e6012f42d$export$2e2bcd8739ae039 = $f7def40e6012f42d$var$FinderPattern;


var $23c639eac58be501$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * RSS util functions.
 */ var $23c639eac58be501$var$RSSUtils = /** @class */ function() {
    function RSSUtils() {}
    RSSUtils.getRSSvalue = function(widths, maxWidth, noNarrow) {
        var e_1, _a;
        var n = 0;
        try {
            for(var widths_1 = $23c639eac58be501$var$__values(widths), widths_1_1 = widths_1.next(); !widths_1_1.done; widths_1_1 = widths_1.next()){
                var width = widths_1_1.value;
                n += width;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (widths_1_1 && !widths_1_1.done && (_a = widths_1.return)) _a.call(widths_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var val = 0;
        var narrowMask = 0;
        var elements = widths.length;
        for(var bar = 0; bar < elements - 1; bar++){
            var elmWidth = void 0;
            for(elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)){
                var subVal = RSSUtils.combins(n - elmWidth - 1, elements - bar - 2);
                if (noNarrow && narrowMask === 0 && n - elmWidth - (elements - bar - 1) >= elements - bar - 1) subVal -= RSSUtils.combins(n - elmWidth - (elements - bar), elements - bar - 2);
                if (elements - bar - 1 > 1) {
                    var lessVal = 0;
                    for(var mxwElement = n - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--)lessVal += RSSUtils.combins(n - elmWidth - mxwElement - 1, elements - bar - 3);
                    subVal -= lessVal * (elements - 1 - bar);
                } else if (n - elmWidth > maxWidth) subVal--;
                val += subVal;
            }
            n -= elmWidth;
        }
        return val;
    };
    RSSUtils.combins = function(n, r) {
        var maxDenom;
        var minDenom;
        if (n - r > r) {
            minDenom = r;
            maxDenom = n - r;
        } else {
            minDenom = n - r;
            maxDenom = r;
        }
        var val = 1;
        var j = 1;
        for(var i = n; i > maxDenom; i--){
            val *= i;
            if (j <= minDenom) {
                val /= j;
                j++;
            }
        }
        while(j <= minDenom){
            val /= j;
            j++;
        }
        return val;
    };
    return RSSUtils;
}();
var $23c639eac58be501$export$2e2bcd8739ae039 = $23c639eac58be501$var$RSSUtils;



var $262b8d3f97e25040$var$BitArrayBuilder = /** @class */ function() {
    function BitArrayBuilder() {}
    BitArrayBuilder.buildBitArray = function(pairs) {
        var charNumber = pairs.length * 2 - 1;
        if (pairs[pairs.length - 1].getRightChar() == null) charNumber -= 1;
        var size = 12 * charNumber;
        var binary = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)(size);
        var accPos = 0;
        var firstPair = pairs[0];
        var firstValue = firstPair.getRightChar().getValue();
        for(var i = 11; i >= 0; --i){
            if ((firstValue & 1 << i) !== 0) binary.set(accPos);
            accPos++;
        }
        for(var i = 1; i < pairs.length; ++i){
            var currentPair = pairs[i];
            var leftValue = currentPair.getLeftChar().getValue();
            for(var j = 11; j >= 0; --j){
                if ((leftValue & 1 << j) !== 0) binary.set(accPos);
                accPos++;
            }
            if (currentPair.getRightChar() !== null) {
                var rightValue = currentPair.getRightChar().getValue();
                for(var j = 11; j >= 0; --j){
                    if ((rightValue & 1 << j) !== 0) binary.set(accPos);
                    accPos++;
                }
            }
        }
        return binary;
    };
    return BitArrayBuilder;
}();
var $262b8d3f97e25040$export$2e2bcd8739ae039 = $262b8d3f97e25040$var$BitArrayBuilder;






var $95d7d9a9d5d8482b$var$BlockParsedResult = /** @class */ function() {
    function BlockParsedResult(finished, decodedInformation) {
        if (decodedInformation) this.decodedInformation = null;
        else {
            this.finished = finished;
            this.decodedInformation = decodedInformation;
        }
    }
    BlockParsedResult.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    };
    BlockParsedResult.prototype.isFinished = function() {
        return this.finished;
    };
    return BlockParsedResult;
}();
var $95d7d9a9d5d8482b$export$2e2bcd8739ae039 = $95d7d9a9d5d8482b$var$BlockParsedResult;


var $63f1c8c48f600179$var$DecodedObject = /** @class */ function() {
    function DecodedObject(newPosition) {
        this.newPosition = newPosition;
    }
    DecodedObject.prototype.getNewPosition = function() {
        return this.newPosition;
    };
    return DecodedObject;
}();
var $63f1c8c48f600179$export$2e2bcd8739ae039 = $63f1c8c48f600179$var$DecodedObject;


var $a3450e5bdde9adb6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a3450e5bdde9adb6$var$DecodedChar = /** @class */ function(_super) {
    $a3450e5bdde9adb6$var$__extends(DecodedChar, _super);
    function DecodedChar(newPosition, value) {
        var _this = _super.call(this, newPosition) || this;
        _this.value = value;
        return _this;
    }
    DecodedChar.prototype.getValue = function() {
        return this.value;
    };
    DecodedChar.prototype.isFNC1 = function() {
        return this.value === DecodedChar.FNC1;
    };
    DecodedChar.FNC1 = "$";
    return DecodedChar;
}((0, $63f1c8c48f600179$export$2e2bcd8739ae039));
var $a3450e5bdde9adb6$export$2e2bcd8739ae039 = $a3450e5bdde9adb6$var$DecodedChar;



var $0b9383618990d0f7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0b9383618990d0f7$var$DecodedInformation = /** @class */ function(_super) {
    $0b9383618990d0f7$var$__extends(DecodedInformation, _super);
    function DecodedInformation(newPosition, newString, remainingValue) {
        var _this = _super.call(this, newPosition) || this;
        if (remainingValue) {
            _this.remaining = true;
            _this.remainingValue = _this.remainingValue;
        } else {
            _this.remaining = false;
            _this.remainingValue = 0;
        }
        _this.newString = newString;
        return _this;
    }
    DecodedInformation.prototype.getNewString = function() {
        return this.newString;
    };
    DecodedInformation.prototype.isRemaining = function() {
        return this.remaining;
    };
    DecodedInformation.prototype.getRemainingValue = function() {
        return this.remainingValue;
    };
    return DecodedInformation;
}((0, $63f1c8c48f600179$export$2e2bcd8739ae039));
var $0b9383618990d0f7$export$2e2bcd8739ae039 = $0b9383618990d0f7$var$DecodedInformation;




var $73bf0e6ee888576b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $73bf0e6ee888576b$var$DecodedNumeric = /** @class */ function(_super) {
    $73bf0e6ee888576b$var$__extends(DecodedNumeric, _super);
    function DecodedNumeric(newPosition, firstDigit, secondDigit) {
        var _this = _super.call(this, newPosition) || this;
        if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        _this.firstDigit = firstDigit;
        _this.secondDigit = secondDigit;
        return _this;
    }
    DecodedNumeric.prototype.getFirstDigit = function() {
        return this.firstDigit;
    };
    DecodedNumeric.prototype.getSecondDigit = function() {
        return this.secondDigit;
    };
    DecodedNumeric.prototype.getValue = function() {
        return this.firstDigit * 10 + this.secondDigit;
    };
    DecodedNumeric.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === DecodedNumeric.FNC1;
    };
    DecodedNumeric.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === DecodedNumeric.FNC1;
    };
    DecodedNumeric.prototype.isAnyFNC1 = function() {
        return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
    };
    DecodedNumeric.FNC1 = 10;
    return DecodedNumeric;
}((0, $63f1c8c48f600179$export$2e2bcd8739ae039));
var $73bf0e6ee888576b$export$2e2bcd8739ae039 = $73bf0e6ee888576b$var$DecodedNumeric;



var $396e66059db5077c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $396e66059db5077c$var$FieldParser = /** @class */ function() {
    function FieldParser() {}
    FieldParser.parseFieldsInGeneralPurpose = function(rawInformation) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        if (!rawInformation) return null;
        // Processing 2-digit AIs
        if (rawInformation.length < 2) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var firstTwoDigits = rawInformation.substring(0, 2);
        try {
            for(var _e = $396e66059db5077c$var$__values(FieldParser.TWO_DIGIT_DATA_LENGTH), _f = _e.next(); !_f.done; _f = _e.next()){
                var dataLength = _f.value;
                if (dataLength[0] === firstTwoDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (rawInformation.length < 3) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var firstThreeDigits = rawInformation.substring(0, 3);
        try {
            for(var _g = $396e66059db5077c$var$__values(FieldParser.THREE_DIGIT_DATA_LENGTH), _h = _g.next(); !_h.done; _h = _g.next()){
                var dataLength = _h.value;
                if (dataLength[0] === firstThreeDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _j = $396e66059db5077c$var$__values(FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), _k = _j.next(); !_k.done; _k = _j.next()){
                var dataLength = _k.value;
                if (dataLength[0] === firstThreeDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (rawInformation.length < 4) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var firstFourDigits = rawInformation.substring(0, 4);
        try {
            for(var _l = $396e66059db5077c$var$__values(FieldParser.FOUR_DIGIT_DATA_LENGTH), _m = _l.next(); !_m.done; _m = _l.next()){
                var dataLength = _m.value;
                if (dataLength[0] === firstFourDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    FieldParser.processFixedAI = function(aiSize, fieldSize, rawInformation) {
        if (rawInformation.length < aiSize) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var ai = rawInformation.substring(0, aiSize);
        if (rawInformation.length < aiSize + fieldSize) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var field = rawInformation.substring(aiSize, aiSize + fieldSize);
        var remaining = rawInformation.substring(aiSize + fieldSize);
        var result = "(" + ai + ")" + field;
        var parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
        return parsedAI == null ? result : result + parsedAI;
    };
    FieldParser.processVariableAI = function(aiSize, variableFieldSize, rawInformation) {
        var ai = rawInformation.substring(0, aiSize);
        var maxSize;
        if (rawInformation.length < aiSize + variableFieldSize) maxSize = rawInformation.length;
        else maxSize = aiSize + variableFieldSize;
        var field = rawInformation.substring(aiSize, maxSize);
        var remaining = rawInformation.substring(maxSize);
        var result = "(" + ai + ")" + field;
        var parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
        return parsedAI == null ? result : result + parsedAI;
    };
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            FieldParser.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        // internal company codes
        [
            "90",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            FieldParser.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            "240",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            FieldParser.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            FieldParser.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            "7001",
            13
        ],
        [
            "7002",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            FieldParser.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            FieldParser.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            FieldParser.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            FieldParser.VARIABLE_LENGTH,
            70
        ]
    ];
    return FieldParser;
}();
var $396e66059db5077c$export$2e2bcd8739ae039 = $396e66059db5077c$var$FieldParser;


var $83fac33d549ba324$var$GeneralAppIdDecoder = /** @class */ function() {
    function GeneralAppIdDecoder(information) {
        this.buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        this.information = information;
    }
    GeneralAppIdDecoder.prototype.decodeAllCodes = function(buff, initialPosition) {
        var currentPosition = initialPosition;
        var remaining = null;
        do {
            var info = this.decodeGeneralPurposeField(currentPosition, remaining);
            var parsedFields = (0, $396e66059db5077c$export$2e2bcd8739ae039).parseFieldsInGeneralPurpose(info.getNewString());
            if (parsedFields != null) buff.append(parsedFields);
            if (info.isRemaining()) remaining = "" + info.getRemainingValue();
            else remaining = null;
            if (currentPosition === info.getNewPosition()) break;
            currentPosition = info.getNewPosition();
        }while (true);
        return buff.toString();
    };
    GeneralAppIdDecoder.prototype.isStillNumeric = function(pos) {
        // It's numeric if it still has 7 positions
        // and one of the first 4 bits is "1".
        if (pos + 7 > this.information.getSize()) return pos + 4 <= this.information.getSize();
        for(var i = pos; i < pos + 3; ++i){
            if (this.information.get(i)) return true;
        }
        return this.information.get(pos + 3);
    };
    GeneralAppIdDecoder.prototype.decodeNumeric = function(pos) {
        if (pos + 7 > this.information.getSize()) {
            var numeric_1 = this.extractNumericValueFromBitArray(pos, 4);
            if (numeric_1 === 0) return new (0, $73bf0e6ee888576b$export$2e2bcd8739ae039)(this.information.getSize(), (0, $73bf0e6ee888576b$export$2e2bcd8739ae039).FNC1, (0, $73bf0e6ee888576b$export$2e2bcd8739ae039).FNC1);
            return new (0, $73bf0e6ee888576b$export$2e2bcd8739ae039)(this.information.getSize(), numeric_1 - 1, (0, $73bf0e6ee888576b$export$2e2bcd8739ae039).FNC1);
        }
        var numeric = this.extractNumericValueFromBitArray(pos, 7);
        var digit1 = (numeric - 8) / 11;
        var digit2 = (numeric - 8) % 11;
        return new (0, $73bf0e6ee888576b$export$2e2bcd8739ae039)(pos + 7, digit1, digit2);
    };
    GeneralAppIdDecoder.prototype.extractNumericValueFromBitArray = function(pos, bits) {
        return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
    };
    GeneralAppIdDecoder.extractNumericValueFromBitArray = function(information, pos, bits) {
        var value = 0;
        for(var i = 0; i < bits; ++i)if (information.get(pos + i)) value |= 1 << bits - i - 1;
        return value;
    };
    GeneralAppIdDecoder.prototype.decodeGeneralPurposeField = function(pos, remaining) {
        // this.buffer.setLength(0);
        this.buffer.setLengthToZero();
        if (remaining != null) this.buffer.append(remaining);
        this.current.setPosition(pos);
        var lastDecoded = this.parseBlocks();
        if (lastDecoded != null && lastDecoded.isRemaining()) return new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
        return new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString());
    };
    GeneralAppIdDecoder.prototype.parseBlocks = function() {
        var isFinished;
        var result;
        do {
            var initialPosition = this.current.getPosition();
            if (this.current.isAlpha()) {
                result = this.parseAlphaBlock();
                isFinished = result.isFinished();
            } else if (this.current.isIsoIec646()) {
                result = this.parseIsoIec646Block();
                isFinished = result.isFinished();
            } else {
                result = this.parseNumericBlock();
                isFinished = result.isFinished();
            }
            var positionChanged = initialPosition !== this.current.getPosition();
            if (!positionChanged && !isFinished) break;
        }while (!isFinished);
        return result.getDecodedInformation();
    };
    GeneralAppIdDecoder.prototype.parseNumericBlock = function() {
        while(this.isStillNumeric(this.current.getPosition())){
            var numeric = this.decodeNumeric(this.current.getPosition());
            this.current.setPosition(numeric.getNewPosition());
            if (numeric.isFirstDigitFNC1()) {
                var information = void 0;
                if (numeric.isSecondDigitFNC1()) information = new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString());
                else information = new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
                return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(true, information);
            }
            this.buffer.append(numeric.getFirstDigit());
            if (numeric.isSecondDigitFNC1()) {
                var information = new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString());
                return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(true, information);
            }
            this.buffer.append(numeric.getSecondDigit());
        }
        if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
            this.current.setAlpha();
            this.current.incrementPosition(4);
        }
        return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(false);
    };
    GeneralAppIdDecoder.prototype.parseIsoIec646Block = function() {
        while(this.isStillIsoIec646(this.current.getPosition())){
            var iso = this.decodeIsoIec646(this.current.getPosition());
            this.current.setPosition(iso.getNewPosition());
            if (iso.isFNC1()) {
                var information = new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString());
                return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(true, information);
            }
            this.buffer.append(iso.getValue());
        }
        if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
            this.current.incrementPosition(3);
            this.current.setNumeric();
        } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
            if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
            else this.current.setPosition(this.information.getSize());
            this.current.setAlpha();
        }
        return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(false);
    };
    GeneralAppIdDecoder.prototype.parseAlphaBlock = function() {
        while(this.isStillAlpha(this.current.getPosition())){
            var alpha = this.decodeAlphanumeric(this.current.getPosition());
            this.current.setPosition(alpha.getNewPosition());
            if (alpha.isFNC1()) {
                var information = new (0, $0b9383618990d0f7$export$2e2bcd8739ae039)(this.current.getPosition(), this.buffer.toString());
                return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(true, information); // end of the char block
            }
            this.buffer.append(alpha.getValue());
        }
        if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
            this.current.incrementPosition(3);
            this.current.setNumeric();
        } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
            if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
            else this.current.setPosition(this.information.getSize());
            this.current.setIsoIec646();
        }
        return new (0, $95d7d9a9d5d8482b$export$2e2bcd8739ae039)(false);
    };
    GeneralAppIdDecoder.prototype.isStillIsoIec646 = function(pos) {
        if (pos + 5 > this.information.getSize()) return false;
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
        if (pos + 7 > this.information.getSize()) return false;
        var sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
        if (sevenBitValue >= 64 && sevenBitValue < 116) return true;
        if (pos + 8 > this.information.getSize()) return false;
        var eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
        return eightBitValue >= 232 && eightBitValue < 253;
    };
    GeneralAppIdDecoder.prototype.decodeIsoIec646 = function(pos) {
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue === 15) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 5, (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039).FNC1);
        if (fiveBitValue >= 5 && fiveBitValue < 15) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 5, "0" + (fiveBitValue - 5));
        var sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
        if (sevenBitValue >= 64 && sevenBitValue < 90) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 7, "" + (sevenBitValue + 1));
        if (sevenBitValue >= 90 && sevenBitValue < 116) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 7, "" + (sevenBitValue + 7));
        var eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
        var c;
        switch(eightBitValue){
            case 232:
                c = "!";
                break;
            case 233:
                c = '"';
                break;
            case 234:
                c = "%";
                break;
            case 235:
                c = "&";
                break;
            case 236:
                c = "'";
                break;
            case 237:
                c = "(";
                break;
            case 238:
                c = ")";
                break;
            case 239:
                c = "*";
                break;
            case 240:
                c = "+";
                break;
            case 241:
                c = ",";
                break;
            case 242:
                c = "-";
                break;
            case 243:
                c = ".";
                break;
            case 244:
                c = "/";
                break;
            case 245:
                c = ":";
                break;
            case 246:
                c = ";";
                break;
            case 247:
                c = "<";
                break;
            case 248:
                c = "=";
                break;
            case 249:
                c = ">";
                break;
            case 250:
                c = "?";
                break;
            case 251:
                c = "_";
                break;
            case 252:
                c = " ";
                break;
            default:
                throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        }
        return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 8, c);
    };
    GeneralAppIdDecoder.prototype.isStillAlpha = function(pos) {
        if (pos + 5 > this.information.getSize()) return false;
        // We now check if it's a valid 5-bit value (0..9 and FNC1)
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
        if (pos + 6 > this.information.getSize()) return false;
        var sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
        return sixBitValue >= 16 && sixBitValue < 63; // 63 not included
    };
    GeneralAppIdDecoder.prototype.decodeAlphanumeric = function(pos) {
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue === 15) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 5, (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039).FNC1);
        if (fiveBitValue >= 5 && fiveBitValue < 15) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 5, "0" + (fiveBitValue - 5));
        var sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
        if (sixBitValue >= 32 && sixBitValue < 58) return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 6, "" + (sixBitValue + 33));
        var c;
        switch(sixBitValue){
            case 58:
                c = "*";
                break;
            case 59:
                c = ",";
                break;
            case 60:
                c = "-";
                break;
            case 61:
                c = ".";
                break;
            case 62:
                c = "/";
                break;
            default:
                throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)("Decoding invalid alphanumeric value: " + sixBitValue);
        }
        return new (0, $a3450e5bdde9adb6$export$2e2bcd8739ae039)(pos + 6, c);
    };
    GeneralAppIdDecoder.prototype.isAlphaTo646ToAlphaLatch = function(pos) {
        if (pos + 1 > this.information.getSize()) return false;
        for(var i = 0; i < 5 && i + pos < this.information.getSize(); ++i){
            if (i === 2) {
                if (!this.information.get(pos + 2)) return false;
            } else if (this.information.get(pos + i)) return false;
        }
        return true;
    };
    GeneralAppIdDecoder.prototype.isAlphaOr646ToNumericLatch = function(pos) {
        // Next is alphanumeric if there are 3 positions and they are all zeros
        if (pos + 3 > this.information.getSize()) return false;
        for(var i = pos; i < pos + 3; ++i){
            if (this.information.get(i)) return false;
        }
        return true;
    };
    GeneralAppIdDecoder.prototype.isNumericToAlphaNumericLatch = function(pos) {
        // Next is alphanumeric if there are 4 positions and they are all zeros, or
        // if there is a subset of this just before the end of the symbol
        if (pos + 1 > this.information.getSize()) return false;
        for(var i = 0; i < 4 && i + pos < this.information.getSize(); ++i){
            if (this.information.get(pos + i)) return false;
        }
        return true;
    };
    return GeneralAppIdDecoder;
}();
var $83fac33d549ba324$export$2e2bcd8739ae039 = $83fac33d549ba324$var$GeneralAppIdDecoder;



var $c002d912d35a75c3$var$AbstractExpandedDecoder = /** @class */ function() {
    function AbstractExpandedDecoder(information) {
        this.information = information;
        this.generalDecoder = new (0, $83fac33d549ba324$export$2e2bcd8739ae039)(information);
    }
    AbstractExpandedDecoder.prototype.getInformation = function() {
        return this.information;
    };
    AbstractExpandedDecoder.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    };
    return AbstractExpandedDecoder;
}();
var $c002d912d35a75c3$export$2e2bcd8739ae039 = $c002d912d35a75c3$var$AbstractExpandedDecoder;


var $8cb8db1506c415a1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8cb8db1506c415a1$var$AI01decoder = /** @class */ function(_super) {
    $8cb8db1506c415a1$var$__extends(AI01decoder, _super);
    function AI01decoder(information) {
        return _super.call(this, information) || this;
    }
    AI01decoder.prototype.encodeCompressedGtin = function(buf, currentPos) {
        buf.append("(01)");
        var initialPosition = buf.length();
        buf.append("9");
        this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
    };
    AI01decoder.prototype.encodeCompressedGtinWithoutAI = function(buf, currentPos, initialBufferPosition) {
        for(var i = 0; i < 4; ++i){
            var currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i, 10);
            if (currentBlock / 100 === 0) buf.append("0");
            if (currentBlock / 10 === 0) buf.append("0");
            buf.append(currentBlock);
        }
        AI01decoder.appendCheckDigit(buf, initialBufferPosition);
    };
    AI01decoder.appendCheckDigit = function(buf, currentPos) {
        var checkDigit = 0;
        for(var i = 0; i < 13; i++){
            // let digit = buf.charAt(i + currentPos) - '0';
            // To be checked
            var digit = buf.charAt(i + currentPos).charCodeAt(0) - "0".charCodeAt(0);
            checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
        }
        checkDigit = 10 - checkDigit % 10;
        if (checkDigit === 10) checkDigit = 0;
        buf.append(checkDigit);
    };
    AI01decoder.GTIN_SIZE = 40;
    return AI01decoder;
}((0, $c002d912d35a75c3$export$2e2bcd8739ae039));
var $8cb8db1506c415a1$export$2e2bcd8739ae039 = $8cb8db1506c415a1$var$AI01decoder;



var $715cf25afb5726a3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $715cf25afb5726a3$var$AI01AndOtherAIs = /** @class */ function(_super) {
    $715cf25afb5726a3$var$__extends(AI01AndOtherAIs, _super);
    // the second one is the encodation method, and the other two are for the variable length
    function AI01AndOtherAIs(information) {
        return _super.call(this, information) || this;
    }
    AI01AndOtherAIs.prototype.parseInformation = function() {
        var buff = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        buff.append("(01)");
        var initialGtinPosition = buff.length();
        var firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
        buff.append(firstGtinDigit);
        this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
        return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
    };
    AI01AndOtherAIs.HEADER_SIZE = 4; // first bit encodes the linkage flag,
    return AI01AndOtherAIs;
}((0, $8cb8db1506c415a1$export$2e2bcd8739ae039));
var $715cf25afb5726a3$export$2e2bcd8739ae039 = $715cf25afb5726a3$var$AI01AndOtherAIs;




var $d0098a33ef3464c5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d0098a33ef3464c5$var$AnyAIDecoder = /** @class */ function(_super) {
    $d0098a33ef3464c5$var$__extends(AnyAIDecoder, _super);
    function AnyAIDecoder(information) {
        return _super.call(this, information) || this;
    }
    AnyAIDecoder.prototype.parseInformation = function() {
        var buf = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
    };
    AnyAIDecoder.HEADER_SIZE = 5;
    return AnyAIDecoder;
}((0, $c002d912d35a75c3$export$2e2bcd8739ae039));
var $d0098a33ef3464c5$export$2e2bcd8739ae039 = $d0098a33ef3464c5$var$AnyAIDecoder;



var $c17b0d7217c6997c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c17b0d7217c6997c$var$AI01weightDecoder = /** @class */ function(_super) {
    $c17b0d7217c6997c$var$__extends(AI01weightDecoder, _super);
    function AI01weightDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01weightDecoder.prototype.encodeCompressedWeight = function(buf, currentPos, weightSize) {
        var originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
        this.addWeightCode(buf, originalWeightNumeric);
        var weightNumeric = this.checkWeight(originalWeightNumeric);
        var currentDivisor = 100000;
        for(var i = 0; i < 5; ++i){
            if (weightNumeric / currentDivisor === 0) buf.append("0");
            currentDivisor /= 10;
        }
        buf.append(weightNumeric);
    };
    return AI01weightDecoder;
}((0, $8cb8db1506c415a1$export$2e2bcd8739ae039));
var $c17b0d7217c6997c$export$2e2bcd8739ae039 = $c17b0d7217c6997c$var$AI01weightDecoder;




var $a6be575ebb4797cb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a6be575ebb4797cb$var$AI013x0xDecoder = /** @class */ function(_super) {
    $a6be575ebb4797cb$var$__extends(AI013x0xDecoder, _super);
    function AI013x0xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI013x0xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== AI013x0xDecoder.HEADER_SIZE + (0, $c17b0d7217c6997c$export$2e2bcd8739ae039).GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var buf = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
        this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + (0, $c17b0d7217c6997c$export$2e2bcd8739ae039).GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
        return buf.toString();
    };
    AI013x0xDecoder.HEADER_SIZE = 5;
    AI013x0xDecoder.WEIGHT_SIZE = 15;
    return AI013x0xDecoder;
}((0, $c17b0d7217c6997c$export$2e2bcd8739ae039));
var $a6be575ebb4797cb$export$2e2bcd8739ae039 = $a6be575ebb4797cb$var$AI013x0xDecoder;


var $4744a7c1b8df4d90$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4744a7c1b8df4d90$var$AI013103decoder = /** @class */ function(_super) {
    $4744a7c1b8df4d90$var$__extends(AI013103decoder, _super);
    function AI013103decoder(information) {
        return _super.call(this, information) || this;
    }
    AI013103decoder.prototype.addWeightCode = function(buf, weight) {
        buf.append("(3103)");
    };
    AI013103decoder.prototype.checkWeight = function(weight) {
        return weight;
    };
    return AI013103decoder;
}((0, $a6be575ebb4797cb$export$2e2bcd8739ae039));
var $4744a7c1b8df4d90$export$2e2bcd8739ae039 = $4744a7c1b8df4d90$var$AI013103decoder;



var $8ce3ba4add38232f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8ce3ba4add38232f$var$AI01320xDecoder = /** @class */ function(_super) {
    $8ce3ba4add38232f$var$__extends(AI01320xDecoder, _super);
    function AI01320xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01320xDecoder.prototype.addWeightCode = function(buf, weight) {
        if (weight < 10000) buf.append("(3202)");
        else buf.append("(3203)");
    };
    AI01320xDecoder.prototype.checkWeight = function(weight) {
        if (weight < 10000) return weight;
        return weight - 10000;
    };
    return AI01320xDecoder;
}((0, $a6be575ebb4797cb$export$2e2bcd8739ae039));
var $8ce3ba4add38232f$export$2e2bcd8739ae039 = $8ce3ba4add38232f$var$AI01320xDecoder;





var $3ea23d88da598e3b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3ea23d88da598e3b$var$AI01392xDecoder = /** @class */ function(_super) {
    $3ea23d88da598e3b$var$__extends(AI01392xDecoder, _super);
    function AI01392xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01392xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var buf = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
        var lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
        buf.append("(392");
        buf.append(lastAIdigit);
        buf.append(")");
        var decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
        buf.append(decodedInformation.getNewString());
        return buf.toString();
    };
    AI01392xDecoder.HEADER_SIZE = 8;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;
    return AI01392xDecoder;
}((0, $8cb8db1506c415a1$export$2e2bcd8739ae039));
var $3ea23d88da598e3b$export$2e2bcd8739ae039 = $3ea23d88da598e3b$var$AI01392xDecoder;





var $a74ad2266de7e511$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a74ad2266de7e511$var$AI01393xDecoder = /** @class */ function(_super) {
    $a74ad2266de7e511$var$__extends(AI01393xDecoder, _super);
    function AI01393xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01393xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var buf = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
        var lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
        buf.append("(393");
        buf.append(lastAIdigit);
        buf.append(")");
        var firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
        if (firstThreeDigits / 100 === 0) buf.append("0");
        if (firstThreeDigits / 10 === 0) buf.append("0");
        buf.append(firstThreeDigits);
        var generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + (0, $8cb8db1506c415a1$export$2e2bcd8739ae039).GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
        buf.append(generalInformation.getNewString());
        return buf.toString();
    };
    AI01393xDecoder.HEADER_SIZE = 8;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;
    return AI01393xDecoder;
}((0, $8cb8db1506c415a1$export$2e2bcd8739ae039));
var $a74ad2266de7e511$export$2e2bcd8739ae039 = $a74ad2266de7e511$var$AI01393xDecoder;





var $4ebedad82aa7dcce$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4ebedad82aa7dcce$var$AI013x0x1xDecoder = /** @class */ function(_super) {
    $4ebedad82aa7dcce$var$__extends(AI013x0x1xDecoder, _super);
    function AI013x0x1xDecoder(information, firstAIdigits, dateCode) {
        var _this = _super.call(this, information) || this;
        _this.dateCode = dateCode;
        _this.firstAIdigits = firstAIdigits;
        return _this;
    }
    AI013x0x1xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var buf = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
        this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
        this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
        return buf.toString();
    };
    AI013x0x1xDecoder.prototype.encodeCompressedDate = function(buf, currentPos) {
        var numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
        if (numericDate === 38400) return;
        buf.append("(");
        buf.append(this.dateCode);
        buf.append(")");
        var day = numericDate % 32;
        numericDate /= 32;
        var month = numericDate % 12 + 1;
        numericDate /= 12;
        var year = numericDate;
        if (year / 10 === 0) buf.append("0");
        buf.append(year);
        if (month / 10 === 0) buf.append("0");
        buf.append(month);
        if (day / 10 === 0) buf.append("0");
        buf.append(day);
    };
    AI013x0x1xDecoder.prototype.addWeightCode = function(buf, weight) {
        buf.append("(");
        buf.append(this.firstAIdigits);
        buf.append(weight / 100000);
        buf.append(")");
    };
    AI013x0x1xDecoder.prototype.checkWeight = function(weight) {
        return weight % 100000;
    };
    AI013x0x1xDecoder.HEADER_SIZE = 8;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;
    return AI013x0x1xDecoder;
}((0, $c17b0d7217c6997c$export$2e2bcd8739ae039));
var $4ebedad82aa7dcce$export$2e2bcd8739ae039 = $4ebedad82aa7dcce$var$AI013x0x1xDecoder;


function $a6b3a0673aa2d1e7$export$f8c898e83b60faaa(information) {
    try {
        if (information.get(1)) return new (0, $715cf25afb5726a3$export$2e2bcd8739ae039)(information);
        if (!information.get(2)) return new (0, $d0098a33ef3464c5$export$2e2bcd8739ae039)(information);
        var fourBitEncodationMethod = (0, $83fac33d549ba324$export$2e2bcd8739ae039).extractNumericValueFromBitArray(information, 1, 4);
        switch(fourBitEncodationMethod){
            case 4:
                return new (0, $4744a7c1b8df4d90$export$2e2bcd8739ae039)(information);
            case 5:
                return new (0, $8ce3ba4add38232f$export$2e2bcd8739ae039)(information);
        }
        var fiveBitEncodationMethod = (0, $83fac33d549ba324$export$2e2bcd8739ae039).extractNumericValueFromBitArray(information, 1, 5);
        switch(fiveBitEncodationMethod){
            case 12:
                return new (0, $3ea23d88da598e3b$export$2e2bcd8739ae039)(information);
            case 13:
                return new (0, $a74ad2266de7e511$export$2e2bcd8739ae039)(information);
        }
        var sevenBitEncodationMethod = (0, $83fac33d549ba324$export$2e2bcd8739ae039).extractNumericValueFromBitArray(information, 1, 7);
        switch(sevenBitEncodationMethod){
            case 56:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "310", "11");
            case 57:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "320", "11");
            case 58:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "310", "13");
            case 59:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "320", "13");
            case 60:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "310", "15");
            case 61:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "320", "15");
            case 62:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "310", "17");
            case 63:
                return new (0, $4ebedad82aa7dcce$export$2e2bcd8739ae039)(information, "320", "17");
        }
    } catch (e) {
        console.log(e);
        throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)("unknown decoder: " + information);
    }
}


var $127210635cd8867b$var$ExpandedPair = /** @class */ function() {
    function ExpandedPair(leftChar, rightChar, finderPatter, mayBeLast) {
        this.leftchar = leftChar;
        this.rightchar = rightChar;
        this.finderpattern = finderPatter;
        this.maybeLast = mayBeLast;
    }
    ExpandedPair.prototype.mayBeLast = function() {
        return this.maybeLast;
    };
    ExpandedPair.prototype.getLeftChar = function() {
        return this.leftchar;
    };
    ExpandedPair.prototype.getRightChar = function() {
        return this.rightchar;
    };
    ExpandedPair.prototype.getFinderPattern = function() {
        return this.finderpattern;
    };
    ExpandedPair.prototype.mustBeLast = function() {
        return this.rightchar == null;
    };
    ExpandedPair.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (this.finderpattern == null ? "null" : this.finderpattern.getValue()) + " ]";
    };
    ExpandedPair.equals = function(o1, o2) {
        if (!(o1 instanceof ExpandedPair)) return false;
        return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) && ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) && ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
    };
    ExpandedPair.equalsOrNull = function(o1, o2) {
        return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
    };
    ExpandedPair.prototype.hashCode = function() {
        // return ExpandedPair.hashNotNull(leftChar) ^ hashNotNull(rightChar) ^ hashNotNull(finderPattern);
        var value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
        return value;
    };
    return ExpandedPair;
}();
var $127210635cd8867b$export$2e2bcd8739ae039 = $127210635cd8867b$var$ExpandedPair;


var $a4b1180d6b9325a8$var$ExpandedRow = /** @class */ function() {
    function ExpandedRow(pairs, rowNumber, wasReversed) {
        this.pairs = pairs;
        this.rowNumber = rowNumber;
        this.wasReversed = wasReversed;
    }
    ExpandedRow.prototype.getPairs = function() {
        return this.pairs;
    };
    ExpandedRow.prototype.getRowNumber = function() {
        return this.rowNumber;
    };
    ExpandedRow.prototype.isReversed = function() {
        return this.wasReversed;
    };
    // check implementation
    ExpandedRow.prototype.isEquivalent = function(otherPairs) {
        return this.checkEqualitity(this, otherPairs);
    };
    // @Override
    ExpandedRow.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    };
    /**
     * Two rows are equal if they contain the same pairs in the same order.
     */ // @Override
    // check implementation
    ExpandedRow.prototype.equals = function(o1, o2) {
        if (!(o1 instanceof ExpandedRow)) return false;
        return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
    };
    ExpandedRow.prototype.checkEqualitity = function(pair1, pair2) {
        if (!pair1 || !pair2) return;
        var result;
        pair1.forEach(function(e1, i) {
            pair2.forEach(function(e2) {
                if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) result = true;
            });
        });
        return result;
    };
    return ExpandedRow;
}();
var $a4b1180d6b9325a8$export$2e2bcd8739ae039 = $a4b1180d6b9325a8$var$ExpandedRow;


var $c4ceb29f9e5438c6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c4ceb29f9e5438c6$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.Iterator;
// import java.util.List;
// import java.util.Map;
// import java.util.Collections;
/** @experimental */ var $c4ceb29f9e5438c6$var$RSSExpandedReader = /** @class */ function(_super) {
    $c4ceb29f9e5438c6$var$__extends(RSSExpandedReader, _super);
    function RSSExpandedReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
        _this.rows = new Array();
        _this.startEnd = [
            2
        ];
        return _this;
    }
    RSSExpandedReader.prototype.decodeRow = function(rowNumber, row, hints) {
        // Rows can start with even pattern in case in prev rows there where odd number of patters.
        // So lets try twice
        // this.pairs.clear();
        this.pairs.length = 0;
        this.startFromEven = false;
        try {
            return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        } catch (e) {
        // OK
        // console.log(e);
        }
        this.pairs.length = 0;
        this.startFromEven = true;
        return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
    };
    RSSExpandedReader.prototype.reset = function() {
        this.pairs.length = 0;
        this.rows.length = 0;
    };
    // Not private for testing
    RSSExpandedReader.prototype.decodeRow2pairs = function(rowNumber, row) {
        var done = false;
        while(!done)try {
            this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
        } catch (error) {
            if (error instanceof (0, $283aa2ad27179317$export$2e2bcd8739ae039)) {
                if (!this.pairs.length) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                // exit this loop when retrieveNextPair() fails and throws
                done = true;
            }
        }
        // TODO: verify sequence of finder patterns as in checkPairSequence()
        if (this.checkChecksum()) return this.pairs;
        var tryStackedDecode;
        if (this.rows.length) tryStackedDecode = true;
        else tryStackedDecode = false;
        // let tryStackedDecode = !this.rows.isEmpty();
        this.storeRow(rowNumber, false); // TODO: deal with reversed rows
        if (tryStackedDecode) {
            // When the image is 180-rotated, then rows are sorted in wrong direction.
            // Try twice with both the directions.
            var ps = this.checkRowsBoolean(false);
            if (ps != null) return ps;
            ps = this.checkRowsBoolean(true);
            if (ps != null) return ps;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    // Need to Verify
    RSSExpandedReader.prototype.checkRowsBoolean = function(reverse) {
        // Limit number of rows we are checking
        // We use recursive algorithm with pure complexity and don't want it to take forever
        // Stacked barcode can have up to 11 rows, so 25 seems reasonable enough
        if (this.rows.length > 25) {
            this.rows.length = 0; // We will never have a chance to get result, so clear it
            return null;
        }
        this.pairs.length = 0;
        if (reverse) this.rows = this.rows.reverse();
        var ps = null;
        try {
            ps = this.checkRows(new Array(), 0);
        } catch (e) {
            // OK
            console.log(e);
        }
        if (reverse) this.rows = this.rows.reverse();
        return ps;
    };
    // Try to construct a valid rows sequence
    // Recursion is used to implement backtracking
    RSSExpandedReader.prototype.checkRows = function(collectedRows, currentRow) {
        var e_1, _a;
        for(var i = currentRow; i < this.rows.length; i++){
            var row = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var collectedRows_1 = (e_1 = void 0, $c4ceb29f9e5438c6$var$__values(collectedRows)), collectedRows_1_1 = collectedRows_1.next(); !collectedRows_1_1.done; collectedRows_1_1 = collectedRows_1.next()){
                    var collectedRow = collectedRows_1_1.value;
                    this.pairs.push(collectedRow.getPairs());
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (collectedRows_1_1 && !collectedRows_1_1.done && (_a = collectedRows_1.return)) _a.call(collectedRows_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.pairs.push(row.getPairs());
            if (!RSSExpandedReader.isValidSequence(this.pairs)) continue;
            if (this.checkChecksum()) return this.pairs;
            var rs = new Array(collectedRows);
            rs.push(row);
            try {
                // Recursion: try to add more rows
                return this.checkRows(rs, i + 1);
            } catch (e) {
                // We failed, try the next candidate
                console.log(e);
            }
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    // Whether the pairs form a valid find pattern sequence,
    // either complete or a prefix
    RSSExpandedReader.isValidSequence = function(pairs) {
        var e_2, _a;
        try {
            for(var _b = $c4ceb29f9e5438c6$var$__values(RSSExpandedReader.FINDER_PATTERN_SEQUENCES), _c = _b.next(); !_c.done; _c = _b.next()){
                var sequence = _c.value;
                if (pairs.length > sequence.length) continue;
                var stop_1 = true;
                for(var j = 0; j < pairs.length; j++)if (pairs[j].getFinderPattern().getValue() !== sequence[j]) {
                    stop_1 = false;
                    break;
                }
                if (stop_1) return true;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return false;
    };
    RSSExpandedReader.prototype.storeRow = function(rowNumber, wasReversed) {
        // Discard if duplicate above or below; otherwise insert in order by row number.
        var insertPos = 0;
        var prevIsSame = false;
        var nextIsSame = false;
        while(insertPos < this.rows.length){
            var erow = this.rows[insertPos];
            if (erow.getRowNumber() > rowNumber) {
                nextIsSame = erow.isEquivalent(this.pairs);
                break;
            }
            prevIsSame = erow.isEquivalent(this.pairs);
            insertPos++;
        }
        if (nextIsSame || prevIsSame) return;
        // When the row was partially decoded (e.g. 2 pairs found instead of 3),
        // it will prevent us from detecting the barcode.
        // Try to merge partial rows
        // Check whether the row is part of an allready detected row
        if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) return;
        this.rows.push(insertPos, new (0, $a4b1180d6b9325a8$export$2e2bcd8739ae039)(this.pairs, rowNumber, wasReversed));
        this.removePartialRows(this.pairs, this.rows);
    };
    // Remove all the rows that contains only specified pairs
    RSSExpandedReader.prototype.removePartialRows = function(pairs, rows) {
        var e_3, _a, e_4, _b, e_5, _c;
        try {
            // for (Iterator<ExpandedRow> iterator = rows.iterator(); iterator.hasNext();) {
            //   ExpandedRow r = iterator.next();
            //   if (r.getPairs().size() == pairs.size()) {
            //     continue;
            //   }
            //   boolean allFound = true;
            //   for (ExpandedPair p : r.getPairs()) {
            //     boolean found = false;
            //     for (ExpandedPair pp : pairs) {
            //       if (p.equals(pp)) {
            //         found = true;
            //         break;
            //       }
            //     }
            //     if (!found) {
            //       allFound = false;
            //       break;
            //     }
            //   }
            //   if (allFound) {
            //     // 'pairs' contains all the pairs from the row 'r'
            //     iterator.remove();
            //   }
            // }
            for(var rows_1 = $c4ceb29f9e5438c6$var$__values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()){
                var row = rows_1_1.value;
                if (row.getPairs().length === pairs.length) continue;
                var allFound = true;
                try {
                    for(var _d = (e_4 = void 0, $c4ceb29f9e5438c6$var$__values(row.getPairs())), _e = _d.next(); !_e.done; _e = _d.next()){
                        var p = _e.value;
                        var found = false;
                        try {
                            for(var pairs_1 = (e_5 = void 0, $c4ceb29f9e5438c6$var$__values(pairs)), pairs_1_1 = pairs_1.next(); !pairs_1_1.done; pairs_1_1 = pairs_1.next()){
                                var pp = pairs_1_1.value;
                                if ((0, $127210635cd8867b$export$2e2bcd8739ae039).equals(p, pp)) {
                                    found = true;
                                    break;
                                }
                            }
                        } catch (e_5_1) {
                            e_5 = {
                                error: e_5_1
                            };
                        } finally{
                            try {
                                if (pairs_1_1 && !pairs_1_1.done && (_c = pairs_1.return)) _c.call(pairs_1);
                            } finally{
                                if (e_5) throw e_5.error;
                            }
                        }
                        if (!found) allFound = false;
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    // Returns true when one of the rows already contains all the pairs
    RSSExpandedReader.isPartialRow = function(pairs, rows) {
        var e_6, _a, e_7, _b, e_8, _c;
        try {
            for(var rows_2 = $c4ceb29f9e5438c6$var$__values(rows), rows_2_1 = rows_2.next(); !rows_2_1.done; rows_2_1 = rows_2.next()){
                var r = rows_2_1.value;
                var allFound = true;
                try {
                    for(var pairs_2 = (e_7 = void 0, $c4ceb29f9e5438c6$var$__values(pairs)), pairs_2_1 = pairs_2.next(); !pairs_2_1.done; pairs_2_1 = pairs_2.next()){
                        var p = pairs_2_1.value;
                        var found = false;
                        try {
                            for(var _d = (e_8 = void 0, $c4ceb29f9e5438c6$var$__values(r.getPairs())), _e = _d.next(); !_e.done; _e = _d.next()){
                                var pp = _e.value;
                                if (p.equals(pp)) {
                                    found = true;
                                    break;
                                }
                            }
                        } catch (e_8_1) {
                            e_8 = {
                                error: e_8_1
                            };
                        } finally{
                            try {
                                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                            } finally{
                                if (e_8) throw e_8.error;
                            }
                        }
                        if (!found) {
                            allFound = false;
                            break;
                        }
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (pairs_2_1 && !pairs_2_1.done && (_b = pairs_2.return)) _b.call(pairs_2);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
                if (allFound) // the row 'r' contain all the pairs from 'pairs'
                return true;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (rows_2_1 && !rows_2_1.done && (_a = rows_2.return)) _a.call(rows_2);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return false;
    };
    // Only used for unit testing
    RSSExpandedReader.prototype.getRows = function() {
        return this.rows;
    };
    // Not private for unit testing
    RSSExpandedReader.constructResult = function(pairs) {
        var binary = (0, $262b8d3f97e25040$export$2e2bcd8739ae039).buildBitArray(pairs);
        var decoder = (0, $a6b3a0673aa2d1e7$export$f8c898e83b60faaa)(binary);
        var resultingString = decoder.parseInformation();
        var firstPoints = pairs[0].getFinderPattern().getResultPoints();
        var lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
        var points = [
            firstPoints[0],
            firstPoints[1],
            lastPoints[0],
            lastPoints[1]
        ];
        return new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(resultingString, null, null, points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).RSS_EXPANDED, null);
    };
    RSSExpandedReader.prototype.checkChecksum = function() {
        var firstPair = this.pairs.get(0);
        var checkCharacter = firstPair.getLeftChar();
        var firstCharacter = firstPair.getRightChar();
        if (firstCharacter === null) return false;
        var checksum = firstCharacter.getChecksumPortion();
        var s = 2;
        for(var i = 1; i < this.pairs.size(); ++i){
            var currentPair = this.pairs.get(i);
            checksum += currentPair.getLeftChar().getChecksumPortion();
            s++;
            var currentRightChar = currentPair.getRightChar();
            if (currentRightChar != null) {
                checksum += currentRightChar.getChecksumPortion();
                s++;
            }
        }
        checksum %= 211;
        var checkCharacterValue = 211 * (s - 4) + checksum;
        return checkCharacterValue === checkCharacter.getValue();
    };
    RSSExpandedReader.getNextSecondBar = function(row, initialPos) {
        var currentPos;
        if (row.get(initialPos)) {
            currentPos = row.getNextUnset(initialPos);
            currentPos = row.getNextSet(currentPos);
        } else {
            currentPos = row.getNextSet(initialPos);
            currentPos = row.getNextUnset(currentPos);
        }
        return currentPos;
    };
    // not private for testing
    RSSExpandedReader.prototype.retrieveNextPair = function(row, previousPairs, rowNumber) {
        var isOddPattern = previousPairs.length % 2 === 0;
        if (this.startFromEven) isOddPattern = !isOddPattern;
        var pattern;
        var keepFinding = true;
        var forcedOffset = -1;
        do {
            this.findNextPair(row, previousPairs, forcedOffset);
            pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
            if (pattern === null) forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
            else keepFinding = false;
        }while (keepFinding);
        // When stacked symbol is split over multiple rows, there's no way to guess if this pair can be last or not.
        // boolean mayBeLast = checkPairSequence(previousPairs, pattern);
        var leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
        if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var rightChar;
        try {
            rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
        } catch (e) {
            rightChar = null;
            console.log(e);
        }
        return new (0, $127210635cd8867b$export$2e2bcd8739ae039)(leftChar, rightChar, pattern, true);
    };
    RSSExpandedReader.prototype.isEmptyPair = function(pairs) {
        if (pairs.length === 0) return true;
        return false;
    };
    RSSExpandedReader.prototype.findNextPair = function(row, previousPairs, forcedOffset) {
        var counters = this.getDecodeFinderCounters();
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var width = row.getSize();
        var rowOffset;
        if (forcedOffset >= 0) rowOffset = forcedOffset;
        else if (this.isEmptyPair(previousPairs)) rowOffset = 0;
        else {
            var lastPair = previousPairs[previousPairs.length - 1];
            rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
        }
        var searchingEvenPair = previousPairs.length % 2 !== 0;
        if (this.startFromEven) searchingEvenPair = !searchingEvenPair;
        var isWhite = false;
        while(rowOffset < width){
            isWhite = !row.get(rowOffset);
            if (!isWhite) break;
            rowOffset++;
        }
        var counterPosition = 0;
        var patternStart = rowOffset;
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === 3) {
                if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                if (RSSExpandedReader.isFinderPattern(counters)) {
                    this.startEnd[0] = patternStart;
                    this.startEnd[1] = x;
                    return;
                }
                if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                patternStart += counters[0] + counters[1];
                counters[0] = counters[2];
                counters[1] = counters[3];
                counters[2] = 0;
                counters[3] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    RSSExpandedReader.reverseCounters = function(counters) {
        var length = counters.length;
        for(var i = 0; i < length / 2; ++i){
            var tmp = counters[i];
            counters[i] = counters[length - i - 1];
            counters[length - i - 1] = tmp;
        }
    };
    RSSExpandedReader.prototype.parseFoundFinderPattern = function(row, rowNumber, oddPattern) {
        // Actually we found elements 2-5.
        var firstCounter;
        var start;
        var end;
        if (oddPattern) {
            // If pattern number is odd, we need to locate element 1 *before* the current block.
            var firstElementStart = this.startEnd[0] - 1;
            // Locate element 1
            while(firstElementStart >= 0 && !row.get(firstElementStart))firstElementStart--;
            firstElementStart++;
            firstCounter = this.startEnd[0] - firstElementStart;
            start = firstElementStart;
            end = this.startEnd[1];
        } else {
            // If pattern number is even, the pattern is reversed, so we need to locate element 1 *after* the current block.
            start = this.startEnd[0];
            end = row.getNextUnset(this.startEnd[1] + 1);
            firstCounter = end - this.startEnd[1];
        }
        // Make 'counters' hold 1-4
        var counters = this.getDecodeFinderCounters();
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(counters, 0, counters, 1, counters.length - 1);
        counters[0] = firstCounter;
        var value;
        try {
            value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
        } catch (e) {
            return null;
        }
        // return new FinderPattern(value, new int[] { start, end }, start, end, rowNumber});
        return new (0, $f7def40e6012f42d$export$2e2bcd8739ae039)(value, [
            start,
            end
        ], start, end, rowNumber);
    };
    RSSExpandedReader.prototype.decodeDataCharacter = function(row, pattern, isOddPattern, leftChar) {
        var counters = this.getDataCharacterCounters();
        for(var x = 0; x < counters.length; x++)counters[x] = 0;
        if (leftChar) RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
        else {
            RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
            // reverse it
            for(var i = 0, j = counters.length - 1; i < j; i++, j--){
                var temp = counters[i];
                counters[i] = counters[j];
                counters[j] = temp;
            }
        } // counters[] has the pixels of the module
        var numModules = 17; // left and right data characters have all the same length
        var elementWidth = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(counters)) / numModules;
        // Sanity check: element width for pattern and the character should match
        var expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15.0;
        if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var oddCounts = this.getOddCounts();
        var evenCounts = this.getEvenCounts();
        var oddRoundingErrors = this.getOddRoundingErrors();
        var evenRoundingErrors = this.getEvenRoundingErrors();
        for(var i = 0; i < counters.length; i++){
            var value_1 = 1.0 * counters[i] / elementWidth;
            var count = value_1 + 0.5; // Round
            if (count < 1) {
                if (value_1 < 0.3) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                count = 1;
            } else if (count > 8) {
                if (value_1 > 8.7) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                count = 8;
            }
            var offset = i / 2;
            if ((i & 0x01) === 0) {
                oddCounts[offset] = count;
                oddRoundingErrors[offset] = value_1 - count;
            } else {
                evenCounts[offset] = count;
                evenRoundingErrors[offset] = value_1 - count;
            }
        }
        this.adjustOddEvenCounts(numModules);
        var weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
        var oddSum = 0;
        var oddChecksumPortion = 0;
        for(var i = oddCounts.length - 1; i >= 0; i--){
            if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                var weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i];
                oddChecksumPortion += oddCounts[i] * weight;
            }
            oddSum += oddCounts[i];
        }
        var evenChecksumPortion = 0;
        // int evenSum = 0;
        for(var i = evenCounts.length - 1; i >= 0; i--)if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
            var weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i + 1];
            evenChecksumPortion += evenCounts[i] * weight;
        }
        var checksumPortion = oddChecksumPortion + evenChecksumPortion;
        if ((oddSum & 0x01) !== 0 || oddSum > 13 || oddSum < 4) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var group = (13 - oddSum) / 2;
        var oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
        var evenWidest = 9 - oddWidest;
        var vOdd = (0, $23c639eac58be501$export$2e2bcd8739ae039).getRSSvalue(oddCounts, oddWidest, true);
        var vEven = (0, $23c639eac58be501$export$2e2bcd8739ae039).getRSSvalue(evenCounts, evenWidest, false);
        var tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
        var gSum = RSSExpandedReader.GSUM[group];
        var value = vOdd * tEven + vEven + gSum;
        return new (0, $e653915cec153e15$export$2e2bcd8739ae039)(value, checksumPortion);
    };
    RSSExpandedReader.isNotA1left = function(pattern, isOddPattern, leftChar) {
        // A1: pattern.getValue is 0 (A), and it's an oddPattern, and it is a left char
        return !(pattern.getValue() === 0 && isOddPattern && leftChar);
    };
    RSSExpandedReader.prototype.adjustOddEvenCounts = function(numModules) {
        var oddSum = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(this.getOddCounts()));
        var evenSum = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(this.getEvenCounts()));
        var incrementOdd = false;
        var decrementOdd = false;
        if (oddSum > 13) decrementOdd = true;
        else if (oddSum < 4) incrementOdd = true;
        var incrementEven = false;
        var decrementEven = false;
        if (evenSum > 13) decrementEven = true;
        else if (evenSum < 4) incrementEven = true;
        var mismatch = oddSum + evenSum - numModules;
        var oddParityBad = (oddSum & 0x01) === 1;
        var evenParityBad = (evenSum & 0x01) === 0;
        if (mismatch === 1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                decrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                decrementEven = true;
            }
        } else if (mismatch === -1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                incrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                incrementEven = true;
            }
        } else if (mismatch === 0) {
            if (oddParityBad) {
                if (!evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                // Both bad
                if (oddSum < evenSum) {
                    incrementOdd = true;
                    decrementEven = true;
                } else {
                    decrementOdd = true;
                    incrementEven = true;
                }
            } else {
                if (evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            // Nothing to do!
            }
        } else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (incrementOdd) {
            if (decrementOdd) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (decrementOdd) RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
        if (incrementEven) {
            if (decrementEven) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        if (decrementEven) RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    };
    RSSExpandedReader.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ];
    RSSExpandedReader.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ];
    RSSExpandedReader.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ];
    RSSExpandedReader.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_C
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ]
    ];
    RSSExpandedReader.MAX_PAIRS = 11;
    return RSSExpandedReader;
}((0, $79dfad1f91e537a3$export$2e2bcd8739ae039));
var $c4ceb29f9e5438c6$export$2e2bcd8739ae039 = $c4ceb29f9e5438c6$var$RSSExpandedReader;




var $4a36491a94280b3d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4a36491a94280b3d$var$Pair = /** @class */ function(_super) {
    $4a36491a94280b3d$var$__extends(Pair, _super);
    function Pair(value, checksumPortion, finderPattern) {
        var _this = _super.call(this, value, checksumPortion) || this;
        _this.count = 0;
        _this.finderPattern = finderPattern;
        return _this;
    }
    Pair.prototype.getFinderPattern = function() {
        return this.finderPattern;
    };
    Pair.prototype.getCount = function() {
        return this.count;
    };
    Pair.prototype.incrementCount = function() {
        this.count++;
    };
    return Pair;
}((0, $e653915cec153e15$export$2e2bcd8739ae039));
var $4a36491a94280b3d$export$2e2bcd8739ae039 = $4a36491a94280b3d$var$Pair;














var $c41face4ec8fcb8d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c41face4ec8fcb8d$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $c41face4ec8fcb8d$var$RSS14Reader = /** @class */ function(_super) {
    $c41face4ec8fcb8d$var$__extends(RSS14Reader, _super);
    function RSS14Reader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.possibleLeftPairs = [];
        _this.possibleRightPairs = [];
        return _this;
    }
    RSS14Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a, e_2, _b;
        var leftPair = this.decodePair(row, false, rowNumber, hints);
        RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
        row.reverse();
        var rightPair = this.decodePair(row, true, rowNumber, hints);
        RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
        row.reverse();
        try {
            for(var _c = $c41face4ec8fcb8d$var$__values(this.possibleLeftPairs), _d = _c.next(); !_d.done; _d = _c.next()){
                var left = _d.value;
                if (left.getCount() > 1) try {
                    for(var _e = (e_2 = void 0, $c41face4ec8fcb8d$var$__values(this.possibleRightPairs)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var right = _f.value;
                        if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) return RSS14Reader.constructResult(left, right);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    RSS14Reader.addOrTally = function(possiblePairs, pair) {
        var e_3, _a;
        if (pair == null) return;
        var found = false;
        try {
            for(var possiblePairs_1 = $c41face4ec8fcb8d$var$__values(possiblePairs), possiblePairs_1_1 = possiblePairs_1.next(); !possiblePairs_1_1.done; possiblePairs_1_1 = possiblePairs_1.next()){
                var other = possiblePairs_1_1.value;
                if (other.getValue() === pair.getValue()) {
                    other.incrementCount();
                    found = true;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (possiblePairs_1_1 && !possiblePairs_1_1.done && (_a = possiblePairs_1.return)) _a.call(possiblePairs_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!found) possiblePairs.push(pair);
    };
    RSS14Reader.prototype.reset = function() {
        this.possibleLeftPairs.length = 0;
        this.possibleRightPairs.length = 0;
    };
    RSS14Reader.constructResult = function(leftPair, rightPair) {
        var symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
        var text = new String(symbolValue).toString();
        var buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        for(var i = 13 - text.length; i > 0; i--)buffer.append("0");
        buffer.append(text);
        var checkDigit = 0;
        for(var i = 0; i < 13; i++){
            var digit = buffer.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
        }
        checkDigit = 10 - checkDigit % 10;
        if (checkDigit === 10) checkDigit = 0;
        buffer.append(checkDigit.toString());
        var leftPoints = leftPair.getFinderPattern().getResultPoints();
        var rightPoints = rightPair.getFinderPattern().getResultPoints();
        return new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(buffer.toString(), null, 0, [
            leftPoints[0],
            leftPoints[1],
            rightPoints[0],
            rightPoints[1]
        ], (0, $03ea32520a329dec$export$2e2bcd8739ae039).RSS_14, new Date().getTime());
    };
    RSS14Reader.checkChecksum = function(leftPair, rightPair) {
        var checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
        var targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
        if (targetCheckValue > 72) targetCheckValue--;
        if (targetCheckValue > 8) targetCheckValue--;
        return checkValue === targetCheckValue;
    };
    RSS14Reader.prototype.decodePair = function(row, right, rowNumber, hints) {
        try {
            var startEnd = this.findFinderPattern(row, right);
            var pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
            var resultPointCallback = hints == null ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).NEED_RESULT_POINT_CALLBACK);
            if (resultPointCallback != null) {
                var center = (startEnd[0] + startEnd[1]) / 2.0;
                if (right) // row is actually reversed
                center = row.getSize() - 1 - center;
                resultPointCallback.foundPossibleResultPoint(new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(center, rowNumber));
            }
            var outside = this.decodeDataCharacter(row, pattern, true);
            var inside = this.decodeDataCharacter(row, pattern, false);
            return new (0, $4a36491a94280b3d$export$2e2bcd8739ae039)(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
        } catch (err) {
            return null;
        }
    };
    RSS14Reader.prototype.decodeDataCharacter = function(row, pattern, outsideChar) {
        var counters = this.getDataCharacterCounters();
        for(var x = 0; x < counters.length; x++)counters[x] = 0;
        if (outsideChar) (0, $2907db4645bc034b$export$2e2bcd8739ae039).recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
        else {
            (0, $2907db4645bc034b$export$2e2bcd8739ae039).recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
            // reverse it
            for(var i = 0, j = counters.length - 1; i < j; i++, j--){
                var temp = counters[i];
                counters[i] = counters[j];
                counters[j] = temp;
            }
        }
        var numModules = outsideChar ? 16 : 15;
        var elementWidth = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(counters)) / numModules;
        var oddCounts = this.getOddCounts();
        var evenCounts = this.getEvenCounts();
        var oddRoundingErrors = this.getOddRoundingErrors();
        var evenRoundingErrors = this.getEvenRoundingErrors();
        for(var i = 0; i < counters.length; i++){
            var value = counters[i] / elementWidth;
            var count = Math.floor(value + 0.5);
            if (count < 1) count = 1;
            else if (count > 8) count = 8;
            var offset = Math.floor(i / 2);
            if ((i & 0x01) === 0) {
                oddCounts[offset] = count;
                oddRoundingErrors[offset] = value - count;
            } else {
                evenCounts[offset] = count;
                evenRoundingErrors[offset] = value - count;
            }
        }
        this.adjustOddEvenCounts(outsideChar, numModules);
        var oddSum = 0;
        var oddChecksumPortion = 0;
        for(var i = oddCounts.length - 1; i >= 0; i--){
            oddChecksumPortion *= 9;
            oddChecksumPortion += oddCounts[i];
            oddSum += oddCounts[i];
        }
        var evenChecksumPortion = 0;
        var evenSum = 0;
        for(var i = evenCounts.length - 1; i >= 0; i--){
            evenChecksumPortion *= 9;
            evenChecksumPortion += evenCounts[i];
            evenSum += evenCounts[i];
        }
        var checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
        if (outsideChar) {
            if ((oddSum & 0x01) !== 0 || oddSum > 12 || oddSum < 4) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            var group = (12 - oddSum) / 2;
            var oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
            var evenWidest = 9 - oddWidest;
            var vOdd = (0, $23c639eac58be501$export$2e2bcd8739ae039).getRSSvalue(oddCounts, oddWidest, false);
            var vEven = (0, $23c639eac58be501$export$2e2bcd8739ae039).getRSSvalue(evenCounts, evenWidest, true);
            var tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
            var gSum = RSS14Reader.OUTSIDE_GSUM[group];
            return new (0, $e653915cec153e15$export$2e2bcd8739ae039)(vOdd * tEven + vEven + gSum, checksumPortion);
        } else {
            if ((evenSum & 0x01) !== 0 || evenSum > 10 || evenSum < 4) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            var group = (10 - evenSum) / 2;
            var oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
            var evenWidest = 9 - oddWidest;
            var vOdd = (0, $23c639eac58be501$export$2e2bcd8739ae039).getRSSvalue(oddCounts, oddWidest, true);
            var vEven = (0, $23c639eac58be501$export$2e2bcd8739ae039).getRSSvalue(evenCounts, evenWidest, false);
            var tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
            var gSum = RSS14Reader.INSIDE_GSUM[group];
            return new (0, $e653915cec153e15$export$2e2bcd8739ae039)(vEven * tOdd + vOdd + gSum, checksumPortion);
        }
    };
    RSS14Reader.prototype.findFinderPattern = function(row, rightFinderPattern) {
        var counters = this.getDecodeFinderCounters();
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var width = row.getSize();
        var isWhite = false;
        var rowOffset = 0;
        while(rowOffset < width){
            isWhite = !row.get(rowOffset);
            if (rightFinderPattern === isWhite) break;
            rowOffset++;
        }
        var counterPosition = 0;
        var patternStart = rowOffset;
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === 3) {
                if ((0, $79dfad1f91e537a3$export$2e2bcd8739ae039).isFinderPattern(counters)) return [
                    patternStart,
                    x
                ];
                patternStart += counters[0] + counters[1];
                counters[0] = counters[2];
                counters[1] = counters[3];
                counters[2] = 0;
                counters[3] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    RSS14Reader.prototype.parseFoundFinderPattern = function(row, rowNumber, right, startEnd) {
        // Actually we found elements 2-5
        var firstIsBlack = row.get(startEnd[0]);
        var firstElementStart = startEnd[0] - 1;
        // Locate element 1
        while(firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart))firstElementStart--;
        firstElementStart++;
        var firstCounter = startEnd[0] - firstElementStart;
        // Make 'counters' hold 1-4
        var counters = this.getDecodeFinderCounters();
        var copy = new Int32Array(counters.length);
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(counters, 0, copy, 1, counters.length - 1);
        copy[0] = firstCounter;
        var value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
        var start = firstElementStart;
        var end = startEnd[1];
        if (right) {
            // row is actually reversed
            start = row.getSize() - 1 - start;
            end = row.getSize() - 1 - end;
        }
        return new (0, $f7def40e6012f42d$export$2e2bcd8739ae039)(value, [
            firstElementStart,
            startEnd[1]
        ], start, end, rowNumber);
    };
    RSS14Reader.prototype.adjustOddEvenCounts = function(outsideChar, numModules) {
        var oddSum = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(this.getOddCounts()));
        var evenSum = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(new Int32Array(this.getEvenCounts()));
        var incrementOdd = false;
        var decrementOdd = false;
        var incrementEven = false;
        var decrementEven = false;
        if (outsideChar) {
            if (oddSum > 12) decrementOdd = true;
            else if (oddSum < 4) incrementOdd = true;
            if (evenSum > 12) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
        } else {
            if (oddSum > 11) decrementOdd = true;
            else if (oddSum < 5) incrementOdd = true;
            if (evenSum > 10) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
        }
        var mismatch = oddSum + evenSum - numModules;
        var oddParityBad = (oddSum & 0x01) === (outsideChar ? 1 : 0);
        var evenParityBad = (evenSum & 0x01) === 1;
        if (mismatch === 1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                decrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                decrementEven = true;
            }
        } else if (mismatch === -1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                incrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                incrementEven = true;
            }
        } else if (mismatch === 0) {
            if (oddParityBad) {
                if (!evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
                // Both bad
                if (oddSum < evenSum) {
                    incrementOdd = true;
                    decrementEven = true;
                } else {
                    decrementOdd = true;
                    incrementEven = true;
                }
            } else {
                if (evenParityBad) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            // Nothing to do!
            }
        } else throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (incrementOdd) {
            if (decrementOdd) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            (0, $79dfad1f91e537a3$export$2e2bcd8739ae039).increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (decrementOdd) (0, $79dfad1f91e537a3$export$2e2bcd8739ae039).decrement(this.getOddCounts(), this.getOddRoundingErrors());
        if (incrementEven) {
            if (decrementEven) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            (0, $79dfad1f91e537a3$export$2e2bcd8739ae039).increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        if (decrementEven) (0, $79dfad1f91e537a3$export$2e2bcd8739ae039).decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    };
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ];
    RSS14Reader.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ];
    RSS14Reader.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ];
    RSS14Reader.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ];
    RSS14Reader.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ];
    return RSS14Reader;
}((0, $79dfad1f91e537a3$export$2e2bcd8739ae039));
var $c41face4ec8fcb8d$export$2e2bcd8739ae039 = $c41face4ec8fcb8d$var$RSS14Reader;


var $9f6904b1e7c47f99$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @author Daniel Switkin <dswitkin@google.com>
 * @author Sean Owen
 */ var $9f6904b1e7c47f99$var$MultiFormatOneDReader = /** @class */ function(_super) {
    $9f6904b1e7c47f99$var$__extends(MultiFormatOneDReader, _super);
    function MultiFormatOneDReader(hints) {
        var _this = _super.call(this) || this;
        _this.readers = [];
        var possibleFormats = !hints ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).POSSIBLE_FORMATS);
        var useCode39CheckDigit = hints && hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).ASSUME_CODE_39_CHECK_DIGIT) !== undefined;
        if (possibleFormats) {
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13) || possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A) || possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_8) || possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_E)) _this.readers.push(new (0, $d716d6460a89b943$export$2e2bcd8739ae039)(hints));
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_39)) _this.readers.push(new (0, $80bc94e3cee10a11$export$2e2bcd8739ae039)(useCode39CheckDigit));
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_93)) _this.readers.push(new (0, $055b6bd23ef58e1b$export$2e2bcd8739ae039)());
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_128)) _this.readers.push(new (0, $af87434495d688e4$export$2e2bcd8739ae039)());
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).ITF)) _this.readers.push(new (0, $99414f6a07350203$export$2e2bcd8739ae039)());
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).CODABAR)) _this.readers.push(new (0, $e1389124812422eb$export$2e2bcd8739ae039)());
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).RSS_14)) _this.readers.push(new (0, $c41face4ec8fcb8d$export$2e2bcd8739ae039)());
            if (possibleFormats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).RSS_EXPANDED)) {
                console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk.");
                _this.readers.push(new (0, $c4ceb29f9e5438c6$export$2e2bcd8739ae039)());
            }
        }
        if (_this.readers.length === 0) {
            _this.readers.push(new (0, $d716d6460a89b943$export$2e2bcd8739ae039)(hints));
            _this.readers.push(new (0, $80bc94e3cee10a11$export$2e2bcd8739ae039)());
            // this.readers.push(new CodaBarReader());
            _this.readers.push(new (0, $055b6bd23ef58e1b$export$2e2bcd8739ae039)());
            _this.readers.push(new (0, $d716d6460a89b943$export$2e2bcd8739ae039)(hints));
            _this.readers.push(new (0, $af87434495d688e4$export$2e2bcd8739ae039)());
            _this.readers.push(new (0, $99414f6a07350203$export$2e2bcd8739ae039)());
            _this.readers.push(new (0, $c41face4ec8fcb8d$export$2e2bcd8739ae039)());
        // this.readers.push(new RSSExpandedReader());
        }
        return _this;
    }
    // @Override
    MultiFormatOneDReader.prototype.decodeRow = function(rowNumber, row, hints) {
        for(var i = 0; i < this.readers.length; i++)try {
            return this.readers[i].decodeRow(rowNumber, row, hints);
        } catch (re) {
        // continue
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    // @Override
    MultiFormatOneDReader.prototype.reset = function() {
        this.readers.forEach(function(reader) {
            return reader.reset();
        });
    };
    return MultiFormatOneDReader;
}((0, $2907db4645bc034b$export$2e2bcd8739ae039));
var $9f6904b1e7c47f99$export$2e2bcd8739ae039 = $9f6904b1e7c47f99$var$MultiFormatOneDReader;


var $6f2446b1b6e7c9a7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * Barcode reader reader to use from browser.
 */ var $6f2446b1b6e7c9a7$export$8710c3a40c27a798 = /** @class */ function(_super) {
    $6f2446b1b6e7c9a7$var$__extends(BrowserBarcodeReader, _super);
    /**
     * Creates an instance of BrowserBarcodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     * @param {Map<DecodeHintType, any>} hints
     */ function BrowserBarcodeReader(timeBetweenScansMillis, hints) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $9f6904b1e7c47f99$export$2e2bcd8739ae039)(hints), timeBetweenScansMillis, hints) || this;
    }
    return BrowserBarcodeReader;
}((0, $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607));
















var $bbda174040c34a86$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
 * use blocks of differing sizes within one version, so, this encapsulates the parameters for
 * each set of blocks. It also holds the number of error-correction codewords per block since it
 * will be the same across all blocks within one version.</p>
 */ var $bbda174040c34a86$export$fad497768edab5c8 = /** @class */ function() {
    function ECBlocks(ecCodewords, ecBlocks1, ecBlocks2) {
        this.ecCodewords = ecCodewords;
        this.ecBlocks = [
            ecBlocks1
        ];
        ecBlocks2 && this.ecBlocks.push(ecBlocks2);
    }
    ECBlocks.prototype.getECCodewords = function() {
        return this.ecCodewords;
    };
    ECBlocks.prototype.getECBlocks = function() {
        return this.ecBlocks;
    };
    return ECBlocks;
}();
/**
 * <p>Encapsulates the parameters for one error-correction block in one symbol version.
 * This includes the number of data codewords, and the number of times a block with these
 * parameters is used consecutively in the Data Matrix code version's format.</p>
 */ var $bbda174040c34a86$export$5c3eb387265a857d = /** @class */ function() {
    function ECB(count, dataCodewords) {
        this.count = count;
        this.dataCodewords = dataCodewords;
    }
    ECB.prototype.getCount = function() {
        return this.count;
    };
    ECB.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    };
    return ECB;
}();
/**
 * The Version object encapsulates attributes about a particular
 * size Data Matrix Code.
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $bbda174040c34a86$var$Version = /** @class */ function() {
    function Version(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks) {
        var e_1, _a;
        this.versionNumber = versionNumber;
        this.symbolSizeRows = symbolSizeRows;
        this.symbolSizeColumns = symbolSizeColumns;
        this.dataRegionSizeRows = dataRegionSizeRows;
        this.dataRegionSizeColumns = dataRegionSizeColumns;
        this.ecBlocks = ecBlocks;
        // Calculate the total number of codewords
        var total = 0;
        var ecCodewords = ecBlocks.getECCodewords();
        var ecbArray = ecBlocks.getECBlocks();
        try {
            for(var ecbArray_1 = $bbda174040c34a86$var$__values(ecbArray), ecbArray_1_1 = ecbArray_1.next(); !ecbArray_1_1.done; ecbArray_1_1 = ecbArray_1.next()){
                var ecBlock = ecbArray_1_1.value;
                total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecbArray_1_1 && !ecbArray_1_1.done && (_a = ecbArray_1.return)) _a.call(ecbArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.totalCodewords = total;
    }
    Version.prototype.getVersionNumber = function() {
        return this.versionNumber;
    };
    Version.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    };
    Version.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    };
    Version.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    };
    Version.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    };
    Version.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    };
    Version.prototype.getECBlocks = function() {
        return this.ecBlocks;
    };
    /**
     * <p>Deduces version information from Data Matrix dimensions.</p>
     *
     * @param numRows Number of rows in modules
     * @param numColumns Number of columns in modules
     * @return Version for a Data Matrix Code of those dimensions
     * @throws FormatException if dimensions do correspond to a valid Data Matrix size
     */ Version.getVersionForDimensions = function(numRows, numColumns) {
        var e_2, _a;
        if ((numRows & 0x01) !== 0 || (numColumns & 0x01) !== 0) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        try {
            for(var _b = $bbda174040c34a86$var$__values(Version.VERSIONS), _c = _b.next(); !_c.done; _c = _b.next()){
                var version = _c.value;
                if (version.symbolSizeRows === numRows && version.symbolSizeColumns === numColumns) return version;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
    };
    //  @Override
    Version.prototype.toString = function() {
        return "" + this.versionNumber;
    };
    /**
     * See ISO 16022:2006 5.5.1 Table 7
     */ Version.buildVersions = function() {
        return [
            new Version(1, 10, 10, 8, 8, new $bbda174040c34a86$export$fad497768edab5c8(5, new $bbda174040c34a86$export$5c3eb387265a857d(1, 3))),
            new Version(2, 12, 12, 10, 10, new $bbda174040c34a86$export$fad497768edab5c8(7, new $bbda174040c34a86$export$5c3eb387265a857d(1, 5))),
            new Version(3, 14, 14, 12, 12, new $bbda174040c34a86$export$fad497768edab5c8(10, new $bbda174040c34a86$export$5c3eb387265a857d(1, 8))),
            new Version(4, 16, 16, 14, 14, new $bbda174040c34a86$export$fad497768edab5c8(12, new $bbda174040c34a86$export$5c3eb387265a857d(1, 12))),
            new Version(5, 18, 18, 16, 16, new $bbda174040c34a86$export$fad497768edab5c8(14, new $bbda174040c34a86$export$5c3eb387265a857d(1, 18))),
            new Version(6, 20, 20, 18, 18, new $bbda174040c34a86$export$fad497768edab5c8(18, new $bbda174040c34a86$export$5c3eb387265a857d(1, 22))),
            new Version(7, 22, 22, 20, 20, new $bbda174040c34a86$export$fad497768edab5c8(20, new $bbda174040c34a86$export$5c3eb387265a857d(1, 30))),
            new Version(8, 24, 24, 22, 22, new $bbda174040c34a86$export$fad497768edab5c8(24, new $bbda174040c34a86$export$5c3eb387265a857d(1, 36))),
            new Version(9, 26, 26, 24, 24, new $bbda174040c34a86$export$fad497768edab5c8(28, new $bbda174040c34a86$export$5c3eb387265a857d(1, 44))),
            new Version(10, 32, 32, 14, 14, new $bbda174040c34a86$export$fad497768edab5c8(36, new $bbda174040c34a86$export$5c3eb387265a857d(1, 62))),
            new Version(11, 36, 36, 16, 16, new $bbda174040c34a86$export$fad497768edab5c8(42, new $bbda174040c34a86$export$5c3eb387265a857d(1, 86))),
            new Version(12, 40, 40, 18, 18, new $bbda174040c34a86$export$fad497768edab5c8(48, new $bbda174040c34a86$export$5c3eb387265a857d(1, 114))),
            new Version(13, 44, 44, 20, 20, new $bbda174040c34a86$export$fad497768edab5c8(56, new $bbda174040c34a86$export$5c3eb387265a857d(1, 144))),
            new Version(14, 48, 48, 22, 22, new $bbda174040c34a86$export$fad497768edab5c8(68, new $bbda174040c34a86$export$5c3eb387265a857d(1, 174))),
            new Version(15, 52, 52, 24, 24, new $bbda174040c34a86$export$fad497768edab5c8(42, new $bbda174040c34a86$export$5c3eb387265a857d(2, 102))),
            new Version(16, 64, 64, 14, 14, new $bbda174040c34a86$export$fad497768edab5c8(56, new $bbda174040c34a86$export$5c3eb387265a857d(2, 140))),
            new Version(17, 72, 72, 16, 16, new $bbda174040c34a86$export$fad497768edab5c8(36, new $bbda174040c34a86$export$5c3eb387265a857d(4, 92))),
            new Version(18, 80, 80, 18, 18, new $bbda174040c34a86$export$fad497768edab5c8(48, new $bbda174040c34a86$export$5c3eb387265a857d(4, 114))),
            new Version(19, 88, 88, 20, 20, new $bbda174040c34a86$export$fad497768edab5c8(56, new $bbda174040c34a86$export$5c3eb387265a857d(4, 144))),
            new Version(20, 96, 96, 22, 22, new $bbda174040c34a86$export$fad497768edab5c8(68, new $bbda174040c34a86$export$5c3eb387265a857d(4, 174))),
            new Version(21, 104, 104, 24, 24, new $bbda174040c34a86$export$fad497768edab5c8(56, new $bbda174040c34a86$export$5c3eb387265a857d(6, 136))),
            new Version(22, 120, 120, 18, 18, new $bbda174040c34a86$export$fad497768edab5c8(68, new $bbda174040c34a86$export$5c3eb387265a857d(6, 175))),
            new Version(23, 132, 132, 20, 20, new $bbda174040c34a86$export$fad497768edab5c8(62, new $bbda174040c34a86$export$5c3eb387265a857d(8, 163))),
            new Version(24, 144, 144, 22, 22, new $bbda174040c34a86$export$fad497768edab5c8(62, new $bbda174040c34a86$export$5c3eb387265a857d(8, 156), new $bbda174040c34a86$export$5c3eb387265a857d(2, 155))),
            new Version(25, 8, 18, 6, 16, new $bbda174040c34a86$export$fad497768edab5c8(7, new $bbda174040c34a86$export$5c3eb387265a857d(1, 5))),
            new Version(26, 8, 32, 6, 14, new $bbda174040c34a86$export$fad497768edab5c8(11, new $bbda174040c34a86$export$5c3eb387265a857d(1, 10))),
            new Version(27, 12, 26, 10, 24, new $bbda174040c34a86$export$fad497768edab5c8(14, new $bbda174040c34a86$export$5c3eb387265a857d(1, 16))),
            new Version(28, 12, 36, 10, 16, new $bbda174040c34a86$export$fad497768edab5c8(18, new $bbda174040c34a86$export$5c3eb387265a857d(1, 22))),
            new Version(29, 16, 36, 14, 16, new $bbda174040c34a86$export$fad497768edab5c8(24, new $bbda174040c34a86$export$5c3eb387265a857d(1, 32))),
            new Version(30, 16, 48, 14, 22, new $bbda174040c34a86$export$fad497768edab5c8(28, new $bbda174040c34a86$export$5c3eb387265a857d(1, 49)))
        ];
    };
    Version.VERSIONS = Version.buildVersions();
    return Version;
}();
var $bbda174040c34a86$export$2e2bcd8739ae039 = $bbda174040c34a86$var$Version;




/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @author bbrown@google.com (Brian Brown)
 */ var $e2a8b72de2a6a10c$var$BitMatrixParser = /** @class */ function() {
    /**
     * @param bitMatrix {@link BitMatrix} to parse
     * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
     */ function BitMatrixParser(bitMatrix) {
        var dimension = bitMatrix.getHeight();
        if (dimension < 8 || dimension > 144 || (dimension & 0x01) !== 0) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        this.version = BitMatrixParser.readVersion(bitMatrix);
        this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
        this.readMappingMatrix = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    BitMatrixParser.prototype.getVersion = function() {
        return this.version;
    };
    /**
     * <p>Creates the version object based on the dimension of the original bit matrix from
     * the datamatrix code.</p>
     *
     * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
     *
     * @param bitMatrix Original {@link BitMatrix} including alignment patterns
     * @return {@link Version} encapsulating the Data Matrix Code's "version"
     * @throws FormatException if the dimensions of the mapping matrix are not valid
     * Data Matrix dimensions.
     */ BitMatrixParser.readVersion = function(bitMatrix) {
        var numRows = bitMatrix.getHeight();
        var numColumns = bitMatrix.getWidth();
        return (0, $bbda174040c34a86$export$2e2bcd8739ae039).getVersionForDimensions(numRows, numColumns);
    };
    /**
     * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
     * in the correct order in order to reconstitute the codewords bytes contained within the
     * Data Matrix Code.</p>
     *
     * @return bytes encoded within the Data Matrix Code
     * @throws FormatException if the exact number of bytes expected is not read
     */ BitMatrixParser.prototype.readCodewords = function() {
        var result = new Int8Array(this.version.getTotalCodewords());
        var resultOffset = 0;
        var row = 4;
        var column = 0;
        var numRows = this.mappingBitMatrix.getHeight();
        var numColumns = this.mappingBitMatrix.getWidth();
        var corner1Read = false;
        var corner2Read = false;
        var corner3Read = false;
        var corner4Read = false;
        // Read all of the codewords
        do {
            // Check the four corner cases
            if (row === numRows && column === 0 && !corner1Read) {
                result[resultOffset++] = this.readCorner1(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner1Read = true;
            } else if (row === numRows - 2 && column === 0 && (numColumns & 0x03) !== 0 && !corner2Read) {
                result[resultOffset++] = this.readCorner2(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner2Read = true;
            } else if (row === numRows + 4 && column === 2 && (numColumns & 0x07) === 0 && !corner3Read) {
                result[resultOffset++] = this.readCorner3(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner3Read = true;
            } else if (row === numRows - 2 && column === 0 && (numColumns & 0x07) === 4 && !corner4Read) {
                result[resultOffset++] = this.readCorner4(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner4Read = true;
            } else {
                // Sweep upward diagonally to the right
                do {
                    if (row < numRows && column >= 0 && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                }while (row >= 0 && column < numColumns);
                row += 1;
                column += 3;
                // Sweep downward diagonally to the left
                do {
                    if (row >= 0 && column < numColumns && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                    row += 2;
                    column -= 2;
                }while (row < numRows && column >= 0);
                row += 3;
                column += 1;
            }
        }while (row < numRows || column < numColumns);
        if (resultOffset !== this.version.getTotalCodewords()) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        return result;
    };
    /**
     * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
     *
     * @param row Row to read in the mapping matrix
     * @param column Column to read in the mapping matrix
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return value of the given bit in the mapping matrix
     */ BitMatrixParser.prototype.readModule = function(row, column, numRows, numColumns) {
        // Adjust the row and column indices based on boundary wrapping
        if (row < 0) {
            row += numRows;
            column += 4 - (numRows + 4 & 0x07);
        }
        if (column < 0) {
            column += numColumns;
            row += 4 - (numColumns + 4 & 0x07);
        }
        this.readMappingMatrix.set(column, row);
        return this.mappingBitMatrix.get(column, row);
    };
    /**
     * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
     *
     * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
     *
     * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
     * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the utah shape
     */ BitMatrixParser.prototype.readUtah = function(row, column, numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(row - 2, column - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 2, column - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 1, column - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 1, column - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 1, column, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row, column - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row, column - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row, column, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 1.</p>
     *
     * <p>See ISO 16022:2006, Figure F.3</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 1
     */ BitMatrixParser.prototype.readCorner1 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 2.</p>
     *
     * <p>See ISO 16022:2006, Figure F.4</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 2
     */ BitMatrixParser.prototype.readCorner2 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 4, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 3.</p>
     *
     * <p>See ISO 16022:2006, Figure F.5</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 3
     */ BitMatrixParser.prototype.readCorner3 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 3, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 4.</p>
     *
     * <p>See ISO 16022:2006, Figure F.6</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 4
     */ BitMatrixParser.prototype.readCorner4 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Extracts the data region from a {@link BitMatrix} that contains
     * alignment patterns.</p>
     *
     * @param bitMatrix Original {@link BitMatrix} with alignment patterns
     * @return BitMatrix that has the alignment patterns removed
     */ BitMatrixParser.prototype.extractDataRegion = function(bitMatrix) {
        var symbolSizeRows = this.version.getSymbolSizeRows();
        var symbolSizeColumns = this.version.getSymbolSizeColumns();
        if (bitMatrix.getHeight() !== symbolSizeRows) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Dimension of bitMatrix must match the version size");
        var dataRegionSizeRows = this.version.getDataRegionSizeRows();
        var dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
        var numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
        var numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
        var sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
        var sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
        var bitMatrixWithoutAlignment = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(sizeDataRegionColumn, sizeDataRegionRow);
        for(var dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow){
            var dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
            for(var dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn){
                var dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
                for(var i = 0; i < dataRegionSizeRows; ++i){
                    var readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i;
                    var writeRowOffset = dataRegionRowOffset + i;
                    for(var j = 0; j < dataRegionSizeColumns; ++j){
                        var readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                        if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                            var writeColumnOffset = dataRegionColumnOffset + j;
                            bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                        }
                    }
                }
            }
        }
        return bitMatrixWithoutAlignment;
    };
    return BitMatrixParser;
}();
var $e2a8b72de2a6a10c$export$2e2bcd8739ae039 = $e2a8b72de2a6a10c$var$BitMatrixParser;



var $69834e2269bb7c1b$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates a block of data within a Data Matrix Code. Data Matrix Codes may split their data into
 * multiple blocks, each of which is a unit of data and error-correction codewords. Each
 * is represented by an instance of this class.</p>
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $69834e2269bb7c1b$var$DataBlock = /** @class */ function() {
    function DataBlock(numDataCodewords, codewords) {
        this.numDataCodewords = numDataCodewords;
        this.codewords = codewords;
    }
    /**
     * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
     * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
     * method will separate the data into original blocks.</p>
     *
     * @param rawCodewords bytes as read directly from the Data Matrix Code
     * @param version version of the Data Matrix Code
     * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
     *         Data Matrix Code
     */ DataBlock.getDataBlocks = function(rawCodewords, version) {
        var e_1, _a, e_2, _b;
        // Figure out the number and size of data blocks used by this version
        var ecBlocks = version.getECBlocks();
        // First count the total number of data blocks
        var totalBlocks = 0;
        var ecBlockArray = ecBlocks.getECBlocks();
        try {
            for(var ecBlockArray_1 = $69834e2269bb7c1b$var$__values(ecBlockArray), ecBlockArray_1_1 = ecBlockArray_1.next(); !ecBlockArray_1_1.done; ecBlockArray_1_1 = ecBlockArray_1.next()){
                var ecBlock = ecBlockArray_1_1.value;
                totalBlocks += ecBlock.getCount();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecBlockArray_1_1 && !ecBlockArray_1_1.done && (_a = ecBlockArray_1.return)) _a.call(ecBlockArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Now establish DataBlocks of the appropriate size and number of data codewords
        var result = new Array(totalBlocks);
        var numResultBlocks = 0;
        try {
            for(var ecBlockArray_2 = $69834e2269bb7c1b$var$__values(ecBlockArray), ecBlockArray_2_1 = ecBlockArray_2.next(); !ecBlockArray_2_1.done; ecBlockArray_2_1 = ecBlockArray_2.next()){
                var ecBlock = ecBlockArray_2_1.value;
                for(var i = 0; i < ecBlock.getCount(); i++){
                    var numDataCodewords = ecBlock.getDataCodewords();
                    var numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
                    result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (ecBlockArray_2_1 && !ecBlockArray_2_1.done && (_b = ecBlockArray_2.return)) _b.call(ecBlockArray_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // All blocks have the same amount of data, except that the last n
        // (where n may be 0) have 1 less byte. Figure out where these start.
        // TODO(bbrown): There is only one case where there is a difference for Data Matrix for size 144
        var longerBlocksTotalCodewords = result[0].codewords.length;
        // int shorterBlocksTotalCodewords = longerBlocksTotalCodewords - 1;
        var longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
        var shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
        // The last elements of result may be 1 element shorter for 144 matrix
        // first fill out as many elements as all of them have minus 1
        var rawCodewordsOffset = 0;
        for(var i = 0; i < shorterBlocksNumDataCodewords; i++)for(var j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
        // Fill out the last data block in the longer ones
        var specialVersion = version.getVersionNumber() === 24;
        var numLongerBlocks = specialVersion ? 8 : numResultBlocks;
        for(var j = 0; j < numLongerBlocks; j++)result[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
        // Now add in error correction blocks
        var max = result[0].codewords.length;
        for(var i = longerBlocksNumDataCodewords; i < max; i++)for(var j = 0; j < numResultBlocks; j++){
            var jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
            var iOffset = specialVersion && jOffset > 7 ? i - 1 : i;
            result[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
        }
        if (rawCodewordsOffset !== rawCodewords.length) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        return result;
    };
    DataBlock.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    };
    DataBlock.prototype.getCodewords = function() {
        return this.codewords;
    };
    return DataBlock;
}();
var $69834e2269bb7c1b$export$2e2bcd8739ae039 = $69834e2269bb7c1b$var$DataBlock;



/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ 
/**
 * <p>This provides an easy abstraction to read bits at a time from a sequence of bytes, where the
 * number of bits read is not often a multiple of 8.</p>
 *
 * <p>This class is thread-safe but not reentrant -- unless the caller modifies the bytes array
 * it passed in, in which case all bets are off.</p>
 *
 * @author Sean Owen
 */ var $30e343486e0343e4$var$BitSource = /** @class */ function() {
    /**
     * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
     * Bits are read within a byte from most-significant to least-significant bit.
     */ function BitSource(bytes) {
        this.bytes = bytes;
        this.byteOffset = 0;
        this.bitOffset = 0;
    }
    /**
     * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
     */ BitSource.prototype.getBitOffset = function() {
        return this.bitOffset;
    };
    /**
     * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
     */ BitSource.prototype.getByteOffset = function() {
        return this.byteOffset;
    };
    /**
     * @param numBits number of bits to read
     * @return int representing the bits read. The bits will appear as the least-significant
     *         bits of the int
     * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
     */ BitSource.prototype.readBits = function(numBits /*int*/ ) {
        if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("" + numBits);
        var result = 0;
        var bitOffset = this.bitOffset;
        var byteOffset = this.byteOffset;
        var bytes = this.bytes;
        // First, read remainder from current byte
        if (bitOffset > 0) {
            var bitsLeft = 8 - bitOffset;
            var toRead = numBits < bitsLeft ? numBits : bitsLeft;
            var bitsToNotRead = bitsLeft - toRead;
            var mask = 0xFF >> 8 - toRead << bitsToNotRead;
            result = (bytes[byteOffset] & mask) >> bitsToNotRead;
            numBits -= toRead;
            bitOffset += toRead;
            if (bitOffset === 8) {
                bitOffset = 0;
                byteOffset++;
            }
        }
        // Next read whole bytes
        if (numBits > 0) {
            while(numBits >= 8){
                result = result << 8 | bytes[byteOffset] & 0xFF;
                byteOffset++;
                numBits -= 8;
            }
            // Finally read a partial byte
            if (numBits > 0) {
                var bitsToNotRead = 8 - numBits;
                var mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                result = result << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
                bitOffset += numBits;
            }
        }
        this.bitOffset = bitOffset;
        this.byteOffset = byteOffset;
        return result;
    };
    /**
     * @return number of bits that can be read successfully
     */ BitSource.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    };
    return BitSource;
}();
var $30e343486e0343e4$export$2e2bcd8739ae039 = $30e343486e0343e4$var$BitSource;







/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $bc958835333f336d$var$Mode;
(function(Mode) {
    Mode[Mode["PAD_ENCODE"] = 0] = "PAD_ENCODE";
    Mode[Mode["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
    Mode[Mode["C40_ENCODE"] = 2] = "C40_ENCODE";
    Mode[Mode["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
    Mode[Mode["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
    Mode[Mode["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
    Mode[Mode["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
})($bc958835333f336d$var$Mode || ($bc958835333f336d$var$Mode = {}));
/**
 * <p>Data Matrix Codes can encode text as bits in one of several modes, and can use multiple modes
 * in one Data Matrix Code. This class decodes the bits back into text.</p>
 *
 * <p>See ISO 16022:2006, 5.2.1 - 5.2.9.2</p>
 *
 * @author bbrown@google.com (Brian Brown)
 * @author Sean Owen
 */ var $bc958835333f336d$var$DecodedBitStreamParser = /** @class */ function() {
    function DecodedBitStreamParser() {}
    DecodedBitStreamParser.decode = function(bytes) {
        var bits = new (0, $30e343486e0343e4$export$2e2bcd8739ae039)(bytes);
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        var resultTrailer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        var byteSegments = new Array();
        var mode = $bc958835333f336d$var$Mode.ASCII_ENCODE;
        do if (mode === $bc958835333f336d$var$Mode.ASCII_ENCODE) mode = this.decodeAsciiSegment(bits, result, resultTrailer);
        else {
            switch(mode){
                case $bc958835333f336d$var$Mode.C40_ENCODE:
                    this.decodeC40Segment(bits, result);
                    break;
                case $bc958835333f336d$var$Mode.TEXT_ENCODE:
                    this.decodeTextSegment(bits, result);
                    break;
                case $bc958835333f336d$var$Mode.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(bits, result);
                    break;
                case $bc958835333f336d$var$Mode.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(bits, result);
                    break;
                case $bc958835333f336d$var$Mode.BASE256_ENCODE:
                    this.decodeBase256Segment(bits, result, byteSegments);
                    break;
                default:
                    throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            }
            mode = $bc958835333f336d$var$Mode.ASCII_ENCODE;
        }
        while (mode !== $bc958835333f336d$var$Mode.PAD_ENCODE && bits.available() > 0);
        if (resultTrailer.length() > 0) result.append(resultTrailer.toString());
        return new (0, $aa602f5deffed2f7$export$2e2bcd8739ae039)(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, null);
    };
    /**
     * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
     */ DecodedBitStreamParser.decodeAsciiSegment = function(bits, result, resultTrailer) {
        var upperShift = false;
        do {
            var oneByte = bits.readBits(8);
            if (oneByte === 0) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            else if (oneByte <= 128) {
                if (upperShift) oneByte += 128;
                result.append(String.fromCharCode(oneByte - 1));
                return $bc958835333f336d$var$Mode.ASCII_ENCODE;
            } else if (oneByte === 129) return $bc958835333f336d$var$Mode.PAD_ENCODE;
            else if (oneByte <= 229) {
                var value = oneByte - 130;
                if (value < 10) result.append("0");
                result.append("" + value);
            } else switch(oneByte){
                case 230:
                    return $bc958835333f336d$var$Mode.C40_ENCODE;
                case 231:
                    return $bc958835333f336d$var$Mode.BASE256_ENCODE;
                case 232:
                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                    break;
                case 233:
                case 234:
                    break;
                case 235:
                    upperShift = true;
                    break;
                case 236:
                    result.append("[)>\x1e05\x1d");
                    resultTrailer.insert(0, "\x1e\x04");
                    break;
                case 237:
                    result.append("[)>\x1e06\x1d");
                    resultTrailer.insert(0, "\x1e\x04");
                    break;
                case 238:
                    return $bc958835333f336d$var$Mode.ANSIX12_ENCODE;
                case 239:
                    return $bc958835333f336d$var$Mode.TEXT_ENCODE;
                case 240:
                    return $bc958835333f336d$var$Mode.EDIFACT_ENCODE;
                case 241:
                    break;
                default:
                    // Not to be used in ASCII encodation
                    // but work around encoders that end with 254, latch back to ASCII
                    if (oneByte !== 254 || bits.available() !== 0) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                    break;
            }
        }while (bits.available() > 0);
        return $bc958835333f336d$var$Mode.ASCII_ENCODE;
    };
    /**
     * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
     */ DecodedBitStreamParser.decodeC40Segment = function(bits, result) {
        // Three C40 values are encoded in a 16-bit value as
        // (1600 * C1) + (40 * C2) + C3 + 1
        // TODO(bbrown): The Upper Shift with C40 doesn't work in the 4 value scenario all the time
        var upperShift = false;
        var cValues = [];
        var shift = 0;
        do {
            // If there is only one byte left then it will be encoded as ASCII
            if (bits.available() === 8) return;
            var firstByte = bits.readBits(8);
            if (firstByte === 254) return;
            this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
            for(var i = 0; i < 3; i++){
                var cValue = cValues[i];
                switch(shift){
                    case 0:
                        if (cValue < 3) shift = cValue + 1;
                        else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                            var c40char = this.C40_BASIC_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(c40char);
                        } else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case 1:
                        if (upperShift) {
                            result.append(String.fromCharCode(cValue + 128));
                            upperShift = false;
                        } else result.append(String.fromCharCode(cValue));
                        shift = 0;
                        break;
                    case 2:
                        if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                            var c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(c40char);
                        } else switch(cValue){
                            case 27:
                                result.append(String.fromCharCode(29)); // translate as ASCII 29
                                break;
                            case 30:
                                upperShift = true;
                                break;
                            default:
                                throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        }
                        shift = 0;
                        break;
                    case 3:
                        if (upperShift) {
                            result.append(String.fromCharCode(cValue + 224));
                            upperShift = false;
                        } else result.append(String.fromCharCode(cValue + 96));
                        shift = 0;
                        break;
                    default:
                        throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                }
            }
        }while (bits.available() > 0);
    };
    /**
     * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
     */ DecodedBitStreamParser.decodeTextSegment = function(bits, result) {
        // Three Text values are encoded in a 16-bit value as
        // (1600 * C1) + (40 * C2) + C3 + 1
        // TODO(bbrown): The Upper Shift with Text doesn't work in the 4 value scenario all the time
        var upperShift = false;
        var cValues = [];
        var shift = 0;
        do {
            // If there is only one byte left then it will be encoded as ASCII
            if (bits.available() === 8) return;
            var firstByte = bits.readBits(8);
            if (firstByte === 254) return;
            this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
            for(var i = 0; i < 3; i++){
                var cValue = cValues[i];
                switch(shift){
                    case 0:
                        if (cValue < 3) shift = cValue + 1;
                        else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                            var textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(textChar);
                        } else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case 1:
                        if (upperShift) {
                            result.append(String.fromCharCode(cValue + 128));
                            upperShift = false;
                        } else result.append(String.fromCharCode(cValue));
                        shift = 0;
                        break;
                    case 2:
                        // Shift 2 for Text is the same encoding as C40
                        if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                            var textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(textChar);
                        } else switch(cValue){
                            case 27:
                                result.append(String.fromCharCode(29)); // translate as ASCII 29
                                break;
                            case 30:
                                upperShift = true;
                                break;
                            default:
                                throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        }
                        shift = 0;
                        break;
                    case 3:
                        if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                            var textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(textChar);
                            shift = 0;
                        } else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    default:
                        throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                }
            }
        }while (bits.available() > 0);
    };
    /**
     * See ISO 16022:2006, 5.2.7
     */ DecodedBitStreamParser.decodeAnsiX12Segment = function(bits, result) {
        // Three ANSI X12 values are encoded in a 16-bit value as
        // (1600 * C1) + (40 * C2) + C3 + 1
        var cValues = [];
        do {
            // If there is only one byte left then it will be encoded as ASCII
            if (bits.available() === 8) return;
            var firstByte = bits.readBits(8);
            if (firstByte === 254) return;
            this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
            for(var i = 0; i < 3; i++){
                var cValue = cValues[i];
                switch(cValue){
                    case 0:
                        result.append("\r");
                        break;
                    case 1:
                        result.append("*");
                        break;
                    case 2:
                        result.append(">");
                        break;
                    case 3:
                        result.append(" ");
                        break;
                    default:
                        if (cValue < 14) result.append(String.fromCharCode(cValue + 44));
                        else if (cValue < 40) result.append(String.fromCharCode(cValue + 51));
                        else throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                }
            }
        }while (bits.available() > 0);
    };
    DecodedBitStreamParser.parseTwoBytes = function(firstByte, secondByte, result) {
        var fullBitValue = (firstByte << 8) + secondByte - 1;
        var temp = Math.floor(fullBitValue / 1600);
        result[0] = temp;
        fullBitValue -= temp * 1600;
        temp = Math.floor(fullBitValue / 40);
        result[1] = temp;
        result[2] = fullBitValue - temp * 40;
    };
    /**
     * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
     */ DecodedBitStreamParser.decodeEdifactSegment = function(bits, result) {
        do {
            // If there is only two or less bytes left then it will be encoded as ASCII
            if (bits.available() <= 16) return;
            for(var i = 0; i < 4; i++){
                var edifactValue = bits.readBits(6);
                // Check for the unlatch character
                if (edifactValue === 0x1F) {
                    // Read rest of byte, which should be 0, and stop
                    var bitsLeft = 8 - bits.getBitOffset();
                    if (bitsLeft !== 8) bits.readBits(bitsLeft);
                    return;
                }
                if ((edifactValue & 0x20) === 0) edifactValue |= 0x40; // Add a leading 01 to the 6 bit binary value
                result.append(String.fromCharCode(edifactValue));
            }
        }while (bits.available() > 0);
    };
    /**
     * See ISO 16022:2006, 5.2.9 and Annex B, B.2
     */ DecodedBitStreamParser.decodeBase256Segment = function(bits, result, byteSegments) {
        // Figure out how long the Base 256 Segment is.
        var codewordPosition = 1 + bits.getByteOffset(); // position is 1-indexed
        var d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
        var count;
        if (d1 === 0) count = bits.available() / 8 | 0;
        else if (d1 < 250) count = d1;
        else count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
        // We're seeing NegativeArraySizeException errors from users.
        if (count < 0) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        var bytes = new Uint8Array(count);
        for(var i = 0; i < count; i++){
            // Have seen this particular error in the wild, such as at
            // http://www.bcgen.com/demo/IDAutomationStreamingDataMatrix.aspx?MODE=3&D=Fred&PFMT=3&PT=F&X=0.3&O=0&LM=0.2
            if (bits.available() < 8) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            bytes[i] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
        }
        byteSegments.push(bytes);
        try {
            result.append((0, $3a88fa58822b35a1$export$2e2bcd8739ae039).decode(bytes, (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).ISO88591));
        } catch (uee) {
            throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)("Platform does not support required encoding: " + uee.message);
        }
    };
    /**
     * See ISO 16022:2006, Annex B, B.2
     */ DecodedBitStreamParser.unrandomize255State = function(randomizedBase256Codeword, base256CodewordPosition) {
        var pseudoRandomNumber = 149 * base256CodewordPosition % 255 + 1;
        var tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
        return tempVariable >= 0 ? tempVariable : tempVariable + 256;
    };
    /**
     * See ISO 16022:2006, Annex C Table C.1
     * The C40 Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ];
    /**
     * See ISO 16022:2006, Annex C Table C.2
     * The Text Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ];
    // Shift 2 for Text is the same encoding as C40
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ];
    return DecodedBitStreamParser;
}();
var $bc958835333f336d$export$2e2bcd8739ae039 = $bc958835333f336d$var$DecodedBitStreamParser;


var $5d8366e402dd9cfb$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>The main class which implements Data Matrix Code decoding -- as opposed to locating and extracting
 * the Data Matrix Code from an image.</p>
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $5d8366e402dd9cfb$var$Decoder = /** @class */ function() {
    function Decoder() {
        this.rsDecoder = new (0, $a1039736c6639077$export$2e2bcd8739ae039)((0, $7973dc50831a46a1$export$2e2bcd8739ae039).DATA_MATRIX_FIELD_256);
    }
    /**
     * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
     * to mean a black module.</p>
     *
     * @param bits booleans representing white/black Data Matrix Code modules
     * @return text and bytes encoded within the Data Matrix Code
     * @throws FormatException if the Data Matrix Code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.decode = function(bits) {
        var e_1, _a;
        // Construct a parser and read version, error-correction level
        var parser = new (0, $e2a8b72de2a6a10c$export$2e2bcd8739ae039)(bits);
        var version = parser.getVersion();
        // Read codewords
        var codewords = parser.readCodewords();
        // Separate into data blocks
        var dataBlocks = (0, $69834e2269bb7c1b$export$2e2bcd8739ae039).getDataBlocks(codewords, version);
        // Count total number of data bytes
        var totalBytes = 0;
        try {
            for(var dataBlocks_1 = $5d8366e402dd9cfb$var$__values(dataBlocks), dataBlocks_1_1 = dataBlocks_1.next(); !dataBlocks_1_1.done; dataBlocks_1_1 = dataBlocks_1.next()){
                var db = dataBlocks_1_1.value;
                totalBytes += db.getNumDataCodewords();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (dataBlocks_1_1 && !dataBlocks_1_1.done && (_a = dataBlocks_1.return)) _a.call(dataBlocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var resultBytes = new Uint8Array(totalBytes);
        var dataBlocksCount = dataBlocks.length;
        // Error-correct and copy data blocks together into a stream of bytes
        for(var j = 0; j < dataBlocksCount; j++){
            var dataBlock = dataBlocks[j];
            var codewordBytes = dataBlock.getCodewords();
            var numDataCodewords = dataBlock.getNumDataCodewords();
            this.correctErrors(codewordBytes, numDataCodewords);
            for(var i = 0; i < numDataCodewords; i++)// De-interlace data blocks.
            resultBytes[i * dataBlocksCount + j] = codewordBytes[i];
        }
        // Decode the contents of that stream of bytes
        return (0, $bc958835333f336d$export$2e2bcd8739ae039).decode(resultBytes);
    };
    /**
     * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
     * correct the errors in-place using Reed-Solomon error correction.</p>
     *
     * @param codewordBytes data and error correction codewords
     * @param numDataCodewords number of codewords that are data bytes
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.correctErrors = function(codewordBytes, numDataCodewords) {
        // const numCodewords = codewordBytes.length;
        // First read into an array of ints
        var codewordsInts = new Int32Array(codewordBytes);
        // for (let i = 0; i < numCodewords; i++) {
        //   codewordsInts[i] = codewordBytes[i] & 0xFF;
        // }
        try {
            this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
        } catch (ignored /* ReedSolomonException */ ) {
            throw new (0, $e19cfb3b440de53d$export$2e2bcd8739ae039)();
        }
        // Copy back into array of bytes -- only need to worry about the bytes that were data
        // We don't care about errors in the error-correction codewords
        for(var i = 0; i < numDataCodewords; i++)codewordBytes[i] = codewordsInts[i];
    };
    return Decoder;
}();
var $5d8366e402dd9cfb$export$2e2bcd8739ae039 = $5d8366e402dd9cfb$var$Decoder;







/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates logic that can detect a Data Matrix Code in an image, even if the Data Matrix Code
 * is rotated or skewed, or partially obscured.</p>
 *
 * @author Sean Owen
 */ var $4a69bfe2f38f94e9$var$Detector = /** @class */ function() {
    function Detector(image) {
        this.image = image;
        this.rectangleDetector = new (0, $dd96a8353b0eb50e$export$2e2bcd8739ae039)(this.image);
    }
    /**
     * <p>Detects a Data Matrix Code in an image.</p>
     *
     * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
     * @throws NotFoundException if no Data Matrix Code can be found
     */ Detector.prototype.detect = function() {
        var cornerPoints = this.rectangleDetector.detect();
        var points = this.detectSolid1(cornerPoints);
        points = this.detectSolid2(points);
        points[3] = this.correctTopRight(points);
        if (!points[3]) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        points = this.shiftToModuleCenter(points);
        var topLeft = points[0];
        var bottomLeft = points[1];
        var bottomRight = points[2];
        var topRight = points[3];
        var dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
        var dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
        if ((dimensionTop & 0x01) === 1) dimensionTop += 1;
        if ((dimensionRight & 0x01) === 1) dimensionRight += 1;
        if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) // The matrix is square
        dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
        var bits = Detector.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
        return new (0, $af1075b9a52868b5$export$2e2bcd8739ae039)(bits, [
            topLeft,
            bottomLeft,
            bottomRight,
            topRight
        ]);
    };
    Detector.shiftPoint = function(point, to, div) {
        var x = (to.getX() - point.getX()) / (div + 1);
        var y = (to.getY() - point.getY()) / (div + 1);
        return new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(point.getX() + x, point.getY() + y);
    };
    Detector.moveAway = function(point, fromX, fromY) {
        var x = point.getX();
        var y = point.getY();
        if (x < fromX) x -= 1;
        else x += 1;
        if (y < fromY) y -= 1;
        else y += 1;
        return new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(x, y);
    };
    /**
     * Detect a solid side which has minimum transition.
     */ Detector.prototype.detectSolid1 = function(cornerPoints) {
        // 0  2
        // 1  3
        var pointA = cornerPoints[0];
        var pointB = cornerPoints[1];
        var pointC = cornerPoints[3];
        var pointD = cornerPoints[2];
        var trAB = this.transitionsBetween(pointA, pointB);
        var trBC = this.transitionsBetween(pointB, pointC);
        var trCD = this.transitionsBetween(pointC, pointD);
        var trDA = this.transitionsBetween(pointD, pointA);
        // 0..3
        // :  :
        // 1--2
        var min = trAB;
        var points = [
            pointD,
            pointA,
            pointB,
            pointC
        ];
        if (min > trBC) {
            min = trBC;
            points[0] = pointA;
            points[1] = pointB;
            points[2] = pointC;
            points[3] = pointD;
        }
        if (min > trCD) {
            min = trCD;
            points[0] = pointB;
            points[1] = pointC;
            points[2] = pointD;
            points[3] = pointA;
        }
        if (min > trDA) {
            points[0] = pointC;
            points[1] = pointD;
            points[2] = pointA;
            points[3] = pointB;
        }
        return points;
    };
    /**
     * Detect a second solid side next to first solid side.
     */ Detector.prototype.detectSolid2 = function(points) {
        // A..D
        // :  :
        // B--C
        var pointA = points[0];
        var pointB = points[1];
        var pointC = points[2];
        var pointD = points[3];
        // Transition detection on the edge is not stable.
        // To safely detect, shift the points to the module center.
        var tr = this.transitionsBetween(pointA, pointD);
        var pointBs = Detector.shiftPoint(pointB, pointC, (tr + 1) * 4);
        var pointCs = Detector.shiftPoint(pointC, pointB, (tr + 1) * 4);
        var trBA = this.transitionsBetween(pointBs, pointA);
        var trCD = this.transitionsBetween(pointCs, pointD);
        // 0..3
        // |  :
        // 1--2
        if (trBA < trCD) {
            // solid sides: A-B-C
            points[0] = pointA;
            points[1] = pointB;
            points[2] = pointC;
            points[3] = pointD;
        } else {
            // solid sides: B-C-D
            points[0] = pointB;
            points[1] = pointC;
            points[2] = pointD;
            points[3] = pointA;
        }
        return points;
    };
    /**
     * Calculates the corner position of the white top right module.
     */ Detector.prototype.correctTopRight = function(points) {
        // A..D
        // |  :
        // B--C
        var pointA = points[0];
        var pointB = points[1];
        var pointC = points[2];
        var pointD = points[3];
        // shift points for safe transition detection.
        var trTop = this.transitionsBetween(pointA, pointD);
        var trRight = this.transitionsBetween(pointB, pointD);
        var pointAs = Detector.shiftPoint(pointA, pointB, (trRight + 1) * 4);
        var pointCs = Detector.shiftPoint(pointC, pointB, (trTop + 1) * 4);
        trTop = this.transitionsBetween(pointAs, pointD);
        trRight = this.transitionsBetween(pointCs, pointD);
        var candidate1 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
        var candidate2 = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
        if (!this.isValid(candidate1)) {
            if (this.isValid(candidate2)) return candidate2;
            return null;
        }
        if (!this.isValid(candidate2)) return candidate1;
        var sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
        var sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
        if (sumc1 > sumc2) return candidate1;
        else return candidate2;
    };
    /**
     * Shift the edge points to the module center.
     */ Detector.prototype.shiftToModuleCenter = function(points) {
        // A..D
        // |  :
        // B--C
        var pointA = points[0];
        var pointB = points[1];
        var pointC = points[2];
        var pointD = points[3];
        // calculate pseudo dimensions
        var dimH = this.transitionsBetween(pointA, pointD) + 1;
        var dimV = this.transitionsBetween(pointC, pointD) + 1;
        // shift points for safe dimension detection
        var pointAs = Detector.shiftPoint(pointA, pointB, dimV * 4);
        var pointCs = Detector.shiftPoint(pointC, pointB, dimH * 4);
        //  calculate more precise dimensions
        dimH = this.transitionsBetween(pointAs, pointD) + 1;
        dimV = this.transitionsBetween(pointCs, pointD) + 1;
        if ((dimH & 0x01) === 1) dimH += 1;
        if ((dimV & 0x01) === 1) dimV += 1;
        // WhiteRectangleDetector returns points inside of the rectangle.
        // I want points on the edges.
        var centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
        var centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
        pointA = Detector.moveAway(pointA, centerX, centerY);
        pointB = Detector.moveAway(pointB, centerX, centerY);
        pointC = Detector.moveAway(pointC, centerX, centerY);
        pointD = Detector.moveAway(pointD, centerX, centerY);
        var pointBs;
        var pointDs;
        // shift points to the center of each modules
        pointAs = Detector.shiftPoint(pointA, pointB, dimV * 4);
        pointAs = Detector.shiftPoint(pointAs, pointD, dimH * 4);
        pointBs = Detector.shiftPoint(pointB, pointA, dimV * 4);
        pointBs = Detector.shiftPoint(pointBs, pointC, dimH * 4);
        pointCs = Detector.shiftPoint(pointC, pointD, dimV * 4);
        pointCs = Detector.shiftPoint(pointCs, pointB, dimH * 4);
        pointDs = Detector.shiftPoint(pointD, pointC, dimV * 4);
        pointDs = Detector.shiftPoint(pointDs, pointA, dimH * 4);
        return [
            pointAs,
            pointBs,
            pointCs,
            pointDs
        ];
    };
    Detector.prototype.isValid = function(p) {
        return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
    };
    Detector.sampleGrid = function(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
        var sampler = (0, $6aeaa999aa5396ea$export$2e2bcd8739ae039).getInstance();
        return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
    };
    /**
     * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
     */ Detector.prototype.transitionsBetween = function(from, to) {
        // See QR Code Detector, sizeOfBlackWhiteBlackRun()
        var fromX = Math.trunc(from.getX());
        var fromY = Math.trunc(from.getY());
        var toX = Math.trunc(to.getX());
        var toY = Math.trunc(to.getY());
        var steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
        if (steep) {
            var temp = fromX;
            fromX = fromY;
            fromY = temp;
            temp = toX;
            toX = toY;
            toY = temp;
        }
        var dx = Math.abs(toX - fromX);
        var dy = Math.abs(toY - fromY);
        var error = -dx / 2;
        var ystep = fromY < toY ? 1 : -1;
        var xstep = fromX < toX ? 1 : -1;
        var transitions = 0;
        var inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
        for(var x = fromX, y = fromY; x !== toX; x += xstep){
            var isBlack = this.image.get(steep ? y : x, steep ? x : y);
            if (isBlack !== inBlack) {
                transitions++;
                inBlack = isBlack;
            }
            error += dy;
            if (error > 0) {
                if (y === toY) break;
                y += ystep;
                error -= dx;
            }
        }
        return transitions;
    };
    return Detector;
}();
var $4a69bfe2f38f94e9$export$2e2bcd8739ae039 = $4a69bfe2f38f94e9$var$Detector;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This implementation can detect and decode Data Matrix codes in an image.
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $4ec6a75867c073ad$var$DataMatrixReader = /** @class */ function() {
    function DataMatrixReader() {
        this.decoder = new (0, $5d8366e402dd9cfb$export$2e2bcd8739ae039)();
    }
    /**
     * Locates and decodes a Data Matrix code in an image.
     *
     * @return a String representing the content encoded by the Data Matrix code
     * @throws NotFoundException if a Data Matrix code cannot be found
     * @throws FormatException if a Data Matrix code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ // @Override
    // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
    //   return decode(image, null);
    // }
    // @Override
    DataMatrixReader.prototype.decode = function(image, hints) {
        if (hints === void 0) hints = null;
        var decoderResult;
        var points;
        if (hints != null && hints.has((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).PURE_BARCODE)) {
            var bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
            decoderResult = this.decoder.decode(bits);
            points = DataMatrixReader.NO_POINTS;
        } else {
            var detectorResult = new (0, $4a69bfe2f38f94e9$export$2e2bcd8739ae039)(image.getBlackMatrix()).detect();
            decoderResult = this.decoder.decode(detectorResult.getBits());
            points = detectorResult.getPoints();
        }
        var rawBytes = decoderResult.getRawBytes();
        var result = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).DATA_MATRIX, (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).currentTimeMillis());
        var byteSegments = decoderResult.getByteSegments();
        if (byteSegments != null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).BYTE_SEGMENTS, byteSegments);
        var ecLevel = decoderResult.getECLevel();
        if (ecLevel != null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ERROR_CORRECTION_LEVEL, ecLevel);
        return result;
    };
    // @Override
    DataMatrixReader.prototype.reset = function() {
    // do nothing
    };
    /**
     * This method detects a code in a "pure" image -- that is, pure monochrome image
     * which contains only an unrotated, unskewed, image of a code, with some white border
     * around it. This is a specialized method that works exceptionally fast in this special
     * case.
     *
     * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
     */ DataMatrixReader.extractPureBits = function(image) {
        var leftTopBlack = image.getTopLeftOnBit();
        var rightBottomBlack = image.getBottomRightOnBit();
        if (leftTopBlack == null || rightBottomBlack == null) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var moduleSize = this.moduleSize(leftTopBlack, image);
        var top = leftTopBlack[1];
        var bottom = rightBottomBlack[1];
        var left = leftTopBlack[0];
        var right = rightBottomBlack[0];
        var matrixWidth = (right - left + 1) / moduleSize;
        var matrixHeight = (bottom - top + 1) / moduleSize;
        if (matrixWidth <= 0 || matrixHeight <= 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        // Push in the "border" by half the module width so that we start
        // sampling in the middle of the module. Just in case the image is a
        // little off, this will help recover.
        var nudge = moduleSize / 2;
        top += nudge;
        left += nudge;
        // Now just read off the bits
        var bits = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(matrixWidth, matrixHeight);
        for(var y = 0; y < matrixHeight; y++){
            var iOffset = top + y * moduleSize;
            for(var x = 0; x < matrixWidth; x++)if (image.get(left + x * moduleSize, iOffset)) bits.set(x, y);
        }
        return bits;
    };
    DataMatrixReader.moduleSize = function(leftTopBlack, image) {
        var width = image.getWidth();
        var x = leftTopBlack[0];
        var y = leftTopBlack[1];
        while(x < width && image.get(x, y))x++;
        if (x === width) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var moduleSize = x - leftTopBlack[0];
        if (moduleSize === 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        return moduleSize;
    };
    DataMatrixReader.NO_POINTS = [];
    return DataMatrixReader;
}();
var $4ec6a75867c073ad$export$2e2bcd8739ae039 = $4ec6a75867c073ad$var$DataMatrixReader;


var $02b47a85c7594abe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * QR Code reader to use from browser.
 */ var $02b47a85c7594abe$export$5eb1c99461f4b7ef = /** @class */ function(_super) {
    $02b47a85c7594abe$var$__extends(BrowserDatamatrixCodeReader, _super);
    /**
     * Creates an instance of BrowserQRCodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     */ function BrowserDatamatrixCodeReader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $4ec6a75867c073ad$export$2e2bcd8739ae039)(), timeBetweenScansMillis) || this;
    }
    return BrowserDatamatrixCodeReader;
}((0, $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607));



/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode {*/ 





/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.decoder {*/ 

var $0ce95cc0cc4839ff$export$a15989971a778f84;
(function(ErrorCorrectionLevelValues) {
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["L"] = 0] = "L";
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["M"] = 1] = "M";
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["Q"] = 2] = "Q";
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["H"] = 3] = "H";
})($0ce95cc0cc4839ff$export$a15989971a778f84 || ($0ce95cc0cc4839ff$export$a15989971a778f84 = {}));
/**
 * <p>See ISO 18004:2006, 6.5.1. This enum encapsulates the four error correction levels
 * defined by the QR code standard.</p>
 *
 * @author Sean Owen
 */ var $0ce95cc0cc4839ff$var$ErrorCorrectionLevel = /** @class */ function() {
    function ErrorCorrectionLevel(value, stringValue, bits /*int*/ ) {
        this.value = value;
        this.stringValue = stringValue;
        this.bits = bits;
        ErrorCorrectionLevel.FOR_BITS.set(bits, this);
        ErrorCorrectionLevel.FOR_VALUE.set(value, this);
    }
    ErrorCorrectionLevel.prototype.getValue = function() {
        return this.value;
    };
    ErrorCorrectionLevel.prototype.getBits = function() {
        return this.bits;
    };
    ErrorCorrectionLevel.fromString = function(s) {
        switch(s){
            case "L":
                return ErrorCorrectionLevel.L;
            case "M":
                return ErrorCorrectionLevel.M;
            case "Q":
                return ErrorCorrectionLevel.Q;
            case "H":
                return ErrorCorrectionLevel.H;
            default:
                throw new (0, $e8bfbc55b79267d4$export$2e2bcd8739ae039)(s + "not available");
        }
    };
    ErrorCorrectionLevel.prototype.toString = function() {
        return this.stringValue;
    };
    ErrorCorrectionLevel.prototype.equals = function(o) {
        if (!(o instanceof ErrorCorrectionLevel)) return false;
        var other = o;
        return this.value === other.value;
    };
    /**
     * @param bits int containing the two bits encoding a QR Code's error correction level
     * @return ErrorCorrectionLevel representing the encoded error correction level
     */ ErrorCorrectionLevel.forBits = function(bits /*int*/ ) {
        if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        return ErrorCorrectionLevel.FOR_BITS.get(bits);
    };
    ErrorCorrectionLevel.FOR_BITS = new Map();
    ErrorCorrectionLevel.FOR_VALUE = new Map();
    /** L = ~7% correction */ ErrorCorrectionLevel.L = new ErrorCorrectionLevel($0ce95cc0cc4839ff$export$a15989971a778f84.L, "L", 0x01);
    /** M = ~15% correction */ ErrorCorrectionLevel.M = new ErrorCorrectionLevel($0ce95cc0cc4839ff$export$a15989971a778f84.M, "M", 0x00);
    /** Q = ~25% correction */ ErrorCorrectionLevel.Q = new ErrorCorrectionLevel($0ce95cc0cc4839ff$export$a15989971a778f84.Q, "Q", 0x03);
    /** H = ~30% correction */ ErrorCorrectionLevel.H = new ErrorCorrectionLevel($0ce95cc0cc4839ff$export$a15989971a778f84.H, "H", 0x02);
    return ErrorCorrectionLevel;
}();
var $0ce95cc0cc4839ff$export$2e2bcd8739ae039 = $0ce95cc0cc4839ff$var$ErrorCorrectionLevel;



var $4747a8566db1feeb$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Encapsulates a QR Code's format information, including the data mask used and
 * error correction level.</p>
 *
 * @author Sean Owen
 * @see DataMask
 * @see ErrorCorrectionLevel
 */ var $4747a8566db1feeb$var$FormatInformation = /** @class */ function() {
    function FormatInformation(formatInfo /*int*/ ) {
        // Bits 3,4
        this.errorCorrectionLevel = (0, $0ce95cc0cc4839ff$export$2e2bcd8739ae039).forBits(formatInfo >> 3 & 0x03);
        // Bottom 3 bits
        this.dataMask = /*(byte) */ formatInfo & 0x07;
    }
    FormatInformation.numBitsDiffering = function(a /*int*/ , b /*int*/ ) {
        return (0, $902e90c40380930f$export$2e2bcd8739ae039).bitCount(a ^ b);
    };
    /**
     * @param maskedFormatInfo1 format info indicator, with mask still applied
     * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
     *  to establish best match
     * @return information about the format it specifies, or {@code null}
     *  if doesn't seem to match any known pattern
     */ FormatInformation.decodeFormatInformation = function(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
        var formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
        if (formatInfo !== null) return formatInfo;
        // Should return null, but, some QR codes apparently
        // do not mask this info. Try again by actually masking the pattern
        // first
        return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
    };
    FormatInformation.doDecodeFormatInformation = function(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
        var e_1, _a;
        // Find the int in FORMAT_INFO_DECODE_LOOKUP with fewest bits differing
        var bestDifference = Number.MAX_SAFE_INTEGER;
        var bestFormatInfo = 0;
        try {
            for(var _b = $4747a8566db1feeb$var$__values(FormatInformation.FORMAT_INFO_DECODE_LOOKUP), _c = _b.next(); !_c.done; _c = _b.next()){
                var decodeInfo = _c.value;
                var targetInfo = decodeInfo[0];
                if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) // Found an exact match
                return new FormatInformation(decodeInfo[1]);
                var bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
                if (bitsDifference < bestDifference) {
                    bestFormatInfo = decodeInfo[1];
                    bestDifference = bitsDifference;
                }
                if (maskedFormatInfo1 !== maskedFormatInfo2) {
                    // also try the other option
                    bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
                    if (bitsDifference < bestDifference) {
                        bestFormatInfo = decodeInfo[1];
                        bestDifference = bitsDifference;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits
        // differing means we found a match
        if (bestDifference <= 3) return new FormatInformation(bestFormatInfo);
        return null;
    };
    FormatInformation.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    };
    FormatInformation.prototype.getDataMask = function() {
        return this.dataMask;
    };
    /*@Override*/ FormatInformation.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    };
    /*@Override*/ FormatInformation.prototype.equals = function(o) {
        if (!(o instanceof FormatInformation)) return false;
        var other = o;
        return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
    };
    FormatInformation.FORMAT_INFO_MASK_QR = 0x5412;
    /**
     * See ISO 18004:2006, Annex C, Table C.1
     */ FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            0x5412,
            0x00
        ]),
        Int32Array.from([
            0x5125,
            0x01
        ]),
        Int32Array.from([
            0x5E7C,
            0x02
        ]),
        Int32Array.from([
            0x5B4B,
            0x03
        ]),
        Int32Array.from([
            0x45F9,
            0x04
        ]),
        Int32Array.from([
            0x40CE,
            0x05
        ]),
        Int32Array.from([
            0x4F97,
            0x06
        ]),
        Int32Array.from([
            0x4AA0,
            0x07
        ]),
        Int32Array.from([
            0x77C4,
            0x08
        ]),
        Int32Array.from([
            0x72F3,
            0x09
        ]),
        Int32Array.from([
            0x7DAA,
            0x0A
        ]),
        Int32Array.from([
            0x789D,
            0x0B
        ]),
        Int32Array.from([
            0x662F,
            0x0C
        ]),
        Int32Array.from([
            0x6318,
            0x0D
        ]),
        Int32Array.from([
            0x6C41,
            0x0E
        ]),
        Int32Array.from([
            0x6976,
            0x0F
        ]),
        Int32Array.from([
            0x1689,
            0x10
        ]),
        Int32Array.from([
            0x13BE,
            0x11
        ]),
        Int32Array.from([
            0x1CE7,
            0x12
        ]),
        Int32Array.from([
            0x19D0,
            0x13
        ]),
        Int32Array.from([
            0x0762,
            0x14
        ]),
        Int32Array.from([
            0x0255,
            0x15
        ]),
        Int32Array.from([
            0x0D0C,
            0x16
        ]),
        Int32Array.from([
            0x083B,
            0x17
        ]),
        Int32Array.from([
            0x355F,
            0x18
        ]),
        Int32Array.from([
            0x3068,
            0x19
        ]),
        Int32Array.from([
            0x3F31,
            0x1A
        ]),
        Int32Array.from([
            0x3A06,
            0x1B
        ]),
        Int32Array.from([
            0x24B4,
            0x1C
        ]),
        Int32Array.from([
            0x2183,
            0x1D
        ]),
        Int32Array.from([
            0x2EDA,
            0x1E
        ]),
        Int32Array.from([
            0x2BED,
            0x1F
        ])
    ];
    return FormatInformation;
}();
var $4747a8566db1feeb$export$2e2bcd8739ae039 = $4747a8566db1feeb$var$FormatInformation;


var $a02637105f5a027d$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
 * use blocks of differing sizes within one version, so, this encapsulates the parameters for
 * each set of blocks. It also holds the number of error-correction codewords per block since it
 * will be the same across all blocks within one version.</p>
 */ var $a02637105f5a027d$var$ECBlocks = /** @class */ function() {
    function ECBlocks(ecCodewordsPerBlock /*int*/ ) {
        var ecBlocks = [];
        for(var _i = 1; _i < arguments.length; _i++)ecBlocks[_i - 1] = arguments[_i];
        this.ecCodewordsPerBlock = ecCodewordsPerBlock;
        this.ecBlocks = ecBlocks;
    }
    ECBlocks.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    };
    ECBlocks.prototype.getNumBlocks = function() {
        var e_1, _a;
        var total = 0;
        var ecBlocks = this.ecBlocks;
        try {
            for(var ecBlocks_1 = $a02637105f5a027d$var$__values(ecBlocks), ecBlocks_1_1 = ecBlocks_1.next(); !ecBlocks_1_1.done; ecBlocks_1_1 = ecBlocks_1.next()){
                var ecBlock = ecBlocks_1_1.value;
                total += ecBlock.getCount();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecBlocks_1_1 && !ecBlocks_1_1.done && (_a = ecBlocks_1.return)) _a.call(ecBlocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return total;
    };
    ECBlocks.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    };
    ECBlocks.prototype.getECBlocks = function() {
        return this.ecBlocks;
    };
    return ECBlocks;
}();
var $a02637105f5a027d$export$2e2bcd8739ae039 = $a02637105f5a027d$var$ECBlocks;


/**
 * <p>Encapsulates the parameters for one error-correction block in one symbol version.
 * This includes the number of data codewords, and the number of times a block with these
 * parameters is used consecutively in the QR code version's format.</p>
 */ var $bdffb20c38af7c88$var$ECB = /** @class */ function() {
    function ECB(count /*int*/ , dataCodewords /*int*/ ) {
        this.count = count;
        this.dataCodewords = dataCodewords;
    }
    ECB.prototype.getCount = function() {
        return this.count;
    };
    ECB.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    };
    return ECB;
}();
var $bdffb20c38af7c88$export$2e2bcd8739ae039 = $bdffb20c38af7c88$var$ECB;




var $1571c868cb7a6ba4$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * See ISO 18004:2006 Annex D
 *
 * @author Sean Owen
 */ var $1571c868cb7a6ba4$var$Version = /** @class */ function() {
    function Version(versionNumber /*int*/ , alignmentPatternCenters) {
        var e_1, _a;
        var ecBlocks = [];
        for(var _i = 2; _i < arguments.length; _i++)ecBlocks[_i - 2] = arguments[_i];
        this.versionNumber = versionNumber;
        this.alignmentPatternCenters = alignmentPatternCenters;
        this.ecBlocks = ecBlocks;
        var total = 0;
        var ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
        var ecbArray = ecBlocks[0].getECBlocks();
        try {
            for(var ecbArray_1 = $1571c868cb7a6ba4$var$__values(ecbArray), ecbArray_1_1 = ecbArray_1.next(); !ecbArray_1_1.done; ecbArray_1_1 = ecbArray_1.next()){
                var ecBlock = ecbArray_1_1.value;
                total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecbArray_1_1 && !ecbArray_1_1.done && (_a = ecbArray_1.return)) _a.call(ecbArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.totalCodewords = total;
    }
    Version.prototype.getVersionNumber = function() {
        return this.versionNumber;
    };
    Version.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    };
    Version.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    };
    Version.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    };
    Version.prototype.getECBlocksForLevel = function(ecLevel) {
        return this.ecBlocks[ecLevel.getValue()];
    // TYPESCRIPTPORT: original was using ordinal, and using the order of levels as defined in ErrorCorrectionLevel enum (LMQH)
    // I will use the direct value from ErrorCorrectionLevelValues enum which in typescript goes to a number
    };
    /**
     * <p>Deduces version information purely from QR Code dimensions.</p>
     *
     * @param dimension dimension in modules
     * @return Version for a QR Code of that dimension
     * @throws FormatException if dimension is not 1 mod 4
     */ Version.getProvisionalVersionForDimension = function(dimension /*int*/ ) {
        if (dimension % 4 !== 1) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        try {
            return this.getVersionForNumber((dimension - 17) / 4);
        } catch (ignored /*: IllegalArgumentException*/ ) {
            throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        }
    };
    Version.getVersionForNumber = function(versionNumber /*int*/ ) {
        if (versionNumber < 1 || versionNumber > 40) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        return Version.VERSIONS[versionNumber - 1];
    };
    Version.decodeVersionInformation = function(versionBits /*int*/ ) {
        var bestDifference = Number.MAX_SAFE_INTEGER;
        var bestVersion = 0;
        for(var i = 0; i < Version.VERSION_DECODE_INFO.length; i++){
            var targetVersion = Version.VERSION_DECODE_INFO[i];
            // Do the version info bits match exactly? done.
            if (targetVersion === versionBits) return Version.getVersionForNumber(i + 7);
            // Otherwise see if this is the closest to a real version info bit string
            // we have seen so far
            var bitsDifference = (0, $4747a8566db1feeb$export$2e2bcd8739ae039).numBitsDiffering(versionBits, targetVersion);
            if (bitsDifference < bestDifference) {
                bestVersion = i + 7;
                bestDifference = bitsDifference;
            }
        }
        // We can tolerate up to 3 bits of error since no two version info codewords will
        // differ in less than 8 bits.
        if (bestDifference <= 3) return Version.getVersionForNumber(bestVersion);
        // If we didn't find a close enough match, fail
        return null;
    };
    /**
     * See ISO 18004:2006 Annex E
     */ Version.prototype.buildFunctionPattern = function() {
        var dimension = this.getDimensionForVersion();
        var bitMatrix = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(dimension);
        // Top left finder pattern + separator + format
        bitMatrix.setRegion(0, 0, 9, 9);
        // Top right finder pattern + separator + format
        bitMatrix.setRegion(dimension - 8, 0, 8, 9);
        // Bottom left finder pattern + separator + format
        bitMatrix.setRegion(0, dimension - 8, 9, 8);
        // Alignment patterns
        var max = this.alignmentPatternCenters.length;
        for(var x = 0; x < max; x++){
            var i = this.alignmentPatternCenters[x] - 2;
            for(var y = 0; y < max; y++){
                if (x === 0 && (y === 0 || y === max - 1) || x === max - 1 && y === 0) continue;
                bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
            }
        }
        // Vertical timing pattern
        bitMatrix.setRegion(6, 9, 1, dimension - 17);
        // Horizontal timing pattern
        bitMatrix.setRegion(9, 6, dimension - 17, 1);
        if (this.versionNumber > 6) {
            // Version info, top right
            bitMatrix.setRegion(dimension - 11, 0, 3, 6);
            // Version info, bottom left
            bitMatrix.setRegion(0, dimension - 11, 6, 3);
        }
        return bitMatrix;
    };
    /*@Override*/ Version.prototype.toString = function() {
        return "" + this.versionNumber;
    };
    /**
       * See ISO 18004:2006 Annex D.
       * Element i represents the raw version bits that specify version i + 7
       */ Version.VERSION_DECODE_INFO = Int32Array.from([
        0x07C94,
        0x085BC,
        0x09A99,
        0x0A4D3,
        0x0BBF6,
        0x0C762,
        0x0D847,
        0x0E60D,
        0x0F928,
        0x10B78,
        0x1145D,
        0x12A17,
        0x13532,
        0x149A6,
        0x15683,
        0x168C9,
        0x177EC,
        0x18EC4,
        0x191E1,
        0x1AFAB,
        0x1B08E,
        0x1CC1A,
        0x1D33F,
        0x1ED75,
        0x1F250,
        0x209D5,
        0x216F0,
        0x228BA,
        0x2379F,
        0x24B0B,
        0x2542E,
        0x26A64,
        0x27541,
        0x28C69
    ]);
    /**
       * See ISO 18004:2006 6.5.1 Table 9
       */ Version.VERSIONS = [
        new Version(1, new Int32Array(0), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(7, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 19)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(10, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 16)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(13, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 13)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(17, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 9))),
        new Version(2, Int32Array.from([
            6,
            18
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(10, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 34)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(16, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 28)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 22)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 16))),
        new Version(3, Int32Array.from([
            6,
            22
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(15, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 55)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 44)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 17)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 13))),
        new Version(4, Int32Array.from([
            6,
            26
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(20, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 80)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 32)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 24)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(16, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 9))),
        new Version(5, Int32Array.from([
            6,
            30
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 108)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 43)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 16)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 11), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 12))),
        new Version(6, Int32Array.from([
            6,
            34
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 68)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(16, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 27)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 19)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 15))),
        new Version(7, Int32Array.from([
            6,
            22,
            38
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(20, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 78)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 31)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 14), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 15)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 13), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 14))),
        new Version(8, Int32Array.from([
            6,
            24,
            42
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 97)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 38), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 39)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 18), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 19)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 14), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 15))),
        new Version(9, Int32Array.from([
            6,
            26,
            46
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 116)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 36), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 37)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(20, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 16), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 17)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 12), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 13))),
        new Version(10, Int32Array.from([
            6,
            28,
            50
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(18, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 68), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 69)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 43), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 44)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 19), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 20)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 16))),
        new Version(11, Int32Array.from([
            6,
            30,
            54
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(20, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 81)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 50), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 51)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 22), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 23)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 12), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 13))),
        new Version(12, Int32Array.from([
            6,
            32,
            58
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 92), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 93)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 36), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 37)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 20), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 21)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 14), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 15))),
        new Version(13, Int32Array.from([
            6,
            34,
            62
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 107)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 37), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 38)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 20), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 21)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(12, 11), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 12))),
        new Version(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 115), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 116)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 40), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 41)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(20, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 16), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 17)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 12), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 13))),
        new Version(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(22, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 87), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 88)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 41), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 42)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 12), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 13))),
        new Version(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 98), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 99)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 45), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 46)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(15, 19), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 20)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 16))),
        new Version(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 107), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 108)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 22), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(15, 23)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 14), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 15))),
        new Version(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 120), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 121)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(9, 43), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 44)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 22), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 23)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 14), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 15))),
        new Version(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 113), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 114)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 44), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 45)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 21), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 22)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(9, 13), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(16, 14))),
        new Version(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 107), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 108)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 41), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 42)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(15, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(15, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 16))),
        new Version(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 116), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 117)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 42)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 22), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 23)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 16), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 17))),
        new Version(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 111), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 112)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 46)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(16, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(24, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(34, 13))),
        new Version(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 121), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 122)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(16, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 16))),
        new Version(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 117), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 118)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 45), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 46)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(16, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(30, 16), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 17))),
        new Version(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(26, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 106), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 107)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(22, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(22, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 16))),
        new Version(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 114), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 115)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(28, 22), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 23)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(33, 16), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 17))),
        new Version(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 122), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 123)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(22, 45), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 46)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(8, 23), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(26, 24)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(12, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(28, 16))),
        new Version(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 117), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 118)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 45), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(23, 46)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(31, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(31, 16))),
        new Version(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 116), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 117)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(21, 45), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 46)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 23), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(37, 24)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(26, 16))),
        new Version(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(5, 115), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 116)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(15, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(25, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(23, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(25, 16))),
        new Version(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 115), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(3, 116)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(29, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(42, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(23, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(28, 16))),
        new Version(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 115)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(23, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(35, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(35, 16))),
        new Version(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 115), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 116)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(21, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(29, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(11, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(46, 16))),
        new Version(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 115), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 116)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(23, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(44, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(59, 16), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(1, 17))),
        new Version(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(12, 121), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 122)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(12, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(26, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(39, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(22, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(41, 16))),
        new Version(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 121), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 122)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(34, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(46, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(2, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(64, 16))),
        new Version(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(17, 122), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 123)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(29, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(49, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(24, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(46, 16))),
        new Version(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 122), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(18, 123)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(13, 46), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(32, 47)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(48, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(14, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(42, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(32, 16))),
        new Version(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(20, 117), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(4, 118)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(40, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(7, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(43, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(22, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(10, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(67, 16))),
        new Version(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(19, 118), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(6, 119)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(28, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(18, 47), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(31, 48)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(34, 24), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(34, 25)), new (0, $a02637105f5a027d$export$2e2bcd8739ae039)(30, new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(20, 15), new (0, $bdffb20c38af7c88$export$2e2bcd8739ae039)(61, 16)))
    ];
    return Version;
}();
var $1571c868cb7a6ba4$export$2e2bcd8739ae039 = $1571c868cb7a6ba4$var$Version;



/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $09cd705f64414715$export$ff43d31cc568a75f;
(function(DataMaskValues) {
    DataMaskValues[DataMaskValues["DATA_MASK_000"] = 0] = "DATA_MASK_000";
    DataMaskValues[DataMaskValues["DATA_MASK_001"] = 1] = "DATA_MASK_001";
    DataMaskValues[DataMaskValues["DATA_MASK_010"] = 2] = "DATA_MASK_010";
    DataMaskValues[DataMaskValues["DATA_MASK_011"] = 3] = "DATA_MASK_011";
    DataMaskValues[DataMaskValues["DATA_MASK_100"] = 4] = "DATA_MASK_100";
    DataMaskValues[DataMaskValues["DATA_MASK_101"] = 5] = "DATA_MASK_101";
    DataMaskValues[DataMaskValues["DATA_MASK_110"] = 6] = "DATA_MASK_110";
    DataMaskValues[DataMaskValues["DATA_MASK_111"] = 7] = "DATA_MASK_111";
})($09cd705f64414715$export$ff43d31cc568a75f || ($09cd705f64414715$export$ff43d31cc568a75f = {}));
/**
 * <p>Encapsulates data masks for the data bits in a QR code, per ISO 18004:2006 6.8. Implementations
 * of this class can un-mask a raw BitMatrix. For simplicity, they will unmask the entire BitMatrix,
 * including areas used for finder patterns, timing patterns, etc. These areas should be unused
 * after the point they are unmasked anyway.</p>
 *
 * <p>Note that the diagram in section 6.8.1 is misleading since it indicates that i is column position
 * and j is row position. In fact, as the text says, i is row position and j is column position.</p>
 *
 * @author Sean Owen
 */ var $09cd705f64414715$var$DataMask = /** @class */ function() {
    // See ISO 18004:2006 6.8.1
    function DataMask(value, isMasked) {
        this.value = value;
        this.isMasked = isMasked;
    }
    // End of enum constants.
    /**
     * <p>Implementations of this method reverse the data masking process applied to a QR Code and
     * make its bits ready to read.</p>
     *
     * @param bits representation of QR Code bits
     * @param dimension dimension of QR Code, represented by bits, being unmasked
     */ DataMask.prototype.unmaskBitMatrix = function(bits, dimension /*int*/ ) {
        for(var i = 0; i < dimension; i++){
            for(var j = 0; j < dimension; j++)if (this.isMasked(i, j)) bits.flip(j, i);
        }
    };
    DataMask.values = new Map([
        /**
         * 000: mask bits for which (x + y) mod 2 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_000,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_000, function(i /*int*/ , j /*int*/ ) {
                return (i + j & 0x01) === 0;
            })
        ],
        /**
         * 001: mask bits for which x mod 2 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_001,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_001, function(i /*int*/ , j /*int*/ ) {
                return (i & 0x01) === 0;
            })
        ],
        /**
         * 010: mask bits for which y mod 3 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_010,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_010, function(i /*int*/ , j /*int*/ ) {
                return j % 3 === 0;
            })
        ],
        /**
         * 011: mask bits for which (x + y) mod 3 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_011,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_011, function(i /*int*/ , j /*int*/ ) {
                return (i + j) % 3 === 0;
            })
        ],
        /**
         * 100: mask bits for which (x/2 + y/3) mod 2 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_100,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_100, function(i /*int*/ , j /*int*/ ) {
                return (Math.floor(i / 2) + Math.floor(j / 3) & 0x01) === 0;
            })
        ],
        /**
         * 101: mask bits for which xy mod 2 + xy mod 3 == 0
         * equivalently, such that xy mod 6 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_101,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_101, function(i /*int*/ , j /*int*/ ) {
                return i * j % 6 === 0;
            })
        ],
        /**
         * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that xy mod 6 < 3
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_110,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_110, function(i /*int*/ , j /*int*/ ) {
                return i * j % 6 < 3;
            })
        ],
        /**
         * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that (x + y + xy mod 3) mod 2 == 0
         */ [
            $09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_111,
            new DataMask($09cd705f64414715$export$ff43d31cc568a75f.DATA_MASK_111, function(i /*int*/ , j /*int*/ ) {
                return (i + j + i * j % 3 & 0x01) === 0;
            })
        ]
    ]);
    return DataMask;
}();
var $09cd705f64414715$export$2e2bcd8739ae039 = $09cd705f64414715$var$DataMask;



/**
 * @author Sean Owen
 */ var $c936bea4d967f015$var$BitMatrixParser = /** @class */ function() {
    /**
     * @param bitMatrix {@link BitMatrix} to parse
     * @throws FormatException if dimension is not >= 21 and 1 mod 4
     */ function BitMatrixParser(bitMatrix) {
        var dimension = bitMatrix.getHeight();
        if (dimension < 21 || (dimension & 0x03) !== 1) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        this.bitMatrix = bitMatrix;
    }
    /**
     * <p>Reads format information from one of its two locations within the QR Code.</p>
     *
     * @return {@link FormatInformation} encapsulating the QR Code's format info
     * @throws FormatException if both format information locations cannot be parsed as
     * the valid encoding of format information
     */ BitMatrixParser.prototype.readFormatInformation = function() {
        if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== undefined) return this.parsedFormatInfo;
        // Read top-left format info bits
        var formatInfoBits1 = 0;
        for(var i = 0; i < 6; i++)formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
        // .. and skip a bit in the timing pattern ...
        formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
        formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
        formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
        // .. and skip a bit in the timing pattern ...
        for(var j = 5; j >= 0; j--)formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
        // Read the top-right/bottom-left pattern too
        var dimension = this.bitMatrix.getHeight();
        var formatInfoBits2 = 0;
        var jMin = dimension - 7;
        for(var j = dimension - 1; j >= jMin; j--)formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
        for(var i = dimension - 8; i < dimension; i++)formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
        this.parsedFormatInfo = (0, $4747a8566db1feeb$export$2e2bcd8739ae039).decodeFormatInformation(formatInfoBits1, formatInfoBits2);
        if (this.parsedFormatInfo !== null) return this.parsedFormatInfo;
        throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
    };
    /**
     * <p>Reads version information from one of its two locations within the QR Code.</p>
     *
     * @return {@link Version} encapsulating the QR Code's version
     * @throws FormatException if both version information locations cannot be parsed as
     * the valid encoding of version information
     */ BitMatrixParser.prototype.readVersion = function() {
        if (this.parsedVersion !== null && this.parsedVersion !== undefined) return this.parsedVersion;
        var dimension = this.bitMatrix.getHeight();
        var provisionalVersion = Math.floor((dimension - 17) / 4);
        if (provisionalVersion <= 6) return (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).getVersionForNumber(provisionalVersion);
        // Read top-right version info: 3 wide by 6 tall
        var versionBits = 0;
        var ijMin = dimension - 11;
        for(var j = 5; j >= 0; j--)for(var i = dimension - 9; i >= ijMin; i--)versionBits = this.copyBit(i, j, versionBits);
        var theParsedVersion = (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).decodeVersionInformation(versionBits);
        if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
            this.parsedVersion = theParsedVersion;
            return theParsedVersion;
        }
        // Hmm, failed. Try bottom left: 6 wide by 3 tall
        versionBits = 0;
        for(var i = 5; i >= 0; i--)for(var j = dimension - 9; j >= ijMin; j--)versionBits = this.copyBit(i, j, versionBits);
        theParsedVersion = (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).decodeVersionInformation(versionBits);
        if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
            this.parsedVersion = theParsedVersion;
            return theParsedVersion;
        }
        throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
    };
    BitMatrixParser.prototype.copyBit = function(i /*int*/ , j /*int*/ , versionBits /*int*/ ) {
        var bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
        return bit ? versionBits << 1 | 0x1 : versionBits << 1;
    };
    /**
     * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
     * correct order in order to reconstruct the codewords bytes contained within the
     * QR Code.</p>
     *
     * @return bytes encoded within the QR Code
     * @throws FormatException if the exact number of bytes expected is not read
     */ BitMatrixParser.prototype.readCodewords = function() {
        var formatInfo = this.readFormatInformation();
        var version = this.readVersion();
        // Get the data mask for the format used in this QR Code. This will exclude
        // some bits from reading as we wind through the bit matrix.
        var dataMask = (0, $09cd705f64414715$export$2e2bcd8739ae039).values.get(formatInfo.getDataMask());
        var dimension = this.bitMatrix.getHeight();
        dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        var functionPattern = version.buildFunctionPattern();
        var readingUp = true;
        var result = new Uint8Array(version.getTotalCodewords());
        var resultOffset = 0;
        var currentByte = 0;
        var bitsRead = 0;
        // Read columns in pairs, from right to left
        for(var j = dimension - 1; j > 0; j -= 2){
            if (j === 6) // Skip whole column with vertical alignment pattern
            // saves time and makes the other code proceed more cleanly
            j--;
            // Read alternatingly from bottom to top then top to bottom
            for(var count = 0; count < dimension; count++){
                var i = readingUp ? dimension - 1 - count : count;
                for(var col = 0; col < 2; col++)// Ignore bits covered by the function pattern
                if (!functionPattern.get(j - col, i)) {
                    // Read a bit
                    bitsRead++;
                    currentByte <<= 1;
                    if (this.bitMatrix.get(j - col, i)) currentByte |= 1;
                    // If we've made a whole byte, save it off
                    if (bitsRead === 8) {
                        result[resultOffset++] = /*(byte) */ currentByte;
                        bitsRead = 0;
                        currentByte = 0;
                    }
                }
            }
            readingUp = !readingUp; // readingUp ^= true; // readingUp = !readingUp; // switch directions
        }
        if (resultOffset !== version.getTotalCodewords()) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        return result;
    };
    /**
     * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
     */ BitMatrixParser.prototype.remask = function() {
        if (this.parsedFormatInfo === null) return; // We have no format information, and have no data mask
        var dataMask = (0, $09cd705f64414715$export$2e2bcd8739ae039).values[this.parsedFormatInfo.getDataMask()];
        var dimension = this.bitMatrix.getHeight();
        dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
    };
    /**
     * Prepare the parser for a mirrored operation.
     * This flag has effect only on the {@link #readFormatInformation()} and the
     * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
     * {@link #mirror()} method should be called.
     *
     * @param mirror Whether to read version and format information mirrored.
     */ BitMatrixParser.prototype.setMirror = function(isMirror) {
        this.parsedVersion = null;
        this.parsedFormatInfo = null;
        this.isMirror = isMirror;
    };
    /** Mirror the bit matrix in order to attempt a second reading. */ BitMatrixParser.prototype.mirror = function() {
        var bitMatrix = this.bitMatrix;
        for(var x = 0, width = bitMatrix.getWidth(); x < width; x++){
            for(var y = x + 1, height = bitMatrix.getHeight(); y < height; y++)if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
                bitMatrix.flip(y, x);
                bitMatrix.flip(x, y);
            }
        }
    };
    return BitMatrixParser;
}();
var $c936bea4d967f015$export$2e2bcd8739ae039 = $c936bea4d967f015$var$BitMatrixParser;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4dcd7c366b02bf46$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Encapsulates a block of data within a QR Code. QR Codes may split their data into
 * multiple blocks, each of which is a unit of data and error-correction codewords. Each
 * is represented by an instance of this class.</p>
 *
 * @author Sean Owen
 */ var $4dcd7c366b02bf46$var$DataBlock = /** @class */ function() {
    function DataBlock(numDataCodewords /*int*/ , codewords) {
        this.numDataCodewords = numDataCodewords;
        this.codewords = codewords;
    }
    /**
     * <p>When QR Codes use multiple data blocks, they are actually interleaved.
     * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
     * method will separate the data into original blocks.</p>
     *
     * @param rawCodewords bytes as read directly from the QR Code
     * @param version version of the QR Code
     * @param ecLevel error-correction level of the QR Code
     * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
     *         QR Code
     */ DataBlock.getDataBlocks = function(rawCodewords, version, ecLevel) {
        var e_1, _a, e_2, _b;
        if (rawCodewords.length !== version.getTotalCodewords()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        // Figure out the number and size of data blocks used by this version and
        // error correction level
        var ecBlocks = version.getECBlocksForLevel(ecLevel);
        // First count the total number of data blocks
        var totalBlocks = 0;
        var ecBlockArray = ecBlocks.getECBlocks();
        try {
            for(var ecBlockArray_1 = $4dcd7c366b02bf46$var$__values(ecBlockArray), ecBlockArray_1_1 = ecBlockArray_1.next(); !ecBlockArray_1_1.done; ecBlockArray_1_1 = ecBlockArray_1.next()){
                var ecBlock = ecBlockArray_1_1.value;
                totalBlocks += ecBlock.getCount();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecBlockArray_1_1 && !ecBlockArray_1_1.done && (_a = ecBlockArray_1.return)) _a.call(ecBlockArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Now establish DataBlocks of the appropriate size and number of data codewords
        var result = new Array(totalBlocks);
        var numResultBlocks = 0;
        try {
            for(var ecBlockArray_2 = $4dcd7c366b02bf46$var$__values(ecBlockArray), ecBlockArray_2_1 = ecBlockArray_2.next(); !ecBlockArray_2_1.done; ecBlockArray_2_1 = ecBlockArray_2.next()){
                var ecBlock = ecBlockArray_2_1.value;
                for(var i = 0; i < ecBlock.getCount(); i++){
                    var numDataCodewords = ecBlock.getDataCodewords();
                    var numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
                    result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (ecBlockArray_2_1 && !ecBlockArray_2_1.done && (_b = ecBlockArray_2.return)) _b.call(ecBlockArray_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // All blocks have the same amount of data, except that the last n
        // (where n may be 0) have 1 more byte. Figure out where these start.
        var shorterBlocksTotalCodewords = result[0].codewords.length;
        var longerBlocksStartAt = result.length - 1;
        // TYPESCRIPTPORT: check length is correct here
        while(longerBlocksStartAt >= 0){
            var numCodewords = result[longerBlocksStartAt].codewords.length;
            if (numCodewords === shorterBlocksTotalCodewords) break;
            longerBlocksStartAt--;
        }
        longerBlocksStartAt++;
        var shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
        // The last elements of result may be 1 element longer
        // first fill out as many elements as all of them have
        var rawCodewordsOffset = 0;
        for(var i = 0; i < shorterBlocksNumDataCodewords; i++)for(var j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
        // Fill out the last data block in the longer ones
        for(var j = longerBlocksStartAt; j < numResultBlocks; j++)result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
        // Now add in error correction blocks
        var max = result[0].codewords.length;
        for(var i = shorterBlocksNumDataCodewords; i < max; i++)for(var j = 0; j < numResultBlocks; j++){
            var iOffset = j < longerBlocksStartAt ? i : i + 1;
            result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
        }
        return result;
    };
    DataBlock.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    };
    DataBlock.prototype.getCodewords = function() {
        return this.codewords;
    };
    return DataBlock;
}();
var $4dcd7c366b02bf46$export$2e2bcd8739ae039 = $4dcd7c366b02bf46$var$DataBlock;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.decoder {*/ 






/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $d9a459a8dae87a87$export$b241eb2cadd22852;
(function(ModeValues) {
    ModeValues[ModeValues["TERMINATOR"] = 0] = "TERMINATOR";
    ModeValues[ModeValues["NUMERIC"] = 1] = "NUMERIC";
    ModeValues[ModeValues["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
    ModeValues[ModeValues["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
    ModeValues[ModeValues["BYTE"] = 4] = "BYTE";
    ModeValues[ModeValues["ECI"] = 5] = "ECI";
    ModeValues[ModeValues["KANJI"] = 6] = "KANJI";
    ModeValues[ModeValues["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
    ModeValues[ModeValues["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ ModeValues[ModeValues["HANZI"] = 9] = "HANZI";
})($d9a459a8dae87a87$export$b241eb2cadd22852 || ($d9a459a8dae87a87$export$b241eb2cadd22852 = {}));
/**
 * <p>See ISO 18004:2006, 6.4.1, Tables 2 and 3. This enum encapsulates the various modes in which
 * data can be encoded to bits in the QR code standard.</p>
 *
 * @author Sean Owen
 */ var $d9a459a8dae87a87$var$Mode = /** @class */ function() {
    function Mode(value, stringValue, characterCountBitsForVersions, bits /*int*/ ) {
        this.value = value;
        this.stringValue = stringValue;
        this.characterCountBitsForVersions = characterCountBitsForVersions;
        this.bits = bits;
        Mode.FOR_BITS.set(bits, this);
        Mode.FOR_VALUE.set(value, this);
    }
    /**
     * @param bits four bits encoding a QR Code data mode
     * @return Mode encoded by these bits
     * @throws IllegalArgumentException if bits do not correspond to a known mode
     */ Mode.forBits = function(bits /*int*/ ) {
        var mode = Mode.FOR_BITS.get(bits);
        if (undefined === mode) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        return mode;
    };
    /**
     * @param version version in question
     * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
     *         count of characters that will follow encoded in this Mode
     */ Mode.prototype.getCharacterCountBits = function(version) {
        var versionNumber = version.getVersionNumber();
        var offset;
        if (versionNumber <= 9) offset = 0;
        else if (versionNumber <= 26) offset = 1;
        else offset = 2;
        return this.characterCountBitsForVersions[offset];
    };
    Mode.prototype.getValue = function() {
        return this.value;
    };
    Mode.prototype.getBits = function() {
        return this.bits;
    };
    Mode.prototype.equals = function(o) {
        if (!(o instanceof Mode)) return false;
        var other = o;
        return this.value === other.value;
    };
    Mode.prototype.toString = function() {
        return this.stringValue;
    };
    Mode.FOR_BITS = new Map();
    Mode.FOR_VALUE = new Map();
    Mode.TERMINATOR = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0x00); // Not really a mode...
    Mode.NUMERIC = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 0x01);
    Mode.ALPHANUMERIC = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 0x02);
    Mode.STRUCTURED_APPEND = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 0x03); // Not supported
    Mode.BYTE = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 0x04);
    Mode.ECI = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 0x07); // character counts don't apply
    Mode.KANJI = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 0x08);
    Mode.FNC1_FIRST_POSITION = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 0x05);
    Mode.FNC1_SECOND_POSITION = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 0x09);
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ Mode.HANZI = new Mode($d9a459a8dae87a87$export$b241eb2cadd22852.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 0x0D);
    return Mode;
}();
var $d9a459a8dae87a87$export$2e2bcd8739ae039 = $d9a459a8dae87a87$var$Mode;


/*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
 * <p>QR Codes can encode text as bits in one of several modes, and can use multiple modes
 * in one QR Code. This class decodes the bits back into text.</p>
 *
 * <p>See ISO 18004:2006, 6.4.3 - 6.4.7</p>
 *
 * @author Sean Owen
 */ var $5c44b39e4ab32768$var$DecodedBitStreamParser = /** @class */ function() {
    function DecodedBitStreamParser() {}
    DecodedBitStreamParser.decode = function(bytes, version, ecLevel, hints) {
        var bits = new (0, $30e343486e0343e4$export$2e2bcd8739ae039)(bytes);
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        var byteSegments = new Array(); // 1
        // TYPESCRIPTPORT: I do not use constructor with size 1 as in original Java means capacity and the array length is checked below
        var symbolSequence = -1;
        var parityData = -1;
        try {
            var currentCharacterSetECI = null;
            var fc1InEffect = false;
            var mode = void 0;
            do {
                // While still another segment to read...
                if (bits.available() < 4) // OK, assume we're done. Really, a TERMINATOR mode should have been recorded here
                mode = (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).TERMINATOR;
                else {
                    var modeBits = bits.readBits(4);
                    mode = (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).forBits(modeBits); // mode is encoded by 4 bits
                }
                switch(mode){
                    case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).TERMINATOR:
                        break;
                    case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).FNC1_FIRST_POSITION:
                    case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).FNC1_SECOND_POSITION:
                        // We do little with FNC1 except alter the parsed result a bit according to the spec
                        fc1InEffect = true;
                        break;
                    case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).STRUCTURED_APPEND:
                        if (bits.available() < 16) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        // sequence number and parity is added later to the result metadata
                        // Read next 8 bits (symbol sequence #) and 8 bits (data: parity), then continue
                        symbolSequence = bits.readBits(8);
                        parityData = bits.readBits(8);
                        break;
                    case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).ECI:
                        // Count doesn't apply to ECI
                        var value = DecodedBitStreamParser.parseECIValue(bits);
                        currentCharacterSetECI = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).getCharacterSetECIByValue(value);
                        if (currentCharacterSetECI === null) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        break;
                    case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).HANZI:
                        // First handle Hanzi mode which does not start with character count
                        // Chinese mode contains a sub set indicator right after mode indicator
                        var subset = bits.readBits(4);
                        var countHanzi = bits.readBits(mode.getCharacterCountBits(version));
                        if (subset === DecodedBitStreamParser.GB2312_SUBSET) DecodedBitStreamParser.decodeHanziSegment(bits, result, countHanzi);
                        break;
                    default:
                        // "Normal" QR code modes:
                        // How many characters will follow, encoded in this mode?
                        var count = bits.readBits(mode.getCharacterCountBits(version));
                        switch(mode){
                            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).NUMERIC:
                                DecodedBitStreamParser.decodeNumericSegment(bits, result, count);
                                break;
                            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).ALPHANUMERIC:
                                DecodedBitStreamParser.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                                break;
                            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).BYTE:
                                DecodedBitStreamParser.decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints);
                                break;
                            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).KANJI:
                                DecodedBitStreamParser.decodeKanjiSegment(bits, result, count);
                                break;
                            default:
                                throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                        }
                        break;
                }
            }while (mode !== (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).TERMINATOR);
        } catch (iae /*: IllegalArgumentException*/ ) {
            // from readBits() calls
            throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        }
        return new (0, $aa602f5deffed2f7$export$2e2bcd8739ae039)(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
    };
    /**
     * See specification GBT 18284-2000
     */ DecodedBitStreamParser.decodeHanziSegment = function(bits, result, count /*int*/ ) {
        // Don't crash trying to read more bits than we have available.
        if (count * 13 > bits.available()) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        // Each character will require 2 bytes. Read the characters as 2-byte pairs
        // and decode as GB2312 afterwards
        var buffer = new Uint8Array(2 * count);
        var offset = 0;
        while(count > 0){
            // Each 13 bits encodes a 2-byte character
            var twoBytes = bits.readBits(13);
            var assembledTwoBytes = twoBytes / 0x060 << 8 & 0xFFFFFFFF | twoBytes % 0x060;
            if (assembledTwoBytes < 0x003BF) // In the 0xA1A1 to 0xAAFE range
            assembledTwoBytes += 0x0A1A1;
            else // In the 0xB0A1 to 0xFAFE range
            assembledTwoBytes += 0x0A6A1;
            buffer[offset] = /*(byte) */ assembledTwoBytes >> 8 & 0xFF;
            buffer[offset + 1] = /*(byte) */ assembledTwoBytes & 0xFF;
            offset += 2;
            count--;
        }
        try {
            result.append((0, $3a88fa58822b35a1$export$2e2bcd8739ae039).decode(buffer, (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).GB2312));
        // TYPESCRIPTPORT: TODO: implement GB2312 decode. StringView from MDN could be a starting point
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)(ignored);
        }
    };
    DecodedBitStreamParser.decodeKanjiSegment = function(bits, result, count /*int*/ ) {
        // Don't crash trying to read more bits than we have available.
        if (count * 13 > bits.available()) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        // Each character will require 2 bytes. Read the characters as 2-byte pairs
        // and decode as Shift_JIS afterwards
        var buffer = new Uint8Array(2 * count);
        var offset = 0;
        while(count > 0){
            // Each 13 bits encodes a 2-byte character
            var twoBytes = bits.readBits(13);
            var assembledTwoBytes = twoBytes / 0x0C0 << 8 & 0xFFFFFFFF | twoBytes % 0x0C0;
            if (assembledTwoBytes < 0x01F00) // In the 0x8140 to 0x9FFC range
            assembledTwoBytes += 0x08140;
            else // In the 0xE040 to 0xEBBF range
            assembledTwoBytes += 0x0C140;
            buffer[offset] = /*(byte) */ assembledTwoBytes >> 8;
            buffer[offset + 1] = /*(byte) */ assembledTwoBytes;
            offset += 2;
            count--;
        }
        // Shift_JIS may not be supported in some environments:
        try {
            result.append((0, $3a88fa58822b35a1$export$2e2bcd8739ae039).decode(buffer, (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).SHIFT_JIS));
        // TYPESCRIPTPORT: TODO: implement SHIFT_JIS decode. StringView from MDN could be a starting point
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)(ignored);
        }
    };
    DecodedBitStreamParser.decodeByteSegment = function(bits, result, count /*int*/ , currentCharacterSetECI, byteSegments, hints) {
        // Don't crash trying to read more bits than we have available.
        if (8 * count > bits.available()) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        var readBytes = new Uint8Array(count);
        for(var i = 0; i < count; i++)readBytes[i] = /*(byte) */ bits.readBits(8);
        var encoding;
        if (currentCharacterSetECI === null) // The spec isn't clear on this mode; see
        // section 6.4.5: t does not say which encoding to assuming
        // upon decoding. I have seen ISO-8859-1 used as well as
        // Shift_JIS -- without anything like an ECI designator to
        // give a hint.
        encoding = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).guessEncoding(readBytes, hints);
        else encoding = currentCharacterSetECI.getName();
        try {
            result.append((0, $3a88fa58822b35a1$export$2e2bcd8739ae039).decode(readBytes, encoding));
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)(ignored);
        }
        byteSegments.push(readBytes);
    };
    DecodedBitStreamParser.toAlphaNumericChar = function(value /*int*/ ) {
        if (value >= DecodedBitStreamParser.ALPHANUMERIC_CHARS.length) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        return DecodedBitStreamParser.ALPHANUMERIC_CHARS[value];
    };
    DecodedBitStreamParser.decodeAlphanumericSegment = function(bits, result, count /*int*/ , fc1InEffect) {
        // Read two characters at a time
        var start = result.length();
        while(count > 1){
            if (bits.available() < 11) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            var nextTwoCharsBits = bits.readBits(11);
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(nextTwoCharsBits % 45));
            count -= 2;
        }
        if (count === 1) {
            // special case: one character left
            if (bits.available() < 6) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(bits.readBits(6)));
        }
        // See section 6.4.8.1, 6.4.8.2
        if (fc1InEffect) {
            // We need to massage the result a bit if in an FNC1 mode:
            for(var i = start; i < result.length(); i++)if (result.charAt(i) === "%") {
                if (i < result.length() - 1 && result.charAt(i + 1) === "%") // %% is rendered as %
                result.deleteCharAt(i + 1);
                else // In alpha mode, % should be converted to FNC1 separator 0x1D
                result.setCharAt(i, String.fromCharCode(0x1D));
            }
        }
    };
    DecodedBitStreamParser.decodeNumericSegment = function(bits, result, count /*int*/ ) {
        // Read three digits at a time
        while(count >= 3){
            // Each 10 bits encodes three digits
            if (bits.available() < 10) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            var threeDigitsBits = bits.readBits(10);
            if (threeDigitsBits >= 1000) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(threeDigitsBits % 10));
            count -= 3;
        }
        if (count === 2) {
            // Two digits left over to read, encoded in 7 bits
            if (bits.available() < 7) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            var twoDigitsBits = bits.readBits(7);
            if (twoDigitsBits >= 100) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(twoDigitsBits % 10));
        } else if (count === 1) {
            // One digit left over to read
            if (bits.available() < 4) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            var digitBits = bits.readBits(4);
            if (digitBits >= 10) throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(digitBits));
        }
    };
    DecodedBitStreamParser.parseECIValue = function(bits) {
        var firstByte = bits.readBits(8);
        if ((firstByte & 0x80) === 0) // just one byte
        return firstByte & 0x7F;
        if ((firstByte & 0xC0) === 0x80) {
            // two bytes
            var secondByte = bits.readBits(8);
            return (firstByte & 0x3F) << 8 & 0xFFFFFFFF | secondByte;
        }
        if ((firstByte & 0xE0) === 0xC0) {
            // three bytes
            var secondThirdBytes = bits.readBits(16);
            return (firstByte & 0x1F) << 16 & 0xFFFFFFFF | secondThirdBytes;
        }
        throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
    };
    /**
     * See ISO 18004:2006, 6.4.4 Table 5
     */ DecodedBitStreamParser.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    DecodedBitStreamParser.GB2312_SUBSET = 1;
    return DecodedBitStreamParser;
}();
var $5c44b39e4ab32768$export$2e2bcd8739ae039 // function Uint8ArrayToString(a: Uint8Array): string {
 //     const CHUNK_SZ = 0x8000;
 //     const c = new StringBuilder();
 //     for (let i = 0, length = a.length; i < length; i += CHUNK_SZ) {
 //         c.append(String.fromCharCode.apply(null, a.subarray(i, i + CHUNK_SZ)));
 //     }
 //     return c.toString();
 // }
 = $5c44b39e4ab32768$var$DecodedBitStreamParser;


/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Meta-data container for QR Code decoding. Instances of this class may be used to convey information back to the
 * decoding caller. Callers are expected to process this.
 *
 * @see com.google.zxing.common.DecoderResult#getOther()
 */ var $bf06753286ec1504$var$QRCodeDecoderMetaData = /** @class */ function() {
    function QRCodeDecoderMetaData(mirrored) {
        this.mirrored = mirrored;
    }
    /**
     * @return true if the QR Code was mirrored.
     */ QRCodeDecoderMetaData.prototype.isMirrored = function() {
        return this.mirrored;
    };
    /**
     * Apply the result points' order correction due to mirroring.
     *
     * @param points Array of points to apply mirror correction to.
     */ QRCodeDecoderMetaData.prototype.applyMirroredCorrection = function(points) {
        if (!this.mirrored || points === null || points.length < 3) return;
        var bottomLeft = points[0];
        points[0] = points[2];
        points[2] = bottomLeft;
    // No need to 'fix' top-left and alignment pattern.
    };
    return QRCodeDecoderMetaData;
}();
var $bf06753286ec1504$export$2e2bcd8739ae039 = $bf06753286ec1504$var$QRCodeDecoderMetaData;


var $d17a8a6152bc8136$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.util.Map;*/ /**
 * <p>The main class which implements QR Code decoding -- as opposed to locating and extracting
 * the QR Code from an image.</p>
 *
 * @author Sean Owen
 */ var $d17a8a6152bc8136$var$Decoder = /** @class */ function() {
    function Decoder() {
        this.rsDecoder = new (0, $a1039736c6639077$export$2e2bcd8739ae039)((0, $7973dc50831a46a1$export$2e2bcd8739ae039).QR_CODE_FIELD_256);
    }
    // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
    //   return decode(image, null)
    // }
    /**
     * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
     * "true" is taken to mean a black module.</p>
     *
     * @param image booleans representing white/black QR Code modules
     * @param hints decoding hints that should be used to influence decoding
     * @return text and bytes encoded within the QR Code
     * @throws FormatException if the QR Code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.decodeBooleanArray = function(image, hints) {
        return this.decodeBitMatrix((0, $ff4f860b0cfaffff$export$2e2bcd8739ae039).parseFromBooleanArray(image), hints);
    };
    // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
    //   return decode(bits, null)
    // }
    /**
     * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
     *
     * @param bits booleans representing white/black QR Code modules
     * @param hints decoding hints that should be used to influence decoding
     * @return text and bytes encoded within the QR Code
     * @throws FormatException if the QR Code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.decodeBitMatrix = function(bits, hints) {
        // Construct a parser and read version, error-correction level
        var parser = new (0, $c936bea4d967f015$export$2e2bcd8739ae039)(bits);
        var ex = null;
        try {
            return this.decodeBitMatrixParser(parser, hints);
        } catch (e /*: FormatException, ChecksumException*/ ) {
            ex = e;
        }
        try {
            // Revert the bit matrix
            parser.remask();
            // Will be attempting a mirrored reading of the version and format info.
            parser.setMirror(true);
            // Preemptively read the version.
            parser.readVersion();
            // Preemptively read the format information.
            parser.readFormatInformation();
            /*
             * Since we're here, this means we have successfully detected some kind
             * of version and format information when mirrored. This is a good sign,
             * that the QR code may be mirrored, and we should try once more with a
             * mirrored content.
             */ // Prepare for a mirrored reading.
            parser.mirror();
            var result = this.decodeBitMatrixParser(parser, hints);
            // Success! Notify the caller that the code was mirrored.
            result.setOther(new (0, $bf06753286ec1504$export$2e2bcd8739ae039)(true));
            return result;
        } catch (e /*FormatException | ChecksumException*/ ) {
            // Throw the exception from the original reading
            if (ex !== null) throw ex;
            throw e;
        }
    };
    Decoder.prototype.decodeBitMatrixParser = function(parser, hints) {
        var e_1, _a, e_2, _b;
        var version = parser.readVersion();
        var ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
        // Read codewords
        var codewords = parser.readCodewords();
        // Separate into data blocks
        var dataBlocks = (0, $4dcd7c366b02bf46$export$2e2bcd8739ae039).getDataBlocks(codewords, version, ecLevel);
        // Count total number of data bytes
        var totalBytes = 0;
        try {
            for(var dataBlocks_1 = $d17a8a6152bc8136$var$__values(dataBlocks), dataBlocks_1_1 = dataBlocks_1.next(); !dataBlocks_1_1.done; dataBlocks_1_1 = dataBlocks_1.next()){
                var dataBlock = dataBlocks_1_1.value;
                totalBytes += dataBlock.getNumDataCodewords();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (dataBlocks_1_1 && !dataBlocks_1_1.done && (_a = dataBlocks_1.return)) _a.call(dataBlocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var resultBytes = new Uint8Array(totalBytes);
        var resultOffset = 0;
        try {
            // Error-correct and copy data blocks together into a stream of bytes
            for(var dataBlocks_2 = $d17a8a6152bc8136$var$__values(dataBlocks), dataBlocks_2_1 = dataBlocks_2.next(); !dataBlocks_2_1.done; dataBlocks_2_1 = dataBlocks_2.next()){
                var dataBlock = dataBlocks_2_1.value;
                var codewordBytes = dataBlock.getCodewords();
                var numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(var i = 0; i < numDataCodewords; i++)resultBytes[resultOffset++] = codewordBytes[i];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (dataBlocks_2_1 && !dataBlocks_2_1.done && (_b = dataBlocks_2.return)) _b.call(dataBlocks_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // Decode the contents of that stream of bytes
        return (0, $5c44b39e4ab32768$export$2e2bcd8739ae039).decode(resultBytes, version, ecLevel, hints);
    };
    /**
     * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
     * correct the errors in-place using Reed-Solomon error correction.</p>
     *
     * @param codewordBytes data and error correction codewords
     * @param numDataCodewords number of codewords that are data bytes
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.correctErrors = function(codewordBytes, numDataCodewords /*int*/ ) {
        // const numCodewords = codewordBytes.length;
        // First read into an array of ints
        var codewordsInts = new Int32Array(codewordBytes);
        // TYPESCRIPTPORT: not realy necessary to transform to ints? could redesign everything to work with unsigned bytes?
        // const codewordsInts = new Int32Array(numCodewords)
        // for (let i = 0; i < numCodewords; i++) {
        //   codewordsInts[i] = codewordBytes[i] & 0xFF
        // }
        try {
            this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
        } catch (ignored /*: ReedSolomonException*/ ) {
            throw new (0, $e19cfb3b440de53d$export$2e2bcd8739ae039)();
        }
        // Copy back into array of bytes -- only need to worry about the bytes that were data
        // We don't care about errors in the error-correction codewords
        for(var i = 0; i < numDataCodewords; i++)codewordBytes[i] = /*(byte) */ codewordsInts[i];
    };
    return Decoder;
}();
var $d17a8a6152bc8136$export$2e2bcd8739ae039 = $d17a8a6152bc8136$var$Decoder;



/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 







/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c38247e91f11d5c5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates an alignment pattern, which are the smaller square patterns found in
 * all but the simplest QR Codes.</p>
 *
 * @author Sean Owen
 */ var $c38247e91f11d5c5$var$AlignmentPattern = /** @class */ function(_super) {
    $c38247e91f11d5c5$var$__extends(AlignmentPattern, _super);
    function AlignmentPattern(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ ) {
        var _this = _super.call(this, posX, posY) || this;
        _this.estimatedModuleSize = estimatedModuleSize;
        return _this;
    }
    /**
     * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
     * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
     */ AlignmentPattern.prototype.aboutEquals = function(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
        if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
            var moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
            return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
        }
        return false;
    };
    /**
     * Combines this object's current estimate of a finder pattern position and module size
     * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
     */ AlignmentPattern.prototype.combineEstimate = function(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
        var combinedX = (this.getX() + j) / 2.0;
        var combinedY = (this.getY() + i) / 2.0;
        var combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2.0;
        return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
    };
    return AlignmentPattern;
}((0, $e9ec26965ff3031c$export$2e2bcd8739ae039));
var $c38247e91f11d5c5$export$2e2bcd8739ae039 = $c38247e91f11d5c5$var$AlignmentPattern;



var $d5bb21272b9f6fb3$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.util.ArrayList;*/ /*import java.util.List;*/ /**
 * <p>This class attempts to find alignment patterns in a QR Code. Alignment patterns look like finder
 * patterns but are smaller and appear at regular intervals throughout the image.</p>
 *
 * <p>At the moment this only looks for the bottom-right alignment pattern.</p>
 *
 * <p>This is mostly a simplified copy of {@link FinderPatternFinder}. It is copied,
 * pasted and stripped down here for maximum performance but does unfortunately duplicate
 * some code.</p>
 *
 * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.</p>
 *
 * @author Sean Owen
 */ var $d5bb21272b9f6fb3$var$AlignmentPatternFinder = /** @class */ function() {
    /**
     * <p>Creates a finder that will look in a portion of the whole image.</p>
     *
     * @param image image to search
     * @param startX left column from which to start searching
     * @param startY top row from which to start searching
     * @param width width of region to search
     * @param height height of region to search
     * @param moduleSize estimated module size so far
     */ function AlignmentPatternFinder(image, startX /*int*/ , startY /*int*/ , width /*int*/ , height /*int*/ , moduleSize /*float*/ , resultPointCallback) {
        this.image = image;
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.height = height;
        this.moduleSize = moduleSize;
        this.resultPointCallback = resultPointCallback;
        this.possibleCenters = []; // new Array<any>(5))
        // TYPESCRIPTPORT: array initialization without size as the length is checked below
        this.crossCheckStateCount = new Int32Array(3);
    }
    /**
     * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
     * it's pretty performance-critical and so is written to be fast foremost.</p>
     *
     * @return {@link AlignmentPattern} if found
     * @throws NotFoundException if not found
     */ AlignmentPatternFinder.prototype.find = function() {
        var startX = this.startX;
        var height = this.height;
        var width = this.width;
        var maxJ = startX + width;
        var middleI = this.startY + height / 2;
        // We are looking for black/white/black modules in 1:1:1 ratio
        // this tracks the number of black/white/black modules seen so far
        var stateCount = new Int32Array(3);
        var image = this.image;
        for(var iGen = 0; iGen < height; iGen++){
            // Search from middle outwards
            var i = middleI + ((iGen & 0x01) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            var j = startX;
            // Burn off leading white pixels before anything else; if we start in the middle of
            // a white run, it doesn't make sense to count its length, since we don't know if the
            // white run continued to the left of the start point
            while(j < maxJ && !image.get(j, i))j++;
            var currentState = 0;
            while(j < maxJ){
                if (image.get(j, i)) {
                    // Black pixel
                    if (currentState === 1) stateCount[1]++;
                    else if (currentState === 2) {
                        if (this.foundPatternCross(stateCount)) {
                            var confirmed = this.handlePossibleCenter(stateCount, i, j);
                            if (confirmed !== null) return confirmed;
                        }
                        stateCount[0] = stateCount[2];
                        stateCount[1] = 1;
                        stateCount[2] = 0;
                        currentState = 1;
                    } else stateCount[++currentState]++;
                } else {
                    if (currentState === 1) currentState++;
                    stateCount[currentState]++;
                }
                j++;
            }
            if (this.foundPatternCross(stateCount)) {
                var confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
                if (confirmed !== null) return confirmed;
            }
        }
        // Hmm, nothing we saw was observed and confirmed twice. If we had
        // any guess at all, return it.
        if (this.possibleCenters.length !== 0) return this.possibleCenters[0];
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
    };
    /**
     * Given a count of black/white/black pixels just seen and an end position,
     * figures the location of the center of this black/white/black run.
     */ AlignmentPatternFinder.centerFromEnd = function(stateCount, end /*int*/ ) {
        return end - stateCount[2] - stateCount[1] / 2.0;
    };
    /**
     * @param stateCount count of black/white/black pixels just read
     * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
     *         used by alignment patterns to be considered a match
     */ AlignmentPatternFinder.prototype.foundPatternCross = function(stateCount) {
        var moduleSize = this.moduleSize;
        var maxVariance = moduleSize / 2.0;
        for(var i = 0; i < 3; i++){
            if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) return false;
        }
        return true;
    };
    /**
     * <p>After a horizontal scan finds a potential alignment pattern, this method
     * "cross-checks" by scanning down vertically through the center of the possible
     * alignment pattern to see if the same proportion is detected.</p>
     *
     * @param startI row where an alignment pattern was detected
     * @param centerJ center of the section that appears to cross an alignment pattern
     * @param maxCount maximum reasonable number of modules that should be
     * observed in any reading state, based on the results of the horizontal scan
     * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
     */ AlignmentPatternFinder.prototype.crossCheckVertical = function(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var image = this.image;
        var maxI = image.getHeight();
        var stateCount = this.crossCheckStateCount;
        stateCount[0] = 0;
        stateCount[1] = 0;
        stateCount[2] = 0;
        // Start counting up from center
        var i = startI;
        while(i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i--;
        }
        // If already too many modules in this state or ran off the edge:
        if (i < 0 || stateCount[1] > maxCount) return NaN;
        while(i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount){
            stateCount[0]++;
            i--;
        }
        if (stateCount[0] > maxCount) return NaN;
        // Now also count down from center
        i = startI + 1;
        while(i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i++;
        }
        if (i === maxI || stateCount[1] > maxCount) return NaN;
        while(i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount){
            stateCount[2]++;
            i++;
        }
        if (stateCount[2] > maxCount) return NaN;
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
        return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
    };
    /**
     * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
     * cross check with a vertical scan, and if successful, will see if this pattern had been
     * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
     * found the alignment pattern.</p>
     *
     * @param stateCount reading state module counts from horizontal scan
     * @param i row where alignment pattern may be found
     * @param j end of possible alignment pattern in row
     * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
     */ AlignmentPatternFinder.prototype.handlePossibleCenter = function(stateCount, i /*int*/ , j /*int*/ ) {
        var e_1, _a;
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
        var centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
        var centerI = this.crossCheckVertical(i, /*(int) */ centerJ, 2 * stateCount[1], stateCountTotal);
        if (!isNaN(centerI)) {
            var estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3.0;
            try {
                for(var _b = $d5bb21272b9f6fb3$var$__values(this.possibleCenters), _c = _b.next(); !_c.done; _c = _b.next()){
                    var center = _c.value;
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Hadn't found this before; save it
            var point = new (0, $c38247e91f11d5c5$export$2e2bcd8739ae039)(centerJ, centerI, estimatedModuleSize);
            this.possibleCenters.push(point);
            if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
        }
        return null;
    };
    return AlignmentPatternFinder;
}();
var $d5bb21272b9f6fb3$export$2e2bcd8739ae039 = $d5bb21272b9f6fb3$var$AlignmentPatternFinder;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6871133ac1a0f317$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates a finder pattern, which are the three square patterns found in
 * the corners of QR Codes. It also encapsulates a count of similar finder patterns,
 * as a convenience to the finder's bookkeeping.</p>
 *
 * @author Sean Owen
 */ var $6871133ac1a0f317$var$FinderPattern = /** @class */ function(_super) {
    $6871133ac1a0f317$var$__extends(FinderPattern, _super);
    // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
    //   this(posX, posY, estimatedModuleSize, 1)
    // }
    function FinderPattern(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ , count /*int*/ ) {
        var _this = _super.call(this, posX, posY) || this;
        _this.estimatedModuleSize = estimatedModuleSize;
        _this.count = count;
        if (undefined === count) _this.count = 1;
        return _this;
    }
    FinderPattern.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    };
    FinderPattern.prototype.getCount = function() {
        return this.count;
    };
    /*
    void incrementCount() {
      this.count++
    }
     */ /**
     * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
     * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
     */ FinderPattern.prototype.aboutEquals = function(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
        if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
            var moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
            return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
        }
        return false;
    };
    /**
     * Combines this object's current estimate of a finder pattern position and module size
     * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
     * based on count.
     */ FinderPattern.prototype.combineEstimate = function(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
        var combinedCount = this.count + 1;
        var combinedX = (this.count * this.getX() + j) / combinedCount;
        var combinedY = (this.count * this.getY() + i) / combinedCount;
        var combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
        return new FinderPattern(combinedX, combinedY, combinedModuleSize, combinedCount);
    };
    return FinderPattern;
}((0, $e9ec26965ff3031c$export$2e2bcd8739ae039));
var $6871133ac1a0f317$export$2e2bcd8739ae039 = $6871133ac1a0f317$var$FinderPattern;


/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates information about finder patterns in an image, including the location of
 * the three finder patterns, and their estimated module size.</p>
 *
 * @author Sean Owen
 */ var $f09057957adbe111$var$FinderPatternInfo = /** @class */ function() {
    function FinderPatternInfo(patternCenters) {
        this.bottomLeft = patternCenters[0];
        this.topLeft = patternCenters[1];
        this.topRight = patternCenters[2];
    }
    FinderPatternInfo.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    };
    FinderPatternInfo.prototype.getTopLeft = function() {
        return this.topLeft;
    };
    FinderPatternInfo.prototype.getTopRight = function() {
        return this.topRight;
    };
    return FinderPatternInfo;
}();
var $f09057957adbe111$export$2e2bcd8739ae039 = $f09057957adbe111$var$FinderPatternInfo;



var $383c3419254e7810$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.io.Serializable;*/ /*import java.util.ArrayList;*/ /*import java.util.Collections;*/ /*import java.util.Comparator;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
 * <p>This class attempts to find finder patterns in a QR Code. Finder patterns are the square
 * markers at three corners of a QR Code.</p>
 *
 * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.
 *
 * @author Sean Owen
 */ var $383c3419254e7810$var$FinderPatternFinder = /** @class */ function() {
    /**
     * <p>Creates a finder that will search the image for three finder patterns.</p>
     *
     * @param image image to search
     */ // public constructor(image: BitMatrix) {
    //   this(image, null)
    // }
    function FinderPatternFinder(image, resultPointCallback) {
        this.image = image;
        this.resultPointCallback = resultPointCallback;
        this.possibleCenters = [];
        this.crossCheckStateCount = new Int32Array(5);
        this.resultPointCallback = resultPointCallback;
    }
    FinderPatternFinder.prototype.getImage = function() {
        return this.image;
    };
    FinderPatternFinder.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    };
    FinderPatternFinder.prototype.find = function(hints) {
        var tryHarder = hints !== null && hints !== undefined && undefined !== hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).TRY_HARDER);
        var pureBarcode = hints !== null && hints !== undefined && undefined !== hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).PURE_BARCODE);
        var image = this.image;
        var maxI = image.getHeight();
        var maxJ = image.getWidth();
        // We are looking for black/white/black/white/black modules in
        // 1:1:3:1:1 ratio; this tracks the number of such modules seen so far
        // Let's assume that the maximum version QR Code we support takes up 1/4 the height of the
        // image, and then account for the center being 3 modules in size. This gives the smallest
        // number of pixels the center could be, so skip this often. When trying harder, look for all
        // QR versions regardless of how dense they are.
        var iSkip = Math.floor(3 * maxI / (4 * FinderPatternFinder.MAX_MODULES));
        if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) iSkip = FinderPatternFinder.MIN_SKIP;
        var done = false;
        var stateCount = new Int32Array(5);
        for(var i = iSkip - 1; i < maxI && !done; i += iSkip){
            // Get a row of black/white values
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            stateCount[3] = 0;
            stateCount[4] = 0;
            var currentState = 0;
            for(var j = 0; j < maxJ; j++){
                if (image.get(j, i)) {
                    // Black pixel
                    if ((currentState & 1) === 1) currentState++;
                    stateCount[currentState]++;
                } else if ((currentState & 1) === 0) {
                    if (currentState === 4) {
                        if (FinderPatternFinder.foundPatternCross(stateCount)) {
                            var confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                            if (confirmed === true) {
                                // Start examining every other line. Checking each line turned out to be too
                                // expensive and didn't improve performance.
                                iSkip = 2;
                                if (this.hasSkipped === true) done = this.haveMultiplyConfirmedCenters();
                                else {
                                    var rowSkip = this.findRowSkip();
                                    if (rowSkip > stateCount[2]) {
                                        // Skip rows between row of lower confirmed center
                                        // and top of presumed third confirmed center
                                        // but back up a bit to get a full chance of detecting
                                        // it, entire width of center of finder pattern
                                        // Skip by rowSkip, but back off by stateCount[2] (size of last center
                                        // of pattern we saw) to be conservative, and also back off by iSkip which
                                        // is about to be re-added
                                        i += rowSkip - stateCount[2] - iSkip;
                                        j = maxJ - 1;
                                    }
                                }
                            } else {
                                stateCount[0] = stateCount[2];
                                stateCount[1] = stateCount[3];
                                stateCount[2] = stateCount[4];
                                stateCount[3] = 1;
                                stateCount[4] = 0;
                                currentState = 3;
                                continue;
                            }
                            // Clear state to start looking again
                            currentState = 0;
                            stateCount[0] = 0;
                            stateCount[1] = 0;
                            stateCount[2] = 0;
                            stateCount[3] = 0;
                            stateCount[4] = 0;
                        } else {
                            stateCount[0] = stateCount[2];
                            stateCount[1] = stateCount[3];
                            stateCount[2] = stateCount[4];
                            stateCount[3] = 1;
                            stateCount[4] = 0;
                            currentState = 3;
                        }
                    } else stateCount[++currentState]++;
                } else stateCount[currentState]++;
            }
            if (FinderPatternFinder.foundPatternCross(stateCount)) {
                var confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
                if (confirmed === true) {
                    iSkip = stateCount[0];
                    if (this.hasSkipped) // Found a third one
                    done = this.haveMultiplyConfirmedCenters();
                }
            }
        }
        var patternInfo = this.selectBestPatterns();
        (0, $e9ec26965ff3031c$export$2e2bcd8739ae039).orderBestPatterns(patternInfo);
        return new (0, $f09057957adbe111$export$2e2bcd8739ae039)(patternInfo);
    };
    /**
     * Given a count of black/white/black/white/black pixels just seen and an end position,
     * figures the location of the center of this run.
     */ FinderPatternFinder.centerFromEnd = function(stateCount, end /*int*/ ) {
        return end - stateCount[4] - stateCount[3] - stateCount[2] / 2.0;
    };
    /**
     * @param stateCount count of black/white/black/white/black pixels just read
     * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
     *         used by finder patterns to be considered a match
     */ FinderPatternFinder.foundPatternCross = function(stateCount) {
        var totalModuleSize = 0;
        for(var i = 0; i < 5; i++){
            var count = stateCount[i];
            if (count === 0) return false;
            totalModuleSize += count;
        }
        if (totalModuleSize < 7) return false;
        var moduleSize = totalModuleSize / 7.0;
        var maxVariance = moduleSize / 2.0;
        // Allow less than 50% variance from 1-1-3-1-1 proportions
        return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3.0 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
    };
    FinderPatternFinder.prototype.getCrossCheckStateCount = function() {
        var crossCheckStateCount = this.crossCheckStateCount;
        crossCheckStateCount[0] = 0;
        crossCheckStateCount[1] = 0;
        crossCheckStateCount[2] = 0;
        crossCheckStateCount[3] = 0;
        crossCheckStateCount[4] = 0;
        return crossCheckStateCount;
    };
    /**
     * After a vertical and horizontal scan finds a potential finder pattern, this method
     * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
     * finder pattern to see if the same proportion is detected.
     *
     * @param startI row where a finder pattern was detected
     * @param centerJ center of the section that appears to cross a finder pattern
     * @param maxCount maximum reasonable number of modules that should be
     *  observed in any reading state, based on the results of the horizontal scan
     * @param originalStateCountTotal The original state count total.
     * @return true if proportions are withing expected limits
     */ FinderPatternFinder.prototype.crossCheckDiagonal = function(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var stateCount = this.getCrossCheckStateCount();
        // Start counting up, left from center finding black center mass
        var i = 0;
        var image = this.image;
        while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)){
            stateCount[2]++;
            i++;
        }
        if (startI < i || centerJ < i) return false;
        // Continue up, left finding white space
        while(startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i++;
        }
        // If already too many modules in this state or ran off the edge:
        if (startI < i || centerJ < i || stateCount[1] > maxCount) return false;
        // Continue up, left finding black border
        while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) && stateCount[0] <= maxCount){
            stateCount[0]++;
            i++;
        }
        if (stateCount[0] > maxCount) return false;
        var maxI = image.getHeight();
        var maxJ = image.getWidth();
        // Now also count down, right from center
        i = 1;
        while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)){
            stateCount[2]++;
            i++;
        }
        // Ran off the edge?
        if (startI + i >= maxI || centerJ + i >= maxJ) return false;
        while(startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) && stateCount[3] < maxCount){
            stateCount[3]++;
            i++;
        }
        if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) return false;
        while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) && stateCount[4] < maxCount){
            stateCount[4]++;
            i++;
        }
        if (stateCount[4] >= maxCount) return false;
        // If we found a finder-pattern-like section, but its size is more than 100% different than
        // the original, assume it's a false positive
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && FinderPatternFinder.foundPatternCross(stateCount);
    };
    /**
     * <p>After a horizontal scan finds a potential finder pattern, this method
     * "cross-checks" by scanning down vertically through the center of the possible
     * finder pattern to see if the same proportion is detected.</p>
     *
     * @param startI row where a finder pattern was detected
     * @param centerJ center of the section that appears to cross a finder pattern
     * @param maxCount maximum reasonable number of modules that should be
     * observed in any reading state, based on the results of the horizontal scan
     * @return vertical center of finder pattern, or {@link Float#NaN} if not found
     */ FinderPatternFinder.prototype.crossCheckVertical = function(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var image = this.image;
        var maxI = image.getHeight();
        var stateCount = this.getCrossCheckStateCount();
        // Start counting up from center
        var i = startI;
        while(i >= 0 && image.get(centerJ, i)){
            stateCount[2]++;
            i--;
        }
        if (i < 0) return NaN;
        while(i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i--;
        }
        // If already too many modules in this state or ran off the edge:
        if (i < 0 || stateCount[1] > maxCount) return NaN;
        while(i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount){
            stateCount[0]++;
            i--;
        }
        if (stateCount[0] > maxCount) return NaN;
        // Now also count down from center
        i = startI + 1;
        while(i < maxI && image.get(centerJ, i)){
            stateCount[2]++;
            i++;
        }
        if (i === maxI) return NaN;
        while(i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount){
            stateCount[3]++;
            i++;
        }
        if (i === maxI || stateCount[3] >= maxCount) return NaN;
        while(i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount){
            stateCount[4]++;
            i++;
        }
        if (stateCount[4] >= maxCount) return NaN;
        // If we found a finder-pattern-like section, but its size is more than 40% different than
        // the original, assume it's a false positive
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
        return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
    };
    /**
     * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
     * except it reads horizontally instead of vertically. This is used to cross-cross
     * check a vertical cross check and locate the real center of the alignment pattern.</p>
     */ FinderPatternFinder.prototype.crossCheckHorizontal = function(startJ /*int*/ , centerI /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var image = this.image;
        var maxJ = image.getWidth();
        var stateCount = this.getCrossCheckStateCount();
        var j = startJ;
        while(j >= 0 && image.get(j, centerI)){
            stateCount[2]++;
            j--;
        }
        if (j < 0) return NaN;
        while(j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount){
            stateCount[1]++;
            j--;
        }
        if (j < 0 || stateCount[1] > maxCount) return NaN;
        while(j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount){
            stateCount[0]++;
            j--;
        }
        if (stateCount[0] > maxCount) return NaN;
        j = startJ + 1;
        while(j < maxJ && image.get(j, centerI)){
            stateCount[2]++;
            j++;
        }
        if (j === maxJ) return NaN;
        while(j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount){
            stateCount[3]++;
            j++;
        }
        if (j === maxJ || stateCount[3] >= maxCount) return NaN;
        while(j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount){
            stateCount[4]++;
            j++;
        }
        if (stateCount[4] >= maxCount) return NaN;
        // If we found a finder-pattern-like section, but its size is significantly different than
        // the original, assume it's a false positive
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) return NaN;
        return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
    };
    /**
     * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
     * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
     * with another horizontal scan. This is needed primarily to locate the real horizontal
     * center of the pattern in cases of extreme skew.
     * And then we cross-cross-cross check with another diagonal scan.</p>
     *
     * <p>If that succeeds the finder pattern location is added to a list that tracks
     * the number of times each location has been nearly-matched as a finder pattern.
     * Each additional find is more evidence that the location is in fact a finder
     * pattern center
     *
     * @param stateCount reading state module counts from horizontal scan
     * @param i row where finder pattern may be found
     * @param j end of possible finder pattern in row
     * @param pureBarcode true if in "pure barcode" mode
     * @return true if a finder pattern candidate was found this time
     */ FinderPatternFinder.prototype.handlePossibleCenter = function(stateCount, i /*int*/ , j /*int*/ , pureBarcode) {
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        var centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
        var centerI = this.crossCheckVertical(i, /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal);
        if (!isNaN(centerI)) {
            // Re-cross check
            centerJ = this.crossCheckHorizontal(/*(int) */ Math.floor(centerJ), /*(int) */ Math.floor(centerI), stateCount[2], stateCountTotal);
            if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(/*(int) */ Math.floor(centerI), /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal))) {
                var estimatedModuleSize = stateCountTotal / 7.0;
                var found = false;
                var possibleCenters = this.possibleCenters;
                for(var index = 0, length_1 = possibleCenters.length; index < length_1; index++){
                    var center = possibleCenters[index];
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                        possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    var point = new (0, $6871133ac1a0f317$export$2e2bcd8739ae039)(centerJ, centerI, estimatedModuleSize);
                    possibleCenters.push(point);
                    if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
                }
                return true;
            }
        }
        return false;
    };
    /**
     * @return number of rows we could safely skip during scanning, based on the first
     *         two finder patterns that have been located. In some cases their position will
     *         allow us to infer that the third pattern must lie below a certain point farther
     *         down in the image.
     */ FinderPatternFinder.prototype.findRowSkip = function() {
        var e_1, _a;
        var max = this.possibleCenters.length;
        if (max <= 1) return 0;
        var firstConfirmedCenter = null;
        try {
            for(var _b = $383c3419254e7810$var$__values(this.possibleCenters), _c = _b.next(); !_c.done; _c = _b.next()){
                var center = _c.value;
                if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                    if (firstConfirmedCenter == null) firstConfirmedCenter = center;
                    else {
                        // We have two confirmed centers
                        // How far down can we skip before resuming looking for the next
                        // pattern? In the worst case, only the difference between the
                        // difference in the x / y coordinates of the two centers.
                        // This is the case where you find top left last.
                        this.hasSkipped = true;
                        return /*(int) */ Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2);
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return 0;
    };
    /**
     * @return true iff we have found at least 3 finder patterns that have been detected
     *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
     *         candidates is "pretty similar"
     */ FinderPatternFinder.prototype.haveMultiplyConfirmedCenters = function() {
        var e_2, _a, e_3, _b;
        var confirmedCount = 0;
        var totalModuleSize = 0.0;
        var max = this.possibleCenters.length;
        try {
            for(var _c = $383c3419254e7810$var$__values(this.possibleCenters), _d = _c.next(); !_d.done; _d = _c.next()){
                var pattern = _d.value;
                if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                    confirmedCount++;
                    totalModuleSize += pattern.getEstimatedModuleSize();
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        if (confirmedCount < 3) return false;
        // OK, we have at least 3 confirmed centers, but, it's possible that one is a "false positive"
        // and that we need to keep looking. We detect this by asking if the estimated module sizes
        // vary too much. We arbitrarily say that when the total deviation from average exceeds
        // 5% of the total module size estimates, it's too much.
        var average = totalModuleSize / max;
        var totalDeviation = 0.0;
        try {
            for(var _e = $383c3419254e7810$var$__values(this.possibleCenters), _f = _e.next(); !_f.done; _f = _e.next()){
                var pattern = _f.value;
                totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return totalDeviation <= 0.05 * totalModuleSize;
    };
    /**
     * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
     *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
     *         size differs from the average among those patterns the least
     * @throws NotFoundException if 3 such finder patterns do not exist
     */ FinderPatternFinder.prototype.selectBestPatterns = function() {
        var e_4, _a, e_5, _b;
        var startSize = this.possibleCenters.length;
        if (startSize < 3) // Couldn't find enough finder patterns
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var possibleCenters = this.possibleCenters;
        var average;
        // Filter outlier possibilities whose module size is too different
        if (startSize > 3) {
            // But we can only afford to do so if we have at least 4 possibilities to choose from
            var totalModuleSize = 0.0;
            var square = 0.0;
            try {
                for(var _c = $383c3419254e7810$var$__values(this.possibleCenters), _d = _c.next(); !_d.done; _d = _c.next()){
                    var center = _d.value;
                    var size = center.getEstimatedModuleSize();
                    totalModuleSize += size;
                    square += size * size;
                }
            } catch (e_4_1) {
                e_4 = {
                    error: e_4_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_4) throw e_4.error;
                }
            }
            average = totalModuleSize / startSize;
            var stdDev = Math.sqrt(square / startSize - average * average);
            possibleCenters.sort(/**
             * <p>Orders by furthest from average</p>
             */ // FurthestFromAverageComparator implements Comparator<FinderPattern>
            function(center1, center2) {
                var dA = Math.abs(center2.getEstimatedModuleSize() - average);
                var dB = Math.abs(center1.getEstimatedModuleSize() - average);
                return dA < dB ? -1 : dA > dB ? 1 : 0;
            });
            var limit = Math.max(0.2 * average, stdDev);
            for(var i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++){
                var pattern = possibleCenters[i];
                if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
                    possibleCenters.splice(i, 1);
                    i--;
                }
            }
        }
        if (possibleCenters.length > 3) {
            // Throw away all but those first size candidate points we found.
            var totalModuleSize = 0.0;
            try {
                for(var possibleCenters_1 = $383c3419254e7810$var$__values(possibleCenters), possibleCenters_1_1 = possibleCenters_1.next(); !possibleCenters_1_1.done; possibleCenters_1_1 = possibleCenters_1.next()){
                    var possibleCenter = possibleCenters_1_1.value;
                    totalModuleSize += possibleCenter.getEstimatedModuleSize();
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (possibleCenters_1_1 && !possibleCenters_1_1.done && (_b = possibleCenters_1.return)) _b.call(possibleCenters_1);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            average = totalModuleSize / possibleCenters.length;
            possibleCenters.sort(/**
             * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
             */ // CenterComparator implements Comparator<FinderPattern>
            function(center1, center2) {
                if (center2.getCount() === center1.getCount()) {
                    var dA = Math.abs(center2.getEstimatedModuleSize() - average);
                    var dB = Math.abs(center1.getEstimatedModuleSize() - average);
                    return dA < dB ? 1 : dA > dB ? -1 : 0;
                } else return center2.getCount() - center1.getCount();
            });
            possibleCenters.splice(3); // this is not realy necessary as we only return first 3 anyway
        }
        return [
            possibleCenters[0],
            possibleCenters[1],
            possibleCenters[2]
        ];
    };
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3; // 1 pixel/module times 3 modules/center
    FinderPatternFinder.MAX_MODULES = 57; // support up to version 10 for mobile clients
    return FinderPatternFinder;
}();
var $383c3419254e7810$export$2e2bcd8739ae039 = $383c3419254e7810$var$FinderPatternFinder;


/*import java.util.Map;*/ /**
 * <p>Encapsulates logic that can detect a QR Code in an image, even if the QR Code
 * is rotated or skewed, or partially obscured.</p>
 *
 * @author Sean Owen
 */ var $b21eca621711e6d3$var$Detector = /** @class */ function() {
    function Detector(image) {
        this.image = image;
    }
    Detector.prototype.getImage = function() {
        return this.image;
    };
    Detector.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    };
    /**
     * <p>Detects a QR Code in an image.</p>
     *
     * @return {@link DetectorResult} encapsulating results of detecting a QR Code
     * @throws NotFoundException if QR Code cannot be found
     * @throws FormatException if a QR Code cannot be decoded
     */ // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
    //   return detect(null)
    // }
    /**
     * <p>Detects a QR Code in an image.</p>
     *
     * @param hints optional hints to detector
     * @return {@link DetectorResult} encapsulating results of detecting a QR Code
     * @throws NotFoundException if QR Code cannot be found
     * @throws FormatException if a QR Code cannot be decoded
     */ Detector.prototype.detect = function(hints) {
        this.resultPointCallback = hints === null || hints === undefined ? null : /*(ResultPointCallback) */ hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).NEED_RESULT_POINT_CALLBACK);
        var finder = new (0, $383c3419254e7810$export$2e2bcd8739ae039)(this.image, this.resultPointCallback);
        var info = finder.find(hints);
        return this.processFinderPatternInfo(info);
    };
    Detector.prototype.processFinderPatternInfo = function(info) {
        var topLeft = info.getTopLeft();
        var topRight = info.getTopRight();
        var bottomLeft = info.getBottomLeft();
        var moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
        if (moduleSize < 1.0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)("No pattern found in proccess finder.");
        var dimension = Detector.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
        var provisionalVersion = (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).getProvisionalVersionForDimension(dimension);
        var modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
        var alignmentPattern = null;
        // Anything above version 1 has an alignment pattern
        if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
            // Guess where a "bottom right" finder pattern would have been
            var bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
            var bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
            // Estimate that alignment pattern is closer by 3 modules
            // from "bottom right" to known top left location
            var correctionToTopLeft = 1.0 - 3.0 / modulesBetweenFPCenters;
            var estAlignmentX = /*(int) */ Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()));
            var estAlignmentY = /*(int) */ Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()));
            // Kind of arbitrary -- expand search radius before giving up
            for(var i = 4; i <= 16; i <<= 1)try {
                alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
                break;
            } catch (re /*NotFoundException*/ ) {
                if (!(re instanceof (0, $283aa2ad27179317$export$2e2bcd8739ae039))) throw re;
            // try next round
            }
        // If we didn't find alignment pattern... well try anyway without it
        }
        var transform = Detector.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
        var bits = Detector.sampleGrid(this.image, transform, dimension);
        var points;
        if (alignmentPattern === null) points = [
            bottomLeft,
            topLeft,
            topRight
        ];
        else points = [
            bottomLeft,
            topLeft,
            topRight,
            alignmentPattern
        ];
        return new (0, $af1075b9a52868b5$export$2e2bcd8739ae039)(bits, points);
    };
    Detector.createTransform = function(topLeft, topRight, bottomLeft, alignmentPattern, dimension /*int*/ ) {
        var dimMinusThree = dimension - 3.5;
        var bottomRightX; /*float*/ 
        var bottomRightY; /*float*/ 
        var sourceBottomRightX; /*float*/ 
        var sourceBottomRightY; /*float*/ 
        if (alignmentPattern !== null) {
            bottomRightX = alignmentPattern.getX();
            bottomRightY = alignmentPattern.getY();
            sourceBottomRightX = dimMinusThree - 3.0;
            sourceBottomRightY = sourceBottomRightX;
        } else {
            // Don't have an alignment pattern, just make up the bottom-right point
            bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
            bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
            sourceBottomRightX = dimMinusThree;
            sourceBottomRightY = dimMinusThree;
        }
        return (0, $b13b825fa9745d86$export$2e2bcd8739ae039).quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
    };
    Detector.sampleGrid = function(image, transform, dimension /*int*/ ) {
        var sampler = (0, $6aeaa999aa5396ea$export$2e2bcd8739ae039).getInstance();
        return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
    };
    /**
     * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
     * of the finder patterns and estimated module size.</p>
     */ Detector.computeDimension = function(topLeft, topRight, bottomLeft, moduleSize /*float*/ ) {
        var tltrCentersDimension = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((0, $e9ec26965ff3031c$export$2e2bcd8739ae039).distance(topLeft, topRight) / moduleSize);
        var tlblCentersDimension = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).round((0, $e9ec26965ff3031c$export$2e2bcd8739ae039).distance(topLeft, bottomLeft) / moduleSize);
        var dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
        switch(dimension & 0x03){
            case 0:
                dimension++;
                break;
            // 1? do nothing
            case 2:
                dimension--;
                break;
            case 3:
                throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)("Dimensions could be not found.");
        }
        return dimension;
    };
    /**
     * <p>Computes an average estimated module size based on estimated derived from the positions
     * of the three finder patterns.</p>
     *
     * @param topLeft detected top-left finder pattern center
     * @param topRight detected top-right finder pattern center
     * @param bottomLeft detected bottom-left finder pattern center
     * @return estimated module size
     */ Detector.prototype.calculateModuleSize = function(topLeft, topRight, bottomLeft) {
        // Take the average
        return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2.0;
    };
    /**
     * <p>Estimates module size based on two finder patterns -- it uses
     * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
     * width of each, measuring along the axis between their centers.</p>
     */ Detector.prototype.calculateModuleSizeOneWay = function(pattern, otherPattern) {
        var moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()), /*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()));
        var moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()), /*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()));
        if (isNaN(moduleSizeEst1)) return moduleSizeEst2 / 7.0;
        if (isNaN(moduleSizeEst2)) return moduleSizeEst1 / 7.0;
        // Average them, and divide by 7 since we've counted the width of 3 black modules,
        // and 1 white and 1 black module on either side. Ergo, divide sum by 14.
        return (moduleSizeEst1 + moduleSizeEst2) / 14.0;
    };
    /**
     * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
     * a finder pattern by looking for a black-white-black run from the center in the direction
     * of another point (another finder pattern center), and in the opposite direction too.
     */ Detector.prototype.sizeOfBlackWhiteBlackRunBothWays = function(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
        var result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
        // Now count other way -- don't run off image though of course
        var scale = 1.0;
        var otherToX = fromX - (toX - fromX);
        if (otherToX < 0) {
            scale = fromX / /*(float) */ (fromX - otherToX);
            otherToX = 0;
        } else if (otherToX >= this.image.getWidth()) {
            scale = (this.image.getWidth() - 1 - fromX) / /*(float) */ (otherToX - fromX);
            otherToX = this.image.getWidth() - 1;
        }
        var otherToY = /*(int) */ Math.floor(fromY - (toY - fromY) * scale);
        scale = 1.0;
        if (otherToY < 0) {
            scale = fromY / /*(float) */ (fromY - otherToY);
            otherToY = 0;
        } else if (otherToY >= this.image.getHeight()) {
            scale = (this.image.getHeight() - 1 - fromY) / /*(float) */ (otherToY - fromY);
            otherToY = this.image.getHeight() - 1;
        }
        otherToX = /*(int) */ Math.floor(fromX + (otherToX - fromX) * scale);
        result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
        // Middle pixel is double-counted this way; subtract 1
        return result - 1.0;
    };
    /**
     * <p>This method traces a line from a point in the image, in the direction towards another point.
     * It begins in a black region, and keeps going until it finds white, then black, then white again.
     * It reports the distance from the start to this point.</p>
     *
     * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
     * may be skewed or rotated.</p>
     */ Detector.prototype.sizeOfBlackWhiteBlackRun = function(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
        // Mild variant of Bresenham's algorithm
        // see http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
        var steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
        if (steep) {
            var temp = fromX;
            fromX = fromY;
            fromY = temp;
            temp = toX;
            toX = toY;
            toY = temp;
        }
        var dx = Math.abs(toX - fromX);
        var dy = Math.abs(toY - fromY);
        var error = -dx / 2;
        var xstep = fromX < toX ? 1 : -1;
        var ystep = fromY < toY ? 1 : -1;
        // In black pixels, looking for white, first or second time.
        var state = 0;
        // Loop up until x == toX, but not beyond
        var xLimit = toX + xstep;
        for(var x = fromX, y = fromY; x !== xLimit; x += xstep){
            var realX = steep ? y : x;
            var realY = steep ? x : y;
            // Does current pixel mean we have moved white to black or vice versa?
            // Scanning black in state 0,2 and white in state 1, so if we find the wrong
            // color, advance to next state or end if we are in state 2 already
            if (state === 1 === this.image.get(realX, realY)) {
                if (state === 2) return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).distance(x, y, fromX, fromY);
                state++;
            }
            error += dy;
            if (error > 0) {
                if (y === toY) break;
                y += ystep;
                error -= dx;
            }
        }
        // Found black-white-black; give the benefit of the doubt that the next pixel outside the image
        // is "white" so this last point at (toX+xStep,toY) is the right ending. This is really a
        // small approximation; (toX+xStep,toY+yStep) might be really correct. Ignore this.
        if (state === 2) return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).distance(toX + xstep, toY, fromX, fromY);
        // else we didn't find even black-white-black; no estimate is really possible
        return NaN;
    };
    /**
     * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
     * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
     *
     * @param overallEstModuleSize estimated module size so far
     * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
     * @param estAlignmentY y coordinate of above
     * @param allowanceFactor number of pixels in all directions to search from the center
     * @return {@link AlignmentPattern} if found, or null otherwise
     * @throws NotFoundException if an unexpected error occurs during detection
     */ Detector.prototype.findAlignmentInRegion = function(overallEstModuleSize /*float*/ , estAlignmentX /*int*/ , estAlignmentY /*int*/ , allowanceFactor /*float*/ ) {
        // Look for an alignment pattern (3 modules in size) around where it
        // should be
        var allowance = /*(int) */ Math.floor(allowanceFactor * overallEstModuleSize);
        var alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
        var alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
        if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)("Alignment top exceeds estimated module size.");
        var alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
        var alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
        if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)("Alignment bottom exceeds estimated module size.");
        var alignmentFinder = new (0, $d5bb21272b9f6fb3$export$2e2bcd8739ae039)(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
        return alignmentFinder.find();
    };
    return Detector;
}();
var $b21eca621711e6d3$export$2e2bcd8739ae039 = $b21eca621711e6d3$var$Detector;


/*import java.util.List;*/ /*import java.util.Map;*/ /**
 * This implementation can detect and decode QR Codes in an image.
 *
 * @author Sean Owen
 */ var $1d4319be5d5105ae$var$QRCodeReader = /** @class */ function() {
    function QRCodeReader() {
        this.decoder = new (0, $d17a8a6152bc8136$export$2e2bcd8739ae039)();
    }
    QRCodeReader.prototype.getDecoder = function() {
        return this.decoder;
    };
    /**
     * Locates and decodes a QR code in an image.
     *
     * @return a representing: string the content encoded by the QR code
     * @throws NotFoundException if a QR code cannot be found
     * @throws FormatException if a QR code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ /*@Override*/ // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
    //   return this.decode(image, null)
    // }
    /*@Override*/ QRCodeReader.prototype.decode = function(image, hints) {
        var decoderResult;
        var points;
        if (hints !== undefined && hints !== null && undefined !== hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).PURE_BARCODE)) {
            var bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
            decoderResult = this.decoder.decodeBitMatrix(bits, hints);
            points = QRCodeReader.NO_POINTS;
        } else {
            var detectorResult = new (0, $b21eca621711e6d3$export$2e2bcd8739ae039)(image.getBlackMatrix()).detect(hints);
            decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
            points = detectorResult.getPoints();
        }
        // If the code was mirrored: swap the bottom-left and the top-right points.
        if (decoderResult.getOther() instanceof (0, $bf06753286ec1504$export$2e2bcd8739ae039)) decoderResult.getOther().applyMirroredCorrection(points);
        var result = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).QR_CODE, undefined);
        var byteSegments = decoderResult.getByteSegments();
        if (byteSegments !== null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).BYTE_SEGMENTS, byteSegments);
        var ecLevel = decoderResult.getECLevel();
        if (ecLevel !== null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ERROR_CORRECTION_LEVEL, ecLevel);
        if (decoderResult.hasStructuredAppend()) {
            result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
            result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
        }
        return result;
    };
    /*@Override*/ QRCodeReader.prototype.reset = function() {
    // do nothing
    };
    /**
     * This method detects a code in a "pure" image -- that is, pure monochrome image
     * which contains only an unrotated, unskewed, image of a code, with some white border
     * around it. This is a specialized method that works exceptionally fast in this special
     * case.
     *
     * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
     */ QRCodeReader.extractPureBits = function(image) {
        var leftTopBlack = image.getTopLeftOnBit();
        var rightBottomBlack = image.getBottomRightOnBit();
        if (leftTopBlack === null || rightBottomBlack === null) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        var moduleSize = this.moduleSize(leftTopBlack, image);
        var top = leftTopBlack[1];
        var bottom = rightBottomBlack[1];
        var left = leftTopBlack[0];
        var right = rightBottomBlack[0];
        // Sanity check!
        if (left >= right || top >= bottom) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (bottom - top !== right - left) {
            // Special case, where bottom-right module wasn't black so we found something else in the last row
            // Assume it's a square, so use height as the width
            right = left + (bottom - top);
            if (right >= image.getWidth()) // Abort if that would not make sense -- off image
            throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        }
        var matrixWidth = Math.round((right - left + 1) / moduleSize);
        var matrixHeight = Math.round((bottom - top + 1) / moduleSize);
        if (matrixWidth <= 0 || matrixHeight <= 0) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (matrixHeight !== matrixWidth) // Only possibly decode square regions
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        // Push in the "border" by half the module width so that we start
        // sampling in the middle of the module. Just in case the image is a
        // little off, this will help recover.
        var nudge = /*(int) */ Math.floor(moduleSize / 2.0);
        top += nudge;
        left += nudge;
        // But careful that this does not sample off the edge
        // "right" is the farthest-right valid pixel location -- right+1 is not necessarily
        // This is positive by how much the inner x loop below would be too large
        var nudgedTooFarRight = left + /*(int) */ Math.floor((matrixWidth - 1) * moduleSize) - right;
        if (nudgedTooFarRight > 0) {
            if (nudgedTooFarRight > nudge) // Neither way fits; abort
            throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            left -= nudgedTooFarRight;
        }
        // See logic above
        var nudgedTooFarDown = top + /*(int) */ Math.floor((matrixHeight - 1) * moduleSize) - bottom;
        if (nudgedTooFarDown > 0) {
            if (nudgedTooFarDown > nudge) // Neither way fits; abort
            throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
            top -= nudgedTooFarDown;
        }
        // Now just read off the bits
        var bits = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(matrixWidth, matrixHeight);
        for(var y = 0; y < matrixHeight; y++){
            var iOffset = top + /*(int) */ Math.floor(y * moduleSize);
            for(var x = 0; x < matrixWidth; x++)if (image.get(left + /*(int) */ Math.floor(x * moduleSize), iOffset)) bits.set(x, y);
        }
        return bits;
    };
    QRCodeReader.moduleSize = function(leftTopBlack, image) {
        var height = image.getHeight();
        var width = image.getWidth();
        var x = leftTopBlack[0];
        var y = leftTopBlack[1];
        var inBlack = true;
        var transitions = 0;
        while(x < width && y < height){
            if (inBlack !== image.get(x, y)) {
                if (++transitions === 5) break;
                inBlack = !inBlack;
            }
            x++;
            y++;
        }
        if (x === width || y === height) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        return (x - leftTopBlack[0]) / 7.0;
    };
    QRCodeReader.NO_POINTS = new Array();
    return QRCodeReader;
}();
var $1d4319be5d5105ae$export$2e2bcd8739ae039 = $1d4319be5d5105ae$var$QRCodeReader;






/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




/*
* Copyright 2009 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.pdf417;


var $43352c804aa61e30$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author SITA Lab (kevin.osullivan@sita.aero)
 * @author Guenther Grau
 */ var $43352c804aa61e30$var$PDF417Common = /** @class */ function() {
    function PDF417Common() {}
    PDF417Common.prototype.PDF417Common = function() {};
    /**
     * @param moduleBitCount values to sum
     * @return sum of values
     * @deprecated call {@link MathUtils#sum(int[])}
     */ // @Deprecated
    PDF417Common.getBitCountSum = function(moduleBitCount) {
        return (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(moduleBitCount);
    };
    PDF417Common.toIntArray = function(list) {
        var e_1, _a;
        if (list == null || !list.length) return PDF417Common.EMPTY_INT_ARRAY;
        var result = new Int32Array(list.length);
        var i = 0;
        try {
            for(var list_1 = $43352c804aa61e30$var$__values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()){
                var integer = list_1_1.value;
                result[i++] = integer;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return result;
    };
    /**
     * @param symbol encoded symbol to translate to a codeword
     * @return the codeword corresponding to the symbol.
     */ PDF417Common.getCodeword = function(symbol /*int*/ ) {
        var i = (0, $eed4834329730fe6$export$2e2bcd8739ae039).binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 0x3FFFF);
        if (i < 0) return -1;
        return (PDF417Common.CODEWORD_TABLE[i] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
    };
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    // Maximum Codewords (Data + Error).
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    // One left row indication column + max 30 data columns + one right row indicator column
    // public static /*final*/ MAX_CODEWORDS_IN_ROW: /*int*/ number = 32;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    /**
     * The sorted table of all possible symbols. Extracted from the PDF417
     * specification. The index of a symbol in this table corresponds to the
     * index into the codeword table.
     */ PDF417Common.SYMBOL_TABLE = Int32Array.from([
        0x1025e,
        0x1027a,
        0x1029e,
        0x102bc,
        0x102f2,
        0x102f4,
        0x1032e,
        0x1034e,
        0x1035c,
        0x10396,
        0x103a6,
        0x103ac,
        0x10422,
        0x10428,
        0x10436,
        0x10442,
        0x10444,
        0x10448,
        0x10450,
        0x1045e,
        0x10466,
        0x1046c,
        0x1047a,
        0x10482,
        0x1049e,
        0x104a0,
        0x104bc,
        0x104c6,
        0x104d8,
        0x104ee,
        0x104f2,
        0x104f4,
        0x10504,
        0x10508,
        0x10510,
        0x1051e,
        0x10520,
        0x1053c,
        0x10540,
        0x10578,
        0x10586,
        0x1058c,
        0x10598,
        0x105b0,
        0x105be,
        0x105ce,
        0x105dc,
        0x105e2,
        0x105e4,
        0x105e8,
        0x105f6,
        0x1062e,
        0x1064e,
        0x1065c,
        0x1068e,
        0x1069c,
        0x106b8,
        0x106de,
        0x106fa,
        0x10716,
        0x10726,
        0x1072c,
        0x10746,
        0x1074c,
        0x10758,
        0x1076e,
        0x10792,
        0x10794,
        0x107a2,
        0x107a4,
        0x107a8,
        0x107b6,
        0x10822,
        0x10828,
        0x10842,
        0x10848,
        0x10850,
        0x1085e,
        0x10866,
        0x1086c,
        0x1087a,
        0x10882,
        0x10884,
        0x10890,
        0x1089e,
        0x108a0,
        0x108bc,
        0x108c6,
        0x108cc,
        0x108d8,
        0x108ee,
        0x108f2,
        0x108f4,
        0x10902,
        0x10908,
        0x1091e,
        0x10920,
        0x1093c,
        0x10940,
        0x10978,
        0x10986,
        0x10998,
        0x109b0,
        0x109be,
        0x109ce,
        0x109dc,
        0x109e2,
        0x109e4,
        0x109e8,
        0x109f6,
        0x10a08,
        0x10a10,
        0x10a1e,
        0x10a20,
        0x10a3c,
        0x10a40,
        0x10a78,
        0x10af0,
        0x10b06,
        0x10b0c,
        0x10b18,
        0x10b30,
        0x10b3e,
        0x10b60,
        0x10b7c,
        0x10b8e,
        0x10b9c,
        0x10bb8,
        0x10bc2,
        0x10bc4,
        0x10bc8,
        0x10bd0,
        0x10bde,
        0x10be6,
        0x10bec,
        0x10c2e,
        0x10c4e,
        0x10c5c,
        0x10c62,
        0x10c64,
        0x10c68,
        0x10c76,
        0x10c8e,
        0x10c9c,
        0x10cb8,
        0x10cc2,
        0x10cc4,
        0x10cc8,
        0x10cd0,
        0x10cde,
        0x10ce6,
        0x10cec,
        0x10cfa,
        0x10d0e,
        0x10d1c,
        0x10d38,
        0x10d70,
        0x10d7e,
        0x10d82,
        0x10d84,
        0x10d88,
        0x10d90,
        0x10d9e,
        0x10da0,
        0x10dbc,
        0x10dc6,
        0x10dcc,
        0x10dd8,
        0x10dee,
        0x10df2,
        0x10df4,
        0x10e16,
        0x10e26,
        0x10e2c,
        0x10e46,
        0x10e58,
        0x10e6e,
        0x10e86,
        0x10e8c,
        0x10e98,
        0x10eb0,
        0x10ebe,
        0x10ece,
        0x10edc,
        0x10f0a,
        0x10f12,
        0x10f14,
        0x10f22,
        0x10f28,
        0x10f36,
        0x10f42,
        0x10f44,
        0x10f48,
        0x10f50,
        0x10f5e,
        0x10f66,
        0x10f6c,
        0x10fb2,
        0x10fb4,
        0x11022,
        0x11028,
        0x11042,
        0x11048,
        0x11050,
        0x1105e,
        0x1107a,
        0x11082,
        0x11084,
        0x11090,
        0x1109e,
        0x110a0,
        0x110bc,
        0x110c6,
        0x110cc,
        0x110d8,
        0x110ee,
        0x110f2,
        0x110f4,
        0x11102,
        0x1111e,
        0x11120,
        0x1113c,
        0x11140,
        0x11178,
        0x11186,
        0x11198,
        0x111b0,
        0x111be,
        0x111ce,
        0x111dc,
        0x111e2,
        0x111e4,
        0x111e8,
        0x111f6,
        0x11208,
        0x1121e,
        0x11220,
        0x11278,
        0x112f0,
        0x1130c,
        0x11330,
        0x1133e,
        0x11360,
        0x1137c,
        0x1138e,
        0x1139c,
        0x113b8,
        0x113c2,
        0x113c8,
        0x113d0,
        0x113de,
        0x113e6,
        0x113ec,
        0x11408,
        0x11410,
        0x1141e,
        0x11420,
        0x1143c,
        0x11440,
        0x11478,
        0x114f0,
        0x115e0,
        0x1160c,
        0x11618,
        0x11630,
        0x1163e,
        0x11660,
        0x1167c,
        0x116c0,
        0x116f8,
        0x1171c,
        0x11738,
        0x11770,
        0x1177e,
        0x11782,
        0x11784,
        0x11788,
        0x11790,
        0x1179e,
        0x117a0,
        0x117bc,
        0x117c6,
        0x117cc,
        0x117d8,
        0x117ee,
        0x1182e,
        0x11834,
        0x1184e,
        0x1185c,
        0x11862,
        0x11864,
        0x11868,
        0x11876,
        0x1188e,
        0x1189c,
        0x118b8,
        0x118c2,
        0x118c8,
        0x118d0,
        0x118de,
        0x118e6,
        0x118ec,
        0x118fa,
        0x1190e,
        0x1191c,
        0x11938,
        0x11970,
        0x1197e,
        0x11982,
        0x11984,
        0x11990,
        0x1199e,
        0x119a0,
        0x119bc,
        0x119c6,
        0x119cc,
        0x119d8,
        0x119ee,
        0x119f2,
        0x119f4,
        0x11a0e,
        0x11a1c,
        0x11a38,
        0x11a70,
        0x11a7e,
        0x11ae0,
        0x11afc,
        0x11b08,
        0x11b10,
        0x11b1e,
        0x11b20,
        0x11b3c,
        0x11b40,
        0x11b78,
        0x11b8c,
        0x11b98,
        0x11bb0,
        0x11bbe,
        0x11bce,
        0x11bdc,
        0x11be2,
        0x11be4,
        0x11be8,
        0x11bf6,
        0x11c16,
        0x11c26,
        0x11c2c,
        0x11c46,
        0x11c4c,
        0x11c58,
        0x11c6e,
        0x11c86,
        0x11c98,
        0x11cb0,
        0x11cbe,
        0x11cce,
        0x11cdc,
        0x11ce2,
        0x11ce4,
        0x11ce8,
        0x11cf6,
        0x11d06,
        0x11d0c,
        0x11d18,
        0x11d30,
        0x11d3e,
        0x11d60,
        0x11d7c,
        0x11d8e,
        0x11d9c,
        0x11db8,
        0x11dc4,
        0x11dc8,
        0x11dd0,
        0x11dde,
        0x11de6,
        0x11dec,
        0x11dfa,
        0x11e0a,
        0x11e12,
        0x11e14,
        0x11e22,
        0x11e24,
        0x11e28,
        0x11e36,
        0x11e42,
        0x11e44,
        0x11e50,
        0x11e5e,
        0x11e66,
        0x11e6c,
        0x11e82,
        0x11e84,
        0x11e88,
        0x11e90,
        0x11e9e,
        0x11ea0,
        0x11ebc,
        0x11ec6,
        0x11ecc,
        0x11ed8,
        0x11eee,
        0x11f1a,
        0x11f2e,
        0x11f32,
        0x11f34,
        0x11f4e,
        0x11f5c,
        0x11f62,
        0x11f64,
        0x11f68,
        0x11f76,
        0x12048,
        0x1205e,
        0x12082,
        0x12084,
        0x12090,
        0x1209e,
        0x120a0,
        0x120bc,
        0x120d8,
        0x120f2,
        0x120f4,
        0x12108,
        0x1211e,
        0x12120,
        0x1213c,
        0x12140,
        0x12178,
        0x12186,
        0x12198,
        0x121b0,
        0x121be,
        0x121e2,
        0x121e4,
        0x121e8,
        0x121f6,
        0x12204,
        0x12210,
        0x1221e,
        0x12220,
        0x12278,
        0x122f0,
        0x12306,
        0x1230c,
        0x12330,
        0x1233e,
        0x12360,
        0x1237c,
        0x1238e,
        0x1239c,
        0x123b8,
        0x123c2,
        0x123c8,
        0x123d0,
        0x123e6,
        0x123ec,
        0x1241e,
        0x12420,
        0x1243c,
        0x124f0,
        0x125e0,
        0x12618,
        0x1263e,
        0x12660,
        0x1267c,
        0x126c0,
        0x126f8,
        0x12738,
        0x12770,
        0x1277e,
        0x12782,
        0x12784,
        0x12790,
        0x1279e,
        0x127a0,
        0x127bc,
        0x127c6,
        0x127cc,
        0x127d8,
        0x127ee,
        0x12820,
        0x1283c,
        0x12840,
        0x12878,
        0x128f0,
        0x129e0,
        0x12bc0,
        0x12c18,
        0x12c30,
        0x12c3e,
        0x12c60,
        0x12c7c,
        0x12cc0,
        0x12cf8,
        0x12df0,
        0x12e1c,
        0x12e38,
        0x12e70,
        0x12e7e,
        0x12ee0,
        0x12efc,
        0x12f04,
        0x12f08,
        0x12f10,
        0x12f20,
        0x12f3c,
        0x12f40,
        0x12f78,
        0x12f86,
        0x12f8c,
        0x12f98,
        0x12fb0,
        0x12fbe,
        0x12fce,
        0x12fdc,
        0x1302e,
        0x1304e,
        0x1305c,
        0x13062,
        0x13068,
        0x1308e,
        0x1309c,
        0x130b8,
        0x130c2,
        0x130c8,
        0x130d0,
        0x130de,
        0x130ec,
        0x130fa,
        0x1310e,
        0x13138,
        0x13170,
        0x1317e,
        0x13182,
        0x13184,
        0x13190,
        0x1319e,
        0x131a0,
        0x131bc,
        0x131c6,
        0x131cc,
        0x131d8,
        0x131f2,
        0x131f4,
        0x1320e,
        0x1321c,
        0x13270,
        0x1327e,
        0x132e0,
        0x132fc,
        0x13308,
        0x1331e,
        0x13320,
        0x1333c,
        0x13340,
        0x13378,
        0x13386,
        0x13398,
        0x133b0,
        0x133be,
        0x133ce,
        0x133dc,
        0x133e2,
        0x133e4,
        0x133e8,
        0x133f6,
        0x1340e,
        0x1341c,
        0x13438,
        0x13470,
        0x1347e,
        0x134e0,
        0x134fc,
        0x135c0,
        0x135f8,
        0x13608,
        0x13610,
        0x1361e,
        0x13620,
        0x1363c,
        0x13640,
        0x13678,
        0x136f0,
        0x1370c,
        0x13718,
        0x13730,
        0x1373e,
        0x13760,
        0x1377c,
        0x1379c,
        0x137b8,
        0x137c2,
        0x137c4,
        0x137c8,
        0x137d0,
        0x137de,
        0x137e6,
        0x137ec,
        0x13816,
        0x13826,
        0x1382c,
        0x13846,
        0x1384c,
        0x13858,
        0x1386e,
        0x13874,
        0x13886,
        0x13898,
        0x138b0,
        0x138be,
        0x138ce,
        0x138dc,
        0x138e2,
        0x138e4,
        0x138e8,
        0x13906,
        0x1390c,
        0x13930,
        0x1393e,
        0x13960,
        0x1397c,
        0x1398e,
        0x1399c,
        0x139b8,
        0x139c8,
        0x139d0,
        0x139de,
        0x139e6,
        0x139ec,
        0x139fa,
        0x13a06,
        0x13a0c,
        0x13a18,
        0x13a30,
        0x13a3e,
        0x13a60,
        0x13a7c,
        0x13ac0,
        0x13af8,
        0x13b0e,
        0x13b1c,
        0x13b38,
        0x13b70,
        0x13b7e,
        0x13b88,
        0x13b90,
        0x13b9e,
        0x13ba0,
        0x13bbc,
        0x13bcc,
        0x13bd8,
        0x13bee,
        0x13bf2,
        0x13bf4,
        0x13c12,
        0x13c14,
        0x13c22,
        0x13c24,
        0x13c28,
        0x13c36,
        0x13c42,
        0x13c48,
        0x13c50,
        0x13c5e,
        0x13c66,
        0x13c6c,
        0x13c82,
        0x13c84,
        0x13c90,
        0x13c9e,
        0x13ca0,
        0x13cbc,
        0x13cc6,
        0x13ccc,
        0x13cd8,
        0x13cee,
        0x13d02,
        0x13d04,
        0x13d08,
        0x13d10,
        0x13d1e,
        0x13d20,
        0x13d3c,
        0x13d40,
        0x13d78,
        0x13d86,
        0x13d8c,
        0x13d98,
        0x13db0,
        0x13dbe,
        0x13dce,
        0x13ddc,
        0x13de4,
        0x13de8,
        0x13df6,
        0x13e1a,
        0x13e2e,
        0x13e32,
        0x13e34,
        0x13e4e,
        0x13e5c,
        0x13e62,
        0x13e64,
        0x13e68,
        0x13e76,
        0x13e8e,
        0x13e9c,
        0x13eb8,
        0x13ec2,
        0x13ec4,
        0x13ec8,
        0x13ed0,
        0x13ede,
        0x13ee6,
        0x13eec,
        0x13f26,
        0x13f2c,
        0x13f3a,
        0x13f46,
        0x13f4c,
        0x13f58,
        0x13f6e,
        0x13f72,
        0x13f74,
        0x14082,
        0x1409e,
        0x140a0,
        0x140bc,
        0x14104,
        0x14108,
        0x14110,
        0x1411e,
        0x14120,
        0x1413c,
        0x14140,
        0x14178,
        0x1418c,
        0x14198,
        0x141b0,
        0x141be,
        0x141e2,
        0x141e4,
        0x141e8,
        0x14208,
        0x14210,
        0x1421e,
        0x14220,
        0x1423c,
        0x14240,
        0x14278,
        0x142f0,
        0x14306,
        0x1430c,
        0x14318,
        0x14330,
        0x1433e,
        0x14360,
        0x1437c,
        0x1438e,
        0x143c2,
        0x143c4,
        0x143c8,
        0x143d0,
        0x143e6,
        0x143ec,
        0x14408,
        0x14410,
        0x1441e,
        0x14420,
        0x1443c,
        0x14440,
        0x14478,
        0x144f0,
        0x145e0,
        0x1460c,
        0x14618,
        0x14630,
        0x1463e,
        0x14660,
        0x1467c,
        0x146c0,
        0x146f8,
        0x1471c,
        0x14738,
        0x14770,
        0x1477e,
        0x14782,
        0x14784,
        0x14788,
        0x14790,
        0x147a0,
        0x147bc,
        0x147c6,
        0x147cc,
        0x147d8,
        0x147ee,
        0x14810,
        0x14820,
        0x1483c,
        0x14840,
        0x14878,
        0x148f0,
        0x149e0,
        0x14bc0,
        0x14c30,
        0x14c3e,
        0x14c60,
        0x14c7c,
        0x14cc0,
        0x14cf8,
        0x14df0,
        0x14e38,
        0x14e70,
        0x14e7e,
        0x14ee0,
        0x14efc,
        0x14f04,
        0x14f08,
        0x14f10,
        0x14f1e,
        0x14f20,
        0x14f3c,
        0x14f40,
        0x14f78,
        0x14f86,
        0x14f8c,
        0x14f98,
        0x14fb0,
        0x14fce,
        0x14fdc,
        0x15020,
        0x15040,
        0x15078,
        0x150f0,
        0x151e0,
        0x153c0,
        0x15860,
        0x1587c,
        0x158c0,
        0x158f8,
        0x159f0,
        0x15be0,
        0x15c70,
        0x15c7e,
        0x15ce0,
        0x15cfc,
        0x15dc0,
        0x15df8,
        0x15e08,
        0x15e10,
        0x15e20,
        0x15e40,
        0x15e78,
        0x15ef0,
        0x15f0c,
        0x15f18,
        0x15f30,
        0x15f60,
        0x15f7c,
        0x15f8e,
        0x15f9c,
        0x15fb8,
        0x1604e,
        0x1605c,
        0x1608e,
        0x1609c,
        0x160b8,
        0x160c2,
        0x160c4,
        0x160c8,
        0x160de,
        0x1610e,
        0x1611c,
        0x16138,
        0x16170,
        0x1617e,
        0x16184,
        0x16188,
        0x16190,
        0x1619e,
        0x161a0,
        0x161bc,
        0x161c6,
        0x161cc,
        0x161d8,
        0x161f2,
        0x161f4,
        0x1620e,
        0x1621c,
        0x16238,
        0x16270,
        0x1627e,
        0x162e0,
        0x162fc,
        0x16304,
        0x16308,
        0x16310,
        0x1631e,
        0x16320,
        0x1633c,
        0x16340,
        0x16378,
        0x16386,
        0x1638c,
        0x16398,
        0x163b0,
        0x163be,
        0x163ce,
        0x163dc,
        0x163e2,
        0x163e4,
        0x163e8,
        0x163f6,
        0x1640e,
        0x1641c,
        0x16438,
        0x16470,
        0x1647e,
        0x164e0,
        0x164fc,
        0x165c0,
        0x165f8,
        0x16610,
        0x1661e,
        0x16620,
        0x1663c,
        0x16640,
        0x16678,
        0x166f0,
        0x16718,
        0x16730,
        0x1673e,
        0x16760,
        0x1677c,
        0x1678e,
        0x1679c,
        0x167b8,
        0x167c2,
        0x167c4,
        0x167c8,
        0x167d0,
        0x167de,
        0x167e6,
        0x167ec,
        0x1681c,
        0x16838,
        0x16870,
        0x168e0,
        0x168fc,
        0x169c0,
        0x169f8,
        0x16bf0,
        0x16c10,
        0x16c1e,
        0x16c20,
        0x16c3c,
        0x16c40,
        0x16c78,
        0x16cf0,
        0x16de0,
        0x16e18,
        0x16e30,
        0x16e3e,
        0x16e60,
        0x16e7c,
        0x16ec0,
        0x16ef8,
        0x16f1c,
        0x16f38,
        0x16f70,
        0x16f7e,
        0x16f84,
        0x16f88,
        0x16f90,
        0x16f9e,
        0x16fa0,
        0x16fbc,
        0x16fc6,
        0x16fcc,
        0x16fd8,
        0x17026,
        0x1702c,
        0x17046,
        0x1704c,
        0x17058,
        0x1706e,
        0x17086,
        0x1708c,
        0x17098,
        0x170b0,
        0x170be,
        0x170ce,
        0x170dc,
        0x170e8,
        0x17106,
        0x1710c,
        0x17118,
        0x17130,
        0x1713e,
        0x17160,
        0x1717c,
        0x1718e,
        0x1719c,
        0x171b8,
        0x171c2,
        0x171c4,
        0x171c8,
        0x171d0,
        0x171de,
        0x171e6,
        0x171ec,
        0x171fa,
        0x17206,
        0x1720c,
        0x17218,
        0x17230,
        0x1723e,
        0x17260,
        0x1727c,
        0x172c0,
        0x172f8,
        0x1730e,
        0x1731c,
        0x17338,
        0x17370,
        0x1737e,
        0x17388,
        0x17390,
        0x1739e,
        0x173a0,
        0x173bc,
        0x173cc,
        0x173d8,
        0x173ee,
        0x173f2,
        0x173f4,
        0x1740c,
        0x17418,
        0x17430,
        0x1743e,
        0x17460,
        0x1747c,
        0x174c0,
        0x174f8,
        0x175f0,
        0x1760e,
        0x1761c,
        0x17638,
        0x17670,
        0x1767e,
        0x176e0,
        0x176fc,
        0x17708,
        0x17710,
        0x1771e,
        0x17720,
        0x1773c,
        0x17740,
        0x17778,
        0x17798,
        0x177b0,
        0x177be,
        0x177dc,
        0x177e2,
        0x177e4,
        0x177e8,
        0x17822,
        0x17824,
        0x17828,
        0x17836,
        0x17842,
        0x17844,
        0x17848,
        0x17850,
        0x1785e,
        0x17866,
        0x1786c,
        0x17882,
        0x17884,
        0x17888,
        0x17890,
        0x1789e,
        0x178a0,
        0x178bc,
        0x178c6,
        0x178cc,
        0x178d8,
        0x178ee,
        0x178f2,
        0x178f4,
        0x17902,
        0x17904,
        0x17908,
        0x17910,
        0x1791e,
        0x17920,
        0x1793c,
        0x17940,
        0x17978,
        0x17986,
        0x1798c,
        0x17998,
        0x179b0,
        0x179be,
        0x179ce,
        0x179dc,
        0x179e2,
        0x179e4,
        0x179e8,
        0x179f6,
        0x17a04,
        0x17a08,
        0x17a10,
        0x17a1e,
        0x17a20,
        0x17a3c,
        0x17a40,
        0x17a78,
        0x17af0,
        0x17b06,
        0x17b0c,
        0x17b18,
        0x17b30,
        0x17b3e,
        0x17b60,
        0x17b7c,
        0x17b8e,
        0x17b9c,
        0x17bb8,
        0x17bc4,
        0x17bc8,
        0x17bd0,
        0x17bde,
        0x17be6,
        0x17bec,
        0x17c2e,
        0x17c32,
        0x17c34,
        0x17c4e,
        0x17c5c,
        0x17c62,
        0x17c64,
        0x17c68,
        0x17c76,
        0x17c8e,
        0x17c9c,
        0x17cb8,
        0x17cc2,
        0x17cc4,
        0x17cc8,
        0x17cd0,
        0x17cde,
        0x17ce6,
        0x17cec,
        0x17d0e,
        0x17d1c,
        0x17d38,
        0x17d70,
        0x17d82,
        0x17d84,
        0x17d88,
        0x17d90,
        0x17d9e,
        0x17da0,
        0x17dbc,
        0x17dc6,
        0x17dcc,
        0x17dd8,
        0x17dee,
        0x17e26,
        0x17e2c,
        0x17e3a,
        0x17e46,
        0x17e4c,
        0x17e58,
        0x17e6e,
        0x17e72,
        0x17e74,
        0x17e86,
        0x17e8c,
        0x17e98,
        0x17eb0,
        0x17ece,
        0x17edc,
        0x17ee2,
        0x17ee4,
        0x17ee8,
        0x17ef6,
        0x1813a,
        0x18172,
        0x18174,
        0x18216,
        0x18226,
        0x1823a,
        0x1824c,
        0x18258,
        0x1826e,
        0x18272,
        0x18274,
        0x18298,
        0x182be,
        0x182e2,
        0x182e4,
        0x182e8,
        0x182f6,
        0x1835e,
        0x1837a,
        0x183ae,
        0x183d6,
        0x18416,
        0x18426,
        0x1842c,
        0x1843a,
        0x18446,
        0x18458,
        0x1846e,
        0x18472,
        0x18474,
        0x18486,
        0x184b0,
        0x184be,
        0x184ce,
        0x184dc,
        0x184e2,
        0x184e4,
        0x184e8,
        0x184f6,
        0x18506,
        0x1850c,
        0x18518,
        0x18530,
        0x1853e,
        0x18560,
        0x1857c,
        0x1858e,
        0x1859c,
        0x185b8,
        0x185c2,
        0x185c4,
        0x185c8,
        0x185d0,
        0x185de,
        0x185e6,
        0x185ec,
        0x185fa,
        0x18612,
        0x18614,
        0x18622,
        0x18628,
        0x18636,
        0x18642,
        0x18650,
        0x1865e,
        0x1867a,
        0x18682,
        0x18684,
        0x18688,
        0x18690,
        0x1869e,
        0x186a0,
        0x186bc,
        0x186c6,
        0x186cc,
        0x186d8,
        0x186ee,
        0x186f2,
        0x186f4,
        0x1872e,
        0x1874e,
        0x1875c,
        0x18796,
        0x187a6,
        0x187ac,
        0x187d2,
        0x187d4,
        0x18826,
        0x1882c,
        0x1883a,
        0x18846,
        0x1884c,
        0x18858,
        0x1886e,
        0x18872,
        0x18874,
        0x18886,
        0x18898,
        0x188b0,
        0x188be,
        0x188ce,
        0x188dc,
        0x188e2,
        0x188e4,
        0x188e8,
        0x188f6,
        0x1890c,
        0x18930,
        0x1893e,
        0x18960,
        0x1897c,
        0x1898e,
        0x189b8,
        0x189c2,
        0x189c8,
        0x189d0,
        0x189de,
        0x189e6,
        0x189ec,
        0x189fa,
        0x18a18,
        0x18a30,
        0x18a3e,
        0x18a60,
        0x18a7c,
        0x18ac0,
        0x18af8,
        0x18b1c,
        0x18b38,
        0x18b70,
        0x18b7e,
        0x18b82,
        0x18b84,
        0x18b88,
        0x18b90,
        0x18b9e,
        0x18ba0,
        0x18bbc,
        0x18bc6,
        0x18bcc,
        0x18bd8,
        0x18bee,
        0x18bf2,
        0x18bf4,
        0x18c22,
        0x18c24,
        0x18c28,
        0x18c36,
        0x18c42,
        0x18c48,
        0x18c50,
        0x18c5e,
        0x18c66,
        0x18c7a,
        0x18c82,
        0x18c84,
        0x18c90,
        0x18c9e,
        0x18ca0,
        0x18cbc,
        0x18ccc,
        0x18cf2,
        0x18cf4,
        0x18d04,
        0x18d08,
        0x18d10,
        0x18d1e,
        0x18d20,
        0x18d3c,
        0x18d40,
        0x18d78,
        0x18d86,
        0x18d98,
        0x18dce,
        0x18de2,
        0x18de4,
        0x18de8,
        0x18e2e,
        0x18e32,
        0x18e34,
        0x18e4e,
        0x18e5c,
        0x18e62,
        0x18e64,
        0x18e68,
        0x18e8e,
        0x18e9c,
        0x18eb8,
        0x18ec2,
        0x18ec4,
        0x18ec8,
        0x18ed0,
        0x18efa,
        0x18f16,
        0x18f26,
        0x18f2c,
        0x18f46,
        0x18f4c,
        0x18f58,
        0x18f6e,
        0x18f8a,
        0x18f92,
        0x18f94,
        0x18fa2,
        0x18fa4,
        0x18fa8,
        0x18fb6,
        0x1902c,
        0x1903a,
        0x19046,
        0x1904c,
        0x19058,
        0x19072,
        0x19074,
        0x19086,
        0x19098,
        0x190b0,
        0x190be,
        0x190ce,
        0x190dc,
        0x190e2,
        0x190e8,
        0x190f6,
        0x19106,
        0x1910c,
        0x19130,
        0x1913e,
        0x19160,
        0x1917c,
        0x1918e,
        0x1919c,
        0x191b8,
        0x191c2,
        0x191c8,
        0x191d0,
        0x191de,
        0x191e6,
        0x191ec,
        0x191fa,
        0x19218,
        0x1923e,
        0x19260,
        0x1927c,
        0x192c0,
        0x192f8,
        0x19338,
        0x19370,
        0x1937e,
        0x19382,
        0x19384,
        0x19390,
        0x1939e,
        0x193a0,
        0x193bc,
        0x193c6,
        0x193cc,
        0x193d8,
        0x193ee,
        0x193f2,
        0x193f4,
        0x19430,
        0x1943e,
        0x19460,
        0x1947c,
        0x194c0,
        0x194f8,
        0x195f0,
        0x19638,
        0x19670,
        0x1967e,
        0x196e0,
        0x196fc,
        0x19702,
        0x19704,
        0x19708,
        0x19710,
        0x19720,
        0x1973c,
        0x19740,
        0x19778,
        0x19786,
        0x1978c,
        0x19798,
        0x197b0,
        0x197be,
        0x197ce,
        0x197dc,
        0x197e2,
        0x197e4,
        0x197e8,
        0x19822,
        0x19824,
        0x19842,
        0x19848,
        0x19850,
        0x1985e,
        0x19866,
        0x1987a,
        0x19882,
        0x19884,
        0x19890,
        0x1989e,
        0x198a0,
        0x198bc,
        0x198cc,
        0x198f2,
        0x198f4,
        0x19902,
        0x19908,
        0x1991e,
        0x19920,
        0x1993c,
        0x19940,
        0x19978,
        0x19986,
        0x19998,
        0x199ce,
        0x199e2,
        0x199e4,
        0x199e8,
        0x19a08,
        0x19a10,
        0x19a1e,
        0x19a20,
        0x19a3c,
        0x19a40,
        0x19a78,
        0x19af0,
        0x19b18,
        0x19b3e,
        0x19b60,
        0x19b9c,
        0x19bc2,
        0x19bc4,
        0x19bc8,
        0x19bd0,
        0x19be6,
        0x19c2e,
        0x19c34,
        0x19c4e,
        0x19c5c,
        0x19c62,
        0x19c64,
        0x19c68,
        0x19c8e,
        0x19c9c,
        0x19cb8,
        0x19cc2,
        0x19cc8,
        0x19cd0,
        0x19ce6,
        0x19cfa,
        0x19d0e,
        0x19d1c,
        0x19d38,
        0x19d70,
        0x19d7e,
        0x19d82,
        0x19d84,
        0x19d88,
        0x19d90,
        0x19da0,
        0x19dcc,
        0x19df2,
        0x19df4,
        0x19e16,
        0x19e26,
        0x19e2c,
        0x19e46,
        0x19e4c,
        0x19e58,
        0x19e74,
        0x19e86,
        0x19e8c,
        0x19e98,
        0x19eb0,
        0x19ebe,
        0x19ece,
        0x19ee2,
        0x19ee4,
        0x19ee8,
        0x19f0a,
        0x19f12,
        0x19f14,
        0x19f22,
        0x19f24,
        0x19f28,
        0x19f42,
        0x19f44,
        0x19f48,
        0x19f50,
        0x19f5e,
        0x19f6c,
        0x19f9a,
        0x19fae,
        0x19fb2,
        0x19fb4,
        0x1a046,
        0x1a04c,
        0x1a072,
        0x1a074,
        0x1a086,
        0x1a08c,
        0x1a098,
        0x1a0b0,
        0x1a0be,
        0x1a0e2,
        0x1a0e4,
        0x1a0e8,
        0x1a0f6,
        0x1a106,
        0x1a10c,
        0x1a118,
        0x1a130,
        0x1a13e,
        0x1a160,
        0x1a17c,
        0x1a18e,
        0x1a19c,
        0x1a1b8,
        0x1a1c2,
        0x1a1c4,
        0x1a1c8,
        0x1a1d0,
        0x1a1de,
        0x1a1e6,
        0x1a1ec,
        0x1a218,
        0x1a230,
        0x1a23e,
        0x1a260,
        0x1a27c,
        0x1a2c0,
        0x1a2f8,
        0x1a31c,
        0x1a338,
        0x1a370,
        0x1a37e,
        0x1a382,
        0x1a384,
        0x1a388,
        0x1a390,
        0x1a39e,
        0x1a3a0,
        0x1a3bc,
        0x1a3c6,
        0x1a3cc,
        0x1a3d8,
        0x1a3ee,
        0x1a3f2,
        0x1a3f4,
        0x1a418,
        0x1a430,
        0x1a43e,
        0x1a460,
        0x1a47c,
        0x1a4c0,
        0x1a4f8,
        0x1a5f0,
        0x1a61c,
        0x1a638,
        0x1a670,
        0x1a67e,
        0x1a6e0,
        0x1a6fc,
        0x1a702,
        0x1a704,
        0x1a708,
        0x1a710,
        0x1a71e,
        0x1a720,
        0x1a73c,
        0x1a740,
        0x1a778,
        0x1a786,
        0x1a78c,
        0x1a798,
        0x1a7b0,
        0x1a7be,
        0x1a7ce,
        0x1a7dc,
        0x1a7e2,
        0x1a7e4,
        0x1a7e8,
        0x1a830,
        0x1a860,
        0x1a87c,
        0x1a8c0,
        0x1a8f8,
        0x1a9f0,
        0x1abe0,
        0x1ac70,
        0x1ac7e,
        0x1ace0,
        0x1acfc,
        0x1adc0,
        0x1adf8,
        0x1ae04,
        0x1ae08,
        0x1ae10,
        0x1ae20,
        0x1ae3c,
        0x1ae40,
        0x1ae78,
        0x1aef0,
        0x1af06,
        0x1af0c,
        0x1af18,
        0x1af30,
        0x1af3e,
        0x1af60,
        0x1af7c,
        0x1af8e,
        0x1af9c,
        0x1afb8,
        0x1afc4,
        0x1afc8,
        0x1afd0,
        0x1afde,
        0x1b042,
        0x1b05e,
        0x1b07a,
        0x1b082,
        0x1b084,
        0x1b088,
        0x1b090,
        0x1b09e,
        0x1b0a0,
        0x1b0bc,
        0x1b0cc,
        0x1b0f2,
        0x1b0f4,
        0x1b102,
        0x1b104,
        0x1b108,
        0x1b110,
        0x1b11e,
        0x1b120,
        0x1b13c,
        0x1b140,
        0x1b178,
        0x1b186,
        0x1b198,
        0x1b1ce,
        0x1b1e2,
        0x1b1e4,
        0x1b1e8,
        0x1b204,
        0x1b208,
        0x1b210,
        0x1b21e,
        0x1b220,
        0x1b23c,
        0x1b240,
        0x1b278,
        0x1b2f0,
        0x1b30c,
        0x1b33e,
        0x1b360,
        0x1b39c,
        0x1b3c2,
        0x1b3c4,
        0x1b3c8,
        0x1b3d0,
        0x1b3e6,
        0x1b410,
        0x1b41e,
        0x1b420,
        0x1b43c,
        0x1b440,
        0x1b478,
        0x1b4f0,
        0x1b5e0,
        0x1b618,
        0x1b660,
        0x1b67c,
        0x1b6c0,
        0x1b738,
        0x1b782,
        0x1b784,
        0x1b788,
        0x1b790,
        0x1b79e,
        0x1b7a0,
        0x1b7cc,
        0x1b82e,
        0x1b84e,
        0x1b85c,
        0x1b88e,
        0x1b89c,
        0x1b8b8,
        0x1b8c2,
        0x1b8c4,
        0x1b8c8,
        0x1b8d0,
        0x1b8e6,
        0x1b8fa,
        0x1b90e,
        0x1b91c,
        0x1b938,
        0x1b970,
        0x1b97e,
        0x1b982,
        0x1b984,
        0x1b988,
        0x1b990,
        0x1b99e,
        0x1b9a0,
        0x1b9cc,
        0x1b9f2,
        0x1b9f4,
        0x1ba0e,
        0x1ba1c,
        0x1ba38,
        0x1ba70,
        0x1ba7e,
        0x1bae0,
        0x1bafc,
        0x1bb08,
        0x1bb10,
        0x1bb20,
        0x1bb3c,
        0x1bb40,
        0x1bb98,
        0x1bbce,
        0x1bbe2,
        0x1bbe4,
        0x1bbe8,
        0x1bc16,
        0x1bc26,
        0x1bc2c,
        0x1bc46,
        0x1bc4c,
        0x1bc58,
        0x1bc72,
        0x1bc74,
        0x1bc86,
        0x1bc8c,
        0x1bc98,
        0x1bcb0,
        0x1bcbe,
        0x1bcce,
        0x1bce2,
        0x1bce4,
        0x1bce8,
        0x1bd06,
        0x1bd0c,
        0x1bd18,
        0x1bd30,
        0x1bd3e,
        0x1bd60,
        0x1bd7c,
        0x1bd9c,
        0x1bdc2,
        0x1bdc4,
        0x1bdc8,
        0x1bdd0,
        0x1bde6,
        0x1bdfa,
        0x1be12,
        0x1be14,
        0x1be22,
        0x1be24,
        0x1be28,
        0x1be42,
        0x1be44,
        0x1be48,
        0x1be50,
        0x1be5e,
        0x1be66,
        0x1be82,
        0x1be84,
        0x1be88,
        0x1be90,
        0x1be9e,
        0x1bea0,
        0x1bebc,
        0x1becc,
        0x1bef4,
        0x1bf1a,
        0x1bf2e,
        0x1bf32,
        0x1bf34,
        0x1bf4e,
        0x1bf5c,
        0x1bf62,
        0x1bf64,
        0x1bf68,
        0x1c09a,
        0x1c0b2,
        0x1c0b4,
        0x1c11a,
        0x1c132,
        0x1c134,
        0x1c162,
        0x1c164,
        0x1c168,
        0x1c176,
        0x1c1ba,
        0x1c21a,
        0x1c232,
        0x1c234,
        0x1c24e,
        0x1c25c,
        0x1c262,
        0x1c264,
        0x1c268,
        0x1c276,
        0x1c28e,
        0x1c2c2,
        0x1c2c4,
        0x1c2c8,
        0x1c2d0,
        0x1c2de,
        0x1c2e6,
        0x1c2ec,
        0x1c2fa,
        0x1c316,
        0x1c326,
        0x1c33a,
        0x1c346,
        0x1c34c,
        0x1c372,
        0x1c374,
        0x1c41a,
        0x1c42e,
        0x1c432,
        0x1c434,
        0x1c44e,
        0x1c45c,
        0x1c462,
        0x1c464,
        0x1c468,
        0x1c476,
        0x1c48e,
        0x1c49c,
        0x1c4b8,
        0x1c4c2,
        0x1c4c8,
        0x1c4d0,
        0x1c4de,
        0x1c4e6,
        0x1c4ec,
        0x1c4fa,
        0x1c51c,
        0x1c538,
        0x1c570,
        0x1c57e,
        0x1c582,
        0x1c584,
        0x1c588,
        0x1c590,
        0x1c59e,
        0x1c5a0,
        0x1c5bc,
        0x1c5c6,
        0x1c5cc,
        0x1c5d8,
        0x1c5ee,
        0x1c5f2,
        0x1c5f4,
        0x1c616,
        0x1c626,
        0x1c62c,
        0x1c63a,
        0x1c646,
        0x1c64c,
        0x1c658,
        0x1c66e,
        0x1c672,
        0x1c674,
        0x1c686,
        0x1c68c,
        0x1c698,
        0x1c6b0,
        0x1c6be,
        0x1c6ce,
        0x1c6dc,
        0x1c6e2,
        0x1c6e4,
        0x1c6e8,
        0x1c712,
        0x1c714,
        0x1c722,
        0x1c728,
        0x1c736,
        0x1c742,
        0x1c744,
        0x1c748,
        0x1c750,
        0x1c75e,
        0x1c766,
        0x1c76c,
        0x1c77a,
        0x1c7ae,
        0x1c7d6,
        0x1c7ea,
        0x1c81a,
        0x1c82e,
        0x1c832,
        0x1c834,
        0x1c84e,
        0x1c85c,
        0x1c862,
        0x1c864,
        0x1c868,
        0x1c876,
        0x1c88e,
        0x1c89c,
        0x1c8b8,
        0x1c8c2,
        0x1c8c8,
        0x1c8d0,
        0x1c8de,
        0x1c8e6,
        0x1c8ec,
        0x1c8fa,
        0x1c90e,
        0x1c938,
        0x1c970,
        0x1c97e,
        0x1c982,
        0x1c984,
        0x1c990,
        0x1c99e,
        0x1c9a0,
        0x1c9bc,
        0x1c9c6,
        0x1c9cc,
        0x1c9d8,
        0x1c9ee,
        0x1c9f2,
        0x1c9f4,
        0x1ca38,
        0x1ca70,
        0x1ca7e,
        0x1cae0,
        0x1cafc,
        0x1cb02,
        0x1cb04,
        0x1cb08,
        0x1cb10,
        0x1cb20,
        0x1cb3c,
        0x1cb40,
        0x1cb78,
        0x1cb86,
        0x1cb8c,
        0x1cb98,
        0x1cbb0,
        0x1cbbe,
        0x1cbce,
        0x1cbdc,
        0x1cbe2,
        0x1cbe4,
        0x1cbe8,
        0x1cbf6,
        0x1cc16,
        0x1cc26,
        0x1cc2c,
        0x1cc3a,
        0x1cc46,
        0x1cc58,
        0x1cc72,
        0x1cc74,
        0x1cc86,
        0x1ccb0,
        0x1ccbe,
        0x1ccce,
        0x1cce2,
        0x1cce4,
        0x1cce8,
        0x1cd06,
        0x1cd0c,
        0x1cd18,
        0x1cd30,
        0x1cd3e,
        0x1cd60,
        0x1cd7c,
        0x1cd9c,
        0x1cdc2,
        0x1cdc4,
        0x1cdc8,
        0x1cdd0,
        0x1cdde,
        0x1cde6,
        0x1cdfa,
        0x1ce22,
        0x1ce28,
        0x1ce42,
        0x1ce50,
        0x1ce5e,
        0x1ce66,
        0x1ce7a,
        0x1ce82,
        0x1ce84,
        0x1ce88,
        0x1ce90,
        0x1ce9e,
        0x1cea0,
        0x1cebc,
        0x1cecc,
        0x1cef2,
        0x1cef4,
        0x1cf2e,
        0x1cf32,
        0x1cf34,
        0x1cf4e,
        0x1cf5c,
        0x1cf62,
        0x1cf64,
        0x1cf68,
        0x1cf96,
        0x1cfa6,
        0x1cfac,
        0x1cfca,
        0x1cfd2,
        0x1cfd4,
        0x1d02e,
        0x1d032,
        0x1d034,
        0x1d04e,
        0x1d05c,
        0x1d062,
        0x1d064,
        0x1d068,
        0x1d076,
        0x1d08e,
        0x1d09c,
        0x1d0b8,
        0x1d0c2,
        0x1d0c4,
        0x1d0c8,
        0x1d0d0,
        0x1d0de,
        0x1d0e6,
        0x1d0ec,
        0x1d0fa,
        0x1d11c,
        0x1d138,
        0x1d170,
        0x1d17e,
        0x1d182,
        0x1d184,
        0x1d188,
        0x1d190,
        0x1d19e,
        0x1d1a0,
        0x1d1bc,
        0x1d1c6,
        0x1d1cc,
        0x1d1d8,
        0x1d1ee,
        0x1d1f2,
        0x1d1f4,
        0x1d21c,
        0x1d238,
        0x1d270,
        0x1d27e,
        0x1d2e0,
        0x1d2fc,
        0x1d302,
        0x1d304,
        0x1d308,
        0x1d310,
        0x1d31e,
        0x1d320,
        0x1d33c,
        0x1d340,
        0x1d378,
        0x1d386,
        0x1d38c,
        0x1d398,
        0x1d3b0,
        0x1d3be,
        0x1d3ce,
        0x1d3dc,
        0x1d3e2,
        0x1d3e4,
        0x1d3e8,
        0x1d3f6,
        0x1d470,
        0x1d47e,
        0x1d4e0,
        0x1d4fc,
        0x1d5c0,
        0x1d5f8,
        0x1d604,
        0x1d608,
        0x1d610,
        0x1d620,
        0x1d640,
        0x1d678,
        0x1d6f0,
        0x1d706,
        0x1d70c,
        0x1d718,
        0x1d730,
        0x1d73e,
        0x1d760,
        0x1d77c,
        0x1d78e,
        0x1d79c,
        0x1d7b8,
        0x1d7c2,
        0x1d7c4,
        0x1d7c8,
        0x1d7d0,
        0x1d7de,
        0x1d7e6,
        0x1d7ec,
        0x1d826,
        0x1d82c,
        0x1d83a,
        0x1d846,
        0x1d84c,
        0x1d858,
        0x1d872,
        0x1d874,
        0x1d886,
        0x1d88c,
        0x1d898,
        0x1d8b0,
        0x1d8be,
        0x1d8ce,
        0x1d8e2,
        0x1d8e4,
        0x1d8e8,
        0x1d8f6,
        0x1d90c,
        0x1d918,
        0x1d930,
        0x1d93e,
        0x1d960,
        0x1d97c,
        0x1d99c,
        0x1d9c2,
        0x1d9c4,
        0x1d9c8,
        0x1d9d0,
        0x1d9e6,
        0x1d9fa,
        0x1da0c,
        0x1da18,
        0x1da30,
        0x1da3e,
        0x1da60,
        0x1da7c,
        0x1dac0,
        0x1daf8,
        0x1db38,
        0x1db82,
        0x1db84,
        0x1db88,
        0x1db90,
        0x1db9e,
        0x1dba0,
        0x1dbcc,
        0x1dbf2,
        0x1dbf4,
        0x1dc22,
        0x1dc42,
        0x1dc44,
        0x1dc48,
        0x1dc50,
        0x1dc5e,
        0x1dc66,
        0x1dc7a,
        0x1dc82,
        0x1dc84,
        0x1dc88,
        0x1dc90,
        0x1dc9e,
        0x1dca0,
        0x1dcbc,
        0x1dccc,
        0x1dcf2,
        0x1dcf4,
        0x1dd04,
        0x1dd08,
        0x1dd10,
        0x1dd1e,
        0x1dd20,
        0x1dd3c,
        0x1dd40,
        0x1dd78,
        0x1dd86,
        0x1dd98,
        0x1ddce,
        0x1dde2,
        0x1dde4,
        0x1dde8,
        0x1de2e,
        0x1de32,
        0x1de34,
        0x1de4e,
        0x1de5c,
        0x1de62,
        0x1de64,
        0x1de68,
        0x1de8e,
        0x1de9c,
        0x1deb8,
        0x1dec2,
        0x1dec4,
        0x1dec8,
        0x1ded0,
        0x1dee6,
        0x1defa,
        0x1df16,
        0x1df26,
        0x1df2c,
        0x1df46,
        0x1df4c,
        0x1df58,
        0x1df72,
        0x1df74,
        0x1df8a,
        0x1df92,
        0x1df94,
        0x1dfa2,
        0x1dfa4,
        0x1dfa8,
        0x1e08a,
        0x1e092,
        0x1e094,
        0x1e0a2,
        0x1e0a4,
        0x1e0a8,
        0x1e0b6,
        0x1e0da,
        0x1e10a,
        0x1e112,
        0x1e114,
        0x1e122,
        0x1e124,
        0x1e128,
        0x1e136,
        0x1e142,
        0x1e144,
        0x1e148,
        0x1e150,
        0x1e166,
        0x1e16c,
        0x1e17a,
        0x1e19a,
        0x1e1b2,
        0x1e1b4,
        0x1e20a,
        0x1e212,
        0x1e214,
        0x1e222,
        0x1e224,
        0x1e228,
        0x1e236,
        0x1e242,
        0x1e248,
        0x1e250,
        0x1e25e,
        0x1e266,
        0x1e26c,
        0x1e27a,
        0x1e282,
        0x1e284,
        0x1e288,
        0x1e290,
        0x1e2a0,
        0x1e2bc,
        0x1e2c6,
        0x1e2cc,
        0x1e2d8,
        0x1e2ee,
        0x1e2f2,
        0x1e2f4,
        0x1e31a,
        0x1e332,
        0x1e334,
        0x1e35c,
        0x1e362,
        0x1e364,
        0x1e368,
        0x1e3ba,
        0x1e40a,
        0x1e412,
        0x1e414,
        0x1e422,
        0x1e428,
        0x1e436,
        0x1e442,
        0x1e448,
        0x1e450,
        0x1e45e,
        0x1e466,
        0x1e46c,
        0x1e47a,
        0x1e482,
        0x1e484,
        0x1e490,
        0x1e49e,
        0x1e4a0,
        0x1e4bc,
        0x1e4c6,
        0x1e4cc,
        0x1e4d8,
        0x1e4ee,
        0x1e4f2,
        0x1e4f4,
        0x1e502,
        0x1e504,
        0x1e508,
        0x1e510,
        0x1e51e,
        0x1e520,
        0x1e53c,
        0x1e540,
        0x1e578,
        0x1e586,
        0x1e58c,
        0x1e598,
        0x1e5b0,
        0x1e5be,
        0x1e5ce,
        0x1e5dc,
        0x1e5e2,
        0x1e5e4,
        0x1e5e8,
        0x1e5f6,
        0x1e61a,
        0x1e62e,
        0x1e632,
        0x1e634,
        0x1e64e,
        0x1e65c,
        0x1e662,
        0x1e668,
        0x1e68e,
        0x1e69c,
        0x1e6b8,
        0x1e6c2,
        0x1e6c4,
        0x1e6c8,
        0x1e6d0,
        0x1e6e6,
        0x1e6fa,
        0x1e716,
        0x1e726,
        0x1e72c,
        0x1e73a,
        0x1e746,
        0x1e74c,
        0x1e758,
        0x1e772,
        0x1e774,
        0x1e792,
        0x1e794,
        0x1e7a2,
        0x1e7a4,
        0x1e7a8,
        0x1e7b6,
        0x1e812,
        0x1e814,
        0x1e822,
        0x1e824,
        0x1e828,
        0x1e836,
        0x1e842,
        0x1e844,
        0x1e848,
        0x1e850,
        0x1e85e,
        0x1e866,
        0x1e86c,
        0x1e87a,
        0x1e882,
        0x1e884,
        0x1e888,
        0x1e890,
        0x1e89e,
        0x1e8a0,
        0x1e8bc,
        0x1e8c6,
        0x1e8cc,
        0x1e8d8,
        0x1e8ee,
        0x1e8f2,
        0x1e8f4,
        0x1e902,
        0x1e904,
        0x1e908,
        0x1e910,
        0x1e920,
        0x1e93c,
        0x1e940,
        0x1e978,
        0x1e986,
        0x1e98c,
        0x1e998,
        0x1e9b0,
        0x1e9be,
        0x1e9ce,
        0x1e9dc,
        0x1e9e2,
        0x1e9e4,
        0x1e9e8,
        0x1e9f6,
        0x1ea04,
        0x1ea08,
        0x1ea10,
        0x1ea20,
        0x1ea40,
        0x1ea78,
        0x1eaf0,
        0x1eb06,
        0x1eb0c,
        0x1eb18,
        0x1eb30,
        0x1eb3e,
        0x1eb60,
        0x1eb7c,
        0x1eb8e,
        0x1eb9c,
        0x1ebb8,
        0x1ebc2,
        0x1ebc4,
        0x1ebc8,
        0x1ebd0,
        0x1ebde,
        0x1ebe6,
        0x1ebec,
        0x1ec1a,
        0x1ec2e,
        0x1ec32,
        0x1ec34,
        0x1ec4e,
        0x1ec5c,
        0x1ec62,
        0x1ec64,
        0x1ec68,
        0x1ec8e,
        0x1ec9c,
        0x1ecb8,
        0x1ecc2,
        0x1ecc4,
        0x1ecc8,
        0x1ecd0,
        0x1ece6,
        0x1ecfa,
        0x1ed0e,
        0x1ed1c,
        0x1ed38,
        0x1ed70,
        0x1ed7e,
        0x1ed82,
        0x1ed84,
        0x1ed88,
        0x1ed90,
        0x1ed9e,
        0x1eda0,
        0x1edcc,
        0x1edf2,
        0x1edf4,
        0x1ee16,
        0x1ee26,
        0x1ee2c,
        0x1ee3a,
        0x1ee46,
        0x1ee4c,
        0x1ee58,
        0x1ee6e,
        0x1ee72,
        0x1ee74,
        0x1ee86,
        0x1ee8c,
        0x1ee98,
        0x1eeb0,
        0x1eebe,
        0x1eece,
        0x1eedc,
        0x1eee2,
        0x1eee4,
        0x1eee8,
        0x1ef12,
        0x1ef22,
        0x1ef24,
        0x1ef28,
        0x1ef36,
        0x1ef42,
        0x1ef44,
        0x1ef48,
        0x1ef50,
        0x1ef5e,
        0x1ef66,
        0x1ef6c,
        0x1ef7a,
        0x1efae,
        0x1efb2,
        0x1efb4,
        0x1efd6,
        0x1f096,
        0x1f0a6,
        0x1f0ac,
        0x1f0ba,
        0x1f0ca,
        0x1f0d2,
        0x1f0d4,
        0x1f116,
        0x1f126,
        0x1f12c,
        0x1f13a,
        0x1f146,
        0x1f14c,
        0x1f158,
        0x1f16e,
        0x1f172,
        0x1f174,
        0x1f18a,
        0x1f192,
        0x1f194,
        0x1f1a2,
        0x1f1a4,
        0x1f1a8,
        0x1f1da,
        0x1f216,
        0x1f226,
        0x1f22c,
        0x1f23a,
        0x1f246,
        0x1f258,
        0x1f26e,
        0x1f272,
        0x1f274,
        0x1f286,
        0x1f28c,
        0x1f298,
        0x1f2b0,
        0x1f2be,
        0x1f2ce,
        0x1f2dc,
        0x1f2e2,
        0x1f2e4,
        0x1f2e8,
        0x1f2f6,
        0x1f30a,
        0x1f312,
        0x1f314,
        0x1f322,
        0x1f328,
        0x1f342,
        0x1f344,
        0x1f348,
        0x1f350,
        0x1f35e,
        0x1f366,
        0x1f37a,
        0x1f39a,
        0x1f3ae,
        0x1f3b2,
        0x1f3b4,
        0x1f416,
        0x1f426,
        0x1f42c,
        0x1f43a,
        0x1f446,
        0x1f44c,
        0x1f458,
        0x1f46e,
        0x1f472,
        0x1f474,
        0x1f486,
        0x1f48c,
        0x1f498,
        0x1f4b0,
        0x1f4be,
        0x1f4ce,
        0x1f4dc,
        0x1f4e2,
        0x1f4e4,
        0x1f4e8,
        0x1f4f6,
        0x1f506,
        0x1f50c,
        0x1f518,
        0x1f530,
        0x1f53e,
        0x1f560,
        0x1f57c,
        0x1f58e,
        0x1f59c,
        0x1f5b8,
        0x1f5c2,
        0x1f5c4,
        0x1f5c8,
        0x1f5d0,
        0x1f5de,
        0x1f5e6,
        0x1f5ec,
        0x1f5fa,
        0x1f60a,
        0x1f612,
        0x1f614,
        0x1f622,
        0x1f624,
        0x1f628,
        0x1f636,
        0x1f642,
        0x1f644,
        0x1f648,
        0x1f650,
        0x1f65e,
        0x1f666,
        0x1f67a,
        0x1f682,
        0x1f684,
        0x1f688,
        0x1f690,
        0x1f69e,
        0x1f6a0,
        0x1f6bc,
        0x1f6cc,
        0x1f6f2,
        0x1f6f4,
        0x1f71a,
        0x1f72e,
        0x1f732,
        0x1f734,
        0x1f74e,
        0x1f75c,
        0x1f762,
        0x1f764,
        0x1f768,
        0x1f776,
        0x1f796,
        0x1f7a6,
        0x1f7ac,
        0x1f7ba,
        0x1f7d2,
        0x1f7d4,
        0x1f89a,
        0x1f8ae,
        0x1f8b2,
        0x1f8b4,
        0x1f8d6,
        0x1f8ea,
        0x1f91a,
        0x1f92e,
        0x1f932,
        0x1f934,
        0x1f94e,
        0x1f95c,
        0x1f962,
        0x1f964,
        0x1f968,
        0x1f976,
        0x1f996,
        0x1f9a6,
        0x1f9ac,
        0x1f9ba,
        0x1f9ca,
        0x1f9d2,
        0x1f9d4,
        0x1fa1a,
        0x1fa2e,
        0x1fa32,
        0x1fa34,
        0x1fa4e,
        0x1fa5c,
        0x1fa62,
        0x1fa64,
        0x1fa68,
        0x1fa76,
        0x1fa8e,
        0x1fa9c,
        0x1fab8,
        0x1fac2,
        0x1fac4,
        0x1fac8,
        0x1fad0,
        0x1fade,
        0x1fae6,
        0x1faec,
        0x1fb16,
        0x1fb26,
        0x1fb2c,
        0x1fb3a,
        0x1fb46,
        0x1fb4c,
        0x1fb58,
        0x1fb6e,
        0x1fb72,
        0x1fb74,
        0x1fb8a,
        0x1fb92,
        0x1fb94,
        0x1fba2,
        0x1fba4,
        0x1fba8,
        0x1fbb6,
        0x1fbda
    ]);
    /**
     * This table contains to codewords for all symbols.
     */ PDF417Common.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2000,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1000,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]);
    return PDF417Common;
}();
var $43352c804aa61e30$export$2e2bcd8739ae039 = $43352c804aa61e30$var$PDF417Common;




/*
* Copyright 2009 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 


/*
* Copyright 2007 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // import java.util.List;
/**
 * @author Guenther Grau
 */ var $73bffb1c52041410$var$PDF417DetectorResult = /** @class */ function() {
    function PDF417DetectorResult(bits, points) {
        this.bits = bits;
        this.points = points;
    }
    PDF417DetectorResult.prototype.getBits = function() {
        return this.bits;
    };
    PDF417DetectorResult.prototype.getPoints = function() {
        return this.points;
    };
    return PDF417DetectorResult;
}();
var $73bffb1c52041410$export$2e2bcd8739ae039 = $73bffb1c52041410$var$PDF417DetectorResult;


var $50b4d6293d11c58b$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.Arrays;
// import java.util.List;
// import java.util.Map;
/**
 * <p>Encapsulates logic that can detect a PDF417 Code in an image, even if the
 * PDF417 Code is rotated or skewed, or partially obscured.</p>
 *
 * @author SITA Lab (kevin.osullivan@sita.aero)
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Guenther Grau
 */ var $50b4d6293d11c58b$var$Detector = /** @class */ function() {
    function Detector() {}
    /**
     * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
     *
     * @param image barcode image to decode
     * @param hints optional hints to detector
     * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
     * be found and returned
     * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
     * @throws NotFoundException if no PDF417 Code can be found
     */ Detector.detectMultiple = function(image, hints, multiple) {
        // TODO detection improvement, tryHarder could try several different luminance thresholds/blackpoints or even
        // different binarizers
        // boolean tryHarder = hints != null && hints.containsKey(DecodeHintType.TRY_HARDER);
        var bitMatrix = image.getBlackMatrix();
        var barcodeCoordinates = Detector.detect(multiple, bitMatrix);
        if (!barcodeCoordinates.length) {
            bitMatrix = bitMatrix.clone();
            bitMatrix.rotate180();
            barcodeCoordinates = Detector.detect(multiple, bitMatrix);
        }
        return new (0, $73bffb1c52041410$export$2e2bcd8739ae039)(bitMatrix, barcodeCoordinates);
    };
    /**
     * Detects PDF417 codes in an image. Only checks 0 degree rotation
     * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
     * be found and returned
     * @param bitMatrix bit matrix to detect barcodes in
     * @return List of ResultPoint arrays containing the coordinates of found barcodes
     */ Detector.detect = function(multiple, bitMatrix) {
        var e_1, _a;
        var barcodeCoordinates = new Array();
        var row = 0;
        var column = 0;
        var foundBarcodeInRow = false;
        while(row < bitMatrix.getHeight()){
            var vertices = Detector.findVertices(bitMatrix, row, column);
            if (vertices[0] == null && vertices[3] == null) {
                if (!foundBarcodeInRow) break;
                // we didn't find a barcode starting at the given column and row. Try again from the first column and slightly
                // below the lowest barcode we found so far.
                foundBarcodeInRow = false;
                column = 0;
                try {
                    for(var barcodeCoordinates_1 = (e_1 = void 0, $50b4d6293d11c58b$var$__values(barcodeCoordinates)), barcodeCoordinates_1_1 = barcodeCoordinates_1.next(); !barcodeCoordinates_1_1.done; barcodeCoordinates_1_1 = barcodeCoordinates_1.next()){
                        var barcodeCoordinate = barcodeCoordinates_1_1.value;
                        if (barcodeCoordinate[1] != null) row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
                        if (barcodeCoordinate[3] != null) row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (barcodeCoordinates_1_1 && !barcodeCoordinates_1_1.done && (_a = barcodeCoordinates_1.return)) _a.call(barcodeCoordinates_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                row += Detector.ROW_STEP;
                continue;
            }
            foundBarcodeInRow = true;
            barcodeCoordinates.push(vertices);
            if (!multiple) break;
            // if we didn't find a right row indicator column, then continue the search for the next barcode after the
            // start pattern of the barcode just found.
            if (vertices[2] != null) {
                column = Math.trunc(vertices[2].getX());
                row = Math.trunc(vertices[2].getY());
            } else {
                column = Math.trunc(vertices[4].getX());
                row = Math.trunc(vertices[4].getY());
            }
        }
        return barcodeCoordinates;
    };
    /**
     * Locate the vertices and the codewords area of a black blob using the Start
     * and Stop patterns as locators.
     *
     * @param matrix the scanned barcode image.
     * @return an array containing the vertices:
     *           vertices[0] x, y top left barcode
     *           vertices[1] x, y bottom left barcode
     *           vertices[2] x, y top right barcode
     *           vertices[3] x, y bottom right barcode
     *           vertices[4] x, y top left codeword area
     *           vertices[5] x, y bottom left codeword area
     *           vertices[6] x, y top right codeword area
     *           vertices[7] x, y bottom right codeword area
     */ Detector.findVertices = function(matrix, startRow, startColumn) {
        var height = matrix.getHeight();
        var width = matrix.getWidth();
        // const result = new ResultPoint[8];
        var result = new Array(8);
        Detector.copyToResult(result, Detector.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector.START_PATTERN), Detector.INDEXES_START_PATTERN);
        if (result[4] != null) {
            startColumn = Math.trunc(result[4].getX());
            startRow = Math.trunc(result[4].getY());
        }
        Detector.copyToResult(result, Detector.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector.STOP_PATTERN), Detector.INDEXES_STOP_PATTERN);
        return result;
    };
    Detector.copyToResult = function(result, tmpResult, destinationIndexes) {
        for(var i = 0; i < destinationIndexes.length; i++)result[destinationIndexes[i]] = tmpResult[i];
    };
    Detector.findRowsWithPattern = function(matrix, height, width, startRow, startColumn, pattern) {
        // const result = new ResultPoint[4];
        var result = new Array(4);
        var found = false;
        var counters = new Int32Array(pattern.length);
        for(; startRow < height; startRow += Detector.ROW_STEP){
            var loc = Detector.findGuardPattern(matrix, startColumn, startRow, width, false, pattern, counters);
            if (loc != null) {
                while(startRow > 0){
                    var previousRowLoc = Detector.findGuardPattern(matrix, startColumn, --startRow, width, false, pattern, counters);
                    if (previousRowLoc != null) loc = previousRowLoc;
                    else {
                        startRow++;
                        break;
                    }
                }
                result[0] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(loc[0], startRow);
                result[1] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(loc[1], startRow);
                found = true;
                break;
            }
        }
        var stopRow = startRow + 1;
        // Last row of the current symbol that contains pattern
        if (found) {
            var skippedRowCount = 0;
            var previousRowLoc = Int32Array.from([
                Math.trunc(result[0].getX()),
                Math.trunc(result[1].getX())
            ]);
            for(; stopRow < height; stopRow++){
                var loc = Detector.findGuardPattern(matrix, previousRowLoc[0], stopRow, width, false, pattern, counters);
                // a found pattern is only considered to belong to the same barcode if the start and end positions
                // don't differ too much. Pattern drift should be not bigger than two for consecutive rows. With
                // a higher number of skipped rows drift could be larger. To keep it simple for now, we allow a slightly
                // larger drift and don't check for skipped rows.
                if (loc != null && Math.abs(previousRowLoc[0] - loc[0]) < Detector.MAX_PATTERN_DRIFT && Math.abs(previousRowLoc[1] - loc[1]) < Detector.MAX_PATTERN_DRIFT) {
                    previousRowLoc = loc;
                    skippedRowCount = 0;
                } else {
                    if (skippedRowCount > Detector.SKIPPED_ROW_COUNT_MAX) break;
                    else skippedRowCount++;
                }
            }
            stopRow -= skippedRowCount + 1;
            result[2] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(previousRowLoc[0], stopRow);
            result[3] = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(previousRowLoc[1], stopRow);
        }
        if (stopRow - startRow < Detector.BARCODE_MIN_HEIGHT) (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(result, null);
        return result;
    };
    /**
     * @param matrix row of black/white values to search
     * @param column x position to start search
     * @param row y position to start search
     * @param width the number of pixels to search on this row
     * @param pattern pattern of counts of number of black and white pixels that are
     *                 being searched for as a pattern
     * @param counters array of counters, as long as pattern, to re-use
     * @return start/end horizontal offset of guard pattern, as an array of two ints.
     */ Detector.findGuardPattern = function(matrix, column, row, width, whiteFirst, pattern, counters) {
        (0, $eed4834329730fe6$export$2e2bcd8739ae039).fillWithin(counters, 0, counters.length, 0);
        var patternStart = column;
        var pixelDrift = 0;
        // if there are black pixels left of the current pixel shift to the left, but only for MAX_PIXEL_DRIFT pixels
        while(matrix.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector.MAX_PIXEL_DRIFT)patternStart--;
        var x = patternStart;
        var counterPosition = 0;
        var patternLength = pattern.length;
        for(var isWhite = whiteFirst; x < width; x++){
            var pixel = matrix.get(x, row);
            if (pixel !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (Detector.patternMatchVariance(counters, pattern, Detector.MAX_INDIVIDUAL_VARIANCE) < Detector.MAX_AVG_VARIANCE) return new Int32Array([
                        patternStart,
                        x
                    ]);
                    patternStart += counters[0] + counters[1];
                    (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(counters, 2, counters, 0, counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
        }
        if (counterPosition === patternLength - 1 && Detector.patternMatchVariance(counters, pattern, Detector.MAX_INDIVIDUAL_VARIANCE) < Detector.MAX_AVG_VARIANCE) return new Int32Array([
            patternStart,
            x - 1
        ]);
        return null;
    };
    /**
     * Determines how closely a set of observed counts of runs of black/white
     * values matches a given target pattern. This is reported as the ratio of
     * the total variance from the expected pattern proportions across all
     * pattern elements, to the length of the pattern.
     *
     * @param counters observed counters
     * @param pattern expected pattern
     * @param maxIndividualVariance The most any counter can differ before we give up
     * @return ratio of total variance between counters and pattern compared to total pattern size
     */ Detector.patternMatchVariance = function(counters, pattern, maxIndividualVariance) {
        var numCounters = counters.length;
        var total = 0;
        var patternLength = 0;
        for(var i = 0; i < numCounters; i++){
            total += counters[i];
            patternLength += pattern[i];
        }
        if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this
        // is too small to reliably match, so fail:
        return /*Float.POSITIVE_INFINITY*/ Infinity;
        // We're going to fake floating-point math in integers. We just need to use more bits.
        // Scale up patternLength so that intermediate values below like scaledCounter will have
        // more "significant digits".
        var unitBarWidth = total / patternLength;
        maxIndividualVariance *= unitBarWidth;
        var totalVariance = 0.0;
        for(var x = 0; x < numCounters; x++){
            var counter = counters[x];
            var scaledPattern = pattern[x] * unitBarWidth;
            var variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
            if (variance > maxIndividualVariance) return /*Float.POSITIVE_INFINITY*/ Infinity;
            totalVariance += variance;
        }
        return totalVariance / total;
    };
    Detector.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]);
    Detector.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]);
    Detector.MAX_AVG_VARIANCE = 0.42;
    Detector.MAX_INDIVIDUAL_VARIANCE = 0.8;
    // B S B S B S B S Bar/Space pattern
    // 11111111 0 1 0 1 0 1 000
    Detector.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]);
    // 1111111 0 1 000 1 0 1 00 1
    Detector.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]);
    Detector.MAX_PIXEL_DRIFT = 3;
    Detector.MAX_PATTERN_DRIFT = 5;
    // if we set the value too low, then we don't detect the correct height of the bar if the start patterns are damaged.
    // if we set the value too high, then we might detect the start pattern from a neighbor barcode.
    Detector.SKIPPED_ROW_COUNT_MAX = 25;
    // A PDF471 barcode should have at least 3 rows, with each row being >= 3 times the module width. Therefore it should be at least
    // 9 pixels tall. To be conservative, we use about half the size to ensure we don't miss it.
    Detector.ROW_STEP = 5;
    Detector.BARCODE_MIN_HEIGHT = 10;
    return Detector;
}();
var $50b4d6293d11c58b$export$2e2bcd8739ae039 = $50b4d6293d11c58b$var$Detector;


/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 




/*
* Copyright 2012 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
/*
* Copyright 2012 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 


var $bf125e0c89e9880f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Sean Owen
 * @see com.google.zxing.common.reedsolomon.GenericGFPoly
 */ var $bf125e0c89e9880f$var$ModulusPoly = /** @class */ function() {
    function ModulusPoly(field, coefficients) {
        if (coefficients.length === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        this.field = field;
        var coefficientsLength = /*int*/ coefficients.length;
        if (coefficientsLength > 1 && coefficients[0] === 0) {
            // Leading term must be non-zero for anything except the constant polynomial "0"
            var firstNonZero = /*int*/ 1;
            while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
            if (firstNonZero === coefficientsLength) this.coefficients = new Int32Array([
                0
            ]);
            else {
                this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
            }
        } else this.coefficients = coefficients;
    }
    ModulusPoly.prototype.getCoefficients = function() {
        return this.coefficients;
    };
    /**
     * @return degree of this polynomial
     */ ModulusPoly.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    };
    /**
     * @return true iff this polynomial is the monomial "0"
     */ ModulusPoly.prototype.isZero = function() {
        return this.coefficients[0] === 0;
    };
    /**
     * @return coefficient of x^degree term in this polynomial
     */ ModulusPoly.prototype.getCoefficient = function(degree) {
        return this.coefficients[this.coefficients.length - 1 - degree];
    };
    /**
     * @return evaluation of this polynomial at a given point
     */ ModulusPoly.prototype.evaluateAt = function(a) {
        var e_1, _a;
        if (a === 0) // Just return the x^0 coefficient
        return this.getCoefficient(0);
        if (a === 1) {
            // Just the sum of the coefficients
            var sum = /*int*/ 0;
            try {
                for(var _b = $bf125e0c89e9880f$var$__values(this.coefficients), _c = _b.next(); !_c.done; _c = _b.next()){
                    var coefficient = _c.value /*int*/ ;
                    sum = this.field.add(sum, coefficient);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return sum;
        }
        var result = /*int*/ this.coefficients[0];
        var size = /*int*/ this.coefficients.length;
        for(var i /*int*/  = 1; i < size; i++)result = this.field.add(this.field.multiply(a, result), this.coefficients[i]);
        return result;
    };
    ModulusPoly.prototype.add = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return other;
        if (other.isZero()) return this;
        var smallerCoefficients = this.coefficients;
        var largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) {
            var temp = smallerCoefficients;
            smallerCoefficients = largerCoefficients;
            largerCoefficients = temp;
        }
        var sumDiff = new Int32Array(largerCoefficients.length);
        var lengthDiff = /*int*/ largerCoefficients.length - smallerCoefficients.length;
        // Copy high-order terms only found in higher-degree polynomial's coefficients
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
        for(var i /*int*/  = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = this.field.add(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
        return new ModulusPoly(this.field, sumDiff);
    };
    ModulusPoly.prototype.subtract = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("ModulusPolys do not have same ModulusGF field");
        if (other.isZero()) return this;
        return this.add(other.negative());
    };
    ModulusPoly.prototype.multiply = function(other) {
        if (other instanceof ModulusPoly) return this.multiplyOther(other);
        return this.multiplyScalar(other);
    };
    ModulusPoly.prototype.multiplyOther = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || other.isZero()) // return this.field.getZero();
        return new ModulusPoly(this.field, new Int32Array([
            0
        ]));
        var aCoefficients = this.coefficients;
        var aLength = /*int*/ aCoefficients.length;
        var bCoefficients = other.coefficients;
        var bLength = /*int*/ bCoefficients.length;
        var product = new Int32Array(aLength + bLength - 1);
        for(var i /*int*/  = 0; i < aLength; i++){
            var aCoeff = /*int*/ aCoefficients[i];
            for(var j /*int*/  = 0; j < bLength; j++)product[i + j] = this.field.add(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
        }
        return new ModulusPoly(this.field, product);
    };
    ModulusPoly.prototype.negative = function() {
        var size = /*int*/ this.coefficients.length;
        var negativeCoefficients = new Int32Array(size);
        for(var i /*int*/  = 0; i < size; i++)negativeCoefficients[i] = this.field.subtract(0, this.coefficients[i]);
        return new ModulusPoly(this.field, negativeCoefficients);
    };
    ModulusPoly.prototype.multiplyScalar = function(scalar) {
        if (scalar === 0) return new ModulusPoly(this.field, new Int32Array([
            0
        ]));
        if (scalar === 1) return this;
        var size = /*int*/ this.coefficients.length;
        var product = new Int32Array(size);
        for(var i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
        return new ModulusPoly(this.field, product);
    };
    ModulusPoly.prototype.multiplyByMonomial = function(degree, coefficient) {
        if (degree < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        if (coefficient === 0) return new ModulusPoly(this.field, new Int32Array([
            0
        ]));
        var size = /*int*/ this.coefficients.length;
        var product = new Int32Array(size + degree);
        for(var i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
        return new ModulusPoly(this.field, product);
    };
    /*
    ModulusPoly[] divide(other: ModulusPoly) {
      if (!field.equals(other.field)) {
        throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
      }
      if (other.isZero()) {
        throw new IllegalArgumentException("Divide by 0");
      }
  
      let quotient: ModulusPoly = field.getZero();
      let remainder: ModulusPoly = this;
  
      let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
      let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
  
      while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
        let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
        let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
        let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
        let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
        quotient = quotient.add(iterationQuotient);
        remainder = remainder.subtract(term);
      }
  
      return new ModulusPoly[] { quotient, remainder };
    }
    */ // @Override
    ModulusPoly.prototype.toString = function() {
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)(); // dynamic string size in JS
        for(var degree /*int*/  = this.getDegree(); degree >= 0; degree--){
            var coefficient = /*int*/ this.getCoefficient(degree);
            if (coefficient !== 0) {
                if (coefficient < 0) {
                    result.append(" - ");
                    coefficient = -coefficient;
                } else if (result.length() > 0) result.append(" + ");
                if (degree === 0 || coefficient !== 1) result.append(coefficient);
                if (degree !== 0) {
                    if (degree === 1) result.append("x");
                    else {
                        result.append("x^");
                        result.append(degree);
                    }
                }
            }
        }
        return result.toString();
    };
    return ModulusPoly;
}();
var $bf125e0c89e9880f$export$2e2bcd8739ae039 = $bf125e0c89e9880f$var$ModulusPoly;


/*
 * Copyright 2012 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 




var $3616f686fc0168bb$var$ModulusBase = /** @class */ function() {
    function ModulusBase() {}
    ModulusBase.prototype.add = function(a, b) {
        return (a + b) % this.modulus;
    };
    ModulusBase.prototype.subtract = function(a, b) {
        return (this.modulus + a - b) % this.modulus;
    };
    ModulusBase.prototype.exp = function(a) {
        return this.expTable[a];
    };
    ModulusBase.prototype.log = function(a) {
        if (a === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        return this.logTable[a];
    };
    ModulusBase.prototype.inverse = function(a) {
        if (a === 0) throw new (0, $c8dc29a1cba9dc67$export$2e2bcd8739ae039)();
        return this.expTable[this.modulus - this.logTable[a] - 1];
    };
    ModulusBase.prototype.multiply = function(a, b) {
        if (a === 0 || b === 0) return 0;
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
    };
    ModulusBase.prototype.getSize = function() {
        return this.modulus;
    };
    ModulusBase.prototype.equals = function(o) {
        return o === this;
    };
    return ModulusBase;
}();
var $3616f686fc0168bb$export$2e2bcd8739ae039 = $3616f686fc0168bb$var$ModulusBase;


var $f29940b440fb8b1a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>A field based on powers of a generator integer, modulo some modulus.</p>
 *
 * @author Sean Owen
 * @see com.google.zxing.common.reedsolomon.GenericGF
 */ var $f29940b440fb8b1a$var$ModulusGF = /** @class */ function(_super) {
    $f29940b440fb8b1a$var$__extends(ModulusGF, _super);
    // private /*final*/ modulus: /*int*/ number;
    function ModulusGF(modulus, generator) {
        var _this = _super.call(this) || this;
        _this.modulus = modulus;
        _this.expTable = new Int32Array(modulus);
        _this.logTable = new Int32Array(modulus);
        var x = /*int*/ 1;
        for(var i /*int*/  = 0; i < modulus; i++){
            _this.expTable[i] = x;
            x = x * generator % modulus;
        }
        for(var i /*int*/  = 0; i < modulus - 1; i++)_this.logTable[_this.expTable[i]] = i;
        // logTable[0] == 0 but this should never be used
        _this.zero = new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(_this, new Int32Array([
            0
        ]));
        _this.one = new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(_this, new Int32Array([
            1
        ]));
        return _this;
    }
    ModulusGF.prototype.getZero = function() {
        return this.zero;
    };
    ModulusGF.prototype.getOne = function() {
        return this.one;
    };
    ModulusGF.prototype.buildMonomial = function(degree, coefficient) {
        if (degree < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)();
        if (coefficient === 0) return this.zero;
        var coefficients = new Int32Array(degree + 1);
        coefficients[0] = coefficient;
        return new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(this, coefficients);
    };
    ModulusGF.PDF417_GF = new ModulusGF((0, $43352c804aa61e30$export$2e2bcd8739ae039).NUMBER_OF_CODEWORDS, 3);
    return ModulusGF;
}((0, $3616f686fc0168bb$export$2e2bcd8739ae039));
var $f29940b440fb8b1a$export$2e2bcd8739ae039 = $f29940b440fb8b1a$var$ModulusGF;


var $21b4ed341b0ece94$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>PDF417 error correction implementation.</p>
 *
 * <p>This <a href="http://en.wikipedia.org/wiki/Reed%E2%80%93Solomon_error_correction#Example">example</a>
 * is quite useful in understanding the algorithm.</p>
 *
 * @author Sean Owen
 * @see com.google.zxing.common.reedsolomon.ReedSolomonDecoder
 */ var $21b4ed341b0ece94$var$ErrorCorrection = /** @class */ function() {
    function ErrorCorrection() {
        this.field = (0, $f29940b440fb8b1a$export$2e2bcd8739ae039).PDF417_GF;
    }
    /**
     * @param received received codewords
     * @param numECCodewords number of those codewords used for EC
     * @param erasures location of erasures
     * @return number of errors
     * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
     */ ErrorCorrection.prototype.decode = function(received, numECCodewords, erasures) {
        var e_1, _a;
        var poly = new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(this.field, received);
        var S = new Int32Array(numECCodewords);
        var error = false;
        for(var i /*int*/  = numECCodewords; i > 0; i--){
            var evaluation = poly.evaluateAt(this.field.exp(i));
            S[numECCodewords - i] = evaluation;
            if (evaluation !== 0) error = true;
        }
        if (!error) return 0;
        var knownErrors = this.field.getOne();
        if (erasures != null) try {
            for(var erasures_1 = $21b4ed341b0ece94$var$__values(erasures), erasures_1_1 = erasures_1.next(); !erasures_1_1.done; erasures_1_1 = erasures_1.next()){
                var erasure = erasures_1_1.value;
                var b = this.field.exp(received.length - 1 - erasure);
                // Add (1 - bx) term:
                var term = new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(this.field, new Int32Array([
                    this.field.subtract(0, b),
                    1
                ]));
                knownErrors = knownErrors.multiply(term);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (erasures_1_1 && !erasures_1_1.done && (_a = erasures_1.return)) _a.call(erasures_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var syndrome = new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(this.field, S);
        // syndrome = syndrome.multiply(knownErrors);
        var sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
        var sigma = sigmaOmega[0];
        var omega = sigmaOmega[1];
        // sigma = sigma.multiply(knownErrors);
        var errorLocations = this.findErrorLocations(sigma);
        var errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
        for(var i /*int*/  = 0; i < errorLocations.length; i++){
            var position = received.length - 1 - this.field.log(errorLocations[i]);
            if (position < 0) throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
            received[position] = this.field.subtract(received[position], errorMagnitudes[i]);
        }
        return errorLocations.length;
    };
    /**
     *
     * @param ModulusPoly
     * @param a
     * @param ModulusPoly
     * @param b
     * @param int
     * @param R
     * @throws ChecksumException
     */ ErrorCorrection.prototype.runEuclideanAlgorithm = function(a, b, R) {
        // Assume a's degree is >= b's
        if (a.getDegree() < b.getDegree()) {
            var temp = a;
            a = b;
            b = temp;
        }
        var rLast = a;
        var r = b;
        var tLast = this.field.getZero();
        var t = this.field.getOne();
        // Run Euclidean algorithm until r's degree is less than R/2
        while(r.getDegree() >= Math.round(R / 2)){
            var rLastLast = rLast;
            var tLastLast = tLast;
            rLast = r;
            tLast = t;
            // Divide rLastLast by rLast, with quotient in q and remainder in r
            if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
            throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
            r = rLastLast;
            var q = this.field.getZero();
            var denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
            var dltInverse = this.field.inverse(denominatorLeadingTerm);
            while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                var degreeDiff = r.getDegree() - rLast.getDegree();
                var scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                q = q.add(this.field.buildMonomial(degreeDiff, scale));
                r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
            }
            t = q.multiply(tLast).subtract(tLastLast).negative();
        }
        var sigmaTildeAtZero = t.getCoefficient(0);
        if (sigmaTildeAtZero === 0) throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
        var inverse = this.field.inverse(sigmaTildeAtZero);
        var sigma = t.multiply(inverse);
        var omega = r.multiply(inverse);
        return [
            sigma,
            omega
        ];
    };
    /**
     *
     * @param errorLocator
     * @throws ChecksumException
     */ ErrorCorrection.prototype.findErrorLocations = function(errorLocator) {
        // This is a direct application of Chien's search
        var numErrors = errorLocator.getDegree();
        var result = new Int32Array(numErrors);
        var e = 0;
        for(var i /*int*/  = 1; i < this.field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
            result[e] = this.field.inverse(i);
            e++;
        }
        if (e !== numErrors) throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
        return result;
    };
    ErrorCorrection.prototype.findErrorMagnitudes = function(errorEvaluator, errorLocator, errorLocations) {
        var errorLocatorDegree = errorLocator.getDegree();
        var formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
        for(var i /*int*/  = 1; i <= errorLocatorDegree; i++)formalDerivativeCoefficients[errorLocatorDegree - i] = this.field.multiply(i, errorLocator.getCoefficient(i));
        var formalDerivative = new (0, $bf125e0c89e9880f$export$2e2bcd8739ae039)(this.field, formalDerivativeCoefficients);
        // This is directly applying Forney's Formula
        var s = errorLocations.length;
        var result = new Int32Array(s);
        for(var i /*int*/  = 0; i < s; i++){
            var xiInverse = this.field.inverse(errorLocations[i]);
            var numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
            var denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
            result[i] = this.field.multiply(numerator, denominator);
        }
        return result;
    };
    return ErrorCorrection;
}();
var $21b4ed341b0ece94$export$2e2bcd8739ae039 = $21b4ed341b0ece94$var$ErrorCorrection;


/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.pdf417.decoder;
// import com.google.zxing.NotFoundException;


/**
 * @author Guenther Grau
 */ var $8c5449399ae5c377$var$BoundingBox = /** @class */ function() {
    function BoundingBox(image, topLeft, bottomLeft, topRight, bottomRight) {
        if (image instanceof BoundingBox) this.constructor_2(image);
        else this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
    }
    /**
     *
     * @param image
     * @param topLeft
     * @param bottomLeft
     * @param topRight
     * @param bottomRight
     *
     * @throws NotFoundException
     */ BoundingBox.prototype.constructor_1 = function(image, topLeft, bottomLeft, topRight, bottomRight) {
        var leftUnspecified = topLeft == null || bottomLeft == null;
        var rightUnspecified = topRight == null || bottomRight == null;
        if (leftUnspecified && rightUnspecified) throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)();
        if (leftUnspecified) {
            topLeft = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(0, topRight.getY());
            bottomLeft = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(0, bottomRight.getY());
        } else if (rightUnspecified) {
            topRight = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(image.getWidth() - 1, topLeft.getY());
            bottomRight = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(image.getWidth() - 1, bottomLeft.getY());
        }
        this.image = image;
        this.topLeft = topLeft;
        this.bottomLeft = bottomLeft;
        this.topRight = topRight;
        this.bottomRight = bottomRight;
        this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
        this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
        this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
        this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
    };
    BoundingBox.prototype.constructor_2 = function(boundingBox) {
        this.image = boundingBox.image;
        this.topLeft = boundingBox.getTopLeft();
        this.bottomLeft = boundingBox.getBottomLeft();
        this.topRight = boundingBox.getTopRight();
        this.bottomRight = boundingBox.getBottomRight();
        this.minX = boundingBox.getMinX();
        this.maxX = boundingBox.getMaxX();
        this.minY = boundingBox.getMinY();
        this.maxY = boundingBox.getMaxY();
    };
    /**
     * @throws NotFoundException
     */ BoundingBox.merge = function(leftBox, rightBox) {
        if (leftBox == null) return rightBox;
        if (rightBox == null) return leftBox;
        return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
    };
    /**
     * @throws NotFoundException
     */ BoundingBox.prototype.addMissingRows = function(missingStartRows, missingEndRows, isLeft) {
        var newTopLeft = this.topLeft;
        var newBottomLeft = this.bottomLeft;
        var newTopRight = this.topRight;
        var newBottomRight = this.bottomRight;
        if (missingStartRows > 0) {
            var top_1 = isLeft ? this.topLeft : this.topRight;
            var newMinY = Math.trunc(top_1.getY() - missingStartRows);
            if (newMinY < 0) newMinY = 0;
            var newTop = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(top_1.getX(), newMinY);
            if (isLeft) newTopLeft = newTop;
            else newTopRight = newTop;
        }
        if (missingEndRows > 0) {
            var bottom = isLeft ? this.bottomLeft : this.bottomRight;
            var newMaxY = Math.trunc(bottom.getY() + missingEndRows);
            if (newMaxY >= this.image.getHeight()) newMaxY = this.image.getHeight() - 1;
            var newBottom = new (0, $e9ec26965ff3031c$export$2e2bcd8739ae039)(bottom.getX(), newMaxY);
            if (isLeft) newBottomLeft = newBottom;
            else newBottomRight = newBottom;
        }
        return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
    };
    BoundingBox.prototype.getMinX = function() {
        return this.minX;
    };
    BoundingBox.prototype.getMaxX = function() {
        return this.maxX;
    };
    BoundingBox.prototype.getMinY = function() {
        return this.minY;
    };
    BoundingBox.prototype.getMaxY = function() {
        return this.maxY;
    };
    BoundingBox.prototype.getTopLeft = function() {
        return this.topLeft;
    };
    BoundingBox.prototype.getTopRight = function() {
        return this.topRight;
    };
    BoundingBox.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    };
    BoundingBox.prototype.getBottomRight = function() {
        return this.bottomRight;
    };
    return BoundingBox;
}();
var $8c5449399ae5c377$export$2e2bcd8739ae039 = $8c5449399ae5c377$var$BoundingBox;


/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417.decoder;
/**
 * @author Guenther Grau
 */ var $6f2d2bc17051afa6$var$BarcodeMetadata = /** @class */ function() {
    function BarcodeMetadata(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel) {
        this.columnCount = columnCount;
        this.errorCorrectionLevel = errorCorrectionLevel;
        this.rowCountUpperPart = rowCountUpperPart;
        this.rowCountLowerPart = rowCountLowerPart;
        this.rowCount = rowCountUpperPart + rowCountLowerPart;
    }
    BarcodeMetadata.prototype.getColumnCount = function() {
        return this.columnCount;
    };
    BarcodeMetadata.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    };
    BarcodeMetadata.prototype.getRowCount = function() {
        return this.rowCount;
    };
    BarcodeMetadata.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    };
    BarcodeMetadata.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    };
    return BarcodeMetadata;
}();
var $6f2d2bc17051afa6$export$2e2bcd8739ae039 = $6f2d2bc17051afa6$var$BarcodeMetadata;


/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Java Formatter class polyfill that works in the JS way.
 */ var $d7946609c4ff0191$var$Formatter = /** @class */ function() {
    function Formatter() {
        this.buffer = "";
    }
    /**
     *
     * @see https://stackoverflow.com/a/13439711/4367683
     *
     * @param str
     * @param arr
     */ Formatter.form = function(str, arr) {
        var i = -1;
        function callback(exp, p0, p1, p2, p3, p4) {
            if (exp === "%%") return "%";
            if (arr[++i] === undefined) return undefined;
            exp = p2 ? parseInt(p2.substr(1)) : undefined;
            var base = p3 ? parseInt(p3.substr(1)) : undefined;
            var val;
            switch(p4){
                case "s":
                    val = arr[i];
                    break;
                case "c":
                    val = arr[i][0];
                    break;
                case "f":
                    val = parseFloat(arr[i]).toFixed(exp);
                    break;
                case "p":
                    val = parseFloat(arr[i]).toPrecision(exp);
                    break;
                case "e":
                    val = parseFloat(arr[i]).toExponential(exp);
                    break;
                case "x":
                    val = parseInt(arr[i]).toString(base ? base : 16);
                    break;
                case "d":
                    val = parseFloat(parseInt(arr[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                    break;
            }
            val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
            var size = parseInt(p1); /* padding size */ 
            var ch = p1 && p1[0] + "" === "0" ? "0" : " "; /* isnull? */ 
            while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
            return val;
        }
        var regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return str.replace(regex, callback);
    };
    /**
     *
     * @param append The new string to append.
     * @param args Argumets values to be formated.
     */ Formatter.prototype.format = function(append) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        this.buffer += Formatter.form(append, args);
    };
    /**
     * Returns the Formatter string value.
     */ Formatter.prototype.toString = function() {
        return this.buffer;
    };
    return Formatter;
}();
var $d7946609c4ff0191$export$2e2bcd8739ae039 = $d7946609c4ff0191$var$Formatter;



var $1abaf97de2742615$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Guenther Grau
 */ var $1abaf97de2742615$var$DetectionResultColumn = /** @class */ function() {
    function DetectionResultColumn(boundingBox) {
        this.boundingBox = new (0, $8c5449399ae5c377$export$2e2bcd8739ae039)(boundingBox);
        // this.codewords = new Codeword[boundingBox.getMaxY() - boundingBox.getMinY() + 1];
        this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
    }
    /*final*/ DetectionResultColumn.prototype.getCodewordNearby = function(imageRow) {
        var codeword = this.getCodeword(imageRow);
        if (codeword != null) return codeword;
        for(var i = 1; i < DetectionResultColumn.MAX_NEARBY_DISTANCE; i++){
            var nearImageRow = this.imageRowToCodewordIndex(imageRow) - i;
            if (nearImageRow >= 0) {
                codeword = this.codewords[nearImageRow];
                if (codeword != null) return codeword;
            }
            nearImageRow = this.imageRowToCodewordIndex(imageRow) + i;
            if (nearImageRow < this.codewords.length) {
                codeword = this.codewords[nearImageRow];
                if (codeword != null) return codeword;
            }
        }
        return null;
    };
    /*final int*/ DetectionResultColumn.prototype.imageRowToCodewordIndex = function(imageRow) {
        return imageRow - this.boundingBox.getMinY();
    };
    /*final void*/ DetectionResultColumn.prototype.setCodeword = function(imageRow, codeword) {
        this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
    };
    /*final*/ DetectionResultColumn.prototype.getCodeword = function(imageRow) {
        return this.codewords[this.imageRowToCodewordIndex(imageRow)];
    };
    /*final*/ DetectionResultColumn.prototype.getBoundingBox = function() {
        return this.boundingBox;
    };
    /*final*/ DetectionResultColumn.prototype.getCodewords = function() {
        return this.codewords;
    };
    // @Override
    DetectionResultColumn.prototype.toString = function() {
        var e_1, _a;
        var formatter = new (0, $d7946609c4ff0191$export$2e2bcd8739ae039)();
        var row = 0;
        try {
            for(var _b = $1abaf97de2742615$var$__values(this.codewords), _c = _b.next(); !_c.done; _c = _b.next()){
                var codeword = _c.value;
                if (codeword == null) {
                    formatter.format("%3d:    |   %n", row++);
                    continue;
                }
                formatter.format("%3d: %3d|%3d%n", row++, codeword.getRowNumber(), codeword.getValue());
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return formatter.toString();
    };
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;
    return DetectionResultColumn;
}();
var $1abaf97de2742615$export$2e2bcd8739ae039 = $1abaf97de2742615$var$DetectionResultColumn;


/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b835928578a76812$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $b835928578a76812$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// import java.util.ArrayList;
// import java.util.Collection;
// import java.util.HashMap;
// import java.util.Map;
// import java.util.Map.Entry;
/**
 * @author Guenther Grau
 */ var $b835928578a76812$var$BarcodeValue = /** @class */ function() {
    function BarcodeValue() {
        this.values = new Map();
    }
    /**
     * Add an occurrence of a value
     */ BarcodeValue.prototype.setValue = function(value) {
        value = Math.trunc(value);
        var confidence = this.values.get(value);
        if (confidence == null) confidence = 0;
        confidence++;
        this.values.set(value, confidence);
    };
    /**
     * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
     * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
     */ BarcodeValue.prototype.getValue = function() {
        var e_1, _a;
        var maxConfidence = -1;
        var result = new Array();
        var _loop_1 = function(key, value) {
            var entry = {
                getKey: function() {
                    return key;
                },
                getValue: function() {
                    return value;
                }
            };
            if (entry.getValue() > maxConfidence) {
                maxConfidence = entry.getValue();
                result = [];
                result.push(entry.getKey());
            } else if (entry.getValue() === maxConfidence) result.push(entry.getKey());
        };
        try {
            for(var _b = $b835928578a76812$var$__values(this.values.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $b835928578a76812$var$__read(_c.value, 2), key = _d[0], value = _d[1];
                _loop_1(key, value);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return (0, $43352c804aa61e30$export$2e2bcd8739ae039).toIntArray(result);
    };
    BarcodeValue.prototype.getConfidence = function(value) {
        return this.values.get(value);
    };
    return BarcodeValue;
}();
var $b835928578a76812$export$2e2bcd8739ae039 = $b835928578a76812$var$BarcodeValue;


var $88fcb4d7821fd7fc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $88fcb4d7821fd7fc$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Guenther Grau
 */ var $88fcb4d7821fd7fc$var$DetectionResultRowIndicatorColumn = /** @class */ function(_super) {
    $88fcb4d7821fd7fc$var$__extends(DetectionResultRowIndicatorColumn, _super);
    function DetectionResultRowIndicatorColumn(boundingBox, isLeft) {
        var _this = _super.call(this, boundingBox) || this;
        _this._isLeft = isLeft;
        return _this;
    }
    DetectionResultRowIndicatorColumn.prototype.setRowNumbers = function() {
        var e_1, _a;
        try {
            for(var _b = $88fcb4d7821fd7fc$var$__values(this.getCodewords()), _c = _b.next(); !_c.done; _c = _b.next()){
                var codeword = _c.value /*Codeword*/ ;
                if (codeword != null) codeword.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    // TODO implement properly
    // TODO maybe we should add missing codewords to store the correct row number to make
    // finding row numbers for other columns easier
    // use row height count to make detection of invalid row numbers more reliable
    DetectionResultRowIndicatorColumn.prototype.adjustCompleteIndicatorColumnRowNumbers = function(barcodeMetadata) {
        var codewords = this.getCodewords();
        this.setRowNumbers();
        this.removeIncorrectCodewords(codewords, barcodeMetadata);
        var boundingBox = this.getBoundingBox();
        var top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
        var bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
        var firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
        var lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
        // We need to be careful using the average row height. Barcode could be skewed so that we have smaller and
        // taller rows
        // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
        var barcodeRow = -1;
        var maxRowHeight = 1;
        var currentRowHeight = 0;
        for(var codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var codeword = codewords[codewordsRow];
            //      float expectedRowNumber = (codewordsRow - firstRow) / averageRowHeight;
            //      if (Math.abs(codeword.getRowNumber() - expectedRowNumber) > 2) {
            //        SimpleLog.log(LEVEL.WARNING,
            //            "Removing codeword, rowNumberSkew too high, codeword[" + codewordsRow + "]: Expected Row: " +
            //                expectedRowNumber + ", RealRow: " + codeword.getRowNumber() + ", value: " + codeword.getValue());
            //        codewords[codewordsRow] = null;
            //      }
            var rowDifference = codeword.getRowNumber() - barcodeRow;
            // TODO improve handling with case where first row indicator doesn't start with 0
            if (rowDifference === 0) currentRowHeight++;
            else if (rowDifference === 1) {
                maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                currentRowHeight = 1;
                barcodeRow = codeword.getRowNumber();
            } else if (rowDifference < 0 || codeword.getRowNumber() >= barcodeMetadata.getRowCount() || rowDifference > codewordsRow) codewords[codewordsRow] = null;
            else {
                var checkedRows = void 0;
                if (maxRowHeight > 2) checkedRows = (maxRowHeight - 2) * rowDifference;
                else checkedRows = rowDifference;
                var closePreviousCodewordFound = checkedRows >= codewordsRow;
                for(var i /*int*/  = 1; i <= checkedRows && !closePreviousCodewordFound; i++)// there must be (height * rowDifference) number of codewords missing. For now we assume height = 1.
                // This should hopefully get rid of most problems already.
                closePreviousCodewordFound = codewords[codewordsRow - i] != null;
                if (closePreviousCodewordFound) codewords[codewordsRow] = null;
                else {
                    barcodeRow = codeword.getRowNumber();
                    currentRowHeight = 1;
                }
            }
        }
    // return (int) (averageRowHeight + 0.5);
    };
    DetectionResultRowIndicatorColumn.prototype.getRowHeights = function() {
        var e_2, _a;
        var barcodeMetadata = this.getBarcodeMetadata();
        if (barcodeMetadata == null) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
        var result = new Int32Array(barcodeMetadata.getRowCount());
        try {
            for(var _b = $88fcb4d7821fd7fc$var$__values(this.getCodewords()), _c = _b.next(); !_c.done; _c = _b.next()){
                var codeword = _c.value /*Codeword*/ ;
                if (codeword != null) {
                    var rowNumber = codeword.getRowNumber();
                    if (rowNumber >= result.length) continue;
                    result[rowNumber]++;
                } // else throw exception?
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
    // TODO maybe we should add missing codewords to store the correct row number to make
    // finding row numbers for other columns easier
    // use row height count to make detection of invalid row numbers more reliable
    DetectionResultRowIndicatorColumn.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(barcodeMetadata) {
        var boundingBox = this.getBoundingBox();
        var top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
        var bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
        var firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
        var lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
        // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
        var codewords = this.getCodewords();
        var barcodeRow = -1;
        var maxRowHeight = 1;
        var currentRowHeight = 0;
        for(var codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var codeword = codewords[codewordsRow];
            codeword.setRowNumberAsRowIndicatorColumn();
            var rowDifference = codeword.getRowNumber() - barcodeRow;
            // TODO improve handling with case where first row indicator doesn't start with 0
            if (rowDifference === 0) currentRowHeight++;
            else if (rowDifference === 1) {
                maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                currentRowHeight = 1;
                barcodeRow = codeword.getRowNumber();
            } else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) codewords[codewordsRow] = null;
            else {
                barcodeRow = codeword.getRowNumber();
                currentRowHeight = 1;
            }
        }
    // return (int) (averageRowHeight + 0.5);
    };
    DetectionResultRowIndicatorColumn.prototype.getBarcodeMetadata = function() {
        var e_3, _a;
        var codewords = this.getCodewords();
        var barcodeColumnCount = new (0, $b835928578a76812$export$2e2bcd8739ae039)();
        var barcodeRowCountUpperPart = new (0, $b835928578a76812$export$2e2bcd8739ae039)();
        var barcodeRowCountLowerPart = new (0, $b835928578a76812$export$2e2bcd8739ae039)();
        var barcodeECLevel = new (0, $b835928578a76812$export$2e2bcd8739ae039)();
        try {
            for(var codewords_1 = $88fcb4d7821fd7fc$var$__values(codewords), codewords_1_1 = codewords_1.next(); !codewords_1_1.done; codewords_1_1 = codewords_1.next()){
                var codeword = codewords_1_1.value /*Codeword*/ ;
                if (codeword == null) continue;
                codeword.setRowNumberAsRowIndicatorColumn();
                var rowIndicatorValue = codeword.getValue() % 30;
                var codewordRowNumber = codeword.getRowNumber();
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
                        break;
                    case 1:
                        barcodeECLevel.setValue(rowIndicatorValue / 3);
                        barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
                        break;
                    case 2:
                        barcodeColumnCount.setValue(rowIndicatorValue + 1);
                        break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (codewords_1_1 && !codewords_1_1.done && (_a = codewords_1.return)) _a.call(codewords_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        // Maybe we should check if we have ambiguous values?
        if (barcodeColumnCount.getValue().length === 0 || barcodeRowCountUpperPart.getValue().length === 0 || barcodeRowCountLowerPart.getValue().length === 0 || barcodeECLevel.getValue().length === 0 || barcodeColumnCount.getValue()[0] < 1 || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < (0, $43352c804aa61e30$export$2e2bcd8739ae039).MIN_ROWS_IN_BARCODE || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > (0, $43352c804aa61e30$export$2e2bcd8739ae039).MAX_ROWS_IN_BARCODE) return null;
        var barcodeMetadata = new (0, $6f2d2bc17051afa6$export$2e2bcd8739ae039)(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
        this.removeIncorrectCodewords(codewords, barcodeMetadata);
        return barcodeMetadata;
    };
    DetectionResultRowIndicatorColumn.prototype.removeIncorrectCodewords = function(codewords, barcodeMetadata) {
        // Remove codewords which do not match the metadata
        // TODO Maybe we should keep the incorrect codewords for the start and end positions?
        for(var codewordRow /*int*/  = 0; codewordRow < codewords.length; codewordRow++){
            var codeword = codewords[codewordRow];
            if (codewords[codewordRow] == null) continue;
            var rowIndicatorValue = codeword.getValue() % 30;
            var codewordRowNumber = codeword.getRowNumber();
            if (codewordRowNumber > barcodeMetadata.getRowCount()) {
                codewords[codewordRow] = null;
                continue;
            }
            if (!this._isLeft) codewordRowNumber += 2;
            switch(codewordRowNumber % 3){
                case 0:
                    if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) codewords[codewordRow] = null;
                    break;
                case 1:
                    if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() || rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) codewords[codewordRow] = null;
                    break;
                case 2:
                    if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) codewords[codewordRow] = null;
                    break;
            }
        }
    };
    DetectionResultRowIndicatorColumn.prototype.isLeft = function() {
        return this._isLeft;
    };
    // @Override
    DetectionResultRowIndicatorColumn.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + _super.prototype.toString.call(this);
    };
    return DetectionResultRowIndicatorColumn;
}((0, $1abaf97de2742615$export$2e2bcd8739ae039));
var $88fcb4d7821fd7fc$export$2e2bcd8739ae039 = $88fcb4d7821fd7fc$var$DetectionResultRowIndicatorColumn;


/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $971a4435c914c923$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Guenther Grau
 */ var $971a4435c914c923$var$DetectionResult = /** @class */ function() {
    function DetectionResult(barcodeMetadata, boundingBox) {
        /*final*/ this.ADJUST_ROW_NUMBER_SKIP = 2;
        this.barcodeMetadata = barcodeMetadata;
        this.barcodeColumnCount = barcodeMetadata.getColumnCount();
        this.boundingBox = boundingBox;
        // this.detectionResultColumns = new DetectionResultColumn[this.barcodeColumnCount + 2];
        this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    DetectionResult.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var unadjustedCodewordCount = (0, $43352c804aa61e30$export$2e2bcd8739ae039).MAX_CODEWORDS_IN_BARCODE;
        var previousUnadjustedCount;
        do {
            previousUnadjustedCount = unadjustedCodewordCount;
            unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
        }while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
        return this.detectionResultColumns;
    };
    DetectionResult.prototype.adjustIndicatorColumnRowNumbers = function(detectionResultColumn) {
        if (detectionResultColumn != null) detectionResultColumn.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    };
    // TODO ensure that no detected codewords with unknown row number are left
    // we should be able to estimate the row height and use it as a hint for the row number
    // we should also fill the rows top to bottom and bottom to top
    /**
     * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
     * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
     */ DetectionResult.prototype.adjustRowNumbersAndGetCount = function() {
        var unadjustedCount = this.adjustRowNumbersByRow();
        if (unadjustedCount === 0) return 0;
        for(var barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++){
            var codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
            for(var codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                if (!codewords[codewordsRow].hasValidRowNumber()) this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
            }
        }
        return unadjustedCount;
    };
    DetectionResult.prototype.adjustRowNumbersByRow = function() {
        this.adjustRowNumbersFromBothRI();
        // TODO we should only do full row adjustments if row numbers of left and right row indicator column match.
        // Maybe it's even better to calculated the height (rows: d) and divide it by the number of barcode
        // rows. This, together with the LRI and RRI row numbers should allow us to get a good estimate where a row
        // number starts and ends.
        var unadjustedCount = this.adjustRowNumbersFromLRI();
        return unadjustedCount + this.adjustRowNumbersFromRRI();
    };
    DetectionResult.prototype.adjustRowNumbersFromBothRI = function() {
        if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return;
        var LRIcodewords = this.detectionResultColumns[0].getCodewords();
        var RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
        for(var codewordsRow /*int*/  = 0; codewordsRow < LRIcodewords.length; codewordsRow++){
            if (LRIcodewords[codewordsRow] != null && RRIcodewords[codewordsRow] != null && LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) for(var barcodeColumn /*int*/  = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++){
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword == null) continue;
                codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
                if (!codeword.hasValidRowNumber()) this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
            }
        }
    };
    DetectionResult.prototype.adjustRowNumbersFromRRI = function() {
        if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return 0;
        var unadjustedCount = 0;
        var codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
        for(var codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
            var invalidRowCounts = 0;
            for(var barcodeColumn /*int*/  = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--){
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword != null) {
                    invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                    if (!codeword.hasValidRowNumber()) unadjustedCount++;
                }
            }
        }
        return unadjustedCount;
    };
    DetectionResult.prototype.adjustRowNumbersFromLRI = function() {
        if (this.detectionResultColumns[0] == null) return 0;
        var unadjustedCount = 0;
        var codewords = this.detectionResultColumns[0].getCodewords();
        for(var codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
            var invalidRowCounts = 0;
            for(var barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++){
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword != null) {
                    invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                    if (!codeword.hasValidRowNumber()) unadjustedCount++;
                }
            }
        }
        return unadjustedCount;
    };
    DetectionResult.adjustRowNumberIfValid = function(rowIndicatorRowNumber, invalidRowCounts, codeword) {
        if (codeword == null) return invalidRowCounts;
        if (!codeword.hasValidRowNumber()) {
            if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
                codeword.setRowNumber(rowIndicatorRowNumber);
                invalidRowCounts = 0;
            } else ++invalidRowCounts;
        }
        return invalidRowCounts;
    };
    DetectionResult.prototype.adjustRowNumbers = function(barcodeColumn, codewordsRow, codewords) {
        var e_1, _a;
        if (this.detectionResultColumns[barcodeColumn - 1] == null) return;
        var codeword = codewords[codewordsRow];
        var previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
        var nextColumnCodewords = previousColumnCodewords;
        if (this.detectionResultColumns[barcodeColumn + 1] != null) nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
        // let otherCodewords: Codeword[] = new Codeword[14];
        var otherCodewords = new Array(14);
        otherCodewords[2] = previousColumnCodewords[codewordsRow];
        otherCodewords[3] = nextColumnCodewords[codewordsRow];
        if (codewordsRow > 0) {
            otherCodewords[0] = codewords[codewordsRow - 1];
            otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
            otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
        }
        if (codewordsRow > 1) {
            otherCodewords[8] = codewords[codewordsRow - 2];
            otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
            otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
        }
        if (codewordsRow < codewords.length - 1) {
            otherCodewords[1] = codewords[codewordsRow + 1];
            otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
            otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
        }
        if (codewordsRow < codewords.length - 2) {
            otherCodewords[9] = codewords[codewordsRow + 2];
            otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
            otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
        }
        try {
            for(var otherCodewords_1 = $971a4435c914c923$var$__values(otherCodewords), otherCodewords_1_1 = otherCodewords_1.next(); !otherCodewords_1_1.done; otherCodewords_1_1 = otherCodewords_1.next()){
                var otherCodeword = otherCodewords_1_1.value;
                if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (otherCodewords_1_1 && !otherCodewords_1_1.done && (_a = otherCodewords_1.return)) _a.call(otherCodewords_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * @return true, if row number was adjusted, false otherwise
     */ DetectionResult.adjustRowNumber = function(codeword, otherCodeword) {
        if (otherCodeword == null) return false;
        if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
            codeword.setRowNumber(otherCodeword.getRowNumber());
            return true;
        }
        return false;
    };
    DetectionResult.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    };
    DetectionResult.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    };
    DetectionResult.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    };
    DetectionResult.prototype.setBoundingBox = function(boundingBox) {
        this.boundingBox = boundingBox;
    };
    DetectionResult.prototype.getBoundingBox = function() {
        return this.boundingBox;
    };
    DetectionResult.prototype.setDetectionResultColumn = function(barcodeColumn, detectionResultColumn) {
        this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
    };
    DetectionResult.prototype.getDetectionResultColumn = function(barcodeColumn) {
        return this.detectionResultColumns[barcodeColumn];
    };
    // @Override
    DetectionResult.prototype.toString = function() {
        var rowIndicatorColumn = this.detectionResultColumns[0];
        if (rowIndicatorColumn == null) rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
        // try (
        var formatter = new (0, $d7946609c4ff0191$export$2e2bcd8739ae039)();
        // ) {
        for(var codewordsRow /*int*/  = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++){
            formatter.format("CW %3d:", codewordsRow);
            for(var barcodeColumn /*int*/  = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++){
                if (this.detectionResultColumns[barcodeColumn] == null) {
                    formatter.format("    |   ");
                    continue;
                }
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword == null) {
                    formatter.format("    |   ");
                    continue;
                }
                formatter.format(" %3d|%3d", codeword.getRowNumber(), codeword.getValue());
            }
            formatter.format("%n");
        }
        return formatter.toString();
    // }
    };
    return DetectionResult;
}();
var $971a4435c914c923$export$2e2bcd8739ae039 = $971a4435c914c923$var$DetectionResult;



/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417.decoder;
/**
 * @author Guenther Grau
 */ var $aaff1997abc48b91$var$Codeword = /** @class */ function() {
    function Codeword(startX, endX, bucket, value) {
        this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
        this.startX = Math.trunc(startX);
        this.endX = Math.trunc(endX);
        this.bucket = Math.trunc(bucket);
        this.value = Math.trunc(value);
    }
    Codeword.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    };
    Codeword.prototype.isValidRowNumber = function(rowNumber) {
        return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === rowNumber % 3 * 3;
    };
    Codeword.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
    };
    Codeword.prototype.getWidth = function() {
        return this.endX - this.startX;
    };
    Codeword.prototype.getStartX = function() {
        return this.startX;
    };
    Codeword.prototype.getEndX = function() {
        return this.endX;
    };
    Codeword.prototype.getBucket = function() {
        return this.bucket;
    };
    Codeword.prototype.getValue = function() {
        return this.value;
    };
    Codeword.prototype.getRowNumber = function() {
        return this.rowNumber;
    };
    Codeword.prototype.setRowNumber = function(rowNumber) {
        this.rowNumber = rowNumber;
    };
    //   @Override
    Codeword.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    };
    Codeword.BARCODE_ROW_UNKNOWN = -1;
    return Codeword;
}();
var $aaff1997abc48b91$export$2e2bcd8739ae039 = $aaff1997abc48b91$var$Codeword;



/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.pdf417.decoder;
// import com.google.zxing.common.detector.MathUtils;



/**
 * @author Guenther Grau
 * @author creatale GmbH (christoph.schulz@creatale.de)
 */ var $f98d346ffacfe264$var$PDF417CodewordDecoder = /** @class */ function() {
    function PDF417CodewordDecoder() {}
    /* @note
     * this action have to be performed before first use of class
     * - static constructor
     * working with 32bit float (based from Java logic)
    */ PDF417CodewordDecoder.initialize = function() {
        // Pre-computes the symbol ratio table.
        for(/*int*/ var i = 0; i < (0, $43352c804aa61e30$export$2e2bcd8739ae039).SYMBOL_TABLE.length; i++){
            var currentSymbol = (0, $43352c804aa61e30$export$2e2bcd8739ae039).SYMBOL_TABLE[i];
            var currentBit = currentSymbol & 0x1;
            for(/*int*/ var j = 0; j < (0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE; j++){
                var size = 0.0;
                while((currentSymbol & 0x1) === currentBit){
                    size += 1.0;
                    currentSymbol >>= 1;
                }
                currentBit = currentSymbol & 0x1;
                if (!PDF417CodewordDecoder.RATIOS_TABLE[i]) PDF417CodewordDecoder.RATIOS_TABLE[i] = new Array((0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE);
                PDF417CodewordDecoder.RATIOS_TABLE[i][(0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE - j - 1] = Math.fround(size / (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD);
            }
        }
        this.bSymbolTableReady = true;
    };
    PDF417CodewordDecoder.getDecodedValue = function(moduleBitCount) {
        var decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
        if (decodedValue !== -1) return decodedValue;
        return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
    };
    PDF417CodewordDecoder.sampleBitCounts = function(moduleBitCount) {
        var bitCountSum = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(moduleBitCount);
        var result = new Int32Array((0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE);
        var bitCountIndex = 0;
        var sumPreviousBits = 0;
        for(/*int*/ var i = 0; i < (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD; i++){
            var sampleIndex = bitCountSum / (2 * (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD) + i * bitCountSum / (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD;
            if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
                sumPreviousBits += moduleBitCount[bitCountIndex];
                bitCountIndex++;
            }
            result[bitCountIndex]++;
        }
        return result;
    };
    PDF417CodewordDecoder.getDecodedCodewordValue = function(moduleBitCount) {
        var decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
        return (0, $43352c804aa61e30$export$2e2bcd8739ae039).getCodeword(decodedValue) === -1 ? -1 : decodedValue;
    };
    PDF417CodewordDecoder.getBitValue = function(moduleBitCount) {
        var result = /*long*/ 0;
        for(var /*int*/ i = 0; i < moduleBitCount.length; i++)for(/*int*/ var bit = 0; bit < moduleBitCount[i]; bit++)result = result << 1 | (i % 2 === 0 ? 1 : 0);
        return Math.trunc(result);
    };
    // working with 32bit float (as in Java)
    PDF417CodewordDecoder.getClosestDecodedValue = function(moduleBitCount) {
        var bitCountSum = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(moduleBitCount);
        var bitCountRatios = new Array((0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE);
        if (bitCountSum > 1) for(var /*int*/ i = 0; i < bitCountRatios.length; i++)bitCountRatios[i] = Math.fround(moduleBitCount[i] / bitCountSum);
        var bestMatchError = (0, $61429817f07e819d$export$2e2bcd8739ae039).MAX_VALUE;
        var bestMatch = -1;
        if (!this.bSymbolTableReady) PDF417CodewordDecoder.initialize();
        for(/*int*/ var j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++){
            var error = 0.0;
            var ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
            for(/*int*/ var k = 0; k < (0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE; k++){
                var diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
                error += Math.fround(diff * diff);
                if (error >= bestMatchError) break;
            }
            if (error < bestMatchError) {
                bestMatchError = error;
                bestMatch = (0, $43352c804aa61e30$export$2e2bcd8739ae039).SYMBOL_TABLE[j];
            }
        }
        return bestMatch;
    };
    // flag that the table is ready for use
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array((0, $43352c804aa61e30$export$2e2bcd8739ae039).SYMBOL_TABLE.length).map(function(x) {
        return x = new Array((0, $43352c804aa61e30$export$2e2bcd8739ae039).BARS_IN_MODULE);
    });
    return PDF417CodewordDecoder;
}();
var $f98d346ffacfe264$export$2e2bcd8739ae039 = $f98d346ffacfe264$var$PDF417CodewordDecoder;


/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417.decoder;
// import com.google.zxing.FormatException;



/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417;
/**
 * @author Guenther Grau
 */ var $956813f24fb761ea$var$PDF417ResultMetadata = /** @class */ function() {
    function PDF417ResultMetadata() {
        this.segmentCount = -1;
        this.fileSize = -1;
        this.timestamp = -1;
        this.checksum = -1;
    }
    /**
     * The Segment ID represents the segment of the whole file distributed over different symbols.
     *
     * @return File segment index
     */ PDF417ResultMetadata.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    };
    PDF417ResultMetadata.prototype.setSegmentIndex = function(segmentIndex) {
        this.segmentIndex = segmentIndex;
    };
    /**
     * Is the same for each related PDF417 symbol
     *
     * @return File ID
     */ PDF417ResultMetadata.prototype.getFileId = function() {
        return this.fileId;
    };
    PDF417ResultMetadata.prototype.setFileId = function(fileId) {
        this.fileId = fileId;
    };
    /**
     * @return always null
     * @deprecated use dedicated already parsed fields
     */ //   @Deprecated
    PDF417ResultMetadata.prototype.getOptionalData = function() {
        return this.optionalData;
    };
    /**
     * @param optionalData old optional data format as int array
     * @deprecated parse and use new fields
     */ //   @Deprecated
    PDF417ResultMetadata.prototype.setOptionalData = function(optionalData) {
        this.optionalData = optionalData;
    };
    /**
     * @return true if it is the last segment
     */ PDF417ResultMetadata.prototype.isLastSegment = function() {
        return this.lastSegment;
    };
    PDF417ResultMetadata.prototype.setLastSegment = function(lastSegment) {
        this.lastSegment = lastSegment;
    };
    /**
     * @return count of segments, -1 if not set
     */ PDF417ResultMetadata.prototype.getSegmentCount = function() {
        return this.segmentCount;
    };
    PDF417ResultMetadata.prototype.setSegmentCount = function(segmentCount /*int*/ ) {
        this.segmentCount = segmentCount;
    };
    PDF417ResultMetadata.prototype.getSender = function() {
        return this.sender || null;
    };
    PDF417ResultMetadata.prototype.setSender = function(sender) {
        this.sender = sender;
    };
    PDF417ResultMetadata.prototype.getAddressee = function() {
        return this.addressee || null;
    };
    PDF417ResultMetadata.prototype.setAddressee = function(addressee) {
        this.addressee = addressee;
    };
    /**
     * Filename of the encoded file
     *
     * @return filename
     */ PDF417ResultMetadata.prototype.getFileName = function() {
        return this.fileName;
    };
    PDF417ResultMetadata.prototype.setFileName = function(fileName) {
        this.fileName = fileName;
    };
    /**
     * filesize in bytes of the encoded file
     *
     * @return filesize in bytes, -1 if not set
     */ PDF417ResultMetadata.prototype.getFileSize = function() {
        return this.fileSize;
    };
    PDF417ResultMetadata.prototype.setFileSize = function(fileSize /*long*/ ) {
        this.fileSize = fileSize;
    };
    /**
     * 16-bit CRC checksum using CCITT-16
     *
     * @return crc checksum, -1 if not set
     */ PDF417ResultMetadata.prototype.getChecksum = function() {
        return this.checksum;
    };
    PDF417ResultMetadata.prototype.setChecksum = function(checksum /*int*/ ) {
        this.checksum = checksum;
    };
    /**
     * unix epock timestamp, elapsed seconds since 1970-01-01
     *
     * @return elapsed seconds, -1 if not set
     */ PDF417ResultMetadata.prototype.getTimestamp = function() {
        return this.timestamp;
    };
    PDF417ResultMetadata.prototype.setTimestamp = function(timestamp /*long*/ ) {
        this.timestamp = timestamp;
    };
    return PDF417ResultMetadata;
}();
var $956813f24fb761ea$export$2e2bcd8739ae039 = $956813f24fb761ea$var$PDF417ResultMetadata;





/**
 * Ponyfill for Java's Long class.
 */ var $94ea729b332c6a19$var$Long = /** @class */ function() {
    function Long() {}
    /**
     * Parses a string to a number, since JS has no really Int64.
     *
     * @param num Numeric string.
     * @param radix Destination radix.
     */ Long.parseLong = function(num, radix) {
        if (radix === void 0) radix = undefined;
        return parseInt(num, radix);
    };
    return Long;
}();
var $94ea729b332c6a19$export$2e2bcd8739ae039 = $94ea729b332c6a19$var$Long;


/*
 * Copyright (c) 1994, 2010, Oracle and/or its affiliates. All rights reserved.
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This code is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License version 2 only, as
 * published by the Free Software Foundation.  Oracle designates this
 * particular file as subject to the "Classpath" exception as provided
 * by Oracle in the LICENSE file that accompanied this code.
 *
 * This code is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
 * version 2 for more details (a copy is included in the LICENSE file that
 * accompanied this code).
 *
 * You should have received a copy of the GNU General Public License version
 * 2 along with this work; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
 *
 * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
 * or visit www.oracle.com if you need additional information or have any
 * questions.
 */ 


var $cb3aebbf341db6d2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $cb3aebbf341db6d2$var$NullPointerException = /** @class */ function(_super) {
    $cb3aebbf341db6d2$var$__extends(NullPointerException, _super);
    function NullPointerException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullPointerException.kind = "NullPointerException";
    return NullPointerException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $cb3aebbf341db6d2$export$2e2bcd8739ae039 = $cb3aebbf341db6d2$var$NullPointerException;


/*
 * Copyright (c) 1994, 2004, Oracle and/or its affiliates. All rights reserved.
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This code is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License version 2 only, as
 * published by the Free Software Foundation.  Oracle designates this
 * particular file as subject to the "Classpath" exception as provided
 * by Oracle in the LICENSE file that accompanied this code.
 *
 * This code is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
 * version 2 for more details (a copy is included in the LICENSE file that
 * accompanied this code).
 *
 * You should have received a copy of the GNU General Public License version
 * 2 along with this work; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
 *
 * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
 * or visit www.oracle.com if you need additional information or have any
 * questions.
 */ // package java.io;
/**
 * This abstract class is the superclass of all classes representing
 * an output stream of bytes. An output stream accepts output bytes
 * and sends them to some sink.
 * <p>
 * Applications that need to define a subclass of
 * <code>OutputStream</code> must always provide at least a method
 * that writes one byte of output.
 *
 * @author  Arthur van Hoff
 * @see     java.io.BufferedOutputStream
 * @see     java.io.ByteArrayOutputStream
 * @see     java.io.DataOutputStream
 * @see     java.io.FilterOutputStream
 * @see     java.io.InputStream
 * @see     java.io.OutputStream#write(int)
 * @since   JDK1.0
 */ var $070e0510307ff29c$var$OutputStream /*implements Closeable, Flushable*/  = /** @class */ function() {
    function OutputStream() {}
    /**
     * Writes <code>b.length</code> bytes from the specified byte array
     * to this output stream. The general contract for <code>write(b)</code>
     * is that it should have exactly the same effect as the call
     * <code>write(b, 0, b.length)</code>.
     *
     * @param      b   the data.
     * @exception  IOException  if an I/O error occurs.
     * @see        java.io.OutputStream#write(byte[], int, int)
     */ OutputStream.prototype.writeBytes = function(b) {
        this.writeBytesOffset(b, 0, b.length);
    };
    /**
     * Writes <code>len</code> bytes from the specified byte array
     * starting at offset <code>off</code> to this output stream.
     * The general contract for <code>write(b, off, len)</code> is that
     * some of the bytes in the array <code>b</code> are written to the
     * output stream in order; element <code>b[off]</code> is the first
     * byte written and <code>b[off+len-1]</code> is the last byte written
     * by this operation.
     * <p>
     * The <code>write</code> method of <code>OutputStream</code> calls
     * the write method of one argument on each of the bytes to be
     * written out. Subclasses are encouraged to override this method and
     * provide a more efficient implementation.
     * <p>
     * If <code>b</code> is <code>null</code>, a
     * <code>NullPointerException</code> is thrown.
     * <p>
     * If <code>off</code> is negative, or <code>len</code> is negative, or
     * <code>off+len</code> is greater than the length of the array
     * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
     *
     * @param      b     the data.
     * @param      off   the start offset in the data.
     * @param      len   the number of bytes to write.
     * @exception  IOException  if an I/O error occurs. In particular,
     *             an <code>IOException</code> is thrown if the output
     *             stream is closed.
     */ OutputStream.prototype.writeBytesOffset = function(b, off, len) {
        if (b == null) throw new (0, $cb3aebbf341db6d2$export$2e2bcd8739ae039)();
        else if (off < 0 || off > b.length || len < 0 || off + len > b.length || off + len < 0) throw new (0, $d11d81052c0bc9f1$export$2e2bcd8739ae039)();
        else if (len === 0) return;
        for(var i = 0; i < len; i++)this.write(b[off + i]);
    };
    /**
     * Flushes this output stream and forces any buffered output bytes
     * to be written out. The general contract of <code>flush</code> is
     * that calling it is an indication that, if any bytes previously
     * written have been buffered by the implementation of the output
     * stream, such bytes should immediately be written to their
     * intended destination.
     * <p>
     * If the intended destination of this stream is an abstraction provided by
     * the underlying operating system, for example a file, then flushing the
     * stream guarantees only that bytes previously written to the stream are
     * passed to the operating system for writing; it does not guarantee that
     * they are actually written to a physical device such as a disk drive.
     * <p>
     * The <code>flush</code> method of <code>OutputStream</code> does nothing.
     *
     * @exception  IOException  if an I/O error occurs.
     */ OutputStream.prototype.flush = function() {};
    /**
     * Closes this output stream and releases any system resources
     * associated with this stream. The general contract of <code>close</code>
     * is that it closes the output stream. A closed stream cannot perform
     * output operations and cannot be reopened.
     * <p>
     * The <code>close</code> method of <code>OutputStream</code> does nothing.
     *
     * @exception  IOException  if an I/O error occurs.
     */ OutputStream.prototype.close = function() {};
    return OutputStream;
}();
var $070e0510307ff29c$export$2e2bcd8739ae039 = $070e0510307ff29c$var$OutputStream;





var $335de6af947d159f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $335de6af947d159f$var$OutOfMemoryError = /** @class */ function(_super) {
    $335de6af947d159f$var$__extends(OutOfMemoryError, _super);
    function OutOfMemoryError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OutOfMemoryError;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $335de6af947d159f$export$2e2bcd8739ae039 = $335de6af947d159f$var$OutOfMemoryError;




var $325362cb4e6f69b4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class implements an output stream in which the data is
 * written into a byte array. The buffer automatically grows as data
 * is written to it.
 * The data can be retrieved using <code>toByteArray()</code> and
 * <code>toString()</code>.
 * <p>
 * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
 * this class can be called after the stream has been closed without
 * generating an <tt>IOException</tt>.
 *
 * @author  Arthur van Hoff
 * @since   JDK1.0
 */ var $325362cb4e6f69b4$var$ByteArrayOutputStream = /** @class */ function(_super) {
    $325362cb4e6f69b4$var$__extends(ByteArrayOutputStream, _super);
    /**
     * Creates a new byte array output stream. The buffer capacity is
     * initially 32 bytes, though its size increases if necessary.
     */ // public constructor() {
    //     this(32);
    // }
    /**
     * Creates a new byte array output stream, with a buffer capacity of
     * the specified size, in bytes.
     *
     * @param   size   the initial size.
     * @exception  IllegalArgumentException if size is negative.
     */ function ByteArrayOutputStream(size) {
        if (size === void 0) size = 32;
        var _this = _super.call(this) || this;
        /**
         * The number of valid bytes in the buffer.
         */ _this.count = 0;
        if (size < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Negative initial size: " + size);
        _this.buf = new Uint8Array(size);
        return _this;
    }
    /**
     * Increases the capacity if necessary to ensure that it can hold
     * at least the number of elements specified by the minimum
     * capacity argument.
     *
     * @param minCapacity the desired minimum capacity
     * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
     * interpreted as a request for the unsatisfiably large capacity
     * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
     */ ByteArrayOutputStream.prototype.ensureCapacity = function(minCapacity) {
        // overflow-conscious code
        if (minCapacity - this.buf.length > 0) this.grow(minCapacity);
    };
    /**
     * Increases the capacity to ensure that it can hold at least the
     * number of elements specified by the minimum capacity argument.
     *
     * @param minCapacity the desired minimum capacity
     */ ByteArrayOutputStream.prototype.grow = function(minCapacity) {
        // overflow-conscious code
        var oldCapacity = this.buf.length;
        var newCapacity = oldCapacity << 1;
        if (newCapacity - minCapacity < 0) newCapacity = minCapacity;
        if (newCapacity < 0) {
            if (minCapacity < 0) throw new (0, $335de6af947d159f$export$2e2bcd8739ae039)();
            newCapacity = (0, $902e90c40380930f$export$2e2bcd8739ae039).MAX_VALUE;
        }
        this.buf = (0, $eed4834329730fe6$export$2e2bcd8739ae039).copyOfUint8Array(this.buf, newCapacity);
    };
    /**
     * Writes the specified byte to this byte array output stream.
     *
     * @param   b   the byte to be written.
     */ ByteArrayOutputStream.prototype.write = function(b) {
        this.ensureCapacity(this.count + 1);
        this.buf[this.count] = /*(byte)*/ b;
        this.count += 1;
    };
    /**
     * Writes <code>len</code> bytes from the specified byte array
     * starting at offset <code>off</code> to this byte array output stream.
     *
     * @param   b     the data.
     * @param   off   the start offset in the data.
     * @param   len   the number of bytes to write.
     */ ByteArrayOutputStream.prototype.writeBytesOffset = function(b, off, len) {
        if (off < 0 || off > b.length || len < 0 || off + len - b.length > 0) throw new (0, $d11d81052c0bc9f1$export$2e2bcd8739ae039)();
        this.ensureCapacity(this.count + len);
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(b, off, this.buf, this.count, len);
        this.count += len;
    };
    /**
     * Writes the complete contents of this byte array output stream to
     * the specified output stream argument, as if by calling the output
     * stream's write method using <code>out.write(buf, 0, count)</code>.
     *
     * @param      out   the output stream to which to write the data.
     * @exception  IOException  if an I/O error occurs.
     */ ByteArrayOutputStream.prototype.writeTo = function(out) {
        out.writeBytesOffset(this.buf, 0, this.count);
    };
    /**
     * Resets the <code>count</code> field of this byte array output
     * stream to zero, so that all currently accumulated output in the
     * output stream is discarded. The output stream can be used again,
     * reusing the already allocated buffer space.
     *
     * @see     java.io.ByteArrayInputStream#count
     */ ByteArrayOutputStream.prototype.reset = function() {
        this.count = 0;
    };
    /**
     * Creates a newly allocated byte array. Its size is the current
     * size of this output stream and the valid contents of the buffer
     * have been copied into it.
     *
     * @return  the current contents of this output stream, as a byte array.
     * @see     java.io.ByteArrayOutputStream#size()
     */ ByteArrayOutputStream.prototype.toByteArray = function() {
        return (0, $eed4834329730fe6$export$2e2bcd8739ae039).copyOfUint8Array(this.buf, this.count);
    };
    /**
     * Returns the current size of the buffer.
     *
     * @return  the value of the <code>count</code> field, which is the number
     *          of valid bytes in this output stream.
     * @see     java.io.ByteArrayOutputStream#count
     */ ByteArrayOutputStream.prototype.size = function() {
        return this.count;
    };
    ByteArrayOutputStream.prototype.toString = function(param) {
        if (!param) return this.toString_void();
        if (typeof param === "string") return this.toString_string(param);
        return this.toString_number(param);
    };
    /**
     * Converts the buffer's contents into a string decoding bytes using the
     * platform's default character set. The length of the new <tt>String</tt>
     * is a function of the character set, and hence may not be equal to the
     * size of the buffer.
     *
     * <p> This method always replaces malformed-input and unmappable-character
     * sequences with the default replacement string for the platform's
     * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
     * class should be used when more control over the decoding process is
     * required.
     *
     * @return String decoded from the buffer's contents.
     * @since  JDK1.1
     */ ByteArrayOutputStream.prototype.toString_void = function() {
        return new String(this.buf /*, 0, this.count*/ ).toString();
    };
    /**
     * Converts the buffer's contents into a string by decoding the bytes using
     * the specified {@link java.nio.charset.Charset charsetName}. The length of
     * the new <tt>String</tt> is a function of the charset, and hence may not be
     * equal to the length of the byte array.
     *
     * <p> This method always replaces malformed-input and unmappable-character
     * sequences with this charset's default replacement string. The {@link
     * java.nio.charset.CharsetDecoder} class should be used when more control
     * over the decoding process is required.
     *
     * @param  charsetName  the name of a supported
     *              {@linkplain java.nio.charset.Charset </code>charset<code>}
     * @return String decoded from the buffer's contents.
     * @exception  UnsupportedEncodingException
     *             If the named charset is not supported
     * @since   JDK1.1
     */ ByteArrayOutputStream.prototype.toString_string = function(charsetName) {
        return new String(this.buf /*, 0, this.count, charsetName*/ ).toString();
    };
    /**
     * Creates a newly allocated string. Its size is the current size of
     * the output stream and the valid contents of the buffer have been
     * copied into it. Each character <i>c</i> in the resulting string is
     * constructed from the corresponding element <i>b</i> in the byte
     * array such that:
     * <blockquote><pre>
     *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
     * </pre></blockquote>
     *
     * @deprecated This method does not properly convert bytes into characters.
     * As of JDK&nbsp;1.1, the preferred way to do this is via the
     * <code>toString(String enc)</code> method, which takes an encoding-name
     * argument, or the <code>toString()</code> method, which uses the
     * platform's default character encoding.
     *
     * @param      hibyte    the high byte of each resulting Unicode character.
     * @return     the current contents of the output stream, as a string.
     * @see        java.io.ByteArrayOutputStream#size()
     * @see        java.io.ByteArrayOutputStream#toString(String)
     * @see        java.io.ByteArrayOutputStream#toString()
     */ // @Deprecated
    ByteArrayOutputStream.prototype.toString_number = function(hibyte) {
        return new String(this.buf /*, hibyte, 0, this.count*/ ).toString();
    };
    /**
     * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
     * this class can be called after the stream has been closed without
     * generating an <tt>IOException</tt>.
     * <p>
     *
     * @throws IOException
     */ ByteArrayOutputStream.prototype.close = function() {};
    return ByteArrayOutputStream;
}((0, $070e0510307ff29c$export$2e2bcd8739ae039));
var $325362cb4e6f69b4$export$2e2bcd8739ae039 = $325362cb4e6f69b4$var$ByteArrayOutputStream;



/*private*/ var $6ae813d87bb7df8a$var$Mode;
(function(Mode) {
    Mode[Mode["ALPHA"] = 0] = "ALPHA";
    Mode[Mode["LOWER"] = 1] = "LOWER";
    Mode[Mode["MIXED"] = 2] = "MIXED";
    Mode[Mode["PUNCT"] = 3] = "PUNCT";
    Mode[Mode["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
    Mode[Mode["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
})($6ae813d87bb7df8a$var$Mode || ($6ae813d87bb7df8a$var$Mode = {}));
/**
 * Indirectly access the global BigInt constructor, it
 * allows browsers that doesn't support BigInt to run
 * the library without breaking due to "undefined BigInt"
 * errors.
 */ function $6ae813d87bb7df8a$var$getBigIntConstructor() {
    if (typeof window !== "undefined") return window["BigInt"] || null;
    if (typeof $parcel$global !== "undefined") return $parcel$global["BigInt"] || null;
    if (typeof self !== "undefined") return self["BigInt"] || null;
    throw new Error("Can't search globals for BigInt!");
}
/**
 * Used to store the BigInt constructor.
 */ var $6ae813d87bb7df8a$var$BigInteger;
/**
 * This function creates a bigint value. It allows browsers
 * that doesn't support BigInt to run the rest of the library
 * by not directly accessing the BigInt constructor.
 */ function $6ae813d87bb7df8a$var$createBigInt(num) {
    if (typeof $6ae813d87bb7df8a$var$BigInteger === "undefined") $6ae813d87bb7df8a$var$BigInteger = $6ae813d87bb7df8a$var$getBigIntConstructor();
    if ($6ae813d87bb7df8a$var$BigInteger === null) throw new Error("BigInt is not supported!");
    return $6ae813d87bb7df8a$var$BigInteger(num);
}
function $6ae813d87bb7df8a$var$getEXP900() {
    // in Java - array with length = 16
    var EXP900 = [];
    EXP900[0] = $6ae813d87bb7df8a$var$createBigInt(1);
    var nineHundred = $6ae813d87bb7df8a$var$createBigInt(900);
    EXP900[1] = nineHundred;
    // in Java - array with length = 16
    for(var i /*int*/  = 2; i < 16; i++)EXP900[i] = EXP900[i - 1] * nineHundred;
    return EXP900;
}
/**
 * <p>This class contains the methods for decoding the PDF417 codewords.</p>
 *
 * @author SITA Lab (kevin.osullivan@sita.aero)
 * @author Guenther Grau
 */ var $6ae813d87bb7df8a$var$DecodedBitStreamParser = /** @class */ function() {
    function DecodedBitStreamParser() {}
    //   private DecodedBitStreamParser() {
    // }
    /**
     *
     * @param codewords
     * @param ecLevel
     *
     * @throws FormatException
     */ DecodedBitStreamParser.decode = function(codewords, ecLevel) {
        // pass encoding to result (will be used for decode symbols in byte mode)
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)("");
        // let encoding: Charset = StandardCharsets.ISO_8859_1;
        var encoding = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).ISO8859_1;
        /**
         * @note the next command is specific from this TypeScript library
         * because TS can't properly cast some values to char and
         * convert it to string later correctly due to encoding
         * differences from Java version. As reported here:
         * https://github.com/zxing-js/library/pull/264/files#r382831593
         */ result.enableDecoding(encoding);
        // Get compaction mode
        var codeIndex = 1;
        var code = codewords[codeIndex++];
        var resultMetadata = new (0, $956813f24fb761ea$export$2e2bcd8739ae039)();
        while(codeIndex < codewords[0]){
            switch(code){
                case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                    codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex, result);
                    break;
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                    codeIndex = DecodedBitStreamParser.byteCompaction(code, codewords, encoding, codeIndex, result);
                    break;
                case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result.append(/*(char)*/ codewords[codeIndex++]);
                    break;
                case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                    codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex, result);
                    break;
                case DecodedBitStreamParser.ECI_CHARSET:
                    var charsetECI = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).getCharacterSetECIByValue(codewords[codeIndex++]);
                    break;
                case DecodedBitStreamParser.ECI_GENERAL_PURPOSE:
                    // Can't do anything with generic ECI; skip its 2 characters
                    codeIndex += 2;
                    break;
                case DecodedBitStreamParser.ECI_USER_DEFINED:
                    // Can't do anything with user ECI; skip its 1 character
                    codeIndex++;
                    break;
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    codeIndex = DecodedBitStreamParser.decodeMacroBlock(codewords, codeIndex, resultMetadata);
                    break;
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                    // Should not see these outside a macro block
                    throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
                default:
                    // Default to text compaction. During testing numerous barcodes
                    // appeared to be missing the starting mode. In these cases defaulting
                    // to text compaction seems to work.
                    codeIndex--;
                    codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex, result);
                    break;
            }
            if (codeIndex < codewords.length) code = codewords[codeIndex++];
            else throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        }
        if (result.length() === 0) throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        var decoderResult = new (0, $aa602f5deffed2f7$export$2e2bcd8739ae039)(null, result.toString(), null, ecLevel);
        decoderResult.setOther(resultMetadata);
        return decoderResult;
    };
    /**
     *
     * @param int
     * @param param1
     * @param codewords
     * @param int
     * @param codeIndex
     * @param PDF417ResultMetadata
     * @param resultMetadata
     *
     * @throws FormatException
     */ // @SuppressWarnings("deprecation")
    DecodedBitStreamParser.decodeMacroBlock = function(codewords, codeIndex, resultMetadata) {
        if (codeIndex + DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) // we must have at least two bytes left for the segment index
        throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        var segmentIndexArray = new Int32Array(DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS);
        for(var i /*int*/  = 0; i < DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS; i++, codeIndex++)segmentIndexArray[i] = codewords[codeIndex];
        resultMetadata.setSegmentIndex((0, $902e90c40380930f$export$2e2bcd8739ae039).parseInt(DecodedBitStreamParser.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var fileId = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex, fileId);
        resultMetadata.setFileId(fileId.toString());
        var optionalFieldsStart = -1;
        if (codewords[codeIndex] === DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) optionalFieldsStart = codeIndex + 1;
        while(codeIndex < codewords[0])switch(codewords[codeIndex]){
            case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                codeIndex++;
                switch(codewords[codeIndex]){
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var fileName = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex + 1, fileName);
                        resultMetadata.setFileName(fileName.toString());
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var sender = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex + 1, sender);
                        resultMetadata.setSender(sender.toString());
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var addressee = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex + 1, addressee);
                        resultMetadata.setAddressee(addressee.toString());
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var segmentCount = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, segmentCount);
                        resultMetadata.setSegmentCount((0, $902e90c40380930f$export$2e2bcd8739ae039).parseInt(segmentCount.toString()));
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var timestamp = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, timestamp);
                        resultMetadata.setTimestamp((0, $94ea729b332c6a19$export$2e2bcd8739ae039).parseLong(timestamp.toString()));
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var checksum = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, checksum);
                        resultMetadata.setChecksum((0, $902e90c40380930f$export$2e2bcd8739ae039).parseInt(checksum.toString()));
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var fileSize = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, fileSize);
                        resultMetadata.setFileSize((0, $94ea729b332c6a19$export$2e2bcd8739ae039).parseLong(fileSize.toString()));
                        break;
                    default:
                        throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
                }
                break;
            case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                codeIndex++;
                resultMetadata.setLastSegment(true);
                break;
            default:
                throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        }
        // copy optional fields to additional options
        if (optionalFieldsStart !== -1) {
            var optionalFieldsLength = codeIndex - optionalFieldsStart;
            if (resultMetadata.isLastSegment()) // do not include terminator
            optionalFieldsLength--;
            resultMetadata.setOptionalData((0, $eed4834329730fe6$export$2e2bcd8739ae039).copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
        }
        return codeIndex;
    };
    /**
     * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
     * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
     * well as selected control characters.
     *
     * @param codewords The array of codewords (data + error)
     * @param codeIndex The current index into the codeword array.
     * @param result    The decoded data is appended to the result.
     * @return The next index into the codeword array.
     */ DecodedBitStreamParser.textCompaction = function(codewords, codeIndex, result) {
        // 2 character per codeword
        var textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
        // Used to hold the byte compaction value if there is a mode shift
        var byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
        var index = 0;
        var end = false;
        while(codeIndex < codewords[0] && !end){
            var code = codewords[codeIndex++];
            if (code < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) {
                textCompactionData[index] = code / 30;
                textCompactionData[index + 1] = code % 30;
                index += 2;
            } else switch(code){
                case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                    // reinitialize text compaction mode to alpha sub mode
                    textCompactionData[index++] = DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                    codeIndex--;
                    end = true;
                    break;
                case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    // The Mode Shift codeword 913 shall cause a temporary
                    // switch from Text Compaction mode to Byte Compaction mode.
                    // This switch shall be in effect for only the next codeword,
                    // after which the mode shall revert to the prevailing sub-mode
                    // of the Text Compaction mode. Codeword 913 is only available
                    // in Text Compaction mode; its use is described in 5.4.2.4.
                    textCompactionData[index] = DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                    code = codewords[codeIndex++];
                    byteCompactionData[index] = code;
                    index++;
                    break;
            }
        }
        DecodedBitStreamParser.decodeTextCompaction(textCompactionData, byteCompactionData, index, result);
        return codeIndex;
    };
    /**
     * The Text Compaction mode includes all the printable ASCII characters
     * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
     * (9: e), LF or line feed (10: e), and CR or carriage
     * return (13: e). The Text Compaction mode also includes various latch
     * and shift characters which are used exclusively within the mode. The Text
     * Compaction mode encodes up to 2 characters per codeword. The compaction rules
     * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
     * switches are defined in 5.4.2.3.
     *
     * @param textCompactionData The text compaction data.
     * @param byteCompactionData The byte compaction data if there
     *                           was a mode shift.
     * @param length             The size of the text compaction and byte compaction data.
     * @param result             The decoded data is appended to the result.
     */ DecodedBitStreamParser.decodeTextCompaction = function(textCompactionData, byteCompactionData, length, result) {
        // Beginning from an initial state of the Alpha sub-mode
        // The default compaction mode for PDF417 in effect at the start of each symbol shall always be Text
        // Compaction mode Alpha sub-mode (alphabetic: uppercase). A latch codeword from another mode to the Text
        // Compaction mode shall always switch to the Text Compaction Alpha sub-mode.
        var subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
        var priorToShiftMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
        var i = 0;
        while(i < length){
            var subModeCh = textCompactionData[i];
            var ch = /*char*/ "";
            switch(subMode){
                case $6ae813d87bb7df8a$var$Mode.ALPHA:
                    // Alpha (alphabetic: uppercase)
                    if (subModeCh < 26) // Upper case Alpha Character
                    // Note: 65 = 'A' ASCII -> there is byte code of symbol
                    ch = /*(char)('A' + subModeCh) */ String.fromCharCode(65 + subModeCh);
                    else switch(subModeCh){
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.LL:
                            subMode = $6ae813d87bb7df8a$var$Mode.LOWER;
                            break;
                        case DecodedBitStreamParser.ML:
                            subMode = $6ae813d87bb7df8a$var$Mode.MIXED;
                            break;
                        case DecodedBitStreamParser.PS:
                            // Shift to punctuation
                            priorToShiftMode = subMode;
                            subMode = $6ae813d87bb7df8a$var$Mode.PUNCT_SHIFT;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $6ae813d87bb7df8a$var$Mode.LOWER:
                    // Lower (alphabetic: lowercase)
                    if (subModeCh < 26) ch = /*(char)('a' + subModeCh)*/ String.fromCharCode(97 + subModeCh);
                    else switch(subModeCh){
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.AS:
                            // Shift to alpha
                            priorToShiftMode = subMode;
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA_SHIFT;
                            break;
                        case DecodedBitStreamParser.ML:
                            subMode = $6ae813d87bb7df8a$var$Mode.MIXED;
                            break;
                        case DecodedBitStreamParser.PS:
                            // Shift to punctuation
                            priorToShiftMode = subMode;
                            subMode = $6ae813d87bb7df8a$var$Mode.PUNCT_SHIFT;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            // TODO Does this need to use the current character encoding? See other occurrences below
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $6ae813d87bb7df8a$var$Mode.MIXED:
                    // Mixed (punctuation: e)
                    if (subModeCh < DecodedBitStreamParser.PL) ch = DecodedBitStreamParser.MIXED_CHARS[subModeCh];
                    else switch(subModeCh){
                        case DecodedBitStreamParser.PL:
                            subMode = $6ae813d87bb7df8a$var$Mode.PUNCT;
                            break;
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.LL:
                            subMode = $6ae813d87bb7df8a$var$Mode.LOWER;
                            break;
                        case DecodedBitStreamParser.AL:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                        case DecodedBitStreamParser.PS:
                            // Shift to punctuation
                            priorToShiftMode = subMode;
                            subMode = $6ae813d87bb7df8a$var$Mode.PUNCT_SHIFT;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $6ae813d87bb7df8a$var$Mode.PUNCT:
                    // Punctuation
                    if (subModeCh < DecodedBitStreamParser.PAL) ch = DecodedBitStreamParser.PUNCT_CHARS[subModeCh];
                    else switch(subModeCh){
                        case DecodedBitStreamParser.PAL:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $6ae813d87bb7df8a$var$Mode.ALPHA_SHIFT:
                    // Restore sub-mode
                    subMode = priorToShiftMode;
                    if (subModeCh < 26) ch = /*(char)('A' + subModeCh)*/ String.fromCharCode(65 + subModeCh);
                    else switch(subModeCh){
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $6ae813d87bb7df8a$var$Mode.PUNCT_SHIFT:
                    // Restore sub-mode
                    subMode = priorToShiftMode;
                    if (subModeCh < DecodedBitStreamParser.PAL) ch = DecodedBitStreamParser.PUNCT_CHARS[subModeCh];
                    else switch(subModeCh){
                        case DecodedBitStreamParser.PAL:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            // PS before Shift-to-Byte is used as a padding character,
                            // see 5.4.2.4 of the specification
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $6ae813d87bb7df8a$var$Mode.ALPHA;
                            break;
                    }
                    break;
            }
            // if (ch !== 0) {
            if (ch !== "") // Append decoded character to result
            result.append(ch);
            i++;
        }
    };
    /**
     * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
     * This includes all ASCII characters value 0 to 127 inclusive and provides for international
     * character set support.
     *
     * @param mode      The byte compaction mode i.e. 901 or 924
     * @param codewords The array of codewords (data + error)
     * @param encoding  Currently active character encoding
     * @param codeIndex The current index into the codeword array.
     * @param result    The decoded data is appended to the result.
     * @return The next index into the codeword array.
     */ DecodedBitStreamParser.byteCompaction = function(mode, codewords, encoding, codeIndex, result) {
        var decodedBytes = new (0, $325362cb4e6f69b4$export$2e2bcd8739ae039)();
        var count = 0;
        var value = /*long*/ 0;
        var end = false;
        switch(mode){
            case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                // Total number of Byte Compaction characters to be encoded
                // is not a multiple of 6
                var byteCompactedCodewords = new Int32Array(6);
                var nextCode = codewords[codeIndex++];
                while(codeIndex < codewords[0] && !end){
                    byteCompactedCodewords[count++] = nextCode;
                    // Base 900
                    value = 900 * value + nextCode;
                    nextCode = codewords[codeIndex++];
                    // perhaps it should be ok to check only nextCode >= TEXT_COMPACTION_MODE_LATCH
                    switch(nextCode){
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                            codeIndex--;
                            end = true;
                            break;
                        default:
                            if (count % 5 === 0 && count > 0) {
                                // Decode every 5 codewords
                                // Convert to Base 256
                                for(var j /*int*/  = 0; j < 6; ++j)/* @note
                                     * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                                     * So the next bitwise operation could not be done with simple numbers
                                     */ decodedBytes.write(/*(byte)*/ Number($6ae813d87bb7df8a$var$createBigInt(value) >> $6ae813d87bb7df8a$var$createBigInt(8 * (5 - j))));
                                value = 0;
                                count = 0;
                            }
                            break;
                    }
                }
                // if the end of all codewords is reached the last codeword needs to be added
                if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) byteCompactedCodewords[count++] = nextCode;
                // If Byte Compaction mode is invoked with codeword 901,
                // the last group of codewords is interpreted directly
                // as one byte per codeword, without compaction.
                for(var i /*int*/  = 0; i < count; i++)decodedBytes.write(/*(byte)*/ byteCompactedCodewords[i]);
                break;
            case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                // Total number of Byte Compaction characters to be encoded
                // is an integer multiple of 6
                while(codeIndex < codewords[0] && !end){
                    var code = codewords[codeIndex++];
                    if (code < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) {
                        count++;
                        // Base 900
                        value = 900 * value + code;
                    } else switch(code){
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                            codeIndex--;
                            end = true;
                            break;
                    }
                    if (count % 5 === 0 && count > 0) {
                        // Decode every 5 codewords
                        // Convert to Base 256
                        /* @note
                         * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                         * So the next bitwise operation could not be done with simple numbers
                        */ for(var j /*int*/  = 0; j < 6; ++j)decodedBytes.write(/*(byte)*/ Number($6ae813d87bb7df8a$var$createBigInt(value) >> $6ae813d87bb7df8a$var$createBigInt(8 * (5 - j))));
                        value = 0;
                        count = 0;
                    }
                }
                break;
        }
        result.append((0, $3a88fa58822b35a1$export$2e2bcd8739ae039).decode(decodedBytes.toByteArray(), encoding));
        return codeIndex;
    };
    /**
     * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
     *
     * @param codewords The array of codewords (data + error)
     * @param codeIndex The current index into the codeword array.
     * @param result    The decoded data is appended to the result.
     * @return The next index into the codeword array.
     *
     * @throws FormatException
     */ DecodedBitStreamParser.numericCompaction = function(codewords, codeIndex /*int*/ , result) {
        var count = 0;
        var end = false;
        var numericCodewords = new Int32Array(DecodedBitStreamParser.MAX_NUMERIC_CODEWORDS);
        while(codeIndex < codewords[0] && !end){
            var code = codewords[codeIndex++];
            if (codeIndex === codewords[0]) end = true;
            if (code < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) {
                numericCodewords[count] = code;
                count++;
            } else switch(code){
                case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                    codeIndex--;
                    end = true;
                    break;
            }
            if ((count % DecodedBitStreamParser.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
                // Re-invoking Numeric Compaction mode (by using codeword 902
                // while in Numeric Compaction mode) serves  to terminate the
                // current Numeric Compaction mode grouping as described in 5.4.4.2,
                // and then to start a new one grouping.
                result.append(DecodedBitStreamParser.decodeBase900toBase10(numericCodewords, count));
                count = 0;
            }
        }
        return codeIndex;
    };
    /**
     * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
     *
     * @param codewords The array of codewords
     * @param count     The number of codewords
     * @return The decoded string representing the Numeric data.
     *
     * EXAMPLE
     * Encode the fifteen digit numeric string 000213298174000
     * Prefix the numeric string with a 1 and set the initial value of
     * t = 1 000 213 298 174 000
     * Calculate codeword 0
     * d0 = 1 000 213 298 174 000 mod 900 = 200
     *
     * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
     * Calculate codeword 1
     * d1 = 1 111 348 109 082 mod 900 = 282
     *
     * t = 1 111 348 109 082 div 900 = 1 234 831 232
     * Calculate codeword 2
     * d2 = 1 234 831 232 mod 900 = 632
     *
     * t = 1 234 831 232 div 900 = 1 372 034
     * Calculate codeword 3
     * d3 = 1 372 034 mod 900 = 434
     *
     * t = 1 372 034 div 900 = 1 524
     * Calculate codeword 4
     * d4 = 1 524 mod 900 = 624
     *
     * t = 1 524 div 900 = 1
     * Calculate codeword 5
     * d5 = 1 mod 900 = 1
     * t = 1 div 900 = 0
     * Codeword sequence is: 1, 624, 434, 632, 282, 200
     *
     * Decode the above codewords involves
     *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
     * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
     *
     * Remove leading 1 =>  Result is 000213298174000
     *
     * @throws FormatException
     */ DecodedBitStreamParser.decodeBase900toBase10 = function(codewords, count) {
        var result = $6ae813d87bb7df8a$var$createBigInt(0);
        for(var i /*int*/  = 0; i < count; i++)result += DecodedBitStreamParser.EXP900[count - i - 1] * $6ae813d87bb7df8a$var$createBigInt(codewords[i]);
        var resultString = result.toString();
        if (resultString.charAt(0) !== "1") throw new (0, $13fe167df36b6e3a$export$2e2bcd8739ae039)();
        return resultString.substring(1);
    };
    DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser.ECI_CHARSET = 927;
    DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser.PL = 25;
    DecodedBitStreamParser.LL = 27;
    DecodedBitStreamParser.AS = 27;
    DecodedBitStreamParser.ML = 28;
    DecodedBitStreamParser.AL = 28;
    DecodedBitStreamParser.PS = 29;
    DecodedBitStreamParser.PAL = 29;
    DecodedBitStreamParser.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'";
    DecodedBitStreamParser.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^";
    /**
     * Table containing values for the exponent of 900.
     * This is used in the numeric compaction decode algorithm.
     */ DecodedBitStreamParser.EXP900 = $6ae813d87bb7df8a$var$getBigIntConstructor() ? $6ae813d87bb7df8a$var$getEXP900() : [];
    DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS = 2;
    return DecodedBitStreamParser;
}();
var $6ae813d87bb7df8a$export$2e2bcd8739ae039 = $6ae813d87bb7df8a$var$DecodedBitStreamParser;



var $50c9c18aad93a23c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.Collection;
// import java.util.Formatter;
// import java.util.List;
/**
 * @author Guenther Grau
 */ var $50c9c18aad93a23c$var$PDF417ScanningDecoder = /** @class */ function() {
    function PDF417ScanningDecoder() {}
    /**
     * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
     *
     * columns. That way width can be deducted from the pattern column.
     * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
     * than it should be. This can happen if the scanner used a bad blackpoint.
     *
     * @param BitMatrix
     * @param image
     * @param ResultPoint
     * @param imageTopLeft
     * @param ResultPoint
     * @param imageBottomLeft
     * @param ResultPoint
     * @param imageTopRight
     * @param ResultPoint
     * @param imageBottomRight
     * @param int
     * @param minCodewordWidth
     * @param int
     * @param maxCodewordWidth
     *
     * @throws NotFoundException
     * @throws FormatException
     * @throws ChecksumException
     */ PDF417ScanningDecoder.decode = function(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
        var boundingBox = new (0, $8c5449399ae5c377$export$2e2bcd8739ae039)(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
        var leftRowIndicatorColumn = null;
        var rightRowIndicatorColumn = null;
        var detectionResult;
        for(var firstPass /*boolean*/  = true;; firstPass = false){
            if (imageTopLeft != null) leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
            if (imageTopRight != null) rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
            detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
            if (detectionResult == null) throw (0, $283aa2ad27179317$export$2e2bcd8739ae039).getNotFoundInstance();
            var resultBox = detectionResult.getBoundingBox();
            if (firstPass && resultBox != null && (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) boundingBox = resultBox;
            else break;
        }
        detectionResult.setBoundingBox(boundingBox);
        var maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
        detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
        detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
        var leftToRight = leftRowIndicatorColumn != null;
        for(var barcodeColumnCount /*int*/  = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++){
            var barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
            if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */ undefined) continue;
            var detectionResultColumn = void 0;
            if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) detectionResultColumn = new (0, $88fcb4d7821fd7fc$export$2e2bcd8739ae039)(boundingBox, barcodeColumn === 0);
            else detectionResultColumn = new (0, $1abaf97de2742615$export$2e2bcd8739ae039)(boundingBox);
            detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
            var startColumn = -1;
            var previousStartColumn = startColumn;
            // TODO start at a row for which we know the start position, then detect upwards and downwards from there.
            for(var imageRow /*int*/  = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++){
                startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
                if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
                    if (previousStartColumn === -1) continue;
                    startColumn = previousStartColumn;
                }
                var codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                if (codeword != null) {
                    detectionResultColumn.setCodeword(imageRow, codeword);
                    previousStartColumn = startColumn;
                    minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
                    maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
                }
            }
        }
        return PDF417ScanningDecoder.createDecoderResult(detectionResult);
    };
    /**
     *
     * @param leftRowIndicatorColumn
     * @param rightRowIndicatorColumn
     *
     * @throws NotFoundException
     */ PDF417ScanningDecoder.merge = function(leftRowIndicatorColumn, rightRowIndicatorColumn) {
        if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) return null;
        var barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
        if (barcodeMetadata == null) return null;
        var boundingBox = (0, $8c5449399ae5c377$export$2e2bcd8739ae039).merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
        return new (0, $971a4435c914c923$export$2e2bcd8739ae039)(barcodeMetadata, boundingBox);
    };
    /**
     *
     * @param rowIndicatorColumn
     *
     * @throws NotFoundException
     */ PDF417ScanningDecoder.adjustBoundingBox = function(rowIndicatorColumn) {
        var e_1, _a;
        if (rowIndicatorColumn == null) return null;
        var rowHeights = rowIndicatorColumn.getRowHeights();
        if (rowHeights == null) return null;
        var maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
        var missingStartRows = 0;
        try {
            for(var rowHeights_1 = $50c9c18aad93a23c$var$__values(rowHeights), rowHeights_1_1 = rowHeights_1.next(); !rowHeights_1_1.done; rowHeights_1_1 = rowHeights_1.next()){
                var rowHeight = rowHeights_1_1.value /*int*/ ;
                missingStartRows += maxRowHeight - rowHeight;
                if (rowHeight > 0) break;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (rowHeights_1_1 && !rowHeights_1_1.done && (_a = rowHeights_1.return)) _a.call(rowHeights_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var codewords = rowIndicatorColumn.getCodewords();
        for(var row /*int*/  = 0; missingStartRows > 0 && codewords[row] == null; row++)missingStartRows--;
        var missingEndRows = 0;
        for(var row /*int*/  = rowHeights.length - 1; row >= 0; row--){
            missingEndRows += maxRowHeight - rowHeights[row];
            if (rowHeights[row] > 0) break;
        }
        for(var row /*int*/  = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--)missingEndRows--;
        return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
    };
    PDF417ScanningDecoder.getMax = function(values) {
        var e_2, _a;
        var maxValue = -1;
        try {
            for(var values_1 = $50c9c18aad93a23c$var$__values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()){
                var value = values_1_1.value /*int*/ ;
                maxValue = Math.max(maxValue, value);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return maxValue;
    };
    PDF417ScanningDecoder.getBarcodeMetadata = function(leftRowIndicatorColumn, rightRowIndicatorColumn) {
        var leftBarcodeMetadata;
        if (leftRowIndicatorColumn == null || (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
        var rightBarcodeMetadata;
        if (rightRowIndicatorColumn == null || (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) return leftBarcodeMetadata;
        if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() && leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() && leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) return null;
        return leftBarcodeMetadata;
    };
    PDF417ScanningDecoder.getRowIndicatorColumn = function(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
        var rowIndicatorColumn = new (0, $88fcb4d7821fd7fc$export$2e2bcd8739ae039)(boundingBox, leftToRight);
        for(var i /*int*/  = 0; i < 2; i++){
            var increment = i === 0 ? 1 : -1;
            var startColumn = Math.trunc(Math.trunc(startPoint.getX()));
            for(var imageRow /*int*/  = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() && imageRow >= boundingBox.getMinY(); imageRow += increment){
                var codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                if (codeword != null) {
                    rowIndicatorColumn.setCodeword(imageRow, codeword);
                    if (leftToRight) startColumn = codeword.getStartX();
                    else startColumn = codeword.getEndX();
                }
            }
        }
        return rowIndicatorColumn;
    };
    /**
     *
     * @param detectionResult
     * @param BarcodeValue
     * @param param2
     * @param param3
     * @param barcodeMatrix
     *
     * @throws NotFoundException
     */ PDF417ScanningDecoder.adjustCodewordCount = function(detectionResult, barcodeMatrix) {
        var barcodeMatrix01 = barcodeMatrix[0][1];
        var numberOfCodewords = barcodeMatrix01.getValue();
        var calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() * detectionResult.getBarcodeRowCount() - PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
        if (numberOfCodewords.length === 0) {
            if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > (0, $43352c804aa61e30$export$2e2bcd8739ae039).MAX_CODEWORDS_IN_BARCODE) throw (0, $283aa2ad27179317$export$2e2bcd8739ae039).getNotFoundInstance();
            barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        } else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) // The calculated one is more reliable as it is derived from the row indicator columns
        barcodeMatrix01.setValue(calculatedNumberOfCodewords);
    };
    /**
     *
     * @param detectionResult
     *
     * @throws FormatException
     * @throws ChecksumException
     * @throws NotFoundException
     */ PDF417ScanningDecoder.createDecoderResult = function(detectionResult) {
        var barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
        PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
        var erasures /*Collection<Integer>*/  = new Array();
        var codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
        var ambiguousIndexValuesList = /*List<int[]>*/ [];
        var ambiguousIndexesList = /*Collection<Integer>*/ new Array();
        for(var row /*int*/  = 0; row < detectionResult.getBarcodeRowCount(); row++)for(var column /*int*/  = 0; column < detectionResult.getBarcodeColumnCount(); column++){
            var values = barcodeMatrix[row][column + 1].getValue();
            var codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
            if (values.length === 0) erasures.push(codewordIndex);
            else if (values.length === 1) codewords[codewordIndex] = values[0];
            else {
                ambiguousIndexesList.push(codewordIndex);
                ambiguousIndexValuesList.push(values);
            }
        }
        var ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
        for(var i /*int*/  = 0; i < ambiguousIndexValues.length; i++)ambiguousIndexValues[i] = ambiguousIndexValuesList[i];
        return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, (0, $43352c804aa61e30$export$2e2bcd8739ae039).toIntArray(erasures), (0, $43352c804aa61e30$export$2e2bcd8739ae039).toIntArray(ambiguousIndexesList), ambiguousIndexValues);
    };
    /**
     * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
     * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
     * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
     * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
     * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
     * so decoding the normal barcodes is not affected by this.
     *
     * @param erasureArray contains the indexes of erasures
     * @param ambiguousIndexes array with the indexes that have more than one most likely value
     * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
     * be the same length as the ambiguousIndexes array
     *
     * @throws FormatException
     * @throws ChecksumException
     */ PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues = function(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
        var ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
        var tries = 100;
        while(tries-- > 0){
            for(var i /*int*/  = 0; i < ambiguousIndexCount.length; i++)codewords[ambiguousIndexes[i]] = ambiguousIndexValues[i][ambiguousIndexCount[i]];
            try {
                return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
            } catch (err) {
                var ignored = err instanceof (0, $e19cfb3b440de53d$export$2e2bcd8739ae039);
                if (!ignored) throw err;
            }
            if (ambiguousIndexCount.length === 0) throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
            for(var i /*int*/  = 0; i < ambiguousIndexCount.length; i++)if (ambiguousIndexCount[i] < ambiguousIndexValues[i].length - 1) {
                ambiguousIndexCount[i]++;
                break;
            } else {
                ambiguousIndexCount[i] = 0;
                if (i === ambiguousIndexCount.length - 1) throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
            }
        }
        throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
    };
    PDF417ScanningDecoder.createBarcodeMatrix = function(detectionResult) {
        var e_3, _a, e_4, _b;
        // let barcodeMatrix: BarcodeValue[][] =
        // new BarcodeValue[detectionResult.getBarcodeRowCount()][detectionResult.getBarcodeColumnCount() + 2];
        var barcodeMatrix = Array.from({
            length: detectionResult.getBarcodeRowCount()
        }, function() {
            return new Array(detectionResult.getBarcodeColumnCount() + 2);
        });
        for(var row /*int*/  = 0; row < barcodeMatrix.length; row++)for(var column_1 /*int*/  = 0; column_1 < barcodeMatrix[row].length; column_1++)barcodeMatrix[row][column_1] = new (0, $b835928578a76812$export$2e2bcd8739ae039)();
        var column = 0;
        try {
            for(var _c = $50c9c18aad93a23c$var$__values(detectionResult.getDetectionResultColumns()), _d = _c.next(); !_d.done; _d = _c.next()){
                var detectionResultColumn = _d.value /*DetectionResultColumn*/ ;
                if (detectionResultColumn != null) try {
                    for(var _e = (e_4 = void 0, $50c9c18aad93a23c$var$__values(detectionResultColumn.getCodewords())), _f = _e.next(); !_f.done; _f = _e.next()){
                        var codeword = _f.value /*Codeword*/ ;
                        if (codeword != null) {
                            var rowNumber = codeword.getRowNumber();
                            if (rowNumber >= 0) {
                                if (rowNumber >= barcodeMatrix.length) continue;
                                barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                            }
                        }
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                column++;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return barcodeMatrix;
    };
    PDF417ScanningDecoder.isValidBarcodeColumn = function(detectionResult, barcodeColumn) {
        return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
    };
    PDF417ScanningDecoder.getStartColumn = function(detectionResult, barcodeColumn, imageRow, leftToRight) {
        var e_5, _a;
        var offset = leftToRight ? 1 : -1;
        var codeword = null;
        if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodeword(imageRow);
        if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
        codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
        if (codeword != null) return leftToRight ? codeword.getStartX() : codeword.getEndX();
        if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodewordNearby(imageRow);
        if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
        var skippedColumns = 0;
        while(PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)){
            barcodeColumn -= offset;
            try {
                for(var _b = (e_5 = void 0, $50c9c18aad93a23c$var$__values(detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords())), _c = _b.next(); !_c.done; _c = _b.next()){
                    var previousRowCodeword = _c.value /*Codeword*/ ;
                    if (previousRowCodeword != null) return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) + offset * skippedColumns * (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            skippedColumns++;
        }
        return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
    };
    PDF417ScanningDecoder.detectCodeword = function(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
        startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
        // we usually know fairly exact now how long a codeword is. We should provide minimum and maximum expected length
        // and try to adjust the read pixels, e.g. remove single pixel errors or try to cut off exceeding pixels.
        // min and maxCodewordWidth should not be used as they are calculated for the whole barcode an can be inaccurate
        // for the current position
        var moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
        if (moduleBitCount == null) return null;
        var endColumn;
        var codewordBitCount = (0, $ebab38c0c75ceb72$export$2e2bcd8739ae039).sum(moduleBitCount);
        if (leftToRight) endColumn = startColumn + codewordBitCount;
        else {
            for(var i /*int*/  = 0; i < moduleBitCount.length / 2; i++){
                var tmpCount = moduleBitCount[i];
                moduleBitCount[i] = moduleBitCount[moduleBitCount.length - 1 - i];
                moduleBitCount[moduleBitCount.length - 1 - i] = tmpCount;
            }
            endColumn = startColumn;
            startColumn = endColumn - codewordBitCount;
        }
        // TODO implement check for width and correction of black and white bars
        // use start (and maybe stop pattern) to determine if black bars are wider than white bars. If so, adjust.
        // should probably done only for codewords with a lot more than 17 bits.
        // The following fixes 10-1.png, which has wide black bars and small white bars
        //    for (let i /*int*/ = 0; i < moduleBitCount.length; i++) {
        //      if (i % 2 === 0) {
        //        moduleBitCount[i]--;
        //      } else {
        //        moduleBitCount[i]++;
        //      }
        //    }
        // We could also use the width of surrounding codewords for more accurate results, but this seems
        // sufficient for now
        if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) // We could try to use the startX and endX position of the codeword in the same column in the previous row,
        // create the bit count from it and normalize it to 8. This would help with single pixel errors.
        return null;
        var decodedValue = (0, $f98d346ffacfe264$export$2e2bcd8739ae039).getDecodedValue(moduleBitCount);
        var codeword = (0, $43352c804aa61e30$export$2e2bcd8739ae039).getCodeword(decodedValue);
        if (codeword === -1) return null;
        return new (0, $aaff1997abc48b91$export$2e2bcd8739ae039)(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
    };
    PDF417ScanningDecoder.getModuleBitCount = function(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
        var imageColumn = startColumn;
        var moduleBitCount = new Int32Array(8);
        var moduleNumber = 0;
        var increment = leftToRight ? 1 : -1;
        var previousPixelValue = leftToRight;
        while((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) && moduleNumber < moduleBitCount.length)if (image.get(imageColumn, imageRow) === previousPixelValue) {
            moduleBitCount[moduleNumber]++;
            imageColumn += increment;
        } else {
            moduleNumber++;
            previousPixelValue = !previousPixelValue;
        }
        if (moduleNumber === moduleBitCount.length || imageColumn === (leftToRight ? maxColumn : minColumn) && moduleNumber === moduleBitCount.length - 1) return moduleBitCount;
        return null;
    };
    PDF417ScanningDecoder.getNumberOfECCodeWords = function(barcodeECLevel) {
        return 2 << barcodeECLevel;
    };
    PDF417ScanningDecoder.adjustCodewordStartColumn = function(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
        var correctedStartColumn = codewordStartColumn;
        var increment = leftToRight ? -1 : 1;
        // there should be no black pixels before the start column. If there are, then we need to start earlier.
        for(var i /*int*/  = 0; i < 2; i++){
            while((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) && leftToRight === image.get(correctedStartColumn, imageRow)){
                if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) return codewordStartColumn;
                correctedStartColumn += increment;
            }
            increment = -increment;
            leftToRight = !leftToRight;
        }
        return correctedStartColumn;
    };
    PDF417ScanningDecoder.checkCodewordSkew = function(codewordSize, minCodewordWidth, maxCodewordWidth) {
        return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize && codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
    };
    /**
     * @throws FormatException,
     * @throws ChecksumException
     */ PDF417ScanningDecoder.decodeCodewords = function(codewords, ecLevel, erasures) {
        if (codewords.length === 0) throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        var numECCodewords = 1 << ecLevel + 1;
        var correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
        PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
        // Decode the codewords
        var decoderResult = (0, $6ae813d87bb7df8a$export$2e2bcd8739ae039).decode(codewords, "" + ecLevel);
        decoderResult.setErrorsCorrected(correctedErrorsCount);
        decoderResult.setErasures(erasures.length);
        return decoderResult;
    };
    /**
     * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
     * correct the errors in-place.</p>
     *
     * @param codewords   data and error correction codewords
     * @param erasures positions of any known erasures
     * @param numECCodewords number of error correction codewords that are available in codewords
     * @throws ChecksumException if error correction fails
     */ PDF417ScanningDecoder.correctErrors = function(codewords, erasures, numECCodewords) {
        if (erasures != null && erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS || numECCodewords < 0 || numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) // Too many errors or EC Codewords is corrupted
        throw (0, $e19cfb3b440de53d$export$2e2bcd8739ae039).getChecksumInstance();
        return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
    };
    /**
     * Verify that all is OK with the codeword array.
     * @throws FormatException
     */ PDF417ScanningDecoder.verifyCodewordCount = function(codewords, numECCodewords) {
        if (codewords.length < 4) // Codeword array size should be at least 4 allowing for
        // Count CW, At least one Data CW, Error Correction CW, Error Correction CW
        throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        // The first codeword, the Symbol Length Descriptor, shall always encode the total number of data
        // codewords in the symbol, including the Symbol Length Descriptor itself, data codewords and pad
        // codewords, but excluding the number of error correction codewords.
        var numberOfCodewords = codewords[0];
        if (numberOfCodewords > codewords.length) throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        if (numberOfCodewords === 0) {
            // Reset to the length of the array - 8 (Allow for at least level 3 Error Correction (8 Error Codewords)
            if (numECCodewords < codewords.length) codewords[0] = codewords.length - numECCodewords;
            else throw (0, $13fe167df36b6e3a$export$2e2bcd8739ae039).getFormatInstance();
        }
    };
    PDF417ScanningDecoder.getBitCountForCodeword = function(codeword) {
        var result = new Int32Array(8);
        var previousValue = 0;
        var i = result.length - 1;
        while(true){
            if ((codeword & 0x1) !== previousValue) {
                previousValue = codeword & 0x1;
                i--;
                if (i < 0) break;
            }
            result[i]++;
            codeword >>= 1;
        }
        return result;
    };
    PDF417ScanningDecoder.getCodewordBucketNumber = function(codeword) {
        if (codeword instanceof Int32Array) return this.getCodewordBucketNumber_Int32Array(codeword);
        return this.getCodewordBucketNumber_number(codeword);
    };
    PDF417ScanningDecoder.getCodewordBucketNumber_number = function(codeword) {
        return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
    };
    PDF417ScanningDecoder.getCodewordBucketNumber_Int32Array = function(moduleBitCount) {
        return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
    };
    PDF417ScanningDecoder.toString = function(barcodeMatrix) {
        var formatter = new (0, $d7946609c4ff0191$export$2e2bcd8739ae039)();
        // try (let formatter = new Formatter()) {
        for(var row /*int*/  = 0; row < barcodeMatrix.length; row++){
            formatter.format("Row %2d: ", row);
            for(var column /*int*/  = 0; column < barcodeMatrix[row].length; column++){
                var barcodeValue = barcodeMatrix[row][column];
                if (barcodeValue.getValue().length === 0) formatter.format("        ", null);
                else formatter.format("%4d(%2d)", barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
            }
            formatter.format("%n");
        }
        return formatter.toString();
    // }
    };
    /*final*/ PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    /*final*/ PDF417ScanningDecoder.MAX_ERRORS = 3;
    /*final*/ PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    /*final*/ PDF417ScanningDecoder.errorCorrection = new (0, $21b4ed341b0ece94$export$2e2bcd8739ae039)();
    return PDF417ScanningDecoder;
}();
var $50c9c18aad93a23c$export$2e2bcd8739ae039 = $50c9c18aad93a23c$var$PDF417ScanningDecoder;


var $6841739796f44583$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.List;
// import java.util.Map;
/**
 * This implementation can detect and decode PDF417 codes in an image.
 *
 * @author Guenther Grau
 */ var $6841739796f44583$var$PDF417Reader = /** @class */ function() {
    function PDF417Reader() {}
    // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
    /**
     * Locates and decodes a PDF417 code in an image.
     *
     * @return a String representing the content encoded by the PDF417 code
     * @throws NotFoundException if a PDF417 code cannot be found,
     * @throws FormatException if a PDF417 cannot be decoded
     * @throws ChecksumException
     */ // @Override
    PDF417Reader.prototype.decode = function(image, hints) {
        if (hints === void 0) hints = null;
        var result = PDF417Reader.decode(image, hints, false);
        if (result == null || result.length === 0 || result[0] == null) throw (0, $283aa2ad27179317$export$2e2bcd8739ae039).getNotFoundInstance();
        return result[0];
    };
    /**
     *
     * @param BinaryBitmap
     * @param image
     * @throws NotFoundException
     */ //   @Override
    PDF417Reader.prototype.decodeMultiple = function(image, hints) {
        if (hints === void 0) hints = null;
        try {
            return PDF417Reader.decode(image, hints, true);
        } catch (ignored) {
            if (ignored instanceof (0, $13fe167df36b6e3a$export$2e2bcd8739ae039) || ignored instanceof (0, $e19cfb3b440de53d$export$2e2bcd8739ae039)) throw (0, $283aa2ad27179317$export$2e2bcd8739ae039).getNotFoundInstance();
            throw ignored;
        }
    };
    /**
     *
     * @param image
     * @param hints
     * @param multiple
     *
     * @throws NotFoundException
     * @throws FormatExceptionß
     * @throws ChecksumException
     */ PDF417Reader.decode = function(image, hints, multiple) {
        var e_1, _a;
        var results = new Array();
        var detectorResult = (0, $50b4d6293d11c58b$export$2e2bcd8739ae039).detectMultiple(image, hints, multiple);
        try {
            for(var _b = $6841739796f44583$var$__values(detectorResult.getPoints()), _c = _b.next(); !_c.done; _c = _b.next()){
                var points = _c.value;
                var decoderResult = (0, $50c9c18aad93a23c$export$2e2bcd8739ae039).decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
                var result = new (0, $aa06c8d16b4c59af$export$2e2bcd8739ae039)(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, (0, $03ea32520a329dec$export$2e2bcd8739ae039).PDF_417);
                result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
                var pdf417ResultMetadata = decoderResult.getOther();
                if (pdf417ResultMetadata != null) result.putMetadata((0, $84e98e00dae0cad6$export$2e2bcd8739ae039).PDF417_EXTRA_METADATA, pdf417ResultMetadata);
                results.push(result);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return results.map(function(x) {
            return x;
        });
    };
    PDF417Reader.getMaxWidth = function(p1, p2) {
        if (p1 == null || p2 == null) return 0;
        return Math.trunc(Math.abs(p1.getX() - p2.getX()));
    };
    PDF417Reader.getMinWidth = function(p1, p2) {
        if (p1 == null || p2 == null) return (0, $902e90c40380930f$export$2e2bcd8739ae039).MAX_VALUE;
        return Math.trunc(Math.abs(p1.getX() - p2.getX()));
    };
    PDF417Reader.getMaxCodewordWidth = function(p) {
        return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD / (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD / (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_STOP_PATTERN)));
    };
    PDF417Reader.getMinCodewordWidth = function(p) {
        return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD / (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_CODEWORD / (0, $43352c804aa61e30$export$2e2bcd8739ae039).MODULES_IN_STOP_PATTERN)));
    };
    // @Override
    PDF417Reader.prototype.reset = function() {
    // nothing needs to be reset
    };
    return PDF417Reader;
}();
var $6841739796f44583$export$2e2bcd8739ae039 = $6841739796f44583$var$PDF417Reader;



var $059d922e5e187179$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $059d922e5e187179$var$ReaderException = /** @class */ function(_super) {
    $059d922e5e187179$var$__extends(ReaderException, _super);
    function ReaderException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReaderException.kind = "ReaderException";
    return ReaderException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $059d922e5e187179$export$2e2bcd8739ae039 = $059d922e5e187179$var$ReaderException;


var $ccdcd020240b91dc$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*namespace com.google.zxing {*/ /**
 * MultiFormatReader is a convenience class and the main entry point into the library for most uses.
 * By default it attempts to decode all barcode formats that the library supports. Optionally, you
 * can provide a hints object to request different behavior, for example only decoding QR codes.
 *
 * @author Sean Owen
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ccdcd020240b91dc$var$MultiFormatReader = /** @class */ function() {
    function MultiFormatReader() {}
    /**
     * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
     * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
     * Use setHints() followed by decodeWithState() for continuous scan applications.
     *
     * @param image The pixel data to decode
     * @return The contents of the image
     *
     * @throws NotFoundException Any errors which occurred
     */ /*@Override*/ // public decode(image: BinaryBitmap): Result {
    //   setHints(null)
    //   return decodeInternal(image)
    // }
    /**
     * Decode an image using the hints provided. Does not honor existing state.
     *
     * @param image The pixel data to decode
     * @param hints The hints to use, clearing the previous state.
     * @return The contents of the image
     *
     * @throws NotFoundException Any errors which occurred
     */ /*@Override*/ MultiFormatReader.prototype.decode = function(image, hints) {
        this.setHints(hints);
        return this.decodeInternal(image);
    };
    /**
     * Decode an image using the state set up by calling setHints() previously. Continuous scan
     * clients will get a <b>large</b> speed increase by using this instead of decode().
     *
     * @param image The pixel data to decode
     * @return The contents of the image
     *
     * @throws NotFoundException Any errors which occurred
     */ MultiFormatReader.prototype.decodeWithState = function(image) {
        // Make sure to set up the default state so we don't crash
        if (this.readers === null || this.readers === undefined) this.setHints(null);
        return this.decodeInternal(image);
    };
    /**
     * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
     * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
     * is important for performance in continuous scan clients.
     *
     * @param hints The set of hints to use for subsequent calls to decode(image)
     */ MultiFormatReader.prototype.setHints = function(hints) {
        this.hints = hints;
        var tryHarder = hints !== null && hints !== undefined && undefined !== hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).TRY_HARDER);
        /*@SuppressWarnings("unchecked")*/ var formats = hints === null || hints === undefined ? null : hints.get((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).POSSIBLE_FORMATS);
        var readers = new Array();
        if (formats !== null && formats !== undefined) {
            var addOneDReader = formats.some(function(f) {
                return f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_A || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).UPC_E || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13 || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_8 || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODABAR || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_39 || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_93 || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).CODE_128 || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).ITF || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).RSS_14 || f === (0, $03ea32520a329dec$export$2e2bcd8739ae039).RSS_EXPANDED;
            });
            // Put 1D readers upfront in "normal" mode
            // TYPESCRIPTPORT: TODO: uncomment below as they are ported
            if (addOneDReader && !tryHarder) readers.push(new (0, $9f6904b1e7c47f99$export$2e2bcd8739ae039)(hints));
            if (formats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).QR_CODE)) readers.push(new (0, $1d4319be5d5105ae$export$2e2bcd8739ae039)());
            if (formats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).DATA_MATRIX)) readers.push(new (0, $4ec6a75867c073ad$export$2e2bcd8739ae039)());
            if (formats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).AZTEC)) readers.push(new (0, $b5a91da25a9d81df$export$2e2bcd8739ae039)());
            if (formats.includes((0, $03ea32520a329dec$export$2e2bcd8739ae039).PDF_417)) readers.push(new (0, $6841739796f44583$export$2e2bcd8739ae039)());
            // if (formats.includes(BarcodeFormat.MAXICODE)) {
            //    readers.push(new MaxiCodeReader())
            // }
            // At end in "try harder" mode
            if (addOneDReader && tryHarder) readers.push(new (0, $9f6904b1e7c47f99$export$2e2bcd8739ae039)(hints));
        }
        if (readers.length === 0) {
            if (!tryHarder) readers.push(new (0, $9f6904b1e7c47f99$export$2e2bcd8739ae039)(hints));
            readers.push(new (0, $1d4319be5d5105ae$export$2e2bcd8739ae039)());
            readers.push(new (0, $4ec6a75867c073ad$export$2e2bcd8739ae039)());
            readers.push(new (0, $b5a91da25a9d81df$export$2e2bcd8739ae039)());
            readers.push(new (0, $6841739796f44583$export$2e2bcd8739ae039)());
            // readers.push(new MaxiCodeReader())
            if (tryHarder) readers.push(new (0, $9f6904b1e7c47f99$export$2e2bcd8739ae039)(hints));
        }
        this.readers = readers; // .toArray(new Reader[readers.size()])
    };
    /*@Override*/ MultiFormatReader.prototype.reset = function() {
        var e_1, _a;
        if (this.readers !== null) try {
            for(var _b = $ccdcd020240b91dc$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                reader.reset();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * @throws NotFoundException
     */ MultiFormatReader.prototype.decodeInternal = function(image) {
        var e_2, _a;
        if (this.readers === null) throw new (0, $059d922e5e187179$export$2e2bcd8739ae039)("No readers where selected, nothing can be read.");
        try {
            for(var _b = $ccdcd020240b91dc$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                // Trying to decode with ${reader} reader.
                try {
                    return reader.decode(image, this.hints);
                } catch (ex) {
                    if (ex instanceof (0, $059d922e5e187179$export$2e2bcd8739ae039)) continue;
                // Bad Exception.
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        throw new (0, $283aa2ad27179317$export$2e2bcd8739ae039)("No MultiFormat Readers were able to detect the code.");
    };
    return MultiFormatReader;
}();
var $ccdcd020240b91dc$export$2e2bcd8739ae039 = $ccdcd020240b91dc$var$MultiFormatReader;


var $e4b571a0a718c980$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e4b571a0a718c980$export$5632271b582b8149 = /** @class */ function(_super) {
    $e4b571a0a718c980$var$__extends(BrowserMultiFormatReader, _super);
    function BrowserMultiFormatReader(hints, timeBetweenScansMillis) {
        if (hints === void 0) hints = null;
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        var _this = this;
        var reader = new (0, $ccdcd020240b91dc$export$2e2bcd8739ae039)();
        reader.setHints(hints);
        _this = _super.call(this, reader, timeBetweenScansMillis) || this;
        return _this;
    }
    /**
     * Overwrite decodeBitmap to call decodeWithState, which will pay
     * attention to the hints set in the constructor function
     */ BrowserMultiFormatReader.prototype.decodeBitmap = function(binaryBitmap) {
        return this.reader.decodeWithState(binaryBitmap);
    };
    return BrowserMultiFormatReader;
}((0, $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607));




var $d1b86ffb751862b2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * QR Code reader to use from browser.
 */ var $d1b86ffb751862b2$export$6b868e6b4d8be0c6 = /** @class */ function(_super) {
    $d1b86ffb751862b2$var$__extends(BrowserPDF417Reader, _super);
    /**
     * Creates an instance of BrowserPDF417Reader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     */ function BrowserPDF417Reader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $6841739796f44583$export$2e2bcd8739ae039)(), timeBetweenScansMillis) || this;
    }
    return BrowserPDF417Reader;
}((0, $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607));




var $2c21890cd4e45395$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * QR Code reader to use from browser.
 */ var $2c21890cd4e45395$export$da7a4b0ac9ceab04 = /** @class */ function(_super) {
    $2c21890cd4e45395$var$__extends(BrowserQRCodeReader, _super);
    /**
     * Creates an instance of BrowserQRCodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     */ function BrowserQRCodeReader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $1d4319be5d5105ae$export$2e2bcd8739ae039)(), timeBetweenScansMillis) || this;
    }
    return BrowserQRCodeReader;
}((0, $d9cadefb0b7bb79e$export$7b30a0ae0c6e0607));


/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * These are a set of hints that you may pass to Writers to specify their behavior.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $0186ee20139e7364$var$EncodeHintType;
(function(EncodeHintType) {
    /**
     * Specifies what degree of error correction to use, for example in QR Codes.
     * Type depends on the encoder. For example for QR codes it's type
     * {@link com.google.zxing.qrcode.decoder.ErrorCorrectionLevel ErrorCorrectionLevel}.
     * For Aztec it is of type {@link Integer}, representing the minimal percentage of error correction words.
     * For PDF417 it is of type {@link Integer}, valid values being 0 to 8.
     * In all cases, it can also be a {@link String} representation of the desired value as well.
     * Note: an Aztec symbol should have a minimum of 25% EC words.
     */ EncodeHintType[EncodeHintType["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
    /**
     * Specifies what character encoding to use where applicable (type {@link String})
     */ EncodeHintType[EncodeHintType["CHARACTER_SET"] = 1] = "CHARACTER_SET";
    /**
     * Specifies the matrix shape for Data Matrix (type {@link com.google.zxing.datamatrix.encoder.SymbolShapeHint})
     */ EncodeHintType[EncodeHintType["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
    /**
     * Specifies whether to use compact mode for Data Matrix (type {@link Boolean}, or "true" or "false"
     * {@link String } value).
     * The compact encoding mode also supports the encoding of characters that are not in the ISO-8859-1
     * character set via ECIs.
     * Please note that in that case, the most compact character encoding is chosen for characters in
     * the input that are not in the ISO-8859-1 character set. Based on experience, some scanners do not
     * support encodings like cp-1256 (Arabic). In such cases the encoding can be forced to UTF-8 by
     * means of the {@link #CHARACTER_SET} encoding hint.
     * Compact encoding also provides GS1-FNC1 support when {@link #GS1_FORMAT} is selected. In this case
     * group-separator character (ASCII 29 decimal) can be used to encode the positions of FNC1 codewords
     * for the purpose of delimiting AIs.
     * This option and {@link #FORCE_C40} are mutually exclusive.
     */ EncodeHintType[EncodeHintType["DATA_MATRIX_COMPACT"] = 3] = "DATA_MATRIX_COMPACT";
    /**
     * Specifies a minimum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
     *
     * @deprecated use width/height params in
     * {@link com.google.zxing.datamatrix.DataMatrixWriter#encode(String, BarcodeFormat, int, int)}
     */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MIN_SIZE"] = 4] = "MIN_SIZE";
    /**
     * Specifies a maximum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
     *
     * @deprecated without replacement
     */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MAX_SIZE"] = 5] = "MAX_SIZE";
    /**
     * Specifies margin, in pixels, to use when generating the barcode. The meaning can vary
     * by format; for example it controls margin before and after the barcode horizontally for
     * most 1D formats. (Type {@link Integer}, or {@link String} representation of the integer value).
     */ EncodeHintType[EncodeHintType["MARGIN"] = 6] = "MARGIN";
    /**
     * Specifies whether to use compact mode for PDF417 (type {@link Boolean}, or "true" or "false"
     * {@link String} value).
     */ EncodeHintType[EncodeHintType["PDF417_COMPACT"] = 7] = "PDF417_COMPACT";
    /**
     * Specifies what compaction mode to use for PDF417 (type
     * {@link com.google.zxing.pdf417.encoder.Compaction Compaction} or {@link String} value of one of its
     * enum values).
     */ EncodeHintType[EncodeHintType["PDF417_COMPACTION"] = 8] = "PDF417_COMPACTION";
    /**
     * Specifies the minimum and maximum number of rows and columns for PDF417 (type
     * {@link com.google.zxing.pdf417.encoder.Dimensions Dimensions}).
     */ EncodeHintType[EncodeHintType["PDF417_DIMENSIONS"] = 9] = "PDF417_DIMENSIONS";
    /**
     * Specifies the required number of layers for an Aztec code.
     * A negative number (-1, -2, -3, -4) specifies a compact Aztec code.
     * 0 indicates to use the minimum number of layers (the default).
     * A positive number (1, 2, .. 32) specifies a normal (non-compact) Aztec code.
     * (Type {@link Integer}, or {@link String} representation of the integer value).
     */ EncodeHintType[EncodeHintType["AZTEC_LAYERS"] = 10] = "AZTEC_LAYERS";
    /**
     * Specifies the exact version of QR code to be encoded.
     * (Type {@link Integer}, or {@link String} representation of the integer value).
     */ EncodeHintType[EncodeHintType["QR_VERSION"] = 11] = "QR_VERSION";
    /**
     * Specifies whether the data should be encoded to the GS1 standard (type {@link Boolean}, or "true" or "false"
     * {@link String } value).
     */ EncodeHintType[EncodeHintType["GS1_FORMAT"] = 12] = "GS1_FORMAT";
    /**
     * Forces C40 encoding for data-matrix (type {@link Boolean}, or "true" or "false") {@link String } value). This
     * option and {@link #DATA_MATRIX_COMPACT} are mutually exclusive.
     */ EncodeHintType[EncodeHintType["FORCE_C40"] = 13] = "FORCE_C40";
})($0186ee20139e7364$var$EncodeHintType || ($0186ee20139e7364$var$EncodeHintType = {}));
var $0186ee20139e7364$export$2e2bcd8739ae039 = $0186ee20139e7364$var$EncodeHintType;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/**
 * <p>Implements Reed-Solomon encoding, as the name implies.</p>
 *
 * @author Sean Owen
 * @author William Rucklidge
 */ var $72dc1ddcdc47f39a$var$ReedSolomonEncoder = /** @class */ function() {
    /**
     * A reed solomon error-correcting encoding constructor is created by
     * passing as Galois Field with of size equal to the number of code
     * words (symbols) in the alphabet (the number of values in each
     * element of arrays that are encoded/decoded).
     * @param field A galois field with a number of elements equal to the size
     * of the alphabet of symbols to encode.
     */ function ReedSolomonEncoder(field) {
        this.field = field;
        this.cachedGenerators = [];
        this.cachedGenerators.push(new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(field, Int32Array.from([
            1
        ])));
    }
    ReedSolomonEncoder.prototype.buildGenerator = function(degree /*int*/ ) {
        var cachedGenerators = this.cachedGenerators;
        if (degree >= cachedGenerators.length) {
            var lastGenerator = cachedGenerators[cachedGenerators.length - 1];
            var field = this.field;
            for(var d = cachedGenerators.length; d <= degree; d++){
                var nextGenerator = lastGenerator.multiply(new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(field, Int32Array.from([
                    1,
                    field.exp(d - 1 + field.getGeneratorBase())
                ])));
                cachedGenerators.push(nextGenerator);
                lastGenerator = nextGenerator;
            }
        }
        return cachedGenerators[degree];
    };
    /**
     * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
     * to detect and correct errors that may have been introduced when the resulting
     * data is stored or transmitted.</p>
     *
     * @param toEncode array used for both and output. Caller initializes the array with
     * the code words (symbols) to be encoded followed by empty elements allocated to make
     * space for error-correction code words in the encoded output. The array contains
     * the encdoded output when encode returns. Code words are encoded as numbers from
     * 0 to n-1, where n is the number of possible code words (symbols), as determined
     * by the size of the Galois Field passed in the constructor of this object.
     * @param ecBytes the number of elements reserved in the array (first parameter)
     * to store error-correction code words. Thus, the number of code words (symbols)
     * to encode in the first parameter is thus toEncode.length - ecBytes.
     * Note, the use of "bytes" in the name of this parameter is misleading, as there may
     * be more or fewer than 256 symbols being encoded, as determined by the number of
     * elements in the Galois Field passed as a constructor to this object.
     * @throws IllegalArgumentException thrown in response to validation errros.
     */ ReedSolomonEncoder.prototype.encode = function(toEncode, ecBytes /*int*/ ) {
        if (ecBytes === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("No error correction bytes");
        var dataBytes = toEncode.length - ecBytes;
        if (dataBytes <= 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("No data bytes provided");
        var generator = this.buildGenerator(ecBytes);
        var infoCoefficients = new Int32Array(dataBytes);
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
        var info = new (0, $a366de35f27fadf9$export$2e2bcd8739ae039)(this.field, infoCoefficients);
        info = info.multiplyByMonomial(ecBytes, 1);
        var remainder = info.divide(generator)[1];
        var coefficients = remainder.getCoefficients();
        var numZeroCoefficients = ecBytes - coefficients.length;
        for(var i = 0; i < numZeroCoefficients; i++)toEncode[dataBytes + i] = 0;
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
    };
    return ReedSolomonEncoder;
}();
var $72dc1ddcdc47f39a$export$2e2bcd8739ae039 = $72dc1ddcdc47f39a$var$ReedSolomonEncoder;




/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * @author Satoru Takabayashi
 * @author Daniel Switkin
 * @author Sean Owen
 */ var $a4b980a466ad6cdb$var$MaskUtil = /** @class */ function() {
    function MaskUtil() {
    // do nothing
    }
    /**
     * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
     * give penalty to them. Example: 00000 or 11111.
     */ MaskUtil.applyMaskPenaltyRule1 = function(matrix) {
        return MaskUtil.applyMaskPenaltyRule1Internal(matrix, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix, false);
    };
    /**
     * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
     * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
     * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
     */ MaskUtil.applyMaskPenaltyRule2 = function(matrix) {
        var penalty = 0;
        var array = matrix.getArray();
        var width = matrix.getWidth();
        var height = matrix.getHeight();
        for(var y = 0; y < height - 1; y++){
            var arrayY = array[y];
            for(var x = 0; x < width - 1; x++){
                var value = arrayY[x];
                if (value === arrayY[x + 1] && value === array[y + 1][x] && value === array[y + 1][x + 1]) penalty++;
            }
        }
        return MaskUtil.N2 * penalty;
    };
    /**
     * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
     * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
     * find patterns like 000010111010000, we give penalty once.
     */ MaskUtil.applyMaskPenaltyRule3 = function(matrix) {
        var numPenalties = 0;
        var array = matrix.getArray();
        var width = matrix.getWidth();
        var height = matrix.getHeight();
        for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
            var arrayY = array[y]; // We can at least optimize this access
            if (x + 6 < width && arrayY[x] === 1 && arrayY[x + 1] === 0 && arrayY[x + 2] === 1 && arrayY[x + 3] === 1 && arrayY[x + 4] === 1 && arrayY[x + 5] === 0 && arrayY[x + 6] === 1 && (MaskUtil.isWhiteHorizontal(arrayY, x - 4, x) || MaskUtil.isWhiteHorizontal(arrayY, x + 7, x + 11))) numPenalties++;
            if (y + 6 < height && array[y][x] === 1 && array[y + 1][x] === 0 && array[y + 2][x] === 1 && array[y + 3][x] === 1 && array[y + 4][x] === 1 && array[y + 5][x] === 0 && array[y + 6][x] === 1 && (MaskUtil.isWhiteVertical(array, x, y - 4, y) || MaskUtil.isWhiteVertical(array, x, y + 7, y + 11))) numPenalties++;
        }
        return numPenalties * MaskUtil.N3;
    };
    MaskUtil.isWhiteHorizontal = function(rowArray, from /*int*/ , to /*int*/ ) {
        from = Math.max(from, 0);
        to = Math.min(to, rowArray.length);
        for(var i = from; i < to; i++){
            if (rowArray[i] === 1) return false;
        }
        return true;
    };
    MaskUtil.isWhiteVertical = function(array, col /*int*/ , from /*int*/ , to /*int*/ ) {
        from = Math.max(from, 0);
        to = Math.min(to, array.length);
        for(var i = from; i < to; i++){
            if (array[i][col] === 1) return false;
        }
        return true;
    };
    /**
     * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
     * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
     */ MaskUtil.applyMaskPenaltyRule4 = function(matrix) {
        var numDarkCells = 0;
        var array = matrix.getArray();
        var width = matrix.getWidth();
        var height = matrix.getHeight();
        for(var y = 0; y < height; y++){
            var arrayY = array[y];
            for(var x = 0; x < width; x++)if (arrayY[x] === 1) numDarkCells++;
        }
        var numTotalCells = matrix.getHeight() * matrix.getWidth();
        var fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
        return fivePercentVariances * MaskUtil.N4;
    };
    /**
     * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
     * pattern conditions.
     */ MaskUtil.getDataMaskBit = function(maskPattern /*int*/ , x /*int*/ , y /*int*/ ) {
        var intermediate; /*int*/ 
        var temp; /*int*/ 
        switch(maskPattern){
            case 0:
                intermediate = y + x & 0x1;
                break;
            case 1:
                intermediate = y & 0x1;
                break;
            case 2:
                intermediate = x % 3;
                break;
            case 3:
                intermediate = (y + x) % 3;
                break;
            case 4:
                intermediate = Math.floor(y / 2) + Math.floor(x / 3) & 0x1;
                break;
            case 5:
                temp = y * x;
                intermediate = (temp & 0x1) + temp % 3;
                break;
            case 6:
                temp = y * x;
                intermediate = (temp & 0x1) + temp % 3 & 0x1;
                break;
            case 7:
                temp = y * x;
                intermediate = temp % 3 + (y + x & 0x1) & 0x1;
                break;
            default:
                throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Invalid mask pattern: " + maskPattern);
        }
        return intermediate === 0;
    };
    /**
     * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
     * vertical and horizontal orders respectively.
     */ MaskUtil.applyMaskPenaltyRule1Internal = function(matrix, isHorizontal) {
        var penalty = 0;
        var iLimit = isHorizontal ? matrix.getHeight() : matrix.getWidth();
        var jLimit = isHorizontal ? matrix.getWidth() : matrix.getHeight();
        var array = matrix.getArray();
        for(var i = 0; i < iLimit; i++){
            var numSameBitCells = 0;
            var prevBit = -1;
            for(var j = 0; j < jLimit; j++){
                var bit = isHorizontal ? array[i][j] : array[j][i];
                if (bit === prevBit) numSameBitCells++;
                else {
                    if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
                    numSameBitCells = 1; // Include the cell itself.
                    prevBit = bit;
                }
            }
            if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
        }
        return penalty;
    };
    // Penalty weights from section 6.8.2.1
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;
    return MaskUtil;
}();
var $a4b980a466ad6cdb$export$2e2bcd8739ae039 = $a4b980a466ad6cdb$var$MaskUtil;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $ecede4972a598cfe$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * JAVAPORT: The original code was a 2D array of ints, but since it only ever gets assigned
 * -1, 0, and 1, I'm going to use less memory and go with bytes.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ecede4972a598cfe$var$ByteMatrix = /** @class */ function() {
    function ByteMatrix(width /*int*/ , height /*int*/ ) {
        this.width = width;
        this.height = height;
        var bytes = new Array(height); // [height][width]
        for(var i = 0; i !== height; i++)bytes[i] = new Uint8Array(width);
        this.bytes = bytes;
    }
    ByteMatrix.prototype.getHeight = function() {
        return this.height;
    };
    ByteMatrix.prototype.getWidth = function() {
        return this.width;
    };
    ByteMatrix.prototype.get = function(x /*int*/ , y /*int*/ ) {
        return this.bytes[y][x];
    };
    /**
     * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
     */ ByteMatrix.prototype.getArray = function() {
        return this.bytes;
    };
    // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
    ByteMatrix.prototype.setNumber = function(x /*int*/ , y /*int*/ , value /*byte|int*/ ) {
        this.bytes[y][x] = value;
    };
    // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
    //   bytes[y][x] = (byte) value
    // }
    ByteMatrix.prototype.setBoolean = function(x /*int*/ , y /*int*/ , value) {
        this.bytes[y][x] = /*(byte) */ value ? 1 : 0;
    };
    ByteMatrix.prototype.clear = function(value /*byte*/ ) {
        var e_1, _a;
        try {
            for(var _b = $ecede4972a598cfe$var$__values(this.bytes), _c = _b.next(); !_c.done; _c = _b.next()){
                var aByte = _c.value;
                (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(aByte, value);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ByteMatrix.prototype.equals = function(o) {
        if (!(o instanceof ByteMatrix)) return false;
        var other = o;
        if (this.width !== other.width) return false;
        if (this.height !== other.height) return false;
        for(var y = 0, height = this.height; y < height; ++y){
            var bytesY = this.bytes[y];
            var otherBytesY = other.bytes[y];
            for(var x = 0, width = this.width; x < width; ++x){
                if (bytesY[x] !== otherBytesY[x]) return false;
            }
        }
        return true;
    };
    /*@Override*/ ByteMatrix.prototype.toString = function() {
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)(); // (2 * width * height + 2)
        for(var y = 0, height = this.height; y < height; ++y){
            var bytesY = this.bytes[y];
            for(var x = 0, width = this.width; x < width; ++x)switch(bytesY[x]){
                case 0:
                    result.append(" 0");
                    break;
                case 1:
                    result.append(" 1");
                    break;
                default:
                    result.append("  ");
                    break;
            }
            result.append("\n");
        }
        return result.toString();
    };
    return ByteMatrix;
}();
var $ecede4972a598cfe$export$2e2bcd8739ae039 = $ecede4972a598cfe$var$ByteMatrix;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * @author satorux@google.com (Satoru Takabayashi) - creator
 * @author dswitkin@google.com (Daniel Switkin) - ported from C++
 */ var $d5b77ba9d7a3f4c8$var$QRCode = /** @class */ function() {
    function QRCode() {
        this.maskPattern = -1;
    }
    QRCode.prototype.getMode = function() {
        return this.mode;
    };
    QRCode.prototype.getECLevel = function() {
        return this.ecLevel;
    };
    QRCode.prototype.getVersion = function() {
        return this.version;
    };
    QRCode.prototype.getMaskPattern = function() {
        return this.maskPattern;
    };
    QRCode.prototype.getMatrix = function() {
        return this.matrix;
    };
    /*@Override*/ QRCode.prototype.toString = function() {
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)(); // (200)
        result.append("<<\n");
        result.append(" mode: ");
        result.append(this.mode ? this.mode.toString() : "null");
        result.append("\n ecLevel: ");
        result.append(this.ecLevel ? this.ecLevel.toString() : "null");
        result.append("\n version: ");
        result.append(this.version ? this.version.toString() : "null");
        result.append("\n maskPattern: ");
        result.append(this.maskPattern.toString());
        if (this.matrix) {
            result.append("\n matrix:\n");
            result.append(this.matrix.toString());
        } else result.append("\n matrix: null\n");
        result.append(">>\n");
        return result.toString();
    };
    QRCode.prototype.setMode = function(value) {
        this.mode = value;
    };
    QRCode.prototype.setECLevel = function(value) {
        this.ecLevel = value;
    };
    QRCode.prototype.setVersion = function(version) {
        this.version = version;
    };
    QRCode.prototype.setMaskPattern = function(value /*int*/ ) {
        this.maskPattern = value;
    };
    QRCode.prototype.setMatrix = function(value) {
        this.matrix = value;
    };
    // Check if "mask_pattern" is valid.
    QRCode.isValidMaskPattern = function(maskPattern /*int*/ ) {
        return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
    };
    QRCode.NUM_MASK_PATTERNS = 8;
    return QRCode;
}();
var $d5b77ba9d7a3f4c8$export$2e2bcd8739ae039 = $d5b77ba9d7a3f4c8$var$QRCode;


/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.encoder {*/ 




var $c94bb32e0deea8cb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $c94bb32e0deea8cb$var$WriterException = /** @class */ function(_super) {
    $c94bb32e0deea8cb$var$__extends(WriterException, _super);
    function WriterException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WriterException.kind = "WriterException";
    return WriterException;
}((0, $7715bd82b11d6dee$export$2e2bcd8739ae039));
var $c94bb32e0deea8cb$export$2e2bcd8739ae039 = $c94bb32e0deea8cb$var$WriterException;



/**
 * @author satorux@google.com (Satoru Takabayashi) - creator
 * @author dswitkin@google.com (Daniel Switkin) - ported from C++
 */ var $838e0c7b6b356f41$var$MatrixUtil = /** @class */ function() {
    function MatrixUtil() {
    // do nothing
    }
    // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
    //
    // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
    // with the ByteMatrix initialized all to zero.
    MatrixUtil.clearMatrix = function(matrix) {
        // TYPESCRIPTPORT: we use UintArray se changed here from -1 to 255
        matrix.clear(/*(byte) */ /*-1*/ 255);
    };
    // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
    // success, store the result in "matrix" and return true.
    MatrixUtil.buildMatrix = function(dataBits, ecLevel, version, maskPattern /*int*/ , matrix) {
        MatrixUtil.clearMatrix(matrix);
        MatrixUtil.embedBasicPatterns(version, matrix);
        // Type information appear with any version.
        MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix);
        // Version info appear if version >= 7.
        MatrixUtil.maybeEmbedVersionInfo(version, matrix);
        // Data should be embedded at end.
        MatrixUtil.embedDataBits(dataBits, maskPattern, matrix);
    };
    // Embed basic patterns. On success, modify the matrix and return true.
    // The basic patterns are:
    // - Position detection patterns
    // - Timing patterns
    // - Dark dot at the left bottom corner
    // - Position adjustment patterns, if need be
    MatrixUtil.embedBasicPatterns = function(version, matrix) {
        // Let's get started with embedding big squares at corners.
        MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix);
        // Then, embed the dark dot at the left bottom corner.
        MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix);
        // Position adjustment patterns appear if version >= 2.
        MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version, matrix);
        // Timing patterns should be embedded after position adj. patterns.
        MatrixUtil.embedTimingPatterns(matrix);
    };
    // Embed type information. On success, modify the matrix.
    MatrixUtil.embedTypeInfo = function(ecLevel, maskPattern /*int*/ , matrix) {
        var typeInfoBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
        for(var i = 0, size = typeInfoBits.getSize(); i < size; ++i){
            // Place bits in LSB to MSB order.  LSB (least significant bit) is the last value in
            // "typeInfoBits".
            var bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i);
            // Type info bits at the left top corner. See 8.9 of JISX0510:2004 (p.46).
            var coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i];
            var x1 = coordinates[0];
            var y1 = coordinates[1];
            matrix.setBoolean(x1, y1, bit);
            if (i < 8) {
                // Right top corner.
                var x2 = matrix.getWidth() - i - 1;
                var y2 = 8;
                matrix.setBoolean(x2, y2, bit);
            } else {
                // Left bottom corner.
                var x2 = 8;
                var y2 = matrix.getHeight() - 7 + (i - 8);
                matrix.setBoolean(x2, y2, bit);
            }
        }
    };
    // Embed version information if need be. On success, modify the matrix and return true.
    // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
    MatrixUtil.maybeEmbedVersionInfo = function(version, matrix) {
        if (version.getVersionNumber() < 7) return; // Don't need version info.
        var versionInfoBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        MatrixUtil.makeVersionInfoBits(version, versionInfoBits);
        var bitIndex = 17; // It will decrease from 17 to 0.
        for(var i = 0; i < 6; ++i)for(var j = 0; j < 3; ++j){
            // Place bits in LSB (least significant bit) to MSB order.
            var bit = versionInfoBits.get(bitIndex);
            bitIndex--;
            // Left bottom corner.
            matrix.setBoolean(i, matrix.getHeight() - 11 + j, bit);
            // Right bottom corner.
            matrix.setBoolean(matrix.getHeight() - 11 + j, i, bit);
        }
    };
    // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
    // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
    // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
    MatrixUtil.embedDataBits = function(dataBits, maskPattern /*int*/ , matrix) {
        var bitIndex = 0;
        var direction = -1;
        // Start from the right bottom cell.
        var x = matrix.getWidth() - 1;
        var y = matrix.getHeight() - 1;
        while(x > 0){
            // Skip the vertical timing pattern.
            if (x === 6) x -= 1;
            while(y >= 0 && y < matrix.getHeight()){
                for(var i = 0; i < 2; ++i){
                    var xx = x - i;
                    // Skip the cell if it's not empty.
                    if (!MatrixUtil.isEmpty(matrix.get(xx, y))) continue;
                    var bit = void 0;
                    if (bitIndex < dataBits.getSize()) {
                        bit = dataBits.get(bitIndex);
                        ++bitIndex;
                    } else // Padding bit. If there is no bit left, we'll fill the left cells with 0, as described
                    // in 8.4.9 of JISX0510:2004 (p. 24).
                    bit = false;
                    // Skip masking if mask_pattern is -1 (TYPESCRIPTPORT: 255).
                    if (maskPattern !== 255 && (0, $a4b980a466ad6cdb$export$2e2bcd8739ae039).getDataMaskBit(maskPattern, xx, y)) bit = !bit;
                    matrix.setBoolean(xx, y, bit);
                }
                y += direction;
            }
            direction = -direction; // Reverse the direction.
            y += direction;
            x -= 2; // Move to the left.
        }
        // All bits should be consumed.
        if (bitIndex !== dataBits.getSize()) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Not all bits consumed: " + bitIndex + "/" + dataBits.getSize());
    };
    // Return the position of the most significant bit set (one: to) in the "value". The most
    // significant bit is position 32. If there is no bit set, return 0. Examples:
    // - findMSBSet(0) => 0
    // - findMSBSet(1) => 1
    // - findMSBSet(255) => 8
    MatrixUtil.findMSBSet = function(value /*int*/ ) {
        return 32 - (0, $902e90c40380930f$export$2e2bcd8739ae039).numberOfLeadingZeros(value);
    };
    // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
    // code is used for encoding type information and version information.
    // Example: Calculation of version information of 7.
    // f(x) is created from 7.
    //   - 7 = 000111 in 6 bits
    //   - f(x) = x^2 + x^1 + x^0
    // g(x) is given by the standard (p. 67)
    //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
    // Multiply f(x) by x^(18 - 6)
    //   - f'(x) = f(x) * x^(18 - 6)
    //   - f'(x) = x^14 + x^13 + x^12
    // Calculate the remainder of f'(x) / g(x)
    //         x^2
    //         __________________________________________________
    //   g(x) )x^14 + x^13 + x^12
    //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
    //         --------------------------------------------------
    //                              x^11 + x^10 + x^7 + x^4 + x^2
    //
    // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
    // Encode it in binary: 110010010100
    // The return value is 0xc94 (1100 1001 0100)
    //
    // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
    // operations. We don't care if coefficients are positive or negative.
    MatrixUtil.calculateBCHCode = function(value /*int*/ , poly /*int*/ ) {
        if (poly === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("0 polynomial");
        // If poly is "1 1111 0010 0101" (version info poly), msbSetInPoly is 13. We'll subtract 1
        // from 13 to make it 12.
        var msbSetInPoly = MatrixUtil.findMSBSet(poly);
        value <<= msbSetInPoly - 1;
        // Do the division business using exclusive-or operations.
        while(MatrixUtil.findMSBSet(value) >= msbSetInPoly)value ^= poly << MatrixUtil.findMSBSet(value) - msbSetInPoly;
        // Now the "value" is the remainder (i.e. the BCH code)
        return value;
    };
    // Make bit vector of type information. On success, store the result in "bits" and return true.
    // Encode error correction level and mask pattern. See 8.9 of
    // JISX0510:2004 (p.45) for details.
    MatrixUtil.makeTypeInfoBits = function(ecLevel, maskPattern /*int*/ , bits) {
        if (!(0, $d5b77ba9d7a3f4c8$export$2e2bcd8739ae039).isValidMaskPattern(maskPattern)) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Invalid mask pattern");
        var typeInfo = ecLevel.getBits() << 3 | maskPattern;
        bits.appendBits(typeInfo, 5);
        var bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
        bits.appendBits(bchCode, 10);
        var maskBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
        bits.xor(maskBits);
        if (bits.getSize() !== 15) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("should not happen but we got: " + bits.getSize());
    };
    // Make bit vector of version information. On success, store the result in "bits" and return true.
    // See 8.10 of JISX0510:2004 (p.45) for details.
    MatrixUtil.makeVersionInfoBits = function(version, bits) {
        bits.appendBits(version.getVersionNumber(), 6);
        var bchCode = MatrixUtil.calculateBCHCode(version.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
        bits.appendBits(bchCode, 12);
        if (bits.getSize() !== 18) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("should not happen but we got: " + bits.getSize());
    };
    // Check if "value" is empty.
    MatrixUtil.isEmpty = function(value /*int*/ ) {
        return value === 255; // -1
    };
    MatrixUtil.embedTimingPatterns = function(matrix) {
        // -8 is for skipping position detection patterns (7: size), and two horizontal/vertical
        // separation patterns (1: size). Thus, 8 = 7 + 1.
        for(var i = 8; i < matrix.getWidth() - 8; ++i){
            var bit = (i + 1) % 2;
            // Horizontal line.
            if (MatrixUtil.isEmpty(matrix.get(i, 6))) matrix.setNumber(i, 6, bit);
            // Vertical line.
            if (MatrixUtil.isEmpty(matrix.get(6, i))) matrix.setNumber(6, i, bit);
        }
    };
    // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
    MatrixUtil.embedDarkDotAtLeftBottomCorner = function(matrix) {
        if (matrix.get(8, matrix.getHeight() - 8) === 0) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)();
        matrix.setNumber(8, matrix.getHeight() - 8, 1);
    };
    MatrixUtil.embedHorizontalSeparationPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var x = 0; x < 8; ++x){
            if (!MatrixUtil.isEmpty(matrix.get(xStart + x, yStart))) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)();
            matrix.setNumber(xStart + x, yStart, 0);
        }
    };
    MatrixUtil.embedVerticalSeparationPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var y = 0; y < 7; ++y){
            if (!MatrixUtil.isEmpty(matrix.get(xStart, yStart + y))) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)();
            matrix.setNumber(xStart, yStart + y, 0);
        }
    };
    MatrixUtil.embedPositionAdjustmentPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var y = 0; y < 5; ++y){
            var patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
            for(var x = 0; x < 5; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
        }
    };
    MatrixUtil.embedPositionDetectionPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var y = 0; y < 7; ++y){
            var patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
            for(var x = 0; x < 7; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
        }
    };
    // Embed position detection patterns and surrounding vertical/horizontal separators.
    MatrixUtil.embedPositionDetectionPatternsAndSeparators = function(matrix) {
        // Embed three big squares at corners.
        var pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
        // Left top corner.
        MatrixUtil.embedPositionDetectionPattern(0, 0, matrix);
        // Right top corner.
        MatrixUtil.embedPositionDetectionPattern(matrix.getWidth() - pdpWidth, 0, matrix);
        // Left bottom corner.
        MatrixUtil.embedPositionDetectionPattern(0, matrix.getWidth() - pdpWidth, matrix);
        // Embed horizontal separation patterns around the squares.
        var hspWidth = 8;
        // Left top corner.
        MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix);
        // Right top corner.
        MatrixUtil.embedHorizontalSeparationPattern(matrix.getWidth() - hspWidth, hspWidth - 1, matrix);
        // Left bottom corner.
        MatrixUtil.embedHorizontalSeparationPattern(0, matrix.getWidth() - hspWidth, matrix);
        // Embed vertical separation patterns around the squares.
        var vspSize = 7;
        // Left top corner.
        MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix);
        // Right top corner.
        MatrixUtil.embedVerticalSeparationPattern(matrix.getHeight() - vspSize - 1, 0, matrix);
        // Left bottom corner.
        MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix.getHeight() - vspSize, matrix);
    };
    // Embed position adjustment patterns if need be.
    MatrixUtil.maybeEmbedPositionAdjustmentPatterns = function(version, matrix) {
        if (version.getVersionNumber() < 2) return;
        var index = version.getVersionNumber() - 1;
        var coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index];
        for(var i = 0, length_1 = coordinates.length; i !== length_1; i++){
            var y = coordinates[i];
            if (y >= 0) for(var j = 0; j !== length_1; j++){
                var x = coordinates[j];
                if (x >= 0 && MatrixUtil.isEmpty(matrix.get(x, y))) // If the cell is unset, we embed the position adjustment pattern here.
                // -2 is necessary since the x/y coordinates point to the center of the pattern, not the
                // left top corner.
                MatrixUtil.embedPositionAdjustmentPattern(x - 2, y - 2, matrix);
            }
        }
    };
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    // From Appendix E. Table 1, JIS0510X:2004 (71: p). The table was double-checked by komatsu.
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]);
    // Type info cells at the left top corner.
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]);
    // From Appendix D in JISX0510:2004 (p. 67)
    MatrixUtil.VERSION_INFO_POLY = 0x1f25; // 1 1111 0010 0101
    // From Appendix C in JISX0510:2004 (p.65).
    MatrixUtil.TYPE_INFO_POLY = 0x537;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 0x5412;
    return MatrixUtil;
}();
var $838e0c7b6b356f41$export$2e2bcd8739ae039 = $838e0c7b6b356f41$var$MatrixUtil;



/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.encoder {*/ var $49fe9c033d9df886$var$BlockPair = /** @class */ function() {
    function BlockPair(dataBytes, errorCorrectionBytes) {
        this.dataBytes = dataBytes;
        this.errorCorrectionBytes = errorCorrectionBytes;
    }
    BlockPair.prototype.getDataBytes = function() {
        return this.dataBytes;
    };
    BlockPair.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    };
    return BlockPair;
}();
var $49fe9c033d9df886$export$2e2bcd8739ae039 = $49fe9c033d9df886$var$BlockPair;



var $0f74c580fcdfdc22$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.Map;*/ /**
 * @author satorux@google.com (Satoru Takabayashi) - creator
 * @author dswitkin@google.com (Daniel Switkin) - ported from C++
 */ var $0f74c580fcdfdc22$var$Encoder = /** @class */ function() {
    // TYPESCRIPTPORT: changed to UTF8, the default for js
    function Encoder() {}
    // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
    // Basically it applies four rules and summate all penalties.
    Encoder.calculateMaskPenalty = function(matrix) {
        return (0, $a4b980a466ad6cdb$export$2e2bcd8739ae039).applyMaskPenaltyRule1(matrix) + (0, $a4b980a466ad6cdb$export$2e2bcd8739ae039).applyMaskPenaltyRule2(matrix) + (0, $a4b980a466ad6cdb$export$2e2bcd8739ae039).applyMaskPenaltyRule3(matrix) + (0, $a4b980a466ad6cdb$export$2e2bcd8739ae039).applyMaskPenaltyRule4(matrix);
    };
    /**
     * @param content text to encode
     * @param ecLevel error correction level to use
     * @return {@link QRCode} representing the encoded QR code
     * @throws WriterException if encoding can't succeed, because of for example invalid content
     *   or configuration
     */ // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
    //   return encode(content, ecLevel, null)
    // }
    Encoder.encode = function(content, ecLevel, hints) {
        if (hints === void 0) hints = null;
        // Determine what character encoding has been specified by the caller, if any
        var encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
        var hasEncodingHint = hints !== null && undefined !== hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).CHARACTER_SET);
        if (hasEncodingHint) encoding = hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).CHARACTER_SET).toString();
        // Pick an encoding mode appropriate for the content. Note that this will not attempt to use
        // multiple modes / segments even if that were more efficient. Twould be nice.
        var mode = this.chooseMode(content, encoding);
        // This will store the header information, like mode and
        // length, as well as "header" segments like an ECI segment.
        var headerBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        // Append ECI segment if applicable
        if (mode === (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
            var eci = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).getCharacterSetECIByName(encoding);
            if (eci !== undefined) this.appendECI(eci, headerBits);
        }
        // (With ECI in place,) Write the mode marker
        this.appendModeInfo(mode, headerBits);
        // Collect data within the main segment, separately, to count its size if needed. Don't add it to
        // main payload yet.
        var dataBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        this.appendBytes(content, mode, dataBits, encoding);
        var version;
        if (hints !== null && undefined !== hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).QR_VERSION)) {
            var versionNumber = Number.parseInt(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).QR_VERSION).toString(), 10);
            version = (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).getVersionForNumber(versionNumber);
            var bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version);
            if (!this.willFit(bitsNeeded, version, ecLevel)) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Data too big for requested version");
        } else version = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
        var headerAndDataBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        headerAndDataBits.appendBitArray(headerBits);
        // Find "length" of main segment and write it
        var numLetters = mode === (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).BYTE ? dataBits.getSizeInBytes() : content.length;
        this.appendLengthInfo(numLetters, version, mode, headerAndDataBits);
        // Put data together into the overall payload
        headerAndDataBits.appendBitArray(dataBits);
        var ecBlocks = version.getECBlocksForLevel(ecLevel);
        var numDataBytes = version.getTotalCodewords() - ecBlocks.getTotalECCodewords();
        // Terminate the bits properly.
        this.terminateBits(numDataBytes, headerAndDataBits);
        // Interleave data bits with error correction code.
        var finalBits = this.interleaveWithECBytes(headerAndDataBits, version.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
        var qrCode = new (0, $d5b77ba9d7a3f4c8$export$2e2bcd8739ae039)();
        qrCode.setECLevel(ecLevel);
        qrCode.setMode(mode);
        qrCode.setVersion(version);
        //  Choose the mask pattern and set to "qrCode".
        var dimension = version.getDimensionForVersion();
        var matrix = new (0, $ecede4972a598cfe$export$2e2bcd8739ae039)(dimension, dimension);
        var maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version, matrix);
        qrCode.setMaskPattern(maskPattern);
        // Build the matrix and set it to "qrCode".
        (0, $838e0c7b6b356f41$export$2e2bcd8739ae039).buildMatrix(finalBits, ecLevel, version, maskPattern, matrix);
        qrCode.setMatrix(matrix);
        return qrCode;
    };
    /**
     * Decides the smallest version of QR code that will contain all of the provided data.
     *
     * @throws WriterException if the data cannot fit in any version
     */ Encoder.recommendVersion = function(ecLevel, mode, headerBits, dataBits) {
        // Hard part: need to know version to know how many bits length takes. But need to know how many
        // bits it takes to know version. First we take a guess at version by assuming version will be
        // the minimum, 1:
        var provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).getVersionForNumber(1));
        var provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
        // Use that guess to calculate the right version. I am still not sure this works in 100% of cases.
        var bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
        return this.chooseVersion(bitsNeeded, ecLevel);
    };
    Encoder.calculateBitsNeeded = function(mode, headerBits, dataBits, version) {
        return headerBits.getSize() + mode.getCharacterCountBits(version) + dataBits.getSize();
    };
    /**
     * @return the code point of the table used in alphanumeric mode or
     *  -1 if there is no corresponding code in the table.
     */ Encoder.getAlphanumericCode = function(code /*int*/ ) {
        if (code < Encoder.ALPHANUMERIC_TABLE.length) return Encoder.ALPHANUMERIC_TABLE[code];
        return -1;
    };
    // public static chooseMode(content: string): Mode {
    //   return chooseMode(content, null);
    // }
    /**
     * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
     * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
     */ Encoder.chooseMode = function(content, encoding) {
        if (encoding === void 0) encoding = null;
        if ((0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) // Choose Kanji mode if all input are double-byte characters
        return (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).KANJI;
        var hasNumeric = false;
        var hasAlphanumeric = false;
        for(var i = 0, length_1 = content.length; i < length_1; ++i){
            var c = content.charAt(i);
            if (Encoder.isDigit(c)) hasNumeric = true;
            else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) hasAlphanumeric = true;
            else return (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).BYTE;
        }
        if (hasAlphanumeric) return (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).ALPHANUMERIC;
        if (hasNumeric) return (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).NUMERIC;
        return (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).BYTE;
    };
    Encoder.isOnlyDoubleByteKanji = function(content) {
        var bytes;
        try {
            bytes = (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).encode(content, (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).SJIS); // content.getBytes("Shift_JIS"))
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            return false;
        }
        var length = bytes.length;
        if (length % 2 !== 0) return false;
        for(var i = 0; i < length; i += 2){
            var byte1 = bytes[i] & 0xFF;
            if ((byte1 < 0x81 || byte1 > 0x9F) && (byte1 < 0xE0 || byte1 > 0xEB)) return false;
        }
        return true;
    };
    Encoder.chooseMaskPattern = function(bits, ecLevel, version, matrix) {
        var minPenalty = Number.MAX_SAFE_INTEGER; // Lower penalty is better.
        var bestMaskPattern = -1;
        // We try all mask patterns to choose the best one.
        for(var maskPattern = 0; maskPattern < (0, $d5b77ba9d7a3f4c8$export$2e2bcd8739ae039).NUM_MASK_PATTERNS; maskPattern++){
            (0, $838e0c7b6b356f41$export$2e2bcd8739ae039).buildMatrix(bits, ecLevel, version, maskPattern, matrix);
            var penalty = this.calculateMaskPenalty(matrix);
            if (penalty < minPenalty) {
                minPenalty = penalty;
                bestMaskPattern = maskPattern;
            }
        }
        return bestMaskPattern;
    };
    Encoder.chooseVersion = function(numInputBits /*int*/ , ecLevel) {
        for(var versionNum = 1; versionNum <= 40; versionNum++){
            var version = (0, $1571c868cb7a6ba4$export$2e2bcd8739ae039).getVersionForNumber(versionNum);
            if (Encoder.willFit(numInputBits, version, ecLevel)) return version;
        }
        throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Data too big");
    };
    /**
     * @return true if the number of input bits will fit in a code with the specified version and
     * error correction level.
     */ Encoder.willFit = function(numInputBits /*int*/ , version, ecLevel) {
        // In the following comments, we use numbers of Version 7-H.
        // numBytes = 196
        var numBytes = version.getTotalCodewords();
        // getNumECBytes = 130
        var ecBlocks = version.getECBlocksForLevel(ecLevel);
        var numEcBytes = ecBlocks.getTotalECCodewords();
        // getNumDataBytes = 196 - 130 = 66
        var numDataBytes = numBytes - numEcBytes;
        var totalInputBytes = (numInputBits + 7) / 8;
        return numDataBytes >= totalInputBytes;
    };
    /**
     * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
     */ Encoder.terminateBits = function(numDataBytes /*int*/ , bits) {
        var capacity = numDataBytes * 8;
        if (bits.getSize() > capacity) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("data bits cannot fit in the QR Code" + bits.getSize() + " > " + capacity);
        for(var i = 0; i < 4 && bits.getSize() < capacity; ++i)bits.appendBit(false);
        // Append termination bits. See 8.4.8 of JISX0510:2004 (p.24) for details.
        // If the last byte isn't 8-bit aligned, we'll add padding bits.
        var numBitsInLastByte = bits.getSize() & 0x07;
        if (numBitsInLastByte > 0) for(var i = numBitsInLastByte; i < 8; i++)bits.appendBit(false);
        // If we have more space, we'll fill the space with padding patterns defined in 8.4.9 (p.24).
        var numPaddingBytes = numDataBytes - bits.getSizeInBytes();
        for(var i = 0; i < numPaddingBytes; ++i)bits.appendBits((i & 0x01) === 0 ? 0xEC : 0x11, 8);
        if (bits.getSize() !== capacity) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Bits size does not equal capacity");
    };
    /**
     * Get number of data bytes and number of error correction bytes for block id "blockID". Store
     * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
     * JISX0510:2004 (p.30)
     */ Encoder.getNumDataBytesAndNumECBytesForBlockID = function(numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ , blockID /*int*/ , numDataBytesInBlock, numECBytesInBlock) {
        if (blockID >= numRSBlocks) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Block ID too large");
        // numRsBlocksInGroup2 = 196 % 5 = 1
        var numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
        // numRsBlocksInGroup1 = 5 - 1 = 4
        var numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
        // numTotalBytesInGroup1 = 196 / 5 = 39
        var numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
        // numTotalBytesInGroup2 = 39 + 1 = 40
        var numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
        // numDataBytesInGroup1 = 66 / 5 = 13
        var numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
        // numDataBytesInGroup2 = 13 + 1 = 14
        var numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
        // numEcBytesInGroup1 = 39 - 13 = 26
        var numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
        // numEcBytesInGroup2 = 40 - 14 = 26
        var numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
        // Sanity checks.
        // 26 = 26
        if (numEcBytesInGroup1 !== numEcBytesInGroup2) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("EC bytes mismatch");
        // 5 = 4 + 1.
        if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("RS blocks mismatch");
        // 196 = (13 + 26) * 4 + (14 + 26) * 1
        if (numTotalBytes !== (numDataBytesInGroup1 + numEcBytesInGroup1) * numRsBlocksInGroup1 + (numDataBytesInGroup2 + numEcBytesInGroup2) * numRsBlocksInGroup2) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Total bytes mismatch");
        if (blockID < numRsBlocksInGroup1) {
            numDataBytesInBlock[0] = numDataBytesInGroup1;
            numECBytesInBlock[0] = numEcBytesInGroup1;
        } else {
            numDataBytesInBlock[0] = numDataBytesInGroup2;
            numECBytesInBlock[0] = numEcBytesInGroup2;
        }
    };
    /**
     * Interleave "bits" with corresponding error correction bytes. On success, store the result in
     * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
     */ Encoder.interleaveWithECBytes = function(bits, numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ ) {
        var e_1, _a, e_2, _b;
        // "bits" must have "getNumDataBytes" bytes of data.
        if (bits.getSizeInBytes() !== numDataBytes) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Number of bits and data bytes does not match");
        // Step 1.  Divide data bytes into blocks and generate error correction bytes for them. We'll
        // store the divided data bytes blocks and error correction bytes blocks into "blocks".
        var dataBytesOffset = 0;
        var maxNumDataBytes = 0;
        var maxNumEcBytes = 0;
        // Since, we know the number of reedsolmon blocks, we can initialize the vector with the number.
        var blocks = new Array(); // new Array<BlockPair>(numRSBlocks)
        for(var i = 0; i < numRSBlocks; ++i){
            var numDataBytesInBlock = new Int32Array(1);
            var numEcBytesInBlock = new Int32Array(1);
            Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i, numDataBytesInBlock, numEcBytesInBlock);
            var size = numDataBytesInBlock[0];
            var dataBytes = new Uint8Array(size);
            bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
            var ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
            blocks.push(new (0, $49fe9c033d9df886$export$2e2bcd8739ae039)(dataBytes, ecBytes));
            maxNumDataBytes = Math.max(maxNumDataBytes, size);
            maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
            dataBytesOffset += numDataBytesInBlock[0];
        }
        if (numDataBytes !== dataBytesOffset) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Data bytes does not match offset");
        var result = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        // First, place data blocks.
        for(var i = 0; i < maxNumDataBytes; ++i)try {
            for(var blocks_1 = (e_1 = void 0, $0f74c580fcdfdc22$var$__values(blocks)), blocks_1_1 = blocks_1.next(); !blocks_1_1.done; blocks_1_1 = blocks_1.next()){
                var block = blocks_1_1.value;
                var dataBytes = block.getDataBytes();
                if (i < dataBytes.length) result.appendBits(dataBytes[i], 8);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (blocks_1_1 && !blocks_1_1.done && (_a = blocks_1.return)) _a.call(blocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Then, place error correction blocks.
        for(var i = 0; i < maxNumEcBytes; ++i)try {
            for(var blocks_2 = (e_2 = void 0, $0f74c580fcdfdc22$var$__values(blocks)), blocks_2_1 = blocks_2.next(); !blocks_2_1.done; blocks_2_1 = blocks_2.next()){
                var block = blocks_2_1.value;
                var ecBytes = block.getErrorCorrectionBytes();
                if (i < ecBytes.length) result.appendBits(ecBytes[i], 8);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (blocks_2_1 && !blocks_2_1.done && (_b = blocks_2.return)) _b.call(blocks_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        if (numTotalBytes !== result.getSizeInBytes()) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Interleaving error: " + numTotalBytes + " and " + result.getSizeInBytes() + " differ.");
        return result;
    };
    Encoder.generateECBytes = function(dataBytes, numEcBytesInBlock /*int*/ ) {
        var numDataBytes = dataBytes.length;
        var toEncode = new Int32Array(numDataBytes + numEcBytesInBlock); // int[numDataBytes + numEcBytesInBlock]
        for(var i = 0; i < numDataBytes; i++)toEncode[i] = dataBytes[i] & 0xFF;
        new (0, $72dc1ddcdc47f39a$export$2e2bcd8739ae039)((0, $7973dc50831a46a1$export$2e2bcd8739ae039).QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
        var ecBytes = new Uint8Array(numEcBytesInBlock);
        for(var i = 0; i < numEcBytesInBlock; i++)ecBytes[i] = /*(byte) */ toEncode[numDataBytes + i];
        return ecBytes;
    };
    /**
     * Append mode info. On success, store the result in "bits".
     */ Encoder.appendModeInfo = function(mode, bits) {
        bits.appendBits(mode.getBits(), 4);
    };
    /**
     * Append length info. On success, store the result in "bits".
     */ Encoder.appendLengthInfo = function(numLetters /*int*/ , version, mode, bits) {
        var numBits = mode.getCharacterCountBits(version);
        if (numLetters >= 1 << numBits) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)(numLetters + " is bigger than " + ((1 << numBits) - 1));
        bits.appendBits(numLetters, numBits);
    };
    /**
     * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
     */ Encoder.appendBytes = function(content, mode, bits, encoding) {
        switch(mode){
            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).NUMERIC:
                Encoder.appendNumericBytes(content, bits);
                break;
            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).ALPHANUMERIC:
                Encoder.appendAlphanumericBytes(content, bits);
                break;
            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).BYTE:
                Encoder.append8BitBytes(content, bits, encoding);
                break;
            case (0, $d9a459a8dae87a87$export$2e2bcd8739ae039).KANJI:
                Encoder.appendKanjiBytes(content, bits);
                break;
            default:
                throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Invalid mode: " + mode);
        }
    };
    Encoder.getDigit = function(singleCharacter) {
        return singleCharacter.charCodeAt(0) - 48;
    };
    Encoder.isDigit = function(singleCharacter) {
        var cn = Encoder.getDigit(singleCharacter);
        return cn >= 0 && cn <= 9;
    };
    Encoder.appendNumericBytes = function(content, bits) {
        var length = content.length;
        var i = 0;
        while(i < length){
            var num1 = Encoder.getDigit(content.charAt(i));
            if (i + 2 < length) {
                // Encode three numeric letters in ten bits.
                var num2 = Encoder.getDigit(content.charAt(i + 1));
                var num3 = Encoder.getDigit(content.charAt(i + 2));
                bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
                i += 3;
            } else if (i + 1 < length) {
                // Encode two numeric letters in seven bits.
                var num2 = Encoder.getDigit(content.charAt(i + 1));
                bits.appendBits(num1 * 10 + num2, 7);
                i += 2;
            } else {
                // Encode one numeric letter in four bits.
                bits.appendBits(num1, 4);
                i++;
            }
        }
    };
    Encoder.appendAlphanumericBytes = function(content, bits) {
        var length = content.length;
        var i = 0;
        while(i < length){
            var code1 = Encoder.getAlphanumericCode(content.charCodeAt(i));
            if (code1 === -1) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)();
            if (i + 1 < length) {
                var code2 = Encoder.getAlphanumericCode(content.charCodeAt(i + 1));
                if (code2 === -1) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)();
                // Encode two alphanumeric letters in 11 bits.
                bits.appendBits(code1 * 45 + code2, 11);
                i += 2;
            } else {
                // Encode one alphanumeric letter in six bits.
                bits.appendBits(code1, 6);
                i++;
            }
        }
    };
    Encoder.append8BitBytes = function(content, bits, encoding) {
        var bytes;
        try {
            bytes = (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).encode(content, encoding);
        } catch (uee /*: UnsupportedEncodingException*/ ) {
            throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)(uee);
        }
        for(var i = 0, length_2 = bytes.length; i !== length_2; i++){
            var b = bytes[i];
            bits.appendBits(b, 8);
        }
    };
    /**
     * @throws WriterException
     */ Encoder.appendKanjiBytes = function(content, bits) {
        var bytes;
        try {
            bytes = (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).encode(content, (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).SJIS);
        } catch (uee /*: UnsupportedEncodingException*/ ) {
            throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)(uee);
        }
        var length = bytes.length;
        for(var i = 0; i < length; i += 2){
            var byte1 = bytes[i] & 0xFF;
            var byte2 = bytes[i + 1] & 0xFF;
            var code = byte1 << 8 & 0xFFFFFFFF | byte2;
            var subtracted = -1;
            if (code >= 0x8140 && code <= 0x9ffc) subtracted = code - 0x8140;
            else if (code >= 0xe040 && code <= 0xebbf) subtracted = code - 0xc140;
            if (subtracted === -1) throw new (0, $c94bb32e0deea8cb$export$2e2bcd8739ae039)("Invalid byte sequence");
            var encoded = (subtracted >> 8) * 0xc0 + (subtracted & 0xff);
            bits.appendBits(encoded, 13);
        }
    };
    Encoder.appendECI = function(eci, bits) {
        bits.appendBits((0, $d9a459a8dae87a87$export$2e2bcd8739ae039).ECI.getBits(), 4);
        // This is correct for values up to 127, which is all we need now.
        bits.appendBits(eci.getValue(), 8);
    };
    // The original table is defined in the table 5 of JISX0510:2004 (p.19).
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).UTF8.getName(); // "ISO-8859-1"
    return Encoder;
}();
var $0f74c580fcdfdc22$export$2e2bcd8739ae039 = $0f74c580fcdfdc22$var$Encoder;





/**
 * @deprecated Moving to @zxing/browser
 */ var $ee8bca1658180b4e$export$611f5a6e99b3de01 = /** @class */ function() {
    function BrowserQRCodeSvgWriter() {}
    /**
     * Writes and renders a QRCode SVG element.
     *
     * @param contents
     * @param width
     * @param height
     * @param hints
     */ BrowserQRCodeSvgWriter.prototype.write = function(contents, width, height, hints) {
        if (hints === void 0) hints = null;
        if (contents.length === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Found empty contents");
        // if (format != BarcodeFormat.QR_CODE) {
        //   throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format)
        // }
        if (width < 0 || height < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Requested dimensions are too small: " + width + "x" + height);
        var errorCorrectionLevel = (0, $0ce95cc0cc4839ff$export$2e2bcd8739ae039).L;
        var quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
        if (hints !== null) {
            if (undefined !== hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).ERROR_CORRECTION)) errorCorrectionLevel = (0, $0ce95cc0cc4839ff$export$2e2bcd8739ae039).fromString(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).ERROR_CORRECTION).toString());
            if (undefined !== hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).MARGIN)) quietZone = Number.parseInt(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).MARGIN).toString(), 10);
        }
        var code = (0, $0f74c580fcdfdc22$export$2e2bcd8739ae039).encode(contents, errorCorrectionLevel, hints);
        return this.renderResult(code, width, height, quietZone);
    };
    /**
     * Renders the result and then appends it to the DOM.
     */ BrowserQRCodeSvgWriter.prototype.writeToDom = function(containerElement, contents, width, height, hints) {
        if (hints === void 0) hints = null;
        if (typeof containerElement === "string") containerElement = document.querySelector(containerElement);
        var svgElement = this.write(contents, width, height, hints);
        if (containerElement) containerElement.appendChild(svgElement);
    };
    /**
     * Note that the input matrix uses 0 == white, 1 == black.
     * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
     */ BrowserQRCodeSvgWriter.prototype.renderResult = function(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
        var input = code.getMatrix();
        if (input === null) throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)();
        var inputWidth = input.getWidth();
        var inputHeight = input.getHeight();
        var qrWidth = inputWidth + quietZone * 2;
        var qrHeight = inputHeight + quietZone * 2;
        var outputWidth = Math.max(width, qrWidth);
        var outputHeight = Math.max(height, qrHeight);
        var multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
        // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
        // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
        // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
        // handle all the padding from 100x100 (the actual QR) up to 200x160.
        var leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
        var topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
        var svgElement = this.createSVGElement(outputWidth, outputHeight);
        for(var inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the barcode
            for(var inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) {
                var svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
                svgElement.appendChild(svgRectElement);
            }
        }
        return svgElement;
    };
    /**
     * Creates a SVG element.
     *
     * @param w SVG's width attribute
     * @param h SVG's height attribute
     */ BrowserQRCodeSvgWriter.prototype.createSVGElement = function(w, h) {
        var svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, "svg");
        svgElement.setAttributeNS(null, "height", w.toString());
        svgElement.setAttributeNS(null, "width", h.toString());
        return svgElement;
    };
    /**
     * Creates a SVG rect element.
     *
     * @param x Element's x coordinate
     * @param y Element's y coordinate
     * @param w Element's width attribute
     * @param h Element's height attribute
     */ BrowserQRCodeSvgWriter.prototype.createSvgRectElement = function(x, y, w, h) {
        var rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, "rect");
        rect.setAttributeNS(null, "x", x.toString());
        rect.setAttributeNS(null, "y", y.toString());
        rect.setAttributeNS(null, "height", w.toString());
        rect.setAttributeNS(null, "width", h.toString());
        rect.setAttributeNS(null, "fill", "#000000");
        return rect;
    };
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    /**
     * SVG markup NameSpace
     */ BrowserQRCodeSvgWriter.SVG_NS = "http://www.w3.org/2000/svg";
    return BrowserQRCodeSvgWriter;
}();





























/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // import DataMatrixWriter from './datamatrix/DataMatrixWriter'
// import CodaBarWriter from './oned/CodaBarWriter'
// import Code128Writer from './oned/Code128Writer'
// import Code39Writer from './oned/Code39Writer'
// import Code93Writer from './oned/Code93Writer'
// import EAN13Writer from './oned/EAN13Writer'
// import EAN8Writer from './oned/EAN8Writer'
// import ITFWriter from './oned/ITFWriter'
// import UPCAWriter from './oned/UPCAWriter'
// import UPCEWriter from './oned/UPCEWriter'
// import PDF417Writer from './pdf417/PDF417Writer'
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode {*/ 






/*import java.util.Map;*/ /**
 * This object renders a QR Code as a BitMatrix 2D array of greyscale values.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $7a22b9bd62578ce3$var$QRCodeWriter = /** @class */ function() {
    function QRCodeWriter() {}
    /*@Override*/ // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
    //     /*throws WriterException */ {
    //   return encode(contents, format, width, height, null)
    // }
    /*@Override*/ QRCodeWriter.prototype.encode = function(contents, format, width /*int*/ , height /*int*/ , hints) {
        if (contents.length === 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Found empty contents");
        if (format !== (0, $03ea32520a329dec$export$2e2bcd8739ae039).QR_CODE) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Can only encode QR_CODE, but got " + format);
        if (width < 0 || height < 0) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Requested dimensions are too small: " + width + "x" + height);
        var errorCorrectionLevel = (0, $0ce95cc0cc4839ff$export$2e2bcd8739ae039).L;
        var quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
        if (hints !== null) {
            if (undefined !== hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).ERROR_CORRECTION)) errorCorrectionLevel = (0, $0ce95cc0cc4839ff$export$2e2bcd8739ae039).fromString(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).ERROR_CORRECTION).toString());
            if (undefined !== hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).MARGIN)) quietZone = Number.parseInt(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).MARGIN).toString(), 10);
        }
        var code = (0, $0f74c580fcdfdc22$export$2e2bcd8739ae039).encode(contents, errorCorrectionLevel, hints);
        return QRCodeWriter.renderResult(code, width, height, quietZone);
    };
    // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
    // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
    QRCodeWriter.renderResult = function(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
        var input = code.getMatrix();
        if (input === null) throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)();
        var inputWidth = input.getWidth();
        var inputHeight = input.getHeight();
        var qrWidth = inputWidth + quietZone * 2;
        var qrHeight = inputHeight + quietZone * 2;
        var outputWidth = Math.max(width, qrWidth);
        var outputHeight = Math.max(height, qrHeight);
        var multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
        // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
        // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
        // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
        // handle all the padding from 100x100 (the actual QR) up to 200x160.
        var leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
        var topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
        var output = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(outputWidth, outputHeight);
        for(var inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the barcode
            for(var inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
        }
        return output;
    };
    QRCodeWriter.QUIET_ZONE_SIZE = 4;
    return QRCodeWriter;
}();
var $7a22b9bd62578ce3$export$2e2bcd8739ae039 = $7a22b9bd62578ce3$var$QRCodeWriter;




/*import java.util.Map;*/ /**
 * This is a factory class which finds the appropriate Writer subclass for the BarcodeFormat
 * requested and encodes the barcode with the supplied contents.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $350195fadd001304$var$MultiFormatWriter = /** @class */ function() {
    function MultiFormatWriter() {}
    /*@Override*/ // public encode(contents: string,
    //                         format: BarcodeFormat,
    //                         width: number /*int*/,
    //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
    //   return encode(contents, format, width, height, null)
    // }
    /*@Override*/ MultiFormatWriter.prototype.encode = function(contents, format, width /*int*/ , height /*int*/ , hints) {
        var writer;
        switch(format){
            // case BarcodeFormat.EAN_8:
            //   writer = new EAN8Writer()
            //   break
            // case BarcodeFormat.UPC_E:
            //   writer = new UPCEWriter()
            //   break
            // case BarcodeFormat.EAN_13:
            //   writer = new EAN13Writer()
            //   break
            // case BarcodeFormat.UPC_A:
            //   writer = new UPCAWriter()
            //   break
            case (0, $03ea32520a329dec$export$2e2bcd8739ae039).QR_CODE:
                writer = new (0, $7a22b9bd62578ce3$export$2e2bcd8739ae039)();
                break;
            // case BarcodeFormat.CODE_39:
            //   writer = new Code39Writer()
            //   break
            // case BarcodeFormat.CODE_93:
            //   writer = new Code93Writer()
            //   break
            // case BarcodeFormat.CODE_128:
            //   writer = new Code128Writer()
            //   break
            // case BarcodeFormat.ITF:
            //   writer = new ITFWriter()
            //   break
            // case BarcodeFormat.PDF_417:
            //   writer = new PDF417Writer()
            //   break
            // case BarcodeFormat.CODABAR:
            //   writer = new CodaBarWriter()
            //   break
            // case BarcodeFormat.DATA_MATRIX:
            //   writer = new DataMatrixWriter()
            //   break
            // case BarcodeFormat.AZTEC:
            //   writer = new AztecWriter()
            //   break
            default:
                throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("No encoder available for format " + format);
        }
        return writer.encode(contents, format, width, height, hints);
    };
    return MultiFormatWriter;
}();
var $350195fadd001304$export$2e2bcd8739ae039 = $350195fadd001304$var$MultiFormatWriter;


/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



var $5287583335264c79$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This object extends LuminanceSource around an array of YUV data returned from the camera driver,
 * with the option to crop to a rectangle within the full data. This can be used to exclude
 * superfluous pixels around the perimeter and speed up decoding.
 *
 * It works for any pixel format where the Y channel is planar and appears first, including
 * YCbCr_420_SP and YCbCr_422_SP.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $5287583335264c79$var$PlanarYUVLuminanceSource = /** @class */ function(_super) {
    $5287583335264c79$var$__extends(PlanarYUVLuminanceSource, _super);
    function PlanarYUVLuminanceSource(yuvData, dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ , reverseHorizontal) {
        var _this = _super.call(this, width, height) || this;
        _this.yuvData = yuvData;
        _this.dataWidth = dataWidth;
        _this.dataHeight = dataHeight;
        _this.left = left;
        _this.top = top;
        if (left + width > dataWidth || top + height > dataHeight) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Crop rectangle does not fit within image data.");
        if (reverseHorizontal) _this.reverseHorizontal(width, height);
        return _this;
    }
    /*@Override*/ PlanarYUVLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        if (y < 0 || y >= this.getHeight()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Requested row is outside the image: " + y);
        var width = this.getWidth();
        if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
        var offset = (y + this.top) * this.dataWidth + this.left;
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.yuvData, offset, row, 0, width);
        return row;
    };
    /*@Override*/ PlanarYUVLuminanceSource.prototype.getMatrix = function() {
        var width = this.getWidth();
        var height = this.getHeight();
        // If the caller asks for the entire underlying image, save the copy and give them the
        // original data. The docs specifically warn that result.length must be ignored.
        if (width === this.dataWidth && height === this.dataHeight) return this.yuvData;
        var area = width * height;
        var matrix = new Uint8ClampedArray(area);
        var inputOffset = this.top * this.dataWidth + this.left;
        // If the width matches the full width of the underlying data, perform a single copy.
        if (width === this.dataWidth) {
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.yuvData, inputOffset, matrix, 0, area);
            return matrix;
        }
        // Otherwise copy one cropped row at a time.
        for(var y = 0; y < height; y++){
            var outputOffset = y * width;
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.yuvData, inputOffset, matrix, outputOffset, width);
            inputOffset += this.dataWidth;
        }
        return matrix;
    };
    /*@Override*/ PlanarYUVLuminanceSource.prototype.isCropSupported = function() {
        return true;
    };
    /*@Override*/ PlanarYUVLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
    };
    PlanarYUVLuminanceSource.prototype.renderThumbnail = function() {
        var width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        var height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        var pixels = new Int32Array(width * height);
        var yuv = this.yuvData;
        var inputOffset = this.top * this.dataWidth + this.left;
        for(var y = 0; y < height; y++){
            var outputOffset = y * width;
            for(var x = 0; x < width; x++){
                var grey = yuv[inputOffset + x * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 0xff;
                pixels[outputOffset + x] = 0xFF000000 | grey * 0x00010101;
            }
            inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        return pixels;
    };
    /**
     * @return width of image from {@link #renderThumbnail()}
     */ PlanarYUVLuminanceSource.prototype.getThumbnailWidth = function() {
        return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
    };
    /**
     * @return height of image from {@link #renderThumbnail()}
     */ PlanarYUVLuminanceSource.prototype.getThumbnailHeight = function() {
        return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
    };
    PlanarYUVLuminanceSource.prototype.reverseHorizontal = function(width /*int*/ , height /*int*/ ) {
        var yuvData = this.yuvData;
        for(var y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth){
            var middle = rowStart + width / 2;
            for(var x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--){
                var temp = yuvData[x1];
                yuvData[x1] = yuvData[x2];
                yuvData[x2] = temp;
            }
        }
    };
    PlanarYUVLuminanceSource.prototype.invert = function() {
        return new (0, $a29a81894b6c54d7$export$2e2bcd8739ae039)(this);
    };
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;
    return PlanarYUVLuminanceSource;
}((0, $ac3b31e65220c3d3$export$2e2bcd8739ae039));
var $5287583335264c79$export$2e2bcd8739ae039 = $5287583335264c79$var$PlanarYUVLuminanceSource;




/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



var $82e181e9da8cacbf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class is used to help decode images from files which arrive as RGB data from
 * an ARGB pixel array. It does not support rotation.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Betaminos
 */ var $82e181e9da8cacbf$var$RGBLuminanceSource = /** @class */ function(_super) {
    $82e181e9da8cacbf$var$__extends(RGBLuminanceSource, _super);
    function RGBLuminanceSource(luminances, width /*int*/ , height /*int*/ , dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ ) {
        var _this = _super.call(this, width, height) || this;
        _this.dataWidth = dataWidth;
        _this.dataHeight = dataHeight;
        _this.left = left;
        _this.top = top;
        if (luminances.BYTES_PER_ELEMENT === 4) {
            var size = width * height;
            var luminancesUint8Array = new Uint8ClampedArray(size);
            for(var offset = 0; offset < size; offset++){
                var pixel = luminances[offset];
                var r = pixel >> 16 & 0xff; // red
                var g2 = pixel >> 7 & 0x1fe; // 2 * green
                var b = pixel & 0xff; // blue
                // Calculate green-favouring average cheaply
                luminancesUint8Array[offset] = (r + g2 + b) / 4 & 0xFF;
            }
            _this.luminances = luminancesUint8Array;
        } else _this.luminances = luminances;
        if (undefined === dataWidth) _this.dataWidth = width;
        if (undefined === dataHeight) _this.dataHeight = height;
        if (undefined === left) _this.left = 0;
        if (undefined === top) _this.top = 0;
        if (_this.left + width > _this.dataWidth || _this.top + height > _this.dataHeight) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Crop rectangle does not fit within image data.");
        return _this;
    }
    /*@Override*/ RGBLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        if (y < 0 || y >= this.getHeight()) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Requested row is outside the image: " + y);
        var width = this.getWidth();
        if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
        var offset = (y + this.top) * this.dataWidth + this.left;
        (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.luminances, offset, row, 0, width);
        return row;
    };
    /*@Override*/ RGBLuminanceSource.prototype.getMatrix = function() {
        var width = this.getWidth();
        var height = this.getHeight();
        // If the caller asks for the entire underlying image, save the copy and give them the
        // original data. The docs specifically warn that result.length must be ignored.
        if (width === this.dataWidth && height === this.dataHeight) return this.luminances;
        var area = width * height;
        var matrix = new Uint8ClampedArray(area);
        var inputOffset = this.top * this.dataWidth + this.left;
        // If the width matches the full width of the underlying data, perform a single copy.
        if (width === this.dataWidth) {
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.luminances, inputOffset, matrix, 0, area);
            return matrix;
        }
        // Otherwise copy one cropped row at a time.
        for(var y = 0; y < height; y++){
            var outputOffset = y * width;
            (0, $77e52d7ed15ef280$export$2e2bcd8739ae039).arraycopy(this.luminances, inputOffset, matrix, outputOffset, width);
            inputOffset += this.dataWidth;
        }
        return matrix;
    };
    /*@Override*/ RGBLuminanceSource.prototype.isCropSupported = function() {
        return true;
    };
    /*@Override*/ RGBLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
    };
    RGBLuminanceSource.prototype.invert = function() {
        return new (0, $a29a81894b6c54d7$export$2e2bcd8739ae039)(this);
    };
    return RGBLuminanceSource;
}((0, $ac3b31e65220c3d3$export$2e2bcd8739ae039));
var $82e181e9da8cacbf$export$2e2bcd8739ae039 = $82e181e9da8cacbf$var$RGBLuminanceSource;







var $64e0b7362b63fd2a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Just to make a shortcut between Java code and TS code.
 */ var $64e0b7362b63fd2a$var$Charset = /** @class */ function(_super) {
    $64e0b7362b63fd2a$var$__extends(Charset, _super);
    function Charset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Charset.forName = function(name) {
        return this.getCharacterSetECIByName(name);
    };
    return Charset;
}((0, $cb860ff3f180bf6b$export$2e2bcd8739ae039));
var $64e0b7362b63fd2a$export$2e2bcd8739ae039 = $64e0b7362b63fd2a$var$Charset;




/**
 * Just to make a shortcut between Java code and TS code.
 */ var $e21db4982d838126$var$StandardCharsets = /** @class */ function() {
    function StandardCharsets() {}
    StandardCharsets.ISO_8859_1 = (0, $cb860ff3f180bf6b$export$2e2bcd8739ae039).ISO8859_1;
    return StandardCharsets;
}();
var $e21db4982d838126$export$2e2bcd8739ae039 = $e21db4982d838126$var$StandardCharsets;


























/**
 * Symbol Character Placement Program. Adapted from Annex M.1 in ISO/IEC 16022:2000(E).
 */ var $e5bfe2ecdcbc6e41$var$DefaultPlacement = /** @class */ function() {
    /**
     * Main constructor
     *
     * @param codewords the codewords to place
     * @param numcols   the number of columns
     * @param numrows   the number of rows
     */ function DefaultPlacement(codewords, numcols, numrows) {
        this.codewords = codewords;
        this.numcols = numcols;
        this.numrows = numrows;
        this.bits = new Uint8Array(numcols * numrows);
        (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(this.bits, 2); // Initialize with "not set" value
    }
    DefaultPlacement.prototype.getNumrows = function() {
        return this.numrows;
    };
    DefaultPlacement.prototype.getNumcols = function() {
        return this.numcols;
    };
    DefaultPlacement.prototype.getBits = function() {
        return this.bits;
    };
    DefaultPlacement.prototype.getBit = function(col, row) {
        return this.bits[row * this.numcols + col] === 1;
    };
    DefaultPlacement.prototype.setBit = function(col, row, bit) {
        this.bits[row * this.numcols + col] = bit ? 1 : 0;
    };
    DefaultPlacement.prototype.noBit = function(col, row) {
        return this.bits[row * this.numcols + col] === 2;
    };
    DefaultPlacement.prototype.place = function() {
        var pos = 0;
        var row = 4;
        var col = 0;
        do {
            // repeatedly first check for one of the special corner cases, then...
            if (row === this.numrows && col === 0) this.corner1(pos++);
            if (row === this.numrows - 2 && col === 0 && this.numcols % 4 !== 0) this.corner2(pos++);
            if (row === this.numrows - 2 && col === 0 && this.numcols % 8 === 4) this.corner3(pos++);
            if (row === this.numrows + 4 && col === 2 && this.numcols % 8 === 0) this.corner4(pos++);
            // sweep upward diagonally, inserting successive characters...
            do {
                if (row < this.numrows && col >= 0 && this.noBit(col, row)) this.utah(row, col, pos++);
                row -= 2;
                col += 2;
            }while (row >= 0 && col < this.numcols);
            row++;
            col += 3;
            // and then sweep downward diagonally, inserting successive characters, ...
            do {
                if (row >= 0 && col < this.numcols && this.noBit(col, row)) this.utah(row, col, pos++);
                row += 2;
                col -= 2;
            }while (row < this.numrows && col >= 0);
            row += 3;
            col++;
        // ...until the entire array is scanned
        }while (row < this.numrows || col < this.numcols);
        // Lastly, if the lower right-hand corner is untouched, fill in fixed pattern
        if (this.noBit(this.numcols - 1, this.numrows - 1)) {
            this.setBit(this.numcols - 1, this.numrows - 1, true);
            this.setBit(this.numcols - 2, this.numrows - 2, true);
        }
    };
    DefaultPlacement.prototype.module = function(row, col, pos, bit) {
        if (row < 0) {
            row += this.numrows;
            col += 4 - (this.numrows + 4) % 8;
        }
        if (col < 0) {
            col += this.numcols;
            row += 4 - (this.numcols + 4) % 8;
        }
        // Note the conversion:
        var v = this.codewords.charCodeAt(pos);
        v &= 1 << 8 - bit;
        this.setBit(col, row, v !== 0);
    };
    /**
     * Places the 8 bits of a utah-shaped symbol character in ECC200.
     *
     * @param row the row
     * @param col the column
     * @param pos character position
     */ DefaultPlacement.prototype.utah = function(row, col, pos) {
        this.module(row - 2, col - 2, pos, 1);
        this.module(row - 2, col - 1, pos, 2);
        this.module(row - 1, col - 2, pos, 3);
        this.module(row - 1, col - 1, pos, 4);
        this.module(row - 1, col, pos, 5);
        this.module(row, col - 2, pos, 6);
        this.module(row, col - 1, pos, 7);
        this.module(row, col, pos, 8);
    };
    DefaultPlacement.prototype.corner1 = function(pos) {
        this.module(this.numrows - 1, 0, pos, 1);
        this.module(this.numrows - 1, 1, pos, 2);
        this.module(this.numrows - 1, 2, pos, 3);
        this.module(0, this.numcols - 2, pos, 4);
        this.module(0, this.numcols - 1, pos, 5);
        this.module(1, this.numcols - 1, pos, 6);
        this.module(2, this.numcols - 1, pos, 7);
        this.module(3, this.numcols - 1, pos, 8);
    };
    DefaultPlacement.prototype.corner2 = function(pos) {
        this.module(this.numrows - 3, 0, pos, 1);
        this.module(this.numrows - 2, 0, pos, 2);
        this.module(this.numrows - 1, 0, pos, 3);
        this.module(0, this.numcols - 4, pos, 4);
        this.module(0, this.numcols - 3, pos, 5);
        this.module(0, this.numcols - 2, pos, 6);
        this.module(0, this.numcols - 1, pos, 7);
        this.module(1, this.numcols - 1, pos, 8);
    };
    DefaultPlacement.prototype.corner3 = function(pos) {
        this.module(this.numrows - 3, 0, pos, 1);
        this.module(this.numrows - 2, 0, pos, 2);
        this.module(this.numrows - 1, 0, pos, 3);
        this.module(0, this.numcols - 2, pos, 4);
        this.module(0, this.numcols - 1, pos, 5);
        this.module(1, this.numcols - 1, pos, 6);
        this.module(2, this.numcols - 1, pos, 7);
        this.module(3, this.numcols - 1, pos, 8);
    };
    DefaultPlacement.prototype.corner4 = function(pos) {
        this.module(this.numrows - 1, 0, pos, 1);
        this.module(this.numrows - 1, this.numcols - 1, pos, 2);
        this.module(0, this.numcols - 3, pos, 3);
        this.module(0, this.numcols - 2, pos, 4);
        this.module(0, this.numcols - 1, pos, 5);
        this.module(1, this.numcols - 3, pos, 6);
        this.module(1, this.numcols - 2, pos, 7);
        this.module(1, this.numcols - 1, pos, 8);
    };
    return DefaultPlacement;
}();
var $e5bfe2ecdcbc6e41$export$2e2bcd8739ae039 = $e5bfe2ecdcbc6e41$var$DefaultPlacement;



var $8956e14186ab1442$var$_a;
var $8956e14186ab1442$export$1a4ea90639b29dc9 = [
    5,
    7,
    10,
    11,
    12,
    14,
    18,
    20,
    24,
    28,
    36,
    42,
    48,
    56,
    62,
    68
];
var $8956e14186ab1442$export$dbdb347f12e46d6c = [
    [
        228,
        48,
        15,
        111,
        62
    ],
    [
        23,
        68,
        144,
        134,
        240,
        92,
        254
    ],
    [
        28,
        24,
        185,
        166,
        223,
        248,
        116,
        255,
        110,
        61
    ],
    [
        175,
        138,
        205,
        12,
        194,
        168,
        39,
        245,
        60,
        97,
        120
    ],
    [
        41,
        153,
        158,
        91,
        61,
        42,
        142,
        213,
        97,
        178,
        100,
        242
    ],
    [
        156,
        97,
        192,
        252,
        95,
        9,
        157,
        119,
        138,
        45,
        18,
        186,
        83,
        185
    ],
    [
        83,
        195,
        100,
        39,
        188,
        75,
        66,
        61,
        241,
        213,
        109,
        129,
        94,
        254,
        225,
        48,
        90,
        188
    ],
    [
        15,
        195,
        244,
        9,
        233,
        71,
        168,
        2,
        188,
        160,
        153,
        145,
        253,
        79,
        108,
        82,
        27,
        174,
        186,
        172
    ],
    [
        52,
        190,
        88,
        205,
        109,
        39,
        176,
        21,
        155,
        197,
        251,
        223,
        155,
        21,
        5,
        172,
        254,
        124,
        12,
        181,
        184,
        96,
        50,
        193
    ],
    [
        211,
        231,
        43,
        97,
        71,
        96,
        103,
        174,
        37,
        151,
        170,
        53,
        75,
        34,
        249,
        121,
        17,
        138,
        110,
        213,
        141,
        136,
        120,
        151,
        233,
        168,
        93,
        255
    ],
    [
        245,
        127,
        242,
        218,
        130,
        250,
        162,
        181,
        102,
        120,
        84,
        179,
        220,
        251,
        80,
        182,
        229,
        18,
        2,
        4,
        68,
        33,
        101,
        137,
        95,
        119,
        115,
        44,
        175,
        184,
        59,
        25,
        225,
        98,
        81,
        112
    ],
    [
        77,
        193,
        137,
        31,
        19,
        38,
        22,
        153,
        247,
        105,
        122,
        2,
        245,
        133,
        242,
        8,
        175,
        95,
        100,
        9,
        167,
        105,
        214,
        111,
        57,
        121,
        21,
        1,
        253,
        57,
        54,
        101,
        248,
        202,
        69,
        50,
        150,
        177,
        226,
        5,
        9,
        5
    ],
    [
        245,
        132,
        172,
        223,
        96,
        32,
        117,
        22,
        238,
        133,
        238,
        231,
        205,
        188,
        237,
        87,
        191,
        106,
        16,
        147,
        118,
        23,
        37,
        90,
        170,
        205,
        131,
        88,
        120,
        100,
        66,
        138,
        186,
        240,
        82,
        44,
        176,
        87,
        187,
        147,
        160,
        175,
        69,
        213,
        92,
        253,
        225,
        19
    ],
    [
        175,
        9,
        223,
        238,
        12,
        17,
        220,
        208,
        100,
        29,
        175,
        170,
        230,
        192,
        215,
        235,
        150,
        159,
        36,
        223,
        38,
        200,
        132,
        54,
        228,
        146,
        218,
        234,
        117,
        203,
        29,
        232,
        144,
        238,
        22,
        150,
        201,
        117,
        62,
        207,
        164,
        13,
        137,
        245,
        127,
        67,
        247,
        28,
        155,
        43,
        203,
        107,
        233,
        53,
        143,
        46
    ],
    [
        242,
        93,
        169,
        50,
        144,
        210,
        39,
        118,
        202,
        188,
        201,
        189,
        143,
        108,
        196,
        37,
        185,
        112,
        134,
        230,
        245,
        63,
        197,
        190,
        250,
        106,
        185,
        221,
        175,
        64,
        114,
        71,
        161,
        44,
        147,
        6,
        27,
        218,
        51,
        63,
        87,
        10,
        40,
        130,
        188,
        17,
        163,
        31,
        176,
        170,
        4,
        107,
        232,
        7,
        94,
        166,
        224,
        124,
        86,
        47,
        11,
        204
    ],
    [
        220,
        228,
        173,
        89,
        251,
        149,
        159,
        56,
        89,
        33,
        147,
        244,
        154,
        36,
        73,
        127,
        213,
        136,
        248,
        180,
        234,
        197,
        158,
        177,
        68,
        122,
        93,
        213,
        15,
        160,
        227,
        236,
        66,
        139,
        153,
        185,
        202,
        167,
        179,
        25,
        220,
        232,
        96,
        210,
        231,
        136,
        223,
        239,
        181,
        241,
        59,
        52,
        172,
        25,
        49,
        232,
        211,
        189,
        64,
        54,
        108,
        153,
        132,
        63,
        96,
        103,
        82,
        186
    ]
];
var /*final*/ $8956e14186ab1442$export$c16b7defc6bd7e7f = 0x12d;
var $8956e14186ab1442$var$static_LOG = function(LOG, ALOG) {
    var p = 1;
    for(var i = 0; i < 255; i++){
        ALOG[i] = p;
        LOG[p] = i;
        p *= 2;
        if (p >= 256) p ^= $8956e14186ab1442$export$c16b7defc6bd7e7f;
    }
    return {
        LOG: LOG,
        ALOG: ALOG
    };
};
var $8956e14186ab1442$export$5bfbc7f735892ffd = ($8956e14186ab1442$var$_a = $8956e14186ab1442$var$static_LOG([], []), $8956e14186ab1442$var$_a.LOG), $8956e14186ab1442$export$1098f4555f330d74 = $8956e14186ab1442$var$_a.ALOG;
var $8956e14186ab1442$export$9943470dc8ddf67b;
(function(SymbolShapeHint) {
    SymbolShapeHint[SymbolShapeHint["FORCE_NONE"] = 0] = "FORCE_NONE";
    SymbolShapeHint[SymbolShapeHint["FORCE_SQUARE"] = 1] = "FORCE_SQUARE";
    SymbolShapeHint[SymbolShapeHint["FORCE_RECTANGLE"] = 2] = "FORCE_RECTANGLE";
})($8956e14186ab1442$export$9943470dc8ddf67b || ($8956e14186ab1442$export$9943470dc8ddf67b = {}));
var $8956e14186ab1442$export$f0a63d87a2a34697 = 129;
var $8956e14186ab1442$export$4a0f817a5f4ee4ee = 230;
var $8956e14186ab1442$export$dd1a688a09fef810 = 231;
var $8956e14186ab1442$export$9ad52e625a8ea11d = 235;
var $8956e14186ab1442$export$17e82e449024cedf = 236;
var $8956e14186ab1442$export$a903123fbb5ef394 = 237;
var $8956e14186ab1442$export$262608b2e224b244 = 238;
var $8956e14186ab1442$export$96851926505e2f00 = 239;
var $8956e14186ab1442$export$b92c818abc80fbe5 = 240;
var $8956e14186ab1442$export$d290130da1db6f5e = 254;
var $8956e14186ab1442$export$15fb43a449900da = 254;
var $8956e14186ab1442$export$b9291bc7e7703008 = "[)>\x1e05\x1d";
var $8956e14186ab1442$export$d9fe944fda3d8b83 = "[)>\x1e06\x1d";
var $8956e14186ab1442$export$c131c12a8149fc4a = "\x1e\x04";
var $8956e14186ab1442$export$14da3e339495da6f = 0;
var $8956e14186ab1442$export$1a39cd5cb553e275 = 1;
var $8956e14186ab1442$export$b6ad1f89161198e3 = 2;
var $8956e14186ab1442$export$9c26c56fb5133974 = 3;
var $8956e14186ab1442$export$468849a05d2676e7 = 4;
var $8956e14186ab1442$export$198535988cfe7d20 = 5;


/**
 * Error Correction Code for ECC200.
 */ var $335d411caacd704e$var$ErrorCorrection = /** @class */ function() {
    function ErrorCorrection() {}
    /**
     * Creates the ECC200 error correction for an encoded message.
     *
     * @param codewords  the codewords
     * @param symbolInfo information about the symbol to be encoded
     * @return the codewords with interleaved error correction.
     */ ErrorCorrection.encodeECC200 = function(codewords, symbolInfo) {
        if (codewords.length !== symbolInfo.getDataCapacity()) throw new Error("The number of codewords does not match the selected symbol");
        var sb = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        sb.append(codewords);
        var blockCount = symbolInfo.getInterleavedBlockCount();
        if (blockCount === 1) {
            var ecc = this.createECCBlock(codewords, symbolInfo.getErrorCodewords());
            sb.append(ecc);
        } else {
            // sb.setLength(sb.capacity());
            var dataSizes = [];
            var errorSizes = [];
            for(var i = 0; i < blockCount; i++){
                dataSizes[i] = symbolInfo.getDataLengthForInterleavedBlock(i + 1);
                errorSizes[i] = symbolInfo.getErrorLengthForInterleavedBlock(i + 1);
            }
            for(var block = 0; block < blockCount; block++){
                var temp = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                for(var d = block; d < symbolInfo.getDataCapacity(); d += blockCount)temp.append(codewords.charAt(d));
                var ecc = this.createECCBlock(temp.toString(), errorSizes[block]);
                var pos = 0;
                for(var e = block; e < errorSizes[block] * blockCount; e += blockCount)sb.setCharAt(symbolInfo.getDataCapacity() + e, ecc.charAt(pos++));
            }
        }
        return sb.toString();
    };
    ErrorCorrection.createECCBlock = function(codewords, numECWords) {
        var table = -1;
        for(var i = 0; i < (0, $8956e14186ab1442$export$1a4ea90639b29dc9).length; i++)if ((0, $8956e14186ab1442$export$1a4ea90639b29dc9)[i] === numECWords) {
            table = i;
            break;
        }
        if (table < 0) throw new Error("Illegal number of error correction codewords specified: " + numECWords);
        var poly = (0, $8956e14186ab1442$export$dbdb347f12e46d6c)[table];
        var ecc = [];
        for(var i = 0; i < numECWords; i++)ecc[i] = 0;
        for(var i = 0; i < codewords.length; i++){
            var m = ecc[numECWords - 1] ^ codewords.charAt(i).charCodeAt(0);
            for(var k = numECWords - 1; k > 0; k--)if (m !== 0 && poly[k] !== 0) ecc[k] = ecc[k - 1] ^ (0, $8956e14186ab1442$export$1098f4555f330d74)[((0, $8956e14186ab1442$export$5bfbc7f735892ffd)[m] + (0, $8956e14186ab1442$export$5bfbc7f735892ffd)[poly[k]]) % 255];
            else ecc[k] = ecc[k - 1];
            if (m !== 0 && poly[0] !== 0) ecc[0] = (0, $8956e14186ab1442$export$1098f4555f330d74)[((0, $8956e14186ab1442$export$5bfbc7f735892ffd)[m] + (0, $8956e14186ab1442$export$5bfbc7f735892ffd)[poly[0]]) % 255];
            else ecc[0] = 0;
        }
        var eccReversed = [];
        for(var i = 0; i < numECWords; i++)eccReversed[i] = ecc[numECWords - i - 1];
        return eccReversed.map(function(c) {
            return String.fromCharCode(c);
        }).join("");
    };
    return ErrorCorrection;
}();
var $335d411caacd704e$export$2e2bcd8739ae039 = $335d411caacd704e$var$ErrorCorrection;


// tslint:disable-next-line:no-circular-imports


var $1978ab0a4735d787$export$17a895f6b9e73f8b = /** @class */ function() {
    function ASCIIEncoder() {}
    ASCIIEncoder.prototype.getEncodingMode = function() {
        return 0, $8956e14186ab1442$export$14da3e339495da6f;
    };
    ASCIIEncoder.prototype.encode = function(context) {
        // step B
        var n = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).determineConsecutiveDigitCount(context.getMessage(), context.pos);
        if (n >= 2) {
            context.writeCodeword(this.encodeASCIIDigits(context.getMessage().charCodeAt(context.pos), context.getMessage().charCodeAt(context.pos + 1)));
            context.pos += 2;
        } else {
            var c = context.getCurrentChar();
            var newMode = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
            if (newMode !== this.getEncodingMode()) switch(newMode){
                case 0, $8956e14186ab1442$export$198535988cfe7d20:
                    context.writeCodeword((0, $8956e14186ab1442$export$dd1a688a09fef810));
                    context.signalEncoderChange((0, $8956e14186ab1442$export$198535988cfe7d20));
                    return;
                case 0, $8956e14186ab1442$export$1a39cd5cb553e275:
                    context.writeCodeword((0, $8956e14186ab1442$export$4a0f817a5f4ee4ee));
                    context.signalEncoderChange((0, $8956e14186ab1442$export$1a39cd5cb553e275));
                    return;
                case 0, $8956e14186ab1442$export$9c26c56fb5133974:
                    context.writeCodeword((0, $8956e14186ab1442$export$262608b2e224b244));
                    context.signalEncoderChange((0, $8956e14186ab1442$export$9c26c56fb5133974));
                    break;
                case 0, $8956e14186ab1442$export$b6ad1f89161198e3:
                    context.writeCodeword((0, $8956e14186ab1442$export$96851926505e2f00));
                    context.signalEncoderChange((0, $8956e14186ab1442$export$b6ad1f89161198e3));
                    break;
                case 0, $8956e14186ab1442$export$468849a05d2676e7:
                    context.writeCodeword((0, $8956e14186ab1442$export$b92c818abc80fbe5));
                    context.signalEncoderChange((0, $8956e14186ab1442$export$468849a05d2676e7));
                    break;
                default:
                    throw new Error("Illegal mode: " + newMode);
            }
            else if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isExtendedASCII(c)) {
                context.writeCodeword((0, $8956e14186ab1442$export$9ad52e625a8ea11d));
                context.writeCodeword(c - 128 + 1);
                context.pos++;
            } else {
                context.writeCodeword(c + 1);
                context.pos++;
            }
        }
    };
    ASCIIEncoder.prototype.encodeASCIIDigits = function(digit1, digit2) {
        if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(digit1) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(digit2)) {
            var num = (digit1 - 48) * 10 + (digit2 - 48);
            return num + 130;
        }
        throw new Error("not digits: " + digit1 + digit2);
    };
    return ASCIIEncoder;
}();






var $74199fddb6d8e999$export$28d91855f6c4550e = /** @class */ function() {
    function Base256Encoder() {}
    Base256Encoder.prototype.getEncodingMode = function() {
        return 0, $8956e14186ab1442$export$198535988cfe7d20;
    };
    Base256Encoder.prototype.encode = function(context) {
        var buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        buffer.append(0); // Initialize length field
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            buffer.append(c);
            context.pos++;
            var newMode = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
            if (newMode !== this.getEncodingMode()) {
                // Return to ASCII encodation, which will actually handle latch to new mode
                context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
                break;
            }
        }
        var dataCount = buffer.length() - 1;
        var lengthFieldSize = 1;
        var currentSize = context.getCodewordCount() + dataCount + lengthFieldSize;
        context.updateSymbolInfo(currentSize);
        var mustPad = context.getSymbolInfo().getDataCapacity() - currentSize > 0;
        if (context.hasMoreCharacters() || mustPad) {
            if (dataCount <= 249) buffer.setCharAt(0, (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(dataCount));
            else if (dataCount <= 1555) {
                buffer.setCharAt(0, (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(Math.floor(dataCount / 250) + 249));
                buffer.insert(1, (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(dataCount % 250));
            } else throw new Error("Message length not in valid ranges: " + dataCount);
        }
        for(var i = 0, c = buffer.length(); i < c; i++)context.writeCodeword(this.randomize255State(buffer.charAt(i).charCodeAt(0), context.getCodewordCount() + 1));
    };
    Base256Encoder.prototype.randomize255State = function(ch, codewordPosition) {
        var pseudoRandom = 149 * codewordPosition % 255 + 1;
        var tempVariable = ch + pseudoRandom;
        if (tempVariable <= 255) return tempVariable;
        else return tempVariable - 256;
    };
    return Base256Encoder;
}();





var $e148c5cb01ffdc9f$export$5b99b12a80a00de6 = /** @class */ function() {
    function C40Encoder() {}
    C40Encoder.prototype.getEncodingMode = function() {
        return 0, $8956e14186ab1442$export$1a39cd5cb553e275;
    };
    C40Encoder.prototype.encodeMaximal = function(context) {
        var buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        var lastCharSize = 0;
        var backtrackStartPosition = context.pos;
        var backtrackBufferLength = 0;
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            context.pos++;
            lastCharSize = this.encodeChar(c, buffer);
            if (buffer.length() % 3 === 0) {
                backtrackStartPosition = context.pos;
                backtrackBufferLength = buffer.length();
            }
        }
        if (backtrackBufferLength !== buffer.length()) {
            var unwritten = Math.floor(buffer.length() / 3 * 2);
            var curCodewordCount = Math.floor(context.getCodewordCount() + unwritten + 1); // +1 for the latch to C40
            context.updateSymbolInfo(curCodewordCount);
            var available = context.getSymbolInfo().getDataCapacity() - curCodewordCount;
            var rest = Math.floor(buffer.length() % 3);
            if (rest === 2 && available !== 2 || rest === 1 && (lastCharSize > 3 || available !== 1)) // buffer.setLength(backtrackBufferLength);
            context.pos = backtrackStartPosition;
        }
        if (buffer.length() > 0) context.writeCodeword((0, $8956e14186ab1442$export$4a0f817a5f4ee4ee));
        this.handleEOD(context, buffer);
    };
    C40Encoder.prototype.encode = function(context) {
        // step C
        var buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            context.pos++;
            var lastCharSize = this.encodeChar(c, buffer);
            var unwritten = Math.floor(buffer.length() / 3) * 2;
            var curCodewordCount = context.getCodewordCount() + unwritten;
            context.updateSymbolInfo(curCodewordCount);
            var available = context.getSymbolInfo().getDataCapacity() - curCodewordCount;
            if (!context.hasMoreCharacters()) {
                // Avoid having a single C40 value in the last triplet
                var removed = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
                if (buffer.length() % 3 === 2 && available !== 2) lastCharSize = this.backtrackOneCharacter(context, buffer, removed, lastCharSize);
                while(buffer.length() % 3 === 1 && (lastCharSize > 3 || available !== 1))lastCharSize = this.backtrackOneCharacter(context, buffer, removed, lastCharSize);
                break;
            }
            var count = buffer.length();
            if (count % 3 === 0) {
                var newMode = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
                if (newMode !== this.getEncodingMode()) {
                    // Return to ASCII encodation, which will actually handle latch to new mode
                    context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
                    break;
                }
            }
        }
        this.handleEOD(context, buffer);
    };
    C40Encoder.prototype.backtrackOneCharacter = function(context, buffer, removed, lastCharSize) {
        var count = buffer.length();
        var test = buffer.toString().substring(0, count - lastCharSize);
        buffer.setLengthToZero();
        buffer.append(test);
        // buffer.delete(count - lastCharSize, count);
        /*for (let i = count - lastCharSize; i < count; i++) {
          buffer.deleteCharAt(i);
        }*/ context.pos--;
        var c = context.getCurrentChar();
        lastCharSize = this.encodeChar(c, removed);
        context.resetSymbolInfo(); // Deal with possible reduction in symbol size
        return lastCharSize;
    };
    C40Encoder.prototype.writeNextTriplet = function(context, buffer) {
        context.writeCodewords(this.encodeToCodewords(buffer.toString()));
        var test = buffer.toString().substring(3);
        buffer.setLengthToZero();
        buffer.append(test);
    // buffer.delete(0, 3);
    /*for (let i = 0; i < 3; i++) {
          buffer.deleteCharAt(i);
        }*/ };
    /**
     * Handle "end of data" situations
     *
     * @param context the encoder context
     * @param buffer  the buffer with the remaining encoded characters
     */ C40Encoder.prototype.handleEOD = function(context, buffer) {
        var unwritten = Math.floor(buffer.length() / 3 * 2);
        var rest = buffer.length() % 3;
        var curCodewordCount = context.getCodewordCount() + unwritten;
        context.updateSymbolInfo(curCodewordCount);
        var available = context.getSymbolInfo().getDataCapacity() - curCodewordCount;
        if (rest === 2) {
            buffer.append("\x00"); // Shift 1
            while(buffer.length() >= 3)this.writeNextTriplet(context, buffer);
            if (context.hasMoreCharacters()) context.writeCodeword((0, $8956e14186ab1442$export$d290130da1db6f5e));
        } else if (available === 1 && rest === 1) {
            while(buffer.length() >= 3)this.writeNextTriplet(context, buffer);
            if (context.hasMoreCharacters()) context.writeCodeword((0, $8956e14186ab1442$export$d290130da1db6f5e));
            // else no unlatch
            context.pos--;
        } else if (rest === 0) {
            while(buffer.length() >= 3)this.writeNextTriplet(context, buffer);
            if (available > 0 || context.hasMoreCharacters()) context.writeCodeword((0, $8956e14186ab1442$export$d290130da1db6f5e));
        } else throw new Error("Unexpected case. Please report!");
        context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
    };
    C40Encoder.prototype.encodeChar = function(c, sb) {
        if (c === " ".charCodeAt(0)) {
            sb.append(3);
            return 1;
        }
        if (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0)) {
            sb.append(c - 48 + 4);
            return 1;
        }
        if (c >= "A".charCodeAt(0) && c <= "Z".charCodeAt(0)) {
            sb.append(c - 65 + 14);
            return 1;
        }
        if (c < " ".charCodeAt(0)) {
            sb.append(0); // Shift 1 Set
            sb.append(c);
            return 2;
        }
        if (c <= "/".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 33);
            return 2;
        }
        if (c <= "@".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 58 + 15);
            return 2;
        }
        if (c <= "_".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 91 + 22);
            return 2;
        }
        if (c <= 127) {
            sb.append(2); // Shift 3 Set
            sb.append(c - 96);
            return 2;
        }
        sb.append("1\x1e"); // Shift 2, Upper Shift
        var len = 2;
        len += this.encodeChar(c - 128, sb);
        return len;
    };
    C40Encoder.prototype.encodeToCodewords = function(sb) {
        var v = 1600 * sb.charCodeAt(0) + 40 * sb.charCodeAt(1) + sb.charCodeAt(2) + 1;
        var cw1 = v / 256;
        var cw2 = v % 256;
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        result.append(cw1);
        result.append(cw2);
        return result.toString();
    };
    return C40Encoder;
}();







var $4d7ea0b17e9bff1a$export$be5dd319206857a0 = /** @class */ function() {
    function EdifactEncoder() {}
    EdifactEncoder.prototype.getEncodingMode = function() {
        return 0, $8956e14186ab1442$export$468849a05d2676e7;
    };
    EdifactEncoder.prototype.encode = function(context) {
        // step F
        var buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            this.encodeChar(c, buffer);
            context.pos++;
            var count = buffer.length();
            if (count >= 4) {
                context.writeCodewords(this.encodeToCodewords(buffer.toString()));
                var test_1 = buffer.toString().substring(4);
                buffer.setLengthToZero();
                buffer.append(test_1);
                // buffer.delete(0, 4);
                // for (let i = 0; i < 4; i++) {
                //  buffer.deleteCharAt(i);
                // }
                var newMode = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
                if (newMode !== this.getEncodingMode()) {
                    // Return to ASCII encodation, which will actually handle latch to new mode
                    context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
                    break;
                }
            }
        }
        buffer.append((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(31)); // Unlatch
        this.handleEOD(context, buffer);
    };
    /**
     * Handle "end of data" situations
     *
     * @param context the encoder context
     * @param buffer  the buffer with the remaining encoded characters
     */ EdifactEncoder.prototype.handleEOD = function(context, buffer) {
        try {
            var count = buffer.length();
            if (count === 0) return; // Already finished
            if (count === 1) {
                // Only an unlatch at the end
                context.updateSymbolInfo();
                var available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
                var remaining = context.getRemainingCharacters();
                // The following two lines are a hack inspired by the 'fix' from https://sourceforge.net/p/barcode4j/svn/221/
                if (remaining > available) {
                    context.updateSymbolInfo(context.getCodewordCount() + 1);
                    available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
                }
                if (remaining <= available && available <= 2) return; // No unlatch
            }
            if (count > 4) throw new Error("Count must not exceed 4");
            var restChars = count - 1;
            var encoded = this.encodeToCodewords(buffer.toString());
            var endOfSymbolReached = !context.hasMoreCharacters();
            var restInAscii = endOfSymbolReached && restChars <= 2;
            if (restChars <= 2) {
                context.updateSymbolInfo(context.getCodewordCount() + restChars);
                var available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
                if (available >= 3) {
                    restInAscii = false;
                    context.updateSymbolInfo(context.getCodewordCount() + encoded.length);
                // available = context.symbolInfo.dataCapacity - context.getCodewordCount();
                }
            }
            if (restInAscii) {
                context.resetSymbolInfo();
                context.pos -= restChars;
            } else context.writeCodewords(encoded);
        } finally{
            context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
        }
    };
    EdifactEncoder.prototype.encodeChar = function(c, sb) {
        if (c >= " ".charCodeAt(0) && c <= "?".charCodeAt(0)) sb.append(c);
        else if (c >= "@".charCodeAt(0) && c <= "^".charCodeAt(0)) sb.append((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(c - 64));
        else (0, $5004b1862ab9242e$export$2e2bcd8739ae039).illegalCharacter((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(c));
    };
    EdifactEncoder.prototype.encodeToCodewords = function(sb) {
        var len = sb.length;
        if (len === 0) throw new Error("StringBuilder must not be empty");
        var c1 = sb.charAt(0).charCodeAt(0);
        var c2 = len >= 2 ? sb.charAt(1).charCodeAt(0) : 0;
        var c3 = len >= 3 ? sb.charAt(2).charCodeAt(0) : 0;
        var c4 = len >= 4 ? sb.charAt(3).charCodeAt(0) : 0;
        var v = (c1 << 18) + (c2 << 12) + (c3 << 6) + c4;
        var cw1 = v >> 16 & 255;
        var cw2 = v >> 8 & 255;
        var cw3 = v & 255;
        var res = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        res.append(cw1);
        if (len >= 2) res.append(cw2);
        if (len >= 3) res.append(cw3);
        return res.toString();
    };
    return EdifactEncoder;
}();



var $89599a019adcd89f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89599a019adcd89f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Symbol info table for DataMatrix.
 */ var $89599a019adcd89f$var$SymbolInfo = /** @class */ function() {
    function SymbolInfo(rectangular, dataCapacity, errorCodewords, matrixWidth, matrixHeight, dataRegions, rsBlockData, rsBlockError) {
        if (rsBlockData === void 0) rsBlockData = 0;
        if (rsBlockError === void 0) rsBlockError = 0;
        this.rectangular = rectangular;
        this.dataCapacity = dataCapacity;
        this.errorCodewords = errorCodewords;
        this.matrixWidth = matrixWidth;
        this.matrixHeight = matrixHeight;
        this.dataRegions = dataRegions;
        this.rsBlockData = rsBlockData;
        this.rsBlockError = rsBlockError;
    }
    SymbolInfo.lookup = function(dataCodewords, shape, minSize, maxSize, fail) {
        var e_1, _a;
        if (shape === void 0) shape = 0 /* FORCE_NONE */ ;
        if (minSize === void 0) minSize = null;
        if (maxSize === void 0) maxSize = null;
        if (fail === void 0) fail = true;
        try {
            for(var PROD_SYMBOLS_1 = $89599a019adcd89f$var$__values($89599a019adcd89f$export$8fe6f6a7cdb34756), PROD_SYMBOLS_1_1 = PROD_SYMBOLS_1.next(); !PROD_SYMBOLS_1_1.done; PROD_SYMBOLS_1_1 = PROD_SYMBOLS_1.next()){
                var symbol = PROD_SYMBOLS_1_1.value;
                if (shape === 1 /* FORCE_SQUARE */  && symbol.rectangular) continue;
                if (shape === 2 /* FORCE_RECTANGLE */  && !symbol.rectangular) continue;
                if (minSize != null && (symbol.getSymbolWidth() < minSize.getWidth() || symbol.getSymbolHeight() < minSize.getHeight())) continue;
                if (maxSize != null && (symbol.getSymbolWidth() > maxSize.getWidth() || symbol.getSymbolHeight() > maxSize.getHeight())) continue;
                if (dataCodewords <= symbol.dataCapacity) return symbol;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (PROD_SYMBOLS_1_1 && !PROD_SYMBOLS_1_1.done && (_a = PROD_SYMBOLS_1.return)) _a.call(PROD_SYMBOLS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (fail) throw new Error("Can't find a symbol arrangement that matches the message. Data codewords: " + dataCodewords);
        return null;
    };
    SymbolInfo.prototype.getHorizontalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
                return 1;
            case 2:
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    };
    SymbolInfo.prototype.getVerticalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
            case 2:
                return 1;
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    };
    SymbolInfo.prototype.getSymbolDataWidth = function() {
        return this.getHorizontalDataRegions() * this.matrixWidth;
    };
    SymbolInfo.prototype.getSymbolDataHeight = function() {
        return this.getVerticalDataRegions() * this.matrixHeight;
    };
    SymbolInfo.prototype.getSymbolWidth = function() {
        return this.getSymbolDataWidth() + this.getHorizontalDataRegions() * 2;
    };
    SymbolInfo.prototype.getSymbolHeight = function() {
        return this.getSymbolDataHeight() + this.getVerticalDataRegions() * 2;
    };
    SymbolInfo.prototype.getCodewordCount = function() {
        return this.dataCapacity + this.errorCodewords;
    };
    SymbolInfo.prototype.getInterleavedBlockCount = function() {
        if (!this.rsBlockData) return 1;
        return this.dataCapacity / this.rsBlockData;
    };
    SymbolInfo.prototype.getDataCapacity = function() {
        return this.dataCapacity;
    };
    SymbolInfo.prototype.getErrorCodewords = function() {
        return this.errorCodewords;
    };
    SymbolInfo.prototype.getDataLengthForInterleavedBlock = function(index) {
        return this.rsBlockData;
    };
    SymbolInfo.prototype.getErrorLengthForInterleavedBlock = function(index) {
        return this.rsBlockError;
    };
    return SymbolInfo;
}();
var $89599a019adcd89f$export$2e2bcd8739ae039 = $89599a019adcd89f$var$SymbolInfo;
var $89599a019adcd89f$var$DataMatrixSymbolInfo144 = /** @class */ function(_super) {
    $89599a019adcd89f$var$__extends(DataMatrixSymbolInfo144, _super);
    function DataMatrixSymbolInfo144() {
        return _super.call(this, false, 1558, 620, 22, 22, 36, -1, 62) || this;
    }
    DataMatrixSymbolInfo144.prototype.getInterleavedBlockCount = function() {
        return 10;
    };
    DataMatrixSymbolInfo144.prototype.getDataLengthForInterleavedBlock = function(index) {
        return index <= 8 ? 156 : 155;
    };
    return DataMatrixSymbolInfo144;
}($89599a019adcd89f$var$SymbolInfo);
var $89599a019adcd89f$export$8fe6f6a7cdb34756 = [
    new $89599a019adcd89f$var$SymbolInfo(false, 3, 5, 8, 8, 1),
    new $89599a019adcd89f$var$SymbolInfo(false, 5, 7, 10, 10, 1),
    /*rect*/ new $89599a019adcd89f$var$SymbolInfo(true, 5, 7, 16, 6, 1),
    new $89599a019adcd89f$var$SymbolInfo(false, 8, 10, 12, 12, 1),
    /*rect*/ new $89599a019adcd89f$var$SymbolInfo(true, 10, 11, 14, 6, 2),
    new $89599a019adcd89f$var$SymbolInfo(false, 12, 12, 14, 14, 1),
    /*rect*/ new $89599a019adcd89f$var$SymbolInfo(true, 16, 14, 24, 10, 1),
    new $89599a019adcd89f$var$SymbolInfo(false, 18, 14, 16, 16, 1),
    new $89599a019adcd89f$var$SymbolInfo(false, 22, 18, 18, 18, 1),
    /*rect*/ new $89599a019adcd89f$var$SymbolInfo(true, 22, 18, 16, 10, 2),
    new $89599a019adcd89f$var$SymbolInfo(false, 30, 20, 20, 20, 1),
    /*rect*/ new $89599a019adcd89f$var$SymbolInfo(true, 32, 24, 16, 14, 2),
    new $89599a019adcd89f$var$SymbolInfo(false, 36, 24, 22, 22, 1),
    new $89599a019adcd89f$var$SymbolInfo(false, 44, 28, 24, 24, 1),
    /*rect*/ new $89599a019adcd89f$var$SymbolInfo(true, 49, 28, 22, 14, 2),
    new $89599a019adcd89f$var$SymbolInfo(false, 62, 36, 14, 14, 4),
    new $89599a019adcd89f$var$SymbolInfo(false, 86, 42, 16, 16, 4),
    new $89599a019adcd89f$var$SymbolInfo(false, 114, 48, 18, 18, 4),
    new $89599a019adcd89f$var$SymbolInfo(false, 144, 56, 20, 20, 4),
    new $89599a019adcd89f$var$SymbolInfo(false, 174, 68, 22, 22, 4),
    new $89599a019adcd89f$var$SymbolInfo(false, 204, 84, 24, 24, 4, 102, 42),
    new $89599a019adcd89f$var$SymbolInfo(false, 280, 112, 14, 14, 16, 140, 56),
    new $89599a019adcd89f$var$SymbolInfo(false, 368, 144, 16, 16, 16, 92, 36),
    new $89599a019adcd89f$var$SymbolInfo(false, 456, 192, 18, 18, 16, 114, 48),
    new $89599a019adcd89f$var$SymbolInfo(false, 576, 224, 20, 20, 16, 144, 56),
    new $89599a019adcd89f$var$SymbolInfo(false, 696, 272, 22, 22, 16, 174, 68),
    new $89599a019adcd89f$var$SymbolInfo(false, 816, 336, 24, 24, 16, 136, 56),
    new $89599a019adcd89f$var$SymbolInfo(false, 1050, 408, 18, 18, 36, 175, 68),
    new $89599a019adcd89f$var$SymbolInfo(false, 1304, 496, 20, 20, 36, 163, 62),
    new $89599a019adcd89f$var$DataMatrixSymbolInfo144()
];


var $b92d1472d9600795$export$9cb00ee6d360e345 = /** @class */ function() {
    function EncoderContext(msg) {
        this.msg = msg;
        this.pos = 0;
        this.skipAtEnd = 0;
        // From this point on Strings are not Unicode anymore!
        var msgBinary = msg.split("").map(function(c) {
            return c.charCodeAt(0);
        });
        var sb = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        for(var i = 0, c = msgBinary.length; i < c; i++){
            var ch = String.fromCharCode(msgBinary[i] & 0xff);
            if (ch === "?" && msg.charAt(i) !== "?") throw new Error("Message contains characters outside ISO-8859-1 encoding.");
            sb.append(ch);
        }
        this.msg = sb.toString(); // Not Unicode here!
        this.shape = 0 /* FORCE_NONE */ ;
        this.codewords = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        this.newEncoding = -1;
    }
    EncoderContext.prototype.setSymbolShape = function(shape) {
        this.shape = shape;
    };
    EncoderContext.prototype.setSizeConstraints = function(minSize, maxSize) {
        this.minSize = minSize;
        this.maxSize = maxSize;
    };
    EncoderContext.prototype.getMessage = function() {
        return this.msg;
    };
    EncoderContext.prototype.setSkipAtEnd = function(count) {
        this.skipAtEnd = count;
    };
    EncoderContext.prototype.getCurrentChar = function() {
        return this.msg.charCodeAt(this.pos);
    };
    EncoderContext.prototype.getCurrent = function() {
        return this.msg.charCodeAt(this.pos);
    };
    EncoderContext.prototype.getCodewords = function() {
        return this.codewords;
    };
    EncoderContext.prototype.writeCodewords = function(codewords) {
        this.codewords.append(codewords);
    };
    EncoderContext.prototype.writeCodeword = function(codeword) {
        this.codewords.append(codeword);
    };
    EncoderContext.prototype.getCodewordCount = function() {
        return this.codewords.length();
    };
    EncoderContext.prototype.getNewEncoding = function() {
        return this.newEncoding;
    };
    EncoderContext.prototype.signalEncoderChange = function(encoding) {
        this.newEncoding = encoding;
    };
    EncoderContext.prototype.resetEncoderSignal = function() {
        this.newEncoding = -1;
    };
    EncoderContext.prototype.hasMoreCharacters = function() {
        return this.pos < this.getTotalMessageCharCount();
    };
    EncoderContext.prototype.getTotalMessageCharCount = function() {
        return this.msg.length - this.skipAtEnd;
    };
    EncoderContext.prototype.getRemainingCharacters = function() {
        return this.getTotalMessageCharCount() - this.pos;
    };
    EncoderContext.prototype.getSymbolInfo = function() {
        return this.symbolInfo;
    };
    EncoderContext.prototype.updateSymbolInfo = function(len) {
        if (len === void 0) len = this.getCodewordCount();
        if (this.symbolInfo == null || len > this.symbolInfo.getDataCapacity()) this.symbolInfo = (0, $89599a019adcd89f$export$2e2bcd8739ae039).lookup(len, this.shape, this.minSize, this.maxSize, true);
    };
    EncoderContext.prototype.resetSymbolInfo = function() {
        this.symbolInfo = null;
    };
    return EncoderContext;
}();







var $f65c9d3de37a2f5c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f65c9d3de37a2f5c$export$b705e49a66db2d15 = /** @class */ function(_super) {
    $f65c9d3de37a2f5c$var$__extends(X12Encoder, _super);
    function X12Encoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    X12Encoder.prototype.getEncodingMode = function() {
        return 0, $8956e14186ab1442$export$9c26c56fb5133974;
    };
    X12Encoder.prototype.encode = function(context) {
        // step C
        var buffer = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            context.pos++;
            this.encodeChar(c, buffer);
            var count = buffer.length();
            if (count % 3 === 0) {
                this.writeNextTriplet(context, buffer);
                var newMode = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
                if (newMode !== this.getEncodingMode()) {
                    // Return to ASCII encodation, which will actually handle latch to new mode
                    context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
                    break;
                }
            }
        }
        this.handleEOD(context, buffer);
    };
    X12Encoder.prototype.encodeChar = function(c, sb) {
        switch(c){
            case 13:
                sb.append(0);
                break;
            case "*".charCodeAt(0):
                sb.append(1);
                break;
            case ">".charCodeAt(0):
                sb.append(2);
                break;
            case " ".charCodeAt(0):
                sb.append(3);
                break;
            default:
                if (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0)) sb.append(c - 48 + 4);
                else if (c >= "A".charCodeAt(0) && c <= "Z".charCodeAt(0)) sb.append(c - 65 + 14);
                else (0, $5004b1862ab9242e$export$2e2bcd8739ae039).illegalCharacter((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(c));
                break;
        }
        return 1;
    };
    X12Encoder.prototype.handleEOD = function(context, buffer) {
        context.updateSymbolInfo();
        var available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
        var count = buffer.length();
        context.pos -= count;
        if (context.getRemainingCharacters() > 1 || available > 1 || context.getRemainingCharacters() !== available) context.writeCodeword((0, $8956e14186ab1442$export$15fb43a449900da));
        if (context.getNewEncoding() < 0) context.signalEncoderChange((0, $8956e14186ab1442$export$14da3e339495da6f));
    };
    return X12Encoder;
}((0, $e148c5cb01ffdc9f$export$5b99b12a80a00de6));




var $eff779d455ccc5a0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $eff779d455ccc5a0$export$88fb0cfd153261a7 = /** @class */ function(_super) {
    $eff779d455ccc5a0$var$__extends(TextEncoder, _super);
    function TextEncoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextEncoder.prototype.getEncodingMode = function() {
        return 0, $8956e14186ab1442$export$b6ad1f89161198e3;
    };
    TextEncoder.prototype.encodeChar = function(c, sb) {
        if (c === " ".charCodeAt(0)) {
            sb.append(3);
            return 1;
        }
        if (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0)) {
            sb.append(c - 48 + 4);
            return 1;
        }
        if (c >= "a".charCodeAt(0) && c <= "z".charCodeAt(0)) {
            sb.append(c - 97 + 14);
            return 1;
        }
        if (c < " ".charCodeAt(0)) {
            sb.append(0); // Shift 1 Set
            sb.append(c);
            return 2;
        }
        if (c <= "/".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 33);
            return 2;
        }
        if (c <= "@".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 58 + 15);
            return 2;
        }
        if (c >= "[".charCodeAt(0) && c <= "_".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 91 + 22);
            return 2;
        }
        if (c === "`".charCodeAt(0)) {
            sb.append(2); // Shift 3 Set
            sb.append(0); // '`' - 96 == 0
            return 2;
        }
        if (c <= "Z".charCodeAt(0)) {
            sb.append(2); // Shift 3 Set
            sb.append(c - 65 + 1);
            return 2;
        }
        if (c <= 127) {
            sb.append(2); // Shift 3 Set
            sb.append(c - 123 + 27);
            return 2;
        }
        sb.append("1\x1e"); // Shift 2, Upper Shift
        var len = 2;
        len += this.encodeChar(c - 128, sb);
        return len;
    };
    return TextEncoder;
}((0, $e148c5cb01ffdc9f$export$5b99b12a80a00de6));




/**
 * DataMatrix ECC 200 data encoder following the algorithm described in ISO/IEC 16022:200(E) in
 * annex S.
 */ var $5004b1862ab9242e$var$HighLevelEncoder = /** @class */ function() {
    function HighLevelEncoder() {}
    HighLevelEncoder.randomize253State = function(codewordPosition) {
        var pseudoRandom = 149 * codewordPosition % 253 + 1;
        var tempVariable = (0, $8956e14186ab1442$export$f0a63d87a2a34697) + pseudoRandom;
        return tempVariable <= 254 ? tempVariable : tempVariable - 254;
    };
    /**
     * Performs message encoding of a DataMatrix message using the algorithm described in annex P
     * of ISO/IEC 16022:2000(E).
     *
     * @param msg     the message
     * @param shape   requested shape. May be {@code SymbolShapeHint.FORCE_NONE},
     *                {@code SymbolShapeHint.FORCE_SQUARE} or {@code SymbolShapeHint.FORCE_RECTANGLE}.
     * @param minSize the minimum symbol size constraint or null for no constraint
     * @param maxSize the maximum symbol size constraint or null for no constraint
     * @param forceC40 enforce C40 encoding
     * @return the encoded message (the char values range from 0 to 255)
     */ HighLevelEncoder.encodeHighLevel = function(msg, shape, minSize, maxSize, forceC40) {
        if (shape === void 0) shape = 0 /* FORCE_NONE */ ;
        if (minSize === void 0) minSize = null;
        if (maxSize === void 0) maxSize = null;
        if (forceC40 === void 0) forceC40 = false;
        // the codewords 0..255 are encoded as Unicode characters
        var c40Encoder = new (0, $e148c5cb01ffdc9f$export$5b99b12a80a00de6)();
        var encoders = [
            new (0, $1978ab0a4735d787$export$17a895f6b9e73f8b)(),
            c40Encoder,
            new (0, $eff779d455ccc5a0$export$88fb0cfd153261a7)(),
            new (0, $f65c9d3de37a2f5c$export$b705e49a66db2d15)(),
            new (0, $4d7ea0b17e9bff1a$export$be5dd319206857a0)(),
            new (0, $74199fddb6d8e999$export$28d91855f6c4550e)()
        ];
        var context = new (0, $b92d1472d9600795$export$9cb00ee6d360e345)(msg);
        context.setSymbolShape(shape);
        context.setSizeConstraints(minSize, maxSize);
        if (msg.startsWith((0, $8956e14186ab1442$export$b9291bc7e7703008)) && msg.endsWith((0, $8956e14186ab1442$export$c131c12a8149fc4a))) {
            context.writeCodeword((0, $8956e14186ab1442$export$17e82e449024cedf));
            context.setSkipAtEnd(2);
            context.pos += (0, $8956e14186ab1442$export$b9291bc7e7703008).length;
        } else if (msg.startsWith((0, $8956e14186ab1442$export$d9fe944fda3d8b83)) && msg.endsWith((0, $8956e14186ab1442$export$c131c12a8149fc4a))) {
            context.writeCodeword((0, $8956e14186ab1442$export$a903123fbb5ef394));
            context.setSkipAtEnd(2);
            context.pos += (0, $8956e14186ab1442$export$d9fe944fda3d8b83).length;
        }
        var encodingMode = (0, $8956e14186ab1442$export$14da3e339495da6f); // Default mode
        if (forceC40) {
            c40Encoder.encodeMaximal(context);
            encodingMode = context.getNewEncoding();
            context.resetEncoderSignal();
        }
        while(context.hasMoreCharacters()){
            encoders[encodingMode].encode(context);
            if (context.getNewEncoding() >= 0) {
                encodingMode = context.getNewEncoding();
                context.resetEncoderSignal();
            }
        }
        var len = context.getCodewordCount();
        context.updateSymbolInfo();
        var capacity = context.getSymbolInfo().getDataCapacity();
        if (len < capacity && encodingMode !== (0, $8956e14186ab1442$export$14da3e339495da6f) && encodingMode !== (0, $8956e14186ab1442$export$198535988cfe7d20) && encodingMode !== (0, $8956e14186ab1442$export$468849a05d2676e7)) context.writeCodeword("\xfe"); // Unlatch (254)
        // Padding
        var codewords = context.getCodewords();
        if (codewords.length() < capacity) codewords.append((0, $8956e14186ab1442$export$f0a63d87a2a34697));
        while(codewords.length() < capacity)codewords.append(this.randomize253State(codewords.length() + 1));
        return context.getCodewords().toString();
    };
    HighLevelEncoder.lookAheadTest = function(msg, startpos, currentMode) {
        var newMode = this.lookAheadTestIntern(msg, startpos, currentMode);
        if (currentMode === (0, $8956e14186ab1442$export$9c26c56fb5133974) && newMode === (0, $8956e14186ab1442$export$9c26c56fb5133974)) {
            var endpos = Math.min(startpos + 3, msg.length);
            for(var i = startpos; i < endpos; i++){
                if (!this.isNativeX12(msg.charCodeAt(i))) return 0, $8956e14186ab1442$export$14da3e339495da6f;
            }
        } else if (currentMode === (0, $8956e14186ab1442$export$468849a05d2676e7) && newMode === (0, $8956e14186ab1442$export$468849a05d2676e7)) {
            var endpos = Math.min(startpos + 4, msg.length);
            for(var i = startpos; i < endpos; i++){
                if (!this.isNativeEDIFACT(msg.charCodeAt(i))) return 0, $8956e14186ab1442$export$14da3e339495da6f;
            }
        }
        return newMode;
    };
    HighLevelEncoder.lookAheadTestIntern = function(msg, startpos, currentMode) {
        if (startpos >= msg.length) return currentMode;
        var charCounts;
        // step J
        if (currentMode === (0, $8956e14186ab1442$export$14da3e339495da6f)) charCounts = [
            0,
            1,
            1,
            1,
            1,
            1.25
        ];
        else {
            charCounts = [
                1,
                2,
                2,
                2,
                2,
                2.25
            ];
            charCounts[currentMode] = 0;
        }
        var charsProcessed = 0;
        var mins = new Uint8Array(6);
        var intCharCounts = [];
        while(true){
            // step K
            if (startpos + charsProcessed === msg.length) {
                (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(mins, 0);
                (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(intCharCounts, 0);
                var min = this.findMinimums(charCounts, intCharCounts, (0, $902e90c40380930f$export$2e2bcd8739ae039).MAX_VALUE, mins);
                var minCount = this.getMinimumCount(mins);
                if (intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f] === min) return 0, $8956e14186ab1442$export$14da3e339495da6f;
                if (minCount === 1) {
                    if (mins[0, $8956e14186ab1442$export$198535988cfe7d20] > 0) return 0, $8956e14186ab1442$export$198535988cfe7d20;
                    if (mins[0, $8956e14186ab1442$export$468849a05d2676e7] > 0) return 0, $8956e14186ab1442$export$468849a05d2676e7;
                    if (mins[0, $8956e14186ab1442$export$b6ad1f89161198e3] > 0) return 0, $8956e14186ab1442$export$b6ad1f89161198e3;
                    if (mins[0, $8956e14186ab1442$export$9c26c56fb5133974] > 0) return 0, $8956e14186ab1442$export$9c26c56fb5133974;
                }
                return 0, $8956e14186ab1442$export$1a39cd5cb553e275;
            }
            var c = msg.charCodeAt(startpos + charsProcessed);
            charsProcessed++;
            // step L
            if (this.isDigit(c)) charCounts[0, $8956e14186ab1442$export$14da3e339495da6f] += 0.5;
            else if (this.isExtendedASCII(c)) {
                charCounts[0, $8956e14186ab1442$export$14da3e339495da6f] = Math.ceil(charCounts[0, $8956e14186ab1442$export$14da3e339495da6f]);
                charCounts[0, $8956e14186ab1442$export$14da3e339495da6f] += 2.0;
            } else {
                charCounts[0, $8956e14186ab1442$export$14da3e339495da6f] = Math.ceil(charCounts[0, $8956e14186ab1442$export$14da3e339495da6f]);
                charCounts[0, $8956e14186ab1442$export$14da3e339495da6f]++;
            }
            // step M
            if (this.isNativeC40(c)) charCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275] += 2.0 / 3.0;
            else if (this.isExtendedASCII(c)) charCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275] += 8.0 / 3.0;
            else charCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275] += 4.0 / 3.0;
            // step N
            if (this.isNativeText(c)) charCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3] += 2.0 / 3.0;
            else if (this.isExtendedASCII(c)) charCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3] += 8.0 / 3.0;
            else charCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3] += 4.0 / 3.0;
            // step O
            if (this.isNativeX12(c)) charCounts[0, $8956e14186ab1442$export$9c26c56fb5133974] += 2.0 / 3.0;
            else if (this.isExtendedASCII(c)) charCounts[0, $8956e14186ab1442$export$9c26c56fb5133974] += 13.0 / 3.0;
            else charCounts[0, $8956e14186ab1442$export$9c26c56fb5133974] += 10.0 / 3.0;
            // step P
            if (this.isNativeEDIFACT(c)) charCounts[0, $8956e14186ab1442$export$468849a05d2676e7] += 0.75;
            else if (this.isExtendedASCII(c)) charCounts[0, $8956e14186ab1442$export$468849a05d2676e7] += 4.25;
            else charCounts[0, $8956e14186ab1442$export$468849a05d2676e7] += 3.25;
            // step Q
            if (this.isSpecialB256(c)) charCounts[0, $8956e14186ab1442$export$198535988cfe7d20] += 4.0;
            else charCounts[0, $8956e14186ab1442$export$198535988cfe7d20]++;
            // step R
            if (charsProcessed >= 4) {
                (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(mins, 0);
                (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(intCharCounts, 0);
                this.findMinimums(charCounts, intCharCounts, (0, $902e90c40380930f$export$2e2bcd8739ae039).MAX_VALUE, mins);
                if (intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f] < this.min(intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20], intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275], intCharCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3], intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974], intCharCounts[0, $8956e14186ab1442$export$468849a05d2676e7])) return 0, $8956e14186ab1442$export$14da3e339495da6f;
                if (intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20] < intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f] || intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20] + 1 < this.min(intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275], intCharCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3], intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974], intCharCounts[0, $8956e14186ab1442$export$468849a05d2676e7])) return 0, $8956e14186ab1442$export$198535988cfe7d20;
                if (intCharCounts[0, $8956e14186ab1442$export$468849a05d2676e7] + 1 < this.min(intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20], intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275], intCharCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3], intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974], intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f])) return 0, $8956e14186ab1442$export$468849a05d2676e7;
                if (intCharCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3] + 1 < this.min(intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20], intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275], intCharCounts[0, $8956e14186ab1442$export$468849a05d2676e7], intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974], intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f])) return 0, $8956e14186ab1442$export$b6ad1f89161198e3;
                if (intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974] + 1 < this.min(intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20], intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275], intCharCounts[0, $8956e14186ab1442$export$468849a05d2676e7], intCharCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3], intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f])) return 0, $8956e14186ab1442$export$9c26c56fb5133974;
                if (intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275] + 1 < this.min(intCharCounts[0, $8956e14186ab1442$export$14da3e339495da6f], intCharCounts[0, $8956e14186ab1442$export$198535988cfe7d20], intCharCounts[0, $8956e14186ab1442$export$468849a05d2676e7], intCharCounts[0, $8956e14186ab1442$export$b6ad1f89161198e3])) {
                    if (intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275] < intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974]) return 0, $8956e14186ab1442$export$1a39cd5cb553e275;
                    if (intCharCounts[0, $8956e14186ab1442$export$1a39cd5cb553e275] === intCharCounts[0, $8956e14186ab1442$export$9c26c56fb5133974]) {
                        var p = startpos + charsProcessed + 1;
                        while(p < msg.length){
                            var tc = msg.charCodeAt(p);
                            if (this.isX12TermSep(tc)) return 0, $8956e14186ab1442$export$9c26c56fb5133974;
                            if (!this.isNativeX12(tc)) break;
                            p++;
                        }
                        return 0, $8956e14186ab1442$export$1a39cd5cb553e275;
                    }
                }
            }
        }
    };
    HighLevelEncoder.min = function(f1, f2, f3, f4, f5) {
        var val = Math.min(f1, Math.min(f2, Math.min(f3, f4)));
        if (f5 === undefined) return val;
        else return Math.min(val, f5);
    };
    HighLevelEncoder.findMinimums = function(charCounts, intCharCounts, min, mins) {
        for(var i = 0; i < 6; i++){
            var current = intCharCounts[i] = Math.ceil(charCounts[i]);
            if (min > current) {
                min = current;
                (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(mins, 0);
            }
            if (min === current) mins[i] = mins[i] + 1;
        }
        return min;
    };
    HighLevelEncoder.getMinimumCount = function(mins) {
        var minCount = 0;
        for(var i = 0; i < 6; i++)minCount += mins[i];
        return minCount || 0;
    };
    HighLevelEncoder.isDigit = function(ch) {
        return ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0);
    };
    HighLevelEncoder.isExtendedASCII = function(ch) {
        return ch >= 128 && ch <= 255;
    };
    HighLevelEncoder.isNativeC40 = function(ch) {
        return ch === " ".charCodeAt(0) || ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0) || ch >= "A".charCodeAt(0) && ch <= "Z".charCodeAt(0);
    };
    HighLevelEncoder.isNativeText = function(ch) {
        return ch === " ".charCodeAt(0) || ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0) || ch >= "a".charCodeAt(0) && ch <= "z".charCodeAt(0);
    };
    HighLevelEncoder.isNativeX12 = function(ch) {
        return this.isX12TermSep(ch) || ch === " ".charCodeAt(0) || ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0) || ch >= "A".charCodeAt(0) && ch <= "Z".charCodeAt(0);
    };
    HighLevelEncoder.isX12TermSep = function(ch) {
        return ch === 13 || // CR
        ch === "*".charCodeAt(0) || ch === ">".charCodeAt(0);
    };
    HighLevelEncoder.isNativeEDIFACT = function(ch) {
        return ch >= " ".charCodeAt(0) && ch <= "^".charCodeAt(0);
    };
    HighLevelEncoder.isSpecialB256 = function(ch) {
        return false; // TODO NOT IMPLEMENTED YET!!!
    };
    /**
     * Determines the number of consecutive characters that are encodable using numeric compaction.
     *
     * @param msg      the message
     * @param startpos the start position within the message
     * @return the requested character count
     */ HighLevelEncoder.determineConsecutiveDigitCount = function(msg, startpos) {
        if (startpos === void 0) startpos = 0;
        var len = msg.length;
        var idx = startpos;
        while(idx < len && this.isDigit(msg.charCodeAt(idx)))idx++;
        return idx - startpos;
    };
    HighLevelEncoder.illegalCharacter = function(singleCharacter) {
        var hex = (0, $902e90c40380930f$export$2e2bcd8739ae039).toHexString(singleCharacter.charCodeAt(0));
        hex = "0000".substring(0, 4 - hex.length) + hex;
        throw new Error("Illegal character: " + singleCharacter + " (0x" + hex + ")");
    };
    return HighLevelEncoder;
}();
var $5004b1862ab9242e$export$2e2bcd8739ae039 = $5004b1862ab9242e$var$HighLevelEncoder;



















/**
 * Set of CharsetEncoders for a given input string
 *
 * Invariants:
 * - The list contains only encoders from CharacterSetECI (list is shorter then the list of encoders available on
 *   the platform for which ECI values are defined).
 * - The list contains encoders at least one encoder for every character in the input.
 * - The first encoder in the list is always the ISO-8859-1 encoder even of no character in the input can be encoded
 *       by it.
 * - If the input contains a character that is not in ISO-8859-1 then the last two entries in the list will be the
 *   UTF-8 encoder and the UTF-16BE encoder.
 *
 * @author Alex Geller
 */ 



var $911d8f78917759f8$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $911d8f78917759f8$var$CharsetEncoder = /** @class */ function() {
    function CharsetEncoder(charset) {
        this.charset = charset;
        this.name = charset.name;
    }
    CharsetEncoder.prototype.canEncode = function(c) {
        try {
            return (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).encode(c, this.charset) != null;
        } catch (ex) {
            return false;
        }
    };
    return CharsetEncoder;
}();
var $911d8f78917759f8$export$b5aa35b60608d324 = /** @class */ function() {
    /**
     * Constructs an encoder set
     *
     * @param stringToEncode the string that needs to be encoded
     * @param priorityCharset The preferred {@link Charset} or null.
     * @param fnc1 fnc1 denotes the character in the input that represents the FNC1 character or -1 for a non-GS1 bar
     * code. When specified, it is considered an error to pass it as argument to the methods canEncode() or encode().
     */ function ECIEncoderSet(stringToEncode, priorityCharset, fnc1) {
        var e_1, _a, e_2, _b, e_3, _c;
        this.ENCODERS = [
            "IBM437",
            "ISO-8859-2",
            "ISO-8859-3",
            "ISO-8859-4",
            "ISO-8859-5",
            "ISO-8859-6",
            "ISO-8859-7",
            "ISO-8859-8",
            "ISO-8859-9",
            "ISO-8859-10",
            "ISO-8859-11",
            "ISO-8859-13",
            "ISO-8859-14",
            "ISO-8859-15",
            "ISO-8859-16",
            "windows-1250",
            "windows-1251",
            "windows-1252",
            "windows-1256",
            "Shift_JIS"
        ].map(function(name) {
            return new $911d8f78917759f8$var$CharsetEncoder((0, $64e0b7362b63fd2a$export$2e2bcd8739ae039).forName(name));
        });
        this.encoders = [];
        var neededEncoders = [];
        // we always need the ISO-8859-1 encoder. It is the default encoding
        neededEncoders.push(new $911d8f78917759f8$var$CharsetEncoder((0, $e21db4982d838126$export$2e2bcd8739ae039).ISO_8859_1));
        var needUnicodeEncoder = priorityCharset != null && priorityCharset.name.startsWith("UTF");
        // Walk over the input string and see if all characters can be encoded with the list of encoders
        for(var i = 0; i < stringToEncode.length; i++){
            var canEncode = false;
            try {
                for(var neededEncoders_1 = (e_1 = void 0, $911d8f78917759f8$var$__values(neededEncoders)), neededEncoders_1_1 = neededEncoders_1.next(); !neededEncoders_1_1.done; neededEncoders_1_1 = neededEncoders_1.next()){
                    var encoder = neededEncoders_1_1.value;
                    var singleCharacter = stringToEncode.charAt(i);
                    var c = singleCharacter.charCodeAt(0);
                    if (c === fnc1 || encoder.canEncode(singleCharacter)) {
                        canEncode = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (neededEncoders_1_1 && !neededEncoders_1_1.done && (_a = neededEncoders_1.return)) _a.call(neededEncoders_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (!canEncode) try {
                // for the character at position i we don't yet have an encoder in the list
                for(var _d = (e_2 = void 0, $911d8f78917759f8$var$__values(this.ENCODERS)), _e = _d.next(); !_e.done; _e = _d.next()){
                    var encoder = _e.value;
                    if (encoder.canEncode(stringToEncode.charAt(i))) {
                        // Good, we found an encoder that can encode the character. We add him to the list and continue scanning
                        // the input
                        neededEncoders.push(encoder);
                        canEncode = true;
                        break;
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            if (!canEncode) // The character is not encodeable by any of the single byte encoders so we remember that we will need a
            // Unicode encoder.
            needUnicodeEncoder = true;
        }
        if (neededEncoders.length === 1 && !needUnicodeEncoder) // the entire input can be encoded by the ISO-8859-1 encoder
        this.encoders = [
            neededEncoders[0]
        ];
        else {
            // we need more than one single byte encoder or we need a Unicode encoder.
            // In this case we append a UTF-8 and UTF-16 encoder to the list
            this.encoders = [];
            var index = 0;
            try {
                for(var neededEncoders_2 = $911d8f78917759f8$var$__values(neededEncoders), neededEncoders_2_1 = neededEncoders_2.next(); !neededEncoders_2_1.done; neededEncoders_2_1 = neededEncoders_2.next()){
                    var encoder = neededEncoders_2_1.value;
                    this.encoders[index++] = encoder;
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (neededEncoders_2_1 && !neededEncoders_2_1.done && (_c = neededEncoders_2.return)) _c.call(neededEncoders_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        // this.encoders[index] = new CharsetEncoder(StandardCharsets.UTF_8);
        // this.encoders[index + 1] = new CharsetEncoder(StandardCharsets.UTF_16BE);
        }
        // Compute priorityEncoderIndex by looking up priorityCharset in encoders
        var priorityEncoderIndexValue = -1;
        if (priorityCharset != null) {
            for(var i = 0; i < this.encoders.length; i++)if (this.encoders[i] != null && priorityCharset.name === this.encoders[i].name) {
                priorityEncoderIndexValue = i;
                break;
            }
        }
        this.priorityEncoderIndex = priorityEncoderIndexValue;
    // invariants
    // if(this?.encoders?.[0].name !== StandardCharsets.ISO_8859_1)){
    // throw new Error("ISO-8859-1 must be the first encoder");
    // }
    }
    ECIEncoderSet.prototype.length = function() {
        return this.encoders.length;
    };
    ECIEncoderSet.prototype.getCharsetName = function(index) {
        if (!(index < this.length())) throw new Error("index must be less than length");
        return this.encoders[index].name;
    };
    ECIEncoderSet.prototype.getCharset = function(index) {
        if (!(index < this.length())) throw new Error("index must be less than length");
        return this.encoders[index].charset;
    };
    ECIEncoderSet.prototype.getECIValue = function(encoderIndex) {
        return this.encoders[encoderIndex].charset.getValueIdentifier();
    };
    /*
     *  returns -1 if no priority charset was defined
     */ ECIEncoderSet.prototype.getPriorityEncoderIndex = function() {
        return this.priorityEncoderIndex;
    };
    ECIEncoderSet.prototype.canEncode = function(c, encoderIndex) {
        if (!(encoderIndex < this.length())) throw new Error("index must be less than length");
        return true;
    };
    ECIEncoderSet.prototype.encode = function(c, encoderIndex) {
        if (!(encoderIndex < this.length())) throw new Error("index must be less than length");
        return (0, $3a88fa58822b35a1$export$2e2bcd8739ae039).encode((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharAt(c), this.encoders[encoderIndex].name);
    };
    return ECIEncoderSet;
}();




var $0a66882b3a01c6d6$var$COST_PER_ECI = 3; // approximated (latch + 2 codewords)
var $0a66882b3a01c6d6$export$196399f5a83a42b6 = /** @class */ function() {
    /**
     * Constructs a minimal input
     *
     * @param stringToEncode the character string to encode
     * @param priorityCharset The preferred {@link Charset}. When the value of the argument is null, the algorithm
     *   chooses charsets that leads to a minimal representation. Otherwise the algorithm will use the priority
     *   charset to encode any character in the input that can be encoded by it if the charset is among the
     *   supported charsets.
     * @param fnc1 denotes the character in the input that represents the FNC1 character or -1 if this is not GS1
     *   input.
     */ function MinimalECIInput(stringToEncode, priorityCharset, fnc1) {
        this.fnc1 = fnc1;
        var encoderSet = new (0, $911d8f78917759f8$export$b5aa35b60608d324)(stringToEncode, priorityCharset, fnc1);
        if (encoderSet.length() === 1) // optimization for the case when all can be encoded without ECI in ISO-8859-1
        for(var i = 0; i < this.bytes.length; i++){
            var c = stringToEncode.charAt(i).charCodeAt(0);
            this.bytes[i] = c === fnc1 ? 1000 : c;
        }
        else this.bytes = this.encodeMinimally(stringToEncode, encoderSet, fnc1);
    }
    MinimalECIInput.prototype.getFNC1Character = function() {
        return this.fnc1;
    };
    /**
     * Returns the length of this input.  The length is the number
     * of {@code byte}s, FNC1 characters or ECIs in the sequence.
     *
     * @return  the number of {@code char}s in this sequence
     */ MinimalECIInput.prototype.length = function() {
        return this.bytes.length;
    };
    MinimalECIInput.prototype.haveNCharacters = function(index, n) {
        if (index + n - 1 >= this.bytes.length) return false;
        for(var i = 0; i < n; i++){
            if (this.isECI(index + i)) return false;
        }
        return true;
    };
    /**
     * Returns the {@code byte} value at the specified index.  An index ranges from zero
     * to {@code length() - 1}.  The first {@code byte} value of the sequence is at
     * index zero, the next at index one, and so on, as for array
     * indexing.
     *
     * @param   index the index of the {@code byte} value to be returned
     *
     * @return  the specified {@code byte} value as character or the FNC1 character
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     * @throws  IllegalArgumentException
     *          if the value at the {@code index} argument is an ECI (@see #isECI)
     */ MinimalECIInput.prototype.charAt = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        if (this.isECI(index)) throw new Error("value at " + index + " is not a character but an ECI");
        return this.isFNC1(index) ? this.fnc1 : this.bytes[index];
    };
    /**
     * Returns a {@code CharSequence} that is a subsequence of this sequence.
     * The subsequence starts with the {@code char} value at the specified index and
     * ends with the {@code char} value at index {@code end - 1}.  The length
     * (in {@code char}s) of the
     * returned sequence is {@code end - start}, so if {@code start == end}
     * then an empty sequence is returned.
     *
     * @param   start   the start index, inclusive
     * @param   end     the end index, exclusive
     *
     * @return  the specified subsequence
     *
     * @throws  IndexOutOfBoundsException
     *          if {@code start} or {@code end} are negative,
     *          if {@code end} is greater than {@code length()},
     *          or if {@code start} is greater than {@code end}
     * @throws  IllegalArgumentException
     *          if a value in the range {@code start}-{@code end} is an ECI (@see #isECI)
     */ MinimalECIInput.prototype.subSequence = function(start, end) {
        if (start < 0 || start > end || end > this.length()) throw new Error("" + start);
        var result = new (0, $f9764fdce9a0dbd7$export$2e2bcd8739ae039)();
        for(var i = start; i < end; i++){
            if (this.isECI(i)) throw new Error("value at " + i + " is not a character but an ECI");
            result.append(this.charAt(i));
        }
        return result.toString();
    };
    /**
     * Determines if a value is an ECI
     *
     * @param   index the index of the value
     *
     * @return  true if the value at position {@code index} is an ECI
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     */ MinimalECIInput.prototype.isECI = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        return this.bytes[index] > 255 && this.bytes[index] <= 999;
    };
    /**
     * Determines if a value is the FNC1 character
     *
     * @param   index the index of the value
     *
     * @return  true if the value at position {@code index} is the FNC1 character
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     */ MinimalECIInput.prototype.isFNC1 = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        return this.bytes[index] === 1000;
    };
    /**
     * Returns the {@code int} ECI value at the specified index.  An index ranges from zero
     * to {@code length() - 1}.  The first {@code byte} value of the sequence is at
     * index zero, the next at index one, and so on, as for array
     * indexing.
     *
     * @param   index the index of the {@code int} value to be returned
     *
     * @return  the specified {@code int} ECI value.
     *          The ECI specified the encoding of all bytes with a higher index until the
     *          next ECI or until the end of the input if no other ECI follows.
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     * @throws  IllegalArgumentException
     *          if the value at the {@code index} argument is not an ECI (@see #isECI)
     */ MinimalECIInput.prototype.getECIValue = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        if (!this.isECI(index)) throw new Error("value at " + index + " is not an ECI but a character");
        return this.bytes[index] - 256;
    };
    MinimalECIInput.prototype.addEdge = function(edges, to, edge) {
        if (edges[to][edge.encoderIndex] == null || edges[to][edge.encoderIndex].cachedTotalSize > edge.cachedTotalSize) edges[to][edge.encoderIndex] = edge;
    };
    MinimalECIInput.prototype.addEdges = function(stringToEncode, encoderSet, edges, from, previous, fnc1) {
        var ch = stringToEncode.charAt(from).charCodeAt(0);
        var start = 0;
        var end = encoderSet.length();
        if (encoderSet.getPriorityEncoderIndex() >= 0 && (ch === fnc1 || encoderSet.canEncode(ch, encoderSet.getPriorityEncoderIndex()))) {
            start = encoderSet.getPriorityEncoderIndex();
            end = start + 1;
        }
        for(var i = start; i < end; i++)if (ch === fnc1 || encoderSet.canEncode(ch, i)) this.addEdge(edges, from + 1, new $0a66882b3a01c6d6$var$InputEdge(ch, encoderSet, i, previous, fnc1));
    };
    MinimalECIInput.prototype.encodeMinimally = function(stringToEncode, encoderSet, fnc1) {
        var inputLength = stringToEncode.length;
        // Array that represents vertices. There is a vertex for every character and encoding.
        var edges = new $0a66882b3a01c6d6$var$InputEdge[inputLength + 1][encoderSet.length()]();
        this.addEdges(stringToEncode, encoderSet, edges, 0, null, fnc1);
        for(var i = 1; i <= inputLength; i++){
            for(var j = 0; j < encoderSet.length(); j++)if (edges[i][j] != null && i < inputLength) this.addEdges(stringToEncode, encoderSet, edges, i, edges[i][j], fnc1);
            // optimize memory by removing edges that have been passed.
            for(var j = 0; j < encoderSet.length(); j++)edges[i - 1][j] = null;
        }
        var minimalJ = -1;
        var minimalSize = (0, $902e90c40380930f$export$2e2bcd8739ae039).MAX_VALUE;
        for(var j = 0; j < encoderSet.length(); j++)if (edges[inputLength][j] != null) {
            var edge = edges[inputLength][j];
            if (edge.cachedTotalSize < minimalSize) {
                minimalSize = edge.cachedTotalSize;
                minimalJ = j;
            }
        }
        if (minimalJ < 0) throw new Error('Failed to encode "' + stringToEncode + '"');
        var intsAL = [];
        var current = edges[inputLength][minimalJ];
        while(current != null){
            if (current.isFNC1()) intsAL.unshift(1000);
            else {
                var bytes = encoderSet.encode(current.c, current.encoderIndex);
                for(var i = bytes.length - 1; i >= 0; i--)intsAL.unshift(bytes[i] & 0xff);
            }
            var previousEncoderIndex = current.previous === null ? 0 : current.previous.encoderIndex;
            if (previousEncoderIndex !== current.encoderIndex) intsAL.unshift(256 + encoderSet.getECIValue(current.encoderIndex));
            current = current.previous;
        }
        var ints = [];
        for(var i = 0; i < ints.length; i++)ints[i] = intsAL[i];
        return ints;
    };
    return MinimalECIInput;
}();
var $0a66882b3a01c6d6$var$InputEdge = /** @class */ function() {
    function InputEdge(c, encoderSet, encoderIndex, previous, fnc1) {
        this.c = c;
        this.encoderSet = encoderSet;
        this.encoderIndex = encoderIndex;
        this.previous = previous;
        this.fnc1 = fnc1;
        this.c = c === fnc1 ? 1000 : c;
        var size = this.isFNC1() ? 1 : encoderSet.encode(c, encoderIndex).length;
        var previousEncoderIndex = previous === null ? 0 : previous.encoderIndex;
        if (previousEncoderIndex !== encoderIndex) size += $0a66882b3a01c6d6$var$COST_PER_ECI;
        if (previous != null) size += previous.cachedTotalSize;
        this.cachedTotalSize = size;
    }
    InputEdge.prototype.isFNC1 = function() {
        return this.c === 1000;
    };
    return InputEdge;
}();



var $40d095c1484f0bf7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $40d095c1484f0bf7$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $40d095c1484f0bf7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $40d095c1484f0bf7$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($40d095c1484f0bf7$var$__read(arguments[i]));
    return ar;
};
var $40d095c1484f0bf7$var$Mode;
(function(Mode) {
    Mode[Mode["ASCII"] = 0] = "ASCII";
    Mode[Mode["C40"] = 1] = "C40";
    Mode[Mode["TEXT"] = 2] = "TEXT";
    Mode[Mode["X12"] = 3] = "X12";
    Mode[Mode["EDF"] = 4] = "EDF";
    Mode[Mode["B256"] = 5] = "B256";
})($40d095c1484f0bf7$var$Mode || ($40d095c1484f0bf7$var$Mode = {}));
var $40d095c1484f0bf7$var$C40_SHIFT2_CHARS = [
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "[",
    "\\",
    "]",
    "^",
    "_"
];
var $40d095c1484f0bf7$export$c5f059be53a7e40d = /** @class */ function() {
    function MinimalEncoder() {}
    MinimalEncoder.isExtendedASCII = function(ch, fnc1) {
        return ch !== fnc1 && ch >= 128 && ch <= 255;
    };
    MinimalEncoder.isInC40Shift1Set = function(ch) {
        return ch <= 31;
    };
    MinimalEncoder.isInC40Shift2Set = function(ch, fnc1) {
        var e_1, _a;
        try {
            for(var C40_SHIFT2_CHARS_1 = $40d095c1484f0bf7$var$__values($40d095c1484f0bf7$var$C40_SHIFT2_CHARS), C40_SHIFT2_CHARS_1_1 = C40_SHIFT2_CHARS_1.next(); !C40_SHIFT2_CHARS_1_1.done; C40_SHIFT2_CHARS_1_1 = C40_SHIFT2_CHARS_1.next()){
                var c40Shift2Char = C40_SHIFT2_CHARS_1_1.value;
                if (c40Shift2Char.charCodeAt(0) === ch) return true;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (C40_SHIFT2_CHARS_1_1 && !C40_SHIFT2_CHARS_1_1.done && (_a = C40_SHIFT2_CHARS_1.return)) _a.call(C40_SHIFT2_CHARS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return ch === fnc1;
    };
    MinimalEncoder.isInTextShift1Set = function(ch) {
        return this.isInC40Shift1Set(ch);
    };
    MinimalEncoder.isInTextShift2Set = function(ch, fnc1) {
        return this.isInC40Shift2Set(ch, fnc1);
    };
    /**
     * Performs message encoding of a DataMatrix message
     *
     * @param msg the message
     * @param priorityCharset The preferred {@link Charset}. When the value of the argument is null, the algorithm
     *   chooses charsets that leads to a minimal representation. Otherwise the algorithm will use the priority
     *   charset to encode any character in the input that can be encoded by it if the charset is among the
     *   supported charsets.
     * @param fnc1 denotes the character in the input that represents the FNC1 character or -1 if this is not a GS1
     *   bar code. If the value is not -1 then a FNC1 is also prepended.
     * @param shape requested shape.
     * @return the encoded message (the char values range from 0 to 255)
     */ MinimalEncoder.encodeHighLevel = function(msg, priorityCharset, fnc1, shape) {
        if (priorityCharset === void 0) priorityCharset = null;
        if (fnc1 === void 0) fnc1 = -1;
        if (shape === void 0) shape = 0 /* FORCE_NONE */ ;
        var macroId = 0;
        if (msg.startsWith((0, $8956e14186ab1442$export$b9291bc7e7703008)) && msg.endsWith((0, $8956e14186ab1442$export$c131c12a8149fc4a))) {
            macroId = 5;
            msg = msg.substring((0, $8956e14186ab1442$export$b9291bc7e7703008).length, msg.length - 2);
        } else if (msg.startsWith((0, $8956e14186ab1442$export$d9fe944fda3d8b83)) && msg.endsWith((0, $8956e14186ab1442$export$c131c12a8149fc4a))) {
            macroId = 6;
            msg = msg.substring((0, $8956e14186ab1442$export$d9fe944fda3d8b83).length, msg.length - 2);
        }
        return decodeURIComponent(escape(String.fromCharCode.apply(String, $40d095c1484f0bf7$var$__spread(this.encode(msg, priorityCharset, fnc1, shape, macroId)))));
    };
    /**
     * Encodes input minimally and returns an array of the codewords
     *
     * @param input The string to encode
     * @param priorityCharset The preferred {@link Charset}. When the value of the argument is null, the algorithm
     *   chooses charsets that leads to a minimal representation. Otherwise the algorithm will use the priority
     *   charset to encode any character in the input that can be encoded by it if the charset is among the
     *   supported charsets.
     * @param fnc1 denotes the character in the input that represents the FNC1 character or -1 if this is not a GS1
     *   bar code. If the value is not -1 then a FNC1 is also prepended.
     * @param shape requested shape.
     * @param macroId Prepends the specified macro function in case that a value of 5 or 6 is specified.
     * @return An array of bytes representing the codewords of a minimal encoding.
     */ MinimalEncoder.encode = function(input, priorityCharset, fnc1, shape, macroId) {
        return this.encodeMinimally(new $40d095c1484f0bf7$var$Input(input, priorityCharset, fnc1, shape, macroId)).getBytes();
    };
    MinimalEncoder.addEdge = function(edges, edge) {
        var vertexIndex = edge.fromPosition + edge.characterLength;
        if (edges[vertexIndex][edge.getEndMode()] === null || edges[vertexIndex][edge.getEndMode()].cachedTotalSize > edge.cachedTotalSize) edges[vertexIndex][edge.getEndMode()] = edge;
    };
    /** @return the number of words in which the string starting at from can be encoded in c40 or text mode.
     *  The number of characters encoded is returned in characterLength.
     *  The number of characters encoded is also minimal in the sense that the algorithm stops as soon
     *  as a character encoding fills a C40 word competely (three C40 values). An exception is at the
     *  end of the string where two C40 values are allowed (according to the spec the third c40 value
     *  is filled  with 0 (Shift 1) in this case).
     */ MinimalEncoder.getNumberOfC40Words = function(input, from, c40, characterLength) {
        var thirdsCount = 0;
        for(var i = from; i < input.length(); i++){
            if (input.isECI(i)) {
                characterLength[0] = 0;
                return 0;
            }
            var ci = input.charAt(i);
            if (c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeC40(ci) || !c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeText(ci)) thirdsCount++; // native
            else if (!MinimalEncoder.isExtendedASCII(ci, input.getFNC1Character())) thirdsCount += 2; // shift
            else {
                var asciiValue = ci & 0xff;
                if (asciiValue >= 128 && (c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeC40(asciiValue - 128) || !c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeText(asciiValue - 128))) thirdsCount += 3; // shift, Upper shift
                else thirdsCount += 4; // shift, Upper shift, shift
            }
            if (thirdsCount % 3 === 0 || (thirdsCount - 2) % 3 === 0 && i + 1 === input.length()) {
                characterLength[0] = i - from + 1;
                return Math.ceil(thirdsCount / 3.0);
            }
        }
        characterLength[0] = 0;
        return 0;
    };
    MinimalEncoder.addEdges = function(input, edges, from, previous) {
        var e_2, _a;
        if (input.isECI(from)) {
            this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.ASCII, from, 1, previous));
            return;
        }
        var ch = input.charAt(from);
        if (previous === null || previous.getEndMode() !== $40d095c1484f0bf7$var$Mode.EDF) {
            // not possible to unlatch a full EDF edge to something
            // else
            if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(ch) && input.haveNCharacters(from, 2) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(input.charAt(from + 1))) // two digits ASCII encoded
            this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.ASCII, from, 2, previous));
            else // one ASCII encoded character or an extended character via Upper Shift
            this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.ASCII, from, 1, previous));
            var modes = [
                $40d095c1484f0bf7$var$Mode.C40,
                $40d095c1484f0bf7$var$Mode.TEXT
            ];
            try {
                for(var modes_1 = $40d095c1484f0bf7$var$__values(modes), modes_1_1 = modes_1.next(); !modes_1_1.done; modes_1_1 = modes_1.next()){
                    var mode = modes_1_1.value;
                    var characterLength = [];
                    if (MinimalEncoder.getNumberOfC40Words(input, from, mode === $40d095c1484f0bf7$var$Mode.C40, characterLength) > 0) this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, mode, from, characterLength[0], previous));
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (modes_1_1 && !modes_1_1.done && (_a = modes_1.return)) _a.call(modes_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            if (input.haveNCharacters(from, 3) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeX12(input.charAt(from)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeX12(input.charAt(from + 1)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeX12(input.charAt(from + 2))) this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.X12, from, 3, previous));
            this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.B256, from, 1, previous));
        }
        // We create 4 EDF edges,  with 1, 2 3 or 4 characters length. The fourth normally doesn't have a latch to ASCII
        // unless it is 2 characters away from the end of the input.
        var i;
        for(i = 0; i < 3; i++){
            var pos = from + i;
            if (input.haveNCharacters(pos, 1) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeEDIFACT(input.charAt(pos))) this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.EDF, from, i + 1, previous));
            else break;
        }
        if (i === 3 && input.haveNCharacters(from, 4) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeEDIFACT(input.charAt(from + 3))) this.addEdge(edges, new $40d095c1484f0bf7$var$Edge(input, $40d095c1484f0bf7$var$Mode.EDF, from, 4, previous));
    };
    MinimalEncoder.encodeMinimally = function(input) {
        /* The minimal encoding is computed by Dijkstra. The acyclic graph is modeled as follows:
         * A vertex represents a combination of a position in the input and an encoding mode where position 0
         * denotes the position left of the first character, 1 the position left of the second character and so on.
         * Likewise the end vertices are located after the last character at position input.length().
         * For any position there might be up to six vertices, one for each of the encoding types ASCII, C40, TEXT, X12,
         * EDF and B256.
         *
         * As an example consider the input string "ABC123" then at position 0 there is only one vertex with the default
         * ASCII encodation. At position 3 there might be vertices for the types ASCII, C40, X12, EDF and B256.
         *
         * An edge leading to such a vertex encodes one or more of the characters left of the position that the vertex
         * represents. It encodes the characters in the encoding mode of the vertex that it ends on. In other words,
         * all edges leading to a particular vertex encode the same characters (the length of the suffix can vary) using the same
         * encoding mode.
         * As an example consider the input string "ABC123" and the vertex (4,EDF). Possible edges leading to this vertex
         * are:
         *   (0,ASCII)  --EDF(ABC1)--> (4,EDF)
         *   (1,ASCII)  --EDF(BC1)-->  (4,EDF)
         *   (1,B256)   --EDF(BC1)-->  (4,EDF)
         *   (1,EDF)    --EDF(BC1)-->  (4,EDF)
         *   (2,ASCII)  --EDF(C1)-->   (4,EDF)
         *   (2,B256)   --EDF(C1)-->   (4,EDF)
         *   (2,EDF)    --EDF(C1)-->   (4,EDF)
         *   (3,ASCII)  --EDF(1)-->    (4,EDF)
         *   (3,B256)   --EDF(1)-->    (4,EDF)
         *   (3,EDF)    --EDF(1)-->    (4,EDF)
         *   (3,C40)    --EDF(1)-->    (4,EDF)
         *   (3,X12)    --EDF(1)-->    (4,EDF)
         *
         * The edges leading to a vertex are stored in such a way that there is a fast way to enumerate the edges ending
         * on a particular vertex.
         *
         * The algorithm processes the vertices in order of their position thereby performing the following:
         *
         * For every vertex at position i the algorithm enumerates the edges ending on the vertex and removes all but the
         * shortest from that list.
         * Then it processes the vertices for the position i+1. If i+1 == input.length() then the algorithm ends
         * and chooses the the edge with the smallest size from any of the edges leading to vertices at this position.
         * Otherwise the algorithm computes all possible outgoing edges for the vertices at the position i+1
         *
         * Examples:
         * The process is illustrated by showing the graph (edges) after each iteration from left to right over the input:
         * An edge is drawn as follows "(" + fromVertex + ") -- " + encodingMode + "(" + encodedInput + ") (" +
         * accumulatedSize + ") --> (" + toVertex + ")"
         *
         * Example 1 encoding the string "ABCDEFG":
         *
         *
         * Situation after adding edges to the start vertex (0,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         *
         * Situation after adding edges to vertices at position 1
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) B256(B) (4) --> (2,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BC) (5) --> (3,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) TEXT(BCD) (6) --> (4,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCD) (5) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCDE) (5) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) ASCII(B) (4) --> (2,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BC) (6) --> (3,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) C40(BCD) (5) --> (4,C40)
         * (0,ASCII) B256(A) (3) --> (1,B256) TEXT(BCD) (7) --> (4,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) X12(BCD) (5) --> (4,X12)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCD) (6) --> (4,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCDE) (6) --> (5,EDF)
         *
         * Edge "(1,ASCII) ASCII(B) (2) --> (2,ASCII)" is minimal for the vertex (2,ASCII) so that edge "(1,B256) ASCII(B) (4) --> (2,ASCII)" is removed.
         * Edge "(1,B256) B256(B) (3) --> (2,B256)" is minimal for the vertext (2,B256) so that the edge "(1,ASCII) B256(B) (4) --> (2,B256)" is removed.
         *
         * Situation after adding edges to vertices at position 2
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BC) (5) --> (3,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) TEXT(BCD) (6) --> (4,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCD) (5) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCDE) (5) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BC) (6) --> (3,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) C40(BCD) (5) --> (4,C40)
         * (0,ASCII) B256(A) (3) --> (1,B256) TEXT(BCD) (7) --> (4,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) X12(BCD) (5) --> (4,X12)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCD) (6) --> (4,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCDE) (6) --> (5,EDF)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) ASCII(C) (5) --> (3,ASCII)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) B256(C) (6) --> (3,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) EDF(CD) (7) --> (4,EDF)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) C40(CDE) (6) --> (5,C40)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) TEXT(CDE) (8) --> (5,TEXT)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) X12(CDE) (6) --> (5,X12)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) EDF(CDE) (7) --> (5,EDF)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) EDF(CDEF) (7) --> (6,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) B256(C) (5) --> (3,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CD) (6) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) C40(CDE) (5) --> (5,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) TEXT(CDE) (7) --> (5,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) X12(CDE) (5) --> (5,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CDE) (6) --> (5,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CDEF) (6) --> (6,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) ASCII(C) (4) --> (3,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) EDF(CD) (6) --> (4,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) C40(CDE) (5) --> (5,C40)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) TEXT(CDE) (7) --> (5,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) X12(CDE) (5) --> (5,X12)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) EDF(CDE) (6) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) EDF(CDEF) (6) --> (6,EDF)
         *
         * Edge "(2,ASCII) ASCII(C) (3) --> (3,ASCII)" is minimal for the vertex (3,ASCII) so that edges "(2,EDF) ASCII(C) (5) --> (3,ASCII)"
         * and "(2,B256) ASCII(C) (4) --> (3,ASCII)" can be removed.
         * Edge "(0,ASCII) EDF(ABC) (4) --> (3,EDF)" is minimal for the vertex (3,EDF) so that edges "(1,ASCII) EDF(BC) (5) --> (3,EDF)"
         * and "(1,B256) EDF(BC) (6) --> (3,EDF)" can be removed.
         * Edge "(2,B256) B256(C) (4) --> (3,B256)" is minimal for the vertex (3,B256) so that edges "(2,ASCII) B256(C) (5) --> (3,B256)"
         * and "(2,EDF) B256(C) (6) --> (3,B256)" can be removed.
         *
         * This continues for vertices 3 thru 7
         *
         * Situation after adding edges to vertices at position 7
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) TEXT(BCD) (6) --> (4,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCDE) (5) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256)
         * (0,ASCII) C40(ABC) (3) --> (3,C40) C40(DEF) (5) --> (6,C40)
         * (0,ASCII) X12(ABC) (3) --> (3,X12) X12(DEF) (5) --> (6,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) C40(CDE) (5) --> (5,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) TEXT(CDE) (7) --> (5,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) X12(CDE) (5) --> (5,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CDEF) (6) --> (6,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40) C40(EFG) (6) --> (7,C40)    //Solution 1
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12) X12(EFG) (6) --> (7,X12)    //Solution 2
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) TEXT(DEF) (8) --> (6,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) EDF(DEFG) (7) --> (7,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) ASCII(E) (5) --> (5,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) TEXT(EFG) (9) --> (7,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256) B256(E) (6) --> (5,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) ASCII(E) (5) --> (5,ASCII) ASCII(F) (6) --> (6,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256) B256(E) (6) --> (5,B256) B256(F) (7) --> (6,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) ASCII(E) (5) --> (5,ASCII) ASCII(F) (6) --> (6,ASCII) ASCII(G) (7) --> (7,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256) B256(E) (6) --> (5,B256) B256(F) (7) --> (6,B256) B256(G) (8) --> (7,B256)
         *
         * Hence a minimal encoding of "ABCDEFG" is either ASCII(A),C40(BCDEFG) or ASCII(A), X12(BCDEFG) with a size of 5 bytes.
         */ var inputLength = input.length();
        // Array that represents vertices. There is a vertex for every character and mode.
        // The last dimension in the array below encodes the 6 modes ASCII, C40, TEXT, X12, EDF and B256
        var edges = Array(inputLength + 1).fill(null).map(function() {
            return Array(6).fill(0);
        });
        this.addEdges(input, edges, 0, null);
        for(var i = 1; i <= inputLength; i++){
            for(var j = 0; j < 6; j++)if (edges[i][j] !== null && i < inputLength) this.addEdges(input, edges, i, edges[i][j]);
            // optimize memory by removing edges that have been passed.
            for(var j = 0; j < 6; j++)edges[i - 1][j] = null;
        }
        var minimalJ = -1;
        var minimalSize = (0, $902e90c40380930f$export$2e2bcd8739ae039).MAX_VALUE;
        for(var j = 0; j < 6; j++)if (edges[inputLength][j] !== null) {
            var edge = edges[inputLength][j];
            var size = j >= 1 && j <= 3 ? edge.cachedTotalSize + 1 : edge.cachedTotalSize; // C40, TEXT and X12 need an
            // extra unlatch at the end
            if (size < minimalSize) {
                minimalSize = size;
                minimalJ = j;
            }
        }
        if (minimalJ < 0) throw new Error('Failed to encode "' + input + '"');
        return new $40d095c1484f0bf7$var$Result(edges[inputLength][minimalJ]);
    };
    return MinimalEncoder;
}();
var $40d095c1484f0bf7$var$Result = /** @class */ function() {
    function Result(solution) {
        var input = solution.input;
        var size = 0;
        var bytesAL = [];
        var randomizePostfixLength = [];
        var randomizeLengths = [];
        if ((solution.mode === $40d095c1484f0bf7$var$Mode.C40 || solution.mode === $40d095c1484f0bf7$var$Mode.TEXT || solution.mode === $40d095c1484f0bf7$var$Mode.X12) && solution.getEndMode() !== $40d095c1484f0bf7$var$Mode.ASCII) size += this.prepend($40d095c1484f0bf7$var$Edge.getBytes(254), bytesAL);
        var current = solution;
        while(current !== null){
            size += this.prepend(current.getDataBytes(), bytesAL);
            if (current.previous === null || current.getPreviousStartMode() !== current.getMode()) {
                if (current.getMode() === $40d095c1484f0bf7$var$Mode.B256) {
                    if (size <= 249) {
                        bytesAL.unshift(size);
                        size++;
                    } else {
                        bytesAL.unshift(size % 250);
                        bytesAL.unshift(size / 250 + 249);
                        size += 2;
                    }
                    randomizePostfixLength.push(bytesAL.length);
                    randomizeLengths.push(size);
                }
                this.prepend(current.getLatchBytes(), bytesAL);
                size = 0;
            }
            current = current.previous;
        }
        if (input.getMacroId() === 5) size += this.prepend($40d095c1484f0bf7$var$Edge.getBytes(236), bytesAL);
        else if (input.getMacroId() === 6) size += this.prepend($40d095c1484f0bf7$var$Edge.getBytes(237), bytesAL);
        if (input.getFNC1Character() > 0) size += this.prepend($40d095c1484f0bf7$var$Edge.getBytes(232), bytesAL);
        for(var i = 0; i < randomizePostfixLength.length; i++)this.applyRandomPattern(bytesAL, bytesAL.length - randomizePostfixLength[i], randomizeLengths[i]);
        // add padding
        var capacity = solution.getMinSymbolSize(bytesAL.length);
        if (bytesAL.length < capacity) bytesAL.push(129);
        while(bytesAL.length < capacity)bytesAL.push(this.randomize253State(bytesAL.length + 1));
        this.bytes = new Uint8Array(bytesAL.length);
        for(var i = 0; i < this.bytes.length; i++)this.bytes[i] = bytesAL[i];
    }
    Result.prototype.prepend = function(bytes, into) {
        for(var i = bytes.length - 1; i >= 0; i--)into.unshift(bytes[i]);
        return bytes.length;
    };
    Result.prototype.randomize253State = function(codewordPosition) {
        var pseudoRandom = 149 * codewordPosition % 253 + 1;
        var tempVariable = 129 + pseudoRandom;
        return tempVariable <= 254 ? tempVariable : tempVariable - 254;
    };
    Result.prototype.applyRandomPattern = function(bytesAL, startPosition, length) {
        for(var i = 0; i < length; i++){
            // See "B.1 253-state algorithm
            var Pad_codeword_position = startPosition + i;
            var Pad_codeword_value = bytesAL[Pad_codeword_position] & 0xff;
            var pseudo_random_number = 149 * (Pad_codeword_position + 1) % 255 + 1;
            var temp_variable = Pad_codeword_value + pseudo_random_number;
            bytesAL[Pad_codeword_position] = temp_variable <= 255 ? temp_variable : temp_variable - 256;
        }
    };
    Result.prototype.getBytes = function() {
        return this.bytes;
    };
    return Result;
}();
var $40d095c1484f0bf7$var$Edge = /** @class */ function() {
    function Edge(input, mode, fromPosition, characterLength, previous) {
        this.input = input;
        this.mode = mode;
        this.fromPosition = fromPosition;
        this.characterLength = characterLength;
        this.previous = previous;
        this.allCodewordCapacities = [
            3,
            5,
            8,
            10,
            12,
            16,
            18,
            22,
            30,
            32,
            36,
            44,
            49,
            62,
            86,
            114,
            144,
            174,
            204,
            280,
            368,
            456,
            576,
            696,
            816,
            1050,
            1304,
            1558
        ];
        this.squareCodewordCapacities = [
            3,
            5,
            8,
            12,
            18,
            22,
            30,
            36,
            44,
            62,
            86,
            114,
            144,
            174,
            204,
            280,
            368,
            456,
            576,
            696,
            816,
            1050,
            1304,
            1558
        ];
        this.rectangularCodewordCapacities = [
            5,
            10,
            16,
            33,
            32,
            49
        ];
        if (!(fromPosition + characterLength <= input.length())) throw new Error("Invalid edge");
        var size = previous !== null ? previous.cachedTotalSize : 0;
        var previousMode = this.getPreviousMode();
        /*
         * Switching modes
         * ASCII -> C40: latch 230
         * ASCII -> TEXT: latch 239
         * ASCII -> X12: latch 238
         * ASCII -> EDF: latch 240
         * ASCII -> B256: latch 231
         * C40 -> ASCII: word(c1,c2,c3), 254
         * TEXT -> ASCII: word(c1,c2,c3), 254
         * X12 -> ASCII: word(c1,c2,c3), 254
         * EDIFACT -> ASCII: Unlatch character,0,0,0 or c1,Unlatch character,0,0 or c1,c2,Unlatch character,0 or
         * c1,c2,c3,Unlatch character
         * B256 -> ASCII: without latch after n bytes
         */ switch(mode){
            case $40d095c1484f0bf7$var$Mode.ASCII:
                size++;
                if (input.isECI(fromPosition) || $40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(input.charAt(fromPosition), input.getFNC1Character())) size++;
                if (previousMode === $40d095c1484f0bf7$var$Mode.C40 || previousMode === $40d095c1484f0bf7$var$Mode.TEXT || previousMode === $40d095c1484f0bf7$var$Mode.X12) size++; // unlatch 254 to ASCII
                break;
            case $40d095c1484f0bf7$var$Mode.B256:
                size++;
                if (previousMode !== $40d095c1484f0bf7$var$Mode.B256) size++; // byte count
                else if (this.getB256Size() === 250) size++; // extra byte count
                if (previousMode === $40d095c1484f0bf7$var$Mode.ASCII) size++; // latch to B256
                else if (previousMode === $40d095c1484f0bf7$var$Mode.C40 || previousMode === $40d095c1484f0bf7$var$Mode.TEXT || previousMode === $40d095c1484f0bf7$var$Mode.X12) size += 2; // unlatch to ASCII, latch to B256
                break;
            case $40d095c1484f0bf7$var$Mode.C40:
            case $40d095c1484f0bf7$var$Mode.TEXT:
            case $40d095c1484f0bf7$var$Mode.X12:
                if (mode === $40d095c1484f0bf7$var$Mode.X12) size += 2;
                else {
                    var charLen = [];
                    size += $40d095c1484f0bf7$export$c5f059be53a7e40d.getNumberOfC40Words(input, fromPosition, mode === $40d095c1484f0bf7$var$Mode.C40, charLen) * 2;
                }
                if (previousMode === $40d095c1484f0bf7$var$Mode.ASCII || previousMode === $40d095c1484f0bf7$var$Mode.B256) size++; // additional byte for latch from ASCII to this mode
                else if (previousMode !== mode && (previousMode === $40d095c1484f0bf7$var$Mode.C40 || previousMode === $40d095c1484f0bf7$var$Mode.TEXT || previousMode === $40d095c1484f0bf7$var$Mode.X12)) size += 2; // unlatch 254 to ASCII followed by latch to this mode
                break;
            case $40d095c1484f0bf7$var$Mode.EDF:
                size += 3;
                if (previousMode === $40d095c1484f0bf7$var$Mode.ASCII || previousMode === $40d095c1484f0bf7$var$Mode.B256) size++; // additional byte for latch from ASCII to this mode
                else if (previousMode === $40d095c1484f0bf7$var$Mode.C40 || previousMode === $40d095c1484f0bf7$var$Mode.TEXT || previousMode === $40d095c1484f0bf7$var$Mode.X12) size += 2; // unlatch 254 to ASCII followed by latch to this mode
                break;
        }
        this.cachedTotalSize = size;
    }
    // does not count beyond 250
    Edge.prototype.getB256Size = function() {
        var cnt = 0;
        var current = this;
        while(current !== null && current.mode === $40d095c1484f0bf7$var$Mode.B256 && cnt <= 250){
            cnt++;
            current = current.previous;
        }
        return cnt;
    };
    Edge.prototype.getPreviousStartMode = function() {
        return this.previous === null ? $40d095c1484f0bf7$var$Mode.ASCII : this.previous.mode;
    };
    Edge.prototype.getPreviousMode = function() {
        return this.previous === null ? $40d095c1484f0bf7$var$Mode.ASCII : this.previous.getEndMode();
    };
    /** Returns Mode.ASCII in case that:
     *  - Mode is EDIFACT and characterLength is less than 4 or the remaining characters can be encoded in at most 2
     *    ASCII bytes.
     *  - Mode is C40, TEXT or X12 and the remaining characters can be encoded in at most 1 ASCII byte.
     *  Returns mode in all other cases.
     * */ Edge.prototype.getEndMode = function() {
        if (this.mode === $40d095c1484f0bf7$var$Mode.EDF) {
            if (this.characterLength < 4) return $40d095c1484f0bf7$var$Mode.ASCII;
            var lastASCII = this.getLastASCII(); // see 5.2.8.2 EDIFACT encodation Rules
            if (lastASCII > 0 && this.getCodewordsRemaining(this.cachedTotalSize + lastASCII) <= 2 - lastASCII) return $40d095c1484f0bf7$var$Mode.ASCII;
        }
        if (this.mode === $40d095c1484f0bf7$var$Mode.C40 || this.mode === $40d095c1484f0bf7$var$Mode.TEXT || this.mode === $40d095c1484f0bf7$var$Mode.X12) {
            // see 5.2.5.2 C40 encodation rules and 5.2.7.2 ANSI X12 encodation rules
            if (this.fromPosition + this.characterLength >= this.input.length() && this.getCodewordsRemaining(this.cachedTotalSize) === 0) return $40d095c1484f0bf7$var$Mode.ASCII;
            var lastASCII = this.getLastASCII();
            if (lastASCII === 1 && this.getCodewordsRemaining(this.cachedTotalSize + 1) === 0) return $40d095c1484f0bf7$var$Mode.ASCII;
        }
        return this.mode;
    };
    Edge.prototype.getMode = function() {
        return this.mode;
    };
    /** Peeks ahead and returns 1 if the postfix consists of exactly two digits, 2 if the postfix consists of exactly
     *  two consecutive digits and a non extended character or of 4 digits.
     *  Returns 0 in any other case
     **/ Edge.prototype.getLastASCII = function() {
        var length = this.input.length();
        var from = this.fromPosition + this.characterLength;
        if (length - from > 4 || from >= length) return 0;
        if (length - from === 1) {
            if ($40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from), this.input.getFNC1Character())) return 0;
            return 1;
        }
        if (length - from === 2) {
            if ($40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from), this.input.getFNC1Character()) || $40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from + 1), this.input.getFNC1Character())) return 0;
            if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 1))) return 1;
            return 2;
        }
        if (length - from === 3) {
            if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 1)) && !$40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from + 2), this.input.getFNC1Character())) return 2;
            if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 1)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 2)) && !$40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from), this.input.getFNC1Character())) return 2;
            return 0;
        }
        if ((0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 1)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 2)) && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isDigit(this.input.charAt(from + 3))) return 2;
        return 0;
    };
    /** Returns the capacity in codewords of the smallest symbol that has enough capacity to fit the given minimal
     * number of codewords.
     **/ Edge.prototype.getMinSymbolSize = function(minimum) {
        var e_3, _a, e_4, _b, e_5, _c;
        switch(this.input.getShapeHint()){
            case 1 /* FORCE_SQUARE */ :
                try {
                    for(var _d = $40d095c1484f0bf7$var$__values(this.squareCodewordCapacities), _e = _d.next(); !_e.done; _e = _d.next()){
                        var capacity = _e.value;
                        if (capacity >= minimum) return capacity;
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
                break;
            case 2 /* FORCE_RECTANGLE */ :
                try {
                    for(var _f = $40d095c1484f0bf7$var$__values(this.rectangularCodewordCapacities), _g = _f.next(); !_g.done; _g = _f.next()){
                        var capacity = _g.value;
                        if (capacity >= minimum) return capacity;
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                break;
        }
        try {
            for(var _h = $40d095c1484f0bf7$var$__values(this.allCodewordCapacities), _j = _h.next(); !_j.done; _j = _h.next()){
                var capacity = _j.value;
                if (capacity >= minimum) return capacity;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return this.allCodewordCapacities[this.allCodewordCapacities.length - 1];
    };
    /** Returns the remaining capacity in codewords of the smallest symbol that has enough capacity to fit the given
     * minimal number of codewords.
     **/ Edge.prototype.getCodewordsRemaining = function(minimum) {
        return this.getMinSymbolSize(minimum) - minimum;
    };
    Edge.getBytes = function(c1, c2) {
        var result = new Uint8Array(c2 ? 2 : 1);
        result[0] = c1;
        if (c2) result[1] = c2;
        return result;
    };
    Edge.prototype.setC40Word = function(bytes, offset, c1, c2, c3) {
        var val16 = 1600 * (c1 & 0xff) + 40 * (c2 & 0xff) + (c3 & 0xff) + 1;
        bytes[offset] = val16 / 256;
        bytes[offset + 1] = val16 % 256;
    };
    Edge.prototype.getX12Value = function(c) {
        return c === 13 ? 0 : c === 42 ? 1 : c === 62 ? 2 : c === 32 ? 3 : c >= 48 && c <= 57 ? c - 44 : c >= 65 && c <= 90 ? c - 51 : c;
    };
    Edge.prototype.getX12Words = function() {
        if (!(this.characterLength % 3 === 0)) throw new Error("X12 words must be a multiple of 3");
        var result = new Uint8Array(this.characterLength / 3 * 2);
        for(var i = 0; i < result.length; i += 2)this.setC40Word(result, i, this.getX12Value(this.input.charAt(this.fromPosition + i / 2 * 3)), this.getX12Value(this.input.charAt(this.fromPosition + i / 2 * 3 + 1)), this.getX12Value(this.input.charAt(this.fromPosition + i / 2 * 3 + 2)));
        return result;
    };
    Edge.prototype.getShiftValue = function(c, c40, fnc1) {
        return c40 && $40d095c1484f0bf7$export$c5f059be53a7e40d.isInC40Shift1Set(c) || !c40 && $40d095c1484f0bf7$export$c5f059be53a7e40d.isInTextShift1Set(c) ? 0 : c40 && $40d095c1484f0bf7$export$c5f059be53a7e40d.isInC40Shift2Set(c, fnc1) || !c40 && $40d095c1484f0bf7$export$c5f059be53a7e40d.isInTextShift2Set(c, fnc1) ? 1 : 2;
    };
    Edge.prototype.getC40Value = function(c40, setIndex, c, fnc1) {
        if (c === fnc1) {
            if (!(setIndex === 2)) throw new Error("FNC1 cannot be used in C40 shift 2");
            return 27;
        }
        if (c40) return c <= 31 ? c : c === 32 ? 3 : c <= 47 ? c - 33 : c <= 57 ? c - 44 : c <= 64 ? c - 43 : c <= 90 ? c - 51 : c <= 95 ? c - 69 : c <= 127 ? c - 96 : c;
        else return c === 0 ? 0 : setIndex === 0 && c <= 3 ? c - 1 // is this a bug in the spec?
         : setIndex === 1 && c <= 31 ? c : c === 32 ? 3 : c >= 33 && c <= 47 ? c - 33 : c >= 48 && c <= 57 ? c - 44 : c >= 58 && c <= 64 ? c - 43 : c >= 65 && c <= 90 ? c - 64 : c >= 91 && c <= 95 ? c - 69 : c === 96 ? 0 : c >= 97 && c <= 122 ? c - 83 : c >= 123 && c <= 127 ? c - 96 : c;
    };
    Edge.prototype.getC40Words = function(c40, fnc1) {
        var c40Values = [];
        for(var i = 0; i < this.characterLength; i++){
            var ci = this.input.charAt(this.fromPosition + i);
            if (c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeC40(ci) || !c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeText(ci)) c40Values.push(this.getC40Value(c40, 0, ci, fnc1));
            else if (!$40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(ci, fnc1)) {
                var shiftValue = this.getShiftValue(ci, c40, fnc1);
                c40Values.push(shiftValue); // Shift[123]
                c40Values.push(this.getC40Value(c40, shiftValue, ci, fnc1));
            } else {
                var asciiValue = (ci & 0xff) - 128;
                if (c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeC40(asciiValue) || !c40 && (0, $5004b1862ab9242e$export$2e2bcd8739ae039).isNativeText(asciiValue)) {
                    c40Values.push(1); // Shift 2
                    c40Values.push(30); // Upper Shift
                    c40Values.push(this.getC40Value(c40, 0, asciiValue, fnc1));
                } else {
                    c40Values.push(1); // Shift 2
                    c40Values.push(30); // Upper Shift
                    var shiftValue = this.getShiftValue(asciiValue, c40, fnc1);
                    c40Values.push(shiftValue); // Shift[123]
                    c40Values.push(this.getC40Value(c40, shiftValue, asciiValue, fnc1));
                }
            }
        }
        if (c40Values.length % 3 !== 0) {
            if (!((c40Values.length - 2) % 3 === 0 && this.fromPosition + this.characterLength === this.input.length())) throw new Error("C40 words must be a multiple of 3");
            c40Values.push(0); // pad with 0 (Shift 1)
        }
        var result = new Uint8Array(c40Values.length / 3 * 2);
        var byteIndex = 0;
        for(var i = 0; i < c40Values.length; i += 3){
            this.setC40Word(result, byteIndex, c40Values[i] & 0xff, c40Values[i + 1] & 0xff, c40Values[i + 2] & 0xff);
            byteIndex += 2;
        }
        return result;
    };
    Edge.prototype.getEDFBytes = function() {
        var numberOfThirds = Math.ceil(this.characterLength / 4.0);
        var result = new Uint8Array(numberOfThirds * 3);
        var pos = this.fromPosition;
        var endPos = Math.min(this.fromPosition + this.characterLength - 1, this.input.length() - 1);
        for(var i = 0; i < numberOfThirds; i += 3){
            var edfValues = [];
            for(var j = 0; j < 4; j++)if (pos <= endPos) edfValues[j] = this.input.charAt(pos++) & 0x3f;
            else edfValues[j] = pos === endPos + 1 ? 0x1f : 0;
            var val24 = edfValues[0] << 18;
            val24 |= edfValues[1] << 12;
            val24 |= edfValues[2] << 6;
            val24 |= edfValues[3];
            result[i] = val24 >> 16 & 0xff;
            result[i + 1] = val24 >> 8 & 0xff;
            result[i + 2] = val24 & 0xff;
        }
        return result;
    };
    Edge.prototype.getLatchBytes = function() {
        switch(this.getPreviousMode()){
            case $40d095c1484f0bf7$var$Mode.ASCII:
            case $40d095c1484f0bf7$var$Mode.B256:
                switch(this.mode){
                    case $40d095c1484f0bf7$var$Mode.B256:
                        return Edge.getBytes(231);
                    case $40d095c1484f0bf7$var$Mode.C40:
                        return Edge.getBytes(230);
                    case $40d095c1484f0bf7$var$Mode.TEXT:
                        return Edge.getBytes(239);
                    case $40d095c1484f0bf7$var$Mode.X12:
                        return Edge.getBytes(238);
                    case $40d095c1484f0bf7$var$Mode.EDF:
                        return Edge.getBytes(240);
                }
                break;
            case $40d095c1484f0bf7$var$Mode.C40:
            case $40d095c1484f0bf7$var$Mode.TEXT:
            case $40d095c1484f0bf7$var$Mode.X12:
                if (this.mode !== this.getPreviousMode()) switch(this.mode){
                    case $40d095c1484f0bf7$var$Mode.ASCII:
                        return Edge.getBytes(254);
                    case $40d095c1484f0bf7$var$Mode.B256:
                        return Edge.getBytes(254, 231);
                    case $40d095c1484f0bf7$var$Mode.C40:
                        return Edge.getBytes(254, 230);
                    case $40d095c1484f0bf7$var$Mode.TEXT:
                        return Edge.getBytes(254, 239);
                    case $40d095c1484f0bf7$var$Mode.X12:
                        return Edge.getBytes(254, 238);
                    case $40d095c1484f0bf7$var$Mode.EDF:
                        return Edge.getBytes(254, 240);
                }
                break;
            case $40d095c1484f0bf7$var$Mode.EDF:
                // The rightmost EDIFACT edge always contains an unlatch character
                if (this.mode !== $40d095c1484f0bf7$var$Mode.EDF) throw new Error("Cannot switch from EDF to " + this.mode);
                break;
        }
        return new Uint8Array(0);
    };
    // Important: The function does not return the length bytes (one or two) in case of B256 encoding
    Edge.prototype.getDataBytes = function() {
        switch(this.mode){
            case $40d095c1484f0bf7$var$Mode.ASCII:
                if (this.input.isECI(this.fromPosition)) return Edge.getBytes(241, this.input.getECIValue(this.fromPosition) + 1);
                else if ($40d095c1484f0bf7$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(this.fromPosition), this.input.getFNC1Character())) return Edge.getBytes(235, this.input.charAt(this.fromPosition) - 127);
                else if (this.characterLength === 2) return Edge.getBytes(this.input.charAt(this.fromPosition) * 10 + this.input.charAt(this.fromPosition + 1) + 130);
                else if (this.input.isFNC1(this.fromPosition)) return Edge.getBytes(232);
                else return Edge.getBytes(this.input.charAt(this.fromPosition) + 1);
            case $40d095c1484f0bf7$var$Mode.B256:
                return Edge.getBytes(this.input.charAt(this.fromPosition));
            case $40d095c1484f0bf7$var$Mode.C40:
                return this.getC40Words(true, this.input.getFNC1Character());
            case $40d095c1484f0bf7$var$Mode.TEXT:
                return this.getC40Words(false, this.input.getFNC1Character());
            case $40d095c1484f0bf7$var$Mode.X12:
                return this.getX12Words();
            case $40d095c1484f0bf7$var$Mode.EDF:
                return this.getEDFBytes();
        }
    };
    return Edge;
}();
var $40d095c1484f0bf7$var$Input = /** @class */ function(_super) {
    $40d095c1484f0bf7$var$__extends(Input, _super);
    function Input(stringToEncode, priorityCharset, fnc1, shape, macroId) {
        var _this = _super.call(this, stringToEncode, priorityCharset, fnc1) || this;
        _this.shape = shape;
        _this.macroId = macroId;
        return _this;
    }
    Input.prototype.getMacroId = function() {
        return this.macroId;
    };
    Input.prototype.getShapeHint = function() {
        return this.shape;
    };
    return Input;
}((0, $0a66882b3a01c6d6$export$196399f5a83a42b6));







var $06797cfbef5f2846$var$DataMatrixWriter = /** @class */ function() {
    function DataMatrixWriter() {}
    DataMatrixWriter.prototype.encode = function(contents, format, width, height, hints) {
        if (hints === void 0) hints = null;
        if (contents.trim() === "") throw new Error("Found empty contents");
        if (format !== (0, $03ea32520a329dec$export$2e2bcd8739ae039).DATA_MATRIX) throw new Error("Can only encode DATA_MATRIX, but got " + format);
        if (width < 0 || height < 0) throw new Error("Requested dimensions can't be negative: " + width + "x" + height);
        // Try to get force shape & min / max size
        var shape = 0 /* FORCE_NONE */ ;
        var minSize = null;
        var maxSize = null;
        if (hints != null) {
            var requestedShape = hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).DATA_MATRIX_SHAPE);
            if (requestedShape != null) shape = requestedShape;
            var requestedMinSize = hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).MIN_SIZE);
            if (requestedMinSize != null) minSize = requestedMinSize;
            var requestedMaxSize = hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).MAX_SIZE);
            if (requestedMaxSize != null) maxSize = requestedMaxSize;
        }
        // 1. step: Data encodation
        var encoded;
        var hasCompactionHint = hints != null && hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).DATA_MATRIX_COMPACT) && Boolean(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).DATA_MATRIX_COMPACT).toString());
        if (hasCompactionHint) {
            var hasGS1FormatHint = hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).GS1_FORMAT) && Boolean(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).GS1_FORMAT).toString());
            var charset = null;
            var hasEncodingHint = hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).CHARACTER_SET);
            if (hasEncodingHint) charset = (0, $64e0b7362b63fd2a$export$2e2bcd8739ae039).forName(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).CHARACTER_SET).toString());
            encoded = (0, $40d095c1484f0bf7$export$c5f059be53a7e40d).encodeHighLevel(contents, charset, hasGS1FormatHint ? 0x1d : -1, shape);
        } else {
            var hasForceC40Hint = hints != null && hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).FORCE_C40) && Boolean(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).FORCE_C40).toString());
            encoded = (0, $5004b1862ab9242e$export$2e2bcd8739ae039).encodeHighLevel(contents, shape, minSize, maxSize, hasForceC40Hint);
        }
        var symbolInfo = (0, $89599a019adcd89f$export$2e2bcd8739ae039).lookup(encoded.length, shape, minSize, maxSize, true);
        // 2. step: ECC generation
        var codewords = (0, $335d411caacd704e$export$2e2bcd8739ae039).encodeECC200(encoded, symbolInfo);
        // 3. step: Module placement in Matrix
        var placement = new (0, $e5bfe2ecdcbc6e41$export$2e2bcd8739ae039)(codewords, symbolInfo.getSymbolDataWidth(), symbolInfo.getSymbolDataHeight());
        placement.place();
        // 4. step: low-level encoding
        return this.encodeLowLevel(placement, symbolInfo, width, height);
    };
    /**
     * Encode the given symbol info to a bit matrix.
     *
     * @param placement  The DataMatrix placement.
     * @param symbolInfo The symbol info to encode.
     * @return The bit matrix generated.
     */ DataMatrixWriter.prototype.encodeLowLevel = function(placement, symbolInfo, width, height) {
        var symbolWidth = symbolInfo.getSymbolDataWidth();
        var symbolHeight = symbolInfo.getSymbolDataHeight();
        var matrix = new (0, $ecede4972a598cfe$export$2e2bcd8739ae039)(symbolInfo.getSymbolWidth(), symbolInfo.getSymbolHeight());
        var matrixY = 0;
        for(var y = 0; y < symbolHeight; y++){
            // Fill the top edge with alternate 0 / 1
            var matrixX = void 0;
            if (y % symbolInfo.matrixHeight === 0) {
                matrixX = 0;
                for(var x = 0; x < symbolInfo.getSymbolWidth(); x++){
                    matrix.setBoolean(matrixX, matrixY, x % 2 === 0);
                    matrixX++;
                }
                matrixY++;
            }
            matrixX = 0;
            for(var x = 0; x < symbolWidth; x++){
                // Fill the right edge with full 1
                if (x % symbolInfo.matrixWidth === 0) {
                    matrix.setBoolean(matrixX, matrixY, true);
                    matrixX++;
                }
                matrix.setBoolean(matrixX, matrixY, placement.getBit(x, y));
                matrixX++;
                // Fill the right edge with alternate 0 / 1
                if (x % symbolInfo.matrixWidth === symbolInfo.matrixWidth - 1) {
                    matrix.setBoolean(matrixX, matrixY, y % 2 === 0);
                    matrixX++;
                }
            }
            matrixY++;
            // Fill the bottom edge with full 1
            if (y % symbolInfo.matrixHeight === symbolInfo.matrixHeight - 1) {
                matrixX = 0;
                for(var x = 0; x < symbolInfo.getSymbolWidth(); x++){
                    matrix.setBoolean(matrixX, matrixY, true);
                    matrixX++;
                }
                matrixY++;
            }
        }
        return this.convertByteMatrixToBitMatrix(matrix, width, height);
    };
    /**
     * Convert the ByteMatrix to BitMatrix.
     *
     * @param reqHeight The requested height of the image (in pixels) with the Datamatrix code
     * @param reqWidth The requested width of the image (in pixels) with the Datamatrix code
     * @param matrix The input matrix.
     * @return The output matrix.
     */ DataMatrixWriter.prototype.convertByteMatrixToBitMatrix = function(matrix, reqWidth, reqHeight) {
        var matrixWidth = matrix.getWidth();
        var matrixHeight = matrix.getHeight();
        var outputWidth = Math.max(reqWidth, matrixWidth);
        var outputHeight = Math.max(reqHeight, matrixHeight);
        var multiple = Math.min(outputWidth / matrixWidth, outputHeight / matrixHeight);
        var leftPadding = (outputWidth - matrixWidth * multiple) / 2;
        var topPadding = (outputHeight - matrixHeight * multiple) / 2;
        var output;
        // remove padding if requested width and height are too small
        if (reqHeight < matrixHeight || reqWidth < matrixWidth) {
            leftPadding = 0;
            topPadding = 0;
            output = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(matrixWidth, matrixHeight);
        } else output = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(reqWidth, reqHeight);
        output.clear();
        for(var inputY = 0, outputY = topPadding; inputY < matrixHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the bytematrix
            for(var inputX = 0, outputX = leftPadding; inputX < matrixWidth; inputX++, outputX += multiple)if (matrix.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
        }
        return output;
    };
    return DataMatrixWriter;
}();
var $06797cfbef5f2846$export$2e2bcd8739ae039 = $06797cfbef5f2846$var$DataMatrixWriter;




















/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.aztec;
// import com.google.zxing.BarcodeFormat;






/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ /**
 * Aztec 2D code representation
 *
 * @author Rustam Abdullaev
 */ var $d497b21fac9ff4b3$var$AztecCode = /** @class */ function() {
    function AztecCode() {}
    /**
     * @return {@code true} if compact instead of full mode
     */ AztecCode.prototype.isCompact = function() {
        return this.compact;
    };
    AztecCode.prototype.setCompact = function(compact) {
        this.compact = compact;
    };
    /**
     * @return size in pixels (width and height)
     */ AztecCode.prototype.getSize = function() {
        return this.size;
    };
    AztecCode.prototype.setSize = function(size) {
        this.size = size;
    };
    /**
     * @return number of levels
     */ AztecCode.prototype.getLayers = function() {
        return this.layers;
    };
    AztecCode.prototype.setLayers = function(layers) {
        this.layers = layers;
    };
    /**
     * @return number of data codewords
     */ AztecCode.prototype.getCodeWords = function() {
        return this.codeWords;
    };
    AztecCode.prototype.setCodeWords = function(codeWords) {
        this.codeWords = codeWords;
    };
    /**
     * @return the symbol image
     */ AztecCode.prototype.getMatrix = function() {
        return this.matrix;
    };
    AztecCode.prototype.setMatrix = function(matrix) {
        this.matrix = matrix;
    };
    return AztecCode;
}();
var $d497b21fac9ff4b3$export$2e2bcd8739ae039 = $d497b21fac9ff4b3$var$AztecCode;




/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6bc13dedef93f294$var$Collections = /** @class */ function() {
    function Collections() {}
    /**
     * The singletonList(T) method is used to return an immutable list containing only the specified object.
     */ Collections.singletonList = function(item) {
        return [
            item
        ];
    };
    /**
     * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
     */ Collections.min = function(collection, comparator) {
        return collection.sort(comparator)[0];
    };
    return Collections;
}();
var $6bc13dedef93f294$export$2e2bcd8739ae039 = $6bc13dedef93f294$var$Collections;


/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ /*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ var $307bbaf166659806$var$Token = /** @class */ function() {
    function Token(previous) {
        this.previous = previous;
    }
    Token.prototype.getPrevious = function() {
        return this.previous;
    };
    return Token;
}();
var $307bbaf166659806$export$2e2bcd8739ae039 = $307bbaf166659806$var$Token;



var $0f25a990b3d8233d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0f25a990b3d8233d$var$SimpleToken = /** @class */ function(_super) {
    $0f25a990b3d8233d$var$__extends(SimpleToken, _super);
    function SimpleToken(previous, value, bitCount) {
        var _this = _super.call(this, previous) || this;
        _this.value = value;
        _this.bitCount = bitCount;
        return _this;
    }
    /**
     * @Override
     */ SimpleToken.prototype.appendTo = function(bitArray, text) {
        bitArray.appendBits(this.value, this.bitCount);
    };
    SimpleToken.prototype.add = function(value, bitCount) {
        return new SimpleToken(this, value, bitCount);
    };
    SimpleToken.prototype.addBinaryShift = function(start, byteCount) {
        // no-op can't binary shift a simple token
        console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token");
        return new SimpleToken(this, start, byteCount);
    };
    /**
     * @Override
     */ SimpleToken.prototype.toString = function() {
        var value = this.value & (1 << this.bitCount) - 1;
        value |= 1 << this.bitCount;
        return "<" + (0, $902e90c40380930f$export$2e2bcd8739ae039).toBinaryString(value | 1 << this.bitCount).substring(1) + ">";
    };
    return SimpleToken;
}((0, $307bbaf166659806$export$2e2bcd8739ae039));
var $0f25a990b3d8233d$export$2e2bcd8739ae039 = $0f25a990b3d8233d$var$SimpleToken;


/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $6077324a412b1308$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6077324a412b1308$var$BinaryShiftToken = /** @class */ function(_super) {
    $6077324a412b1308$var$__extends(BinaryShiftToken, _super);
    function BinaryShiftToken(previous, binaryShiftStart, binaryShiftByteCount) {
        var _this = _super.call(this, previous, 0, 0) || this;
        _this.binaryShiftStart = binaryShiftStart;
        _this.binaryShiftByteCount = binaryShiftByteCount;
        return _this;
    }
    /**
     * @Override
     */ BinaryShiftToken.prototype.appendTo = function(bitArray, text) {
        for(var i = 0; i < this.binaryShiftByteCount; i++){
            if (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) {
                // We need a header before the first character, and before
                // character 31 when the total byte code is <= 62
                bitArray.appendBits(31, 5); // BINARY_SHIFT
                if (this.binaryShiftByteCount > 62) bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
                else if (i === 0) // 1 <= binaryShiftByteCode <= 62
                bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
                else // 32 <= binaryShiftCount <= 62 and i == 31
                bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
            }
            bitArray.appendBits(text[this.binaryShiftStart + i], 8);
        }
    };
    BinaryShiftToken.prototype.addBinaryShift = function(start, byteCount) {
        // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
        return new BinaryShiftToken(this, start, byteCount);
    };
    /**
     * @Override
     */ BinaryShiftToken.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    };
    return BinaryShiftToken;
}((0, $0f25a990b3d8233d$export$2e2bcd8739ae039));
var $6077324a412b1308$export$2e2bcd8739ae039 = $6077324a412b1308$var$BinaryShiftToken;


function $7550abbc47a34215$export$682754f93767697e(token, start, byteCount) {
    // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
    return new (0, $6077324a412b1308$export$2e2bcd8739ae039)(token, start, byteCount);
}
function $7550abbc47a34215$export$e16d8520af44a096(token, value, bitCount) {
    return new (0, $0f25a990b3d8233d$export$2e2bcd8739ae039)(token, value, bitCount);
}



var /*final*/ $5530db33e992a0bb$export$b330669118f5398c = [
    "UPPER",
    "LOWER",
    "DIGIT",
    "MIXED",
    "PUNCT"
];
var /*final*/ $5530db33e992a0bb$export$b62eceed7909eedb = 0; // 5 bits
var /*final*/ $5530db33e992a0bb$export$dddc678b91a92292 = 1; // 5 bits
var /*final*/ $5530db33e992a0bb$export$5a5ce6a997d69865 = 2; // 4 bits
var /*final*/ $5530db33e992a0bb$export$7ff1f62ca8a43556 = 3; // 5 bits
var /*final*/ $5530db33e992a0bb$export$4e7b78785f29ce0f = 4; // 5 bits
var $5530db33e992a0bb$export$89bb5d126ce811a2 = new (0, $0f25a990b3d8233d$export$2e2bcd8739ae039)(null, 0, 0);


// The Latch Table shows, for each pair of Modes, the optimal method for
// getting from one mode to another.  In the worst possible case, this can
// be up to 14 bits.  In the best possible case, we are already there!
// The high half-word of each entry gives the number of bits.
// The low half-word of each entry are the actual bits necessary to change
var $13e5a4c052d2b6df$export$fff4b7837da52261 = [
    Int32Array.from([
        0,
        327708,
        327710,
        327709,
        656318 // UPPER -> MIXED -> PUNCT
    ]),
    Int32Array.from([
        590318,
        0,
        327710,
        327709,
        656318 // LOWER -> MIXED -> PUNCT
    ]),
    Int32Array.from([
        262158,
        590300,
        0,
        590301,
        932798
    ]),
    Int32Array.from([
        327709,
        327708,
        656318,
        0,
        327710 // MIXED -> PUNCT
    ]),
    Int32Array.from([
        327711,
        656380,
        656382,
        656381,
        0
    ])
];




var $072d3736f14449e0$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $072d3736f14449e0$export$7347b8daf304f5f1(SHIFT_TABLE) {
    var e_1, _a;
    try {
        for(var SHIFT_TABLE_1 = $072d3736f14449e0$var$__values(SHIFT_TABLE), SHIFT_TABLE_1_1 = SHIFT_TABLE_1.next(); !SHIFT_TABLE_1_1.done; SHIFT_TABLE_1_1 = SHIFT_TABLE_1.next()){
            var table = SHIFT_TABLE_1_1.value /*Int32Array*/ ;
            (0, $eed4834329730fe6$export$2e2bcd8739ae039).fill(table, -1);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (SHIFT_TABLE_1_1 && !SHIFT_TABLE_1_1.done && (_a = SHIFT_TABLE_1.return)) _a.call(SHIFT_TABLE_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    SHIFT_TABLE[$5530db33e992a0bb$export$b62eceed7909eedb][$5530db33e992a0bb$export$4e7b78785f29ce0f] = 0;
    SHIFT_TABLE[$5530db33e992a0bb$export$dddc678b91a92292][$5530db33e992a0bb$export$4e7b78785f29ce0f] = 0;
    SHIFT_TABLE[$5530db33e992a0bb$export$dddc678b91a92292][$5530db33e992a0bb$export$b62eceed7909eedb] = 28;
    SHIFT_TABLE[$5530db33e992a0bb$export$7ff1f62ca8a43556][$5530db33e992a0bb$export$4e7b78785f29ce0f] = 0;
    SHIFT_TABLE[$5530db33e992a0bb$export$5a5ce6a997d69865][$5530db33e992a0bb$export$4e7b78785f29ce0f] = 0;
    SHIFT_TABLE[$5530db33e992a0bb$export$5a5ce6a997d69865][$5530db33e992a0bb$export$b62eceed7909eedb] = 15;
    return SHIFT_TABLE;
}
var /*final*/ $072d3736f14449e0$export$46c23485303b0705 = $072d3736f14449e0$export$7347b8daf304f5f1((0, $eed4834329730fe6$export$2e2bcd8739ae039).createInt32Array(6, 6)); // mode shift codes, per table



var $eb2646fe0cb525a0$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * State represents all information about a sequence necessary to generate the current output.
 * Note that a state is immutable.
 */ var $eb2646fe0cb525a0$var$State = /** @class */ function() {
    function State(token, mode, binaryBytes, bitCount) {
        this.token = token;
        this.mode = mode;
        this.binaryShiftByteCount = binaryBytes;
        this.bitCount = bitCount;
    // Make sure we match the token
    // int binaryShiftBitCount = (binaryShiftByteCount * 8) +
    //    (binaryShiftByteCount === 0 ? 0 :
    //     binaryShiftByteCount <= 31 ? 10 :
    //     binaryShiftByteCount <= 62 ? 20 : 21);
    // assert this.bitCount === token.getTotalBitCount() + binaryShiftBitCount;
    }
    State.prototype.getMode = function() {
        return this.mode;
    };
    State.prototype.getToken = function() {
        return this.token;
    };
    State.prototype.getBinaryShiftByteCount = function() {
        return this.binaryShiftByteCount;
    };
    State.prototype.getBitCount = function() {
        return this.bitCount;
    };
    // Create a new state representing this state with a latch to a (not
    // necessary different) mode, and then a code.
    State.prototype.latchAndAppend = function(mode, value) {
        // assert binaryShiftByteCount === 0;
        var bitCount = this.bitCount;
        var token = this.token;
        if (mode !== this.mode) {
            var latch = $13e5a4c052d2b6df$export$fff4b7837da52261[this.mode][mode];
            token = $7550abbc47a34215$export$e16d8520af44a096(token, latch & 0xffff, latch >> 16);
            bitCount += latch >> 16;
        }
        var latchModeBitCount = mode === $5530db33e992a0bb$export$5a5ce6a997d69865 ? 4 : 5;
        token = $7550abbc47a34215$export$e16d8520af44a096(token, value, latchModeBitCount);
        return new State(token, mode, 0, bitCount + latchModeBitCount);
    };
    // Create a new state representing this state, with a temporary shift
    // to a different mode to output a single value.
    State.prototype.shiftAndAppend = function(mode, value) {
        // assert binaryShiftByteCount === 0 && this.mode !== mode;
        var token = this.token;
        var thisModeBitCount = this.mode === $5530db33e992a0bb$export$5a5ce6a997d69865 ? 4 : 5;
        // Shifts exist only to UPPER and PUNCT, both with tokens size 5.
        token = $7550abbc47a34215$export$e16d8520af44a096(token, $072d3736f14449e0$export$46c23485303b0705[this.mode][mode], thisModeBitCount);
        token = $7550abbc47a34215$export$e16d8520af44a096(token, value, 5);
        return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
    };
    // Create a new state representing this state, but an additional character
    // output in Binary Shift mode.
    State.prototype.addBinaryShiftChar = function(index) {
        var token = this.token;
        var mode = this.mode;
        var bitCount = this.bitCount;
        if (this.mode === $5530db33e992a0bb$export$4e7b78785f29ce0f || this.mode === $5530db33e992a0bb$export$5a5ce6a997d69865) {
            // assert binaryShiftByteCount === 0;
            var latch = $13e5a4c052d2b6df$export$fff4b7837da52261[mode][$5530db33e992a0bb$export$b62eceed7909eedb];
            token = $7550abbc47a34215$export$e16d8520af44a096(token, latch & 0xffff, latch >> 16);
            bitCount += latch >> 16;
            mode = $5530db33e992a0bb$export$b62eceed7909eedb;
        }
        var deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8;
        var result = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
        if (result.binaryShiftByteCount === 2078) // The string is as long as it's allowed to be.  We should end it.
        result = result.endBinaryShift(index + 1);
        return result;
    };
    // Create the state identical to this one, but we are no longer in
    // Binary Shift mode.
    State.prototype.endBinaryShift = function(index) {
        if (this.binaryShiftByteCount === 0) return this;
        var token = this.token;
        token = $7550abbc47a34215$export$682754f93767697e(token, index - this.binaryShiftByteCount, this.binaryShiftByteCount);
        // assert token.getTotalBitCount() === this.bitCount;
        return new State(token, this.mode, 0, this.bitCount);
    };
    // Returns true if "this" state is better (equal: or) to be in than "that"
    // state under all possible circumstances.
    State.prototype.isBetterThanOrEqualTo = function(other) {
        var newModeBitCount = this.bitCount + ($13e5a4c052d2b6df$export$fff4b7837da52261[this.mode][other.mode] >> 16);
        if (this.binaryShiftByteCount < other.binaryShiftByteCount) // add additional B/S encoding cost of other, if any
        newModeBitCount += State.calculateBinaryShiftCost(other) - State.calculateBinaryShiftCost(this);
        else if (this.binaryShiftByteCount > other.binaryShiftByteCount && other.binaryShiftByteCount > 0) // maximum possible additional cost (it: h)
        newModeBitCount += 10;
        return newModeBitCount <= other.bitCount;
    };
    State.prototype.toBitArray = function(text) {
        var e_1, _a;
        // Reverse the tokens, so that they are in the order that they should
        // be output
        var symbols = [];
        for(var token = this.endBinaryShift(text.length).token; token !== null; token = token.getPrevious())symbols.unshift(token);
        var bitArray = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        try {
            // Add each token to the result.
            for(var symbols_1 = $eb2646fe0cb525a0$var$__values(symbols), symbols_1_1 = symbols_1.next(); !symbols_1_1.done; symbols_1_1 = symbols_1.next()){
                var symbol = symbols_1_1.value;
                symbol.appendTo(bitArray, text);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (symbols_1_1 && !symbols_1_1.done && (_a = symbols_1.return)) _a.call(symbols_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // assert bitArray.getSize() === this.bitCount;
        return bitArray;
    };
    /**
     * @Override
     */ State.prototype.toString = function() {
        return (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).format("%s bits=%d bytes=%d", $5530db33e992a0bb$export$b330669118f5398c[this.mode], this.bitCount, this.binaryShiftByteCount);
    };
    State.calculateBinaryShiftCost = function(state) {
        if (state.binaryShiftByteCount > 62) return 21; // B/S with extended length
        if (state.binaryShiftByteCount > 31) return 20; // two B/S
        if (state.binaryShiftByteCount > 0) return 10; // one B/S
        return 0;
    };
    State.INITIAL_STATE = new State($5530db33e992a0bb$export$89bb5d126ce811a2, $5530db33e992a0bb$export$b62eceed7909eedb, 0, 0);
    return State;
}();
var $eb2646fe0cb525a0$export$2e2bcd8739ae039 = $eb2646fe0cb525a0$var$State;






function $3fc23ca0a7d4d087$export$cc3e6a9bbac46e84(CHAR_MAP) {
    var spaceCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(" ");
    var pointCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(".");
    var commaCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(",");
    CHAR_MAP[$5530db33e992a0bb$export$b62eceed7909eedb][spaceCharCode] = 1;
    var zUpperCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("Z");
    var aUpperCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("A");
    for(var c = aUpperCharCode; c <= zUpperCharCode; c++)CHAR_MAP[$5530db33e992a0bb$export$b62eceed7909eedb][c] = c - aUpperCharCode + 2;
    CHAR_MAP[$5530db33e992a0bb$export$dddc678b91a92292][spaceCharCode] = 1;
    var zLowerCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("z");
    var aLowerCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("a");
    for(var c = aLowerCharCode; c <= zLowerCharCode; c++)CHAR_MAP[$5530db33e992a0bb$export$dddc678b91a92292][c] = c - aLowerCharCode + 2;
    CHAR_MAP[$5530db33e992a0bb$export$5a5ce6a997d69865][spaceCharCode] = 1;
    var nineCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("9");
    var zeroCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("0");
    for(var c = zeroCharCode; c <= nineCharCode; c++)CHAR_MAP[$5530db33e992a0bb$export$5a5ce6a997d69865][c] = c - zeroCharCode + 2;
    CHAR_MAP[$5530db33e992a0bb$export$5a5ce6a997d69865][commaCharCode] = 12;
    CHAR_MAP[$5530db33e992a0bb$export$5a5ce6a997d69865][pointCharCode] = 13;
    var mixedTable = [
        "\x00",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f"
    ];
    for(var i = 0; i < mixedTable.length; i++)CHAR_MAP[$5530db33e992a0bb$export$7ff1f62ca8a43556][(0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(mixedTable[i])] = i;
    var punctTable = [
        "\x00",
        "\r",
        "\x00",
        "\x00",
        "\x00",
        "\x00",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(var i = 0; i < punctTable.length; i++)if ((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(punctTable[i]) > 0) CHAR_MAP[$5530db33e992a0bb$export$4e7b78785f29ce0f][(0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(punctTable[i])] = i;
    return CHAR_MAP;
}
var $3fc23ca0a7d4d087$export$15ce3e30c0b81cf5 = $3fc23ca0a7d4d087$export$cc3e6a9bbac46e84((0, $eed4834329730fe6$export$2e2bcd8739ae039).createInt32Array(5, 256));




var $22f8516a75615a63$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * This produces nearly optimal encodings of text into the first-level of
 * encoding used by Aztec code.
 *
 * It uses a dynamic algorithm.  For each prefix of the string, it determines
 * a set of encodings that could lead to this prefix.  We repeatedly add a
 * character and generate a new set of optimal encodings until we have read
 * through the entire input.
 *
 * @author Frank Yellin
 * @author Rustam Abdullaev
 */ var $22f8516a75615a63$var$HighLevelEncoder = /** @class */ function() {
    function HighLevelEncoder(text) {
        this.text = text;
    }
    /**
     * @return text represented by this encoder encoded as a {@link BitArray}
     */ HighLevelEncoder.prototype.encode = function() {
        var spaceCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(" ");
        var lineBreakCharCode = (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("\n");
        var states = (0, $6bc13dedef93f294$export$2e2bcd8739ae039).singletonList((0, $eb2646fe0cb525a0$export$2e2bcd8739ae039).INITIAL_STATE);
        for(var index = 0; index < this.text.length; index++){
            var pairCode = void 0;
            var nextChar = index + 1 < this.text.length ? this.text[index + 1] : 0;
            switch(this.text[index]){
                case (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("\r"):
                    pairCode = nextChar === lineBreakCharCode ? 2 : 0;
                    break;
                case (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode("."):
                    pairCode = nextChar === spaceCharCode ? 3 : 0;
                    break;
                case (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(","):
                    pairCode = nextChar === spaceCharCode ? 4 : 0;
                    break;
                case (0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getCharCode(":"):
                    pairCode = nextChar === spaceCharCode ? 5 : 0;
                    break;
                default:
                    pairCode = 0;
            }
            if (pairCode > 0) {
                // We have one of the four special PUNCT pairs.  Treat them specially.
                // Get a new set of states for the two new characters.
                states = HighLevelEncoder.updateStateListForPair(states, index, pairCode);
                index++;
            } else // Get a new set of states for the new character.
            states = this.updateStateListForChar(states, index);
        }
        // We are left with a set of states.  Find the shortest one.
        var minState = (0, $6bc13dedef93f294$export$2e2bcd8739ae039).min(states, function(a, b) {
            return a.getBitCount() - b.getBitCount();
        });
        // Convert it to a bit array, and return.
        return minState.toBitArray(this.text);
    };
    // We update a set of states for a new character by updating each state
    // for the new character, merging the results, and then removing the
    // non-optimal states.
    HighLevelEncoder.prototype.updateStateListForChar = function(states, index) {
        var e_1, _a;
        var result = [];
        try {
            for(var states_1 = $22f8516a75615a63$var$__values(states), states_1_1 = states_1.next(); !states_1_1.done; states_1_1 = states_1.next()){
                var state = states_1_1.value /*State*/ ;
                this.updateStateForChar(state, index, result);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (states_1_1 && !states_1_1.done && (_a = states_1.return)) _a.call(states_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return HighLevelEncoder.simplifyStates(result);
    };
    // Return a set of states that represent the possible ways of updating this
    // state for the next character.  The resulting set of states are added to
    // the "result" list.
    HighLevelEncoder.prototype.updateStateForChar = function(state, index, result) {
        var ch = this.text[index] & 0xff;
        var charInCurrentTable = $3fc23ca0a7d4d087$export$15ce3e30c0b81cf5[state.getMode()][ch] > 0;
        var stateNoBinary = null;
        for(var mode /*int*/  = 0; mode <= $5530db33e992a0bb$export$4e7b78785f29ce0f; mode++){
            var charInMode = $3fc23ca0a7d4d087$export$15ce3e30c0b81cf5[mode][ch];
            if (charInMode > 0) {
                if (stateNoBinary == null) // Only create stateNoBinary the first time it's required.
                stateNoBinary = state.endBinaryShift(index);
                // Try generating the character by latching to its mode
                if (!charInCurrentTable || mode === state.getMode() || mode === $5530db33e992a0bb$export$5a5ce6a997d69865) {
                    // If the character is in the current table, we don't want to latch to
                    // any other mode except possibly digit (which uses only 4 bits).  Any
                    // other latch would be equally successful *after* this character, and
                    // so wouldn't save any bits.
                    var latchState = stateNoBinary.latchAndAppend(mode, charInMode);
                    result.push(latchState);
                }
                // Try generating the character by switching to its mode.
                if (!charInCurrentTable && $072d3736f14449e0$export$46c23485303b0705[state.getMode()][mode] >= 0) {
                    // It never makes sense to temporarily shift to another mode if the
                    // character exists in the current mode.  That can never save bits.
                    var shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
                    result.push(shiftState);
                }
            }
        }
        if (state.getBinaryShiftByteCount() > 0 || $3fc23ca0a7d4d087$export$15ce3e30c0b81cf5[state.getMode()][ch] === 0) {
            // It's never worthwhile to go into binary shift mode if you're not already
            // in binary shift mode, and the character exists in your current mode.
            // That can never save bits over just outputting the char in the current mode.
            var binaryState = state.addBinaryShiftChar(index);
            result.push(binaryState);
        }
    };
    HighLevelEncoder.updateStateListForPair = function(states, index, pairCode) {
        var e_2, _a;
        var result = [];
        try {
            for(var states_2 = $22f8516a75615a63$var$__values(states), states_2_1 = states_2.next(); !states_2_1.done; states_2_1 = states_2.next()){
                var state = states_2_1.value /*State*/ ;
                this.updateStateForPair(state, index, pairCode, result);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (states_2_1 && !states_2_1.done && (_a = states_2.return)) _a.call(states_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return this.simplifyStates(result);
    };
    HighLevelEncoder.updateStateForPair = function(state, index, pairCode, result) {
        var stateNoBinary = state.endBinaryShift(index);
        // Possibility 1.  Latch to C.MODE_PUNCT, and then append this code
        result.push(stateNoBinary.latchAndAppend($5530db33e992a0bb$export$4e7b78785f29ce0f, pairCode));
        if (state.getMode() !== $5530db33e992a0bb$export$4e7b78785f29ce0f) // Possibility 2.  Shift to C.MODE_PUNCT, and then append this code.
        // Every state except C.MODE_PUNCT (handled above) can shift
        result.push(stateNoBinary.shiftAndAppend($5530db33e992a0bb$export$4e7b78785f29ce0f, pairCode));
        if (pairCode === 3 || pairCode === 4) {
            // both characters are in DIGITS.  Sometimes better to just add two digits
            var digitState = stateNoBinary.latchAndAppend($5530db33e992a0bb$export$5a5ce6a997d69865, 16 - pairCode) // period or comma in DIGIT
            .latchAndAppend($5530db33e992a0bb$export$5a5ce6a997d69865, 1); // space in DIGIT
            result.push(digitState);
        }
        if (state.getBinaryShiftByteCount() > 0) {
            // It only makes sense to do the characters as binary if we're already
            // in binary mode.
            var binaryState = state.addBinaryShiftChar(index).addBinaryShiftChar(index + 1);
            result.push(binaryState);
        }
    };
    HighLevelEncoder.simplifyStates = function(states) {
        var e_3, _a, e_4, _b;
        var result = [];
        try {
            for(var states_3 = $22f8516a75615a63$var$__values(states), states_3_1 = states_3.next(); !states_3_1.done; states_3_1 = states_3.next()){
                var newState = states_3_1.value;
                var add = true;
                var _loop_1 = function(oldState) {
                    if (oldState.isBetterThanOrEqualTo(newState)) {
                        add = false;
                        return "break";
                    }
                    if (newState.isBetterThanOrEqualTo(oldState)) // iterator.remove();
                    result = result.filter(function(x) {
                        return x !== oldState;
                    }); // remove old state
                };
                try {
                    for(var result_1 = (e_4 = void 0, $22f8516a75615a63$var$__values(result)), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()){
                        var oldState = result_1_1.value;
                        var state_1 = _loop_1(oldState);
                        if (state_1 === "break") break;
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (result_1_1 && !result_1_1.done && (_b = result_1.return)) _b.call(result_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                if (add) result.push(newState);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (states_3_1 && !states_3_1.done && (_a = states_3.return)) _a.call(states_3);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
    return HighLevelEncoder;
}();
var $22f8516a75615a63$export$2e2bcd8739ae039 = $22f8516a75615a63$var$HighLevelEncoder;



var $0f20204df495ef78$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.aztec.encoder;
// import com.google.zxing.common.BitArray;
// import com.google.zxing.common.BitMatrix;
// import com.google.zxing.common.reedsolomon.GenericGF;
// import com.google.zxing.common.reedsolomon.ReedSolomonEncoder;
/**
 * Generates Aztec 2D barcodes.
 *
 * @author Rustam Abdullaev
 */ var $0f20204df495ef78$var$Encoder = /** @class */ function() {
    function Encoder() {}
    /**
     * Encodes the given binary content as an Aztec symbol
     *
     * @param data input data string
     * @return Aztec symbol matrix with metadata
     */ Encoder.encodeBytes = function(data) {
        return Encoder.encode(data, Encoder.DEFAULT_EC_PERCENT, Encoder.DEFAULT_AZTEC_LAYERS);
    };
    /**
     * Encodes the given binary content as an Aztec symbol
     *
     * @param data input data string
     * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
     *                      a minimum of 23% + 3 words is recommended)
     * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
     * @return Aztec symbol matrix with metadata
     */ Encoder.encode = function(data, minECCPercent, userSpecifiedLayers) {
        // High-level encode
        var bits = new (0, $22f8516a75615a63$export$2e2bcd8739ae039)(data).encode();
        // stuff bits and choose symbol size
        var eccBits = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(bits.getSize() * minECCPercent, 100) + 11;
        var totalSizeBits = bits.getSize() + eccBits;
        var compact;
        var layers;
        var totalBitsInLayer;
        var wordSize;
        var stuffedBits;
        if (userSpecifiedLayers !== Encoder.DEFAULT_AZTEC_LAYERS) {
            compact = userSpecifiedLayers < 0;
            layers = Math.abs(userSpecifiedLayers);
            if (layers > (compact ? Encoder.MAX_NB_BITS_COMPACT : Encoder.MAX_NB_BITS)) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).format("Illegal value %s for layers", userSpecifiedLayers));
            totalBitsInLayer = Encoder.totalBitsInLayer(layers, compact);
            wordSize = Encoder.WORD_SIZE[layers];
            var usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
            stuffedBits = Encoder.stuffBits(bits, wordSize);
            if (stuffedBits.getSize() + eccBits > usableBitsInLayers) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Data to large for user specified layer");
            if (compact && stuffedBits.getSize() > wordSize * 64) // Compact format only allows 64 data words, though C4 can hold more words than that
            throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Data to large for user specified layer");
        } else {
            wordSize = 0;
            stuffedBits = null;
            // We look at the possible table sizes in the order Compact1, Compact2, Compact3,
            // Compact4, Normal4,...  Normal(i) for i < 4 isn't typically used since Compact(i+1)
            // is the same size, but has more data.
            for(var i /*int*/  = 0;; i++){
                if (i > Encoder.MAX_NB_BITS) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Data too large for an Aztec code");
                compact = i <= 3;
                layers = compact ? i + 1 : i;
                totalBitsInLayer = Encoder.totalBitsInLayer(layers, compact);
                if (totalSizeBits > totalBitsInLayer) continue;
                // [Re]stuff the bits if this is the first opportunity, or if the
                // wordSize has changed
                if (stuffedBits == null || wordSize !== Encoder.WORD_SIZE[layers]) {
                    wordSize = Encoder.WORD_SIZE[layers];
                    stuffedBits = Encoder.stuffBits(bits, wordSize);
                }
                var usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                if (compact && stuffedBits.getSize() > wordSize * 64) continue;
                if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) break;
            }
        }
        var messageBits = Encoder.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
        // generate mode message
        var messageSizeInWords = stuffedBits.getSize() / wordSize;
        var modeMessage = Encoder.generateModeMessage(compact, layers, messageSizeInWords);
        // allocate symbol
        var baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
        var alignmentMap = new Int32Array(baseMatrixSize);
        var matrixSize;
        if (compact) {
            // no alignment marks in compact mode, alignmentMap is a no-op
            matrixSize = baseMatrixSize;
            for(var i /*int*/  = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
        } else {
            matrixSize = baseMatrixSize + 1 + 2 * (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision((0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(baseMatrixSize, 2) - 1, 15);
            var origCenter = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(baseMatrixSize, 2);
            var center = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2);
            for(var i /*int*/  = 0; i < origCenter; i++){
                var newOffset = i + (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(i, 15);
                alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                alignmentMap[origCenter + i] = center + newOffset + 1;
            }
        }
        var matrix = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(matrixSize);
        // draw data bits
        for(var i /*int*/  = 0, rowOffset = 0; i < layers; i++){
            var rowSize = (layers - i) * 4 + (compact ? 9 : 12);
            for(var j /*int*/  = 0; j < rowSize; j++){
                var columnOffset = j * 2;
                for(var k /*int*/  = 0; k < 2; k++){
                    if (messageBits.get(rowOffset + columnOffset + k)) matrix.set(alignmentMap[i * 2 + k], alignmentMap[i * 2 + j]);
                    if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) matrix.set(alignmentMap[i * 2 + j], alignmentMap[baseMatrixSize - 1 - i * 2 - k]);
                    if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - k], alignmentMap[baseMatrixSize - 1 - i * 2 - j]);
                    if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - j], alignmentMap[i * 2 + k]);
                }
            }
            rowOffset += rowSize * 8;
        }
        // draw mode message
        Encoder.drawModeMessage(matrix, compact, matrixSize, modeMessage);
        // draw alignment marks
        if (compact) Encoder.drawBullsEye(matrix, (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2), 5);
        else {
            Encoder.drawBullsEye(matrix, (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2), 7);
            for(var i /*int*/  = 0, j = 0; i < (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(baseMatrixSize, 2) - 1; i += 15, j += 16)for(var k /*int*/  = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2){
                matrix.set((0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2) - j, k);
                matrix.set((0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2) + j, k);
                matrix.set(k, (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2) - j);
                matrix.set(k, (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2) + j);
            }
        }
        var aztec = new (0, $d497b21fac9ff4b3$export$2e2bcd8739ae039)();
        aztec.setCompact(compact);
        aztec.setSize(matrixSize);
        aztec.setLayers(layers);
        aztec.setCodeWords(messageSizeInWords);
        aztec.setMatrix(matrix);
        return aztec;
    };
    Encoder.drawBullsEye = function(matrix, center, size) {
        for(var i /*int*/  = 0; i < size; i += 2)for(var j /*int*/  = center - i; j <= center + i; j++){
            matrix.set(j, center - i);
            matrix.set(j, center + i);
            matrix.set(center - i, j);
            matrix.set(center + i, j);
        }
        matrix.set(center - size, center - size);
        matrix.set(center - size + 1, center - size);
        matrix.set(center - size, center - size + 1);
        matrix.set(center + size, center - size);
        matrix.set(center + size, center - size + 1);
        matrix.set(center + size, center + size - 1);
    };
    Encoder.generateModeMessage = function(compact, layers, messageSizeInWords) {
        var modeMessage = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        if (compact) {
            modeMessage.appendBits(layers - 1, 2);
            modeMessage.appendBits(messageSizeInWords - 1, 6);
            modeMessage = Encoder.generateCheckWords(modeMessage, 28, 4);
        } else {
            modeMessage.appendBits(layers - 1, 5);
            modeMessage.appendBits(messageSizeInWords - 1, 11);
            modeMessage = Encoder.generateCheckWords(modeMessage, 40, 4);
        }
        return modeMessage;
    };
    Encoder.drawModeMessage = function(matrix, compact, matrixSize, modeMessage) {
        var center = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(matrixSize, 2);
        if (compact) for(var i /*int*/  = 0; i < 7; i++){
            var offset = center - 3 + i;
            if (modeMessage.get(i)) matrix.set(offset, center - 5);
            if (modeMessage.get(i + 7)) matrix.set(center + 5, offset);
            if (modeMessage.get(20 - i)) matrix.set(offset, center + 5);
            if (modeMessage.get(27 - i)) matrix.set(center - 5, offset);
        }
        else for(var i /*int*/  = 0; i < 10; i++){
            var offset = center - 5 + i + (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(i, 5);
            if (modeMessage.get(i)) matrix.set(offset, center - 7);
            if (modeMessage.get(i + 10)) matrix.set(center + 7, offset);
            if (modeMessage.get(29 - i)) matrix.set(offset, center + 7);
            if (modeMessage.get(39 - i)) matrix.set(center - 7, offset);
        }
    };
    Encoder.generateCheckWords = function(bitArray, totalBits, wordSize) {
        var e_1, _a;
        // bitArray is guaranteed to be a multiple of the wordSize, so no padding needed
        var messageSizeInWords = bitArray.getSize() / wordSize;
        var rs = new (0, $72dc1ddcdc47f39a$export$2e2bcd8739ae039)(Encoder.getGF(wordSize));
        var totalWords = (0, $902e90c40380930f$export$2e2bcd8739ae039).truncDivision(totalBits, wordSize);
        var messageWords = Encoder.bitsToWords(bitArray, wordSize, totalWords);
        rs.encode(messageWords, totalWords - messageSizeInWords);
        var startPad = totalBits % wordSize;
        var messageBits = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        messageBits.appendBits(0, startPad);
        try {
            for(var _b = $0f20204df495ef78$var$__values(Array.from(messageWords)), _c = _b.next(); !_c.done; _c = _b.next()){
                var messageWord = _c.value /*: int*/ ;
                messageBits.appendBits(messageWord, wordSize);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return messageBits;
    };
    Encoder.bitsToWords = function(stuffedBits, wordSize, totalWords) {
        var message = new Int32Array(totalWords);
        var i;
        var n;
        for(i = 0, n = stuffedBits.getSize() / wordSize; i < n; i++){
            var value = 0;
            for(var j /*int*/  = 0; j < wordSize; j++)value |= stuffedBits.get(i * wordSize + j) ? 1 << wordSize - j - 1 : 0;
            message[i] = value;
        }
        return message;
    };
    Encoder.getGF = function(wordSize) {
        switch(wordSize){
            case 4:
                return (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_PARAM;
            case 6:
                return (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_6;
            case 8:
                return (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_8;
            case 10:
                return (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_10;
            case 12:
                return (0, $7973dc50831a46a1$export$2e2bcd8739ae039).AZTEC_DATA_12;
            default:
                throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Unsupported word size " + wordSize);
        }
    };
    Encoder.stuffBits = function(bits, wordSize) {
        var out = new (0, $d449ed9f21ed6168$export$2e2bcd8739ae039)();
        var n = bits.getSize();
        var mask = (1 << wordSize) - 2;
        for(var i /*int*/  = 0; i < n; i += wordSize){
            var word = 0;
            for(var j /*int*/  = 0; j < wordSize; j++)if (i + j >= n || bits.get(i + j)) word |= 1 << wordSize - 1 - j;
            if ((word & mask) === mask) {
                out.appendBits(word & mask, wordSize);
                i--;
            } else if ((word & mask) === 0) {
                out.appendBits(word | 1, wordSize);
                i--;
            } else out.appendBits(word, wordSize);
        }
        return out;
    };
    Encoder.totalBitsInLayer = function(layers, compact) {
        return ((compact ? 88 : 112) + 16 * layers) * layers;
    };
    Encoder.DEFAULT_EC_PERCENT = 33; // default minimal percentage of error check words
    Encoder.DEFAULT_AZTEC_LAYERS = 0;
    Encoder.MAX_NB_BITS = 32;
    Encoder.MAX_NB_BITS_COMPACT = 4;
    Encoder.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
    return Encoder;
}();
var $0f20204df495ef78$export$2e2bcd8739ae039 = $0f20204df495ef78$var$Encoder;









/**
 * Renders an Aztec code as a {@link BitMatrix}.
 */ var $f56610534cd66c1c$var$AztecWriter = /** @class */ function() {
    function AztecWriter() {}
    // @Override
    AztecWriter.prototype.encode = function(contents, format, width, height) {
        return this.encodeWithHints(contents, format, width, height, null);
    };
    // @Override
    AztecWriter.prototype.encodeWithHints = function(contents, format, width, height, hints) {
        var charset = (0, $e21db4982d838126$export$2e2bcd8739ae039).ISO_8859_1;
        var eccPercent = (0, $0f20204df495ef78$export$2e2bcd8739ae039).DEFAULT_EC_PERCENT;
        var layers = (0, $0f20204df495ef78$export$2e2bcd8739ae039).DEFAULT_AZTEC_LAYERS;
        if (hints != null) {
            if (hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).CHARACTER_SET)) charset = (0, $64e0b7362b63fd2a$export$2e2bcd8739ae039).forName(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).CHARACTER_SET).toString());
            if (hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).ERROR_CORRECTION)) eccPercent = (0, $902e90c40380930f$export$2e2bcd8739ae039).parseInt(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).ERROR_CORRECTION).toString());
            if (hints.has((0, $0186ee20139e7364$export$2e2bcd8739ae039).AZTEC_LAYERS)) layers = (0, $902e90c40380930f$export$2e2bcd8739ae039).parseInt(hints.get((0, $0186ee20139e7364$export$2e2bcd8739ae039).AZTEC_LAYERS).toString());
        }
        return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
    };
    AztecWriter.encodeLayers = function(contents, format, width, height, charset, eccPercent, layers) {
        if (format !== (0, $03ea32520a329dec$export$2e2bcd8739ae039).AZTEC) throw new (0, $f35d37e876714c26$export$2e2bcd8739ae039)("Can only encode AZTEC, but got " + format);
        var aztec = (0, $0f20204df495ef78$export$2e2bcd8739ae039).encode((0, $d9f8f9e5b61dd63f$export$2e2bcd8739ae039).getBytes(contents, charset), eccPercent, layers);
        return AztecWriter.renderResult(aztec, width, height);
    };
    AztecWriter.renderResult = function(code, width, height) {
        var input = code.getMatrix();
        if (input == null) throw new (0, $66514fa37e3c5a9c$export$2e2bcd8739ae039)();
        var inputWidth = input.getWidth();
        var inputHeight = input.getHeight();
        var outputWidth = Math.max(width, inputWidth);
        var outputHeight = Math.max(height, inputHeight);
        var multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
        var leftPadding = (outputWidth - inputWidth * multiple) / 2;
        var topPadding = (outputHeight - inputHeight * multiple) / 2;
        var output = new (0, $ff4f860b0cfaffff$export$2e2bcd8739ae039)(outputWidth, outputHeight);
        for(var inputY /*int*/  = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the barcode
            for(var inputX /*int*/  = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY)) output.setRegion(outputX, outputY, multiple, multiple);
        }
        return output;
    };
    return AztecWriter;
}();
var $f56610534cd66c1c$export$2e2bcd8739ae039 = $f56610534cd66c1c$var$AztecWriter;























var $7fPBF = parcelRequire("7fPBF");
"use client";
function $a7405a6d835797da$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = $7fPBF.createContext(void 0);
    Context.displayName = name;
    function useContext2() {
        var _a;
        const context = $7fPBF.useContext(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext2);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext2,
        Context
    ];
}


"use client";
var [$8d7d6525e5036ff7$export$4aacc92b34f48449, $8d7d6525e5036ff7$export$c1f1c27d8fe70f39] = (0, $a7405a6d835797da$export$fd42f52fd3ae1109)({
    name: "CardContext",
    strict: true,
    errorMessage: "useCardContext: `context` is undefined. Seems you forgot to wrap component within <Card />"
});


// src/types.ts
var $4821bfc64ede9c08$export$f05c09085eeea85c = [
    "0",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "3xl",
    "4xl",
    "5xl",
    "6xl",
    "7xl",
    "8xl",
    "9xl",
    "1",
    "2",
    "3",
    "3.5",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "20",
    "24",
    "28",
    "32",
    "36",
    "40",
    "44",
    "48",
    "52",
    "56",
    "60",
    "64",
    "72",
    "80",
    "96"
];
var $4821bfc64ede9c08$export$e04743fb5fc64cba = $4821bfc64ede9c08$export$f05c09085eeea85c.map((key)=>`unit-${key}`);


var $3f15c71ad5587fe0$export$407448d2b89b1813 = (t)=>typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, $3f15c71ad5587fe0$export$8b22cf2602fb60ce = (t)=>!t || typeof t != "object" || Object.keys(t).length === 0, $3f15c71ad5587fe0$export$db3b6bfb95261072 = (t, e)=>JSON.stringify(t) === JSON.stringify(e), $3f15c71ad5587fe0$export$4368d992c4eafac0 = (t)=>typeof t == "boolean";
function $3f15c71ad5587fe0$var$i(t, e) {
    t.forEach(function(n) {
        Array.isArray(n) ? $3f15c71ad5587fe0$var$i(n, e) : e.push(n);
    });
}
function $3f15c71ad5587fe0$export$f1e1789686576879(t) {
    let e = [];
    return $3f15c71ad5587fe0$var$i(t, e), e;
}
var $3f15c71ad5587fe0$export$2d1720544b23b823 = (...t)=>$3f15c71ad5587fe0$export$f1e1789686576879(t).filter(Boolean), $3f15c71ad5587fe0$export$39b482c5e57630a8 = (t, e)=>{
    let n = {}, c = Object.keys(t), f = Object.keys(e);
    for (let o of c)if (f.includes(o)) {
        let s = t[o], r = e[o];
        typeof s == "object" && typeof r == "object" ? n[o] = $3f15c71ad5587fe0$export$39b482c5e57630a8(s, r) : n[o] = r + " " + s;
    } else n[o] = t[o];
    for (let o of f)c.includes(o) || (n[o] = e[o]);
    return n;
}, $3f15c71ad5587fe0$export$dda1d9f60106f0e9 = (t)=>!t || typeof t != "string" ? t : t.replace(/\s+/g, " ").trim();


var $14cd8908df625495$var$CLASS_PART_SEPARATOR = "-";
function $14cd8908df625495$export$e3a687438e51f555(config) {
    var classMap = $14cd8908df625495$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($14cd8908df625495$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $14cd8908df625495$var$getGroupRecursive(classParts, classMap) || $14cd8908df625495$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $14cd8908df625495$var$getGroupRecursive(classParts, classPartObject) {
    var _classPartObject_validators_find;
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $14cd8908df625495$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($14cd8908df625495$var$CLASS_PART_SEPARATOR);
    return (_classPartObject_validators_find = classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })) === null || _classPartObject_validators_find === void 0 ? void 0 : _classPartObject_validators_find.classGroupId;
}
var $14cd8908df625495$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $14cd8908df625495$var$getGroupIdForArbitraryProperty(className) {
    if ($14cd8908df625495$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $14cd8908df625495$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName === null || arbitraryPropertyClassName === void 0 ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $14cd8908df625495$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $14cd8908df625495$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $14cd8908df625495$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $14cd8908df625495$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $14cd8908df625495$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($14cd8908df625495$var$isThemeGetter(classDefinition)) {
                $14cd8908df625495$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $14cd8908df625495$var$processClassesRecursively(classGroup, $14cd8908df625495$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $14cd8908df625495$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($14cd8908df625495$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $14cd8908df625495$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $14cd8908df625495$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}


// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $2ebe01d34ddbaf51$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}


var $ccbd4067243decf0$export$61823b46426d06fa = "!";
function $ccbd4067243decf0$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($ccbd4067243decf0$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $ccbd4067243decf0$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}


function $d334f6f1edb1ff7a$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $2ebe01d34ddbaf51$export$cf6a7cbaa5f64437)(config.cacheSize),
        splitModifiers: (0, $ccbd4067243decf0$export$b5f40ac45a8dd583)(config),
        ...(0, $14cd8908df625495$export$e3a687438e51f555)(config)
    };
}



var $2c916e253c61a20d$var$SPLIT_CLASSES_REGEX = /\s+/;
function $2c916e253c61a20d$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($2c916e253c61a20d$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $ccbd4067243decf0$export$4f247a60f8a83b3a)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $ccbd4067243decf0$export$61823b46426d06fa) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}


/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $019f4c130afadfac$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $019f4c130afadfac$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $019f4c130afadfac$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $019f4c130afadfac$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}


function $9468785b73eb8b84$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $d334f6f1edb1ff7a$export$56ab4ba5b0b25eb0)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $2c916e253c61a20d$export$b41084d9255a3248)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $019f4c130afadfac$export$a8bbfb445e1f163f).apply(null, arguments));
    };
}


function $284d2c8efd0fd6ef$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}


var $ea1c1b9dc188746c$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $ea1c1b9dc188746c$var$fractionRegex = /^\d+\/\d+$/;
var $ea1c1b9dc188746c$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $ea1c1b9dc188746c$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $ea1c1b9dc188746c$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $ea1c1b9dc188746c$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $ea1c1b9dc188746c$export$38db3d147cb3433(value) {
    return $ea1c1b9dc188746c$export$7e4aa119212bc614(value) || $ea1c1b9dc188746c$var$stringLengths.has(value) || $ea1c1b9dc188746c$var$fractionRegex.test(value) || $ea1c1b9dc188746c$export$f5e3af6d4c0fbe38(value);
}
function $ea1c1b9dc188746c$export$f5e3af6d4c0fbe38(value) {
    return $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "length", $ea1c1b9dc188746c$var$isLengthOnly);
}
function $ea1c1b9dc188746c$export$92dbd3a305a7cb8b(value) {
    return $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "size", $ea1c1b9dc188746c$var$isNever);
}
function $ea1c1b9dc188746c$export$57d00f225f425549(value) {
    return $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "position", $ea1c1b9dc188746c$var$isNever);
}
function $ea1c1b9dc188746c$export$478a5386e985802b(value) {
    return $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "url", $ea1c1b9dc188746c$var$isUrl);
}
function $ea1c1b9dc188746c$export$ea45ce4f1b2d6088(value) {
    return $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "number", $ea1c1b9dc188746c$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $ea1c1b9dc188746c$export$cd3ce15f42623f06 = $ea1c1b9dc188746c$export$ea45ce4f1b2d6088;
function $ea1c1b9dc188746c$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $ea1c1b9dc188746c$export$e50269385c77c348(value) {
    return value.endsWith("%") && $ea1c1b9dc188746c$export$7e4aa119212bc614(value.slice(0, -1));
}
function $ea1c1b9dc188746c$export$a287f47fed4544b8(value) {
    return $ea1c1b9dc188746c$var$isIntegerOnly(value) || $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "number", $ea1c1b9dc188746c$var$isIntegerOnly);
}
function $ea1c1b9dc188746c$export$5534a8576501817d(value) {
    return $ea1c1b9dc188746c$var$arbitraryValueRegex.test(value);
}
function $ea1c1b9dc188746c$export$ebb65efc98a3b5f7() {
    return true;
}
function $ea1c1b9dc188746c$export$a40791c6b7db5bcc(value) {
    return $ea1c1b9dc188746c$var$tshirtUnitRegex.test(value);
}
function $ea1c1b9dc188746c$export$d01106465b385604(value) {
    return $ea1c1b9dc188746c$var$getIsArbitraryValue(value, "", $ea1c1b9dc188746c$var$isShadow);
}
function $ea1c1b9dc188746c$var$getIsArbitraryValue(value, label, testValue) {
    var result = $ea1c1b9dc188746c$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $ea1c1b9dc188746c$var$isLengthOnly(value) {
    return $ea1c1b9dc188746c$var$lengthUnitRegex.test(value);
}
function $ea1c1b9dc188746c$var$isNever() {
    return false;
}
function $ea1c1b9dc188746c$var$isUrl(value) {
    return value.startsWith("url(");
}
function $ea1c1b9dc188746c$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $ea1c1b9dc188746c$var$isShadow(value) {
    return $ea1c1b9dc188746c$var$shadowRegex.test(value);
}


function $bd566715c7b32b41$export$ed30944e0fe6ae5c() {
    var colors = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("colors");
    var spacing = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("spacing");
    var blur = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("blur");
    var brightness = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("brightness");
    var borderColor = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("borderColor");
    var borderRadius = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("borderRadius");
    var borderSpacing = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("borderSpacing");
    var borderWidth = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("borderWidth");
    var contrast = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("contrast");
    var grayscale = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("grayscale");
    var hueRotate = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("hueRotate");
    var invert = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("invert");
    var gap = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("gap");
    var gradientColorStops = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("gradientColorStops");
    var gradientColorStopPositions = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("gradientColorStopPositions");
    var inset = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("inset");
    var margin = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("margin");
    var opacity = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("opacity");
    var padding = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("padding");
    var saturate = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("saturate");
    var scale = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("scale");
    var sepia = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("sepia");
    var skew = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("skew");
    var space = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("space");
    var translate = (0, $284d2c8efd0fd6ef$export$e176af7b8eefe933)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $ea1c1b9dc188746c$export$5534a8576501817d),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $ea1c1b9dc188746c$export$5534a8576501817d),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $ea1c1b9dc188746c$export$7e4aa119212bc614),
            (0, $ea1c1b9dc188746c$export$5534a8576501817d)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $ea1c1b9dc188746c$export$5534a8576501817d)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $ea1c1b9dc188746c$export$7e4aa119212bc614),
            (0, $ea1c1b9dc188746c$export$ea45ce4f1b2d6088)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $ea1c1b9dc188746c$export$7e4aa119212bc614),
            (0, $ea1c1b9dc188746c$export$5534a8576501817d)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $ea1c1b9dc188746c$export$ebb65efc98a3b5f7)
            ],
            spacing: [
                (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
            ],
            blur: [
                "none",
                "",
                (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc),
                (0, $ea1c1b9dc188746c$export$5534a8576501817d)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc),
                (0, $ea1c1b9dc188746c$export$5534a8576501817d)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $ea1c1b9dc188746c$export$e50269385c77c348),
                (0, $ea1c1b9dc188746c$export$f5e3af6d4c0fbe38)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $ea1c1b9dc188746c$export$a287f47fed4544b8)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $ea1c1b9dc188746c$export$a287f47fed4544b8)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $ea1c1b9dc188746c$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $ea1c1b9dc188746c$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $ea1c1b9dc188746c$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $ea1c1b9dc188746c$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc)
                            ]
                        },
                        (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc),
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc),
                        (0, $ea1c1b9dc188746c$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $ea1c1b9dc188746c$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $ea1c1b9dc188746c$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $ea1c1b9dc188746c$export$7e4aa119212bc614),
                        (0, $ea1c1b9dc188746c$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $ea1c1b9dc188746c$export$57d00f225f425549)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $ea1c1b9dc188746c$export$92dbd3a305a7cb8b)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $ea1c1b9dc188746c$export$478a5386e985802b)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d),
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc),
                        (0, $ea1c1b9dc188746c$export$d01106465b385604)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $ea1c1b9dc188746c$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $ea1c1b9dc188746c$export$a40791c6b7db5bcc),
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $ea1c1b9dc188746c$export$a287f47fed4544b8),
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $ea1c1b9dc188746c$export$5534a8576501817d)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $ea1c1b9dc188746c$export$38db3d147cb3433),
                        (0, $ea1c1b9dc188746c$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}


/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $69be36b2019c99d8$export$5d86b86a654a7039(baseConfig, configExtension) {
    for(var key in configExtension)$69be36b2019c99d8$var$mergePropertyRecursively(baseConfig, key, configExtension[key]);
    return baseConfig;
}
var $69be36b2019c99d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $69be36b2019c99d8$var$overrideTypes = /*#__PURE__*/ new Set([
    "string",
    "number",
    "boolean"
]);
function $69be36b2019c99d8$var$mergePropertyRecursively(baseObject, mergeKey, mergeValue) {
    if (!$69be36b2019c99d8$var$hasOwnProperty.call(baseObject, mergeKey) || $69be36b2019c99d8$var$overrideTypes.has(typeof mergeValue) || mergeValue === null) {
        baseObject[mergeKey] = mergeValue;
        return;
    }
    if (Array.isArray(mergeValue) && Array.isArray(baseObject[mergeKey])) {
        baseObject[mergeKey] = baseObject[mergeKey].concat(mergeValue);
        return;
    }
    if (typeof mergeValue === "object" && typeof baseObject[mergeKey] === "object") {
        if (baseObject[mergeKey] === null) {
            baseObject[mergeKey] = mergeValue;
            return;
        }
        for(var nextKey in mergeValue)$69be36b2019c99d8$var$mergePropertyRecursively(baseObject[mergeKey], nextKey, mergeValue[nextKey]);
    }
}


function $2af1e252b0ed3ec5$export$c8d8406b6cd2243e(configExtension) {
    for(var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)createConfig[_key - 1] = arguments[_key];
    return typeof configExtension === "function" ? (0, $9468785b73eb8b84$export$ea2d4fba4d1bd27f).apply(void 0, [
        (0, $bd566715c7b32b41$export$ed30944e0fe6ae5c),
        configExtension
    ].concat(createConfig)) : (0, $9468785b73eb8b84$export$ea2d4fba4d1bd27f).apply(void 0, [
        function() {
            return (0, $69be36b2019c99d8$export$5d86b86a654a7039)((0, $bd566715c7b32b41$export$ed30944e0fe6ae5c)(), configExtension);
        }
    ].concat(createConfig));
}



var $66cd06ed350745cc$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $9468785b73eb8b84$export$ea2d4fba4d1bd27f)((0, $bd566715c7b32b41$export$ed30944e0fe6ae5c));


var $badabf1879a9e1a9$export$f84bd70098573c5c = {
    twMerge: !0,
    twMergeConfig: {},
    responsiveVariants: !1
}, $badabf1879a9e1a9$export$b2b720306681cd4b = (s)=>s || void 0, $badabf1879a9e1a9$export$bdb9d1405dbffd0f = (...s)=>$badabf1879a9e1a9$export$b2b720306681cd4b((0, $3f15c71ad5587fe0$export$f1e1789686576879)(s).filter(Boolean).join(" ")), $badabf1879a9e1a9$var$R = null, $badabf1879a9e1a9$var$O = {}, $badabf1879a9e1a9$var$q = !1, $badabf1879a9e1a9$export$1343a74baacb0543 = (...s)=>(d)=>d.twMerge ? ((!$badabf1879a9e1a9$var$R || $badabf1879a9e1a9$var$q) && ($badabf1879a9e1a9$var$q = !1, $badabf1879a9e1a9$var$R = (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)($badabf1879a9e1a9$var$O) ? (0, $66cd06ed350745cc$export$b4660bb6000dfbc9) : (0, $2af1e252b0ed3ec5$export$c8d8406b6cd2243e)($badabf1879a9e1a9$var$O)), $badabf1879a9e1a9$export$b2b720306681cd4b($badabf1879a9e1a9$var$R($badabf1879a9e1a9$export$bdb9d1405dbffd0f(s)))) : $badabf1879a9e1a9$export$bdb9d1405dbffd0f(s), $badabf1879a9e1a9$var$Y = (s, d)=>{
    for(let e in d)s.hasOwnProperty(e) ? s[e] = $badabf1879a9e1a9$export$bdb9d1405dbffd0f(s[e], d[e]) : s[e] = d[e];
    return s;
}, $badabf1879a9e1a9$export$984d890fc49ac622 = (s, d)=>{
    let { extend: e = null, slots: N = {}, variants: F = {}, compoundVariants: C = [], compoundSlots: V = [], defaultVariants: U = {} } = s, m = {
        ...$badabf1879a9e1a9$export$f84bd70098573c5c,
        ...d
    }, M = e != null && e.base ? $badabf1879a9e1a9$export$bdb9d1405dbffd0f(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(e.variants) ? (0, $3f15c71ad5587fe0$export$39b482c5e57630a8)(F, e.variants) : F, A = e != null && e.defaultVariants && !(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(e.defaultVariants) ? {
        ...e.defaultVariants,
        ...U
    } : U;
    !(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(m.twMergeConfig) && !(0, $3f15c71ad5587fe0$export$db3b6bfb95261072)(m.twMergeConfig, $badabf1879a9e1a9$var$O) && ($badabf1879a9e1a9$var$q = !0, $badabf1879a9e1a9$var$O = m.twMergeConfig);
    let $ = (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(N) ? {} : {
        base: s == null ? void 0 : s.base,
        ...N
    }, h$1 = (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(e == null ? void 0 : e.slots) ? $ : $badabf1879a9e1a9$var$Y({
        ...e == null ? void 0 : e.slots
    }, (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)($) ? {
        base: s == null ? void 0 : s.base
    } : $), v = (l)=>{
        if ((0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(g$1) && (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(N) && (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(e == null ? void 0 : e.slots)) return $badabf1879a9e1a9$export$1343a74baacb0543(M, l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
        if (C && !Array.isArray(C)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof C}`);
        if (V && !Array.isArray(V)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof V}`);
        let K = (t, n, a = [], i)=>{
            let r = a;
            if (typeof n == "string") r = r.concat((0, $3f15c71ad5587fe0$export$dda1d9f60106f0e9)(n).split(" ").map((c)=>`${t}:${c}`));
            else if (Array.isArray(n)) r = r.concat(n.reduce((c, f)=>c.concat(`${t}:${f}`), []));
            else if (typeof n == "object" && typeof i == "string") {
                for(let c in n)if (n.hasOwnProperty(c) && c === i) {
                    let f = n[c];
                    if (f && typeof f == "string") {
                        let o = (0, $3f15c71ad5587fe0$export$dda1d9f60106f0e9)(f);
                        r[i] ? r[i] = r[i].concat(o.split(" ").map((u)=>`${t}:${u}`)) : r[i] = o.split(" ").map((u)=>`${t}:${u}`);
                    } else Array.isArray(f) && f.length > 0 && (r[i] = f.reduce((o, u)=>o.concat(`${t}:${u}`), []));
                }
            }
            return r;
        }, W = (t, n = g$1, a$1 = null, i = null)=>{
            var I;
            let r = n[t];
            if (!r || (0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(r)) return null;
            let c = (I = i == null ? void 0 : i[t]) != null ? I : l == null ? void 0 : l[t];
            if (c === null) return null;
            let f = (0, $3f15c71ad5587fe0$export$407448d2b89b1813)(c), o = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === !0, u = A == null ? void 0 : A[t], b$1 = [];
            if (typeof f == "object" && o) for (let [T, J] of Object.entries(f)){
                let te = r[J];
                if (T === "initial") {
                    u = J;
                    continue;
                }
                Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(T) || (b$1 = K(T, te, b$1, a$1));
            }
            let S = r[f] || r[(0, $3f15c71ad5587fe0$export$407448d2b89b1813)(u)];
            return typeof b$1 == "object" && typeof a$1 == "string" && b$1[a$1] ? $badabf1879a9e1a9$var$Y(b$1, S) : b$1.length > 0 ? (b$1.push(S), b$1) : S;
        }, x = ()=>g$1 ? Object.keys(g$1).map((t)=>W(t, g$1)) : null, P = (t, n)=>{
            if (!g$1 || typeof g$1 != "object") return null;
            let a = new Array;
            for(let i in g$1){
                let r = W(i, g$1, t, n), c = t === "base" && typeof r == "string" ? r : r && r[t];
                c && (a[a.length] = c);
            }
            return a;
        }, z = {};
        for(let t in l)l[t] !== void 0 && (z[t] = l[t]);
        let D = (t, n)=>{
            var i;
            let a = typeof (l == null ? void 0 : l[t]) == "object" ? {
                [t]: (i = l[t]) == null ? void 0 : i.initial
            } : {};
            return {
                ...A,
                ...z,
                ...a,
                ...n
            };
        }, G = (t = [], n)=>{
            let a = [];
            for (let { class: i, className: r, ...c } of t){
                let f = !0;
                for (let [o, u] of Object.entries(c)){
                    let b = D(o, n);
                    if (Array.isArray(u)) {
                        if (!u.includes(b[o])) {
                            f = !1;
                            break;
                        }
                    } else if (b[o] !== u) {
                        f = !1;
                        break;
                    }
                }
                f && (i && a.push(i), r && a.push(r));
            }
            return a;
        }, H = (t)=>{
            let n = G(C, t), a = G(e == null ? void 0 : e.compoundVariants, t);
            return (0, $3f15c71ad5587fe0$export$2d1720544b23b823)(a, n);
        }, p = (t)=>{
            let n = H(t);
            if (!Array.isArray(n)) return n;
            let a = {};
            for (let i of n)if (typeof i == "string" && (a.base = $badabf1879a9e1a9$export$1343a74baacb0543(a.base, i)(m)), typeof i == "object") for (let [r, c] of Object.entries(i))a[r] = $badabf1879a9e1a9$export$1343a74baacb0543(a[r], c)(m);
            return a;
        }, ee = (t)=>{
            if (V.length < 1) return null;
            let n = {};
            for (let { slots: a = [], class: i, className: r, ...c } of V){
                if (!(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(c)) {
                    let f = !0;
                    for (let o of Object.keys(c)){
                        let u = D(o, t)[o];
                        if (u === void 0 || (Array.isArray(c[o]) ? !c[o].includes(u) : c[o] !== u)) {
                            f = !1;
                            break;
                        }
                    }
                    if (!f) continue;
                }
                for (let f of a)n[f] = n[f] || [], n[f].push([
                    i,
                    r
                ]);
            }
            return n;
        };
        if (!(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(N) || !(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(e == null ? void 0 : e.slots)) {
            let t = {};
            if (typeof h$1 == "object" && !(0, $3f15c71ad5587fe0$export$8b22cf2602fb60ce)(h$1)) for (let n of Object.keys(h$1))t[n] = (a)=>{
                var i, r;
                return $badabf1879a9e1a9$export$1343a74baacb0543(h$1[n], P(n, a), ((i = p(a)) != null ? i : [])[n], ((r = ee(a)) != null ? r : [])[n], a == null ? void 0 : a.class, a == null ? void 0 : a.className)(m);
            };
            return t;
        }
        return $badabf1879a9e1a9$export$1343a74baacb0543(M, x(), H(), l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
    }, _ = ()=>{
        if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
    };
    return v.variantKeys = _(), v.extend = e, v.base = M, v.slots = h$1, v.variants = g$1, v.defaultVariants = A, v.compoundSlots = V, v.compoundVariants = C, v;
}, $badabf1879a9e1a9$export$cc73e0e70ed8b709 = (s)=>(d, e)=>$badabf1879a9e1a9$export$984d890fc49ac622(d, e ? (0, $3f15c71ad5587fe0$export$39b482c5e57630a8)(s, e) : s);


var $17f34cb256e35c11$var$COMMON_UNITS = [
    "small",
    "medium",
    "large"
];
var $17f34cb256e35c11$export$984d890fc49ac622 = (options, config)=>{
    var _a, _b, _c;
    return (0, $badabf1879a9e1a9$export$984d890fc49ac622)(options, {
        ...config,
        twMerge: (_a = config == null ? void 0 : config.twMerge) != null ? _a : true,
        twMergeConfig: {
            ...config == null ? void 0 : config.twMergeConfig,
            theme: {
                ...(_b = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _b.theme,
                opacity: [
                    "disabled"
                ],
                spacing: [
                    "divider",
                    "unit",
                    ...(0, $4821bfc64ede9c08$export$e04743fb5fc64cba)
                ],
                borderWidth: $17f34cb256e35c11$var$COMMON_UNITS,
                borderRadius: $17f34cb256e35c11$var$COMMON_UNITS
            },
            classGroups: {
                ...(_c = config == null ? void 0 : config.twMergeConfig) == null ? void 0 : _c.classGroups,
                shadow: [
                    {
                        shadow: $17f34cb256e35c11$var$COMMON_UNITS
                    }
                ],
                "font-size": [
                    {
                        text: [
                            "tiny",
                            ...$17f34cb256e35c11$var$COMMON_UNITS
                        ]
                    }
                ],
                "bg-image": [
                    "bg-stripe-gradient"
                ],
                "min-w": [
                    {
                        "min-w": [
                            "unit",
                            ...(0, $4821bfc64ede9c08$export$e04743fb5fc64cba)
                        ]
                    }
                ],
                "min-h": [
                    {
                        "min-h": [
                            "unit",
                            ...(0, $4821bfc64ede9c08$export$e04743fb5fc64cba)
                        ]
                    }
                ]
            }
        }
    });
};


// src/utils/classes.ts
var $9946c85750e1f084$export$6a08aa478781aaec = (prefix)=>({
        color: `hsl(var(--${prefix}-foreground))`,
        backgroundColor: `hsl(var(--${prefix}-background))`
    });
var $9946c85750e1f084$export$ca6a30fd41be6708 = [
    "focus-visible:z-10",
    "focus-visible:outline-2",
    "focus-visible:outline-focus",
    "focus-visible:outline-offset-2"
];
var $9946c85750e1f084$export$13376dc9c57a19ba = [
    "outline-none",
    "data-[focus-visible=true]:z-10",
    "data-[focus-visible=true]:outline-2",
    "data-[focus-visible=true]:outline-focus",
    "data-[focus-visible=true]:outline-offset-2"
];
var $9946c85750e1f084$export$23b17e6367ab693 = [
    "outline-none",
    "group-data-[focus-visible=true]:z-10",
    "group-data-[focus-visible=true]:ring-2",
    "group-data-[focus-visible=true]:ring-focus",
    "group-data-[focus-visible=true]:ring-offset-2",
    "group-data-[focus-visible=true]:ring-offset-background"
];
var $9946c85750e1f084$export$e0ed6e3275f8955 = [
    "outline-none",
    "ring-2",
    "ring-focus",
    "ring-offset-2",
    "ring-offset-background"
];
var $9946c85750e1f084$export$99bb92cbe55f4b50 = [
    "absolute",
    "top-1/2",
    "left-1/2",
    "-translate-x-1/2",
    "-translate-y-1/2"
];
var $9946c85750e1f084$export$88a9566cd73b4303 = [
    "absolute",
    "inset-0"
];
var $9946c85750e1f084$export$be7ffb88629cefac = {
    default: [
        "[&+.border-medium.border-default]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    primary: [
        "[&+.border-medium.border-primary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    secondary: [
        "[&+.border-medium.border-secondary]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    success: [
        "[&+.border-medium.border-success]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    warning: [
        "[&+.border-medium.border-warning]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ],
    danger: [
        "[&+.border-medium.border-danger]:ms-[calc(theme(borderWidth.medium)*-1)]"
    ]
};


// src/components/card.ts
var $318a941d4267a4c8$export$aa3e815946b80764 = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "flex-col",
            "relative",
            "overflow-hidden",
            "height-auto",
            "outline-none",
            "text-foreground",
            "box-border",
            "bg-content1",
            ...(0, $9946c85750e1f084$export$13376dc9c57a19ba)
        ],
        header: [
            "flex",
            "p-3",
            "z-10",
            "w-full",
            "justify-start",
            "items-center",
            "shrink-0",
            "overflow-inherit",
            "color-inherit",
            "subpixel-antialiased"
        ],
        body: [
            "relative",
            "flex",
            "flex-1",
            "w-full",
            "p-3",
            "flex-auto",
            "flex-col",
            "place-content-inherit",
            "align-items-inherit",
            "h-auto",
            "break-words",
            "text-left",
            "overflow-y-auto",
            "subpixel-antialiased"
        ],
        footer: [
            "p-3",
            "h-auto",
            "flex",
            "w-full",
            "items-center",
            "overflow-hidden",
            "color-inherit",
            "subpixel-antialiased"
        ]
    },
    variants: {
        shadow: {
            none: {
                base: "shadow-none"
            },
            sm: {
                base: "shadow-small"
            },
            md: {
                base: "shadow-medium"
            },
            lg: {
                base: "shadow-large"
            }
        },
        radius: {
            none: {
                base: "rounded-none",
                header: "rounded-none",
                footer: "rounded-none"
            },
            sm: {
                base: "rounded-small",
                header: "rounded-t-small",
                footer: "rounded-b-small"
            },
            md: {
                base: "rounded-medium",
                header: "rounded-t-medium",
                footer: "rounded-b-medium"
            },
            lg: {
                base: "rounded-large",
                header: "rounded-t-large",
                footer: "rounded-b-large"
            }
        },
        fullWidth: {
            true: {
                base: "w-full"
            }
        },
        isHoverable: {
            true: {
                base: "data-[hover=true]:bg-content2 dark:data-[hover=true]:bg-content2"
            }
        },
        isPressable: {
            true: {
                base: "cursor-pointer"
            }
        },
        isBlurred: {
            true: {
                base: [
                    "bg-background/80",
                    "dark:bg-background/20",
                    "backdrop-blur-md",
                    "backdrop-saturate-150"
                ]
            }
        },
        isFooterBlurred: {
            true: {
                footer: [
                    "bg-background/10",
                    "backdrop-blur",
                    "backdrop-saturate-150"
                ]
            }
        },
        isDisabled: {
            true: {
                base: "opacity-disabled cursor-not-allowed"
            }
        },
        disableAnimation: {
            true: "",
            false: {
                base: "transition-transform-background motion-reduce:transition-none"
            }
        }
    },
    compoundVariants: [
        {
            isPressable: true,
            disableAnimation: false,
            class: "data-[pressed=true]:scale-[0.97] tap-highlight-transparent"
        }
    ],
    defaultVariants: {
        radius: "lg",
        shadow: "md",
        fullWidth: false,
        isHoverable: false,
        isPressable: false,
        isDisabled: false,
        disableAnimation: false,
        isFooterBlurred: false
    }
});



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ef9e0b5e070789ea$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $7fPBF.useState)(value || defaultValue);
    let isControlledRef = (0, $7fPBF.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $7fPBF.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $7fPBF.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $ef9e0b5e070789ea$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $ef9e0b5e070789ea$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    let string = step.toString();
    let index = string.indexOf(".");
    let precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $ef9e0b5e070789ea$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $ed57708adbbc95d6$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $ed57708adbbc95d6$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($ed57708adbbc95d6$var$$b5e257d569688ac6$var$defaultContext);
const $ed57708adbbc95d6$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(false);
// This is only used in React < 18.
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $7fPBF.useContext)($ed57708adbbc95d6$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useCounter(cur === $ed57708adbbc95d6$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $7fPBF.useState)(true);
    let value = (0, $7fPBF.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $ed57708adbbc95d6$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $7fPBF.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ed57708adbbc95d6$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ed57708adbbc95d6$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $ed57708adbbc95d6$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $ed57708adbbc95d6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))["useId"] === "function") {
        if (!$ed57708adbbc95d6$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $ed57708adbbc95d6$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ed57708adbbc95d6$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $ed57708adbbc95d6$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $ed57708adbbc95d6$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $7fPBF.useContext)($ed57708adbbc95d6$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $7fPBF.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $ed57708adbbc95d6$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $ed57708adbbc95d6$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $ed57708adbbc95d6$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $7fPBF.useContext)($ed57708adbbc95d6$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $ed57708adbbc95d6$var$$b5e257d569688ac6$var$defaultContext && !$ed57708adbbc95d6$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId();
    let [didSSR] = (0, $7fPBF.useState)($ed57708adbbc95d6$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$ed57708adbbc95d6$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $ed57708adbbc95d6$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))["useId"] === "function" ? $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useModernSSRSafeId : $ed57708adbbc95d6$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $ed57708adbbc95d6$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $ed57708adbbc95d6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))["useSyncExternalStore"]($ed57708adbbc95d6$var$$b5e257d569688ac6$var$subscribe, $ed57708adbbc95d6$var$$b5e257d569688ac6$var$getSnapshot, $ed57708adbbc95d6$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $7fPBF.useContext)($ed57708adbbc95d6$var$$b5e257d569688ac6$var$IsSSRContext);
}


function $e2e9f7015a5aa268$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $e2e9f7015a5aa268$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $e2e9f7015a5aa268$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $e2e9f7015a5aa268$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e2e9f7015a5aa268$export$2e2bcd8739ae039 = $e2e9f7015a5aa268$export$4f5d2d50c9deca37;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a26d4c995bb2a467$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect : ()=>{};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$7f54fc3180508a52(fn) {
    const ref = (0, $7fPBF.useRef)(null);
    $a26d4c995bb2a467$export$e5c5a5f917a5871c(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $7fPBF.useCallback)((...args)=>{
        const f = ref.current;
        return f(...args);
    }, []);
}
function $a26d4c995bb2a467$export$14d238f342723f25(defaultValue) {
    let [value1, setValue] = (0, $7fPBF.useState)(defaultValue);
    let effect = (0, $7fPBF.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = $a26d4c995bb2a467$export$7f54fc3180508a52(()=>{
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value1 === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    $a26d4c995bb2a467$export$e5c5a5f917a5871c(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = $a26d4c995bb2a467$export$7f54fc3180508a52((fn)=>{
        effect.current = fn(value1);
        nextRef();
    });
    return [
        value1,
        queue
    ];
}
// copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $a26d4c995bb2a467$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $a26d4c995bb2a467$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $a26d4c995bb2a467$export$f680877a34711e37(defaultId) {
    let [value1, setValue] = (0, $7fPBF.useState)(defaultId);
    let nextId = (0, $7fPBF.useRef)(null);
    let res = (0, $ed57708adbbc95d6$export$619500959fc48b26)(value1);
    let updateValue = (0, $7fPBF.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($a26d4c995bb2a467$var$$bdb11010cef70236$var$canUseDOM) $a26d4c995bb2a467$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    $a26d4c995bb2a467$export$e5c5a5f917a5871c(()=>{
        let r = res;
        return ()=>{
            $a26d4c995bb2a467$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $7fPBF.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $a26d4c995bb2a467$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdA = $a26d4c995bb2a467$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    let setIdB = $a26d4c995bb2a467$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $a26d4c995bb2a467$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $a26d4c995bb2a467$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = $a26d4c995bb2a467$export$14d238f342723f25(id);
    let updateId = (0, $7fPBF.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    $a26d4c995bb2a467$export$e5c5a5f917a5871c(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $a26d4c995bb2a467$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === "function") callback(...args);
    };
}
const $a26d4c995bb2a467$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $a26d4c995bb2a467$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $a26d4c995bb2a467$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = $a26d4c995bb2a467$export$e08e3b67e392101e(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)(a, b);
            else if (key === "id" && a && b) result.id = $a26d4c995bb2a467$export$cd8c9cb68f842629(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$c9058316764c140e(...refs) {
    if (refs.length === 1) return refs[0];
    return (value1)=>{
        for (let ref of refs){
            if (typeof ref === "function") ref(value1);
            else if (ref != null) ref.current = value1;
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
const $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
const $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
const $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $a26d4c995bb2a467$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $a26d4c995bb2a467$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$de79e2c695e052f3(element) {
    if ($a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $a26d4c995bb2a467$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $a26d4c995bb2a467$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $a26d4c995bb2a467$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $a26d4c995bb2a467$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $a26d4c995bb2a467$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$622cea445a1c5b7d(element, reverse, orientation = "horizontal") {
    let rect = element.getBoundingClientRect();
    if (reverse) return orientation === "horizontal" ? rect.right : rect.bottom;
    return orientation === "horizontal" ? rect.left : rect.top;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $a26d4c995bb2a467$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $a26d4c995bb2a467$export$9ac100e40613ea10() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $a26d4c995bb2a467$export$186c6964ca17d99() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $a26d4c995bb2a467$export$7bef049ce92e4224() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $a26d4c995bb2a467$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $a26d4c995bb2a467$export$fedb369cb70207f1() {
    return $a26d4c995bb2a467$export$186c6964ca17d99() || $a26d4c995bb2a467$export$7bef049ce92e4224();
}
function $a26d4c995bb2a467$export$e1865c3bedcd822b() {
    return $a26d4c995bb2a467$export$9ac100e40613ea10() || $a26d4c995bb2a467$export$fedb369cb70207f1();
}
function $a26d4c995bb2a467$export$78551043582a6a98() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$a26d4c995bb2a467$export$6446a186d09e379e();
}
function $a26d4c995bb2a467$export$6446a186d09e379e() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $a26d4c995bb2a467$export$a11b0059900ceec8() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $a26d4c995bb2a467$var$$c87311424ea30a05$export$b7d78993b74f766d() {
    return $a26d4c995bb2a467$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
}
const $a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $7fPBF.createContext)({
    isNative: true,
    open: $a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$openSyntheticLink
});
function $a26d4c995bb2a467$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate } = props;
    let ctx = (0, $7fPBF.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers)=>{
                $a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($a26d4c995bb2a467$export$efa8c9099e530235(link, modifiers)) navigate(link.pathname + link.search + link.hash);
                    else $a26d4c995bb2a467$export$95185d699e05d4d7(link, modifiers);
                });
            }
        }), [
        navigate
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $a26d4c995bb2a467$export$9a302a45f65d0572() {
    return (0, $7fPBF.useContext)($a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $a26d4c995bb2a467$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $a26d4c995bb2a467$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ($a26d4c995bb2a467$var$$c87311424ea30a05$export$b7d78993b74f766d() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ($a26d4c995bb2a467$export$9ac100e40613ea10()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = $a26d4c995bb2a467$export$78551043582a6a98() && $a26d4c995bb2a467$export$9ac100e40613ea10() && !$a26d4c995bb2a467$export$7bef049ce92e4224() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $a26d4c995bb2a467$export$95185d699e05d4d7.isOpening = setOpening;
    $a26d4c995bb2a467$export$de79e2c695e052f3(target);
    target.dispatchEvent(event);
    $a26d4c995bb2a467$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$a26d4c995bb2a467$export$95185d699e05d4d7.isOpening = false;
function $a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        let link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $a26d4c995bb2a467$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$a26d4c995bb2a467$export$95185d699e05d4d7(link, modifiers));
}
function $a26d4c995bb2a467$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    let onTransitionStart = (e)=>{
        // Add the transitioning property to the list for this element.
        let transitions = $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd);
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        // Remove property from list of transitioning properties.
        let properties = $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $a26d4c995bb2a467$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $a26d4c995bb2a467$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ // Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.
const $a26d4c995bb2a467$var$$9cc09df9fd7676be$var$draggingElements = [];
function $a26d4c995bb2a467$export$7bbed75feba39706(props) {
    console.warn("useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html");
    let { containerRef: containerRef, reverse: reverse, orientation: orientation, onHover: onHover, onDrag: onDrag, onPositionChange: onPositionChange, onIncrement: onIncrement, onDecrement: onDecrement, onIncrementToMax: onIncrementToMax, onDecrementToMin: onDecrementToMin, onCollapseToggle: onCollapseToggle } = props;
    let getPosition = (e)=>orientation === "horizontal" ? e.clientX : e.clientY;
    let getNextOffset = (e)=>{
        let containerOffset = $a26d4c995bb2a467$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
        let mouseOffset = getPosition(e);
        let nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
        return nextOffset;
    };
    let dragging = (0, $7fPBF.useRef)(false);
    let prevPosition = (0, $7fPBF.useRef)(0);
    // Keep track of the current handlers in a ref so that the events can access them.
    let handlers = (0, $7fPBF.useRef)({
        onPositionChange: onPositionChange,
        onDrag: onDrag
    });
    handlers.current.onDrag = onDrag;
    handlers.current.onPositionChange = onPositionChange;
    let onMouseDragged = (e)=>{
        e.preventDefault();
        let nextOffset = getNextOffset(e);
        if (!dragging.current) {
            dragging.current = true;
            if (handlers.current.onDrag) handlers.current.onDrag(true);
            if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        }
        if (prevPosition.current === nextOffset) return;
        prevPosition.current = nextOffset;
        if (onPositionChange) onPositionChange(nextOffset);
    };
    let onMouseUp = (e)=>{
        const target = e.target;
        dragging.current = false;
        let nextOffset = getNextOffset(e);
        if (handlers.current.onDrag) handlers.current.onDrag(false);
        if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        $a26d4c995bb2a467$var$$9cc09df9fd7676be$var$draggingElements.splice($a26d4c995bb2a467$var$$9cc09df9fd7676be$var$draggingElements.indexOf(target), 1);
        window.removeEventListener("mouseup", onMouseUp, false);
        window.removeEventListener("mousemove", onMouseDragged, false);
    };
    let onMouseDown = (e)=>{
        const target = e.currentTarget;
        // If we're already handling dragging on a descendant with useDrag1D, then
        // we don't want to handle the drag motion on this target as well.
        if ($a26d4c995bb2a467$var$$9cc09df9fd7676be$var$draggingElements.some((elt)=>target.contains(elt))) return;
        $a26d4c995bb2a467$var$$9cc09df9fd7676be$var$draggingElements.push(target);
        window.addEventListener("mousemove", onMouseDragged, false);
        window.addEventListener("mouseup", onMouseUp, false);
    };
    let onMouseEnter = ()=>{
        if (onHover) onHover(true);
    };
    let onMouseOut = ()=>{
        if (onHover) onHover(false);
    };
    let onKeyDown = (e)=>{
        switch(e.key){
            case "Left":
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Up":
            case "ArrowUp":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Right":
            case "ArrowRight":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Down":
            case "ArrowDown":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Home":
                e.preventDefault();
                if (onDecrementToMin) onDecrementToMin();
                break;
            case "End":
                e.preventDefault();
                if (onIncrementToMax) onIncrementToMax();
                break;
            case "Enter":
                e.preventDefault();
                if (onCollapseToggle) onCollapseToggle();
                break;
        }
    };
    return {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onKeyDown: onKeyDown
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $7fPBF.useRef)(new Map());
    let addGlobalListener = (0, $7fPBF.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $7fPBF.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $7fPBF.useCallback)(()=>{
        globalListeners.current.forEach((value1, key)=>{
            removeGlobalListener(value1.eventTarget, value1.type, key, value1.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, "aria-label": label, "aria-labelledby": labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = $a26d4c995bb2a467$export$f680877a34711e37(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $7fPBF.useRef)();
    return (0, $7fPBF.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = (0, $7fPBF.useRef)(true);
    const lastDeps = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}
function $a26d4c995bb2a467$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $a26d4c995bb2a467$export$683480f191c0e3ea(options) {
    const { ref: ref, onResize: onResize } = options;
    (0, $7fPBF.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$a26d4c995bb2a467$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return ()=>{
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$4debdb1a3f0fa79e(context, ref) {
    $a26d4c995bb2a467$export$e5c5a5f917a5871c(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                context.ref.current = null;
            };
        }
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$cfa2225e87938781(node) {
    if ($a26d4c995bb2a467$export$2bb74740c4e19def(node)) node = node.parentElement;
    while(node && !$a26d4c995bb2a467$export$2bb74740c4e19def(node))node = node.parentElement;
    return node || document.scrollingElement || document.documentElement;
}
function $a26d4c995bb2a467$export$2bb74740c4e19def(node) {
    let style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
let $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $a26d4c995bb2a467$export$d699905dd57c73ca() {
    let isSSR = (0, $ed57708adbbc95d6$export$535bd6ca7f90a273)();
    let [size, setSize] = (0, $7fPBF.useState)(()=>isSSR ? {
            width: 0,
            height: 0
        } : $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$getViewportSize());
    (0, $7fPBF.useEffect)(()=>{
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        let onResize = ()=>{
            setSize((size)=>{
                let newSize = $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport) window.addEventListener("resize", onResize);
        else $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport.addEventListener("resize", onResize);
        return ()=>{
            if (!$a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport) window.removeEventListener("resize", onResize);
            else $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, []);
    return size;
}
function $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: ($a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport === null || $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: ($a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport === null || $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $a26d4c995bb2a467$var$$5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $a26d4c995bb2a467$var$$ef06256079686ba0$var$descriptionId = 0;
const $a26d4c995bb2a467$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $a26d4c995bb2a467$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $7fPBF.useState)(undefined);
    $a26d4c995bb2a467$export$e5c5a5f917a5871c(()=>{
        if (!description) return;
        let desc = $a26d4c995bb2a467$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$a26d4c995bb2a467$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $a26d4c995bb2a467$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (--desc.refCount === 0) {
                desc.element.remove();
                $a26d4c995bb2a467$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = $a26d4c995bb2a467$export$7f54fc3180508a52(handler);
    let isDisabled = handler == null;
    (0, $7fPBF.useEffect)(()=>{
        if (isDisabled) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $a26d4c995bb2a467$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    let offsetY = $a26d4c995bb2a467$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $a26d4c995bb2a467$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === "left" ? "offsetLeft" : "offsetTop";
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $a26d4c995bb2a467$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            let scrollParent = $a26d4c995bb2a467$export$cfa2225e87938781(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            while(targetElement && scrollParent && targetElement !== root && scrollParent !== root){
                $a26d4c995bb2a467$export$53a0910f038337bd(scrollParent, targetElement);
                targetElement = scrollParent;
                scrollParent = $a26d4c995bb2a467$export$cfa2225e87938781(targetElement);
            }
        }
    }
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ($a26d4c995bb2a467$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $a26d4c995bb2a467$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !$a26d4c995bb2a467$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $a26d4c995bb2a467$export$722debc0e56fea39(value1, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, $7fPBF.useRef)(null);
    if (value1 && lastValue.current && isEqual(value1, lastValue.current)) value1 = lastValue.current;
    lastValue.current = value1;
    return value1;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a26d4c995bb2a467$export$5add1d006293d136(ref, initialValue, onReset) {
    let resetValue = (0, $7fPBF.useRef)(initialValue);
    let handleReset = $a26d4c995bb2a467$export$7f54fc3180508a52(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, $7fPBF.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
function $3e8576eccd4c7288$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $d86b59e89b8a0208$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $54af65440e83a537$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $d86b59e89b8a0208$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $3e8576eccd4c7288$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $4dddf84ac518a0ab$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $0a7837cd8c38b609$export$e235798705076415(obj, privateMap, value) {
    (0, $4dddf84ac518a0ab$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $0b3c0e0699c28bdc$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $2906a6c695077413$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $d86b59e89b8a0208$export$20c20a422940e173)(receiver, privateMap, "set");
    (0, $0b3c0e0699c28bdc$export$b7b24cdba6bcb11c)(receiver, descriptor, value);
    return value;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $9102a566b416415c$var$$14c0b72509d70225$var$state = "default";
let $9102a566b416415c$var$$14c0b72509d70225$var$savedUserSelect = "";
let $9102a566b416415c$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $9102a566b416415c$var$$14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, $a26d4c995bb2a467$export$fedb369cb70207f1)()) {
        if ($9102a566b416415c$var$$14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            const documentObject = (0, $a26d4c995bb2a467$export$b204af158042fbac)(target);
            $9102a566b416415c$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $9102a566b416415c$var$$14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $9102a566b416415c$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $9102a566b416415c$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, $a26d4c995bb2a467$export$fedb369cb70207f1)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($9102a566b416415c$var$$14c0b72509d70225$var$state !== "disabled") return;
        $9102a566b416415c$var$$14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $a26d4c995bb2a467$export$24490316f764c430)(()=>{
                // Avoid race conditions
                if ($9102a566b416415c$var$$14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    const documentObject = (0, $a26d4c995bb2a467$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $9102a566b416415c$var$$14c0b72509d70225$var$savedUserSelect || "";
                    $9102a566b416415c$var$$14c0b72509d70225$var$savedUserSelect = "";
                    $9102a566b416415c$var$$14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $9102a566b416415c$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $9102a566b416415c$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none" && targetOldUserSelect) target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $9102a566b416415c$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9102a566b416415c$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    register: ()=>{}
});
$9102a566b416415c$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $9102a566b416415c$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $7fPBF.useContext)($9102a566b416415c$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $a26d4c995bb2a467$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $9102a566b416415c$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $9102a566b416415c$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $2906a6c695077413$export$268446c9779b3a21)(this, $9102a566b416415c$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $54af65440e83a537$export$5a67b255b80ee4f2)(this, $9102a566b416415c$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $0a7837cd8c38b609$export$e235798705076415)(this, $9102a566b416415c$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $2906a6c695077413$export$268446c9779b3a21)(this, $9102a566b416415c$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
}
const $9102a566b416415c$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $9102a566b416415c$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $9102a566b416415c$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $7fPBF.useState)(false);
    let ref = (0, $7fPBF.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $a26d4c995bb2a467$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $9102a566b416415c$var$$f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $9102a566b416415c$var$$f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $9102a566b416415c$var$$f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $9102a566b416415c$var$$f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) $9102a566b416415c$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
    });
    let cancelOnPointerExit = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $7fPBF.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($9102a566b416415c$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred.
                        addGlobalListener((0, $a26d4c995bb2a467$export$b204af158042fbac)(e.currentTarget), "keyup", onKeyUp, false);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $a26d4c995bb2a467$export$9ac100e40613ea10)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onKeyUp (e) {
                if ($9102a566b416415c$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && !e.repeat && e.currentTarget.contains(e.target) && state.target) triggerPressUp($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $a26d4c995bb2a467$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $a26d4c995bb2a467$export$60278871457622de)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $9102a566b416415c$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                let shouldStopPropagation = triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                if (shouldStopPropagation) e.stopPropagation();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $9102a566b416415c$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$9102a566b416415c$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$9102a566b416415c$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $a26d4c995bb2a467$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $a26d4c995bb2a467$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $9102a566b416415c$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $a26d4c995bb2a467$export$b204af158042fbac)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $a26d4c995bb2a467$export$b204af158042fbac)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $a26d4c995bb2a467$export$b204af158042fbac)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $9102a566b416415c$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $a26d4c995bb2a467$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $a26d4c995bb2a467$export$b204af158042fbac)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $9102a566b416415c$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) $9102a566b416415c$var$$14c0b72509d70225$export$16a4697467175487(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $a26d4c995bb2a467$export$f21a1ffae260145a)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $9102a566b416415c$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $9102a566b416415c$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) $9102a566b416415c$var$$14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) $9102a566b416415c$var$$14c0b72509d70225$export$b0d6fa1ab32e3295((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $a26d4c995bb2a467$export$f21a1ffae260145a)(element).HTMLInputElement && !$9102a566b416415c$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $a26d4c995bb2a467$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $9102a566b416415c$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $9102a566b416415c$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $9102a566b416415c$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $9102a566b416415c$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$9102a566b416415c$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($9102a566b416415c$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
const $9102a566b416415c$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $9102a566b416415c$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $9102a566b416415c$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
const $9102a566b416415c$export$27c701ed9e449e99 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(({ children: children, ...props }, ref)=>{
    ref = (0, $a26d4c995bb2a467$export$4338b53315abf666)(ref);
    let { pressProps: pressProps } = $9102a566b416415c$export$45712eceda6fad21({
        ...props,
        ref: ref
    });
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(child, {
        ref: ref,
        ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(child.props, pressProps)
    });
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9102a566b416415c$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $7fPBF.useRef)(false);
    let prevContext = (0, $7fPBF.useContext)($9102a566b416415c$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    ref = (0, $a26d4c995bb2a467$export$4338b53315abf666)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $a26d4c995bb2a467$export$4debdb1a3f0fa79e)(prevContext, ref);
    (0, $7fPBF.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($9102a566b416415c$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
function $9102a566b416415c$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $7fPBF.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($9102a566b416415c$var$$ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $9102a566b416415c$var$$8a9cb279dc87e130$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $9102a566b416415c$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $7fPBF.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $7fPBF.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $9102a566b416415c$var$$8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
function $9102a566b416415c$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $7fPBF.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = $9102a566b416415c$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    const onFocus = (0, $7fPBF.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (e.target === e.currentTarget && document.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality = null;
let $9102a566b416415c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $9102a566b416415c$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $9102a566b416415c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $9102a566b416415c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $9102a566b416415c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $9102a566b416415c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $9102a566b416415c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $a26d4c995bb2a467$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $9102a566b416415c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($9102a566b416415c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $9102a566b416415c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9102a566b416415c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $9102a566b416415c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $a26d4c995bb2a467$export$60278871457622de)(e)) {
        $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $9102a566b416415c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$9102a566b416415c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $9102a566b416415c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9102a566b416415c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $9102a566b416415c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $9102a566b416415c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $9102a566b416415c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents() {
    if (typeof window === "undefined" || $9102a566b416415c$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners) return;
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function() {
        $9102a566b416415c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    document.addEventListener("keydown", $9102a566b416415c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("keyup", $9102a566b416415c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    document.addEventListener("click", $9102a566b416415c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    window.addEventListener("focus", $9102a566b416415c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    window.addEventListener("blur", $9102a566b416415c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointermove", $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("pointerup", $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        document.addEventListener("mousedown", $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mousemove", $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        document.addEventListener("mouseup", $9102a566b416415c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $9102a566b416415c$var$$507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $9102a566b416415c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    else document.addEventListener("DOMContentLoaded", $9102a566b416415c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $9102a566b416415c$export$b9b3dfddab17db27() {
    return $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $9102a566b416415c$export$630ff653c5ada6a9() {
    return $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality;
}
function $9102a566b416415c$export$8397ddfc504fdb9a(modality) {
    $9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $9102a566b416415c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $9102a566b416415c$export$98e20ec92f614cfe() {
    $9102a566b416415c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $7fPBF.useState)($9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $7fPBF.useEffect)(()=>{
        let handler = ()=>{
            setModality($9102a566b416415c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $9102a566b416415c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9102a566b416415c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $ed57708adbbc95d6$export$535bd6ca7f90a273)() ? null : modality;
}
const $9102a566b416415c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $9102a566b416415c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof HTMLInputElement && !$9102a566b416415c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof HTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof HTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof KeyboardEvent && !$9102a566b416415c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $9102a566b416415c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $7fPBF.useState)(autoFocus || $9102a566b416415c$export$b9b3dfddab17db27());
    $9102a566b416415c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $9102a566b416415c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $9102a566b416415c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $7fPBF.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$9102a566b416415c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($9102a566b416415c$export$b9b3dfddab17db27());
        };
        $9102a566b416415c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $9102a566b416415c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $9102a566b416415c$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $7fPBF.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $7fPBF.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = $9102a566b416415c$var$$8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    let onFocus = (0, $7fPBF.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $9102a566b416415c$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $9102a566b416415c$var$$6179b936705e76d3$var$hoverCount = 0;
function $9102a566b416415c$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $9102a566b416415c$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $9102a566b416415c$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $9102a566b416415c$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $9102a566b416415c$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $9102a566b416415c$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $9102a566b416415c$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $9102a566b416415c$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $9102a566b416415c$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $9102a566b416415c$var$$6179b936705e76d3$var$hoverCount--;
        if ($9102a566b416415c$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $9102a566b416415c$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $9102a566b416415c$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $9102a566b416415c$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $7fPBF.useState)(false);
    let state = (0, $7fPBF.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $7fPBF.useEffect)($9102a566b416415c$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $7fPBF.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($9102a566b416415c$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$9102a566b416415c$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $9102a566b416415c$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $7fPBF.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside && $9102a566b416415c$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $7fPBF.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $a26d4c995bb2a467$export$b204af158042fbac)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $9102a566b416415c$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $9102a566b416415c$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $9102a566b416415c$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $9102a566b416415c$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9102a566b416415c$var$$93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $9102a566b416415c$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $9102a566b416415c$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $9102a566b416415c$var$$93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9102a566b416415c$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $7fPBF.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $a26d4c995bb2a467$export$4eaf04e54aa8eed6)();
    let move = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                type: "movestart",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 || onMove({
            type: "move",
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let end = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        $9102a566b416415c$var$$14c0b72509d70225$export$b0d6fa1ab32e3295();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
            type: "moveend",
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let moveProps = (0, $7fPBF.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            $9102a566b416415c$var$$14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === "undefined") {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "mouse", e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let { pageX: pageX, pageY: pageY } = e.changedTouches[touch];
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX, pageY: pageY, identifier: identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let pointerType = e.pointerType || "mouse";
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps: moveProps
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9102a566b416415c$export$2123ff2b87c81ca(props, ref) {
    let { onScroll: onScroll, isDisabled: isDisabled } = props;
    let onScrollHandler = (0, $7fPBF.useCallback)((e)=>{
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, $a26d4c995bb2a467$export$90fc3a17d93f704c)(ref, "wheel", isDisabled ? undefined : onScrollHandler);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9102a566b416415c$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $9102a566b416415c$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $9102a566b416415c$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $7fPBF.useRef)();
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $a26d4c995bb2a467$export$4eaf04e54aa8eed6)();
    let { pressProps: pressProps } = $9102a566b416415c$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: "longpressstart"
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: "longpress"
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd({
                ...e,
                type: "longpressend"
            });
        }
    });
    let descriptionProps = (0, $a26d4c995bb2a467$export$f8aeda7b10753fa1)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(pressProps, descriptionProps)
    };
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2cf1c82089cb095e$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    if ((0, $9102a566b416415c$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = document.activeElement;
        (0, $a26d4c995bb2a467$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (document.activeElement === lastFocusedElement && document.contains(element)) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(element);
        });
    } else (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2cf1c82089cb095e$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $2cf1c82089cb095e$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $2cf1c82089cb095e$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $2cf1c82089cb095e$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $2cf1c82089cb095e$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $2cf1c82089cb095e$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $2cf1c82089cb095e$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
let $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = null;
function $2cf1c82089cb095e$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $7fPBF.useRef)(null);
    let endRef = (0, $7fPBF.useRef)(null);
    let scopeRef = (0, $7fPBF.useRef)([]);
    let { parentNode: parentNode } = (0, $7fPBF.useContext)($2cf1c82089cb095e$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $7fPBF.useMemo)(()=>new $2cf1c82089cb095e$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.root;
        if ($2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope && !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isAncestorScope($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        let node = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $7fPBF.useEffect)(()=>{
        let activeElement = document.activeElement;
        let scope = null;
        if ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope || $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $7fPBF.useMemo)(()=>$2cf1c82089cb095e$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $7fPBF.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($2cf1c82089cb095e$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $2cf1c82089cb095e$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $7fPBF.useContext)($2cf1c82089cb095e$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || document.activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $2cf1c82089cb095e$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $2cf1c82089cb095e$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $7fPBF.useRef)();
    let raf = (0, $7fPBF.useRef)();
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = document.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope || $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isAncestorScope($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope.current) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusFirstInScope($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (document.activeElement && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInChildScope(document.activeElement, scopeRef)) {
                    $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (document.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope.current) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusFirstInScope($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        document.addEventListener("keydown", onKeyDown, false);
        document.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            document.removeEventListener("keydown", onKeyDown, false);
            document.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.traverse($2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $2cf1c82089cb095e$export$1258395f99bf9cbf(element) {
    return $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInChildScope(element, $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope);
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        $2cf1c82089cb095e$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(autoFocus);
    (0, $7fPBF.useEffect)(()=>{
        if (autoFocusRef.current) {
            $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            if (!$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        let onFocus = (e)=>{
            let target = e.target;
            if ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = null;
        };
        document.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            document.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    const nodeToRestoreRef = (0, $7fPBF.useRef)(typeof document !== "undefined" ? document.activeElement : null);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope || $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isAncestorScope($2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current)) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        document.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            document.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            let focusedElement = document.activeElement;
            if (!$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(document.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !document.body.contains(nodeToRestore) || nodeToRestore === document.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) document.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) document.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        if (!restoreFocus) return;
        let treeNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(document.activeElement, scopeRef.current) || document.activeElement === document.body && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (document.activeElement === document.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && document.body.contains(treeNode.nodeToRestore)) {
                                $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $2cf1c82089cb095e$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $2cf1c82089cb095e$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $2cf1c82089cb095e$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $2cf1c82089cb095e$var$$645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $2cf1c82089cb095e$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || document.activeElement;
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || document.activeElement;
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$last(walker);
                if (next) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $2cf1c82089cb095e$var$$9bf71ea28793e738$var$last(walker);
            if (next) $2cf1c82089cb095e$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $2cf1c82089cb095e$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $2cf1c82089cb095e$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $2cf1c82089cb095e$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $2cf1c82089cb095e$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $2cf1c82089cb095e$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $2cf1c82089cb095e$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $2cf1c82089cb095e$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $2cf1c82089cb095e$var$$9bf71ea28793e738$export$d06fae2ee68b101e = new $2cf1c82089cb095e$var$$9bf71ea28793e738$var$Tree();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2cf1c82089cb095e$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $7fPBF.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $9102a566b416415c$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $7fPBF.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $7fPBF.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $7fPBF.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $7fPBF.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $9102a566b416415c$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $9102a566b416415c$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $9102a566b416415c$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $2cf1c82089cb095e$export$1a38b4ad7f578e1d(props) {
    let { children: children, focusClass: focusClass, focusRingClass: focusRingClass } = props;
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = $2cf1c82089cb095e$export$4e328f61c538687f(props);
    let child = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(child, (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(child.props, {
        ...focusProps,
        className: (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039)({
            [focusClass || ""]: isFocused,
            [focusRingClass || ""]: isFocusVisible
        })
    }));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
function $2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $7fPBF.useContext)($2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $a26d4c995bb2a467$export$4debdb1a3f0fa79e)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $a26d4c995bb2a467$export$4338b53315abf666)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $2cf1c82089cb095e$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef($2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $2cf1c82089cb095e$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $9102a566b416415c$export$f8168d8dd8fd66e6)(props);
    let { keyboardProps: keyboardProps } = (0, $9102a566b416415c$export$8f71654801c2f7cd)(props);
    let interactions = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(focusProps, keyboardProps);
    let domProps = $2cf1c82089cb095e$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $7fPBF.useRef)(props.autoFocus);
    (0, $7fPBF.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) $2cf1c82089cb095e$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2cf1c82089cb095e$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $7fPBF.useState)(false);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = $2cf1c82089cb095e$export$2d6ec8fc375ceafa(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}



// src/index.ts


// src/context.ts

var $7fPBF = parcelRequire("7fPBF");
var $d0053959974f77e8$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
$d0053959974f77e8$export$5165eccb35aaadb5.displayName = "PressResponderContext";


var $c20e82bf339a28f8$var$__defProp = Object.defineProperty;
var $c20e82bf339a28f8$var$__defNormalProp = (obj, key, value)=>key in obj ? $c20e82bf339a28f8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c20e82bf339a28f8$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $c20e82bf339a28f8$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $c20e82bf339a28f8$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $c20e82bf339a28f8$export$18a094aefa070634 = (obj, member, getter)=>{
    $c20e82bf339a28f8$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $c20e82bf339a28f8$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $c20e82bf339a28f8$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $c20e82bf339a28f8$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};


// src/events.ts
var $e247d84fdb7f6ded$var$_shouldStopPropagation;
var $e247d84fdb7f6ded$export$c67d0d444dae0df7 = class {
    continuePropagation() {
        (0, $c20e82bf339a28f8$export$42432efe6614d3b4)(this, $e247d84fdb7f6ded$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $c20e82bf339a28f8$export$18a094aefa070634)(this, $e247d84fdb7f6ded$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent){
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "type");
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "pointerType");
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "target");
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "shiftKey");
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "ctrlKey");
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "metaKey");
        (0, $c20e82bf339a28f8$export$5cb848ba4d1f099)(this, "altKey");
        (0, $c20e82bf339a28f8$export$addf369becd23283)(this, $e247d84fdb7f6ded$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
};
$e247d84fdb7f6ded$var$_shouldStopPropagation = new WeakMap();


// src/dom-helpers.ts
var $3c77279102a1faed$export$b204af158042fbac = (el)=>{
    var _a;
    return (_a = el == null ? void 0 : el.ownerDocument) != null ? _a : document;
};
var $3c77279102a1faed$export$f21a1ffae260145a = (el)=>{
    var _a, _b;
    return (_b = (_a = el == null ? void 0 : el.ownerDocument) == null ? void 0 : _a.defaultView) != null ? _b : window;
};



var $094d44bfac4b86f6$var$state = "default";
var $094d44bfac4b86f6$var$savedUserSelect = "";
var $094d44bfac4b86f6$var$modifiedElementMap = /* @__PURE__ */ new WeakMap();
function $094d44bfac4b86f6$export$16a4697467175487(target) {
    if ((0, $a26d4c995bb2a467$export$fedb369cb70207f1)()) {
        if ($094d44bfac4b86f6$var$state === "default") {
            const documentObject = (0, $3c77279102a1faed$export$b204af158042fbac)(target);
            $094d44bfac4b86f6$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $094d44bfac4b86f6$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        $094d44bfac4b86f6$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $094d44bfac4b86f6$export$b0d6fa1ab32e3295(target) {
    if ((0, $a26d4c995bb2a467$export$fedb369cb70207f1)()) {
        if ($094d44bfac4b86f6$var$state !== "disabled") return;
        $094d44bfac4b86f6$var$state = "restoring";
        setTimeout(()=>{
            (0, $a26d4c995bb2a467$export$24490316f764c430)(()=>{
                if ($094d44bfac4b86f6$var$state === "restoring") {
                    const documentObject = (0, $3c77279102a1faed$export$b204af158042fbac)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $094d44bfac4b86f6$var$savedUserSelect || "";
                    $094d44bfac4b86f6$var$savedUserSelect = "";
                    $094d44bfac4b86f6$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $094d44bfac4b86f6$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $094d44bfac4b86f6$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none" && targetOldUserSelect) target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $094d44bfac4b86f6$var$modifiedElementMap.delete(target);
        }
    }
}






var $7fPBF = parcelRequire("7fPBF");
function $40d6d4ef5e24c485$var$usePressResponderContext(props) {
    let context = (0, $7fPBF.useContext)((0, $d0053959974f77e8$export$5165eccb35aaadb5));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(contextProps, props);
        register();
    }
    (0, $a26d4c995bb2a467$export$4debdb1a3f0fa79e)(context, props.ref);
    return props;
}
var $40d6d4ef5e24c485$var$LINK_CLICKED = Symbol("linkClicked");
function $40d6d4ef5e24c485$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $40d6d4ef5e24c485$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $7fPBF.useState)(false);
    let ref = (0, $7fPBF.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $a26d4c995bb2a467$export$4eaf04e54aa8eed6)();
    let triggerPressStart = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new (0, $e247d84fdb7f6ded$export$c67d0d444dae0df7)("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new (0, $e247d84fdb7f6ded$export$c67d0d444dae0df7)("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new (0, $e247d84fdb7f6ded$export$c67d0d444dae0df7)("press", pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new (0, $e247d84fdb7f6ded$export$c67d0d444dae0df7)("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        let state = ref.current;
        if (state.isPressed) {
            if (state.isOverTarget && state.target) triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress && state.target) (0, $094d44bfac4b86f6$export$b0d6fa1ab32e3295)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $a26d4c995bb2a467$export$7f54fc3180508a52)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $7fPBF.useMemo)(()=>{
        let state = ref.current;
        let pressProps2 = {
            onKeyDown (e) {
                var _a;
                if ($40d6d4ef5e24c485$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    if ($40d6d4ef5e24c485$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        addGlobalListener((0, $3c77279102a1faed$export$b204af158042fbac)(e.currentTarget), "keyup", onKeyUp, false);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    if (e.metaKey && (0, $a26d4c995bb2a467$export$9ac100e40613ea10)()) (_a = state.metaKeyEvents) == null || _a.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = /* @__PURE__ */ new Map();
            },
            onKeyUp (e) {
                if (state.target && $40d6d4ef5e24c485$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && !e.repeat && e.currentTarget.contains(e.target)) triggerPressUp($40d6d4ef5e24c485$var$createEvent(state.target, e), "keyboard");
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $a26d4c995bb2a467$export$95185d699e05d4d7).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, $a26d4c995bb2a467$export$60278871457622de)(e.nativeEvent))) {
                        if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, "virtual");
                        let stopPressUp = triggerPressUp(e, "virtual");
                        let stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _a, _b;
            if (state.isPressed && state.target && $40d6d4ef5e24c485$var$isValidKeyboardEvent(e, state.target)) {
                if ($40d6d4ef5e24c485$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                let shouldStopPropagation = triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                if (shouldStopPropagation) e.stopPropagation();
                if (e.key !== "Enter" && $40d6d4ef5e24c485$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$40d6d4ef5e24c485$var$LINK_CLICKED]) {
                    e[$40d6d4ef5e24c485$var$LINK_CLICKED] = true;
                    (0, $a26d4c995bb2a467$export$95185d699e05d4d7)(state.target, e, false);
                }
                state.isPressed = false;
                (_a = state.metaKeyEvents) == null || _a.delete(e.key);
            } else if (e.key === "Meta" && ((_b = state.metaKeyEvents) == null ? void 0 : _b.size)) {
                let events = state.metaKeyEvents;
                state.metaKeyEvents = null;
                for (let event of events.values())state.target && state.target.dispatchEvent(new KeyboardEvent("keyup", event));
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps2.onPointerDown = (e)=>{
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                if ((0, $a26d4c995bb2a467$export$29bf1b5f2c56cf63)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                if ($40d6d4ef5e24c485$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $094d44bfac4b86f6$export$16a4697467175487)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $3c77279102a1faed$export$b204af158042fbac)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, $3c77279102a1faed$export$b204af158042fbac)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, $3c77279102a1faed$export$b204af158042fbac)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps2.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    if ($40d6d4ef5e24c485$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps2.onPointerUp = (e)=>{
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                if (e.button === 0 && $40d6d4ef5e24c485$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId || !state.target) return;
                if ($40d6d4ef5e24c485$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        triggerPressStart($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($40d6d4ef5e24c485$var$isOverTarget(e, state.target)) triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget) triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $094d44bfac4b86f6$export$b0d6fa1ab32e3295)(state.target);
                }
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps2.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        } else {
            pressProps2.onMouseDown = (e)=>{
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                if ($40d6d4ef5e24c485$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $a26d4c995bb2a467$export$60278871457622de)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $3c77279102a1faed$export$b204af158042fbac)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps2.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps2.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps2.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            let onMouseUp = (e)=>{
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (!state.target) return;
                if ($40d6d4ef5e24c485$var$isOverTarget(e, state.target)) triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType);
                else if (state.isOverTarget) triggerPressEnd($40d6d4ef5e24c485$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps2.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $40d6d4ef5e24c485$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                if (!isDisabled && !preventFocusOnPress) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $094d44bfac4b86f6$export$16a4697467175487)(state.target);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $3c77279102a1faed$export$f21a1ffae260145a)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps2.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $40d6d4ef5e24c485$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $40d6d4ef5e24c485$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps2.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $40d6d4ef5e24c485$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $40d6d4ef5e24c485$var$isOverTarget(touch, e.currentTarget)) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (!allowTextSelectionOnPress && state.target) (0, $094d44bfac4b86f6$export$b0d6fa1ab32e3295)(state.target);
                removeAllGlobalListeners();
            };
            pressProps2.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps2.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps2;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            if (!allowTextSelectionOnPress && ref.current.target) (0, $094d44bfac4b86f6$export$b0d6fa1ab32e3295)(ref.current.target);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(domProps, pressProps)
    };
}
function $40d6d4ef5e24c485$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $40d6d4ef5e24c485$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute("role");
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, $3c77279102a1faed$export$f21a1ffae260145a)(element).HTMLInputElement && !$40d6d4ef5e24c485$var$isValidInputKey(element, key) || element instanceof (0, $3c77279102a1faed$export$f21a1ffae260145a)(element).HTMLTextAreaElement || element.isContentEditable) && !((role === "link" || !role && $40d6d4ef5e24c485$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $40d6d4ef5e24c485$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $40d6d4ef5e24c485$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $40d6d4ef5e24c485$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $40d6d4ef5e24c485$var$getPointClientRect(point) {
    let offsetX = !!point.width ? point.width / 2 : point.radiusX || 0;
    let offsetY = !!point.height ? point.height / 2 : point.radiusY || 0;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $40d6d4ef5e24c485$var$areRectanglesOverlapping(a, b) {
    if (a.left > b.right || b.left > a.right) return false;
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $40d6d4ef5e24c485$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $40d6d4ef5e24c485$var$getPointClientRect(point);
    return $40d6d4ef5e24c485$var$areRectanglesOverlapping(rect, pointRect);
}
function $40d6d4ef5e24c485$var$shouldPreventDefault(target) {
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $40d6d4ef5e24c485$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$40d6d4ef5e24c485$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($40d6d4ef5e24c485$var$isHTMLAnchorLink(target)) return false;
    return true;
}
var $40d6d4ef5e24c485$var$nonTextInputTypes = /* @__PURE__ */ new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $40d6d4ef5e24c485$var$isValidInputKey(target, key) {
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $40d6d4ef5e24c485$var$nonTextInputTypes.has(target.type);
}


function $9cac810099d73b74$export$1aff6edc04132adb(props, ref) {
    let { elementType: elementType = "button", isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = "button", allowTextSelectionOnPress: allowTextSelectionOnPress } = props;
    let additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? void 0 : 0,
        href: elementType === "a" && isDisabled ? void 0 : href,
        target: elementType === "a" ? target : void 0,
        type: elementType === "input" ? type : void 0,
        disabled: elementType === "input" ? isDisabled : void 0,
        "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
        rel: elementType === "a" ? rel : void 0
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $40d6d4ef5e24c485$export$45712eceda6fad21)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        allowTextSelectionOnPress: allowTextSelectionOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $2cf1c82089cb095e$export$4c014de7c8940b4c)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(focusableProps, pressProps, (0, $a26d4c995bb2a467$export$457c3d6518dd4c6f)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: (e)=>{
                deprecatedOnClick == null || deprecatedOnClick(e);
            }
        })
    };
}


// src/utils.ts


var $7fPBF = parcelRequire("7fPBF");
function $4f1e9f4a2dccf0c0$export$257a8862b851cb5b(component) {
    return (0, $7fPBF.forwardRef)(component);
}
var $4f1e9f4a2dccf0c0$export$21e0669b7bd01bb4 = (obj)=>{
    return {
        ...obj,
        [Symbol.iterator]: function() {
            const keys = Object.keys(this);
            let index = 0;
            return {
                next: ()=>{
                    if (index >= keys.length) return {
                        done: true
                    };
                    const key = keys[index];
                    const value = this[key];
                    index++;
                    return {
                        value: {
                            key: key,
                            value: value
                        },
                        done: false
                    };
                }
            };
        }
    };
};
var $4f1e9f4a2dccf0c0$export$9f203ede2b8cf905 = (props, variantKeys, removeVariantProps = true)=>{
    if (!variantKeys) return [
        props,
        {}
    ];
    const picked = variantKeys.reduce((acc, key)=>{
        if (key in props) return {
            ...acc,
            [key]: props[key]
        };
        else return acc;
    }, {});
    if (removeVariantProps) {
        const omitted = Object.keys(props).filter((key)=>!variantKeys.includes(key)).reduce((acc, key)=>({
                ...acc,
                [key]: props[key]
            }), {});
        return [
            omitted,
            picked
        ];
    } else return [
        props,
        picked
    ];
};
var $4f1e9f4a2dccf0c0$export$ab8830944406cf18 = (originalProps, variantKeys, commonKeys)=>{
    const props = Object.keys(originalProps).filter((key)=>!variantKeys.includes(key) || (commonKeys == null ? void 0 : commonKeys.includes(key))).reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    const variants = variantKeys.reduce((acc, key)=>({
            ...acc,
            [key]: originalProps[key]
        }), {});
    return [
        props,
        variants
    ];
};
var $4f1e9f4a2dccf0c0$export$1343a74baacb0543 = (0, $e2e9f7015a5aa268$export$2e2bcd8739ae039);


// src/clsx.ts
function $f98c818df3fcb362$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $f98c818df3fcb362$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $f98c818df3fcb362$export$4f5d2d50c9deca37(...args) {
    var i = 0, tmp, x, str = "";
    while(i < args.length){
        if (tmp = args[i++]) {
            if (x = $f98c818df3fcb362$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

// src/assertion.ts
var $019af025c81e2707$export$a866f231438cc228 = false;
var $019af025c81e2707$export$61cb32cff9a99948 = false;
function $019af025c81e2707$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $019af025c81e2707$export$4c0262a4f954db45(value) {
    return $019af025c81e2707$export$43bee75e5e14138e(value) && value.length === 0;
}
function $019af025c81e2707$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$019af025c81e2707$export$43bee75e5e14138e(value);
}
function $019af025c81e2707$export$83b788b1a3698c03(value) {
    return $019af025c81e2707$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $019af025c81e2707$export$dd1bc94b04021eeb(value) {
    if ($019af025c81e2707$export$43bee75e5e14138e(value)) return $019af025c81e2707$export$4c0262a4f954db45(value);
    if ($019af025c81e2707$export$a6cdc56e425d0d0a(value)) return $019af025c81e2707$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
function $019af025c81e2707$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
var $019af025c81e2707$export$5cc3b7b83e34ade7 = (condition)=>condition ? "true" : void 0;
var $019af025c81e2707$export$e90fb89750dba83f = (value)=>value != null && parseInt(value.toString(), 10) > 0;


// src/dom-props.ts
var $f532394850315144$export$5f28e08e1b07d392 = /* @__PURE__ */ new Set([
    "id",
    "type",
    "style",
    "title",
    "role",
    "tabIndex",
    "htmlFor",
    "width",
    "height",
    "abbr",
    "accept",
    "acceptCharset",
    "accessKey",
    "action",
    "allowFullScreen",
    "allowTransparency",
    "alt",
    "async",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "challenge",
    "charset",
    "checked",
    "cite",
    "class",
    "className",
    "cols",
    "colSpan",
    "command",
    "content",
    "contentEditable",
    "contextMenu",
    "controls",
    "coords",
    "crossOrigin",
    "data",
    "dateTime",
    "default",
    "defer",
    "dir",
    "disabled",
    "download",
    "draggable",
    "dropzone",
    "encType",
    "for",
    "form",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "headers",
    "hidden",
    "high",
    "href",
    "hrefLang",
    "httpEquiv",
    "icon",
    "inputMode",
    "isMap",
    "itemId",
    "itemProp",
    "itemRef",
    "itemScope",
    "itemType",
    "kind",
    "label",
    "lang",
    "list",
    "loop",
    "manifest",
    "max",
    "maxLength",
    "media",
    "mediaGroup",
    "method",
    "min",
    "minLength",
    "multiple",
    "muted",
    "name",
    "noValidate",
    "open",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "poster",
    "preload",
    "radioGroup",
    "referrerPolicy",
    "readOnly",
    "rel",
    "required",
    "rows",
    "rowSpan",
    "sandbox",
    "scope",
    "scoped",
    "scrolling",
    "seamless",
    "selected",
    "shape",
    "size",
    "sizes",
    "slot",
    "sortable",
    "span",
    "spellCheck",
    "src",
    "srcDoc",
    "srcSet",
    "start",
    "step",
    "target",
    "translate",
    "typeMustMatch",
    "useMap",
    "value",
    "wmode",
    "wrap"
]);
var $f532394850315144$export$8519a64fe4099896 = /* @__PURE__ */ new Set([
    "onCopy",
    "onCut",
    "onPaste",
    "onLoad",
    "onError",
    "onWheel",
    "onScroll",
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate",
    "onKeyDown",
    "onKeyPress",
    "onKeyUp",
    "onFocus",
    "onBlur",
    "onChange",
    "onInput",
    "onSubmit",
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp",
    "onPointerDown",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerUp",
    "onSelect",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration",
    "onTransitionEnd"
]);


// src/filter-dom-props.ts
var $4ef54568ed699843$var$propRe = /^(data-.*)$/;
var $4ef54568ed699843$var$ariaRe = /^(aria-.*)$/;
var $4ef54568ed699843$var$funcRe = /^(on[A-Z].*)$/;
function $4ef54568ed699843$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable = true, enabled: enabled = true, propNames: propNames, omitPropNames: omitPropNames, omitEventNames: omitEventNames } = opts;
    let filteredProps = {};
    if (!enabled) return props;
    for(const prop in props){
        if (omitPropNames == null ? void 0 : omitPropNames.has(prop)) continue;
        if ((omitEventNames == null ? void 0 : omitEventNames.has(prop)) && $4ef54568ed699843$var$funcRe.test(prop)) continue;
        if ($4ef54568ed699843$var$funcRe.test(prop) && !(0, $f532394850315144$export$8519a64fe4099896).has(prop)) continue;
        if (Object.prototype.hasOwnProperty.call(props, prop) && ((0, $f532394850315144$export$5f28e08e1b07d392).has(prop) || labelable && $4ef54568ed699843$var$ariaRe.test(prop) || (propNames == null ? void 0 : propNames.has(prop)) || $4ef54568ed699843$var$propRe.test(prop)) || $4ef54568ed699843$var$funcRe.test(prop)) filteredProps[prop] = props[prop];
    }
    return filteredProps;
}


var $7fPBF = parcelRequire("7fPBF");
"use client";
function $fbbbeef99fe5a8b0$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $fbbbeef99fe5a8b0$export$4e09c449d6c407f7 = $fbbbeef99fe5a8b0$export$71594e8a50f746f4();
function $fbbbeef99fe5a8b0$export$6ffcd379b2770ab0(navigator) {
    const { userAgent: ua, vendor: vendor } = navigator;
    const android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $fbbbeef99fe5a8b0$export$54dee9623b75428b(navigator) {
    const { userAgent: ua, platform: platform } = navigator;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $fbbbeef99fe5a8b0$export$568a7d21694b4b32(navigator) {
    const { userAgent: ua } = navigator;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $fbbbeef99fe5a8b0$export$3070bd282ec37ea8(os) {
    if (!$fbbbeef99fe5a8b0$export$4e09c449d6c407f7) return false;
    return $fbbbeef99fe5a8b0$export$54dee9623b75428b(window.navigator) === os;
}
function $fbbbeef99fe5a8b0$export$2d31490a0c05f094(browser) {
    if (!$fbbbeef99fe5a8b0$export$4e09c449d6c407f7) return false;
    return $fbbbeef99fe5a8b0$export$6ffcd379b2770ab0(window.navigator) === browser;
}
function $fbbbeef99fe5a8b0$export$8d04c8cf4d9e22d8() {
    if (!$fbbbeef99fe5a8b0$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $fbbbeef99fe5a8b0$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $fbbbeef99fe5a8b0$export$79d69eee6ae4b329(domRef, focusableRef = domRef) {
    return {
        ...$fbbbeef99fe5a8b0$export$a5795cc979dfae80(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function $fbbbeef99fe5a8b0$export$c2c55ef9111cafd8(ref) {
    const domRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>domRef.current);
    return domRef;
}
function $fbbbeef99fe5a8b0$export$96a734597687c040(ref, focusableRef) {
    const domRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>$fbbbeef99fe5a8b0$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $fbbbeef99fe5a8b0$export$4debdb1a3f0fa79e(context, ref) {
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (context && context.ref && ref && ref.current) {
            context.ref.current = ref.current;
            return ()=>{
                var _a;
                if ((_a = context.ref) == null ? void 0 : _a.current) context.ref.current = null;
            };
        }
    }, [
        context,
        ref
    ]);
}


// src/functions.ts
var $dbd496723874cc51$export$9a00dee1beb8f576 = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function $dbd496723874cc51$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $dbd496723874cc51$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
function $dbd496723874cc51$export$bb64030b028b5009(key, defaultValue, ...objs) {
    let result = defaultValue;
    for (const obj of objs)if (obj && key in obj && !!obj[key]) result = obj[key];
    return result;
}
function $dbd496723874cc51$export$b8ba5815f1bdad68(prefix) {
    return `${prefix}-${Math.floor(Math.random() * 1e6)}`;
}
function $dbd496723874cc51$export$da5f6eb3bb522cd(input) {
    for(const key in input)if (key.startsWith("on")) delete input[key];
    return input;
}



var $7fPBF = parcelRequire("7fPBF");
"use client";
function $c541656b7cf90435$export$66d23405c38d2c80(props = {}) {
    const [ripples, setRipples] = (0, $7fPBF.useState)([]);
    const onClick = (0, $7fPBF.useCallback)((event)=>{
        const trigger = event.currentTarget;
        const size = Math.max(trigger.clientWidth, trigger.clientHeight);
        const rect = trigger.getBoundingClientRect();
        setRipples((prevRipples)=>[
                ...prevRipples,
                {
                    key: (0, $dbd496723874cc51$export$b8ba5815f1bdad68)(prevRipples.length.toString()),
                    size: size,
                    x: event.clientX - rect.x - size / 2,
                    y: event.clientY - rect.y - size / 2
                }
            ]);
    }, []);
    const onClear = (0, $7fPBF.useCallback)((key)=>{
        setRipples((prevState)=>prevState.filter((ripple)=>ripple.key !== key));
    }, []);
    return {
        ripples: ripples,
        onClick: onClick,
        onClear: onClear,
        ...props
    };
}


"use client";
function $b7bc5be477e90467$export$5a0763f6a9ca51f0(originalProps) {
    const [props, variantProps] = (0, $4f1e9f4a2dccf0c0$export$9f203ede2b8cf905)(originalProps, (0, $318a941d4267a4c8$export$aa3e815946b80764).variantKeys);
    const { ref: ref, as: as, children: children, disableRipple: disableRipple = false, onClick: onClick, onPress: onPress, autoFocus: autoFocus, className: className, classNames: classNames, allowTextSelectionOnPress: allowTextSelectionOnPress = true, ...otherProps } = props;
    const domRef = (0, $fbbbeef99fe5a8b0$export$c2c55ef9111cafd8)(ref);
    const Component = as || (originalProps.isPressable ? "button" : "div");
    const shouldFilterDOMProps = typeof Component === "string";
    const baseStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const { onClick: onRippleClickHandler, onClear: onClearRipple, ripples: ripples } = (0, $c541656b7cf90435$export$66d23405c38d2c80)();
    const handleClick = (e)=>{
        if (!originalProps.disableAnimation && !disableRipple && domRef.current) onRippleClickHandler(e);
    };
    const { buttonProps: buttonProps, isPressed: isPressed } = (0, $9cac810099d73b74$export$1aff6edc04132adb)({
        onPress: onPress,
        elementType: as,
        isDisabled: !originalProps.isPressable,
        onClick: (0, $a26d4c995bb2a467$export$e08e3b67e392101e)(onClick, handleClick),
        allowTextSelectionOnPress: allowTextSelectionOnPress,
        ...otherProps
    }, domRef);
    const { hoverProps: hoverProps, isHovered: isHovered } = (0, $9102a566b416415c$export$ae780daf29e6d456)({
        isDisabled: !originalProps.isHoverable,
        ...otherProps
    });
    const { isFocusVisible: isFocusVisible, isFocused: isFocused, focusProps: focusProps } = (0, $2cf1c82089cb095e$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const slots = (0, $7fPBF.useMemo)(()=>(0, $318a941d4267a4c8$export$aa3e815946b80764)({
            ...variantProps
        }), [
        ...Object.values(variantProps)
    ]);
    const context = (0, $7fPBF.useMemo)(()=>({
            isDisabled: originalProps.isDisabled,
            isFooterBlurred: originalProps.isFooterBlurred,
            disableAnimation: originalProps.disableAnimation,
            fullWidth: originalProps.fullWidth,
            slots: slots,
            classNames: classNames
        }), [
        slots,
        classNames,
        originalProps.isDisabled,
        originalProps.isFooterBlurred,
        originalProps.disableAnimation,
        originalProps.fullWidth
    ]);
    const getCardProps = (0, $7fPBF.useCallback)((props2 = {})=>{
        return {
            ref: domRef,
            className: slots.base({
                class: baseStyles
            }),
            tabIndex: originalProps.isPressable ? 0 : -1,
            "data-hover": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isHovered),
            "data-pressed": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isFocusVisible),
            "data-disabled": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(originalProps.isDisabled),
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(originalProps.isPressable ? {
                ...buttonProps,
                ...focusProps,
                role: "button"
            } : {}, originalProps.isHoverable ? hoverProps : {}, (0, $4ef54568ed699843$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), (0, $4ef54568ed699843$export$457c3d6518dd4c6f)(props2))
        };
    }, [
        domRef,
        slots,
        baseStyles,
        shouldFilterDOMProps,
        originalProps.isPressable,
        originalProps.isHoverable,
        originalProps.isDisabled,
        isHovered,
        isPressed,
        isFocusVisible,
        buttonProps,
        focusProps,
        hoverProps,
        otherProps
    ]);
    const getRippleProps = (0, $7fPBF.useCallback)(()=>({
            ripples: ripples,
            onClear: onClearRipple
        }), [
        ripples,
        onClearRipple
    ]);
    return {
        context: context,
        domRef: domRef,
        Component: Component,
        classNames: classNames,
        children: children,
        isHovered: isHovered,
        isPressed: isPressed,
        isPressable: originalProps.isPressable,
        isHoverable: originalProps.isHoverable,
        disableAnimation: originalProps.disableAnimation,
        disableRipple: disableRipple,
        handleClick: handleClick,
        isFocusVisible: isFocusVisible,
        getCardProps: getCardProps,
        getRippleProps: getRippleProps
    };
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $eab4d64e1bdb7129$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $af582d6e296d97ab$export$700979bc83e7db82 = (0, $eab4d64e1bdb7129$export$4e09c449d6c407f7) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


function $8708fc81c5d4c054$export$80c2a3957bcb42ea() {
    const isMounted = (0, $7fPBF.useRef)(false);
    (0, $af582d6e296d97ab$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $0eca9a23e11b208d$export$8793edee2d425525 = (any)=>any;


class $1f4cbb9bcd909f05$var$Queue {
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
}
function $1f4cbb9bcd909f05$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $1f4cbb9bcd909f05$var$Queue();
    let nextFrame = new $1f4cbb9bcd909f05$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $80cdde40495b4b7b$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $80cdde40495b4b7b$var$maxElapsed = 40;
function $80cdde40495b4b7b$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $80cdde40495b4b7b$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $1f4cbb9bcd909f05$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $80cdde40495b4b7b$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $80cdde40495b4b7b$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $80cdde40495b4b7b$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$80cdde40495b4b7b$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $4bfc6ff75ec6ae14$export$2cef06c20297c17d, cancel: $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb, state: $4bfc6ff75ec6ae14$export$fff89137e9e818ce, steps: $4bfc6ff75ec6ae14$export$be3f796aed065412 } = (0, $80cdde40495b4b7b$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $0eca9a23e11b208d$export$8793edee2d425525), true);


function $205a8fa568e2b758$export$91db9bc4f8ac944a() {
    const isMounted = (0, $8708fc81c5d4c054$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $7fPBF.useState)(0);
    const forceRender = (0, $7fPBF.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $7fPBF.useCallback)(()=>(0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @public
 */ const $13549fe6f5cbc799$export$f224e4635b6f8ce2 = (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $2a1bdfabf21bf6e8$export$fe4300aa8eebea86(init) {
    const ref = (0, $7fPBF.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $ffdd26e99fd777d3$var$PopChildMeasure extends $7fPBF.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $ffdd26e99fd777d3$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $7fPBF.useId)();
    const ref = (0, $7fPBF.useRef)(null);
    const size = (0, $7fPBF.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $7fPBF.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $7fPBF.createElement($ffdd26e99fd777d3$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $7fPBF.cloneElement(children, {
        ref: ref
    }));
}


const $208768b98234d3ad$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $2a1bdfabf21bf6e8$export$fe4300aa8eebea86)($208768b98234d3ad$var$newChildrenMap);
    const id = (0, $7fPBF.useId)();
    const context = (0, $7fPBF.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $7fPBF.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $7fPBF.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $7fPBF.createElement((0, $ffdd26e99fd777d3$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $7fPBF.createElement((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $208768b98234d3ad$var$newChildrenMap() {
    return new Map();
}



var $7fPBF = parcelRequire("7fPBF");
const $e8832bf2a75e672d$export$a3579ca508007a95 = (0, $7fPBF.createContext)({});




var $7fPBF = parcelRequire("7fPBF");
function $4a24ec40de0bf15b$export$f3a192d0cbd30b96(callback) {
    return (0, $7fPBF.useEffect)(()=>()=>callback(), []);
}



let $e9fa7280c44589a0$export$491112666e282270 = (0, $0eca9a23e11b208d$export$8793edee2d425525);
let $e9fa7280c44589a0$export$f5708dca728d7177 = (0, $0eca9a23e11b208d$export$8793edee2d425525);
var $e9fa7280c44589a0$var$check, $e9fa7280c44589a0$var$message, $e9fa7280c44589a0$var$check1, $e9fa7280c44589a0$var$message1;


const $322c4f4c50d01684$var$getChildKey = (child)=>child.key || "";
function $322c4f4c50d01684$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $322c4f4c50d01684$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $322c4f4c50d01684$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $7fPBF.Children).forEach(children, (child)=>{
        if ((0, $7fPBF.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $322c4f4c50d01684$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $e9fa7280c44589a0$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95)).forceRender || (0, $205a8fa568e2b758$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $8708fc81c5d4c054$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $322c4f4c50d01684$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $7fPBF.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $7fPBF.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $7fPBF.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $7fPBF.useRef)(true);
    (0, $af582d6e296d97ab$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $322c4f4c50d01684$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $4a24ec40de0bf15b$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $7fPBF.createElement($7fPBF.Fragment, null, childrenToRender.map((child)=>$7fPBF.createElement((0, $208768b98234d3ad$export$979daf65881a382a), {
            key: $322c4f4c50d01684$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($322c4f4c50d01684$var$getChildKey);
    const targetKeys = filteredChildren.map($322c4f4c50d01684$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $322c4f4c50d01684$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $7fPBF.createElement((0, $208768b98234d3ad$export$979daf65881a382a), {
                key: $322c4f4c50d01684$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $7fPBF.createElement((0, $208768b98234d3ad$export$979daf65881a382a), {
            key: $322c4f4c50d01684$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $7fPBF.createElement($7fPBF.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $7fPBF.cloneElement)(child)));
};


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @public
 */ const $a8ff94f377278375$export$22a697fb29aac98d = (0, $7fPBF.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $7fPBF = parcelRequire("7fPBF");
const $022ea981eb8a45f5$export$2285bbca2c666415 = (0, $7fPBF.createContext)({});



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
const $1a3b4aa5979f4505$export$40f10139ecf1f171 = (0, $7fPBF.createContext)({
    strict: false
});



function $7d1717bf2273b4e2$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415));
    const lazyContext = (0, $7fPBF.useContext)((0, $1a3b4aa5979f4505$export$40f10139ecf1f171));
    const presenceContext = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $7fPBF.useContext)((0, $a8ff94f377278375$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $7fPBF.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $7fPBF.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const canHandoff = (0, $7fPBF.useRef)(Boolean(window.HandoffAppearAnimations));
    (0, $af582d6e296d97ab$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!canHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        /**
         * Once we've handed off animations we can delete HandoffAppearAnimations
         * so components added after the initial render can animate changes
         * in useEffect vs useLayoutEffect.
         */ window.HandoffAppearAnimations = undefined;
        canHandoff.current = false;
    });
    return visualElement;
}



var $7fPBF = parcelRequire("7fPBF");
function $881a839ff5ec248c$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3efbe3f66e4b88ba$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $7fPBF.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $881a839ff5ec248c$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $7fPBF = parcelRequire("7fPBF");

/**
 * Decides if the supplied variable is variant label
 */ function $cf9a579fabd47d14$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $0ff067b1f8954c56$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $90bbd5b0e4403b6f$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $90bbd5b0e4403b6f$export$1405a65085f40b9 = [
    "initial",
    ...$90bbd5b0e4403b6f$export$16e45afcc206d3a8
];


function $76ceffd285582b8c$export$4b3c3bd8d910d78d(props) {
    return (0, $0ff067b1f8954c56$export$aa71198ceeaf53ce)(props.animate) || (0, $90bbd5b0e4403b6f$export$1405a65085f40b9).some((name)=>(0, $cf9a579fabd47d14$export$720b90e312cea233)(props[name]));
}
function $76ceffd285582b8c$export$ce46fa4165cdec40(props) {
    return Boolean($76ceffd285582b8c$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $854409cb45b6f949$export$12fc32fc096a04a3(props, context) {
    if ((0, $76ceffd285582b8c$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $cf9a579fabd47d14$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $cf9a579fabd47d14$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $a9d13e94686be65e$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $854409cb45b6f949$export$12fc32fc096a04a3)(props, (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415)));
    return (0, $7fPBF.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a9d13e94686be65e$var$variantLabelsAsDependency(initial),
        $a9d13e94686be65e$var$variantLabelsAsDependency(animate)
    ]);
}
function $a9d13e94686be65e$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $000eadb1a85dd08b$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $000eadb1a85dd08b$export$65570e08d843624d = {};
for(const key in $000eadb1a85dd08b$var$featureProps)$000eadb1a85dd08b$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$000eadb1a85dd08b$var$featureProps[key].some((name)=>!!props[name])
};


function $1a95148514458996$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $000eadb1a85dd08b$export$65570e08d843624d)[key] = {
        ...(0, $000eadb1a85dd08b$export$65570e08d843624d)[key],
        ...features[key]
    };
}






var $7fPBF = parcelRequire("7fPBF");
/**
 * Internal, exported only for usage in Framer
 */ const $813b6750233d847f$export$da5f7b802957459a = (0, $7fPBF.createContext)({});


const $b4cb5ee9ecabcf16$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $9202ab606c3569b2$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $1a95148514458996$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $7fPBF.useContext)((0, $a8ff94f377278375$export$22a697fb29aac98d)),
            ...props,
            layoutId: $9202ab606c3569b2$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $a9d13e94686be65e$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $eab4d64e1bdb7129$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7d1717bf2273b4e2$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $7fPBF.useContext)((0, $813b6750233d847f$export$da5f7b802957459a));
            const isStrict = (0, $7fPBF.useContext)((0, $1a3b4aa5979f4505$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $7fPBF.createElement((0, $022ea981eb8a45f5$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $7fPBF.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $3efbe3f66e4b88ba$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $7fPBF.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $b4cb5ee9ecabcf16$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $9202ab606c3569b2$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $ab4b5ecb7c661962$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $9202ab606c3569b2$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $087915a6be8a879b$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $e87a7c920482c926$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $087915a6be8a879b$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $e57013859c9cf5f3$export$91ddd985b97788d1 = {};
function $e57013859c9cf5f3$export$de9e7791c71225fd(correctors) {
    Object.assign($e57013859c9cf5f3$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $a68c8b42e34fb3f9$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $a68c8b42e34fb3f9$export$7b42a0094fb00b6e = new Set($a68c8b42e34fb3f9$export$280dc01950909d86);


function $927f87b2c16ad07f$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $e57013859c9cf5f3$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $bb62727ea8cab401$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $827b30d603ad9a35$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $827b30d603ad9a35$var$numTransforms = (0, $a68c8b42e34fb3f9$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $827b30d603ad9a35$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $827b30d603ad9a35$var$numTransforms; i++){
        const key = (0, $a68c8b42e34fb3f9$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $827b30d603ad9a35$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $9bea4890e7790ee2$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $9bea4890e7790ee2$export$9de1236619d9e756 = $9bea4890e7790ee2$var$checkStringStartsWith("--");
const $9bea4890e7790ee2$export$31f9caa2600b5723 = $9bea4890e7790ee2$var$checkStringStartsWith("var(--");
const $9bea4890e7790ee2$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $415b2c7be6fb8db8$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $874dc586b35ff5e5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $45353614456d19cf$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $45353614456d19cf$export$58f0f39f63f3cf42 = {
    ...$45353614456d19cf$export$98e628dec113755e,
    transform: (v)=>(0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $45353614456d19cf$export$dcdf75081b88279d = {
    ...$45353614456d19cf$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $1f499153cf8251ff$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $1f499153cf8251ff$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $1f499153cf8251ff$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $1f499153cf8251ff$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $1f499153cf8251ff$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $ff0d5edf20a77464$var$createUnitType = (unit)=>({
        test: (v)=>(0, $1f499153cf8251ff$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ff0d5edf20a77464$export$41fc368e1a942b97 = $ff0d5edf20a77464$var$createUnitType("deg");
const $ff0d5edf20a77464$export$626336c2cd4b14de = $ff0d5edf20a77464$var$createUnitType("%");
const $ff0d5edf20a77464$export$91c0eda1d06bf008 = $ff0d5edf20a77464$var$createUnitType("px");
const $ff0d5edf20a77464$export$f91e8c45a95a32f2 = $ff0d5edf20a77464$var$createUnitType("vh");
const $ff0d5edf20a77464$export$aed3d7b7d206c196 = $ff0d5edf20a77464$var$createUnitType("vw");
const $ff0d5edf20a77464$export$44e2e1705876d7ed = {
    ...$ff0d5edf20a77464$export$626336c2cd4b14de,
    parse: (v)=>$ff0d5edf20a77464$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ff0d5edf20a77464$export$626336c2cd4b14de.transform(v * 100)
};



const $ab331e967f4ea724$export$7d260a2a5f8bc19e = {
    ...(0, $45353614456d19cf$export$98e628dec113755e),
    transform: Math.round
};


const $5f3e75d790bf898d$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderTopWidth: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderRightWidth: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderRadius: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    radius: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    maxWidth: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    height: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    maxHeight: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    size: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    top: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    right: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    bottom: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    left: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    paddingTop: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    paddingRight: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    paddingBottom: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    paddingLeft: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    margin: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    marginTop: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    marginRight: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    marginBottom: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    marginLeft: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    rotateX: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    rotateY: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    rotateZ: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    scale: $45353614456d19cf$export$dcdf75081b88279d,
    scaleX: (0, $45353614456d19cf$export$dcdf75081b88279d),
    scaleY: (0, $45353614456d19cf$export$dcdf75081b88279d),
    scaleZ: (0, $45353614456d19cf$export$dcdf75081b88279d),
    skew: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    skewX: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    skewY: (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    distance: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    translateX: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    translateY: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    translateZ: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    x: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    y: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    z: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    perspective: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    transformPerspective: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    opacity: (0, $45353614456d19cf$export$58f0f39f63f3cf42),
    originX: (0, $ff0d5edf20a77464$export$44e2e1705876d7ed),
    originY: (0, $ff0d5edf20a77464$export$44e2e1705876d7ed),
    originZ: (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $ab331e967f4ea724$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $45353614456d19cf$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $45353614456d19cf$export$58f0f39f63f3cf42),
    numOctaves: (0, $ab331e967f4ea724$export$7d260a2a5f8bc19e)
};


function $b0a51bec594e4a19$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $9bea4890e7790ee2$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $5f3e75d790bf898d$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $415b2c7be6fb8db8$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $827b30d603ad9a35$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $0e0ff089d25fb1a0$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $f78b51ebf65a693b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $bb62727ea8cab401$export$605d60a2578142d3)(source[key]) && !(0, $927f87b2c16ad07f$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $f78b51ebf65a693b$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $7fPBF.useMemo)(()=>{
        const state = (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)();
        (0, $b0a51bec594e4a19$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $f78b51ebf65a693b$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $f78b51ebf65a693b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $f78b51ebf65a693b$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $f78b51ebf65a693b$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $f78b51ebf65a693b$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $19b21865892304dc$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $19b21865892304dc$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $19b21865892304dc$var$validMotionProps.has(key);
}


let $8c94e6d37c758765$var$shouldForward = (key)=>!(0, $19b21865892304dc$export$2f9c46555243bf04)(key);
function $8c94e6d37c758765$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $8c94e6d37c758765$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $19b21865892304dc$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $8c94e6d37c758765$export$59d6962c470509a5((parcelRequire("bIIiG")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $8c94e6d37c758765$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($8c94e6d37c758765$var$shouldForward(key) || forwardMotionProps === true && (0, $19b21865892304dc$export$2f9c46555243bf04)(key) || !isDom && !(0, $19b21865892304dc$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $7fPBF = parcelRequire("7fPBF");



function $abf7e20f6e104bf3$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ff0d5edf20a77464$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $abf7e20f6e104bf3$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $abf7e20f6e104bf3$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $abf7e20f6e104bf3$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $ebd72f6f7559a4ec$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $ebd72f6f7559a4ec$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $ebd72f6f7559a4ec$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $ebd72f6f7559a4ec$var$dashKeys : $ebd72f6f7559a4ec$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ff0d5edf20a77464$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ff0d5edf20a77464$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $ff0d5edf20a77464$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $80fd6b170c9760b2$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $b0a51bec594e4a19$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $abf7e20f6e104bf3$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $ebd72f6f7559a4ec$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $9caa1e13b1076d24$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $83ceefcb56dbbbcb$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $b38d0f78ad3b903e$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $7fPBF.useMemo)(()=>{
        const state = (0, $9caa1e13b1076d24$export$41be8b43e1c4d4f9)();
        (0, $80fd6b170c9760b2$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $83ceefcb56dbbbcb$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $f78b51ebf65a693b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $aa7c12fccf65e136$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component) ? (0, $b38d0f78ad3b903e$export$84309c4f53cb1bd5) : (0, $f78b51ebf65a693b$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $8c94e6d37c758765$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $7fPBF.useMemo)(()=>(0, $bb62727ea8cab401$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $7fPBF.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $913b547f18b26c6d$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $ee8ed79b3b31ab7c$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $8ced42779a60149c$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $0e23cd39959ac87d$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $ee8ed79b3b31ab7c$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $8ced42779a60149c$export$28931db5d57958e5).has(key) ? (0, $913b547f18b26c6d$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $03f83528154d3b62$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $bb62727ea8cab401$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $bb62727ea8cab401$export$605d60a2578142d3)(prevProps.style[key]) || (0, $927f87b2c16ad07f$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $46c3baf131a44c99$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $03f83528154d3b62$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $bb62727ea8cab401$export$605d60a2578142d3)(props[key]) || (0, $bb62727ea8cab401$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $a68c8b42e34fb3f9$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $7fPBF = parcelRequire("7fPBF");


function $cceda5b0163aa04f$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $f37a908eb8ed8ba6$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $2a9071a29f66d2e8$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $2a9071a29f66d2e8$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $f37a908eb8ed8ba6$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $0fd34dcca7ac00f9$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $bb62727ea8cab401$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $2a9071a29f66d2e8$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $598d667c288f7fba$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $598d667c288f7fba$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $598d667c288f7fba$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415));
        const presenceContext = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
        const make = ()=>$598d667c288f7fba$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $2a1bdfabf21bf6e8$export$fe4300aa8eebea86)(make);
    };
function $598d667c288f7fba$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $0fd34dcca7ac00f9$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $76ceffd285582b8c$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $76ceffd285582b8c$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $0ff067b1f8954c56$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $cceda5b0163aa04f$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}






const $bb811bdfd1c7ccf6$export$44dabd3fae512e85 = {
    useVisualState: (0, $598d667c288f7fba$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $46c3baf131a44c99$export$16da615486abaa45),
        createRenderState: (0, $9caa1e13b1076d24$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).render(()=>{
                (0, $80fd6b170c9760b2$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $83ceefcb56dbbbcb$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $0e23cd39959ac87d$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $283d6bd6ceb374d3$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $598d667c288f7fba$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $03f83528154d3b62$export$16da615486abaa45,
        createRenderState: (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)
    })
};


function $c0eba65a3cb498de$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component) ? (0, $bb811bdfd1c7ccf6$export$44dabd3fae512e85) : (0, $283d6bd6ceb374d3$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $aa7c12fccf65e136$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $b73d9e888c3c60f3$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $9ae03fcd9fa90244$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $fc126d8b66e58ebd$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $fc126d8b66e58ebd$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $9ae03fcd9fa90244$export$a4cf9c8a4b063a6e)(event) && handler(event, $fc126d8b66e58ebd$export$12f84bb882d06e1a(event));
};


function $1f42ffe5b9091d52$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(target, eventName, (0, $fc126d8b66e58ebd$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $edc9aad1460f89ff$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $edc9aad1460f89ff$export$a4627e546088548d = (...transformers)=>transformers.reduce($edc9aad1460f89ff$var$combineFunctions);


function $a7404270087418a0$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $a7404270087418a0$var$globalHorizontalLock = $a7404270087418a0$export$518c5fc2dcb7974b("dragHorizontal");
const $a7404270087418a0$var$globalVerticalLock = $a7404270087418a0$export$518c5fc2dcb7974b("dragVertical");
function $a7404270087418a0$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $a7404270087418a0$var$globalVerticalLock();
    else if (drag === "x") lock = $a7404270087418a0$var$globalHorizontalLock();
    else {
        const openHorizontal = $a7404270087418a0$var$globalHorizontalLock();
        const openVertical = $a7404270087418a0$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $a7404270087418a0$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $a7404270087418a0$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $f9402c45bde3a9c6$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}



function $cc9187ec974de0d4$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $a7404270087418a0$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $cc9187ec974de0d4$export$93a81ea037eac456 extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $edc9aad1460f89ff$export$a4627e546088548d)($cc9187ec974de0d4$var$addHoverEvent(this.node, true), $cc9187ec974de0d4$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $78cbf4a00036ebdd$export$d4826db40d47595b extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $edc9aad1460f89ff$export$a4627e546088548d)((0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $4c1efe23d1f861ad$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $4c1efe23d1f861ad$export$e841ada32ff745b(parent, child.parentElement);
};




function $1ff4529f1b09a613$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $1ff4529f1b09a613$export$f026abdbba7f0c9e extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $a7404270087418a0$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $edc9aad1460f89ff$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $0eca9a23e11b208d$export$8793edee2d425525);
        this.removeEndListeners = (0, $0eca9a23e11b208d$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $0eca9a23e11b208d$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $4c1efe23d1f861ad$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $edc9aad1460f89ff$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $1ff4529f1b09a613$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $1ff4529f1b09a613$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $1ff4529f1b09a613$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $edc9aad1460f89ff$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $d711141c523810a9$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $d711141c523810a9$var$observers = new WeakMap();
const $d711141c523810a9$var$fireObserverCallback = (entry)=>{
    const callback = $d711141c523810a9$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $d711141c523810a9$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($d711141c523810a9$var$fireObserverCallback);
};
function $d711141c523810a9$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$d711141c523810a9$var$observers.has(lookupRoot)) $d711141c523810a9$var$observers.set(lookupRoot, {});
    const rootObservers = $d711141c523810a9$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($d711141c523810a9$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $d711141c523810a9$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $d711141c523810a9$var$initIntersectionObserver(options);
    $d711141c523810a9$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $d711141c523810a9$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $13f3207f49b45e2c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $13f3207f49b45e2c$export$150851c8cc2f0c72 extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $13f3207f49b45e2c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $d711141c523810a9$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($13f3207f49b45e2c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $13f3207f49b45e2c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $55b9f4465d1c76fa$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $13f3207f49b45e2c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $1ff4529f1b09a613$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $78cbf4a00036ebdd$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $cc9187ec974de0d4$export$93a81ea037eac456)
    }
};





function $c002467f696c0b79$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $48ac66acf47ec559$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $48ac66acf47ec559$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $48ac66acf47ec559$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $cceda5b0163aa04f$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $48ac66acf47ec559$var$getCurrent(visualElement), $48ac66acf47ec559$var$getVelocity(visualElement));
}






const $af8518df201286cf$export$ed7b8fa9dbf0105d = "framerAppearId";
const $af8518df201286cf$export$8592e1c077c890a6 = "data-" + (0, $913b547f18b26c6d$export$9fd24a634729c672)($af8518df201286cf$export$ed7b8fa9dbf0105d);



/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $96ae4a6175eac365$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $96ae4a6175eac365$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $1af661ba29024555$export$888a3d84909f9e3d = {
    current: false
};


const $4b82379e2303dbb6$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $788726c9e4398b5c$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $788726c9e4398b5c$export$2cf569f5e2221176[easing] || (0, $4b82379e2303dbb6$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($788726c9e4398b5c$export$fcdd8f3f2160beda));
}
const $788726c9e4398b5c$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $788726c9e4398b5c$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $788726c9e4398b5c$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $788726c9e4398b5c$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $788726c9e4398b5c$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $788726c9e4398b5c$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $788726c9e4398b5c$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $4b82379e2303dbb6$export$ff43f99925d7366b)(easing) ? $788726c9e4398b5c$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($788726c9e4398b5c$export$916ea73bcd3a6030) : $788726c9e4398b5c$export$2cf569f5e2221176[easing];
}


function $75bccdfa64eb9ce7$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $788726c9e4398b5c$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $7ce9a7d155295689$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $346d447082ae3761$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $346d447082ae3761$var$subdivisionPrecision = 0.0000001;
const $346d447082ae3761$var$subdivisionMaxIterations = 12;
function $346d447082ae3761$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $346d447082ae3761$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $346d447082ae3761$var$subdivisionPrecision && ++i < $346d447082ae3761$var$subdivisionMaxIterations);
    return currentT;
}
function $346d447082ae3761$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $0eca9a23e11b208d$export$8793edee2d425525;
    const getTForX = (aX)=>$346d447082ae3761$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $346d447082ae3761$var$calcBezier(getTForX(t), mY1, mY2);
}


const $eacef97532bb161f$export$929e5a82286172a6 = (0, $346d447082ae3761$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $eacef97532bb161f$export$57636bb43b1ccbb0 = (0, $346d447082ae3761$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $eacef97532bb161f$export$c07234257a03d5e9 = (0, $346d447082ae3761$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $feade9edb3680bd5$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $3442962051b2df09$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $6e8ac5d3dcd1f160$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $3fe67aad12992024$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $3fe67aad12992024$export$c8d67a19199d1a50 = (0, $6e8ac5d3dcd1f160$export$2c07eeff45156d4d)($3fe67aad12992024$export$e444123e42d03385);
const $3fe67aad12992024$export$30d3455eee55bed5 = (0, $3442962051b2df09$export$f946554fb8aeaf0d)($3fe67aad12992024$export$c8d67a19199d1a50);





const $e604df30838acfd9$export$77edfce482316a60 = (0, $346d447082ae3761$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $e604df30838acfd9$export$b01116c84cdfe1a2 = (0, $6e8ac5d3dcd1f160$export$2c07eeff45156d4d)($e604df30838acfd9$export$77edfce482316a60);
const $e604df30838acfd9$export$ddc5fd596f6c71b2 = (0, $3442962051b2df09$export$f946554fb8aeaf0d)($e604df30838acfd9$export$b01116c84cdfe1a2);



const $b186769c95a61d65$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $e604df30838acfd9$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $9e8db153a43f0760$var$easingLookup = {
    linear: (0, $0eca9a23e11b208d$export$8793edee2d425525),
    easeIn: $eacef97532bb161f$export$929e5a82286172a6,
    easeInOut: $eacef97532bb161f$export$c07234257a03d5e9,
    easeOut: $eacef97532bb161f$export$57636bb43b1ccbb0,
    circIn: $3fe67aad12992024$export$e444123e42d03385,
    circInOut: $3fe67aad12992024$export$30d3455eee55bed5,
    circOut: $3fe67aad12992024$export$c8d67a19199d1a50,
    backIn: $e604df30838acfd9$export$b01116c84cdfe1a2,
    backInOut: $e604df30838acfd9$export$ddc5fd596f6c71b2,
    backOut: $e604df30838acfd9$export$77edfce482316a60,
    anticipate: $b186769c95a61d65$export$6b0af63b873d419e
};
const $9e8db153a43f0760$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $e9fa7280c44589a0$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $346d447082ae3761$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $e9fa7280c44589a0$export$f5708dca728d7177)($9e8db153a43f0760$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $9e8db153a43f0760$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $e34063dbf1337d54$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $1f499153cf8251ff$export$844ec244b1367d54)(v) && (0, $1f499153cf8251ff$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e34063dbf1337d54$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $1f499153cf8251ff$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $1f499153cf8251ff$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $a36b8fd0713c0f84$var$clampRgbUnit = (v)=>(0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $a36b8fd0713c0f84$export$7a99c86b5b1f4c9e = {
    ...(0, $45353614456d19cf$export$98e628dec113755e),
    transform: (v)=>Math.round($a36b8fd0713c0f84$var$clampRgbUnit(v))
};
const $a36b8fd0713c0f84$export$4e46ac54fc82cf3b = {
    test: (0, $e34063dbf1337d54$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $e34063dbf1337d54$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $a36b8fd0713c0f84$export$7a99c86b5b1f4c9e.transform(red) + ", " + $a36b8fd0713c0f84$export$7a99c86b5b1f4c9e.transform(green) + ", " + $a36b8fd0713c0f84$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $1f499153cf8251ff$export$83d2e9e3e4ee39ed)((0, $45353614456d19cf$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $dc9226eb9c441f2f$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $dc9226eb9c441f2f$export$834dfc94dde4b3d8 = {
    test: (0, $e34063dbf1337d54$export$2c8400d58aca05e)("#"),
    parse: $dc9226eb9c441f2f$var$parseHex,
    transform: (0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b).transform
};






const $5bf7839fd94a36d2$export$810b04175080204c = {
    test: (0, $e34063dbf1337d54$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $e34063dbf1337d54$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ff0d5edf20a77464$export$626336c2cd4b14de).transform((0, $1f499153cf8251ff$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $ff0d5edf20a77464$export$626336c2cd4b14de).transform((0, $1f499153cf8251ff$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $1f499153cf8251ff$export$83d2e9e3e4ee39ed)((0, $45353614456d19cf$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $992a91550fd1b376$export$35e9368ef982300f = {
    test: (v)=>(0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b).test(v) || (0, $dc9226eb9c441f2f$export$834dfc94dde4b3d8).test(v) || (0, $5bf7839fd94a36d2$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b).test(v)) return (0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $5bf7839fd94a36d2$export$810b04175080204c).test(v)) return (0, $5bf7839fd94a36d2$export$810b04175080204c).parse(v);
        else return (0, $dc9226eb9c441f2f$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $1f499153cf8251ff$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b).transform(v) : (0, $5bf7839fd94a36d2$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $3e00f7c3658443dd$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $f4d0082ce0d7ffb1$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f4d0082ce0d7ffb1$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f4d0082ce0d7ffb1$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f4d0082ce0d7ffb1$var$hueToRgb(p, q, hue);
        blue = $f4d0082ce0d7ffb1$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $e0afa4b22912cfd3$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $e0afa4b22912cfd3$var$colorTypes = [
    (0, $dc9226eb9c441f2f$export$834dfc94dde4b3d8),
    (0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b),
    (0, $5bf7839fd94a36d2$export$810b04175080204c)
];
const $e0afa4b22912cfd3$var$getColorType = (v)=>$e0afa4b22912cfd3$var$colorTypes.find((type)=>type.test(v));
function $e0afa4b22912cfd3$var$asRGBA(color) {
    const type = $e0afa4b22912cfd3$var$getColorType(color);
    (0, $e9fa7280c44589a0$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $5bf7839fd94a36d2$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $f4d0082ce0d7ffb1$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $e0afa4b22912cfd3$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $e0afa4b22912cfd3$var$asRGBA(from);
    const toRGBA = $e0afa4b22912cfd3$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $e0afa4b22912cfd3$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $e0afa4b22912cfd3$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $e0afa4b22912cfd3$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $a36b8fd0713c0f84$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $c62cbd6c5e1cf34f$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $1f499153cf8251ff$export$844ec244b1367d54)(v) && (((_a = v.match((0, $1f499153cf8251ff$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $1f499153cf8251ff$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $c62cbd6c5e1cf34f$var$cssVarTokeniser = {
    regex: (0, $9bea4890e7790ee2$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $0eca9a23e11b208d$export$8793edee2d425525)
};
const $c62cbd6c5e1cf34f$var$colorTokeniser = {
    regex: (0, $1f499153cf8251ff$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $992a91550fd1b376$export$35e9368ef982300f).parse
};
const $c62cbd6c5e1cf34f$var$numberTokeniser = {
    regex: (0, $1f499153cf8251ff$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $45353614456d19cf$export$98e628dec113755e).parse
};
function $c62cbd6c5e1cf34f$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $c62cbd6c5e1cf34f$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $c62cbd6c5e1cf34f$var$tokenise(info, $c62cbd6c5e1cf34f$var$cssVarTokeniser);
    $c62cbd6c5e1cf34f$var$tokenise(info, $c62cbd6c5e1cf34f$var$colorTokeniser);
    $c62cbd6c5e1cf34f$var$tokenise(info, $c62cbd6c5e1cf34f$var$numberTokeniser);
    return info;
}
function $c62cbd6c5e1cf34f$var$parseComplexValue(v) {
    return $c62cbd6c5e1cf34f$export$b61fc7c44bf646d5(v).values;
}
function $c62cbd6c5e1cf34f$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $c62cbd6c5e1cf34f$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($c62cbd6c5e1cf34f$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($c62cbd6c5e1cf34f$var$colorTokeniser.token, (0, $992a91550fd1b376$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($c62cbd6c5e1cf34f$var$numberTokeniser.token, (0, $1f499153cf8251ff$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $c62cbd6c5e1cf34f$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $c62cbd6c5e1cf34f$var$getAnimatableNone(v) {
    const parsed = $c62cbd6c5e1cf34f$var$parseComplexValue(v);
    const transformer = $c62cbd6c5e1cf34f$var$createTransformer(v);
    return transformer(parsed.map($c62cbd6c5e1cf34f$var$convertNumbersToZero));
}
const $c62cbd6c5e1cf34f$export$83a0e34f1302825b = {
    test: $c62cbd6c5e1cf34f$var$test,
    parse: $c62cbd6c5e1cf34f$var$parseComplexValue,
    createTransformer: $c62cbd6c5e1cf34f$var$createTransformer,
    getAnimatableNone: $c62cbd6c5e1cf34f$var$getAnimatableNone
};


const $fcf20520a319b677$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $fcf20520a319b677$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $992a91550fd1b376$export$35e9368ef982300f).test(origin)) return (0, $e0afa4b22912cfd3$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $fcf20520a319b677$var$mixImmediate(origin, target) : $fcf20520a319b677$export$65516310a87d8205(origin, target);
}
const $fcf20520a319b677$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$fcf20520a319b677$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $fcf20520a319b677$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $fcf20520a319b677$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $fcf20520a319b677$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $c62cbd6c5e1cf34f$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $c62cbd6c5e1cf34f$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $edc9aad1460f89ff$export$a4627e546088548d)($fcf20520a319b677$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $e9fa7280c44589a0$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $fcf20520a319b677$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $e35631e0cd0a469e$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $53cc4942ea6653ad$var$mixNumber = (from, to)=>(p)=>(0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(from, to, p);
function $53cc4942ea6653ad$var$detectMixerFactory(v) {
    if (typeof v === "number") return $53cc4942ea6653ad$var$mixNumber;
    else if (typeof v === "string") return (0, $992a91550fd1b376$export$35e9368ef982300f).test(v) ? (0, $e0afa4b22912cfd3$export$51e568cf5c039bac) : (0, $fcf20520a319b677$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $fcf20520a319b677$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $fcf20520a319b677$export$ebc23b6840c51ba1;
    return $53cc4942ea6653ad$var$mixNumber;
}
function $53cc4942ea6653ad$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $53cc4942ea6653ad$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $0eca9a23e11b208d$export$8793edee2d425525) : ease;
            mixer = (0, $edc9aad1460f89ff$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $53cc4942ea6653ad$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $e9fa7280c44589a0$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $53cc4942ea6653ad$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $e35631e0cd0a469e$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $f969cbedebe719ca$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $e35631e0cd0a469e$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $1935b5964b281c5e$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $f969cbedebe719ca$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $2f5f8b80003cb4ed$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $1975694e8a170fca$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $eacef97532bb161f$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $1975694e8a170fca$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $feade9edb3680bd5$export$216948827bbdc797)(ease) ? ease.map((0, $9e8db153a43f0760$export$ef97fe084f156ca4)) : (0, $9e8db153a43f0760$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $2f5f8b80003cb4ed$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $1935b5964b281c5e$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $53cc4942ea6653ad$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $1975694e8a170fca$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $90430efacaa86001$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $da4d45ab5b2f6ec2$var$velocitySampleDuration = 5; // ms
function $da4d45ab5b2f6ec2$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $da4d45ab5b2f6ec2$var$velocitySampleDuration, 0);
    return (0, $90430efacaa86001$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $e4ce76c6bdcbfc33$var$safeMin = 0.001;
const $e4ce76c6bdcbfc33$export$a3cdb76e84ee608e = 0.01;
const $e4ce76c6bdcbfc33$export$1824b851fad8862b = 10.0;
const $e4ce76c6bdcbfc33$export$ff08f2d53484465 = 0.05;
const $e4ce76c6bdcbfc33$export$201ca48e54038115 = 1;
function $e4ce76c6bdcbfc33$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $e9fa7280c44589a0$export$491112666e282270)(duration <= (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)($e4ce76c6bdcbfc33$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)($e4ce76c6bdcbfc33$export$ff08f2d53484465, $e4ce76c6bdcbfc33$export$201ca48e54038115, dampingRatio);
    duration = (0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)($e4ce76c6bdcbfc33$export$a3cdb76e84ee608e, $e4ce76c6bdcbfc33$export$1824b851fad8862b, (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $e4ce76c6bdcbfc33$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $e4ce76c6bdcbfc33$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $e4ce76c6bdcbfc33$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $e4ce76c6bdcbfc33$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$e4ce76c6bdcbfc33$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $e4ce76c6bdcbfc33$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $e4ce76c6bdcbfc33$var$rootIterations = 12;
function $e4ce76c6bdcbfc33$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $e4ce76c6bdcbfc33$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $e4ce76c6bdcbfc33$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $ceda95cb8f8675df$var$durationKeys = [
    "duration",
    "bounce"
];
const $ceda95cb8f8675df$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $ceda95cb8f8675df$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $ceda95cb8f8675df$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$ceda95cb8f8675df$var$isSpringType(options, $ceda95cb8f8675df$var$physicsKeys) && $ceda95cb8f8675df$var$isSpringType(options, $ceda95cb8f8675df$var$durationKeys)) {
        const derived = (0, $e4ce76c6bdcbfc33$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $ceda95cb8f8675df$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $ceda95cb8f8675df$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $e4ce76c6bdcbfc33$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $da4d45ab5b2f6ec2$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $bf71f26dd6e10aea$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $ceda95cb8f8675df$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $da4d45ab5b2f6ec2$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $51952e42e6449bb2$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).isProcessing ? (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $70340219b9f0a7d7$export$f4ff70a5b4808fd8 = 20000;
function $70340219b9f0a7d7$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $70340219b9f0a7d7$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $70340219b9f0a7d7$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $5c0ac7ab8625287f$var$types = {
    decay: (0, $bf71f26dd6e10aea$export$ee3ff3a17106998),
    inertia: $bf71f26dd6e10aea$export$ee3ff3a17106998,
    tween: (0, $1975694e8a170fca$export$d25ddfdf17c3ad3e),
    keyframes: (0, $1975694e8a170fca$export$d25ddfdf17c3ad3e),
    spring: $ceda95cb8f8675df$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $5c0ac7ab8625287f$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $51952e42e6449bb2$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $5c0ac7ab8625287f$var$types[type] || (0, $1975694e8a170fca$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $1975694e8a170fca$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $53cc4942ea6653ad$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $70340219b9f0a7d7$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $70340219b9f0a7d7$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $e503f18eb863e060$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $83c8557959e113fd$var$supportsWaapi = (0, $e503f18eb863e060$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $83c8557959e113fd$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $83c8557959e113fd$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $83c8557959e113fd$var$maxDuration = 20000;
const $83c8557959e113fd$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $788726c9e4398b5c$export$fcdd8f3f2160beda)(options.ease);
function $83c8557959e113fd$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $83c8557959e113fd$var$supportsWaapi() && $83c8557959e113fd$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($83c8557959e113fd$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $5c0ac7ab8625287f$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $83c8557959e113fd$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $83c8557959e113fd$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $83c8557959e113fd$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $75bccdfa64eb9ce7$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */ if (options.syncStart) animation.startTime = (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).isProcessing ? (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp : document.timeline ? document.timeline.currentTime : performance.now();
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $7ce9a7d155295689$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $0eca9a23e11b208d$export$8793edee2d425525;
        },
        get time () {
            return (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $5c0ac7ab8625287f$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $83c8557959e113fd$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $83c8557959e113fd$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $48393e50c2e14a85$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $0eca9a23e11b208d$export$8793edee2d425525),
            pause: (0, $0eca9a23e11b208d$export$8793edee2d425525),
            stop: (0, $0eca9a23e11b208d$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $0eca9a23e11b208d$export$8793edee2d425525),
            complete: (0, $0eca9a23e11b208d$export$8793edee2d425525)
        };
    };
    return delay ? (0, $5c0ac7ab8625287f$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $cb0c1a1da5ec181e$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $cb0c1a1da5ec181e$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $cb0c1a1da5ec181e$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $cb0c1a1da5ec181e$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $cb0c1a1da5ec181e$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $cb0c1a1da5ec181e$var$keyframesTransition;
    else if ((0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $cb0c1a1da5ec181e$var$criticallyDampedSpring(keyframes[1]) : $cb0c1a1da5ec181e$var$underDampedSpring;
    return $cb0c1a1da5ec181e$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $980f5cb4cc96bc5f$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $9d177cb550fc5281$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9d177cb550fc5281$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $1f499153cf8251ff$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9d177cb550fc5281$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9d177cb550fc5281$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $9d177cb550fc5281$export$3dea766d36a8935f = {
    ...(0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($9d177cb550fc5281$var$functionRegex);
        return functions ? functions.map($9d177cb550fc5281$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $5f8b2e638e139982$export$98cd7c72c5a731fb = {
    ...(0, $5f3e75d790bf898d$export$eec14432cd1cb67b),
    color: // Color props
    $992a91550fd1b376$export$35e9368ef982300f,
    backgroundColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    outlineColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    fill: (0, $992a91550fd1b376$export$35e9368ef982300f),
    stroke: (0, $992a91550fd1b376$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    borderTopColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    borderRightColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    borderBottomColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    borderLeftColor: (0, $992a91550fd1b376$export$35e9368ef982300f),
    filter: $9d177cb550fc5281$export$3dea766d36a8935f,
    WebkitFilter: (0, $9d177cb550fc5281$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5f8b2e638e139982$export$67d1babe0338d23b = (key)=>$5f8b2e638e139982$export$98cd7c72c5a731fb[key];


function $ad59be11c08b10a1$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5f8b2e638e139982$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $9d177cb550fc5281$export$3dea766d36a8935f)) defaultValueType = (0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $ef2561d42a896c4f$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $44cdd92be2178f1f$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $ef2561d42a896c4f$export$ade84c85e44a6cb1)(value);
}


function $36f19fb90410957d$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $980f5cb4cc96bc5f$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $44cdd92be2178f1f$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $ad59be11c08b10a1$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $8ccfe363436b3d52$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $8ccfe363436b3d52$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $1d8b88ddf1b5ffc3$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $8ccfe363436b3d52$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $36f19fb90410957d$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $980f5cb4cc96bc5f$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $980f5cb4cc96bc5f$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $e9fa7280c44589a0$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $8ccfe363436b3d52$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $cb0c1a1da5ec181e$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $1af661ba29024555$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $48393e50c2e14a85$export$6f34fc8ef6c42b70)((0, $1af661ba29024555$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $83c8557959e113fd$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $5c0ac7ab8625287f$export$ee9b76de7353d815)(options);
    };
};



function $fc68338e527e1e2a$export$98397f3adbf6259f(value) {
    return Boolean((0, $bb62727ea8cab401$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $033973daeb8869c4$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $d2dd061b942897d8$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $d2dd061b942897d8$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $d2dd061b942897d8$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $74e3145b191de5e8$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $d2dd061b942897d8$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $d2dd061b942897d8$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}





const $09bd23c1b3eae755$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $09bd23c1b3eae755$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $09bd23c1b3eae755$export$8cea36d14ee64562 {
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $74e3145b191de5e8$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($09bd23c1b3eae755$export$67fcd818a264039d.current) $09bd23c1b3eae755$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $90430efacaa86001$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.16.7";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $09bd23c1b3eae755$var$isFloat(this.current);
        this.owner = options.owner;
    }
}
function $09bd23c1b3eae755$export$ce8bdc721e76545f(init, options) {
    return new $09bd23c1b3eae755$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $fcb420c3f4d6107a$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $e2c3ba8438b09402$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $cb2f2f5e272874a2$export$d176691c1998a1f5 = [
    (0, $45353614456d19cf$export$98e628dec113755e),
    (0, $ff0d5edf20a77464$export$91c0eda1d06bf008),
    (0, $ff0d5edf20a77464$export$626336c2cd4b14de),
    (0, $ff0d5edf20a77464$export$41fc368e1a942b97),
    (0, $ff0d5edf20a77464$export$aed3d7b7d206c196),
    (0, $ff0d5edf20a77464$export$f91e8c45a95a32f2),
    (0, $e2c3ba8438b09402$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $cb2f2f5e272874a2$export$eefdd52e3ccae428 = (v)=>$cb2f2f5e272874a2$export$d176691c1998a1f5.find((0, $fcb420c3f4d6107a$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $5b2f2c95f5fddbb9$var$valueTypes = [
    ...(0, $cb2f2f5e272874a2$export$d176691c1998a1f5),
    (0, $992a91550fd1b376$export$35e9368ef982300f),
    (0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $5b2f2c95f5fddbb9$export$950e7e59ea1ffed7 = (v)=>$5b2f2c95f5fddbb9$var$valueTypes.find((0, $fcb420c3f4d6107a$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $1127fa396a6d5b62$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $09bd23c1b3eae755$export$ce8bdc721e76545f)(value));
}
function $1127fa396a6d5b62$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $48ac66acf47ec559$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $2a9071a29f66d2e8$export$5485128c47bd48bb)(target[key]);
        $1127fa396a6d5b62$var$setMotionValue(visualElement, key, value);
    }
}
function $1127fa396a6d5b62$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $1127fa396a6d5b62$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $1127fa396a6d5b62$var$setVariants(child, variantLabels);
        });
    });
}
function $1127fa396a6d5b62$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $1127fa396a6d5b62$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $1127fa396a6d5b62$var$setVariants(visualElement, [
        definition
    ]);
    else $1127fa396a6d5b62$export$1f61c53461aff4a5(visualElement, definition);
}
function $1127fa396a6d5b62$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $033973daeb8869c4$export$65583ed5a868f2d9)(value) || (0, $ef2561d42a896c4f$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $5b2f2c95f5fddbb9$export$950e7e59ea1ffed7)(value) && (0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b).test(targetValue)) value = (0, $ad59be11c08b10a1$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $09bd23c1b3eae755$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $1127fa396a6d5b62$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $1127fa396a6d5b62$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $1127fa396a6d5b62$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $2f95c96bd674d22b$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $2f95c96bd674d22b$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $2f95c96bd674d22b$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $af8518df201286cf$export$8592e1c077c890a6];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d));
                valueTransition.syncStart = true;
            }
        }
        value.start((0, $1d8b88ddf1b5ffc3$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $fc68338e527e1e2a$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $1127fa396a6d5b62$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $46c189e83cc15f77$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $48ac66acf47ec559$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $2f95c96bd674d22b$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $46c189e83cc15f77$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $46c189e83cc15f77$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($46c189e83cc15f77$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($46c189e83cc15f77$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $46c189e83cc15f77$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $f8ae7d831ba5fc70$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $46c189e83cc15f77$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $46c189e83cc15f77$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $48ac66acf47ec559$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $2f95c96bd674d22b$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $49204dd8cfdef81a$var$reversePriorityOrder = [
    ...(0, $90bbd5b0e4403b6f$export$16e45afcc206d3a8)
].reverse();
const $49204dd8cfdef81a$var$numAnimationTypes = (0, $90bbd5b0e4403b6f$export$16e45afcc206d3a8).length;
function $49204dd8cfdef81a$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $f8ae7d831ba5fc70$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $49204dd8cfdef81a$export$bb53502b7a672aa8(visualElement) {
    let animate = $49204dd8cfdef81a$var$animateList(visualElement);
    const state = $49204dd8cfdef81a$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $48ac66acf47ec559$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $49204dd8cfdef81a$var$numAnimationTypes; i++){
            const type = $49204dd8cfdef81a$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $cf9a579fabd47d14$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $0ff067b1f8954c56$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $49204dd8cfdef81a$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $f37a908eb8ed8ba6$export$9153ad4c4999f4a0)(next) && (0, $f37a908eb8ed8ba6$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $c002467f696c0b79$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $49204dd8cfdef81a$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $c002467f696c0b79$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $49204dd8cfdef81a$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $49204dd8cfdef81a$var$createState() {
    return {
        animate: $49204dd8cfdef81a$var$createTypeState(true),
        whileInView: $49204dd8cfdef81a$var$createTypeState(),
        whileHover: $49204dd8cfdef81a$var$createTypeState(),
        whileTap: $49204dd8cfdef81a$var$createTypeState(),
        whileDrag: $49204dd8cfdef81a$var$createTypeState(),
        whileFocus: $49204dd8cfdef81a$var$createTypeState(),
        exit: $49204dd8cfdef81a$var$createTypeState()
    };
}



class $f6a9c87179214dae$export$b45b3fe5caabdca extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $0ff067b1f8954c56$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $49204dd8cfdef81a$export$bb53502b7a672aa8)(node));
    }
}



let $4c6e705b5858a78b$var$id = 0;
class $4c6e705b5858a78b$export$4989d1eb6104cc6c extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $4c6e705b5858a78b$var$id++;
    }
}


const $9bb9392be544c52d$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f6a9c87179214dae$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $4c6e705b5858a78b$export$4989d1eb6104cc6c)
    }
};









const $8df1b266d7b10633$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8df1b266d7b10633$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8df1b266d7b10633$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8df1b266d7b10633$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $caca2cdd35c93217$export$d9c66232c9c4689c {
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $caca2cdd35c93217$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8df1b266d7b10633$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $caca2cdd35c93217$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $9ae03fcd9fa90244$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event);
        const initialInfo = $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $caca2cdd35c93217$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $edc9aad1460f89ff$export$a4627e546088548d)((0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
}
function $caca2cdd35c93217$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $caca2cdd35c93217$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $caca2cdd35c93217$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $caca2cdd35c93217$var$subtractPoint(point, $caca2cdd35c93217$var$lastDevicePoint(history)),
        offset: $caca2cdd35c93217$var$subtractPoint(point, $caca2cdd35c93217$var$startDevicePoint(history)),
        velocity: $caca2cdd35c93217$var$getVelocity(history, 0.1)
    };
}
function $caca2cdd35c93217$var$startDevicePoint(history) {
    return history[0];
}
function $caca2cdd35c93217$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $caca2cdd35c93217$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $caca2cdd35c93217$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $96ae4a6175eac365$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $96ae4a6175eac365$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $0faee63ecf63dcff$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $0faee63ecf63dcff$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $0faee63ecf63dcff$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $0faee63ecf63dcff$export$c1c127004b72a37(target) / $0faee63ecf63dcff$export$c1c127004b72a37(source);
    if ($0faee63ecf63dcff$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($0faee63ecf63dcff$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $0faee63ecf63dcff$export$c0d25e96fc67d310(delta, source, target, origin) {
    $0faee63ecf63dcff$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $0faee63ecf63dcff$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $0faee63ecf63dcff$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $0faee63ecf63dcff$export$c1c127004b72a37(relative);
}
function $0faee63ecf63dcff$export$426154f9d100f99(target, relative, parent) {
    $0faee63ecf63dcff$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $0faee63ecf63dcff$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $0faee63ecf63dcff$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $0faee63ecf63dcff$export$c1c127004b72a37(layout);
}
function $0faee63ecf63dcff$export$2785bfcc929c5650(target, layout, parent) {
    $0faee63ecf63dcff$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $0faee63ecf63dcff$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $1e37744b98f775f4$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $1e37744b98f775f4$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $1e37744b98f775f4$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $1e37744b98f775f4$export$690c180aa5775042(layoutBox.x, left, right),
        y: $1e37744b98f775f4$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $1e37744b98f775f4$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $1e37744b98f775f4$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $1e37744b98f775f4$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $1e37744b98f775f4$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $1e37744b98f775f4$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(source);
    const targetLength = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $e35631e0cd0a469e$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $e35631e0cd0a469e$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $1e37744b98f775f4$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $1e37744b98f775f4$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $1e37744b98f775f4$export$7c5eaef8f4723d22(dragElastic = $1e37744b98f775f4$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $1e37744b98f775f4$export$a3366d3bac43a742;
    return {
        x: $1e37744b98f775f4$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $1e37744b98f775f4$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $1e37744b98f775f4$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $1f131aef74d1d3af$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $1f131aef74d1d3af$export$3d227df54007d73a = ()=>({
        x: $1f131aef74d1d3af$export$ff25708b37f72782(),
        y: $1f131aef74d1d3af$export$ff25708b37f72782()
    });
const $1f131aef74d1d3af$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $1f131aef74d1d3af$export$6459fc9e86be362e = ()=>({
        x: $1f131aef74d1d3af$export$6db76765312617ac(),
        y: $1f131aef74d1d3af$export$6db76765312617ac()
    });


function $0e01654167de8de1$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $d3ed08020f6c32f7$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $d3ed08020f6c32f7$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $d3ed08020f6c32f7$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $71d9e97358d1bf45$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $71d9e97358d1bf45$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$71d9e97358d1bf45$var$isIdentityScale(scale) || !$71d9e97358d1bf45$var$isIdentityScale(scaleX) || !$71d9e97358d1bf45$var$isIdentityScale(scaleY);
}
function $71d9e97358d1bf45$export$a545127cf1fbb600(values) {
    return $71d9e97358d1bf45$export$bdf30dca883ea463(values) || $71d9e97358d1bf45$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $71d9e97358d1bf45$export$bf80f5f8f4dc327f(values) {
    return $71d9e97358d1bf45$var$is2DTranslate(values.x) || $71d9e97358d1bf45$var$is2DTranslate(values.y);
}
function $71d9e97358d1bf45$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $8dc4e4c06656cf30$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $8dc4e4c06656cf30$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $8dc4e4c06656cf30$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $8dc4e4c06656cf30$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $8dc4e4c06656cf30$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $8dc4e4c06656cf30$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $8dc4e4c06656cf30$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $8dc4e4c06656cf30$export$d80074982803af5c(box, { x: x, y: y }) {
    $8dc4e4c06656cf30$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $8dc4e4c06656cf30$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $8dc4e4c06656cf30$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $8dc4e4c06656cf30$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $8dc4e4c06656cf30$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $71d9e97358d1bf45$export$a545127cf1fbb600)(node.latestValues)) $8dc4e4c06656cf30$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $8dc4e4c06656cf30$var$snapToDefault(treeScale.x);
    treeScale.y = $8dc4e4c06656cf30$var$snapToDefault(treeScale.y);
}
function $8dc4e4c06656cf30$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $8dc4e4c06656cf30$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $8dc4e4c06656cf30$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $8dc4e4c06656cf30$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $8dc4e4c06656cf30$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $8dc4e4c06656cf30$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $8dc4e4c06656cf30$export$58b16271041fbfb(box, transform) {
    $8dc4e4c06656cf30$export$625f1dd140a2f5e7(box.x, transform, $8dc4e4c06656cf30$var$xKeys);
    $8dc4e4c06656cf30$export$625f1dd140a2f5e7(box.y, transform, $8dc4e4c06656cf30$var$yKeys);
}


function $b2660c7be3e466a6$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $d3ed08020f6c32f7$export$d3955c6a8f65a36b)((0, $d3ed08020f6c32f7$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $b2660c7be3e466a6$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $b2660c7be3e466a6$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $4089e47ff1a2b128$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $a35deb4b2fbeb723$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $a35deb4b2fbeb723$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $a7404270087418a0$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ff0d5edf20a77464$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $a35deb4b2fbeb723$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $caca2cdd35c93217$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            contextWindow: (0, $4089e47ff1a2b128$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $1e37744b98f775f4$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $1e37744b98f775f4$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $1e37744b98f775f4$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $1e37744b98f775f4$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $881a839ff5ec248c$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $e9fa7280c44589a0$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $b2660c7be3e466a6$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $1e37744b98f775f4$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $d3ed08020f6c32f7$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $d3ed08020f6c32f7$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $1d8b88ddf1b5ffc3$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $1e37744b98f775f4$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $a35deb4b2fbeb723$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $1e37744b98f775f4$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
}
function $a35deb4b2fbeb723$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $a35deb4b2fbeb723$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $4c6ddc74cf07a272$export$5d97dc2872682820 extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $0eca9a23e11b208d$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $0eca9a23e11b208d$export$8793edee2d425525);
        this.removeListeners = (0, $0eca9a23e11b208d$export$8793edee2d425525);
        this.controls = new (0, $a35deb4b2fbeb723$export$86bff71f18910307)(node);
    }
}








const $11e1e830cf2014df$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $11e1e830cf2014df$export$b4f8f1ee75ce5859 extends (0, $f9402c45bde3a9c6$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $caca2cdd35c93217$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $4089e47ff1a2b128$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $11e1e830cf2014df$var$asyncHandler(onPanSessionStart),
            onStart: $11e1e830cf2014df$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $0eca9a23e11b208d$export$8793edee2d425525);
    }
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $0b8f44c4758488da$export$2a8c16d82a0a0e26() {
    const context = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $7fPBF.useId)();
    (0, $7fPBF.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $0b8f44c4758488da$export$8249053f690ea39a() {
    return $0b8f44c4758488da$export$ee27c052bca048fb((0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2)));
}
function $0b8f44c4758488da$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $874fe2ea807af794$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $6786a9a504abb82a$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $6786a9a504abb82a$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ff0d5edf20a77464$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $6786a9a504abb82a$export$fafff692be55225d(latest, node.target.x);
        const y = $6786a9a504abb82a$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $00bb8f1862db9493$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $c62cbd6c5e1cf34f$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $fb4bab01f29b923f$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $e57013859c9cf5f3$export$de9e7791c71225fd)($fb4bab01f29b923f$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $874fe2ea807af794$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $fb4bab01f29b923f$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $0b8f44c4758488da$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($fb4bab01f29b923f$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $7fPBF.useContext)((0, $813b6750233d847f$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $fb4bab01f29b923f$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $6786a9a504abb82a$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $6786a9a504abb82a$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $6786a9a504abb82a$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $6786a9a504abb82a$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $6786a9a504abb82a$export$5eafb6257a5844c),
    boxShadow: (0, $00bb8f1862db9493$export$eb0bc629e74dcf8)
};








const $3293e83353dbb9d2$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $3293e83353dbb9d2$var$numBorders = $3293e83353dbb9d2$var$borders.length;
const $3293e83353dbb9d2$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $3293e83353dbb9d2$var$isPx = (value)=>typeof value === "number" || (0, $ff0d5edf20a77464$export$91c0eda1d06bf008).test(value);
function $3293e83353dbb9d2$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $3293e83353dbb9d2$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $3293e83353dbb9d2$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $3293e83353dbb9d2$var$numBorders; i++){
        const borderLabel = `border${$3293e83353dbb9d2$var$borders[i]}Radius`;
        let followRadius = $3293e83353dbb9d2$var$getRadius(follow, borderLabel);
        let leadRadius = $3293e83353dbb9d2$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $3293e83353dbb9d2$var$isPx(followRadius) === $3293e83353dbb9d2$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)($3293e83353dbb9d2$var$asNumber(followRadius), $3293e83353dbb9d2$var$asNumber(leadRadius), progress), 0);
            if ((0, $ff0d5edf20a77464$export$626336c2cd4b14de).test(leadRadius) || (0, $ff0d5edf20a77464$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $3293e83353dbb9d2$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $3293e83353dbb9d2$var$easeCrossfadeIn = $3293e83353dbb9d2$var$compress(0, 0.5, (0, $3fe67aad12992024$export$c8d67a19199d1a50));
const $3293e83353dbb9d2$var$easeCrossfadeOut = $3293e83353dbb9d2$var$compress(0.5, 0.95, (0, $0eca9a23e11b208d$export$8793edee2d425525));
function $3293e83353dbb9d2$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $e35631e0cd0a469e$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5d9effa9de3ff6bb$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5d9effa9de3ff6bb$export$c53fd88f45d77e4b(box, originBox) {
    $5d9effa9de3ff6bb$export$a0230ae482601ae8(box.x, originBox.x);
    $5d9effa9de3ff6bb$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $88d2196b1db722f0$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $8dc4e4c06656cf30$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $8dc4e4c06656cf30$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $88d2196b1db722f0$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ff0d5edf20a77464$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $88d2196b1db722f0$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $88d2196b1db722f0$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $88d2196b1db722f0$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $88d2196b1db722f0$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $88d2196b1db722f0$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $88d2196b1db722f0$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $88d2196b1db722f0$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $88d2196b1db722f0$export$42b76f1d0d16d5b(box.x, transforms, $88d2196b1db722f0$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $88d2196b1db722f0$export$42b76f1d0d16d5b(box.y, transforms, $88d2196b1db722f0$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $52f15e0c583d172b$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $52f15e0c583d172b$export$a7ec7642fe550fb6(delta) {
    return $52f15e0c583d172b$var$isAxisDeltaZero(delta.x) && $52f15e0c583d172b$var$isAxisDeltaZero(delta.y);
}
function $52f15e0c583d172b$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $52f15e0c583d172b$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $52f15e0c583d172b$export$c5706146bc63213(box) {
    return (0, $0faee63ecf63dcff$export$c1c127004b72a37)(box.x) / (0, $0faee63ecf63dcff$export$c1c127004b72a37)(box.y);
}



class $0cdb17640d029db2$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $d2dd061b942897d8$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $d2dd061b942897d8$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}



function $2b66b29b86f19dbd$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $c5dbaa1ace98cd36$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e1bdb730ee810804$export$1465d17e3de78a96 {
    add(child) {
        (0, $d2dd061b942897d8$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $d2dd061b942897d8$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $c5dbaa1ace98cd36$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}





/**
 * Timeout defined in ms
 */ function $b6393b5830f20a51$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(checkElapsed);
}



function $113fa9ca82eb0ab0$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $d10a57f6b40c8d5b$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $68c37e24dc04aae1$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $bb62727ea8cab401$export$605d60a2578142d3)(value) ? value : (0, $09bd23c1b3eae755$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $1d8b88ddf1b5ffc3$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $e937d8999e84f8b3$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $e937d8999e84f8b3$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $e937d8999e84f8b3$var$animationTarget = 1000;
let $e937d8999e84f8b3$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $e937d8999e84f8b3$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $e937d8999e84f8b3$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $74e3145b191de5e8$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $d10a57f6b40c8d5b$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $b6393b5830f20a51$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $874fe2ea807af794$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $874fe2ea807af794$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($e937d8999e84f8b3$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $e937d8999e84f8b3$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $52f15e0c583d172b$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $8ccfe363436b3d52$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $e937d8999e84f8b3$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($e937d8999e84f8b3$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($e937d8999e84f8b3$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($e937d8999e84f8b3$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($e937d8999e84f8b3$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($e937d8999e84f8b3$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($e937d8999e84f8b3$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).delta = (0, $874dc586b35ff5e5$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp);
            (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp = now;
            (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).isProcessing = true;
            (0, $4bfc6ff75ec6ae14$export$be3f796aed065412).update.process((0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce));
            (0, $4bfc6ff75ec6ae14$export$be3f796aed065412).preRender.process((0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce));
            (0, $4bfc6ff75ec6ae14$export$be3f796aed065412).render.process((0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce));
            (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($e937d8999e84f8b3$var$clearSnapshot);
            this.sharedNodes.forEach($e937d8999e84f8b3$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $52f15e0c583d172b$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $71d9e97358d1bf45$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $e937d8999e84f8b3$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $8dc4e4c06656cf30$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $8dc4e4c06656cf30$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $71d9e97358d1bf45$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $8dc4e4c06656cf30$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $71d9e97358d1bf45$export$a545127cf1fbb600)(this.latestValues)) (0, $8dc4e4c06656cf30$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $71d9e97358d1bf45$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $71d9e97358d1bf45$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $88d2196b1db722f0$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $71d9e97358d1bf45$export$a545127cf1fbb600)(this.latestValues)) (0, $88d2196b1db722f0$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    (0, $0faee63ecf63dcff$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $0faee63ecf63dcff$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $8dc4e4c06656cf30$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    (0, $0faee63ecf63dcff$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $e937d8999e84f8b3$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $71d9e97358d1bf45$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $71d9e97358d1bf45$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $4bfc6ff75ec6ae14$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $8dc4e4c06656cf30$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $1f131aef74d1d3af$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $1f131aef74d1d3af$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $1f131aef74d1d3af$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $0faee63ecf63dcff$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $2b66b29b86f19dbd$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $e937d8999e84f8b3$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $1f131aef74d1d3af$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($e937d8999e84f8b3$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $e937d8999e84f8b3$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $e937d8999e84f8b3$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $0faee63ecf63dcff$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $e937d8999e84f8b3$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $52f15e0c583d172b$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $3293e83353dbb9d2$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(()=>{
                (0, $874fe2ea807af794$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $68c37e24dc04aae1$export$335a17c977067b99)(0, $e937d8999e84f8b3$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($e937d8999e84f8b3$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $e937d8999e84f8b3$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                const xLength = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5d9effa9de3ff6bb$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $8dc4e4c06656cf30$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $0faee63ecf63dcff$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $0cdb17640d029db2$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $e937d8999e84f8b3$var$transformAxes.length; i++){
                const key = "rotate" + $e937d8999e84f8b3$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $e937d8999e84f8b3$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $0fd34dcca7ac00f9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $0fd34dcca7ac00f9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $71d9e97358d1bf45$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $2b66b29b86f19dbd$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $e57013859c9cf5f3$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $e57013859c9cf5f3$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $0fd34dcca7ac00f9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($e937d8999e84f8b3$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $e937d8999e84f8b3$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $e937d8999e84f8b3$var$projectionFrameData.totalNodes = $e937d8999e84f8b3$var$projectionFrameData.resolvedTargetDeltas = $e937d8999e84f8b3$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($e937d8999e84f8b3$export$131f2f0cc5fe9609);
                this.nodes.forEach($e937d8999e84f8b3$var$resolveTargetDelta);
                this.nodes.forEach($e937d8999e84f8b3$var$calcProjection);
                this.nodes.forEach($e937d8999e84f8b3$export$c2664f37bc951031);
                (0, $113fa9ca82eb0ab0$export$e5185e241753e543)($e937d8999e84f8b3$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e1bdb730ee810804$export$1465d17e3de78a96)();
        }
    };
}
function $e937d8999e84f8b3$var$updateLayout(node) {
    node.updateLayout();
}
function $e937d8999e84f8b3$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($e937d8999e84f8b3$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $0e01654167de8de1$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $0faee63ecf63dcff$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $1f131aef74d1d3af$export$3d227df54007d73a)();
        (0, $0faee63ecf63dcff$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $1f131aef74d1d3af$export$3d227df54007d73a)();
        if (isShared) (0, $0faee63ecf63dcff$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $0faee63ecf63dcff$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $52f15e0c583d172b$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    (0, $0faee63ecf63dcff$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
                    (0, $0faee63ecf63dcff$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $52f15e0c583d172b$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $e937d8999e84f8b3$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $e937d8999e84f8b3$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $e937d8999e84f8b3$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $e937d8999e84f8b3$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $e937d8999e84f8b3$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $e937d8999e84f8b3$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $e937d8999e84f8b3$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $e937d8999e84f8b3$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $e937d8999e84f8b3$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $e937d8999e84f8b3$var$calcProjection(node) {
    node.calcProjection();
}
function $e937d8999e84f8b3$var$resetRotation(node) {
    node.resetRotation();
}
function $e937d8999e84f8b3$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $e937d8999e84f8b3$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $e937d8999e84f8b3$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $3e00f7c3658443dd$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $e937d8999e84f8b3$export$6ffd3e6ae339a132(output, from, to, p) {
    $e937d8999e84f8b3$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $e937d8999e84f8b3$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $e937d8999e84f8b3$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $e937d8999e84f8b3$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $e937d8999e84f8b3$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $e937d8999e84f8b3$var$roundPoint = $e937d8999e84f8b3$var$userAgentContains("applewebkit/") && !$e937d8999e84f8b3$var$userAgentContains("chrome/") ? Math.round : (0, $0eca9a23e11b208d$export$8793edee2d425525);
function $e937d8999e84f8b3$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $e937d8999e84f8b3$var$roundPoint(axis.min);
    axis.max = $e937d8999e84f8b3$var$roundPoint(axis.max);
}
function $e937d8999e84f8b3$var$roundBox(box) {
    $e937d8999e84f8b3$var$roundAxis(box.x);
    $e937d8999e84f8b3$var$roundAxis(box.y);
}
function $e937d8999e84f8b3$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $0faee63ecf63dcff$export$28d0384c4b79bde2)((0, $52f15e0c583d172b$export$c5706146bc63213)(snapshot), (0, $52f15e0c583d172b$export$c5706146bc63213)(layout), 0.2);
}




const $32d37450102b1639$export$2d029a49a09b6177 = (0, $e937d8999e84f8b3$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $b73d9e888c3c60f3$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $dbef83b35adb3d3b$export$b91509fcf893b648 = {
    current: undefined
};
const $dbef83b35adb3d3b$export$b61a9eb3dbde8858 = (0, $e937d8999e84f8b3$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$dbef83b35adb3d3b$export$b91509fcf893b648.current) {
            const documentNode = new (0, $32d37450102b1639$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $dbef83b35adb3d3b$export$b91509fcf893b648.current = documentNode;
        }
        return $dbef83b35adb3d3b$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $58aa614d3a6a82b6$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $11e1e830cf2014df$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $4c6ddc74cf07a272$export$5d97dc2872682820),
        ProjectionNode: (0, $dbef83b35adb3d3b$export$b61a9eb3dbde8858),
        MeasureLayout: $fb4bab01f29b923f$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $60654ef245337834$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $60654ef245337834$export$b9f0c1f373aee2b0(current) {
    const match = $60654ef245337834$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $60654ef245337834$var$maxDepth = 4;
function $60654ef245337834$var$getVariableValue(current, element, depth = 1) {
    (0, $e9fa7280c44589a0$export$f5708dca728d7177)(depth <= $60654ef245337834$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $60654ef245337834$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $033973daeb8869c4$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $9bea4890e7790ee2$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $60654ef245337834$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $60654ef245337834$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $9bea4890e7790ee2$export$31f9caa2600b5723)(current)) return;
        const resolved = $60654ef245337834$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $9bea4890e7790ee2$export$31f9caa2600b5723)(current)) continue;
        const resolved = $60654ef245337834$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $baddd6bb05731de7$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $baddd6bb05731de7$var$isPositionalKey = (key)=>$baddd6bb05731de7$var$positionalKeys.has(key);
const $baddd6bb05731de7$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($baddd6bb05731de7$var$isPositionalKey);
};
const $baddd6bb05731de7$var$isNumOrPxType = (v)=>v === (0, $45353614456d19cf$export$98e628dec113755e) || v === (0, $ff0d5edf20a77464$export$91c0eda1d06bf008);
const $baddd6bb05731de7$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $baddd6bb05731de7$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $baddd6bb05731de7$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $baddd6bb05731de7$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $baddd6bb05731de7$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $baddd6bb05731de7$var$nonTranslationalTransformKeys = (0, $a68c8b42e34fb3f9$export$280dc01950909d86).filter((key)=>!$baddd6bb05731de7$var$transformKeys.has(key));
function $baddd6bb05731de7$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $baddd6bb05731de7$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $baddd6bb05731de7$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $baddd6bb05731de7$var$getTranslateFromMatrix(4, 13),
    y: $baddd6bb05731de7$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$baddd6bb05731de7$export$781d46a8aa670d52.translateX = $baddd6bb05731de7$export$781d46a8aa670d52.x;
$baddd6bb05731de7$export$781d46a8aa670d52.translateY = $baddd6bb05731de7$export$781d46a8aa670d52.y;
const $baddd6bb05731de7$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $baddd6bb05731de7$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $baddd6bb05731de7$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $baddd6bb05731de7$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($baddd6bb05731de7$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $cb2f2f5e272874a2$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $f37a908eb8ed8ba6$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $cb2f2f5e272874a2$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $cb2f2f5e272874a2$export$eefdd52e3ccae428)(to[i]);
                    (0, $e9fa7280c44589a0$export$f5708dca728d7177)(toType === fromType || $baddd6bb05731de7$var$isNumOrPxType(fromType) && $baddd6bb05731de7$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $e9fa7280c44589a0$export$f5708dca728d7177)((0, $cb2f2f5e272874a2$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $cb2f2f5e272874a2$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($baddd6bb05731de7$var$isNumOrPxType(fromType) && $baddd6bb05731de7$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $ff0d5edf20a77464$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $baddd6bb05731de7$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $baddd6bb05731de7$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $eab4d64e1bdb7129$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $baddd6bb05731de7$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $baddd6bb05731de7$var$hasPositionalKey(target) ? $baddd6bb05731de7$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $4c5414901d35c401$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $60654ef245337834$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $baddd6bb05731de7$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $cb5417f97ee749d1$export$ff7706047246b98b = {
    current: null
};
const $cb5417f97ee749d1$export$6476d16e2fd2d0db = {
    current: false
};


function $246c267ad4291190$export$ca9f41fb23dded3d() {
    (0, $cb5417f97ee749d1$export$6476d16e2fd2d0db).current = true;
    if (!(0, $eab4d64e1bdb7129$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $cb5417f97ee749d1$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $cb5417f97ee749d1$export$ff7706047246b98b).current = false;
}














function $21b009f0fd79bf79$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $bb62727ea8cab401$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $fc68338e527e1e2a$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $bb62727ea8cab401$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $09bd23c1b3eae755$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $fc68338e527e1e2a$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $09bd23c1b3eae755$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $c0f7059e46f27f2d$export$bc2a978a17abfdde = new WeakMap();



const $82d25579e5668b1d$var$featureNames = Object.keys((0, $000eadb1a85dd08b$export$65570e08d843624d));
const $82d25579e5668b1d$var$numFeatures = $82d25579e5668b1d$var$featureNames.length;
const $82d25579e5668b1d$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $82d25579e5668b1d$var$numVariantProps = (0, $90bbd5b0e4403b6f$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $82d25579e5668b1d$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $c0f7059e46f27f2d$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $cb5417f97ee749d1$export$6476d16e2fd2d0db).current) (0, $246c267ad4291190$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $cb5417f97ee749d1$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $c0f7059e46f27f2d$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $4bfc6ff75ec6ae14$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $82d25579e5668b1d$var$numFeatures; i++){
            const name = $82d25579e5668b1d$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $000eadb1a85dd08b$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $82d25579e5668b1d$var$propEventHandlers.length; i++){
            const key = $82d25579e5668b1d$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $21b009f0fd79bf79$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $82d25579e5668b1d$var$numVariantProps; i++){
            const name = (0, $90bbd5b0e4403b6f$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $cf9a579fabd47d14$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $09bd23c1b3eae755$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $cceda5b0163aa04f$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $bb62727ea8cab401$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $74e3145b191de5e8$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $4bfc6ff75ec6ae14$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $76ceffd285582b8c$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $76ceffd285582b8c$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $bb62727ea8cab401$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $fc68338e527e1e2a$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
}


class $ec28e525b36f17a6$export$e49735c2a366bdc7 extends (0, $82d25579e5668b1d$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $1127fa396a6d5b62$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $1127fa396a6d5b62$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $4c5414901d35c401$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $3aec860b2645715a$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $3aec860b2645715a$export$23fea75b03ac16b3 extends (0, $ec28e525b36f17a6$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5f8b2e638e139982$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $3aec860b2645715a$export$3735103072e4a80(instance);
            const value = ((0, $9bea4890e7790ee2$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $b2660c7be3e466a6$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $b0a51bec594e4a19$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $03f83528154d3b62$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $bb62727ea8cab401$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $ee8ed79b3b31ab7c$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $92fb5c13d0664f01$export$86bcdffbaf733d84 extends (0, $ec28e525b36f17a6$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $a68c8b42e34fb3f9$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5f8b2e638e139982$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $8ced42779a60149c$export$28931db5d57958e5).has(key) ? (0, $913b547f18b26c6d$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $1f131aef74d1d3af$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $46c3baf131a44c99$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $80fd6b170c9760b2$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $0e23cd39959ac87d$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $83ceefcb56dbbbcb$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
}



const $782ff79d5f331768$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component) ? new (0, $92fb5c13d0664f01$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $3aec860b2645715a$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $55377c4d7156276f$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $dbef83b35adb3d3b$export$b61a9eb3dbde8858),
        MeasureLayout: $fb4bab01f29b923f$export$779f5fb01ad751cd
    }
};


const $55f7a48462954fda$var$preloadedFeatures = {
    ...(0, $9bb9392be544c52d$export$7f9953c70dacfd7f),
    ...(0, $55b9f4465d1c76fa$export$e5b72898e5a201f1),
    ...(0, $58aa614d3a6a82b6$export$d7d5d435647ed5a0),
    ...(0, $55377c4d7156276f$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $55f7a48462954fda$export$e25e478948902b8b = /*@__PURE__*/ (0, $ab4b5ecb7c661962$export$a28d6df673050e18)((Component, config)=>(0, $c0eba65a3cb498de$export$732916c0e88175fb)(Component, config, $55f7a48462954fda$var$preloadedFeatures, (0, $782ff79d5f331768$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $55f7a48462954fda$export$546614c4a05701f9(key) {
    return (0, $9202ab606c3569b2$export$46b7e4b9dc6110c3)((0, $c0eba65a3cb498de$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $55f7a48462954fda$var$preloadedFeatures, (0, $782ff79d5f331768$export$56ba0183203348f5)));
}



"use client";
var $775c02c9baac18b8$var$clamp = (value, min, max)=>{
    return Math.min(Math.max(value, min), max);
};
var $775c02c9baac18b8$var$Ripple = (props)=>{
    const { ripples: ripples = [], motionProps: motionProps, color: color = "currentColor", style: style, onClear: onClear } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: ripples.map((ripple)=>{
            const duration = $775c02c9baac18b8$var$clamp(0.01 * ripple.size, 0.2, ripple.size > 100 ? 0.75 : 0.5);
            return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $322c4f4c50d01684$export$3ae376d12526dd6f), {
                mode: "popLayout",
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $55f7a48462954fda$export$e25e478948902b8b).span, {
                    animate: {
                        transform: "scale(2)",
                        opacity: 0
                    },
                    className: "nextui-ripple",
                    exit: {
                        opacity: 0
                    },
                    initial: {
                        transform: "scale(0)",
                        opacity: 0.35
                    },
                    style: {
                        position: "absolute",
                        backgroundColor: color,
                        borderRadius: "100%",
                        transformOrigin: "center",
                        pointerEvents: "none",
                        zIndex: 10,
                        top: ripple.y,
                        left: ripple.x,
                        width: `${ripple.size}px`,
                        height: `${ripple.size}px`,
                        ...style
                    },
                    transition: {
                        duration: duration
                    },
                    onAnimationComplete: ()=>{
                        onClear(ripple.key);
                    },
                    ...motionProps
                })
            }, ripple.key);
        })
    });
};
$775c02c9baac18b8$var$Ripple.displayName = "NextUI.Ripple";
var $775c02c9baac18b8$export$db886ec4bd2671e8 = $775c02c9baac18b8$var$Ripple;



"use client";
var $74eb4db8dbffa2c8$var$Card = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, context: context, Component: Component, isPressable: isPressable, disableAnimation: disableAnimation, disableRipple: disableRipple, getCardProps: getCardProps, getRippleProps: getRippleProps } = (0, $b7bc5be477e90467$export$5a0763f6a9ca51f0)({
        ...props,
        ref: ref
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(Component, {
        ...getCardProps(),
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $8d7d6525e5036ff7$export$4aacc92b34f48449), {
                value: context,
                children: children
            }),
            isPressable && !disableAnimation && !disableRipple && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $775c02c9baac18b8$export$db886ec4bd2671e8), {
                ...getRippleProps()
            })
        ]
    });
});
$74eb4db8dbffa2c8$var$Card.displayName = "NextUI.Card";
var $74eb4db8dbffa2c8$export$4630804d47451d56 = $74eb4db8dbffa2c8$var$Card;






"use client";
var $5effc2172a4bcbde$var$CardFooter = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { as: as, className: className, children: children, ...otherProps } = props;
    const Component = as || "div";
    const domRef = (0, $fbbbeef99fe5a8b0$export$c2c55ef9111cafd8)(ref);
    const { slots: slots, classNames: classNames } = (0, $8d7d6525e5036ff7$export$c1f1c27d8fe70f39)();
    const footerStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.footer, className);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Component, {
        ref: domRef,
        className: (_a = slots.footer) == null ? void 0 : _a.call(slots, {
            class: footerStyles
        }),
        ...otherProps,
        children: children
    });
});
$5effc2172a4bcbde$var$CardFooter.displayName = "NextUI.CardFooter";
var $5effc2172a4bcbde$export$69daf8f7928b4c69 = $5effc2172a4bcbde$var$CardFooter;


var $7fPBF = parcelRequire("7fPBF");


// src/components/image.ts
var $5c420f376c4b7525$export$5c452ff88e35e47d = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    slots: {
        wrapper: "relative shadow-black/5",
        zoomedWrapper: "relative overflow-hidden rounded-inherit",
        img: "relative z-10 opacity-0 shadow-black/5 data-[loaded=true]:opacity-100",
        blurredImg: [
            "absolute",
            "z-0",
            "inset-0",
            "w-full",
            "h-full",
            "object-cover",
            "filter",
            "blur-lg",
            "scale-105",
            "saturate-150",
            "opacity-30",
            "translate-y-1"
        ]
    },
    variants: {
        radius: {
            none: {},
            sm: {},
            md: {},
            lg: {},
            full: {}
        },
        shadow: {
            none: {
                wrapper: "shadow-none",
                img: "shadow-none"
            },
            sm: {
                wrapper: "shadow-small",
                img: "shadow-small"
            },
            md: {
                wrapper: "shadow-medium",
                img: "shadow-medium"
            },
            lg: {
                wrapper: "shadow-large",
                img: "shadow-large"
            }
        },
        isZoomed: {
            true: {
                img: [
                    "object-cover",
                    "transform",
                    "hover:scale-125"
                ]
            }
        },
        showSkeleton: {
            true: {
                wrapper: [
                    "group",
                    "relative",
                    "overflow-hidden",
                    "bg-content3 dark:bg-content2",
                    "before:opacity-100",
                    "before:absolute",
                    "before:inset-0",
                    "before:-translate-x-full",
                    "before:animate-[shimmer_2s_infinite]",
                    "before:border-t",
                    "before:border-content4/30",
                    "before:bg-gradient-to-r",
                    "before:from-transparent",
                    "before:via-content4",
                    "dark:before:via-default-700/10",
                    "before:to-transparent",
                    "after:opacity-100",
                    "after:absolute",
                    "after:inset-0",
                    "after:-z-10",
                    "after:bg-content3",
                    "dark:after:bg-content2"
                ],
                img: "opacity-0"
            }
        },
        disableAnimation: {
            true: {
                img: "transition-none"
            },
            false: {
                img: "transition-transform-opacity motion-reduce:transition-none !duration-300"
            }
        }
    },
    defaultVariants: {
        radius: "lg",
        shadow: "none",
        isZoomed: false,
        isBlurred: false,
        showSkeleton: false,
        disableAnimation: false
    },
    compoundSlots: [
        {
            slots: [
                "wrapper",
                "img",
                "blurredImg",
                "zoomedWrapper"
            ],
            radius: "none",
            class: "rounded-none"
        },
        {
            slots: [
                "wrapper",
                "img",
                "blurredImg",
                "zoomedWrapper"
            ],
            radius: "full",
            class: "rounded-full"
        },
        {
            slots: [
                "wrapper",
                "img",
                "blurredImg",
                "zoomedWrapper"
            ],
            radius: "sm",
            class: "rounded-small"
        },
        {
            slots: [
                "wrapper",
                "img",
                "blurredImg",
                "zoomedWrapper"
            ],
            radius: "md",
            class: "rounded-md"
        },
        {
            slots: [
                "wrapper",
                "img",
                "blurredImg",
                "zoomedWrapper"
            ],
            radius: "lg",
            class: "rounded-large"
        }
    ]
});




// src/index.ts

var $7fPBF = parcelRequire("7fPBF");
// src/index.ts

var $7fPBF = parcelRequire("7fPBF");
var $fbcc105ed02853db$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


function $969466db09a95461$export$e4da99f09da8b739(props = {}) {
    const { loading: loading, src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    const [status, setStatus] = (0, $7fPBF.useState)("pending");
    (0, $7fPBF.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    const imageRef = (0, $7fPBF.useRef)();
    const load = (0, $7fPBF.useCallback)(()=>{
        if (!src) return;
        flush();
        const img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        if (loading) img.loading = loading;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad == null || onLoad(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError == null || onError(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError,
        loading
    ]);
    const flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $fbcc105ed02853db$export$deebe11a338de063)(()=>{
        if (ignoreFallback) return void 0;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    return ignoreFallback ? "loaded" : status;
}
var $969466db09a95461$export$b80814126d314dea = (status, fallbackStrategy)=>status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";


"use client";
function $8c5589b15b9d1055$export$e4da99f09da8b739(originalProps) {
    const [props, variantProps] = (0, $4f1e9f4a2dccf0c0$export$9f203ede2b8cf905)(originalProps, (0, $5c420f376c4b7525$export$5c452ff88e35e47d).variantKeys);
    const { ref: ref, as: as, src: src, className: className, classNames: classNames, loading: loading, isBlurred: isBlurred, fallbackSrc: fallbackSrc, isLoading: isLoadingProp, disableSkeleton: disableSkeleton = !!fallbackSrc, removeWrapper: removeWrapper = false, onError: onError, onLoad: onLoad, srcSet: srcSet, sizes: sizes, crossOrigin: crossOrigin, ...otherProps } = props;
    const imageStatus = (0, $969466db09a95461$export$e4da99f09da8b739)({
        src: src,
        loading: loading,
        onError: onError,
        onLoad: onLoad,
        ignoreFallback: false,
        srcSet: srcSet,
        sizes: sizes,
        crossOrigin: crossOrigin
    });
    const isImgLoaded = imageStatus === "loaded" && !isLoadingProp;
    const isLoading = imageStatus === "loading" || isLoadingProp;
    const isZoomed = originalProps.isZoomed;
    const Component = as || "img";
    const domRef = (0, $fbbbeef99fe5a8b0$export$c2c55ef9111cafd8)(ref);
    const { w: w } = (0, $7fPBF.useMemo)(()=>{
        return {
            w: props.width ? typeof props.width === "number" ? `${props.width}px` : props.width : "fit-content"
        };
    }, [
        props == null ? void 0 : props.width
    ]);
    const showFallback = (!src || !isImgLoaded) && !!fallbackSrc;
    const showSkeleton = isLoading && !disableSkeleton;
    const slots = (0, $7fPBF.useMemo)(()=>(0, $5c420f376c4b7525$export$5c452ff88e35e47d)({
            ...variantProps,
            showSkeleton: showSkeleton
        }), [
        ...Object.values(variantProps),
        showSkeleton
    ]);
    const baseStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(className, classNames == null ? void 0 : classNames.img);
    const getImgProps = (props2 = {})=>{
        const imgStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(baseStyles, props2 == null ? void 0 : props2.className);
        return {
            src: src,
            ref: domRef,
            "data-loaded": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isImgLoaded),
            className: slots.img({
                class: imgStyles
            }),
            loading: loading,
            srcSet: srcSet,
            sizes: sizes,
            crossOrigin: crossOrigin,
            ...otherProps
        };
    };
    const getWrapperProps = (0, $7fPBF.useCallback)(()=>{
        const fallbackStyle = showFallback ? {
            backgroundImage: `url(${fallbackSrc})`
        } : {};
        return {
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            }),
            style: {
                ...fallbackStyle,
                maxWidth: w
            }
        };
    }, [
        slots,
        showFallback,
        fallbackSrc,
        classNames == null ? void 0 : classNames.wrapper
    ]);
    const getBlurredImgProps = (0, $7fPBF.useCallback)(()=>{
        return {
            src: src,
            "aria-hidden": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(true),
            className: slots.blurredImg({
                class: classNames == null ? void 0 : classNames.blurredImg
            })
        };
    }, [
        slots,
        src,
        classNames == null ? void 0 : classNames.blurredImg
    ]);
    return {
        Component: Component,
        domRef: domRef,
        slots: slots,
        classNames: classNames,
        isBlurred: isBlurred,
        disableSkeleton: disableSkeleton,
        fallbackSrc: fallbackSrc,
        removeWrapper: removeWrapper,
        isZoomed: isZoomed,
        isLoading: isLoading,
        getImgProps: getImgProps,
        getWrapperProps: getWrapperProps,
        getBlurredImgProps: getBlurredImgProps
    };
}



var $7fPBF = parcelRequire("7fPBF");


"use client";
var $1a9063f91d9ffdd3$var$Image = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, domRef: domRef, slots: slots, classNames: classNames, isBlurred: isBlurred, isZoomed: isZoomed, fallbackSrc: fallbackSrc, removeWrapper: removeWrapper, disableSkeleton: disableSkeleton, getImgProps: getImgProps, getWrapperProps: getWrapperProps, getBlurredImgProps: getBlurredImgProps } = (0, $8c5589b15b9d1055$export$e4da99f09da8b739)({
        ...props,
        ref: ref
    });
    const img = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Component, {
        ref: domRef,
        ...getImgProps()
    });
    if (removeWrapper) return img;
    const zoomed = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: slots.zoomedWrapper({
            class: classNames == null ? void 0 : classNames.zoomedWrapper
        }),
        children: img
    });
    if (isBlurred) return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("div", {
        ...getWrapperProps(),
        children: [
            isZoomed ? zoomed : img,
            (0, $7fPBF.cloneElement)(img, getBlurredImgProps())
        ]
    });
    if (isZoomed || !disableSkeleton || fallbackSrc) return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("div", {
        ...getWrapperProps(),
        children: [
            " ",
            isZoomed ? zoomed : img
        ]
    });
    return img;
});
$1a9063f91d9ffdd3$var$Image.displayName = "NextUI.Image";
var $1a9063f91d9ffdd3$export$5e8a114113e3f7c = $1a9063f91d9ffdd3$var$Image;


"use client";
function $772440a20437d4e2$export$5db3965fb0ec818(props) {
    const { isSelected: isSelected, disableAnimation: disableAnimation, ...otherProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "aria-hidden": "true",
        "data-selected": isSelected,
        role: "presentation",
        viewBox: "0 0 17 18",
        ...otherProps,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("polyline", {
            fill: "none",
            points: "1 9 7 14 15 4",
            stroke: "currentColor",
            strokeDasharray: 22,
            strokeDashoffset: isSelected ? 44 : 66,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            style: !disableAnimation ? {
                transition: "stroke-dashoffset 200ms ease"
            } : {}
        })
    });
}



var $7fPBF = parcelRequire("7fPBF");


// src/components/menu.ts
var $28cb637712cc540b$export$b1e5508a851be14d = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    slots: {
        base: "w-full relative flex flex-col gap-1 p-1",
        list: "w-full flex flex-col gap-0.5 outline-none",
        emptyContent: [
            "h-10",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "text-foreground-400",
            "text-start"
        ]
    }
});
var $28cb637712cc540b$export$c176f998e71d0f08 = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    slots: {
        base: [
            "flex",
            "group",
            "gap-2",
            "items-center",
            "justify-between",
            "relative",
            "px-2",
            "py-1.5",
            "w-full",
            "h-full",
            "box-border",
            "rounded-small",
            "subpixel-antialiased",
            "outline-none",
            "cursor-pointer",
            "tap-highlight-transparent",
            ...(0, $9946c85750e1f084$export$13376dc9c57a19ba),
            "data-[focus-visible=true]:dark:ring-offset-background-content1"
        ],
        wrapper: "w-full flex flex-col items-start justify-center",
        title: "flex-1 text-small font-normal truncate",
        description: [
            "w-full",
            "text-tiny",
            "text-foreground-500",
            "group-hover:text-current"
        ],
        selectedIcon: [
            "text-inherit",
            "w-3",
            "h-3",
            "flex-shrink-0"
        ],
        shortcut: [
            "px-1",
            "py-0.5",
            "rounded",
            "font-sans",
            "text-foreground-500",
            "text-tiny",
            "border-small",
            "border-default-300",
            "group-hover:border-current"
        ]
    },
    variants: {
        variant: {
            solid: {
                base: ""
            },
            bordered: {
                base: "border-medium border-transparent bg-transparent"
            },
            light: {
                base: "bg-transparent"
            },
            faded: {
                base: [
                    "border-small border-transparent hover:border-default data-[hover=true]:bg-default-100",
                    "data-[selectable=true]:focus:border-default data-[selectable=true]:focus:bg-default-100"
                ]
            },
            flat: {
                base: ""
            },
            shadow: {
                base: "data-[hover=true]:shadow-lg"
            }
        },
        color: {
            default: {},
            primary: {},
            secondary: {},
            success: {},
            warning: {},
            danger: {}
        },
        showDivider: {
            true: {
                base: [
                    "mb-1.5",
                    "after:content-['']",
                    "after:absolute",
                    "after:-bottom-1",
                    "after:left-0",
                    "after:right-0",
                    "after:h-divider",
                    "after:bg-divider"
                ]
            },
            false: {}
        },
        isDisabled: {
            true: {
                base: "opacity-disabled pointer-events-none"
            }
        },
        disableAnimation: {
            true: {},
            false: {
                base: "data-[hover=true]:transition-colors"
            }
        }
    },
    defaultVariants: {
        variant: "solid",
        color: "default",
        disableAnimation: false,
        showDivider: false
    },
    compoundVariants: [
        {
            variant: "solid",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "solid",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:shadow-default/50 data-[hover=true]:bg-default data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:shadow-default/50 data-[selectable=true]:focus:bg-default data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:shadow-primary/30 data-[hover=true]:bg-primary data-[hover=true]:text-primary-foreground",
                    "data-[selectable=true]:focus:shadow-primary/30 data-[selectable=true]:focus:bg-primary data-[selectable=true]:focus:text-primary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:shadow-secondary/30 data-[hover=true]:bg-secondary data-[hover=true]:text-secondary-foreground",
                    "data-[selectable=true]:focus:shadow-secondary/30 data-[selectable=true]:focus:bg-secondary data-[selectable=true]:focus:text-secondary-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:shadow-success/30 data-[hover=true]:bg-success data-[hover=true]:text-success-foreground",
                    "data-[selectable=true]:focus:shadow-success/30 data-[selectable=true]:focus:bg-success data-[selectable=true]:focus:text-success-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:shadow-warning/30 data-[hover=true]:bg-warning data-[hover=true]:text-warning-foreground",
                    "data-[selectable=true]:focus:shadow-warning/30 data-[selectable=true]:focus:bg-warning data-[selectable=true]:focus:text-warning-foreground"
                ]
            }
        },
        {
            variant: "shadow",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:shadow-danger/30 data-[hover=true]:bg-danger data-[hover=true]:text-danger-foreground",
                    "data-[selectable=true]:focus:shadow-danger/30 data-[selectable=true]:focus:bg-danger data-[selectable=true]:focus:text-danger-foreground"
                ]
            }
        },
        {
            variant: "bordered",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:border-default",
                    "data-[selectable=true]:focus:border-default"
                ]
            }
        },
        {
            variant: "bordered",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:border-primary data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:border-primary data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:border-secondary data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:border-secondary data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "bordered",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:border-success data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:border-success data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "bordered",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:border-warning data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:border-warning data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "bordered",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:border-danger data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:border-danger data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "flat",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:bg-default/40",
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:bg-default/40",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "flat",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:bg-primary/20 data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:bg-primary/20 data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "flat",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:bg-secondary/20 data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:bg-secondary/20 data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "flat",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:bg-success/20 data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:bg-success/20 data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "flat",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:bg-warning/20 data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:bg-warning/20 data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "flat",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:bg-danger/20 data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:bg-danger/20 data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "faded",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-foreground",
                    "data-[selectable=true]:focus:text-default-foreground"
                ]
            }
        },
        {
            variant: "faded",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "faded",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "faded",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "faded",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "faded",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        },
        {
            variant: "light",
            color: "default",
            class: {
                base: [
                    "data-[hover=true]:text-default-500",
                    "data-[selectable=true]:focus:text-default-500"
                ]
            }
        },
        {
            variant: "light",
            color: "primary",
            class: {
                base: [
                    "data-[hover=true]:text-primary",
                    "data-[selectable=true]:focus:text-primary"
                ]
            }
        },
        {
            variant: "light",
            color: "secondary",
            class: {
                base: [
                    "data-[hover=true]:text-secondary",
                    "data-[selectable=true]:focus:text-secondary"
                ]
            }
        },
        {
            variant: "light",
            color: "success",
            class: {
                base: [
                    "data-[hover=true]:text-success",
                    "data-[selectable=true]:focus:text-success"
                ]
            }
        },
        {
            variant: "light",
            color: "warning",
            class: {
                base: [
                    "data-[hover=true]:text-warning",
                    "data-[selectable=true]:focus:text-warning"
                ]
            }
        },
        {
            variant: "light",
            color: "danger",
            class: {
                base: [
                    "data-[hover=true]:text-danger",
                    "data-[selectable=true]:focus:text-danger"
                ]
            }
        }
    ]
});
var $28cb637712cc540b$export$95e0837a3419f5c1 = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    slots: {
        base: "relative mb-2",
        heading: "pl-1 text-tiny text-foreground-500",
        group: "data-[has-title=true]:pt-1",
        divider: "mt-2"
    }
});









/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e2d9bb95c851dd17$export$8467354a121f1b9f(props) {
    let { id: id, label: label, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel, labelElementType: labelElementType = "label" } = props;
    id = (0, $a26d4c995bb2a467$export$f680877a34711e37)(id);
    let labelId = (0, $a26d4c995bb2a467$export$f680877a34711e37)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    let fieldProps = (0, $a26d4c995bb2a467$export$d6875122194c7b44)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}
function $e2d9bb95c851dd17$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = $e2d9bb95c851dd17$export$8467354a121f1b9f(props);
    let descriptionId = (0, $a26d4c995bb2a467$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $a26d4c995bb2a467$export$b4cc09c592e8fdb8)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}




var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $fc0f58a4c3b6de6a$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $fc0f58a4c3b6de6a$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    constructor(messages, defaultLocale = "en-US"){
        // Clone messages so we don't modify the original object.
        this.strings = {
            ...messages
        };
        this.defaultLocale = defaultLocale;
    }
}
function $fc0f58a4c3b6de6a$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $fc0f58a4c3b6de6a$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $fc0f58a4c3b6de6a$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fc0f58a4c3b6de6a$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $fc0f58a4c3b6de6a$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $fc0f58a4c3b6de6a$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === "function" ? message(variables, this) : message;
    }
    plural(count, options, type = "cardinal") {
        let opt = options["=" + count];
        if (opt) return typeof opt === "function" ? opt() : opt;
        let key = this.locale + ":" + type;
        let pluralRules = $fc0f58a4c3b6de6a$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $fc0f58a4c3b6de6a$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    number(value) {
        let numberFormat = $fc0f58a4c3b6de6a$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $fc0f58a4c3b6de6a$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === "function" ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}
function $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$784d13d8ee351f07(date) {
    if (date.era) return new $fe9c616554b20da0$export$99faa760c7908e4f(date.calendar, date.era, date.year, date.month, date.day);
    else return new $fe9c616554b20da0$export$99faa760c7908e4f(date.calendar, date.year, date.month, date.day);
}
function $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$27fa0172ae2644b3(date) {
    if (date.era) return new $fe9c616554b20da0$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
    else return new $fe9c616554b20da0$export$ca871e8dbb80966f(date.calendar, date.year, date.month, date.day, date.hour, date.minute, date.second);
}
const $fe9c616554b20da0$var$$3b62074eb05584b2$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, month, day) {
    year = $fe9c616554b20da0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year);
    let y1 = year - 1;
    let monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $fe9c616554b20da0$var$$3b62074eb05584b2$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $fe9c616554b20da0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year) {
    return era === "BC" ? 1 - year : year;
}
function $fe9c616554b20da0$var$$3b62074eb05584b2$export$4475b7e617eb123c(year) {
    let era = "AD";
    if (year <= 0) {
        era = "BC";
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
const $fe9c616554b20da0$var$$3b62074eb05584b2$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
class $fe9c616554b20da0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let jd0 = jd;
        let depoch = jd0 - $fe9c616554b20da0$var$$3b62074eb05584b2$var$EPOCH;
        let quadricent = Math.floor(depoch / 146097);
        let dqc = $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(depoch, 146097);
        let cent = Math.floor(dqc / 36524);
        let dcent = $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(dqc, 36524);
        let quad = Math.floor(dcent / 1461);
        let dquad = $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(dcent, 1461);
        let yindex = Math.floor(dquad / 365);
        let extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
        let [era, year] = $fe9c616554b20da0$var$$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear);
        let yearDay = jd0 - $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 1, 1);
        let leapAdj = 2;
        if (jd0 < $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
        else if ($fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) leapAdj = 1;
        let month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
        let day = jd0 - $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, month, 1) + 1;
        return new $fe9c616554b20da0$export$99faa760c7908e4f(era, year, month, day);
    }
    toJulianDay(date) {
        return $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $fe9c616554b20da0$var$$3b62074eb05584b2$var$daysInMonth[$fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? "leapyear" : "standard"][date.month - 1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMonthsInYear(date) {
        return 12;
    }
    getDaysInYear(date) {
        return $fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getYearsInEra(date) {
        return 9999;
    }
    getEras() {
        return [
            "BC",
            "AD"
        ];
    }
    isInverseEra(date) {
        return date.era === "BC";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BC" ? "AD" : "BC";
            date.year = 1 - date.year;
        }
    }
    constructor(){
        this.identifier = "gregory";
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
const $fe9c616554b20da0$var$$2fe286d2fb449abb$export$7a5acbd77d414bd9 = {
    "001": 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};
function $fe9c616554b20da0$export$ea39ec197993aef0(a, b) {
    b = $fe9c616554b20da0$export$b4a036af3fc0b032(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $fe9c616554b20da0$export$a18c89cbd24170ff(a, b) {
    b = $fe9c616554b20da0$export$b4a036af3fc0b032(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $fe9c616554b20da0$export$a5a3b454ada2268e(a);
    b = $fe9c616554b20da0$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $fe9c616554b20da0$export$5841f9eb9773f25f(a, b) {
    b = $fe9c616554b20da0$export$b4a036af3fc0b032(b, a.calendar);
    a = $fe9c616554b20da0$export$f91e89d3d0406102(a);
    b = $fe9c616554b20da0$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $fe9c616554b20da0$export$91b62ebf2ba703ee(a, b) {
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $fe9c616554b20da0$export$5a8da0c44a3afdf2(a, b) {
    a = $fe9c616554b20da0$export$a5a3b454ada2268e(a);
    b = $fe9c616554b20da0$export$a5a3b454ada2268e(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
function $fe9c616554b20da0$export$ea840f5a6dda8147(a, b) {
    a = $fe9c616554b20da0$export$f91e89d3d0406102(a);
    b = $fe9c616554b20da0$export$f91e89d3d0406102(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
function $fe9c616554b20da0$export$629b0a497aa65267(date, timeZone) {
    return $fe9c616554b20da0$export$ea39ec197993aef0(date, $fe9c616554b20da0$export$d0bdf45af03a6ea3(timeZone));
}
function $fe9c616554b20da0$export$2061056d06d7cdf7(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1 - $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$getWeekStart(locale)) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $fe9c616554b20da0$export$461939dd4422153(timeZone) {
    return $fe9c616554b20da0$export$1b96692a1ba042ac(Date.now(), timeZone);
}
function $fe9c616554b20da0$export$d0bdf45af03a6ea3(timeZone) {
    return $fe9c616554b20da0$export$93522d1a439f3617($fe9c616554b20da0$export$461939dd4422153(timeZone));
}
function $fe9c616554b20da0$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $fe9c616554b20da0$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(a, b) {
    return $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$timeToMs(a) - $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$timeToMs(b);
}
function $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $fe9c616554b20da0$export$126c91c941de7e(a, timeZone) {
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(a, timeZone);
    let tomorrow = a.add({
        days: 1
    });
    let tomorrowMs = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
let $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$localTimeZone = null;
function $fe9c616554b20da0$export$aa8b41735afcabd2() {
    // TODO: invalidate this somehow?
    if ($fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$localTimeZone == null) $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$localTimeZone;
}
function $fe9c616554b20da0$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $fe9c616554b20da0$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $fe9c616554b20da0$export$f91e89d3d0406102(date) {
    return $fe9c616554b20da0$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $fe9c616554b20da0$export$8b7aa55c66d5569e(date) {
    return $fe9c616554b20da0$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $fe9c616554b20da0$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $fe9c616554b20da0$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $fe9c616554b20da0$export$42c81a444fbfb5d4(date, locale) {
    let dayOfWeek = $fe9c616554b20da0$export$2061056d06d7cdf7(date, locale);
    return date.subtract({
        days: dayOfWeek
    });
}
function $fe9c616554b20da0$export$ef8b6d9133084f4e(date, locale) {
    return $fe9c616554b20da0$export$42c81a444fbfb5d4(date, locale).add({
        days: 6
    });
}
const $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$cachedRegions = new Map();
function $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        let region = $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    let part = locale.split("-")[1];
    return part === "u" ? null : part;
}
function $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    let region = $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    return $fe9c616554b20da0$var$$2fe286d2fb449abb$export$7a5acbd77d414bd9[region] || 0;
}
function $fe9c616554b20da0$export$ccc1b2479e7dd654(date, locale) {
    let days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($fe9c616554b20da0$export$2061056d06d7cdf7($fe9c616554b20da0$export$a5a3b454ada2268e(date), locale) + days) / 7);
}
function $fe9c616554b20da0$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $fe9c616554b20da0$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
const $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $fe9c616554b20da0$export$618d60ea299da42(date, locale) {
    let julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    let dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    let region = $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    let [start, end] = $fe9c616554b20da0$var$$14e0f24ef4ac5c92$var$WEEKEND_DATA[region] || [
        6,
        0
    ];
    return dayOfWeek === start || dayOfWeek === end;
}
function $fe9c616554b20da0$export$ee9d87258e1d19ed(date, locale) {
    return !$fe9c616554b20da0$export$618d60ea299da42(date, locale);
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) {
    date = $fe9c616554b20da0$export$b4a036af3fc0b032(date, new $fe9c616554b20da0$export$80ee6245ec4f29ec());
    let year = $fe9c616554b20da0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
    return $fe9c616554b20da0$var$$11d87f3f76e88657$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    let date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === "UTC") return 0;
    // Fast path: for local timezone after 1970, use native Date.
    if (ms > 0 && timeZone === $fe9c616554b20da0$export$aa8b41735afcabd2()) return new Date(ms).getTimezoneOffset() * -60000;
    let { year: year, month: month, day: day, hour: hour, minute: minute, second: second } = $fe9c616554b20da0$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone);
    let utc = $fe9c616554b20da0$var$$11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
const $fe9c616554b20da0$var$$11d87f3f76e88657$var$formattersByTimeZone = new Map();
function $fe9c616554b20da0$var$$11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone) {
    let formatter = $fe9c616554b20da0$var$$11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour12: false,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
        $fe9c616554b20da0$var$$11d87f3f76e88657$var$formattersByTimeZone.set(timeZone, formatter);
    }
    let parts = formatter.formatToParts(new Date(ms));
    let namedParts = {};
    for (let part of parts)if (part.type !== "literal") namedParts[part.type] = part.value;
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
const $fe9c616554b20da0$var$$11d87f3f76e88657$var$DAYMILLIS = 86400000;
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$136f38efe7caf549(date, timeZone) {
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date);
    let earlier = ms - $fe9c616554b20da0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms - $fe9c616554b20da0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let later = ms - $fe9c616554b20da0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms + $fe9c616554b20da0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    return $fe9c616554b20da0$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later) {
    let found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter((absolute)=>$fe9c616554b20da0$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute));
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute) {
    let parts = $fe9c616554b20da0$var$$11d87f3f76e88657$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation = "compatible") {
    let dateTime = $fe9c616554b20da0$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === "UTC") return $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === $fe9c616554b20da0$export$aa8b41735afcabd2() && disambiguation === "compatible") {
        dateTime = $fe9c616554b20da0$export$b4a036af3fc0b032(dateTime, new $fe9c616554b20da0$export$80ee6245ec4f29ec());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        let date = new Date();
        let year = $fe9c616554b20da0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(dateTime.era, dateTime.year);
        date.setFullYear(year, dateTime.month - 1, dateTime.day);
        date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return date.getTime();
    }
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    let offsetBefore = $fe9c616554b20da0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms - $fe9c616554b20da0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let offsetAfter = $fe9c616554b20da0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms + $fe9c616554b20da0$var$$11d87f3f76e88657$var$DAYMILLIS, timeZone);
    let valid = $fe9c616554b20da0$var$$11d87f3f76e88657$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case "compatible":
        case "earlier":
            return valid[0];
        case "later":
            return valid[valid.length - 1];
        case "reject":
            throw new RangeError("Multiple possible absolute times found");
    }
    switch(disambiguation){
        case "earlier":
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case "compatible":
        case "later":
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case "reject":
            throw new RangeError("No such absolute time found");
    }
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$e67a095c620b86fe(dateTime, timeZone, disambiguation = "compatible") {
    return new Date($fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $fe9c616554b20da0$export$1b96692a1ba042ac(ms, timeZone) {
    let offset = $fe9c616554b20da0$var$$11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone);
    let date = new Date(ms + offset);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    let millisecond = date.getUTCMilliseconds();
    return new $fe9c616554b20da0$export$d3b7288e7994edea(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $fe9c616554b20da0$export$e57ff100d91bd4b9(date, timeZone) {
    return $fe9c616554b20da0$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$d7f92bcd3596b086(date) {
    return $fe9c616554b20da0$export$e57ff100d91bd4b9(date, $fe9c616554b20da0$export$aa8b41735afcabd2());
}
function $fe9c616554b20da0$export$93522d1a439f3617(dateTime) {
    return new $fe9c616554b20da0$export$99faa760c7908e4f(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $fe9c616554b20da0$export$b21e0b124e224484(date, time) {
    let hour = 0, minute = 0, second = 0, millisecond = 0;
    if ("timeZone" in date) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = date);
    else if ("hour" in date && !time) return date;
    if (time) ({ hour: hour, minute: minute, second: second, millisecond: millisecond } = time);
    return new $fe9c616554b20da0$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $fe9c616554b20da0$export$d33f79e3ffc3dc83(dateTime) {
    return new $fe9c616554b20da0$export$680ea196effce5f(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $fe9c616554b20da0$export$b4a036af3fc0b032(date, calendar) {
    if (date.calendar.identifier === calendar.identifier) return date;
    let calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    let copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(copy);
    return copy;
}
function $fe9c616554b20da0$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof $fe9c616554b20da0$export$d3b7288e7994edea) {
        if (date.timeZone === timeZone) return date;
        return $fe9c616554b20da0$export$538b00033cc11c75(date, timeZone);
    }
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $fe9c616554b20da0$export$1b96692a1ba042ac(ms, timeZone);
}
function $fe9c616554b20da0$var$$11d87f3f76e88657$export$83aac07b4c37b25(date) {
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $fe9c616554b20da0$export$538b00033cc11c75(date, timeZone) {
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $fe9c616554b20da0$export$b4a036af3fc0b032($fe9c616554b20da0$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $fe9c616554b20da0$export$d9b67bc93c097491(date) {
    return $fe9c616554b20da0$export$538b00033cc11c75(date, $fe9c616554b20da0$export$aa8b41735afcabd2());
}
const $fe9c616554b20da0$var$$735220c2d4774dd3$var$ONE_HOUR = 3600000;
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$e16d8520af44a096(date, duration) {
    let mutableDate = date.copy();
    let days = "hour" in mutableDate ? $fe9c616554b20da0$var$$735220c2d4774dd3$var$addTimeFields(mutableDate, duration) : 0;
    $fe9c616554b20da0$var$$735220c2d4774dd3$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceYearMonth(mutableDate);
    $fe9c616554b20da0$var$$735220c2d4774dd3$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _mutableDate_calendar, _mutableDate_calendar_isInverseEra;
        let isInverseEra = (_mutableDate_calendar_isInverseEra = (_mutableDate_calendar = mutableDate.calendar).isInverseEra) === null || _mutableDate_calendar_isInverseEra === void 0 ? void 0 : _mutableDate_calendar_isInverseEra.call(_mutableDate_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    let maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$addYears(date, years) {
    var _date_calendar, _date_calendar_isInverseEra;
    if ((_date_calendar_isInverseEra = (_date_calendar = date.calendar).isInverseEra) === null || _date_calendar_isInverseEra === void 0 ? void 0 : _date_calendar_isInverseEra.call(_date_calendar, date)) years = -years;
    date.year += years;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceYearMonth(date) {
    while(date.month < 1){
        $fe9c616554b20da0$var$$735220c2d4774dd3$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    let monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $fe9c616554b20da0$var$$735220c2d4774dd3$var$addYears(date, 1);
    }
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceYearMonth(date);
    }
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $fe9c616554b20da0$var$$735220c2d4774dd3$var$constrainMonthDay(date);
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration) {
    let inverseDuration = {};
    for(let key in duration)if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(date, duration) {
    return $fe9c616554b20da0$var$$735220c2d4774dd3$export$e16d8520af44a096(date, $fe9c616554b20da0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(date, fields) {
    let mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(value, fields) {
    let mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $fe9c616554b20da0$var$$735220c2d4774dd3$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $fe9c616554b20da0$var$$735220c2d4774dd3$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $fe9c616554b20da0$var$$735220c2d4774dd3$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $fe9c616554b20da0$var$$735220c2d4774dd3$var$nonNegativeMod(time.minute, 60);
    let days = Math.floor(time.hour / 24);
    time.hour = $fe9c616554b20da0$var$$735220c2d4774dd3$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$nonNegativeMod(a, b) {
    let result = a % b;
    if (result < 0) result += b;
    return result;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $fe9c616554b20da0$var$$735220c2d4774dd3$var$balanceTime(time);
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$7ed87b6bc2506470(time, duration) {
    let res = time.copy();
    $fe9c616554b20da0$var$$735220c2d4774dd3$var$addTimeFields(res, duration);
    return res;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$fe34d3a381cd7501(time, duration) {
    return $fe9c616554b20da0$var$$735220c2d4774dd3$export$7ed87b6bc2506470(time, $fe9c616554b20da0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "era":
            {
                let eras = value.calendar.getEras();
                let eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
                eraIndex = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case "year":
            var _mutable_calendar, _mutable_calendar_isInverseEra;
            if ((_mutable_calendar_isInverseEra = (_mutable_calendar = mutable.calendar).isInverseEra) === null || _mutable_calendar_isInverseEra === void 0 ? void 0 : _mutable_calendar_isInverseEra.call(_mutable_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case "month":
            mutable.month = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case "day":
            mutable.day = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(value, field, amount, options) {
    let mutable = value.copy();
    switch(field){
        case "hour":
            {
                let hours = value.hour;
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case "minute":
            mutable.minute = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "second":
            mutable.second = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "millisecond":
            mutable.millisecond = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    return mutable;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(value, amount, min, max, round = false) {
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        let div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$96b1d28349274637(dateTime, duration) {
    let ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        let res = $fe9c616554b20da0$var$$735220c2d4774dd3$export$e16d8520af44a096($fe9c616554b20da0$export$b21e0b124e224484(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
    } else ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    let res = $fe9c616554b20da0$export$1b96692a1ba042ac(ms, dateTime.timeZone);
    return $fe9c616554b20da0$export$b4a036af3fc0b032(res, dateTime.calendar);
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$6814caac34ca03c7(dateTime, duration) {
    return $fe9c616554b20da0$var$$735220c2d4774dd3$export$96b1d28349274637(dateTime, $fe9c616554b20da0$var$$735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case "hour":
            {
                let min = 0;
                let max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    let isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                let plainDateTime = $fe9c616554b20da0$export$b21e0b124e224484(dateTime);
                let minDate = $fe9c616554b20da0$export$b4a036af3fc0b032($fe9c616554b20da0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new $fe9c616554b20da0$export$80ee6245ec4f29ec());
                let minAbsolute = [
                    $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "earlier"),
                    $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "later")
                ].filter((ms)=>$fe9c616554b20da0$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === minDate.day)[0];
                let maxDate = $fe9c616554b20da0$export$b4a036af3fc0b032($fe9c616554b20da0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new $fe9c616554b20da0$export$80ee6245ec4f29ec());
                let maxAbsolute = [
                    $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "earlier"),
                    $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "later")
                ].filter((ms)=>$fe9c616554b20da0$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === maxDate.day).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
                let hours = Math.floor(ms / $fe9c616554b20da0$var$$735220c2d4774dd3$var$ONE_HOUR);
                let remainder = ms % $fe9c616554b20da0$var$$735220c2d4774dd3$var$ONE_HOUR;
                ms = $fe9c616554b20da0$var$$735220c2d4774dd3$var$cycleValue(hours, amount, Math.floor(minAbsolute / $fe9c616554b20da0$var$$735220c2d4774dd3$var$ONE_HOUR), Math.floor(maxAbsolute / $fe9c616554b20da0$var$$735220c2d4774dd3$var$ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * $fe9c616554b20da0$var$$735220c2d4774dd3$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return $fe9c616554b20da0$export$b4a036af3fc0b032($fe9c616554b20da0$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
            }
        case "minute":
        case "second":
        case "millisecond":
            // @ts-ignore
            return $fe9c616554b20da0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case "era":
        case "year":
        case "month":
        case "day":
            {
                let res = $fe9c616554b20da0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c($fe9c616554b20da0$export$b21e0b124e224484(dateTime), field, amount, options);
                let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
                return $fe9c616554b20da0$export$b4a036af3fc0b032($fe9c616554b20da0$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error("Unsupported field " + field);
    }
}
function $fe9c616554b20da0$var$$735220c2d4774dd3$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    let plainDateTime = $fe9c616554b20da0$export$b21e0b124e224484(dateTime);
    let res = $fe9c616554b20da0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56($fe9c616554b20da0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    let ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone, disambiguation);
    return $fe9c616554b20da0$export$b4a036af3fc0b032($fe9c616554b20da0$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fe9c616554b20da0$var$$fae977aafc393c5c$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?)?\[(.*?)\]$/;
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$DATE_TIME_DURATION_RE = /^((?<negative>-)|\+)?P((?<years>\d*)Y)?((?<months>\d*)M)?((?<weeks>\d*)W)?((?<days>\d*)D)?((?<time>T)((?<hours>\d*[.,]?\d{1,9})H)?((?<minutes>\d*[.,]?\d{1,9})M)?((?<seconds>\d*[.,]?\d{1,9})S)?)?$/;
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$requiredDurationTimeGroups = [
    "hours",
    "minutes",
    "seconds"
];
const $fe9c616554b20da0$var$$fae977aafc393c5c$var$requiredDurationGroups = [
    "years",
    "months",
    "weeks",
    "days",
    ...$fe9c616554b20da0$var$$fae977aafc393c5c$var$requiredDurationTimeGroups
];
function $fe9c616554b20da0$export$c9698ec7f05a07e1(value) {
    let m = value.match($fe9c616554b20da0$var$$fae977aafc393c5c$var$TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 time string: " + value);
    return new $fe9c616554b20da0$export$680ea196effce5f($fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 23), m[2] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $fe9c616554b20da0$export$6b862160d295c8e(value) {
    let m = value.match($fe9c616554b20da0$var$$fae977aafc393c5c$var$DATE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date string: " + value);
    let date = new $fe9c616554b20da0$export$99faa760c7908e4f($fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[1], 0, 9999), $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1);
    date.day = $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $fe9c616554b20da0$export$588937bcd60ade55(value) {
    let m = value.match($fe9c616554b20da0$var$$fae977aafc393c5c$var$DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $fe9c616554b20da0$export$ca871e8dbb80966f($fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[4] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $fe9c616554b20da0$export$fd7893f06e92a6a4(value, disambiguation) {
    let m = value.match($fe9c616554b20da0$var$$fae977aafc393c5c$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $fe9c616554b20da0$export$d3b7288e7994edea($fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    let plainDateTime = $fe9c616554b20da0$export$b21e0b124e224484(date);
    let ms;
    if (m[8]) {
        var _m_;
        date.offset = $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
        ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
        // Validate offset against parsed date.
        let absolutes = $fe9c616554b20da0$var$$11d87f3f76e88657$export$136f38efe7caf549(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error(`Offset ${$fe9c616554b20da0$var$$fae977aafc393c5c$var$offsetToString(date.offset)} is invalid for ${$fe9c616554b20da0$var$$fae977aafc393c5c$export$4223de14708adc63(date)} in ${date.timeZone}`);
    } else ms = $fe9c616554b20da0$var$$11d87f3f76e88657$export$5107c82f94518f5c($fe9c616554b20da0$export$b21e0b124e224484(plainDateTime), date.timeZone, disambiguation);
    return $fe9c616554b20da0$export$1b96692a1ba042ac(ms, date.timeZone);
}
function $fe9c616554b20da0$export$5adfdab05168c219(value, timeZone) {
    let m = value.match($fe9c616554b20da0$var$$fae977aafc393c5c$var$ABSOLUTE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    let date = new $fe9c616554b20da0$export$d3b7288e7994edea($fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var _m_;
    if (m[8]) date.offset = $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
    return $fe9c616554b20da0$export$538b00033cc11c75(date, timeZone);
}
function $fe9c616554b20da0$export$8e384432362ed0f0(value) {
    return $fe9c616554b20da0$export$5adfdab05168c219(value, $fe9c616554b20da0$export$aa8b41735afcabd2());
}
function $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(value, min, max) {
    let val = Number(value);
    if (val < min || val > max) throw new RangeError(`Value out of range: ${min} <= ${val} <= ${max}`);
    return val;
}
function $fe9c616554b20da0$var$$fae977aafc393c5c$export$f59dee82248f5ad4(time) {
    return `${String(time.hour).padStart(2, "0")}:${String(time.minute).padStart(2, "0")}:${String(time.second).padStart(2, "0")}${time.millisecond ? String(time.millisecond / 1000).slice(1) : ""}`;
}
function $fe9c616554b20da0$var$$fae977aafc393c5c$export$60dfd74aa96791bd(date) {
    let gregorianDate = $fe9c616554b20da0$export$b4a036af3fc0b032(date, new $fe9c616554b20da0$export$80ee6245ec4f29ec());
    return `${String(gregorianDate.year).padStart(4, "0")}-${String(gregorianDate.month).padStart(2, "0")}-${String(gregorianDate.day).padStart(2, "0")}`;
}
function $fe9c616554b20da0$var$$fae977aafc393c5c$export$4223de14708adc63(date) {
    // @ts-ignore
    return `${$fe9c616554b20da0$var$$fae977aafc393c5c$export$60dfd74aa96791bd(date)}T${$fe9c616554b20da0$var$$fae977aafc393c5c$export$f59dee82248f5ad4(date)}`;
}
function $fe9c616554b20da0$var$$fae977aafc393c5c$var$offsetToString(offset) {
    let sign = Math.sign(offset) < 0 ? "-" : "+";
    offset = Math.abs(offset);
    let offsetHours = Math.floor(offset / 3600000);
    let offsetMinutes = offset % 3600000 / 60000;
    return `${sign}${String(offsetHours).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
}
function $fe9c616554b20da0$var$$fae977aafc393c5c$export$bf79f1ebf4b18792(date) {
    return `${$fe9c616554b20da0$var$$fae977aafc393c5c$export$4223de14708adc63(date)}${$fe9c616554b20da0$var$$fae977aafc393c5c$var$offsetToString(date.offset)}[${date.timeZone}]`;
}
function $fe9c616554b20da0$export$ecae829bb3747ea6(value) {
    var _match_groups, _match_groups1, _match_groups2, _match_groups3, _match_groups4, _match_groups5, _match_groups6, _match_groups7, _match_groups8;
    const match = value.match($fe9c616554b20da0$var$$fae977aafc393c5c$var$DATE_TIME_DURATION_RE);
    if (!match) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const parseDurationGroup = (group, isNegative, min, max)=>{
        if (!group) return 0;
        try {
            const sign = isNegative ? -1 : 1;
            return sign * $fe9c616554b20da0$var$$fae977aafc393c5c$var$parseNumber(group.replace(",", "."), min, max);
        } catch  {
            throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
        }
    };
    const isNegative = !!((_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups.negative);
    const hasRequiredGroups = $fe9c616554b20da0$var$$fae977aafc393c5c$var$requiredDurationGroups.some((group)=>{
        var _match_groups;
        return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
    });
    if (!hasRequiredGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    const durationStringIncludesTime = (_match_groups1 = match.groups) === null || _match_groups1 === void 0 ? void 0 : _match_groups1.time;
    if (durationStringIncludesTime) {
        const hasRequiredDurationTimeGroups = $fe9c616554b20da0$var$$fae977aafc393c5c$var$requiredDurationTimeGroups.some((group)=>{
            var _match_groups;
            return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
        });
        if (!hasRequiredDurationTimeGroups) throw new Error(`Invalid ISO 8601 Duration string: ${value}`);
    }
    const duration = {
        years: parseDurationGroup((_match_groups2 = match.groups) === null || _match_groups2 === void 0 ? void 0 : _match_groups2.years, isNegative, 0, 9999),
        months: parseDurationGroup((_match_groups3 = match.groups) === null || _match_groups3 === void 0 ? void 0 : _match_groups3.months, isNegative, 0, 12),
        weeks: parseDurationGroup((_match_groups4 = match.groups) === null || _match_groups4 === void 0 ? void 0 : _match_groups4.weeks, isNegative, 0, Infinity),
        days: parseDurationGroup((_match_groups5 = match.groups) === null || _match_groups5 === void 0 ? void 0 : _match_groups5.days, isNegative, 0, 31),
        hours: parseDurationGroup((_match_groups6 = match.groups) === null || _match_groups6 === void 0 ? void 0 : _match_groups6.hours, isNegative, 0, 23),
        minutes: parseDurationGroup((_match_groups7 = match.groups) === null || _match_groups7 === void 0 ? void 0 : _match_groups7.minutes, isNegative, 0, 59),
        seconds: parseDurationGroup((_match_groups8 = match.groups) === null || _match_groups8 === void 0 ? void 0 : _match_groups8.seconds, isNegative, 0, 59)
    };
    if (duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    if (duration.minutes % 1 !== 0 && duration.seconds) throw new Error(`Invalid ISO 8601 Duration string: ${value} - only the smallest unit can be fractional`);
    return duration;
}
function $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$shiftArgs(args) {
    let calendar = typeof args[0] === "object" ? args.shift() : new $fe9c616554b20da0$export$80ee6245ec4f29ec();
    let era;
    if (typeof args[0] === "string") era = args.shift();
    else {
        let eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    let year = args.shift();
    let month = args.shift();
    let day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
var // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
// If that behavior is desired, use the AnyCalendarDate interface instead.
// @ts-ignore
$fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type = /*#__PURE__*/ new WeakMap();
class $fe9c616554b20da0$export$99faa760c7908e4f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $fe9c616554b20da0$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
        else return new $fe9c616554b20da0$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
    }
    /** Returns a new `CalendarDate` with the given duration added to it. */ add(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$e16d8520af44a096(this, duration);
    }
    /** Returns a new `CalendarDate` with the given duration subtracted from it. */ subtract(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
    }
    /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be(this, fields);
    }
    /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ toDate(timeZone) {
        return $fe9c616554b20da0$var$$11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return $fe9c616554b20da0$var$$fae977aafc393c5c$export$60dfd74aa96791bd(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        return $fe9c616554b20da0$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
    }
    constructor(...args){
        (0, $0a7837cd8c38b609$export$e235798705076415)(this, $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var // @ts-ignore
$fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type1 = /*#__PURE__*/ new WeakMap();
class $fe9c616554b20da0$export$680ea196effce5f {
    /** Returns a copy of this time. */ copy() {
        return new $fe9c616554b20da0$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `Time` with the given duration added to it. */ add(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$7ed87b6bc2506470(this, duration);
    }
    /** Returns a new `Time` with the given duration subtracted from it. */ subtract(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$fe34d3a381cd7501(this, duration);
    }
    /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields);
    }
    /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
    }
    /** Converts the time to an ISO 8601 formatted string. */ toString() {
        return $fe9c616554b20da0$var$$fae977aafc393c5c$export$f59dee82248f5ad4(this);
    }
    /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ compare(b) {
        return $fe9c616554b20da0$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, b);
    }
    constructor(hour = 0, minute = 0, second = 0, millisecond = 0){
        (0, $0a7837cd8c38b609$export$e235798705076415)(this, $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type1, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        $fe9c616554b20da0$var$$735220c2d4774dd3$export$7555de1e070510cb(this);
    }
}
var // @ts-ignore
$fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type2 = /*#__PURE__*/ new WeakMap();
class $fe9c616554b20da0$export$ca871e8dbb80966f {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $fe9c616554b20da0$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
        else return new $fe9c616554b20da0$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `CalendarDateTime` with the given duration added to it. */ add(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$e16d8520af44a096(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
    }
    /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$adaa4cf7ef1b65be($fe9c616554b20da0$var$$735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields), fields);
    }
    /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        switch(field){
            case "era":
            case "year":
            case "month":
            case "day":
                return $fe9c616554b20da0$var$$735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
            default:
                return $fe9c616554b20da0$var$$735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
        }
    }
    /** Converts the date to a native JavaScript Date object in the given time zone. */ toDate(timeZone, disambiguation) {
        return $fe9c616554b20da0$var$$11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone, disambiguation);
    }
    /** Converts the date to an ISO 8601 formatted string. */ toString() {
        return $fe9c616554b20da0$var$$fae977aafc393c5c$export$4223de14708adc63(this);
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        let res = $fe9c616554b20da0$var$$14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
        if (res === 0) return $fe9c616554b20da0$var$$14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, $fe9c616554b20da0$export$b21e0b124e224484(b));
        return res;
    }
    constructor(...args){
        (0, $0a7837cd8c38b609$export$e235798705076415)(this, $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type2, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
var // @ts-ignore
$fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type3 = /*#__PURE__*/ new WeakMap();
class $fe9c616554b20da0$export$d3b7288e7994edea {
    /** Returns a copy of this date. */ copy() {
        if (this.era) return new $fe9c616554b20da0$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
        else return new $fe9c616554b20da0$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
    }
    /** Returns a new `ZonedDateTime` with the given duration added to it. */ add(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$96b1d28349274637(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ subtract(duration) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$6814caac34ca03c7(this, duration);
    }
    /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ set(fields, disambiguation) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$31b5430eb18be4f8(this, fields, disambiguation);
    }
    /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ cycle(field, amount, options) {
        return $fe9c616554b20da0$var$$735220c2d4774dd3$export$9a297d111fc86b79(this, field, amount, options);
    }
    /** Converts the date to a native JavaScript Date object. */ toDate() {
        return $fe9c616554b20da0$var$$11d87f3f76e88657$export$83aac07b4c37b25(this);
    }
    /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ toString() {
        return $fe9c616554b20da0$var$$fae977aafc393c5c$export$bf79f1ebf4b18792(this);
    }
    /** Converts the date to an ISO 8601 formatted string in UTC. */ toAbsoluteString() {
        return this.toDate().toISOString();
    }
    /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ compare(b) {
        // TODO: Is this a bad idea??
        return this.toDate().getTime() - $fe9c616554b20da0$export$84c95a83c799e074(b, this.timeZone).toDate().getTime();
    }
    constructor(...args){
        (0, $0a7837cd8c38b609$export$e235798705076415)(this, $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$_type3, {
            writable: true,
            value: void 0
        });
        let [calendar, era, year, month, day] = $fe9c616554b20da0$var$$35ea8db9cb2ccb90$var$shiftArgs(args);
        let timeZone = args.shift();
        let offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $fe9c616554b20da0$var$$735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
const $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
const $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
const $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES = [
    "meiji",
    "taisho",
    "showa",
    "heisei",
    "reiwa"
];
function $fe9c616554b20da0$var$$62225008020f0a13$var$findEraFromGregorianDate(date) {
    const idx = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES.findIndex(([year, month, day])=>{
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $fe9c616554b20da0$var$$62225008020f0a13$var$toGregorian(date) {
    let eraAddend = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_ADDENDS[$fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error("Unknown era: " + date.era);
    return new $fe9c616554b20da0$export$99faa760c7908e4f(date.year + eraAddend, date.month, date.day);
}
class $fe9c616554b20da0$export$b746ab2b60cdffbf extends $fe9c616554b20da0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let era = $fe9c616554b20da0$var$$62225008020f0a13$var$findEraFromGregorianDate(date);
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES[era], date.year - $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($fe9c616554b20da0$var$$62225008020f0a13$var$toGregorian(date));
    }
    balanceDate(date) {
        let gregorianDate = $fe9c616554b20da0$var$$62225008020f0a13$var$toGregorian(date);
        let era = $fe9c616554b20da0$var$$62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
        if ($fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
            date.era = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES[era];
            date.year = gregorianDate.year - $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_ADDENDS[era];
        }
        // Constrain in case we went before the first supported era.
        this.constrainDate(date);
    }
    constrainDate(date) {
        let idx = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let end = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_END_DATES[idx];
        if (end != null) {
            let [endYear, endMonth, endDay] = end;
            // Constrain the year to the maximum possible value in the era.
            // Then constrain the month and day fields within that.
            let maxYear = endYear - $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_ADDENDS[idx];
            date.year = Math.max(1, Math.min(maxYear, date.year));
            if (date.year === maxYear) {
                date.month = Math.min(endMonth, date.month);
                if (date.month === endMonth) date.day = Math.min(endDay, date.day);
            }
        }
        if (date.year === 1 && idx >= 0) {
            let [, startMonth, startDay] = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES[idx];
            date.month = Math.max(startMonth, date.month);
            if (date.month === startMonth) date.day = Math.max(startDay, date.day);
        }
    }
    getEras() {
        return $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES;
    }
    getYearsInEra(date) {
        // Get the number of years in the era, taking into account the date's month and day fields.
        let era = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        let cur = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES[era];
        let next = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES[era + 1];
        if (next == null) return 9999 - cur[0] + 1;
        let years = next[0] - cur[0];
        if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
        return years;
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($fe9c616554b20da0$var$$62225008020f0a13$var$toGregorian(date));
    }
    getMinimumMonthInYear(date) {
        let start = $fe9c616554b20da0$var$$62225008020f0a13$var$getMinimums(date);
        return start ? start[1] : 1;
    }
    getMinimumDayInMonth(date) {
        let start = $fe9c616554b20da0$var$$62225008020f0a13$var$getMinimums(date);
        return start && date.month === start[1] ? start[2] : 1;
    }
    constructor(...args){
        super(...args);
        this.identifier = "japanese";
    }
}
function $fe9c616554b20da0$var$$62225008020f0a13$var$getMinimums(date) {
    if (date.year === 1) {
        let idx = $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        return $fe9c616554b20da0$var$$62225008020f0a13$var$ERA_START_DATES[idx];
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START = -543;
class $fe9c616554b20da0$export$42d20a78301dee44 extends $fe9c616554b20da0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let gregorianDate = super.fromJulianDay(jd);
        let year = $fe9c616554b20da0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(gregorianDate.era, gregorianDate.year);
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, year - $fe9c616554b20da0$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($fe9c616554b20da0$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    getEras() {
        return [
            "BE"
        ];
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($fe9c616554b20da0$var$$8d73d47422ca7302$var$toGregorian(date));
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "buddhist";
    }
}
function $fe9c616554b20da0$var$$8d73d47422ca7302$var$toGregorian(date) {
    let [era, year] = $fe9c616554b20da0$var$$3b62074eb05584b2$export$4475b7e617eb123c(date.year + $fe9c616554b20da0$var$$8d73d47422ca7302$var$BUDDHIST_ERA_START);
    return new $fe9c616554b20da0$export$99faa760c7908e4f(era, year, date.month, date.day);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START = 1911;
function $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$gregorianYear(date) {
    return date.era === "minguo" ? date.year + $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START : 1 - date.year + $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
}
function $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(year) {
    let y = year - $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    if (y > 0) return [
        "minguo",
        y
    ];
    else return [
        "before_minguo",
        1 - y
    ];
}
class $fe9c616554b20da0$export$65e01080afcb0799 extends $fe9c616554b20da0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        let date = super.fromJulianDay(jd);
        let extendedYear = $fe9c616554b20da0$var$$3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
        let [era, year] = $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear);
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, era, year, date.month, date.day);
    }
    toJulianDay(date) {
        return super.toJulianDay($fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getEras() {
        return [
            "before_minguo",
            "minguo"
        ];
    }
    balanceDate(date) {
        let [era, year] = $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$gregorianToTaiwan($fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
        date.era = era;
        date.year = year;
    }
    isInverseEra(date) {
        return date.era === "before_minguo";
    }
    getDaysInMonth(date) {
        return super.getDaysInMonth($fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$toGregorian(date));
    }
    getYearsInEra(date) {
        return date.era === "before_minguo" ? 9999 : 9999 - $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    }
    constructor(...args){
        super(...args);
        this.identifier = "roc" // Republic of China
        ;
    }
}
function $fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$toGregorian(date) {
    let [era, year] = $fe9c616554b20da0$var$$3b62074eb05584b2$export$4475b7e617eb123c($fe9c616554b20da0$var$$5f31bd6f0c8940b2$var$gregorianYear(date));
    return new $fe9c616554b20da0$export$99faa760c7908e4f(era, year, date.month, date.day);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH = 1948321; // 622/03/19 Julian C.E.
function $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$isLeapYear(year) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    return $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1((y1 + 38) * 31, 128) < 31;
}
function $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, month, day) {
    let y0 = year > 0 ? year - 474 : year - 473;
    let y1 = $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    let offset = month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6;
    return $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$PERSIAN_EPOCH - 1 + 1029983 * Math.floor(y0 / 2820) + 365 * (y1 - 1) + Math.floor((31 * y1 - 5) / 128) + offset + day;
}
class $fe9c616554b20da0$export$37fccdbfd14c5939 {
    fromJulianDay(jd) {
        let d0 = jd - $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(475, 1, 1);
        let n2820 = Math.floor(d0 / 1029983);
        let d1 = $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(d0, 1029983);
        let y2820 = d1 === 1029982 ? 2820 : Math.floor((128 * d1 + 46878) / 46751);
        let year = 474 + 2820 * n2820 + y2820;
        if (year <= 0) year--;
        let yDay = jd - $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, 1, 1) + 1;
        let month = yDay <= 186 ? Math.ceil(yDay / 31) : Math.ceil((yDay - 6) / 31);
        let day = jd - $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(year, month, 1) + 1;
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, year, month, day);
    }
    toJulianDay(date) {
        return $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$persianToJulianDay(date.year, date.month, date.day);
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInMonth(date) {
        if (date.month <= 6) return 31;
        if (date.month <= 11) return 30;
        return $fe9c616554b20da0$var$$f3ed2e4472ae7e25$var$isLeapYear(date.year) ? 30 : 29;
    }
    getEras() {
        return [
            "AP"
        ];
    }
    getYearsInEra() {
        // 9378-10-10 persian is 9999-12-31 gregorian.
        // Round down to 9377 to set the maximum full year.
        return 9377;
    }
    constructor(){
        this.identifier = "persian";
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
// Starts in 78 AD,
const $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
const $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_YEAR_START = 80;
class $fe9c616554b20da0$export$39f31c639fa15726 extends $fe9c616554b20da0$export$80ee6245ec4f29ec {
    fromJulianDay(jd) {
        // Gregorian date for Julian day
        let date = super.fromJulianDay(jd);
        // Year in Saka era
        let indianYear = date.year - $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        // Day number in Gregorian year (starting from 0)
        let yDay = jd - $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, 1, 1);
        let leapMonth;
        if (yDay < $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_YEAR_START) {
            //  Day is at the end of the preceding Saka year
            indianYear--;
            // Days in leapMonth this year, previous Gregorian year
            leapMonth = $fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year - 1) ? 31 : 30;
            yDay += leapMonth + 155 + 90 + 10;
        } else {
            // Days in leapMonth this year
            leapMonth = $fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 31 : 30;
            yDay -= $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_YEAR_START;
        }
        let indianMonth;
        let indianDay;
        if (yDay < leapMonth) {
            indianMonth = 1;
            indianDay = yDay + 1;
        } else {
            let mDay = yDay - leapMonth;
            if (mDay < 155) {
                indianMonth = Math.floor(mDay / 31) + 2;
                indianDay = mDay % 31 + 1;
            } else {
                mDay -= 155;
                indianMonth = Math.floor(mDay / 30) + 7;
                indianDay = mDay % 30 + 1;
            }
        }
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, indianYear, indianMonth, indianDay);
    }
    toJulianDay(date) {
        let extendedYear = date.year + $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_ERA_START;
        let [era, year] = $fe9c616554b20da0$var$$3b62074eb05584b2$export$4475b7e617eb123c(extendedYear);
        let leapMonth;
        let jd;
        if ($fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(year)) {
            leapMonth = 31;
            jd = $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 21);
        } else {
            leapMonth = 30;
            jd = $fe9c616554b20da0$var$$3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 22);
        }
        if (date.month === 1) return jd + date.day - 1;
        jd += leapMonth + Math.min(date.month - 2, 5) * 31;
        if (date.month >= 8) jd += (date.month - 7) * 30;
        jd += date.day - 1;
        return jd;
    }
    getDaysInMonth(date) {
        if (date.month === 1 && $fe9c616554b20da0$var$$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year + $fe9c616554b20da0$var$$82c358003bdda0a8$var$INDIAN_ERA_START)) return 31;
        if (date.month >= 2 && date.month <= 6) return 31;
        return 30;
    }
    getYearsInEra() {
        // 9999-12-31 gregorian is 9920-10-10 indian.
        // Round down to 9919 for the last full year.
        return 9919;
    }
    getEras() {
        return [
            "saka"
        ];
    }
    balanceDate() {}
    constructor(...args){
        super(...args);
        this.identifier = "indian";
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
const $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
const $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START = 1300;
const $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END = 1600;
const $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS = 460322;
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(calendar, epoch, jd) {
    let year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    let month = Math.min(12, Math.ceil((jd - (29 + $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    let day = jd - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new $fe9c616554b20da0$export$99faa760c7908e4f(calendar, year, month, day);
}
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
class $fe9c616554b20da0$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, jd);
    }
    toJulianDay(date) {
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let length = 29 + date.month % 2;
        if (date.month === 12 && $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year)) length++;
        return length;
    }
    getMonthsInYear() {
        return 12;
    }
    getDaysInYear(date) {
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$isLeapYear(date.year) ? 355 : 354;
    }
    getYearsInEra() {
        // 9999 gregorian
        return 9665;
    }
    getEras() {
        return [
            "AH"
        ];
    }
    constructor(){
        this.identifier = "islamic-civil";
    }
}
class $fe9c616554b20da0$export$37f0887f2f9d22f7 extends $fe9c616554b20da0$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$julianDayToIslamic(this, $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, jd);
    }
    toJulianDay(date) {
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$islamicToJulianDay($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
    constructor(...args){
        super(...args);
        this.identifier = "islamic-tbla";
    }
}
// Generated by scripts/generate-umalqura.js
const $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;
let $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year) {
    return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_START_DAYS + $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, month) {
    let idx = year - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;
    let mask = 0x01 << 11 - (month - 1);
    if (($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(year, month) {
    let day = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearStart(year);
    for(let i = 1; i < month; i++)day += $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
    return day;
}
function $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearLength(year) {
    return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year + 1 - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
class $fe9c616554b20da0$export$5baab4758c231076 extends $fe9c616554b20da0$export$2066795aadd37bfc {
    fromJulianDay(jd) {
        let days = jd - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC;
        let startDays = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearStart($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);
        let endDays = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearStart($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);
        if (days < startDays || days > endDays) return super.fromJulianDay(jd);
        else {
            let y = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START - 1;
            let m = 1;
            let d = 1;
            while(d > 0){
                y++;
                d = days - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearStart(y) + 1;
                let yearLength = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearLength(y);
                if (d === yearLength) {
                    m = 12;
                    break;
                } else if (d < yearLength) {
                    let monthLength = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    m = 1;
                    while(d > monthLength){
                        d -= monthLength;
                        m++;
                        monthLength = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                    }
                    break;
                }
            }
            return new $fe9c616554b20da0$export$99faa760c7908e4f(this, y, m, days - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(y, m) + 1);
        }
    }
    toJulianDay(date) {
        if (date.year < $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.toJulianDay(date);
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$CIVIL_EPOC + $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
    getDaysInMonth(date) {
        if (date.year < $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInMonth(date);
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(date.year, date.month);
    }
    getDaysInYear(date) {
        if (date.year < $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return super.getDaysInYear(date);
        return $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraYearLength(date.year);
    }
    constructor(){
        super();
        this.identifier = "islamic-umalqura";
        if (!$fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH) $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_DATA), (c)=>c.charCodeAt(0)).buffer);
        if (!$fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE) {
            $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START + 1);
            let yearStart = 0;
            for(let year = $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START; year <= $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_END; year++){
                $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] = yearStart;
                for(let i = 1; i <= 12; i++)yearStart += $fe9c616554b20da0$var$$f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
            }
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$7c5f6fbf42389787$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
const $fe9c616554b20da0$var$$7c5f6fbf42389787$var$HOUR_PARTS = 1080;
const $fe9c616554b20da0$var$$7c5f6fbf42389787$var$DAY_PARTS = 24 * $fe9c616554b20da0$var$$7c5f6fbf42389787$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
const $fe9c616554b20da0$var$$7c5f6fbf42389787$var$MONTH_DAYS = 29;
const $fe9c616554b20da0$var$$7c5f6fbf42389787$var$MONTH_FRACT = 12 * $fe9c616554b20da0$var$$7c5f6fbf42389787$var$HOUR_PARTS + 793;
const $fe9c616554b20da0$var$$7c5f6fbf42389787$var$MONTH_PARTS = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$MONTH_DAYS * $fe9c616554b20da0$var$$7c5f6fbf42389787$var$DAY_PARTS + $fe9c616554b20da0$var$$7c5f6fbf42389787$var$MONTH_FRACT;
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(year) {
    return $fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay1(year) {
    let months = Math.floor((235 * year - 234) / 19);
    let parts = 12084 + 13753 * months;
    let day = months * 29 + Math.floor(parts / 25920);
    if ($fe9c616554b20da0$var$$2b4dce13dd5a17fa$export$842a2cf37af977e1(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay2(year) {
    let last = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay1(year - 1);
    let present = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay1(year);
    let next = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$startOfYear(year) {
    return $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay1(year) + $fe9c616554b20da0$var$$7c5f6fbf42389787$var$hebrewDelay2(year);
}
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInYear(year) {
    return $fe9c616554b20da0$var$$7c5f6fbf42389787$var$startOfYear(year + 1) - $fe9c616554b20da0$var$$7c5f6fbf42389787$var$startOfYear(year);
}
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getYearType(year) {
    let yearLength = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    let yearType = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
class $fe9c616554b20da0$export$ca405048b8fb5af {
    fromJulianDay(jd) {
        let d = jd - $fe9c616554b20da0$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
        let m = d * $fe9c616554b20da0$var$$7c5f6fbf42389787$var$DAY_PARTS / $fe9c616554b20da0$var$$7c5f6fbf42389787$var$MONTH_PARTS; // Months (approx)
        let year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
        let ys = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$startOfYear(year); // 1st day of year
        let dayOfYear = Math.floor(d - ys);
        // Because of the postponement rules, it's possible to guess wrong.  Fix it.
        while(dayOfYear < 1){
            year--;
            ys = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$startOfYear(year);
            dayOfYear = Math.floor(d - ys);
        }
        // Now figure out which month we're in, and the date within that month
        let month = 1;
        let monthStart = 0;
        while(monthStart < dayOfYear){
            monthStart += $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
            month++;
        }
        month--;
        monthStart -= $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInMonth(year, month);
        let day = dayOfYear - monthStart;
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, year, month, day);
    }
    toJulianDay(date) {
        let jd = $fe9c616554b20da0$var$$7c5f6fbf42389787$var$startOfYear(date.year);
        for(let month = 1; month < date.month; month++)jd += $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, month);
        return jd + date.day + $fe9c616554b20da0$var$$7c5f6fbf42389787$var$HEBREW_EPOCH;
    }
    getDaysInMonth(date) {
        return $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear(date) {
        return $fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(date.year) ? 13 : 12;
    }
    getDaysInYear(date) {
        return $fe9c616554b20da0$var$$7c5f6fbf42389787$var$getDaysInYear(date.year);
    }
    getYearsInEra() {
        // 6239 gregorian
        return 9999;
    }
    getEras() {
        return [
            "AM"
        ];
    }
    balanceYearMonth(date, previousDate) {
        // Keep date in the same month when switching between leap years and non leap years
        if (previousDate.year !== date.year) {
            if ($fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && !$fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
            else if (!$fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && $fe9c616554b20da0$var$$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
        }
    }
    constructor(){
        this.identifier = "hebrew";
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
const $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH = 1723856;
const $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
const $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA = 5500;
function $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$julianDayToCE(epoch, jd) {
    let year = Math.floor(4 * (jd - epoch) / 1461);
    let month = 1 + Math.floor((jd - $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    let day = jd + 1 - $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$getLeapDay(year) + 5;
}
class $fe9c616554b20da0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$julianDayToCE($fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        let era = "AM";
        if (year <= 0) {
            era = "AA";
            year += $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        }
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "AA") year -= $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ceToJulianDay($fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        return $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$getDaysInMonth(date.year, date.month);
    }
    getMonthsInYear() {
        return 13;
    }
    getDaysInYear(date) {
        return 365 + $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$getLeapDay(date.year);
    }
    getYearsInEra(date) {
        // 9999-12-31 gregorian is 9992-20-02 ethiopic.
        // Round down to 9991 for the last full year.
        // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
        return date.era === "AA" ? 9999 : 9991;
    }
    getEras() {
        return [
            "AA",
            "AM"
        ];
    }
    constructor(){
        this.identifier = "ethiopic";
    }
}
class $fe9c616554b20da0$export$d72e0c37005a4914 extends $fe9c616554b20da0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$julianDayToCE($fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd);
        year += $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, "AA", year, month, day);
    }
    getEras() {
        return [
            "AA"
        ];
    }
    getYearsInEra() {
        // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
        return 9999;
    }
    constructor(...args){
        super(...args);
        this.identifier = "ethioaa" // also known as 'ethiopic-amete-alem' in ICU
        ;
    }
}
class $fe9c616554b20da0$export$fe6243cbe1a4b7c1 extends $fe9c616554b20da0$export$26ba6eab5e20cd7d {
    fromJulianDay(jd) {
        let [year, month, day] = $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$julianDayToCE($fe9c616554b20da0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, jd);
        let era = "CE";
        if (year <= 0) {
            era = "BCE";
            year = 1 - year;
        }
        return new $fe9c616554b20da0$export$99faa760c7908e4f(this, era, year, month, day);
    }
    toJulianDay(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$ceToJulianDay($fe9c616554b20da0$var$$b956b2d7a6cf451f$var$COPTIC_EPOCH, year, date.month, date.day);
    }
    getDaysInMonth(date) {
        let year = date.year;
        if (date.era === "BCE") year = 1 - year;
        return $fe9c616554b20da0$var$$b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
    }
    isInverseEra(date) {
        return date.era === "BCE";
    }
    balanceDate(date) {
        if (date.year <= 0) {
            date.era = date.era === "BCE" ? "CE" : "BCE";
            date.year = 1 - date.year;
        }
    }
    getEras() {
        return [
            "BCE",
            "CE"
        ];
    }
    getYearsInEra(date) {
        // 9999-12-30 gregorian is 9716-02-20 coptic.
        // Round down to 9715 for the last full year.
        // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
        return date.era === "BCE" ? 9999 : 9715;
    }
    constructor(...args){
        super(...args);
        this.identifier = "coptic";
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fe9c616554b20da0$export$dd0bbc9b26defe37(name) {
    switch(name){
        case "buddhist":
            return new $fe9c616554b20da0$export$42d20a78301dee44();
        case "ethiopic":
            return new $fe9c616554b20da0$export$26ba6eab5e20cd7d();
        case "ethioaa":
            return new $fe9c616554b20da0$export$d72e0c37005a4914();
        case "coptic":
            return new $fe9c616554b20da0$export$fe6243cbe1a4b7c1();
        case "hebrew":
            return new $fe9c616554b20da0$export$ca405048b8fb5af();
        case "indian":
            return new $fe9c616554b20da0$export$39f31c639fa15726();
        case "islamic-civil":
            return new $fe9c616554b20da0$export$2066795aadd37bfc();
        case "islamic-tbla":
            return new $fe9c616554b20da0$export$37f0887f2f9d22f7();
        case "islamic-umalqura":
            return new $fe9c616554b20da0$export$5baab4758c231076();
        case "japanese":
            return new $fe9c616554b20da0$export$b746ab2b60cdffbf();
        case "persian":
            return new $fe9c616554b20da0$export$37fccdbfd14c5939();
        case "roc":
            return new $fe9c616554b20da0$export$65e01080afcb0799();
        case "gregory":
        default:
            return new $fe9c616554b20da0$export$80ee6245ec4f29ec();
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $fe9c616554b20da0$var$$fb18d541ea1ad717$var$formatterCache = new Map();
class $fe9c616554b20da0$export$ad991b66133851cf {
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if ($fe9c616554b20da0$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = $fe9c616554b20da0$var$$fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
        return resolvedOptions;
    }
    constructor(locale, options = {}){
        this.formatter = $fe9c616554b20da0$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const $fe9c616554b20da0$var$$fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $fe9c616554b20da0$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $fe9c616554b20da0$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = $fe9c616554b20da0$var$$fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        let defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($fe9c616554b20da0$var$$fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $fe9c616554b20da0$var$$fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    $fe9c616554b20da0$var$$fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let $fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $fe9c616554b20da0$var$$fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $fe9c616554b20da0$var$$fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $fe9c616554b20da0$var$$fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $fe9c616554b20da0$var$$fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    let formatter = $fe9c616554b20da0$var$$fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === "hour").value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === "hour").value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
let $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
class $9846c2f941c9c3e2$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = "";
        if (!$9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === "unit" && !$9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = "short", locale: locale } = this.resolvedOptions();
            let values = (_UNITS_unit = $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        // @ts-ignore
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError("End date must be >= start date");
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: "startRange"
                })),
            {
                type: "literal",
                value: " \u2013 ",
                source: "shared"
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: "endRange"
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = {
            ...options,
            style: "unit",
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.indexOf("-u-nu-") === -1) locale = `${locale}-u-nu-${numberingSystem}`;
    if (options.style === "unit" && !$9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = "short" } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: "decimal"
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $9846c2f941c9c3e2$var$$488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ([
                ...minus
            ].length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
const $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
class $9846c2f941c9c3e2$export$cd11ab140839f11d {
    /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ parse(value) {
        return $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ isValidPartialNumber(value, minValue, maxValue) {
        return $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ getNumberingSystem(value) {
        return $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.options = options;
    }
}
const $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$numberParserCache = new Map();
function $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    let defaultParser = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        for (let numberingSystem of $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$NUMBERING_SYSTEMS)if (numberingSystem !== defaultParser.options.numberingSystem) {
            let parser = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
            if (parser.isValidPartialNumber(value)) return parser;
        }
    }
    return defaultParser;
}
function $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    let parser = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
class $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$NumberParserImpl {
    parse(value) {
        // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
        let fullySanitizedValue = this.sanitize(value);
        // Remove group characters, and replace decimal points and numerals with ASCII values.
        fullySanitizedValue = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "").replace(this.symbols.decimal, ".").replace(this.symbols.minusSign, "-").replace(this.symbols.numeral, this.symbols.index);
        if (this.options.style === "percent") {
            // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
            let isNegative = fullySanitizedValue.indexOf("-");
            fullySanitizedValue = fullySanitizedValue.replace("-", "");
            let index = fullySanitizedValue.indexOf(".");
            if (index === -1) index = fullySanitizedValue.length;
            fullySanitizedValue = fullySanitizedValue.replace(".", "");
            if (index - 2 === 0) fullySanitizedValue = `0.${fullySanitizedValue}`;
            else if (index - 2 === -1) fullySanitizedValue = `0.0${fullySanitizedValue}`;
            else if (index - 2 === -2) fullySanitizedValue = "0.00";
            else fullySanitizedValue = `${fullySanitizedValue.slice(0, index - 2)}.${fullySanitizedValue.slice(index - 2)}`;
            if (isNegative > -1) fullySanitizedValue = `-${fullySanitizedValue}`;
        }
        let newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
        if (isNaN(newValue)) return NaN;
        if (this.options.style === "percent") {
            // extra step for rounding percents to what our formatter would output
            let options = {
                ...this.options,
                style: "decimal",
                minimumFractionDigits: Math.min(this.options.minimumFractionDigits + 2, 20),
                maximumFractionDigits: Math.min(this.options.maximumFractionDigits + 2, 20)
            };
            return new $9846c2f941c9c3e2$export$cd11ab140839f11d(this.locale, options).parse(new $9846c2f941c9c3e2$export$cc77c4ff7e8673c5(this.locale, options).format(newValue));
        }
        // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
        if (this.options.currencySign === "accounting" && $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
        return newValue;
    }
    sanitize(value) {
        // Remove literals and whitespace, which are allowed anywhere in the string
        value = value.replace(this.symbols.literals, "");
        // Replace the ASCII minus sign with the minus sign used in the current locale
        // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
        value = value.replace("-", this.symbols.minusSign);
        // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
        // instead they use the , (44) character or apparently the (1548) character.
        if (this.options.numberingSystem === "arab") {
            value = value.replace(",", this.symbols.decimal);
            value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
            value = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
        }
        // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
        // so allow 'period' as a group char and replace it with a space
        if (this.options.locale === "fr-FR") value = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
        return value;
    }
    isValidPartialNumber(value, minValue = -Infinity, maxValue = Infinity) {
        value = this.sanitize(value);
        // Remove minus or plus sign, which must be at the start of the string.
        if (value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
        else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
        // Numbers cannot start with a group separator
        if (value.startsWith(this.symbols.group)) return false;
        // Numbers that can't have any decimal values fail if a decimal character is typed
        if (value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
        // Remove numerals, groups, and decimals
        value = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "").replace(this.symbols.numeral, "").replace(this.symbols.decimal, "");
        // The number is valid if there are no remaining characters
        return value.length === 0;
    }
    constructor(locale, options = {}){
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
}
const $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
const $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    let symbolFormatter = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21
    });
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    let allParts = symbolFormatter.formatToParts(-10000.111);
    let posAllParts = symbolFormatter.formatToParts(10000.111);
    let pluralParts = $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$pluralNumbers.map((n)=>symbolFormatter.formatToParts(n));
    var _allParts_find_value;
    let minusSign = (_allParts_find_value = (_allParts_find = allParts.find((p)=>p.type === "minusSign")) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    let plusSign = (_posAllParts_find = posAllParts.find((p)=>p.type === "plusSign")) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    let decimalParts = new Intl.NumberFormat(locale, {
        ...intlOptions,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).formatToParts(0.001);
    let decimal = (_decimalParts_find = decimalParts.find((p)=>p.type === "decimal")) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    let group = (_allParts_find1 = allParts.find((p)=>p.type === "group")) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    let allPartsLiterals = allParts.filter((p)=>!$9846c2f941c9c3e2$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$9846c2f941c9c3e2$var$$6c7bd7858deea686$var$escapeRegex(p.value));
    let pluralPartsLiterals = pluralParts.flatMap((p)=>p.filter((p)=>!$9846c2f941c9c3e2$var$$6c7bd7858deea686$var$nonLiteralParts.has(p.type)).map((p)=>$9846c2f941c9c3e2$var$$6c7bd7858deea686$var$escapeRegex(p.value)));
    let sortedLiterals = [
        ...new Set([
            ...allPartsLiterals,
            ...pluralPartsLiterals
        ])
    ].sort((a, b)=>b.length - a.length);
    let literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${sortedLiterals.join("|")}|[\\p{White_Space}]`, "gu");
    // These are for replacing non-latn characters with the latn equivalent
    let numerals = [
        ...new Intl.NumberFormat(intlOptions.locale, {
            useGrouping: false
        }).format(9876543210)
    ].reverse();
    let indexes = new Map(numerals.map((d, i)=>[
            d,
            i
        ]));
    let numeral = new RegExp(`[${numerals.join("")}]`, "g");
    let index = (d)=>String(indexes.get(d));
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $9846c2f941c9c3e2$var$$6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $fcf9384597cd7e10$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
const $fcf9384597cd7e10$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $fcf9384597cd7e10$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) {
    // If the Intl.Locale API is available, use it to get the script for the locale.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    // @ts-ignore
    if (Intl.Locale) {
        // @ts-ignore
        let script = new Intl.Locale(locale).maximize().script;
        if (!script) return false;
        return $fcf9384597cd7e10$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = locale.split("-")[0];
    return $fcf9384597cd7e10$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    // @ts-ignore
    let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: $fcf9384597cd7e10$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
let $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$currentLocale = $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$currentLocale = $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    for (let listener of $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$listeners)listener($fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $ed57708adbbc95d6$export$535bd6ca7f90a273)();
    let [defaultLocale, setDefaultLocale] = (0, $7fPBF.useState)($fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $7fPBF.useEffect)(()=>{
        if ($fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}
const $fcf9384597cd7e10$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
function $fcf9384597cd7e10$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let value = locale ? {
        locale: locale,
        direction: $fcf9384597cd7e10$var$$148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($fcf9384597cd7e10$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $fcf9384597cd7e10$export$43bb16f9c6d9e3f7() {
    let defaultLocale = $fcf9384597cd7e10$var$$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    let context = (0, $7fPBF.useContext)($fcf9384597cd7e10$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}
var $fcf9384597cd7e10$var$$2aa2084a6c2b6b4f$exports = {};
"use strict";
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fcf9384597cd7e10$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $fcf9384597cd7e10$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $fcf9384597cd7e10$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $fc0f58a4c3b6de6a$export$c17fa47878dc55b6)(strings);
        $fcf9384597cd7e10$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $fcf9384597cd7e10$export$f12b703ca79dfbb1(strings) {
    let { locale: locale } = $fcf9384597cd7e10$export$43bb16f9c6d9e3f7();
    let dictionary = (0, $7fPBF.useMemo)(()=>$fcf9384597cd7e10$var$$fca6afa0e843324b$var$getCachedDictionary(strings), [
        strings
    ]);
    return (0, $7fPBF.useMemo)(()=>new (0, $fc0f58a4c3b6de6a$export$2f817fcdc4b89ae0)(locale, dictionary), [
        locale,
        dictionary
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fcf9384597cd7e10$export$a2f47a3d2973640(options = {}) {
    let { locale: locale } = $fcf9384597cd7e10$export$43bb16f9c6d9e3f7();
    return (0, $7fPBF.useMemo)(()=>new Intl.ListFormat(locale, options), [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fcf9384597cd7e10$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, $a26d4c995bb2a467$export$722debc0e56fea39)(options !== null && options !== void 0 ? options : {}, $fcf9384597cd7e10$var$$896ba0a80a8f4d36$var$isEqual);
    let { locale: locale } = $fcf9384597cd7e10$export$43bb16f9c6d9e3f7();
    return (0, $7fPBF.useMemo)(()=>new (0, $fe9c616554b20da0$export$ad991b66133851cf)(locale, options), [
        locale,
        options
    ]);
}
function $fcf9384597cd7e10$var$$896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fcf9384597cd7e10$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = $fcf9384597cd7e10$export$43bb16f9c6d9e3f7();
    return (0, $7fPBF.useMemo)(()=>new (0, $9846c2f941c9c3e2$export$cc77c4ff7e8673c5)(locale, options), [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $fcf9384597cd7e10$var$$325a3faab7a68acd$var$cache = new Map();
function $fcf9384597cd7e10$export$a16aca283550c30d(options) {
    let { locale: locale } = $fcf9384597cd7e10$export$43bb16f9c6d9e3f7();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : "");
    if ($fcf9384597cd7e10$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $fcf9384597cd7e10$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $fcf9384597cd7e10$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fcf9384597cd7e10$export$3274cf84b703fff(options) {
    let collator = $fcf9384597cd7e10$export$a16aca283550c30d({
        usage: "search",
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    let startsWith = (0, $7fPBF.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    let endsWith = (0, $7fPBF.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    let contains = (0, $7fPBF.useCallback)((string, substring)=>{
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        let scan = 0;
        let sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            let slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, $7fPBF.useMemo)(()=>({
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ee6c7218d784230d$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $a26d4c995bb2a467$export$e1865c3bedcd822b)() ? e.altKey : e.ctrlKey;
}
function $ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e) {
    if ((0, $a26d4c995bb2a467$export$9ac100e40613ea10)()) return e.metaKey;
    return e.ctrlKey;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $ee6c7218d784230d$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $ee6c7218d784230d$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $7fPBF.useRef)({
        search: "",
        timeout: null
    }).current;
    let onKeyDown = (e)=>{
        let character = $ee6c7218d784230d$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === " " && state.search.trim().length > 0) {
            e.preventDefault();
            if (!("continuePropagation" in e)) e.stopPropagation();
        }
        state.search += character;
        // Use the delegate to find a key to focus.
        // Prioritize items after the currently focused item, falling back to searching the whole list.
        let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
        // If no key found, search from the top.
        if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
        if (key != null) {
            selectionManager.setFocusedKey(key);
            if (onTypeSelect) onTypeSelect(key);
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = "";
        }, $ee6c7218d784230d$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : null
        }
    };
}
function $ee6c7218d784230d$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return "";
}
function $ee6c7218d784230d$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === "replace", disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = "action" } = options;
    let { direction: direction } = (0, $fcf9384597cd7e10$export$43bb16f9c6d9e3f7)();
    let router = (0, $a26d4c995bb2a467$export$9a302a45f65d0572)();
    let onKeyDown = (e)=>{
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === "Tab") e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!ref.current.contains(e.target)) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === "selection" && selectOnFocus && !$ee6c7218d784230d$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) {
                    (0, $b4ba1c853f6e1116$exports.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = scrollRef.current.querySelector(`[data-key="${key}"]`);
                    router.open(item, e);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === "override") return;
                if (e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(key);
                else if (selectOnFocus && !$ee6c7218d784230d$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case "ArrowDown":
                if (delegate.getKeyBelow) {
                    var _delegate_getFirstKey, _delegate_getFirstKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyBelow(manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowUp":
                if (delegate.getKeyAbove) {
                    var _delegate_getLastKey, _delegate_getLastKey1;
                    e.preventDefault();
                    let nextKey = manager.focusedKey != null ? delegate.getKeyAbove(manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "ArrowLeft":
                if (delegate.getKeyLeftOf) {
                    var _delegate_getFirstKey2, _delegate_getLastKey2;
                    e.preventDefault();
                    let nextKey = delegate.getKeyLeftOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "first" : "last");
                }
                break;
            case "ArrowRight":
                if (delegate.getKeyRightOf) {
                    var _delegate_getLastKey3, _delegate_getFirstKey3;
                    e.preventDefault();
                    let nextKey = delegate.getKeyRightOf(manager.focusedKey);
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === "rtl" ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    navigateToKey(nextKey, direction === "rtl" ? "last" : "first");
                }
                break;
            case "Home":
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, $ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(firstKey);
                    if ($ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(firstKey);
                    else if (selectOnFocus) manager.replaceSelection(firstKey);
                }
                break;
            case "End":
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, $ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e));
                    manager.setFocusedKey(lastKey);
                    if ($ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e) && e.shiftKey && manager.selectionMode === "multiple") manager.extendSelection(lastKey);
                    else if (selectOnFocus) manager.replaceSelection(lastKey);
                }
                break;
            case "PageDown":
                if (delegate.getKeyPageBelow) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "PageUp":
                if (delegate.getKeyPageAbove) {
                    e.preventDefault();
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    navigateToKey(nextKey);
                }
                break;
            case "a":
                if ($ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e) && manager.selectionMode === "multiple" && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case "Escape":
                e.preventDefault();
                if (!disallowEmptySelection) manager.clearSelection();
                break;
            case "Tab":
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $2cf1c82089cb095e$export$2d6ec8fc375ceafa)(ref.current, {
                            tabbable: true
                        });
                        let next;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    let scrollPos = (0, $7fPBF.useRef)({
        top: 0,
        left: 0
    });
    (0, $a26d4c995bb2a467$export$90fc3a17d93f704c)(scrollRef, "scroll", isVirtualized ? null : ()=>{
        scrollPos.current = {
            top: scrollRef.current.scrollTop,
            left: scrollRef.current.scrollLeft
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : delegate.getLastKey());
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : delegate.getFirstKey());
        } else if (!isVirtualized) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (!isVirtualized && manager.focusedKey != null) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $a26d4c995bb2a467$export$de79e2c695e052f3)(element);
                let modality = (0, $9102a566b416415c$export$630ff653c5ada6a9)();
                if (modality === "keyboard") (0, $a26d4c995bb2a467$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $7fPBF.useRef)(autoFocus);
    (0, $7fPBF.useEffect)(()=>{
        if (autoFocusRef.current) {
            let focusedKey = null;
            // Check focus strategy to determine which item to focus
            if (autoFocus === "first") focusedKey = delegate.getFirstKey();
            if (autoFocus === "last") focusedKey = delegate.getLastKey();
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) focusedKey = selectedKeys.values().next().value;
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus) (0, $2cf1c82089cb095e$export$80f3e147d781571c)(ref.current);
        }
        autoFocusRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If not virtualized, scroll the focused element into view when the focusedKey changes.
    // When virtualized, Virtualizer handles this internally.
    let lastFocusedKey = (0, $7fPBF.useRef)(manager.focusedKey);
    (0, $7fPBF.useEffect)(()=>{
        let modality = (0, $9102a566b416415c$export$630ff653c5ada6a9)();
        if (manager.isFocused && manager.focusedKey != null && (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current)) {
            let element = scrollRef.current.querySelector(`[data-key="${manager.focusedKey}"]`);
            if (element && modality === "keyboard") {
                if (!isVirtualized) (0, $a26d4c995bb2a467$export$53a0910f038337bd)(scrollRef.current, element);
                (0, $a26d4c995bb2a467$export$c826860796309d1b)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null) (0, $2cf1c82089cb095e$export$80f3e147d781571c)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
    }, [
        isVirtualized,
        scrollRef,
        manager.focusedKey,
        manager.isFocused,
        ref
    ]);
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = $ee6c7218d784230d$export$e32c88dfddc6e1d8({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ee6c7218d784230d$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = "action" } = options;
    let router = (0, $a26d4c995bb2a467$export$9a302a45f65d0572)();
    let onSelect = (e)=>{
        if (e.pointerType === "keyboard" && $ee6c7218d784230d$var$$feb5ffebff200149$export$d3e3bd3e26688c04(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === "none") return;
            if (manager.isLink(key)) {
                if (linkBehavior === "selection") {
                    router.open(ref.current, e);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === "override" || linkBehavior === "none") return;
            }
            if (manager.selectionMode === "single") {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === "toggle" || e && ($ee6c7218d784230d$var$$feb5ffebff200149$export$16792effe837dba3(e) || e.pointerType === "touch" || e.pointerType === "virtual")) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current) (0, $2cf1c82089cb095e$export$80f3e147d781571c)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === "override";
    let hasLinkAction = manager.isLink(key) && linkBehavior !== "selection" && linkBehavior !== "none";
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === "replace" ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === "replace";
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $7fPBF.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $7fPBF.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $7fPBF.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction) router.open(ref.current, e);
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === "keyboard" && (!hasAction || $ee6c7218d784230d$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== "mouse") {
                if (e.pointerType === "keyboard" && !$ee6c7218d784230d$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? null : (e)=>{
                if (e.pointerType !== "keyboard" && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : null;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === "mouse" && !hasPrimaryAction || e.pointerType === "keyboard" && (!allowsActions || $ee6c7218d784230d$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === "touch" || e.pointerType === "pen" || e.pointerType === "virtual" || e.pointerType === "keyboard" && hasAction && $ee6c7218d784230d$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === "mouse" && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps["data-key"] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $9102a566b416415c$export$45712eceda6fad21)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === "mouse") {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $9102a566b416415c$export$c24ed0104d07eab9)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === "touch") {
                onSelect(e);
                manager.setSelectionBehavior("toggle");
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === "touch" && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $a26d4c995bb2a467$export$95185d699e05d4d7).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $ee6c7218d784230d$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === "Enter";
}
function $ee6c7218d784230d$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === " " || (event === null || event === void 0 ? void 0 : event.code) === "Space";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $ee6c7218d784230d$export$a05409b8bb224a5a {
    getNextKey(key) {
        key = this.collection.getKeyAfter(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getPreviousKey(key) {
        key = this.collection.getKeyBefore(key);
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findKey(key, nextKey, shouldSkip) {
        let item = this.getItem(key);
        if (!item) return null;
        // Find the item above or below in the same column.
        let prevRect = item.getBoundingClientRect();
        do {
            key = nextKey(key);
            item = this.getItem(key);
        }while (item && shouldSkip(prevRect, item.getBoundingClientRect()));
        return key;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.top === itemRect.top || prevRect.left !== itemRect.left;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.left === itemRect.left || prevRect.top !== itemRect.top;
    }
    getKeyBelow(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === "grid" && this.orientation === "vertical") return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "rtl");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "rtl"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "rtl");
        return null;
    }
    getKeyLeftOf(key) {
        if (this.layout === "grid") {
            if (this.orientation === "vertical") return this.getNextColumn(key, this.direction === "ltr");
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === "ltr"), this.isSameColumn);
        } else if (this.orientation === "horizontal") return this.getNextColumn(key, this.direction === "ltr");
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyAfter(key);
        }
        return null;
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (item.type === "item" && !this.disabledKeys.has(key)) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    getItem(key) {
        return this.ref.current.querySelector(`[data-key="${key}"]`);
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $a26d4c995bb2a467$export$2bb74740c4e19def)(menu)) return this.getFirstKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.max(0, itemRect.x - containerX + itemRect.width - containerRect.width);
            while(item && itemRect.x - containerX > pageX){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.max(0, itemRect.y - containerY + itemRect.height - containerRect.height);
            while(item && itemRect.y - containerY > pageY){
                key = this.getKeyAbove(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let item = this.getItem(key);
        if (!item) return null;
        if (!(0, $a26d4c995bb2a467$export$2bb74740c4e19def)(menu)) return this.getLastKey();
        let containerRect = menu.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        if (this.orientation === "horizontal") {
            let containerX = containerRect.x - menu.scrollLeft;
            let pageX = Math.min(menu.scrollWidth, itemRect.x - containerX - itemRect.width + containerRect.width);
            while(item && itemRect.x - containerX < pageX){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        } else {
            let containerY = containerRect.y - menu.scrollTop;
            let pageY = Math.min(menu.scrollHeight, itemRect.y - containerY - itemRect.height + containerRect.height);
            while(item && itemRect.y - containerY < pageY){
                key = this.getKeyBelow(key);
                item = key == null ? null : this.getItem(key);
                itemRect = item === null || item === void 0 ? void 0 : item.getBoundingClientRect();
            }
        }
        return key !== null && key !== void 0 ? key : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getKeyBelow(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.orientation = opts.orientation;
            this.direction = opts.direction;
            this.layout = opts.layout || "stack";
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = "stack";
            this.orientation = "vertical";
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === "stack" && this.orientation === "vertical") {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}
function $ee6c7218d784230d$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $fcf9384597cd7e10$export$a16aca283550c30d)({
        usage: "search",
        sensitivity: "base"
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $7fPBF.useMemo)(()=>keyboardDelegate || new $ee6c7218d784230d$export$a05409b8bb224a5a(collection, disabledBehavior === "selection" ? new Set() : disabledKeys, ref, collator), [
        keyboardDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = $ee6c7218d784230d$export$d6daf82dcd84e87c({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}



var $7fPBF = parcelRequire("7fPBF");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a0e211f31ad856f3$var$$c1d7fb2ec91bae71$var$Item(props) {
    return null;
}
$a0e211f31ad856f3$var$$c1d7fb2ec91bae71$var$Item.getCollectionNode = function* getCollectionNode(props, context) {
    let { childItems: childItems, title: title, children: children } = props;
    let rendered = props.title || props.children;
    let textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || "";
    // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
    if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
    yield {
        type: "item",
        props: props,
        rendered: rendered,
        textValue: textValue,
        "aria-label": props["aria-label"],
        hasChildNodes: $a0e211f31ad856f3$var$$c1d7fb2ec91bae71$var$hasChildItems(props),
        *childNodes () {
            if (childItems) for (let child of childItems)yield {
                type: "item",
                value: child
            };
            else if (title) {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
function $a0e211f31ad856f3$var$$c1d7fb2ec91bae71$var$hasChildItems(props) {
    if (props.hasChildItems != null) return props.hasChildItems;
    if (props.childItems) return true;
    if (props.title && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.count(props.children) > 0) return true;
    return false;
}
// We don't want getCollectionNode to show up in the type definition
let $a0e211f31ad856f3$export$6d08773d2e66f8f2 = $a0e211f31ad856f3$var$$c1d7fb2ec91bae71$var$Item;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a0e211f31ad856f3$var$$9fc4852771d079eb$var$Section(props) {
    return null;
}
$a0e211f31ad856f3$var$$9fc4852771d079eb$var$Section.getCollectionNode = function* getCollectionNode(props) {
    let { children: children, title: title, items: items } = props;
    yield {
        type: "section",
        props: props,
        hasChildNodes: true,
        rendered: title,
        "aria-label": props["aria-label"],
        *childNodes () {
            if (typeof children === "function") {
                if (!items) throw new Error("props.children was a function but props.items is missing");
                for (let item of items)yield {
                    type: "item",
                    value: item,
                    renderer: children
                };
            } else {
                let items = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(children, (child)=>{
                    items.push({
                        type: "item",
                        element: child
                    });
                });
                yield* items;
            }
        }
    };
};
// We don't want getCollectionNode to show up in the type definition
let $a0e211f31ad856f3$export$6e2c8f0811a474ce = $a0e211f31ad856f3$var$$9fc4852771d079eb$var$Section;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a0e211f31ad856f3$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if (typeof children === "function") {
            if (!items) throw new Error("props.children was a function but props.items is missing");
            for (let item of props.items)yield* this.getFullNode({
                value: item
            }, {
                renderer: children
            });
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(children, (child)=>{
                items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === "cell" && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error("No key found for item");
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== "function" && typeof type.getCollectionNode !== "function") {
                let name = typeof element.type === "function" ? element.type.name : element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            let index = partialNode.index;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                let nodeKey = childNode.key;
                if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    // Cache the node based on its value
                    node.value = childNode.value || partialNode.value;
                    if (node.value) this.cache.set(node.value, node);
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$capitalize(parentNode.type)}>. Only <${$a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null) return;
        // Create full node
        let builder = this;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: partialNode.value,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: partialNode.textValue,
            "aria-label": partialNode["aria-label"],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes,
            childNodes: $a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    child.index = index;
                    let nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $a0e211f31ad856f3$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
function $a0e211f31ad856f3$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $7fPBF.useMemo)(()=>new $a0e211f31ad856f3$export$bf788dd355e3a401(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $7fPBF.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a0e211f31ad856f3$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $a0e211f31ad856f3$export$fbdeaa6a76694f71(iterable) {
    return $a0e211f31ad856f3$export$5f3398f8733f90e2(iterable, 0);
}
function $a0e211f31ad856f3$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $a0e211f31ad856f3$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $a0e211f31ad856f3$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$a0e211f31ad856f3$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$a0e211f31ad856f3$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $a0e211f31ad856f3$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    while((node === null || node === void 0 ? void 0 : node.parentKey) != null){
        node = collection.getItem(node.parentKey);
        parents.unshift(node);
    }
    return parents;
}
const $a0e211f31ad856f3$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $a0e211f31ad856f3$export$77d5aafae4e095b2(collection) {
    let count = $a0e211f31ad856f3$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    count = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === "section") countItems($a0e211f31ad856f3$export$1005530eda016c13(item, collection));
        else count++;
    };
    countItems(collection);
    $a0e211f31ad856f3$var$$453cc9f0df89c0a5$var$cache.set(collection, count);
    return count;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d4ccce7d4487cff2$export$3585ede4d035bf14 = new WeakMap();
function $d4ccce7d4487cff2$var$$b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === "string") return key.replace(/\s*/g, "");
    return "" + key;
}
function $d4ccce7d4487cff2$export$9145995848b05025(state, itemKey) {
    let data = $d4ccce7d4487cff2$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error("Unknown list");
    return `${data.id}-option-${$d4ccce7d4487cff2$var$$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}
function $d4ccce7d4487cff2$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $a26d4c995bb2a467$export$457c3d6518dd4c6f)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || "toggle";
    let linkBehavior = props.linkBehavior || (selectionBehavior === "replace" ? "action" : "override");
    if (selectionBehavior === "toggle" && linkBehavior === "action") // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = "override";
    let { listProps: listProps } = (0, $ee6c7218d784230d$export$b95089534ab7c1fd)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $9102a566b416415c$export$420e68273165f4ec)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $a26d4c995bb2a467$export$f680877a34711e37)(props.id);
    $d4ccce7d4487cff2$export$3585ede4d035bf14.set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $e2d9bb95c851dd17$export$8467354a121f1b9f)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span"
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(domProps, focusWithinProps, state.selectionManager.selectionMode === "multiple" ? {
            "aria-multiselectable": "true"
        } : {}, {
            role: "listbox",
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(fieldProps, listProps)
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d4ccce7d4487cff2$export$497855f14858aa34(props, state, ref) {
    var _item_props;
    let { key: key } = props;
    let data = $d4ccce7d4487cff2$export$3585ede4d035bf14.get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.disabledKeys.has(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, $a26d4c995bb2a467$export$b4cc09c592e8fdb8)();
    let descriptionId = (0, $a26d4c995bb2a467$export$b4cc09c592e8fdb8)();
    let optionProps = {
        role: "option",
        "aria-disabled": isDisabled || undefined,
        "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, $a26d4c995bb2a467$export$9ac100e40613ea10)() && (0, $a26d4c995bb2a467$export$78551043582a6a98)())) {
        optionProps["aria-label"] = props["aria-label"];
        optionProps["aria-labelledby"] = labelId;
        optionProps["aria-describedby"] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps["aria-posinset"] = Number.isNaN(index) ? undefined : index + 1;
        optionProps["aria-setsize"] = (0, $a0e211f31ad856f3$export$77d5aafae4e095b2)(state.collection);
    }
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $ee6c7218d784230d$export$ecf600387e221c37)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
            var _data_onAction;
            return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
        } : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior
    });
    let { hoverProps: hoverProps } = (0, $9102a566b416415c$export$ae780daf29e6d456)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $9102a566b416415c$export$b9b3dfddab17db27)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $a26d4c995bb2a467$export$457c3d6518dd4c6f)(item === null || item === void 0 ? void 0 : item.props, {
        isLink: !!(item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.href)
    });
    delete domProps.id;
    return {
        optionProps: {
            ...optionProps,
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(domProps, itemProps, hoverProps),
            id: $d4ccce7d4487cff2$export$9145995848b05025(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && (0, $9102a566b416415c$export$b9b3dfddab17db27)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d4ccce7d4487cff2$export$c3f9f39876e4bc7(props) {
    let { heading: heading, "aria-label": ariaLabel } = props;
    let headingId = (0, $a26d4c995bb2a467$export$f680877a34711e37)();
    return {
        itemProps: {
            role: "presentation"
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: "presentation"
        } : {},
        groupProps: {
            role: "group",
            "aria-label": ariaLabel,
            "aria-labelledby": heading ? headingId : undefined
        }
    };
}





// src/index.ts

var $75fe740326d2578f$var$MOBILE_SCREEN_WIDTH = 700;
function $75fe740326d2578f$export$2b96349243a56116() {
    let isSSR = (0, $ed57708adbbc95d6$export$535bd6ca7f90a273)();
    if (isSSR || typeof window === "undefined") return false;
    return window.screen.width <= $75fe740326d2578f$var$MOBILE_SCREEN_WIDTH;
}


"use client";
function $52abb678dffdf386$export$887eda06ad18acaf(originalProps) {
    const [props, variantProps] = (0, $4f1e9f4a2dccf0c0$export$9f203ede2b8cf905)(originalProps, (0, $28cb637712cc540b$export$c176f998e71d0f08).variantKeys);
    const { as: as, item: item, state: state, description: description, startContent: startContent, endContent: endContent, isVirtualized: isVirtualized, selectedIcon: selectedIcon, className: className, classNames: classNames, autoFocus: autoFocus, onPress: onPress, onClick: onClick, shouldHighlightOnFocus: shouldHighlightOnFocus, hideSelectedIcon: hideSelectedIcon = false, isReadOnly: isReadOnly = false, ...otherProps } = props;
    const disableAnimation = originalProps.disableAnimation;
    const domRef = (0, $7fPBF.useRef)(null);
    const Component = as || (originalProps.href ? "a" : "li");
    const shouldFilterDOMProps = typeof Component === "string";
    const { rendered: rendered, key: key } = item;
    const isDisabled = state.disabledKeys.has(key) || originalProps.isDisabled;
    const isSelectable = state.selectionManager.selectionMode !== "none";
    const isMobile = (0, $75fe740326d2578f$export$2b96349243a56116)();
    const { pressProps: pressProps, isPressed: isPressed } = (0, $40d6d4ef5e24c485$export$45712eceda6fad21)({
        ref: domRef,
        isDisabled: isDisabled,
        onPress: onPress
    });
    const { isHovered: isHovered, hoverProps: hoverProps } = (0, $9102a566b416415c$export$ae780daf29e6d456)({
        isDisabled: isDisabled
    });
    const { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $2cf1c82089cb095e$export$4e328f61c538687f)({
        autoFocus: autoFocus
    });
    const { isFocused: isFocused, isSelected: isSelected, optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps } = (0, $d4ccce7d4487cff2$export$497855f14858aa34)({
        key: key,
        isDisabled: isDisabled,
        "aria-label": props["aria-label"],
        isVirtualized: isVirtualized
    }, state, domRef);
    let itemProps = optionProps;
    const slots = (0, $7fPBF.useMemo)(()=>(0, $28cb637712cc540b$export$c176f998e71d0f08)({
            ...variantProps,
            isDisabled: isDisabled,
            disableAnimation: disableAnimation
        }), [
        ...Object.values(variantProps),
        isDisabled,
        disableAnimation
    ]);
    const baseStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    if (isReadOnly) itemProps = (0, $dbd496723874cc51$export$da5f6eb3bb522cd)(itemProps);
    const isHighlighted = (0, $7fPBF.useMemo)(()=>{
        if (shouldHighlightOnFocus && isFocused) return true;
        return isMobile ? isHovered || isPressed : isHovered;
    }, [
        isHovered,
        isPressed,
        isFocused,
        isMobile,
        shouldHighlightOnFocus
    ]);
    const getItemProps = (props2 = {})=>({
            ref: domRef,
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)({
                onClick: onClick
            }, itemProps, isReadOnly ? {} : (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(focusProps, pressProps), hoverProps, (0, $4ef54568ed699843$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }), props2),
            "data-selectable": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isSelectable),
            "data-focus": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isFocused),
            "data-hover": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isHighlighted),
            "data-disabled": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isDisabled),
            "data-selected": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isSelected),
            "data-pressed": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isPressed),
            "data-focus-visible": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isFocusVisible),
            className: slots.base({
                class: (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(baseStyles, props2.className)
            })
        });
    const getLabelProps = (props2 = {})=>({
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(labelProps, props2),
            "data-label": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(true),
            className: slots.title({
                class: classNames == null ? void 0 : classNames.title
            })
        });
    const getDescriptionProps = (props2 = {})=>({
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(descriptionProps, props2),
            className: slots.description({
                class: classNames == null ? void 0 : classNames.description
            })
        });
    const getWrapperProps = (props2 = {})=>({
            ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(props2),
            className: slots.wrapper({
                class: classNames == null ? void 0 : classNames.wrapper
            })
        });
    const getSelectedIconProps = (0, $7fPBF.useCallback)((props2 = {})=>{
        return {
            "aria-hidden": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(true),
            "data-disabled": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(isDisabled),
            className: slots.selectedIcon({
                class: classNames == null ? void 0 : classNames.selectedIcon
            }),
            ...props2
        };
    }, [
        isDisabled,
        slots,
        classNames
    ]);
    return {
        Component: Component,
        domRef: domRef,
        slots: slots,
        classNames: classNames,
        isSelectable: isSelectable,
        isSelected: isSelected,
        isDisabled: isDisabled,
        rendered: rendered,
        description: description,
        startContent: startContent,
        endContent: endContent,
        selectedIcon: selectedIcon,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getWrapperProps: getWrapperProps,
        getDescriptionProps: getDescriptionProps,
        getSelectedIconProps: getSelectedIconProps
    };
}



var $7fPBF = parcelRequire("7fPBF");


"use client";
var $95b03baa52b33f23$var$ListboxItem = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)((props, _)=>{
    const { Component: Component, rendered: rendered, description: description, isSelectable: isSelectable, isSelected: isSelected, isDisabled: isDisabled, selectedIcon: selectedIcon, startContent: startContent, endContent: endContent, hideSelectedIcon: hideSelectedIcon, disableAnimation: disableAnimation, getItemProps: getItemProps, getLabelProps: getLabelProps, getWrapperProps: getWrapperProps, getDescriptionProps: getDescriptionProps, getSelectedIconProps: getSelectedIconProps } = (0, $52abb678dffdf386$export$887eda06ad18acaf)(props);
    const selectedContent = (0, $7fPBF.useMemo)(()=>{
        const defaultIcon = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $772440a20437d4e2$export$5db3965fb0ec818), {
            disableAnimation: disableAnimation,
            isSelected: isSelected
        });
        if (typeof selectedIcon === "function") return selectedIcon({
            icon: defaultIcon,
            isSelected: isSelected,
            isDisabled: isDisabled
        });
        if (selectedIcon) return selectedIcon;
        return defaultIcon;
    }, [
        selectedIcon,
        isSelected,
        isDisabled,
        disableAnimation
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(Component, {
        ...getItemProps(),
        children: [
            startContent,
            description ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("div", {
                ...getWrapperProps(),
                children: [
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
                        ...getLabelProps(),
                        children: rendered
                    }),
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
                        ...getDescriptionProps(),
                        children: description
                    })
                ]
            }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
                ...getLabelProps(),
                children: rendered
            }),
            isSelectable && !hideSelectedIcon && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
                ...getSelectedIconProps(),
                children: selectedContent
            }),
            endContent
        ]
    });
});
$95b03baa52b33f23$var$ListboxItem.displayName = "NextUI.ListboxItem";
var $95b03baa52b33f23$export$5f4bb52909be7a78 = $95b03baa52b33f23$var$ListboxItem;




var $7fPBF = parcelRequire("7fPBF");



// src/use-separator.ts

function $c28e4379704af5bf$export$52210f68a14655d0(props) {
    let domProps = (0, $4ef54568ed699843$export$457c3d6518dd4c6f)(props, {
        enabled: typeof props.elementType === "string"
    });
    let ariaOrientation;
    if (props.orientation === "vertical") ariaOrientation = "vertical";
    if (props.elementType !== "hr") return {
        separatorProps: {
            ...domProps,
            role: "separator",
            "aria-orientation": ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}



// src/components/divider.ts
var $cabfc0770fe7677d$export$e8c9778bf415dd08 = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    base: "shrink-0 bg-divider border-none",
    variants: {
        orientation: {
            horizontal: "w-full h-divider",
            vertical: "h-full w-divider"
        }
    },
    defaultVariants: {
        orientation: "horizontal"
    }
});



var $7fPBF = parcelRequire("7fPBF");
function $94a6683b51221acb$export$9352472c0af59bd6(props) {
    const { as: as, className: className, orientation: orientation, ...otherProps } = props;
    let Component = as || "hr";
    if (Component === "hr" && orientation === "vertical") Component = "div";
    const { separatorProps: separatorProps } = (0, $c28e4379704af5bf$export$52210f68a14655d0)({
        elementType: typeof Component === "string" ? Component : "hr",
        orientation: orientation
    });
    const styles = (0, $7fPBF.useMemo)(()=>(0, $cabfc0770fe7677d$export$e8c9778bf415dd08)({
            orientation: orientation,
            className: className
        }), [
        orientation,
        className
    ]);
    const getDividerProps = (0, $7fPBF.useCallback)((props2 = {})=>({
            className: styles,
            role: "separator",
            "data-orientation": orientation,
            ...separatorProps,
            ...otherProps,
            ...props2
        }), [
        styles,
        orientation,
        separatorProps,
        otherProps
    ]);
    return {
        Component: Component,
        getDividerProps: getDividerProps
    };
}




var $ec79efe03c937e81$var$Divider = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, getDividerProps: getDividerProps } = (0, $94a6683b51221acb$export$9352472c0af59bd6)({
        ...props
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Component, {
        ref: ref,
        ...getDividerProps()
    });
});
$ec79efe03c937e81$var$Divider.displayName = "NextUI.Divider";
var $ec79efe03c937e81$export$2233c5fdcde64809 = $ec79efe03c937e81$var$Divider;




"use client";
var $41444ae7f32f29bf$var$ListboxSection = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)(({ item: item, state: state, as: as, variant: variant, color: color, disableAnimation: disableAnimation, className: className, classNames: classNames, hideSelectedIcon: hideSelectedIcon, showDivider: showDivider = false, dividerProps: dividerProps = {}, itemClasses: itemClasses, title: title, ...otherProps }, _)=>{
    const Component = as || "li";
    const slots = (0, $7fPBF.useMemo)(()=>(0, $28cb637712cc540b$export$95e0837a3419f5c1)(), []);
    const baseStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const dividerStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.divider, dividerProps == null ? void 0 : dividerProps.className);
    const { itemProps: itemProps, headingProps: headingProps, groupProps: groupProps } = (0, $d4ccce7d4487cff2$export$c3f9f39876e4bc7)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(Component, {
        "data-slot": "base",
        ...(0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(itemProps, otherProps),
        className: slots.base({
            class: baseStyles
        }),
        children: [
            item.rendered && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
                ...headingProps,
                className: slots.heading({
                    class: classNames == null ? void 0 : classNames.heading
                }),
                "data-slot": "heading",
                children: item.rendered
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                ...groupProps,
                className: slots.group({
                    class: classNames == null ? void 0 : classNames.group
                }),
                "data-has-title": !!item.rendered,
                "data-slot": "group",
                children: [
                    [
                        ...item.childNodes
                    ].map((node)=>{
                        const { key: nodeKey, props: nodeProps } = node;
                        let listboxItem = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $95b03baa52b33f23$export$5f4bb52909be7a78), {
                            classNames: itemClasses,
                            color: color,
                            disableAnimation: disableAnimation,
                            hideSelectedIcon: hideSelectedIcon,
                            item: node,
                            state: state,
                            variant: variant,
                            ...nodeProps
                        }, nodeKey);
                        if (node.wrapper) listboxItem = node.wrapper(listboxItem);
                        return listboxItem;
                    }),
                    showDivider && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $ec79efe03c937e81$export$2233c5fdcde64809), {
                        as: "li",
                        className: slots.divider({
                            class: dividerStyles
                        }),
                        ...dividerProps
                    })
                ]
            })
        ]
    }, item.key);
});
$41444ae7f32f29bf$var$ListboxSection.displayName = "NextUI.ListboxSection";
var $41444ae7f32f29bf$export$f8b3202ede999f4c = $41444ae7f32f29bf$var$ListboxSection;







var $7fPBF = parcelRequire("7fPBF");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf) {
            this.anchorKey = anchorKey || keys.anchorKey;
            this.currentKey = currentKey || keys.currentKey;
        } else {
            this.anchorKey = anchorKey;
            this.currentKey = currentKey;
        }
    }
}
function $16727344dfed81ea$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $16727344dfed81ea$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = "none", disallowEmptySelection: disallowEmptySelection, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = "toggle", disabledBehavior: disabledBehavior = "all" } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $7fPBF.useRef)(false);
    let [, setFocused] = (0, $7fPBF.useState)(false);
    let focusedKeyRef = (0, $7fPBF.useRef)(null);
    let childFocusStrategyRef = (0, $7fPBF.useRef)(null);
    let [, setFocusedKey] = (0, $7fPBF.useState)(null);
    let selectedKeysProp = (0, $7fPBF.useMemo)(()=>$16727344dfed81ea$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $7fPBF.useMemo)(()=>$16727344dfed81ea$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $ef9e0b5e070789ea$export$40bfa8c7b0832715)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $7fPBF.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $7fPBF.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === "replace" && selectionBehavior === "toggle" && typeof selectedKeys === "object" && selectedKeys.size === 0) setSelectionBehavior("replace");
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $7fPBF.useRef)(selectionBehaviorProp);
    (0, $7fPBF.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = "first") {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$16727344dfed81ea$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $16727344dfed81ea$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === "all" ? "all" : new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf(selection);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $16727344dfed81ea$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === "none") return false;
        key = this.getKey(key);
        return this.state.selectedKeys === "all" ? this.canSelectItem(key) : this.state.selectedKeys.has(key);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === "all") return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $a0e211f31ad856f3$export$8c434b3a7a4dad6)(this.collection, item, first) < 0) first = item;
        }
        return first === null || first === void 0 ? void 0 : first.key;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $a0e211f31ad856f3$export$8c434b3a7a4dad6)(this.collection, item, last) > 0) last = item;
        }
        return last === null || last === void 0 ? void 0 : last.key;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            this.replaceSelection(toKey);
            return;
        }
        toKey = this.getKey(toKey);
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === "all") selection = new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf([
            toKey
        ], toKey, toKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            let anchorKey = selectedKeys.anchorKey || toKey;
            selection = new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf(selectedKeys, anchorKey, toKey);
            for (let key of this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey))selection.delete(key);
            for (let key of this.getKeyRange(toKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $a0e211f31ad856f3$export$8c434b3a7a4dad6)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        let keys = [];
        let key = from;
        while(key){
            let item = this.collection.getItem(key);
            if (item && item.type === "item" || item.type === "cell" && this.allowsCellSelection) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === "cell" && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item.type !== "item" && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== "item") return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single" && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        key = this.getKey(key);
        if (key == null) return;
        let keys = new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(key)) keys.delete(key);
        else if (this.canSelectItem(key)) {
            keys.add(key);
            keys.anchorKey = key;
            keys.currentKey = key;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === "none") return;
        key = this.getKey(key);
        if (key == null) return;
        let selection = this.canSelectItem(key) ? new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf([
            key
        ], key, key) : new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === "none") return;
        let selection = new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf();
        for (let key of keys){
            key = this.getKey(key);
            if (key != null) {
                selection.add(key);
                if (this.selectionMode === "single") break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key){
                if (this.canSelectItem(key)) {
                    let item = this.collection.getItem(key);
                    if (item.type === "item") keys.push(key);
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if (item.hasChildNodes && (this.allowsCellSelection || item.type !== "item")) addKeys((0, $a0e211f31ad856f3$export$fbdeaa6a76694f71)((0, $a0e211f31ad856f3$export$1005530eda016c13)(item, this.collection)).key);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === "multiple") this.state.setSelectedKeys("all");
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new $16727344dfed81ea$var$$e40ea825a81a3709$export$52baac22726c72bf());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === "none") return;
        if (this.selectionMode === "single") {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === "toggle" || e && (e.pointerType === "touch" || e.pointerType === "virtual")) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        if (this.state.selectionMode === "none" || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || item.type === "cell" && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        return this.state.disabledKeys.has(key) && this.state.disabledBehavior === "all";
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
    }
}



var $7fPBF = parcelRequire("7fPBF");


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $bac41ac4a0d3007a$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        return node ? node.prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        return node ? node.nextKey : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        return this.keyMap.get(key);
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === "section") for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === "item") node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        this.lastKey = last === null || last === void 0 ? void 0 : last.key;
    }
}
function $bac41ac4a0d3007a$export$2f645645f7bca764(props) {
    let { filter: filter } = props;
    let selectionState = (0, $16727344dfed81ea$export$253fe78d46329472)(props);
    let disabledKeys = (0, $7fPBF.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $7fPBF.useCallback)((nodes)=>filter ? new $bac41ac4a0d3007a$export$d085fb9e920b5ca7(filter(nodes)) : new $bac41ac4a0d3007a$export$d085fb9e920b5ca7(nodes), [
        filter
    ]);
    let context = (0, $7fPBF.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $a0e211f31ad856f3$export$6cd28814d92fa9c9)(props, factory, context);
    let selectionManager = (0, $7fPBF.useMemo)(()=>new (0, $16727344dfed81ea$export$6c8a5aaad13c9852)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return itemNode.type === "item" ? itemNode : null;
            }).filter((node)=>node !== null);
            const diff = cachedItemNodes.length - itemNodes.length;
            let index = Math.min(diff > 1 ? Math.max(startItem.index - diff + 1, 0) : startItem.index, itemNodes.length - 1);
            let newNode;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1) index++;
                else {
                    if (index > startItem.index) index = startItem.index;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bac41ac4a0d3007a$export$e7f05e985daf4b5f(props) {
    var _props_defaultSelectedKey;
    let [selectedKey, setSelectedKey] = (0, $ef9e0b5e070789ea$export$40bfa8c7b0832715)(props.selectedKey, (_props_defaultSelectedKey = props.defaultSelectedKey) !== null && _props_defaultSelectedKey !== void 0 ? _props_defaultSelectedKey : null, props.onSelectionChange);
    let selectedKeys = (0, $7fPBF.useMemo)(()=>selectedKey != null ? [
            selectedKey
        ] : [], [
        selectedKey
    ]);
    let { collection: collection, disabledKeys: disabledKeys, selectionManager: selectionManager } = $bac41ac4a0d3007a$export$2f645645f7bca764({
        ...props,
        selectionMode: "single",
        disallowEmptySelection: true,
        allowDuplicateSelectionEvents: true,
        selectedKeys: selectedKeys,
        onSelectionChange: (keys)=>{
            var _keys_values_next_value;
            let key = (_keys_values_next_value = keys.values().next().value) !== null && _keys_values_next_value !== void 0 ? _keys_values_next_value : null;
            // Always fire onSelectionChange, even if the key is the same
            // as the current key (useControlledState does not).
            if (key === selectedKey && props.onSelectionChange) props.onSelectionChange(key);
            setSelectedKey(key);
        }
    });
    let selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        selectedKey: selectedKey,
        setSelectedKey: setSelectedKey,
        selectedItem: selectedItem
    };
}




var $7fPBF = parcelRequire("7fPBF");

"use client";
function $c64dc53f121c064f$export$33446f1f63e37cb2(props) {
    const { ref: ref, as: as, state: propState, variant: variant, color: color, onAction: onAction, children: children, onSelectionChange: onSelectionChange, disableAnimation: disableAnimation, itemClasses: itemClasses, className: className, topContent: topContent, bottomContent: bottomContent, emptyContent: emptyContent = "No items.", hideSelectedIcon: hideSelectedIcon = false, hideEmptyContent: hideEmptyContent = false, shouldHighlightOnFocus: shouldHighlightOnFocus = false, classNames: classNames, ...otherProps } = props;
    const Component = as || "ul";
    const shouldFilterDOMProps = typeof Component === "string";
    const domRef = (0, $fbbbeef99fe5a8b0$export$c2c55ef9111cafd8)(ref);
    const innerState = (0, $bac41ac4a0d3007a$export$2f645645f7bca764)({
        ...props,
        children: children,
        onSelectionChange: onSelectionChange
    });
    const state = propState || innerState;
    const { listBoxProps: listBoxProps } = (0, $d4ccce7d4487cff2$export$50eacbbf140a3141)({
        ...props,
        onAction: onAction
    }, state, domRef);
    const slots = (0, $7fPBF.useMemo)(()=>(0, $28cb637712cc540b$export$b1e5508a851be14d)({
            className: className
        }), [
        ,
        className
    ]);
    const baseStyles = (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(classNames == null ? void 0 : classNames.base, className);
    const getBaseProps = (props2 = {})=>{
        return {
            ref: domRef,
            "data-slot": "base",
            className: slots.base({
                class: baseStyles
            }),
            ...(0, $4ef54568ed699843$export$457c3d6518dd4c6f)(otherProps, {
                enabled: shouldFilterDOMProps
            }),
            ...props2
        };
    };
    const getListProps = (props2 = {})=>{
        return {
            "data-slot": "list",
            className: slots.list({
                class: classNames == null ? void 0 : classNames.list
            }),
            ...listBoxProps,
            ...props2
        };
    };
    const getEmptyContentProps = (props2 = {})=>{
        return {
            "data-slot": "empty-content",
            children: emptyContent,
            className: slots.emptyContent({
                class: classNames == null ? void 0 : classNames.emptyContent
            }),
            ...props2
        };
    };
    return {
        Component: Component,
        state: state,
        variant: variant,
        color: color,
        slots: slots,
        classNames: classNames,
        topContent: topContent,
        bottomContent: bottomContent,
        emptyContent: emptyContent,
        hideEmptyContent: hideEmptyContent,
        shouldHighlightOnFocus: shouldHighlightOnFocus,
        hideSelectedIcon: hideSelectedIcon,
        disableAnimation: disableAnimation,
        className: className,
        itemClasses: itemClasses,
        getBaseProps: getBaseProps,
        getListProps: getListProps,
        getEmptyContentProps: getEmptyContentProps
    };
}





"use client";
function $1ba92ec6d8172df1$var$Listbox(props, ref) {
    const { Component: Component, state: state, color: color, variant: variant, itemClasses: itemClasses, getBaseProps: getBaseProps, topContent: topContent, bottomContent: bottomContent, hideEmptyContent: hideEmptyContent, hideSelectedIcon: hideSelectedIcon, shouldHighlightOnFocus: shouldHighlightOnFocus, disableAnimation: disableAnimation, getEmptyContentProps: getEmptyContentProps, getListProps: getListProps } = (0, $c64dc53f121c064f$export$33446f1f63e37cb2)({
        ...props,
        ref: ref
    });
    const content = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(Component, {
        ...getListProps(),
        children: [
            !state.collection.size && !hideEmptyContent && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("li", {
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
                    ...getEmptyContentProps()
                })
            }),
            [
                ...state.collection
            ].map((item)=>{
                var _a;
                const itemProps = {
                    color: color,
                    item: item,
                    state: state,
                    variant: variant,
                    disableAnimation: disableAnimation,
                    hideSelectedIcon: hideSelectedIcon,
                    ...item.props
                };
                if (item.type === "section") return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $41444ae7f32f29bf$export$f8b3202ede999f4c), {
                    ...itemProps,
                    itemClasses: itemClasses
                }, item.key);
                let listboxItem = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $95b03baa52b33f23$export$5f4bb52909be7a78), {
                    ...itemProps,
                    classNames: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(itemClasses, (_a = item.props) == null ? void 0 : _a.classNames),
                    shouldHighlightOnFocus: shouldHighlightOnFocus
                }, item.key);
                if (item.wrapper) listboxItem = item.wrapper(listboxItem);
                return listboxItem;
            })
        ]
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("div", {
        ...getBaseProps(),
        children: [
            topContent,
            content,
            bottomContent
        ]
    });
}
$1ba92ec6d8172df1$var$Listbox.displayName = "NextUI.Listbox";
var $1ba92ec6d8172df1$export$3f842a5957aa0e7a = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)($1ba92ec6d8172df1$var$Listbox);
$1ba92ec6d8172df1$var$Listbox.displayName = "NextUI.Listbox";


"use client";
var $fb7a9ec4fc828b48$var$ListboxItemBase = (0, $a0e211f31ad856f3$export$6d08773d2e66f8f2);
var $fb7a9ec4fc828b48$export$c9741ea17cd30897 = $fb7a9ec4fc828b48$var$ListboxItemBase;

// src/provider.tsx



var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2c809ae57d1cab8c$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $2c809ae57d1cab8c$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $7fPBF.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $9102a566b416415c$export$420e68273165f4ec)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $7fPBF.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$2c809ae57d1cab8c$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $2c809ae57d1cab8c$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $2c809ae57d1cab8c$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = "div", isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $2c809ae57d1cab8c$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Element, (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}


function $d753be7c27b4fc04$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS = {
    top: "top",
    bottom: "top",
    left: "left",
    right: "left"
};
const $d753be7c27b4fc04$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
const $d753be7c27b4fc04$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: "left",
    left: "top"
};
const $d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: "height",
    left: "width"
};
const $d753be7c27b4fc04$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: "totalWidth",
    height: "totalHeight"
};
const $d753be7c27b4fc04$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    if (containerNode.tagName === "BODY") {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport === null || $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport === null || $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $d753be7c27b4fc04$var$$edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
    } else {
        ({ width: width, height: height, top: top, left: left } = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding) {
    let containerScroll = containerDimensions.scroll[axis];
    let boundaryHeight = boundaryDimensions[$d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    let startEdgeOffset = offset - padding - containerScroll;
    let endEdgeOffset = offset + padding - containerScroll + size;
    if (startEdgeOffset < 0) return -startEdgeOffset;
    else if (endEdgeOffset > boundaryHeight) return Math.max(boundaryHeight - endEdgeOffset, -startEdgeOffset);
    else return 0;
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($d753be7c27b4fc04$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $d753be7c27b4fc04$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(" ");
    let axis = $d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS[placement] || "right";
    let crossAxis = $d753be7c27b4fc04$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = "center";
    let size = $d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $d753be7c27b4fc04$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $d753be7c27b4fc04$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $d753be7c27b4fc04$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === "center") // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
    /* else {
    the overlay top should match the button top
  } */ // add the crossOffset from props
    position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $ef9e0b5e070789ea$export$7d15b64cf5a3a4c4)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$d753be7c27b4fc04$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$d753be7c27b4fc04$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding) {
    return position.top != null ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - (containerOffsetWithBoundary.top + position.top // this is the top of the overlay
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, childOffset.top + containerOffsetWithBoundary.top // this is the top of the trigger
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$d753be7c27b4fc04$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$d753be7c27b4fc04$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    let placementInfo = $d753be7c27b4fc04$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $d753be7c27b4fc04$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let normalizedOffset = offset;
    let space = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $d753be7c27b4fc04$var$$edcf132a9284368a$var$parsePlacement(`${$d753be7c27b4fc04$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $d753be7c27b4fc04$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        let flippedSpace = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    let delta = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding);
    position[crossAxis] += delta;
    let maxHeight = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $d753be7c27b4fc04$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - overlaySize[crossAxis];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    const arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] - overlaySize[crossAxis] + arrowSize / 2;
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - overlaySize[crossAxis] - arrowSize / 2;
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $ef9e0b5e070789ea$export$7d15b64cf5a3a4c4)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $ef9e0b5e070789ea$export$7d15b64cf5a3a4c4)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let container = overlayNode instanceof HTMLElement ? $d753be7c27b4fc04$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== "static";
    let childOffset = isViewportContainer ? $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(targetNode) : $d753be7c27b4fc04$var$$edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    let scrollSize = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerDimensions = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getContainerDimensions(container);
    let containerOffsetWithBoundary = boundaryElement.tagName === "BODY" ? $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(container) : $d753be7c27b4fc04$var$$edcf132a9284368a$var$getPosition(container, boundaryElement);
    return $d753be7c27b4fc04$var$$edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(node) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === "fixed") {
        let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(node);
        let parentOffset = $d753be7c27b4fc04$var$$edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === "static" && !$d753be7c27b4fc04$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$d753be7c27b4fc04$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $d753be7c27b4fc04$var$$edcf132a9284368a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== "none" || /transform|perspective/.test(style.willChange) || style.filter !== "none" || style.contain === "paint" || // @ts-ignore
    "backdropFilter" in style && style.backdropFilter !== "none" || // @ts-ignore
    "WebkitBackdropFilter" in style && style.WebkitBackdropFilter !== "none";
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d753be7c27b4fc04$var$$dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $d753be7c27b4fc04$var$$dd149f63282afbbf$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            let onCloseHandler = onClose || $d753be7c27b4fc04$var$$dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener("scroll", onScroll, true);
        return ()=>{
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}
// @ts-ignore
let $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $d753be7c27b4fc04$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $fcf9384597cd7e10$export$43bb16f9c6d9e3f7)();
    let { arrowSize: arrowSize = 0, targetRef: targetRef, overlayRef: overlayRef, scrollRef: scrollRef = overlayRef, placement: placement = "bottom", containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== "undefined" ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $7fPBF.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    });
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    let updatePosition = (0, $7fPBF.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        let position = $d753be7c27b4fc04$var$$edcf132a9284368a$export$b3ceb0cbf1056d98({
            placement: $d753be7c27b4fc04$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        Object.keys(position.position).forEach((key)=>overlayRef.current.style[key] = position.position[key] + "px");
        overlayRef.current.style.maxHeight = position.maxHeight != null ? position.maxHeight + "px" : undefined;
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(updatePosition, deps);
    // Update position on window resize
    $d753be7c27b4fc04$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $a26d4c995bb2a467$export$683480f191c0e3ea)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $7fPBF.useRef)(false);
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === null || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === void 0 || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport.addEventListener("resize", onResize);
        $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === null || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === void 0 || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport.addEventListener("scroll", onResize);
        return ()=>{
            $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === null || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === void 0 || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("resize", onResize);
            $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === null || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport === void 0 || $d753be7c27b4fc04$var$$2a41e45df1593e64$var$visualViewport.removeEventListener("scroll", onResize);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $7fPBF.useCallback)(()=>{
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    $d753be7c27b4fc04$var$$dd149f63282afbbf$export$18fc8428861184da({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    return {
        overlayProps: {
            style: {
                position: "absolute",
                zIndex: 100000,
                ...position.position,
                maxHeight: position.maxHeight
            }
        },
        placement: position.placement,
        arrowProps: {
            "aria-hidden": "true",
            role: "presentation",
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $d753be7c27b4fc04$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        window.addEventListener("resize", onResize, false);
        return ()=>{
            window.removeEventListener("resize", onResize, false);
        };
    }, [
        onResize
    ]);
}
function $d753be7c27b4fc04$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === "rtl") return position.replace("start", "right").replace("end", "left");
    return position.replace("start", "left").replace("end", "right");
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $d753be7c27b4fc04$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    (0, $7fPBF.useEffect)(()=>{
        if (isOpen) $d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack.
    let onHide = ()=>{
        if ($d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays[$d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays[$d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays[$d753be7c27b4fc04$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === "Escape" && !isKeyboardDismissDisabled) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $9102a566b416415c$export$872b660ac5a1ff98)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $9102a566b416415c$export$420e68273165f4ec)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $2cf1c82089cb095e$export$1258395f99bf9cbf)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d753be7c27b4fc04$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $7fPBF.useEffect)(()=>{
        if (ref && ref.current) $d753be7c27b4fc04$var$$dd149f63282afbbf$export$f6211563215e3b37.set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === "menu") ariaHasPopup = true;
    else if (type === "listbox") ariaHasPopup = "listbox";
    let overlayId = (0, $a26d4c995bb2a467$export$f680877a34711e37)();
    return {
        triggerProps: {
            "aria-haspopup": ariaHasPopup,
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
const $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
let $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$restore;
function $d753be7c27b4fc04$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        if (isDisabled) return;
        $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $a26d4c995bb2a467$export$fedb369cb70207f1)()) $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$restore = $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$restore = $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    return (0, $a26d4c995bb2a467$export$e08e3b67e392101e)($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Prevent default on `touchmove` events inside a scrollable element when the scroll position is at the
//    top or bottom. This avoids the whole page scrolling instead, but does prevent overscrolling.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let lastY = 0;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $a26d4c995bb2a467$export$cfa2225e87938781)(e.target);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        lastY = e.changedTouches[0].pageY;
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead. Unfortunately, this disables bounce scrolling when at
        // the top but it's the best we can do.
        let y = e.changedTouches[0].pageY;
        let scrollTop = scrollable.scrollTop;
        let bottom = scrollable.scrollHeight - scrollable.clientHeight;
        if (bottom === 0) return;
        if (scrollTop <= 0 && y > lastY || scrollTop >= bottom && y < lastY) e.preventDefault();
        lastY = y;
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = "translateY(-2000px)";
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = "";
            });
        }
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = "translateY(-2000px)";
            requestAnimationFrame(()=>{
                target.style.transform = "";
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$visualViewport.addEventListener("resize", ()=>$d753be7c27b4fc04$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let onWindowScroll = ()=>{
        // Last resort. If the window scrolled, scroll it back to the top.
        // It should always be at the top because the body will have a negative margin (see below).
        window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    let restoreStyles = (0, $a26d4c995bb2a467$export$e08e3b67e392101e)($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`));
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
    let removeEvents = (0, $a26d4c995bb2a467$export$e08e3b67e392101e)($d753be7c27b4fc04$var$$49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
        passive: false,
        capture: true
    }), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
        passive: false,
        capture: true
    }), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
        passive: false,
        capture: true
    }), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$addEvent(document, "focus", onFocus, true), $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreStyles();
        removeEvents();
        window.scrollTo(scrollX, scrollY);
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return ()=>{
        target.removeEventListener(event, handler, options);
    };
}
function $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $a26d4c995bb2a467$export$cfa2225e87938781)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function $d753be7c27b4fc04$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$d753be7c27b4fc04$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d753be7c27b4fc04$var$$f57aed4a881a3485$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
function $d753be7c27b4fc04$export$178405afcd8c5eb(props) {
    let { children: children } = props;
    let parent = (0, $7fPBF.useContext)($d753be7c27b4fc04$var$$f57aed4a881a3485$var$Context);
    let [modalCount, setModalCount] = (0, $7fPBF.useState)(0);
    let context = (0, $7fPBF.useMemo)(()=>({
            parent: parent,
            modalCount: modalCount,
            addModal () {
                setModalCount((count)=>count + 1);
                if (parent) parent.addModal();
            },
            removeModal () {
                setModalCount((count)=>count - 1);
                if (parent) parent.removeModal();
            }
        }), [
        parent,
        modalCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d753be7c27b4fc04$var$$f57aed4a881a3485$var$Context.Provider, {
        value: context
    }, children);
}
function $d753be7c27b4fc04$export$d9aaed4c3ece1bc0() {
    let context = (0, $7fPBF.useContext)($d753be7c27b4fc04$var$$f57aed4a881a3485$var$Context);
    return {
        modalProviderProps: {
            "aria-hidden": context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function $d753be7c27b4fc04$var$$f57aed4a881a3485$var$OverlayContainerDOM(props) {
    let { modalProviderProps: modalProviderProps } = $d753be7c27b4fc04$export$d9aaed4c3ece1bc0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-overlay-container": true,
        ...props,
        ...modalProviderProps
    });
}
function $d753be7c27b4fc04$export$bf688221f59024e5(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d753be7c27b4fc04$export$178405afcd8c5eb, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d753be7c27b4fc04$var$$f57aed4a881a3485$var$OverlayContainerDOM, props));
}
function $d753be7c27b4fc04$export$b47c3594eab58386(props) {
    let isSSR = (0, $ed57708adbbc95d6$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, ...rest } = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    let contents = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d753be7c27b4fc04$export$bf688221f59024e5, rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).createPortal(contents, portalContainer);
}
function $d753be7c27b4fc04$export$33ffd74ebf07f060(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    let context = (0, $7fPBF.useContext)($d753be7c27b4fc04$var$$f57aed4a881a3485$var$Context);
    if (!context) throw new Error("Modal is not contained within a provider");
    (0, $7fPBF.useEffect)(()=>{
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return ()=>{
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            "data-ismodal": !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $d753be7c27b4fc04$var$$a2f21f5f14f60553$exports = {};
var $d753be7c27b4fc04$var$$773d5888b972f1cf$exports = {};
$d753be7c27b4fc04$var$$773d5888b972f1cf$exports = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};
var $d753be7c27b4fc04$var$$d11f19852b941573$exports = {};
$d753be7c27b4fc04$var$$d11f19852b941573$exports = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};
var $d753be7c27b4fc04$var$$b983974c2ee1efb3$exports = {};
$d753be7c27b4fc04$var$$b983974c2ee1efb3$exports = {
    "dismiss": `Odstranit`
};
var $d753be7c27b4fc04$var$$5809cc9d4e92de73$exports = {};
$d753be7c27b4fc04$var$$5809cc9d4e92de73$exports = {
    "dismiss": `Luk`
};
var $d753be7c27b4fc04$var$$c68c2e4fc74398d1$exports = {};
$d753be7c27b4fc04$var$$c68c2e4fc74398d1$exports = {
    "dismiss": `Schlie\xdfen`
};
var $d753be7c27b4fc04$var$$0898b4c153db2b77$exports = {};
$d753be7c27b4fc04$var$$0898b4c153db2b77$exports = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};
var $d753be7c27b4fc04$var$$6d74810286a15183$exports = {};
$d753be7c27b4fc04$var$$6d74810286a15183$exports = {
    "dismiss": `Dismiss`
};
var $d753be7c27b4fc04$var$$309d73dc65f78055$exports = {};
$d753be7c27b4fc04$var$$309d73dc65f78055$exports = {
    "dismiss": `Descartar`
};
var $d753be7c27b4fc04$var$$44ad94f7205cf593$exports = {};
$d753be7c27b4fc04$var$$44ad94f7205cf593$exports = {
    "dismiss": `L\xf5peta`
};
var $d753be7c27b4fc04$var$$7c28f5687f0779a9$exports = {};
$d753be7c27b4fc04$var$$7c28f5687f0779a9$exports = {
    "dismiss": `Hylk\xe4\xe4`
};
var $d753be7c27b4fc04$var$$e6d75df4b68bd73a$exports = {};
$d753be7c27b4fc04$var$$e6d75df4b68bd73a$exports = {
    "dismiss": `Rejeter`
};
var $d753be7c27b4fc04$var$$87505c9dab186d0f$exports = {};
$d753be7c27b4fc04$var$$87505c9dab186d0f$exports = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};
var $d753be7c27b4fc04$var$$553439c3ffb3e492$exports = {};
$d753be7c27b4fc04$var$$553439c3ffb3e492$exports = {
    "dismiss": `Odbaci`
};
var $d753be7c27b4fc04$var$$74cf411061b983a2$exports = {};
$d753be7c27b4fc04$var$$74cf411061b983a2$exports = {
    "dismiss": `Elutas\xedt\xe1s`
};
var $d753be7c27b4fc04$var$$e933f298574dc435$exports = {};
$d753be7c27b4fc04$var$$e933f298574dc435$exports = {
    "dismiss": `Ignora`
};
var $d753be7c27b4fc04$var$$ac91fc9fe02f71f6$exports = {};
$d753be7c27b4fc04$var$$ac91fc9fe02f71f6$exports = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};
var $d753be7c27b4fc04$var$$52b96f86422025af$exports = {};
$d753be7c27b4fc04$var$$52b96f86422025af$exports = {
    "dismiss": `\u{BB34}\u{C2DC}`
};
var $d753be7c27b4fc04$var$$c0d724c3e51dafa6$exports = {};
$d753be7c27b4fc04$var$$c0d724c3e51dafa6$exports = {
    "dismiss": `Atmesti`
};
var $d753be7c27b4fc04$var$$c92899672a3fe72e$exports = {};
$d753be7c27b4fc04$var$$c92899672a3fe72e$exports = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};
var $d753be7c27b4fc04$var$$9f576b39d8e7a9d6$exports = {};
$d753be7c27b4fc04$var$$9f576b39d8e7a9d6$exports = {
    "dismiss": `Lukk`
};
var $d753be7c27b4fc04$var$$9d025808aeec81a7$exports = {};
$d753be7c27b4fc04$var$$9d025808aeec81a7$exports = {
    "dismiss": `Negeren`
};
var $d753be7c27b4fc04$var$$fce709921e2c0fa6$exports = {};
$d753be7c27b4fc04$var$$fce709921e2c0fa6$exports = {
    "dismiss": `Zignoruj`
};
var $d753be7c27b4fc04$var$$2599cf0c4ab37f59$exports = {};
$d753be7c27b4fc04$var$$2599cf0c4ab37f59$exports = {
    "dismiss": `Descartar`
};
var $d753be7c27b4fc04$var$$3c220ae7ef8a35fd$exports = {};
$d753be7c27b4fc04$var$$3c220ae7ef8a35fd$exports = {
    "dismiss": `Dispensar`
};
var $d753be7c27b4fc04$var$$93562b5094072f54$exports = {};
$d753be7c27b4fc04$var$$93562b5094072f54$exports = {
    "dismiss": `Revocare`
};
var $d753be7c27b4fc04$var$$cd9e2abd0d06c7b4$exports = {};
$d753be7c27b4fc04$var$$cd9e2abd0d06c7b4$exports = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};
var $d753be7c27b4fc04$var$$45375701f409adf1$exports = {};
$d753be7c27b4fc04$var$$45375701f409adf1$exports = {
    "dismiss": `Zru\u{161}i\u{165}`
};
var $d753be7c27b4fc04$var$$27fab53a576de9dd$exports = {};
$d753be7c27b4fc04$var$$27fab53a576de9dd$exports = {
    "dismiss": `Opusti`
};
var $d753be7c27b4fc04$var$$4438748d9952e7c7$exports = {};
$d753be7c27b4fc04$var$$4438748d9952e7c7$exports = {
    "dismiss": `Odbaci`
};
var $d753be7c27b4fc04$var$$0936d7347ef4da4c$exports = {};
$d753be7c27b4fc04$var$$0936d7347ef4da4c$exports = {
    "dismiss": `Avvisa`
};
var $d753be7c27b4fc04$var$$29700c92185d38f8$exports = {};
$d753be7c27b4fc04$var$$29700c92185d38f8$exports = {
    "dismiss": `Kapat`
};
var $d753be7c27b4fc04$var$$662ccaf2be4c25b3$exports = {};
$d753be7c27b4fc04$var$$662ccaf2be4c25b3$exports = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};
var $d753be7c27b4fc04$var$$d80a27deda7cdb3c$exports = {};
$d753be7c27b4fc04$var$$d80a27deda7cdb3c$exports = {
    "dismiss": `\u{53D6}\u{6D88}`
};
var $d753be7c27b4fc04$var$$2b2734393847c884$exports = {};
$d753be7c27b4fc04$var$$2b2734393847c884$exports = {
    "dismiss": `\u{95DC}\u{9589}`
};
$d753be7c27b4fc04$var$$a2f21f5f14f60553$exports = {
    "ar-AE": $d753be7c27b4fc04$var$$773d5888b972f1cf$exports,
    "bg-BG": $d753be7c27b4fc04$var$$d11f19852b941573$exports,
    "cs-CZ": $d753be7c27b4fc04$var$$b983974c2ee1efb3$exports,
    "da-DK": $d753be7c27b4fc04$var$$5809cc9d4e92de73$exports,
    "de-DE": $d753be7c27b4fc04$var$$c68c2e4fc74398d1$exports,
    "el-GR": $d753be7c27b4fc04$var$$0898b4c153db2b77$exports,
    "en-US": $d753be7c27b4fc04$var$$6d74810286a15183$exports,
    "es-ES": $d753be7c27b4fc04$var$$309d73dc65f78055$exports,
    "et-EE": $d753be7c27b4fc04$var$$44ad94f7205cf593$exports,
    "fi-FI": $d753be7c27b4fc04$var$$7c28f5687f0779a9$exports,
    "fr-FR": $d753be7c27b4fc04$var$$e6d75df4b68bd73a$exports,
    "he-IL": $d753be7c27b4fc04$var$$87505c9dab186d0f$exports,
    "hr-HR": $d753be7c27b4fc04$var$$553439c3ffb3e492$exports,
    "hu-HU": $d753be7c27b4fc04$var$$74cf411061b983a2$exports,
    "it-IT": $d753be7c27b4fc04$var$$e933f298574dc435$exports,
    "ja-JP": $d753be7c27b4fc04$var$$ac91fc9fe02f71f6$exports,
    "ko-KR": $d753be7c27b4fc04$var$$52b96f86422025af$exports,
    "lt-LT": $d753be7c27b4fc04$var$$c0d724c3e51dafa6$exports,
    "lv-LV": $d753be7c27b4fc04$var$$c92899672a3fe72e$exports,
    "nb-NO": $d753be7c27b4fc04$var$$9f576b39d8e7a9d6$exports,
    "nl-NL": $d753be7c27b4fc04$var$$9d025808aeec81a7$exports,
    "pl-PL": $d753be7c27b4fc04$var$$fce709921e2c0fa6$exports,
    "pt-BR": $d753be7c27b4fc04$var$$2599cf0c4ab37f59$exports,
    "pt-PT": $d753be7c27b4fc04$var$$3c220ae7ef8a35fd$exports,
    "ro-RO": $d753be7c27b4fc04$var$$93562b5094072f54$exports,
    "ru-RU": $d753be7c27b4fc04$var$$cd9e2abd0d06c7b4$exports,
    "sk-SK": $d753be7c27b4fc04$var$$45375701f409adf1$exports,
    "sl-SI": $d753be7c27b4fc04$var$$27fab53a576de9dd$exports,
    "sr-SP": $d753be7c27b4fc04$var$$4438748d9952e7c7$exports,
    "sv-SE": $d753be7c27b4fc04$var$$0936d7347ef4da4c$exports,
    "tr-TR": $d753be7c27b4fc04$var$$29700c92185d38f8$exports,
    "uk-UA": $d753be7c27b4fc04$var$$662ccaf2be4c25b3$exports,
    "zh-CN": $d753be7c27b4fc04$var$$d80a27deda7cdb3c$exports,
    "zh-TW": $d753be7c27b4fc04$var$$2b2734393847c884$exports
};
function $d753be7c27b4fc04$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $fcf9384597cd7e10$export$f12b703ca79dfbb1)(/*@__PURE__*/ $d753be7c27b4fc04$var$$parcel$interopDefault($d753be7c27b4fc04$var$$a2f21f5f14f60553$exports));
    let labels = (0, $a26d4c995bb2a467$export$d6875122194c7b44)(otherProps, stringFormatter.format("dismiss"));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2c809ae57d1cab8c$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick
    }));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $d753be7c27b4fc04$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
let $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack = [];
function $d753be7c27b4fc04$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $d753be7c27b4fc04$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute("aria-hidden") === "true" && refCount === 0) return;
        if (refCount === 0) node.setAttribute("aria-hidden", "true");
        hiddenNodes.add(node);
        $d753be7c27b4fc04$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.length) $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack[$d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== "childList" || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === "true" || node.dataset.reactAriaTopLayer === "true")) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $d753be7c27b4fc04$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count === 1) {
                node.removeAttribute("aria-hidden");
                $d753be7c27b4fc04$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $d753be7c27b4fc04$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack[$d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.pop();
            if ($d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.length) $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack[$d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.splice($d753be7c27b4fc04$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d753be7c27b4fc04$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, ...otherProps } = props;
    let { overlayProps: overlayProps, underlayProps: underlayProps } = $d753be7c27b4fc04$export$ea8f71083e90600f({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled
    }, popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement } = $d753be7c27b4fc04$export$d39e1813b3bdd0e1({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: null
    });
    $d753be7c27b4fc04$export$ee0f7cc6afcd1c18({
        isDisabled: isNonModal
    });
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return $d753be7c27b4fc04$export$1c3ebcada18427bf([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d753be7c27b4fc04$var$$337b884510726a0d$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
function $d753be7c27b4fc04$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $ed57708adbbc95d6$export$535bd6ca7f90a273)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $7fPBF.useState)(false);
    let contextValue = (0, $7fPBF.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2cf1c82089cb095e$export$20e40289641fbbb6), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d753be7c27b4fc04$var$$337b884510726a0d$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9102a566b416415c$export$cf75428e0b9ed1ea), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).createPortal(contents, portalContainer);
}
function $d753be7c27b4fc04$export$14c98a7594375490() {
    let ctx = (0, $7fPBF.useContext)($d753be7c27b4fc04$var$$337b884510726a0d$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $a26d4c995bb2a467$export$e5c5a5f917a5871c)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}
function $d753be7c27b4fc04$export$dbc0f175b25fb0fb(props, state, ref) {
    let { overlayProps: overlayProps, underlayProps: underlayProps } = $d753be7c27b4fc04$export$ea8f71083e90600f({
        ...props,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    $d753be7c27b4fc04$export$ee0f7cc6afcd1c18({
        isDisabled: !state.isOpen
    });
    $d753be7c27b4fc04$export$14c98a7594375490();
    (0, $7fPBF.useEffect)(()=>{
        if (state.isOpen) return $d753be7c27b4fc04$export$1c3ebcada18427bf([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, $a26d4c995bb2a467$export$9d1611c77c2fe928)(overlayProps),
        underlayProps: underlayProps
    };
}



var $d3a3430f50e4bea6$export$a3257b987c70dc9c = ({ children: children, locale: locale = "en-US", navigate: navigate, ...otherProps })=>{
    let contents = children;
    if (navigate) contents = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $a26d4c995bb2a467$export$323e4fc2fa4753fb), {
        navigate: navigate,
        children: contents
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $fcf9384597cd7e10$export$a54013f0d02a8f82), {
        locale: locale,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $d753be7c27b4fc04$export$bf688221f59024e5), {
            ...otherProps,
            children: contents
        })
    });
};

// src/utils.ts
var $c72a005e5c56992c$export$5458b64234d1333c = {
    px: "1px",
    0: "0px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    11: "2.75rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};




// src/components/spacer.ts
var $f5eedf0a5c659f4e$export$8cc075c801fd6817 = (0, $17f34cb256e35c11$export$984d890fc49ac622)({
    base: "w-px h-px inline-block",
    variants: {
        isInline: {
            true: "inline-block",
            false: "block"
        }
    },
    defaultVariants: {
        isInline: false
    }
});




var $7fPBF = parcelRequire("7fPBF");
var $a973c9584b15caac$export$1bc603050bd777b1 = (value)=>{
    var _a;
    return (_a = (0, $c72a005e5c56992c$export$5458b64234d1333c)[value]) != null ? _a : value;
};
function $a973c9584b15caac$export$58945fa1b9292af9(originalProps) {
    const [props, variantProps] = (0, $4f1e9f4a2dccf0c0$export$9f203ede2b8cf905)(originalProps, (0, $f5eedf0a5c659f4e$export$8cc075c801fd6817).variantKeys);
    const { as: as, className: className, x: x = 1, y: y = 1, ...otherProps } = props;
    const Component = as || "span";
    const styles = (0, $7fPBF.useMemo)(()=>(0, $f5eedf0a5c659f4e$export$8cc075c801fd6817)({
            ...variantProps,
            className: className
        }), [
        ...Object.values(variantProps),
        className
    ]);
    const marginLeft = $a973c9584b15caac$export$1bc603050bd777b1(x);
    const marginTop = $a973c9584b15caac$export$1bc603050bd777b1(y);
    const getSpacerProps = (props2 = {})=>({
            ...props2,
            ...otherProps,
            "aria-hidden": (0, $019af025c81e2707$export$5cc3b7b83e34ade7)(true),
            className: (0, $f98c818df3fcb362$export$4f5d2d50c9deca37)(styles, props2.className),
            style: {
                ...props2.style,
                ...otherProps.style,
                marginLeft: marginLeft,
                marginTop: marginTop
            }
        });
    return {
        Component: Component,
        getSpacerProps: getSpacerProps
    };
}




var $ef3f3c7d430a5a59$var$Spacer = (0, $4f1e9f4a2dccf0c0$export$257a8862b851cb5b)((props, ref)=>{
    const { Component: Component, getSpacerProps: getSpacerProps } = (0, $a973c9584b15caac$export$58945fa1b9292af9)({
        ...props
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Component, {
        ref: ref,
        ...getSpacerProps()
    });
});
$ef3f3c7d430a5a59$var$Spacer.displayName = "NextUI.Spacer";
var $ef3f3c7d430a5a59$export$64d520e621f7eab5 = $ef3f3c7d430a5a59$var$Spacer;



var $7fPBF = parcelRequire("7fPBF");
const $6aaba76260e26777$var$primaryGreen = "#189C64";
const $6aaba76260e26777$var$DeleteIcon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "1em",
        role: "presentation",
        viewBox: "0 0 20 20",
        width: "1em",
        ...props,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M7.08331 4.14169L7.26665 3.05002C7.39998 2.25835 7.49998 1.66669 8.90831 1.66669H11.0916C12.5 1.66669 12.6083 2.29169 12.7333 3.05835L12.9166 4.14169",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15.7084 7.61664L15.1667 16.0083C15.075 17.3166 15 18.3333 12.675 18.3333H7.32502C5.00002 18.3333 4.92502 17.3166 4.83335 16.0083L4.29169 7.61664",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M8.60834 13.75H11.3833",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M7.91669 10.4167H12.0834",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5
            })
        ]
    });
const $6aaba76260e26777$var$ScannerPage = ({ setScanError: setScanError, setScanned: setScanned, products: products, scanError: scanError, removeScannedItem: removeScannedItem })=>{
    const scanDelayMs = 2000;
    const [isScanning, setScanning] = (0, $7fPBF.useState)(true);
    const hints = new Map();
    const formats = [
        (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_13,
        (0, $03ea32520a329dec$export$2e2bcd8739ae039).EAN_8
    ];
    hints.set((0, $7d7d8fb74b352319$export$2e2bcd8739ae039).POSSIBLE_FORMATS, formats);
    const stopDecoding = !isScanning;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "p-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                onClick: ()=>setScanning((current)=>!current),
                className: "rounded-medium overflow-hidden",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $849102574a83a574$export$646b390d8bcaeffa), {
                    stopDecoding: stopDecoding,
                    hints: hints,
                    tracker: true,
                    scanDelay: scanDelayMs,
                    onDecode: (scanned)=>setScanned((prev)=>[
                                scanned,
                                ...prev
                            ]),
                    onError: setScanError,
                    className: "rounded-medium"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef3f3c7d430a5a59$export$64d520e621f7eab5), {
                y: 2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba92ec6d8172df1$export$3f842a5957aa0e7a), {
                className: "bg-primary text-white overflow-visible shadow-small rounded-medium",
                emptyContent: "\u30B9\u30AD\u30E3\u30F3\u3055\u3089\u305F\u30D0\u30FC\u30B3\u30FC\u30C9\u304C\u3042\u308A\u307E\u305B\u3093",
                children: products.map((item, index)=>{
                    if (typeof item === "object") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb7a9ec4fc828b48$export$c9741ea17cd30897), {
                        onPress: ()=>removeScannedItem(index),
                        startContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9063f91d9ffdd3$export$5e8a114113e3f7c), {
                            src: item.image_url,
                            width: 64,
                            height: 64,
                            alt: item.title
                        }),
                        endContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6aaba76260e26777$var$DeleteIcon, {}),
                        children: item.title
                    });
                    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb7a9ec4fc828b48$export$c9741ea17cd30897), {
                        children: item
                    });
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: scanError !== null ? scanError === null || scanError === void 0 ? void 0 : scanError.message : ""
            })
        ]
    });
};
const $6aaba76260e26777$var$HomePage = ({ recommendations: recommendations, purchases: purchases, products: products })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex flex-row space-x-4 justify-center",
                children: recommendations.map((recommendation)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $74eb4db8dbffa2c8$export$4630804d47451d56), {
                        className: "h-[300px]",
                        isFooterBlurred: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9063f91d9ffdd3$export$5e8a114113e3f7c), {
                                removeWrapper: true,
                                alt: "Card background",
                                className: "z-0 w-full h-full object-cover",
                                src: recommendation.image_url
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5effc2172a4bcbde$export$69daf8f7928b4c69), {
                                className: "absolute flex flex-col bg-black/98 bottom-0 z-10 border-t-1 border-default-600",
                                style: {
                                    backgroundColor: "rgba(0,0,0,0.4)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-tiny text-white/60 uppercase font-bold",
                                        children: "\u304A\u3059\u3059\u3081"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                        className: "text-white font-medium text-medium",
                                        children: recommendation.title
                                    })
                                ]
                            })
                        ]
                    }, recommendation.product_id))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef3f3c7d430a5a59$export$64d520e621f7eab5), {
                y: 4
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: "\u98DF\u6B74"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "p-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba92ec6d8172df1$export$3f842a5957aa0e7a), {
                    className: "bg-primary text-white overflow-visible shadow-small rounded-medium",
                    emptyContent: "\u98DF\u6B74\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
                    children: purchases.map((p, index)=>{
                        const item = p.item;
                        const date = new Date();
                        date.setTime(p.time);
                        const timeText = new Intl.DateTimeFormat("ja-JP", {
                            dateStyle: "long",
                            timeStyle: "medium"
                        }).format(date);
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb7a9ec4fc828b48$export$c9741ea17cd30897), {
                            startContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9063f91d9ffdd3$export$5e8a114113e3f7c), {
                                src: item.image_url,
                                width: 64,
                                height: 64,
                                alt: item.title
                            }),
                            endContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "text-tiny p-4",
                                children: timeText
                            }),
                            children: item.title
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef3f3c7d430a5a59$export$64d520e621f7eab5), {
                y: 4
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                children: "\u6599\u7406\u4E00\u89A7"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "p-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba92ec6d8172df1$export$3f842a5957aa0e7a), {
                    className: "bg-primary text-white overflow-visible shadow-small rounded-medium",
                    emptyContent: "\u6599\u7406\u60C5\u5831\u8AAD\u307F\u8FBC\u307F\u4E2D...",
                    children: products.map((item, index)=>{
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb7a9ec4fc828b48$export$c9741ea17cd30897), {
                            startContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9063f91d9ffdd3$export$5e8a114113e3f7c), {
                                src: item.image_url,
                                width: 64,
                                height: 64,
                                alt: item.title
                            }),
                            children: item.title
                        }, index);
                    })
                })
            })
        ]
    });
};
const $6aaba76260e26777$var$fetchScannedProducts = ({ scanned: scanned, setProducts: setProducts })=>{
    const controller = new AbortController();
    const signal = controller.signal;
    const updates = scanned.map((item)=>{
        if (typeof item === "object") return Promise.resolve(item);
        else return fetch("https://hal.cross-compass.com/api/items/" + item, {
            signal: signal
        }).then((res)=>res.json()).then((body)=>({
                type: "product",
                ...body
            })).catch((err)=>{});
    });
    Promise.all(updates).then((updated)=>{
        setProducts(updated);
    });
    return ()=>{
        controller.abort();
    };
};
const $6aaba76260e26777$var$fetchRecommendations = ({ userName: userName, setRecommendations: setRecommendations })=>{
    fetch("https://hal.cross-compass.com/api/popularity/" + userName).then((res)=>res.json()).then((body)=>setRecommendations(body.recommendations));
    return ()=>{};
};
const $6aaba76260e26777$var$fetchPurchases = ({ userName: userName, setPurchases: setPurchases })=>{
    fetch("https://hal.cross-compass.com/api/purchases/" + userName).then((res)=>res.json()).then(setPurchases);
    return ()=>{};
};
const $6aaba76260e26777$var$fetchMenu = ({ setMenu: setMenu })=>{
    fetch("https://hal.cross-compass.com/api/items").then((res)=>res.json()).then(setMenu);
    return ()=>{};
};
const $6aaba76260e26777$var$submitProducts = ({ userName: userName, products: products, onDone: onDone })=>{
    console.log({
        items: products
    });
    fetch("https://hal.cross-compass.com/api/checkout/" + userName, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            items: products
        })
    }).then(onDone);
    return ()=>{};
};
function $6aaba76260e26777$var$useConfirm(message, onConfirm, onAbort) {
    const confirm = ()=>{
        if (window.confirm(message)) onConfirm();
        else onAbort();
    };
    return confirm;
}
function $6aaba76260e26777$var$App() {
    const urlParams = new URLSearchParams(window.location.search);
    const userParam = urlParams.get("user");
    if (userParam) localStorage.setItem("user", userParam);
    const userNameValue = localStorage.getItem("user");
    const userName = userNameValue !== null ? userNameValue : "\u30B0\u30EB\u30E1\u592A\u90CE";
    const [stopDecoding, setStopDecoding] = (0, $7fPBF.useState)(true);
    const [scanned, setScanned] = (0, $7fPBF.useState)([]);
    const [products, setProducts] = (0, $7fPBF.useState)([]);
    const [scanError, setScanError] = (0, $7fPBF.useState)(null);
    const [position, setPosition] = (0, $7fPBF.useState)(null);
    const [recommendations, setRecommendations] = (0, $7fPBF.useState)([]);
    const [purchases, setPurchases] = (0, $7fPBF.useState)([]);
    const [menu, setMenu] = (0, $7fPBF.useState)([]);
    const [refreshToken, setRefreshToken] = (0, $7fPBF.useState)(true);
    const removeScannedItem = (index)=>{
        const nextScanned = [
            ...scanned.slice(0, index),
            ...scanned.slice(index + 1)
        ];
        const nextPurchases = [
            ...purchases.slice(0, index),
            ...purchases.slice(index + 1)
        ];
        setScanned(nextScanned);
        setPurchases(nextPurchases);
    };
    (0, $7fPBF.useEffect)(()=>{
        return $6aaba76260e26777$var$fetchRecommendations({
            userName: userName,
            setRecommendations: setRecommendations
        });
    }, [
        userName,
        refreshToken
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return $6aaba76260e26777$var$fetchPurchases({
            userName: userName,
            setPurchases: setPurchases
        });
    }, [
        userName,
        refreshToken
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return $6aaba76260e26777$var$fetchScannedProducts({
            scanned: scanned,
            setProducts: setProducts
        });
    }, [
        scanned
    ]);
    (0, $7fPBF.useEffect)(()=>{
        $6aaba76260e26777$var$fetchMenu({
            setMenu: setMenu
        });
    }, []);
    const clearScan = ()=>{
        setProducts([]);
        setScanned([]);
        setStopDecoding(true);
        setRefreshToken((t)=>!t);
    };
    const checkout = $6aaba76260e26777$var$useConfirm(`${products.length}\u{70B9}\u{3092}\u{8ACB}\u{6C42}`, ()=>$6aaba76260e26777$var$submitProducts({
            products: products,
            userName: userName,
            onDone: ()=>{
                clearScan();
            }
        }), ()=>{});
    (0, $7fPBF.useEffect)(()=>{
        const hours = 3600000;
        // using low accuracy position is faster
        const enableHighAccuracy = false;
        const positionOptions = {
            enableHighAccuracy: enableHighAccuracy,
            timeout: 4000,
            maximumAge: 1 * hours
        };
        const positionError = (err)=>{
            setPosition(null);
            console.warn(`Failed to get location E(${err.code}): ${err.message}`);
        };
        if (!stopDecoding) navigator.geolocation.getCurrentPosition((pos)=>setPosition({
                lat: pos.coords.latitude,
                long: pos.coords.longitude,
                acc: pos.coords.accuracy
            }), positionError, positionOptions);
    }, [
        stopDecoding
    ]);
    // TODO: pass hints specifying the barcode formats
    const barcodeText = stopDecoding ? "\u30D0\u30FC\u30B3\u30FC\u30C9\u30B9\u30AD\u30E3\u30F3\u958B\u59CB" : "\u30B9\u30AD\u30E3\u30F3\u505C\u6B62";
    const main = stopDecoding ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6aaba76260e26777$var$HomePage, {
        recommendations: recommendations,
        purchases: purchases,
        products: menu
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6aaba76260e26777$var$ScannerPage, {
        products: products,
        setScanned: setScanned,
        setScanError: setScanError,
        scanned: scanned,
        scanError: scanError,
        removeScannedItem: removeScannedItem
    });
    const footer = stopDecoding ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "flex flex-row justify-center h-24",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "flex flex-col",
            onClick: ()=>setStopDecoding(false),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($80b309bb900a72a7$exports))),
                    className: "barcode",
                    alt: barcodeText
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: barcodeText
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-row ml-8 items-center h-24",
        style: {
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex flex-col",
                onClick: clearScan,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a9063f91d9ffdd3$export$5e8a114113e3f7c), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0d5034b72fb48a$exports))),
                    alt: "back",
                    height: 40,
                    width: 40
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "text-2xl",
                    children: products.length ? `${products.length}\u{70B9}` : ""
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col mr-8",
                onClick: checkout,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d8166cd39748a67e$exports))),
                        alt: "\u8CFC\u5165"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-2xl",
                        children: "\u8CFC\u5165"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3a3430f50e4bea6$export$a3257b987c70dc9c), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "App text-foreground bg-background",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("header", {
                    className: "App-header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($eaf6e2f2fe42ede8$exports))),
                            className: "App-logo",
                            alt: "logo"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "user",
                            children: userName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                    children: main
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                    className: "App-footer",
                    children: footer
                })
            ]
        })
    });
}
var $6aaba76260e26777$export$2e2bcd8739ae039 = $6aaba76260e26777$var$App;


const $4a5191623062d5ff$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById("root"));
$4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aaba76260e26777$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.27220a6c.js.map
